/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 756);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(213);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(213);

function _defineProperty(e, r, t) {
  return (r = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(421);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, e);
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createSuper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(424);



function _createSuper(t) {
  var r = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function () {
    var e,
        o = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(t);
    if (r) {
      var s = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, e);
  };
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Setter_js__ = __webpack_require__(212);




var Parser = /*#__PURE__*/function () {
  function Parser() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Parser);
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "incompatibleTokens", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "priority", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "subPriority", void 0);
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new __WEBPACK_IMPORTED_MODULE_3__Setter_js__["b" /* ValueSetter */](result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mapValue;
/* harmony export (immutable) */ __webpack_exports__["h"] = parseNumericPattern;
/* harmony export (immutable) */ __webpack_exports__["i"] = parseTimezonePattern;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseAnyDigitsSigned;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseNDigits;
/* harmony export (immutable) */ __webpack_exports__["g"] = parseNDigitsSigned;
/* harmony export (immutable) */ __webpack_exports__["a"] = dayPeriodEnumToHours;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeTwoDigitYear;
/* harmony export (immutable) */ __webpack_exports__["b"] = isLeapYearIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(17);


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c" /* millisecondsInMinute */] + seconds * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["d" /* millisecondsInSecond */]),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].singleDigit, dateString);
    case 2:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].twoDigits, dateString);
    case 3:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].threeDigits, dateString);
    case 4:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* numericPatterns */].fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return daysInWeek; });
/* unused harmony export daysInYear */
/* unused harmony export maxTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return millisecondsInMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return millisecondsInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return millisecondsInSecond; });
/* unused harmony export minTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return minutesInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return monthsInQuarter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return monthsInYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return quartersInYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return secondsInHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return secondsInMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return secondsInDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return secondsInWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return secondsInYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return secondsInMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return secondsInQuarter; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultOptions;
/* harmony export (immutable) */ __webpack_exports__["b"] = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numericPatterns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timezonePatterns; });
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (o) {
    return typeof o === "undefined" ? "undefined" : _typeof2(o);
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o === "undefined" ? "undefined" : _typeof2(o);
  }, _typeof(o);
}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(225);
var isBuffer = __webpack_require__(548);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(885));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(231);
} else {
  module.exports = require('./vue.common.dev.js');
}

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__ = __webpack_require__(13);




/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a" /* default */])(dirtyDateLeft);
  var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a" /* default */])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isDate_index_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isDate_index_js__["a" /* default */])(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = nextDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {Day} day - day of the week
 * @returns {Date} - the date is the next day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextDay(date, day) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var delta = day - Object(__WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a" /* default */])(date);
  if (delta <= 0) delta += 7;
  return Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(date, delta);
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = previousDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subDays_index_js__ = __webpack_require__(97);



/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @param {Date | number} date - the date to check
 * @param {number} day - day of the week
 * @returns {Date} - the date is the previous day of week
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */
function previousDay(date, day) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var delta = Object(__WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a" /* default */])(date) - day;
  if (delta <= 0) delta += 7;
  return Object(__WEBPACK_IMPORTED_MODULE_2__subDays_index_js__["a" /* default */])(date, delta);
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(313);
var ieee754 = __webpack_require__(163);
var isArray = __webpack_require__(314);

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDate, {
    weekStartsOn: 1
  });
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareAsc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(964);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SESSION_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESPONSE_ERROR_CODES_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTO_TAB_INDEX_DATA_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILE_INPUT_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PHONE_NUMBER_INPUT_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MIN_PHONE_NUMBER_LENGTH_TO_PARSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FIRST_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STEP_REF_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SESSION_META; });
var SESSION_COOKIE = {
	NAME: 'sa-cookie',
	LIFESPAN_IN_DAYS: 365,
	SESSION_SEPARATOR: ',',
	KEY_VALUE_SEPARATOR: '='
};

var CLASSES = {
	INVALID_INPUT: '.form-input--error'
};

var ERROR_CODES = {
	REQUIRED: 'REQUIRED',
	TOO_SHORT: 'TOO_SHORT',
	TOO_LONG: 'TOO_LONG',
	TOO_LOW: 'TOO_LOW',
	TOO_HIGH: 'TOO_HIGH',
	TOO_FEW_ITEMS: 'TOO_FEW_ITEMS',
	TOO_MANY_ITEMS: 'TOO_MANY_ITEMS',
	WRONG_EMAIL: 'WRONG_EMAIL',
	WRONG_FORMAT: 'WRONG_FORMAT',
	CANNOT_BE_EMPTY: 'CANNOT_BE_EMPTY',
	NOT_ALLOWED_VALUE: 'NOT_ALLOWED_VALUE',
	INVALID_DATE: 'INVALID_DATE',
	DATE_LESS_THAN_MIN: 'DATE_LESS_THAN_MIN',
	DATE_GREATER_THAN_MAX: 'DATE_GREATER_THAN_MAX',
	FORMAT_ERROR: 'FORMAT_ERROR',
	MAX_FILE_SIZE: 'MAX_FILE_SIZE',
	MAX_TOTAL_FILE_SIZE: 'MAX_TOTAL_FILE_SIZE',
	MAX_FILE_COUNT: 'MAX_FILE_COUNT',
	FORBIDDEN_FILE_EXTENSION: 'FORBIDDEN_FILE_EXTENSION',
	FORBIDDEN_FILENAME_PATTERN: 'FORBIDDEN_FILENAME_PATTERN',
	FORBIDDEN_EMAIL_DOMAIN: 'FORBIDDEN_EMAIL_DOMAIN',
	INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
	UNKNOWN: 'UNKNOWN'
};

var RESPONSE_ERROR_CODES_MAP = {
	'required': ERROR_CODES.REQUIRED,
	'minlength': ERROR_CODES.TOO_SHORT,
	'maxlength': ERROR_CODES.TOO_LONG,
	'min': ERROR_CODES.TOO_LOW,
	'max': ERROR_CODES.TOO_HIGH,
	'pattern': ERROR_CODES.WRONG_FORMAT,
	'max-size': ERROR_CODES.MAX_FILE_SIZE,
	'max-total-size': ERROR_CODES.MAX_TOTAL_FILE_SIZE,
	'max-file-count': ERROR_CODES.MAX_FILE_COUNT,
	'file-extension': ERROR_CODES.FORBIDDEN_FILE_EXTENSION,
	'filename-pattern': ERROR_CODES.FORBIDDEN_FILENAME_PATTERN,
	'multi-select': ERROR_CODES.REQUIRED,
	'type': ERROR_CODES.WRONG_FORMAT
};

var AUTO_TAB_INDEX_DATA_ATTR = 'data-auto-tab-index';

var KEYS = {
	BACKSPACE: 'Backspace'
};

var EVENTS = {
	BLUR: 'blur',
	INPUT: 'input',
	DATE_INPUT: 'date-input',
	INPUT_TO_VALIDATE: 'input-to-validate',
	BLUR_TO_VALIDATE: 'blur-to-validate'
};

var FILE_INPUT_STATES = {
	IS_UPLOADING: 'isUploading',
	IS_DRAG_ON: 'isDragOn',
	UPLOAD_PROGRESS: 'uploadProgress',
	UPLOADED_FILES: 'uploadedFiles'
};

var PHONE_NUMBER_INPUT_FIELDS = {
	COUNTRY_CODE: 'countryCode',
	AREA_CODE: 'areaCode',
	PHONE_NUMBER: 'phoneNumber'
};

var MIN_PHONE_NUMBER_LENGTH_TO_PARSE = 11;

var FIRST_STEP = 1;

var STEP_REF_PREFIX = 'step';

var SESSION_META = {
	OBJECT: 'meta',
	LAST_STEP: 'lastStep'
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);subClass.prototype.constructor = subClass;subClass.__proto__ = superClass;
}

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual === 'undefined' ? 'undefined' : _typeof(actual));
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(164);
var Writable = __webpack_require__(169);
__webpack_require__(64)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRoundingMethod;
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};

var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(369);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a" /* default */]);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(584)('wks');
var uid = __webpack_require__(269);
var _Symbol = __webpack_require__(45).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function TempCtor() {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);


function startOfUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__ = __webpack_require__(13);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isMac = exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.rafThrottle = rafThrottle;
exports.objToArray = objToArray;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _types = __webpack_require__(666);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var kebabCase = exports.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};

var capitalize = exports.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var looseEqual = exports.looseEqual = function looseEqual(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

var isEqual = exports.isEqual = function isEqual(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
      {
        return !val.size;
      }
    // Plain Object
    case '[object Object]':
      {
        return !Object.keys(val).length;
      }
  }

  return false;
};

function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

var isMac = exports.isMac = function isMac() {
  return !_vue2.default.prototype.$isServer && /macintosh|mac os x/i.test(navigator.userAgent);
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(630);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamReader = exports.EndOfStreamError = void 0;
var EndOfFileStream_1 = __webpack_require__(110);
Object.defineProperty(exports, "EndOfStreamError", { enumerable: true, get: function get() {
    return EndOfFileStream_1.EndOfStreamError;
  } });
var StreamReader_1 = __webpack_require__(330);
Object.defineProperty(exports, "StreamReader", { enumerable: true, get: function get() {
    return StreamReader_1.StreamReader;
  } });

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWeekend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var days = amount * 7;
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a" /* default */])(dirtyDate, days);
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dateLeft).getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dateRight).getTime();
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLastDayOfMonth_index_js__ = __webpack_require__(187);





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight);
  var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__["a" /* default */])(dateLeft, dateRight));
  var result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastMonthNotFull = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight) === -sign;

    // Check for cases of one full calendar month
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isLastDayOfMonth_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft)) && difference === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(51);



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a" /* default */])(dateLeft, dateRight) / 1000;
  return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
}; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null && vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(234)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(104);
var IE8_DOM_DEFINE = __webpack_require__(677);
var toPrimitive = __webpack_require__(580);
var dP = Object.defineProperty;

exports.f = __webpack_require__(99) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(136);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(784),
    getValue = __webpack_require__(787);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__(48).codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
exports.EndOfStreamError = exports.defaultMessages = void 0;
exports.defaultMessages = 'End-Of-Stream';
/**
 * Thrown on read operation of the end of file or stream has been reached
 */

var EndOfStreamError = function (_Error) {
    _inherits(EndOfStreamError, _Error);

    function EndOfStreamError() {
        _classCallCheck(this, EndOfStreamError);

        return _possibleConstructorReturn(this, (EndOfStreamError.__proto__ || Object.getPrototypeOf(EndOfStreamError)).call(this, exports.defaultMessages));
    }

    return EndOfStreamError;
}(Error);

exports.EndOfStreamError = EndOfStreamError;

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSunday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 0;
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_HOUR = 3600000;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var months = amount * 3;
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a" /* default */])(dirtyDate, months);
}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateLeft, options);
  var startOfWeekRight = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__(51);




/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a" /* default */])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInHour */];
  return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__ = __webpack_require__(51);




/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */
function differenceInMinutes(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInMilliseconds_index_js__["a" /* default */])(dateLeft, dateRight) / __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c" /* millisecondsInMinute */];
  return Object(__WEBPACK_IMPORTED_MODULE_3__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfMinute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eachWeekendOfInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */
function eachWeekendOfInterval(interval) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var dateInterval = Object(__WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__["a" /* default */])(interval);
  var weekends = [];
  var index = 0;
  while (index < dateInterval.length) {
    var date = dateInterval[index++];
    if (Object(__WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__["a" /* default */])(date)) {
      weekends.push(date);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__["a" /* default */])(date)) index = index + 5;
    }
  }
  return weekends;
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var cleanDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__ = __webpack_require__(13);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__ = __webpack_require__(13);





/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__["a" /* default */])(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a" /* default */])(firstWeek, options);
  return date;
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__ = __webpack_require__(13);




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week (and month and year)
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfWeek = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateLeft, options);
  var dateRightStartOfWeek = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var month = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(21);
var normalizeHeaderName = __webpack_require__(550);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(226);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(226);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(74);
var ctx = __webpack_require__(265);
var hide = __webpack_require__(135);
var has = __webpack_require__(137);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(103);
var createDesc = __webpack_require__(267);
module.exports = __webpack_require__(99) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(80);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150),
    getRawTag = __webpack_require__(770),
    objectToString = __webpack_require__(771);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasFileWithFakeExtension;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertArrayToObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["d"] = isPhoneNumberObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_type_browser__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_type_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_type_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_livr_livr_utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DNFORM_constants__ = __webpack_require__(47);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('sf:dynaform:dnform-utils');

function getRealFileExtension(file, fileExtensionFromFilename) {
	return new Promise(function (resolve, reject) {
		var fileReader = new FileReader();
		fileReader.readAsArrayBuffer(file);

		fileReader.onload = function () {
			__WEBPACK_IMPORTED_MODULE_1_file_type_browser___default.a.fromBuffer(fileReader.result).then(function (response) {
				// file-type can't detect text-based file formats, that's why we have a
				// fallback value with the file extension from filename
				var resultToResolve = response && response.ext ? response.ext : fileExtensionFromFilename;
				resolve(resultToResolve);
			}).catch(function (error) {
				reject(error);
			});
		};

		fileReader.onerror = function (error) {
			reject(error);
		};
	});
}

function hasFileWithFakeExtension(files) {
	debug('hasFileWithFakeExtension');
	return new Promise(function (resolve) {
		var results = [];

		var _loop = function _loop(file) {
			var fileExtensionFromFilename = __WEBPACK_IMPORTED_MODULE_2__common_livr_livr_utils__["a" /* default */].getFileExtensionFromFilename(file.name);
			debug('for file of files', { fileExtensionFromFilename: fileExtensionFromFilename });
			results.push(new Promise(function (nestedResolve) {
				getRealFileExtension(file, fileExtensionFromFilename).then(function (realFileExtension) {
					var hasError = fileExtensionFromFilename !== realFileExtension;
					debug('getRealFileExtension hasError', { realFileExtension: realFileExtension, hasError: hasError });
					nestedResolve(hasError);
				}).catch(function () {
					debug('getRealFileExtension catch');
					nestedResolve(true);
				});
			}));
		};

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = Array.from(files)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var file = _step.value;

				_loop(file);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		Promise.all(results).then(function (response) {
			debug('Promise all', { response: response });
			var hasError = response.some(function (_response) {
				return !!_response;
			});
			debug('Promise all', { hasError: hasError });
			resolve(hasError);
		}).catch(function () {
			resolve(true);
		});
	});
}

function convertArrayToObject(array) {
	var result = {};

	array.forEach(function (el, index) {
		result[index + 1] = el;
	});

	return result;
}

function isObject(value) {
	return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && !Array.isArray(value);
}

function isPhoneNumberObject(object) {
	var keys = Object.keys(object);
	var phoneNumberFields = Object.values(__WEBPACK_IMPORTED_MODULE_3__DNFORM_constants__["i" /* PHONE_NUMBER_INPUT_FIELDS */]);
	return keys.length == phoneNumberFields.length && keys.every(function (key) {
		return phoneNumberFields.includes(key);
	});
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(547);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueMultiselect = e() : t.VueMultiselect = e();
}(this, function () {
  return function (t) {
    function e(i) {
      if (n[i]) return n[i].exports;var r = n[i] = { i: i, l: !1, exports: {} };return t[i].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }var n = {};return e.m = t, e.c = n, e.i = function (t) {
      return t;
    }, e.d = function (t, n, i) {
      e.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: i });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 60);
  }([function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    var i = n(49)("wks"),
        r = n(30),
        o = n(0).Symbol,
        s = "function" == typeof o;(t.exports = function (t) {
      return i[t] || (i[t] = s && o[t] || (s ? o : r)("Symbol." + t));
    }).store = i;
  }, function (t, e, n) {
    var i = n(5);t.exports = function (t) {
      if (!i(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(10),
        o = n(8),
        s = n(6),
        u = n(11),
        a = function a(t, e, n) {
      var l,
          c,
          f,
          p,
          h = t & a.F,
          d = t & a.G,
          v = t & a.S,
          g = t & a.P,
          y = t & a.B,
          m = d ? i : v ? i[e] || (i[e] = {}) : (i[e] || {}).prototype,
          b = d ? r : r[e] || (r[e] = {}),
          _ = b.prototype || (b.prototype = {});d && (n = e);for (l in n) {
        c = !h && m && void 0 !== m[l], f = (c ? m : n)[l], p = y && c ? u(f, i) : g && "function" == typeof f ? u(Function.call, f) : f, m && s(m, l, f, t & a.U), b[l] != f && o(b, l, p), g && _[l] != f && (_[l] = f);
      }
    };i.core = r, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, e, n) {
    t.exports = !n(7)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(8),
        o = n(12),
        s = n(30)("src"),
        u = Function.toString,
        a = ("" + u).split("toString");n(10).inspectSource = function (t) {
      return u.call(t);
    }, (t.exports = function (t, e, n, u) {
      var l = "function" == typeof n;l && (o(n, "name") || r(n, "name", e)), t[e] !== n && (l && (o(n, s) || r(n, s, t[e] ? "" + t[e] : a.join(String(e)))), t === i ? t[e] = n : u ? t[e] ? t[e] = n : r(t, e, n) : (delete t[e], r(t, e, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[s] || u.call(this);
    });
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(25);t.exports = n(4) ? function (t, e, n) {
      return i.f(t, e, r(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    var n = {}.toString;t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    var n = t.exports = { version: "2.5.7" };"number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var i = n(14);t.exports = function (t, e, n) {
      if (i(t), void 0 === e) return t;switch (n) {case 1:
          return function (n) {
            return t.call(e, n);
          };case 2:
          return function (n, i) {
            return t.call(e, n, i);
          };case 3:
          return function (n, i, r) {
            return t.call(e, n, i, r);
          };}return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(41),
        o = n(29),
        s = Object.defineProperty;e.f = n(4) ? Object.defineProperty : function (t, e, n) {
      if (i(t), e = o(e, !0), i(n), r) try {
        return s(t, e, n);
      } catch (t) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(7);t.exports = function (t, e) {
      return !!t && i(function () {
        e ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, e, n) {
    var i = n(23),
        r = n(16);t.exports = function (t) {
      return i(r(t));
    };
  }, function (t, e, n) {
    var i = n(53),
        r = Math.min;t.exports = function (t) {
      return t > 0 ? r(i(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(23),
        o = n(28),
        s = n(19),
        u = n(64);t.exports = function (t, e) {
      var n = 1 == t,
          a = 2 == t,
          l = 3 == t,
          c = 4 == t,
          f = 6 == t,
          p = 5 == t || f,
          h = e || u;return function (e, u, d) {
        for (var v, g, y = o(e), m = r(y), b = i(u, d, 3), _ = s(m.length), x = 0, w = n ? h(e, _) : a ? h(e, 0) : void 0; _ > x; x++) {
          if ((p || x in m) && (v = m[x], g = b(v, x, y), t)) if (n) w[x] = g;else if (g) switch (t) {case 3:
              return !0;case 5:
              return v;case 6:
              return x;case 2:
              w.push(v);} else if (c) return !1;
        }return f ? -1 : l || c ? c : w;
      };
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(0).document,
        o = i(r) && i(r.createElement);t.exports = function (t) {
      return o ? r.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var i = n(9);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == i(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e) {
    t.exports = function (t, e) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
    };
  }, function (t, e, n) {
    var i = n(13).f,
        r = n(12),
        o = n(1)("toStringTag");t.exports = function (t, e, n) {
      t && !r(t = n ? t : t.prototype, o) && i(t, o, { configurable: !0, value: e });
    };
  }, function (t, e, n) {
    var i = n(49)("keys"),
        r = n(30);t.exports = function (t) {
      return i[t] || (i[t] = r(t));
    };
  }, function (t, e, n) {
    var i = n(16);t.exports = function (t) {
      return Object(i(t));
    };
  }, function (t, e, n) {
    var i = n(5);t.exports = function (t, e) {
      if (!i(t)) return t;var n, r;if (e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;if ("function" == typeof (n = t.valueOf) && !i(r = n.call(t))) return r;if (!e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    var n = 0,
        i = Math.random();t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36));
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(0),
        r = n(12),
        o = n(9),
        s = n(67),
        u = n(29),
        a = n(7),
        l = n(77).f,
        c = n(45).f,
        f = n(13).f,
        p = n(51).trim,
        _h = i.Number,
        d = _h,
        v = _h.prototype,
        g = "Number" == o(n(44)(v)),
        y = "trim" in String.prototype,
        m = function m(t) {
      var e = u(t, !1);if ("string" == typeof e && e.length > 2) {
        e = y ? e.trim() : p(e, 3);var n,
            i,
            r,
            o = e.charCodeAt(0);if (43 === o || 45 === o) {
          if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
        } else if (48 === o) {
          switch (e.charCodeAt(1)) {case 66:case 98:
              i = 2, r = 49;break;case 79:case 111:
              i = 8, r = 55;break;default:
              return +e;}for (var s, a = e.slice(2), l = 0, c = a.length; l < c; l++) {
            if ((s = a.charCodeAt(l)) < 48 || s > r) return NaN;
          }return parseInt(a, i);
        }
      }return +e;
    };if (!_h(" 0o1") || !_h("0b1") || _h("+0x1")) {
      _h = function h(t) {
        var e = arguments.length < 1 ? 0 : t,
            n = this;return n instanceof _h && (g ? a(function () {
          v.valueOf.call(n);
        }) : "Number" != o(n)) ? s(new d(m(e)), n, _h) : m(e);
      };for (var b, _ = n(4) ? l(d) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), x = 0; _.length > x; x++) {
        r(d, b = _[x]) && !r(_h, b) && f(_h, b, c(d, b));
      }_h.prototype = v, v.constructor = _h, n(6)(i, "Number", _h);
    }
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return 0 !== t && (!(!Array.isArray(t) || 0 !== t.length) || !t);
    }function r(t) {
      return function () {
        return !t.apply(void 0, arguments);
      };
    }function o(t, e) {
      return void 0 === t && (t = "undefined"), null === t && (t = "null"), !1 === t && (t = "false"), -1 !== t.toString().toLowerCase().indexOf(e.trim());
    }function s(t, e, n, i) {
      return t.filter(function (t) {
        return o(i(t, n), e);
      });
    }function u(t) {
      return t.filter(function (t) {
        return !t.$isLabel;
      });
    }function a(t, e) {
      return function (n) {
        return n.reduce(function (n, i) {
          return i[t] && i[t].length ? (n.push({ $groupLabel: i[e], $isLabel: !0 }), n.concat(i[t])) : n;
        }, []);
      };
    }function l(t, e, i, r, o) {
      return function (u) {
        return u.map(function (u) {
          var a;if (!u[i]) return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];var l = s(u[i], t, e, o);return l.length ? (a = {}, n.i(d.a)(a, r, u[r]), n.i(d.a)(a, i, l), a) : [];
        });
      };
    }var c = n(59),
        f = n(54),
        p = (n.n(f), n(95)),
        h = (n.n(p), n(31)),
        d = (n.n(h), n(58)),
        v = n(91),
        g = (n.n(v), n(98)),
        y = (n.n(g), n(92)),
        m = (n.n(y), n(88)),
        b = (n.n(m), n(97)),
        _ = (n.n(b), n(89)),
        x = (n.n(_), n(96)),
        w = (n.n(x), n(93)),
        S = (n.n(w), n(90)),
        O = (n.n(S), function () {
      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }return function (t) {
        return e.reduce(function (t, e) {
          return e(t);
        }, t);
      };
    });e.a = { data: function data() {
        return { search: "", isOpen: !1, preferredOpenDirection: "below", optimizedHeight: this.maxHeight };
      }, props: { internalSearch: { type: Boolean, default: !0 }, options: { type: Array, required: !0 }, multiple: { type: Boolean, default: !1 }, value: { type: null, default: function _default() {
            return [];
          } }, trackBy: { type: String }, label: { type: String }, searchable: { type: Boolean, default: !0 }, clearOnSelect: { type: Boolean, default: !0 }, hideSelected: { type: Boolean, default: !1 }, placeholder: { type: String, default: "Select option" }, allowEmpty: { type: Boolean, default: !0 }, resetAfter: { type: Boolean, default: !1 }, closeOnSelect: { type: Boolean, default: !0 }, customLabel: { type: Function, default: function _default(t, e) {
            return i(t) ? "" : e ? t[e] : t;
          } }, taggable: { type: Boolean, default: !1 }, tagPlaceholder: { type: String, default: "Press enter to create a tag" }, tagPosition: { type: String, default: "top" }, max: { type: [Number, Boolean], default: !1 }, id: { default: null }, optionsLimit: { type: Number, default: 1e3 }, groupValues: { type: String }, groupLabel: { type: String }, groupSelect: { type: Boolean, default: !1 }, blockKeys: { type: Array, default: function _default() {
            return [];
          } }, preserveSearch: { type: Boolean, default: !1 }, preselectFirst: { type: Boolean, default: !1 } }, mounted: function mounted() {
        !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
      }, computed: { internalValue: function internalValue() {
          return this.value || 0 === this.value ? Array.isArray(this.value) ? this.value : [this.value] : [];
        }, filteredOptions: function filteredOptions() {
          var t = this.search || "",
              e = t.toLowerCase().trim(),
              n = this.options.concat();return n = this.internalSearch ? this.groupValues ? this.filterAndFlat(n, e, this.label) : s(n, e, this.label, this.customLabel) : this.groupValues ? a(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(r(this.isSelected)) : n, this.taggable && e.length && !this.isExistingOption(e) && ("bottom" === this.tagPosition ? n.push({ isTag: !0, label: t }) : n.unshift({ isTag: !0, label: t })), n.slice(0, this.optionsLimit);
        }, valueKeys: function valueKeys() {
          var t = this;return this.trackBy ? this.internalValue.map(function (e) {
            return e[t.trackBy];
          }) : this.internalValue;
        }, optionKeys: function optionKeys() {
          var t = this;return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function (e) {
            return t.customLabel(e, t.label).toString().toLowerCase();
          });
        }, currentOptionLabel: function currentOptionLabel() {
          return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
        } }, watch: { internalValue: function internalValue() {
          this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
        }, search: function search() {
          this.$emit("search-change", this.search, this.id);
        } }, methods: { getValue: function getValue() {
          return this.multiple ? this.internalValue : 0 === this.internalValue.length ? null : this.internalValue[0];
        }, filterAndFlat: function filterAndFlat(t, e, n) {
          return O(l(e, n, this.groupValues, this.groupLabel, this.customLabel), a(this.groupValues, this.groupLabel))(t);
        }, flatAndStrip: function flatAndStrip(t) {
          return O(a(this.groupValues, this.groupLabel), u)(t);
        }, updateSearch: function updateSearch(t) {
          this.search = t;
        }, isExistingOption: function isExistingOption(t) {
          return !!this.options && this.optionKeys.indexOf(t) > -1;
        }, isSelected: function isSelected(t) {
          var e = this.trackBy ? t[this.trackBy] : t;return this.valueKeys.indexOf(e) > -1;
        }, isOptionDisabled: function isOptionDisabled(t) {
          return !!t.$isDisabled;
        }, getOptionLabel: function getOptionLabel(t) {
          if (i(t)) return "";if (t.isTag) return t.label;if (t.$isLabel) return t.$groupLabel;var e = this.customLabel(t, this.label);return i(e) ? "" : e;
        }, select: function select(t, e) {
          if (t.$isLabel && this.groupSelect) return void this.selectGroup(t);if (!(-1 !== this.blockKeys.indexOf(e) || this.disabled || t.$isDisabled || t.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && ("Tab" !== e || this.pointerDirty)) {
            if (t.isTag) this.$emit("tag", t.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();else {
              if (this.isSelected(t)) return void ("Tab" !== e && this.removeElement(t));this.$emit("select", t, this.id), this.multiple ? this.$emit("input", this.internalValue.concat([t]), this.id) : this.$emit("input", t, this.id), this.clearOnSelect && (this.search = "");
            }this.closeOnSelect && this.deactivate();
          }
        }, selectGroup: function selectGroup(t) {
          var e = this,
              n = this.options.find(function (n) {
            return n[e.groupLabel] === t.$groupLabel;
          });if (n) if (this.wholeGroupSelected(n)) {
            this.$emit("remove", n[this.groupValues], this.id);var i = this.internalValue.filter(function (t) {
              return -1 === n[e.groupValues].indexOf(t);
            });this.$emit("input", i, this.id);
          } else {
            var r = n[this.groupValues].filter(function (t) {
              return !(e.isOptionDisabled(t) || e.isSelected(t));
            });this.$emit("select", r, this.id), this.$emit("input", this.internalValue.concat(r), this.id);
          }
        }, wholeGroupSelected: function wholeGroupSelected(t) {
          var e = this;return t[this.groupValues].every(function (t) {
            return e.isSelected(t) || e.isOptionDisabled(t);
          });
        }, wholeGroupDisabled: function wholeGroupDisabled(t) {
          return t[this.groupValues].every(this.isOptionDisabled);
        }, removeElement: function removeElement(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];if (!this.disabled && !t.$isDisabled) {
            if (!this.allowEmpty && this.internalValue.length <= 1) return void this.deactivate();var i = "object" === n.i(c.a)(t) ? this.valueKeys.indexOf(t[this.trackBy]) : this.valueKeys.indexOf(t);if (this.$emit("remove", t, this.id), this.multiple) {
              var r = this.internalValue.slice(0, i).concat(this.internalValue.slice(i + 1));this.$emit("input", r, this.id);
            } else this.$emit("input", null, this.id);this.closeOnSelect && e && this.deactivate();
          }
        }, removeLastElement: function removeLastElement() {
          -1 === this.blockKeys.indexOf("Delete") && 0 === this.search.length && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
        }, activate: function activate() {
          var t = this;this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && 0 === this.pointer && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.$nextTick(function () {
            return t.$refs.search.focus();
          })) : this.$el.focus(), this.$emit("open", this.id));
        }, deactivate: function deactivate() {
          this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search.blur() : this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
        }, toggle: function toggle() {
          this.isOpen ? this.deactivate() : this.activate();
        }, adjustPosition: function adjustPosition() {
          if ("undefined" != typeof window) {
            var t = this.$el.getBoundingClientRect().top,
                e = window.innerHeight - this.$el.getBoundingClientRect().bottom;e > this.maxHeight || e > t || "below" === this.openDirection || "bottom" === this.openDirection ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(e - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(t - 40, this.maxHeight));
          }
        } } };
  }, function (t, e, n) {
    "use strict";
    var i = n(54),
        r = (n.n(i), n(31));n.n(r);e.a = { data: function data() {
        return { pointer: 0, pointerDirty: !1 };
      }, props: { showPointer: { type: Boolean, default: !0 }, optionHeight: { type: Number, default: 40 } }, computed: { pointerPosition: function pointerPosition() {
          return this.pointer * this.optionHeight;
        }, visibleElements: function visibleElements() {
          return this.optimizedHeight / this.optionHeight;
        } }, watch: { filteredOptions: function filteredOptions() {
          this.pointerAdjust();
        }, isOpen: function isOpen() {
          this.pointerDirty = !1;
        } }, methods: { optionHighlight: function optionHighlight(t, e) {
          return { "multiselect__option--highlight": t === this.pointer && this.showPointer, "multiselect__option--selected": this.isSelected(e) };
        }, groupHighlight: function groupHighlight(t, e) {
          var n = this;if (!this.groupSelect) return ["multiselect__option--group", "multiselect__option--disabled"];var i = this.options.find(function (t) {
            return t[n.groupLabel] === e.$groupLabel;
          });return i && !this.wholeGroupDisabled(i) ? ["multiselect__option--group", { "multiselect__option--highlight": t === this.pointer && this.showPointer }, { "multiselect__option--group-selected": this.wholeGroupSelected(i) }] : "multiselect__option--disabled";
        }, addPointerElement: function addPointerElement() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Enter",
              e = t.key;this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
        }, pointerForward: function pointerForward() {
          this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
        }, pointerBackward: function pointerBackward() {
          this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
        }, pointerReset: function pointerReset() {
          this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
        }, pointerAdjust: function pointerAdjust() {
          this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
        }, pointerSet: function pointerSet(t) {
          this.pointer = t, this.pointerDirty = !0;
        } } };
  }, function (t, e, n) {
    "use strict";
    var i = n(36),
        r = n(74),
        o = n(15),
        s = n(18);t.exports = n(72)(Array, "Array", function (t, e) {
      this._t = s(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;return !t || n >= t.length ? (this._t = void 0, r(1)) : "keys" == e ? r(0, n) : "values" == e ? r(0, t[n]) : r(0, [n, t[n]]);
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  }, function (t, e, n) {
    "use strict";
    var i = n(31),
        r = (n.n(i), n(32)),
        o = n(33);e.a = { name: "vue-multiselect", mixins: [r.a, o.a], props: { name: { type: String, default: "" }, selectLabel: { type: String, default: "Press enter to select" }, selectGroupLabel: { type: String, default: "Press enter to select group" }, selectedLabel: { type: String, default: "Selected" }, deselectLabel: { type: String, default: "Press enter to remove" }, deselectGroupLabel: { type: String, default: "Press enter to deselect group" }, showLabels: { type: Boolean, default: !0 }, limit: { type: Number, default: 99999 }, maxHeight: { type: Number, default: 300 }, limitText: { type: Function, default: function _default(t) {
            return "and ".concat(t, " more");
          } }, loading: { type: Boolean, default: !1 }, disabled: { type: Boolean, default: !1 }, openDirection: { type: String, default: "" }, showNoOptions: { type: Boolean, default: !0 }, showNoResults: { type: Boolean, default: !0 }, tabindex: { type: Number, default: 0 } }, computed: { isSingleLabelVisible: function isSingleLabelVisible() {
          return (this.singleValue || 0 === this.singleValue) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
        }, isPlaceholderVisible: function isPlaceholderVisible() {
          return !(this.internalValue.length || this.searchable && this.isOpen);
        }, visibleValues: function visibleValues() {
          return this.multiple ? this.internalValue.slice(0, this.limit) : [];
        }, singleValue: function singleValue() {
          return this.internalValue[0];
        }, deselectLabelText: function deselectLabelText() {
          return this.showLabels ? this.deselectLabel : "";
        }, deselectGroupLabelText: function deselectGroupLabelText() {
          return this.showLabels ? this.deselectGroupLabel : "";
        }, selectLabelText: function selectLabelText() {
          return this.showLabels ? this.selectLabel : "";
        }, selectGroupLabelText: function selectGroupLabelText() {
          return this.showLabels ? this.selectGroupLabel : "";
        }, selectedLabelText: function selectedLabelText() {
          return this.showLabels ? this.selectedLabel : "";
        }, inputStyle: function inputStyle() {
          if (this.searchable || this.multiple && this.value && this.value.length) return this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" };
        }, contentStyle: function contentStyle() {
          return this.options.length ? { display: "inline-block" } : { display: "block" };
        }, isAbove: function isAbove() {
          return "above" === this.openDirection || "top" === this.openDirection || "below" !== this.openDirection && "bottom" !== this.openDirection && "above" === this.preferredOpenDirection;
        }, showSearchInput: function showSearchInput() {
          return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && 0 !== this.visibleSingleValue || this.isOpen);
        } } };
  }, function (t, e, n) {
    var i = n(1)("unscopables"),
        r = Array.prototype;void 0 == r[i] && n(8)(r, i, {}), t.exports = function (t) {
      r[i][t] = !0;
    };
  }, function (t, e, n) {
    var i = n(18),
        r = n(19),
        o = n(85);t.exports = function (t) {
      return function (e, n, s) {
        var u,
            a = i(e),
            l = r(a.length),
            c = o(s, l);if (t && n != n) {
          for (; l > c;) {
            if ((u = a[c++]) != u) return !0;
          }
        } else for (; l > c; c++) {
          if ((t || c in a) && a[c] === n) return t || c || 0;
        }return !t && -1;
      };
    };
  }, function (t, e, n) {
    var i = n(9),
        r = n(1)("toStringTag"),
        o = "Arguments" == i(function () {
      return arguments;
    }()),
        s = function s(t, e) {
      try {
        return t[e];
      } catch (t) {}
    };t.exports = function (t) {
      var e, n, u;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = s(e = Object(t), r)) ? n : o ? i(e) : "Object" == (u = i(e)) && "function" == typeof e.callee ? "Arguments" : u;
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(2);t.exports = function () {
      var t = i(this),
          e = "";return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    };
  }, function (t, e, n) {
    var i = n(0).document;t.exports = i && i.documentElement;
  }, function (t, e, n) {
    t.exports = !n(4) && !n(7)(function () {
      return 7 != Object.defineProperty(n(21)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, e, n) {
    var i = n(9);t.exports = Array.isArray || function (t) {
      return "Array" == i(t);
    };
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      var e, n;this.promise = new t(function (t, i) {
        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");e = t, n = i;
      }), this.resolve = r(e), this.reject = r(n);
    }var r = n(14);t.exports.f = function (t) {
      return new i(t);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(76),
        o = n(22),
        s = n(27)("IE_PROTO"),
        u = function u() {},
        _a = function a() {
      var t,
          e = n(21)("iframe"),
          i = o.length;for (e.style.display = "none", n(40).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; i--;) {
        delete _a.prototype[o[i]];
      }return _a();
    };t.exports = Object.create || function (t, e) {
      var n;return null !== t ? (u.prototype = i(t), n = new u(), u.prototype = null, n[s] = t) : n = _a(), void 0 === e ? n : r(n, e);
    };
  }, function (t, e, n) {
    var i = n(79),
        r = n(25),
        o = n(18),
        s = n(29),
        u = n(12),
        a = n(41),
        l = Object.getOwnPropertyDescriptor;e.f = n(4) ? l : function (t, e) {
      if (t = o(t), e = s(e, !0), a) try {
        return l(t, e);
      } catch (t) {}if (u(t, e)) return r(!i.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(18),
        o = n(37)(!1),
        s = n(27)("IE_PROTO");t.exports = function (t, e) {
      var n,
          u = r(t),
          a = 0,
          l = [];for (n in u) {
        n != s && i(u, n) && l.push(n);
      }for (; e.length > a;) {
        i(u, n = e[a++]) && (~o(l, n) || l.push(n));
      }return l;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22);t.exports = Object.keys || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(5),
        o = n(43);t.exports = function (t, e) {
      if (i(t), r(e) && e.constructor === t) return e;var n = o.f(t);return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    var i = n(10),
        r = n(0),
        o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});(t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({ version: i.version, mode: n(24) ? "pure" : "global", copyright: "© 2018 Denis Pushkarev (zloirock.ru)" });
  }, function (t, e, n) {
    var i = n(2),
        r = n(14),
        o = n(1)("species");t.exports = function (t, e) {
      var n,
          s = i(t).constructor;return void 0 === s || void 0 == (n = i(s)[o]) ? e : r(n);
    };
  }, function (t, e, n) {
    var i = n(3),
        r = n(16),
        o = n(7),
        s = n(84),
        u = "[" + s + "]",
        a = "​",
        l = RegExp("^" + u + u + "*"),
        c = RegExp(u + u + "*$"),
        f = function f(t, e, n) {
      var r = {},
          u = o(function () {
        return !!s[t]() || a[t]() != a;
      }),
          l = r[t] = u ? e(p) : s[t];n && (r[n] = l), i(i.P + i.F * u, "String", r);
    },
        p = f.trim = function (t, e) {
      return t = String(r(t)), 1 & e && (t = t.replace(l, "")), 2 & e && (t = t.replace(c, "")), t;
    };t.exports = f;
  }, function (t, e, n) {
    var i,
        r,
        o,
        s = n(11),
        u = n(68),
        a = n(40),
        l = n(21),
        c = n(0),
        f = c.process,
        p = c.setImmediate,
        h = c.clearImmediate,
        d = c.MessageChannel,
        v = c.Dispatch,
        g = 0,
        y = {},
        m = function m() {
      var t = +this;if (y.hasOwnProperty(t)) {
        var e = y[t];delete y[t], e();
      }
    },
        b = function b(t) {
      m.call(t.data);
    };p && h || (p = function p(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }return y[++g] = function () {
        u("function" == typeof t ? t : Function(t), e);
      }, i(g), g;
    }, h = function h(t) {
      delete y[t];
    }, "process" == n(9)(f) ? i = function i(t) {
      f.nextTick(s(m, t, 1));
    } : v && v.now ? i = function i(t) {
      v.now(s(m, t, 1));
    } : d ? (r = new d(), o = r.port2, r.port1.onmessage = b, i = s(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (i = function i(t) {
      c.postMessage(t + "", "*");
    }, c.addEventListener("message", b, !1)) : i = "onreadystatechange" in l("script") ? function (t) {
      a.appendChild(l("script")).onreadystatechange = function () {
        a.removeChild(this), m.call(t);
      };
    } : function (t) {
      setTimeout(s(m, t, 1), 0);
    }), t.exports = { set: p, clear: h };
  }, function (t, e) {
    var n = Math.ceil,
        i = Math.floor;t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? i : n)(t);
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(5),
        o = !0;"find" in [] && Array(1).find(function () {
      o = !1;
    }), i(i.P + i.F * o, "Array", { find: function find(t) {
        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), n(36)("find");
  }, function (t, e, n) {
    "use strict";
    var i,
        r,
        o,
        s,
        u = n(24),
        a = n(0),
        l = n(11),
        c = n(38),
        f = n(3),
        p = n(5),
        h = n(14),
        d = n(61),
        v = n(66),
        g = n(50),
        y = n(52).set,
        m = n(75)(),
        b = n(43),
        _ = n(80),
        x = n(86),
        w = n(48),
        S = a.TypeError,
        O = a.process,
        L = O && O.versions,
        k = L && L.v8 || "",
        _P = a.Promise,
        T = "process" == c(O),
        V = function V() {},
        E = r = b.f,
        A = !!function () {
      try {
        var t = _P.resolve(1),
            e = (t.constructor = {})[n(1)("species")] = function (t) {
          t(V, V);
        };return (T || "function" == typeof PromiseRejectionEvent) && t.then(V) instanceof e && 0 !== k.indexOf("6.6") && -1 === x.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        C = function C(t) {
      var e;return !(!p(t) || "function" != typeof (e = t.then)) && e;
    },
        D = function D(t, e) {
      if (!t._n) {
        t._n = !0;var n = t._c;m(function () {
          for (var i = t._v, r = 1 == t._s, o = 0; n.length > o;) {
            !function (e) {
              var n,
                  o,
                  s,
                  u = r ? e.ok : e.fail,
                  a = e.resolve,
                  l = e.reject,
                  c = e.domain;try {
                u ? (r || (2 == t._h && $(t), t._h = 1), !0 === u ? n = i : (c && c.enter(), n = u(i), c && (c.exit(), s = !0)), n === e.promise ? l(S("Promise-chain cycle")) : (o = C(n)) ? o.call(n, a, l) : a(n)) : l(i);
              } catch (t) {
                c && !s && c.exit(), l(t);
              }
            }(n[o++]);
          }t._c = [], t._n = !1, e && !t._h && j(t);
        });
      }
    },
        j = function j(t) {
      y.call(a, function () {
        var e,
            n,
            i,
            r = t._v,
            o = N(t);if (o && (e = _(function () {
          T ? O.emit("unhandledRejection", r, t) : (n = a.onunhandledrejection) ? n({ promise: t, reason: r }) : (i = a.console) && i.error && i.error("Unhandled promise rejection", r);
        }), t._h = T || N(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
      });
    },
        N = function N(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        $ = function $(t) {
      y.call(a, function () {
        var e;T ? O.emit("rejectionHandled", t) : (e = a.onrejectionhandled) && e({ promise: t, reason: t._v });
      });
    },
        F = function F(t) {
      var e = this;e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), D(e, !0));
    },
        M = function M(t) {
      var e,
          n = this;if (!n._d) {
        n._d = !0, n = n._w || n;try {
          if (n === t) throw S("Promise can't be resolved itself");(e = C(t)) ? m(function () {
            var i = { _w: n, _d: !1 };try {
              e.call(t, l(M, i, 1), l(F, i, 1));
            } catch (t) {
              F.call(i, t);
            }
          }) : (n._v = t, n._s = 1, D(n, !1));
        } catch (t) {
          F.call({ _w: n, _d: !1 }, t);
        }
      }
    };A || (_P = function P(t) {
      d(this, _P, "Promise", "_h"), h(t), i.call(this);try {
        t(l(M, this, 1), l(F, this, 1));
      } catch (t) {
        F.call(this, t);
      }
    }, i = function i(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, i.prototype = n(81)(_P.prototype, { then: function then(t, e) {
        var n = E(g(this, _P));return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = T ? O.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && D(this, !1), n.promise;
      }, catch: function _catch(t) {
        return this.then(void 0, t);
      } }), o = function o() {
      var t = new i();this.promise = t, this.resolve = l(M, t, 1), this.reject = l(F, t, 1);
    }, b.f = E = function E(t) {
      return t === _P || t === s ? new o(t) : r(t);
    }), f(f.G + f.W + f.F * !A, { Promise: _P }), n(26)(_P, "Promise"), n(83)("Promise"), s = n(10).Promise, f(f.S + f.F * !A, "Promise", { reject: function reject(t) {
        var e = E(this);return (0, e.reject)(t), e.promise;
      } }), f(f.S + f.F * (u || !A), "Promise", { resolve: function resolve(t) {
        return w(u && this === s ? _P : this, t);
      } }), f(f.S + f.F * !(A && n(73)(function (t) {
      _P.all(t).catch(V);
    })), "Promise", { all: function all(t) {
        var e = this,
            n = E(e),
            i = n.resolve,
            r = n.reject,
            o = _(function () {
          var n = [],
              o = 0,
              s = 1;v(t, !1, function (t) {
            var u = o++,
                a = !1;n.push(void 0), s++, e.resolve(t).then(function (t) {
              a || (a = !0, n[u] = t, --s || i(n));
            }, r);
          }), --s || i(n);
        });return o.e && r(o.v), n.promise;
      }, race: function race(t) {
        var e = this,
            n = E(e),
            i = n.reject,
            r = _(function () {
          v(t, !1, function (t) {
            e.resolve(t).then(n.resolve, i);
          });
        });return r.e && i(r.v), n.promise;
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(10),
        o = n(0),
        s = n(50),
        u = n(48);i(i.P + i.R, "Promise", { finally: function _finally(t) {
        var e = s(this, r.Promise || o.Promise),
            n = "function" == typeof t;return this.then(n ? function (n) {
          return u(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return u(e, t()).then(function () {
            throw n;
          });
        } : t);
      } });
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      n(99);
    }var r = n(35),
        o = n(101),
        s = n(100),
        u = i,
        a = s(r.a, o.a, !1, u, null, null);e.a = a.exports;
  }, function (t, e, n) {
    "use strict";
    function i(t, e, n) {
      return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
    }e.a = i;
  }, function (t, e, n) {
    "use strict";
    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
      })(t);
    }function r(t) {
      return (r = "function" == typeof Symbol && "symbol" === i(Symbol.iterator) ? function (t) {
        return i(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : i(t);
      })(t);
    }e.a = r;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var i = n(34),
        r = (n.n(i), n(55)),
        o = (n.n(r), n(56)),
        s = (n.n(o), n(57)),
        u = n(32),
        a = n(33);n.d(e, "Multiselect", function () {
      return s.a;
    }), n.d(e, "multiselectMixin", function () {
      return u.a;
    }), n.d(e, "pointerMixin", function () {
      return a.a;
    }), e.default = s.a;
  }, function (t, e) {
    t.exports = function (t, e, n, i) {
      if (!(t instanceof e) || void 0 !== i && i in t) throw TypeError(n + ": incorrect invocation!");return t;
    };
  }, function (t, e, n) {
    var i = n(14),
        r = n(28),
        o = n(23),
        s = n(19);t.exports = function (t, e, n, u, a) {
      i(e);var l = r(t),
          c = o(l),
          f = s(l.length),
          p = a ? f - 1 : 0,
          h = a ? -1 : 1;if (n < 2) for (;;) {
        if (p in c) {
          u = c[p], p += h;break;
        }if (p += h, a ? p < 0 : f <= p) throw TypeError("Reduce of empty array with no initial value");
      }for (; a ? p >= 0 : f > p; p += h) {
        p in c && (u = e(u, c[p], p, l));
      }return u;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(42),
        o = n(1)("species");t.exports = function (t) {
      var e;return r(t) && (e = t.constructor, "function" != typeof e || e !== Array && !r(e.prototype) || (e = void 0), i(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
    };
  }, function (t, e, n) {
    var i = n(63);t.exports = function (t, e) {
      return new (i(t))(e);
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(8),
        r = n(6),
        o = n(7),
        s = n(16),
        u = n(1);t.exports = function (t, e, n) {
      var a = u(t),
          l = n(s, a, ""[t]),
          c = l[0],
          f = l[1];o(function () {
        var e = {};return e[a] = function () {
          return 7;
        }, 7 != ""[t](e);
      }) && (r(String.prototype, t, c), i(RegExp.prototype, a, 2 == e ? function (t, e) {
        return f.call(t, this, e);
      } : function (t) {
        return f.call(t, this);
      }));
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(70),
        o = n(69),
        s = n(2),
        u = n(19),
        a = n(87),
        l = {},
        c = {},
        e = t.exports = function (t, e, n, f, p) {
      var h,
          d,
          v,
          g,
          y = p ? function () {
        return t;
      } : a(t),
          m = i(n, f, e ? 2 : 1),
          b = 0;if ("function" != typeof y) throw TypeError(t + " is not iterable!");if (o(y)) {
        for (h = u(t.length); h > b; b++) {
          if ((g = e ? m(s(d = t[b])[0], d[1]) : m(t[b])) === l || g === c) return g;
        }
      } else for (v = y.call(t); !(d = v.next()).done;) {
        if ((g = r(v, m, d.value, e)) === l || g === c) return g;
      }
    };e.BREAK = l, e.RETURN = c;
  }, function (t, e, n) {
    var i = n(5),
        r = n(82).set;t.exports = function (t, e, n) {
      var o,
          s = e.constructor;return s !== n && "function" == typeof s && (o = s.prototype) !== n.prototype && i(o) && r && r(t, o), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var i = void 0 === n;switch (e.length) {case 0:
          return i ? t() : t.call(n);case 1:
          return i ? t(e[0]) : t.call(n, e[0]);case 2:
          return i ? t(e[0], e[1]) : t.call(n, e[0], e[1]);case 3:
          return i ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);case 4:
          return i ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);}return t.apply(n, e);
    };
  }, function (t, e, n) {
    var i = n(15),
        r = n(1)("iterator"),
        o = Array.prototype;t.exports = function (t) {
      return void 0 !== t && (i.Array === t || o[r] === t);
    };
  }, function (t, e, n) {
    var i = n(2);t.exports = function (t, e, n, r) {
      try {
        return r ? e(i(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t.return;throw void 0 !== o && i(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(44),
        r = n(25),
        o = n(26),
        s = {};n(8)(s, n(1)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = i(s, { next: r(1, n) }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(24),
        r = n(3),
        o = n(6),
        s = n(8),
        u = n(15),
        a = n(71),
        l = n(26),
        c = n(78),
        f = n(1)("iterator"),
        p = !([].keys && "next" in [].keys()),
        h = function h() {
      return this;
    };t.exports = function (t, e, n, d, v, g, y) {
      a(n, e, d);var m,
          b,
          _,
          x = function x(t) {
        if (!p && t in L) return L[t];switch (t) {case "keys":case "values":
            return function () {
              return new n(this, t);
            };}return function () {
          return new n(this, t);
        };
      },
          w = e + " Iterator",
          S = "values" == v,
          O = !1,
          L = t.prototype,
          k = L[f] || L["@@iterator"] || v && L[v],
          P = k || x(v),
          T = v ? S ? x("entries") : P : void 0,
          V = "Array" == e ? L.entries || k : k;if (V && (_ = c(V.call(new t()))) !== Object.prototype && _.next && (l(_, w, !0), i || "function" == typeof _[f] || s(_, f, h)), S && k && "values" !== k.name && (O = !0, P = function P() {
        return k.call(this);
      }), i && !y || !p && !O && L[f] || s(L, f, P), u[e] = P, u[w] = h, v) if (m = { values: S ? P : x("values"), keys: g ? P : x("keys"), entries: T }, y) for (b in m) {
        b in L || o(L, b, m[b]);
      } else r(r.P + r.F * (p || O), e, m);return m;
    };
  }, function (t, e, n) {
    var i = n(1)("iterator"),
        r = !1;try {
      var o = [7][i]();o.return = function () {
        r = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}t.exports = function (t, e) {
      if (!e && !r) return !1;var n = !1;try {
        var o = [7],
            s = o[i]();s.next = function () {
          return { done: n = !0 };
        }, o[i] = function () {
          return s;
        }, t(o);
      } catch (t) {}return n;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return { value: e, done: !!t };
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(52).set,
        o = i.MutationObserver || i.WebKitMutationObserver,
        s = i.process,
        u = i.Promise,
        a = "process" == n(9)(s);t.exports = function () {
      var t,
          e,
          n,
          l = function l() {
        var i, r;for (a && (i = s.domain) && i.exit(); t;) {
          r = t.fn, t = t.next;try {
            r();
          } catch (i) {
            throw t ? n() : e = void 0, i;
          }
        }e = void 0, i && i.enter();
      };if (a) n = function n() {
        s.nextTick(l);
      };else if (!o || i.navigator && i.navigator.standalone) {
        if (u && u.resolve) {
          var c = u.resolve(void 0);n = function n() {
            c.then(l);
          };
        } else n = function n() {
          r.call(i, l);
        };
      } else {
        var f = !0,
            p = document.createTextNode("");new o(l).observe(p, { characterData: !0 }), n = function n() {
          p.data = f = !f;
        };
      }return function (i) {
        var r = { fn: i, next: void 0 };e && (e.next = r), t || (t = r, n()), e = r;
      };
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(2),
        o = n(47);t.exports = n(4) ? Object.defineProperties : function (t, e) {
      r(t);for (var n, s = o(e), u = s.length, a = 0; u > a;) {
        i.f(t, n = s[a++], e[n]);
      }return t;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22).concat("length", "prototype");e.f = Object.getOwnPropertyNames || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(28),
        o = n(27)("IE_PROTO"),
        s = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
      return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return { e: !1, v: t() };
      } catch (t) {
        return { e: !0, v: t };
      }
    };
  }, function (t, e, n) {
    var i = n(6);t.exports = function (t, e, n) {
      for (var r in e) {
        i(t, r, e[r], n);
      }return t;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(2),
        o = function o(t, e) {
      if (r(t), !i(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, i) {
        try {
          i = n(11)(Function.call, n(45).f(Object.prototype, "__proto__").set, 2), i(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : i(t, n), t;
        };
      }({}, !1) : void 0), check: o };
  }, function (t, e, n) {
    "use strict";
    var i = n(0),
        r = n(13),
        o = n(4),
        s = n(1)("species");t.exports = function (t) {
      var e = i[t];o && e && !e[s] && r.f(e, s, { configurable: !0, get: function get() {
          return this;
        } });
    };
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    var i = n(53),
        r = Math.max,
        o = Math.min;t.exports = function (t, e) {
      return t = i(t), t < 0 ? r(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    var i = n(0),
        r = i.navigator;t.exports = r && r.userAgent || "";
  }, function (t, e, n) {
    var i = n(38),
        r = n(1)("iterator"),
        o = n(15);t.exports = n(10).getIteratorMethod = function (t) {
      if (void 0 != t) return t[r] || t["@@iterator"] || o[i(t)];
    };
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(2);i(i.P + i.F * !n(17)([].filter, !0), "Array", { filter: function filter(t) {
        return r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(37)(!1),
        o = [].indexOf,
        s = !!o && 1 / [1].indexOf(1, -0) < 0;i(i.P + i.F * (s || !n(17)(o)), "Array", { indexOf: function indexOf(t) {
        return s ? o.apply(this, arguments) || 0 : r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    var i = n(3);i(i.S, "Array", { isArray: n(42) });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(20)(1);i(i.P + i.F * !n(17)([].map, !0), "Array", { map: function map(t) {
        return r(this, t, arguments[1]);
      } });
  }, function (t, e, n) {
    "use strict";
    var i = n(3),
        r = n(62);i(i.P + i.F * !n(17)([].reduce, !0), "Array", { reduce: function reduce(t) {
        return r(this, t, arguments.length, arguments[1], !1);
      } });
  }, function (t, e, n) {
    var i = Date.prototype,
        r = i.toString,
        o = i.getTime;new Date(NaN) + "" != "Invalid Date" && n(6)(i, "toString", function () {
      var t = o.call(this);return t === t ? r.call(this) : "Invalid Date";
    });
  }, function (t, e, n) {
    n(4) && "g" != /./g.flags && n(13).f(RegExp.prototype, "flags", { configurable: !0, get: n(39) });
  }, function (t, e, n) {
    n(65)("search", 1, function (t, e, n) {
      return [function (n) {
        "use strict";
        var i = t(this),
            r = void 0 == n ? void 0 : n[e];return void 0 !== r ? r.call(n, i) : new RegExp(n)[e](String(i));
      }, n];
    });
  }, function (t, e, n) {
    "use strict";
    n(94);var i = n(2),
        r = n(39),
        o = n(4),
        s = /./.toString,
        u = function u(t) {
      n(6)(RegExp.prototype, "toString", t, !0);
    };n(7)(function () {
      return "/a/b" != s.call({ source: "a", flags: "b" });
    }) ? u(function () {
      var t = i(this);return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? r.call(t) : void 0);
    }) : "toString" != s.name && u(function () {
      return s.call(this);
    });
  }, function (t, e, n) {
    "use strict";
    n(51)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, e, n) {
    for (var i = n(34), r = n(47), o = n(6), s = n(0), u = n(8), a = n(15), l = n(1), c = l("iterator"), f = l("toStringTag"), p = a.Array, h = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, d = r(h), v = 0; v < d.length; v++) {
      var g,
          y = d[v],
          m = h[y],
          b = s[y],
          _ = b && b.prototype;if (_ && (_[c] || u(_, c, p), _[f] || u(_, f, y), a[y] = p, m)) for (g in i) {
        _[g] || o(_, g, i[g], !0);
      }
    }
  }, function (t, e) {}, function (t, e) {
    t.exports = function (t, e, n, i, r, o) {
      var s,
          u = t = t || {},
          a = _typeof(t.default);"object" !== a && "function" !== a || (s = t, u = t.default);var l = "function" == typeof u ? u.options : u;e && (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0), n && (l.functional = !0), r && (l._scopeId = r);var c;if (o ? (c = function c(t) {
        t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
      }, l._ssrRegister = c) : i && (c = i), c) {
        var f = l.functional,
            p = f ? l.render : l.beforeCreate;f ? (l._injectStyles = c, l.render = function (t, e) {
          return c.call(e), p(t, e);
        }) : l.beforeCreate = p ? [].concat(p, c) : [c];
      }return { esModule: s, exports: u, options: l };
    };
  }, function (t, e, n) {
    "use strict";
    var i = function i() {
      var t = this,
          e = t.$createElement,
          n = t._self._c || e;return n("div", { staticClass: "multiselect", class: { "multiselect--active": t.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": t.isAbove }, attrs: { tabindex: t.searchable ? -1 : t.tabindex }, on: { focus: function focus(e) {
            t.activate();
          }, blur: function blur(e) {
            !t.searchable && t.deactivate();
          }, keydown: [function (e) {
            return "button" in e || !t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerForward()) : null;
          }, function (e) {
            return "button" in e || !t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerBackward()) : null;
          }], keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") || !t._k(e.keyCode, "tab", 9, e.key, "Tab") ? (e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          }, keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;t.deactivate();
          } } }, [t._t("caret", [n("div", { staticClass: "multiselect__select", on: { mousedown: function mousedown(e) {
            e.preventDefault(), e.stopPropagation(), t.toggle();
          } } })], { toggle: t.toggle }), t._v(" "), t._t("clear", null, { search: t.search }), t._v(" "), n("div", { ref: "tags", staticClass: "multiselect__tags" }, [t._t("selection", [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.visibleValues.length > 0, expression: "visibleValues.length > 0" }], staticClass: "multiselect__tags-wrap" }, [t._l(t.visibleValues, function (e, i) {
        return [t._t("tag", [n("span", { key: i, staticClass: "multiselect__tag" }, [n("span", { domProps: { textContent: t._s(t.getOptionLabel(e)) } }), t._v(" "), n("i", { staticClass: "multiselect__tag-icon", attrs: { "aria-hidden": "true", tabindex: "1" }, on: { keypress: function keypress(n) {
              if (!("button" in n) && t._k(n.keyCode, "enter", 13, n.key, "Enter")) return null;n.preventDefault(), t.removeElement(e);
            }, mousedown: function mousedown(n) {
              n.preventDefault(), t.removeElement(e);
            } } })])], { option: e, search: t.search, remove: t.removeElement })];
      })], 2), t._v(" "), t.internalValue && t.internalValue.length > t.limit ? [t._t("limit", [n("strong", { staticClass: "multiselect__strong", domProps: { textContent: t._s(t.limitText(t.internalValue.length - t.limit)) } })])] : t._e()], { search: t.search, remove: t.removeElement, values: t.visibleValues, isOpen: t.isOpen }), t._v(" "), n("transition", { attrs: { name: "multiselect__loading" } }, [t._t("loading", [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.loading, expression: "loading" }], staticClass: "multiselect__spinner" })])], 2), t._v(" "), t.searchable ? n("input", { ref: "search", staticClass: "multiselect__input", style: t.inputStyle, attrs: { name: t.name, id: t.id, type: "text", autocomplete: "nope", placeholder: t.placeholder, disabled: t.disabled, tabindex: t.tabindex }, domProps: { value: t.search }, on: { input: function input(e) {
            t.updateSearch(e.target.value);
          }, focus: function focus(e) {
            e.preventDefault(), t.activate();
          }, blur: function blur(e) {
            e.preventDefault(), t.deactivate();
          }, keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;t.deactivate();
          }, keydown: [function (e) {
            if (!("button" in e) && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"])) return null;e.preventDefault(), t.pointerForward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"])) return null;e.preventDefault(), t.pointerBackward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "delete", [8, 46], e.key, ["Backspace", "Delete"])) return null;e.stopPropagation(), t.removeLastElement();
          }], keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") ? (e.preventDefault(), e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          } } }) : t._e(), t._v(" "), t.isSingleLabelVisible ? n("span", { staticClass: "multiselect__single", on: { mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          } } }, [t._t("singleLabel", [[t._v(t._s(t.currentOptionLabel))]], { option: t.singleValue })], 2) : t._e(), t._v(" "), t.isPlaceholderVisible ? n("span", { staticClass: "multiselect__placeholder", on: { mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          } } }, [t._t("placeholder", [t._v("\n          " + t._s(t.placeholder) + "\n        ")])], 2) : t._e()], 2), t._v(" "), n("transition", { attrs: { name: "multiselect" } }, [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.isOpen, expression: "isOpen" }], ref: "list", staticClass: "multiselect__content-wrapper", style: { maxHeight: t.optimizedHeight + "px" }, attrs: { tabindex: "-1" }, on: { focus: t.activate, mousedown: function mousedown(t) {
            t.preventDefault();
          } } }, [n("ul", { staticClass: "multiselect__content", style: t.contentStyle }, [t._t("beforeList"), t._v(" "), t.multiple && t.max === t.internalValue.length ? n("li", [n("span", { staticClass: "multiselect__option" }, [t._t("maxElements", [t._v("Maximum of " + t._s(t.max) + " options selected. First remove a selected option to select another.")])], 2)]) : t._e(), t._v(" "), !t.max || t.internalValue.length < t.max ? t._l(t.filteredOptions, function (e, i) {
        return n("li", { key: i, staticClass: "multiselect__element" }, [e && (e.$isLabel || e.$isDisabled) ? t._e() : n("span", { staticClass: "multiselect__option", class: t.optionHighlight(i, e), attrs: { "data-select": e && e.isTag ? t.tagPlaceholder : t.selectLabelText, "data-selected": t.selectedLabelText, "data-deselect": t.deselectLabelText }, on: { click: function click(n) {
              n.stopPropagation(), t.select(e);
            }, mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;t.pointerSet(i);
            } } }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], { option: e, search: t.search })], 2), t._v(" "), e && (e.$isLabel || e.$isDisabled) ? n("span", { staticClass: "multiselect__option", class: t.groupHighlight(i, e), attrs: { "data-select": t.groupSelect && t.selectGroupLabelText, "data-deselect": t.groupSelect && t.deselectGroupLabelText }, on: { mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;t.groupSelect && t.pointerSet(i);
            }, mousedown: function mousedown(n) {
              n.preventDefault(), t.selectGroup(e);
            } } }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], { option: e, search: t.search })], 2) : t._e()]);
      }) : t._e(), t._v(" "), n("li", { directives: [{ name: "show", rawName: "v-show", value: t.showNoResults && 0 === t.filteredOptions.length && t.search && !t.loading, expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)" }] }, [n("span", { staticClass: "multiselect__option" }, [t._t("noResult", [t._v("No elements found. Consider changing the search query.")], { search: t.search })], 2)]), t._v(" "), n("li", { directives: [{ name: "show", rawName: "v-show", value: t.showNoOptions && 0 === t.options.length && !t.search && !t.loading, expression: "showNoOptions && (options.length === 0 && !search && !loading)" }] }, [n("span", { staticClass: "multiselect__option" }, [t._t("noOptions", [t._v("List is empty.")])], 2)]), t._v(" "), t._t("afterList")], 2)])])], 2);
    },
        r = [],
        o = { render: i, staticRenderFns: r };e.a = o;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(679);
var defined = __webpack_require__(581);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(165).EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(166);
/*</replacement>*/

var Buffer = __webpack_require__(41).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(317);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(318);
var destroyImpl = __webpack_require__(167);
var _require = __webpack_require__(168),
    getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__(48).codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(64)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(49);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(170).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(49);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(170).StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(322);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(323);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(27)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var R = (typeof Reflect === 'undefined' ? 'undefined' : _typeof(Reflect)) === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === 'undefined' ? 'undefined' : _typeof(listener)));
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function get() {
    return defaultMaxListeners;
  },
  set: function set(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function () {

  if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) {
    args.push(arguments[i]);
  }var doError = type === 'error';

  var events = this._events;
  if (events !== undefined) doError = doError && events.error === undefined;else if (!doError) return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0) er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined) return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i) {
      ReflectApply(listeners[i], this, args);
    }
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0) return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;

  checkListener(listener);

  events = this._events;
  if (events === undefined) return this;

  list = events[type];
  if (list === undefined) return this;

  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0) this._events = Object.create(null);else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (position === 0) list.shift();else {
      spliceOne(list, position);
    }

    if (list.length === 1) events[type] = list[0];

    if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events, i;

  events = this._events;
  if (events === undefined) return this;

  // not listening for removeListener, no need to emit
  if (events.removeListener === undefined) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events[type] !== undefined) {
      if (--this._eventsCount === 0) this._events = Object.create(null);else delete events[type];
    }
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    var keys = Object.keys(events);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners !== undefined) {
    // LIFO order
    for (i = listeners.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners[i]);
    }
  }

  return this;
};

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined) return [];

  var evlistener = events[type];
  if (evlistener === undefined) return [];

  if (typeof evlistener === 'function') return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i) {
    copy[i] = arr[i];
  }return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++) {
    list[index] = list[index + 1];
  }list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === 'undefined' ? 'undefined' : _typeof(emitter)));
  }
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(165).EventEmitter;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// undocumented cb() API, needed for core, not for public API

function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__(48).codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(320)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(166);
/*</replacement>*/

var Buffer = __webpack_require__(41).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(167);
var _require = __webpack_require__(168),
    getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__(48).codes,
    ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
    ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
    ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(64)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(49);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(49);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(27)))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(321).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\uFFFD';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\uFFFD';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\uFFFD';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\uFFFD';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = __webpack_require__(48).codes,
    ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
    ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
    ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(49);
__webpack_require__(64)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTokenizer = void 0;
var peek_readable_1 = __webpack_require__(88);
/**
 * Core tokenizer
 */

var AbstractTokenizer = function () {
    function AbstractTokenizer(fileInfo) {
        _classCallCheck(this, AbstractTokenizer);

        /**
         * Tokenizer-stream position
         */
        this.position = 0;
        this.numBuffer = new Uint8Array(8);
        this.fileInfo = fileInfo ? fileInfo : {};
    }
    /**
     * Read a token from the tokenizer-stream
     * @param token - The token to read
     * @param position - If provided, the desired position in the tokenizer-stream
     * @returns Promise with token data
     */


    _createClass(AbstractTokenizer, [{
        key: "readToken",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
                var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.position;
                var uint8Array, len;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                uint8Array = Buffer.alloc(token.len);
                                _context.next = 3;
                                return this.readBuffer(uint8Array, { position: position });

                            case 3:
                                len = _context.sent;

                                if (!(len < token.len)) {
                                    _context.next = 6;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 6:
                                return _context.abrupt("return", token.get(uint8Array, 0));

                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function readToken(_x) {
                return _ref.apply(this, arguments);
            }

            return readToken;
        }()
        /**
         * Peek a token from the tokenizer-stream.
         * @param token - Token to peek from the tokenizer-stream.
         * @param position - Offset where to begin reading within the file. If position is null, data will be read from the current file position.
         * @returns Promise with token data
         */

    }, {
        key: "peekToken",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
                var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.position;
                var uint8Array, len;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                uint8Array = Buffer.alloc(token.len);
                                _context2.next = 3;
                                return this.peekBuffer(uint8Array, { position: position });

                            case 3:
                                len = _context2.sent;

                                if (!(len < token.len)) {
                                    _context2.next = 6;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 6:
                                return _context2.abrupt("return", token.get(uint8Array, 0));

                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function peekToken(_x3) {
                return _ref2.apply(this, arguments);
            }

            return peekToken;
        }()
        /**
         * Read a numeric token from the stream
         * @param token - Numeric token
         * @returns Promise with number
         */

    }, {
        key: "readNumber",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token) {
                var len;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.readBuffer(this.numBuffer, { length: token.len });

                            case 2:
                                len = _context3.sent;

                                if (!(len < token.len)) {
                                    _context3.next = 5;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 5:
                                return _context3.abrupt("return", token.get(this.numBuffer, 0));

                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function readNumber(_x5) {
                return _ref3.apply(this, arguments);
            }

            return readNumber;
        }()
        /**
         * Read a numeric token from the stream
         * @param token - Numeric token
         * @returns Promise with number
         */

    }, {
        key: "peekNumber",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(token) {
                var len;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.peekBuffer(this.numBuffer, { length: token.len });

                            case 2:
                                len = _context4.sent;

                                if (!(len < token.len)) {
                                    _context4.next = 5;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 5:
                                return _context4.abrupt("return", token.get(this.numBuffer, 0));

                            case 6:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function peekNumber(_x6) {
                return _ref4.apply(this, arguments);
            }

            return peekNumber;
        }()
        /**
         * Ignore number of bytes, advances the pointer in under tokenizer-stream.
         * @param length - Number of bytes to ignore
         * @return resolves the number of bytes ignored, equals length if this available, otherwise the number of bytes available
         */

    }, {
        key: "ignore",
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(length) {
                var bytesLeft;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(this.fileInfo.size !== undefined)) {
                                    _context5.next = 5;
                                    break;
                                }

                                bytesLeft = this.fileInfo.size - this.position;

                                if (!(length > bytesLeft)) {
                                    _context5.next = 5;
                                    break;
                                }

                                this.position += bytesLeft;
                                return _context5.abrupt("return", bytesLeft);

                            case 5:
                                this.position += length;
                                return _context5.abrupt("return", length);

                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function ignore(_x7) {
                return _ref5.apply(this, arguments);
            }

            return ignore;
        }()
    }, {
        key: "close",
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function close() {
                return _ref6.apply(this, arguments);
            }

            return close;
        }()
    }, {
        key: "normalizeOptions",
        value: function normalizeOptions(uint8Array, options) {
            if (options && options.position !== undefined && options.position < this.position) {
                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');
            }
            if (options) {
                return {
                    mayBeLess: options.mayBeLess === true,
                    offset: options.offset ? options.offset : 0,
                    length: options.length ? options.length : uint8Array.length - (options.offset ? options.offset : 0),
                    position: options.position ? options.position : this.position
                };
            }
            return {
                mayBeLess: false,
                offset: 0,
                length: uint8Array.length,
                position: this.position
            };
        }
    }]);

    return AbstractTokenizer;
}();

exports.AbstractTokenizer = AbstractTokenizer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addMonths_index_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__ = __webpack_require__(3);






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  if (!duration || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.years) : 0;
  var months = duration.months ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.months) : 0;
  var weeks = duration.weeks ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.weeks) : 0;
  var days = duration.days ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.days) : 0;
  var hours = duration.hours ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.hours) : 0;
  var minutes = duration.minutes ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.minutes) : 0;
  var seconds = duration.seconds ? Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])(duration.seconds) : 0;

  // Add years and months
  var date = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a" /* default */])(dirtyDate);
  var dateWithMonths = months || years ? Object(__WEBPACK_IMPORTED_MODULE_2__addMonths_index_js__["a" /* default */])(date, months + years * 12) : date;

  // Add weeks and days
  var dateWithDays = days || weeks ? Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a" /* default */])(dateWithMonths, days + weeks * 7) : dateWithMonths;

  // Add days, hours, minutes and seconds
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addBusinessDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__ = __webpack_require__(175);






/**
 * @name addBusinessDays
 * @category Day Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */
function addBusinessDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var startedOnWeekend = Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a" /* default */])(date);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  if (isNaN(amount)) return new Date(NaN);
  var hours = date.getHours();
  var sign = amount < 0 ? -1 : 1;
  var fullWeeks = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(amount / 5);
  date.setDate(date.getDate() + fullWeeks * 7);

  // Get remaining days not part of a full week
  var restDays = Math.abs(amount % 5);

  // Loops over remaining days
  while (restDays > 0) {
    date.setDate(date.getDate() + sign);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a" /* default */])(date)) restDays -= 1;
  }

  // If the date is a weekend day and we reduce a dividable of
  // 5 from it, we land on a weekend date.
  // To counter this, we add days accordingly to land on the next business day
  if (startedOnWeekend && Object(__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a" /* default */])(date) && amount !== 0) {
    // If we're reducing days, we want to add days until we land on a weekday
    // If we're adding days we want to reduce days until we land on a weekday
    if (Object(__WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__["a" /* default */])(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__["a" /* default */])(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
  }

  // Restore hours to avoid DST lag
  date.setHours(hours);
  return date;
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSaturday;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 6;
}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addISOWeekYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOWeekYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__["a" /* default */])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__["a" /* default */])(dirtyDate) + amount);
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);





/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyISOWeekYear);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a" /* default */])(date));
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a" /* default */])(fourthOfJanuary);
  date.setDate(date.getDate() + diff);
  return date;
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * 1000);
}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a" /* default */])(dirtyDate, amount * 12);
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return value instanceof Date || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarISOWeekYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDateLeft) - Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDateRight);
}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInCalendarQuarters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var quarterDiff = Object(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a" /* default */])(dateLeft) - Object(__WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a" /* default */])(dateRight);
  return yearDiff * 4 + quarterDiff;
}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subISOWeekYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addISOWeekYears_index_js__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOWeekYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addISOWeekYears_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLastDayOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  return Object(__WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__["a" /* default */])(date).getTime() === Object(__WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a" /* default */])(date).getTime();
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = differenceInYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight);
  var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__["a" /* default */])(dateLeft, dateRight));

  // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eachDayOfInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }
  return dates;
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_format_formatters_index_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_defaultLocale_index_js__ = __webpack_require__(53);










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  Object(__WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_9__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_10__lib_defaultLocale_index_js__["a" /* default */];
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(dirtyDate);
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = __WEBPACK_IMPORTED_MODULE_3__lib_format_formatters_index_js__["a" /* default */][firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__ = __webpack_require__(70);



function getUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a" /* default */])(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(52);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differenceInSeconds_index_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_defaultLocale_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_cloneObject_index_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_assign_index_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0);










var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;
  Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_4__lib_defaultLocale_index_js__["a" /* default */];
  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }
  var comparison = Object(__WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__["a" /* default */])(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = Object(__WEBPACK_IMPORTED_MODULE_7__lib_assign_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__lib_cloneObject_index_js__["a" /* default */])(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyBaseDate);
    dateRight = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyDate);
  } else {
    dateLeft = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyDate);
    dateRight = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyBaseDate);
  }
  var seconds = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInSeconds_index_js__["a" /* default */])(dateRight, dateLeft);
  var offsetInSeconds = (Object(__WEBPACK_IMPORTED_MODULE_8__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(dateRight) - Object(__WEBPACK_IMPORTED_MODULE_8__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }
  months = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__["a" /* default */])(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assign_index_js__ = __webpack_require__(72);

function cloneObject(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assign_index_js__["a" /* default */])({}, object);
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistanceStrict;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_assign_index_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_defaultLocale_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);








var MILLISECONDS_IN_MINUTE = 1000 * 60;
var MINUTES_IN_DAY = 60 * 24;
var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _options$roundingMeth;
  Object(__WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_6__lib_defaultLocale_index_js__["a" /* default */];
  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property');
  }
  var comparison = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }
  var localizeOptions = Object(__WEBPACK_IMPORTED_MODULE_5__lib_assign_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__["a" /* default */])(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison: comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a" /* default */])(dirtyBaseDate);
    dateRight = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a" /* default */])(dirtyDate);
  } else {
    dateLeft = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a" /* default */])(dirtyDate);
    dateRight = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a" /* default */])(dirtyBaseDate);
  }
  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
  var roundingMethodFn;
  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }
  var milliseconds = dateRight.getTime() - dateLeft.getTime();
  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(dateRight) - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(dateLeft);

  // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.
  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
  var unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = 'second';
    } else if (minutes < 60) {
      unit = 'minute';
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'hour';
    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
      unit = 'day';
    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
      unit = 'month';
    } else {
      unit = 'year';
    }
  } else {
    unit = String(defaultUnit);
  }

  // 0 up to 60 seconds
  if (unit === 'second') {
    var seconds = roundingMethodFn(milliseconds / 1000);
    return locale.formatDistance('xSeconds', seconds, localizeOptions);

    // 1 up to 60 mins
  } else if (unit === 'minute') {
    var roundedMinutes = roundingMethodFn(minutes);
    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);

    // 1 up to 24 hours
  } else if (unit === 'hour') {
    var hours = roundingMethodFn(minutes / 60);
    return locale.formatDistance('xHours', hours, localizeOptions);

    // 1 up to 30 days
  } else if (unit === 'day') {
    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions);

    // 1 up to 12 months
  } else if (unit === 'month') {
    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
    return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);

    // 1 year up to max Date
  } else if (unit === 'year') {
    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
    return locale.formatDistance('xYears', years, localizeOptions);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLeapYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a" /* default */])(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a" /* default */])(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__ = __webpack_require__(13);





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a" /* default */])(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createForOfIteratorHelper__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_defaultLocale_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_assign_index_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_format_longFormatters_index_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_protectedTokens_index_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_Setter_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_parsers_index_js__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_defaultOptions_index_js__ = __webpack_require__(13);













 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  Object(__WEBPACK_IMPORTED_MODULE_10__lib_requiredArgs_index_js__["a" /* default */])(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_13__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_2__lib_defaultLocale_index_js__["a" /* default */];
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_9__lib_toInteger_index_js__["a" /* default */])((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_9__lib_toInteger_index_js__["a" /* default */])((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a" /* default */])(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new __WEBPACK_IMPORTED_MODULE_11__lib_Setter_js__["a" /* DateToSystemTimezoneSetter */]()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in __WEBPACK_IMPORTED_MODULE_6__lib_format_longFormatters_index_js__["a" /* default */]) {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_6__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createForOfIteratorHelper__["a" /* default */])(tokens),
      _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_8__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(token)) {
        Object(__WEBPACK_IMPORTED_MODULE_8__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && Object(__WEBPACK_IMPORTED_MODULE_8__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(token)) {
        Object(__WEBPACK_IMPORTED_MODULE_8__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = __WEBPACK_IMPORTED_MODULE_12__lib_parsers_index_js__["a" /* parsers */][firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = Object(__WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a" /* default */])(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_7__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var flags = {};
  var _iterator2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createForOfIteratorHelper__["a" /* default */])(uniquePrioritySetters),
      _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        Object(__WEBPACK_IMPORTED_MODULE_5__lib_assign_index_js__["a" /* default */])(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Setter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ValueSetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateToSystemTimezoneSetter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);






var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Setter);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "priority", void 0);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "subPriority", 0);
  }
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inherits__["a" /* default */])(ValueSetter, _Setter);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inherits__["a" /* default */])(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2), "subPriority", -1);
    return _this2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(425);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameHour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */
function isSameHour(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfHour = Object(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfHour = Object(__WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfHour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */
function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a" /* default */])(dirtyDateLeft, dirtyDateRight, {
    weekStartsOn: 1
  });
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameMinute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */
function isSameMinute(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfMinute = Object(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfMinute = Object(__WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameSecond;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */
function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfSecond = Object(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfSecond = Object(__WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfSecond;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setMilliseconds(0);
  return date;
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lastDayOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__ = __webpack_require__(13);




/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_3__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date;
}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var settle = __webpack_require__(551);
var buildURL = __webpack_require__(553);
var parseHeaders = __webpack_require__(554);
var isURLSameOrigin = __webpack_require__(555);
var createError = __webpack_require__(227);
var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(556);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || request.readyState !== 4 && !xDomain) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(557);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(552);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(652),
    baseAssignValue = __webpack_require__(565);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var e = Object.freeze({});function t(e) {
  return null == e;
}function n(e) {
  return null != e;
}function r(e) {
  return !0 === e;
}function i(e) {
  return "string" == typeof e || "number" == typeof e || "symbol" == (typeof e === "undefined" ? "undefined" : _typeof(e)) || "boolean" == typeof e;
}function o(e) {
  return null !== e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e));
}var a = Object.prototype.toString;function s(e) {
  return "[object Object]" === a.call(e);
}function c(e) {
  var t = parseFloat(String(e));return t >= 0 && Math.floor(t) === t && isFinite(e);
}function u(e) {
  return n(e) && "function" == typeof e.then && "function" == typeof e.catch;
}function l(e) {
  return null == e ? "" : Array.isArray(e) || s(e) && e.toString === a ? JSON.stringify(e, null, 2) : String(e);
}function f(e) {
  var t = parseFloat(e);return isNaN(t) ? e : t;
}function p(e, t) {
  for (var n = Object.create(null), r = e.split(","), i = 0; i < r.length; i++) {
    n[r[i]] = !0;
  }return t ? function (e) {
    return n[e.toLowerCase()];
  } : function (e) {
    return n[e];
  };
}var d = p("slot,component", !0),
    v = p("key,ref,slot,slot-scope,is");function h(e, t) {
  if (e.length) {
    var n = e.indexOf(t);if (n > -1) return e.splice(n, 1);
  }
}var m = Object.prototype.hasOwnProperty;function y(e, t) {
  return m.call(e, t);
}function g(e) {
  var t = Object.create(null);return function (n) {
    return t[n] || (t[n] = e(n));
  };
}var _ = /-(\w)/g,
    b = g(function (e) {
  return e.replace(_, function (e, t) {
    return t ? t.toUpperCase() : "";
  });
}),
    $ = g(function (e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}),
    w = /\B([A-Z])/g,
    C = g(function (e) {
  return e.replace(w, "-$1").toLowerCase();
});var x = Function.prototype.bind ? function (e, t) {
  return e.bind(t);
} : function (e, t) {
  function n(n) {
    var r = arguments.length;return r ? r > 1 ? e.apply(t, arguments) : e.call(t, n) : e.call(t);
  }return n._length = e.length, n;
};function k(e, t) {
  t = t || 0;for (var n = e.length - t, r = new Array(n); n--;) {
    r[n] = e[n + t];
  }return r;
}function A(e, t) {
  for (var n in t) {
    e[n] = t[n];
  }return e;
}function O(e) {
  for (var t = {}, n = 0; n < e.length; n++) {
    e[n] && A(t, e[n]);
  }return t;
}function S(e, t, n) {}var T = function T(e, t, n) {
  return !1;
},
    E = function E(e) {
  return e;
};function N(e, t) {
  if (e === t) return !0;var n = o(e),
      r = o(t);if (!n || !r) return !n && !r && String(e) === String(t);try {
    var i = Array.isArray(e),
        a = Array.isArray(t);if (i && a) return e.length === t.length && e.every(function (e, n) {
      return N(e, t[n]);
    });if (e instanceof Date && t instanceof Date) return e.getTime() === t.getTime();if (i || a) return !1;var s = Object.keys(e),
        c = Object.keys(t);return s.length === c.length && s.every(function (n) {
      return N(e[n], t[n]);
    });
  } catch (e) {
    return !1;
  }
}function j(e, t) {
  for (var n = 0; n < e.length; n++) {
    if (N(e[n], t)) return n;
  }return -1;
}function D(e) {
  var t = !1;return function () {
    t || (t = !0, e.apply(this, arguments));
  };
}var L = "data-server-rendered",
    M = ["component", "directive", "filter"],
    I = ["beforeCreate", "created", "beforeMount", "mounted", "beforeUpdate", "updated", "beforeDestroy", "destroyed", "activated", "deactivated", "errorCaptured", "serverPrefetch"],
    F = { optionMergeStrategies: Object.create(null), silent: !1, productionTip: !1, devtools: !1, performance: !1, errorHandler: null, warnHandler: null, ignoredElements: [], keyCodes: Object.create(null), isReservedTag: T, isReservedAttr: T, isUnknownElement: T, getTagNamespace: S, parsePlatformTagName: E, mustUseProp: T, async: !0, _lifecycleHooks: I },
    P = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e, t, n, r) {
  Object.defineProperty(e, t, { value: n, enumerable: !!r, writable: !0, configurable: !0 });
}var H = new RegExp("[^" + P.source + ".$_\\d]");var B,
    U = "__proto__" in {},
    z = "undefined" != typeof window,
    V = "undefined" != typeof WXEnvironment && !!WXEnvironment.platform,
    K = V && WXEnvironment.platform.toLowerCase(),
    J = z && window.navigator.userAgent.toLowerCase(),
    q = J && /msie|trident/.test(J),
    W = J && J.indexOf("msie 9.0") > 0,
    Z = J && J.indexOf("edge/") > 0,
    G = (J && J.indexOf("android"), J && /iphone|ipad|ipod|ios/.test(J) || "ios" === K),
    X = (J && /chrome\/\d+/.test(J), J && /phantomjs/.test(J), J && J.match(/firefox\/(\d+)/)),
    Y = {}.watch,
    Q = !1;if (z) try {
  var ee = {};Object.defineProperty(ee, "passive", { get: function get() {
      Q = !0;
    } }), window.addEventListener("test-passive", null, ee);
} catch (e) {}var te = function te() {
  return void 0 === B && (B = !z && !V && "undefined" != typeof global && global.process && "server" === global.process.env.VUE_ENV), B;
},
    ne = z && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e) {
  return "function" == typeof e && /native code/.test(e.toString());
}var ie,
    oe = "undefined" != typeof Symbol && re(Symbol) && "undefined" != typeof Reflect && re(Reflect.ownKeys);ie = "undefined" != typeof Set && re(Set) ? Set : function () {
  function e() {
    this.set = Object.create(null);
  }return e.prototype.has = function (e) {
    return !0 === this.set[e];
  }, e.prototype.add = function (e) {
    this.set[e] = !0;
  }, e.prototype.clear = function () {
    this.set = Object.create(null);
  }, e;
}();var ae = S,
    se = 0,
    ce = function ce() {
  this.id = se++, this.subs = [];
};ce.prototype.addSub = function (e) {
  this.subs.push(e);
}, ce.prototype.removeSub = function (e) {
  h(this.subs, e);
}, ce.prototype.depend = function () {
  ce.target && ce.target.addDep(this);
}, ce.prototype.notify = function () {
  for (var e = this.subs.slice(), t = 0, n = e.length; t < n; t++) {
    e[t].update();
  }
}, ce.target = null;var ue = [];function le(e) {
  ue.push(e), ce.target = e;
}function fe() {
  ue.pop(), ce.target = ue[ue.length - 1];
}var pe = function pe(e, t, n, r, i, o, a, s) {
  this.tag = e, this.data = t, this.children = n, this.text = r, this.elm = i, this.ns = void 0, this.context = o, this.fnContext = void 0, this.fnOptions = void 0, this.fnScopeId = void 0, this.key = t && t.key, this.componentOptions = a, this.componentInstance = void 0, this.parent = void 0, this.raw = !1, this.isStatic = !1, this.isRootInsert = !0, this.isComment = !1, this.isCloned = !1, this.isOnce = !1, this.asyncFactory = s, this.asyncMeta = void 0, this.isAsyncPlaceholder = !1;
},
    de = { child: { configurable: !0 } };de.child.get = function () {
  return this.componentInstance;
}, Object.defineProperties(pe.prototype, de);var ve = function ve(e) {
  void 0 === e && (e = "");var t = new pe();return t.text = e, t.isComment = !0, t;
};function he(e) {
  return new pe(void 0, void 0, void 0, String(e));
}function me(e) {
  var t = new pe(e.tag, e.data, e.children && e.children.slice(), e.text, e.elm, e.context, e.componentOptions, e.asyncFactory);return t.ns = e.ns, t.isStatic = e.isStatic, t.key = e.key, t.isComment = e.isComment, t.fnContext = e.fnContext, t.fnOptions = e.fnOptions, t.fnScopeId = e.fnScopeId, t.asyncMeta = e.asyncMeta, t.isCloned = !0, t;
}var ye = Array.prototype,
    ge = Object.create(ye);["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(function (e) {
  var t = ye[e];R(ge, e, function () {
    for (var n = [], r = arguments.length; r--;) {
      n[r] = arguments[r];
    }var i,
        o = t.apply(this, n),
        a = this.__ob__;switch (e) {case "push":case "unshift":
        i = n;break;case "splice":
        i = n.slice(2);}return i && a.observeArray(i), a.dep.notify(), o;
  });
});var _e = Object.getOwnPropertyNames(ge),
    be = !0;function $e(e) {
  be = e;
}var we = function we(e) {
  var t;this.value = e, this.dep = new ce(), this.vmCount = 0, R(e, "__ob__", this), Array.isArray(e) ? (U ? (t = ge, e.__proto__ = t) : function (e, t, n) {
    for (var r = 0, i = n.length; r < i; r++) {
      var o = n[r];R(e, o, t[o]);
    }
  }(e, ge, _e), this.observeArray(e)) : this.walk(e);
};function Ce(e, t) {
  var n;if (o(e) && !(e instanceof pe)) return y(e, "__ob__") && e.__ob__ instanceof we ? n = e.__ob__ : be && !te() && (Array.isArray(e) || s(e)) && Object.isExtensible(e) && !e._isVue && (n = new we(e)), t && n && n.vmCount++, n;
}function xe(e, t, n, r, i) {
  var o = new ce(),
      a = Object.getOwnPropertyDescriptor(e, t);if (!a || !1 !== a.configurable) {
    var s = a && a.get,
        c = a && a.set;s && !c || 2 !== arguments.length || (n = e[t]);var u = !i && Ce(n);Object.defineProperty(e, t, { enumerable: !0, configurable: !0, get: function get() {
        var t = s ? s.call(e) : n;return ce.target && (o.depend(), u && (u.dep.depend(), Array.isArray(t) && function e(t) {
          for (var n = void 0, r = 0, i = t.length; r < i; r++) {
            (n = t[r]) && n.__ob__ && n.__ob__.dep.depend(), Array.isArray(n) && e(n);
          }
        }(t))), t;
      }, set: function set(t) {
        var r = s ? s.call(e) : n;t === r || t != t && r != r || s && !c || (c ? c.call(e, t) : n = t, u = !i && Ce(t), o.notify());
      } });
  }
}function ke(e, t, n) {
  if (Array.isArray(e) && c(t)) return e.length = Math.max(e.length, t), e.splice(t, 1, n), n;if (t in e && !(t in Object.prototype)) return e[t] = n, n;var r = e.__ob__;return e._isVue || r && r.vmCount ? n : r ? (xe(r.value, t, n), r.dep.notify(), n) : (e[t] = n, n);
}function Ae(e, t) {
  if (Array.isArray(e) && c(t)) e.splice(t, 1);else {
    var n = e.__ob__;e._isVue || n && n.vmCount || y(e, t) && (delete e[t], n && n.dep.notify());
  }
}we.prototype.walk = function (e) {
  for (var t = Object.keys(e), n = 0; n < t.length; n++) {
    xe(e, t[n]);
  }
}, we.prototype.observeArray = function (e) {
  for (var t = 0, n = e.length; t < n; t++) {
    Ce(e[t]);
  }
};var Oe = F.optionMergeStrategies;function Se(e, t) {
  if (!t) return e;for (var n, r, i, o = oe ? Reflect.ownKeys(t) : Object.keys(t), a = 0; a < o.length; a++) {
    "__ob__" !== (n = o[a]) && (r = e[n], i = t[n], y(e, n) ? r !== i && s(r) && s(i) && Se(r, i) : ke(e, n, i));
  }return e;
}function Te(e, t, n) {
  return n ? function () {
    var r = "function" == typeof t ? t.call(n, n) : t,
        i = "function" == typeof e ? e.call(n, n) : e;return r ? Se(r, i) : i;
  } : t ? e ? function () {
    return Se("function" == typeof t ? t.call(this, this) : t, "function" == typeof e ? e.call(this, this) : e);
  } : t : e;
}function Ee(e, t) {
  var n = t ? e ? e.concat(t) : Array.isArray(t) ? t : [t] : e;return n ? function (e) {
    for (var t = [], n = 0; n < e.length; n++) {
      -1 === t.indexOf(e[n]) && t.push(e[n]);
    }return t;
  }(n) : n;
}function Ne(e, t, n, r) {
  var i = Object.create(e || null);return t ? A(i, t) : i;
}Oe.data = function (e, t, n) {
  return n ? Te(e, t, n) : t && "function" != typeof t ? e : Te(e, t);
}, I.forEach(function (e) {
  Oe[e] = Ee;
}), M.forEach(function (e) {
  Oe[e + "s"] = Ne;
}), Oe.watch = function (e, t, n, r) {
  if (e === Y && (e = void 0), t === Y && (t = void 0), !t) return Object.create(e || null);if (!e) return t;var i = {};for (var o in A(i, e), t) {
    var a = i[o],
        s = t[o];a && !Array.isArray(a) && (a = [a]), i[o] = a ? a.concat(s) : Array.isArray(s) ? s : [s];
  }return i;
}, Oe.props = Oe.methods = Oe.inject = Oe.computed = function (e, t, n, r) {
  if (!e) return t;var i = Object.create(null);return A(i, e), t && A(i, t), i;
}, Oe.provide = Te;var je = function je(e, t) {
  return void 0 === t ? e : t;
};function De(e, t, n) {
  if ("function" == typeof t && (t = t.options), function (e, t) {
    var n = e.props;if (n) {
      var r,
          i,
          o = {};if (Array.isArray(n)) for (r = n.length; r--;) {
        "string" == typeof (i = n[r]) && (o[b(i)] = { type: null });
      } else if (s(n)) for (var a in n) {
        i = n[a], o[b(a)] = s(i) ? i : { type: i };
      }e.props = o;
    }
  }(t), function (e, t) {
    var n = e.inject;if (n) {
      var r = e.inject = {};if (Array.isArray(n)) for (var i = 0; i < n.length; i++) {
        r[n[i]] = { from: n[i] };
      } else if (s(n)) for (var o in n) {
        var a = n[o];r[o] = s(a) ? A({ from: o }, a) : { from: a };
      }
    }
  }(t), function (e) {
    var t = e.directives;if (t) for (var n in t) {
      var r = t[n];"function" == typeof r && (t[n] = { bind: r, update: r });
    }
  }(t), !t._base && (t.extends && (e = De(e, t.extends, n)), t.mixins)) for (var r = 0, i = t.mixins.length; r < i; r++) {
    e = De(e, t.mixins[r], n);
  }var o,
      a = {};for (o in e) {
    c(o);
  }for (o in t) {
    y(e, o) || c(o);
  }function c(r) {
    var i = Oe[r] || je;a[r] = i(e[r], t[r], n, r);
  }return a;
}function Le(e, t, n, r) {
  if ("string" == typeof n) {
    var i = e[t];if (y(i, n)) return i[n];var o = b(n);if (y(i, o)) return i[o];var a = $(o);return y(i, a) ? i[a] : i[n] || i[o] || i[a];
  }
}function Me(e, t, n, r) {
  var i = t[e],
      o = !y(n, e),
      a = n[e],
      s = Pe(Boolean, i.type);if (s > -1) if (o && !y(i, "default")) a = !1;else if ("" === a || a === C(e)) {
    var c = Pe(String, i.type);(c < 0 || s < c) && (a = !0);
  }if (void 0 === a) {
    a = function (e, t, n) {
      if (!y(t, "default")) return;var r = t.default;if (e && e.$options.propsData && void 0 === e.$options.propsData[n] && void 0 !== e._props[n]) return e._props[n];return "function" == typeof r && "Function" !== Ie(t.type) ? r.call(e) : r;
    }(r, i, e);var u = be;$e(!0), Ce(a), $e(u);
  }return a;
}function Ie(e) {
  var t = e && e.toString().match(/^\s*function (\w+)/);return t ? t[1] : "";
}function Fe(e, t) {
  return Ie(e) === Ie(t);
}function Pe(e, t) {
  if (!Array.isArray(t)) return Fe(t, e) ? 0 : -1;for (var n = 0, r = t.length; n < r; n++) {
    if (Fe(t[n], e)) return n;
  }return -1;
}function Re(e, t, n) {
  le();try {
    if (t) for (var r = t; r = r.$parent;) {
      var i = r.$options.errorCaptured;if (i) for (var o = 0; o < i.length; o++) {
        try {
          if (!1 === i[o].call(r, e, t, n)) return;
        } catch (e) {
          Be(e, r, "errorCaptured hook");
        }
      }
    }Be(e, t, n);
  } finally {
    fe();
  }
}function He(e, t, n, r, i) {
  var o;try {
    (o = n ? e.apply(t, n) : e.call(t)) && !o._isVue && u(o) && !o._handled && (o.catch(function (e) {
      return Re(e, r, i + " (Promise/async)");
    }), o._handled = !0);
  } catch (e) {
    Re(e, r, i);
  }return o;
}function Be(e, t, n) {
  if (F.errorHandler) try {
    return F.errorHandler.call(null, e, t, n);
  } catch (t) {
    t !== e && Ue(t, null, "config.errorHandler");
  }Ue(e, t, n);
}function Ue(e, t, n) {
  if (!z && !V || "undefined" == typeof console) throw e;console.error(e);
}var ze,
    Ve = !1,
    Ke = [],
    Je = !1;function qe() {
  Je = !1;var e = Ke.slice(0);Ke.length = 0;for (var t = 0; t < e.length; t++) {
    e[t]();
  }
}if ("undefined" != typeof Promise && re(Promise)) {
  var We = Promise.resolve();ze = function ze() {
    We.then(qe), G && setTimeout(S);
  }, Ve = !0;
} else if (q || "undefined" == typeof MutationObserver || !re(MutationObserver) && "[object MutationObserverConstructor]" !== MutationObserver.toString()) ze = "undefined" != typeof setImmediate && re(setImmediate) ? function () {
  setImmediate(qe);
} : function () {
  setTimeout(qe, 0);
};else {
  var Ze = 1,
      Ge = new MutationObserver(qe),
      Xe = document.createTextNode(String(Ze));Ge.observe(Xe, { characterData: !0 }), ze = function ze() {
    Ze = (Ze + 1) % 2, Xe.data = String(Ze);
  }, Ve = !0;
}function Ye(e, t) {
  var n;if (Ke.push(function () {
    if (e) try {
      e.call(t);
    } catch (e) {
      Re(e, t, "nextTick");
    } else n && n(t);
  }), Je || (Je = !0, ze()), !e && "undefined" != typeof Promise) return new Promise(function (e) {
    n = e;
  });
}var Qe = new ie();function et(e) {
  !function e(t, n) {
    var r, i;var a = Array.isArray(t);if (!a && !o(t) || Object.isFrozen(t) || t instanceof pe) return;if (t.__ob__) {
      var s = t.__ob__.dep.id;if (n.has(s)) return;n.add(s);
    }if (a) for (r = t.length; r--;) {
      e(t[r], n);
    } else for (i = Object.keys(t), r = i.length; r--;) {
      e(t[i[r]], n);
    }
  }(e, Qe), Qe.clear();
}var tt = g(function (e) {
  var t = "&" === e.charAt(0),
      n = "~" === (e = t ? e.slice(1) : e).charAt(0),
      r = "!" === (e = n ? e.slice(1) : e).charAt(0);return { name: e = r ? e.slice(1) : e, once: n, capture: r, passive: t };
});function nt(e, t) {
  function n() {
    var e = arguments,
        r = n.fns;if (!Array.isArray(r)) return He(r, null, arguments, t, "v-on handler");for (var i = r.slice(), o = 0; o < i.length; o++) {
      He(i[o], null, e, t, "v-on handler");
    }
  }return n.fns = e, n;
}function rt(e, n, i, o, a, s) {
  var c, u, l, f;for (c in e) {
    u = e[c], l = n[c], f = tt(c), t(u) || (t(l) ? (t(u.fns) && (u = e[c] = nt(u, s)), r(f.once) && (u = e[c] = a(f.name, u, f.capture)), i(f.name, u, f.capture, f.passive, f.params)) : u !== l && (l.fns = u, e[c] = l));
  }for (c in n) {
    t(e[c]) && o((f = tt(c)).name, n[c], f.capture);
  }
}function it(e, i, o) {
  var a;e instanceof pe && (e = e.data.hook || (e.data.hook = {}));var s = e[i];function c() {
    o.apply(this, arguments), h(a.fns, c);
  }t(s) ? a = nt([c]) : n(s.fns) && r(s.merged) ? (a = s).fns.push(c) : a = nt([s, c]), a.merged = !0, e[i] = a;
}function ot(e, t, r, i, o) {
  if (n(t)) {
    if (y(t, r)) return e[r] = t[r], o || delete t[r], !0;if (y(t, i)) return e[r] = t[i], o || delete t[i], !0;
  }return !1;
}function at(e) {
  return i(e) ? [he(e)] : Array.isArray(e) ? function e(o, a) {
    var s = [];var c, u, l, f;for (c = 0; c < o.length; c++) {
      t(u = o[c]) || "boolean" == typeof u || (l = s.length - 1, f = s[l], Array.isArray(u) ? u.length > 0 && (st((u = e(u, (a || "") + "_" + c))[0]) && st(f) && (s[l] = he(f.text + u[0].text), u.shift()), s.push.apply(s, u)) : i(u) ? st(f) ? s[l] = he(f.text + u) : "" !== u && s.push(he(u)) : st(u) && st(f) ? s[l] = he(f.text + u.text) : (r(o._isVList) && n(u.tag) && t(u.key) && n(a) && (u.key = "__vlist" + a + "_" + c + "__"), s.push(u)));
    }return s;
  }(e) : void 0;
}function st(e) {
  return n(e) && n(e.text) && !1 === e.isComment;
}function ct(e, t) {
  if (e) {
    for (var n = Object.create(null), r = oe ? Reflect.ownKeys(e) : Object.keys(e), i = 0; i < r.length; i++) {
      var o = r[i];if ("__ob__" !== o) {
        for (var a = e[o].from, s = t; s;) {
          if (s._provided && y(s._provided, a)) {
            n[o] = s._provided[a];break;
          }s = s.$parent;
        }if (!s && "default" in e[o]) {
          var c = e[o].default;n[o] = "function" == typeof c ? c.call(t) : c;
        }
      }
    }return n;
  }
}function ut(e, t) {
  if (!e || !e.length) return {};for (var n = {}, r = 0, i = e.length; r < i; r++) {
    var o = e[r],
        a = o.data;if (a && a.attrs && a.attrs.slot && delete a.attrs.slot, o.context !== t && o.fnContext !== t || !a || null == a.slot) (n.default || (n.default = [])).push(o);else {
      var s = a.slot,
          c = n[s] || (n[s] = []);"template" === o.tag ? c.push.apply(c, o.children || []) : c.push(o);
    }
  }for (var u in n) {
    n[u].every(lt) && delete n[u];
  }return n;
}function lt(e) {
  return e.isComment && !e.asyncFactory || " " === e.text;
}function ft(t, n, r) {
  var i,
      o = Object.keys(n).length > 0,
      a = t ? !!t.$stable : !o,
      s = t && t.$key;if (t) {
    if (t._normalized) return t._normalized;if (a && r && r !== e && s === r.$key && !o && !r.$hasNormal) return r;for (var c in i = {}, t) {
      t[c] && "$" !== c[0] && (i[c] = pt(n, c, t[c]));
    }
  } else i = {};for (var u in n) {
    u in i || (i[u] = dt(n, u));
  }return t && Object.isExtensible(t) && (t._normalized = i), R(i, "$stable", a), R(i, "$key", s), R(i, "$hasNormal", o), i;
}function pt(e, t, n) {
  var r = function r() {
    var e = arguments.length ? n.apply(null, arguments) : n({});return (e = e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && !Array.isArray(e) ? [e] : at(e)) && (0 === e.length || 1 === e.length && e[0].isComment) ? void 0 : e;
  };return n.proxy && Object.defineProperty(e, t, { get: r, enumerable: !0, configurable: !0 }), r;
}function dt(e, t) {
  return function () {
    return e[t];
  };
}function vt(e, t) {
  var r, i, a, s, c;if (Array.isArray(e) || "string" == typeof e) for (r = new Array(e.length), i = 0, a = e.length; i < a; i++) {
    r[i] = t(e[i], i);
  } else if ("number" == typeof e) for (r = new Array(e), i = 0; i < e; i++) {
    r[i] = t(i + 1, i);
  } else if (o(e)) if (oe && e[Symbol.iterator]) {
    r = [];for (var u = e[Symbol.iterator](), l = u.next(); !l.done;) {
      r.push(t(l.value, r.length)), l = u.next();
    }
  } else for (s = Object.keys(e), r = new Array(s.length), i = 0, a = s.length; i < a; i++) {
    c = s[i], r[i] = t(e[c], c, i);
  }return n(r) || (r = []), r._isVList = !0, r;
}function ht(e, t, n, r) {
  var i,
      o = this.$scopedSlots[e];o ? (n = n || {}, r && (n = A(A({}, r), n)), i = o(n) || t) : i = this.$slots[e] || t;var a = n && n.slot;return a ? this.$createElement("template", { slot: a }, i) : i;
}function mt(e) {
  return Le(this.$options, "filters", e) || E;
}function yt(e, t) {
  return Array.isArray(e) ? -1 === e.indexOf(t) : e !== t;
}function gt(e, t, n, r, i) {
  var o = F.keyCodes[t] || n;return i && r && !F.keyCodes[t] ? yt(i, r) : o ? yt(o, e) : r ? C(r) !== t : void 0;
}function _t(e, t, n, r, i) {
  if (n) if (o(n)) {
    var a;Array.isArray(n) && (n = O(n));var s = function s(o) {
      if ("class" === o || "style" === o || v(o)) a = e;else {
        var s = e.attrs && e.attrs.type;a = r || F.mustUseProp(t, s, o) ? e.domProps || (e.domProps = {}) : e.attrs || (e.attrs = {});
      }var c = b(o),
          u = C(o);c in a || u in a || (a[o] = n[o], i && ((e.on || (e.on = {}))["update:" + o] = function (e) {
        n[o] = e;
      }));
    };for (var c in n) {
      s(c);
    }
  } else ;return e;
}function bt(e, t) {
  var n = this._staticTrees || (this._staticTrees = []),
      r = n[e];return r && !t ? r : (wt(r = n[e] = this.$options.staticRenderFns[e].call(this._renderProxy, null, this), "__static__" + e, !1), r);
}function $t(e, t, n) {
  return wt(e, "__once__" + t + (n ? "_" + n : ""), !0), e;
}function wt(e, t, n) {
  if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
    e[r] && "string" != typeof e[r] && Ct(e[r], t + "_" + r, n);
  } else Ct(e, t, n);
}function Ct(e, t, n) {
  e.isStatic = !0, e.key = t, e.isOnce = n;
}function xt(e, t) {
  if (t) if (s(t)) {
    var n = e.on = e.on ? A({}, e.on) : {};for (var r in t) {
      var i = n[r],
          o = t[r];n[r] = i ? [].concat(i, o) : o;
    }
  } else ;return e;
}function kt(e, t, n, r) {
  t = t || { $stable: !n };for (var i = 0; i < e.length; i++) {
    var o = e[i];Array.isArray(o) ? kt(o, t, n) : o && (o.proxy && (o.fn.proxy = !0), t[o.key] = o.fn);
  }return r && (t.$key = r), t;
}function At(e, t) {
  for (var n = 0; n < t.length; n += 2) {
    var r = t[n];"string" == typeof r && r && (e[t[n]] = t[n + 1]);
  }return e;
}function Ot(e, t) {
  return "string" == typeof e ? t + e : e;
}function St(e) {
  e._o = $t, e._n = f, e._s = l, e._l = vt, e._t = ht, e._q = N, e._i = j, e._m = bt, e._f = mt, e._k = gt, e._b = _t, e._v = he, e._e = ve, e._u = kt, e._g = xt, e._d = At, e._p = Ot;
}function Tt(t, n, i, o, a) {
  var s,
      c = this,
      u = a.options;y(o, "_uid") ? (s = Object.create(o))._original = o : (s = o, o = o._original);var l = r(u._compiled),
      f = !l;this.data = t, this.props = n, this.children = i, this.parent = o, this.listeners = t.on || e, this.injections = ct(u.inject, o), this.slots = function () {
    return c.$slots || ft(t.scopedSlots, c.$slots = ut(i, o)), c.$slots;
  }, Object.defineProperty(this, "scopedSlots", { enumerable: !0, get: function get() {
      return ft(t.scopedSlots, this.slots());
    } }), l && (this.$options = u, this.$slots = this.slots(), this.$scopedSlots = ft(t.scopedSlots, this.$slots)), u._scopeId ? this._c = function (e, t, n, r) {
    var i = Pt(s, e, t, n, r, f);return i && !Array.isArray(i) && (i.fnScopeId = u._scopeId, i.fnContext = o), i;
  } : this._c = function (e, t, n, r) {
    return Pt(s, e, t, n, r, f);
  };
}function Et(e, t, n, r, i) {
  var o = me(e);return o.fnContext = n, o.fnOptions = r, t.slot && ((o.data || (o.data = {})).slot = t.slot), o;
}function Nt(e, t) {
  for (var n in t) {
    e[b(n)] = t[n];
  }
}St(Tt.prototype);var jt = { init: function init(e, t) {
    if (e.componentInstance && !e.componentInstance._isDestroyed && e.data.keepAlive) {
      var r = e;jt.prepatch(r, r);
    } else {
      (e.componentInstance = function (e, t) {
        var r = { _isComponent: !0, _parentVnode: e, parent: t },
            i = e.data.inlineTemplate;n(i) && (r.render = i.render, r.staticRenderFns = i.staticRenderFns);return new e.componentOptions.Ctor(r);
      }(e, Wt)).$mount(t ? e.elm : void 0, t);
    }
  }, prepatch: function prepatch(t, n) {
    var r = n.componentOptions;!function (t, n, r, i, o) {
      var a = i.data.scopedSlots,
          s = t.$scopedSlots,
          c = !!(a && !a.$stable || s !== e && !s.$stable || a && t.$scopedSlots.$key !== a.$key),
          u = !!(o || t.$options._renderChildren || c);t.$options._parentVnode = i, t.$vnode = i, t._vnode && (t._vnode.parent = i);if (t.$options._renderChildren = o, t.$attrs = i.data.attrs || e, t.$listeners = r || e, n && t.$options.props) {
        $e(!1);for (var l = t._props, f = t.$options._propKeys || [], p = 0; p < f.length; p++) {
          var d = f[p],
              v = t.$options.props;l[d] = Me(d, v, n, t);
        }$e(!0), t.$options.propsData = n;
      }r = r || e;var h = t.$options._parentListeners;t.$options._parentListeners = r, qt(t, r, h), u && (t.$slots = ut(o, i.context), t.$forceUpdate());
    }(n.componentInstance = t.componentInstance, r.propsData, r.listeners, n, r.children);
  }, insert: function insert(e) {
    var t,
        n = e.context,
        r = e.componentInstance;r._isMounted || (r._isMounted = !0, Yt(r, "mounted")), e.data.keepAlive && (n._isMounted ? ((t = r)._inactive = !1, en.push(t)) : Xt(r, !0));
  }, destroy: function destroy(e) {
    var t = e.componentInstance;t._isDestroyed || (e.data.keepAlive ? function e(t, n) {
      if (n && (t._directInactive = !0, Gt(t))) return;if (!t._inactive) {
        t._inactive = !0;for (var r = 0; r < t.$children.length; r++) {
          e(t.$children[r]);
        }Yt(t, "deactivated");
      }
    }(t, !0) : t.$destroy());
  } },
    Dt = Object.keys(jt);function Lt(i, a, s, c, l) {
  if (!t(i)) {
    var f = s.$options._base;if (o(i) && (i = f.extend(i)), "function" == typeof i) {
      var p;if (t(i.cid) && void 0 === (i = function (e, i) {
        if (r(e.error) && n(e.errorComp)) return e.errorComp;if (n(e.resolved)) return e.resolved;var a = Ht;a && n(e.owners) && -1 === e.owners.indexOf(a) && e.owners.push(a);if (r(e.loading) && n(e.loadingComp)) return e.loadingComp;if (a && !n(e.owners)) {
          var s = e.owners = [a],
              c = !0,
              l = null,
              f = null;a.$on("hook:destroyed", function () {
            return h(s, a);
          });var p = function p(e) {
            for (var t = 0, n = s.length; t < n; t++) {
              s[t].$forceUpdate();
            }e && (s.length = 0, null !== l && (clearTimeout(l), l = null), null !== f && (clearTimeout(f), f = null));
          },
              d = D(function (t) {
            e.resolved = Bt(t, i), c ? s.length = 0 : p(!0);
          }),
              v = D(function (t) {
            n(e.errorComp) && (e.error = !0, p(!0));
          }),
              m = e(d, v);return o(m) && (u(m) ? t(e.resolved) && m.then(d, v) : u(m.component) && (m.component.then(d, v), n(m.error) && (e.errorComp = Bt(m.error, i)), n(m.loading) && (e.loadingComp = Bt(m.loading, i), 0 === m.delay ? e.loading = !0 : l = setTimeout(function () {
            l = null, t(e.resolved) && t(e.error) && (e.loading = !0, p(!1));
          }, m.delay || 200)), n(m.timeout) && (f = setTimeout(function () {
            f = null, t(e.resolved) && v(null);
          }, m.timeout)))), c = !1, e.loading ? e.loadingComp : e.resolved;
        }
      }(p = i, f))) return function (e, t, n, r, i) {
        var o = ve();return o.asyncFactory = e, o.asyncMeta = { data: t, context: n, children: r, tag: i }, o;
      }(p, a, s, c, l);a = a || {}, $n(i), n(a.model) && function (e, t) {
        var r = e.model && e.model.prop || "value",
            i = e.model && e.model.event || "input";(t.attrs || (t.attrs = {}))[r] = t.model.value;var o = t.on || (t.on = {}),
            a = o[i],
            s = t.model.callback;n(a) ? (Array.isArray(a) ? -1 === a.indexOf(s) : a !== s) && (o[i] = [s].concat(a)) : o[i] = s;
      }(i.options, a);var d = function (e, r, i) {
        var o = r.options.props;if (!t(o)) {
          var a = {},
              s = e.attrs,
              c = e.props;if (n(s) || n(c)) for (var u in o) {
            var l = C(u);ot(a, c, u, l, !0) || ot(a, s, u, l, !1);
          }return a;
        }
      }(a, i);if (r(i.options.functional)) return function (t, r, i, o, a) {
        var s = t.options,
            c = {},
            u = s.props;if (n(u)) for (var l in u) {
          c[l] = Me(l, u, r || e);
        } else n(i.attrs) && Nt(c, i.attrs), n(i.props) && Nt(c, i.props);var f = new Tt(i, c, a, o, t),
            p = s.render.call(null, f._c, f);if (p instanceof pe) return Et(p, i, f.parent, s);if (Array.isArray(p)) {
          for (var d = at(p) || [], v = new Array(d.length), h = 0; h < d.length; h++) {
            v[h] = Et(d[h], i, f.parent, s);
          }return v;
        }
      }(i, d, a, s, c);var v = a.on;if (a.on = a.nativeOn, r(i.options.abstract)) {
        var m = a.slot;a = {}, m && (a.slot = m);
      }!function (e) {
        for (var t = e.hook || (e.hook = {}), n = 0; n < Dt.length; n++) {
          var r = Dt[n],
              i = t[r],
              o = jt[r];i === o || i && i._merged || (t[r] = i ? Mt(o, i) : o);
        }
      }(a);var y = i.options.name || l;return new pe("vue-component-" + i.cid + (y ? "-" + y : ""), a, void 0, void 0, void 0, s, { Ctor: i, propsData: d, listeners: v, tag: l, children: c }, p);
    }
  }
}function Mt(e, t) {
  var n = function n(_n2, r) {
    e(_n2, r), t(_n2, r);
  };return n._merged = !0, n;
}var It = 1,
    Ft = 2;function Pt(e, a, s, c, u, l) {
  return (Array.isArray(s) || i(s)) && (u = c, c = s, s = void 0), r(l) && (u = Ft), function (e, i, a, s, c) {
    if (n(a) && n(a.__ob__)) return ve();n(a) && n(a.is) && (i = a.is);if (!i) return ve();Array.isArray(s) && "function" == typeof s[0] && ((a = a || {}).scopedSlots = { default: s[0] }, s.length = 0);c === Ft ? s = at(s) : c === It && (s = function (e) {
      for (var t = 0; t < e.length; t++) {
        if (Array.isArray(e[t])) return Array.prototype.concat.apply([], e);
      }return e;
    }(s));var u, l;if ("string" == typeof i) {
      var f;l = e.$vnode && e.$vnode.ns || F.getTagNamespace(i), u = F.isReservedTag(i) ? new pe(F.parsePlatformTagName(i), a, s, void 0, void 0, e) : a && a.pre || !n(f = Le(e.$options, "components", i)) ? new pe(i, a, s, void 0, void 0, e) : Lt(f, a, e, s, i);
    } else u = Lt(i, a, e, s);return Array.isArray(u) ? u : n(u) ? (n(l) && function e(i, o, a) {
      i.ns = o;"foreignObject" === i.tag && (o = void 0, a = !0);if (n(i.children)) for (var s = 0, c = i.children.length; s < c; s++) {
        var u = i.children[s];n(u.tag) && (t(u.ns) || r(a) && "svg" !== u.tag) && e(u, o, a);
      }
    }(u, l), n(a) && function (e) {
      o(e.style) && et(e.style);o(e.class) && et(e.class);
    }(a), u) : ve();
  }(e, a, s, c, u);
}var Rt,
    Ht = null;function Bt(e, t) {
  return (e.__esModule || oe && "Module" === e[Symbol.toStringTag]) && (e = e.default), o(e) ? t.extend(e) : e;
}function Ut(e) {
  return e.isComment && e.asyncFactory;
}function zt(e) {
  if (Array.isArray(e)) for (var t = 0; t < e.length; t++) {
    var r = e[t];if (n(r) && (n(r.componentOptions) || Ut(r))) return r;
  }
}function Vt(e, t) {
  Rt.$on(e, t);
}function Kt(e, t) {
  Rt.$off(e, t);
}function Jt(e, t) {
  var n = Rt;return function r() {
    null !== t.apply(null, arguments) && n.$off(e, r);
  };
}function qt(e, t, n) {
  Rt = e, rt(t, n || {}, Vt, Kt, Jt, e), Rt = void 0;
}var Wt = null;function Zt(e) {
  var t = Wt;return Wt = e, function () {
    Wt = t;
  };
}function Gt(e) {
  for (; e && (e = e.$parent);) {
    if (e._inactive) return !0;
  }return !1;
}function Xt(e, t) {
  if (t) {
    if (e._directInactive = !1, Gt(e)) return;
  } else if (e._directInactive) return;if (e._inactive || null === e._inactive) {
    e._inactive = !1;for (var n = 0; n < e.$children.length; n++) {
      Xt(e.$children[n]);
    }Yt(e, "activated");
  }
}function Yt(e, t) {
  le();var n = e.$options[t],
      r = t + " hook";if (n) for (var i = 0, o = n.length; i < o; i++) {
    He(n[i], e, null, e, r);
  }e._hasHookEvent && e.$emit("hook:" + t), fe();
}var Qt = [],
    en = [],
    tn = {},
    nn = !1,
    rn = !1,
    on = 0;var an = 0,
    sn = Date.now;if (z && !q) {
  var cn = window.performance;cn && "function" == typeof cn.now && sn() > document.createEvent("Event").timeStamp && (sn = function sn() {
    return cn.now();
  });
}function un() {
  var e, t;for (an = sn(), rn = !0, Qt.sort(function (e, t) {
    return e.id - t.id;
  }), on = 0; on < Qt.length; on++) {
    (e = Qt[on]).before && e.before(), t = e.id, tn[t] = null, e.run();
  }var n = en.slice(),
      r = Qt.slice();on = Qt.length = en.length = 0, tn = {}, nn = rn = !1, function (e) {
    for (var t = 0; t < e.length; t++) {
      e[t]._inactive = !0, Xt(e[t], !0);
    }
  }(n), function (e) {
    var t = e.length;for (; t--;) {
      var n = e[t],
          r = n.vm;r._watcher === n && r._isMounted && !r._isDestroyed && Yt(r, "updated");
    }
  }(r), ne && F.devtools && ne.emit("flush");
}var ln = 0,
    fn = function fn(e, t, n, r, i) {
  this.vm = e, i && (e._watcher = this), e._watchers.push(this), r ? (this.deep = !!r.deep, this.user = !!r.user, this.lazy = !!r.lazy, this.sync = !!r.sync, this.before = r.before) : this.deep = this.user = this.lazy = this.sync = !1, this.cb = n, this.id = ++ln, this.active = !0, this.dirty = this.lazy, this.deps = [], this.newDeps = [], this.depIds = new ie(), this.newDepIds = new ie(), this.expression = "", "function" == typeof t ? this.getter = t : (this.getter = function (e) {
    if (!H.test(e)) {
      var t = e.split(".");return function (e) {
        for (var n = 0; n < t.length; n++) {
          if (!e) return;e = e[t[n]];
        }return e;
      };
    }
  }(t), this.getter || (this.getter = S)), this.value = this.lazy ? void 0 : this.get();
};fn.prototype.get = function () {
  var e;le(this);var t = this.vm;try {
    e = this.getter.call(t, t);
  } catch (e) {
    if (!this.user) throw e;Re(e, t, 'getter for watcher "' + this.expression + '"');
  } finally {
    this.deep && et(e), fe(), this.cleanupDeps();
  }return e;
}, fn.prototype.addDep = function (e) {
  var t = e.id;this.newDepIds.has(t) || (this.newDepIds.add(t), this.newDeps.push(e), this.depIds.has(t) || e.addSub(this));
}, fn.prototype.cleanupDeps = function () {
  for (var e = this.deps.length; e--;) {
    var t = this.deps[e];this.newDepIds.has(t.id) || t.removeSub(this);
  }var n = this.depIds;this.depIds = this.newDepIds, this.newDepIds = n, this.newDepIds.clear(), n = this.deps, this.deps = this.newDeps, this.newDeps = n, this.newDeps.length = 0;
}, fn.prototype.update = function () {
  this.lazy ? this.dirty = !0 : this.sync ? this.run() : function (e) {
    var t = e.id;if (null == tn[t]) {
      if (tn[t] = !0, rn) {
        for (var n = Qt.length - 1; n > on && Qt[n].id > e.id;) {
          n--;
        }Qt.splice(n + 1, 0, e);
      } else Qt.push(e);nn || (nn = !0, Ye(un));
    }
  }(this);
}, fn.prototype.run = function () {
  if (this.active) {
    var e = this.get();if (e !== this.value || o(e) || this.deep) {
      var t = this.value;if (this.value = e, this.user) try {
        this.cb.call(this.vm, e, t);
      } catch (e) {
        Re(e, this.vm, 'callback for watcher "' + this.expression + '"');
      } else this.cb.call(this.vm, e, t);
    }
  }
}, fn.prototype.evaluate = function () {
  this.value = this.get(), this.dirty = !1;
}, fn.prototype.depend = function () {
  for (var e = this.deps.length; e--;) {
    this.deps[e].depend();
  }
}, fn.prototype.teardown = function () {
  if (this.active) {
    this.vm._isBeingDestroyed || h(this.vm._watchers, this);for (var e = this.deps.length; e--;) {
      this.deps[e].removeSub(this);
    }this.active = !1;
  }
};var pn = { enumerable: !0, configurable: !0, get: S, set: S };function dn(e, t, n) {
  pn.get = function () {
    return this[t][n];
  }, pn.set = function (e) {
    this[t][n] = e;
  }, Object.defineProperty(e, n, pn);
}function vn(e) {
  e._watchers = [];var t = e.$options;t.props && function (e, t) {
    var n = e.$options.propsData || {},
        r = e._props = {},
        i = e.$options._propKeys = [];e.$parent && $e(!1);var o = function o(_o2) {
      i.push(_o2);var a = Me(_o2, t, n, e);xe(r, _o2, a), _o2 in e || dn(e, "_props", _o2);
    };for (var a in t) {
      o(a);
    }$e(!0);
  }(e, t.props), t.methods && function (e, t) {
    e.$options.props;for (var n in t) {
      e[n] = "function" != typeof t[n] ? S : x(t[n], e);
    }
  }(e, t.methods), t.data ? function (e) {
    var t = e.$options.data;s(t = e._data = "function" == typeof t ? function (e, t) {
      le();try {
        return e.call(t, t);
      } catch (e) {
        return Re(e, t, "data()"), {};
      } finally {
        fe();
      }
    }(t, e) : t || {}) || (t = {});var n = Object.keys(t),
        r = e.$options.props,
        i = (e.$options.methods, n.length);for (; i--;) {
      var o = n[i];r && y(r, o) || (a = void 0, 36 !== (a = (o + "").charCodeAt(0)) && 95 !== a && dn(e, "_data", o));
    }var a;Ce(t, !0);
  }(e) : Ce(e._data = {}, !0), t.computed && function (e, t) {
    var n = e._computedWatchers = Object.create(null),
        r = te();for (var i in t) {
      var o = t[i],
          a = "function" == typeof o ? o : o.get;r || (n[i] = new fn(e, a || S, S, hn)), i in e || mn(e, i, o);
    }
  }(e, t.computed), t.watch && t.watch !== Y && function (e, t) {
    for (var n in t) {
      var r = t[n];if (Array.isArray(r)) for (var i = 0; i < r.length; i++) {
        _n(e, n, r[i]);
      } else _n(e, n, r);
    }
  }(e, t.watch);
}var hn = { lazy: !0 };function mn(e, t, n) {
  var r = !te();"function" == typeof n ? (pn.get = r ? yn(t) : gn(n), pn.set = S) : (pn.get = n.get ? r && !1 !== n.cache ? yn(t) : gn(n.get) : S, pn.set = n.set || S), Object.defineProperty(e, t, pn);
}function yn(e) {
  return function () {
    var t = this._computedWatchers && this._computedWatchers[e];if (t) return t.dirty && t.evaluate(), ce.target && t.depend(), t.value;
  };
}function gn(e) {
  return function () {
    return e.call(this, this);
  };
}function _n(e, t, n, r) {
  return s(n) && (r = n, n = n.handler), "string" == typeof n && (n = e[n]), e.$watch(t, n, r);
}var bn = 0;function $n(e) {
  var t = e.options;if (e.super) {
    var n = $n(e.super);if (n !== e.superOptions) {
      e.superOptions = n;var r = function (e) {
        var t,
            n = e.options,
            r = e.sealedOptions;for (var i in n) {
          n[i] !== r[i] && (t || (t = {}), t[i] = n[i]);
        }return t;
      }(e);r && A(e.extendOptions, r), (t = e.options = De(n, e.extendOptions)).name && (t.components[t.name] = e);
    }
  }return t;
}function wn(e) {
  this._init(e);
}function Cn(e) {
  e.cid = 0;var t = 1;e.extend = function (e) {
    e = e || {};var n = this,
        r = n.cid,
        i = e._Ctor || (e._Ctor = {});if (i[r]) return i[r];var o = e.name || n.options.name,
        a = function a(e) {
      this._init(e);
    };return (a.prototype = Object.create(n.prototype)).constructor = a, a.cid = t++, a.options = De(n.options, e), a.super = n, a.options.props && function (e) {
      var t = e.options.props;for (var n in t) {
        dn(e.prototype, "_props", n);
      }
    }(a), a.options.computed && function (e) {
      var t = e.options.computed;for (var n in t) {
        mn(e.prototype, n, t[n]);
      }
    }(a), a.extend = n.extend, a.mixin = n.mixin, a.use = n.use, M.forEach(function (e) {
      a[e] = n[e];
    }), o && (a.options.components[o] = a), a.superOptions = n.options, a.extendOptions = e, a.sealedOptions = A({}, a.options), i[r] = a, a;
  };
}function xn(e) {
  return e && (e.Ctor.options.name || e.tag);
}function kn(e, t) {
  return Array.isArray(e) ? e.indexOf(t) > -1 : "string" == typeof e ? e.split(",").indexOf(t) > -1 : (n = e, "[object RegExp]" === a.call(n) && e.test(t));var n;
}function An(e, t) {
  var n = e.cache,
      r = e.keys,
      i = e._vnode;for (var o in n) {
    var a = n[o];if (a) {
      var s = xn(a.componentOptions);s && !t(s) && On(n, o, r, i);
    }
  }
}function On(e, t, n, r) {
  var i = e[t];!i || r && i.tag === r.tag || i.componentInstance.$destroy(), e[t] = null, h(n, t);
}!function (t) {
  t.prototype._init = function (t) {
    var n = this;n._uid = bn++, n._isVue = !0, t && t._isComponent ? function (e, t) {
      var n = e.$options = Object.create(e.constructor.options),
          r = t._parentVnode;n.parent = t.parent, n._parentVnode = r;var i = r.componentOptions;n.propsData = i.propsData, n._parentListeners = i.listeners, n._renderChildren = i.children, n._componentTag = i.tag, t.render && (n.render = t.render, n.staticRenderFns = t.staticRenderFns);
    }(n, t) : n.$options = De($n(n.constructor), t || {}, n), n._renderProxy = n, n._self = n, function (e) {
      var t = e.$options,
          n = t.parent;if (n && !t.abstract) {
        for (; n.$options.abstract && n.$parent;) {
          n = n.$parent;
        }n.$children.push(e);
      }e.$parent = n, e.$root = n ? n.$root : e, e.$children = [], e.$refs = {}, e._watcher = null, e._inactive = null, e._directInactive = !1, e._isMounted = !1, e._isDestroyed = !1, e._isBeingDestroyed = !1;
    }(n), function (e) {
      e._events = Object.create(null), e._hasHookEvent = !1;var t = e.$options._parentListeners;t && qt(e, t);
    }(n), function (t) {
      t._vnode = null, t._staticTrees = null;var n = t.$options,
          r = t.$vnode = n._parentVnode,
          i = r && r.context;t.$slots = ut(n._renderChildren, i), t.$scopedSlots = e, t._c = function (e, n, r, i) {
        return Pt(t, e, n, r, i, !1);
      }, t.$createElement = function (e, n, r, i) {
        return Pt(t, e, n, r, i, !0);
      };var o = r && r.data;xe(t, "$attrs", o && o.attrs || e, null, !0), xe(t, "$listeners", n._parentListeners || e, null, !0);
    }(n), Yt(n, "beforeCreate"), function (e) {
      var t = ct(e.$options.inject, e);t && ($e(!1), Object.keys(t).forEach(function (n) {
        xe(e, n, t[n]);
      }), $e(!0));
    }(n), vn(n), function (e) {
      var t = e.$options.provide;t && (e._provided = "function" == typeof t ? t.call(e) : t);
    }(n), Yt(n, "created"), n.$options.el && n.$mount(n.$options.el);
  };
}(wn), function (e) {
  var t = { get: function get() {
      return this._data;
    } },
      n = { get: function get() {
      return this._props;
    } };Object.defineProperty(e.prototype, "$data", t), Object.defineProperty(e.prototype, "$props", n), e.prototype.$set = ke, e.prototype.$delete = Ae, e.prototype.$watch = function (e, t, n) {
    if (s(t)) return _n(this, e, t, n);(n = n || {}).user = !0;var r = new fn(this, e, t, n);if (n.immediate) try {
      t.call(this, r.value);
    } catch (e) {
      Re(e, this, 'callback for immediate watcher "' + r.expression + '"');
    }return function () {
      r.teardown();
    };
  };
}(wn), function (e) {
  var t = /^hook:/;e.prototype.$on = function (e, n) {
    var r = this;if (Array.isArray(e)) for (var i = 0, o = e.length; i < o; i++) {
      r.$on(e[i], n);
    } else (r._events[e] || (r._events[e] = [])).push(n), t.test(e) && (r._hasHookEvent = !0);return r;
  }, e.prototype.$once = function (e, t) {
    var n = this;function r() {
      n.$off(e, r), t.apply(n, arguments);
    }return r.fn = t, n.$on(e, r), n;
  }, e.prototype.$off = function (e, t) {
    var n = this;if (!arguments.length) return n._events = Object.create(null), n;if (Array.isArray(e)) {
      for (var r = 0, i = e.length; r < i; r++) {
        n.$off(e[r], t);
      }return n;
    }var o,
        a = n._events[e];if (!a) return n;if (!t) return n._events[e] = null, n;for (var s = a.length; s--;) {
      if ((o = a[s]) === t || o.fn === t) {
        a.splice(s, 1);break;
      }
    }return n;
  }, e.prototype.$emit = function (e) {
    var t = this._events[e];if (t) {
      t = t.length > 1 ? k(t) : t;for (var n = k(arguments, 1), r = 'event handler for "' + e + '"', i = 0, o = t.length; i < o; i++) {
        He(t[i], this, n, this, r);
      }
    }return this;
  };
}(wn), function (e) {
  e.prototype._update = function (e, t) {
    var n = this,
        r = n.$el,
        i = n._vnode,
        o = Zt(n);n._vnode = e, n.$el = i ? n.__patch__(i, e) : n.__patch__(n.$el, e, t, !1), o(), r && (r.__vue__ = null), n.$el && (n.$el.__vue__ = n), n.$vnode && n.$parent && n.$vnode === n.$parent._vnode && (n.$parent.$el = n.$el);
  }, e.prototype.$forceUpdate = function () {
    this._watcher && this._watcher.update();
  }, e.prototype.$destroy = function () {
    var e = this;if (!e._isBeingDestroyed) {
      Yt(e, "beforeDestroy"), e._isBeingDestroyed = !0;var t = e.$parent;!t || t._isBeingDestroyed || e.$options.abstract || h(t.$children, e), e._watcher && e._watcher.teardown();for (var n = e._watchers.length; n--;) {
        e._watchers[n].teardown();
      }e._data.__ob__ && e._data.__ob__.vmCount--, e._isDestroyed = !0, e.__patch__(e._vnode, null), Yt(e, "destroyed"), e.$off(), e.$el && (e.$el.__vue__ = null), e.$vnode && (e.$vnode.parent = null);
    }
  };
}(wn), function (e) {
  St(e.prototype), e.prototype.$nextTick = function (e) {
    return Ye(e, this);
  }, e.prototype._render = function () {
    var e,
        t = this,
        n = t.$options,
        r = n.render,
        i = n._parentVnode;i && (t.$scopedSlots = ft(i.data.scopedSlots, t.$slots, t.$scopedSlots)), t.$vnode = i;try {
      Ht = t, e = r.call(t._renderProxy, t.$createElement);
    } catch (n) {
      Re(n, t, "render"), e = t._vnode;
    } finally {
      Ht = null;
    }return Array.isArray(e) && 1 === e.length && (e = e[0]), e instanceof pe || (e = ve()), e.parent = i, e;
  };
}(wn);var Sn = [String, RegExp, Array],
    Tn = { KeepAlive: { name: "keep-alive", abstract: !0, props: { include: Sn, exclude: Sn, max: [String, Number] }, created: function created() {
      this.cache = Object.create(null), this.keys = [];
    }, destroyed: function destroyed() {
      for (var e in this.cache) {
        On(this.cache, e, this.keys);
      }
    }, mounted: function mounted() {
      var e = this;this.$watch("include", function (t) {
        An(e, function (e) {
          return kn(t, e);
        });
      }), this.$watch("exclude", function (t) {
        An(e, function (e) {
          return !kn(t, e);
        });
      });
    }, render: function render() {
      var e = this.$slots.default,
          t = zt(e),
          n = t && t.componentOptions;if (n) {
        var r = xn(n),
            i = this.include,
            o = this.exclude;if (i && (!r || !kn(i, r)) || o && r && kn(o, r)) return t;var a = this.cache,
            s = this.keys,
            c = null == t.key ? n.Ctor.cid + (n.tag ? "::" + n.tag : "") : t.key;a[c] ? (t.componentInstance = a[c].componentInstance, h(s, c), s.push(c)) : (a[c] = t, s.push(c), this.max && s.length > parseInt(this.max) && On(a, s[0], s, this._vnode)), t.data.keepAlive = !0;
      }return t || e && e[0];
    } } };!function (e) {
  var t = { get: function get() {
      return F;
    } };Object.defineProperty(e, "config", t), e.util = { warn: ae, extend: A, mergeOptions: De, defineReactive: xe }, e.set = ke, e.delete = Ae, e.nextTick = Ye, e.observable = function (e) {
    return Ce(e), e;
  }, e.options = Object.create(null), M.forEach(function (t) {
    e.options[t + "s"] = Object.create(null);
  }), e.options._base = e, A(e.options.components, Tn), function (e) {
    e.use = function (e) {
      var t = this._installedPlugins || (this._installedPlugins = []);if (t.indexOf(e) > -1) return this;var n = k(arguments, 1);return n.unshift(this), "function" == typeof e.install ? e.install.apply(e, n) : "function" == typeof e && e.apply(null, n), t.push(e), this;
    };
  }(e), function (e) {
    e.mixin = function (e) {
      return this.options = De(this.options, e), this;
    };
  }(e), Cn(e), function (e) {
    M.forEach(function (t) {
      e[t] = function (e, n) {
        return n ? ("component" === t && s(n) && (n.name = n.name || e, n = this.options._base.extend(n)), "directive" === t && "function" == typeof n && (n = { bind: n, update: n }), this.options[t + "s"][e] = n, n) : this.options[t + "s"][e];
      };
    });
  }(e);
}(wn), Object.defineProperty(wn.prototype, "$isServer", { get: te }), Object.defineProperty(wn.prototype, "$ssrContext", { get: function get() {
    return this.$vnode && this.$vnode.ssrContext;
  } }), Object.defineProperty(wn, "FunctionalRenderContext", { value: Tt }), wn.version = "2.6.12";var En = p("style,class"),
    Nn = p("input,textarea,option,select,progress"),
    jn = function jn(e, t, n) {
  return "value" === n && Nn(e) && "button" !== t || "selected" === n && "option" === e || "checked" === n && "input" === e || "muted" === n && "video" === e;
},
    Dn = p("contenteditable,draggable,spellcheck"),
    Ln = p("events,caret,typing,plaintext-only"),
    Mn = function Mn(e, t) {
  return Hn(t) || "false" === t ? "false" : "contenteditable" === e && Ln(t) ? t : "true";
},
    In = p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),
    Fn = "http://www.w3.org/1999/xlink",
    Pn = function Pn(e) {
  return ":" === e.charAt(5) && "xlink" === e.slice(0, 5);
},
    Rn = function Rn(e) {
  return Pn(e) ? e.slice(6, e.length) : "";
},
    Hn = function Hn(e) {
  return null == e || !1 === e;
};function Bn(e) {
  for (var t = e.data, r = e, i = e; n(i.componentInstance);) {
    (i = i.componentInstance._vnode) && i.data && (t = Un(i.data, t));
  }for (; n(r = r.parent);) {
    r && r.data && (t = Un(t, r.data));
  }return function (e, t) {
    if (n(e) || n(t)) return zn(e, Vn(t));return "";
  }(t.staticClass, t.class);
}function Un(e, t) {
  return { staticClass: zn(e.staticClass, t.staticClass), class: n(e.class) ? [e.class, t.class] : t.class };
}function zn(e, t) {
  return e ? t ? e + " " + t : e : t || "";
}function Vn(e) {
  return Array.isArray(e) ? function (e) {
    for (var t, r = "", i = 0, o = e.length; i < o; i++) {
      n(t = Vn(e[i])) && "" !== t && (r && (r += " "), r += t);
    }return r;
  }(e) : o(e) ? function (e) {
    var t = "";for (var n in e) {
      e[n] && (t && (t += " "), t += n);
    }return t;
  }(e) : "string" == typeof e ? e : "";
}var Kn = { svg: "http://www.w3.org/2000/svg", math: "http://www.w3.org/1998/Math/MathML" },
    Jn = p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),
    qn = p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", !0),
    Wn = function Wn(e) {
  return Jn(e) || qn(e);
};function Zn(e) {
  return qn(e) ? "svg" : "math" === e ? "math" : void 0;
}var Gn = Object.create(null);var Xn = p("text,number,password,search,email,tel,url");function Yn(e) {
  if ("string" == typeof e) {
    var t = document.querySelector(e);return t || document.createElement("div");
  }return e;
}var Qn = Object.freeze({ createElement: function createElement(e, t) {
    var n = document.createElement(e);return "select" !== e ? n : (t.data && t.data.attrs && void 0 !== t.data.attrs.multiple && n.setAttribute("multiple", "multiple"), n);
  }, createElementNS: function createElementNS(e, t) {
    return document.createElementNS(Kn[e], t);
  }, createTextNode: function createTextNode(e) {
    return document.createTextNode(e);
  }, createComment: function createComment(e) {
    return document.createComment(e);
  }, insertBefore: function insertBefore(e, t, n) {
    e.insertBefore(t, n);
  }, removeChild: function removeChild(e, t) {
    e.removeChild(t);
  }, appendChild: function appendChild(e, t) {
    e.appendChild(t);
  }, parentNode: function parentNode(e) {
    return e.parentNode;
  }, nextSibling: function nextSibling(e) {
    return e.nextSibling;
  }, tagName: function tagName(e) {
    return e.tagName;
  }, setTextContent: function setTextContent(e, t) {
    e.textContent = t;
  }, setStyleScope: function setStyleScope(e, t) {
    e.setAttribute(t, "");
  } }),
    er = { create: function create(e, t) {
    tr(t);
  }, update: function update(e, t) {
    e.data.ref !== t.data.ref && (tr(e, !0), tr(t));
  }, destroy: function destroy(e) {
    tr(e, !0);
  } };function tr(e, t) {
  var r = e.data.ref;if (n(r)) {
    var i = e.context,
        o = e.componentInstance || e.elm,
        a = i.$refs;t ? Array.isArray(a[r]) ? h(a[r], o) : a[r] === o && (a[r] = void 0) : e.data.refInFor ? Array.isArray(a[r]) ? a[r].indexOf(o) < 0 && a[r].push(o) : a[r] = [o] : a[r] = o;
  }
}var nr = new pe("", {}, []),
    rr = ["create", "activate", "update", "remove", "destroy"];function ir(e, i) {
  return e.key === i.key && (e.tag === i.tag && e.isComment === i.isComment && n(e.data) === n(i.data) && function (e, t) {
    if ("input" !== e.tag) return !0;var r,
        i = n(r = e.data) && n(r = r.attrs) && r.type,
        o = n(r = t.data) && n(r = r.attrs) && r.type;return i === o || Xn(i) && Xn(o);
  }(e, i) || r(e.isAsyncPlaceholder) && e.asyncFactory === i.asyncFactory && t(i.asyncFactory.error));
}function or(e, t, r) {
  var i,
      o,
      a = {};for (i = t; i <= r; ++i) {
    n(o = e[i].key) && (a[o] = i);
  }return a;
}var ar = { create: sr, update: sr, destroy: function destroy(e) {
    sr(e, nr);
  } };function sr(e, t) {
  (e.data.directives || t.data.directives) && function (e, t) {
    var n,
        r,
        i,
        o = e === nr,
        a = t === nr,
        s = ur(e.data.directives, e.context),
        c = ur(t.data.directives, t.context),
        u = [],
        l = [];for (n in c) {
      r = s[n], i = c[n], r ? (i.oldValue = r.value, i.oldArg = r.arg, fr(i, "update", t, e), i.def && i.def.componentUpdated && l.push(i)) : (fr(i, "bind", t, e), i.def && i.def.inserted && u.push(i));
    }if (u.length) {
      var f = function f() {
        for (var n = 0; n < u.length; n++) {
          fr(u[n], "inserted", t, e);
        }
      };o ? it(t, "insert", f) : f();
    }l.length && it(t, "postpatch", function () {
      for (var n = 0; n < l.length; n++) {
        fr(l[n], "componentUpdated", t, e);
      }
    });if (!o) for (n in s) {
      c[n] || fr(s[n], "unbind", e, e, a);
    }
  }(e, t);
}var cr = Object.create(null);function ur(e, t) {
  var n,
      r,
      i = Object.create(null);if (!e) return i;for (n = 0; n < e.length; n++) {
    (r = e[n]).modifiers || (r.modifiers = cr), i[lr(r)] = r, r.def = Le(t.$options, "directives", r.name);
  }return i;
}function lr(e) {
  return e.rawName || e.name + "." + Object.keys(e.modifiers || {}).join(".");
}function fr(e, t, n, r, i) {
  var o = e.def && e.def[t];if (o) try {
    o(n.elm, e, n, r, i);
  } catch (r) {
    Re(r, n.context, "directive " + e.name + " " + t + " hook");
  }
}var pr = [er, ar];function dr(e, r) {
  var i = r.componentOptions;if (!(n(i) && !1 === i.Ctor.options.inheritAttrs || t(e.data.attrs) && t(r.data.attrs))) {
    var o,
        a,
        s = r.elm,
        c = e.data.attrs || {},
        u = r.data.attrs || {};for (o in n(u.__ob__) && (u = r.data.attrs = A({}, u)), u) {
      a = u[o], c[o] !== a && vr(s, o, a);
    }for (o in (q || Z) && u.value !== c.value && vr(s, "value", u.value), c) {
      t(u[o]) && (Pn(o) ? s.removeAttributeNS(Fn, Rn(o)) : Dn(o) || s.removeAttribute(o));
    }
  }
}function vr(e, t, n) {
  e.tagName.indexOf("-") > -1 ? hr(e, t, n) : In(t) ? Hn(n) ? e.removeAttribute(t) : (n = "allowfullscreen" === t && "EMBED" === e.tagName ? "true" : t, e.setAttribute(t, n)) : Dn(t) ? e.setAttribute(t, Mn(t, n)) : Pn(t) ? Hn(n) ? e.removeAttributeNS(Fn, Rn(t)) : e.setAttributeNS(Fn, t, n) : hr(e, t, n);
}function hr(e, t, n) {
  if (Hn(n)) e.removeAttribute(t);else {
    if (q && !W && "TEXTAREA" === e.tagName && "placeholder" === t && "" !== n && !e.__ieph) {
      var r = function r(t) {
        t.stopImmediatePropagation(), e.removeEventListener("input", r);
      };e.addEventListener("input", r), e.__ieph = !0;
    }e.setAttribute(t, n);
  }
}var mr = { create: dr, update: dr };function yr(e, r) {
  var i = r.elm,
      o = r.data,
      a = e.data;if (!(t(o.staticClass) && t(o.class) && (t(a) || t(a.staticClass) && t(a.class)))) {
    var s = Bn(r),
        c = i._transitionClasses;n(c) && (s = zn(s, Vn(c))), s !== i._prevClass && (i.setAttribute("class", s), i._prevClass = s);
  }
}var gr,
    _r,
    br,
    $r,
    wr,
    Cr,
    xr = { create: yr, update: yr },
    kr = /[\w).+\-_$\]]/;function Ar(e) {
  var t,
      n,
      r,
      i,
      o,
      a = !1,
      s = !1,
      c = !1,
      u = !1,
      l = 0,
      f = 0,
      p = 0,
      d = 0;for (r = 0; r < e.length; r++) {
    if (n = t, t = e.charCodeAt(r), a) 39 === t && 92 !== n && (a = !1);else if (s) 34 === t && 92 !== n && (s = !1);else if (c) 96 === t && 92 !== n && (c = !1);else if (u) 47 === t && 92 !== n && (u = !1);else if (124 !== t || 124 === e.charCodeAt(r + 1) || 124 === e.charCodeAt(r - 1) || l || f || p) {
      switch (t) {case 34:
          s = !0;break;case 39:
          a = !0;break;case 96:
          c = !0;break;case 40:
          p++;break;case 41:
          p--;break;case 91:
          f++;break;case 93:
          f--;break;case 123:
          l++;break;case 125:
          l--;}if (47 === t) {
        for (var v = r - 1, h = void 0; v >= 0 && " " === (h = e.charAt(v)); v--) {}h && kr.test(h) || (u = !0);
      }
    } else void 0 === i ? (d = r + 1, i = e.slice(0, r).trim()) : m();
  }function m() {
    (o || (o = [])).push(e.slice(d, r).trim()), d = r + 1;
  }if (void 0 === i ? i = e.slice(0, r).trim() : 0 !== d && m(), o) for (r = 0; r < o.length; r++) {
    i = Or(i, o[r]);
  }return i;
}function Or(e, t) {
  var n = t.indexOf("(");if (n < 0) return '_f("' + t + '")(' + e + ")";var r = t.slice(0, n),
      i = t.slice(n + 1);return '_f("' + r + '")(' + e + (")" !== i ? "," + i : i);
}function Sr(e, t) {
  console.error("[Vue compiler]: " + e);
}function Tr(e, t) {
  return e ? e.map(function (e) {
    return e[t];
  }).filter(function (e) {
    return e;
  }) : [];
}function Er(e, t, n, r, i) {
  (e.props || (e.props = [])).push(Rr({ name: t, value: n, dynamic: i }, r)), e.plain = !1;
}function Nr(e, t, n, r, i) {
  (i ? e.dynamicAttrs || (e.dynamicAttrs = []) : e.attrs || (e.attrs = [])).push(Rr({ name: t, value: n, dynamic: i }, r)), e.plain = !1;
}function jr(e, t, n, r) {
  e.attrsMap[t] = n, e.attrsList.push(Rr({ name: t, value: n }, r));
}function Dr(e, t, n, r, i, o, a, s) {
  (e.directives || (e.directives = [])).push(Rr({ name: t, rawName: n, value: r, arg: i, isDynamicArg: o, modifiers: a }, s)), e.plain = !1;
}function Lr(e, t, n) {
  return n ? "_p(" + t + ',"' + e + '")' : e + t;
}function Mr(t, n, r, i, o, a, s, c) {
  var u;(i = i || e).right ? c ? n = "(" + n + ")==='click'?'contextmenu':(" + n + ")" : "click" === n && (n = "contextmenu", delete i.right) : i.middle && (c ? n = "(" + n + ")==='click'?'mouseup':(" + n + ")" : "click" === n && (n = "mouseup")), i.capture && (delete i.capture, n = Lr("!", n, c)), i.once && (delete i.once, n = Lr("~", n, c)), i.passive && (delete i.passive, n = Lr("&", n, c)), i.native ? (delete i.native, u = t.nativeEvents || (t.nativeEvents = {})) : u = t.events || (t.events = {});var l = Rr({ value: r.trim(), dynamic: c }, s);i !== e && (l.modifiers = i);var f = u[n];Array.isArray(f) ? o ? f.unshift(l) : f.push(l) : u[n] = f ? o ? [l, f] : [f, l] : l, t.plain = !1;
}function Ir(e, t, n) {
  var r = Fr(e, ":" + t) || Fr(e, "v-bind:" + t);if (null != r) return Ar(r);if (!1 !== n) {
    var i = Fr(e, t);if (null != i) return JSON.stringify(i);
  }
}function Fr(e, t, n) {
  var r;if (null != (r = e.attrsMap[t])) for (var i = e.attrsList, o = 0, a = i.length; o < a; o++) {
    if (i[o].name === t) {
      i.splice(o, 1);break;
    }
  }return n && delete e.attrsMap[t], r;
}function Pr(e, t) {
  for (var n = e.attrsList, r = 0, i = n.length; r < i; r++) {
    var o = n[r];if (t.test(o.name)) return n.splice(r, 1), o;
  }
}function Rr(e, t) {
  return t && (null != t.start && (e.start = t.start), null != t.end && (e.end = t.end)), e;
}function Hr(e, t, n) {
  var r = n || {},
      i = r.number,
      o = "$$v";r.trim && (o = "(typeof $$v === 'string'? $$v.trim(): $$v)"), i && (o = "_n(" + o + ")");var a = Br(t, o);e.model = { value: "(" + t + ")", expression: JSON.stringify(t), callback: "function ($$v) {" + a + "}" };
}function Br(e, t) {
  var n = function (e) {
    if (e = e.trim(), gr = e.length, e.indexOf("[") < 0 || e.lastIndexOf("]") < gr - 1) return ($r = e.lastIndexOf(".")) > -1 ? { exp: e.slice(0, $r), key: '"' + e.slice($r + 1) + '"' } : { exp: e, key: null };_r = e, $r = wr = Cr = 0;for (; !zr();) {
      Vr(br = Ur()) ? Jr(br) : 91 === br && Kr(br);
    }return { exp: e.slice(0, wr), key: e.slice(wr + 1, Cr) };
  }(e);return null === n.key ? e + "=" + t : "$set(" + n.exp + ", " + n.key + ", " + t + ")";
}function Ur() {
  return _r.charCodeAt(++$r);
}function zr() {
  return $r >= gr;
}function Vr(e) {
  return 34 === e || 39 === e;
}function Kr(e) {
  var t = 1;for (wr = $r; !zr();) {
    if (Vr(e = Ur())) Jr(e);else if (91 === e && t++, 93 === e && t--, 0 === t) {
      Cr = $r;break;
    }
  }
}function Jr(e) {
  for (var t = e; !zr() && (e = Ur()) !== t;) {}
}var qr,
    Wr = "__r",
    Zr = "__c";function Gr(e, t, n) {
  var r = qr;return function i() {
    null !== t.apply(null, arguments) && Qr(e, i, n, r);
  };
}var Xr = Ve && !(X && Number(X[1]) <= 53);function Yr(e, t, n, r) {
  if (Xr) {
    var i = an,
        o = t;t = o._wrapper = function (e) {
      if (e.target === e.currentTarget || e.timeStamp >= i || e.timeStamp <= 0 || e.target.ownerDocument !== document) return o.apply(this, arguments);
    };
  }qr.addEventListener(e, t, Q ? { capture: n, passive: r } : n);
}function Qr(e, t, n, r) {
  (r || qr).removeEventListener(e, t._wrapper || t, n);
}function ei(e, r) {
  if (!t(e.data.on) || !t(r.data.on)) {
    var i = r.data.on || {},
        o = e.data.on || {};qr = r.elm, function (e) {
      if (n(e[Wr])) {
        var t = q ? "change" : "input";e[t] = [].concat(e[Wr], e[t] || []), delete e[Wr];
      }n(e[Zr]) && (e.change = [].concat(e[Zr], e.change || []), delete e[Zr]);
    }(i), rt(i, o, Yr, Qr, Gr, r.context), qr = void 0;
  }
}var ti,
    ni = { create: ei, update: ei };function ri(e, r) {
  if (!t(e.data.domProps) || !t(r.data.domProps)) {
    var i,
        o,
        a = r.elm,
        s = e.data.domProps || {},
        c = r.data.domProps || {};for (i in n(c.__ob__) && (c = r.data.domProps = A({}, c)), s) {
      i in c || (a[i] = "");
    }for (i in c) {
      if (o = c[i], "textContent" === i || "innerHTML" === i) {
        if (r.children && (r.children.length = 0), o === s[i]) continue;1 === a.childNodes.length && a.removeChild(a.childNodes[0]);
      }if ("value" === i && "PROGRESS" !== a.tagName) {
        a._value = o;var u = t(o) ? "" : String(o);ii(a, u) && (a.value = u);
      } else if ("innerHTML" === i && qn(a.tagName) && t(a.innerHTML)) {
        (ti = ti || document.createElement("div")).innerHTML = "<svg>" + o + "</svg>";for (var l = ti.firstChild; a.firstChild;) {
          a.removeChild(a.firstChild);
        }for (; l.firstChild;) {
          a.appendChild(l.firstChild);
        }
      } else if (o !== s[i]) try {
        a[i] = o;
      } catch (e) {}
    }
  }
}function ii(e, t) {
  return !e.composing && ("OPTION" === e.tagName || function (e, t) {
    var n = !0;try {
      n = document.activeElement !== e;
    } catch (e) {}return n && e.value !== t;
  }(e, t) || function (e, t) {
    var r = e.value,
        i = e._vModifiers;if (n(i)) {
      if (i.number) return f(r) !== f(t);if (i.trim) return r.trim() !== t.trim();
    }return r !== t;
  }(e, t));
}var oi = { create: ri, update: ri },
    ai = g(function (e) {
  var t = {},
      n = /:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function (e) {
    if (e) {
      var r = e.split(n);r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
});function si(e) {
  var t = ci(e.style);return e.staticStyle ? A(e.staticStyle, t) : t;
}function ci(e) {
  return Array.isArray(e) ? O(e) : "string" == typeof e ? ai(e) : e;
}var ui,
    li = /^--/,
    fi = /\s*!important$/,
    pi = function pi(e, t, n) {
  if (li.test(t)) e.style.setProperty(t, n);else if (fi.test(n)) e.style.setProperty(C(t), n.replace(fi, ""), "important");else {
    var r = vi(t);if (Array.isArray(n)) for (var i = 0, o = n.length; i < o; i++) {
      e.style[r] = n[i];
    } else e.style[r] = n;
  }
},
    di = ["Webkit", "Moz", "ms"],
    vi = g(function (e) {
  if (ui = ui || document.createElement("div").style, "filter" !== (e = b(e)) && e in ui) return e;for (var t = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < di.length; n++) {
    var r = di[n] + t;if (r in ui) return r;
  }
});function hi(e, r) {
  var i = r.data,
      o = e.data;if (!(t(i.staticStyle) && t(i.style) && t(o.staticStyle) && t(o.style))) {
    var a,
        s,
        c = r.elm,
        u = o.staticStyle,
        l = o.normalizedStyle || o.style || {},
        f = u || l,
        p = ci(r.data.style) || {};r.data.normalizedStyle = n(p.__ob__) ? A({}, p) : p;var d = function (e, t) {
      var n,
          r = {};if (t) for (var i = e; i.componentInstance;) {
        (i = i.componentInstance._vnode) && i.data && (n = si(i.data)) && A(r, n);
      }(n = si(e.data)) && A(r, n);for (var o = e; o = o.parent;) {
        o.data && (n = si(o.data)) && A(r, n);
      }return r;
    }(r, !0);for (s in f) {
      t(d[s]) && pi(c, s, "");
    }for (s in d) {
      (a = d[s]) !== f[s] && pi(c, s, null == a ? "" : a);
    }
  }
}var mi = { create: hi, update: hi },
    yi = /\s+/;function gi(e, t) {
  if (t && (t = t.trim())) if (e.classList) t.indexOf(" ") > -1 ? t.split(yi).forEach(function (t) {
    return e.classList.add(t);
  }) : e.classList.add(t);else {
    var n = " " + (e.getAttribute("class") || "") + " ";n.indexOf(" " + t + " ") < 0 && e.setAttribute("class", (n + t).trim());
  }
}function _i(e, t) {
  if (t && (t = t.trim())) if (e.classList) t.indexOf(" ") > -1 ? t.split(yi).forEach(function (t) {
    return e.classList.remove(t);
  }) : e.classList.remove(t), e.classList.length || e.removeAttribute("class");else {
    for (var n = " " + (e.getAttribute("class") || "") + " ", r = " " + t + " "; n.indexOf(r) >= 0;) {
      n = n.replace(r, " ");
    }(n = n.trim()) ? e.setAttribute("class", n) : e.removeAttribute("class");
  }
}function bi(e) {
  if (e) {
    if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) {
      var t = {};return !1 !== e.css && A(t, $i(e.name || "v")), A(t, e), t;
    }return "string" == typeof e ? $i(e) : void 0;
  }
}var $i = g(function (e) {
  return { enterClass: e + "-enter", enterToClass: e + "-enter-to", enterActiveClass: e + "-enter-active", leaveClass: e + "-leave", leaveToClass: e + "-leave-to", leaveActiveClass: e + "-leave-active" };
}),
    wi = z && !W,
    Ci = "transition",
    xi = "animation",
    ki = "transition",
    Ai = "transitionend",
    Oi = "animation",
    Si = "animationend";wi && (void 0 === window.ontransitionend && void 0 !== window.onwebkittransitionend && (ki = "WebkitTransition", Ai = "webkitTransitionEnd"), void 0 === window.onanimationend && void 0 !== window.onwebkitanimationend && (Oi = "WebkitAnimation", Si = "webkitAnimationEnd"));var Ti = z ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : function (e) {
  return e();
};function Ei(e) {
  Ti(function () {
    Ti(e);
  });
}function Ni(e, t) {
  var n = e._transitionClasses || (e._transitionClasses = []);n.indexOf(t) < 0 && (n.push(t), gi(e, t));
}function ji(e, t) {
  e._transitionClasses && h(e._transitionClasses, t), _i(e, t);
}function Di(e, t, n) {
  var r = Mi(e, t),
      i = r.type,
      o = r.timeout,
      a = r.propCount;if (!i) return n();var s = i === Ci ? Ai : Si,
      c = 0,
      u = function u() {
    e.removeEventListener(s, l), n();
  },
      l = function l(t) {
    t.target === e && ++c >= a && u();
  };setTimeout(function () {
    c < a && u();
  }, o + 1), e.addEventListener(s, l);
}var Li = /\b(transform|all)(,|$)/;function Mi(e, t) {
  var n,
      r = window.getComputedStyle(e),
      i = (r[ki + "Delay"] || "").split(", "),
      o = (r[ki + "Duration"] || "").split(", "),
      a = Ii(i, o),
      s = (r[Oi + "Delay"] || "").split(", "),
      c = (r[Oi + "Duration"] || "").split(", "),
      u = Ii(s, c),
      l = 0,
      f = 0;return t === Ci ? a > 0 && (n = Ci, l = a, f = o.length) : t === xi ? u > 0 && (n = xi, l = u, f = c.length) : f = (n = (l = Math.max(a, u)) > 0 ? a > u ? Ci : xi : null) ? n === Ci ? o.length : c.length : 0, { type: n, timeout: l, propCount: f, hasTransform: n === Ci && Li.test(r[ki + "Property"]) };
}function Ii(e, t) {
  for (; e.length < t.length;) {
    e = e.concat(e);
  }return Math.max.apply(null, t.map(function (t, n) {
    return Fi(t) + Fi(e[n]);
  }));
}function Fi(e) {
  return 1e3 * Number(e.slice(0, -1).replace(",", "."));
}function Pi(e, r) {
  var i = e.elm;n(i._leaveCb) && (i._leaveCb.cancelled = !0, i._leaveCb());var a = bi(e.data.transition);if (!t(a) && !n(i._enterCb) && 1 === i.nodeType) {
    for (var s = a.css, c = a.type, u = a.enterClass, l = a.enterToClass, p = a.enterActiveClass, d = a.appearClass, v = a.appearToClass, h = a.appearActiveClass, m = a.beforeEnter, y = a.enter, g = a.afterEnter, _ = a.enterCancelled, b = a.beforeAppear, $ = a.appear, w = a.afterAppear, C = a.appearCancelled, x = a.duration, k = Wt, A = Wt.$vnode; A && A.parent;) {
      k = A.context, A = A.parent;
    }var O = !k._isMounted || !e.isRootInsert;if (!O || $ || "" === $) {
      var S = O && d ? d : u,
          T = O && h ? h : p,
          E = O && v ? v : l,
          N = O && b || m,
          j = O && "function" == typeof $ ? $ : y,
          L = O && w || g,
          M = O && C || _,
          I = f(o(x) ? x.enter : x),
          F = !1 !== s && !W,
          P = Bi(j),
          R = i._enterCb = D(function () {
        F && (ji(i, E), ji(i, T)), R.cancelled ? (F && ji(i, S), M && M(i)) : L && L(i), i._enterCb = null;
      });e.data.show || it(e, "insert", function () {
        var t = i.parentNode,
            n = t && t._pending && t._pending[e.key];n && n.tag === e.tag && n.elm._leaveCb && n.elm._leaveCb(), j && j(i, R);
      }), N && N(i), F && (Ni(i, S), Ni(i, T), Ei(function () {
        ji(i, S), R.cancelled || (Ni(i, E), P || (Hi(I) ? setTimeout(R, I) : Di(i, c, R)));
      })), e.data.show && (r && r(), j && j(i, R)), F || P || R();
    }
  }
}function Ri(e, r) {
  var i = e.elm;n(i._enterCb) && (i._enterCb.cancelled = !0, i._enterCb());var a = bi(e.data.transition);if (t(a) || 1 !== i.nodeType) return r();if (!n(i._leaveCb)) {
    var s = a.css,
        c = a.type,
        u = a.leaveClass,
        l = a.leaveToClass,
        p = a.leaveActiveClass,
        d = a.beforeLeave,
        v = a.leave,
        h = a.afterLeave,
        m = a.leaveCancelled,
        y = a.delayLeave,
        g = a.duration,
        _ = !1 !== s && !W,
        b = Bi(v),
        $ = f(o(g) ? g.leave : g),
        w = i._leaveCb = D(function () {
      i.parentNode && i.parentNode._pending && (i.parentNode._pending[e.key] = null), _ && (ji(i, l), ji(i, p)), w.cancelled ? (_ && ji(i, u), m && m(i)) : (r(), h && h(i)), i._leaveCb = null;
    });y ? y(C) : C();
  }function C() {
    w.cancelled || (!e.data.show && i.parentNode && ((i.parentNode._pending || (i.parentNode._pending = {}))[e.key] = e), d && d(i), _ && (Ni(i, u), Ni(i, p), Ei(function () {
      ji(i, u), w.cancelled || (Ni(i, l), b || (Hi($) ? setTimeout(w, $) : Di(i, c, w)));
    })), v && v(i, w), _ || b || w());
  }
}function Hi(e) {
  return "number" == typeof e && !isNaN(e);
}function Bi(e) {
  if (t(e)) return !1;var r = e.fns;return n(r) ? Bi(Array.isArray(r) ? r[0] : r) : (e._length || e.length) > 1;
}function Ui(e, t) {
  !0 !== t.data.show && Pi(t);
}var zi = function (e) {
  var o,
      a,
      s = {},
      c = e.modules,
      u = e.nodeOps;for (o = 0; o < rr.length; ++o) {
    for (s[rr[o]] = [], a = 0; a < c.length; ++a) {
      n(c[a][rr[o]]) && s[rr[o]].push(c[a][rr[o]]);
    }
  }function l(e) {
    var t = u.parentNode(e);n(t) && u.removeChild(t, e);
  }function f(e, t, i, o, a, c, l) {
    if (n(e.elm) && n(c) && (e = c[l] = me(e)), e.isRootInsert = !a, !function (e, t, i, o) {
      var a = e.data;if (n(a)) {
        var c = n(e.componentInstance) && a.keepAlive;if (n(a = a.hook) && n(a = a.init) && a(e, !1), n(e.componentInstance)) return d(e, t), v(i, e.elm, o), r(c) && function (e, t, r, i) {
          for (var o, a = e; a.componentInstance;) {
            if (a = a.componentInstance._vnode, n(o = a.data) && n(o = o.transition)) {
              for (o = 0; o < s.activate.length; ++o) {
                s.activate[o](nr, a);
              }t.push(a);break;
            }
          }v(r, e.elm, i);
        }(e, t, i, o), !0;
      }
    }(e, t, i, o)) {
      var f = e.data,
          p = e.children,
          m = e.tag;n(m) ? (e.elm = e.ns ? u.createElementNS(e.ns, m) : u.createElement(m, e), g(e), h(e, p, t), n(f) && y(e, t), v(i, e.elm, o)) : r(e.isComment) ? (e.elm = u.createComment(e.text), v(i, e.elm, o)) : (e.elm = u.createTextNode(e.text), v(i, e.elm, o));
    }
  }function d(e, t) {
    n(e.data.pendingInsert) && (t.push.apply(t, e.data.pendingInsert), e.data.pendingInsert = null), e.elm = e.componentInstance.$el, m(e) ? (y(e, t), g(e)) : (tr(e), t.push(e));
  }function v(e, t, r) {
    n(e) && (n(r) ? u.parentNode(r) === e && u.insertBefore(e, t, r) : u.appendChild(e, t));
  }function h(e, t, n) {
    if (Array.isArray(t)) for (var r = 0; r < t.length; ++r) {
      f(t[r], n, e.elm, null, !0, t, r);
    } else i(e.text) && u.appendChild(e.elm, u.createTextNode(String(e.text)));
  }function m(e) {
    for (; e.componentInstance;) {
      e = e.componentInstance._vnode;
    }return n(e.tag);
  }function y(e, t) {
    for (var r = 0; r < s.create.length; ++r) {
      s.create[r](nr, e);
    }n(o = e.data.hook) && (n(o.create) && o.create(nr, e), n(o.insert) && t.push(e));
  }function g(e) {
    var t;if (n(t = e.fnScopeId)) u.setStyleScope(e.elm, t);else for (var r = e; r;) {
      n(t = r.context) && n(t = t.$options._scopeId) && u.setStyleScope(e.elm, t), r = r.parent;
    }n(t = Wt) && t !== e.context && t !== e.fnContext && n(t = t.$options._scopeId) && u.setStyleScope(e.elm, t);
  }function _(e, t, n, r, i, o) {
    for (; r <= i; ++r) {
      f(n[r], o, e, t, !1, n, r);
    }
  }function b(e) {
    var t,
        r,
        i = e.data;if (n(i)) for (n(t = i.hook) && n(t = t.destroy) && t(e), t = 0; t < s.destroy.length; ++t) {
      s.destroy[t](e);
    }if (n(t = e.children)) for (r = 0; r < e.children.length; ++r) {
      b(e.children[r]);
    }
  }function $(e, t, r) {
    for (; t <= r; ++t) {
      var i = e[t];n(i) && (n(i.tag) ? (w(i), b(i)) : l(i.elm));
    }
  }function w(e, t) {
    if (n(t) || n(e.data)) {
      var r,
          i = s.remove.length + 1;for (n(t) ? t.listeners += i : t = function (e, t) {
        function n() {
          0 == --n.listeners && l(e);
        }return n.listeners = t, n;
      }(e.elm, i), n(r = e.componentInstance) && n(r = r._vnode) && n(r.data) && w(r, t), r = 0; r < s.remove.length; ++r) {
        s.remove[r](e, t);
      }n(r = e.data.hook) && n(r = r.remove) ? r(e, t) : t();
    } else l(e.elm);
  }function C(e, t, r, i) {
    for (var o = r; o < i; o++) {
      var a = t[o];if (n(a) && ir(e, a)) return o;
    }
  }function x(e, i, o, a, c, l) {
    if (e !== i) {
      n(i.elm) && n(a) && (i = a[c] = me(i));var p = i.elm = e.elm;if (r(e.isAsyncPlaceholder)) n(i.asyncFactory.resolved) ? O(e.elm, i, o) : i.isAsyncPlaceholder = !0;else if (r(i.isStatic) && r(e.isStatic) && i.key === e.key && (r(i.isCloned) || r(i.isOnce))) i.componentInstance = e.componentInstance;else {
        var d,
            v = i.data;n(v) && n(d = v.hook) && n(d = d.prepatch) && d(e, i);var h = e.children,
            y = i.children;if (n(v) && m(i)) {
          for (d = 0; d < s.update.length; ++d) {
            s.update[d](e, i);
          }n(d = v.hook) && n(d = d.update) && d(e, i);
        }t(i.text) ? n(h) && n(y) ? h !== y && function (e, r, i, o, a) {
          for (var s, c, l, p = 0, d = 0, v = r.length - 1, h = r[0], m = r[v], y = i.length - 1, g = i[0], b = i[y], w = !a; p <= v && d <= y;) {
            t(h) ? h = r[++p] : t(m) ? m = r[--v] : ir(h, g) ? (x(h, g, o, i, d), h = r[++p], g = i[++d]) : ir(m, b) ? (x(m, b, o, i, y), m = r[--v], b = i[--y]) : ir(h, b) ? (x(h, b, o, i, y), w && u.insertBefore(e, h.elm, u.nextSibling(m.elm)), h = r[++p], b = i[--y]) : ir(m, g) ? (x(m, g, o, i, d), w && u.insertBefore(e, m.elm, h.elm), m = r[--v], g = i[++d]) : (t(s) && (s = or(r, p, v)), t(c = n(g.key) ? s[g.key] : C(g, r, p, v)) ? f(g, o, e, h.elm, !1, i, d) : ir(l = r[c], g) ? (x(l, g, o, i, d), r[c] = void 0, w && u.insertBefore(e, l.elm, h.elm)) : f(g, o, e, h.elm, !1, i, d), g = i[++d]);
          }p > v ? _(e, t(i[y + 1]) ? null : i[y + 1].elm, i, d, y, o) : d > y && $(r, p, v);
        }(p, h, y, o, l) : n(y) ? (n(e.text) && u.setTextContent(p, ""), _(p, null, y, 0, y.length - 1, o)) : n(h) ? $(h, 0, h.length - 1) : n(e.text) && u.setTextContent(p, "") : e.text !== i.text && u.setTextContent(p, i.text), n(v) && n(d = v.hook) && n(d = d.postpatch) && d(e, i);
      }
    }
  }function k(e, t, i) {
    if (r(i) && n(e.parent)) e.parent.data.pendingInsert = t;else for (var o = 0; o < t.length; ++o) {
      t[o].data.hook.insert(t[o]);
    }
  }var A = p("attrs,class,staticClass,staticStyle,key");function O(e, t, i, o) {
    var a,
        s = t.tag,
        c = t.data,
        u = t.children;if (o = o || c && c.pre, t.elm = e, r(t.isComment) && n(t.asyncFactory)) return t.isAsyncPlaceholder = !0, !0;if (n(c) && (n(a = c.hook) && n(a = a.init) && a(t, !0), n(a = t.componentInstance))) return d(t, i), !0;if (n(s)) {
      if (n(u)) if (e.hasChildNodes()) {
        if (n(a = c) && n(a = a.domProps) && n(a = a.innerHTML)) {
          if (a !== e.innerHTML) return !1;
        } else {
          for (var l = !0, f = e.firstChild, p = 0; p < u.length; p++) {
            if (!f || !O(f, u[p], i, o)) {
              l = !1;break;
            }f = f.nextSibling;
          }if (!l || f) return !1;
        }
      } else h(t, u, i);if (n(c)) {
        var v = !1;for (var m in c) {
          if (!A(m)) {
            v = !0, y(t, i);break;
          }
        }!v && c.class && et(c.class);
      }
    } else e.data !== t.text && (e.data = t.text);return !0;
  }return function (e, i, o, a) {
    if (!t(i)) {
      var c,
          l = !1,
          p = [];if (t(e)) l = !0, f(i, p);else {
        var d = n(e.nodeType);if (!d && ir(e, i)) x(e, i, p, null, null, a);else {
          if (d) {
            if (1 === e.nodeType && e.hasAttribute(L) && (e.removeAttribute(L), o = !0), r(o) && O(e, i, p)) return k(i, p, !0), e;c = e, e = new pe(u.tagName(c).toLowerCase(), {}, [], void 0, c);
          }var v = e.elm,
              h = u.parentNode(v);if (f(i, p, v._leaveCb ? null : h, u.nextSibling(v)), n(i.parent)) for (var y = i.parent, g = m(i); y;) {
            for (var _ = 0; _ < s.destroy.length; ++_) {
              s.destroy[_](y);
            }if (y.elm = i.elm, g) {
              for (var w = 0; w < s.create.length; ++w) {
                s.create[w](nr, y);
              }var C = y.data.hook.insert;if (C.merged) for (var A = 1; A < C.fns.length; A++) {
                C.fns[A]();
              }
            } else tr(y);y = y.parent;
          }n(h) ? $([e], 0, 0) : n(e.tag) && b(e);
        }
      }return k(i, p, l), i.elm;
    }n(e) && b(e);
  };
}({ nodeOps: Qn, modules: [mr, xr, ni, oi, mi, z ? { create: Ui, activate: Ui, remove: function remove(e, t) {
      !0 !== e.data.show ? Ri(e, t) : t();
    } } : {}].concat(pr) });W && document.addEventListener("selectionchange", function () {
  var e = document.activeElement;e && e.vmodel && Xi(e, "input");
});var Vi = { inserted: function inserted(e, t, n, r) {
    "select" === n.tag ? (r.elm && !r.elm._vOptions ? it(n, "postpatch", function () {
      Vi.componentUpdated(e, t, n);
    }) : Ki(e, t, n.context), e._vOptions = [].map.call(e.options, Wi)) : ("textarea" === n.tag || Xn(e.type)) && (e._vModifiers = t.modifiers, t.modifiers.lazy || (e.addEventListener("compositionstart", Zi), e.addEventListener("compositionend", Gi), e.addEventListener("change", Gi), W && (e.vmodel = !0)));
  }, componentUpdated: function componentUpdated(e, t, n) {
    if ("select" === n.tag) {
      Ki(e, t, n.context);var r = e._vOptions,
          i = e._vOptions = [].map.call(e.options, Wi);if (i.some(function (e, t) {
        return !N(e, r[t]);
      })) (e.multiple ? t.value.some(function (e) {
        return qi(e, i);
      }) : t.value !== t.oldValue && qi(t.value, i)) && Xi(e, "change");
    }
  } };function Ki(e, t, n) {
  Ji(e, t, n), (q || Z) && setTimeout(function () {
    Ji(e, t, n);
  }, 0);
}function Ji(e, t, n) {
  var r = t.value,
      i = e.multiple;if (!i || Array.isArray(r)) {
    for (var o, a, s = 0, c = e.options.length; s < c; s++) {
      if (a = e.options[s], i) o = j(r, Wi(a)) > -1, a.selected !== o && (a.selected = o);else if (N(Wi(a), r)) return void (e.selectedIndex !== s && (e.selectedIndex = s));
    }i || (e.selectedIndex = -1);
  }
}function qi(e, t) {
  return t.every(function (t) {
    return !N(t, e);
  });
}function Wi(e) {
  return "_value" in e ? e._value : e.value;
}function Zi(e) {
  e.target.composing = !0;
}function Gi(e) {
  e.target.composing && (e.target.composing = !1, Xi(e.target, "input"));
}function Xi(e, t) {
  var n = document.createEvent("HTMLEvents");n.initEvent(t, !0, !0), e.dispatchEvent(n);
}function Yi(e) {
  return !e.componentInstance || e.data && e.data.transition ? e : Yi(e.componentInstance._vnode);
}var Qi = { model: Vi, show: { bind: function bind(e, t, n) {
      var r = t.value,
          i = (n = Yi(n)).data && n.data.transition,
          o = e.__vOriginalDisplay = "none" === e.style.display ? "" : e.style.display;r && i ? (n.data.show = !0, Pi(n, function () {
        e.style.display = o;
      })) : e.style.display = r ? o : "none";
    }, update: function update(e, t, n) {
      var r = t.value;!r != !t.oldValue && ((n = Yi(n)).data && n.data.transition ? (n.data.show = !0, r ? Pi(n, function () {
        e.style.display = e.__vOriginalDisplay;
      }) : Ri(n, function () {
        e.style.display = "none";
      })) : e.style.display = r ? e.__vOriginalDisplay : "none");
    }, unbind: function unbind(e, t, n, r, i) {
      i || (e.style.display = e.__vOriginalDisplay);
    } } },
    eo = { name: String, appear: Boolean, css: Boolean, mode: String, type: String, enterClass: String, leaveClass: String, enterToClass: String, leaveToClass: String, enterActiveClass: String, leaveActiveClass: String, appearClass: String, appearActiveClass: String, appearToClass: String, duration: [Number, String, Object] };function to(e) {
  var t = e && e.componentOptions;return t && t.Ctor.options.abstract ? to(zt(t.children)) : e;
}function no(e) {
  var t = {},
      n = e.$options;for (var r in n.propsData) {
    t[r] = e[r];
  }var i = n._parentListeners;for (var o in i) {
    t[b(o)] = i[o];
  }return t;
}function ro(e, t) {
  if (/\d-keep-alive$/.test(t.tag)) return e("keep-alive", { props: t.componentOptions.propsData });
}var io = function io(e) {
  return e.tag || Ut(e);
},
    oo = function oo(e) {
  return "show" === e.name;
},
    ao = { name: "transition", props: eo, abstract: !0, render: function render(e) {
    var t = this,
        n = this.$slots.default;if (n && (n = n.filter(io)).length) {
      var r = this.mode,
          o = n[0];if (function (e) {
        for (; e = e.parent;) {
          if (e.data.transition) return !0;
        }
      }(this.$vnode)) return o;var a = to(o);if (!a) return o;if (this._leaving) return ro(e, o);var s = "__transition-" + this._uid + "-";a.key = null == a.key ? a.isComment ? s + "comment" : s + a.tag : i(a.key) ? 0 === String(a.key).indexOf(s) ? a.key : s + a.key : a.key;var c = (a.data || (a.data = {})).transition = no(this),
          u = this._vnode,
          l = to(u);if (a.data.directives && a.data.directives.some(oo) && (a.data.show = !0), l && l.data && !function (e, t) {
        return t.key === e.key && t.tag === e.tag;
      }(a, l) && !Ut(l) && (!l.componentInstance || !l.componentInstance._vnode.isComment)) {
        var f = l.data.transition = A({}, c);if ("out-in" === r) return this._leaving = !0, it(f, "afterLeave", function () {
          t._leaving = !1, t.$forceUpdate();
        }), ro(e, o);if ("in-out" === r) {
          if (Ut(a)) return u;var p,
              d = function d() {
            p();
          };it(c, "afterEnter", d), it(c, "enterCancelled", d), it(f, "delayLeave", function (e) {
            p = e;
          });
        }
      }return o;
    }
  } },
    so = A({ tag: String, moveClass: String }, eo);function co(e) {
  e.elm._moveCb && e.elm._moveCb(), e.elm._enterCb && e.elm._enterCb();
}function uo(e) {
  e.data.newPos = e.elm.getBoundingClientRect();
}function lo(e) {
  var t = e.data.pos,
      n = e.data.newPos,
      r = t.left - n.left,
      i = t.top - n.top;if (r || i) {
    e.data.moved = !0;var o = e.elm.style;o.transform = o.WebkitTransform = "translate(" + r + "px," + i + "px)", o.transitionDuration = "0s";
  }
}delete so.mode;var fo = { Transition: ao, TransitionGroup: { props: so, beforeMount: function beforeMount() {
      var e = this,
          t = this._update;this._update = function (n, r) {
        var i = Zt(e);e.__patch__(e._vnode, e.kept, !1, !0), e._vnode = e.kept, i(), t.call(e, n, r);
      };
    }, render: function render(e) {
      for (var t = this.tag || this.$vnode.data.tag || "span", n = Object.create(null), r = this.prevChildren = this.children, i = this.$slots.default || [], o = this.children = [], a = no(this), s = 0; s < i.length; s++) {
        var c = i[s];c.tag && null != c.key && 0 !== String(c.key).indexOf("__vlist") && (o.push(c), n[c.key] = c, (c.data || (c.data = {})).transition = a);
      }if (r) {
        for (var u = [], l = [], f = 0; f < r.length; f++) {
          var p = r[f];p.data.transition = a, p.data.pos = p.elm.getBoundingClientRect(), n[p.key] ? u.push(p) : l.push(p);
        }this.kept = e(t, null, u), this.removed = l;
      }return e(t, null, o);
    }, updated: function updated() {
      var e = this.prevChildren,
          t = this.moveClass || (this.name || "v") + "-move";e.length && this.hasMove(e[0].elm, t) && (e.forEach(co), e.forEach(uo), e.forEach(lo), this._reflow = document.body.offsetHeight, e.forEach(function (e) {
        if (e.data.moved) {
          var n = e.elm,
              r = n.style;Ni(n, t), r.transform = r.WebkitTransform = r.transitionDuration = "", n.addEventListener(Ai, n._moveCb = function e(r) {
            r && r.target !== n || r && !/transform$/.test(r.propertyName) || (n.removeEventListener(Ai, e), n._moveCb = null, ji(n, t));
          });
        }
      }));
    }, methods: { hasMove: function hasMove(e, t) {
        if (!wi) return !1;if (this._hasMove) return this._hasMove;var n = e.cloneNode();e._transitionClasses && e._transitionClasses.forEach(function (e) {
          _i(n, e);
        }), gi(n, t), n.style.display = "none", this.$el.appendChild(n);var r = Mi(n);return this.$el.removeChild(n), this._hasMove = r.hasTransform;
      } } } };wn.config.mustUseProp = jn, wn.config.isReservedTag = Wn, wn.config.isReservedAttr = En, wn.config.getTagNamespace = Zn, wn.config.isUnknownElement = function (e) {
  if (!z) return !0;if (Wn(e)) return !1;if (e = e.toLowerCase(), null != Gn[e]) return Gn[e];var t = document.createElement(e);return e.indexOf("-") > -1 ? Gn[e] = t.constructor === window.HTMLUnknownElement || t.constructor === window.HTMLElement : Gn[e] = /HTMLUnknownElement/.test(t.toString());
}, A(wn.options.directives, Qi), A(wn.options.components, fo), wn.prototype.__patch__ = z ? zi : S, wn.prototype.$mount = function (e, t) {
  return function (e, t, n) {
    var r;return e.$el = t, e.$options.render || (e.$options.render = ve), Yt(e, "beforeMount"), r = function r() {
      e._update(e._render(), n);
    }, new fn(e, r, S, { before: function before() {
        e._isMounted && !e._isDestroyed && Yt(e, "beforeUpdate");
      } }, !0), n = !1, null == e.$vnode && (e._isMounted = !0, Yt(e, "mounted")), e;
  }(this, e = e && z ? Yn(e) : void 0, t);
}, z && setTimeout(function () {
  F.devtools && ne && ne.emit("init", wn);
}, 0);var po = /\{\{((?:.|\r?\n)+?)\}\}/g,
    vo = /[-.*+?^${}()|[\]\/\\]/g,
    ho = g(function (e) {
  var t = e[0].replace(vo, "\\$&"),
      n = e[1].replace(vo, "\\$&");return new RegExp(t + "((?:.|\\n)+?)" + n, "g");
});var mo = { staticKeys: ["staticClass"], transformNode: function transformNode(e, t) {
    t.warn;var n = Fr(e, "class");n && (e.staticClass = JSON.stringify(n));var r = Ir(e, "class", !1);r && (e.classBinding = r);
  }, genData: function genData(e) {
    var t = "";return e.staticClass && (t += "staticClass:" + e.staticClass + ","), e.classBinding && (t += "class:" + e.classBinding + ","), t;
  } };var yo,
    go = { staticKeys: ["staticStyle"], transformNode: function transformNode(e, t) {
    t.warn;var n = Fr(e, "style");n && (e.staticStyle = JSON.stringify(ai(n)));var r = Ir(e, "style", !1);r && (e.styleBinding = r);
  }, genData: function genData(e) {
    var t = "";return e.staticStyle && (t += "staticStyle:" + e.staticStyle + ","), e.styleBinding && (t += "style:(" + e.styleBinding + "),"), t;
  } },
    _o = function _o(e) {
  return (yo = yo || document.createElement("div")).innerHTML = e, yo.textContent;
},
    bo = p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),
    $o = p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),
    wo = p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),
    Co = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
    xo = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,
    ko = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + P.source + "]*",
    Ao = "((?:" + ko + "\\:)?" + ko + ")",
    Oo = new RegExp("^<" + Ao),
    So = /^\s*(\/?)>/,
    To = new RegExp("^<\\/" + Ao + "[^>]*>"),
    Eo = /^<!DOCTYPE [^>]+>/i,
    No = /^<!\--/,
    jo = /^<!\[/,
    Do = p("script,style,textarea", !0),
    Lo = {},
    Mo = { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&amp;": "&", "&#10;": "\n", "&#9;": "\t", "&#39;": "'" },
    Io = /&(?:lt|gt|quot|amp|#39);/g,
    Fo = /&(?:lt|gt|quot|amp|#39|#10|#9);/g,
    Po = p("pre,textarea", !0),
    Ro = function Ro(e, t) {
  return e && Po(e) && "\n" === t[0];
};function Ho(e, t) {
  var n = t ? Fo : Io;return e.replace(n, function (e) {
    return Mo[e];
  });
}var Bo,
    Uo,
    zo,
    Vo,
    Ko,
    Jo,
    qo,
    Wo,
    Zo = /^@|^v-on:/,
    Go = /^v-|^@|^:|^#/,
    Xo = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
    Yo = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
    Qo = /^\(|\)$/g,
    ea = /^\[.*\]$/,
    ta = /:(.*)$/,
    na = /^:|^\.|^v-bind:/,
    ra = /\.[^.\]]+(?=[^\]]*$)/g,
    ia = /^v-slot(:|$)|^#/,
    oa = /[\r\n]/,
    aa = /\s+/g,
    sa = g(_o),
    ca = "_empty_";function ua(e, t, n) {
  return { type: 1, tag: e, attrsList: t, attrsMap: ma(t), rawAttrsMap: {}, parent: n, children: [] };
}function la(e, t) {
  Bo = t.warn || Sr, Jo = t.isPreTag || T, qo = t.mustUseProp || T, Wo = t.getTagNamespace || T;t.isReservedTag;zo = Tr(t.modules, "transformNode"), Vo = Tr(t.modules, "preTransformNode"), Ko = Tr(t.modules, "postTransformNode"), Uo = t.delimiters;var n,
      r,
      i = [],
      o = !1 !== t.preserveWhitespace,
      a = t.whitespace,
      s = !1,
      c = !1;function u(e) {
    if (l(e), s || e.processed || (e = fa(e, t)), i.length || e === n || n.if && (e.elseif || e.else) && da(n, { exp: e.elseif, block: e }), r && !e.forbidden) if (e.elseif || e.else) a = e, (u = function (e) {
      var t = e.length;for (; t--;) {
        if (1 === e[t].type) return e[t];e.pop();
      }
    }(r.children)) && u.if && da(u, { exp: a.elseif, block: a });else {
      if (e.slotScope) {
        var o = e.slotTarget || '"default"';(r.scopedSlots || (r.scopedSlots = {}))[o] = e;
      }r.children.push(e), e.parent = r;
    }var a, u;e.children = e.children.filter(function (e) {
      return !e.slotScope;
    }), l(e), e.pre && (s = !1), Jo(e.tag) && (c = !1);for (var f = 0; f < Ko.length; f++) {
      Ko[f](e, t);
    }
  }function l(e) {
    if (!c) for (var t; (t = e.children[e.children.length - 1]) && 3 === t.type && " " === t.text;) {
      e.children.pop();
    }
  }return function (e, t) {
    for (var n, r, i = [], o = t.expectHTML, a = t.isUnaryTag || T, s = t.canBeLeftOpenTag || T, c = 0; e;) {
      if (n = e, r && Do(r)) {
        var u = 0,
            l = r.toLowerCase(),
            f = Lo[l] || (Lo[l] = new RegExp("([\\s\\S]*?)(</" + l + "[^>]*>)", "i")),
            p = e.replace(f, function (e, n, r) {
          return u = r.length, Do(l) || "noscript" === l || (n = n.replace(/<!\--([\s\S]*?)-->/g, "$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1")), Ro(l, n) && (n = n.slice(1)), t.chars && t.chars(n), "";
        });c += e.length - p.length, e = p, A(l, c - u, c);
      } else {
        var d = e.indexOf("<");if (0 === d) {
          if (No.test(e)) {
            var v = e.indexOf("--\x3e");if (v >= 0) {
              t.shouldKeepComment && t.comment(e.substring(4, v), c, c + v + 3), C(v + 3);continue;
            }
          }if (jo.test(e)) {
            var h = e.indexOf("]>");if (h >= 0) {
              C(h + 2);continue;
            }
          }var m = e.match(Eo);if (m) {
            C(m[0].length);continue;
          }var y = e.match(To);if (y) {
            var g = c;C(y[0].length), A(y[1], g, c);continue;
          }var _ = x();if (_) {
            k(_), Ro(_.tagName, e) && C(1);continue;
          }
        }var b = void 0,
            $ = void 0,
            w = void 0;if (d >= 0) {
          for ($ = e.slice(d); !(To.test($) || Oo.test($) || No.test($) || jo.test($) || (w = $.indexOf("<", 1)) < 0);) {
            d += w, $ = e.slice(d);
          }b = e.substring(0, d);
        }d < 0 && (b = e), b && C(b.length), t.chars && b && t.chars(b, c - b.length, c);
      }if (e === n) {
        t.chars && t.chars(e);break;
      }
    }function C(t) {
      c += t, e = e.substring(t);
    }function x() {
      var t = e.match(Oo);if (t) {
        var n,
            r,
            i = { tagName: t[1], attrs: [], start: c };for (C(t[0].length); !(n = e.match(So)) && (r = e.match(xo) || e.match(Co));) {
          r.start = c, C(r[0].length), r.end = c, i.attrs.push(r);
        }if (n) return i.unarySlash = n[1], C(n[0].length), i.end = c, i;
      }
    }function k(e) {
      var n = e.tagName,
          c = e.unarySlash;o && ("p" === r && wo(n) && A(r), s(n) && r === n && A(n));for (var u = a(n) || !!c, l = e.attrs.length, f = new Array(l), p = 0; p < l; p++) {
        var d = e.attrs[p],
            v = d[3] || d[4] || d[5] || "",
            h = "a" === n && "href" === d[1] ? t.shouldDecodeNewlinesForHref : t.shouldDecodeNewlines;f[p] = { name: d[1], value: Ho(v, h) };
      }u || (i.push({ tag: n, lowerCasedTag: n.toLowerCase(), attrs: f, start: e.start, end: e.end }), r = n), t.start && t.start(n, f, u, e.start, e.end);
    }function A(e, n, o) {
      var a, s;if (null == n && (n = c), null == o && (o = c), e) for (s = e.toLowerCase(), a = i.length - 1; a >= 0 && i[a].lowerCasedTag !== s; a--) {} else a = 0;if (a >= 0) {
        for (var u = i.length - 1; u >= a; u--) {
          t.end && t.end(i[u].tag, n, o);
        }i.length = a, r = a && i[a - 1].tag;
      } else "br" === s ? t.start && t.start(e, [], !0, n, o) : "p" === s && (t.start && t.start(e, [], !1, n, o), t.end && t.end(e, n, o));
    }A();
  }(e, { warn: Bo, expectHTML: t.expectHTML, isUnaryTag: t.isUnaryTag, canBeLeftOpenTag: t.canBeLeftOpenTag, shouldDecodeNewlines: t.shouldDecodeNewlines, shouldDecodeNewlinesForHref: t.shouldDecodeNewlinesForHref, shouldKeepComment: t.comments, outputSourceRange: t.outputSourceRange, start: function start(e, o, a, l, f) {
      var p = r && r.ns || Wo(e);q && "svg" === p && (o = function (e) {
        for (var t = [], n = 0; n < e.length; n++) {
          var r = e[n];ya.test(r.name) || (r.name = r.name.replace(ga, ""), t.push(r));
        }return t;
      }(o));var d,
          v = ua(e, o, r);p && (v.ns = p), "style" !== (d = v).tag && ("script" !== d.tag || d.attrsMap.type && "text/javascript" !== d.attrsMap.type) || te() || (v.forbidden = !0);for (var h = 0; h < Vo.length; h++) {
        v = Vo[h](v, t) || v;
      }s || (!function (e) {
        null != Fr(e, "v-pre") && (e.pre = !0);
      }(v), v.pre && (s = !0)), Jo(v.tag) && (c = !0), s ? function (e) {
        var t = e.attrsList,
            n = t.length;if (n) for (var r = e.attrs = new Array(n), i = 0; i < n; i++) {
          r[i] = { name: t[i].name, value: JSON.stringify(t[i].value) }, null != t[i].start && (r[i].start = t[i].start, r[i].end = t[i].end);
        } else e.pre || (e.plain = !0);
      }(v) : v.processed || (pa(v), function (e) {
        var t = Fr(e, "v-if");if (t) e.if = t, da(e, { exp: t, block: e });else {
          null != Fr(e, "v-else") && (e.else = !0);var n = Fr(e, "v-else-if");n && (e.elseif = n);
        }
      }(v), function (e) {
        null != Fr(e, "v-once") && (e.once = !0);
      }(v)), n || (n = v), a ? u(v) : (r = v, i.push(v));
    }, end: function end(e, t, n) {
      var o = i[i.length - 1];i.length -= 1, r = i[i.length - 1], u(o);
    }, chars: function chars(e, t, n) {
      if (r && (!q || "textarea" !== r.tag || r.attrsMap.placeholder !== e)) {
        var i,
            u,
            l,
            f = r.children;if (e = c || e.trim() ? "script" === (i = r).tag || "style" === i.tag ? e : sa(e) : f.length ? a ? "condense" === a && oa.test(e) ? "" : " " : o ? " " : "" : "") c || "condense" !== a || (e = e.replace(aa, " ")), !s && " " !== e && (u = function (e, t) {
          var n = t ? ho(t) : po;if (n.test(e)) {
            for (var r, i, o, a = [], s = [], c = n.lastIndex = 0; r = n.exec(e);) {
              (i = r.index) > c && (s.push(o = e.slice(c, i)), a.push(JSON.stringify(o)));var u = Ar(r[1].trim());a.push("_s(" + u + ")"), s.push({ "@binding": u }), c = i + r[0].length;
            }return c < e.length && (s.push(o = e.slice(c)), a.push(JSON.stringify(o))), { expression: a.join("+"), tokens: s };
          }
        }(e, Uo)) ? l = { type: 2, expression: u.expression, tokens: u.tokens, text: e } : " " === e && f.length && " " === f[f.length - 1].text || (l = { type: 3, text: e }), l && f.push(l);
      }
    }, comment: function comment(e, t, n) {
      if (r) {
        var i = { type: 3, text: e, isComment: !0 };r.children.push(i);
      }
    } }), n;
}function fa(e, t) {
  var n, r;(r = Ir(n = e, "key")) && (n.key = r), e.plain = !e.key && !e.scopedSlots && !e.attrsList.length, function (e) {
    var t = Ir(e, "ref");t && (e.ref = t, e.refInFor = function (e) {
      var t = e;for (; t;) {
        if (void 0 !== t.for) return !0;t = t.parent;
      }return !1;
    }(e));
  }(e), function (e) {
    var t;"template" === e.tag ? (t = Fr(e, "scope"), e.slotScope = t || Fr(e, "slot-scope")) : (t = Fr(e, "slot-scope")) && (e.slotScope = t);var n = Ir(e, "slot");n && (e.slotTarget = '""' === n ? '"default"' : n, e.slotTargetDynamic = !(!e.attrsMap[":slot"] && !e.attrsMap["v-bind:slot"]), "template" === e.tag || e.slotScope || Nr(e, "slot", n, function (e, t) {
      return e.rawAttrsMap[":" + t] || e.rawAttrsMap["v-bind:" + t] || e.rawAttrsMap[t];
    }(e, "slot")));if ("template" === e.tag) {
      var r = Pr(e, ia);if (r) {
        var i = va(r),
            o = i.name,
            a = i.dynamic;e.slotTarget = o, e.slotTargetDynamic = a, e.slotScope = r.value || ca;
      }
    } else {
      var s = Pr(e, ia);if (s) {
        var c = e.scopedSlots || (e.scopedSlots = {}),
            u = va(s),
            l = u.name,
            f = u.dynamic,
            p = c[l] = ua("template", [], e);p.slotTarget = l, p.slotTargetDynamic = f, p.children = e.children.filter(function (e) {
          if (!e.slotScope) return e.parent = p, !0;
        }), p.slotScope = s.value || ca, e.children = [], e.plain = !1;
      }
    }
  }(e), function (e) {
    "slot" === e.tag && (e.slotName = Ir(e, "name"));
  }(e), function (e) {
    var t;(t = Ir(e, "is")) && (e.component = t);null != Fr(e, "inline-template") && (e.inlineTemplate = !0);
  }(e);for (var i = 0; i < zo.length; i++) {
    e = zo[i](e, t) || e;
  }return function (e) {
    var t,
        n,
        r,
        i,
        o,
        a,
        s,
        c,
        u = e.attrsList;for (t = 0, n = u.length; t < n; t++) {
      if (r = i = u[t].name, o = u[t].value, Go.test(r)) {
        if (e.hasBindings = !0, (a = ha(r.replace(Go, ""))) && (r = r.replace(ra, "")), na.test(r)) r = r.replace(na, ""), o = Ar(o), (c = ea.test(r)) && (r = r.slice(1, -1)), a && (a.prop && !c && "innerHtml" === (r = b(r)) && (r = "innerHTML"), a.camel && !c && (r = b(r)), a.sync && (s = Br(o, "$event"), c ? Mr(e, '"update:"+(' + r + ")", s, null, !1, 0, u[t], !0) : (Mr(e, "update:" + b(r), s, null, !1, 0, u[t]), C(r) !== b(r) && Mr(e, "update:" + C(r), s, null, !1, 0, u[t])))), a && a.prop || !e.component && qo(e.tag, e.attrsMap.type, r) ? Er(e, r, o, u[t], c) : Nr(e, r, o, u[t], c);else if (Zo.test(r)) r = r.replace(Zo, ""), (c = ea.test(r)) && (r = r.slice(1, -1)), Mr(e, r, o, a, !1, 0, u[t], c);else {
          var l = (r = r.replace(Go, "")).match(ta),
              f = l && l[1];c = !1, f && (r = r.slice(0, -(f.length + 1)), ea.test(f) && (f = f.slice(1, -1), c = !0)), Dr(e, r, i, o, f, c, a, u[t]);
        }
      } else Nr(e, r, JSON.stringify(o), u[t]), !e.component && "muted" === r && qo(e.tag, e.attrsMap.type, r) && Er(e, r, "true", u[t]);
    }
  }(e), e;
}function pa(e) {
  var t;if (t = Fr(e, "v-for")) {
    var n = function (e) {
      var t = e.match(Xo);if (!t) return;var n = {};n.for = t[2].trim();var r = t[1].trim().replace(Qo, ""),
          i = r.match(Yo);i ? (n.alias = r.replace(Yo, "").trim(), n.iterator1 = i[1].trim(), i[2] && (n.iterator2 = i[2].trim())) : n.alias = r;return n;
    }(t);n && A(e, n);
  }
}function da(e, t) {
  e.ifConditions || (e.ifConditions = []), e.ifConditions.push(t);
}function va(e) {
  var t = e.name.replace(ia, "");return t || "#" !== e.name[0] && (t = "default"), ea.test(t) ? { name: t.slice(1, -1), dynamic: !0 } : { name: '"' + t + '"', dynamic: !1 };
}function ha(e) {
  var t = e.match(ra);if (t) {
    var n = {};return t.forEach(function (e) {
      n[e.slice(1)] = !0;
    }), n;
  }
}function ma(e) {
  for (var t = {}, n = 0, r = e.length; n < r; n++) {
    t[e[n].name] = e[n].value;
  }return t;
}var ya = /^xmlns:NS\d+/,
    ga = /^NS\d+:/;function _a(e) {
  return ua(e.tag, e.attrsList.slice(), e.parent);
}var ba = [mo, go, { preTransformNode: function preTransformNode(e, t) {
    if ("input" === e.tag) {
      var n,
          r = e.attrsMap;if (!r["v-model"]) return;if ((r[":type"] || r["v-bind:type"]) && (n = Ir(e, "type")), r.type || n || !r["v-bind"] || (n = "(" + r["v-bind"] + ").type"), n) {
        var i = Fr(e, "v-if", !0),
            o = i ? "&&(" + i + ")" : "",
            a = null != Fr(e, "v-else", !0),
            s = Fr(e, "v-else-if", !0),
            c = _a(e);pa(c), jr(c, "type", "checkbox"), fa(c, t), c.processed = !0, c.if = "(" + n + ")==='checkbox'" + o, da(c, { exp: c.if, block: c });var u = _a(e);Fr(u, "v-for", !0), jr(u, "type", "radio"), fa(u, t), da(c, { exp: "(" + n + ")==='radio'" + o, block: u });var l = _a(e);return Fr(l, "v-for", !0), jr(l, ":type", n), fa(l, t), da(c, { exp: i, block: l }), a ? c.else = !0 : s && (c.elseif = s), c;
      }
    }
  } }];var $a,
    wa,
    Ca = { expectHTML: !0, modules: ba, directives: { model: function model(e, t, n) {
      var r = t.value,
          i = t.modifiers,
          o = e.tag,
          a = e.attrsMap.type;if (e.component) return Hr(e, r, i), !1;if ("select" === o) !function (e, t, n) {
        var r = 'var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return ' + (n && n.number ? "_n(val)" : "val") + "});";r = r + " " + Br(t, "$event.target.multiple ? $$selectedVal : $$selectedVal[0]"), Mr(e, "change", r, null, !0);
      }(e, r, i);else if ("input" === o && "checkbox" === a) !function (e, t, n) {
        var r = n && n.number,
            i = Ir(e, "value") || "null",
            o = Ir(e, "true-value") || "true",
            a = Ir(e, "false-value") || "false";Er(e, "checked", "Array.isArray(" + t + ")?_i(" + t + "," + i + ")>-1" + ("true" === o ? ":(" + t + ")" : ":_q(" + t + "," + o + ")")), Mr(e, "change", "var $$a=" + t + ",$$el=$event.target,$$c=$$el.checked?(" + o + "):(" + a + ");if(Array.isArray($$a)){var $$v=" + (r ? "_n(" + i + ")" : i) + ",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&(" + Br(t, "$$a.concat([$$v])") + ")}else{$$i>-1&&(" + Br(t, "$$a.slice(0,$$i).concat($$a.slice($$i+1))") + ")}}else{" + Br(t, "$$c") + "}", null, !0);
      }(e, r, i);else if ("input" === o && "radio" === a) !function (e, t, n) {
        var r = n && n.number,
            i = Ir(e, "value") || "null";Er(e, "checked", "_q(" + t + "," + (i = r ? "_n(" + i + ")" : i) + ")"), Mr(e, "change", Br(t, i), null, !0);
      }(e, r, i);else if ("input" === o || "textarea" === o) !function (e, t, n) {
        var r = e.attrsMap.type,
            i = n || {},
            o = i.lazy,
            a = i.number,
            s = i.trim,
            c = !o && "range" !== r,
            u = o ? "change" : "range" === r ? Wr : "input",
            l = "$event.target.value";s && (l = "$event.target.value.trim()"), a && (l = "_n(" + l + ")");var f = Br(t, l);c && (f = "if($event.target.composing)return;" + f), Er(e, "value", "(" + t + ")"), Mr(e, u, f, null, !0), (s || a) && Mr(e, "blur", "$forceUpdate()");
      }(e, r, i);else if (!F.isReservedTag(o)) return Hr(e, r, i), !1;return !0;
    }, text: function text(e, t) {
      t.value && Er(e, "textContent", "_s(" + t.value + ")", t);
    }, html: function html(e, t) {
      t.value && Er(e, "innerHTML", "_s(" + t.value + ")", t);
    } }, isPreTag: function isPreTag(e) {
    return "pre" === e;
  }, isUnaryTag: bo, mustUseProp: jn, canBeLeftOpenTag: $o, isReservedTag: Wn, getTagNamespace: Zn, staticKeys: function (e) {
    return e.reduce(function (e, t) {
      return e.concat(t.staticKeys || []);
    }, []).join(",");
  }(ba) },
    xa = g(function (e) {
  return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" + (e ? "," + e : ""));
});function ka(e, t) {
  e && ($a = xa(t.staticKeys || ""), wa = t.isReservedTag || T, function e(t) {
    t.static = function (e) {
      if (2 === e.type) return !1;if (3 === e.type) return !0;return !(!e.pre && (e.hasBindings || e.if || e.for || d(e.tag) || !wa(e.tag) || function (e) {
        for (; e.parent;) {
          if ("template" !== (e = e.parent).tag) return !1;if (e.for) return !0;
        }return !1;
      }(e) || !Object.keys(e).every($a)));
    }(t);if (1 === t.type) {
      if (!wa(t.tag) && "slot" !== t.tag && null == t.attrsMap["inline-template"]) return;for (var n = 0, r = t.children.length; n < r; n++) {
        var i = t.children[n];e(i), i.static || (t.static = !1);
      }if (t.ifConditions) for (var o = 1, a = t.ifConditions.length; o < a; o++) {
        var s = t.ifConditions[o].block;e(s), s.static || (t.static = !1);
      }
    }
  }(e), function e(t, n) {
    if (1 === t.type) {
      if ((t.static || t.once) && (t.staticInFor = n), t.static && t.children.length && (1 !== t.children.length || 3 !== t.children[0].type)) return void (t.staticRoot = !0);if (t.staticRoot = !1, t.children) for (var r = 0, i = t.children.length; r < i; r++) {
        e(t.children[r], n || !!t.for);
      }if (t.ifConditions) for (var o = 1, a = t.ifConditions.length; o < a; o++) {
        e(t.ifConditions[o].block, n);
      }
    }
  }(e, !1));
}var Aa = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,
    Oa = /\([^)]*?\);*$/,
    Sa = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,
    Ta = { esc: 27, tab: 9, enter: 13, space: 32, up: 38, left: 37, right: 39, down: 40, delete: [8, 46] },
    Ea = { esc: ["Esc", "Escape"], tab: "Tab", enter: "Enter", space: [" ", "Spacebar"], up: ["Up", "ArrowUp"], left: ["Left", "ArrowLeft"], right: ["Right", "ArrowRight"], down: ["Down", "ArrowDown"], delete: ["Backspace", "Delete", "Del"] },
    Na = function Na(e) {
  return "if(" + e + ")return null;";
},
    ja = { stop: "$event.stopPropagation();", prevent: "$event.preventDefault();", self: Na("$event.target !== $event.currentTarget"), ctrl: Na("!$event.ctrlKey"), shift: Na("!$event.shiftKey"), alt: Na("!$event.altKey"), meta: Na("!$event.metaKey"), left: Na("'button' in $event && $event.button !== 0"), middle: Na("'button' in $event && $event.button !== 1"), right: Na("'button' in $event && $event.button !== 2") };function Da(e, t) {
  var n = t ? "nativeOn:" : "on:",
      r = "",
      i = "";for (var o in e) {
    var a = La(e[o]);e[o] && e[o].dynamic ? i += o + "," + a + "," : r += '"' + o + '":' + a + ",";
  }return r = "{" + r.slice(0, -1) + "}", i ? n + "_d(" + r + ",[" + i.slice(0, -1) + "])" : n + r;
}function La(e) {
  if (!e) return "function(){}";if (Array.isArray(e)) return "[" + e.map(function (e) {
    return La(e);
  }).join(",") + "]";var t = Sa.test(e.value),
      n = Aa.test(e.value),
      r = Sa.test(e.value.replace(Oa, ""));if (e.modifiers) {
    var i = "",
        o = "",
        a = [];for (var s in e.modifiers) {
      if (ja[s]) o += ja[s], Ta[s] && a.push(s);else if ("exact" === s) {
        var c = e.modifiers;o += Na(["ctrl", "shift", "alt", "meta"].filter(function (e) {
          return !c[e];
        }).map(function (e) {
          return "$event." + e + "Key";
        }).join("||"));
      } else a.push(s);
    }return a.length && (i += function (e) {
      return "if(!$event.type.indexOf('key')&&" + e.map(Ma).join("&&") + ")return null;";
    }(a)), o && (i += o), "function($event){" + i + (t ? "return " + e.value + "($event)" : n ? "return (" + e.value + ")($event)" : r ? "return " + e.value : e.value) + "}";
  }return t || n ? e.value : "function($event){" + (r ? "return " + e.value : e.value) + "}";
}function Ma(e) {
  var t = parseInt(e, 10);if (t) return "$event.keyCode!==" + t;var n = Ta[e],
      r = Ea[e];return "_k($event.keyCode," + JSON.stringify(e) + "," + JSON.stringify(n) + ",$event.key," + JSON.stringify(r) + ")";
}var Ia = { on: function on(e, t) {
    e.wrapListeners = function (e) {
      return "_g(" + e + "," + t.value + ")";
    };
  }, bind: function bind(e, t) {
    e.wrapData = function (n) {
      return "_b(" + n + ",'" + e.tag + "'," + t.value + "," + (t.modifiers && t.modifiers.prop ? "true" : "false") + (t.modifiers && t.modifiers.sync ? ",true" : "") + ")";
    };
  }, cloak: S },
    Fa = function Fa(e) {
  this.options = e, this.warn = e.warn || Sr, this.transforms = Tr(e.modules, "transformCode"), this.dataGenFns = Tr(e.modules, "genData"), this.directives = A(A({}, Ia), e.directives);var t = e.isReservedTag || T;this.maybeComponent = function (e) {
    return !!e.component || !t(e.tag);
  }, this.onceId = 0, this.staticRenderFns = [], this.pre = !1;
};function Pa(e, t) {
  var n = new Fa(t);return { render: "with(this){return " + (e ? Ra(e, n) : '_c("div")') + "}", staticRenderFns: n.staticRenderFns };
}function Ra(e, t) {
  if (e.parent && (e.pre = e.pre || e.parent.pre), e.staticRoot && !e.staticProcessed) return Ha(e, t);if (e.once && !e.onceProcessed) return Ba(e, t);if (e.for && !e.forProcessed) return za(e, t);if (e.if && !e.ifProcessed) return Ua(e, t);if ("template" !== e.tag || e.slotTarget || t.pre) {
    if ("slot" === e.tag) return function (e, t) {
      var n = e.slotName || '"default"',
          r = qa(e, t),
          i = "_t(" + n + (r ? "," + r : ""),
          o = e.attrs || e.dynamicAttrs ? Ga((e.attrs || []).concat(e.dynamicAttrs || []).map(function (e) {
        return { name: b(e.name), value: e.value, dynamic: e.dynamic };
      })) : null,
          a = e.attrsMap["v-bind"];!o && !a || r || (i += ",null");o && (i += "," + o);a && (i += (o ? "" : ",null") + "," + a);return i + ")";
    }(e, t);var n;if (e.component) n = function (e, t, n) {
      var r = t.inlineTemplate ? null : qa(t, n, !0);return "_c(" + e + "," + Va(t, n) + (r ? "," + r : "") + ")";
    }(e.component, e, t);else {
      var r;(!e.plain || e.pre && t.maybeComponent(e)) && (r = Va(e, t));var i = e.inlineTemplate ? null : qa(e, t, !0);n = "_c('" + e.tag + "'" + (r ? "," + r : "") + (i ? "," + i : "") + ")";
    }for (var o = 0; o < t.transforms.length; o++) {
      n = t.transforms[o](e, n);
    }return n;
  }return qa(e, t) || "void 0";
}function Ha(e, t) {
  e.staticProcessed = !0;var n = t.pre;return e.pre && (t.pre = e.pre), t.staticRenderFns.push("with(this){return " + Ra(e, t) + "}"), t.pre = n, "_m(" + (t.staticRenderFns.length - 1) + (e.staticInFor ? ",true" : "") + ")";
}function Ba(e, t) {
  if (e.onceProcessed = !0, e.if && !e.ifProcessed) return Ua(e, t);if (e.staticInFor) {
    for (var n = "", r = e.parent; r;) {
      if (r.for) {
        n = r.key;break;
      }r = r.parent;
    }return n ? "_o(" + Ra(e, t) + "," + t.onceId++ + "," + n + ")" : Ra(e, t);
  }return Ha(e, t);
}function Ua(e, t, n, r) {
  return e.ifProcessed = !0, function e(t, n, r, i) {
    if (!t.length) return i || "_e()";var o = t.shift();return o.exp ? "(" + o.exp + ")?" + a(o.block) + ":" + e(t, n, r, i) : "" + a(o.block);function a(e) {
      return r ? r(e, n) : e.once ? Ba(e, n) : Ra(e, n);
    }
  }(e.ifConditions.slice(), t, n, r);
}function za(e, t, n, r) {
  var i = e.for,
      o = e.alias,
      a = e.iterator1 ? "," + e.iterator1 : "",
      s = e.iterator2 ? "," + e.iterator2 : "";return e.forProcessed = !0, (r || "_l") + "((" + i + "),function(" + o + a + s + "){return " + (n || Ra)(e, t) + "})";
}function Va(e, t) {
  var n = "{",
      r = function (e, t) {
    var n = e.directives;if (!n) return;var r,
        i,
        o,
        a,
        s = "directives:[",
        c = !1;for (r = 0, i = n.length; r < i; r++) {
      o = n[r], a = !0;var u = t.directives[o.name];u && (a = !!u(e, o, t.warn)), a && (c = !0, s += '{name:"' + o.name + '",rawName:"' + o.rawName + '"' + (o.value ? ",value:(" + o.value + "),expression:" + JSON.stringify(o.value) : "") + (o.arg ? ",arg:" + (o.isDynamicArg ? o.arg : '"' + o.arg + '"') : "") + (o.modifiers ? ",modifiers:" + JSON.stringify(o.modifiers) : "") + "},");
    }if (c) return s.slice(0, -1) + "]";
  }(e, t);r && (n += r + ","), e.key && (n += "key:" + e.key + ","), e.ref && (n += "ref:" + e.ref + ","), e.refInFor && (n += "refInFor:true,"), e.pre && (n += "pre:true,"), e.component && (n += 'tag:"' + e.tag + '",');for (var i = 0; i < t.dataGenFns.length; i++) {
    n += t.dataGenFns[i](e);
  }if (e.attrs && (n += "attrs:" + Ga(e.attrs) + ","), e.props && (n += "domProps:" + Ga(e.props) + ","), e.events && (n += Da(e.events, !1) + ","), e.nativeEvents && (n += Da(e.nativeEvents, !0) + ","), e.slotTarget && !e.slotScope && (n += "slot:" + e.slotTarget + ","), e.scopedSlots && (n += function (e, t, n) {
    var r = e.for || Object.keys(t).some(function (e) {
      var n = t[e];return n.slotTargetDynamic || n.if || n.for || Ka(n);
    }),
        i = !!e.if;if (!r) for (var o = e.parent; o;) {
      if (o.slotScope && o.slotScope !== ca || o.for) {
        r = !0;break;
      }o.if && (i = !0), o = o.parent;
    }var a = Object.keys(t).map(function (e) {
      return Ja(t[e], n);
    }).join(",");return "scopedSlots:_u([" + a + "]" + (r ? ",null,true" : "") + (!r && i ? ",null,false," + function (e) {
      var t = 5381,
          n = e.length;for (; n;) {
        t = 33 * t ^ e.charCodeAt(--n);
      }return t >>> 0;
    }(a) : "") + ")";
  }(e, e.scopedSlots, t) + ","), e.model && (n += "model:{value:" + e.model.value + ",callback:" + e.model.callback + ",expression:" + e.model.expression + "},"), e.inlineTemplate) {
    var o = function (e, t) {
      var n = e.children[0];if (n && 1 === n.type) {
        var r = Pa(n, t.options);return "inlineTemplate:{render:function(){" + r.render + "},staticRenderFns:[" + r.staticRenderFns.map(function (e) {
          return "function(){" + e + "}";
        }).join(",") + "]}";
      }
    }(e, t);o && (n += o + ",");
  }return n = n.replace(/,$/, "") + "}", e.dynamicAttrs && (n = "_b(" + n + ',"' + e.tag + '",' + Ga(e.dynamicAttrs) + ")"), e.wrapData && (n = e.wrapData(n)), e.wrapListeners && (n = e.wrapListeners(n)), n;
}function Ka(e) {
  return 1 === e.type && ("slot" === e.tag || e.children.some(Ka));
}function Ja(e, t) {
  var n = e.attrsMap["slot-scope"];if (e.if && !e.ifProcessed && !n) return Ua(e, t, Ja, "null");if (e.for && !e.forProcessed) return za(e, t, Ja);var r = e.slotScope === ca ? "" : String(e.slotScope),
      i = "function(" + r + "){return " + ("template" === e.tag ? e.if && n ? "(" + e.if + ")?" + (qa(e, t) || "undefined") + ":undefined" : qa(e, t) || "undefined" : Ra(e, t)) + "}",
      o = r ? "" : ",proxy:true";return "{key:" + (e.slotTarget || '"default"') + ",fn:" + i + o + "}";
}function qa(e, t, n, r, i) {
  var o = e.children;if (o.length) {
    var a = o[0];if (1 === o.length && a.for && "template" !== a.tag && "slot" !== a.tag) {
      var s = n ? t.maybeComponent(a) ? ",1" : ",0" : "";return "" + (r || Ra)(a, t) + s;
    }var c = n ? function (e, t) {
      for (var n = 0, r = 0; r < e.length; r++) {
        var i = e[r];if (1 === i.type) {
          if (Wa(i) || i.ifConditions && i.ifConditions.some(function (e) {
            return Wa(e.block);
          })) {
            n = 2;break;
          }(t(i) || i.ifConditions && i.ifConditions.some(function (e) {
            return t(e.block);
          })) && (n = 1);
        }
      }return n;
    }(o, t.maybeComponent) : 0,
        u = i || Za;return "[" + o.map(function (e) {
      return u(e, t);
    }).join(",") + "]" + (c ? "," + c : "");
  }
}function Wa(e) {
  return void 0 !== e.for || "template" === e.tag || "slot" === e.tag;
}function Za(e, t) {
  return 1 === e.type ? Ra(e, t) : 3 === e.type && e.isComment ? (r = e, "_e(" + JSON.stringify(r.text) + ")") : "_v(" + (2 === (n = e).type ? n.expression : Xa(JSON.stringify(n.text))) + ")";var n, r;
}function Ga(e) {
  for (var t = "", n = "", r = 0; r < e.length; r++) {
    var i = e[r],
        o = Xa(i.value);i.dynamic ? n += i.name + "," + o + "," : t += '"' + i.name + '":' + o + ",";
  }return t = "{" + t.slice(0, -1) + "}", n ? "_d(" + t + ",[" + n.slice(0, -1) + "])" : t;
}function Xa(e) {
  return e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}new RegExp("\\b" + "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b") + "\\b");function Ya(e, t) {
  try {
    return new Function(e);
  } catch (n) {
    return t.push({ err: n, code: e }), S;
  }
}function Qa(e) {
  var t = Object.create(null);return function (n, r, i) {
    (r = A({}, r)).warn;delete r.warn;var o = r.delimiters ? String(r.delimiters) + n : n;if (t[o]) return t[o];var a = e(n, r),
        s = {},
        c = [];return s.render = Ya(a.render, c), s.staticRenderFns = a.staticRenderFns.map(function (e) {
      return Ya(e, c);
    }), t[o] = s;
  };
}var es,
    ts,
    ns = (es = function es(e, t) {
  var n = la(e.trim(), t);!1 !== t.optimize && ka(n, t);var r = Pa(n, t);return { ast: n, render: r.render, staticRenderFns: r.staticRenderFns };
}, function (e) {
  function t(t, n) {
    var r = Object.create(e),
        i = [],
        o = [];if (n) for (var a in n.modules && (r.modules = (e.modules || []).concat(n.modules)), n.directives && (r.directives = A(Object.create(e.directives || null), n.directives)), n) {
      "modules" !== a && "directives" !== a && (r[a] = n[a]);
    }r.warn = function (e, t, n) {
      (n ? o : i).push(e);
    };var s = es(t.trim(), r);return s.errors = i, s.tips = o, s;
  }return { compile: t, compileToFunctions: Qa(t) };
})(Ca),
    rs = (ns.compile, ns.compileToFunctions);function is(e) {
  return (ts = ts || document.createElement("div")).innerHTML = e ? '<a href="\n"/>' : '<div a="\n"/>', ts.innerHTML.indexOf("&#10;") > 0;
}var os = !!z && is(!1),
    as = !!z && is(!0),
    ss = g(function (e) {
  var t = Yn(e);return t && t.innerHTML;
}),
    cs = wn.prototype.$mount;wn.prototype.$mount = function (e, t) {
  if ((e = e && Yn(e)) === document.body || e === document.documentElement) return this;var n = this.$options;if (!n.render) {
    var r = n.template;if (r) {
      if ("string" == typeof r) "#" === r.charAt(0) && (r = ss(r));else {
        if (!r.nodeType) return this;r = r.innerHTML;
      }
    } else e && (r = function (e) {
      if (e.outerHTML) return e.outerHTML;var t = document.createElement("div");return t.appendChild(e.cloneNode(!0)), t.innerHTML;
    }(e));if (r) {
      var i = rs(r, { outputSourceRange: !1, shouldDecodeNewlines: os, shouldDecodeNewlinesForHref: as, delimiters: n.delimiters, comments: n.comments }, this),
          o = i.render,
          a = i.staticRenderFns;n.render = o, n.staticRenderFns = a;
    }
  }return cs.call(this, e, t);
}, wn.compile = rs, module.exports = wn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(232).setImmediate))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(233);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(27)))

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t(__webpack_require__(985)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(986)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueAwesomeSwiper = t(require("swiper/dist/js/swiper.js")) : e.VueAwesomeSwiper = t(e.Swiper);
}(this, function (e) {
  return function (e) {
    function t(i) {
      if (n[i]) return n[i].exports;var s = n[i] = { i: i, l: !1, exports: {} };return e[i].call(s.exports, s, s.exports, t), s.l = !0, s.exports;
    }var n = {};return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, i) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: i });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/", t(t.s = 4);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t) {
    e.exports = function (e, t, n, i, s, r) {
      var o,
          a = e = e || {},
          u = _typeof(e.default);"object" !== u && "function" !== u || (o = e, a = e.default);var p = "function" == typeof a ? a.options : a;t && (p.render = t.render, p.staticRenderFns = t.staticRenderFns, p._compiled = !0), n && (p.functional = !0), s && (p._scopeId = s);var l;if (r ? (l = function l(e) {
        e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, e || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), i && i.call(this, e), e && e._registeredComponents && e._registeredComponents.add(r);
      }, p._ssrRegister = l) : i && (l = i), l) {
        var c = p.functional,
            d = c ? p.render : p.beforeCreate;c ? (p._injectStyles = l, p.render = function (e, t) {
          return l.call(t), d(e, t);
        }) : p.beforeCreate = d ? [].concat(d, l) : [l];
      }return { esModule: o, exports: a, options: p };
    };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var i = n(5),
        s = n.n(i),
        r = n(8),
        o = n(1),
        a = o(s.a, r.a, !1, null, null, null);t.default = a.exports;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var i = n(6),
        s = n.n(i),
        r = n(7),
        o = n(1),
        a = o(s.a, r.a, !1, null, null, null);t.default = a.exports;
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 }), t.install = t.swiperSlide = t.swiper = t.Swiper = void 0;var s = n(0),
        r = i(s),
        o = n(2),
        a = i(o),
        u = n(3),
        p = i(u),
        l = window.Swiper || r.default,
        c = p.default,
        d = a.default,
        f = function f(e, t) {
      t && (p.default.props.globalOptions.default = function () {
        return t;
      }), e.component(p.default.name, p.default), e.component(a.default.name, a.default);
    },
        h = { Swiper: l, swiper: c, swiperSlide: d, install: f };t.default = h, t.Swiper = l, t.swiper = c, t.swiperSlide = d, t.install = f;
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { name: "swiper-slide", data: function data() {
        return { slideClass: "swiper-slide" };
      }, ready: function ready() {
        this.update();
      }, mounted: function mounted() {
        this.update(), this.$parent && this.$parent.options && this.$parent.options.slideClass && (this.slideClass = this.$parent.options.slideClass);
      }, updated: function updated() {
        this.update();
      }, attached: function attached() {
        this.update();
      }, methods: { update: function update() {
          this.$parent && this.$parent.swiper && this.$parent.update();
        } } };
  }, function (e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var i = n(0),
        s = function (e) {
      return e && e.__esModule ? e : { default: e };
    }(i),
        r = window.Swiper || s.default;"function" != typeof Object.assign && Object.defineProperty(Object, "assign", { value: function value(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");for (var n = Object(e), i = 1; i < arguments.length; i++) {
          var s = arguments[i];if (null != s) for (var r in s) {
            Object.prototype.hasOwnProperty.call(s, r) && (n[r] = s[r]);
          }
        }return n;
      }, writable: !0, configurable: !0 });var o = ["beforeDestroy", "slideChange", "slideChangeTransitionStart", "slideChangeTransitionEnd", "slideNextTransitionStart", "slideNextTransitionEnd", "slidePrevTransitionStart", "slidePrevTransitionEnd", "transitionStart", "transitionEnd", "touchStart", "touchMove", "touchMoveOpposite", "sliderMove", "touchEnd", "click", "tap", "doubleTap", "imagesReady", "progress", "reachBeginning", "reachEnd", "fromEdge", "setTranslate", "setTransition", "resize"];t.default = { name: "swiper", props: { options: { type: Object, default: function _default() {
            return {};
          } }, globalOptions: { type: Object, required: !1, default: function _default() {
            return {};
          } } }, data: function data() {
        return { swiper: null, classes: { wrapperClass: "swiper-wrapper" } };
      }, ready: function ready() {
        this.swiper || this.mountInstance();
      }, mounted: function mounted() {
        if (!this.swiper) {
          var e = !1;for (var t in this.classes) {
            this.classes.hasOwnProperty(t) && this.options[t] && (e = !0, this.classes[t] = this.options[t]);
          }e ? this.$nextTick(this.mountInstance) : this.mountInstance();
        }
      }, activated: function activated() {
        this.update();
      }, updated: function updated() {
        this.update();
      }, beforeDestroy: function beforeDestroy() {
        this.$nextTick(function () {
          this.swiper && (this.swiper.destroy && this.swiper.destroy(), delete this.swiper);
        });
      }, methods: { update: function update() {
          this.swiper && (this.swiper.update && this.swiper.update(), this.swiper.navigation && this.swiper.navigation.update(), this.swiper.pagination && this.swiper.pagination.render(), this.swiper.pagination && this.swiper.pagination.update());
        }, mountInstance: function mountInstance() {
          var e = Object.assign({}, this.globalOptions, this.options);this.swiper = new r(this.$el, e), this.bindEvents(), this.$emit("ready", this.swiper);
        }, bindEvents: function bindEvents() {
          var e = this,
              t = this;o.forEach(function (n) {
            e.swiper.on(n, function () {
              t.$emit.apply(t, [n].concat(Array.prototype.slice.call(arguments))), t.$emit.apply(t, [n.replace(/([A-Z])/g, "-$1").toLowerCase()].concat(Array.prototype.slice.call(arguments)));
            });
          });
        } } };
  }, function (e, t, n) {
    "use strict";
    var i = function i() {
      var e = this,
          t = e.$createElement,
          n = e._self._c || t;return n("div", { staticClass: "swiper-container" }, [e._t("parallax-bg"), e._v(" "), n("div", { class: e.classes.wrapperClass }, [e._t("default")], 2), e._v(" "), e._t("pagination"), e._v(" "), e._t("button-prev"), e._v(" "), e._t("button-next"), e._v(" "), e._t("scrollbar")], 2);
    },
        s = [],
        r = { render: i, staticRenderFns: s };t.a = r;
  }, function (e, t, n) {
    "use strict";
    var i = function i() {
      var e = this,
          t = e.$createElement;return (e._self._c || t)("div", { class: e.slideClass }, [e._t("default")], 2);
    },
        s = [],
        r = { render: i, staticRenderFns: s };t.a = r;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(292);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(769),
    isObjectLike = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248),
    stackClear = __webpack_require__(779),
    stackDelete = __webpack_require__(780),
    stackGet = __webpack_require__(781),
    stackHas = __webpack_require__(782),
    stackSet = __webpack_require__(783);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(774),
    listCacheDelete = __webpack_require__(775),
    listCacheGet = __webpack_require__(776),
    listCacheHas = __webpack_require__(777),
    listCacheSet = __webpack_require__(778);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(162);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(796);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(639),
    baseKeys = __webpack_require__(811),
    isArrayLike = __webpack_require__(255);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(80),
    stubFalse = __webpack_require__(809);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 254 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(296),
    isLength = __webpack_require__(304);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(813),
    Map = __webpack_require__(295),
    Promise = __webpack_require__(814),
    Set = __webpack_require__(641),
    WeakMap = __webpack_require__(815),
    baseGetTag = __webpack_require__(151),
    toSource = __webpack_require__(632);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_DNFORM_DNFORM_utils_DNFORM_utils__ = __webpack_require__(152);



/* harmony default export */ __webpack_exports__["a"] = ({
	isNoValue: function isNoValue(value) {
		return value === undefined || value === null || value === '' || value == false;
	},
	isEmptyValue: function isEmptyValue(value) {
		return this.isNoValue(value) || Array.isArray(value) && !value.length || Object(__WEBPACK_IMPORTED_MODULE_1__modules_DNFORM_DNFORM_utils_DNFORM_utils__["c" /* isObject */])(value) && Object.values(value).some(function (_value) {
			return _value === '';
		});
	},
	isValidDate: function isValidDate(value) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["a" /* isValid */])(new Date(value));
	},
	convertMegaByteToByte: function convertMegaByteToByte(value) {
		return value * Math.pow(1024, 2);
	},
	getFileExtensionFromFilename: function getFileExtensionFromFilename(filename) {
		return filename.split('.').pop();
	},
	hasFileWithForbiddenExtension: function hasFileWithForbiddenExtension(allowedFileExtensions, files) {
		var _this = this;

		return Array.from(files).some(function (file) {
			var fileExtension = _this.getFileExtensionFromFilename(file.name);
			return !allowedFileExtensions.includes(fileExtension);
		});
	},
	isPrimitiveValue: function isPrimitiveValue(value) {
		if (typeof value === 'string') return true;
		if (typeof value === 'number' && isFinite(value)) return true;
		if (typeof value === 'boolean') return true;
		return false;
	}
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(639),
    baseKeysIn = __webpack_require__(850),
    isArrayLike = __webpack_require__(255);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
    ( false ? 'undefined' : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global['vue-scrollto'] = factory();
})(this, function () {
    'use strict';

    /**
     * https://github.com/gre/bezier-easing
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     */

    // These values are established by empiricism with tests (tradeoff: performance VS precision)

    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;

    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

    var float32ArraySupported = typeof Float32Array === 'function';

    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }

    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }

    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX,
            currentT,
            i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }

    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }

    var index = function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
            throw new Error('bezier x values must be in [0, 1] range');
        }

        // Precompute samples table
        var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) {
            for (var i = 0; i < kSplineTableSize; ++i) {
                sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }
        }

        function getTForX(aX) {
            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;

            for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += kSampleStepSize;
            }
            --currentSample;

            // Interpolate to provide an initial guess for t
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;

            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            } else if (initialSlope === 0.0) {
                return guessForT;
            } else {
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        }

        return function BezierEasing(x) {
            if (mX1 === mY1 && mX2 === mY2) {
                return x; // linear
            }
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) {
                return 0;
            }
            if (x === 1) {
                return 1;
            }
            return calcBezier(getTForX(x), mY1, mY2);
        };
    };

    var easings = {
        ease: [0.25, 0.1, 0.25, 1.0],
        linear: [0.00, 0.0, 1.00, 1.0],
        "ease-in": [0.42, 0.0, 1.00, 1.0],
        "ease-out": [0.00, 0.0, 0.58, 1.0],
        "ease-in-out": [0.42, 0.0, 0.58, 1.0]
    };

    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener("test", null, opts);
    } catch (e) {}

    var _ = {
        $: function $(selector) {
            if (typeof selector !== "string") {
                return selector;
            }
            return document.querySelector(selector);
        },
        on: function on(element, events, handler) {
            var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { passive: false };

            if (!(events instanceof Array)) {
                events = [events];
            }
            for (var i = 0; i < events.length; i++) {
                element.addEventListener(events[i], handler, supportsPassive ? opts : false);
            }
        },
        off: function off(element, events, handler) {
            if (!(events instanceof Array)) {
                events = [events];
            }
            for (var i = 0; i < events.length; i++) {
                element.removeEventListener(events[i], handler);
            }
        },
        cumulativeOffset: function cumulativeOffset(element) {
            var top = 0;
            var left = 0;

            do {
                top += element.offsetTop || 0;
                left += element.offsetLeft || 0;
                element = element.offsetParent;
            } while (element);

            return {
                top: top,
                left: left
            };
        }
    };

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    var abortEvents = ["mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"];

    var defaults$$1 = {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        cancelable: true,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    };

    function setDefaults(options) {
        defaults$$1 = _extends({}, defaults$$1, options);
    }

    var scroller = function scroller() {
        var element = void 0; // element to scroll to
        var container = void 0; // container to scroll
        var duration = void 0; // duration of the scrolling
        var easing = void 0; // easing to be used when scrolling
        var offset = void 0; // offset to be added (subtracted)
        var cancelable = void 0; // indicates if user can cancel the scroll or not.
        var onDone = void 0; // callback when scrolling is done
        var onCancel = void 0; // callback when scrolling is canceled / aborted
        var x = void 0; // scroll on x axis
        var y = void 0; // scroll on y axis

        var initialX = void 0; // initial X of container
        var targetX = void 0; // target X of container
        var initialY = void 0; // initial Y of container
        var targetY = void 0; // target Y of container
        var diffX = void 0; // difference
        var diffY = void 0; // difference

        var abort = void 0; // is scrolling aborted

        var abortEv = void 0; // event that aborted scrolling
        var abortFn = function abortFn(e) {
            if (!cancelable) return;
            abortEv = e;
            abort = true;
        };
        var easingFn = void 0;

        var timeStart = void 0; // time when scrolling started
        var timeElapsed = void 0; // time elapsed since scrolling started

        var progress = void 0; // progress

        function scrollTop(container) {
            var scrollTop = container.scrollTop;

            if (container.tagName.toLowerCase() === "body") {
                // in firefox body.scrollTop always returns 0
                // thus if we are trying to get scrollTop on a body tag
                // we need to get it from the documentElement
                scrollTop = scrollTop || document.documentElement.scrollTop;
            }

            return scrollTop;
        }

        function scrollLeft(container) {
            var scrollLeft = container.scrollLeft;

            if (container.tagName.toLowerCase() === "body") {
                // in firefox body.scrollLeft always returns 0
                // thus if we are trying to get scrollLeft on a body tag
                // we need to get it from the documentElement
                scrollLeft = scrollLeft || document.documentElement.scrollLeft;
            }

            return scrollLeft;
        }

        function step(timestamp) {
            if (abort) return done();
            if (!timeStart) timeStart = timestamp;

            timeElapsed = timestamp - timeStart;

            progress = Math.min(timeElapsed / duration, 1);
            progress = easingFn(progress);

            topLeft(container, initialY + diffY * progress, initialX + diffX * progress);

            timeElapsed < duration ? window.requestAnimationFrame(step) : done();
        }

        function done() {
            if (!abort) topLeft(container, targetY, targetX);
            timeStart = false;

            _.off(container, abortEvents, abortFn);
            if (abort && onCancel) onCancel(abortEv);
            if (!abort && onDone) onDone();
        }

        function topLeft(element, top, left) {
            if (y) element.scrollTop = top;
            if (x) element.scrollLeft = left;
            if (element.tagName.toLowerCase() === "body") {
                // in firefox body.scrollTop doesn't scroll the page
                // thus if we are trying to scrollTop on a body tag
                // we need to scroll on the documentElement
                if (y) document.documentElement.scrollTop = top;
                if (x) document.documentElement.scrollLeft = left;
            }
        }

        function scrollTo(target, _duration) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if ((typeof _duration === "undefined" ? "undefined" : _typeof(_duration)) === "object") {
                options = _duration;
            } else if (typeof _duration === "number") {
                options.duration = _duration;
            }

            element = _.$(target);

            if (!element) {
                return console.warn("[vue-scrollto warn]: Trying to scroll to an element that is not on the page: " + target);
            }

            container = _.$(options.container || defaults$$1.container);
            duration = options.duration || defaults$$1.duration;
            easing = options.easing || defaults$$1.easing;
            offset = options.offset || defaults$$1.offset;
            cancelable = options.hasOwnProperty("cancelable") ? options.cancelable !== false : defaults$$1.cancelable;
            onDone = options.onDone || defaults$$1.onDone;
            onCancel = options.onCancel || defaults$$1.onCancel;
            x = options.x === undefined ? defaults$$1.x : options.x;
            y = options.y === undefined ? defaults$$1.y : options.y;

            var cumulativeOffsetContainer = _.cumulativeOffset(container);
            var cumulativeOffsetElement = _.cumulativeOffset(element);

            if (typeof offset === "function") {
                offset = offset();
            }

            initialY = scrollTop(container);
            targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;

            initialX = scrollLeft(container);
            targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;

            abort = false;

            diffY = targetY - initialY;
            diffX = targetX - initialX;

            if (typeof easing === "string") {
                easing = easings[easing] || easings["ease"];
            }

            easingFn = index.apply(index, easing);

            if (!diffY && !diffX) return;

            _.on(container, abortEvents, abortFn, { passive: true });

            window.requestAnimationFrame(step);

            return function () {
                abortEv = null;
                abort = true;
            };
        }

        return scrollTo;
    };

    var _scroller = scroller();

    var bindings = []; // store binding data

    function deleteBinding(el) {
        for (var i = 0; i < bindings.length; ++i) {
            if (bindings[i].el === el) {
                bindings.splice(i, 1);
                return true;
            }
        }
        return false;
    }

    function findBinding(el) {
        for (var i = 0; i < bindings.length; ++i) {
            if (bindings[i].el === el) {
                return bindings[i];
            }
        }
    }

    function getBinding(el) {
        var binding = findBinding(el);

        if (binding) {
            return binding;
        }

        bindings.push(binding = {
            el: el,
            binding: {}
        });

        return binding;
    }

    function handleClick(e) {
        e.preventDefault();
        var ctx = getBinding(this).binding;

        if (typeof ctx.value === "string") {
            return _scroller(ctx.value);
        }
        _scroller(ctx.value.el || ctx.value.element, ctx.value);
    }

    var VueScrollTo$1 = {
        bind: function bind(el, binding) {
            getBinding(el).binding = binding;
            _.on(el, "click", handleClick);
        },
        unbind: function unbind(el) {
            deleteBinding(el);
            _.off(el, "click", handleClick);
        },
        update: function update(el, binding) {
            getBinding(el).binding = binding;
        },

        scrollTo: _scroller,
        bindings: bindings
    };

    var install = function install(Vue, options) {
        if (options) setDefaults(options);
        Vue.directive("scroll-to", VueScrollTo$1);
        Vue.prototype.$scrollTo = VueScrollTo$1.scrollTo;
    };

    if (typeof window !== "undefined" && window.Vue) {
        window.VueScrollTo = VueScrollTo$1;
        window.VueScrollTo.setDefaults = setDefaults;
        Vue.use(install);
    }

    VueScrollTo$1.install = install;

    return VueScrollTo$1;
});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _popup = __webpack_require__(667);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(914);
var stop = function stop(e) {
  return e.stopPropagation();
};

/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */
exports.default = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },

  data: function data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },

    showPopper: function showPopper(val) {
      if (this.disabled) return;
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },

  methods: {
    createPopper: function createPopper() {
      var _this = this;

      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      var options = this.popperOptions;
      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(function (_) {
        _this.$emit('created', _this);
        _this.resetTransformOrigin();
        _this.$nextTick(_this.updatePopper);
      });
      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }
      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },
    updatePopper: function updatePopper() {
      var popperJS = this.popperJS;
      if (popperJS) {
        popperJS.update();
        if (popperJS._popper) {
          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
        }
      } else {
        this.createPopper();
      }
    },
    doDestroy: function doDestroy(forceDestroy) {
      /* istanbul ignore if */
      if (!this.popperJS || this.showPopper && !forceDestroy) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },
    destroyPopper: function destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },
    resetTransformOrigin: function resetTransformOrigin() {
      if (!this.transformOrigin) return;
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
    },
    appendArrow: function appendArrow(element) {
      var hash = void 0;
      if (this.appended) {
        return;
      }

      this.appended = true;

      for (var item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      var arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }
      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.doDestroy(true);
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },

  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(574);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(266);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(678);
var enumBugKeys = __webpack_require__(585);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 269 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 270 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _iterator = __webpack_require__(939);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(948);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(103).f;
var has = __webpack_require__(137);
var TAG = __webpack_require__(54)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LANGUAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_CAMPAIGN; });
var LANGUAGES = {
	HU: 'hu',
	EN: 'en'
};

var ACTIVE_CAMPAIGN = {
	COMPANY_NAME: '2',
	GDPR: '7',
	GDPR_TRUE_VALUE: 'true',
	GDPR_FALSE_VALUE: 'false',
	CONTACT_JOBTITLE: '8',
	SOURCE_CAMPAIGN: '29',
	NEWSLETTER: '30',
	NEWSLETTER_TRUE_VALUE: 'Igen',
	NEWSLETTER_FALSE_VALUE: 'Nem'
};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapState; });
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function applyMixin(Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if (options === void 0) options = {};

      options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function' ? options.store() : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook = typeof window !== 'undefined' && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!devtoolHook) {
    return;
  }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error("[vuex] " + msg);
  }
}

var Module = function Module(rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced;
};

Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};

Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties(Module.prototype, prototypeAccessors$1);

var ModuleCollection = function ModuleCollection(rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function (module, key) {
    return module.getChild(key);
  }, this.root);
};

ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '');
  }, '');
};

ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1 = this;
  if (runtime === void 0) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) {
    return;
  }

  parent.removeChild(key);
};

function update(path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
        }
        return;
      }
      update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var functionAssert = {
  assert: function assert(value) {
    return typeof value === 'function';
  },
  expected: 'function'
};

var objectAssert = {
  assert: function assert(value) {
    return typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.handler === 'function';
  },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule(path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) {
      return;
    }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
    });
  });
}

function makeAssertionMessage(path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + path.join('.') + "\"";
  }
  buf += " is " + JSON.stringify(value) + ".";
  return buf;
}

var Vue; // bind on install

var Store = function Store(options) {
  var this$1 = this;
  if (options === void 0) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins;if (plugins === void 0) plugins = [];
  var strict = options.strict;if (strict === void 0) strict = false;

  var state = options.state;if (state === void 0) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload);
  };
  this.commit = function boundCommit(type, payload, options) {
    return commit.call(store, type, payload, options);
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) {
    return plugin(this$1);
  });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state;
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
  var type = ref.type;
  var payload = ref.payload;
  var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown mutation type: " + type);
    }
    return;
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) {
    return sub(mutation, this$1.state);
  });

  if (false) {
    console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
  }
};

Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
  var type = ref.type;
  var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown action type: " + type);
    }
    return;
  }

  this._actionSubscribers.forEach(function (sub) {
    return sub(action, this$1.state);
  });

  return entry.length > 1 ? Promise.all(entry.map(function (handler) {
    return handler(payload);
  })) : entry[0](payload);
};

Store.prototype.subscribe = function subscribe(fn) {
  return genericSubscribe(fn, this._subscribers);
};

Store.prototype.subscribeAction = function subscribeAction(fn) {
  return genericSubscribe(fn, this._actionSubscribers);
};

Store.prototype.watch = function watch(getter, cb, options) {
  var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () {
    return getter(this$1.state, this$1.getters);
  }, cb, options);
};

Store.prototype.replaceState = function replaceState(state) {
  var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1 = this;

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties(Store.prototype, prototypeAccessors);

function genericSubscribe(fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}

function resetStore(store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM(store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () {
      return fn(store);
    };
    Object.defineProperty(store.getters, key, {
      get: function get() {
        return store._vm[key];
      },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () {
      return oldVm.$destroy();
    });
  }
}

function installModule(store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext(store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
          return;
        }
      }

      return store.dispatch(type, payload);
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
          return;
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function () {
        return store.getters;
      } : function () {
        return makeLocalGetters(store, namespace);
      }
    },
    state: {
      get: function get() {
        return getNestedState(store.state, path);
      }
    }
  });

  return local;
}

function makeLocalGetters(store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) {
      return;
    }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function get() {
        return store.getters[type];
      },
      enumerable: true
    });
  });

  return gettersProxy;
}

function registerMutation(store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction(store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler(payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err;
      });
    } else {
      return res;
    }
  });
}

function registerGetter(store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error("[vuex] duplicate getter key: " + type);
    }
    return;
  }
  store._wrappedGetters[type] = function wrappedGetter(store) {
    return rawGetter(local.state, // local state
    local.getters, // local getters
    store.state, // root state
    store.getters // root getters
    );
  };
}

function enableStrictMode(store) {
  store._vm.$watch(function () {
    return this._data.$$state;
  }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState(state, path) {
  return path.length ? path.reduce(function (state, key) {
    return state[key];
  }, state) : state;
}

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', "Expects string as the type, but found " + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + ".");
  }

  return { type: type, payload: payload, options: options };
}

function install(_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    }
    return;
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return;
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function' ? val.call(this, state, getters) : state[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return;
        }
        commit = module.context.commit;
      }
      return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return;
      }
      if (false) {
        console.error("[vuex] unknown getter: " + val);
        return;
      }
      return this.$store.getters[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return;
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

var createNamespacedHelpers = function createNamespacedHelpers(namespace) {
  return {
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  };
};

function normalizeMap(map) {
  return Array.isArray(map) ? map.map(function (key) {
    return { key: key, val: key };
  }) : Object.keys(map).map(function (key) {
    return { key: key, val: map[key] };
  });
}

function normalizeNamespace(fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map);
  };
}

function getModuleByNamespace(store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
  }
  return module;
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(293);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(80);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(151),
    isObject = __webpack_require__(87);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(788),
    mapCacheDelete = __webpack_require__(795),
    mapCacheGet = __webpack_require__(797),
    mapCacheHas = __webpack_require__(798),
    mapCacheSet = __webpack_require__(799);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(297),
    setCacheAdd = __webpack_require__(801),
    setCacheHas = __webpack_require__(802);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(807),
    stubArray = __webpack_require__(638);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(810),
    baseUnary = __webpack_require__(254),
    nodeUtil = __webpack_require__(305);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 304 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(630);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 306 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = __webpack_require__(63),
    isSymbol = __webpack_require__(308);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(151),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(309),
    overRest = __webpack_require__(830),
    setToString = __webpack_require__(832);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(255),
    isObjectLike = __webpack_require__(86);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var fromStream = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stream) {
		var readableWebToNodeStream, fileType;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						readableWebToNodeStream = new ReadableWebToNodeStream(stream);
						_context.next = 3;
						return core.fromStream(readableWebToNodeStream);

					case 3:
						fileType = _context.sent;
						_context.next = 6;
						return readableWebToNodeStream.close();

					case 6:
						return _context.abrupt('return', fileType);

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function fromStream(_x) {
		return _ref.apply(this, arguments);
	};
}();

var fromBlob = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(blob) {
		var buffer;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return blobToArrayBuffer(blob);

					case 2:
						buffer = _context2.sent;
						return _context2.abrupt('return', core.fromBuffer(Buffer.from(buffer)));

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function fromBlob(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

/**
Convert Blobs to ArrayBuffer.
@param {Blob} blob - Web API Blob.
@returns {Promise<ArrayBuffer>}
*/


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _require = __webpack_require__(315),
    ReadableWebToNodeStream = _require.ReadableWebToNodeStream;

var core = __webpack_require__(326);

function blobToArrayBuffer(blob) {
	if (blob.arrayBuffer) {
		return blob.arrayBuffer();
	}

	// TODO: Remove when stop supporting older environments
	return new Promise(function (resolve, reject) {
		var fileReader = new FileReader();
		fileReader.addEventListener('loadend', function (event) {
			resolve(event.target.result);
		});

		fileReader.addEventListener('error', function (event) {
			reject(new Error(event.message));
		});

		fileReader.addEventListener('abort', function (event) {
			reject(new Error(event.type));
		});

		fileReader.readAsArrayBuffer(blob);
	});
}

Object.assign(module.exports, core, {
	fromStream: fromStream,
	fromBlob: fromBlob
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens(b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;

  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;

  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }

  return parts.join('');
}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadableWebToNodeStream = void 0;
var readable_stream_1 = __webpack_require__(316);
/**
 * Converts a Web-API stream into Node stream.Readable class
 * Node stream readable: https://nodejs.org/api/stream.html#stream_readable_streams
 * Web API readable-stream: https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
 * Node readable stream: https://nodejs.org/api/stream.html#stream_readable_streams
 */

var ReadableWebToNodeStream = function (_readable_stream_1$Re) {
    _inherits(ReadableWebToNodeStream, _readable_stream_1$Re);

    /**
     *
     * @param stream Readable​Stream: https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
     */
    function ReadableWebToNodeStream(stream) {
        _classCallCheck(this, ReadableWebToNodeStream);

        var _this = _possibleConstructorReturn(this, (ReadableWebToNodeStream.__proto__ || Object.getPrototypeOf(ReadableWebToNodeStream)).call(this));

        _this.bytesRead = 0;
        _this.released = false;
        _this.reader = stream.getReader();
        return _this;
    }
    /**
     * Implementation of readable._read(size).
     * When readable._read() is called, if data is available from the resource,
     * the implementation should begin pushing that data into the read queue
     * https://nodejs.org/api/stream.html#stream_readable_read_size_1
     */


    _createClass(ReadableWebToNodeStream, [{
        key: "_read",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var data;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!this.released) {
                                    _context.next = 3;
                                    break;
                                }

                                this.push(null); // Signal EOF
                                return _context.abrupt("return");

                            case 3:
                                this.pendingRead = this.reader.read();
                                _context.next = 6;
                                return this.pendingRead;

                            case 6:
                                data = _context.sent;

                                // clear the promise before pushing pushing new data to the queue and allow sequential calls to _read()
                                delete this.pendingRead;
                                if (data.done || this.released) {
                                    this.push(null); // Signal EOF
                                } else {
                                    this.bytesRead += data.value.length;
                                    this.push(data.value); // Push new data to the queue
                                }

                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _read() {
                return _ref.apply(this, arguments);
            }

            return _read;
        }()
        /**
         * If there is no unresolved read call to Web-API Readable​Stream immediately returns;
         * otherwise will wait until the read is resolved.
         */

    }, {
        key: "waitForReadToComplete",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.pendingRead) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.pendingRead;

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function waitForReadToComplete() {
                return _ref2.apply(this, arguments);
            }

            return waitForReadToComplete;
        }()
        /**
         * Close wrapper
         */

    }, {
        key: "close",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.syncAndRelease();

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function close() {
                return _ref3.apply(this, arguments);
            }

            return close;
        }()
    }, {
        key: "syncAndRelease",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.released = true;
                                _context4.next = 3;
                                return this.waitForReadToComplete();

                            case 3:
                                _context4.next = 5;
                                return this.reader.releaseLock();

                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function syncAndRelease() {
                return _ref4.apply(this, arguments);
            }

            return syncAndRelease;
        }()
    }]);

    return ReadableWebToNodeStream;
}(readable_stream_1.Readable);

exports.ReadableWebToNodeStream = ReadableWebToNodeStream;
//# sourceMappingURL=index.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(164);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(169);
exports.Duplex = __webpack_require__(49);
exports.Transform = __webpack_require__(171);
exports.PassThrough = __webpack_require__(324);
exports.finished = __webpack_require__(109);
exports.pipeline = __webpack_require__(325);

/***/ }),
/* 317 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);Object.defineProperty(Constructor, "prototype", { writable: false });return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");return (typeof key === "undefined" ? "undefined" : _typeof(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if ((typeof input === "undefined" ? "undefined" : _typeof(input)) !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {
    var res = prim.call(input, hint || "default");if ((typeof res === "undefined" ? "undefined" : _typeof(res)) !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");
  }return (hint === "string" ? String : Number)(input);
}
var _require = __webpack_require__(41),
    Buffer = _require.Buffer;
var _require2 = __webpack_require__(319),
    inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) {
        ret += s + p.data;
      }return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),
/* 319 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate(fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config(name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(41);
var Buffer = buffer.Buffer;

// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
  for (var key in src) {
    dst[key] = src[key];
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer;
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports);
  exports.Buffer = SafeBuffer;
}

function SafeBuffer(arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length);
}

SafeBuffer.prototype = Object.create(Buffer.prototype);

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number');
  }
  return Buffer(arg, encodingOrOffset, length);
};

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  var buf = Buffer(size);
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding);
    } else {
      buf.fill(fill);
    }
  } else {
    buf.fill(0);
  }
  return buf;
};

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return Buffer(size);
};

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return buffer.SlowBuffer(size);
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");return (typeof key === "undefined" ? "undefined" : _typeof(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if ((typeof input === "undefined" ? "undefined" : _typeof(input)) !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {
    var res = prim.call(input, hint || "default");if ((typeof res === "undefined" ? "undefined" : _typeof(res)) !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");
  }return (hint === "string" ? String : Number)(input);
}
var finished = __webpack_require__(109);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser');
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(171);
__webpack_require__(64)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = __webpack_require__(48).codes,
    ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(109);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _this = this;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// A fair amount of file-types are detectable within this range

var fromStream = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stream) {
		var tokenizer;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return strtok3.fromStream(stream);

					case 2:
						tokenizer = _context.sent;
						_context.prev = 3;
						_context.next = 6;
						return fromTokenizer(tokenizer);

					case 6:
						return _context.abrupt('return', _context.sent);

					case 7:
						_context.prev = 7;
						_context.next = 10;
						return tokenizer.close();

					case 10:
						return _context.finish(7);

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3,, 7, 11]]);
	}));

	return function fromStream(_x) {
		return _ref.apply(this, arguments);
	};
}();

var fromBuffer = function () {
	var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(input) {
		var buffer, tokenizer;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (input instanceof Uint8Array || input instanceof ArrayBuffer || Buffer.isBuffer(input)) {
							_context2.next = 2;
							break;
						}

						throw new TypeError('Expected the `input` argument to be of type `Uint8Array` or `Buffer` or `ArrayBuffer`, got `' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '`');

					case 2:
						buffer = input instanceof Buffer ? input : Buffer.from(input);

						if (buffer && buffer.length > 1) {
							_context2.next = 5;
							break;
						}

						return _context2.abrupt('return');

					case 5:
						tokenizer = strtok3.fromBuffer(buffer);
						return _context2.abrupt('return', fromTokenizer(tokenizer));

					case 7:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function fromBuffer(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var fromTokenizer = function () {
	var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tokenizer) {
		return regeneratorRuntime.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						return _context3.abrupt('return', _fromTokenizer(tokenizer));

					case 4:
						_context3.prev = 4;
						_context3.t0 = _context3['catch'](0);

						if (_context3.t0 instanceof strtok3.EndOfStreamError) {
							_context3.next = 8;
							break;
						}

						throw _context3.t0;

					case 8:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 4]]);
	}));

	return function fromTokenizer(_x3) {
		return _ref5.apply(this, arguments);
	};
}();

var _fromTokenizer = function () {
	var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(tokenizer) {
		var buffer, bytesRead, check, checkString, id3HeaderLen, zipHeader, type, mimeType, nextHeaderIndex, _type, brandMajor, maxBufferSize, _buffer, readField, readElement, readChildren, re, docType, str, readChunkHeader, chunk, readHeader, header, payload, typeId, _type2, jsonSize, _header, json;

		return regeneratorRuntime.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						buffer = Buffer.alloc(minimumBytes);
						bytesRead = 12;

						check = function check(header, options) {
							return _check(buffer, header, options);
						};

						checkString = function checkString(header, options) {
							return check(stringToBytes(header), options);
						};

						// Keep reading until EOF if the file size is unknown.


						if (!tokenizer.fileInfo.size) {
							tokenizer.fileInfo.size = Number.MAX_SAFE_INTEGER;
						}

						_context9.next = 7;
						return tokenizer.peekBuffer(buffer, { length: bytesRead, mayBeLess: true });

					case 7:
						if (!check([0x42, 0x4D])) {
							_context9.next = 9;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'bmp',
							mime: 'image/bmp'
						});

					case 9:
						if (!check([0x0B, 0x77])) {
							_context9.next = 11;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ac3',
							mime: 'audio/vnd.dolby.dd-raw'
						});

					case 11:
						if (!check([0x78, 0x01])) {
							_context9.next = 13;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'dmg',
							mime: 'application/x-apple-diskimage'
						});

					case 13:
						if (!check([0x4D, 0x5A])) {
							_context9.next = 15;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'exe',
							mime: 'application/x-msdownload'
						});

					case 15:
						if (!check([0x25, 0x21])) {
							_context9.next = 21;
							break;
						}

						_context9.next = 18;
						return tokenizer.peekBuffer(buffer, { length: 24, mayBeLess: true });

					case 18:
						if (!(checkString('PS-Adobe-', { offset: 2 }) && checkString(' EPSF-', { offset: 14 }))) {
							_context9.next = 20;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'eps',
							mime: 'application/eps'
						});

					case 20:
						return _context9.abrupt('return', {
							ext: 'ps',
							mime: 'application/postscript'
						});

					case 21:
						if (!(check([0x1F, 0xA0]) || check([0x1F, 0x9D]))) {
							_context9.next = 23;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'Z',
							mime: 'application/x-compress'
						});

					case 23:
						if (!check([0xFF, 0xD8, 0xFF])) {
							_context9.next = 25;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'jpg',
							mime: 'image/jpeg'
						});

					case 25:
						if (!check([0x49, 0x49, 0xBC])) {
							_context9.next = 27;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'jxr',
							mime: 'image/vnd.ms-photo'
						});

					case 27:
						if (!check([0x1F, 0x8B, 0x8])) {
							_context9.next = 29;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'gz',
							mime: 'application/gzip'
						});

					case 29:
						if (!check([0x42, 0x5A, 0x68])) {
							_context9.next = 31;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'bz2',
							mime: 'application/x-bzip2'
						});

					case 31:
						if (!checkString('ID3')) {
							_context9.next = 42;
							break;
						}

						_context9.next = 34;
						return tokenizer.ignore(6);

					case 34:
						_context9.next = 36;
						return tokenizer.readToken(uint32SyncSafeToken);

					case 36:
						id3HeaderLen = _context9.sent;

						if (!(tokenizer.position + id3HeaderLen > tokenizer.fileInfo.size)) {
							_context9.next = 39;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mp3',
							mime: 'audio/mpeg'
						});

					case 39:
						_context9.next = 41;
						return tokenizer.ignore(id3HeaderLen);

					case 41:
						return _context9.abrupt('return', fromTokenizer(tokenizer));

					case 42:
						if (!checkString('MP+')) {
							_context9.next = 44;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mpc',
							mime: 'audio/x-musepack'
						});

					case 44:
						if (!((buffer[0] === 0x43 || buffer[0] === 0x46) && check([0x57, 0x53], { offset: 1 }))) {
							_context9.next = 46;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'swf',
							mime: 'application/x-shockwave-flash'
						});

					case 46:
						if (!check([0x47, 0x49, 0x46])) {
							_context9.next = 48;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'gif',
							mime: 'image/gif'
						});

					case 48:
						if (!checkString('FLIF')) {
							_context9.next = 50;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'flif',
							mime: 'image/flif'
						});

					case 50:
						if (!checkString('8BPS')) {
							_context9.next = 52;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'psd',
							mime: 'image/vnd.adobe.photoshop'
						});

					case 52:
						if (!checkString('WEBP', { offset: 8 })) {
							_context9.next = 54;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'webp',
							mime: 'image/webp'
						});

					case 54:
						if (!checkString('MPCK')) {
							_context9.next = 56;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mpc',
							mime: 'audio/x-musepack'
						});

					case 56:
						if (!checkString('FORM')) {
							_context9.next = 58;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'aif',
							mime: 'audio/aiff'
						});

					case 58:
						if (!checkString('icns', { offset: 0 })) {
							_context9.next = 60;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'icns',
							mime: 'image/icns'
						});

					case 60:
						if (!check([0x50, 0x4B, 0x3, 0x4])) {
							_context9.next = 121;
							break;
						}

						_context9.prev = 61;

					case 62:
						if (!(tokenizer.position + 30 < tokenizer.fileInfo.size)) {
							_context9.next = 114;
							break;
						}

						_context9.next = 65;
						return tokenizer.readBuffer(buffer, { length: 30 });

					case 65:

						// https://en.wikipedia.org/wiki/Zip_(file_format)#File_headers
						zipHeader = {
							compressedSize: buffer.readUInt32LE(18),
							uncompressedSize: buffer.readUInt32LE(22),
							filenameLength: buffer.readUInt16LE(26),
							extraFieldLength: buffer.readUInt16LE(28)
						};
						_context9.next = 68;
						return tokenizer.readToken(new Token.StringType(zipHeader.filenameLength, 'utf-8'));

					case 68:
						zipHeader.filename = _context9.sent;
						_context9.next = 71;
						return tokenizer.ignore(zipHeader.extraFieldLength);

					case 71:
						if (!(zipHeader.filename === 'META-INF/mozilla.rsa')) {
							_context9.next = 73;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xpi',
							mime: 'application/x-xpinstall'
						});

					case 73:
						if (!(zipHeader.filename.endsWith('.rels') || zipHeader.filename.endsWith('.xml'))) {
							_context9.next = 83;
							break;
						}

						type = zipHeader.filename.split('/')[0];
						_context9.t0 = type;
						_context9.next = _context9.t0 === '_rels' ? 78 : _context9.t0 === 'word' ? 79 : _context9.t0 === 'ppt' ? 80 : _context9.t0 === 'xl' ? 81 : 82;
						break;

					case 78:
						return _context9.abrupt('break', 83);

					case 79:
						return _context9.abrupt('return', {
							ext: 'docx',
							mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
						});

					case 80:
						return _context9.abrupt('return', {
							ext: 'pptx',
							mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
						});

					case 81:
						return _context9.abrupt('return', {
							ext: 'xlsx',
							mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						});

					case 82:
						return _context9.abrupt('break', 83);

					case 83:
						if (!zipHeader.filename.startsWith('xl/')) {
							_context9.next = 85;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xlsx',
							mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						});

					case 85:
						if (!(zipHeader.filename.startsWith('3D/') && zipHeader.filename.endsWith('.model'))) {
							_context9.next = 87;
							break;
						}

						return _context9.abrupt('return', {
							ext: '3mf',
							mime: 'model/3mf'
						});

					case 87:
						if (!(zipHeader.filename === 'mimetype' && zipHeader.compressedSize === zipHeader.uncompressedSize)) {
							_context9.next = 98;
							break;
						}

						_context9.next = 90;
						return tokenizer.readToken(new Token.StringType(zipHeader.compressedSize, 'utf-8'));

					case 90:
						mimeType = _context9.sent;
						_context9.t1 = mimeType;
						_context9.next = _context9.t1 === 'application/epub+zip' ? 94 : _context9.t1 === 'application/vnd.oasis.opendocument.text' ? 95 : _context9.t1 === 'application/vnd.oasis.opendocument.spreadsheet' ? 96 : _context9.t1 === 'application/vnd.oasis.opendocument.presentation' ? 97 : 98;
						break;

					case 94:
						return _context9.abrupt('return', {
							ext: 'epub',
							mime: 'application/epub+zip'
						});

					case 95:
						return _context9.abrupt('return', {
							ext: 'odt',
							mime: 'application/vnd.oasis.opendocument.text'
						});

					case 96:
						return _context9.abrupt('return', {
							ext: 'ods',
							mime: 'application/vnd.oasis.opendocument.spreadsheet'
						});

					case 97:
						return _context9.abrupt('return', {
							ext: 'odp',
							mime: 'application/vnd.oasis.opendocument.presentation'
						});

					case 98:
						if (!(zipHeader.compressedSize === 0)) {
							_context9.next = 110;
							break;
						}

						nextHeaderIndex = -1;

					case 100:
						if (!(nextHeaderIndex < 0 && tokenizer.position < tokenizer.fileInfo.size)) {
							_context9.next = 108;
							break;
						}

						_context9.next = 103;
						return tokenizer.peekBuffer(buffer, { mayBeLess: true });

					case 103:

						nextHeaderIndex = buffer.indexOf('504B0304', 0, 'hex');
						// Move position to the next header if found, skip the whole buffer otherwise
						_context9.next = 106;
						return tokenizer.ignore(nextHeaderIndex >= 0 ? nextHeaderIndex : buffer.length);

					case 106:
						_context9.next = 100;
						break;

					case 108:
						_context9.next = 112;
						break;

					case 110:
						_context9.next = 112;
						return tokenizer.ignore(zipHeader.compressedSize);

					case 112:
						_context9.next = 62;
						break;

					case 114:
						_context9.next = 120;
						break;

					case 116:
						_context9.prev = 116;
						_context9.t2 = _context9['catch'](61);

						if (_context9.t2 instanceof strtok3.EndOfStreamError) {
							_context9.next = 120;
							break;
						}

						throw _context9.t2;

					case 120:
						return _context9.abrupt('return', {
							ext: 'zip',
							mime: 'application/zip'
						});

					case 121:
						if (!checkString('OggS')) {
							_context9.next = 140;
							break;
						}

						_context9.next = 124;
						return tokenizer.ignore(28);

					case 124:
						_type = Buffer.alloc(8);
						_context9.next = 127;
						return tokenizer.readBuffer(_type);

					case 127:
						if (!_check(_type, [0x4F, 0x70, 0x75, 0x73, 0x48, 0x65, 0x61, 0x64])) {
							_context9.next = 129;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'opus',
							mime: 'audio/opus'
						});

					case 129:
						if (!_check(_type, [0x80, 0x74, 0x68, 0x65, 0x6F, 0x72, 0x61])) {
							_context9.next = 131;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ogv',
							mime: 'video/ogg'
						});

					case 131:
						if (!_check(_type, [0x01, 0x76, 0x69, 0x64, 0x65, 0x6F, 0x00])) {
							_context9.next = 133;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ogm',
							mime: 'video/ogg'
						});

					case 133:
						if (!_check(_type, [0x7F, 0x46, 0x4C, 0x41, 0x43])) {
							_context9.next = 135;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'oga',
							mime: 'audio/ogg'
						});

					case 135:
						if (!_check(_type, [0x53, 0x70, 0x65, 0x65, 0x78, 0x20, 0x20])) {
							_context9.next = 137;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'spx',
							mime: 'audio/ogg'
						});

					case 137:
						if (!_check(_type, [0x01, 0x76, 0x6F, 0x72, 0x62, 0x69, 0x73])) {
							_context9.next = 139;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ogg',
							mime: 'audio/ogg'
						});

					case 139:
						return _context9.abrupt('return', {
							ext: 'ogx',
							mime: 'application/ogg'
						});

					case 140:
						if (!(check([0x50, 0x4B]) && (buffer[2] === 0x3 || buffer[2] === 0x5 || buffer[2] === 0x7) && (buffer[3] === 0x4 || buffer[3] === 0x6 || buffer[3] === 0x8))) {
							_context9.next = 142;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'zip',
							mime: 'application/zip'
						});

					case 142:
						if (!(checkString('ftyp', { offset: 4 }) && (buffer[8] & 0x60) !== 0x00 // Brand major, first character ASCII?
						)) {
							_context9.next = 167;
							break;
						}

						// They all can have MIME `video/mp4` except `application/mp4` special-case which is hard to detect.
						// For some cases, we're specific, everything else falls to `video/mp4` with `mp4` extension.
						brandMajor = buffer.toString('binary', 8, 12).replace('\0', ' ').trim();
						_context9.t3 = brandMajor;
						_context9.next = _context9.t3 === 'avif' ? 147 : _context9.t3 === 'mif1' ? 148 : _context9.t3 === 'msf1' ? 149 : _context9.t3 === 'heic' ? 150 : _context9.t3 === 'heix' ? 150 : _context9.t3 === 'hevc' ? 151 : _context9.t3 === 'hevx' ? 151 : _context9.t3 === 'qt' ? 152 : _context9.t3 === 'M4V' ? 153 : _context9.t3 === 'M4VH' ? 153 : _context9.t3 === 'M4VP' ? 153 : _context9.t3 === 'M4P' ? 154 : _context9.t3 === 'M4B' ? 155 : _context9.t3 === 'M4A' ? 156 : _context9.t3 === 'F4V' ? 157 : _context9.t3 === 'F4P' ? 158 : _context9.t3 === 'F4A' ? 159 : _context9.t3 === 'F4B' ? 160 : _context9.t3 === 'crx' ? 161 : 162;
						break;

					case 147:
						return _context9.abrupt('return', { ext: 'avif', mime: 'image/avif' });

					case 148:
						return _context9.abrupt('return', { ext: 'heic', mime: 'image/heif' });

					case 149:
						return _context9.abrupt('return', { ext: 'heic', mime: 'image/heif-sequence' });

					case 150:
						return _context9.abrupt('return', { ext: 'heic', mime: 'image/heic' });

					case 151:
						return _context9.abrupt('return', { ext: 'heic', mime: 'image/heic-sequence' });

					case 152:
						return _context9.abrupt('return', { ext: 'mov', mime: 'video/quicktime' });

					case 153:
						return _context9.abrupt('return', { ext: 'm4v', mime: 'video/x-m4v' });

					case 154:
						return _context9.abrupt('return', { ext: 'm4p', mime: 'video/mp4' });

					case 155:
						return _context9.abrupt('return', { ext: 'm4b', mime: 'audio/mp4' });

					case 156:
						return _context9.abrupt('return', { ext: 'm4a', mime: 'audio/x-m4a' });

					case 157:
						return _context9.abrupt('return', { ext: 'f4v', mime: 'video/mp4' });

					case 158:
						return _context9.abrupt('return', { ext: 'f4p', mime: 'video/mp4' });

					case 159:
						return _context9.abrupt('return', { ext: 'f4a', mime: 'audio/mp4' });

					case 160:
						return _context9.abrupt('return', { ext: 'f4b', mime: 'audio/mp4' });

					case 161:
						return _context9.abrupt('return', { ext: 'cr3', mime: 'image/x-canon-cr3' });

					case 162:
						if (!brandMajor.startsWith('3g')) {
							_context9.next = 166;
							break;
						}

						if (!brandMajor.startsWith('3g2')) {
							_context9.next = 165;
							break;
						}

						return _context9.abrupt('return', { ext: '3g2', mime: 'video/3gpp2' });

					case 165:
						return _context9.abrupt('return', { ext: '3gp', mime: 'video/3gpp' });

					case 166:
						return _context9.abrupt('return', { ext: 'mp4', mime: 'video/mp4' });

					case 167:
						if (!checkString('MThd')) {
							_context9.next = 169;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mid',
							mime: 'audio/midi'
						});

					case 169:
						if (!(checkString('wOFF') && (check([0x00, 0x01, 0x00, 0x00], { offset: 4 }) || checkString('OTTO', { offset: 4 })))) {
							_context9.next = 171;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'woff',
							mime: 'font/woff'
						});

					case 171:
						if (!(checkString('wOF2') && (check([0x00, 0x01, 0x00, 0x00], { offset: 4 }) || checkString('OTTO', { offset: 4 })))) {
							_context9.next = 173;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'woff2',
							mime: 'font/woff2'
						});

					case 173:
						if (!(check([0xD4, 0xC3, 0xB2, 0xA1]) || check([0xA1, 0xB2, 0xC3, 0xD4]))) {
							_context9.next = 175;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'pcap',
							mime: 'application/vnd.tcpdump.pcap'
						});

					case 175:
						if (!checkString('DSD ')) {
							_context9.next = 177;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'dsf',
							mime: 'audio/x-dsf' // Non-standard
						});

					case 177:
						if (!checkString('LZIP')) {
							_context9.next = 179;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'lz',
							mime: 'application/x-lzip'
						});

					case 179:
						if (!checkString('fLaC')) {
							_context9.next = 181;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'flac',
							mime: 'audio/x-flac'
						});

					case 181:
						if (!check([0x42, 0x50, 0x47, 0xFB])) {
							_context9.next = 183;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'bpg',
							mime: 'image/bpg'
						});

					case 183:
						if (!checkString('wvpk')) {
							_context9.next = 185;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'wv',
							mime: 'audio/wavpack'
						});

					case 185:
						if (!checkString('%PDF')) {
							_context9.next = 195;
							break;
						}

						_context9.next = 188;
						return tokenizer.ignore(1350);

					case 188:
						maxBufferSize = 10 * 1024 * 1024;
						_buffer = Buffer.alloc(Math.min(maxBufferSize, tokenizer.fileInfo.size));
						_context9.next = 192;
						return tokenizer.readBuffer(_buffer, { mayBeLess: true });

					case 192:
						if (!_buffer.includes(Buffer.from('AIPrivateData'))) {
							_context9.next = 194;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ai',
							mime: 'application/postscript'
						});

					case 194:
						return _context9.abrupt('return', {
							ext: 'pdf',
							mime: 'application/pdf'
						});

					case 195:
						if (!check([0x00, 0x61, 0x73, 0x6D])) {
							_context9.next = 197;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'wasm',
							mime: 'application/wasm'
						});

					case 197:
						if (!check([0x49, 0x49, 0x2A, 0x0])) {
							_context9.next = 210;
							break;
						}

						if (!checkString('CR', { offset: 8 })) {
							_context9.next = 200;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'cr2',
							mime: 'image/x-canon-cr2'
						});

					case 200:
						if (!(check([0x1C, 0x00, 0xFE, 0x00], { offset: 8 }) || check([0x1F, 0x00, 0x0B, 0x00], { offset: 8 }))) {
							_context9.next = 202;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'nef',
							mime: 'image/x-nikon-nef'
						});

					case 202:
						if (!(check([0x08, 0x00, 0x00, 0x00], { offset: 4 }) && (check([0x2D, 0x00, 0xFE, 0x00], { offset: 8 }) || check([0x27, 0x00, 0xFE, 0x00], { offset: 8 })))) {
							_context9.next = 204;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'dng',
							mime: 'image/x-adobe-dng'
						});

					case 204:

						buffer = Buffer.alloc(24);
						_context9.next = 207;
						return tokenizer.peekBuffer(buffer);

					case 207:
						if (!((check([0x10, 0xFB, 0x86, 0x01], { offset: 4 }) || check([0x08, 0x00, 0x00, 0x00], { offset: 4 })) &&
						// This pattern differentiates ARW from other TIFF-ish file types:
						check([0x00, 0xFE, 0x00, 0x04, 0x00, 0x01, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x03, 0x01], { offset: 9 }))) {
							_context9.next = 209;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'arw',
							mime: 'image/x-sony-arw'
						});

					case 209:
						return _context9.abrupt('return', {
							ext: 'tif',
							mime: 'image/tiff'
						});

					case 210:
						if (!check([0x4D, 0x4D, 0x0, 0x2A])) {
							_context9.next = 212;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'tif',
							mime: 'image/tiff'
						});

					case 212:
						if (!checkString('MAC ')) {
							_context9.next = 214;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ape',
							mime: 'audio/ape'
						});

					case 214:
						if (!check([0x1A, 0x45, 0xDF, 0xA3])) {
							_context9.next = 230;
							break;
						}

						// Root element: EBML
						readField = function () {
							var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
								var msb, mask, ic, id;
								return regeneratorRuntime.wrap(function _callee4$(_context4) {
									while (1) {
										switch (_context4.prev = _context4.next) {
											case 0:
												_context4.next = 2;
												return tokenizer.peekNumber(Token.UINT8);

											case 2:
												msb = _context4.sent;
												mask = 0x80;
												ic = 0; // 0 = A, 1 = B, 2 = C, 3 = D

												while ((msb & mask) === 0) {
													++ic;
													mask >>= 1;
												}

												id = Buffer.alloc(ic + 1);
												_context4.next = 9;
												return tokenizer.readBuffer(id);

											case 9:
												return _context4.abrupt('return', id);

											case 10:
											case 'end':
												return _context4.stop();
										}
									}
								}, _callee4, this);
							}));

							return function readField() {
								return _ref7.apply(this, arguments);
							};
						}();

						readElement = function () {
							var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
								var id, lenField, nrLen;
								return regeneratorRuntime.wrap(function _callee5$(_context5) {
									while (1) {
										switch (_context5.prev = _context5.next) {
											case 0:
												_context5.next = 2;
												return readField();

											case 2:
												id = _context5.sent;
												_context5.next = 5;
												return readField();

											case 5:
												lenField = _context5.sent;

												lenField[0] ^= 0x80 >> lenField.length - 1;
												nrLen = Math.min(6, lenField.length); // JavaScript can max read 6 bytes integer

												return _context5.abrupt('return', {
													id: id.readUIntBE(0, id.length),
													len: lenField.readUIntBE(lenField.length - nrLen, nrLen)
												});

											case 9:
											case 'end':
												return _context5.stop();
										}
									}
								}, _callee5, this);
							}));

							return function readElement() {
								return _ref8.apply(this, arguments);
							};
						}();

						readChildren = function () {
							var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(level, children) {
								var e;
								return regeneratorRuntime.wrap(function _callee6$(_context6) {
									while (1) {
										switch (_context6.prev = _context6.next) {
											case 0:
												if (!(children > 0)) {
													_context6.next = 11;
													break;
												}

												_context6.next = 3;
												return readElement();

											case 3:
												e = _context6.sent;

												if (!(e.id === 0x4282)) {
													_context6.next = 6;
													break;
												}

												return _context6.abrupt('return', tokenizer.readToken(new Token.StringType(e.len, 'utf-8')));

											case 6:
												_context6.next = 8;
												return tokenizer.ignore(e.len);

											case 8:
												// ignore payload
												--children;
												_context6.next = 0;
												break;

											case 11:
											case 'end':
												return _context6.stop();
										}
									}
								}, _callee6, this);
							}));

							return function readChildren(_x5, _x6) {
								return _ref9.apply(this, arguments);
							};
						}();

						_context9.next = 220;
						return readElement();

					case 220:
						re = _context9.sent;
						_context9.next = 223;
						return readChildren(1, re.len);

					case 223:
						docType = _context9.sent;
						_context9.t4 = docType;
						_context9.next = _context9.t4 === 'webm' ? 227 : _context9.t4 === 'matroska' ? 228 : 229;
						break;

					case 227:
						return _context9.abrupt('return', {
							ext: 'webm',
							mime: 'video/webm'
						});

					case 228:
						return _context9.abrupt('return', {
							ext: 'mkv',
							mime: 'video/x-matroska'
						});

					case 229:
						return _context9.abrupt('return');

					case 230:
						if (!check([0x52, 0x49, 0x46, 0x46])) {
							_context9.next = 237;
							break;
						}

						if (!check([0x41, 0x56, 0x49], { offset: 8 })) {
							_context9.next = 233;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'avi',
							mime: 'video/vnd.avi'
						});

					case 233:
						if (!check([0x57, 0x41, 0x56, 0x45], { offset: 8 })) {
							_context9.next = 235;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'wav',
							mime: 'audio/vnd.wave'
						});

					case 235:
						if (!check([0x51, 0x4C, 0x43, 0x4D], { offset: 8 })) {
							_context9.next = 237;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'qcp',
							mime: 'audio/qcelp'
						});

					case 237:
						if (!checkString('SQLi')) {
							_context9.next = 239;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'sqlite',
							mime: 'application/x-sqlite3'
						});

					case 239:
						if (!check([0x4E, 0x45, 0x53, 0x1A])) {
							_context9.next = 241;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'nes',
							mime: 'application/x-nintendo-nes-rom'
						});

					case 241:
						if (!checkString('Cr24')) {
							_context9.next = 243;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'crx',
							mime: 'application/x-google-chrome-extension'
						});

					case 243:
						if (!(checkString('MSCF') || checkString('ISc('))) {
							_context9.next = 245;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'cab',
							mime: 'application/vnd.ms-cab-compressed'
						});

					case 245:
						if (!check([0xED, 0xAB, 0xEE, 0xDB])) {
							_context9.next = 247;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'rpm',
							mime: 'application/x-rpm'
						});

					case 247:
						if (!check([0xC5, 0xD0, 0xD3, 0xC6])) {
							_context9.next = 249;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'eps',
							mime: 'application/eps'
						});

					case 249:
						if (!check([0x28, 0xB5, 0x2F, 0xFD])) {
							_context9.next = 251;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'zst',
							mime: 'application/zstd'
						});

					case 251:
						if (!check([0x4F, 0x54, 0x54, 0x4F, 0x00])) {
							_context9.next = 253;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'otf',
							mime: 'font/otf'
						});

					case 253:
						if (!checkString('#!AMR')) {
							_context9.next = 255;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'amr',
							mime: 'audio/amr'
						});

					case 255:
						if (!checkString('{\\rtf')) {
							_context9.next = 257;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'rtf',
							mime: 'application/rtf'
						});

					case 257:
						if (!check([0x46, 0x4C, 0x56, 0x01])) {
							_context9.next = 259;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'flv',
							mime: 'video/x-flv'
						});

					case 259:
						if (!checkString('IMPM')) {
							_context9.next = 261;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'it',
							mime: 'audio/x-it'
						});

					case 261:
						if (!(checkString('-lh0-', { offset: 2 }) || checkString('-lh1-', { offset: 2 }) || checkString('-lh2-', { offset: 2 }) || checkString('-lh3-', { offset: 2 }) || checkString('-lh4-', { offset: 2 }) || checkString('-lh5-', { offset: 2 }) || checkString('-lh6-', { offset: 2 }) || checkString('-lh7-', { offset: 2 }) || checkString('-lzs-', { offset: 2 }) || checkString('-lz4-', { offset: 2 }) || checkString('-lz5-', { offset: 2 }) || checkString('-lhd-', { offset: 2 }))) {
							_context9.next = 263;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'lzh',
							mime: 'application/x-lzh-compressed'
						});

					case 263:
						if (!check([0x00, 0x00, 0x01, 0xBA])) {
							_context9.next = 268;
							break;
						}

						if (!check([0x21], { offset: 4, mask: [0xF1] })) {
							_context9.next = 266;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mpg', // May also be .ps, .mpeg
							mime: 'video/MP1S'
						});

					case 266:
						if (!check([0x44], { offset: 4, mask: [0xC4] })) {
							_context9.next = 268;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mpg', // May also be .mpg, .m2p, .vob or .sub
							mime: 'video/MP2P'
						});

					case 268:
						if (!checkString('ITSF')) {
							_context9.next = 270;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'chm',
							mime: 'application/vnd.ms-htmlhelp'
						});

					case 270:
						if (!check([0xFD, 0x37, 0x7A, 0x58, 0x5A, 0x00])) {
							_context9.next = 272;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xz',
							mime: 'application/x-xz'
						});

					case 272:
						if (!checkString('<?xml ')) {
							_context9.next = 274;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xml',
							mime: 'application/xml'
						});

					case 274:
						if (!check([0x37, 0x7A, 0xBC, 0xAF, 0x27, 0x1C])) {
							_context9.next = 276;
							break;
						}

						return _context9.abrupt('return', {
							ext: '7z',
							mime: 'application/x-7z-compressed'
						});

					case 276:
						if (!(check([0x52, 0x61, 0x72, 0x21, 0x1A, 0x7]) && (buffer[6] === 0x0 || buffer[6] === 0x1))) {
							_context9.next = 278;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'rar',
							mime: 'application/x-rar-compressed'
						});

					case 278:
						if (!checkString('solid ')) {
							_context9.next = 280;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'stl',
							mime: 'model/stl'
						});

					case 280:
						if (!checkString('BLENDER')) {
							_context9.next = 282;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'blend',
							mime: 'application/x-blender'
						});

					case 282:
						if (!checkString('!<arch>')) {
							_context9.next = 291;
							break;
						}

						_context9.next = 285;
						return tokenizer.ignore(8);

					case 285:
						_context9.next = 287;
						return tokenizer.readToken(new Token.StringType(13, 'ascii'));

					case 287:
						str = _context9.sent;

						if (!(str === 'debian-binary')) {
							_context9.next = 290;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'deb',
							mime: 'application/x-deb'
						});

					case 290:
						return _context9.abrupt('return', {
							ext: 'ar',
							mime: 'application/x-unix-archive'
						});

					case 291:
						if (!check([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
							_context9.next = 309;
							break;
						}

						// ignore PNG signature

						readChunkHeader = function () {
							var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
								return regeneratorRuntime.wrap(function _callee7$(_context7) {
									while (1) {
										switch (_context7.prev = _context7.next) {
											case 0:
												_context7.next = 2;
												return tokenizer.readToken(Token.INT32_BE);

											case 2:
												_context7.t0 = _context7.sent;
												_context7.next = 5;
												return tokenizer.readToken(new Token.StringType(4, 'binary'));

											case 5:
												_context7.t1 = _context7.sent;
												return _context7.abrupt('return', {
													length: _context7.t0,
													type: _context7.t1
												});

											case 7:
											case 'end':
												return _context7.stop();
										}
									}
								}, _callee7, this);
							}));

							return function readChunkHeader() {
								return _ref10.apply(this, arguments);
							};
						}();

						_context9.next = 295;
						return tokenizer.ignore(8);

					case 295:
						_context9.next = 297;
						return readChunkHeader();

					case 297:
						chunk = _context9.sent;

						if (!(chunk.length < 0)) {
							_context9.next = 300;
							break;
						}

						return _context9.abrupt('return');

					case 300:
						_context9.t5 = chunk.type;
						_context9.next = _context9.t5 === 'IDAT' ? 303 : _context9.t5 === 'acTL' ? 304 : 305;
						break;

					case 303:
						return _context9.abrupt('return', {
							ext: 'png',
							mime: 'image/png'
						});

					case 304:
						return _context9.abrupt('return', {
							ext: 'apng',
							mime: 'image/apng'
						});

					case 305:
						_context9.next = 307;
						return tokenizer.ignore(chunk.length + 4);

					case 307:
						if (tokenizer.position + 8 < tokenizer.fileInfo.size) {
							_context9.next = 295;
							break;
						}

					case 308:
						return _context9.abrupt('return', {
							ext: 'png',
							mime: 'image/png'
						});

					case 309:
						if (!check([0x41, 0x52, 0x52, 0x4F, 0x57, 0x31, 0x00, 0x00])) {
							_context9.next = 311;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'arrow',
							mime: 'application/x-apache-arrow'
						});

					case 311:
						if (!check([0x67, 0x6C, 0x54, 0x46, 0x02, 0x00, 0x00, 0x00])) {
							_context9.next = 313;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'glb',
							mime: 'model/gltf-binary'
						});

					case 313:
						if (!(check([0x66, 0x72, 0x65, 0x65], { offset: 4 }) || // `free`
						check([0x6D, 0x64, 0x61, 0x74], { offset: 4 }) || // `mdat` MJPEG
						check([0x6D, 0x6F, 0x6F, 0x76], { offset: 4 }) || // `moov`
						check([0x77, 0x69, 0x64, 0x65], { offset: 4 }) // `wide`
						)) {
							_context9.next = 315;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mov',
							mime: 'video/quicktime'
						});

					case 315:
						if (!check([0x49, 0x49, 0x52, 0x4F, 0x08, 0x00, 0x00, 0x00, 0x18])) {
							_context9.next = 317;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'orf',
							mime: 'image/x-olympus-orf'
						});

					case 317:
						if (!checkString('gimp xcf ')) {
							_context9.next = 319;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xcf',
							mime: 'image/x-xcf'
						});

					case 319:
						if (!check([0x49, 0x49, 0x55, 0x00, 0x18, 0x00, 0x00, 0x00, 0x88, 0xE7, 0x74, 0xD8])) {
							_context9.next = 321;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'rw2',
							mime: 'image/x-panasonic-rw2'
						});

					case 321:
						if (!check([0x30, 0x26, 0xB2, 0x75, 0x8E, 0x66, 0xCF, 0x11, 0xA6, 0xD9])) {
							_context9.next = 345;
							break;
						}

						readHeader = function () {
							var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
								var guid;
								return regeneratorRuntime.wrap(function _callee8$(_context8) {
									while (1) {
										switch (_context8.prev = _context8.next) {
											case 0:
												guid = Buffer.alloc(16);
												_context8.next = 3;
												return tokenizer.readBuffer(guid);

											case 3:
												_context8.t0 = guid;
												_context8.next = 6;
												return tokenizer.readToken(Token.UINT64_LE);

											case 6:
												_context8.t1 = _context8.sent;
												return _context8.abrupt('return', {
													id: _context8.t0,
													size: _context8.t1
												});

											case 8:
											case 'end':
												return _context8.stop();
										}
									}
								}, _callee8, this);
							}));

							return function readHeader() {
								return _ref11.apply(this, arguments);
							};
						}();

						_context9.next = 325;
						return tokenizer.ignore(30);

					case 325:
						if (!(tokenizer.position + 24 < tokenizer.fileInfo.size)) {
							_context9.next = 344;
							break;
						}

						_context9.next = 328;
						return readHeader();

					case 328:
						header = _context9.sent;
						payload = header.size - 24;

						if (!_check(header.id, [0x91, 0x07, 0xDC, 0xB7, 0xB7, 0xA9, 0xCF, 0x11, 0x8E, 0xE6, 0x00, 0xC0, 0x0C, 0x20, 0x53, 0x65])) {
							_context9.next = 340;
							break;
						}

						// Sync on Stream-Properties-Object (B7DC0791-A9B7-11CF-8EE6-00C00C205365)
						typeId = Buffer.alloc(16);
						_context9.next = 334;
						return tokenizer.readBuffer(typeId);

					case 334:
						payload -= _context9.sent;

						if (!_check(typeId, [0x40, 0x9E, 0x69, 0xF8, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
							_context9.next = 337;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'asf',
							mime: 'audio/x-ms-asf'
						});

					case 337:
						if (!_check(typeId, [0xC0, 0xEF, 0x19, 0xBC, 0x4D, 0x5B, 0xCF, 0x11, 0xA8, 0xFD, 0x00, 0x80, 0x5F, 0x5C, 0x44, 0x2B])) {
							_context9.next = 339;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'asf',
							mime: 'video/x-ms-asf'
						});

					case 339:
						return _context9.abrupt('break', 344);

					case 340:
						_context9.next = 342;
						return tokenizer.ignore(payload);

					case 342:
						_context9.next = 325;
						break;

					case 344:
						return _context9.abrupt('return', {
							ext: 'asf',
							mime: 'application/vnd.ms-asf'
						});

					case 345:
						if (!check([0xAB, 0x4B, 0x54, 0x58, 0x20, 0x31, 0x31, 0xBB, 0x0D, 0x0A, 0x1A, 0x0A])) {
							_context9.next = 347;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ktx',
							mime: 'image/ktx'
						});

					case 347:
						if (!((check([0x7E, 0x10, 0x04]) || check([0x7E, 0x18, 0x04])) && check([0x30, 0x4D, 0x49, 0x45], { offset: 4 }))) {
							_context9.next = 349;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mie',
							mime: 'application/x-mie'
						});

					case 349:
						if (!check([0x27, 0x0A, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00], { offset: 2 })) {
							_context9.next = 351;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'shp',
							mime: 'application/x-esri-shape'
						});

					case 351:
						if (!check([0x00, 0x00, 0x00, 0x0C, 0x6A, 0x50, 0x20, 0x20, 0x0D, 0x0A, 0x87, 0x0A])) {
							_context9.next = 365;
							break;
						}

						_context9.next = 354;
						return tokenizer.ignore(20);

					case 354:
						_context9.next = 356;
						return tokenizer.readToken(new Token.StringType(4, 'ascii'));

					case 356:
						_type2 = _context9.sent;
						_context9.t6 = _type2;
						_context9.next = _context9.t6 === 'jp2 ' ? 360 : _context9.t6 === 'jpx ' ? 361 : _context9.t6 === 'jpm ' ? 362 : _context9.t6 === 'mjp2' ? 363 : 364;
						break;

					case 360:
						return _context9.abrupt('return', {
							ext: 'jp2',
							mime: 'image/jp2'
						});

					case 361:
						return _context9.abrupt('return', {
							ext: 'jpx',
							mime: 'image/jpx'
						});

					case 362:
						return _context9.abrupt('return', {
							ext: 'jpm',
							mime: 'image/jpm'
						});

					case 363:
						return _context9.abrupt('return', {
							ext: 'mj2',
							mime: 'image/mj2'
						});

					case 364:
						return _context9.abrupt('return');

					case 365:
						if (!(check([0xFF, 0x0A]) || check([0x00, 0x00, 0x00, 0x0C, 0x4A, 0x58, 0x4C, 0x20, 0x0D, 0x0A, 0x87, 0x0A]))) {
							_context9.next = 367;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'jxl',
							mime: 'image/jxl'
						});

					case 367:
						if (!(check([0x0, 0x0, 0x1, 0xBA]) || check([0x0, 0x0, 0x1, 0xB3]))) {
							_context9.next = 369;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mpg',
							mime: 'video/mpeg'
						});

					case 369:
						if (!check([0x00, 0x01, 0x00, 0x00, 0x00])) {
							_context9.next = 371;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ttf',
							mime: 'font/ttf'
						});

					case 371:
						if (!check([0x00, 0x00, 0x01, 0x00])) {
							_context9.next = 373;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ico',
							mime: 'image/x-icon'
						});

					case 373:
						if (!check([0x00, 0x00, 0x02, 0x00])) {
							_context9.next = 375;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'cur',
							mime: 'image/x-icon'
						});

					case 375:
						if (!check([0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1])) {
							_context9.next = 377;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'cfb',
							mime: 'application/x-cfb'
						});

					case 377:
						_context9.next = 379;
						return tokenizer.peekBuffer(buffer, { length: Math.min(256, tokenizer.fileInfo.size), mayBeLess: true });

					case 379:
						if (!checkString('BEGIN:')) {
							_context9.next = 384;
							break;
						}

						if (!checkString('VCARD', { offset: 6 })) {
							_context9.next = 382;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'vcf',
							mime: 'text/vcard'
						});

					case 382:
						if (!checkString('VCALENDAR', { offset: 6 })) {
							_context9.next = 384;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'ics',
							mime: 'text/calendar'
						});

					case 384:
						if (!checkString('FUJIFILMCCD-RAW')) {
							_context9.next = 386;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'raf',
							mime: 'image/x-fujifilm-raf'
						});

					case 386:
						if (!checkString('Extended Module:')) {
							_context9.next = 388;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'xm',
							mime: 'audio/x-xm'
						});

					case 388:
						if (!checkString('Creative Voice File')) {
							_context9.next = 390;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'voc',
							mime: 'audio/x-voc'
						});

					case 390:
						if (!(check([0x04, 0x00, 0x00, 0x00]) && buffer.length >= 16)) {
							_context9.next = 402;
							break;
						}

						// Rough & quick check Pickle/ASAR
						jsonSize = buffer.readUInt32LE(12);

						if (!(jsonSize > 12 && buffer.length >= jsonSize + 16)) {
							_context9.next = 402;
							break;
						}

						_context9.prev = 393;
						_header = buffer.slice(16, jsonSize + 16).toString();
						json = JSON.parse(_header);
						// Check if Pickle is ASAR

						if (!json.files) {
							_context9.next = 398;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'asar',
							mime: 'application/x-asar'
						});

					case 398:
						_context9.next = 402;
						break;

					case 400:
						_context9.prev = 400;
						_context9.t7 = _context9['catch'](393);

					case 402:
						if (!check([0x06, 0x0E, 0x2B, 0x34, 0x02, 0x05, 0x01, 0x01, 0x0D, 0x01, 0x02, 0x01, 0x01, 0x02])) {
							_context9.next = 404;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mxf',
							mime: 'application/mxf'
						});

					case 404:
						if (!checkString('SCRM', { offset: 44 })) {
							_context9.next = 406;
							break;
						}

						return _context9.abrupt('return', {
							ext: 's3m',
							mime: 'audio/x-s3m'
						});

					case 406:
						if (!(check([0x47], { offset: 4 }) && (check([0x47], { offset: 192 }) || check([0x47], { offset: 196 })))) {
							_context9.next = 408;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mts',
							mime: 'video/mp2t'
						});

					case 408:
						if (!check([0x42, 0x4F, 0x4F, 0x4B, 0x4D, 0x4F, 0x42, 0x49], { offset: 60 })) {
							_context9.next = 410;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mobi',
							mime: 'application/x-mobipocket-ebook'
						});

					case 410:
						if (!check([0x44, 0x49, 0x43, 0x4D], { offset: 128 })) {
							_context9.next = 412;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'dcm',
							mime: 'application/dicom'
						});

					case 412:
						if (!check([0x4C, 0x00, 0x00, 0x00, 0x01, 0x14, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00, 0xC0, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x46])) {
							_context9.next = 414;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'lnk',
							mime: 'application/x.ms.shortcut' // Invented by us
						});

					case 414:
						if (!check([0x62, 0x6F, 0x6F, 0x6B, 0x00, 0x00, 0x00, 0x00, 0x6D, 0x61, 0x72, 0x6B, 0x00, 0x00, 0x00, 0x00])) {
							_context9.next = 416;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'alias',
							mime: 'application/x.apple.alias' // Invented by us
						});

					case 416:
						if (!(check([0x4C, 0x50], { offset: 34 }) && (check([0x00, 0x00, 0x01], { offset: 8 }) || check([0x01, 0x00, 0x02], { offset: 8 }) || check([0x02, 0x00, 0x02], { offset: 8 })))) {
							_context9.next = 418;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'eot',
							mime: 'application/vnd.ms-fontobject'
						});

					case 418:
						if (!check([0x06, 0x06, 0xED, 0xF5, 0xD8, 0x1D, 0x46, 0xE5, 0xBD, 0x31, 0xEF, 0xE7, 0xFE, 0x74, 0xB7, 0x1D])) {
							_context9.next = 420;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'indd',
							mime: 'application/x-indesign'
						});

					case 420:
						_context9.next = 422;
						return tokenizer.peekBuffer(buffer, { length: Math.min(512, tokenizer.fileInfo.size), mayBeLess: true });

					case 422:
						if (!tarHeaderChecksumMatches(buffer)) {
							_context9.next = 424;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'tar',
							mime: 'application/x-tar'
						});

					case 424:
						if (!check([0xFF, 0xFE, 0xFF, 0x0E, 0x53, 0x00, 0x6B, 0x00, 0x65, 0x00, 0x74, 0x00, 0x63, 0x00, 0x68, 0x00, 0x55, 0x00, 0x70, 0x00, 0x20, 0x00, 0x4D, 0x00, 0x6F, 0x00, 0x64, 0x00, 0x65, 0x00, 0x6C, 0x00])) {
							_context9.next = 426;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'skp',
							mime: 'application/vnd.sketchup.skp'
						});

					case 426:
						if (!checkString('-----BEGIN PGP MESSAGE-----')) {
							_context9.next = 428;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'pgp',
							mime: 'application/pgp-encrypted'
						});

					case 428:
						if (!(buffer.length >= 2 && check([0xFF, 0xE0], { offset: 0, mask: [0xFF, 0xE0] }))) {
							_context9.next = 439;
							break;
						}

						if (!check([0x10], { offset: 1, mask: [0x16] })) {
							_context9.next = 433;
							break;
						}

						if (!check([0x08], { offset: 1, mask: [0x08] })) {
							_context9.next = 432;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'aac',
							mime: 'audio/aac'
						});

					case 432:
						return _context9.abrupt('return', {
							ext: 'aac',
							mime: 'audio/aac'
						});

					case 433:
						if (!check([0x02], { offset: 1, mask: [0x06] })) {
							_context9.next = 435;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mp3',
							mime: 'audio/mpeg'
						});

					case 435:
						if (!check([0x04], { offset: 1, mask: [0x06] })) {
							_context9.next = 437;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mp2',
							mime: 'audio/mpeg'
						});

					case 437:
						if (!check([0x06], { offset: 1, mask: [0x06] })) {
							_context9.next = 439;
							break;
						}

						return _context9.abrupt('return', {
							ext: 'mp1',
							mime: 'audio/mpeg'
						});

					case 439:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this, [[61, 116], [393, 400]]);
	}));

	return function _fromTokenizer(_x4) {
		return _ref6.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Token = __webpack_require__(327);
var strtok3 = __webpack_require__(328);

var _require = __webpack_require__(333),
    stringToBytes = _require.stringToBytes,
    tarHeaderChecksumMatches = _require.tarHeaderChecksumMatches,
    uint32SyncSafeToken = _require.uint32SyncSafeToken;

var supported = __webpack_require__(334);

var minimumBytes = 4100;

function _check(buffer, headers, options) {
	options = _extends({
		offset: 0
	}, options);

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = headers.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref3 = _step.value;

			var _ref4 = _slicedToArray(_ref3, 2);

			var index = _ref4[0];
			var header = _ref4[1];

			// If a bitmask is set
			if (options.mask) {
				// If header doesn't equal `buf` with bits masked off
				if (header !== (options.mask[index] & buffer[index + options.offset])) {
					return false;
				}
			} else if (header !== buffer[index + options.offset]) {
				return false;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return true;
}

var stream = function stream(readableStream) {
	return new Promise(function (resolve, reject) {
		// Using `eval` to work around issues when bundling with Webpack
		var stream = eval('require')('stream'); // eslint-disable-line no-eval

		readableStream.on('error', reject);
		readableStream.once('readable', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
			var pass, outputStream, chunk, _fileType;

			return regeneratorRuntime.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							// Set up output stream
							pass = new stream.PassThrough();
							outputStream = void 0;

							if (stream.pipeline) {
								outputStream = stream.pipeline(readableStream, pass, function () {});
							} else {
								outputStream = readableStream.pipe(pass);
							}

							// Read the input stream and detect the filetype
							chunk = readableStream.read(minimumBytes) || readableStream.read() || Buffer.alloc(0);
							_context10.prev = 4;
							_context10.next = 7;
							return fromBuffer(chunk);

						case 7:
							_fileType = _context10.sent;

							pass.fileType = _fileType;
							_context10.next = 14;
							break;

						case 11:
							_context10.prev = 11;
							_context10.t0 = _context10['catch'](4);

							reject(_context10.t0);

						case 14:

							resolve(outputStream);

						case 15:
						case 'end':
							return _context10.stop();
					}
				}
			}, _callee10, _this, [[4, 11]]);
		})));
	});
};

var fileType = {
	fromStream: fromStream,
	fromTokenizer: fromTokenizer,
	fromBuffer: fromBuffer,
	stream: stream
};

Object.defineProperty(fileType, 'extensions', {
	get: function get() {
		return new Set(supported.extensions);
	}
});

Object.defineProperty(fileType, 'mimeTypes', {
	get: function get() {
		return new Set(supported.mimeTypes);
	}
});

module.exports = fileType;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
exports.writeIntBE = exports.readIntBE = exports.writeUIntBE = exports.readUIntBE = exports.writeIntLE = exports.AnsiStringType = exports.StringType = exports.BufferType = exports.IgnoreType = exports.Float80_LE = exports.Float80_BE = exports.Float64_LE = exports.Float64_BE = exports.Float32_LE = exports.Float32_BE = exports.Float16_LE = exports.Float16_BE = exports.INT64_BE = exports.UINT64_BE = exports.INT64_LE = exports.UINT64_LE = exports.INT32_LE = exports.INT32_BE = exports.INT24_BE = exports.INT24_LE = exports.INT16_LE = exports.INT16_BE = exports.INT8 = exports.UINT32_BE = exports.UINT32_LE = exports.UINT24_BE = exports.UINT24_LE = exports.UINT16_BE = exports.UINT16_LE = exports.UINT8 = void 0;
var ieee754 = __webpack_require__(163);
// Primitive types
/**
 * 8-bit unsigned integer
 */
exports.UINT8 = {
    len: 1,
    get: function get(buf, off) {
        return buf.readUInt8(off);
    },
    put: function put(buf, off, v) {
        return buf.writeUInt8(v, off);
    }
};
/**
 * 16-bit unsigned integer, Little Endian byte order
 */
exports.UINT16_LE = {
    len: 2,
    get: function get(buf, off) {
        return buf.readUInt16LE(off);
    },
    put: function put(buf, off, v) {
        return buf.writeUInt16LE(v, off);
    }
};
/**
 * 16-bit unsigned integer, Big Endian byte order
 */
exports.UINT16_BE = {
    len: 2,
    get: function get(buf, off) {
        return buf.readUInt16BE(off);
    },
    put: function put(buf, off, v) {
        return buf.writeUInt16BE(v, off);
    }
};
/**
 * 24-bit unsigned integer, Little Endian byte order
 */
exports.UINT24_LE = {
    len: 3,
    get: function get(buf, off) {
        return buf.readUIntLE(off, 3);
    },
    put: function put(buf, off, v) {
        return buf.writeUIntLE(v, off, 3);
    }
};
/**
 * 24-bit unsigned integer, Big Endian byte order
 */
exports.UINT24_BE = {
    len: 3,
    get: function get(buf, off) {
        return buf.readUIntBE(off, 3);
    },
    put: function put(buf, off, v) {
        return buf.writeUIntBE(v, off, 3);
    }
};
/**
 * 32-bit unsigned integer, Little Endian byte order
 */
exports.UINT32_LE = {
    len: 4,
    get: function get(buf, off) {
        return buf.readUInt32LE(off);
    },
    put: function put(b, o, v) {
        return b.writeUInt32LE(v, o);
    }
};
/**
 * 32-bit unsigned integer, Big Endian byte order
 */
exports.UINT32_BE = {
    len: 4,
    get: function get(buf, off) {
        return buf.readUInt32BE(off);
    },
    put: function put(buf, off, v) {
        return buf.writeUInt32BE(v, off);
    }
};
/**
 * 8-bit signed integer
 */
exports.INT8 = {
    len: 1,
    get: function get(buf, off) {
        return buf.readInt8(off);
    },
    put: function put(buf, off, v) {
        return buf.writeInt8(v, off);
    }
};
/**
 * 16-bit signed integer, Big Endian byte order
 */
exports.INT16_BE = {
    len: 2,
    get: function get(buf, off) {
        return buf.readInt16BE(off);
    },
    put: function put(b, o, v) {
        return b.writeInt16BE(v, o);
    }
};
/**
 * 16-bit signed integer, Little Endian byte order
 */
exports.INT16_LE = {
    len: 2,
    get: function get(buf, off) {
        return buf.readInt16LE(off);
    },
    put: function put(b, o, v) {
        return b.writeInt16LE(v, o);
    }
};
/**
 * 24-bit signed integer, Little Endian byte order
 */
exports.INT24_LE = {
    len: 3,
    get: function get(buf, off) {
        return buf.readIntLE(off, 3);
    },
    put: function put(b, o, v) {
        return b.writeIntLE(v, o, 3);
    }
};
/**
 * 24-bit signed integer, Big Endian byte order
 */
exports.INT24_BE = {
    len: 3,
    get: function get(buf, off) {
        return buf.readIntBE(off, 3);
    },
    put: function put(b, o, v) {
        return b.writeIntBE(v, o, 3);
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_BE = {
    len: 4,
    get: function get(buf, off) {
        return buf.readInt32BE(off);
    },
    put: function put(b, o, v) {
        return b.writeInt32BE(v, o);
    }
};
/**
 * 32-bit signed integer, Big Endian byte order
 */
exports.INT32_LE = {
    len: 4,
    get: function get(buf, off) {
        return buf.readInt32LE(off);
    },
    put: function put(b, o, v) {
        return b.writeInt32LE(v, o);
    }
};
/**
 * 64-bit unsigned integer, Little Endian byte order
 */
exports.UINT64_LE = {
    len: 8,
    get: function get(buf, off) {
        return readUIntLE(buf, off, this.len);
    },
    put: function put(b, o, v) {
        return writeUIntLE(b, v, o, this.len);
    }
};
/**
 * 64-bit signed integer, Little Endian byte order
 */
exports.INT64_LE = {
    len: 8,
    get: function get(buf, off) {
        return readIntLE(buf, off, this.len);
    },
    put: function put(b, off, v) {
        return writeIntLE(b, v, off, this.len);
    }
};
/**
 * 64-bit unsigned integer, Big Endian byte order
 */
exports.UINT64_BE = {
    len: 8,
    get: function get(b, off) {
        return readUIntBE(b, off, this.len);
    },
    put: function put(b, o, v) {
        return writeUIntBE(b, v, o, this.len);
    }
};
/**
 * 64-bit signed integer, Big Endian byte order
 */
exports.INT64_BE = {
    len: 8,
    get: function get(b, off) {
        return readIntBE(b, off, this.len);
    },
    put: function put(b, off, v) {
        return writeIntBE(b, v, off, this.len);
    }
};
/**
 * IEEE 754 16-bit (half precision) float, big endian
 */
exports.Float16_BE = {
    len: 2,
    get: function get(b, off) {
        return ieee754.read(b, off, false, 10, this.len);
    },
    put: function put(b, off, v) {
        ieee754.write(b, v, off, false, 10, this.len);
        return off + this.len;
    }
};
/**
 * IEEE 754 16-bit (half precision) float, little endian
 */
exports.Float16_LE = {
    len: 2,
    get: function get(b, off) {
        return ieee754.read(b, off, true, 10, this.len);
    },
    put: function put(b, off, v) {
        ieee754.write(b, v, off, true, 10, this.len);
        return off + this.len;
    }
};
/**
 * IEEE 754 32-bit (single precision) float, big endian
 */
exports.Float32_BE = {
    len: 4,
    get: function get(b, off) {
        return b.readFloatBE(off);
    },
    put: function put(b, off, v) {
        return b.writeFloatBE(v, off);
    }
};
/**
 * IEEE 754 32-bit (single precision) float, little endian
 */
exports.Float32_LE = {
    len: 4,
    get: function get(b, off) {
        return b.readFloatLE(off);
    },
    put: function put(b, off, v) {
        return b.writeFloatLE(v, off);
    }
};
/**
 * IEEE 754 64-bit (double precision) float, big endian
 */
exports.Float64_BE = {
    len: 8,
    get: function get(b, off) {
        return b.readDoubleBE(off);
    },
    put: function put(b, off, v) {
        return b.writeDoubleBE(v, off);
    }
};
/**
 * IEEE 754 64-bit (double precision) float, little endian
 */
exports.Float64_LE = {
    len: 8,
    get: function get(b, off) {
        return b.readDoubleLE(off);
    },
    put: function put(b, off, v) {
        return b.writeDoubleLE(v, off);
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, big endian
 */
exports.Float80_BE = {
    len: 10,
    get: function get(b, off) {
        return ieee754.read(b, off, false, 63, this.len);
    },
    put: function put(b, off, v) {
        ieee754.write(b, v, off, false, 63, this.len);
        return off + this.len;
    }
};
/**
 * IEEE 754 80-bit (extended precision) float, little endian
 */
exports.Float80_LE = {
    len: 10,
    get: function get(b, off) {
        return ieee754.read(b, off, true, 63, this.len);
    },
    put: function put(b, off, v) {
        ieee754.write(b, v, off, true, 63, this.len);
        return off + this.len;
    }
};
/**
 * Ignore a given number of bytes
 */

var IgnoreType = function () {
    /**
     * @param len number of bytes to ignore
     */
    function IgnoreType(len) {
        _classCallCheck(this, IgnoreType);

        this.len = len;
    }
    // ToDo: don't read, but skip data


    _createClass(IgnoreType, [{
        key: "get",
        value: function get(buf, off) {}
    }]);

    return IgnoreType;
}();

exports.IgnoreType = IgnoreType;

var BufferType = function () {
    function BufferType(len) {
        _classCallCheck(this, BufferType);

        this.len = len;
    }

    _createClass(BufferType, [{
        key: "get",
        value: function get(buf, off) {
            return buf.slice(off, off + this.len);
        }
    }]);

    return BufferType;
}();

exports.BufferType = BufferType;
/**
 * Consume a fixed number of bytes from the stream and return a string with a specified encoding.
 */

var StringType = function () {
    function StringType(len, encoding) {
        _classCallCheck(this, StringType);

        this.len = len;
        this.encoding = encoding;
    }

    _createClass(StringType, [{
        key: "get",
        value: function get(buf, off) {
            return buf.toString(this.encoding, off, off + this.len);
        }
    }]);

    return StringType;
}();

exports.StringType = StringType;
/**
 * ANSI Latin 1 String
 * Using windows-1252 / ISO 8859-1 decoding
 */

var AnsiStringType = function () {
    function AnsiStringType(len) {
        _classCallCheck(this, AnsiStringType);

        this.len = len;
    }

    _createClass(AnsiStringType, [{
        key: "get",
        value: function get(buf) {
            var off = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            return AnsiStringType.decode(buf, off, off + this.len);
        }
    }], [{
        key: "decode",
        value: function decode(buffer, off, until) {
            var str = '';
            for (var i = off; i < until; ++i) {
                str += AnsiStringType.codePointToString(AnsiStringType.singleByteDecoder(buffer[i]));
            }
            return str;
        }
    }, {
        key: "inRange",
        value: function inRange(a, min, max) {
            return min <= a && a <= max;
        }
    }, {
        key: "codePointToString",
        value: function codePointToString(cp) {
            if (cp <= 0xFFFF) {
                return String.fromCharCode(cp);
            } else {
                cp -= 0x10000;
                return String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
            }
        }
    }, {
        key: "singleByteDecoder",
        value: function singleByteDecoder(bite) {
            if (AnsiStringType.inRange(bite, 0x00, 0x7F)) {
                return bite;
            }
            var codePoint = AnsiStringType.windows1252[bite - 0x80];
            if (codePoint === null) {
                throw Error('invaliding encoding');
            }
            return codePoint;
        }
    }]);

    return AnsiStringType;
}();

exports.AnsiStringType = AnsiStringType;
AnsiStringType.windows1252 = [8364, 129, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, 141, 381, 143, 144, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, 157, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255];
/**
 * Best effort approach to read up to 64 bit unsigned integer, little endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function readUIntLE(buf, offset, byteLength) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var val = buf[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
        val += buf[offset + i] * mul;
    }
    return val;
}
/**
 * Best effort approach to write up to 64 bit unsigned integer, little endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function writeUIntLE(buf, value, offset, byteLength) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var mul = 1;
    var i = 0;
    buf[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
        buf[offset + i] = value / mul & 0xFF;
    }
    return offset + byteLength;
}
/**
 * Best effort approach to read 64 but signed integer, little endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function readIntLE(buf, offset, byteLength) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var val = buf[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
        val += buf[offset + i] * mul;
    }
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
}
/**
 * Best effort approach to write 64 but signed integer, little endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function writeIntLE(buf, value, offset, byteLength) {
    value = +value;
    offset = offset >>> 0;
    var i = 0;
    var mul = 1;
    var sub = 0;
    buf[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && buf[offset + i - 1] !== 0) {
            sub = 1;
        }
        buf[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
}
exports.writeIntLE = writeIntLE;
/**
 * Best effort approach to read up to 64 bit unsigned integer, big endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function readUIntBE(buf, offset, byteLength) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var val = buf[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
        val += buf[offset + --byteLength] * mul;
    }
    return val;
}
exports.readUIntBE = readUIntBE;
/**
 * Best effort approach to write up to 64 bit unsigned integer, big endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function writeUIntBE(buf, value, offset, byteLength) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var i = byteLength - 1;
    var mul = 1;
    buf[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
        buf[offset + i] = value / mul & 0xFF;
    }
    return offset + byteLength;
}
exports.writeUIntBE = writeUIntBE;
/**
 * Best effort approach to read 64 but signed integer, big endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function readIntBE(buf, offset, byteLength) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    var i = byteLength;
    var mul = 1;
    var val = buf[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
        val += buf[offset + --i] * mul;
    }
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
}
exports.readIntBE = readIntBE;
/**
 * Best effort approach to write 64 but signed integer, big endian.
 * Note that JavasScript is limited to 2^53 - 1 bit.
 */
function writeIntBE(buf, value, offset, byteLength) {
    value = +value;
    offset = offset >>> 0;
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    buf[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
        if (value < 0 && sub === 0 && buf[offset + i + 1] !== 0) {
            sub = 1;
        }
        buf[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
}
exports.writeIntBE = writeIntBE;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBuffer = exports.fromStream = exports.EndOfStreamError = void 0;
var ReadStreamTokenizer_1 = __webpack_require__(329);
var BufferTokenizer_1 = __webpack_require__(332);
var peek_readable_1 = __webpack_require__(88);
Object.defineProperty(exports, "EndOfStreamError", { enumerable: true, get: function get() {
    return peek_readable_1.EndOfStreamError;
  } });
/**
 * Construct ReadStreamTokenizer from given Stream.
 * Will set fileSize, if provided given Stream has set the .path property/
 * @param stream - Read from Node.js Stream.Readable
 * @param fileInfo - Pass the file information, like size and MIME-type of the corresponding stream.
 * @returns ReadStreamTokenizer
 */
function fromStream(stream, fileInfo) {
  fileInfo = fileInfo ? fileInfo : {};
  return new ReadStreamTokenizer_1.ReadStreamTokenizer(stream, fileInfo);
}
exports.fromStream = fromStream;
/**
 * Construct ReadStreamTokenizer from given Buffer.
 * @param uint8Array - Uint8Array to tokenize
 * @param fileInfo - Pass additional file information to the tokenizer
 * @returns BufferTokenizer
 */
function fromBuffer(uint8Array, fileInfo) {
  return new BufferTokenizer_1.BufferTokenizer(uint8Array, fileInfo);
}
exports.fromBuffer = fromBuffer;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadStreamTokenizer = void 0;
var AbstractTokenizer_1 = __webpack_require__(172);
var peek_readable_1 = __webpack_require__(88);
var maxBufferSize = 256000;

var ReadStreamTokenizer = function (_AbstractTokenizer_1$) {
    _inherits(ReadStreamTokenizer, _AbstractTokenizer_1$);

    function ReadStreamTokenizer(stream, fileInfo) {
        _classCallCheck(this, ReadStreamTokenizer);

        var _this = _possibleConstructorReturn(this, (ReadStreamTokenizer.__proto__ || Object.getPrototypeOf(ReadStreamTokenizer)).call(this, fileInfo));

        _this.streamReader = new peek_readable_1.StreamReader(stream);
        return _this;
    }
    /**
     * Get file information, an HTTP-client may implement this doing a HEAD request
     * @return Promise with file information
     */


    _createClass(ReadStreamTokenizer, [{
        key: "getFileInfo",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt("return", this.fileInfo);

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getFileInfo() {
                return _ref.apply(this, arguments);
            }

            return getFileInfo;
        }()
        /**
         * Read buffer from tokenizer
         * @param uint8Array - Target Uint8Array to fill with data read from the tokenizer-stream
         * @param options - Read behaviour options
         * @returns Promise with number of bytes read
         */

    }, {
        key: "readBuffer",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uint8Array, options) {
                var normOptions, skipBytes, bytesRead;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                normOptions = this.normalizeOptions(uint8Array, options);
                                skipBytes = normOptions.position - this.position;

                                if (!(skipBytes > 0)) {
                                    _context2.next = 8;
                                    break;
                                }

                                _context2.next = 5;
                                return this.ignore(skipBytes);

                            case 5:
                                return _context2.abrupt("return", this.readBuffer(uint8Array, options));

                            case 8:
                                if (!(skipBytes < 0)) {
                                    _context2.next = 10;
                                    break;
                                }

                                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

                            case 10:
                                if (!(normOptions.length === 0)) {
                                    _context2.next = 12;
                                    break;
                                }

                                return _context2.abrupt("return", 0);

                            case 12:
                                _context2.next = 14;
                                return this.streamReader.read(uint8Array, normOptions.offset, normOptions.length);

                            case 14:
                                bytesRead = _context2.sent;

                                this.position += bytesRead;

                                if (!((!options || !options.mayBeLess) && bytesRead < normOptions.length)) {
                                    _context2.next = 18;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 18:
                                return _context2.abrupt("return", bytesRead);

                            case 19:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function readBuffer(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return readBuffer;
        }()
        /**
         * Peek (read ahead) buffer from tokenizer
         * @param uint8Array - Uint8Array (or Buffer) to write data to
         * @param options - Read behaviour options
         * @returns Promise with number of bytes peeked
         */

    }, {
        key: "peekBuffer",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(uint8Array, options) {
                var normOptions, bytesRead, skipBytes, skipBuffer;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                normOptions = this.normalizeOptions(uint8Array, options);
                                bytesRead = 0;

                                if (!normOptions.position) {
                                    _context3.next = 15;
                                    break;
                                }

                                skipBytes = normOptions.position - this.position;

                                if (!(skipBytes > 0)) {
                                    _context3.next = 13;
                                    break;
                                }

                                skipBuffer = new Uint8Array(normOptions.length + skipBytes);
                                _context3.next = 8;
                                return this.peekBuffer(skipBuffer, { mayBeLess: normOptions.mayBeLess });

                            case 8:
                                bytesRead = _context3.sent;

                                uint8Array.set(skipBuffer.subarray(skipBytes), normOptions.offset);
                                return _context3.abrupt("return", bytesRead - skipBytes);

                            case 13:
                                if (!(skipBytes < 0)) {
                                    _context3.next = 15;
                                    break;
                                }

                                throw new Error('Cannot peek from a negative offset in a stream');

                            case 15:
                                if (!(normOptions.length > 0)) {
                                    _context3.next = 29;
                                    break;
                                }

                                _context3.prev = 16;
                                _context3.next = 19;
                                return this.streamReader.peek(uint8Array, normOptions.offset, normOptions.length);

                            case 19:
                                bytesRead = _context3.sent;
                                _context3.next = 27;
                                break;

                            case 22:
                                _context3.prev = 22;
                                _context3.t0 = _context3["catch"](16);

                                if (!(options && options.mayBeLess && _context3.t0 instanceof peek_readable_1.EndOfStreamError)) {
                                    _context3.next = 26;
                                    break;
                                }

                                return _context3.abrupt("return", 0);

                            case 26:
                                throw _context3.t0;

                            case 27:
                                if (!(!normOptions.mayBeLess && bytesRead < normOptions.length)) {
                                    _context3.next = 29;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 29:
                                return _context3.abrupt("return", bytesRead);

                            case 30:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[16, 22]]);
            }));

            function peekBuffer(_x3, _x4) {
                return _ref3.apply(this, arguments);
            }

            return peekBuffer;
        }()
    }, {
        key: "ignore",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(length) {
                var bufSize, buf, totBytesRead, remaining, bytesRead;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                // debug(`ignore ${this.position}...${this.position + length - 1}`);
                                bufSize = Math.min(maxBufferSize, length);
                                buf = new Uint8Array(bufSize);
                                totBytesRead = 0;

                            case 3:
                                if (!(totBytesRead < length)) {
                                    _context4.next = 13;
                                    break;
                                }

                                remaining = length - totBytesRead;
                                _context4.next = 7;
                                return this.readBuffer(buf, { length: Math.min(bufSize, remaining) });

                            case 7:
                                bytesRead = _context4.sent;

                                if (!(bytesRead < 0)) {
                                    _context4.next = 10;
                                    break;
                                }

                                return _context4.abrupt("return", bytesRead);

                            case 10:
                                totBytesRead += bytesRead;
                                _context4.next = 3;
                                break;

                            case 13:
                                return _context4.abrupt("return", totBytesRead);

                            case 14:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function ignore(_x5) {
                return _ref4.apply(this, arguments);
            }

            return ignore;
        }()
    }]);

    return ReadStreamTokenizer;
}(AbstractTokenizer_1.AbstractTokenizer);

exports.ReadStreamTokenizer = ReadStreamTokenizer;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamReader = exports.EndOfStreamError = void 0;
var EndOfFileStream_1 = __webpack_require__(110);
var Deferred_1 = __webpack_require__(331);
var EndOfFileStream_2 = __webpack_require__(110);
Object.defineProperty(exports, "EndOfStreamError", { enumerable: true, get: function get() {
        return EndOfFileStream_2.EndOfStreamError;
    } });
var maxStreamReadSize = 1 * 1024 * 1024; // Maximum request length on read-stream operation

var StreamReader = function () {
    function StreamReader(s) {
        var _this = this;

        _classCallCheck(this, StreamReader);

        this.s = s;
        /**
         * Deferred used for postponed read request (as not data is yet available to read)
         */
        this.deferred = null;
        this.endOfStream = false;
        /**
         * Store peeked data
         * @type {Array}
         */
        this.peekQueue = [];
        if (!s.read || !s.once) {
            throw new Error('Expected an instance of stream.Readable');
        }
        this.s.once('end', function () {
            return _this.reject(new EndOfFileStream_1.EndOfStreamError());
        });
        this.s.once('error', function (err) {
            return _this.reject(err);
        });
        this.s.once('close', function () {
            return _this.reject(new Error('Stream closed'));
        });
    }
    /**
     * Read ahead (peek) from stream. Subsequent read or peeks will return the same data
     * @param uint8Array - Uint8Array (or Buffer) to store data read from stream in
     * @param offset - Offset target
     * @param length - Number of bytes to read
     * @returns Number of bytes peeked
     */


    _createClass(StreamReader, [{
        key: "peek",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uint8Array, offset, length) {
                var bytesRead;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.read(uint8Array, offset, length);

                            case 2:
                                bytesRead = _context.sent;

                                this.peekQueue.push(uint8Array.subarray(offset, offset + bytesRead)); // Put read data back to peek buffer
                                return _context.abrupt("return", bytesRead);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function peek(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return peek;
        }()
        /**
         * Read chunk from stream
         * @param buffer - Target Uint8Array (or Buffer) to store data read from stream in
         * @param offset - Offset target
         * @param length - Number of bytes to read
         * @returns Number of bytes read
         */

    }, {
        key: "read",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(buffer, offset, length) {
                var remaining, bytesRead, peekData, lenCopy, reqLen, chunkLen;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(length === 0)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return", 0);

                            case 2:
                                if (!(this.peekQueue.length === 0 && this.endOfStream)) {
                                    _context2.next = 4;
                                    break;
                                }

                                throw new EndOfFileStream_1.EndOfStreamError();

                            case 4:
                                remaining = length;
                                bytesRead = 0;
                                // consume peeked data first

                            case 6:
                                if (!(this.peekQueue.length > 0 && remaining > 0)) {
                                    _context2.next = 17;
                                    break;
                                }

                                peekData = this.peekQueue.pop(); // Front of queue

                                if (peekData) {
                                    _context2.next = 10;
                                    break;
                                }

                                throw new Error('peekData should be defined');

                            case 10:
                                lenCopy = Math.min(peekData.length, remaining);

                                buffer.set(peekData.subarray(0, lenCopy), offset + bytesRead);
                                bytesRead += lenCopy;
                                remaining -= lenCopy;
                                if (lenCopy < peekData.length) {
                                    // remainder back to queue
                                    this.peekQueue.push(peekData.subarray(lenCopy));
                                }
                                _context2.next = 6;
                                break;

                            case 17:
                                if (!(remaining > 0 && !this.endOfStream)) {
                                    _context2.next = 28;
                                    break;
                                }

                                reqLen = Math.min(remaining, maxStreamReadSize);
                                _context2.next = 21;
                                return this.readFromStream(buffer, offset + bytesRead, reqLen);

                            case 21:
                                chunkLen = _context2.sent;

                                bytesRead += chunkLen;

                                if (!(chunkLen < reqLen)) {
                                    _context2.next = 25;
                                    break;
                                }

                                return _context2.abrupt("break", 28);

                            case 25:
                                remaining -= chunkLen;
                                _context2.next = 17;
                                break;

                            case 28:
                                return _context2.abrupt("return", bytesRead);

                            case 29:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function read(_x4, _x5, _x6) {
                return _ref2.apply(this, arguments);
            }

            return read;
        }()
        /**
         * Read chunk from stream
         * @param buffer Target Uint8Array (or Buffer) to store data read from stream in
         * @param offset Offset target
         * @param length Number of bytes to read
         * @returns Number of bytes read
         */

    }, {
        key: "readFromStream",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(buffer, offset, length) {
                var _this2 = this;

                var readBuffer, request;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                readBuffer = this.s.read(length);

                                if (!readBuffer) {
                                    _context3.next = 6;
                                    break;
                                }

                                buffer.set(readBuffer, offset);
                                return _context3.abrupt("return", readBuffer.length);

                            case 6:
                                request = {
                                    buffer: buffer,
                                    offset: offset,
                                    length: length,
                                    deferred: new Deferred_1.Deferred()
                                };

                                this.deferred = request.deferred;
                                this.s.once('readable', function () {
                                    _this2.readDeferred(request);
                                });
                                return _context3.abrupt("return", request.deferred.promise);

                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function readFromStream(_x7, _x8, _x9) {
                return _ref3.apply(this, arguments);
            }

            return readFromStream;
        }()
        /**
         * Process deferred read request
         * @param request Deferred read request
         */

    }, {
        key: "readDeferred",
        value: function readDeferred(request) {
            var _this3 = this;

            var readBuffer = this.s.read(request.length);
            if (readBuffer) {
                request.buffer.set(readBuffer, request.offset);
                request.deferred.resolve(readBuffer.length);
                this.deferred = null;
            } else {
                this.s.once('readable', function () {
                    _this3.readDeferred(request);
                });
            }
        }
    }, {
        key: "reject",
        value: function reject(err) {
            this.endOfStream = true;
            if (this.deferred) {
                this.deferred.reject(err);
                this.deferred = null;
            }
        }
    }]);

    return StreamReader;
}();

exports.StreamReader = StreamReader;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
exports.Deferred = void 0;

var Deferred = function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this.resolve = function () {
        return null;
    };
    this.reject = function () {
        return null;
    };
    this.promise = new Promise(function (resolve, reject) {
        _this.reject = reject;
        _this.resolve = resolve;
    });
};

exports.Deferred = Deferred;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferTokenizer = void 0;
var peek_readable_1 = __webpack_require__(88);
var AbstractTokenizer_1 = __webpack_require__(172);

var BufferTokenizer = function (_AbstractTokenizer_1$) {
    _inherits(BufferTokenizer, _AbstractTokenizer_1$);

    /**
     * Construct BufferTokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param fileInfo - Pass additional file information to the tokenizer
     */
    function BufferTokenizer(uint8Array, fileInfo) {
        _classCallCheck(this, BufferTokenizer);

        var _this = _possibleConstructorReturn(this, (BufferTokenizer.__proto__ || Object.getPrototypeOf(BufferTokenizer)).call(this, fileInfo));

        _this.uint8Array = uint8Array;
        _this.fileInfo.size = _this.fileInfo.size ? _this.fileInfo.size : uint8Array.length;
        return _this;
    }
    /**
     * Read buffer from tokenizer
     * @param uint8Array - Uint8Array to tokenize
     * @param options - Read behaviour options
     * @returns {Promise<number>}
     */


    _createClass(BufferTokenizer, [{
        key: "readBuffer",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(uint8Array, options) {
                var bytesRead;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(options && options.position)) {
                                    _context.next = 4;
                                    break;
                                }

                                if (!(options.position < this.position)) {
                                    _context.next = 3;
                                    break;
                                }

                                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

                            case 3:
                                this.position = options.position;

                            case 4:
                                _context.next = 6;
                                return this.peekBuffer(uint8Array, options);

                            case 6:
                                bytesRead = _context.sent;

                                this.position += bytesRead;
                                return _context.abrupt("return", bytesRead);

                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function readBuffer(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return readBuffer;
        }()
        /**
         * Peek (read ahead) buffer from tokenizer
         * @param uint8Array
         * @param options - Read behaviour options
         * @returns {Promise<number>}
         */

    }, {
        key: "peekBuffer",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uint8Array, options) {
                var normOptions, bytes2read;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                normOptions = this.normalizeOptions(uint8Array, options);
                                bytes2read = Math.min(this.uint8Array.length - normOptions.position, normOptions.length);

                                if (!(!normOptions.mayBeLess && bytes2read < normOptions.length)) {
                                    _context2.next = 6;
                                    break;
                                }

                                throw new peek_readable_1.EndOfStreamError();

                            case 6:
                                uint8Array.set(this.uint8Array.subarray(normOptions.position, normOptions.position + bytes2read), normOptions.offset);
                                return _context2.abrupt("return", bytes2read);

                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function peekBuffer(_x3, _x4) {
                return _ref2.apply(this, arguments);
            }

            return peekBuffer;
        }()
    }, {
        key: "close",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function close() {
                return _ref3.apply(this, arguments);
            }

            return close;
        }()
    }]);

    return BufferTokenizer;
}(AbstractTokenizer_1.AbstractTokenizer);

exports.BufferTokenizer = BufferTokenizer;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.stringToBytes = function (string) {
	return [].concat(_toConsumableArray(string)).map(function (character) {
		return character.charCodeAt(0);
	});
};

/**
Checks whether the TAR checksum is valid.

@param {Buffer} buffer - The TAR header `[offset ... offset + 512]`.
@param {number} offset - TAR header offset.
@returns {boolean} `true` if the TAR checksum is valid, otherwise `false`.
*/
exports.tarHeaderChecksumMatches = function (buffer) {
	var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	var readSum = parseInt(buffer.toString('utf8', 148, 154).replace(/\0.*$/, '').trim(), 8); // Read sum in header
	if (isNaN(readSum)) {
		return false;
	}

	var sum = 8 * 0x20; // Initialize signed bit sum

	for (var i = offset; i < offset + 148; i++) {
		sum += buffer[i];
	}

	for (var _i = offset + 156; _i < offset + 512; _i++) {
		sum += buffer[_i];
	}

	return readSum === sum;
};

/**
ID3 UINT32 sync-safe tokenizer token.
28 bits (representing up to 256MB) integer, the msb is 0 to avoid "false syncsignals".
*/
exports.uint32SyncSafeToken = {
	get: function get(buffer, offset) {
		return buffer[offset + 3] & 0x7F | buffer[offset + 2] << 7 | buffer[offset + 1] << 14 | buffer[offset] << 21;
	},
	len: 4
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	extensions: ['jpg', 'png', 'apng', 'gif', 'webp', 'flif', 'xcf', 'cr2', 'cr3', 'orf', 'arw', 'dng', 'nef', 'rw2', 'raf', 'tif', 'bmp', 'icns', 'jxr', 'psd', 'indd', 'zip', 'tar', 'rar', 'gz', 'bz2', '7z', 'dmg', 'mp4', 'mid', 'mkv', 'webm', 'mov', 'avi', 'mpg', 'mp2', 'mp3', 'm4a', 'oga', 'ogg', 'ogv', 'opus', 'flac', 'wav', 'spx', 'amr', 'pdf', 'epub', 'exe', 'swf', 'rtf', 'wasm', 'woff', 'woff2', 'eot', 'ttf', 'otf', 'ico', 'flv', 'ps', 'xz', 'sqlite', 'nes', 'crx', 'xpi', 'cab', 'deb', 'ar', 'rpm', 'Z', 'lz', 'cfb', 'mxf', 'mts', 'blend', 'bpg', 'docx', 'pptx', 'xlsx', '3gp', '3g2', 'jp2', 'jpm', 'jpx', 'mj2', 'aif', 'qcp', 'odt', 'ods', 'odp', 'xml', 'mobi', 'heic', 'cur', 'ktx', 'ape', 'wv', 'dcm', 'ics', 'glb', 'pcap', 'dsf', 'lnk', 'alias', 'voc', 'ac3', 'm4v', 'm4p', 'm4b', 'f4v', 'f4p', 'f4b', 'f4a', 'mie', 'asf', 'ogm', 'ogx', 'mpc', 'arrow', 'shp', 'aac', 'mp1', 'it', 's3m', 'xm', 'ai', 'skp', 'avif', 'eps', 'lzh', 'pgp', 'asar', 'stl', 'chm', '3mf', 'zst', 'jxl', 'vcf'],
	mimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/flif', 'image/x-xcf', 'image/x-canon-cr2', 'image/x-canon-cr3', 'image/tiff', 'image/bmp', 'image/vnd.ms-photo', 'image/vnd.adobe.photoshop', 'application/x-indesign', 'application/epub+zip', 'application/x-xpinstall', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/x-tar', 'application/x-rar-compressed', 'application/gzip', 'application/x-bzip2', 'application/x-7z-compressed', 'application/x-apple-diskimage', 'application/x-apache-arrow', 'video/mp4', 'audio/midi', 'video/x-matroska', 'video/webm', 'video/quicktime', 'video/vnd.avi', 'audio/vnd.wave', 'audio/qcelp', 'audio/x-ms-asf', 'video/x-ms-asf', 'application/vnd.ms-asf', 'video/mpeg', 'video/3gpp', 'audio/mpeg', 'audio/mp4', // RFC 4337
	'audio/opus', 'video/ogg', 'audio/ogg', 'application/ogg', 'audio/x-flac', 'audio/ape', 'audio/wavpack', 'audio/amr', 'application/pdf', 'application/x-msdownload', 'application/x-shockwave-flash', 'application/rtf', 'application/wasm', 'font/woff', 'font/woff2', 'application/vnd.ms-fontobject', 'font/ttf', 'font/otf', 'image/x-icon', 'video/x-flv', 'application/postscript', 'application/eps', 'application/x-xz', 'application/x-sqlite3', 'application/x-nintendo-nes-rom', 'application/x-google-chrome-extension', 'application/vnd.ms-cab-compressed', 'application/x-deb', 'application/x-unix-archive', 'application/x-rpm', 'application/x-compress', 'application/x-lzip', 'application/x-cfb', 'application/x-mie', 'application/mxf', 'video/mp2t', 'application/x-blender', 'image/bpg', 'image/jp2', 'image/jpx', 'image/jpm', 'image/mj2', 'audio/aiff', 'application/xml', 'application/x-mobipocket-ebook', 'image/heif', 'image/heif-sequence', 'image/heic', 'image/heic-sequence', 'image/icns', 'image/ktx', 'application/dicom', 'audio/x-musepack', 'text/calendar', 'text/vcard', 'model/gltf-binary', 'application/vnd.tcpdump.pcap', 'audio/x-dsf', // Non-standard
	'application/x.ms.shortcut', // Invented by us
	'application/x.apple.alias', // Invented by us
	'audio/x-voc', 'audio/vnd.dolby.dd-raw', 'audio/x-m4a', 'image/apng', 'image/x-olympus-orf', 'image/x-sony-arw', 'image/x-adobe-dng', 'image/x-nikon-nef', 'image/x-panasonic-rw2', 'image/x-fujifilm-raf', 'video/x-m4v', 'video/3gpp2', 'application/x-esri-shape', 'audio/aac', 'audio/x-it', 'audio/x-s3m', 'audio/x-xm', 'video/MP1S', 'video/MP2P', 'application/vnd.sketchup.skp', 'image/avif', 'application/x-lzh-compressed', 'application/pgp-encrypted', 'application/x-asar', 'model/stl', 'application/vnd.ms-htmlhelp', 'model/3mf', 'image/jxl', 'application/zstd']
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_index_js__ = __webpack_require__(173);
/* unused harmony reexport add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__ = __webpack_require__(174);
/* unused harmony reexport addBusinessDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(30);
/* unused harmony reexport addDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addHours_index_js__ = __webpack_require__(112);
/* unused harmony reexport addHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addISOWeekYears_index_js__ = __webpack_require__(176);
/* unused harmony reexport addISOWeekYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addMilliseconds_index_js__ = __webpack_require__(66);
/* unused harmony reexport addMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addMinutes_index_js__ = __webpack_require__(113);
/* unused harmony reexport addMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addMonths_index_js__ = __webpack_require__(65);
/* unused harmony reexport addMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addQuarters_index_js__ = __webpack_require__(114);
/* unused harmony reexport addQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addSeconds_index_js__ = __webpack_require__(178);
/* unused harmony reexport addSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addWeeks_index_js__ = __webpack_require__(91);
/* unused harmony reexport addWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addYears_index_js__ = __webpack_require__(179);
/* unused harmony reexport addYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__areIntervalsOverlapping_index_js__ = __webpack_require__(336);
/* unused harmony reexport areIntervalsOverlapping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__clamp_index_js__ = __webpack_require__(337);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__closestIndexTo_index_js__ = __webpack_require__(338);
/* unused harmony reexport closestIndexTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__closestTo_index_js__ = __webpack_require__(339);
/* unused harmony reexport closestTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__compareAsc_index_js__ = __webpack_require__(43);
/* unused harmony reexport compareAsc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__compareDesc_index_js__ = __webpack_require__(340);
/* unused harmony reexport compareDesc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__daysToWeeks_index_js__ = __webpack_require__(341);
/* unused harmony reexport daysToWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__differenceInBusinessDays_index_js__ = __webpack_require__(342);
/* unused harmony reexport differenceInBusinessDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* unused harmony reexport differenceInCalendarDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(183);
/* unused harmony reexport differenceInCalendarISOWeekYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__differenceInCalendarISOWeeks_index_js__ = __webpack_require__(343);
/* unused harmony reexport differenceInCalendarISOWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__differenceInCalendarMonths_index_js__ = __webpack_require__(115);
/* unused harmony reexport differenceInCalendarMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__differenceInCalendarQuarters_index_js__ = __webpack_require__(184);
/* unused harmony reexport differenceInCalendarQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__differenceInCalendarWeeks_index_js__ = __webpack_require__(116);
/* unused harmony reexport differenceInCalendarWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__differenceInCalendarYears_index_js__ = __webpack_require__(117);
/* unused harmony reexport differenceInCalendarYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__differenceInDays_index_js__ = __webpack_require__(118);
/* unused harmony reexport differenceInDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__differenceInHours_index_js__ = __webpack_require__(119);
/* unused harmony reexport differenceInHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__differenceInISOWeekYears_index_js__ = __webpack_require__(344);
/* unused harmony reexport differenceInISOWeekYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__differenceInMilliseconds_index_js__ = __webpack_require__(92);
/* unused harmony reexport differenceInMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__differenceInMinutes_index_js__ = __webpack_require__(120);
/* unused harmony reexport differenceInMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__differenceInMonths_index_js__ = __webpack_require__(93);
/* unused harmony reexport differenceInMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__differenceInQuarters_index_js__ = __webpack_require__(345);
/* unused harmony reexport differenceInQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__differenceInSeconds_index_js__ = __webpack_require__(94);
/* unused harmony reexport differenceInSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__differenceInWeeks_index_js__ = __webpack_require__(346);
/* unused harmony reexport differenceInWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__differenceInYears_index_js__ = __webpack_require__(188);
/* unused harmony reexport differenceInYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__eachDayOfInterval_index_js__ = __webpack_require__(189);
/* unused harmony reexport eachDayOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__eachHourOfInterval_index_js__ = __webpack_require__(347);
/* unused harmony reexport eachHourOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__eachMinuteOfInterval_index_js__ = __webpack_require__(348);
/* unused harmony reexport eachMinuteOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__eachMonthOfInterval_index_js__ = __webpack_require__(349);
/* unused harmony reexport eachMonthOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__eachQuarterOfInterval_index_js__ = __webpack_require__(350);
/* unused harmony reexport eachQuarterOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__eachWeekOfInterval_index_js__ = __webpack_require__(351);
/* unused harmony reexport eachWeekOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__eachWeekendOfInterval_index_js__ = __webpack_require__(125);
/* unused harmony reexport eachWeekendOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__eachWeekendOfMonth_index_js__ = __webpack_require__(352);
/* unused harmony reexport eachWeekendOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__eachWeekendOfYear_index_js__ = __webpack_require__(353);
/* unused harmony reexport eachWeekendOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__eachYearOfInterval_index_js__ = __webpack_require__(354);
/* unused harmony reexport eachYearOfInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__endOfDay_index_js__ = __webpack_require__(121);
/* unused harmony reexport endOfDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__endOfDecade_index_js__ = __webpack_require__(355);
/* unused harmony reexport endOfDecade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__endOfHour_index_js__ = __webpack_require__(356);
/* unused harmony reexport endOfHour */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__endOfISOWeek_index_js__ = __webpack_require__(357);
/* unused harmony reexport endOfISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__endOfISOWeekYear_index_js__ = __webpack_require__(358);
/* unused harmony reexport endOfISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__endOfMinute_index_js__ = __webpack_require__(359);
/* unused harmony reexport endOfMinute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__endOfMonth_index_js__ = __webpack_require__(122);
/* unused harmony reexport endOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__endOfQuarter_index_js__ = __webpack_require__(360);
/* unused harmony reexport endOfQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__endOfSecond_index_js__ = __webpack_require__(361);
/* unused harmony reexport endOfSecond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__endOfToday_index_js__ = __webpack_require__(362);
/* unused harmony reexport endOfToday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__endOfTomorrow_index_js__ = __webpack_require__(363);
/* unused harmony reexport endOfTomorrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__endOfWeek_index_js__ = __webpack_require__(191);
/* unused harmony reexport endOfWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__endOfYear_index_js__ = __webpack_require__(190);
/* unused harmony reexport endOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__endOfYesterday_index_js__ = __webpack_require__(364);
/* unused harmony reexport endOfYesterday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__format_index_js__ = __webpack_require__(192);
/* unused harmony reexport format */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__formatDistance_index_js__ = __webpack_require__(199);
/* unused harmony reexport formatDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__formatDistanceStrict_index_js__ = __webpack_require__(201);
/* unused harmony reexport formatDistanceStrict */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__formatDistanceToNow_index_js__ = __webpack_require__(379);
/* unused harmony reexport formatDistanceToNow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__formatDistanceToNowStrict_index_js__ = __webpack_require__(380);
/* unused harmony reexport formatDistanceToNowStrict */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__formatDuration_index_js__ = __webpack_require__(381);
/* unused harmony reexport formatDuration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__formatISO_index_js__ = __webpack_require__(382);
/* unused harmony reexport formatISO */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__formatISO9075_index_js__ = __webpack_require__(383);
/* unused harmony reexport formatISO9075 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__formatISODuration_index_js__ = __webpack_require__(384);
/* unused harmony reexport formatISODuration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__formatRFC3339_index_js__ = __webpack_require__(385);
/* unused harmony reexport formatRFC3339 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__formatRFC7231_index_js__ = __webpack_require__(386);
/* unused harmony reexport formatRFC7231 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__formatRelative_index_js__ = __webpack_require__(387);
/* unused harmony reexport formatRelative */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__fromUnixTime_index_js__ = __webpack_require__(388);
/* unused harmony reexport fromUnixTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__getDate_index_js__ = __webpack_require__(202);
/* unused harmony reexport getDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__getDay_index_js__ = __webpack_require__(96);
/* unused harmony reexport getDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__getDayOfYear_index_js__ = __webpack_require__(389);
/* unused harmony reexport getDayOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__getDaysInMonth_index_js__ = __webpack_require__(203);
/* unused harmony reexport getDaysInMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__getDaysInYear_index_js__ = __webpack_require__(390);
/* unused harmony reexport getDaysInYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__getDecade_index_js__ = __webpack_require__(391);
/* unused harmony reexport getDecade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__getDefaultOptions_index_js__ = __webpack_require__(392);
/* unused harmony reexport getDefaultOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__getHours_index_js__ = __webpack_require__(393);
/* unused harmony reexport getHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__getISODay_index_js__ = __webpack_require__(205);
/* unused harmony reexport getISODay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__getISOWeek_index_js__ = __webpack_require__(206);
/* unused harmony reexport getISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__getISOWeekYear_index_js__ = __webpack_require__(50);
/* unused harmony reexport getISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__getISOWeeksInYear_index_js__ = __webpack_require__(394);
/* unused harmony reexport getISOWeeksInYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__getMilliseconds_index_js__ = __webpack_require__(395);
/* unused harmony reexport getMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__getMinutes_index_js__ = __webpack_require__(396);
/* unused harmony reexport getMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__getMonth_index_js__ = __webpack_require__(397);
/* unused harmony reexport getMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__getOverlappingDaysInIntervals_index_js__ = __webpack_require__(398);
/* unused harmony reexport getOverlappingDaysInIntervals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__getQuarter_index_js__ = __webpack_require__(185);
/* unused harmony reexport getQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__getSeconds_index_js__ = __webpack_require__(399);
/* unused harmony reexport getSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__getTime_index_js__ = __webpack_require__(207);
/* unused harmony reexport getTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__getUnixTime_index_js__ = __webpack_require__(400);
/* unused harmony reexport getUnixTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__getWeek_index_js__ = __webpack_require__(208);
/* unused harmony reexport getWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__getWeekOfMonth_index_js__ = __webpack_require__(401);
/* unused harmony reexport getWeekOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__getWeekYear_index_js__ = __webpack_require__(209);
/* unused harmony reexport getWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__getWeeksInMonth_index_js__ = __webpack_require__(402);
/* unused harmony reexport getWeeksInMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__getYear_index_js__ = __webpack_require__(403);
/* unused harmony reexport getYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__hoursToMilliseconds_index_js__ = __webpack_require__(404);
/* unused harmony reexport hoursToMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__hoursToMinutes_index_js__ = __webpack_require__(405);
/* unused harmony reexport hoursToMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__hoursToSeconds_index_js__ = __webpack_require__(406);
/* unused harmony reexport hoursToSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__intervalToDuration_index_js__ = __webpack_require__(407);
/* unused harmony reexport intervalToDuration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__intlFormat_index_js__ = __webpack_require__(408);
/* unused harmony reexport intlFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__intlFormatDistance_index_js__ = __webpack_require__(409);
/* unused harmony reexport intlFormatDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__isAfter_index_js__ = __webpack_require__(410);
/* unused harmony reexport isAfter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__isBefore_index_js__ = __webpack_require__(411);
/* unused harmony reexport isBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__isDate_index_js__ = __webpack_require__(182);
/* unused harmony reexport isDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__isEqual_index_js__ = __webpack_require__(412);
/* unused harmony reexport isEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__isExists_index_js__ = __webpack_require__(413);
/* unused harmony reexport isExists */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__isFirstDayOfMonth_index_js__ = __webpack_require__(414);
/* unused harmony reexport isFirstDayOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__isFriday_index_js__ = __webpack_require__(415);
/* unused harmony reexport isFriday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__isFuture_index_js__ = __webpack_require__(416);
/* unused harmony reexport isFuture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__isLastDayOfMonth_index_js__ = __webpack_require__(187);
/* unused harmony reexport isLastDayOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__isLeapYear_index_js__ = __webpack_require__(204);
/* unused harmony reexport isLeapYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__isMatch_index_js__ = __webpack_require__(417);
/* unused harmony reexport isMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__isMonday_index_js__ = __webpack_require__(461);
/* unused harmony reexport isMonday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__isPast_index_js__ = __webpack_require__(462);
/* unused harmony reexport isPast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__isSameDay_index_js__ = __webpack_require__(68);
/* unused harmony reexport isSameDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__isSameHour_index_js__ = __webpack_require__(214);
/* unused harmony reexport isSameHour */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__isSameISOWeek_index_js__ = __webpack_require__(216);
/* unused harmony reexport isSameISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__isSameISOWeekYear_index_js__ = __webpack_require__(463);
/* unused harmony reexport isSameISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__isSameMinute_index_js__ = __webpack_require__(217);
/* unused harmony reexport isSameMinute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__isSameMonth_index_js__ = __webpack_require__(218);
/* unused harmony reexport isSameMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__isSameQuarter_index_js__ = __webpack_require__(219);
/* unused harmony reexport isSameQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__isSameSecond_index_js__ = __webpack_require__(220);
/* unused harmony reexport isSameSecond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__isSameWeek_index_js__ = __webpack_require__(130);
/* unused harmony reexport isSameWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__isSameYear_index_js__ = __webpack_require__(222);
/* unused harmony reexport isSameYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__isSaturday_index_js__ = __webpack_require__(175);
/* unused harmony reexport isSaturday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__isSunday_index_js__ = __webpack_require__(111);
/* unused harmony reexport isSunday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__isThisHour_index_js__ = __webpack_require__(464);
/* unused harmony reexport isThisHour */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__isThisISOWeek_index_js__ = __webpack_require__(465);
/* unused harmony reexport isThisISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__isThisMinute_index_js__ = __webpack_require__(466);
/* unused harmony reexport isThisMinute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__isThisMonth_index_js__ = __webpack_require__(467);
/* unused harmony reexport isThisMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__isThisQuarter_index_js__ = __webpack_require__(468);
/* unused harmony reexport isThisQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__isThisSecond_index_js__ = __webpack_require__(469);
/* unused harmony reexport isThisSecond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__isThisWeek_index_js__ = __webpack_require__(470);
/* unused harmony reexport isThisWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__isThisYear_index_js__ = __webpack_require__(471);
/* unused harmony reexport isThisYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__isThursday_index_js__ = __webpack_require__(472);
/* unused harmony reexport isThursday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__isToday_index_js__ = __webpack_require__(473);
/* unused harmony reexport isToday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__isTomorrow_index_js__ = __webpack_require__(474);
/* unused harmony reexport isTomorrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__isTuesday_index_js__ = __webpack_require__(475);
/* unused harmony reexport isTuesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__isValid_index_js__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_142__isValid_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__isWednesday_index_js__ = __webpack_require__(476);
/* unused harmony reexport isWednesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__isWeekend_index_js__ = __webpack_require__(89);
/* unused harmony reexport isWeekend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__isWithinInterval_index_js__ = __webpack_require__(477);
/* unused harmony reexport isWithinInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__isYesterday_index_js__ = __webpack_require__(478);
/* unused harmony reexport isYesterday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__lastDayOfDecade_index_js__ = __webpack_require__(479);
/* unused harmony reexport lastDayOfDecade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__lastDayOfISOWeek_index_js__ = __webpack_require__(480);
/* unused harmony reexport lastDayOfISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__lastDayOfISOWeekYear_index_js__ = __webpack_require__(481);
/* unused harmony reexport lastDayOfISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__lastDayOfMonth_index_js__ = __webpack_require__(210);
/* unused harmony reexport lastDayOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__lastDayOfQuarter_index_js__ = __webpack_require__(482);
/* unused harmony reexport lastDayOfQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__lastDayOfWeek_index_js__ = __webpack_require__(223);
/* unused harmony reexport lastDayOfWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__lastDayOfYear_index_js__ = __webpack_require__(483);
/* unused harmony reexport lastDayOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__lightFormat_index_js__ = __webpack_require__(484);
/* unused harmony reexport lightFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__max_index_js__ = __webpack_require__(180);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__milliseconds_index_js__ = __webpack_require__(485);
/* unused harmony reexport milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__millisecondsToHours_index_js__ = __webpack_require__(486);
/* unused harmony reexport millisecondsToHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__millisecondsToMinutes_index_js__ = __webpack_require__(487);
/* unused harmony reexport millisecondsToMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__millisecondsToSeconds_index_js__ = __webpack_require__(488);
/* unused harmony reexport millisecondsToSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__min_index_js__ = __webpack_require__(181);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__minutesToHours_index_js__ = __webpack_require__(489);
/* unused harmony reexport minutesToHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__minutesToMilliseconds_index_js__ = __webpack_require__(490);
/* unused harmony reexport minutesToMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__minutesToSeconds_index_js__ = __webpack_require__(491);
/* unused harmony reexport minutesToSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__monthsToQuarters_index_js__ = __webpack_require__(492);
/* unused harmony reexport monthsToQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__monthsToYears_index_js__ = __webpack_require__(493);
/* unused harmony reexport monthsToYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__nextDay_index_js__ = __webpack_require__(39);
/* unused harmony reexport nextDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__nextFriday_index_js__ = __webpack_require__(494);
/* unused harmony reexport nextFriday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__nextMonday_index_js__ = __webpack_require__(495);
/* unused harmony reexport nextMonday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__nextSaturday_index_js__ = __webpack_require__(496);
/* unused harmony reexport nextSaturday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__nextSunday_index_js__ = __webpack_require__(497);
/* unused harmony reexport nextSunday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__nextThursday_index_js__ = __webpack_require__(498);
/* unused harmony reexport nextThursday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__nextTuesday_index_js__ = __webpack_require__(499);
/* unused harmony reexport nextTuesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__nextWednesday_index_js__ = __webpack_require__(500);
/* unused harmony reexport nextWednesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__parse_index_js__ = __webpack_require__(211);
/* unused harmony reexport parse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__parseISO_index_js__ = __webpack_require__(501);
/* unused harmony reexport parseISO */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__parseJSON_index_js__ = __webpack_require__(502);
/* unused harmony reexport parseJSON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__previousDay_index_js__ = __webpack_require__(40);
/* unused harmony reexport previousDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__previousFriday_index_js__ = __webpack_require__(503);
/* unused harmony reexport previousFriday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__previousMonday_index_js__ = __webpack_require__(504);
/* unused harmony reexport previousMonday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__previousSaturday_index_js__ = __webpack_require__(505);
/* unused harmony reexport previousSaturday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__previousSunday_index_js__ = __webpack_require__(506);
/* unused harmony reexport previousSunday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__previousThursday_index_js__ = __webpack_require__(507);
/* unused harmony reexport previousThursday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__previousTuesday_index_js__ = __webpack_require__(508);
/* unused harmony reexport previousTuesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__previousWednesday_index_js__ = __webpack_require__(509);
/* unused harmony reexport previousWednesday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__quartersToMonths_index_js__ = __webpack_require__(510);
/* unused harmony reexport quartersToMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__quartersToYears_index_js__ = __webpack_require__(511);
/* unused harmony reexport quartersToYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__roundToNearestMinutes_index_js__ = __webpack_require__(512);
/* unused harmony reexport roundToNearestMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__secondsToHours_index_js__ = __webpack_require__(513);
/* unused harmony reexport secondsToHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__secondsToMilliseconds_index_js__ = __webpack_require__(514);
/* unused harmony reexport secondsToMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__secondsToMinutes_index_js__ = __webpack_require__(515);
/* unused harmony reexport secondsToMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__set_index_js__ = __webpack_require__(516);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__setDate_index_js__ = __webpack_require__(517);
/* unused harmony reexport setDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__setDay_index_js__ = __webpack_require__(518);
/* unused harmony reexport setDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__setDayOfYear_index_js__ = __webpack_require__(519);
/* unused harmony reexport setDayOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__setDefaultOptions_index_js__ = __webpack_require__(520);
/* unused harmony reexport setDefaultOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__setHours_index_js__ = __webpack_require__(521);
/* unused harmony reexport setHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__setISODay_index_js__ = __webpack_require__(522);
/* unused harmony reexport setISODay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__setISOWeek_index_js__ = __webpack_require__(523);
/* unused harmony reexport setISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__setISOWeekYear_index_js__ = __webpack_require__(177);
/* unused harmony reexport setISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__setMilliseconds_index_js__ = __webpack_require__(524);
/* unused harmony reexport setMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__setMinutes_index_js__ = __webpack_require__(525);
/* unused harmony reexport setMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__setMonth_index_js__ = __webpack_require__(131);
/* unused harmony reexport setMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__setQuarter_index_js__ = __webpack_require__(526);
/* unused harmony reexport setQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__setSeconds_index_js__ = __webpack_require__(527);
/* unused harmony reexport setSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__setWeek_index_js__ = __webpack_require__(528);
/* unused harmony reexport setWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__setWeekYear_index_js__ = __webpack_require__(529);
/* unused harmony reexport setWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__setYear_index_js__ = __webpack_require__(530);
/* unused harmony reexport setYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__startOfDay_index_js__ = __webpack_require__(90);
/* unused harmony reexport startOfDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__startOfDecade_index_js__ = __webpack_require__(531);
/* unused harmony reexport startOfDecade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__startOfHour_index_js__ = __webpack_require__(215);
/* unused harmony reexport startOfHour */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__startOfISOWeek_index_js__ = __webpack_require__(42);
/* unused harmony reexport startOfISOWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__startOfISOWeekYear_index_js__ = __webpack_require__(67);
/* unused harmony reexport startOfISOWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__startOfMinute_index_js__ = __webpack_require__(123);
/* unused harmony reexport startOfMinute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__startOfMonth_index_js__ = __webpack_require__(95);
/* unused harmony reexport startOfMonth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__startOfQuarter_index_js__ = __webpack_require__(124);
/* unused harmony reexport startOfQuarter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__startOfSecond_index_js__ = __webpack_require__(221);
/* unused harmony reexport startOfSecond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__startOfToday_index_js__ = __webpack_require__(532);
/* unused harmony reexport startOfToday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__startOfTomorrow_index_js__ = __webpack_require__(533);
/* unused harmony reexport startOfTomorrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__startOfWeek_index_js__ = __webpack_require__(36);
/* unused harmony reexport startOfWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__startOfWeekYear_index_js__ = __webpack_require__(128);
/* unused harmony reexport startOfWeekYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__startOfYear_index_js__ = __webpack_require__(126);
/* unused harmony reexport startOfYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__startOfYesterday_index_js__ = __webpack_require__(534);
/* unused harmony reexport startOfYesterday */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__sub_index_js__ = __webpack_require__(535);
/* unused harmony reexport sub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__subBusinessDays_index_js__ = __webpack_require__(536);
/* unused harmony reexport subBusinessDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__subDays_index_js__ = __webpack_require__(97);
/* unused harmony reexport subDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__subHours_index_js__ = __webpack_require__(537);
/* unused harmony reexport subHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__subISOWeekYears_index_js__ = __webpack_require__(186);
/* unused harmony reexport subISOWeekYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__subMilliseconds_index_js__ = __webpack_require__(69);
/* unused harmony reexport subMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__subMinutes_index_js__ = __webpack_require__(538);
/* unused harmony reexport subMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__subMonths_index_js__ = __webpack_require__(224);
/* unused harmony reexport subMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__subQuarters_index_js__ = __webpack_require__(539);
/* unused harmony reexport subQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__subSeconds_index_js__ = __webpack_require__(540);
/* unused harmony reexport subSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__subWeeks_index_js__ = __webpack_require__(541);
/* unused harmony reexport subWeeks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__subYears_index_js__ = __webpack_require__(542);
/* unused harmony reexport subYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__toDate_index_js__ = __webpack_require__(1);
/* unused harmony reexport toDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__weeksToDays_index_js__ = __webpack_require__(543);
/* unused harmony reexport weeksToDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__yearsToMonths_index_js__ = __webpack_require__(544);
/* unused harmony reexport yearsToMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__yearsToQuarters_index_js__ = __webpack_require__(545);
/* unused harmony reexport yearsToQuarters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__constants_index_js__ = __webpack_require__(12);
/* unused harmony namespace reexport */
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

















































































































































































































































/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
 * @returns {Boolean} whether the time intervals are overlapping
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var leftStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
  var leftEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
  var rightStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
  var rightEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }
  if (options !== null && options !== void 0 && options.inclusive) {
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  }
  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_index_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__min_index_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 *
 * @param {Date | Number} date - the date to be bounded
 * @param {Interval} interval - the interval to bound to
 * @returns {Date} the date bounded by the start and the end of the interval
 * @throws {TypeError} 2 arguments required
 */
function clamp(date, _ref) {
  var start = _ref.start,
      end = _ref.end;
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__min_index_js__["a" /* default */])([Object(__WEBPACK_IMPORTED_MODULE_0__max_index_js__["a" /* default */])([date, start]), end]);
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return NaN;
  var timeToCompare = dateToCompare.getTime();
  var datesArray;
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = [];

    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }
  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate, index) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < Number(minDistance)) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date | Number} dateToCompare - the date to compare with
 * @param {Array<Date> | Array<number>} datesArray - the array to search
 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo(dirtyDateToCompare, dirtyDatesArray) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return new Date(NaN);
  var timeToCompare = dateToCompare.getTime();
  var datesArray;
  // `dirtyDatesArray` is undefined or null
  if (dirtyDatesArray == null) {
    datesArray = [];

    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  } else if (typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }
  var result;
  var minDistance;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = new Date(NaN);
      minDistance = NaN;
      return;
    }
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < Number(minDistance)) {
      result = currentDate;
      minDistance = distance;
    }
  });
  return result;
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @param {number} days - number of days to be converted
 *
 * @returns {number} the number of days converted in weeks
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */
function daysToWeeks(days) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var weeks = days / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["a" /* daysInWeek */];
  return Math.floor(weeks);
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isSameDay_index_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isWeekend_index_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(3);








/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of business days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */
function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyDateRight);
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isValid_index_js__["a" /* default */])(dateLeft) || !Object(__WEBPACK_IMPORTED_MODULE_3__isValid_index_js__["a" /* default */])(dateRight)) return NaN;
  var calendarDifference = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight);
  var sign = calendarDifference < 0 ? -1 : 1;
  var weeks = Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(calendarDifference / 7);
  var result = weeks * 5;
  dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(dateRight, weeks * 7);

  // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
  while (!Object(__WEBPACK_IMPORTED_MODULE_2__isSameDay_index_js__["a" /* default */])(dateLeft, dateRight)) {
    // sign is used to account for both negative and positive differences
    result += Object(__WEBPACK_IMPORTED_MODULE_4__isWeekend_index_js__["a" /* default */])(dateRight) ? 0 : sign;
    dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(dateRight, sign);
  }
  return result === 0 ? 0 : result;
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var startOfISOWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(dirtyDateLeft);
  var startOfISOWeekRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(dirtyDateRight);
  var timestampLeft = startOfISOWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfISOWeekLeft);
  var timestampRight = startOfISOWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfISOWeekRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);





/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateRight);
  var sign = Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight);
  var difference = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__["a" /* default */])(dateLeft, dateRight));
  dateLeft = Object(__WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__["a" /* default */])(dateLeft, sign * difference);

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOWeekYearNotFull = Number(Object(__WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a" /* default */])(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastISOWeekYearNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(51);



/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */
function differenceInQuarters(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__["a" /* default */])(dateLeft, dateRight) / 3;
  return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__ = __webpack_require__(51);



/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */
function differenceInWeeks(dateLeft, dateRight, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__["a" /* default */])(dateLeft, dateRight) / 7;
  return Object(__WEBPACK_IMPORTED_MODULE_2__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */
function eachHourOfInterval(dirtyInterval, options) {
  var _options$step;
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setMinutes(0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(currentDate));
    currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__addHours_index_js__["a" /* default */])(currentDate, step);
  }
  return dates;
}

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfMinute_index_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The step must be equal to or greater than 1
 * @throws {TypeError} 1 argument required
 * @returns {Date[]} the array with starts of minutes from the minute of the interval start to the minute of the interval end
 * @throws {RangeError} `options.step` must be a number equal to or greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */
function eachMinuteOfInterval(interval, options) {
  var _options$step;
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__startOfMinute_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(interval.start));
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();
  if (startTime >= endTime) {
    throw new RangeError('Invalid interval');
  }
  var dates = [];
  var currentDate = startDate;
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal to or greater than 1');
  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(currentDate));
    currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__["a" /* default */])(currentDate, step);
  }
  return dates;
}

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */
function eachMonthOfInterval(dirtyInterval) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime();
  var dates = [];

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);
  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(currentDate));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }
  return dates;
}

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */
function eachQuarterOfInterval(dirtyInterval) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var startDateQuarter = Object(__WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a" /* default */])(startDate);
  var endDateQuarter = Object(__WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a" /* default */])(endDate);
  endTime = endDateQuarter.getTime();
  var quarters = [];
  var currentQuarter = startDateQuarter;
  while (currentQuarter.getTime() <= endTime) {
    quarters.push(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(currentQuarter));
    currentQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__["a" /* default */])(currentQuarter, 1);
  }
  return quarters;
}

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */
function eachWeekOfInterval(dirtyInterval, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var startDateWeek = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a" /* default */])(startDate, options);
  var endDateWeek = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a" /* default */])(endDate, options);

  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  endTime = endDateWeek.getTime();
  var weeks = [];
  var currentWeek = startDateWeek;
  while (currentWeek.getTime() <= endTime) {
    currentWeek.setHours(0);
    weeks.push(Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(currentWeek));
    currentWeek = Object(__WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__["a" /* default */])(currentWeek, 1);
    currentWeek.setHours(15);
  }
  return weeks;
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @param {Date|Number} date - the given month
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */
function eachWeekendOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__["a" /* default */])(dirtyDate);
  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a" /* default */])(dirtyDate);
  return Object(__WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a" /* default */])({
    start: startDate,
    end: endDate
  });
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__endOfYear_index_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfYear_index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @param {Date|Number} date - the given year
 * @returns {Date[]} an array containing all the Saturdays and Sundays
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The passed date is invalid
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */
function eachWeekendOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_2__startOfYear_index_js__["a" /* default */])(dirtyDate);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_1__endOfYear_index_js__["a" /* default */])(dirtyDate);
  return Object(__WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a" /* default */])({
    start: startDate,
    end: endDate
  });
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */
function eachYearOfInterval(dirtyInterval) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start);
  var endDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end);
  var endTime = endDate.getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);
  while (currentDate.getTime() <= endTime) {
    dates.push(Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + 1);
  }
  return dates;
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a decade
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */
function endOfDecade(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade, 11, 31);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__["a" /* default */])(dirtyDate, {
    weekStartsOn: 1
  });
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setSeconds(59, 999);
  return date;
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  date.setMilliseconds(999);
  return date;
}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__ = __webpack_require__(121);

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__["a" /* default */])(Date.now());
}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__ = __webpack_require__(196);







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date);

    // Padding
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCWeek_index_js__["a" /* default */])(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCISOWeek_index_js__["a" /* default */])(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCDayOfYear_index_js__["a" /* default */])(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return __WEBPACK_IMPORTED_MODULE_6__lightFormatters_index_js__["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_5__addLeadingZeros_index_js__["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0);



function startOfUTCISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__ = __webpack_require__(13);





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCWeekYear_index_js__["a" /* default */])(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeek, options);
  return date;
}

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(376);





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0 /* Sunday */
    , firstWeekContainsDate: 1
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ __webpack_exports__["a"] = (formatDistance);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(372);

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ __webpack_exports__["a"] = (formatRelative);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(375);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(378);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function formatDistanceToNow(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__["a" /* default */])(dirtyDate, Date.now(), options);
}

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function formatDistanceToNowStrict(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__["a" /* default */])(dirtyDate, Date.now(), options);
}

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_defaultLocale_index_js__ = __webpack_require__(53);


var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];

/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @param {Duration} duration - the duration to format
 * @param {Object} [options] - an object with options.
 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
 * @param {boolean} [options.zero=false] - should zeros be included in the output?
 * @param {string} [options.delimiter=' '] - delimiter string
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {string} the formatted date string
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */
function formatDuration(duration, options) {
  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_1__lib_defaultLocale_index_js__["a" /* default */];
  var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
  if (!locale.formatDistance) {
    return '';
  }
  var result = format.reduce(function (acc, unit) {
    var token = "x".concat(unit.replace(/(^.)/, function (m) {
      return m.toUpperCase();
    }));
    var value = duration[unit];
    if (typeof value === 'number' && (zero || duration[unit])) {
      return acc.concat(locale.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */
function formatISO(date, options) {
  var _options$format, _options$representati;
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(date);
  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }
  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : '';

  // Representation is either 'date' or 'complete'
  if (representation !== 'time') {
    var day = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getDate(), 2);
    var month = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMonth() + 1, 2);
    var year = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }

  // Representation is either 'time' or 'complete'
  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();
    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(absoluteOffset % 60, 2);
      // If less than 0, the sign is +, because it is ahead of time.
      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }
    var hour = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getHours(), 2);
    var minute = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMinutes(), 2);
    var second = Object(__WEBPACK_IMPORTED_MODULE_1__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getSeconds(), 2);

    // If there's also date, separate it with time with 'T'
    var separator = result === '' ? '' : 'T';

    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
    var time = [hour, minute, second].join(timeDelimiter);

    // HHmmss or HH:mm:ss.
    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }
  return result;
}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(52);



/**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */
function formatISO9075(dirtyDate, options) {
  var _options$format, _options$representati;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : '';

  // Representation is either 'date' or 'complete'
  if (representation !== 'time') {
    var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getDate(), 2);
    var month = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMonth() + 1, 2);
    var year = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }

  // Representation is either 'time' or 'complete'
  if (representation !== 'date') {
    var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getHours(), 2);
    var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMinutes(), 2);
    var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getSeconds(), 2);

    // If there's also date, separate it with time with a space
    var separator = result === '' ? '' : ' ';

    // HHmmss or HH:mm:ss.
    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
  }
  return result;
}

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param {Duration} duration - the duration to format
 *
 * @returns {String} The ISO 8601 duration string
 * @throws {TypeError} Requires 1 argument
 * @throws {Error} Argument must be an object
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */
function formatISODuration(duration) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(duration) !== 'object') throw new Error('Duration must be an object');
  var _duration$years = duration.years,
      years = _duration$years === void 0 ? 0 : _duration$years,
      _duration$months = duration.months,
      months = _duration$months === void 0 ? 0 : _duration$months,
      _duration$days = duration.days,
      days = _duration$days === void 0 ? 0 : _duration$days,
      _duration$hours = duration.hours,
      hours = _duration$hours === void 0 ? 0 : _duration$hours,
      _duration$minutes = duration.minutes,
      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
      _duration$seconds = duration.seconds,
      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(3);




/**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
 * //=> '2019-09-18T19:00:52.23Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
 * //=> '2019-09-18T19:00:52.234Z'
 */
function formatRFC3339(dirtyDate, options) {
  var _options$fractionDigi;
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0);

  // Test if fractionDigits is between 0 and 3 _and_ is not NaN
  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
  }
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getDate(), 2);
  var month = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMonth() + 1, 2);
  var year = originalDate.getFullYear();
  var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getHours(), 2);
  var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getMinutes(), 2);
  var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getSeconds(), 2);
  var fractionalSecond = '';
  if (fractionDigits > 0) {
    var milliseconds = originalDate.getMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
    fractionalSecond = '.' + Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, fractionDigits);
  }
  var offset = '';
  var tzOffset = originalDate.getTimezoneOffset();
  if (tzOffset !== 0) {
    var absoluteOffset = Math.abs(tzOffset);
    var hourOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(absoluteOffset / 60), 2);
    var minuteOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(absoluteOffset % 60, 2);
    // If less than 0, the sign is +, because it is ahead of time.
    var sign = tzOffset < 0 ? '+' : '-';
    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
  } else {
    offset = 'Z';
  }
  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(52);



var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {String} the formatted date string
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */
function formatRFC7231(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var dayName = days[originalDate.getUTCDay()];
  var dayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getUTCDate(), 2);
  var monthName = months[originalDate.getUTCMonth()];
  var year = originalDate.getUTCFullYear();
  var hour = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getUTCHours(), 2);
  var minute = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getUTCMinutes(), 2);
  var second = Object(__WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a" /* default */])(originalDate.getUTCSeconds(), 2);

  // Result variables.
  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_index_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_defaultLocale_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(3);









/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @param {Date|Number} date - the date to format
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {String} the date in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(addDays(new Date(), -6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */
function formatRelative(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyDate);
  var baseDate = Object(__WEBPACK_IMPORTED_MODULE_5__toDate_index_js__["a" /* default */])(dirtyBaseDate);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : __WEBPACK_IMPORTED_MODULE_3__lib_defaultLocale_index_js__["a" /* default */];
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  if (!locale.formatRelative) {
    throw new RangeError('locale must contain formatRelative property');
  }
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(date, baseDate);
  if (isNaN(diff)) {
    throw new RangeError('Invalid time value');
  }
  var token;
  if (diff < -6) {
    token = 'other';
  } else if (diff < -1) {
    token = 'lastWeek';
  } else if (diff < 0) {
    token = 'yesterday';
  } else if (diff < 1) {
    token = 'today';
  } else if (diff < 2) {
    token = 'tomorrow';
  } else if (diff < 7) {
    token = 'nextWeek';
  } else {
    token = 'other';
  }
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var utcBaseDate = Object(__WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__["a" /* default */])(baseDate, Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(baseDate));
  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
  return Object(__WEBPACK_IMPORTED_MODULE_2__format_index_js__["a" /* default */])(date, formatStr, {
    locale: locale,
    weekStartsOn: weekStartsOn
  });
}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param {Number} unixTime - the given Unix timestamp (in seconds)
 * @returns {Date} the date
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(dirtyUnixTime) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var unixTime = Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(dirtyUnixTime);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(unixTime * 1000);
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a" /* default */])(date));
  var dayOfYear = diff + 1;
  return dayOfYear;
}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  if (String(new Date(date)) === 'Invalid Date') {
    return NaN;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__["a" /* default */])(date) ? 366 : 365;
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year of decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */
function getDecade(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  return decade;
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_assign_index_js__ = __webpack_require__(72);


/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions]{@link https://date-fns.org/docs/setDefaultOptions}.
 *
 * @returns {Object} default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__lib_assign_index_js__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])());
}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var thisYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var nextYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a" /* default */])(thisYear, 60));
  var diff = nextYear.valueOf() - thisYear.valueOf();
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var milliseconds = date.getMilliseconds();
  return milliseconds;
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals
 *
 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
 * @returns {Number} the number of days that overlap in two time intervals
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */

function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var intervalLeft = dirtyIntervalLeft || {};
  var intervalRight = dirtyIntervalRight || {};
  var leftStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.start).getTime();
  var leftEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalLeft.end).getTime();
  var rightStartTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.start).getTime();
  var rightEndTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(intervalRight.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError('Invalid interval');
  }
  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
  if (!isOverlapping) {
    return 0;
  }
  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
  var differenceInMs = overlapEndDate - overlapStartDate;
  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTime_index_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__getTime_index_js__["a" /* default */])(dirtyDate) / 1000);
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDate_index_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDay_index_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__startOfMonth_index_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__ = __webpack_require__(3);






/**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the week of month
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */
function getWeekOfMonth(date, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_5__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var currentDayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_1__getDate_index_js__["a" /* default */])(date);
  if (isNaN(currentDayOfMonth)) return NaN;
  var startWeekDay = Object(__WEBPACK_IMPORTED_MODULE_2__getDay_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__startOfMonth_index_js__["a" /* default */])(date));
  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__["a" /* default */])(date), Object(__WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__["a" /* default */])(date), options) + 1;
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getFullYear();
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted to milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */
function hoursToMilliseconds(hours) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["b" /* millisecondsInHour */]);
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */
function hoursToMinutes(hours) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["e" /* minutesInHour */]);
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @param {number} hours - number of hours to be converted
 *
 * @returns {number} the number of hours converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */
function hoursToSeconds(hours) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(hours * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["j" /* secondsInHour */]);
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_index_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInDays_index_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differenceInHours_index_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__differenceInMinutes_index_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__differenceInMonths_index_js__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__differenceInYears_index_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0);










/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @param {Interval} interval - the interval to convert to duration
 *
 * @returns {Duration} The duration Object
 * @throws {TypeError} Requires 2 arguments
 * @throws {RangeError} `start` must not be Invalid Date
 * @throws {RangeError} `end` must not be Invalid Date
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */
function intervalToDuration(interval) {
  Object(__WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var start = Object(__WEBPACK_IMPORTED_MODULE_8__toDate_index_js__["a" /* default */])(interval.start);
  var end = Object(__WEBPACK_IMPORTED_MODULE_8__toDate_index_js__["a" /* default */])(interval.end);
  if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
  if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
  var duration = {};
  duration.years = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_7__differenceInYears_index_js__["a" /* default */])(end, start));
  var sign = Object(__WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a" /* default */])(end, start);
  var remainingMonths = Object(__WEBPACK_IMPORTED_MODULE_1__add_index_js__["a" /* default */])(start, {
    years: sign * duration.years
  });
  duration.months = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_5__differenceInMonths_index_js__["a" /* default */])(end, remainingMonths));
  var remainingDays = Object(__WEBPACK_IMPORTED_MODULE_1__add_index_js__["a" /* default */])(remainingMonths, {
    months: sign * duration.months
  });
  duration.days = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_2__differenceInDays_index_js__["a" /* default */])(end, remainingDays));
  var remainingHours = Object(__WEBPACK_IMPORTED_MODULE_1__add_index_js__["a" /* default */])(remainingDays, {
    days: sign * duration.days
  });
  duration.hours = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_3__differenceInHours_index_js__["a" /* default */])(end, remainingHours));
  var remainingMinutes = Object(__WEBPACK_IMPORTED_MODULE_1__add_index_js__["a" /* default */])(remainingHours, {
    hours: sign * duration.hours
  });
  duration.minutes = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_4__differenceInMinutes_index_js__["a" /* default */])(end, remainingMinutes));
  var remainingSeconds = Object(__WEBPACK_IMPORTED_MODULE_1__add_index_js__["a" /* default */])(remainingMinutes, {
    minutes: sign * duration.minutes
  });
  duration.seconds = Math.abs(Object(__WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__["a" /* default */])(end, remainingSeconds));
  return duration;
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);

/**
 * @name intlFormat
 * @category Common Helpers
 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @param {Date|Number} argument - the original date.
 * @param {Object} [formatOptions] - an object with options.
 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
 * @param {String} [formatOptions.timeZone] - the time zone to use.
 * @param {Object} [localeOptions] - an object with locale.
 * @param {String|String[]} [localeOptions.locale] - the locale code
 * @returns {String} the formatted date string.
 * @throws {TypeError} 1 argument required.
 * @throws {RangeError} `date` must not be Invalid Date
 *
 * @example
 * // Represent 10 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      weekday: 'long',
 *      year: 'numeric',
 *      month: 'long',
 *      day: 'numeric',
 *    }, {
 *      locale: 'de-DE',
 *  })
 * //=> Freitag, 4. Oktober 2019
 *
 * @example
 * // Represent 10 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      year: 'numeric',
 *      month: 'numeric',
 *      day: 'numeric',
 *      hour: 'numeric',
 *  })
 * //=> 10/4/2019, 12 PM
 *
 * @example
 * // Represent 10 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *      locale: 'ko-KR',
 *  })
 * //=> 2019. 10. 4.
 *
 * @example
 * // Represent 10 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */
function intlFormat(date, formatOrLocale, localeOptions) {
  var _localeOptions;
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}
function isFormatOptions(opts) {
  return opts !== undefined && !('locale' in opts);
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarMonths_index_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarQuarters_index_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__differenceInCalendarWeeks_index_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__differenceInCalendarYears_index_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__differenceInHours_index_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__differenceInMinutes_index_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__differenceInSeconds_index_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_requiredArgs_index_js__ = __webpack_require__(0);











/**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with.
 * @param {Object} [options] - an object with options.
 * @param {String} [options.unit] - formats the distance with the given unit ('year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second').
 * @param {String|String[]} [options.locale] - the locale to use.
 * @param {String} [options.localeMatcher='best fit'] - the locale matching algorithm to use. Other value: 'lookup'.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * @param {String} [options.numeric='auto'] - the output message format. The values are 'auto' (e.g. `yesterday`), 'always'(e.g. `1 day ago`).
 * @param {String} [options.style='long'] - the length of the result. The values are: 'long' (e.g. `1 month`), 'short' (e.g. 'in 1 mo.'), 'narrow' (e.g. 'in 1 mo.').
 * The narrow one could be similar to the short one for some locales.
 * @returns {String} the distance in words according to language-sensitive relative time formatting.
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.unit` must not be invalid Unit
 * @throws {RangeError} `options.locale` must not be invalid locale
 * @throws {RangeError} `options.localeMatcher` must not be invalid localeMatcher
 * @throws {RangeError} `options.numeric` must not be invalid numeric
 * @throws {RangeError} `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */
function intlFormatDistance(date, baseDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_10__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var value = 0;
  var unit;
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a" /* default */])(date);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a" /* default */])(baseDate);
  if (!(options !== null && options !== void 0 && options.unit)) {
    // Get the unit based on diffInSeconds calculations if no unit is specified
    var diffInSeconds = Object(__WEBPACK_IMPORTED_MODULE_8__differenceInSeconds_index_js__["a" /* default */])(dateLeft, dateRight); // The smallest unit

    if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["k" /* secondsInMinute */]) {
      value = Object(__WEBPACK_IMPORTED_MODULE_8__differenceInSeconds_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'second';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["j" /* secondsInHour */]) {
      value = Object(__WEBPACK_IMPORTED_MODULE_7__differenceInMinutes_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'minute';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["i" /* secondsInDay */] && Math.abs(Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight)) < 1) {
      value = Object(__WEBPACK_IMPORTED_MODULE_6__differenceInHours_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'hour';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["n" /* secondsInWeek */] && (value = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight)) && Math.abs(value) < 7) {
      unit = 'day';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["l" /* secondsInMonth */]) {
      value = Object(__WEBPACK_IMPORTED_MODULE_4__differenceInCalendarWeeks_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'week';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["m" /* secondsInQuarter */]) {
      value = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarMonths_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'month';
    } else if (Math.abs(diffInSeconds) < __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["o" /* secondsInYear */]) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarQuarters_index_js__["a" /* default */])(dateLeft, dateRight) < 4) {
        // To filter out cases that are less than a year but match 4 quarters
        value = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarQuarters_index_js__["a" /* default */])(dateLeft, dateRight);
        unit = 'quarter';
      } else {
        value = Object(__WEBPACK_IMPORTED_MODULE_5__differenceInCalendarYears_index_js__["a" /* default */])(dateLeft, dateRight);
        unit = 'year';
      }
    } else {
      value = Object(__WEBPACK_IMPORTED_MODULE_5__differenceInCalendarYears_index_js__["a" /* default */])(dateLeft, dateRight);
      unit = 'year';
    }
  } else {
    // Get the value if unit is specified
    unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'second') {
      value = Object(__WEBPACK_IMPORTED_MODULE_8__differenceInSeconds_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'minute') {
      value = Object(__WEBPACK_IMPORTED_MODULE_7__differenceInMinutes_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'hour') {
      value = Object(__WEBPACK_IMPORTED_MODULE_6__differenceInHours_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'day') {
      value = Object(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'week') {
      value = Object(__WEBPACK_IMPORTED_MODULE_4__differenceInCalendarWeeks_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'month') {
      value = Object(__WEBPACK_IMPORTED_MODULE_2__differenceInCalendarMonths_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'quarter') {
      value = Object(__WEBPACK_IMPORTED_MODULE_3__differenceInCalendarQuarters_index_js__["a" /* default */])(dateLeft, dateRight);
    } else if (unit === 'year') {
      value = Object(__WEBPACK_IMPORTED_MODULE_5__differenceInCalendarYears_index_js__["a" /* default */])(dateLeft, dateRight);
    }
  }
  var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
    localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
    numeric: (options === null || options === void 0 ? void 0 : options.numeric) || 'auto',
    style: options === null || options === void 0 ? void 0 : options.style
  });
  return rtf.format(value, unit);
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyLeftDate);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param {Number} year of the date to check
 * @param {Number} month of the date to check
 * @param {Number} day of the date to check
 * @returns {Boolean} the date exists
 * @throws {TypeError} 3 arguments required
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */
function isExists(year, month, day) {
  if (arguments.length < 3) {
    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
  }
  var date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDate() === 1;
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 5;
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getTime() > Date.now();
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_index_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 *
 *
 * @param {String} dateString - the date string to verify
 * @param {String} formatString - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Boolean}
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateString, formatString, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__parse_index_js__["a" /* default */])(dateString, formatString, new Date(), options));
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createForOfIteratorHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unsupportedIterableToArray_js__ = __webpack_require__(419);

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Object(__WEBPACK_IMPORTED_MODULE_0__unsupportedIterableToArray_js__["a" /* default */])(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
          F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
      a = !0,
      u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _unsupportedIterableToArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(420);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(r, a) : void 0;
  }
}


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayLikeToArray; });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) {
    n[e] = r[e];
  }return n;
}


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _isNativeReflectConstruct; });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(4);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(t);
}


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(20);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EraParser_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YearParser_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocalWeekYearParser_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ISOWeekYearParser_js__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExtendedYearParser_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuarterParser_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StandAloneQuarterParser_js__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MonthParser_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StandAloneMonthParser_js__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocalWeekParser_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ISOWeekParser_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DateParser_js__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DayOfYearParser_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DayParser_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LocalDayParser_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StandAloneLocalDayParser_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ISODayParser_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AMPMParser_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AMPMMidnightParser_js__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DayPeriodParser_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Hour1to12Parser_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Hour0to23Parser_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Hour0To11Parser_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Hour1To24Parser_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__MinuteParser_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SecondParser_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FractionOfSecondParser_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ISOTimezoneWithZParser_js__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ISOTimezoneParser_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__TimestampSecondsParser_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__TimestampMillisecondsParser_js__ = __webpack_require__(460);































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new __WEBPACK_IMPORTED_MODULE_0__EraParser_js__["a" /* EraParser */](),
  y: new __WEBPACK_IMPORTED_MODULE_1__YearParser_js__["a" /* YearParser */](),
  Y: new __WEBPACK_IMPORTED_MODULE_2__LocalWeekYearParser_js__["a" /* LocalWeekYearParser */](),
  R: new __WEBPACK_IMPORTED_MODULE_3__ISOWeekYearParser_js__["a" /* ISOWeekYearParser */](),
  u: new __WEBPACK_IMPORTED_MODULE_4__ExtendedYearParser_js__["a" /* ExtendedYearParser */](),
  Q: new __WEBPACK_IMPORTED_MODULE_5__QuarterParser_js__["a" /* QuarterParser */](),
  q: new __WEBPACK_IMPORTED_MODULE_6__StandAloneQuarterParser_js__["a" /* StandAloneQuarterParser */](),
  M: new __WEBPACK_IMPORTED_MODULE_7__MonthParser_js__["a" /* MonthParser */](),
  L: new __WEBPACK_IMPORTED_MODULE_8__StandAloneMonthParser_js__["a" /* StandAloneMonthParser */](),
  w: new __WEBPACK_IMPORTED_MODULE_9__LocalWeekParser_js__["a" /* LocalWeekParser */](),
  I: new __WEBPACK_IMPORTED_MODULE_10__ISOWeekParser_js__["a" /* ISOWeekParser */](),
  d: new __WEBPACK_IMPORTED_MODULE_11__DateParser_js__["a" /* DateParser */](),
  D: new __WEBPACK_IMPORTED_MODULE_12__DayOfYearParser_js__["a" /* DayOfYearParser */](),
  E: new __WEBPACK_IMPORTED_MODULE_13__DayParser_js__["a" /* DayParser */](),
  e: new __WEBPACK_IMPORTED_MODULE_14__LocalDayParser_js__["a" /* LocalDayParser */](),
  c: new __WEBPACK_IMPORTED_MODULE_15__StandAloneLocalDayParser_js__["a" /* StandAloneLocalDayParser */](),
  i: new __WEBPACK_IMPORTED_MODULE_16__ISODayParser_js__["a" /* ISODayParser */](),
  a: new __WEBPACK_IMPORTED_MODULE_17__AMPMParser_js__["a" /* AMPMParser */](),
  b: new __WEBPACK_IMPORTED_MODULE_18__AMPMMidnightParser_js__["a" /* AMPMMidnightParser */](),
  B: new __WEBPACK_IMPORTED_MODULE_19__DayPeriodParser_js__["a" /* DayPeriodParser */](),
  h: new __WEBPACK_IMPORTED_MODULE_20__Hour1to12Parser_js__["a" /* Hour1to12Parser */](),
  H: new __WEBPACK_IMPORTED_MODULE_21__Hour0to23Parser_js__["a" /* Hour0to23Parser */](),
  K: new __WEBPACK_IMPORTED_MODULE_22__Hour0To11Parser_js__["a" /* Hour0To11Parser */](),
  k: new __WEBPACK_IMPORTED_MODULE_23__Hour1To24Parser_js__["a" /* Hour1To24Parser */](),
  m: new __WEBPACK_IMPORTED_MODULE_24__MinuteParser_js__["a" /* MinuteParser */](),
  s: new __WEBPACK_IMPORTED_MODULE_25__SecondParser_js__["a" /* SecondParser */](),
  S: new __WEBPACK_IMPORTED_MODULE_26__FractionOfSecondParser_js__["a" /* FractionOfSecondParser */](),
  X: new __WEBPACK_IMPORTED_MODULE_27__ISOTimezoneWithZParser_js__["a" /* ISOTimezoneWithZParser */](),
  x: new __WEBPACK_IMPORTED_MODULE_28__ISOTimezoneParser_js__["a" /* ISOTimezoneParser */](),
  t: new __WEBPACK_IMPORTED_MODULE_29__TimestampSecondsParser_js__["a" /* TimestampSecondsParser */](),
  T: new __WEBPACK_IMPORTED_MODULE_30__TimestampMillisecondsParser_js__["a" /* TimestampMillisecondsParser */]()
};

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EraParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);







var EraParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(EraParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(EraParser);
  function EraParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 140);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YearParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(YearParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(YearParser);
  function YearParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 130);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(4, dateString), valueCallback);
        case 'yo':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["d" /* normalizeTwoDigitYear */])(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalWeekYearParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_getUTCWeekYear_index_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_startOfUTCWeek_index_js__ = __webpack_require__(71);










// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(LocalWeekYearParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 130);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(4, dateString), valueCallback);
        case 'Yo':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = Object(__WEBPACK_IMPORTED_MODULE_8__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["d" /* normalizeTwoDigitYear */])(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return Object(__WEBPACK_IMPORTED_MODULE_9__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_9__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISOWeekYearParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(70);








 // ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ISOWeekYearParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 130);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["g" /* parseNDigitsSigned */])(4, dateString);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["g" /* parseNDigitsSigned */])(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_8__lib_startOfUTCISOWeek_index_js__["a" /* default */])(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendedYearParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ExtendedYearParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 130);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["g" /* parseNDigitsSigned */])(4, dateString);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["g" /* parseNDigitsSigned */])(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuarterParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var QuarterParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(QuarterParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(QuarterParser);
  function QuarterParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 120);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandAloneQuarterParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(StandAloneQuarterParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 120);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonthParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_js__ = __webpack_require__(17);









var MonthParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(MonthParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(MonthParser);
  function MonthParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 110);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* numericPatterns */].month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["f" /* parseNDigits */])(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(__WEBPACK_IMPORTED_MODULE_7__Parser_js__["a" /* Parser */]);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandAloneMonthParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(StandAloneMonthParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 110);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalWeekParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_setUTCWeek_index_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_startOfUTCWeek_index_js__ = __webpack_require__(71);










 // Local week of year
var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(LocalWeekParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 100);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__lib_startOfUTCWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__lib_setUTCWeek_index_js__["a" /* default */])(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var week = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a" /* default */])(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISOWeekParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_setUTCISOWeek_index_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(70);










 // ISO week of year
var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ISOWeekParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 100);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__lib_startOfUTCISOWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__lib_setUTCISOWeek_index_js__["a" /* default */])(date, value));
    }
  }]);
  return ISOWeekParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  Object(__WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyISOWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a" /* default */])(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_js__ = __webpack_require__(17);









var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(DateParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DateParser);
  function DateParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "subPriority", 1);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* numericPatterns */].date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = Object(__WEBPACK_IMPORTED_MODULE_6__utils_js__["b" /* isLeapYearIndex */])(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(__WEBPACK_IMPORTED_MODULE_7__Parser_js__["a" /* Parser */]);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayOfYearParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(DayOfYearParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "subpriority", 1);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["b" /* isLeapYearIndex */])(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_setUTCDay_index_js__ = __webpack_require__(129);







 // Day of week
var DayParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(DayParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DayParser);
  function DayParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_7__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalDayParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_setUTCDay_index_js__ = __webpack_require__(129);








 // Local day of week
var LocalDayParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(LocalDayParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(LocalDayParser);
  function LocalDayParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_8__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandAloneLocalDayParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_setUTCDay_index_js__ = __webpack_require__(129);








 // Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(StandAloneLocalDayParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_8__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISODayParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_setUTCISODay_index_js__ = __webpack_require__(446);








 // ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ISODayParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ISODayParser);
  function ISODayParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 90);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = Object(__WEBPACK_IMPORTED_MODULE_8__lib_setUTCISODay_index_js__["a" /* default */])(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__ = __webpack_require__(3);



function setUTCISODay(dirtyDate, dirtyDay) {
  Object(__WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a" /* default */])(2, arguments);
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__toInteger_index_js__["a" /* default */])(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AMPMParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var AMPMParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(AMPMParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(AMPMParser);
  function AMPMParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 80);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["a" /* dayPeriodEnumToHours */])(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AMPMMidnightParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(AMPMMidnightParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 80);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["a" /* dayPeriodEnumToHours */])(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPeriodParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);







 // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(DayPeriodParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 80);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["a" /* dayPeriodEnumToHours */])(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hour1to12Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Hour1to12Parser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 70);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hour0to23Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Hour0to23Parser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 70);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hour0To11Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Hour0To11Parser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 70);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hour1To24Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Hour1To24Parser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 70);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MinuteParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var MinuteParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(MinuteParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(MinuteParser);
  function MinuteParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 60);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SecondParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);









var SecondParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(SecondParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(SecondParser);
  function SecondParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 50);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["h" /* parseNumericPattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["a" /* numericPatterns */].second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["f" /* parseNDigits */])(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FractionOfSecondParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(FractionOfSecondParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 30);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["c" /* mapValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["f" /* parseNDigits */])(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISOTimezoneWithZParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);








 // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ISOTimezoneWithZParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 10);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basicOptionalMinutes, dateString);
        case 'XX':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basic, dateString);
        case 'XXXX':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basicOptionalSeconds, dateString);
        case 'XXXXX':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISOTimezoneParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_js__ = __webpack_require__(11);








 // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(ISOTimezoneParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 10);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basicOptionalMinutes, dateString);
        case 'xx':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basic, dateString);
        case 'xxxx':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].basicOptionalSeconds, dateString);
        case 'xxxxx':
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return Object(__WEBPACK_IMPORTED_MODULE_8__utils_js__["i" /* parseTimezonePattern */])(__WEBPACK_IMPORTED_MODULE_7__constants_js__["b" /* timezonePatterns */].extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimestampSecondsParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(TimestampSecondsParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 40);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", '*');
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["e" /* parseAnyDigitsSigned */])(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimestampMillisecondsParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Parser_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(11);








var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(TimestampMillisecondsParser, _Parser);
  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "priority", 20);
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), "incompatibleTokens", '*');
    return _this;
  }
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_js__["e" /* parseAnyDigitsSigned */])(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(__WEBPACK_IMPORTED_MODULE_6__Parser_js__["a" /* Parser */]);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(date).getDay() === 1;
}

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getTime() < Date.now();
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */
function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var dateLeftStartOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a" /* default */])(dirtyDateLeft);
  var dateRightStartOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a" /* default */])(dirtyDateRight);
  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__["a" /* default */])(Date.now(), dirtyDate);
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__["a" /* default */])(dirtyDate, Date.now());
}

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__["a" /* default */])(Date.now(), dirtyDate);
}

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__["a" /* default */])(Date.now(), dirtyDate);
}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__["a" /* default */])(Date.now(), dirtyDate);
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__["a" /* default */])(Date.now(), dirtyDate);
}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */

function isThisWeek(dirtyDate, options) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a" /* default */])(dirtyDate, Date.now(), options);
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__["a" /* default */])(dirtyDate, Date.now());
}

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 4;
}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a" /* default */])(dirtyDate, Date.now());
}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__["a" /* default */])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(Date.now(), 1));
}

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 2;
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getDay() === 3;
}

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var time = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate).getTime();
  var startTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.start).getTime();
  var endTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subDays_index_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a" /* default */])(dirtyDate, Object(__WEBPACK_IMPORTED_MODULE_1__subDays_index_js__["a" /* default */])(Date.now(), 1));
}

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */
function lastDayOfDecade(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__["a" /* default */])(dirtyDate, {
    weekStartsOn: 1
  });
}

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOWeekYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  date.setDate(date.getDate() - 1);
  return date;
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the last day of a quarter
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isValid_index_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__ = __webpack_require__(0);





 // This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */

function lightFormat(dirtyDate, formatStr) {
  Object(__WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isValid_index_js__["a" /* default */])(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var tokens = formatStr.match(formattingTokensRegExp);

  // The only case when formattingTokensRegExp doesn't match the string is when it's empty
  if (!tokens) return '';
  var result = tokens.map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__["a" /* default */][firstCharacter];
    if (formatter) {
      return formatter(utcDate, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matches = input.match(escapedStringRegExp);
  if (!matches) {
    return input;
  }
  return matches[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);

// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
var daysInYear = 365.2425;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {number} the milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */
function milliseconds(_ref) {
  var years = _ref.years,
      months = _ref.months,
      weeks = _ref.weeks,
      days = _ref.days,
      hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var totalDays = 0;
  if (years) totalDays += years * daysInYear;
  if (months) totalDays += months * (daysInYear / 12);
  if (weeks) totalDays += weeks * 7;
  if (days) totalDays += days;
  var totalSeconds = totalDays * 24 * 60 * 60;
  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;
  return Math.round(totalSeconds * 1000);
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */
function millisecondsToHours(milliseconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var hours = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["b" /* millisecondsInHour */];
  return Math.floor(hours);
}

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param {number} milliseconds - number of milliseconds to be converted.
 *
 * @returns {number} the number of milliseconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */
function millisecondsToMinutes(milliseconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var minutes = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["c" /* millisecondsInMinute */];
  return Math.floor(minutes);
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param {number} milliseconds - number of milliseconds to be converted
 *
 * @returns {number} the number of milliseconds converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */
function millisecondsToSeconds(milliseconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var seconds = milliseconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["d" /* millisecondsInSecond */];
  return Math.floor(seconds);
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */
function minutesToHours(minutes) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var hours = minutes / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["e" /* minutesInHour */];
  return Math.floor(hours);
}

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param {number} minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */
function minutesToMilliseconds(minutes) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(minutes * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["c" /* millisecondsInMinute */]);
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param { number } minutes - number of minutes to be converted
 *
 * @returns {number} the number of minutes converted in seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */
function minutesToSeconds(minutes) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(minutes * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["k" /* secondsInMinute */]);
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param {number} months - number of months to be converted.
 *
 * @returns {number} the number of months converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */
function monthsToQuarters(months) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var quarters = months / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["f" /* monthsInQuarter */];
  return Math.floor(quarters);
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param {number} months - number of months to be converted
 *
 * @returns {number} the number of months converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */
function monthsToYears(months) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var years = months / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["g" /* monthsInYear */];
  return Math.floor(years);
}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */
function nextFriday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 5);
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */
function nextMonday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 1);
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */
function nextSaturday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 6);
}

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */
function nextSunday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 0);
}

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */
function nextThursday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 4);
}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextTuesday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 2);
}

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */
function nextWednesday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_0__nextDay_index_js__["a" /* default */])(date, 3);
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_index_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var additionalDigits = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c" /* millisecondsInMinute */] + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["b" /* millisecondsInHour */] + minutes * __WEBPACK_IMPORTED_MODULE_0__constants_index_js__["c" /* millisecondsInMinute */]);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate]{@link https://date-fns.org/docs/toDate}:
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 */
function parseJSON(argument) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  if (typeof argument === 'string') {
    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) {
      // Group 8 matches the sign
      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
    }
    return new Date(NaN);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(argument);
}

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */
function previousFriday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 5);
}

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Monday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */
function previousMonday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 1);
}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */
function previousSaturday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 6);
}

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */
function previousSunday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 0);
}

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Thursday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */
function previousThursday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 4);
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Tuesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */
function previousTuesday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 2);
}

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__ = __webpack_require__(40);


/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Wednesday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */
function previousWednesday(date) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Object(__WEBPACK_IMPORTED_MODULE_1__previousDay_index_js__["a" /* default */])(date, 3);
}

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */
function quartersToMonths(quarters) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(quarters * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["f" /* monthsInQuarter */]);
}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @param {number} quarters - number of quarters to be converted
 *
 * @returns {number} the number of quarters converted in years
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */
function quartersToYears(quarters) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var years = quarters / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["h" /* quartersInYear */];
  return Math.floor(years);
}

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_roundingMethods_index_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @param {Date|Number} date - the date to round
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Date} the new date rounded to the closest minute
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
 * //=> Thu Jul 10 2014 12:15:00
 */
function roundToNearestMinutes(dirtyDate, options) {
  var _options$nearestTo;
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only none provided present');
  }
  var nearestTo = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
  if (nearestTo < 1 || nearestTo > 30) {
    throw new RangeError('`options.nearestTo` must be between 1 and 30');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
  var minutes = date.getMinutes() + seconds / 60;
  var roundingMethod = Object(__WEBPACK_IMPORTED_MODULE_1__lib_roundingMethods_index_js__["a" /* getRoundingMethod */])(options === null || options === void 0 ? void 0 : options.roundingMethod);
  var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  var remainderMinutes = minutes % nearestTo;
  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */
function secondsToHours(seconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var hours = seconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["j" /* secondsInHour */];
  return Math.floor(hours);
}

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in milliseconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */
function secondsToMilliseconds(seconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return seconds * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["d" /* millisecondsInSecond */];
}

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param {number} seconds - number of seconds to be converted
 *
 * @returns {number} the number of seconds converted in minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */
function secondsToMinutes(seconds) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var minutes = seconds / __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["k" /* secondsInMinute */];
  return Math.floor(minutes);
}

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);





/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["a" /* default */])(date, values.month);
  }
  if (values.date != null) {
    date.setDate(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(values.date));
  }
  if (values.hours != null) {
    date.setHours(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(values.milliseconds));
  }
  return date;
}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate(dirtyDate, dirtyDayOfMonth) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var dayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__ = __webpack_require__(13);





/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_4__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var weekStartsOn = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = date.getDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var delta = 7 - weekStartsOn;
  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return Object(__WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a" /* default */])(date, diff);
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear(dirtyDate, dirtyDayOfYear) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyDayOfYear);
  date.setMonth(0);
  date.setDate(dayOfYear);
  return date;
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param {Object} newOptions - an object with options.
 * @param {Locale} [newOptions.locale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [newOptions.weekStartsOn] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [newOptions.firstWeekContainsDate] - the day of January, which is always in the first week of the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */
function setDefaultOptions(newOptions) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var result = {};
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  for (var property in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
      ;
      result[property] = defaultOptions[property];
    }
  }
  for (var _property in newOptions) {
    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
      if (newOptions[_property] === undefined) {
        delete result[_property];
      } else {
        ;
        result[_property] = newOptions[_property];
      }
    }
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_defaultOptions_index_js__["b" /* setDefaultOptions */])(result);
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);





/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(dirtyDate, dirtyDay) {
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = Object(__WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__["a" /* default */])(date);
  var diff = day - currentDay;
  return Object(__WEBPACK_IMPORTED_MODULE_2__addDays_index_js__["a" /* default */])(date, diff);
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(dirtyDate, dirtyISOWeek) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyISOWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__["a" /* default */])(date) - isoWeek;
  date.setDate(date.getDate() - diff * 7);
  return date;
}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var milliseconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMilliseconds);
  date.setMilliseconds(milliseconds);
  return date;
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);




/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var quarter = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["a" /* default */])(date, date.getMonth() + diff * 3);
}

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(3);




/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} week - the week of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(dirtyDate, dirtyWeek, options) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var week = Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(dirtyWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__["a" /* default */])(date, options) - week;
  date.setDate(date.getDate() - diff * 7);
  return date;
}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_defaultOptions_index_js__ = __webpack_require__(13);






/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} weekYear - the local week-numbering year of the new date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the new date with the local week-numbering year set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */
function setWeekYear(dirtyDate, dirtyWeekYear, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  Object(__WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var defaultOptions = Object(__WEBPACK_IMPORTED_MODULE_5__lib_defaultOptions_index_js__["a" /* getDefaultOptions */])();
  var firstWeekContainsDate = Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a" /* default */])(dirtyDate);
  var weekYear = Object(__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a" /* default */])(dirtyWeekYear);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a" /* default */])(date, options));
  var firstWeek = new Date(0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a" /* default */])(firstWeek, options);
  date.setDate(date.getDate() + diff);
  return date;
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);


/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a decade
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */
function startOfDecade(dirtyDate) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a" /* default */])(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  date.setFullYear(decade, 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(90);

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a" /* default */])(Date.now());
}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subDays_index_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subMonths_index_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__ = __webpack_require__(3);





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  if (!duration || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.years) : 0;
  var months = duration.months ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.months) : 0;
  var weeks = duration.weeks ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.weeks) : 0;
  var days = duration.days ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.days) : 0;
  var hours = duration.hours ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.hours) : 0;
  var minutes = duration.minutes ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.minutes) : 0;
  var seconds = duration.seconds ? Object(__WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a" /* default */])(duration.seconds) : 0;

  // Subtract years and months
  var dateWithoutMonths = Object(__WEBPACK_IMPORTED_MODULE_2__subMonths_index_js__["a" /* default */])(date, months + years * 12);

  // Subtract weeks and days
  var dateWithoutDays = Object(__WEBPACK_IMPORTED_MODULE_1__subDays_index_js__["a" /* default */])(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addBusinessDays_index_js__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the business days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */
function subBusinessDays(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addBusinessDays_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addHours_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(3);



/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_0__addMinutes_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);



/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  Object(__WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a" /* default */])(2, arguments);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param {number} weeks - number of weeks to be converted
 *
 * @returns {number} the number of weeks converted in days
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */
function weeksToDays(weeks) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(weeks * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["a" /* daysInWeek */]);
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in months
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */
function yearsToMonths(years) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(years * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["g" /* monthsInYear */]);
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_index_js__ = __webpack_require__(12);


/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param {number} years - number of years to be converted
 *
 * @returns {number} the number of years converted in quarters
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */
function yearsToQuarters(years) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a" /* default */])(1, arguments);
  return Math.floor(years * __WEBPACK_IMPORTED_MODULE_1__constants_index_js__["h" /* quartersInYear */]);
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = sendForm;
/* harmony export (immutable) */ __webpack_exports__["e"] = sendTemporaryForm;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTemporaryForm;
/* harmony export (immutable) */ __webpack_exports__["g"] = validateTemporaryForm;
/* harmony export (immutable) */ __webpack_exports__["f"] = uploadFiles;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUploadedFiles;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


function sendForm(formId, sessionToken, payload) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/complete', payload);
}

function sendTemporaryForm(formId, sessionToken, pageId, payload) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/temporary/pages/' + pageId, payload);
}

function getTemporaryForm(formId, sessionToken) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/temporary');
}

function validateTemporaryForm(formId, sessionToken, pageId, payload) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/temporary/pages/' + pageId + '/validate', payload);
}

function uploadFiles(formId, sessionToken, pageNumber, fileInputId, files, onUploadProgress) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/pages/' + pageNumber + '/files/' + fileInputId, files, {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		onUploadProgress: onUploadProgress(fileInputId)
	});
}

function getUploadedFiles(formId, sessionToken, fileInputId) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/files/' + fileInputId);
}

function deleteFile(formId, sessionToken, fileInputId, filename) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/apps/formpost/' + formId + '/sessions/' + sessionToken + '/files/' + fileInputId, {
		params: {
			filename: filename
		}
	});
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var bind = __webpack_require__(225);
var Axios = __webpack_require__(549);
var defaults = __webpack_require__(132);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(229);
axios.CancelToken = __webpack_require__(563);
axios.isCancel = __webpack_require__(228);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(564);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 548 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(132);
var utils = __webpack_require__(21);
var InterceptorManager = __webpack_require__(558);
var dispatchRequest = __webpack_require__(559);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(227);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error();
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
  // initialize result and counter
  var block, charCode, idx = 0, map = chars;
  // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1);
  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var transformData = __webpack_require__(560);
var isCancel = __webpack_require__(228);
var defaults = __webpack_require__(132);
var isAbsoluteURL = __webpack_require__(561);
var combineURLs = __webpack_require__(562);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(229);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(647);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(640);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(635);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (( false ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
})(function () {
	function extend() {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[i];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init(converter) {
		function api(key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return document.cookie = key + '=' + value + stringifiedAttributes;
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;

var _zhCN = __webpack_require__(910);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _deepmerge = __webpack_require__(911);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _format = __webpack_require__(912);

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(569);

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var scrollBarWidth = void 0;

;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 75);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/11:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(668);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(263);

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/75:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: [_vm.type === "textarea" ? "el-textarea" : "el-input", _vm.inputSize ? "el-input--" + _vm.inputSize : "", {
          "is-disabled": _vm.inputDisabled,
          "is-exceed": _vm.inputExceed,
          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "el-input-group--append": _vm.$slots.append,
          "el-input-group--prepend": _vm.$slots.prepend,
          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "el-input--suffix": _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable || _vm.showPassword
        }],
        on: {
          mouseenter: function mouseenter($event) {
            _vm.hovering = true;
          },
          mouseleave: function mouseleave($event) {
            _vm.hovering = false;
          }
        }
      }, [_vm.type !== "textarea" ? [_vm.$slots.prepend ? _c("div", { staticClass: "el-input-group__prepend" }, [_vm._t("prepend")], 2) : _vm._e(), _vm.type !== "textarea" ? _c("input", _vm._b({
        ref: "input",
        staticClass: "el-input__inner",
        attrs: {
          tabindex: _vm.tabindex,
          type: _vm.showPassword ? _vm.passwordVisible ? "text" : "password" : _vm.type,
          disabled: _vm.inputDisabled,
          readonly: _vm.readonly,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          "aria-label": _vm.label
        },
        on: {
          compositionstart: _vm.handleCompositionStart,
          compositionupdate: _vm.handleCompositionUpdate,
          compositionend: _vm.handleCompositionEnd,
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          change: _vm.handleChange
        }
      }, "input", _vm.$attrs, false)) : _vm._e(), _vm.$slots.prefix || _vm.prefixIcon ? _c("span", { staticClass: "el-input__prefix" }, [_vm._t("prefix"), _vm.prefixIcon ? _c("i", {
        staticClass: "el-input__icon",
        class: _vm.prefixIcon
      }) : _vm._e()], 2) : _vm._e(), _vm.getSuffixVisible() ? _c("span", { staticClass: "el-input__suffix" }, [_c("span", { staticClass: "el-input__suffix-inner" }, [!_vm.showClear || !_vm.showPwdVisible || !_vm.isWordLimitVisible ? [_vm._t("suffix"), _vm.suffixIcon ? _c("i", {
        staticClass: "el-input__icon",
        class: _vm.suffixIcon
      }) : _vm._e()] : _vm._e(), _vm.showClear ? _c("i", {
        staticClass: "el-input__icon el-icon-circle-close el-input__clear",
        on: {
          mousedown: function mousedown($event) {
            $event.preventDefault();
          },
          click: _vm.clear
        }
      }) : _vm._e(), _vm.showPwdVisible ? _c("i", {
        staticClass: "el-input__icon el-icon-view el-input__clear",
        on: { click: _vm.handlePasswordVisible }
      }) : _vm._e(), _vm.isWordLimitVisible ? _c("span", { staticClass: "el-input__count" }, [_c("span", { staticClass: "el-input__count-inner" }, [_vm._v("\n            " + _vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit) + "\n          ")])]) : _vm._e()], 2), _vm.validateState ? _c("i", {
        staticClass: "el-input__icon",
        class: ["el-input__validateIcon", _vm.validateIcon]
      }) : _vm._e()]) : _vm._e(), _vm.$slots.append ? _c("div", { staticClass: "el-input-group__append" }, [_vm._t("append")], 2) : _vm._e()] : _c("textarea", _vm._b({
        ref: "textarea",
        staticClass: "el-textarea__inner",
        style: _vm.textareaStyle,
        attrs: {
          tabindex: _vm.tabindex,
          disabled: _vm.inputDisabled,
          readonly: _vm.readonly,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          "aria-label": _vm.label
        },
        on: {
          compositionstart: _vm.handleCompositionStart,
          compositionupdate: _vm.handleCompositionUpdate,
          compositionend: _vm.handleCompositionEnd,
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          change: _vm.handleChange
        }
      }, "textarea", _vm.$attrs, false)), _vm.isWordLimitVisible && _vm.type === "textarea" ? _c("span", { staticClass: "el-input__count" }, [_vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))]) : _vm._e()], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
    var migrating_ = __webpack_require__(11);
    var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

    // CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
    var hiddenTextarea = void 0;

    var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

    var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

    function calculateNodeStyling(targetElement) {
      var style = window.getComputedStyle(targetElement);

      var boxSizing = style.getPropertyValue('box-sizing');

      var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

      var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

      var contextStyle = CONTEXT_STYLE.map(function (name) {
        return name + ':' + style.getPropertyValue(name);
      }).join(';');

      return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
    }

    function calcTextareaHeight(targetElement) {
      var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
      }

      var _calculateNodeStyling = calculateNodeStyling(targetElement),
          paddingSize = _calculateNodeStyling.paddingSize,
          borderSize = _calculateNodeStyling.borderSize,
          boxSizing = _calculateNodeStyling.boxSizing,
          contextStyle = _calculateNodeStyling.contextStyle;

      hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
      hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

      var height = hiddenTextarea.scrollHeight;
      var result = {};

      if (boxSizing === 'border-box') {
        height = height + borderSize;
      } else if (boxSizing === 'content-box') {
        height = height - paddingSize;
      }

      hiddenTextarea.value = '';
      var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

      if (minRows !== null) {
        var minHeight = singleRowHeight * minRows;
        if (boxSizing === 'border-box') {
          minHeight = minHeight + paddingSize + borderSize;
        }
        height = Math.max(minHeight, height);
        result.minHeight = minHeight + 'px';
      }
      if (maxRows !== null) {
        var maxHeight = singleRowHeight * maxRows;
        if (boxSizing === 'border-box') {
          maxHeight = maxHeight + paddingSize + borderSize;
        }
        height = Math.min(maxHeight, height);
      }
      result.height = height + 'px';
      hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      hiddenTextarea = null;
      return result;
    };
    // EXTERNAL MODULE: external "element-ui/lib/utils/merge"
    var merge_ = __webpack_require__(9);
    var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var inputvue_type_script_lang_js_ = {
      name: 'ElInput',

      componentName: 'ElInput',

      mixins: [emitter_default.a, migrating_default.a],

      inheritAttrs: false,

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      data: function data() {
        return {
          textareaCalcStyle: {},
          hovering: false,
          focused: false,
          isComposing: false,
          passwordVisible: false
        };
      },

      props: {
        value: [String, Number],
        size: String,
        resize: String,
        form: String,
        disabled: Boolean,
        readonly: Boolean,
        type: {
          type: String,
          default: 'text'
        },
        autosize: {
          type: [Boolean, Object],
          default: false
        },
        autocomplete: {
          type: String,
          default: 'off'
        },
        /** @Deprecated in next major version */
        autoComplete: {
          type: String,
          validator: function validator(val) {
            false && false;
            return true;
          }
        },
        validateEvent: {
          type: Boolean,
          default: true
        },
        suffixIcon: String,
        prefixIcon: String,
        label: String,
        clearable: {
          type: Boolean,
          default: false
        },
        showPassword: {
          type: Boolean,
          default: false
        },
        showWordLimit: {
          type: Boolean,
          default: false
        },
        tabindex: String
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        validateState: function validateState() {
          return this.elFormItem ? this.elFormItem.validateState : '';
        },
        needStatusIcon: function needStatusIcon() {
          return this.elForm ? this.elForm.statusIcon : false;
        },
        validateIcon: function validateIcon() {
          return {
            validating: 'el-icon-loading',
            success: 'el-icon-circle-check',
            error: 'el-icon-circle-close'
          }[this.validateState];
        },
        textareaStyle: function textareaStyle() {
          return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
        },
        inputSize: function inputSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        inputDisabled: function inputDisabled() {
          return this.disabled || (this.elForm || {}).disabled;
        },
        nativeInputValue: function nativeInputValue() {
          return this.value === null || this.value === undefined ? '' : String(this.value);
        },
        showClear: function showClear() {
          return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
        },
        showPwdVisible: function showPwdVisible() {
          return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
        },
        isWordLimitVisible: function isWordLimitVisible() {
          return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
        },
        upperLimit: function upperLimit() {
          return this.$attrs.maxlength;
        },
        textLength: function textLength() {
          if (typeof this.value === 'number') {
            return String(this.value).length;
          }

          return (this.value || '').length;
        },
        inputExceed: function inputExceed() {
          // show exceed style if length of initial value greater then maxlength
          return this.isWordLimitVisible && this.textLength > this.upperLimit;
        }
      },

      watch: {
        value: function value(val) {
          this.$nextTick(this.resizeTextarea);
          if (this.validateEvent) {
            this.dispatch('ElFormItem', 'el.form.change', [val]);
          }
        },

        // native input value is set explicitly
        // do not use v-model / :value in template
        // see: https://github.com/ElemeFE/element/issues/14521
        nativeInputValue: function nativeInputValue() {
          this.setNativeInputValue();
        },

        // when change between <input> and <textarea>,
        // update DOM dependent value and styles
        // https://github.com/ElemeFE/element/issues/14857
        type: function type() {
          var _this = this;

          this.$nextTick(function () {
            _this.setNativeInputValue();
            _this.resizeTextarea();
            _this.updateIconOffset();
          });
        }
      },

      methods: {
        focus: function focus() {
          this.getInput().focus();
        },
        blur: function blur() {
          this.getInput().blur();
        },
        getMigratingConfig: function getMigratingConfig() {
          return {
            props: {
              'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
              'on-icon-click': 'on-icon-click is removed.'
            },
            events: {
              'click': 'click is removed.'
            }
          };
        },
        handleBlur: function handleBlur(event) {
          this.focused = false;
          this.$emit('blur', event);
          if (this.validateEvent) {
            this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
          }
        },
        select: function select() {
          this.getInput().select();
        },
        resizeTextarea: function resizeTextarea() {
          if (this.$isServer) return;
          var autosize = this.autosize,
              type = this.type;

          if (type !== 'textarea') return;
          if (!autosize) {
            this.textareaCalcStyle = {
              minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
            };
            return;
          }
          var minRows = autosize.minRows;
          var maxRows = autosize.maxRows;

          this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
        },
        setNativeInputValue: function setNativeInputValue() {
          var input = this.getInput();
          if (!input) return;
          if (input.value === this.nativeInputValue) return;
          input.value = this.nativeInputValue;
        },
        handleFocus: function handleFocus(event) {
          this.focused = true;
          this.$emit('focus', event);
        },
        handleCompositionStart: function handleCompositionStart(event) {
          this.$emit('compositionstart', event);
          this.isComposing = true;
        },
        handleCompositionUpdate: function handleCompositionUpdate(event) {
          this.$emit('compositionupdate', event);
          var text = event.target.value;
          var lastCharacter = text[text.length - 1] || '';
          this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
        },
        handleCompositionEnd: function handleCompositionEnd(event) {
          this.$emit('compositionend', event);
          if (this.isComposing) {
            this.isComposing = false;
            this.handleInput(event);
          }
        },
        handleInput: function handleInput(event) {
          // should not emit input during composition
          // see: https://github.com/ElemeFE/element/issues/10516
          if (this.isComposing) return;

          // hack for https://github.com/ElemeFE/element/issues/8548
          // should remove the following line when we don't support IE
          if (event.target.value === this.nativeInputValue) return;

          this.$emit('input', event.target.value);

          // ensure native input value is controlled
          // see: https://github.com/ElemeFE/element/issues/12850
          this.$nextTick(this.setNativeInputValue);
        },
        handleChange: function handleChange(event) {
          this.$emit('change', event.target.value);
        },
        calcIconOffset: function calcIconOffset(place) {
          var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
          if (!elList.length) return;
          var el = null;
          for (var i = 0; i < elList.length; i++) {
            if (elList[i].parentNode === this.$el) {
              el = elList[i];
              break;
            }
          }
          if (!el) return;
          var pendantMap = {
            suffix: 'append',
            prefix: 'prepend'
          };

          var pendant = pendantMap[place];
          if (this.$slots[pendant]) {
            el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
          } else {
            el.removeAttribute('style');
          }
        },
        updateIconOffset: function updateIconOffset() {
          this.calcIconOffset('prefix');
          this.calcIconOffset('suffix');
        },
        clear: function clear() {
          this.$emit('input', '');
          this.$emit('change', '');
          this.$emit('clear');
        },
        handlePasswordVisible: function handlePasswordVisible() {
          var _this2 = this;

          this.passwordVisible = !this.passwordVisible;
          this.$nextTick(function () {
            _this2.focus();
          });
        },
        getInput: function getInput() {
          return this.$refs.input || this.$refs.textarea;
        },
        getSuffixVisible: function getSuffixVisible() {
          return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
        }
      },

      created: function created() {
        this.$on('inputSelect', this.select);
      },
      mounted: function mounted() {
        this.setNativeInputValue();
        this.resizeTextarea();
        this.updateIconOffset();
      },
      updated: function updated() {
        this.$nextTick(this.updateIconOffset);
      }
    };
    // CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
    /* harmony default export */var src_inputvue_type_script_lang_js_ = inputvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/input/src/input.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_inputvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/input/src/input.vue";
    /* harmony default export */var input = component.exports;
    // CONCATENATED MODULE: ./packages/input/index.js


    /* istanbul ignore next */
    input.install = function (Vue) {
      Vue.component(input.name, input);
    };

    /* harmony default export */var packages_input = __webpack_exports__["default"] = input;

    /***/
  },

  /***/9:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(262);

    /***/
  }

  /******/ });

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.removeResizeListener = exports.addResizeListener = undefined;

var _resizeObserverPolyfill = __webpack_require__(916);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _throttleDebounce = __webpack_require__(671);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var resizeHandler = function resizeHandler(entries) {
  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var entry = _ref;

    var listeners = entry.target.__resizeListeners__ || [];
    if (listeners.length) {
      listeners.forEach(function (fn) {
        fn();
      });
    }
  }
};

/* istanbul ignore next */
var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new _resizeObserverPolyfill2.default((0, _throttleDebounce.debounce)(16, resizeHandler));
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn);
};

/* istanbul ignore next */
var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};

/***/ }),
/* 574 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function (delay, noTrailing, callback, debounceMode) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if (typeof noTrailing !== 'boolean') {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper() {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec() {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear() {
			timeoutID = undefined;
		}

		if (debounceMode && !timeoutID) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if (timeoutID) {
			clearTimeout(timeoutID);
		}

		if (debounceMode === undefined && elapsed > delay) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();
		} else if (noTrailing !== true) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}
	}

	// Return the wrapper function.
	return wrapper;
};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 133);
  /******/
}(
/************************************************************************/
/******/{

  /***/133:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
    var resize_event_ = __webpack_require__(16);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
    var scrollbar_width_ = __webpack_require__(39);
    var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // CONCATENATED MODULE: ./packages/scrollbar/src/util.js
    var BAR_MAP = {
      vertical: {
        offset: 'offsetHeight',
        scroll: 'scrollTop',
        scrollSize: 'scrollHeight',
        size: 'height',
        key: 'vertical',
        axis: 'Y',
        client: 'clientY',
        direction: 'top'
      },
      horizontal: {
        offset: 'offsetWidth',
        scroll: 'scrollLeft',
        scrollSize: 'scrollWidth',
        size: 'width',
        key: 'horizontal',
        axis: 'X',
        client: 'clientX',
        direction: 'left'
      }
    };

    function renderThumbStyle(_ref) {
      var move = _ref.move,
          size = _ref.size,
          bar = _ref.bar;

      var style = {};
      var translate = 'translate' + bar.axis + '(' + move + '%)';

      style[bar.size] = size;
      style.transform = translate;
      style.msTransform = translate;
      style.webkitTransform = translate;

      return style;
    };
    // CONCATENATED MODULE: ./packages/scrollbar/src/bar.js


    /* istanbul ignore next */
    /* harmony default export */var src_bar = {
      name: 'Bar',

      props: {
        vertical: Boolean,
        size: String,
        move: Number
      },

      computed: {
        bar: function bar() {
          return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
        },
        wrap: function wrap() {
          return this.$parent.wrap;
        }
      },

      render: function render(h) {
        var size = this.size,
            move = this.move,
            bar = this.bar;

        return h('div', {
          'class': ['el-scrollbar__bar', 'is-' + bar.key],
          on: {
            'mousedown': this.clickTrackHandler
          }
        }, [h('div', {
          ref: 'thumb',
          'class': 'el-scrollbar__thumb',
          on: {
            'mousedown': this.clickThumbHandler
          },

          style: renderThumbStyle({ size: size, move: move, bar: bar }) })]);
      },

      methods: {
        clickThumbHandler: function clickThumbHandler(e) {
          // prevent click event of right button
          if (e.ctrlKey || e.button === 2) {
            return;
          }
          this.startDrag(e);
          this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
        },
        clickTrackHandler: function clickTrackHandler(e) {
          var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
          var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
          var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

          this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
        },
        startDrag: function startDrag(e) {
          e.stopImmediatePropagation();
          this.cursorDown = true;

          Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
          Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
          document.onselectstart = function () {
            return false;
          };
        },
        mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
          if (this.cursorDown === false) return;
          var prevPage = this[this.bar.axis];

          if (!prevPage) return;

          var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
          var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
          var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

          this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
        },
        mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
          this.cursorDown = false;
          this[this.bar.axis] = 0;
          Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
          document.onselectstart = null;
        }
      },

      destroyed: function destroyed() {
        Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
      }
    };
    // CONCATENATED MODULE: ./packages/scrollbar/src/main.js
    // reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js


    /* istanbul ignore next */
    /* harmony default export */var main = {
      name: 'ElScrollbar',

      components: { Bar: src_bar },

      props: {
        native: Boolean,
        wrapStyle: {},
        wrapClass: {},
        viewClass: {},
        viewStyle: {},
        noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
        tag: {
          type: String,
          default: 'div'
        }
      },

      data: function data() {
        return {
          sizeWidth: '0',
          sizeHeight: '0',
          moveX: 0,
          moveY: 0
        };
      },

      computed: {
        wrap: function wrap() {
          return this.$refs.wrap;
        }
      },

      render: function render(h) {
        var gutter = scrollbar_width_default()();
        var style = this.wrapStyle;

        if (gutter) {
          var gutterWith = '-' + gutter + 'px';
          var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

          if (Array.isArray(this.wrapStyle)) {
            style = Object(util_["toObject"])(this.wrapStyle);
            style.marginRight = style.marginBottom = gutterWith;
          } else if (typeof this.wrapStyle === 'string') {
            style += gutterStyle;
          } else {
            style = gutterStyle;
          }
        }
        var view = h(this.tag, {
          class: ['el-scrollbar__view', this.viewClass],
          style: this.viewStyle,
          ref: 'resize'
        }, this.$slots.default);
        var wrap = h('div', {
          ref: 'wrap',
          style: style,
          on: {
            'scroll': this.handleScroll
          },

          'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] }, [[view]]);
        var nodes = void 0;

        if (!this.native) {
          nodes = [wrap, h(src_bar, {
            attrs: {
              move: this.moveX,
              size: this.sizeWidth }
          }), h(src_bar, {
            attrs: {
              vertical: true,
              move: this.moveY,
              size: this.sizeHeight }
          })];
        } else {
          nodes = [h('div', {
            ref: 'wrap',
            'class': [this.wrapClass, 'el-scrollbar__wrap'],
            style: style }, [[view]])];
        }
        return h('div', { class: 'el-scrollbar' }, nodes);
      },

      methods: {
        handleScroll: function handleScroll() {
          var wrap = this.wrap;

          this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
          this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
        },
        update: function update() {
          var heightPercentage = void 0,
              widthPercentage = void 0;
          var wrap = this.wrap;
          if (!wrap) return;

          heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
          widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

          this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
          this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
        }
      },

      mounted: function mounted() {
        if (this.native) return;
        this.$nextTick(this.update);
        !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
      },
      beforeDestroy: function beforeDestroy() {
        if (this.native) return;
        !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
      }
    };
    // CONCATENATED MODULE: ./packages/scrollbar/index.js


    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.component(main.name, main);
    };

    /* harmony default export */var scrollbar = __webpack_exports__["default"] = main;

    /***/
  },

  /***/16:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(573);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(98);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/39:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(571);

    /***/
  }

  /******/ });

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = scrollIntoView;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollIntoView(container, selected) {
  if (_vue2.default.prototype.$isServer) return;

  if (!selected) {
    container.scrollTop = 0;
    return;
  }

  var offsetParents = [];
  var pointer = selected.offsetParent;
  while (pointer && container !== pointer && container.contains(pointer)) {
    offsetParents.push(pointer);
    pointer = pointer.offsetParent;
  }
  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
    return prev + curr.offsetTop;
  }, 0);
  var bottom = top + selected.offsetHeight;
  var viewRectTop = container.scrollTop;
  var viewRectBottom = viewRectTop + container.clientHeight;

  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};

exports.default = aria.Utils;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(136);
var document = __webpack_require__(45).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(136);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(584)('keys');
var uid = __webpack_require__(269);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(74);
var global = __webpack_require__(45);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(236) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 586 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(581);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(54);

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var core = __webpack_require__(74);
var LIBRARY = __webpack_require__(236);
var wksExt = __webpack_require__(588);
var defineProperty = __webpack_require__(103).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__(266);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUGGEST_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWS_LIST_URL; });
var PREFIX = window.prefix || '';
var SEARCH_URL = '/' + PREFIX + 'apps/search/do';
var SUGGEST_URL = '/' + PREFIX + 'apps/search/suggest';
var NEWS_LIST_URL = '/' + PREFIX + 'apps/list/news';

/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(294),
    isFlattenable = __webpack_require__(768);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(772),
    baseMatchesProperty = __webpack_require__(817),
    identity = __webpack_require__(309),
    isArray = __webpack_require__(63),
    property = __webpack_require__(827);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(800),
    isObjectLike = __webpack_require__(86);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(298),
    arraySome = __webpack_require__(803),
    cacheHas = __webpack_require__(299);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(80);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(637),
    getSymbols = __webpack_require__(301),
    keys = __webpack_require__(252);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(294),
    isArray = __webpack_require__(63);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(808),
    isArguments = __webpack_require__(246),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(253),
    isIndex = __webpack_require__(302),
    isTypedArray = __webpack_require__(303);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(80);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),
/* 643 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(645),
    toKey = __webpack_require__(257);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(63),
    isKey = __webpack_require__(307),
    stringToPath = __webpack_require__(819),
    toString = __webpack_require__(822);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),
/* 646 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(837);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;

/***/ }),
/* 649 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(846);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(565),
    eq = __webpack_require__(162);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(80);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(294),
    getPrototype = __webpack_require__(566),
    getSymbols = __webpack_require__(301),
    stubArray = __webpack_require__(638);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(860),
    getPrototype = __webpack_require__(566),
    isPrototype = __webpack_require__(306);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

module.exports = initCloneObject;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(867);
var v4 = __webpack_require__(868);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function rng() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 660 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(565),
    eq = __webpack_require__(162);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

/***/ }),
/* 662 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueRecaptcha);

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;
exports._setTarget = exports.target = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread({}, target, {}, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* Modified from https://github.com/taylorhakes/fecha
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Taylor Hakes
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd

(function (main) {
  'use strict';

  /**
   * Parse or format dates
   * @class fecha
   */

  var fecha = {};
  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
  var twoDigits = '\\d\\d?';
  var threeDigits = '\\d{3}';
  var fourDigits = '\\d{4}';
  var word = '[^\\s]+';
  var literal = /\[([^]*?)\]/gm;
  var noop = function noop() {};

  function regexEscape(str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
  }

  function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
  }

  function monthUpdate(arrName) {
    return function (d, v, i18n) {
      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
      if (~index) {
        d.month = index;
      }
    };
  }

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthNamesShort = shorten(monthNames, 3);
  var dayNamesShort = shorten(dayNames, 3);
  fecha.i18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ['am', 'pm'],
    DoFn: function DoFn(D) {
      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
  };

  var formatFlags = {
    D: function D(dateObj) {
      return dateObj.getDay();
    },
    DD: function DD(dateObj) {
      return pad(dateObj.getDay());
    },
    Do: function Do(dateObj, i18n) {
      return i18n.DoFn(dateObj.getDate());
    },
    d: function d(dateObj) {
      return dateObj.getDate();
    },
    dd: function dd(dateObj) {
      return pad(dateObj.getDate());
    },
    ddd: function ddd(dateObj, i18n) {
      return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function dddd(dateObj, i18n) {
      return i18n.dayNames[dateObj.getDay()];
    },
    M: function M(dateObj) {
      return dateObj.getMonth() + 1;
    },
    MM: function MM(dateObj) {
      return pad(dateObj.getMonth() + 1);
    },
    MMM: function MMM(dateObj, i18n) {
      return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function MMMM(dateObj, i18n) {
      return i18n.monthNames[dateObj.getMonth()];
    },
    yy: function yy(dateObj) {
      return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    yyyy: function yyyy(dateObj) {
      return pad(dateObj.getFullYear(), 4);
    },
    h: function h(dateObj) {
      return dateObj.getHours() % 12 || 12;
    },
    hh: function hh(dateObj) {
      return pad(dateObj.getHours() % 12 || 12);
    },
    H: function H(dateObj) {
      return dateObj.getHours();
    },
    HH: function HH(dateObj) {
      return pad(dateObj.getHours());
    },
    m: function m(dateObj) {
      return dateObj.getMinutes();
    },
    mm: function mm(dateObj) {
      return pad(dateObj.getMinutes());
    },
    s: function s(dateObj) {
      return dateObj.getSeconds();
    },
    ss: function ss(dateObj) {
      return pad(dateObj.getSeconds());
    },
    S: function S(dateObj) {
      return Math.round(dateObj.getMilliseconds() / 100);
    },
    SS: function SS(dateObj) {
      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function SSS(dateObj) {
      return pad(dateObj.getMilliseconds(), 3);
    },
    a: function a(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function A(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
    },
    ZZ: function ZZ(dateObj) {
      var o = dateObj.getTimezoneOffset();
      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
  };

  var parseFlags = {
    d: [twoDigits, function (d, v) {
      d.day = v;
    }],
    Do: [twoDigits + word, function (d, v) {
      d.day = parseInt(v, 10);
    }],
    M: [twoDigits, function (d, v) {
      d.month = v - 1;
    }],
    yy: [twoDigits, function (d, v) {
      var da = new Date(),
          cent = +('' + da.getFullYear()).substr(0, 2);
      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, function (d, v) {
      d.hour = v;
    }],
    m: [twoDigits, function (d, v) {
      d.minute = v;
    }],
    s: [twoDigits, function (d, v) {
      d.second = v;
    }],
    yyyy: [fourDigits, function (d, v) {
      d.year = v;
    }],
    S: ['\\d', function (d, v) {
      d.millisecond = v * 100;
    }],
    SS: ['\\d{2}', function (d, v) {
      d.millisecond = v * 10;
    }],
    SSS: [threeDigits, function (d, v) {
      d.millisecond = v;
    }],
    D: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, function (d, v, i18n) {
      var val = v.toLowerCase();
      if (val === i18n.amPm[0]) {
        d.isPm = false;
      } else if (val === i18n.amPm[1]) {
        d.isPm = true;
      }
    }],
    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
      var parts = (v + '').match(/([+-]|\d\d)/gi),
          minutes;

      if (parts) {
        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    }]
  };
  parseFlags.dd = parseFlags.d;
  parseFlags.dddd = parseFlags.ddd;
  parseFlags.DD = parseFlags.D;
  parseFlags.mm = parseFlags.m;
  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
  parseFlags.MM = parseFlags.M;
  parseFlags.ss = parseFlags.s;
  parseFlags.A = parseFlags.a;

  // Some common format strings
  fecha.masks = {
    default: 'ddd MMM dd yyyy HH:mm:ss',
    shortDate: 'M/D/yy',
    mediumDate: 'MMM d, yyyy',
    longDate: 'MMMM d, yyyy',
    fullDate: 'dddd, MMMM d, yyyy',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
  };

  /***
   * Format a date
   * @method format
   * @param {Date|number} dateObj
   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
   */
  fecha.format = function (dateObj, mask, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof dateObj === 'number') {
      dateObj = new Date(dateObj);
    }

    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
      throw new Error('Invalid Date in fecha.format');
    }

    mask = fecha.masks[mask] || mask || fecha.masks['default'];

    var literals = [];

    // Make literals inactive by replacing them with ??
    mask = mask.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () {
      return literals.shift();
    });
  };

  /**
   * Parse a date string into an object, changes - into /
   * @method parse
   * @param {string} dateStr Date string
   * @param {string} format Date parse format
   * @returns {Date|boolean}
   */
  fecha.parse = function (dateStr, format, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof format !== 'string') {
      throw new Error('Invalid format in fecha.parse');
    }

    format = fecha.masks[format] || format;

    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
      return null;
    }

    var dateInfo = {};
    var parseInfo = [];
    var literals = [];
    format = format.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    var newFormat = regexEscape(format).replace(token, function ($0) {
      if (parseFlags[$0]) {
        var info = parseFlags[$0];
        parseInfo.push(info[1]);
        return '(' + info[0] + ')';
      }

      return $0;
    });
    newFormat = newFormat.replace(/@@@/g, function () {
      return literals.shift();
    });
    var matches = dateStr.match(new RegExp(newFormat, 'i'));
    if (!matches) {
      return null;
    }

    for (var i = 1; i < matches.length; i++) {
      parseInfo[i - 1](dateInfo, matches[i], i18n);
    }

    var today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
      dateInfo.hour = +dateInfo.hour + 12;
    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
      dateInfo.hour = 0;
    }

    var date;
    if (dateInfo.timezoneOffset != null) {
      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
    } else {
      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
    }
    return date;
  };

  /* istanbul ignore next */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fecha;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fecha;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    main.fecha = fecha;
  }
})(undefined);

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isDefined = exports.isUndefined = exports.isFunction = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.isString = isString;
exports.isObject = isObject;
exports.isHtmlElement = isHtmlElement;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

/**
 *  - Inspired:
 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
 */
var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

if (typeof /./ !== 'function' && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
  exports.isFunction = isFunction = function isFunction(obj) {
    return typeof obj === 'function' || false;
  };
}

exports.isFunction = isFunction;
var isUndefined = exports.isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = exports.isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__(262);

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__(913);

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__(571);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var idSeed = 1;

var scrollBarWidth = void 0;

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },

  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(73);

/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
exports.default = {
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      propName = (0, _util.kebabCase)(propName); // compatible with camel case
      if (props[propName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
      if (events[eventName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  return startClick = e;
});

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports.default = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 91);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/91:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("label", {
        staticClass: "el-checkbox",
        class: [_vm.border && _vm.checkboxSize ? "el-checkbox--" + _vm.checkboxSize : "", { "is-disabled": _vm.isDisabled }, { "is-bordered": _vm.border }, { "is-checked": _vm.isChecked }],
        attrs: { id: _vm.id }
      }, [_c("span", {
        staticClass: "el-checkbox__input",
        class: {
          "is-disabled": _vm.isDisabled,
          "is-checked": _vm.isChecked,
          "is-indeterminate": _vm.indeterminate,
          "is-focus": _vm.focus
        },
        attrs: {
          tabindex: _vm.indeterminate ? 0 : false,
          role: _vm.indeterminate ? "checkbox" : false,
          "aria-checked": _vm.indeterminate ? "mixed" : false
        }
      }, [_c("span", { staticClass: "el-checkbox__inner" }), _vm.trueLabel || _vm.falseLabel ? _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        staticClass: "el-checkbox__original",
        attrs: {
          type: "checkbox",
          "aria-hidden": _vm.indeterminate ? "true" : "false",
          name: _vm.name,
          disabled: _vm.isDisabled,
          "true-value": _vm.trueLabel,
          "false-value": _vm.falseLabel
        },
        domProps: {
          checked: Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
        },
        on: {
          change: [function ($event) {
            var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel;
            if (Array.isArray($$a)) {
              var $$v = null,
                  $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.model = $$c;
            }
          }, _vm.handleChange],
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          }
        }
      }) : _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        staticClass: "el-checkbox__original",
        attrs: {
          type: "checkbox",
          "aria-hidden": _vm.indeterminate ? "true" : "false",
          disabled: _vm.isDisabled,
          name: _vm.name
        },
        domProps: {
          value: _vm.label,
          checked: Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : _vm.model
        },
        on: {
          change: [function ($event) {
            var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = _vm.label,
                  $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.model = $$c;
            }
          }, _vm.handleChange],
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          }
        }
      })]), _vm.$slots.default || _vm.label ? _c("span", { staticClass: "el-checkbox__label" }, [_vm._t("default"), !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var checkboxvue_type_script_lang_js_ = {
      name: 'ElCheckbox',

      mixins: [emitter_default.a],

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      componentName: 'ElCheckbox',

      data: function data() {
        return {
          selfModel: false,
          focus: false,
          isLimitExceeded: false
        };
      },

      computed: {
        model: {
          get: function get() {
            return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
          },
          set: function set(val) {
            if (this.isGroup) {
              this.isLimitExceeded = false;
              this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

              this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

              this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
            } else {
              this.$emit('input', val);
              this.selfModel = val;
            }
          }
        },

        isChecked: function isChecked() {
          if ({}.toString.call(this.model) === '[object Boolean]') {
            return this.model;
          } else if (Array.isArray(this.model)) {
            return this.model.indexOf(this.label) > -1;
          } else if (this.model !== null && this.model !== undefined) {
            return this.model === this.trueLabel;
          }
        },
        isGroup: function isGroup() {
          var parent = this.$parent;
          while (parent) {
            if (parent.$options.componentName !== 'ElCheckboxGroup') {
              parent = parent.$parent;
            } else {
              this._checkboxGroup = parent;
              return true;
            }
          }
          return false;
        },
        store: function store() {
          return this._checkboxGroup ? this._checkboxGroup.value : this.value;
        },

        /* used to make the isDisabled judgment under max/min props */
        isLimitDisabled: function isLimitDisabled() {
          var _checkboxGroup = this._checkboxGroup,
              max = _checkboxGroup.max,
              min = _checkboxGroup.min;

          return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
        },
        isDisabled: function isDisabled() {
          return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        checkboxSize: function checkboxSize() {
          var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
        }
      },

      props: {
        value: {},
        label: {},
        indeterminate: Boolean,
        disabled: Boolean,
        checked: Boolean,
        name: String,
        trueLabel: [String, Number],
        falseLabel: [String, Number],
        id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
        controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
        border: Boolean,
        size: String
      },

      methods: {
        addToStore: function addToStore() {
          if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
            this.model.push(this.label);
          } else {
            this.model = this.trueLabel || true;
          }
        },
        handleChange: function handleChange(ev) {
          var _this = this;

          if (this.isLimitExceeded) return;
          var value = void 0;
          if (ev.target.checked) {
            value = this.trueLabel === undefined ? true : this.trueLabel;
          } else {
            value = this.falseLabel === undefined ? false : this.falseLabel;
          }
          this.$emit('change', value, ev);
          this.$nextTick(function () {
            if (_this.isGroup) {
              _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
            }
          });
        }
      },

      created: function created() {
        this.checked && this.addToStore();
      },
      mounted: function mounted() {
        // 为indeterminate元素 添加aria-controls 属性
        if (this.indeterminate) {
          this.$el.setAttribute('aria-controls', this.controls);
        }
      },

      watch: {
        value: function value(_value) {
          this.dispatch('ElFormItem', 'el.form.change', _value);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
    /* harmony default export */var src_checkboxvue_type_script_lang_js_ = checkboxvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_checkboxvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/checkbox/src/checkbox.vue";
    /* harmony default export */var src_checkbox = component.exports;
    // CONCATENATED MODULE: ./packages/checkbox/index.js


    /* istanbul ignore next */
    src_checkbox.install = function (Vue) {
      Vue.component(src_checkbox.name, src_checkbox);
    };

    /* harmony default export */var packages_checkbox = __webpack_exports__["default"] = src_checkbox;

    /***/
  }

  /******/ });

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var throttle = __webpack_require__(574);
var debounce = __webpack_require__(264);

module.exports = {
	throttle: throttle,
	debounce: debounce
};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/;

module.exports = function mergeJSXProps(objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp;
    for (key in b) {
      aa = a[key];
      bb = b[key];
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa;
            a[key] = aa = {};
            aa[temp] = true;
          }
          if (typeof bb === 'string') {
            temp = bb;
            b[key] = bb = {};
            bb[temp] = true;
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey]);
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb);
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb);
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey];
          }
        }
      } else {
        a[key] = b[key];
      }
    }
    return a;
  }, {});
};

function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments);
    b && b.apply(this, arguments);
  };
}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 674 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 132);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/132:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&

    /* harmony default export */var tagvue_type_script_lang_js_ = {
      name: 'ElTag',
      props: {
        text: String,
        closable: Boolean,
        type: String,
        hit: Boolean,
        disableTransitions: Boolean,
        color: String,
        size: String,
        effect: {
          type: String,
          default: 'light',
          validator: function validator(val) {
            return ['dark', 'light', 'plain'].indexOf(val) !== -1;
          }
        }
      },
      methods: {
        handleClose: function handleClose(event) {
          event.stopPropagation();
          this.$emit('close', event);
        },
        handleClick: function handleClick(event) {
          this.$emit('click', event);
        }
      },
      computed: {
        tagSize: function tagSize() {
          return this.size || (this.$ELEMENT || {}).size;
        }
      },
      render: function render(h) {
        var type = this.type,
            tagSize = this.tagSize,
            hit = this.hit,
            effect = this.effect;

        var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
        var tagEl = h('span', {
          'class': classes,
          style: { backgroundColor: this.color },
          on: {
            'click': this.handleClick
          }
        }, [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
            'click': this.handleClose
          }
        })]);

        return this.disableTransitions ? tagEl : h('transition', {
          attrs: { name: 'el-zoom-in-center' }
        }, [tagEl]);
      }
    };
    // CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
    /* harmony default export */var src_tagvue_type_script_lang_js_ = tagvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/tag/src/tag.vue
    var render, staticRenderFns;

    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_tagvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/tag/src/tag.vue";
    /* harmony default export */var tag = component.exports;
    // CONCATENATED MODULE: ./packages/tag/index.js


    /* istanbul ignore next */
    tag.install = function (Vue) {
      Vue.component(tag.name, tag);
    };

    /* harmony default export */var packages_tag = __webpack_exports__["default"] = tag;

    /***/
  }

  /******/ });

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(676);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(934), __esModule: true };

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(99) && !__webpack_require__(234)(function () {
  return Object.defineProperty(__webpack_require__(579)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(137);
var toIObject = __webpack_require__(155);
var arrayIndexOf = __webpack_require__(937)(false);
var IE_PROTO = __webpack_require__(583)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(235);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(582);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(941)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(682)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(236);
var $export = __webpack_require__(134);
var redefine = __webpack_require__(683);
var hide = __webpack_require__(135);
var Iterators = __webpack_require__(237);
var $iterCreate = __webpack_require__(942);
var setToStringTag = __webpack_require__(272);
var getPrototypeOf = __webpack_require__(944);
var ITERATOR = __webpack_require__(54)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(135);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(104);
var dPs = __webpack_require__(943);
var enumBugKeys = __webpack_require__(585);
var IE_PROTO = __webpack_require__(583)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(579)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(685).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(45).document;
module.exports = document && document.documentElement;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(945);
var global = __webpack_require__(45);
var hide = __webpack_require__(135);
var Iterators = __webpack_require__(237);
var TO_STRING_TAG = __webpack_require__(54)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(678);
var hiddenKeys = __webpack_require__(585).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 688 */
/***/ (function(module, exports) {



/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 88);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/88:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("label", {
        staticClass: "el-radio",
        class: [_vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "", { "is-disabled": _vm.isDisabled }, { "is-focus": _vm.focus }, { "is-bordered": _vm.border }, { "is-checked": _vm.model === _vm.label }],
        attrs: {
          role: "radio",
          "aria-checked": _vm.model === _vm.label,
          "aria-disabled": _vm.isDisabled,
          tabindex: _vm.tabIndex
        },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.model = _vm.isDisabled ? _vm.model : _vm.label;
          }
        }
      }, [_c("span", {
        staticClass: "el-radio__input",
        class: {
          "is-disabled": _vm.isDisabled,
          "is-checked": _vm.model === _vm.label
        }
      }, [_c("span", { staticClass: "el-radio__inner" }), _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        ref: "radio",
        staticClass: "el-radio__original",
        attrs: {
          type: "radio",
          "aria-hidden": "true",
          name: _vm.name,
          disabled: _vm.isDisabled,
          tabindex: "-1",
          autocomplete: "off"
        },
        domProps: {
          value: _vm.label,
          checked: _vm._q(_vm.model, _vm.label)
        },
        on: {
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          },
          change: [function ($event) {
            _vm.model = _vm.label;
          }, _vm.handleChange]
        }
      })]), _c("span", {
        staticClass: "el-radio__label",
        on: {
          keydown: function keydown($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._t("default"), !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var radiovue_type_script_lang_js_ = {
      name: 'ElRadio',

      mixins: [emitter_default.a],

      inject: {
        elForm: {
          default: ''
        },

        elFormItem: {
          default: ''
        }
      },

      componentName: 'ElRadio',

      props: {
        value: {},
        label: {},
        disabled: Boolean,
        name: String,
        border: Boolean,
        size: String
      },

      data: function data() {
        return {
          focus: false
        };
      },

      computed: {
        isGroup: function isGroup() {
          var parent = this.$parent;
          while (parent) {
            if (parent.$options.componentName !== 'ElRadioGroup') {
              parent = parent.$parent;
            } else {
              this._radioGroup = parent;
              return true;
            }
          }
          return false;
        },

        model: {
          get: function get() {
            return this.isGroup ? this._radioGroup.value : this.value;
          },
          set: function set(val) {
            if (this.isGroup) {
              this.dispatch('ElRadioGroup', 'input', [val]);
            } else {
              this.$emit('input', val);
            }
            this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
          }
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        radioSize: function radioSize() {
          var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
        },
        isDisabled: function isDisabled() {
          return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
        },
        tabIndex: function tabIndex() {
          return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
        }
      },

      methods: {
        handleChange: function handleChange() {
          var _this = this;

          this.$nextTick(function () {
            _this.$emit('change', _this.model);
            _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
          });
        }
      }
    };
    // CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
    /* harmony default export */var src_radiovue_type_script_lang_js_ = radiovue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/radio/src/radio.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_radiovue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/radio/src/radio.vue";
    /* harmony default export */var src_radio = component.exports;
    // CONCATENATED MODULE: ./packages/radio/index.js


    /* istanbul ignore next */
    src_radio.install = function (Vue) {
      Vue.component(src_radio.name, src_radio);
    };

    /* harmony default export */var packages_radio = __webpack_exports__["default"] = src_radio;

    /***/
  }

  /******/ });

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return win; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return doc; });
/**
 * SSR Window 1.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2018, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: July 18, 2018
 */
var doc = typeof document === 'undefined' ? {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  location: { hash: '' }
} : document; // eslint-disable-line

var win = typeof window === 'undefined' ? {
  document: doc,
  navigator: {
    userAgent: ''
  },
  location: {},
  history: {},
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {}
} : window; // eslint-disable-line



/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_typeahead__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_typeahead__);
/**
 * Created by laszlo.czondor on 2017. 11. 14.
 */


var QUERY_HASH = '#query=';

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_typeahead___default.a, // vue@1.0.22+
	data: function data() {
		return {
			isOpen: false,
			limit: 5,
			minChars: 3,
			// Highlight the first item in the list
			selectFirst: true,
			queryParamName: 'query',
			query: ''
		};
	},

	props: {
		searchUrl: {
			type: String,
			required: true
		},
		autoSuggestItems: {
			type: Array,
			required: false
		}
	},
	methods: {
		toggleResults: function toggleResults(item, isOpen) {
			var isItemString = typeof item === 'string';
			if (isItemString) {
				this.query = item;
				this.search(this.query);
			}
			this.isOpen = isOpen;
		},

		// The callback function which is triggered when the user hits on an item
		onHit: function onHit($event) {
			if (this.current !== -1) {
				this.query = this.autoSuggestItems[this.current];
				this.isOpen = false;
			}

			if ($event.type === 'keydown' && $event.key === 'Enter') {
				this.search(this.query);
			}
		},
		search: function search(query) {
			if (this.isOnSearchPage) {
				this.$emit('on-search', query);
			} else {
				window.location.href = this.searchUrl + QUERY_HASH + query;
			}
		},


		// The callback function which is triggered when the response data are received
		prepareResponseData: function prepareResponseData(data) {
			this.isOpen = true;
			return data.suggestions;
		},
		update: function update() {
			this.$emit('on-auto-suggest', this.query);
		}
	},
	computed: {
		isOnSearchPage: function isOnSearchPage() {
			return window.location.pathname === this.searchUrl;
		}
	},
	mounted: function mounted() {
		if (window.location.hash && new RegExp(QUERY_HASH).test(window.location.hash)) {
			var query = decodeURI(window.location.hash.split('=')[1]);
			this.query = query;
			this.$emit('on-search', query);
		}
	}
});

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(235);
var TAG = __webpack_require__(54)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(104);
var aFunction = __webpack_require__(266);
var SPECIES = __webpack_require__(54)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(265);
var invoke = __webpack_require__(1002);
var html = __webpack_require__(685);
var cel = __webpack_require__(579);
var global = __webpack_require__(45);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(235)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(104);
var isObject = __webpack_require__(136);
var newPromiseCapability = __webpack_require__(590);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_pagination_js__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dde1d2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_pagination_pug__ = __webpack_require__(1021);
var normalizeComponent = __webpack_require__(102)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_pagination_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dde1d2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_pagination_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_DNFORM_DNFORM__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_FRM01_form_FRM01_form__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_FRM02_form_FRM02_form__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_GAL01_gallery_GAL01_gallery__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_HEA01_header_HEA01_header__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_HER01_hero_HER01_hero__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_LST03_list_LST03_list__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_NL01_news_list_NL01_news_list_vue__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_SLD03_product_slider_SLD03_product_slider__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_SLD04_logo_slider_SLD04_logo_slider__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_SRC01_search_SRC01_search__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_szechenyi_szechenyi__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_central_vuex_store_central_vuex__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_HEA01_header_HEA01_header_vuex__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_PRO01_promo_PRO01_promo__ = __webpack_require__(1034);

















document.body.addEventListener('jsLoaded', function () {
	Vue.use(__WEBPACK_IMPORTED_MODULE_12_vuelidate___default.a);

	var store = new Vuex.Store(__WEBPACK_IMPORTED_MODULE_13__common_central_vuex_store_central_vuex__["a" /* default */]);
	store.registerModule('headerSearchStore', __WEBPACK_IMPORTED_MODULE_14__modules_HEA01_header_HEA01_header_vuex__["a" /* default */]);

	new Vue({
		store: store,
		components: {
			'dnform': __WEBPACK_IMPORTED_MODULE_0__modules_DNFORM_DNFORM__["a" /* default */],
			'frm01-form': __WEBPACK_IMPORTED_MODULE_1__modules_FRM01_form_FRM01_form__["a" /* default */],
			'frm02-form': __WEBPACK_IMPORTED_MODULE_2__modules_FRM02_form_FRM02_form__["a" /* default */],
			'gal01-gallery': __WEBPACK_IMPORTED_MODULE_3__modules_GAL01_gallery_GAL01_gallery__["a" /* default */],
			'hea01-header': __WEBPACK_IMPORTED_MODULE_4__modules_HEA01_header_HEA01_header__["a" /* default */],
			'her01-hero': __WEBPACK_IMPORTED_MODULE_5__modules_HER01_hero_HER01_hero__["a" /* default */],
			'lst03-list': __WEBPACK_IMPORTED_MODULE_6__modules_LST03_list_LST03_list__["a" /* default */],
			'nl01-news-list': __WEBPACK_IMPORTED_MODULE_7__modules_NL01_news_list_NL01_news_list_vue__["a" /* default */],
			'sld03-product-slider': __WEBPACK_IMPORTED_MODULE_8__modules_SLD03_product_slider_SLD03_product_slider__["a" /* default */],
			'sld04-logo-slider': __WEBPACK_IMPORTED_MODULE_9__modules_SLD04_logo_slider_SLD04_logo_slider__["a" /* default */],
			'src01-search': __WEBPACK_IMPORTED_MODULE_10__modules_SRC01_search_SRC01_search__["a" /* default */],
			'szechenyi-logo': __WEBPACK_IMPORTED_MODULE_11__common_szechenyi_szechenyi__["a" /* default */],
			'pro01-promo': __WEBPACK_IMPORTED_MODULE_15__modules_PRO01_promo_PRO01_promo__["a" /* default */]
		},
		el: '#vue-app'
	});
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DNFORM_phone_number_DNFORM_phone_number_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DNFORM_input_email_DNFORM_input_email_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DNFORM_mixins_DNFORM_file_input_mixin__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DNFORM_mixins_DNFORM_form_submit_mixin__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DNFORM_mixins_DNFORM_response_handler_mixin__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DNFORM_mixins_DNFORM_session_mixin__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DNFORM_mixins_DNFORM_stepper_mixin__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DNFORM_mixins_DNFORM_summary_mixin__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DNFORM_mixins_DNFORM_validation_mixin__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_recaptcha_v3_init_recaptcha_v3__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);













/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Dynaform',
	components: {
		'vue-select': __WEBPACK_IMPORTED_MODULE_0_vue_select___default.a,
		'phone-number': __WEBPACK_IMPORTED_MODULE_1__DNFORM_phone_number_DNFORM_phone_number_vue__["a" /* default */],
		'input-email': __WEBPACK_IMPORTED_MODULE_2__DNFORM_input_email_DNFORM_input_email_vue__["a" /* default */]
	},
	props: {
		formId: {
			type: String,
			required: true
		},
		formModel: {
			type: Object,
			required: true
		},
		formValidation: {
			type: Object,
			required: true
		},
		labelsOfInputs: {
			type: Object,
			required: false,
			default: undefined
		},
		isRecaptchaEnabled: {
			type: Boolean,
			required: false,
			default: false
		},
		isSummaryEnabled: {
			type: Boolean,
			required: false,
			default: false
		},
		steps: {
			type: Array,
			required: false,
			default: function _default() {
				return [];
			}
		}
	},
	data: function data() {
		return {
			PHONE_NUMBER_INPUT_FIELDS: __WEBPACK_IMPORTED_MODULE_11__DNFORM_utils_DNFORM_constants__["i" /* PHONE_NUMBER_INPUT_FIELDS */],
			fromId: this.formId,
			model: {},
			modelForSummary: {},
			validation: {}
		};
	},

	mixins: [__WEBPACK_IMPORTED_MODULE_3__DNFORM_mixins_DNFORM_file_input_mixin__["a" /* fileInputMixin */], __WEBPACK_IMPORTED_MODULE_4__DNFORM_mixins_DNFORM_form_submit_mixin__["a" /* formSubmitMixin */], __WEBPACK_IMPORTED_MODULE_5__DNFORM_mixins_DNFORM_response_handler_mixin__["a" /* responseHandlerMixin */], __WEBPACK_IMPORTED_MODULE_6__DNFORM_mixins_DNFORM_session_mixin__["a" /* sessionMixin */], __WEBPACK_IMPORTED_MODULE_7__DNFORM_mixins_DNFORM_stepper_mixin__["a" /* stepperMixin */], __WEBPACK_IMPORTED_MODULE_8__DNFORM_mixins_DNFORM_summary_mixin__["a" /* summaryMixin */], __WEBPACK_IMPORTED_MODULE_9__DNFORM_mixins_DNFORM_validation_mixin__["a" /* validationMixin */]],
	created: function created() {
		this.model = JSON.parse(JSON.stringify(this.formModel));
		this.validation = JSON.parse(JSON.stringify(this.formValidation));
		this.extendValidation(this.validation, true);
	},
	mounted: function mounted() {
		var _this = this;

		Object(__WEBPACK_IMPORTED_MODULE_10__common_recaptcha_v3_init_recaptcha_v3__["a" /* initRecaptcha */])();
		window.addEventListener('beforeunload', function (event) {
			if (_this.warnOnPageLeave) {
				event.preventDefault();
				event.returnValue = '';
			}
		});
	}
});

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueSelect = e() : t.VueSelect = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    var e = {};function n(o) {
      if (e[o]) return e[o].exports;var i = e[o] = { i: o, l: !1, exports: {} };return t[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: o });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var o = Object.create(null);if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var i in t) {
        n.d(o, i, function (e) {
          return t[e];
        }.bind(null, i));
      }return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/", n(n.s = 8);
  }([function (t, e, n) {
    var o = n(4),
        i = n(5),
        r = n(6);t.exports = function (t) {
      return o(t) || i(t) || r();
    };
  }, function (t, e) {
    function n(e) {
      return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? t.exports = n = function n(t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
      }, n(e);
    }t.exports = n;
  }, function (t, e, n) {}, function (t, e) {
    t.exports = function (t, e, n) {
      return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }return n;
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (t, e, n) {
    "use strict";
    var o = n(2);n.n(o).a;
  }, function (t, e, n) {
    "use strict";
    n.r(e);var o = n(0),
        i = n.n(o),
        r = n(1),
        s = n.n(r),
        a = n(3),
        l = n.n(a),
        c = { props: { autoscroll: { type: Boolean, default: !0 } }, watch: { typeAheadPointer: function typeAheadPointer() {
          this.autoscroll && this.maybeAdjustScroll();
        } }, methods: { maybeAdjustScroll: function maybeAdjustScroll() {
          var t,
              e = (null === (t = this.$refs.dropdownMenu) || void 0 === t ? void 0 : t.children[this.typeAheadPointer]) || !1;if (e) {
            var n = this.getDropdownViewport(),
                o = e.getBoundingClientRect(),
                i = o.top,
                r = o.bottom,
                s = o.height;if (i < n.top) return this.$refs.dropdownMenu.scrollTop = e.offsetTop;if (r > n.bottom) return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (n.height - s);
          }
        }, getDropdownViewport: function getDropdownViewport() {
          return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : { height: 0, top: 0, bottom: 0 };
        } } },
        u = { data: function data() {
        return { typeAheadPointer: -1 };
      }, watch: { filteredOptions: function filteredOptions() {
          for (var t = 0; t < this.filteredOptions.length; t++) {
            if (this.selectable(this.filteredOptions[t])) {
              this.typeAheadPointer = t;break;
            }
          }
        } }, methods: { typeAheadUp: function typeAheadUp() {
          for (var t = this.typeAheadPointer - 1; t >= 0; t--) {
            if (this.selectable(this.filteredOptions[t])) {
              this.typeAheadPointer = t;break;
            }
          }
        }, typeAheadDown: function typeAheadDown() {
          for (var t = this.typeAheadPointer + 1; t < this.filteredOptions.length; t++) {
            if (this.selectable(this.filteredOptions[t])) {
              this.typeAheadPointer = t;break;
            }
          }
        }, typeAheadSelect: function typeAheadSelect() {
          var t = this.filteredOptions[this.typeAheadPointer];t && this.select(t);
        } } },
        p = { props: { loading: { type: Boolean, default: !1 } }, data: function data() {
        return { mutableLoading: !1 };
      }, watch: { search: function search() {
          this.$emit("search", this.search, this.toggleLoading);
        }, loading: function loading(t) {
          this.mutableLoading = t;
        } }, methods: { toggleLoading: function toggleLoading() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;return this.mutableLoading = null == t ? !this.mutableLoading : t;
        } } };function h(t, e, n, o, i, r, s, a) {
      var l,
          c = "function" == typeof t ? t.options : t;if (e && (c.render = e, c.staticRenderFns = n, c._compiled = !0), o && (c.functional = !0), r && (c._scopeId = "data-v-" + r), s ? (l = function l(t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(s);
      }, c._ssrRegister = l) : i && (l = a ? function () {
        i.call(this, this.$root.$options.shadowRoot);
      } : i), l) if (c.functional) {
        c._injectStyles = l;var u = c.render;c.render = function (t, e) {
          return l.call(e), u(t, e);
        };
      } else {
        var p = c.beforeCreate;c.beforeCreate = p ? [].concat(p, l) : [l];
      }return { exports: t, options: c };
    }var d = { Deselect: h({}, function () {
        var t = this.$createElement,
            e = this._self._c || t;return e("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10" } }, [e("path", { attrs: { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" } })]);
      }, [], !1, null, null, null).exports, OpenIndicator: h({}, function () {
        var t = this.$createElement,
            e = this._self._c || t;return e("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "10" } }, [e("path", { attrs: { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" } })]);
      }, [], !1, null, null, null).exports },
        f = { inserted: function inserted(t, e, n) {
        var o = n.context;if (o.appendToBody) {
          var i = o.$refs.toggle.getBoundingClientRect(),
              r = i.height,
              s = i.top,
              a = i.left,
              l = i.width,
              c = window.scrollX || window.pageXOffset,
              u = window.scrollY || window.pageYOffset;t.unbindPosition = o.calculatePosition(t, o, { width: l + "px", left: c + a + "px", top: u + s + r + "px" }), document.body.appendChild(t);
        }
      }, unbind: function unbind(t, e, n) {
        n.context.appendToBody && (t.unbindPosition && "function" == typeof t.unbindPosition && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
      } };var y = function y(t) {
      var e = {};return Object.keys(t).sort().forEach(function (n) {
        e[n] = t[n];
      }), JSON.stringify(e);
    },
        b = 0;var g = function g() {
      return ++b;
    };function v(t, e) {
      var n = Object.keys(t);if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(t);e && (o = o.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, o);
      }return n;
    }function m(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};e % 2 ? v(Object(n), !0).forEach(function (e) {
          l()(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }return t;
    }var _ = { components: m({}, d), directives: { appendToBody: f }, mixins: [c, u, p], props: { value: {}, components: { type: Object, default: function _default() {
            return {};
          } }, options: { type: Array, default: function _default() {
            return [];
          } }, disabled: { type: Boolean, default: !1 }, clearable: { type: Boolean, default: !0 }, searchable: { type: Boolean, default: !0 }, multiple: { type: Boolean, default: !1 }, placeholder: { type: String, default: "" }, transition: { type: String, default: "vs__fade" }, clearSearchOnSelect: { type: Boolean, default: !0 }, closeOnSelect: { type: Boolean, default: !0 }, label: { type: String, default: "label" }, autocomplete: { type: String, default: "off" }, reduce: { type: Function, default: function _default(t) {
            return t;
          } }, selectable: { type: Function, default: function _default(t) {
            return !0;
          } }, getOptionLabel: { type: Function, default: function _default(t) {
            return "object" === s()(t) ? t.hasOwnProperty(this.label) ? t[this.label] : console.warn('[vue-select warn]: Label key "option.'.concat(this.label, '" does not') + " exist in options object ".concat(JSON.stringify(t), ".\n") + "https://vue-select.org/api/props.html#getoptionlabel") : t;
          } }, getOptionKey: { type: Function, default: function _default(t) {
            if ("object" !== s()(t)) return t;try {
              return t.hasOwnProperty("id") ? t.id : y(t);
            } catch (e) {
              return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey", t, e);
            }
          } }, onTab: { type: Function, default: function _default() {
            this.selectOnTab && !this.isComposing && this.typeAheadSelect();
          } }, taggable: { type: Boolean, default: !1 }, tabindex: { type: Number, default: null }, pushTags: { type: Boolean, default: !1 }, filterable: { type: Boolean, default: !0 }, filterBy: { type: Function, default: function _default(t, e, n) {
            return (e || "").toLowerCase().indexOf(n.toLowerCase()) > -1;
          } }, filter: { type: Function, default: function _default(t, e) {
            var n = this;return t.filter(function (t) {
              var o = n.getOptionLabel(t);return "number" == typeof o && (o = o.toString()), n.filterBy(t, o, e);
            });
          } }, createOption: { type: Function, default: function _default(t) {
            return "object" === s()(this.optionList[0]) ? l()({}, this.label, t) : t;
          } }, resetOnOptionsChange: { default: !1, validator: function validator(t) {
            return ["function", "boolean"].includes(s()(t));
          } }, clearSearchOnBlur: { type: Function, default: function _default(t) {
            var e = t.clearSearchOnSelect,
                n = t.multiple;return e && !n;
          } }, noDrop: { type: Boolean, default: !1 }, inputId: { type: String }, dir: { type: String, default: "auto" }, selectOnTab: { type: Boolean, default: !1 }, selectOnKeyCodes: { type: Array, default: function _default() {
            return [13];
          } }, searchInputQuerySelector: { type: String, default: "[type=search]" }, mapKeydown: { type: Function, default: function _default(t, e) {
            return t;
          } }, appendToBody: { type: Boolean, default: !1 }, calculatePosition: { type: Function, default: function _default(t, e, n) {
            var o = n.width,
                i = n.top,
                r = n.left;t.style.top = i, t.style.left = r, t.style.width = o;
          } }, dropdownShouldOpen: { type: Function, default: function _default(t) {
            var e = t.noDrop,
                n = t.open,
                o = t.mutableLoading;return !e && n && !o;
          } } }, data: function data() {
        return { uid: g(), search: "", open: !1, isComposing: !1, pushedTags: [], _value: [] };
      }, computed: { isTrackingValues: function isTrackingValues() {
          return void 0 === this.value || this.$options.propsData.hasOwnProperty("reduce");
        }, selectedValue: function selectedValue() {
          var t = this.value;return this.isTrackingValues && (t = this.$data._value), t ? [].concat(t) : [];
        }, optionList: function optionList() {
          return this.options.concat(this.pushTags ? this.pushedTags : []);
        }, searchEl: function searchEl() {
          return this.$scopedSlots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
        }, scope: function scope() {
          var t = this,
              e = { search: this.search, loading: this.loading, searching: this.searching, filteredOptions: this.filteredOptions };return { search: { attributes: m({ disabled: this.disabled, placeholder: this.searchPlaceholder, tabindex: this.tabindex, readonly: !this.searchable, id: this.inputId, "aria-autocomplete": "list", "aria-labelledby": "vs".concat(this.uid, "__combobox"), "aria-controls": "vs".concat(this.uid, "__listbox"), ref: "search", type: "search", autocomplete: this.autocomplete, value: this.search }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? { "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer) } : {}), events: { compositionstart: function compositionstart() {
                  return t.isComposing = !0;
                }, compositionend: function compositionend() {
                  return t.isComposing = !1;
                }, keydown: this.onSearchKeyDown, blur: this.onSearchBlur, focus: this.onSearchFocus, input: function input(e) {
                  return t.search = e.target.value;
                } } }, spinner: { loading: this.mutableLoading }, noOptions: { search: this.search, loading: this.mutableLoading, searching: this.searching }, openIndicator: { attributes: { ref: "openIndicator", role: "presentation", class: "vs__open-indicator" } }, listHeader: e, listFooter: e, header: m({}, e, { deselect: this.deselect }), footer: m({}, e, { deselect: this.deselect }) };
        }, childComponents: function childComponents() {
          return m({}, d, {}, this.components);
        }, stateClasses: function stateClasses() {
          return { "vs--open": this.dropdownOpen, "vs--single": !this.multiple, "vs--searching": this.searching && !this.noDrop, "vs--searchable": this.searchable && !this.noDrop, "vs--unsearchable": !this.searchable, "vs--loading": this.mutableLoading, "vs--disabled": this.disabled };
        }, searching: function searching() {
          return !!this.search;
        }, dropdownOpen: function dropdownOpen() {
          return this.dropdownShouldOpen(this);
        }, searchPlaceholder: function searchPlaceholder() {
          return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
        }, filteredOptions: function filteredOptions() {
          var t = [].concat(this.optionList);if (!this.filterable && !this.taggable) return t;var e = this.search.length ? this.filter(t, this.search, this) : t;if (this.taggable && this.search.length) {
            var n = this.createOption(this.search);this.optionExists(n) || e.unshift(n);
          }return e;
        }, isValueEmpty: function isValueEmpty() {
          return 0 === this.selectedValue.length;
        }, showClearButton: function showClearButton() {
          return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
        } }, watch: { options: function options(t, e) {
          var n = this;!this.taggable && ("function" == typeof n.resetOnOptionsChange ? n.resetOnOptionsChange(t, e, n.selectedValue) : n.resetOnOptionsChange) && this.clearSelection(), this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value);
        }, value: function value(t) {
          this.isTrackingValues && this.setInternalValueFromOptions(t);
        }, multiple: function multiple() {
          this.clearSelection();
        }, open: function open(t) {
          this.$emit(t ? "open" : "close");
        } }, created: function created() {
        this.mutableLoading = this.loading, void 0 !== this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value), this.$on("option:created", this.pushTag);
      }, methods: { setInternalValueFromOptions: function setInternalValueFromOptions(t) {
          var e = this;Array.isArray(t) ? this.$data._value = t.map(function (t) {
            return e.findOptionFromReducedValue(t);
          }) : this.$data._value = this.findOptionFromReducedValue(t);
        }, select: function select(t) {
          this.$emit("option:selecting", t), this.isOptionSelected(t) || (this.taggable && !this.optionExists(t) && this.$emit("option:created", t), this.multiple && (t = this.selectedValue.concat(t)), this.updateValue(t), this.$emit("option:selected", t)), this.onAfterSelect(t);
        }, deselect: function deselect(t) {
          var e = this;this.$emit("option:deselecting", t), this.updateValue(this.selectedValue.filter(function (n) {
            return !e.optionComparator(n, t);
          })), this.$emit("option:deselected", t);
        }, clearSelection: function clearSelection() {
          this.updateValue(this.multiple ? [] : null);
        }, onAfterSelect: function onAfterSelect(t) {
          this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
        }, updateValue: function updateValue(t) {
          var e = this;void 0 === this.value && (this.$data._value = t), null !== t && (t = Array.isArray(t) ? t.map(function (t) {
            return e.reduce(t);
          }) : this.reduce(t)), this.$emit("input", t);
        }, toggleDropdown: function toggleDropdown(t) {
          var e = t.target !== this.searchEl;e && t.preventDefault();var n = [].concat(i()(this.$refs.deselectButtons || []), i()([this.$refs.clearButton] || !1));void 0 === this.searchEl || n.filter(Boolean).some(function (e) {
            return e.contains(t.target) || e === t.target;
          }) ? t.preventDefault() : this.open && e ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
        }, isOptionSelected: function isOptionSelected(t) {
          var e = this;return this.selectedValue.some(function (n) {
            return e.optionComparator(n, t);
          });
        }, optionComparator: function optionComparator(t, e) {
          return this.getOptionKey(t) === this.getOptionKey(e);
        }, findOptionFromReducedValue: function findOptionFromReducedValue(t) {
          var e = this,
              n = [].concat(i()(this.options), i()(this.pushedTags)).filter(function (n) {
            return JSON.stringify(e.reduce(n)) === JSON.stringify(t);
          });return 1 === n.length ? n[0] : n.find(function (t) {
            return e.optionComparator(t, e.$data._value);
          }) || t;
        }, closeSearchOptions: function closeSearchOptions() {
          this.open = !1, this.$emit("search:blur");
        }, maybeDeleteValue: function maybeDeleteValue() {
          if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
            var t = null;this.multiple && (t = i()(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(t);
          }
        }, optionExists: function optionExists(t) {
          var e = this;return this.optionList.some(function (n) {
            return e.optionComparator(n, t);
          });
        }, normalizeOptionForSlot: function normalizeOptionForSlot(t) {
          return "object" === s()(t) ? t : l()({}, this.label, t);
        }, pushTag: function pushTag(t) {
          this.pushedTags.push(t);
        }, onEscape: function onEscape() {
          this.search.length ? this.search = "" : this.searchEl.blur();
        }, onSearchBlur: function onSearchBlur() {
          if (!this.mousedown || this.searching) {
            var t = this.clearSearchOnSelect,
                e = this.multiple;return this.clearSearchOnBlur({ clearSearchOnSelect: t, multiple: e }) && (this.search = ""), void this.closeSearchOptions();
          }this.mousedown = !1, 0 !== this.search.length || 0 !== this.options.length || this.closeSearchOptions();
        }, onSearchFocus: function onSearchFocus() {
          this.open = !0, this.$emit("search:focus");
        }, onMousedown: function onMousedown() {
          this.mousedown = !0;
        }, onMouseUp: function onMouseUp() {
          this.mousedown = !1;
        }, onSearchKeyDown: function onSearchKeyDown(t) {
          var e = this,
              n = function n(t) {
            return t.preventDefault(), !e.isComposing && e.typeAheadSelect();
          },
              o = { 8: function _(t) {
              return e.maybeDeleteValue();
            }, 9: function _(t) {
              return e.onTab();
            }, 27: function _(t) {
              return e.onEscape();
            }, 38: function _(t) {
              return t.preventDefault(), e.typeAheadUp();
            }, 40: function _(t) {
              return t.preventDefault(), e.typeAheadDown();
            } };this.selectOnKeyCodes.forEach(function (t) {
            return o[t] = n;
          });var i = this.mapKeydown(o, this);if ("function" == typeof i[t.keyCode]) return i[t.keyCode](t);
        } } },
        O = (n(7), h(_, function () {
      var t = this,
          e = t.$createElement,
          n = t._self._c || e;return n("div", { staticClass: "v-select", class: t.stateClasses, attrs: { dir: t.dir } }, [t._t("header", null, null, t.scope.header), t._v(" "), n("div", { ref: "toggle", staticClass: "vs__dropdown-toggle", attrs: { id: "vs" + t.uid + "__combobox", role: "combobox", "aria-expanded": t.dropdownOpen.toString(), "aria-owns": "vs" + t.uid + "__listbox", "aria-label": "Search for option" }, on: { mousedown: function mousedown(e) {
            return t.toggleDropdown(e);
          } } }, [n("div", { ref: "selectedOptions", staticClass: "vs__selected-options" }, [t._l(t.selectedValue, function (e) {
        return t._t("selected-option-container", [n("span", { key: t.getOptionKey(e), staticClass: "vs__selected" }, [t._t("selected-option", [t._v("\n            " + t._s(t.getOptionLabel(e)) + "\n          ")], null, t.normalizeOptionForSlot(e)), t._v(" "), t.multiple ? n("button", { ref: "deselectButtons", refInFor: !0, staticClass: "vs__deselect", attrs: { disabled: t.disabled, type: "button", title: "Deselect " + t.getOptionLabel(e), "aria-label": "Deselect " + t.getOptionLabel(e) }, on: { click: function click(n) {
              return t.deselect(e);
            } } }, [n(t.childComponents.Deselect, { tag: "component" })], 1) : t._e()], 2)], { option: t.normalizeOptionForSlot(e), deselect: t.deselect, multiple: t.multiple, disabled: t.disabled });
      }), t._v(" "), t._t("search", [n("input", t._g(t._b({ staticClass: "vs__search" }, "input", t.scope.search.attributes, !1), t.scope.search.events))], null, t.scope.search)], 2), t._v(" "), n("div", { ref: "actions", staticClass: "vs__actions" }, [n("button", { directives: [{ name: "show", rawName: "v-show", value: t.showClearButton, expression: "showClearButton" }], ref: "clearButton", staticClass: "vs__clear", attrs: { disabled: t.disabled, type: "button", title: "Clear Selected", "aria-label": "Clear Selected" }, on: { click: t.clearSelection } }, [n(t.childComponents.Deselect, { tag: "component" })], 1), t._v(" "), t._t("open-indicator", [t.noDrop ? t._e() : n(t.childComponents.OpenIndicator, t._b({ tag: "component" }, "component", t.scope.openIndicator.attributes, !1))], null, t.scope.openIndicator), t._v(" "), t._t("spinner", [n("div", { directives: [{ name: "show", rawName: "v-show", value: t.mutableLoading, expression: "mutableLoading" }], staticClass: "vs__spinner" }, [t._v("Loading...")])], null, t.scope.spinner)], 2)]), t._v(" "), n("transition", { attrs: { name: t.transition } }, [t.dropdownOpen ? n("ul", { directives: [{ name: "append-to-body", rawName: "v-append-to-body" }], key: "vs" + t.uid + "__listbox", ref: "dropdownMenu", staticClass: "vs__dropdown-menu", attrs: { id: "vs" + t.uid + "__listbox", role: "listbox", tabindex: "-1" }, on: { mousedown: function mousedown(e) {
            return e.preventDefault(), t.onMousedown(e);
          }, mouseup: t.onMouseUp } }, [t._t("list-header", null, null, t.scope.listHeader), t._v(" "), t._l(t.filteredOptions, function (e, o) {
        return n("li", { key: t.getOptionKey(e), staticClass: "vs__dropdown-option", class: { "vs__dropdown-option--selected": t.isOptionSelected(e), "vs__dropdown-option--highlight": o === t.typeAheadPointer, "vs__dropdown-option--disabled": !t.selectable(e) }, attrs: { id: "vs" + t.uid + "__option-" + o, role: "option", "aria-selected": o === t.typeAheadPointer || null }, on: { mouseover: function mouseover(n) {
              t.selectable(e) && (t.typeAheadPointer = o);
            }, click: function click(n) {
              n.preventDefault(), n.stopPropagation(), t.selectable(e) && t.select(e);
            } } }, [t._t("option", [t._v("\n          " + t._s(t.getOptionLabel(e)) + "\n        ")], null, t.normalizeOptionForSlot(e))], 2);
      }), t._v(" "), 0 === t.filteredOptions.length ? n("li", { staticClass: "vs__no-options" }, [t._t("no-options", [t._v("Sorry, no matching options.")], null, t.scope.noOptions)], 2) : t._e(), t._v(" "), t._t("list-footer", null, null, t.scope.listFooter)], 2) : n("ul", { staticStyle: { display: "none", visibility: "hidden" }, attrs: { id: "vs" + t.uid + "__listbox", role: "listbox" } })]), t._v(" "), t._t("footer", null, null, t.scope.footer)], 2);
    }, [], !1, null, null, null).exports),
        w = { ajax: p, pointer: u, pointerScroll: c };n.d(e, "VueSelect", function () {
      return O;
    }), n.d(e, "mixins", function () {
      return w;
    });e.default = O;
  }]);
});
//# sourceMappingURL=vue-select.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module)))

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_developer_tools_node_modules_vue_loader_lib_selector_type_script_index_0_DNFORM_phone_number_vue__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_739d34d0_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_DNFORM_phone_number_vue__ = __webpack_require__(762);
var normalizeComponent = __webpack_require__(102)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_developer_tools_node_modules_vue_loader_lib_selector_type_script_index_0_DNFORM_phone_number_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_739d34d0_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_DNFORM_phone_number_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DNFORM_mixins_DNFORM_input_focus_handler_mixin__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var INPUT_REF = 'phoneNumber';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PhoneNumber',
	mixins: [__WEBPACK_IMPORTED_MODULE_0__DNFORM_mixins_DNFORM_input_focus_handler_mixin__["a" /* inputFocusHandlerMixin */]],
	props: {
		value: {
			type: Object,
			required: true
		},
		modelName: {
			type: String,
			required: true
		},
		fixedCountryCode: {
			type: String,
			required: false,
			default: ''
		},
		countryCodes: {
			type: Array,
			required: false,
			default: undefined
		},
		areaCodes: {
			type: Object,
			required: false,
			default: undefined
		}
	},
	data: function data() {
		return {
			countryCode: this.getCountryCode(),
			areaCode: '',
			phoneNumber: '',
			touchedFields: {
				countryCode: false,
				areaCode: false,
				phoneNumber: false
			},
			areaCodeOptions: []
		};
	},

	computed: {
		hasSelectOptions: function hasSelectOptions() {
			return !!(this.countryCodes && this.countryCodes.length && this.areaCodes && Object.keys(this.areaCodes).length);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler: function handler(newValue) {
				if (newValue.countryCode && newValue.areaCode && newValue.phoneNumber) {
					this.countryCode = this.getCountryCode(newValue.countryCode);
					this.areaCode = newValue.areaCode;
					this.phoneNumber = newValue.phoneNumber;
				}
			}
		},
		countryCode: {
			immediate: true,
			handler: function handler(newCountryCode) {
				if (this.hasSelectOptions) {
					this.getAreaCodeOptionsForCountryCode(newCountryCode);
					this.selectFirstAreaCodeOption();
				}
				this.emitPhoneNumberObject();
			}
		},
		areaCode: function areaCode() {
			this.emitPhoneNumberObject();
		},
		phoneNumber: function phoneNumber() {
			this.emitPhoneNumberObject();
		}
	},
	mounted: function mounted() {
		if (this.countryCode || this.fixedCountryCode) {
			this.touchedFields.countryCode = true;
		}

		if (this.areaCode) {
			this.touchedFields.areaCode = true;
		}

		if (this.phoneNumber) {
			this.touchedFields.phoneNumber = true;
		}
	},

	methods: {
		getCountryCode: function getCountryCode(value) {
			return value || this.fixedCountryCode || (this.hasSelectOptions ? this.countryCodes[0] : '');
		},
		getAreaCodeOptionsForCountryCode: function getAreaCodeOptionsForCountryCode(newCountryCode) {
			this.areaCodeOptions = this.areaCodes[newCountryCode] || [];
		},
		selectFirstAreaCodeOption: function selectFirstAreaCodeOption() {
			this.areaCode = this.areaCodeOptions.length ? this.areaCodeOptions[0] : '';
		},
		onKeyDown: function onKeyDown(event) {
			if (event.key && event.key.length == 1 && !event.key.match(/[0-9]/)) {
				event.preventDefault();
			}

			if (event.key === __WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_constants__["g" /* KEYS */].BACKSPACE) {
				this.setFocusOnPrevInput(event.target, INPUT_REF, this.shouldSetFocusOnPrevInput);
			}
		},
		onBlur: function onBlur(event, id) {
			// The id param comes from the select component's select event
			this.touchedFields[id || event.target && event.target.name] = true;
			var allFieldsTouched = Object.values(this.touchedFields).every(function (field) {
				return !!field;
			});

			if (allFieldsTouched) {
				this.$emit(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].BLUR_TO_VALIDATE, this.modelName);
			}
		},
		onInput: function onInput(event, field) {
			var isInputTypeSelect = event && typeof event === 'string';
			// If true then the event parameter is equal to the selected value
			this[field] = isInputTypeSelect ? event : event.target && event.target.value;

			if (!isInputTypeSelect && event) {
				this.setFocusOnNextInput(event.target, INPUT_REF, this.shouldSetFocusOnNextInput);
			}
		},
		emitPhoneNumberObject: function emitPhoneNumberObject() {
			var phoneNumber = {
				countryCode: this.countryCode,
				areaCode: this.areaCode,
				phoneNumber: this.phoneNumber
			};

			var staticCountryCode = !!(this.fixedCountryCode || this.hasSelectOptions);
			var staticAreaCode = !!this.areaCodes;
			// empty model when no phoneNumber set and there are static area and country codes
			if (!this.phoneNumber && staticAreaCode && staticCountryCode || !this.phoneNumber && !this.areaCode && staticCountryCode) {
				phoneNumber = {
					countryCode: '',
					areaCode: '',
					phoneNumber: ''
				};
			}

			this.$emit(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].INPUT, phoneNumber);
			this.$emit(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].INPUT_TO_VALIDATE, this.modelName);
		},
		shouldSetFocusOnPrevInput: function shouldSetFocusOnPrevInput(targetInput) {
			var value = targetInput.value,
			    dataset = targetInput.dataset;

			return !value.length && dataset.autoTabIndex;
		},
		shouldSetFocusOnNextInput: function shouldSetFocusOnNextInput(targetInput) {
			var maxLength = targetInput.maxLength,
			    value = targetInput.value,
			    dataset = targetInput.dataset;

			return maxLength === value.length && dataset.autoTabIndex;
		}
	}
});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inputFocusHandlerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);


var inputFocusHandlerMixin = {
	methods: {
		setFocusOnPrevInput: function setFocusOnPrevInput(targetInput, ref, shouldSetCallback) {
			var shouldSetFocus = shouldSetCallback(targetInput);

			if (shouldSetFocus) {
				var prevAutoTabIndex = Number(targetInput.dataset.autoTabIndex) - 1;

				if (this.$refs[ref]) {
					var prevInput = this.$refs[ref].querySelector('[' + __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["a" /* AUTO_TAB_INDEX_DATA_ATTR */] + '="' + prevAutoTabIndex + '"]');

					if (prevInput) {
						prevInput.focus();
					}
				}
			}
		},
		setFocusOnNextInput: function setFocusOnNextInput(targetInput, ref, shouldSetCallback) {
			var shouldSetFocus = shouldSetCallback(targetInput);

			if (shouldSetFocus) {
				var nextAutoTabIndex = Number(targetInput.dataset.autoTabIndex) + 1;

				if (this.$refs[ref]) {
					var nextInput = this.$refs[ref].querySelector('[' + __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["a" /* AUTO_TAB_INDEX_DATA_ATTR */] + '="' + nextAutoTabIndex + '"]');

					if (nextInput) {
						nextInput.focus();
					}
				}
			}
		}
	}
};

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"phoneNumber",staticClass:"phone-number-container"},[_vm._t("default",null,{"countryCode":_vm.countryCode,"areaCode":_vm.areaCode,"phoneNumber":_vm.phoneNumber,"countryCodeOptions":_vm.countryCodes,"areaCodeOptions":_vm.areaCodeOptions,"onKeyDown":_vm.onKeyDown,"onBlur":_vm.onBlur,"onInput":_vm.onInput})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_developer_tools_node_modules_vue_loader_lib_selector_type_script_index_0_DNFORM_input_email_vue__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_682002af_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_DNFORM_input_email_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(102)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_developer_tools_node_modules_vue_loader_lib_selector_type_script_index_0_DNFORM_input_email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_682002af_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_DNFORM_input_email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'InputEmail',
	data: function data() {
		return {
			model: null
		};
	},

	props: {
		value: {
			required: true
		}
	},
	computed: {
		inputListeners: function inputListeners() {
			var vm = this;
			return Object.assign({}, this.$listeners, {
				input: function input(event) {
					if (event.target.value == "") {
						vm.model = null;
					};
					vm.$emit('input', vm.model);
				}
			});
		}
	},
	watch: {
		value: function value(newValue) {
			this.model = newValue;
		}
	}
});

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],domProps:{"value":(_vm.model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.model=$event.target.value}}},_vm.inputListeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileInputMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_unionBy__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_unionBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_differenceBy__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_differenceBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_differenceBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_utils__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_api__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);







var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('sf:dynaform:dnform-file-input-mixin');

var fileInputMixin = {
	data: function data() {
		return {
			FILE_INPUT_STATES: __WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */],
			isUploading: {},
			uploadProgress: {},
			isDragOn: {},
			uploadedFiles: {}
		};
	},
	created: function created() {
		var _this = this;

		// Set the init values of the file input states to make them accessible and reactive
		var endStep = this.isSummaryEnabled ? this.totalSteps - 1 : this.totalSteps;

		var _loop = function _loop(step) {
			Object.values(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */]).forEach(function (state) {
				_this.$set(_this[state], step, {});
			});
		};

		for (var step = 1; step <= endStep; step++) {
			_loop(step);
		}
	},

	methods: {
		// To set the isUploading, isDragOn, uploadProgress and uploadedFiles states of a specific file input
		setFileInputState: function setFileInputState(state, fileInputId, stateValue) {
			this.$set(this[state][this.currentStep], fileInputId, stateValue);
		},
		getFilesOfFileInput: function getFilesOfFileInput(fileInputId) {
			return this.model[this.currentStep][fileInputId] ? this.model[this.currentStep][fileInputId] : [];
		},
		setFilesOfFileInput: function setFilesOfFileInput(fileInputId, newFiles) {
			var includeCurrentFiles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			var currentFiles = includeCurrentFiles ? this.getFilesOfFileInput(fileInputId) : [];
			var totalFiles = this.replaceExistingFilesWithNew(newFiles, currentFiles);
			// Set the file input's model value to empty string If we deleted all files to make the 'required' validation rule fail
			this.model[this.currentStep][fileInputId] = totalFiles.length ? totalFiles : '';
		},
		removeFilesFromInput: function removeFilesFromInput(fileInputId, filesToRemove) {
			var currentFiles = this.getFilesOfFileInput(fileInputId);
			var remainingFiles = __WEBPACK_IMPORTED_MODULE_2_lodash_differenceBy___default()(currentFiles, Array.from(filesToRemove));
			this.model[this.currentStep][fileInputId] = remainingFiles.length ? remainingFiles : '';
		},
		replaceExistingFilesWithNew: function replaceExistingFilesWithNew(newFiles, currentFiles) {
			return __WEBPACK_IMPORTED_MODULE_1_lodash_unionBy___default()(Array.from(newFiles), Array.from(currentFiles), 'name');
		},
		onUploadProgress: function onUploadProgress(fileInputId) {
			var _this2 = this;

			return function (progressEvent) {
				var progressInPercentage = Math.round(progressEvent.loaded / progressEvent.total * 100);
				_this2.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].UPLOAD_PROGRESS, fileInputId, progressInPercentage);
			};
		},
		uploadFiles: function uploadFiles(fileInputId, files) {
			var _this3 = this;

			this.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].IS_UPLOADING, fileInputId, true);
			var formData = new FormData();

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var file = _step.value;

					formData.append('files', file);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			Object(__WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_api__["f" /* uploadFiles */])(this.formId, this.sessionToken, this.currentStep, fileInputId, formData, this.onUploadProgress).then(function (response) {
				if (response.data && response.data.length) {
					_this3.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].UPLOADED_FILES, fileInputId, response.data);
				} else if (response.data[_this3.currentStep] && response.data[_this3.currentStep].length) {
					_this3.handleErrorResponse(response.data);
				}
			}).catch(function (error) {
				_this3.removeFilesFromInput(fileInputId, files);
				console.error('Failed to upload files', error, 'Params:', { formId: _this3.formId, sessionToken: _this3.sessionToken, pageNumber: _this3.currentStep, fileInputId: fileInputId, formData: formData });
			}).finally(function () {
				_this3.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].IS_UPLOADING, fileInputId, false);
			});
		},
		deleteFile: function deleteFile(fileInputId, filename) {
			var _this4 = this;

			Object(__WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_api__["a" /* deleteFile */])(this.formId, this.sessionToken, fileInputId, filename).then(function (response) {
				var remainingFileObjects = _this4.model[_this4.currentStep][fileInputId].filter(function (uploadedFile) {
					return uploadedFile.name !== filename;
				});
				_this4.setFilesOfFileInput(fileInputId, remainingFileObjects, false);
				_this4.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].UPLOADED_FILES, fileInputId, response.data);
				_this4.validateInput(fileInputId);
			}).catch(function (error) {
				console.error('Failed to delete file', error, 'Params:', { formId: _this4.formId, sessionToken: _this4.sessionToken, fileInputId: fileInputId, filename: filename });
			});
		},
		validateFiles: function validateFiles(fileInputId, files) {
			var _this5 = this;

			debug('validateFiles', { fileInputId: fileInputId, files: files });
			// We should handle this with livr but it doesn't support async validation
			return Object(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_utils__["b" /* hasFileWithFakeExtension */])(files).then(function (hasError) {
				debug('validateFiles then', { hasError: hasError });
				_this5.setFilesOfFileInput(fileInputId, files);
				_this5.validateInput(fileInputId);

				if (hasError) {
					_this5.errors.items[fileInputId] = __WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["c" /* ERROR_CODES */].FORBIDDEN_FILE_EXTENSION;
					_this5.errors.touchedFields[fileInputId] = true;
				}
			}).catch(function (error) {
				console.error('Failed to get result of hasFileWithFakeExtension', error, 'File input ID', fileInputId);
			});
		},
		handleFileUpload: function handleFileUpload(fileInputId, files) {
			if (!this.errors.items[fileInputId]) {
				this.uploadFiles(fileInputId, files);
			} else {
				this.removeFilesFromInput(fileInputId, files);
			}
		},
		handleFileDrop: function handleFileDrop(event, id) {
			var _this6 = this;

			var files = event.dataTransfer.files;

			this.setFileInputState(__WEBPACK_IMPORTED_MODULE_5__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].IS_DRAG_ON, id, false);
			this.turnOnPageLeaveWarning();

			this.validateFiles(id, files).then(function () {
				return _this6.handleFileUpload(id, files);
			}).catch(function (error) {
				console.error('Failed to validate files while handling file drop', error, 'File input ID', id);
			});
		},
		handleFileInput: function handleFileInput(event) {
			var _this7 = this;

			debug('handleFileInput');
			var _event$target = event.target,
			    id = _event$target.id,
			    files = _event$target.files;

			this.turnOnPageLeaveWarning();

			this.validateFiles(id, files).then(function () {
				debug('handleFileInput validateFiles then');
				_this7.handleFileUpload(id, files);
			}).catch(function (error) {
				console.error('Failed to validate files while handling file input', error, 'File input ID', id);
			});
		}
	}
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(629),
    baseIteratee = __webpack_require__(631),
    baseRest = __webpack_require__(310),
    baseUniq = __webpack_require__(836),
    isArrayLikeObject = __webpack_require__(311),
    last = __webpack_require__(650);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function (arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150),
    isArguments = __webpack_require__(246),
    isArray = __webpack_require__(63);

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(151),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(773),
    getMatchData = __webpack_require__(816),
    matchesStrictComparable = __webpack_require__(643);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(247),
    baseIsEqual = __webpack_require__(633);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(249);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(249);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(249);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(249);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 782 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(248),
    Map = __webpack_require__(295),
    MapCache = __webpack_require__(297);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(296),
    isMasked = __webpack_require__(785),
    isObject = __webpack_require__(87),
    toSource = __webpack_require__(632);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(786);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(80);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(789),
    ListCache = __webpack_require__(248),
    Map = __webpack_require__(295);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(790),
    hashDelete = __webpack_require__(791),
    hashGet = __webpack_require__(792),
    hashHas = __webpack_require__(793),
    hashSet = __webpack_require__(794);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(250);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(250);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(250);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(250);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(251);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(251);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(251);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(251);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(247),
    equalArrays = __webpack_require__(634),
    equalByTag = __webpack_require__(804),
    equalObjects = __webpack_require__(806),
    getTag = __webpack_require__(256),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(253),
    isTypedArray = __webpack_require__(303);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150),
    Uint8Array = __webpack_require__(635),
    eq = __webpack_require__(162),
    equalArrays = __webpack_require__(634),
    mapToArray = __webpack_require__(805),
    setToArray = __webpack_require__(300);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(636);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 808 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 809 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(151),
    isLength = __webpack_require__(304),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(306),
    nativeKeys = __webpack_require__(812);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(640);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(80);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(80);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(108),
    root = __webpack_require__(80);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(642),
    keys = __webpack_require__(252);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(633),
    get = __webpack_require__(818),
    hasIn = __webpack_require__(824),
    isKey = __webpack_require__(307),
    isStrictComparable = __webpack_require__(642),
    matchesStrictComparable = __webpack_require__(643),
    toKey = __webpack_require__(257);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(644);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(820);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(821);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(297);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(823);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150),
    arrayMap = __webpack_require__(646),
    isArray = __webpack_require__(63),
    isSymbol = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(825),
    hasPath = __webpack_require__(826);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(645),
    isArguments = __webpack_require__(246),
    isArray = __webpack_require__(63),
    isIndex = __webpack_require__(302),
    isLength = __webpack_require__(304),
    toKey = __webpack_require__(257);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

module.exports = hasPath;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(828),
    basePropertyDeep = __webpack_require__(829),
    isKey = __webpack_require__(307),
    toKey = __webpack_require__(257);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),
/* 828 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(644);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(831);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(833),
    shortOut = __webpack_require__(835);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(834),
    defineProperty = __webpack_require__(647),
    identity = __webpack_require__(309);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 835 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(298),
    arrayIncludes = __webpack_require__(648),
    arrayIncludesWith = __webpack_require__(649),
    cacheHas = __webpack_require__(299),
    createSet = __webpack_require__(841),
    setToArray = __webpack_require__(300);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(838),
    baseIsNaN = __webpack_require__(839),
    strictIndexOf = __webpack_require__(840);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;

/***/ }),
/* 838 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(641),
    noop = __webpack_require__(842),
    setToArray = __webpack_require__(300);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
  return new Set(values);
};

module.exports = createSet;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(844),
    baseFlatten = __webpack_require__(629),
    baseIteratee = __webpack_require__(631),
    baseRest = __webpack_require__(310),
    isArrayLikeObject = __webpack_require__(311),
    last = __webpack_require__(650);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function (array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2)) : [];
});

module.exports = differenceBy;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(298),
    arrayIncludes = __webpack_require__(648),
    arrayIncludesWith = __webpack_require__(649),
    arrayMap = __webpack_require__(646),
    baseUnary = __webpack_require__(254),
    cacheHas = __webpack_require__(299);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    } else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formSubmitMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_api__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DNFORM_utils_DNFORM_utils__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var formSubmitMixin = {
	data: function data() {
		return {
			isLoading: false,
			isSubmitSuccessful: false,
			isSubmitFailed: false,
			recaptchaToken: '',
			metaData: {}
		};
	},

	methods: {
		scrollToTopOfForm: function scrollToTopOfForm() {
			var _this = this;

			this.$nextTick(function () {
				var form = _this.$refs[_this.formId];

				if (form) {
					form.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		createFormPayload: function createFormPayload() {
			var payload = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(this.model);
			// It creates an object with the names of the uploaded files for each file input
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = Object.entries(this.uploadedFiles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;

					var _ref2 = _slicedToArray(_ref, 2);

					var step = _ref2[0];
					var fileInputs = _ref2[1];

					var _loop = function _loop(inputId, files) {
						var fileInputObject = {};

						files.forEach(function (file, index) {
							fileInputObject[index + 1] = file;
						});

						payload[step][inputId] = fileInputObject;
					};

					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = Object.entries(fileInputs)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion3 = (_step4 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var _ref5 = _step4.value;

							var _ref6 = _slicedToArray(_ref5, 2);

							var inputId = _ref6[0];
							var files = _ref6[1];

							_loop(inputId, files);
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
				}
				// Convert array to objects
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = Object.entries(payload)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion2 = (_step3 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var _ref3 = _step3.value;

					var _ref4 = _slicedToArray(_ref3, 2);

					var _step2 = _ref4[0];
					var inputs = _ref4[1];
					var _iteratorNormalCompletion4 = true;
					var _didIteratorError4 = false;
					var _iteratorError4 = undefined;

					try {
						for (var _iterator4 = Object.entries(inputs)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion4 = (_step5 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
							var _ref7 = _step5.value;

							var _ref8 = _slicedToArray(_ref7, 2);

							var _inputId = _ref8[0];
							var inputValue = _ref8[1];

							if (Array.isArray(inputValue)) {
								payload[_step2][_inputId] = Object(__WEBPACK_IMPORTED_MODULE_2__DNFORM_utils_DNFORM_utils__["a" /* convertArrayToObject */])(inputValue);
							}
						}
					} catch (err) {
						_didIteratorError4 = true;
						_iteratorError4 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion4 && _iterator4.return) {
								_iterator4.return();
							}
						} finally {
							if (_didIteratorError4) {
								throw _iteratorError4;
							}
						}
					}
				}
				// If it exists and we're completing the form add reCaptcha token to the last step's payload
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			if (this.recaptchaToken && this.isLastStep) {
				var lastStepIndex = this.isMultiStepForm ? this.totalSteps - 1 : this.totalSteps;
				payload[lastStepIndex].recaptcha = this.recaptchaToken;
			}

			if (!this.isLastStep) {
				payload[__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].OBJECT] = this.createMetaDataObject();
			}

			return payload;
		},
		createMetaDataObject: function createMetaDataObject() {
			var metaDataLastStep = this.metaData[__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].LAST_STEP];
			var lastStep = metaDataLastStep && metaDataLastStep > this.currentStep + 1 ? metaDataLastStep : this.currentStep + 1;

			return _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].LAST_STEP, lastStep);
		},
		resetSubmitFailed: function resetSubmitFailed() {
			if (this.isSubmitFailed) {
				this.isSubmitFailed = false;
			}
		},
		getRecaptchaToken: function getRecaptchaToken() {
			var _this2 = this;

			return new Promise(function (resolve, reject) {
				_this2.$recaptchaLoaded().then(function () {
					var recaptchaId = _this2.$recaptchaInstance.recaptchaID;
					_this2.$recaptchaInstance.recaptcha.execute(recaptchaId).then(function (token) {
						resolve(token);
					}).catch(function (error) {
						reject(error);
					});
				});
			});
		},
		onSubmit: function onSubmit() {
			var _this3 = this;

			return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var isFormValid;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								// Skip form validation if we're on the summary page
								if (!_this3.isSummary) {
									_this3.validateForm();
								}

								isFormValid = Object.values(_this3.errors.items).every(function (error) {
									return error === '';
								});

								if (isFormValid) {
									_context.next = 6;
									break;
								}

								_this3.$nextTick(function () {
									_this3.scrollToFirstInvalidInput();
								});
								_context.next = 18;
								break;

							case 6:
								if (!(_this3.formId && _this3.sessionToken)) {
									_context.next = 18;
									break;
								}

								if (!(_this3.isRecaptchaEnabled && _this3.isLastStep)) {
									_context.next = 17;
									break;
								}

								_context.prev = 8;
								_context.next = 11;
								return _this3.getRecaptchaToken();

							case 11:
								_this3.recaptchaToken = _context.sent;
								_context.next = 17;
								break;

							case 14:
								_context.prev = 14;
								_context.t0 = _context['catch'](8);

								console.error('Failed to get reCaptcha token', _context.t0);

							case 17:

								if (_this3.isLastStep) {
									_this3.sendFormData();
								} else {
									_this3.sendTemporaryFormData();
								}

							case 18:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3, [[8, 14]]);
			}))();
		},
		sendFormData: function sendFormData() {
			var _this4 = this;

			this.isLoading = true;
			var payload = this.createFormPayload();

			Object(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_api__["d" /* sendForm */])(this.formId, this.sessionToken, payload).then(function (response) {
				return _this4.handleSendFormResponse(response);
			}).catch(function (error) {
				_this4.isSubmitFailed = true;
				console.error('Failed send form data', error, 'Params:', { formId: _this4.formId, sessionToken: _this4.sessionToken, payload: payload });
			}).finally(function () {
				_this4.scrollToTopOfForm();
				_this4.isLoading = false;
			});
		},
		validateTemporaryFormData: function validateTemporaryFormData(payload) {
			var _this5 = this;

			return new Promise(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_api__["g" /* validateTemporaryForm */])(_this5.formId, _this5.sessionToken, _this5.currentStep, payload).then(function (response) {
					_this5.resetSubmitFailed();
					var isValid = !(response.data[_this5.currentStep] && response.data[_this5.currentStep].length);

					if (!isValid) {
						_this5.handleErrorResponse(response.data);
					}

					resolve(isValid);
				}).catch(function (error) {
					reject(error);
				});
			});
		},
		sendTemporaryFormData: function sendTemporaryFormData() {
			var _this6 = this;

			this.isLoading = true;
			var payload = this.createFormPayload();

			this.validateTemporaryFormData(payload).then(function (isValid) {
				if (isValid) {
					Object(__WEBPACK_IMPORTED_MODULE_1__DNFORM_utils_DNFORM_api__["e" /* sendTemporaryForm */])(_this6.formId, _this6.sessionToken, _this6.currentStep, payload).then(function (response) {
						return _this6.handleSendTemporaryFormResponse(response);
					}).catch(function (error) {
						_this6.isSubmitFailed = true;
						console.error('Failed send temporary form data', error, 'Params:', { formId: _this6.formId, sessionToken: _this6.sessionToken, pageId: _this6.currentStep, payload: payload });
					}).finally(function () {
						_this6.isLoading = false;
					});
				} else {
					_this6.isLoading = false;
				}
			}).catch(function (error) {
				_this6.isLoading = false;
				_this6.isSubmitFailed = true;
				console.error('Failed validate temporary form data', error, 'Params:', { formId: _this6.formId, sessionToken: _this6.sessionToken, pageId: _this6.currentStep, payload: payload });
			}).finally(function () {
				_this6.scrollToTopOfForm();
			});
		}
	}
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(247),
    arrayEach = __webpack_require__(847),
    assignValue = __webpack_require__(652),
    baseAssign = __webpack_require__(848),
    baseAssignIn = __webpack_require__(849),
    cloneBuffer = __webpack_require__(653),
    copyArray = __webpack_require__(654),
    copySymbols = __webpack_require__(852),
    copySymbolsIn = __webpack_require__(853),
    getAllKeys = __webpack_require__(636),
    getAllKeysIn = __webpack_require__(854),
    getTag = __webpack_require__(256),
    initCloneArray = __webpack_require__(855),
    initCloneByTag = __webpack_require__(856),
    initCloneObject = __webpack_require__(657),
    isArray = __webpack_require__(63),
    isBuffer = __webpack_require__(253),
    isMap = __webpack_require__(861),
    isObject = __webpack_require__(87),
    isSet = __webpack_require__(863),
    keys = __webpack_require__(252);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

/***/ }),
/* 847 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(230),
    keys = __webpack_require__(252);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(230),
    keysIn = __webpack_require__(259);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87),
    isPrototype = __webpack_require__(306),
    nativeKeysIn = __webpack_require__(851);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(230),
    getSymbols = __webpack_require__(301);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(230),
    getSymbolsIn = __webpack_require__(655);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(637),
    getSymbolsIn = __webpack_require__(655),
    keysIn = __webpack_require__(259);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567),
    cloneDataView = __webpack_require__(857),
    cloneRegExp = __webpack_require__(858),
    cloneSymbol = __webpack_require__(859),
    cloneTypedArray = __webpack_require__(656);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor();

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor();

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(567);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol = __webpack_require__(150);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(862),
    baseUnary = __webpack_require__(254),
    nodeUtil = __webpack_require__(305);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(256),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(864),
    baseUnary = __webpack_require__(254),
    nodeUtil = __webpack_require__(305);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(256),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return responseHandlerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);


var responseHandlerMixin = {
	data: function data() {
		return {
			ERROR_CODES: __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["c" /* ERROR_CODES */]
		};
	},

	methods: {
		getFirstStepWithError: function getFirstStepWithError(responseData) {
			var result = this.currentStep;

			if (this.isLastStep) {
				result = Number(Object.keys(responseData)[0]);
			}

			return result;
		},
		setResponseErrors: function setResponseErrors(responseErrors) {
			var validationErrors = {};

			responseErrors.forEach(function (responseError) {
				if (responseError && responseError.errors && Array.isArray(responseError.errors)) {
					responseError.errors.forEach(function (error) {
						var errorCode = __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["j" /* RESPONSE_ERROR_CODES_MAP */][error] || __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["c" /* ERROR_CODES */].UNKNOWN;
						validationErrors[responseError.field] = errorCode;
					});
				}
			});

			this.errors.setError(validationErrors);
		},
		getResponseErrors: function getResponseErrors(responseData) {
			var results = [];

			if (this.isLastStep) {
				results = responseData[Object.keys(responseData)[0]];
			} else {
				results = responseData[this.currentStep];
			}

			return results;
		},
		handleErrorResponse: function handleErrorResponse(responseData) {
			var _this = this;

			var firstStepWithError = this.getFirstStepWithError(responseData);
			this.changeStep(firstStepWithError);

			var responseErrors = this.getResponseErrors(responseData);
			this.setResponseErrors(responseErrors);

			this.$nextTick(function () {
				_this.scrollToFirstInvalidInput();
			});
		},
		handleSendFormResponse: function handleSendFormResponse(response) {
			this.resetSubmitFailed();

			if (response.data.status && response.data.status === 'OK') {
				this.isSubmitSuccessful = true;
				this.removeSessionFromCookie();
			} else {
				var hasErrors = !!Object.keys(response.data).length;

				if (hasErrors) {
					this.handleErrorResponse(response.data);
				}
			}
		},
		handleSendTemporaryFormResponse: function handleSendTemporaryFormResponse(_ref) {
			var data = _ref.data;

			this.resetSubmitFailed();

			// https://wiki.shiwaforce.com/pages/viewpage.action?pageId=115281886
			if (data.status && data.status === 'OK' || !data[this.currentStep] || !data[this.currentStep].length) {
				this.addStepToDoneSteps(this.currentStep);
				this.changeStep(this.currentStep + 1);
			} else if (data[this.currentStep] && data[this.currentStep].length) {
				this.handleErrorResponse(data);
			}
		}
	}
};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sessionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DNFORM_utils_DNFORM_api__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_utils__ = __webpack_require__(152);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var sessionMixin = {
	data: function data() {
		return {
			STEP_REF_PREFIX: __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["m" /* STEP_REF_PREFIX */],
			sessionToken: ''
		};
	},

	watch: {
		currentStep: function currentStep() {
			this.$nextTick(this.getUploadedFiles);
		}
	},
	mounted: function mounted() {
		this.handleSession();
	},

	methods: {
		handleSession: function handleSession() {
			var sessions = this.getSessionCookie();

			if (sessions) {
				var sessionTokenOfForm = this.getSessionToken(sessions);

				if (sessionTokenOfForm) {
					this.sessionToken = sessionTokenOfForm;

					if (this.isMultiStepForm) {
						this.getSessionData();
					}
				} else {
					this.extendSessionCookie(sessions);
				}
			} else {
				this.createSessionCookie();
			}
		},
		getSessionCookie: function getSessionCookie() {
			return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].NAME);
		},
		setSessionCookie: function setSessionCookie(content) {
			__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].NAME, content, { expires: __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].LIFESPAN_IN_DAYS });
		},
		createSessionCookie: function createSessionCookie() {
			this.sessionToken = Object(__WEBPACK_IMPORTED_MODULE_1_uuid__["v4"])();
			var cookieContent = '' + this.formId + __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].KEY_VALUE_SEPARATOR + this.sessionToken;
			this.setSessionCookie(cookieContent);
		},
		extendSessionCookie: function extendSessionCookie(sessions) {
			this.sessionToken = Object(__WEBPACK_IMPORTED_MODULE_1_uuid__["v4"])();
			var cookieContent = '' + sessions + __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].SESSION_SEPARATOR + this.formId + '=' + this.sessionToken;
			this.setSessionCookie(cookieContent);
		},
		removeSessionFromCookie: function removeSessionFromCookie() {
			var _this = this;

			var sessions = this.getSessionCookie();
			var sessionsArray = sessions.split(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].SESSION_SEPARATOR);

			sessionsArray.forEach(function (session, index) {
				var formId = session.split(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].KEY_VALUE_SEPARATOR)[0];

				if (formId === _this.formId) {
					sessionsArray.splice(index, 1);
					var cookieContent = sessionsArray.join(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].SESSION_SEPARATOR);
					_this.setSessionCookie(cookieContent);
				}
			});
		},
		getSessionToken: function getSessionToken(sessionsString) {
			var _this2 = this;

			var result = '';
			var sessionsArray = sessionsString.split(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].SESSION_SEPARATOR);

			sessionsArray.forEach(function (session) {
				var splittedSession = session.split(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["k" /* SESSION_COOKIE */].KEY_VALUE_SEPARATOR);

				if (splittedSession.length === 2) {
					var formId = splittedSession[0];

					if (formId === _this2.formId) {
						result = splittedSession[1];
					}
				}
			});

			return result;
		},
		getSessionData: function getSessionData() {
			var _this3 = this;

			Object(__WEBPACK_IMPORTED_MODULE_2__DNFORM_utils_DNFORM_api__["b" /* getTemporaryForm */])(this.formId, this.sessionToken).then(function (response) {
				if (response.data) {
					// In this case we submitted temporary data at least once so the change of currentStep
					// will trigger the getUploadedFiles method
					_this3.model = _this3.normalizeModel(response.data);

					var metaData = response.data[__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].OBJECT];

					if (metaData) {
						_this3.metaData = metaData;
						_this3.handleSessionMetaData();
					}
				} else {
					_this3.getUploadedFiles();
				}
			}).catch(function (error) {
				console.error('Failed to get session data', error, 'Params:', { formId: _this3.formId, sessionToken: _this3.sessionToken });
			});
		},
		getUploadedFiles: function getUploadedFiles() {
			var _this4 = this;

			var stepRef = this.$refs['' + __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["m" /* STEP_REF_PREFIX */] + this.currentStep];

			if (stepRef) {
				var fileInputs = stepRef.querySelectorAll('input[type=file]');

				if (fileInputs.length) {
					var fileInputIds = Array.from(fileInputs).map(function (fileInput) {
						return fileInput.id;
					});
					var getUploadedFilesRequests = fileInputIds.map(function (fileInputId) {
						return Object(__WEBPACK_IMPORTED_MODULE_2__DNFORM_utils_DNFORM_api__["c" /* getUploadedFiles */])(_this4.formId, _this4.sessionToken, fileInputId);
					});

					Promise.all(getUploadedFilesRequests).then(function (response) {
						_this4.setUploadedFiles(response);
					}).catch(function (error) {
						var fileInputId = _this4.getFileInputIdFromUrl(error.response.config.url);
						console.error('Failed to get uploaded files', error, 'Params:', { formId: _this4.formId, sessionToken: _this4.sessionToken, fileInputId: fileInputId });
					});
				}
			}
		},
		setUploadedFiles: function setUploadedFiles(allResponse) {
			var _this5 = this;

			allResponse.forEach(function (response) {
				if (response.data.length) {
					var fileInputId = _this5.getFileInputIdFromUrl(response.config.url);
					_this5.setFileInputState(__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["e" /* FILE_INPUT_STATES */].UPLOADED_FILES, fileInputId, response.data);
					// We need File objects in model instead of filenames to make it consistent
					_this5.convertFilenamesToFileObjectsInModel(fileInputId, response.data);
				}
			});
		},
		handleSessionMetaData: function handleSessionMetaData() {
			var lastStep = this.metaData[__WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].LAST_STEP];

			if (lastStep) {
				this.currentStep = lastStep;
				this.setDoneSteps(lastStep);
			}
		},
		normalizeModel: function normalizeModel(model) {
			var result = model;
			// Remove meta
			result = Object.keys(model).filter(function (step) {
				return step !== __WEBPACK_IMPORTED_MODULE_3__DNFORM_utils_DNFORM_constants__["l" /* SESSION_META */].OBJECT;
			}).reduce(function (obj, key) {
				obj[key] = model[key];
				return obj;
			}, {});
			// Convert objects back to arrays unless it is a phone number object
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = Object.entries(result)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;

					var _ref2 = _slicedToArray(_ref, 2);

					var step = _ref2[0];
					var inputs = _ref2[1];
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = Object.entries(inputs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var _ref3 = _step2.value;

							var _ref4 = _slicedToArray(_ref3, 2);

							var inputId = _ref4[0];
							var inputValue = _ref4[1];

							if (Object(__WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_utils__["c" /* isObject */])(inputValue) && !Object(__WEBPACK_IMPORTED_MODULE_4__DNFORM_utils_DNFORM_utils__["d" /* isPhoneNumberObject */])(inputValue)) {
								result[step][inputId] = Object.values(inputValue);
							}
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return result;
		},
		convertFilenamesToFileObjectsInModel: function convertFilenamesToFileObjectsInModel(fileInputId, filenames) {
			this.model[this.currentStep][fileInputId] = filenames.map(function (filename) {
				return new File([], filename);
			});
		},
		setDoneSteps: function setDoneSteps(lastStep) {
			for (var i = 1; i < lastStep; i++) {
				this.addStepToDoneSteps(i);
			}
		},
		getFileInputIdFromUrl: function getFileInputIdFromUrl(url) {
			return url.split('/').pop();
		}
	}
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(659);
var bytesToUuid = __webpack_require__(660);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0,
    _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(659);
var bytesToUuid = __webpack_require__(660);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stepperMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);


var stepperMixin = {
	data: function data() {
		return {
			currentStep: __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["f" /* FIRST_STEP */],
			doneSteps: []
		};
	},

	computed: {
		totalSteps: function totalSteps() {
			return this.steps.length || 1;
		},
		isMultiStepForm: function isMultiStepForm() {
			return this.totalSteps > 1;
		},
		isFirstStep: function isFirstStep() {
			return this.currentStep === __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["f" /* FIRST_STEP */];
		},
		isLastStep: function isLastStep() {
			return this.currentStep === this.totalSteps;
		},
		isSummary: function isSummary() {
			return this.isSummaryEnabled && this.isLastStep;
		}
	},
	methods: {
		changeStep: function changeStep(step) {
			if (step >= __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["f" /* FIRST_STEP */] && step <= this.totalSteps) {
				this.currentStep = Number(step);
			}
		},
		addStepToDoneSteps: function addStepToDoneSteps(step) {
			if (!this.doneSteps.includes(step)) {
				this.doneSteps.push(step);
			}
		}
	}
};

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return summaryMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);



var summaryMixin = {
	watch: {
		currentStep: function currentStep() {
			if (this.isSummaryEnabled && this.isLastStep) {
				this.createModelForSummary();
			}
		}
	},
	methods: {
		getLabelOfInput: function getLabelOfInput(inputId) {
			return this.labelsOfInputs ? this.labelsOfInputs[inputId] : '';
		},
		createModelForSummary: function createModelForSummary() {
			// We can't use File objects in v-for but we can use the plain objects from uploadedFiles
			var clonedModel = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(this.model);
			this.modelForSummary = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()({}, clonedModel, this.uploadedFiles);
		},
		editStepData: function editStepData(step) {
			this.changeStep(step);
		}
	}
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(872),
    createAssigner = __webpack_require__(878);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function (object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(247),
    assignMergeValue = __webpack_require__(661),
    baseFor = __webpack_require__(873),
    baseMergeDeep = __webpack_require__(875),
    isObject = __webpack_require__(87),
    keysIn = __webpack_require__(259),
    safeGet = __webpack_require__(662);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function (srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack());
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(874);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 874 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(661),
    cloneBuffer = __webpack_require__(653),
    cloneTypedArray = __webpack_require__(656),
    copyArray = __webpack_require__(654),
    initCloneObject = __webpack_require__(657),
    isArguments = __webpack_require__(246),
    isArray = __webpack_require__(63),
    isArrayLikeObject = __webpack_require__(311),
    isBuffer = __webpack_require__(253),
    isFunction = __webpack_require__(296),
    isObject = __webpack_require__(87),
    isPlainObject = __webpack_require__(876),
    isTypedArray = __webpack_require__(303),
    safeGet = __webpack_require__(662),
    toPlainObject = __webpack_require__(877);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(151),
    getPrototype = __webpack_require__(566),
    isObjectLike = __webpack_require__(86);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(230),
    keysIn = __webpack_require__(259);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(310),
    isIterateeCall = __webpack_require__(879);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(162),
    isArrayLike = __webpack_require__(255),
    isIndex = __webpack_require__(302),
    isObject = __webpack_require__(87);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validationMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__ = __webpack_require__(47);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var validationMixin = {
	data: function data() {
		return {
			EVENTS: __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */],
			warnOnPageLeave: false
		};
	},

	watch: {
		currentStep: function currentStep() {
			// Because of the required_if rule we have to update the validation rules when the step changes
			this.extendValidation(this.validation, true);
		}
	},
	methods: {
		extendValidation: function extendValidation(model) {
			var isFirstLoop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var currentModel = isFirstLoop ? model[this.currentStep] : model;

			for (var key in currentModel) {
				if (_typeof(currentModel[key]) == 'object' && currentModel[key] !== null) {
					if (Object.keys(currentModel[key]).includes('required_if') && Object.values(currentModel[key])[0].length === 1) {
						// eslint-disable-next-line camelcase
						var extendedRequiredIfObject = { required_if: [].concat(_toConsumableArray(Object.values(currentModel[key])[0]), [this.model[this.currentStep]]) };
						currentModel[key] = extendedRequiredIfObject;
					} else {
						this.extendValidation(currentModel[key]);
					}
				}
			}
		},
		onBlur: function onBlur(field, controlledFields) {
			if (controlledFields && controlledFields.length) {
				this.handleDynamicFieldValidation(field, controlledFields, __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].BLUR);
			}

			this.validateInput(field);
		},
		onInput: function onInput(field, controlledFields) {
			if (controlledFields && controlledFields.length) {
				this.handleDynamicFieldValidation(field, controlledFields, __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].INPUT);
			}

			var isFieldTouched = this.isFieldTouched(field);

			if (isFieldTouched || this.errors.allTouched) {
				this.validateInput(field);
			}
		},
		onDateInput: function onDateInput(date, field) {
			this.model[this.currentStep][field] = date;
			this.validateInput(field);
		},
		validateInput: function validateInput(field) {
			this.turnOnPageLeaveWarning();
			this.$livr.validate(_defineProperty({}, field, this.validation[this.currentStep][field]), _defineProperty({}, field, this.model[this.currentStep][field]), field);
		},
		validateForm: function validateForm() {
			this.$livr.validateAll(this.validation[this.currentStep], this.model[this.currentStep]);
		},
		isFieldTouched: function isFieldTouched(field) {
			return !!this.errors.touchedFields[field];
		},
		handleDynamicFieldValidation: function handleDynamicFieldValidation(controlField, controlledFields, event) {
			var _this = this;

			// Validate the controlled fields if necessary
			controlledFields.forEach(function (field) {
				if (event === __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].BLUR) {
					_this.validateInput(field);
				} else if (event === __WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["d" /* EVENTS */].INPUT) {
					var isControlledFieldTouched = _this.isFieldTouched(field);

					if (isControlledFieldTouched || _this.errors.allTouched) {
						_this.validateInput(field);
					}
				}
			});
		},
		hasError: function hasError(inputId, errorCode) {
			var result = false;

			if (errorCode) {
				result = this.errors.items[inputId] && this.errors.items[inputId] === errorCode;
			} else {
				result = this.errors.items[inputId];
			}

			return result;
		},
		scrollToFirstInvalidInput: function scrollToFirstInvalidInput() {
			var form = this.$refs[this.formId];

			if (form) {
				var invalidInput = form.querySelector(__WEBPACK_IMPORTED_MODULE_0__DNFORM_utils_DNFORM_constants__["b" /* CLASSES */].INVALID_INPUT);

				if (invalidInput) {
					invalidInput.scrollIntoView({ behavior: 'smooth' });
					invalidInput.focus({ preventScroll: true });
				}
			}
		},
		turnOnPageLeaveWarning: function turnOnPageLeaveWarning() {
			if (!this.warnOnPageLeave) {
				this.warnOnPageLeave = true;
			}
		}
	}
};

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initRecaptcha;
function initRecaptcha() {
	var script = document.createElement('script');
	script.src = '/static/recaptcha-v3.js';
	document.body.appendChild(script);
}

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var STATE = {
	LOADING: 'LOADING',
	ERROR: 'ERROR',
	SUCCESS: 'SUCCESS',
	IDLE: 'IDLE'
};

var DEFAULT_MODEL = {
	name: '',
	email: '',
	company: '',
	phone: '',
	message: '',
	contactMode: '',
	gdpr: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'frm01-form',
	data: function data() {
		return {
			model: _extends({}, DEFAULT_MODEL),

			state: STATE.IDLE,
			STATE: STATE
		};
	},

	components: {
		VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__["a" /* default */],
		multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
	},
	validations: {
		model: {
			name: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(50)
			},
			email: {
				required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"],
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(50)
			},
			company: {
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(50)
			},
			phone: {
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(50)
			},
			message: {
				maxLength: Object(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(500)
			},
			gdpr: {
				required: function required(value) {
					return value == true;
				}
			}
		}
	},
	methods: {
		validateRecaptcha: function validateRecaptcha() {
			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.state = STATE.LOADING;
			this.$refs.recaptcha.execute();
		},
		onRecaptchaSuccess: function onRecaptchaSuccess(token) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/apps/form', this.model, {
				headers: {
					'X-Recaptcha-Token': token
				}
			}).then(function () {
				_this.state = STATE.SUCCESS;
				document.querySelector('html').style.overflow = 'hidden';
				_this.model = _extends({}, DEFAULT_MODEL);
				_this.$v.$reset();
			}).catch(function (_err) {
				console.error('Nem sikerült lementeni a formot.', _err);
				_this.state = STATE.ERROR;
			});
		},
		onRecaptchaFailed: function onRecaptchaFailed() {
			console.error('Nem sikerült a recaptcha validáció.');
			this.state = STATE.ERROR;
		},
		hasError: function hasError(field, errorType) {
			return this.$v.model[field].$dirty && !this.$v.model[field][errorType];
		}
	}
});

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(884));

var _alphaNum = _interopRequireDefault(__webpack_require__(887));

var _numeric = _interopRequireDefault(__webpack_require__(888));

var _between = _interopRequireDefault(__webpack_require__(889));

var _email = _interopRequireDefault(__webpack_require__(890));

var _ipAddress = _interopRequireDefault(__webpack_require__(891));

var _macAddress = _interopRequireDefault(__webpack_require__(892));

var _maxLength = _interopRequireDefault(__webpack_require__(893));

var _minLength = _interopRequireDefault(__webpack_require__(894));

var _required = _interopRequireDefault(__webpack_require__(895));

var _requiredIf = _interopRequireDefault(__webpack_require__(896));

var _requiredUnless = _interopRequireDefault(__webpack_require__(897));

var _sameAs = _interopRequireDefault(__webpack_require__(898));

var _url = _interopRequireDefault(__webpack_require__(899));

var _or = _interopRequireDefault(__webpack_require__(900));

var _and = _interopRequireDefault(__webpack_require__(901));

var _not = _interopRequireDefault(__webpack_require__(902));

var _minValue = _interopRequireDefault(__webpack_require__(903));

var _maxValue = _interopRequireDefault(__webpack_require__(904));

var _integer = _interopRequireDefault(__webpack_require__(905));

var _decimal = _interopRequireDefault(__webpack_require__(906));

var helpers = _interopRequireWildcard(__webpack_require__(25));

exports.helpers = helpers;

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;var cache = new WeakMap();_getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }var cache = _getRequireWildcardCache();if (cache && cache.has(obj)) {
    return cache.get(obj);
  }var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }newObj.default = obj;if (cache) {
    cache.set(obj, newObj);
  }return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = process.env.BUILD === 'web' ? __webpack_require__(886).withParams : __webpack_require__(664).withParams;
var _default = withParams;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(25);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__ = __webpack_require__(273);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'frm02-form',
	components: {
		'multiselect': __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
		'el-date-picker': __WEBPACK_IMPORTED_MODULE_2_element_ui__["DatePicker"],
		VueRecaptcha: __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__["a" /* default */]
	},
	data: function data() {
		return {
			fromId: '',
			model: {},
			modelErrors: {},
			validationErrors: {},
			submitted: false,
			serverError: false,
			scrollDurationInMs: 500,
			scrollOffsetInPx: -20,
			sessionToken: '',
			sourceCampaign: ''
		};
	},
	created: function created() {
		this.fromId = window.formId;
		this.model = JSON.parse(JSON.stringify(window.formModel));
		this.modelErrors = JSON.parse(JSON.stringify(window.formModel));
		this.validationErrors = JSON.parse(JSON.stringify(window.formValidation));
		this.sessionToken = Object(__WEBPACK_IMPORTED_MODULE_4_uuid__["v4"])();
		this.sourceCampaign = window.sourceCampaign;
	},

	methods: {
		validateRecaptcha: function validateRecaptcha() {
			if (!this.validateRequiredFields()) {
				this.$refs.recaptcha.execute();
			}
		},
		onRecaptchaSuccess: function onRecaptchaSuccess(token) {
			this.submitHandler(token);
		},
		onRecaptchaFailed: function onRecaptchaFailed() {
			console.error('Nem sikerült a recaptcha validáció.');
		},
		errorFactory: function errorFactory(errors) {
			var _this = this;

			errors.forEach(function (error) {
				error.errors.forEach(function (err) {
					_this.modelErrors[error.field] = true;
					_this.validationErrors[error.field][err] = true;
				});
			});
		},
		validateRequiredFields: function validateRequiredFields() {
			var hasError = false;
			var hasScrolled = false;

			for (var i in this.validationErrors) {
				if (Object.keys(this.validationErrors[i]).includes('required')) {
					if (!this.model[i] || _typeof(this.model[i]) === 'object' && Object.keys(this.model[i]).length === 0) {
						this.validationErrors[i].required = true;

						if (i !== 'newsletter_type' || this.model.newsletter) {
							hasError = true;

							if (!hasScrolled) {
								this.scrollToError('[name="' + i + '"]');
								hasScrolled = true;
							}
						}
					} else {
						this.validationErrors[i].required = false;
					}
				}
			}

			return hasError;
		},
		scrollToError: function scrollToError(element, offset) {
			__WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo(element, this.scrollDurationInMs, { offset: offset || this.scrollOffsetInPx });
		},
		resetValidation: function resetValidation() {
			this.modelErrors = JSON.parse(JSON.stringify(window.formModel));
			this.validationErrors = JSON.parse(JSON.stringify(window.formValidation));
		},
		submitHandler: function submitHandler(recaptchaToken) {
			var _this2 = this;

			// reset serverError
			if (this.serverError) {
				this.serverError = false;
			}

			var formData = {
				1: this.model
			};

			formData[1].recaptcha = recaptchaToken;

			Axios.post('/apps/formpost/' + this.fromId + '/sessions/' + this.sessionToken + '/complete', formData).then(function (response) {
				_this2.resetValidation();

				if (response.data.status && response.data.status === 'OK') {
					_this2.submitted = true;
					document.querySelector('html').style.overflow = 'hidden';
				} else {
					_this2.$refs.recaptcha.reset();
				}

				if (response.data['1'] && response.data['1'].length) {
					_this2.errorFactory(response.data['1']);
					_this2.scrollToError('#' + response.data['1'][0].field);
				}
			}).catch(function () {
				_this2.serverError = true;
				_this2.scrollToError('.frm02-form', 0);
			});

			// ActiveCampaign
			var activeCampaignData = {
				contact: {
					email: formData[1].email,
					firstName: formData[1].first_name,
					lastName: formData[1].last_name,
					phone: formData[1].phone,
					fieldValues: [{
						field: __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].SOURCE_CAMPAIGN,
						value: this.sourceCampaign
					}, {
						field: __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].COMPANY_NAME,
						value: formData[1].company_name
					}, {
						field: __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].GDPR,
						value: formData[1].terms === 'adatkezelés elfogadása' ? __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].GDPR_TRUE_VALUE : __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].GDPR_FALSE_VALUE
					}, {
						field: __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].CONTACT_JOBTITLE,
						value: formData[1].post
					}, {
						field: __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].NEWSLETTER,
						value: formData[1].newsletter === 'Hírlevél feliratkozás' ? __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].NEWSLETTER_TRUE_VALUE : __WEBPACK_IMPORTED_MODULE_5__common_utils_constants__["a" /* ACTIVE_CAMPAIGN */].NEWSLETTER_FALSE_VALUE
					}]
				}
			};

			var options = {
				method: 'post',
				url: '/apps/active-campaign',
				headers: {
					'content-type': 'application/json'
				},
				data: JSON.stringify(activeCampaignData)
			};

			Axios(options).catch(function () {
				_this2.serverError = true;
			});
		}
	}
});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};module.exports=/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******//******/// The require function
/******/function __webpack_require__(moduleId){/******//******/// Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******//******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******//******/// Flag the module as loaded
/******/module.l=true;/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//******//******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******//******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******//******/// define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{enumerable:true,get:getter});/******/}/******/};/******//******/// define __esModule on exports
/******/__webpack_require__.r=function(exports){/******/if(typeof Symbol!=='undefined'&&Symbol.toStringTag){/******/Object.defineProperty(exports,Symbol.toStringTag,{value:'Module'});/******/}/******/Object.defineProperty(exports,'__esModule',{value:true});/******/};/******//******/// create a fake namespace object
/******/// mode & 1: value is a module id, require it
/******/// mode & 2: merge all properties of value into the ns
/******/// mode & 4: return value when already ns object
/******/// mode & 8|1: behave like require
/******/__webpack_require__.t=function(value,mode){/******/if(mode&1)value=__webpack_require__(value);/******/if(mode&8)return value;/******/if(mode&4&&(typeof value==='undefined'?'undefined':_typeof2(value))==='object'&&value&&value.__esModule)return value;/******/var ns=Object.create(null);/******/__webpack_require__.r(ns);/******/Object.defineProperty(ns,'default',{enumerable:true,value:value});/******/if(mode&2&&typeof value!='string')for(var key in value){__webpack_require__.d(ns,key,function(key){return value[key];}.bind(null,key));}/******/return ns;/******/};/******//******/// getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******//******/// Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******//******/// __webpack_public_path__
/******/__webpack_require__.p="/dist/";/******//******//******/// Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=46);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports){module.exports=__webpack_require__(909);/***/},/* 1 *//***/function(module,exports){module.exports=__webpack_require__(98);/***/},/* 2 *//***/function(module,exports){module.exports=__webpack_require__(73);/***/},/* 3 *//***/function(module,exports){module.exports=__webpack_require__(133);/***/},/* 4 *//***/function(module,exports){module.exports=__webpack_require__(570);/***/},/* 5 *//***/function(module,exports){module.exports=__webpack_require__(261);/***/},/* 6 *//***/function(module,exports){module.exports=__webpack_require__(32);/***/},/* 7 *//***/function(module,exports){module.exports=__webpack_require__(262);/***/},/* 8 *//***/function(module,exports){module.exports=__webpack_require__(572);/***/},/* 9 *//***/function(module,exports){module.exports=__webpack_require__(668);/***/},/* 10 *//***/function(module,exports){module.exports=__webpack_require__(669);/***/},/* 11 *//***/function(module,exports){module.exports=__webpack_require__(667);/***/},/* 12 *//***/function(module,exports){module.exports=__webpack_require__(569);/***/},/* 13 *//***/function(module,exports){module.exports=__webpack_require__(915);/***/},/* 14 *//***/function(module,exports){module.exports=__webpack_require__(670);/***/},/* 15 *//***/function(module,exports){module.exports=__webpack_require__(573);/***/},/* 16 *//***/function(module,exports){module.exports=__webpack_require__(666);/***/},/* 17 *//***/function(module,exports){module.exports=__webpack_require__(264);/***/},/* 18 *//***/function(module,exports){module.exports=__webpack_require__(575);/***/},/* 19 *//***/function(module,exports){module.exports=__webpack_require__(263);/***/},/* 20 *//***/function(module,exports){module.exports=__webpack_require__(665);/***/},/* 21 *//***/function(module,exports){module.exports=__webpack_require__(917);/***/},/* 22 *//***/function(module,exports){module.exports=__webpack_require__(918);/***/},/* 23 *//***/function(module,exports){module.exports=__webpack_require__(576);/***/},/* 24 *//***/function(module,exports){module.exports=__webpack_require__(672);/***/},/* 25 *//***/function(module,exports){module.exports=__webpack_require__(574);/***/},/* 26 *//***/function(module,exports){module.exports=__webpack_require__(919);/***/},/* 27 *//***/function(module,exports){module.exports=__webpack_require__(577);/***/},/* 28 *//***/function(module,exports){module.exports=__webpack_require__(920);/***/},/* 29 *//***/function(module,exports){module.exports=__webpack_require__(921);/***/},/* 30 *//***/function(module,exports){module.exports=__webpack_require__(674);/***/},/* 31 *//***/function(module,exports){module.exports=__webpack_require__(571);/***/},/* 32 *//***/function(module,exports){module.exports=__webpack_require__(922);/***/},/* 33 *//***/function(module,exports){module.exports=__webpack_require__(923);/***/},/* 34 *//***/function(module,exports){module.exports=__webpack_require__(924);/***/},/* 35 *//***/function(module,exports){module.exports=__webpack_require__(578);/***/},/* 36 *//***/function(module,exports){module.exports=__webpack_require__(671);/***/},/* 37 *//***/function(module,exports){module.exports=__webpack_require__(925);/***/},/* 38 *//***/function(module,exports){module.exports=__webpack_require__(926);/***/},/* 39 *//***/function(module,exports){module.exports=__webpack_require__(927);/***/},/* 40 *//***/function(module,exports){module.exports=__webpack_require__(932);/***/},/* 41 *//***/function(module,exports){module.exports=__webpack_require__(933);/***/},/* 42 *//***/function(module,exports){module.exports=__webpack_require__(979);/***/},/* 43 *//***/function(module,exports){module.exports=__webpack_require__(980);/***/},/* 44 *//***/function(module,exports){module.exports=__webpack_require__(690);/***/},/* 45 *//***/function(module,exports){module.exports=__webpack_require__(981);/***/},/* 46 *//***/function(module,exports,__webpack_require__){module.exports=__webpack_require__(47);/***/},/* 47 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
var pagervue_type_template_id_7274f267_render=function pagervue_type_template_id_7274f267_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("ul",{staticClass:"el-pager",on:{click:_vm.onPagerClick}},[_vm.pageCount>0?_c("li",{staticClass:"number",class:{active:_vm.currentPage===1,disabled:_vm.disabled}},[_vm._v("1")]):_vm._e(),_vm.showPrevMore?_c("li",{staticClass:"el-icon more btn-quickprev",class:[_vm.quickprevIconClass,{disabled:_vm.disabled}],on:{mouseenter:function mouseenter($event){_vm.onMouseenter("left");},mouseleave:function mouseleave($event){_vm.quickprevIconClass="el-icon-more";}}}):_vm._e(),_vm._l(_vm.pagers,function(pager){return _c("li",{key:pager,staticClass:"number",class:{active:_vm.currentPage===pager,disabled:_vm.disabled}},[_vm._v(_vm._s(pager))]);}),_vm.showNextMore?_c("li",{staticClass:"el-icon more btn-quicknext",class:[_vm.quicknextIconClass,{disabled:_vm.disabled}],on:{mouseenter:function mouseenter($event){_vm.onMouseenter("right");},mouseleave:function mouseleave($event){_vm.quicknextIconClass="el-icon-more";}}}):_vm._e(),_vm.pageCount>1?_c("li",{staticClass:"number",class:{active:_vm.currentPage===_vm.pageCount,disabled:_vm.disabled}},[_vm._v(_vm._s(_vm.pageCount))]):_vm._e()],2);};var staticRenderFns=[];pagervue_type_template_id_7274f267_render._withStripped=true;// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var pagervue_type_script_lang_js_={name:'ElPager',props:{currentPage:Number,pageCount:Number,pagerCount:Number,disabled:Boolean},watch:{showPrevMore:function showPrevMore(val){if(!val)this.quickprevIconClass='el-icon-more';},showNextMore:function showNextMore(val){if(!val)this.quicknextIconClass='el-icon-more';}},methods:{onPagerClick:function onPagerClick(event){var target=event.target;if(target.tagName==='UL'||this.disabled){return;}var newPage=Number(event.target.textContent);var pageCount=this.pageCount;var currentPage=this.currentPage;var pagerCountOffset=this.pagerCount-2;if(target.className.indexOf('more')!==-1){if(target.className.indexOf('quickprev')!==-1){newPage=currentPage-pagerCountOffset;}else if(target.className.indexOf('quicknext')!==-1){newPage=currentPage+pagerCountOffset;}}/* istanbul ignore if */if(!isNaN(newPage)){if(newPage<1){newPage=1;}if(newPage>pageCount){newPage=pageCount;}}if(newPage!==currentPage){this.$emit('change',newPage);}},onMouseenter:function onMouseenter(direction){if(this.disabled)return;if(direction==='left'){this.quickprevIconClass='el-icon-d-arrow-left';}else{this.quicknextIconClass='el-icon-d-arrow-right';}}},computed:{pagers:function pagers(){var pagerCount=this.pagerCount;var halfPagerCount=(pagerCount-1)/2;var currentPage=Number(this.currentPage);var pageCount=Number(this.pageCount);var showPrevMore=false;var showNextMore=false;if(pageCount>pagerCount){if(currentPage>pagerCount-halfPagerCount){showPrevMore=true;}if(currentPage<pageCount-halfPagerCount){showNextMore=true;}}var array=[];if(showPrevMore&&!showNextMore){var startPage=pageCount-(pagerCount-2);for(var i=startPage;i<pageCount;i++){array.push(i);}}else if(!showPrevMore&&showNextMore){for(var _i=2;_i<pagerCount;_i++){array.push(_i);}}else if(showPrevMore&&showNextMore){var offset=Math.floor(pagerCount/2)-1;for(var _i2=currentPage-offset;_i2<=currentPage+offset;_i2++){array.push(_i2);}}else{for(var _i3=2;_i3<pageCount;_i3++){array.push(_i3);}}this.showPrevMore=showPrevMore;this.showNextMore=showNextMore;return array;}},data:function data(){return{current:null,showPrevMore:false,showNextMore:false,quicknextIconClass:'el-icon-more',quickprevIconClass:'el-icon-more'};}};// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
/* harmony default export */var src_pagervue_type_script_lang_js_=pagervue_type_script_lang_js_;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.
function normalizeComponent(scriptExports,render,staticRenderFns,functionalTemplate,injectStyles,scopeId,moduleIdentifier,/* server only */shadowMode/* vue-cli only */){// Vue.extend constructor export interop
var options=typeof scriptExports==='function'?scriptExports.options:scriptExports;// render functions
if(render){options.render=render;options.staticRenderFns=staticRenderFns;options._compiled=true;}// functional template
if(functionalTemplate){options.functional=true;}// scopedId
if(scopeId){options._scopeId='data-v-'+scopeId;}var hook;if(moduleIdentifier){// server build
hook=function hook(context){// 2.3 injection
context=context||// cached call
this.$vnode&&this.$vnode.ssrContext||// stateful
this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext;// functional
// 2.2 with runInNewContext: true
if(!context&&typeof __VUE_SSR_CONTEXT__!=='undefined'){context=__VUE_SSR_CONTEXT__;}// inject component styles
if(injectStyles){injectStyles.call(this,context);}// register component module identifier for async chunk inferrence
if(context&&context._registeredComponents){context._registeredComponents.add(moduleIdentifier);}};// used by ssr in case component is cached and beforeCreate
// never gets called
options._ssrRegister=hook;}else if(injectStyles){hook=shadowMode?function(){injectStyles.call(this,this.$root.$options.shadowRoot);}:injectStyles;}if(hook){if(options.functional){// for template-only hot-reload because in that case the render fn doesn't
// go through the normalizer
options._injectStyles=hook;// register for functioal component in vue file
var originalRender=options.render;options.render=function renderWithStyleInjection(h,context){hook.call(context);return originalRender(h,context);};}else{// inject component registration as beforeCreate hook
var existing=options.beforeCreate;options.beforeCreate=existing?[].concat(existing,hook):[hook];}}return{exports:scriptExports,options:options};}// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
/* normalize component */var component=normalizeComponent(src_pagervue_type_script_lang_js_,pagervue_type_template_id_7274f267_render,staticRenderFns,false,null,null,null);/* hot reload */if(false){var api;}component.options.__file="packages/pagination/src/pager.vue";/* harmony default export */var pager=component.exports;// EXTERNAL MODULE: external "element-ui/lib/select"
var select_=__webpack_require__(37);var select_default=/*#__PURE__*/__webpack_require__.n(select_);// EXTERNAL MODULE: external "element-ui/lib/option"
var option_=__webpack_require__(38);var option_default=/*#__PURE__*/__webpack_require__.n(option_);// EXTERNAL MODULE: external "element-ui/lib/input"
var input_=__webpack_require__(8);var input_default=/*#__PURE__*/__webpack_require__.n(input_);// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_=__webpack_require__(4);var locale_default=/*#__PURE__*/__webpack_require__.n(locale_);// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_=__webpack_require__(2);// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
/* harmony default export */var pagination={name:'ElPagination',props:{pageSize:{type:Number,default:10},small:Boolean,total:Number,pageCount:Number,pagerCount:{type:Number,validator:function validator(value){return(value|0)===value&&value>4&&value<22&&value%2===1;},default:7},currentPage:{type:Number,default:1},layout:{default:'prev, pager, next, jumper, ->, total'},pageSizes:{type:Array,default:function _default(){return[10,20,30,40,50,100];}},popperClass:String,prevText:String,nextText:String,background:Boolean,disabled:Boolean,hideOnSinglePage:Boolean},data:function data(){return{internalCurrentPage:1,internalPageSize:0,lastEmittedPage:-1,userChangePageSize:false};},render:function render(h){var layout=this.layout;if(!layout)return null;if(this.hideOnSinglePage&&(!this.internalPageCount||this.internalPageCount===1))return null;var template=h('div',{'class':['el-pagination',{'is-background':this.background,'el-pagination--small':this.small}]});var TEMPLATE_MAP={prev:h('prev'),jumper:h('jumper'),pager:h('pager',{attrs:{currentPage:this.internalCurrentPage,pageCount:this.internalPageCount,pagerCount:this.pagerCount,disabled:this.disabled},on:{'change':this.handleCurrentChange}}),next:h('next'),sizes:h('sizes',{attrs:{pageSizes:this.pageSizes}}),slot:h('slot',[this.$slots.default?this.$slots.default:'']),total:h('total')};var components=layout.split(',').map(function(item){return item.trim();});var rightWrapper=h('div',{'class':'el-pagination__rightwrapper'});var haveRightWrapper=false;template.children=template.children||[];rightWrapper.children=rightWrapper.children||[];components.forEach(function(compo){if(compo==='->'){haveRightWrapper=true;return;}if(!haveRightWrapper){template.children.push(TEMPLATE_MAP[compo]);}else{rightWrapper.children.push(TEMPLATE_MAP[compo]);}});if(haveRightWrapper){template.children.unshift(rightWrapper);}return template;},components:{Prev:{render:function render(h){return h('button',{attrs:{type:'button',disabled:this.$parent.disabled||this.$parent.internalCurrentPage<=1},'class':'btn-prev',on:{'click':this.$parent.prev}},[this.$parent.prevText?h('span',[this.$parent.prevText]):h('i',{'class':'el-icon el-icon-arrow-left'})]);}},Next:{render:function render(h){return h('button',{attrs:{type:'button',disabled:this.$parent.disabled||this.$parent.internalCurrentPage===this.$parent.internalPageCount||this.$parent.internalPageCount===0},'class':'btn-next',on:{'click':this.$parent.next}},[this.$parent.nextText?h('span',[this.$parent.nextText]):h('i',{'class':'el-icon el-icon-arrow-right'})]);}},Sizes:{mixins:[locale_default.a],props:{pageSizes:Array},watch:{pageSizes:{immediate:true,handler:function handler(newVal,oldVal){if(Object(util_["valueEquals"])(newVal,oldVal))return;if(Array.isArray(newVal)){this.$parent.internalPageSize=newVal.indexOf(this.$parent.pageSize)>-1?this.$parent.pageSize:this.pageSizes[0];}}}},render:function render(h){var _this=this;return h('span',{'class':'el-pagination__sizes'},[h('el-select',{attrs:{value:this.$parent.internalPageSize,popperClass:this.$parent.popperClass||'',size:'mini',disabled:this.$parent.disabled},on:{'input':this.handleChange}},[this.pageSizes.map(function(item){return h('el-option',{attrs:{value:item,label:item+_this.t('el.pagination.pagesize')}});})])]);},components:{ElSelect:select_default.a,ElOption:option_default.a},methods:{handleChange:function handleChange(val){if(val!==this.$parent.internalPageSize){this.$parent.internalPageSize=val=parseInt(val,10);this.$parent.userChangePageSize=true;this.$parent.$emit('update:pageSize',val);this.$parent.$emit('size-change',val);}}}},Jumper:{mixins:[locale_default.a],components:{ElInput:input_default.a},data:function data(){return{userInput:null};},watch:{'$parent.internalCurrentPage':function $parentInternalCurrentPage(){this.userInput=null;}},methods:{handleKeyup:function handleKeyup(_ref){var keyCode=_ref.keyCode,target=_ref.target;// Chrome, Safari, Firefox triggers change event on Enter
// Hack for IE: https://github.com/ElemeFE/element/issues/11710
// Drop this method when we no longer supports IE
if(keyCode===13){this.handleChange(target.value);}},handleInput:function handleInput(value){this.userInput=value;},handleChange:function handleChange(value){this.$parent.internalCurrentPage=this.$parent.getValidCurrentPage(value);this.$parent.emitChange();this.userInput=null;}},render:function render(h){return h('span',{'class':'el-pagination__jump'},[this.t('el.pagination.goto'),h('el-input',{'class':'el-pagination__editor is-in-pagination',attrs:{min:1,max:this.$parent.internalPageCount,value:this.userInput!==null?this.userInput:this.$parent.internalCurrentPage,type:'number',disabled:this.$parent.disabled},nativeOn:{'keyup':this.handleKeyup},on:{'input':this.handleInput,'change':this.handleChange}}),this.t('el.pagination.pageClassifier')]);}},Total:{mixins:[locale_default.a],render:function render(h){return typeof this.$parent.total==='number'?h('span',{'class':'el-pagination__total'},[this.t('el.pagination.total',{total:this.$parent.total})]):'';}},Pager:pager},methods:{handleCurrentChange:function handleCurrentChange(val){this.internalCurrentPage=this.getValidCurrentPage(val);this.userChangePageSize=true;this.emitChange();},prev:function prev(){if(this.disabled)return;var newVal=this.internalCurrentPage-1;this.internalCurrentPage=this.getValidCurrentPage(newVal);this.$emit('prev-click',this.internalCurrentPage);this.emitChange();},next:function next(){if(this.disabled)return;var newVal=this.internalCurrentPage+1;this.internalCurrentPage=this.getValidCurrentPage(newVal);this.$emit('next-click',this.internalCurrentPage);this.emitChange();},getValidCurrentPage:function getValidCurrentPage(value){value=parseInt(value,10);var havePageCount=typeof this.internalPageCount==='number';var resetValue=void 0;if(!havePageCount){if(isNaN(value)||value<1)resetValue=1;}else{if(value<1){resetValue=1;}else if(value>this.internalPageCount){resetValue=this.internalPageCount;}}if(resetValue===undefined&&isNaN(value)){resetValue=1;}else if(resetValue===0){resetValue=1;}return resetValue===undefined?value:resetValue;},emitChange:function emitChange(){var _this2=this;this.$nextTick(function(){if(_this2.internalCurrentPage!==_this2.lastEmittedPage||_this2.userChangePageSize){_this2.$emit('current-change',_this2.internalCurrentPage);_this2.lastEmittedPage=_this2.internalCurrentPage;_this2.userChangePageSize=false;}});}},computed:{internalPageCount:function internalPageCount(){if(typeof this.total==='number'){return Math.max(1,Math.ceil(this.total/this.internalPageSize));}else if(typeof this.pageCount==='number'){return Math.max(1,this.pageCount);}return null;}},watch:{currentPage:{immediate:true,handler:function handler(val){this.internalCurrentPage=this.getValidCurrentPage(val);}},pageSize:{immediate:true,handler:function handler(val){this.internalPageSize=isNaN(val)?10:val;}},internalCurrentPage:{immediate:true,handler:function handler(newVal){this.$emit('update:currentPage',newVal);this.lastEmittedPage=-1;}},internalPageCount:function internalPageCount(newVal){/* istanbul ignore if */var oldPage=this.internalCurrentPage;if(newVal>0&&oldPage===0){this.internalCurrentPage=1;}else if(oldPage>newVal){this.internalCurrentPage=newVal===0?1:newVal;this.userChangePageSize&&this.emitChange();}this.userChangePageSize=false;}}};// CONCATENATED MODULE: ./packages/pagination/index.js
/* istanbul ignore next */pagination.install=function(Vue){Vue.component(pagination.name,pagination);};/* harmony default export */var packages_pagination=pagination;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
var componentvue_type_template_id_60140e62_render=function componentvue_type_template_id_60140e62_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"dialog-fade"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-dialog__wrapper",on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{key:_vm.key,ref:"dialog",class:["el-dialog",{"is-fullscreen":_vm.fullscreen,"el-dialog--center":_vm.center},_vm.customClass],style:_vm.style,attrs:{role:"dialog","aria-modal":"true","aria-label":_vm.title||"dialog"}},[_c("div",{staticClass:"el-dialog__header"},[_vm._t("title",[_c("span",{staticClass:"el-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-dialog__headerbtn",attrs:{type:"button","aria-label":"Close"},on:{click:_vm.handleClose}},[_c("i",{staticClass:"el-dialog__close el-icon el-icon-close"})]):_vm._e()],2),_vm.rendered?_c("div",{staticClass:"el-dialog__body"},[_vm._t("default")],2):_vm._e(),_vm.$slots.footer?_c("div",{staticClass:"el-dialog__footer"},[_vm._t("footer")],2):_vm._e()])])]);};var componentvue_type_template_id_60140e62_staticRenderFns=[];componentvue_type_template_id_60140e62_render._withStripped=true;// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_=__webpack_require__(11);var popup_default=/*#__PURE__*/__webpack_require__.n(popup_);// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
var migrating_=__webpack_require__(9);var migrating_default=/*#__PURE__*/__webpack_require__.n(migrating_);// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_=__webpack_require__(3);var emitter_default=/*#__PURE__*/__webpack_require__.n(emitter_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var componentvue_type_script_lang_js_={name:'ElDialog',mixins:[popup_default.a,emitter_default.a,migrating_default.a],props:{title:{type:String,default:''},modal:{type:Boolean,default:true},modalAppendToBody:{type:Boolean,default:true},appendToBody:{type:Boolean,default:false},lockScroll:{type:Boolean,default:true},closeOnClickModal:{type:Boolean,default:true},closeOnPressEscape:{type:Boolean,default:true},showClose:{type:Boolean,default:true},width:String,fullscreen:Boolean,customClass:{type:String,default:''},top:{type:String,default:'15vh'},beforeClose:Function,center:{type:Boolean,default:false},destroyOnClose:Boolean},data:function data(){return{closed:false,key:0};},watch:{visible:function visible(val){var _this=this;if(val){this.closed=false;this.$emit('open');this.$el.addEventListener('scroll',this.updatePopper);this.$nextTick(function(){_this.$refs.dialog.scrollTop=0;});if(this.appendToBody){document.body.appendChild(this.$el);}}else{this.$el.removeEventListener('scroll',this.updatePopper);if(!this.closed)this.$emit('close');if(this.destroyOnClose){this.$nextTick(function(){_this.key++;});}}}},computed:{style:function style(){var style={};if(!this.fullscreen){style.marginTop=this.top;if(this.width){style.width=this.width;}}return style;}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'size':'size is removed.'}};},handleWrapperClick:function handleWrapperClick(){if(!this.closeOnClickModal)return;this.handleClose();},handleClose:function handleClose(){if(typeof this.beforeClose==='function'){this.beforeClose(this.hide);}else{this.hide();}},hide:function hide(cancel){if(cancel!==false){this.$emit('update:visible',false);this.$emit('close');this.closed=true;}},updatePopper:function updatePopper(){this.broadcast('ElSelectDropdown','updatePopper');this.broadcast('ElDropdownMenu','updatePopper');},afterEnter:function afterEnter(){this.$emit('opened');},afterLeave:function afterLeave(){this.$emit('closed');}},mounted:function mounted(){if(this.visible){this.rendered=true;this.open();if(this.appendToBody){document.body.appendChild(this.$el);}}},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
/* harmony default export */var src_componentvue_type_script_lang_js_=componentvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dialog/src/component.vue
/* normalize component */var component_component=normalizeComponent(src_componentvue_type_script_lang_js_,componentvue_type_template_id_60140e62_render,componentvue_type_template_id_60140e62_staticRenderFns,false,null,null,null);/* hot reload */if(false){var component_api;}component_component.options.__file="packages/dialog/src/component.vue";/* harmony default export */var src_component=component_component.exports;// CONCATENATED MODULE: ./packages/dialog/index.js
/* istanbul ignore next */src_component.install=function(Vue){Vue.component(src_component.name,src_component);};/* harmony default export */var dialog=src_component;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
var autocompletevue_type_template_id_152f2ee6_render=function autocompletevue_type_template_id_152f2ee6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.close,expression:"close"}],staticClass:"el-autocomplete",attrs:{"aria-haspopup":"listbox",role:"combobox","aria-expanded":_vm.suggestionVisible,"aria-owns":_vm.id}},[_c("el-input",_vm._b({ref:"input",on:{input:_vm.handleInput,change:_vm.handleChange,focus:_vm.handleFocus,blur:_vm.handleBlur,clear:_vm.handleClear},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();_vm.highlight(_vm.highlightedIndex-1);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();_vm.highlight(_vm.highlightedIndex+1);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleKeyEnter($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}return _vm.close($event);}]}},"el-input",[_vm.$props,_vm.$attrs],false),[_vm.$slots.prepend?_c("template",{slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),_vm.$slots.append?_c("template",{slot:"append"},[_vm._t("append")],2):_vm._e(),_vm.$slots.prefix?_c("template",{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),_vm.$slots.suffix?_c("template",{slot:"suffix"},[_vm._t("suffix")],2):_vm._e()],2),_c("el-autocomplete-suggestions",{ref:"suggestions",class:[_vm.popperClass?_vm.popperClass:""],attrs:{"visible-arrow":"","popper-options":_vm.popperOptions,"append-to-body":_vm.popperAppendToBody,placement:_vm.placement,id:_vm.id}},_vm._l(_vm.suggestions,function(item,index){return _c("li",{key:index,class:{highlighted:_vm.highlightedIndex===index},attrs:{id:_vm.id+"-item-"+index,role:"option","aria-selected":_vm.highlightedIndex===index},on:{click:function click($event){_vm.select(item);}}},[_vm._t("default",[_vm._v("\n        "+_vm._s(item[_vm.valueKey])+"\n      ")],{item:item})],2);}),0)],1);};var autocompletevue_type_template_id_152f2ee6_staticRenderFns=[];autocompletevue_type_template_id_152f2ee6_render._withStripped=true;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_=__webpack_require__(17);var debounce_default=/*#__PURE__*/__webpack_require__.n(debounce_);// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
var clickoutside_=__webpack_require__(10);var clickoutside_default=/*#__PURE__*/__webpack_require__.n(clickoutside_);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render=function autocomplete_suggestionsvue_type_template_id_cd10dcf0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-autocomplete-suggestion el-popper",class:{"is-loading":!_vm.parent.hideLoading&&_vm.parent.loading},style:{width:_vm.dropdownWidth},attrs:{role:"region"}},[_c("el-scrollbar",{attrs:{tag:"ul","wrap-class":"el-autocomplete-suggestion__wrap","view-class":"el-autocomplete-suggestion__list"}},[!_vm.parent.hideLoading&&_vm.parent.loading?_c("li",[_c("i",{staticClass:"el-icon-loading"})]):_vm._t("default")],2)],1)]);};var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns=[];autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped=true;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_=__webpack_require__(5);var vue_popper_default=/*#__PURE__*/__webpack_require__.n(vue_popper_);// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_=__webpack_require__(18);var scrollbar_default=/*#__PURE__*/__webpack_require__.n(scrollbar_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var autocomplete_suggestionsvue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},mixins:[vue_popper_default.a,emitter_default.a],componentName:'ElAutocompleteSuggestions',data:function data(){return{parent:this.$parent,dropdownWidth:''};},props:{options:{default:function _default(){return{gpuAcceleration:false};}},id:String},methods:{select:function select(item){this.dispatch('ElAutocomplete','item-click',item);}},updated:function updated(){var _this=this;this.$nextTick(function(_){_this.popperJS&&_this.updatePopper();});},mounted:function mounted(){this.$parent.popperElm=this.popperElm=this.$el;this.referenceElm=this.$parent.$refs.input.$refs.input||this.$parent.$refs.input.$refs.textarea;this.referenceList=this.$el.querySelector('.el-autocomplete-suggestion__list');this.referenceList.setAttribute('role','listbox');this.referenceList.setAttribute('id',this.id);},created:function created(){var _this2=this;this.$on('visible',function(val,inputWidth){_this2.dropdownWidth=inputWidth+'px';_this2.showPopper=val;});}};// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
/* harmony default export */var src_autocomplete_suggestionsvue_type_script_lang_js_=autocomplete_suggestionsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
/* normalize component */var autocomplete_suggestions_component=normalizeComponent(src_autocomplete_suggestionsvue_type_script_lang_js_,autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var autocomplete_suggestions_api;}autocomplete_suggestions_component.options.__file="packages/autocomplete/src/autocomplete-suggestions.vue";/* harmony default export */var autocomplete_suggestions=autocomplete_suggestions_component.exports;// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
var focus_=__webpack_require__(23);var focus_default=/*#__PURE__*/__webpack_require__.n(focus_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var autocompletevue_type_script_lang_js_={name:'ElAutocomplete',mixins:[emitter_default.a,focus_default()('input'),migrating_default.a],inheritAttrs:false,componentName:'ElAutocomplete',components:{ElInput:input_default.a,ElAutocompleteSuggestions:autocomplete_suggestions},directives:{Clickoutside:clickoutside_default.a},props:{valueKey:{type:String,default:'value'},popperClass:String,popperOptions:Object,placeholder:String,clearable:{type:Boolean,default:false},disabled:Boolean,name:String,size:String,value:String,maxlength:Number,minlength:Number,autofocus:Boolean,fetchSuggestions:Function,triggerOnFocus:{type:Boolean,default:true},customItem:String,selectWhenUnmatched:{type:Boolean,default:false},prefixIcon:String,suffixIcon:String,label:String,debounce:{type:Number,default:300},placement:{type:String,default:'bottom-start'},hideLoading:Boolean,popperAppendToBody:{type:Boolean,default:true},highlightFirstItem:{type:Boolean,default:false}},data:function data(){return{activated:false,suggestions:[],loading:false,highlightedIndex:-1,suggestionDisabled:false};},computed:{suggestionVisible:function suggestionVisible(){var suggestions=this.suggestions;var isValidData=Array.isArray(suggestions)&&suggestions.length>0;return(isValidData||this.loading)&&this.activated;},id:function id(){return'el-autocomplete-'+Object(util_["generateId"])();}},watch:{suggestionVisible:function suggestionVisible(val){var $input=this.getInput();if($input){this.broadcast('ElAutocompleteSuggestions','visible',[val,$input.offsetWidth]);}}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'custom-item':'custom-item is removed, use scoped slot instead.','props':'props is removed, use value-key instead.'}};},getData:function getData(queryString){var _this=this;if(this.suggestionDisabled){return;}this.loading=true;this.fetchSuggestions(queryString,function(suggestions){_this.loading=false;if(_this.suggestionDisabled){return;}if(Array.isArray(suggestions)){_this.suggestions=suggestions;_this.highlightedIndex=_this.highlightFirstItem?0:-1;}else{console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');}});},handleInput:function handleInput(value){this.$emit('input',value);this.suggestionDisabled=false;if(!this.triggerOnFocus&&!value){this.suggestionDisabled=true;this.suggestions=[];return;}this.debouncedGetData(value);},handleChange:function handleChange(value){this.$emit('change',value);},handleFocus:function handleFocus(event){this.activated=true;this.$emit('focus',event);if(this.triggerOnFocus){this.debouncedGetData(this.value);}},handleBlur:function handleBlur(event){this.$emit('blur',event);},handleClear:function handleClear(){this.activated=false;this.$emit('clear');},close:function close(e){this.activated=false;},handleKeyEnter:function handleKeyEnter(e){var _this2=this;if(this.suggestionVisible&&this.highlightedIndex>=0&&this.highlightedIndex<this.suggestions.length){e.preventDefault();this.select(this.suggestions[this.highlightedIndex]);}else if(this.selectWhenUnmatched){this.$emit('select',{value:this.value});this.$nextTick(function(_){_this2.suggestions=[];_this2.highlightedIndex=-1;});}},select:function select(item){var _this3=this;this.$emit('input',item[this.valueKey]);this.$emit('select',item);this.$nextTick(function(_){_this3.suggestions=[];_this3.highlightedIndex=-1;});},highlight:function highlight(index){if(!this.suggestionVisible||this.loading){return;}if(index<0){this.highlightedIndex=-1;return;}if(index>=this.suggestions.length){index=this.suggestions.length-1;}var suggestion=this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');var suggestionList=suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');var highlightItem=suggestionList[index];var scrollTop=suggestion.scrollTop;var offsetTop=highlightItem.offsetTop;if(offsetTop+highlightItem.scrollHeight>scrollTop+suggestion.clientHeight){suggestion.scrollTop+=highlightItem.scrollHeight;}if(offsetTop<scrollTop){suggestion.scrollTop-=highlightItem.scrollHeight;}this.highlightedIndex=index;var $input=this.getInput();$input.setAttribute('aria-activedescendant',this.id+'-item-'+this.highlightedIndex);},getInput:function getInput(){return this.$refs.input.getInput();}},mounted:function mounted(){var _this4=this;this.debouncedGetData=debounce_default()(this.debounce,this.getData);this.$on('item-click',function(item){_this4.select(item);});var $input=this.getInput();$input.setAttribute('role','textbox');$input.setAttribute('aria-autocomplete','list');$input.setAttribute('aria-controls','id');$input.setAttribute('aria-activedescendant',this.id+'-item-'+this.highlightedIndex);},beforeDestroy:function beforeDestroy(){this.$refs.suggestions.$destroy();}};// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
/* harmony default export */var src_autocompletevue_type_script_lang_js_=autocompletevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
/* normalize component */var autocomplete_component=normalizeComponent(src_autocompletevue_type_script_lang_js_,autocompletevue_type_template_id_152f2ee6_render,autocompletevue_type_template_id_152f2ee6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var autocomplete_api;}autocomplete_component.options.__file="packages/autocomplete/src/autocomplete.vue";/* harmony default export */var autocomplete=autocomplete_component.exports;// CONCATENATED MODULE: ./packages/autocomplete/index.js
/* istanbul ignore next */autocomplete.install=function(Vue){Vue.component(autocomplete.name,autocomplete);};/* harmony default export */var packages_autocomplete=autocomplete;// EXTERNAL MODULE: external "element-ui/lib/button"
var button_=__webpack_require__(13);var button_default=/*#__PURE__*/__webpack_require__.n(button_);// EXTERNAL MODULE: external "element-ui/lib/button-group"
var button_group_=__webpack_require__(29);var button_group_default=/*#__PURE__*/__webpack_require__.n(button_group_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var dropdownvue_type_script_lang_js_={name:'ElDropdown',componentName:'ElDropdown',mixins:[emitter_default.a,migrating_default.a],directives:{Clickoutside:clickoutside_default.a},components:{ElButton:button_default.a,ElButtonGroup:button_group_default.a},provide:function provide(){return{dropdown:this};},props:{trigger:{type:String,default:'hover'},type:String,size:{type:String,default:''},splitButton:Boolean,hideOnClick:{type:Boolean,default:true},placement:{type:String,default:'bottom-end'},visibleArrow:{default:true},showTimeout:{type:Number,default:250},hideTimeout:{type:Number,default:150},tabindex:{type:Number,default:0},disabled:{type:Boolean,default:false}},data:function data(){return{timeout:null,visible:false,triggerElm:null,menuItems:null,menuItemsArray:null,dropdownElm:null,focusing:false,listId:'dropdown-menu-'+Object(util_["generateId"])()};},computed:{dropdownSize:function dropdownSize(){return this.size||(this.$ELEMENT||{}).size;}},mounted:function mounted(){this.$on('menu-item-click',this.handleMenuItemClick);},watch:{visible:function visible(val){this.broadcast('ElDropdownMenu','visible',val);this.$emit('visible-change',val);},focusing:function focusing(val){var selfDefine=this.$el.querySelector('.el-dropdown-selfdefine');if(selfDefine){// 自定义
if(val){selfDefine.className+=' focusing';}else{selfDefine.className=selfDefine.className.replace('focusing','');}}}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'menu-align':'menu-align is renamed to placement.'}};},show:function show(){var _this=this;if(this.disabled)return;clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this.visible=true;},this.trigger==='click'?0:this.showTimeout);},hide:function hide(){var _this2=this;if(this.disabled)return;this.removeTabindex();if(this.tabindex>=0){this.resetTabindex(this.triggerElm);}clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this2.visible=false;},this.trigger==='click'?0:this.hideTimeout);},handleClick:function handleClick(){if(this.disabled)return;if(this.visible){this.hide();}else{this.show();}},handleTriggerKeyDown:function handleTriggerKeyDown(ev){var keyCode=ev.keyCode;if([38,40].indexOf(keyCode)>-1){// up/down
this.removeTabindex();this.resetTabindex(this.menuItems[0]);this.menuItems[0].focus();ev.preventDefault();ev.stopPropagation();}else if(keyCode===13){// space enter选中
this.handleClick();}else if([9,27].indexOf(keyCode)>-1){// tab || esc
this.hide();}},handleItemKeyDown:function handleItemKeyDown(ev){var keyCode=ev.keyCode;var target=ev.target;var currentIndex=this.menuItemsArray.indexOf(target);var max=this.menuItemsArray.length-1;var nextIndex=void 0;if([38,40].indexOf(keyCode)>-1){// up/down
if(keyCode===38){// up
nextIndex=currentIndex!==0?currentIndex-1:0;}else{// down
nextIndex=currentIndex<max?currentIndex+1:max;}this.removeTabindex();this.resetTabindex(this.menuItems[nextIndex]);this.menuItems[nextIndex].focus();ev.preventDefault();ev.stopPropagation();}else if(keyCode===13){// enter选中
this.triggerElmFocus();target.click();if(this.hideOnClick){// click关闭
this.visible=false;}}else if([9,27].indexOf(keyCode)>-1){// tab // esc
this.hide();this.triggerElmFocus();}},resetTabindex:function resetTabindex(ele){// 下次tab时组件聚焦元素
this.removeTabindex();ele.setAttribute('tabindex','0');// 下次期望的聚焦元素
},removeTabindex:function removeTabindex(){this.triggerElm.setAttribute('tabindex','-1');this.menuItemsArray.forEach(function(item){item.setAttribute('tabindex','-1');});},initAria:function initAria(){this.dropdownElm.setAttribute('id',this.listId);this.triggerElm.setAttribute('aria-haspopup','list');this.triggerElm.setAttribute('aria-controls',this.listId);if(!this.splitButton){// 自定义
this.triggerElm.setAttribute('role','button');this.triggerElm.setAttribute('tabindex',this.tabindex);this.triggerElm.setAttribute('class',(this.triggerElm.getAttribute('class')||'')+' el-dropdown-selfdefine');// 控制
}},initEvent:function initEvent(){var _this3=this;var trigger=this.trigger,show=this.show,hide=this.hide,handleClick=this.handleClick,splitButton=this.splitButton,handleTriggerKeyDown=this.handleTriggerKeyDown,handleItemKeyDown=this.handleItemKeyDown;this.triggerElm=splitButton?this.$refs.trigger.$el:this.$slots.default[0].elm;var dropdownElm=this.dropdownElm;this.triggerElm.addEventListener('keydown',handleTriggerKeyDown);// triggerElm keydown
dropdownElm.addEventListener('keydown',handleItemKeyDown,true);// item keydown
// 控制自定义元素的样式
if(!splitButton){this.triggerElm.addEventListener('focus',function(){_this3.focusing=true;});this.triggerElm.addEventListener('blur',function(){_this3.focusing=false;});this.triggerElm.addEventListener('click',function(){_this3.focusing=false;});}if(trigger==='hover'){this.triggerElm.addEventListener('mouseenter',show);this.triggerElm.addEventListener('mouseleave',hide);dropdownElm.addEventListener('mouseenter',show);dropdownElm.addEventListener('mouseleave',hide);}else if(trigger==='click'){this.triggerElm.addEventListener('click',handleClick);}},handleMenuItemClick:function handleMenuItemClick(command,instance){if(this.hideOnClick){this.visible=false;}this.$emit('command',command,instance);},triggerElmFocus:function triggerElmFocus(){this.triggerElm.focus&&this.triggerElm.focus();},initDomOperation:function initDomOperation(){this.dropdownElm=this.popperElm;this.menuItems=this.dropdownElm.querySelectorAll("[tabindex='-1']");this.menuItemsArray=[].slice.call(this.menuItems);this.initEvent();this.initAria();}},render:function render(h){var _this4=this;var hide=this.hide,splitButton=this.splitButton,type=this.type,dropdownSize=this.dropdownSize,disabled=this.disabled;var handleMainButtonClick=function handleMainButtonClick(event){_this4.$emit('click',event);hide();};var triggerElm=null;if(splitButton){triggerElm=h('el-button-group',[h('el-button',{attrs:{type:type,size:dropdownSize,disabled:disabled},nativeOn:{'click':handleMainButtonClick}},[this.$slots.default]),h('el-button',{ref:'trigger',attrs:{type:type,size:dropdownSize,disabled:disabled},'class':'el-dropdown__caret-button'},[h('i',{'class':'el-dropdown__icon el-icon-arrow-down'})])]);}else{triggerElm=this.$slots.default;var vnodeData=triggerElm[0].data||{};var _vnodeData$attrs=vnodeData.attrs,attrs=_vnodeData$attrs===undefined?{}:_vnodeData$attrs;if(disabled&&!attrs.disabled){attrs.disabled=true;vnodeData.attrs=attrs;}}var menuElm=disabled?null:this.$slots.dropdown;return h('div',{'class':'el-dropdown',directives:[{name:'clickoutside',value:hide}],attrs:{'aria-disabled':disabled}},[triggerElm,menuElm]);}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdownvue_type_script_lang_js_=dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
var dropdown_render,dropdown_staticRenderFns;/* normalize component */var dropdown_component=normalizeComponent(src_dropdownvue_type_script_lang_js_,dropdown_render,dropdown_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_api;}dropdown_component.options.__file="packages/dropdown/src/dropdown.vue";/* harmony default export */var dropdown=dropdown_component.exports;// CONCATENATED MODULE: ./packages/dropdown/index.js
/* istanbul ignore next */dropdown.install=function(Vue){Vue.component(dropdown.name,dropdown);};/* harmony default export */var packages_dropdown=dropdown;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
var dropdown_menuvue_type_template_id_0da6b714_render=function dropdown_menuvue_type_template_id_0da6b714_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("ul",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-dropdown-menu el-popper",class:[_vm.size&&"el-dropdown-menu--"+_vm.size]},[_vm._t("default")],2)]);};var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns=[];dropdown_menuvue_type_template_id_0da6b714_render._withStripped=true;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */var dropdown_menuvue_type_script_lang_js_={name:'ElDropdownMenu',componentName:'ElDropdownMenu',mixins:[vue_popper_default.a],props:{visibleArrow:{type:Boolean,default:true},arrowOffset:{type:Number,default:0}},data:function data(){return{size:this.dropdown.dropdownSize};},inject:['dropdown'],created:function created(){var _this=this;this.$on('updatePopper',function(){if(_this.showPopper)_this.updatePopper();});this.$on('visible',function(val){_this.showPopper=val;});},mounted:function mounted(){this.dropdown.popperElm=this.popperElm=this.$el;this.referenceElm=this.dropdown.$el;// compatible with 2.6 new v-slot syntax
// issue link https://github.com/ElemeFE/element/issues/14345
this.dropdown.initDomOperation();},watch:{'dropdown.placement':{immediate:true,handler:function handler(val){this.currentPlacement=val;}}}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdown_menuvue_type_script_lang_js_=dropdown_menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
/* normalize component */var dropdown_menu_component=normalizeComponent(src_dropdown_menuvue_type_script_lang_js_,dropdown_menuvue_type_template_id_0da6b714_render,dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_menu_api;}dropdown_menu_component.options.__file="packages/dropdown/src/dropdown-menu.vue";/* harmony default export */var dropdown_menu=dropdown_menu_component.exports;// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
/* istanbul ignore next */dropdown_menu.install=function(Vue){Vue.component(dropdown_menu.name,dropdown_menu);};/* harmony default export */var packages_dropdown_menu=dropdown_menu;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
var dropdown_itemvue_type_template_id_6359102a_render=function dropdown_itemvue_type_template_id_6359102a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-dropdown-menu__item",class:{"is-disabled":_vm.disabled,"el-dropdown-menu__item--divided":_vm.divided},attrs:{"aria-disabled":_vm.disabled,tabindex:_vm.disabled?null:-1},on:{click:_vm.handleClick}},[_vm.icon?_c("i",{class:_vm.icon}):_vm._e(),_vm._t("default")],2);};var dropdown_itemvue_type_template_id_6359102a_staticRenderFns=[];dropdown_itemvue_type_template_id_6359102a_render._withStripped=true;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var dropdown_itemvue_type_script_lang_js_={name:'ElDropdownItem',mixins:[emitter_default.a],props:{command:{},disabled:Boolean,divided:Boolean,icon:String},methods:{handleClick:function handleClick(e){this.dispatch('ElDropdown','menu-item-click',[this.command,this]);}}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdown_itemvue_type_script_lang_js_=dropdown_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
/* normalize component */var dropdown_item_component=normalizeComponent(src_dropdown_itemvue_type_script_lang_js_,dropdown_itemvue_type_template_id_6359102a_render,dropdown_itemvue_type_template_id_6359102a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_item_api;}dropdown_item_component.options.__file="packages/dropdown/src/dropdown-item.vue";/* harmony default export */var dropdown_item=dropdown_item_component.exports;// CONCATENATED MODULE: ./packages/dropdown-item/index.js
/* istanbul ignore next */dropdown_item.install=function(Vue){Vue.component(dropdown_item.name,dropdown_item);};/* harmony default export */var packages_dropdown_item=dropdown_item;// CONCATENATED MODULE: ./src/utils/aria-utils.js
var aria=aria||{};aria.Utils=aria.Utils||{};/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */aria.Utils.focusFirstDescendant=function(element){for(var i=0;i<element.childNodes.length;i++){var child=element.childNodes[i];if(aria.Utils.attemptFocus(child)||aria.Utils.focusFirstDescendant(child)){return true;}}return false;};/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */aria.Utils.focusLastDescendant=function(element){for(var i=element.childNodes.length-1;i>=0;i--){var child=element.childNodes[i];if(aria.Utils.attemptFocus(child)||aria.Utils.focusLastDescendant(child)){return true;}}return false;};/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */aria.Utils.attemptFocus=function(element){if(!aria.Utils.isFocusable(element)){return false;}aria.Utils.IgnoreUtilFocusChanges=true;try{element.focus();}catch(e){}aria.Utils.IgnoreUtilFocusChanges=false;return document.activeElement===element;};aria.Utils.isFocusable=function(element){if(element.tabIndex>0||element.tabIndex===0&&element.getAttribute('tabIndex')!==null){return true;}if(element.disabled){return false;}switch(element.nodeName){case'A':return!!element.href&&element.rel!=='ignore';case'INPUT':return element.type!=='hidden'&&element.type!=='file';case'BUTTON':case'SELECT':case'TEXTAREA':return true;default:return false;}};/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */aria.Utils.triggerEvent=function(elm,name){var eventName=void 0;if(/^mouse|click/.test(name)){eventName='MouseEvents';}else if(/^key/.test(name)){eventName='KeyboardEvent';}else{eventName='HTMLEvents';}var evt=document.createEvent(eventName);for(var _len=arguments.length,opts=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){opts[_key-2]=arguments[_key];}evt.initEvent.apply(evt,[name].concat(opts));elm.dispatchEvent?elm.dispatchEvent(evt):elm.fireEvent('on'+name,evt);return elm;};aria.Utils.keys={tab:9,enter:13,space:32,left:37,up:38,right:39,down:40,esc:27};/* harmony default export */var aria_utils=aria.Utils;// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
var SubMenu=function SubMenu(parent,domNode){this.domNode=domNode;this.parent=parent;this.subMenuItems=[];this.subIndex=0;this.init();};SubMenu.prototype.init=function(){this.subMenuItems=this.domNode.querySelectorAll('li');this.addListeners();};SubMenu.prototype.gotoSubIndex=function(idx){if(idx===this.subMenuItems.length){idx=0;}else if(idx<0){idx=this.subMenuItems.length-1;}this.subMenuItems[idx].focus();this.subIndex=idx;};SubMenu.prototype.addListeners=function(){var _this=this;var keys=aria_utils.keys;var parentNode=this.parent.domNode;Array.prototype.forEach.call(this.subMenuItems,function(el){el.addEventListener('keydown',function(event){var prevDef=false;switch(event.keyCode){case keys.down:_this.gotoSubIndex(_this.subIndex+1);prevDef=true;break;case keys.up:_this.gotoSubIndex(_this.subIndex-1);prevDef=true;break;case keys.tab:aria_utils.triggerEvent(parentNode,'mouseleave');break;case keys.enter:case keys.space:prevDef=true;event.currentTarget.click();break;}if(prevDef){event.preventDefault();event.stopPropagation();}return false;});});};/* harmony default export */var aria_submenu=SubMenu;// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
var MenuItem=function MenuItem(domNode){this.domNode=domNode;this.submenu=null;this.init();};MenuItem.prototype.init=function(){this.domNode.setAttribute('tabindex','0');var menuChild=this.domNode.querySelector('.el-menu');if(menuChild){this.submenu=new aria_submenu(this,menuChild);}this.addListeners();};MenuItem.prototype.addListeners=function(){var _this=this;var keys=aria_utils.keys;this.domNode.addEventListener('keydown',function(event){var prevDef=false;switch(event.keyCode){case keys.down:aria_utils.triggerEvent(event.currentTarget,'mouseenter');_this.submenu&&_this.submenu.gotoSubIndex(0);prevDef=true;break;case keys.up:aria_utils.triggerEvent(event.currentTarget,'mouseenter');_this.submenu&&_this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length-1);prevDef=true;break;case keys.tab:aria_utils.triggerEvent(event.currentTarget,'mouseleave');break;case keys.enter:case keys.space:prevDef=true;event.currentTarget.click();break;}if(prevDef){event.preventDefault();}});};/* harmony default export */var aria_menuitem=MenuItem;// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
var Menu=function Menu(domNode){this.domNode=domNode;this.init();};Menu.prototype.init=function(){var menuChildren=this.domNode.childNodes;[].filter.call(menuChildren,function(child){return child.nodeType===1;}).forEach(function(child){new aria_menuitem(child);// eslint-disable-line
});};/* harmony default export */var aria_menubar=Menu;// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_=__webpack_require__(1);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
/* harmony default export */var menuvue_type_script_lang_js_={name:'ElMenu',render:function render(h){var component=h('ul',{attrs:{role:'menubar'},key:+this.collapse,style:{backgroundColor:this.backgroundColor||''},'class':{'el-menu--horizontal':this.mode==='horizontal','el-menu--collapse':this.collapse,"el-menu":true}},[this.$slots.default]);if(this.collapseTransition){return h('el-menu-collapse-transition',[component]);}else{return component;}},componentName:'ElMenu',mixins:[emitter_default.a,migrating_default.a],provide:function provide(){return{rootMenu:this};},components:{'el-menu-collapse-transition':{functional:true,render:function render(createElement,context){var data={props:{mode:'out-in'},on:{beforeEnter:function beforeEnter(el){el.style.opacity=0.2;},enter:function enter(el){Object(dom_["addClass"])(el,'el-opacity-transition');el.style.opacity=1;},afterEnter:function afterEnter(el){Object(dom_["removeClass"])(el,'el-opacity-transition');el.style.opacity='';},beforeLeave:function beforeLeave(el){if(!el.dataset)el.dataset={};if(Object(dom_["hasClass"])(el,'el-menu--collapse')){Object(dom_["removeClass"])(el,'el-menu--collapse');el.dataset.oldOverflow=el.style.overflow;el.dataset.scrollWidth=el.clientWidth;Object(dom_["addClass"])(el,'el-menu--collapse');}else{Object(dom_["addClass"])(el,'el-menu--collapse');el.dataset.oldOverflow=el.style.overflow;el.dataset.scrollWidth=el.clientWidth;Object(dom_["removeClass"])(el,'el-menu--collapse');}el.style.width=el.scrollWidth+'px';el.style.overflow='hidden';},leave:function leave(el){Object(dom_["addClass"])(el,'horizontal-collapse-transition');el.style.width=el.dataset.scrollWidth+'px';}}};return createElement('transition',data,context.children);}}},props:{mode:{type:String,default:'vertical'},defaultActive:{type:String,default:''},defaultOpeneds:Array,uniqueOpened:Boolean,router:Boolean,menuTrigger:{type:String,default:'hover'},collapse:Boolean,backgroundColor:String,textColor:String,activeTextColor:String,collapseTransition:{type:Boolean,default:true}},data:function data(){return{activeIndex:this.defaultActive,openedMenus:this.defaultOpeneds&&!this.collapse?this.defaultOpeneds.slice(0):[],items:{},submenus:{}};},computed:{hoverBackground:function hoverBackground(){return this.backgroundColor?this.mixColor(this.backgroundColor,0.2):'';},isMenuPopup:function isMenuPopup(){return this.mode==='horizontal'||this.mode==='vertical'&&this.collapse;}},watch:{defaultActive:function defaultActive(value){if(!this.items[value]){this.activeIndex=null;}this.updateActiveIndex(value);},defaultOpeneds:function defaultOpeneds(value){if(!this.collapse){this.openedMenus=value;}},collapse:function collapse(value){if(value)this.openedMenus=[];this.broadcast('ElSubmenu','toggle-collapse',value);}},methods:{updateActiveIndex:function updateActiveIndex(val){var item=this.items[val]||this.items[this.activeIndex]||this.items[this.defaultActive];if(item){this.activeIndex=item.index;this.initOpenedMenu();}else{this.activeIndex=null;}},getMigratingConfig:function getMigratingConfig(){return{props:{'theme':'theme is removed.'}};},getColorChannels:function getColorChannels(color){color=color.replace('#','');if(/^[0-9a-fA-F]{3}$/.test(color)){color=color.split('');for(var i=2;i>=0;i--){color.splice(i,0,color[i]);}color=color.join('');}if(/^[0-9a-fA-F]{6}$/.test(color)){return{red:parseInt(color.slice(0,2),16),green:parseInt(color.slice(2,4),16),blue:parseInt(color.slice(4,6),16)};}else{return{red:255,green:255,blue:255};}},mixColor:function mixColor(color,percent){var _getColorChannels=this.getColorChannels(color),red=_getColorChannels.red,green=_getColorChannels.green,blue=_getColorChannels.blue;if(percent>0){// shade given color
red*=1-percent;green*=1-percent;blue*=1-percent;}else{// tint given color
red+=(255-red)*percent;green+=(255-green)*percent;blue+=(255-blue)*percent;}return'rgb('+Math.round(red)+', '+Math.round(green)+', '+Math.round(blue)+')';},addItem:function addItem(item){this.$set(this.items,item.index,item);},removeItem:function removeItem(item){delete this.items[item.index];},addSubmenu:function addSubmenu(item){this.$set(this.submenus,item.index,item);},removeSubmenu:function removeSubmenu(item){delete this.submenus[item.index];},openMenu:function openMenu(index,indexPath){var openedMenus=this.openedMenus;if(openedMenus.indexOf(index)!==-1)return;// 将不在该菜单路径下的其余菜单收起
// collapse all menu that are not under current menu item
if(this.uniqueOpened){this.openedMenus=openedMenus.filter(function(index){return indexPath.indexOf(index)!==-1;});}this.openedMenus.push(index);},closeMenu:function closeMenu(index){var i=this.openedMenus.indexOf(index);if(i!==-1){this.openedMenus.splice(i,1);}},handleSubmenuClick:function handleSubmenuClick(submenu){var index=submenu.index,indexPath=submenu.indexPath;var isOpened=this.openedMenus.indexOf(index)!==-1;if(isOpened){this.closeMenu(index);this.$emit('close',index,indexPath);}else{this.openMenu(index,indexPath);this.$emit('open',index,indexPath);}},handleItemClick:function handleItemClick(item){var _this=this;var index=item.index,indexPath=item.indexPath;var oldActiveIndex=this.activeIndex;var hasIndex=item.index!==null;if(hasIndex){this.activeIndex=item.index;}this.$emit('select',index,indexPath,item);if(this.mode==='horizontal'||this.collapse){this.openedMenus=[];}if(this.router&&hasIndex){this.routeToItem(item,function(error){_this.activeIndex=oldActiveIndex;if(error){// vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
// https://github.com/ElemeFE/element/issues/17044
if(error.name==='NavigationDuplicated')return;console.error(error);}});}},// 初始化展开菜单
// initialize opened menu
initOpenedMenu:function initOpenedMenu(){var _this2=this;var index=this.activeIndex;var activeItem=this.items[index];if(!activeItem||this.mode==='horizontal'||this.collapse)return;var indexPath=activeItem.indexPath;// 展开该菜单项的路径上所有子菜单
// expand all submenus of the menu item
indexPath.forEach(function(index){var submenu=_this2.submenus[index];submenu&&_this2.openMenu(index,submenu.indexPath);});},routeToItem:function routeToItem(item,onError){var route=item.route||item.index;try{this.$router.push(route,function(){},onError);}catch(e){console.error(e);}},open:function open(index){var _this3=this;var indexPath=this.submenus[index.toString()].indexPath;indexPath.forEach(function(i){return _this3.openMenu(i,indexPath);});},close:function close(index){this.closeMenu(index);}},mounted:function mounted(){this.initOpenedMenu();this.$on('item-click',this.handleItemClick);this.$on('submenu-click',this.handleSubmenuClick);if(this.mode==='horizontal'){new aria_menubar(this.$el);// eslint-disable-line
}this.$watch('items',this.updateActiveIndex);}};// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_menuvue_type_script_lang_js_=menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu.vue
var menu_render,menu_staticRenderFns;/* normalize component */var menu_component=normalizeComponent(src_menuvue_type_script_lang_js_,menu_render,menu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_api;}menu_component.options.__file="packages/menu/src/menu.vue";/* harmony default export */var src_menu=menu_component.exports;// CONCATENATED MODULE: ./packages/menu/index.js
/* istanbul ignore next */src_menu.install=function(Vue){Vue.component(src_menu.name,src_menu);};/* harmony default export */var packages_menu=src_menu;// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
var collapse_transition_=__webpack_require__(21);var collapse_transition_default=/*#__PURE__*/__webpack_require__.n(collapse_transition_);// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
/* harmony default export */var menu_mixin={inject:['rootMenu'],computed:{indexPath:function indexPath(){var path=[this.index];var parent=this.$parent;while(parent.$options.componentName!=='ElMenu'){if(parent.index){path.unshift(parent.index);}parent=parent.$parent;}return path;},parentMenu:function parentMenu(){var parent=this.$parent;while(parent&&['ElMenu','ElSubmenu'].indexOf(parent.$options.componentName)===-1){parent=parent.$parent;}return parent;},paddingStyle:function paddingStyle(){if(this.rootMenu.mode!=='vertical')return{};var padding=20;var parent=this.$parent;if(this.rootMenu.collapse){padding=20;}else{while(parent&&parent.$options.componentName!=='ElMenu'){if(parent.$options.componentName==='ElSubmenu'){padding+=20;}parent=parent.$parent;}}return{paddingLeft:padding+'px'};}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
var poperMixins={props:{transformOrigin:{type:[Boolean,String],default:false},offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,popperOptions:vue_popper_default.a.props.popperOptions},data:vue_popper_default.a.data,methods:vue_popper_default.a.methods,beforeDestroy:vue_popper_default.a.beforeDestroy,deactivated:vue_popper_default.a.deactivated};/* harmony default export */var submenuvue_type_script_lang_js_={name:'ElSubmenu',componentName:'ElSubmenu',mixins:[menu_mixin,emitter_default.a,poperMixins],components:{ElCollapseTransition:collapse_transition_default.a},props:{index:{type:String,required:true},showTimeout:{type:Number,default:300},hideTimeout:{type:Number,default:300},popperClass:String,disabled:Boolean,popperAppendToBody:{type:Boolean,default:undefined}},data:function data(){return{popperJS:null,timeout:null,items:{},submenus:{},mouseInChild:false};},watch:{opened:function opened(val){var _this=this;if(this.isMenuPopup){this.$nextTick(function(_){_this.updatePopper();});}}},computed:{// popper option
appendToBody:function appendToBody(){return this.popperAppendToBody===undefined?this.isFirstLevel:this.popperAppendToBody;},menuTransitionName:function menuTransitionName(){return this.rootMenu.collapse?'el-zoom-in-left':'el-zoom-in-top';},opened:function opened(){return this.rootMenu.openedMenus.indexOf(this.index)>-1;},active:function active(){var isActive=false;var submenus=this.submenus;var items=this.items;Object.keys(items).forEach(function(index){if(items[index].active){isActive=true;}});Object.keys(submenus).forEach(function(index){if(submenus[index].active){isActive=true;}});return isActive;},hoverBackground:function hoverBackground(){return this.rootMenu.hoverBackground;},backgroundColor:function backgroundColor(){return this.rootMenu.backgroundColor||'';},activeTextColor:function activeTextColor(){return this.rootMenu.activeTextColor||'';},textColor:function textColor(){return this.rootMenu.textColor||'';},mode:function mode(){return this.rootMenu.mode;},isMenuPopup:function isMenuPopup(){return this.rootMenu.isMenuPopup;},titleStyle:function titleStyle(){if(this.mode!=='horizontal'){return{color:this.textColor};}return{borderBottomColor:this.active?this.rootMenu.activeTextColor?this.activeTextColor:'':'transparent',color:this.active?this.activeTextColor:this.textColor};},isFirstLevel:function isFirstLevel(){var isFirstLevel=true;var parent=this.$parent;while(parent&&parent!==this.rootMenu){if(['ElSubmenu','ElMenuItemGroup'].indexOf(parent.$options.componentName)>-1){isFirstLevel=false;break;}else{parent=parent.$parent;}}return isFirstLevel;}},methods:{handleCollapseToggle:function handleCollapseToggle(value){if(value){this.initPopper();}else{this.doDestroy();}},addItem:function addItem(item){this.$set(this.items,item.index,item);},removeItem:function removeItem(item){delete this.items[item.index];},addSubmenu:function addSubmenu(item){this.$set(this.submenus,item.index,item);},removeSubmenu:function removeSubmenu(item){delete this.submenus[item.index];},handleClick:function handleClick(){var rootMenu=this.rootMenu,disabled=this.disabled;if(rootMenu.menuTrigger==='hover'&&rootMenu.mode==='horizontal'||rootMenu.collapse&&rootMenu.mode==='vertical'||disabled){return;}this.dispatch('ElMenu','submenu-click',this);},handleMouseenter:function handleMouseenter(event){var _this2=this;var showTimeout=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.showTimeout;if(!('ActiveXObject'in window)&&event.type==='focus'&&!event.relatedTarget){return;}var rootMenu=this.rootMenu,disabled=this.disabled;if(rootMenu.menuTrigger==='click'&&rootMenu.mode==='horizontal'||!rootMenu.collapse&&rootMenu.mode==='vertical'||disabled){return;}this.dispatch('ElSubmenu','mouse-enter-child');clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this2.rootMenu.openMenu(_this2.index,_this2.indexPath);},showTimeout);if(this.appendToBody){this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));}},handleMouseleave:function handleMouseleave(){var _this3=this;var deepDispatch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var rootMenu=this.rootMenu;if(rootMenu.menuTrigger==='click'&&rootMenu.mode==='horizontal'||!rootMenu.collapse&&rootMenu.mode==='vertical'){return;}this.dispatch('ElSubmenu','mouse-leave-child');clearTimeout(this.timeout);this.timeout=setTimeout(function(){!_this3.mouseInChild&&_this3.rootMenu.closeMenu(_this3.index);},this.hideTimeout);if(this.appendToBody&&deepDispatch){if(this.$parent.$options.name==='ElSubmenu'){this.$parent.handleMouseleave(true);}}},handleTitleMouseenter:function handleTitleMouseenter(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;var title=this.$refs['submenu-title'];title&&(title.style.backgroundColor=this.rootMenu.hoverBackground);},handleTitleMouseleave:function handleTitleMouseleave(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;var title=this.$refs['submenu-title'];title&&(title.style.backgroundColor=this.rootMenu.backgroundColor||'');},updatePlacement:function updatePlacement(){this.currentPlacement=this.mode==='horizontal'&&this.isFirstLevel?'bottom-start':'right-start';},initPopper:function initPopper(){this.referenceElm=this.$el;this.popperElm=this.$refs.menu;this.updatePlacement();}},created:function created(){var _this4=this;this.$on('toggle-collapse',this.handleCollapseToggle);this.$on('mouse-enter-child',function(){_this4.mouseInChild=true;clearTimeout(_this4.timeout);});this.$on('mouse-leave-child',function(){_this4.mouseInChild=false;clearTimeout(_this4.timeout);});},mounted:function mounted(){this.parentMenu.addSubmenu(this);this.rootMenu.addSubmenu(this);this.initPopper();},beforeDestroy:function beforeDestroy(){this.parentMenu.removeSubmenu(this);this.rootMenu.removeSubmenu(this);},render:function render(h){var _this5=this;var active=this.active,opened=this.opened,paddingStyle=this.paddingStyle,titleStyle=this.titleStyle,backgroundColor=this.backgroundColor,rootMenu=this.rootMenu,currentPlacement=this.currentPlacement,menuTransitionName=this.menuTransitionName,mode=this.mode,disabled=this.disabled,popperClass=this.popperClass,$slots=this.$slots,isFirstLevel=this.isFirstLevel;var popupMenu=h('transition',{attrs:{name:menuTransitionName}},[h('div',{ref:'menu',directives:[{name:'show',value:opened}],'class':['el-menu--'+mode,popperClass],on:{'mouseenter':function mouseenter($event){return _this5.handleMouseenter($event,100);},'mouseleave':function mouseleave(){return _this5.handleMouseleave(true);},'focus':function focus($event){return _this5.handleMouseenter($event,100);}}},[h('ul',{attrs:{role:'menu'},'class':['el-menu el-menu--popup','el-menu--popup-'+currentPlacement],style:{backgroundColor:rootMenu.backgroundColor||''}},[$slots.default])])]);var inlineMenu=h('el-collapse-transition',[h('ul',{attrs:{role:'menu'},'class':'el-menu el-menu--inline',directives:[{name:'show',value:opened}],style:{backgroundColor:rootMenu.backgroundColor||''}},[$slots.default])]);var submenuTitleIcon=rootMenu.mode==='horizontal'&&isFirstLevel||rootMenu.mode==='vertical'&&!rootMenu.collapse?'el-icon-arrow-down':'el-icon-arrow-right';return h('li',{'class':{'el-submenu':true,'is-active':active,'is-opened':opened,'is-disabled':disabled},attrs:{role:'menuitem','aria-haspopup':'true','aria-expanded':opened},on:{'mouseenter':this.handleMouseenter,'mouseleave':function mouseleave(){return _this5.handleMouseleave(false);},'focus':this.handleMouseenter}},[h('div',{'class':'el-submenu__title',ref:'submenu-title',on:{'click':this.handleClick,'mouseenter':this.handleTitleMouseenter,'mouseleave':this.handleTitleMouseleave},style:[paddingStyle,titleStyle,{backgroundColor:backgroundColor}]},[$slots.title,h('i',{'class':['el-submenu__icon-arrow',submenuTitleIcon]})]),this.isMenuPopup?popupMenu:inlineMenu]);}};// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
/* harmony default export */var src_submenuvue_type_script_lang_js_=submenuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
var submenu_render,submenu_staticRenderFns;/* normalize component */var submenu_component=normalizeComponent(src_submenuvue_type_script_lang_js_,submenu_render,submenu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var submenu_api;}submenu_component.options.__file="packages/menu/src/submenu.vue";/* harmony default export */var submenu=submenu_component.exports;// CONCATENATED MODULE: ./packages/submenu/index.js
/* istanbul ignore next */submenu.install=function(Vue){Vue.component(submenu.name,submenu);};/* harmony default export */var packages_submenu=submenu;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
var menu_itemvue_type_template_id_2a5dbfea_render=function menu_itemvue_type_template_id_2a5dbfea_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-menu-item",class:{"is-active":_vm.active,"is-disabled":_vm.disabled},style:[_vm.paddingStyle,_vm.itemStyle,{backgroundColor:_vm.backgroundColor}],attrs:{role:"menuitem",tabindex:"-1"},on:{click:_vm.handleClick,mouseenter:_vm.onMouseEnter,focus:_vm.onMouseEnter,blur:_vm.onMouseLeave,mouseleave:_vm.onMouseLeave}},[_vm.parentMenu.$options.componentName==="ElMenu"&&_vm.rootMenu.collapse&&_vm.$slots.title?_c("el-tooltip",{attrs:{effect:"dark",placement:"right"}},[_c("div",{attrs:{slot:"content"},slot:"content"},[_vm._t("title")],2),_c("div",{staticStyle:{position:"absolute",left:"0",top:"0",height:"100%",width:"100%",display:"inline-block","box-sizing":"border-box",padding:"0 20px"}},[_vm._t("default")],2)]):[_vm._t("default"),_vm._t("title")]],2);};var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns=[];menu_itemvue_type_template_id_2a5dbfea_render._withStripped=true;// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
// EXTERNAL MODULE: external "element-ui/lib/tooltip"
var tooltip_=__webpack_require__(26);var tooltip_default=/*#__PURE__*/__webpack_require__.n(tooltip_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var menu_itemvue_type_script_lang_js_={name:'ElMenuItem',componentName:'ElMenuItem',mixins:[menu_mixin,emitter_default.a],components:{ElTooltip:tooltip_default.a},props:{index:{default:null,validator:function validator(val){return typeof val==='string'||val===null;}},route:[String,Object],disabled:Boolean},computed:{active:function active(){return this.index===this.rootMenu.activeIndex;},hoverBackground:function hoverBackground(){return this.rootMenu.hoverBackground;},backgroundColor:function backgroundColor(){return this.rootMenu.backgroundColor||'';},activeTextColor:function activeTextColor(){return this.rootMenu.activeTextColor||'';},textColor:function textColor(){return this.rootMenu.textColor||'';},mode:function mode(){return this.rootMenu.mode;},itemStyle:function itemStyle(){var style={color:this.active?this.activeTextColor:this.textColor};if(this.mode==='horizontal'&&!this.isNested){style.borderBottomColor=this.active?this.rootMenu.activeTextColor?this.activeTextColor:'':'transparent';}return style;},isNested:function isNested(){return this.parentMenu!==this.rootMenu;}},methods:{onMouseEnter:function onMouseEnter(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;this.$el.style.backgroundColor=this.hoverBackground;},onMouseLeave:function onMouseLeave(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;this.$el.style.backgroundColor=this.backgroundColor;},handleClick:function handleClick(){if(!this.disabled){this.dispatch('ElMenu','item-click',this);this.$emit('click',this);}}},mounted:function mounted(){this.parentMenu.addItem(this);this.rootMenu.addItem(this);},beforeDestroy:function beforeDestroy(){this.parentMenu.removeItem(this);this.rootMenu.removeItem(this);}};// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_menu_itemvue_type_script_lang_js_=menu_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
/* normalize component */var menu_item_component=normalizeComponent(src_menu_itemvue_type_script_lang_js_,menu_itemvue_type_template_id_2a5dbfea_render,menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_item_api;}menu_item_component.options.__file="packages/menu/src/menu-item.vue";/* harmony default export */var menu_item=menu_item_component.exports;// CONCATENATED MODULE: ./packages/menu-item/index.js
/* istanbul ignore next */menu_item.install=function(Vue){Vue.component(menu_item.name,menu_item);};/* harmony default export */var packages_menu_item=menu_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
var menu_item_groupvue_type_template_id_543b7bdc_render=function menu_item_groupvue_type_template_id_543b7bdc_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-menu-item-group"},[_c("div",{staticClass:"el-menu-item-group__title",style:{paddingLeft:_vm.levelPadding+"px"}},[!_vm.$slots.title?[_vm._v(_vm._s(_vm.title))]:_vm._t("title")],2),_c("ul",[_vm._t("default")],2)]);};var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns=[];menu_item_groupvue_type_template_id_543b7bdc_render._withStripped=true;// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var menu_item_groupvue_type_script_lang_js_={name:'ElMenuItemGroup',componentName:'ElMenuItemGroup',inject:['rootMenu'],props:{title:{type:String}},data:function data(){return{paddingLeft:20};},computed:{levelPadding:function levelPadding(){var padding=20;var parent=this.$parent;if(this.rootMenu.collapse)return 20;while(parent&&parent.$options.componentName!=='ElMenu'){if(parent.$options.componentName==='ElSubmenu'){padding+=20;}parent=parent.$parent;}return padding;}}};// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_menu_item_groupvue_type_script_lang_js_=menu_item_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
/* normalize component */var menu_item_group_component=normalizeComponent(src_menu_item_groupvue_type_script_lang_js_,menu_item_groupvue_type_template_id_543b7bdc_render,menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_item_group_api;}menu_item_group_component.options.__file="packages/menu/src/menu-item-group.vue";/* harmony default export */var menu_item_group=menu_item_group_component.exports;// CONCATENATED MODULE: ./packages/menu-item-group/index.js
/* istanbul ignore next */menu_item_group.install=function(Vue){Vue.component(menu_item_group.name,menu_item_group);};/* harmony default export */var packages_menu_item_group=menu_item_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var inputvue_type_template_id_343dd774_render=function inputvue_type_template_id_343dd774_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:[_vm.type==="textarea"?"el-textarea":"el-input",_vm.inputSize?"el-input--"+_vm.inputSize:"",{"is-disabled":_vm.inputDisabled,"is-exceed":_vm.inputExceed,"el-input-group":_vm.$slots.prepend||_vm.$slots.append,"el-input-group--append":_vm.$slots.append,"el-input-group--prepend":_vm.$slots.prepend,"el-input--prefix":_vm.$slots.prefix||_vm.prefixIcon,"el-input--suffix":_vm.$slots.suffix||_vm.suffixIcon||_vm.clearable||_vm.showPassword}],on:{mouseenter:function mouseenter($event){_vm.hovering=true;},mouseleave:function mouseleave($event){_vm.hovering=false;}}},[_vm.type!=="textarea"?[_vm.$slots.prepend?_c("div",{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),_vm.type!=="textarea"?_c("input",_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{tabindex:_vm.tabindex,type:_vm.showPassword?_vm.passwordVisible?"text":"password":_vm.type,disabled:_vm.inputDisabled,readonly:_vm.readonly,autocomplete:_vm.autoComplete||_vm.autocomplete,"aria-label":_vm.label},on:{compositionstart:_vm.handleCompositionStart,compositionupdate:_vm.handleCompositionUpdate,compositionend:_vm.handleCompositionEnd,input:_vm.handleInput,focus:_vm.handleFocus,blur:_vm.handleBlur,change:_vm.handleChange}},"input",_vm.$attrs,false)):_vm._e(),_vm.$slots.prefix||_vm.prefixIcon?_c("span",{staticClass:"el-input__prefix"},[_vm._t("prefix"),_vm.prefixIcon?_c("i",{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),_vm.getSuffixVisible()?_c("span",{staticClass:"el-input__suffix"},[_c("span",{staticClass:"el-input__suffix-inner"},[!_vm.showClear||!_vm.showPwdVisible||!_vm.isWordLimitVisible?[_vm._t("suffix"),_vm.suffixIcon?_c("i",{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_vm._e(),_vm.showClear?_c("i",{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{mousedown:function mousedown($event){$event.preventDefault();},click:_vm.clear}}):_vm._e(),_vm.showPwdVisible?_c("i",{staticClass:"el-input__icon el-icon-view el-input__clear",on:{click:_vm.handlePasswordVisible}}):_vm._e(),_vm.isWordLimitVisible?_c("span",{staticClass:"el-input__count"},[_c("span",{staticClass:"el-input__count-inner"},[_vm._v("\n            "+_vm._s(_vm.textLength)+"/"+_vm._s(_vm.upperLimit)+"\n          ")])]):_vm._e()],2),_vm.validateState?_c("i",{staticClass:"el-input__icon",class:["el-input__validateIcon",_vm.validateIcon]}):_vm._e()]):_vm._e(),_vm.$slots.append?_c("div",{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c("textarea",_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:_vm.textareaStyle,attrs:{tabindex:_vm.tabindex,disabled:_vm.inputDisabled,readonly:_vm.readonly,autocomplete:_vm.autoComplete||_vm.autocomplete,"aria-label":_vm.label},on:{compositionstart:_vm.handleCompositionStart,compositionupdate:_vm.handleCompositionUpdate,compositionend:_vm.handleCompositionEnd,input:_vm.handleInput,focus:_vm.handleFocus,blur:_vm.handleBlur,change:_vm.handleChange}},"textarea",_vm.$attrs,false)),_vm.isWordLimitVisible&&_vm.type==="textarea"?_c("span",{staticClass:"el-input__count"},[_vm._v(_vm._s(_vm.textLength)+"/"+_vm._s(_vm.upperLimit))]):_vm._e()],2);};var inputvue_type_template_id_343dd774_staticRenderFns=[];inputvue_type_template_id_343dd774_render._withStripped=true;// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea=void 0;var HIDDEN_STYLE='\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';var CONTEXT_STYLE=['letter-spacing','line-height','padding-top','padding-bottom','font-family','font-weight','font-size','text-rendering','text-transform','width','text-indent','padding-left','padding-right','border-width','box-sizing'];function calculateNodeStyling(targetElement){var style=window.getComputedStyle(targetElement);var boxSizing=style.getPropertyValue('box-sizing');var paddingSize=parseFloat(style.getPropertyValue('padding-bottom'))+parseFloat(style.getPropertyValue('padding-top'));var borderSize=parseFloat(style.getPropertyValue('border-bottom-width'))+parseFloat(style.getPropertyValue('border-top-width'));var contextStyle=CONTEXT_STYLE.map(function(name){return name+':'+style.getPropertyValue(name);}).join(';');return{contextStyle:contextStyle,paddingSize:paddingSize,borderSize:borderSize,boxSizing:boxSizing};}function calcTextareaHeight(targetElement){var minRows=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var maxRows=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(!hiddenTextarea){hiddenTextarea=document.createElement('textarea');document.body.appendChild(hiddenTextarea);}var _calculateNodeStyling=calculateNodeStyling(targetElement),paddingSize=_calculateNodeStyling.paddingSize,borderSize=_calculateNodeStyling.borderSize,boxSizing=_calculateNodeStyling.boxSizing,contextStyle=_calculateNodeStyling.contextStyle;hiddenTextarea.setAttribute('style',contextStyle+';'+HIDDEN_STYLE);hiddenTextarea.value=targetElement.value||targetElement.placeholder||'';var height=hiddenTextarea.scrollHeight;var result={};if(boxSizing==='border-box'){height=height+borderSize;}else if(boxSizing==='content-box'){height=height-paddingSize;}hiddenTextarea.value='';var singleRowHeight=hiddenTextarea.scrollHeight-paddingSize;if(minRows!==null){var minHeight=singleRowHeight*minRows;if(boxSizing==='border-box'){minHeight=minHeight+paddingSize+borderSize;}height=Math.max(minHeight,height);result.minHeight=minHeight+'px';}if(maxRows!==null){var maxHeight=singleRowHeight*maxRows;if(boxSizing==='border-box'){maxHeight=maxHeight+paddingSize+borderSize;}height=Math.min(maxHeight,height);}result.height=height+'px';hiddenTextarea.parentNode&&hiddenTextarea.parentNode.removeChild(hiddenTextarea);hiddenTextarea=null;return result;};// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_=__webpack_require__(7);var merge_default=/*#__PURE__*/__webpack_require__.n(merge_);// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_=__webpack_require__(19);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var inputvue_type_script_lang_js_={name:'ElInput',componentName:'ElInput',mixins:[emitter_default.a,migrating_default.a],inheritAttrs:false,inject:{elForm:{default:''},elFormItem:{default:''}},data:function data(){return{textareaCalcStyle:{},hovering:false,focused:false,isComposing:false,passwordVisible:false};},props:{value:[String,Number],size:String,resize:String,form:String,disabled:Boolean,readonly:Boolean,type:{type:String,default:'text'},autosize:{type:[Boolean,Object],default:false},autocomplete:{type:String,default:'off'},/** @Deprecated in next major version */autoComplete:{type:String,validator:function validator(val){false&&false;return true;}},validateEvent:{type:Boolean,default:true},suffixIcon:String,prefixIcon:String,label:String,clearable:{type:Boolean,default:false},showPassword:{type:Boolean,default:false},showWordLimit:{type:Boolean,default:false},tabindex:String},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},validateState:function validateState(){return this.elFormItem?this.elFormItem.validateState:'';},needStatusIcon:function needStatusIcon(){return this.elForm?this.elForm.statusIcon:false;},validateIcon:function validateIcon(){return{validating:'el-icon-loading',success:'el-icon-circle-check',error:'el-icon-circle-close'}[this.validateState];},textareaStyle:function textareaStyle(){return merge_default()({},this.textareaCalcStyle,{resize:this.resize});},inputSize:function inputSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},inputDisabled:function inputDisabled(){return this.disabled||(this.elForm||{}).disabled;},nativeInputValue:function nativeInputValue(){return this.value===null||this.value===undefined?'':String(this.value);},showClear:function showClear(){return this.clearable&&!this.inputDisabled&&!this.readonly&&this.nativeInputValue&&(this.focused||this.hovering);},showPwdVisible:function showPwdVisible(){return this.showPassword&&!this.inputDisabled&&!this.readonly&&(!!this.nativeInputValue||this.focused);},isWordLimitVisible:function isWordLimitVisible(){return this.showWordLimit&&this.$attrs.maxlength&&(this.type==='text'||this.type==='textarea')&&!this.inputDisabled&&!this.readonly&&!this.showPassword;},upperLimit:function upperLimit(){return this.$attrs.maxlength;},textLength:function textLength(){if(typeof this.value==='number'){return String(this.value).length;}return(this.value||'').length;},inputExceed:function inputExceed(){// show exceed style if length of initial value greater then maxlength
return this.isWordLimitVisible&&this.textLength>this.upperLimit;}},watch:{value:function value(val){this.$nextTick(this.resizeTextarea);if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',[val]);}},// native input value is set explicitly
// do not use v-model / :value in template
// see: https://github.com/ElemeFE/element/issues/14521
nativeInputValue:function nativeInputValue(){this.setNativeInputValue();},// when change between <input> and <textarea>,
// update DOM dependent value and styles
// https://github.com/ElemeFE/element/issues/14857
type:function type(){var _this=this;this.$nextTick(function(){_this.setNativeInputValue();_this.resizeTextarea();_this.updateIconOffset();});}},methods:{focus:function focus(){this.getInput().focus();},blur:function blur(){this.getInput().blur();},getMigratingConfig:function getMigratingConfig(){return{props:{'icon':'icon is removed, use suffix-icon / prefix-icon instead.','on-icon-click':'on-icon-click is removed.'},events:{'click':'click is removed.'}};},handleBlur:function handleBlur(event){this.focused=false;this.$emit('blur',event);if(this.validateEvent){this.dispatch('ElFormItem','el.form.blur',[this.value]);}},select:function select(){this.getInput().select();},resizeTextarea:function resizeTextarea(){if(this.$isServer)return;var autosize=this.autosize,type=this.type;if(type!=='textarea')return;if(!autosize){this.textareaCalcStyle={minHeight:calcTextareaHeight(this.$refs.textarea).minHeight};return;}var minRows=autosize.minRows;var maxRows=autosize.maxRows;this.textareaCalcStyle=calcTextareaHeight(this.$refs.textarea,minRows,maxRows);},setNativeInputValue:function setNativeInputValue(){var input=this.getInput();if(!input)return;if(input.value===this.nativeInputValue)return;input.value=this.nativeInputValue;},handleFocus:function handleFocus(event){this.focused=true;this.$emit('focus',event);},handleCompositionStart:function handleCompositionStart(event){this.$emit('compositionstart',event);this.isComposing=true;},handleCompositionUpdate:function handleCompositionUpdate(event){this.$emit('compositionupdate',event);var text=event.target.value;var lastCharacter=text[text.length-1]||'';this.isComposing=!Object(shared_["isKorean"])(lastCharacter);},handleCompositionEnd:function handleCompositionEnd(event){this.$emit('compositionend',event);if(this.isComposing){this.isComposing=false;this.handleInput(event);}},handleInput:function handleInput(event){// should not emit input during composition
// see: https://github.com/ElemeFE/element/issues/10516
if(this.isComposing)return;// hack for https://github.com/ElemeFE/element/issues/8548
// should remove the following line when we don't support IE
if(event.target.value===this.nativeInputValue)return;this.$emit('input',event.target.value);// ensure native input value is controlled
// see: https://github.com/ElemeFE/element/issues/12850
this.$nextTick(this.setNativeInputValue);},handleChange:function handleChange(event){this.$emit('change',event.target.value);},calcIconOffset:function calcIconOffset(place){var elList=[].slice.call(this.$el.querySelectorAll('.el-input__'+place)||[]);if(!elList.length)return;var el=null;for(var i=0;i<elList.length;i++){if(elList[i].parentNode===this.$el){el=elList[i];break;}}if(!el)return;var pendantMap={suffix:'append',prefix:'prepend'};var pendant=pendantMap[place];if(this.$slots[pendant]){el.style.transform='translateX('+(place==='suffix'?'-':'')+this.$el.querySelector('.el-input-group__'+pendant).offsetWidth+'px)';}else{el.removeAttribute('style');}},updateIconOffset:function updateIconOffset(){this.calcIconOffset('prefix');this.calcIconOffset('suffix');},clear:function clear(){this.$emit('input','');this.$emit('change','');this.$emit('clear');},handlePasswordVisible:function handlePasswordVisible(){var _this2=this;this.passwordVisible=!this.passwordVisible;this.$nextTick(function(){_this2.focus();});},getInput:function getInput(){return this.$refs.input||this.$refs.textarea;},getSuffixVisible:function getSuffixVisible(){return this.$slots.suffix||this.suffixIcon||this.showClear||this.showPassword||this.isWordLimitVisible||this.validateState&&this.needStatusIcon;}},created:function created(){this.$on('inputSelect',this.select);},mounted:function mounted(){this.setNativeInputValue();this.resizeTextarea();this.updateIconOffset();},updated:function updated(){this.$nextTick(this.updateIconOffset);}};// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
/* harmony default export */var src_inputvue_type_script_lang_js_=inputvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/input/src/input.vue
/* normalize component */var input_component=normalizeComponent(src_inputvue_type_script_lang_js_,inputvue_type_template_id_343dd774_render,inputvue_type_template_id_343dd774_staticRenderFns,false,null,null,null);/* hot reload */if(false){var input_api;}input_component.options.__file="packages/input/src/input.vue";/* harmony default export */var src_input=input_component.exports;// CONCATENATED MODULE: ./packages/input/index.js
/* istanbul ignore next */src_input.install=function(Vue){Vue.component(src_input.name,src_input);};/* harmony default export */var packages_input=src_input;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
var input_numbervue_type_template_id_42f8cf66_render=function input_numbervue_type_template_id_42f8cf66_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-input-number",_vm.inputNumberSize?"el-input-number--"+_vm.inputNumberSize:"",{"is-disabled":_vm.inputNumberDisabled},{"is-without-controls":!_vm.controls},{"is-controls-right":_vm.controlsAtRight}],on:{dragstart:function dragstart($event){$event.preventDefault();}}},[_vm.controls?_c("span",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-input-number__decrease",class:{"is-disabled":_vm.minDisabled},attrs:{role:"button"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.decrease($event);}}},[_c("i",{class:"el-icon-"+(_vm.controlsAtRight?"arrow-down":"minus")})]):_vm._e(),_vm.controls?_c("span",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-input-number__increase",class:{"is-disabled":_vm.maxDisabled},attrs:{role:"button"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.increase($event);}}},[_c("i",{class:"el-icon-"+(_vm.controlsAtRight?"arrow-up":"plus")})]):_vm._e(),_c("el-input",{ref:"input",attrs:{value:_vm.displayValue,placeholder:_vm.placeholder,disabled:_vm.inputNumberDisabled,size:_vm.inputNumberSize,max:_vm.max,min:_vm.min,name:_vm.name,label:_vm.label},on:{blur:_vm.handleBlur,focus:_vm.handleFocus,input:_vm.handleInput,change:_vm.handleInputChange},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();return _vm.increase($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();return _vm.decrease($event);}]}})],1);};var input_numbervue_type_template_id_42f8cf66_staticRenderFns=[];input_numbervue_type_template_id_42f8cf66_render._withStripped=true;// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
// CONCATENATED MODULE: ./src/directives/repeat-click.js
/* harmony default export */var repeat_click={bind:function bind(el,binding,vnode){var interval=null;var startTime=void 0;var maxIntervals=Object(util_["isMac"])()?100:200;var handler=function handler(){return vnode.context[binding.expression].apply();};var clear=function clear(){if(Date.now()-startTime<maxIntervals){handler();}clearInterval(interval);interval=null;};Object(dom_["on"])(el,'mousedown',function(e){if(e.button!==0)return;startTime=Date.now();Object(dom_["once"])(document,'mouseup',clear);clearInterval(interval);interval=setInterval(handler,maxIntervals);});}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var input_numbervue_type_script_lang_js_={name:'ElInputNumber',mixins:[focus_default()('input')],inject:{elForm:{default:''},elFormItem:{default:''}},directives:{repeatClick:repeat_click},components:{ElInput:input_default.a},props:{step:{type:Number,default:1},stepStrictly:{type:Boolean,default:false},max:{type:Number,default:Infinity},min:{type:Number,default:-Infinity},value:{},disabled:Boolean,size:String,controls:{type:Boolean,default:true},controlsPosition:{type:String,default:''},name:String,label:String,placeholder:String,precision:{type:Number,validator:function validator(val){return val>=0&&val===parseInt(val,10);}}},data:function data(){return{currentValue:0,userInput:null};},watch:{value:{immediate:true,handler:function handler(value){var newVal=value===undefined?value:Number(value);if(newVal!==undefined){if(isNaN(newVal)){return;}if(this.stepStrictly){var stepPrecision=this.getPrecision(this.step);var precisionFactor=Math.pow(10,stepPrecision);newVal=Math.round(newVal/this.step)*precisionFactor*this.step/precisionFactor;}if(this.precision!==undefined){newVal=this.toPrecision(newVal,this.precision);}}if(newVal>=this.max)newVal=this.max;if(newVal<=this.min)newVal=this.min;this.currentValue=newVal;this.userInput=null;this.$emit('input',newVal);}}},computed:{minDisabled:function minDisabled(){return this._decrease(this.value,this.step)<this.min;},maxDisabled:function maxDisabled(){return this._increase(this.value,this.step)>this.max;},numPrecision:function numPrecision(){var value=this.value,step=this.step,getPrecision=this.getPrecision,precision=this.precision;var stepPrecision=getPrecision(step);if(precision!==undefined){if(stepPrecision>precision){console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');}return precision;}else{return Math.max(getPrecision(value),stepPrecision);}},controlsAtRight:function controlsAtRight(){return this.controls&&this.controlsPosition==='right';},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},inputNumberSize:function inputNumberSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},inputNumberDisabled:function inputNumberDisabled(){return this.disabled||!!(this.elForm||{}).disabled;},displayValue:function displayValue(){if(this.userInput!==null){return this.userInput;}var currentValue=this.currentValue;if(typeof currentValue==='number'){if(this.stepStrictly){var stepPrecision=this.getPrecision(this.step);var precisionFactor=Math.pow(10,stepPrecision);currentValue=Math.round(currentValue/this.step)*precisionFactor*this.step/precisionFactor;}if(this.precision!==undefined){currentValue=currentValue.toFixed(this.precision);}}return currentValue;}},methods:{toPrecision:function toPrecision(num,precision){if(precision===undefined)precision=this.numPrecision;return parseFloat(Math.round(num*Math.pow(10,precision))/Math.pow(10,precision));},getPrecision:function getPrecision(value){if(value===undefined)return 0;var valueString=value.toString();var dotPosition=valueString.indexOf('.');var precision=0;if(dotPosition!==-1){precision=valueString.length-dotPosition-1;}return precision;},_increase:function _increase(val,step){if(typeof val!=='number'&&val!==undefined)return this.currentValue;var precisionFactor=Math.pow(10,this.numPrecision);// Solve the accuracy problem of JS decimal calculation by converting the value to integer.
return this.toPrecision((precisionFactor*val+precisionFactor*step)/precisionFactor);},_decrease:function _decrease(val,step){if(typeof val!=='number'&&val!==undefined)return this.currentValue;var precisionFactor=Math.pow(10,this.numPrecision);return this.toPrecision((precisionFactor*val-precisionFactor*step)/precisionFactor);},increase:function increase(){if(this.inputNumberDisabled||this.maxDisabled)return;var value=this.value||0;var newVal=this._increase(value,this.step);this.setCurrentValue(newVal);},decrease:function decrease(){if(this.inputNumberDisabled||this.minDisabled)return;var value=this.value||0;var newVal=this._decrease(value,this.step);this.setCurrentValue(newVal);},handleBlur:function handleBlur(event){this.$emit('blur',event);},handleFocus:function handleFocus(event){this.$emit('focus',event);},setCurrentValue:function setCurrentValue(newVal){var oldVal=this.currentValue;if(typeof newVal==='number'&&this.precision!==undefined){newVal=this.toPrecision(newVal,this.precision);}if(newVal>=this.max)newVal=this.max;if(newVal<=this.min)newVal=this.min;if(oldVal===newVal)return;this.userInput=null;this.$emit('input',newVal);this.$emit('change',newVal,oldVal);this.currentValue=newVal;},handleInput:function handleInput(value){this.userInput=value;},handleInputChange:function handleInputChange(value){var newVal=value===''?undefined:Number(value);if(!isNaN(newVal)||value===''){this.setCurrentValue(newVal);}this.userInput=null;},select:function select(){this.$refs.input.select();}},mounted:function mounted(){var innerInput=this.$refs.input.$refs.input;innerInput.setAttribute('role','spinbutton');innerInput.setAttribute('aria-valuemax',this.max);innerInput.setAttribute('aria-valuemin',this.min);innerInput.setAttribute('aria-valuenow',this.currentValue);innerInput.setAttribute('aria-disabled',this.inputNumberDisabled);},updated:function updated(){if(!this.$refs||!this.$refs.input)return;var innerInput=this.$refs.input.$refs.input;innerInput.setAttribute('aria-valuenow',this.currentValue);}};// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
/* harmony default export */var src_input_numbervue_type_script_lang_js_=input_numbervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
/* normalize component */var input_number_component=normalizeComponent(src_input_numbervue_type_script_lang_js_,input_numbervue_type_template_id_42f8cf66_render,input_numbervue_type_template_id_42f8cf66_staticRenderFns,false,null,null,null);/* hot reload */if(false){var input_number_api;}input_number_component.options.__file="packages/input-number/src/input-number.vue";/* harmony default export */var input_number=input_number_component.exports;// CONCATENATED MODULE: ./packages/input-number/index.js
/* istanbul ignore next */input_number.install=function(Vue){Vue.component(input_number.name,input_number);};/* harmony default export */var packages_input_number=input_number;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
var radiovue_type_template_id_69cd6268_render=function radiovue_type_template_id_69cd6268_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-radio",class:[_vm.border&&_vm.radioSize?"el-radio--"+_vm.radioSize:"",{"is-disabled":_vm.isDisabled},{"is-focus":_vm.focus},{"is-bordered":_vm.border},{"is-checked":_vm.model===_vm.label}],attrs:{role:"radio","aria-checked":_vm.model===_vm.label,"aria-disabled":_vm.isDisabled,tabindex:_vm.tabIndex},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.model=_vm.isDisabled?_vm.model:_vm.label;}}},[_c("span",{staticClass:"el-radio__input",class:{"is-disabled":_vm.isDisabled,"is-checked":_vm.model===_vm.label}},[_c("span",{staticClass:"el-radio__inner"}),_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],ref:"radio",staticClass:"el-radio__original",attrs:{type:"radio","aria-hidden":"true",name:_vm.name,disabled:_vm.isDisabled,tabindex:"-1",autocomplete:"off"},domProps:{value:_vm.label,checked:_vm._q(_vm.model,_vm.label)},on:{focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;},change:[function($event){_vm.model=_vm.label;},_vm.handleChange]}})]),_c("span",{staticClass:"el-radio__label",on:{keydown:function keydown($event){$event.stopPropagation();}}},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)]);};var radiovue_type_template_id_69cd6268_staticRenderFns=[];radiovue_type_template_id_69cd6268_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var radiovue_type_script_lang_js_={name:'ElRadio',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},componentName:'ElRadio',props:{value:{},label:{},disabled:Boolean,name:String,border:Boolean,size:String},data:function data(){return{focus:false};},computed:{isGroup:function isGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElRadioGroup'){parent=parent.$parent;}else{this._radioGroup=parent;return true;}}return false;},model:{get:function get(){return this.isGroup?this._radioGroup.value:this.value;},set:function set(val){if(this.isGroup){this.dispatch('ElRadioGroup','input',[val]);}else{this.$emit('input',val);}this.$refs.radio&&(this.$refs.radio.checked=this.model===this.label);}},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},radioSize:function radioSize(){var temRadioSize=this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;return this.isGroup?this._radioGroup.radioGroupSize||temRadioSize:temRadioSize;},isDisabled:function isDisabled(){return this.isGroup?this._radioGroup.disabled||this.disabled||(this.elForm||{}).disabled:this.disabled||(this.elForm||{}).disabled;},tabIndex:function tabIndex(){return this.isDisabled||this.isGroup&&this.model!==this.label?-1:0;}},methods:{handleChange:function handleChange(){var _this=this;this.$nextTick(function(){_this.$emit('change',_this.model);_this.isGroup&&_this.dispatch('ElRadioGroup','handleChange',_this.model);});}}};// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
/* harmony default export */var src_radiovue_type_script_lang_js_=radiovue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio.vue
/* normalize component */var radio_component=normalizeComponent(src_radiovue_type_script_lang_js_,radiovue_type_template_id_69cd6268_render,radiovue_type_template_id_69cd6268_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_api;}radio_component.options.__file="packages/radio/src/radio.vue";/* harmony default export */var src_radio=radio_component.exports;// CONCATENATED MODULE: ./packages/radio/index.js
/* istanbul ignore next */src_radio.install=function(Vue){Vue.component(src_radio.name,src_radio);};/* harmony default export */var packages_radio=src_radio;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
var radio_groupvue_type_template_id_818a704c_render=function radio_groupvue_type_template_id_818a704c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm._elTag,{tag:"component",staticClass:"el-radio-group",attrs:{role:"radiogroup"},on:{keydown:_vm.handleKeydown}},[_vm._t("default")],2);};var radio_groupvue_type_template_id_818a704c_staticRenderFns=[];radio_groupvue_type_template_id_818a704c_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
var keyCode=Object.freeze({LEFT:37,UP:38,RIGHT:39,DOWN:40});/* harmony default export */var radio_groupvue_type_script_lang_js_={name:'ElRadioGroup',componentName:'ElRadioGroup',inject:{elFormItem:{default:''}},mixins:[emitter_default.a],props:{value:{},size:String,fill:String,textColor:String,disabled:Boolean},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},_elTag:function _elTag(){var tag=(this.$vnode.data||{}).tag;if(!tag||tag==='component')tag='div';return tag;},radioGroupSize:function radioGroupSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;}},created:function created(){var _this=this;this.$on('handleChange',function(value){_this.$emit('change',value);});},mounted:function mounted(){// 当radioGroup没有默认选项时，第一个可以选中Tab导航
var radios=this.$el.querySelectorAll('[type=radio]');var firstLabel=this.$el.querySelectorAll('[role=radio]')[0];if(![].some.call(radios,function(radio){return radio.checked;})&&firstLabel){firstLabel.tabIndex=0;}},methods:{handleKeydown:function handleKeydown(e){// 左右上下按键 可以在radio组内切换不同选项
var target=e.target;var className=target.nodeName==='INPUT'?'[type=radio]':'[role=radio]';var radios=this.$el.querySelectorAll(className);var length=radios.length;var index=[].indexOf.call(radios,target);var roleRadios=this.$el.querySelectorAll('[role=radio]');switch(e.keyCode){case keyCode.LEFT:case keyCode.UP:e.stopPropagation();e.preventDefault();if(index===0){roleRadios[length-1].click();roleRadios[length-1].focus();}else{roleRadios[index-1].click();roleRadios[index-1].focus();}break;case keyCode.RIGHT:case keyCode.DOWN:if(index===length-1){e.stopPropagation();e.preventDefault();roleRadios[0].click();roleRadios[0].focus();}else{roleRadios[index+1].click();roleRadios[index+1].focus();}break;default:break;}}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',[this.value]);}}};// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_radio_groupvue_type_script_lang_js_=radio_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
/* normalize component */var radio_group_component=normalizeComponent(src_radio_groupvue_type_script_lang_js_,radio_groupvue_type_template_id_818a704c_render,radio_groupvue_type_template_id_818a704c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_group_api;}radio_group_component.options.__file="packages/radio/src/radio-group.vue";/* harmony default export */var radio_group=radio_group_component.exports;// CONCATENATED MODULE: ./packages/radio-group/index.js
/* istanbul ignore next */radio_group.install=function(Vue){Vue.component(radio_group.name,radio_group);};/* harmony default export */var packages_radio_group=radio_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
var radio_buttonvue_type_template_id_18a77a32_render=function radio_buttonvue_type_template_id_18a77a32_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-radio-button",class:[_vm.size?"el-radio-button--"+_vm.size:"",{"is-active":_vm.value===_vm.label},{"is-disabled":_vm.isDisabled},{"is-focus":_vm.focus}],attrs:{role:"radio","aria-checked":_vm.value===_vm.label,"aria-disabled":_vm.isDisabled,tabindex:_vm.tabIndex},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.value=_vm.isDisabled?_vm.value:_vm.label;}}},[_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.value,expression:"value"}],staticClass:"el-radio-button__orig-radio",attrs:{type:"radio",name:_vm.name,disabled:_vm.isDisabled,tabindex:"-1",autocomplete:"off"},domProps:{value:_vm.label,checked:_vm._q(_vm.value,_vm.label)},on:{change:[function($event){_vm.value=_vm.label;},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}),_c("span",{staticClass:"el-radio-button__inner",style:_vm.value===_vm.label?_vm.activeStyle:null,on:{keydown:function keydown($event){$event.stopPropagation();}}},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)]);};var radio_buttonvue_type_template_id_18a77a32_staticRenderFns=[];radio_buttonvue_type_template_id_18a77a32_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var radio_buttonvue_type_script_lang_js_={name:'ElRadioButton',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},props:{label:{},disabled:Boolean,name:String},data:function data(){return{focus:false};},computed:{value:{get:function get(){return this._radioGroup.value;},set:function set(value){this._radioGroup.$emit('input',value);}},_radioGroup:function _radioGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElRadioGroup'){parent=parent.$parent;}else{return parent;}}return false;},activeStyle:function activeStyle(){return{backgroundColor:this._radioGroup.fill||'',borderColor:this._radioGroup.fill||'',boxShadow:this._radioGroup.fill?'-1px 0 0 0 '+this._radioGroup.fill:'',color:this._radioGroup.textColor||''};},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},size:function size(){return this._radioGroup.radioGroupSize||this._elFormItemSize||(this.$ELEMENT||{}).size;},isDisabled:function isDisabled(){return this.disabled||this._radioGroup.disabled||(this.elForm||{}).disabled;},tabIndex:function tabIndex(){return this.isDisabled||this._radioGroup&&this.value!==this.label?-1:0;}},methods:{handleChange:function handleChange(){var _this=this;this.$nextTick(function(){_this.dispatch('ElRadioGroup','handleChange',_this.value);});}}};// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
/* harmony default export */var src_radio_buttonvue_type_script_lang_js_=radio_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
/* normalize component */var radio_button_component=normalizeComponent(src_radio_buttonvue_type_script_lang_js_,radio_buttonvue_type_template_id_18a77a32_render,radio_buttonvue_type_template_id_18a77a32_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_button_api;}radio_button_component.options.__file="packages/radio/src/radio-button.vue";/* harmony default export */var radio_button=radio_button_component.exports;// CONCATENATED MODULE: ./packages/radio-button/index.js
/* istanbul ignore next */radio_button.install=function(Vue){Vue.component(radio_button.name,radio_button);};/* harmony default export */var packages_radio_button=radio_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
var checkboxvue_type_template_id_d0387074_render=function checkboxvue_type_template_id_d0387074_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-checkbox",class:[_vm.border&&_vm.checkboxSize?"el-checkbox--"+_vm.checkboxSize:"",{"is-disabled":_vm.isDisabled},{"is-bordered":_vm.border},{"is-checked":_vm.isChecked}],attrs:{id:_vm.id}},[_c("span",{staticClass:"el-checkbox__input",class:{"is-disabled":_vm.isDisabled,"is-checked":_vm.isChecked,"is-indeterminate":_vm.indeterminate,"is-focus":_vm.focus},attrs:{tabindex:_vm.indeterminate?0:false,role:_vm.indeterminate?"checkbox":false,"aria-checked":_vm.indeterminate?"mixed":false}},[_c("span",{staticClass:"el-checkbox__inner"}),_vm.trueLabel||_vm.falseLabel?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox__original",attrs:{type:"checkbox","aria-hidden":_vm.indeterminate?"true":"false",name:_vm.name,disabled:_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{checked:Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?_vm.trueLabel:_vm.falseLabel;if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}):_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox__original",attrs:{type:"checkbox","aria-hidden":_vm.indeterminate?"true":"false",disabled:_vm.isDisabled,name:_vm.name},domProps:{value:_vm.label,checked:Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:_vm.model},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?true:false;if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}})]),_vm.$slots.default||_vm.label?_c("span",{staticClass:"el-checkbox__label"},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_vm._e()]);};var checkboxvue_type_template_id_d0387074_staticRenderFns=[];checkboxvue_type_template_id_d0387074_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var checkboxvue_type_script_lang_js_={name:'ElCheckbox',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},componentName:'ElCheckbox',data:function data(){return{selfModel:false,focus:false,isLimitExceeded:false};},computed:{model:{get:function get(){return this.isGroup?this.store:this.value!==undefined?this.value:this.selfModel;},set:function set(val){if(this.isGroup){this.isLimitExceeded=false;this._checkboxGroup.min!==undefined&&val.length<this._checkboxGroup.min&&(this.isLimitExceeded=true);this._checkboxGroup.max!==undefined&&val.length>this._checkboxGroup.max&&(this.isLimitExceeded=true);this.isLimitExceeded===false&&this.dispatch('ElCheckboxGroup','input',[val]);}else{this.$emit('input',val);this.selfModel=val;}}},isChecked:function isChecked(){if({}.toString.call(this.model)==='[object Boolean]'){return this.model;}else if(Array.isArray(this.model)){return this.model.indexOf(this.label)>-1;}else if(this.model!==null&&this.model!==undefined){return this.model===this.trueLabel;}},isGroup:function isGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElCheckboxGroup'){parent=parent.$parent;}else{this._checkboxGroup=parent;return true;}}return false;},store:function store(){return this._checkboxGroup?this._checkboxGroup.value:this.value;},/* used to make the isDisabled judgment under max/min props */isLimitDisabled:function isLimitDisabled(){var _checkboxGroup=this._checkboxGroup,max=_checkboxGroup.max,min=_checkboxGroup.min;return!!(max||min)&&this.model.length>=max&&!this.isChecked||this.model.length<=min&&this.isChecked;},isDisabled:function isDisabled(){return this.isGroup?this._checkboxGroup.disabled||this.disabled||(this.elForm||{}).disabled||this.isLimitDisabled:this.disabled||(this.elForm||{}).disabled;},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},checkboxSize:function checkboxSize(){var temCheckboxSize=this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;return this.isGroup?this._checkboxGroup.checkboxGroupSize||temCheckboxSize:temCheckboxSize;}},props:{value:{},label:{},indeterminate:Boolean,disabled:Boolean,checked:Boolean,name:String,trueLabel:[String,Number],falseLabel:[String,Number],id:String,/* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/controls:String,/* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/border:Boolean,size:String},methods:{addToStore:function addToStore(){if(Array.isArray(this.model)&&this.model.indexOf(this.label)===-1){this.model.push(this.label);}else{this.model=this.trueLabel||true;}},handleChange:function handleChange(ev){var _this=this;if(this.isLimitExceeded)return;var value=void 0;if(ev.target.checked){value=this.trueLabel===undefined?true:this.trueLabel;}else{value=this.falseLabel===undefined?false:this.falseLabel;}this.$emit('change',value,ev);this.$nextTick(function(){if(_this.isGroup){_this.dispatch('ElCheckboxGroup','change',[_this._checkboxGroup.value]);}});}},created:function created(){this.checked&&this.addToStore();},mounted:function mounted(){// 为indeterminate元素 添加aria-controls 属性
if(this.indeterminate){this.$el.setAttribute('aria-controls',this.controls);}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',_value);}}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkboxvue_type_script_lang_js_=checkboxvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
/* normalize component */var checkbox_component=normalizeComponent(src_checkboxvue_type_script_lang_js_,checkboxvue_type_template_id_d0387074_render,checkboxvue_type_template_id_d0387074_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_api;}checkbox_component.options.__file="packages/checkbox/src/checkbox.vue";/* harmony default export */var src_checkbox=checkbox_component.exports;// CONCATENATED MODULE: ./packages/checkbox/index.js
/* istanbul ignore next */src_checkbox.install=function(Vue){Vue.component(src_checkbox.name,src_checkbox);};/* harmony default export */var packages_checkbox=src_checkbox;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
var checkbox_buttonvue_type_template_id_478e906e_render=function checkbox_buttonvue_type_template_id_478e906e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-checkbox-button",class:[_vm.size?"el-checkbox-button--"+_vm.size:"",{"is-disabled":_vm.isDisabled},{"is-checked":_vm.isChecked},{"is-focus":_vm.focus}],attrs:{role:"checkbox","aria-checked":_vm.isChecked,"aria-disabled":_vm.isDisabled}},[_vm.trueLabel||_vm.falseLabel?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{type:"checkbox",name:_vm.name,disabled:_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{checked:Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?_vm.trueLabel:_vm.falseLabel;if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}):_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{type:"checkbox",name:_vm.name,disabled:_vm.isDisabled},domProps:{value:_vm.label,checked:Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:_vm.model},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?true:false;if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}),_vm.$slots.default||_vm.label?_c("span",{staticClass:"el-checkbox-button__inner",style:_vm.isChecked?_vm.activeStyle:null},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()]);};var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns=[];checkbox_buttonvue_type_template_id_478e906e_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var checkbox_buttonvue_type_script_lang_js_={name:'ElCheckboxButton',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},data:function data(){return{selfModel:false,focus:false,isLimitExceeded:false};},props:{value:{},label:{},disabled:Boolean,checked:Boolean,name:String,trueLabel:[String,Number],falseLabel:[String,Number]},computed:{model:{get:function get(){return this._checkboxGroup?this.store:this.value!==undefined?this.value:this.selfModel;},set:function set(val){if(this._checkboxGroup){this.isLimitExceeded=false;this._checkboxGroup.min!==undefined&&val.length<this._checkboxGroup.min&&(this.isLimitExceeded=true);this._checkboxGroup.max!==undefined&&val.length>this._checkboxGroup.max&&(this.isLimitExceeded=true);this.isLimitExceeded===false&&this.dispatch('ElCheckboxGroup','input',[val]);}else if(this.value!==undefined){this.$emit('input',val);}else{this.selfModel=val;}}},isChecked:function isChecked(){if({}.toString.call(this.model)==='[object Boolean]'){return this.model;}else if(Array.isArray(this.model)){return this.model.indexOf(this.label)>-1;}else if(this.model!==null&&this.model!==undefined){return this.model===this.trueLabel;}},_checkboxGroup:function _checkboxGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElCheckboxGroup'){parent=parent.$parent;}else{return parent;}}return false;},store:function store(){return this._checkboxGroup?this._checkboxGroup.value:this.value;},activeStyle:function activeStyle(){return{backgroundColor:this._checkboxGroup.fill||'',borderColor:this._checkboxGroup.fill||'',color:this._checkboxGroup.textColor||'','box-shadow':'-1px 0 0 0 '+this._checkboxGroup.fill};},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},size:function size(){return this._checkboxGroup.checkboxGroupSize||this._elFormItemSize||(this.$ELEMENT||{}).size;},/* used to make the isDisabled judgment under max/min props */isLimitDisabled:function isLimitDisabled(){var _checkboxGroup2=this._checkboxGroup,max=_checkboxGroup2.max,min=_checkboxGroup2.min;return!!(max||min)&&this.model.length>=max&&!this.isChecked||this.model.length<=min&&this.isChecked;},isDisabled:function isDisabled(){return this._checkboxGroup?this._checkboxGroup.disabled||this.disabled||(this.elForm||{}).disabled||this.isLimitDisabled:this.disabled||(this.elForm||{}).disabled;}},methods:{addToStore:function addToStore(){if(Array.isArray(this.model)&&this.model.indexOf(this.label)===-1){this.model.push(this.label);}else{this.model=this.trueLabel||true;}},handleChange:function handleChange(ev){var _this=this;if(this.isLimitExceeded)return;var value=void 0;if(ev.target.checked){value=this.trueLabel===undefined?true:this.trueLabel;}else{value=this.falseLabel===undefined?false:this.falseLabel;}this.$emit('change',value,ev);this.$nextTick(function(){if(_this._checkboxGroup){_this.dispatch('ElCheckboxGroup','change',[_this._checkboxGroup.value]);}});}},created:function created(){this.checked&&this.addToStore();}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkbox_buttonvue_type_script_lang_js_=checkbox_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
/* normalize component */var checkbox_button_component=normalizeComponent(src_checkbox_buttonvue_type_script_lang_js_,checkbox_buttonvue_type_template_id_478e906e_render,checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_button_api;}checkbox_button_component.options.__file="packages/checkbox/src/checkbox-button.vue";/* harmony default export */var checkbox_button=checkbox_button_component.exports;// CONCATENATED MODULE: ./packages/checkbox-button/index.js
/* istanbul ignore next */checkbox_button.install=function(Vue){Vue.component(checkbox_button.name,checkbox_button);};/* harmony default export */var packages_checkbox_button=checkbox_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
var checkbox_groupvue_type_template_id_7289a290_render=function checkbox_groupvue_type_template_id_7289a290_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-checkbox-group",attrs:{role:"group","aria-label":"checkbox-group"}},[_vm._t("default")],2);};var checkbox_groupvue_type_template_id_7289a290_staticRenderFns=[];checkbox_groupvue_type_template_id_7289a290_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
/* harmony default export */var checkbox_groupvue_type_script_lang_js_={name:'ElCheckboxGroup',componentName:'ElCheckboxGroup',mixins:[emitter_default.a],inject:{elFormItem:{default:''}},props:{value:{},disabled:Boolean,min:Number,max:Number,size:String,fill:String,textColor:String},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},checkboxGroupSize:function checkboxGroupSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',[_value]);}}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkbox_groupvue_type_script_lang_js_=checkbox_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
/* normalize component */var checkbox_group_component=normalizeComponent(src_checkbox_groupvue_type_script_lang_js_,checkbox_groupvue_type_template_id_7289a290_render,checkbox_groupvue_type_template_id_7289a290_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_group_api;}checkbox_group_component.options.__file="packages/checkbox/src/checkbox-group.vue";/* harmony default export */var checkbox_group=checkbox_group_component.exports;// CONCATENATED MODULE: ./packages/checkbox-group/index.js
/* istanbul ignore next */checkbox_group.install=function(Vue){Vue.component(checkbox_group.name,checkbox_group);};/* harmony default export */var packages_checkbox_group=checkbox_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
var componentvue_type_template_id_2dcd8fbb_render=function componentvue_type_template_id_2dcd8fbb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-switch",class:{"is-disabled":_vm.switchDisabled,"is-checked":_vm.checked},attrs:{role:"switch","aria-checked":_vm.checked,"aria-disabled":_vm.switchDisabled},on:{click:function click($event){$event.preventDefault();return _vm.switchValue($event);}}},[_c("input",{ref:"input",staticClass:"el-switch__input",attrs:{type:"checkbox",id:_vm.id,name:_vm.name,"true-value":_vm.activeValue,"false-value":_vm.inactiveValue,disabled:_vm.switchDisabled},on:{change:_vm.handleChange,keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.switchValue($event);}}}),_vm.inactiveIconClass||_vm.inactiveText?_c("span",{class:["el-switch__label","el-switch__label--left",!_vm.checked?"is-active":""]},[_vm.inactiveIconClass?_c("i",{class:[_vm.inactiveIconClass]}):_vm._e(),!_vm.inactiveIconClass&&_vm.inactiveText?_c("span",{attrs:{"aria-hidden":_vm.checked}},[_vm._v(_vm._s(_vm.inactiveText))]):_vm._e()]):_vm._e(),_c("span",{ref:"core",staticClass:"el-switch__core",style:{width:_vm.coreWidth+"px"}}),_vm.activeIconClass||_vm.activeText?_c("span",{class:["el-switch__label","el-switch__label--right",_vm.checked?"is-active":""]},[_vm.activeIconClass?_c("i",{class:[_vm.activeIconClass]}):_vm._e(),!_vm.activeIconClass&&_vm.activeText?_c("span",{attrs:{"aria-hidden":!_vm.checked}},[_vm._v(_vm._s(_vm.activeText))]):_vm._e()]):_vm._e()]);};var componentvue_type_template_id_2dcd8fbb_staticRenderFns=[];componentvue_type_template_id_2dcd8fbb_render._withStripped=true;// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var switch_src_componentvue_type_script_lang_js_={name:'ElSwitch',mixins:[focus_default()('input'),migrating_default.a,emitter_default.a],inject:{elForm:{default:''}},props:{value:{type:[Boolean,String,Number],default:false},disabled:{type:Boolean,default:false},width:{type:Number,default:40},activeIconClass:{type:String,default:''},inactiveIconClass:{type:String,default:''},activeText:String,inactiveText:String,activeColor:{type:String,default:''},inactiveColor:{type:String,default:''},activeValue:{type:[Boolean,String,Number],default:true},inactiveValue:{type:[Boolean,String,Number],default:false},name:{type:String,default:''},validateEvent:{type:Boolean,default:true},id:String},data:function data(){return{coreWidth:this.width};},created:function created(){if(!~[this.activeValue,this.inactiveValue].indexOf(this.value)){this.$emit('input',this.inactiveValue);}},computed:{checked:function checked(){return this.value===this.activeValue;},switchDisabled:function switchDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{checked:function checked(){this.$refs.input.checked=this.checked;if(this.activeColor||this.inactiveColor){this.setBackgroundColor();}if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',[this.value]);}}},methods:{handleChange:function handleChange(event){var _this=this;var val=this.checked?this.inactiveValue:this.activeValue;this.$emit('input',val);this.$emit('change',val);this.$nextTick(function(){// set input's checked property
// in case parent refuses to change component's value
if(_this.$refs.input){_this.$refs.input.checked=_this.checked;}});},setBackgroundColor:function setBackgroundColor(){var newColor=this.checked?this.activeColor:this.inactiveColor;this.$refs.core.style.borderColor=newColor;this.$refs.core.style.backgroundColor=newColor;},switchValue:function switchValue(){!this.switchDisabled&&this.handleChange();},getMigratingConfig:function getMigratingConfig(){return{props:{'on-color':'on-color is renamed to active-color.','off-color':'off-color is renamed to inactive-color.','on-text':'on-text is renamed to active-text.','off-text':'off-text is renamed to inactive-text.','on-value':'on-value is renamed to active-value.','off-value':'off-value is renamed to inactive-value.','on-icon-class':'on-icon-class is renamed to active-icon-class.','off-icon-class':'off-icon-class is renamed to inactive-icon-class.'}};}},mounted:function mounted(){/* istanbul ignore if */this.coreWidth=this.width||40;if(this.activeColor||this.inactiveColor){this.setBackgroundColor();}this.$refs.input.checked=this.checked;}};// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
/* harmony default export */var packages_switch_src_componentvue_type_script_lang_js_=switch_src_componentvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/switch/src/component.vue
/* normalize component */var src_component_component=normalizeComponent(packages_switch_src_componentvue_type_script_lang_js_,componentvue_type_template_id_2dcd8fbb_render,componentvue_type_template_id_2dcd8fbb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_component_api;}src_component_component.options.__file="packages/switch/src/component.vue";/* harmony default export */var switch_src_component=src_component_component.exports;// CONCATENATED MODULE: ./packages/switch/index.js
/* istanbul ignore next */switch_src_component.install=function(Vue){Vue.component(switch_src_component.name,switch_src_component);};/* harmony default export */var packages_switch=switch_src_component;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
var selectvue_type_template_id_0e4aade6_render=function selectvue_type_template_id_0e4aade6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],staticClass:"el-select",class:[_vm.selectSize?"el-select--"+_vm.selectSize:""],on:{click:function click($event){$event.stopPropagation();return _vm.toggleMenu($event);}}},[_vm.multiple?_c("div",{ref:"tags",staticClass:"el-select__tags",style:{"max-width":_vm.inputWidth-32+"px",width:"100%"}},[_vm.collapseTags&&_vm.selected.length?_c("span",[_c("el-tag",{attrs:{closable:!_vm.selectDisabled,size:_vm.collapseTagSize,hit:_vm.selected[0].hitState,type:"info","disable-transitions":""},on:{close:function close($event){_vm.deleteTag($event,_vm.selected[0]);}}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(_vm.selected[0].currentLabel))])]),_vm.selected.length>1?_c("el-tag",{attrs:{closable:false,size:_vm.collapseTagSize,type:"info","disable-transitions":""}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v("+ "+_vm._s(_vm.selected.length-1))])]):_vm._e()],1):_vm._e(),!_vm.collapseTags?_c("transition-group",{on:{"after-leave":_vm.resetInputHeight}},_vm._l(_vm.selected,function(item){return _c("el-tag",{key:_vm.getValueKey(item),attrs:{closable:!_vm.selectDisabled,size:_vm.collapseTagSize,hit:item.hitState,type:"info","disable-transitions":""},on:{close:function close($event){_vm.deleteTag($event,item);}}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(item.currentLabel))])]);}),1):_vm._e(),_vm.filterable?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.query,expression:"query"}],ref:"input",staticClass:"el-select__input",class:[_vm.selectSize?"is-"+_vm.selectSize:""],style:{"flex-grow":"1",width:_vm.inputLength/(_vm.inputWidth-32)+"%","max-width":_vm.inputWidth-42+"px"},attrs:{type:"text",disabled:_vm.selectDisabled,autocomplete:_vm.autoComplete||_vm.autocomplete},domProps:{value:_vm.query},on:{focus:_vm.handleFocus,blur:function blur($event){_vm.softFocus=false;},keyup:_vm.managePlaceholder,keydown:[_vm.resetInputState,function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();_vm.handleNavigate("next");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();_vm.handleNavigate("prev");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.preventDefault();return _vm.selectOption($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.visible=false;},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}return _vm.deletePrevTag($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}_vm.visible=false;}],compositionstart:_vm.handleComposition,compositionupdate:_vm.handleComposition,compositionend:_vm.handleComposition,input:[function($event){if($event.target.composing){return;}_vm.query=$event.target.value;},_vm.debouncedQueryChange]}}):_vm._e()],1):_vm._e(),_c("el-input",{ref:"reference",class:{"is-focus":_vm.visible},attrs:{type:"text",placeholder:_vm.currentPlaceholder,name:_vm.name,id:_vm.id,autocomplete:_vm.autoComplete||_vm.autocomplete,size:_vm.selectSize,disabled:_vm.selectDisabled,readonly:_vm.readonly,"validate-event":false,tabindex:_vm.multiple&&_vm.filterable?"-1":null},on:{focus:_vm.handleFocus,blur:_vm.handleBlur,input:_vm.debouncedOnInputChange,compositionstart:_vm.handleComposition,compositionupdate:_vm.handleComposition,compositionend:_vm.handleComposition},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.handleNavigate("next");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.handleNavigate("prev");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.preventDefault();return _vm.selectOption($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.visible=false;},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}_vm.visible=false;}],mouseenter:function mouseenter($event){_vm.inputHovering=true;},mouseleave:function mouseleave($event){_vm.inputHovering=false;}},model:{value:_vm.selectedLabel,callback:function callback($$v){_vm.selectedLabel=$$v;},expression:"selectedLabel"}},[_vm.$slots.prefix?_c("template",{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),_c("template",{slot:"suffix"},[_c("i",{directives:[{name:"show",rawName:"v-show",value:!_vm.showClose,expression:"!showClose"}],class:["el-select__caret","el-input__icon","el-icon-"+_vm.iconClass]}),_vm.showClose?_c("i",{staticClass:"el-select__caret el-input__icon el-icon-circle-close",on:{click:_vm.handleClearClick}}):_vm._e()])],2),_c("transition",{attrs:{name:"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":_vm.doDestroy}},[_c("el-select-menu",{directives:[{name:"show",rawName:"v-show",value:_vm.visible&&_vm.emptyText!==false,expression:"visible && emptyText !== false"}],ref:"popper",attrs:{"append-to-body":_vm.popperAppendToBody}},[_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.options.length>0&&!_vm.loading,expression:"options.length > 0 && !loading"}],ref:"scrollbar",class:{"is-empty":!_vm.allowCreate&&_vm.query&&_vm.filteredOptionsCount===0},attrs:{tag:"ul","wrap-class":"el-select-dropdown__wrap","view-class":"el-select-dropdown__list"}},[_vm.showNewOption?_c("el-option",{attrs:{value:_vm.query,created:""}}):_vm._e(),_vm._t("default")],2),_vm.emptyText&&(!_vm.allowCreate||_vm.loading||_vm.allowCreate&&_vm.options.length===0)?[_vm.$slots.empty?_vm._t("empty"):_c("p",{staticClass:"el-select-dropdown__empty"},[_vm._v("\n          "+_vm._s(_vm.emptyText)+"\n        ")])]:_vm._e()],2)],1)],1);};var selectvue_type_template_id_0e4aade6_staticRenderFns=[];selectvue_type_template_id_0e4aade6_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
var select_dropdownvue_type_template_id_06828748_render=function select_dropdownvue_type_template_id_06828748_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-select-dropdown el-popper",class:[{"is-multiple":_vm.$parent.multiple},_vm.popperClass],style:{minWidth:_vm.minWidth}},[_vm._t("default")],2);};var select_dropdownvue_type_template_id_06828748_staticRenderFns=[];select_dropdownvue_type_template_id_06828748_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */var select_dropdownvue_type_script_lang_js_={name:'ElSelectDropdown',componentName:'ElSelectDropdown',mixins:[vue_popper_default.a],props:{placement:{default:'bottom-start'},boundariesPadding:{default:0},popperOptions:{default:function _default(){return{gpuAcceleration:false};}},visibleArrow:{default:true},appendToBody:{type:Boolean,default:true}},data:function data(){return{minWidth:''};},computed:{popperClass:function popperClass(){return this.$parent.popperClass;}},watch:{'$parent.inputWidth':function $parentInputWidth(){this.minWidth=this.$parent.$el.getBoundingClientRect().width+'px';}},mounted:function mounted(){var _this=this;this.referenceElm=this.$parent.$refs.reference.$el;this.$parent.popperElm=this.popperElm=this.$el;this.$on('updatePopper',function(){if(_this.$parent.visible)_this.updatePopper();});this.$on('destroyPopper',this.destroyPopper);}};// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var src_select_dropdownvue_type_script_lang_js_=select_dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
/* normalize component */var select_dropdown_component=normalizeComponent(src_select_dropdownvue_type_script_lang_js_,select_dropdownvue_type_template_id_06828748_render,select_dropdownvue_type_template_id_06828748_staticRenderFns,false,null,null,null);/* hot reload */if(false){var select_dropdown_api;}select_dropdown_component.options.__file="packages/select/src/select-dropdown.vue";/* harmony default export */var select_dropdown=select_dropdown_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var optionvue_type_template_id_7a44c642_render=function optionvue_type_template_id_7a44c642_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-select-dropdown__item",class:{selected:_vm.itemSelected,"is-disabled":_vm.disabled||_vm.groupDisabled||_vm.limitReached,hover:_vm.hover},on:{mouseenter:_vm.hoverItem,click:function click($event){$event.stopPropagation();return _vm.selectOptionClick($event);}}},[_vm._t("default",[_c("span",[_vm._v(_vm._s(_vm.currentLabel))])])],2);};var optionvue_type_template_id_7a44c642_staticRenderFns=[];optionvue_type_template_id_7a44c642_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var optionvue_type_script_lang_js_={mixins:[emitter_default.a],name:'ElOption',componentName:'ElOption',inject:['select'],props:{value:{required:true},label:[String,Number],created:Boolean,disabled:{type:Boolean,default:false}},data:function data(){return{index:-1,groupDisabled:false,visible:true,hitState:false,hover:false};},computed:{isObject:function isObject(){return Object.prototype.toString.call(this.value).toLowerCase()==='[object object]';},currentLabel:function currentLabel(){return this.label||(this.isObject?'':this.value);},currentValue:function currentValue(){return this.value||this.label||'';},itemSelected:function itemSelected(){if(!this.select.multiple){return this.isEqual(this.value,this.select.value);}else{return this.contains(this.select.value,this.value);}},limitReached:function limitReached(){if(this.select.multiple){return!this.itemSelected&&(this.select.value||[]).length>=this.select.multipleLimit&&this.select.multipleLimit>0;}else{return false;}}},watch:{currentLabel:function currentLabel(){if(!this.created&&!this.select.remote)this.dispatch('ElSelect','setSelected');},value:function value(val,oldVal){var _select=this.select,remote=_select.remote,valueKey=_select.valueKey;if(!this.created&&!remote){if(valueKey&&(typeof val==='undefined'?'undefined':_typeof(val))==='object'&&(typeof oldVal==='undefined'?'undefined':_typeof(oldVal))==='object'&&val[valueKey]===oldVal[valueKey]){return;}this.dispatch('ElSelect','setSelected');}}},methods:{isEqual:function isEqual(a,b){if(!this.isObject){return a===b;}else{var valueKey=this.select.valueKey;return Object(util_["getValueByPath"])(a,valueKey)===Object(util_["getValueByPath"])(b,valueKey);}},contains:function contains(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var target=arguments[1];if(!this.isObject){return arr&&arr.indexOf(target)>-1;}else{var valueKey=this.select.valueKey;return arr&&arr.some(function(item){return Object(util_["getValueByPath"])(item,valueKey)===Object(util_["getValueByPath"])(target,valueKey);});}},handleGroupDisabled:function handleGroupDisabled(val){this.groupDisabled=val;},hoverItem:function hoverItem(){if(!this.disabled&&!this.groupDisabled){this.select.hoverIndex=this.select.options.indexOf(this);}},selectOptionClick:function selectOptionClick(){if(this.disabled!==true&&this.groupDisabled!==true){this.dispatch('ElSelect','handleOptionClick',[this,true]);}},queryChange:function queryChange(query){this.visible=new RegExp(Object(util_["escapeRegexpString"])(query),'i').test(this.currentLabel)||this.created;if(!this.visible){this.select.filteredOptionsCount--;}}},created:function created(){this.select.options.push(this);this.select.cachedOptions.push(this);this.select.optionsCount++;this.select.filteredOptionsCount++;this.$on('queryChange',this.queryChange);this.$on('handleGroupDisabled',this.handleGroupDisabled);},beforeDestroy:function beforeDestroy(){var _select2=this.select,selected=_select2.selected,multiple=_select2.multiple;var selectedOptions=multiple?selected:[selected];var index=this.select.cachedOptions.indexOf(this);var selectedIndex=selectedOptions.indexOf(this);// if option is not selected, remove it from cache
if(index>-1&&selectedIndex<0){this.select.cachedOptions.splice(index,1);}this.select.onOptionDestroy(this.select.options.indexOf(this));}};// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
/* harmony default export */var src_optionvue_type_script_lang_js_=optionvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/option.vue
/* normalize component */var option_component=normalizeComponent(src_optionvue_type_script_lang_js_,optionvue_type_template_id_7a44c642_render,optionvue_type_template_id_7a44c642_staticRenderFns,false,null,null,null);/* hot reload */if(false){var option_api;}option_component.options.__file="packages/select/src/option.vue";/* harmony default export */var src_option=option_component.exports;// EXTERNAL MODULE: external "element-ui/lib/tag"
var tag_=__webpack_require__(30);var tag_default=/*#__PURE__*/__webpack_require__.n(tag_);// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
var resize_event_=__webpack_require__(15);// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
var scroll_into_view_=__webpack_require__(27);var scroll_into_view_default=/*#__PURE__*/__webpack_require__.n(scroll_into_view_);// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
/* harmony default export */var navigation_mixin={data:function data(){return{hoverOption:-1};},computed:{optionsAllDisabled:function optionsAllDisabled(){return this.options.filter(function(option){return option.visible;}).every(function(option){return option.disabled;});}},watch:{hoverIndex:function hoverIndex(val){var _this=this;if(typeof val==='number'&&val>-1){this.hoverOption=this.options[val]||{};}this.options.forEach(function(option){option.hover=_this.hoverOption===option;});}},methods:{navigateOptions:function navigateOptions(direction){var _this2=this;if(!this.visible){this.visible=true;return;}if(this.options.length===0||this.filteredOptionsCount===0)return;if(!this.optionsAllDisabled){if(direction==='next'){this.hoverIndex++;if(this.hoverIndex===this.options.length){this.hoverIndex=0;}}else if(direction==='prev'){this.hoverIndex--;if(this.hoverIndex<0){this.hoverIndex=this.options.length-1;}}var option=this.options[this.hoverIndex];if(option.disabled===true||option.groupDisabled===true||!option.visible){this.navigateOptions(direction);}this.$nextTick(function(){return _this2.scrollToOption(_this2.hoverOption);});}}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var selectvue_type_script_lang_js_={mixins:[emitter_default.a,locale_default.a,focus_default()('reference'),navigation_mixin],name:'ElSelect',componentName:'ElSelect',inject:{elForm:{default:''},elFormItem:{default:''}},provide:function provide(){return{'select':this};},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},readonly:function readonly(){return!this.filterable||this.multiple||!Object(util_["isIE"])()&&!Object(util_["isEdge"])()&&!this.visible;},showClose:function showClose(){var hasValue=this.multiple?Array.isArray(this.value)&&this.value.length>0:this.value!==undefined&&this.value!==null&&this.value!=='';var criteria=this.clearable&&!this.selectDisabled&&this.inputHovering&&hasValue;return criteria;},iconClass:function iconClass(){return this.remote&&this.filterable?'':this.visible?'arrow-up is-reverse':'arrow-up';},debounce:function debounce(){return this.remote?300:0;},emptyText:function emptyText(){if(this.loading){return this.loadingText||this.t('el.select.loading');}else{if(this.remote&&this.query===''&&this.options.length===0)return false;if(this.filterable&&this.query&&this.options.length>0&&this.filteredOptionsCount===0){return this.noMatchText||this.t('el.select.noMatch');}if(this.options.length===0){return this.noDataText||this.t('el.select.noData');}}return null;},showNewOption:function showNewOption(){var _this=this;var hasExistingOption=this.options.filter(function(option){return!option.created;}).some(function(option){return option.currentLabel===_this.query;});return this.filterable&&this.allowCreate&&this.query!==''&&!hasExistingOption;},selectSize:function selectSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},selectDisabled:function selectDisabled(){return this.disabled||(this.elForm||{}).disabled;},collapseTagSize:function collapseTagSize(){return['small','mini'].indexOf(this.selectSize)>-1?'mini':'small';},propPlaceholder:function propPlaceholder(){return typeof this.placeholder!=='undefined'?this.placeholder:this.t('el.select.placeholder');}},components:{ElInput:input_default.a,ElSelectMenu:select_dropdown,ElOption:src_option,ElTag:tag_default.a,ElScrollbar:scrollbar_default.a},directives:{Clickoutside:clickoutside_default.a},props:{name:String,id:String,value:{required:true},autocomplete:{type:String,default:'off'},/** @Deprecated in next major version */autoComplete:{type:String,validator:function validator(val){false&&false;return true;}},automaticDropdown:Boolean,size:String,disabled:Boolean,clearable:Boolean,filterable:Boolean,allowCreate:Boolean,loading:Boolean,popperClass:String,remote:Boolean,loadingText:String,noMatchText:String,noDataText:String,remoteMethod:Function,filterMethod:Function,multiple:Boolean,multipleLimit:{type:Number,default:0},placeholder:{type:String,required:false},defaultFirstOption:Boolean,reserveKeyword:Boolean,valueKey:{type:String,default:'value'},collapseTags:Boolean,popperAppendToBody:{type:Boolean,default:true}},data:function data(){return{options:[],cachedOptions:[],createdLabel:null,createdSelected:false,selected:this.multiple?[]:{},inputLength:20,inputWidth:0,initialInputHeight:0,cachedPlaceHolder:'',optionsCount:0,filteredOptionsCount:0,visible:false,softFocus:false,selectedLabel:'',hoverIndex:-1,query:'',previousQuery:null,inputHovering:false,currentPlaceholder:'',menuVisibleOnFocus:false,isOnComposition:false,isSilentBlur:false};},watch:{selectDisabled:function selectDisabled(){var _this2=this;this.$nextTick(function(){_this2.resetInputHeight();});},propPlaceholder:function propPlaceholder(val){this.cachedPlaceHolder=this.currentPlaceholder=val;},value:function value(val,oldVal){if(this.multiple){this.resetInputHeight();if(val&&val.length>0||this.$refs.input&&this.query!==''){this.currentPlaceholder='';}else{this.currentPlaceholder=this.cachedPlaceHolder;}if(this.filterable&&!this.reserveKeyword){this.query='';this.handleQueryChange(this.query);}}this.setSelected();if(this.filterable&&!this.multiple){this.inputLength=20;}if(!Object(util_["valueEquals"])(val,oldVal)){this.dispatch('ElFormItem','el.form.change',val);}},visible:function visible(val){var _this3=this;if(!val){this.broadcast('ElSelectDropdown','destroyPopper');if(this.$refs.input){this.$refs.input.blur();}this.query='';this.previousQuery=null;this.selectedLabel='';this.inputLength=20;this.menuVisibleOnFocus=false;this.resetHoverIndex();this.$nextTick(function(){if(_this3.$refs.input&&_this3.$refs.input.value===''&&_this3.selected.length===0){_this3.currentPlaceholder=_this3.cachedPlaceHolder;}});if(!this.multiple){if(this.selected){if(this.filterable&&this.allowCreate&&this.createdSelected&&this.createdLabel){this.selectedLabel=this.createdLabel;}else{this.selectedLabel=this.selected.currentLabel;}if(this.filterable)this.query=this.selectedLabel;}if(this.filterable){this.currentPlaceholder=this.cachedPlaceHolder;}}}else{this.broadcast('ElSelectDropdown','updatePopper');if(this.filterable){this.query=this.remote?'':this.selectedLabel;this.handleQueryChange(this.query);if(this.multiple){this.$refs.input.focus();}else{if(!this.remote){this.broadcast('ElOption','queryChange','');this.broadcast('ElOptionGroup','queryChange');}if(this.selectedLabel){this.currentPlaceholder=this.selectedLabel;this.selectedLabel='';}}}}this.$emit('visible-change',val);},options:function options(){var _this4=this;if(this.$isServer)return;this.$nextTick(function(){_this4.broadcast('ElSelectDropdown','updatePopper');});if(this.multiple){this.resetInputHeight();}var inputs=this.$el.querySelectorAll('input');if([].indexOf.call(inputs,document.activeElement)===-1){this.setSelected();}if(this.defaultFirstOption&&(this.filterable||this.remote)&&this.filteredOptionsCount){this.checkDefaultFirstOption();}}},methods:{handleNavigate:function handleNavigate(direction){if(this.isOnComposition)return;this.navigateOptions(direction);},handleComposition:function handleComposition(event){var _this5=this;var text=event.target.value;if(event.type==='compositionend'){this.isOnComposition=false;this.$nextTick(function(_){return _this5.handleQueryChange(text);});}else{var lastCharacter=text[text.length-1]||'';this.isOnComposition=!Object(shared_["isKorean"])(lastCharacter);}},handleQueryChange:function handleQueryChange(val){var _this6=this;if(this.previousQuery===val||this.isOnComposition)return;if(this.previousQuery===null&&(typeof this.filterMethod==='function'||typeof this.remoteMethod==='function')){this.previousQuery=val;return;}this.previousQuery=val;this.$nextTick(function(){if(_this6.visible)_this6.broadcast('ElSelectDropdown','updatePopper');});this.hoverIndex=-1;if(this.multiple&&this.filterable){this.$nextTick(function(){var length=_this6.$refs.input.value.length*15+20;_this6.inputLength=_this6.collapseTags?Math.min(50,length):length;_this6.managePlaceholder();_this6.resetInputHeight();});}if(this.remote&&typeof this.remoteMethod==='function'){this.hoverIndex=-1;this.remoteMethod(val);}else if(typeof this.filterMethod==='function'){this.filterMethod(val);this.broadcast('ElOptionGroup','queryChange');}else{this.filteredOptionsCount=this.optionsCount;this.broadcast('ElOption','queryChange',val);this.broadcast('ElOptionGroup','queryChange');}if(this.defaultFirstOption&&(this.filterable||this.remote)&&this.filteredOptionsCount){this.checkDefaultFirstOption();}},scrollToOption:function scrollToOption(option){var target=Array.isArray(option)&&option[0]?option[0].$el:option.$el;if(this.$refs.popper&&target){var menu=this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');scroll_into_view_default()(menu,target);}this.$refs.scrollbar&&this.$refs.scrollbar.handleScroll();},handleMenuEnter:function handleMenuEnter(){var _this7=this;this.$nextTick(function(){return _this7.scrollToOption(_this7.selected);});},emitChange:function emitChange(val){if(!Object(util_["valueEquals"])(this.value,val)){this.$emit('change',val);}},getOption:function getOption(value){var option=void 0;var isObject=Object.prototype.toString.call(value).toLowerCase()==='[object object]';var isNull=Object.prototype.toString.call(value).toLowerCase()==='[object null]';var isUndefined=Object.prototype.toString.call(value).toLowerCase()==='[object undefined]';for(var i=this.cachedOptions.length-1;i>=0;i--){var cachedOption=this.cachedOptions[i];var isEqual=isObject?Object(util_["getValueByPath"])(cachedOption.value,this.valueKey)===Object(util_["getValueByPath"])(value,this.valueKey):cachedOption.value===value;if(isEqual){option=cachedOption;break;}}if(option)return option;var label=!isObject&&!isNull&&!isUndefined?String(value):'';var newOption={value:value,currentLabel:label};if(this.multiple){newOption.hitState=false;}return newOption;},setSelected:function setSelected(){var _this8=this;if(!this.multiple){var option=this.getOption(this.value);if(option.created){this.createdLabel=option.currentLabel;this.createdSelected=true;}else{this.createdSelected=false;}this.selectedLabel=option.currentLabel;this.selected=option;if(this.filterable)this.query=this.selectedLabel;return;}var result=[];if(Array.isArray(this.value)){this.value.forEach(function(value){result.push(_this8.getOption(value));});}this.selected=result;this.$nextTick(function(){_this8.resetInputHeight();});},handleFocus:function handleFocus(event){if(!this.softFocus){if(this.automaticDropdown||this.filterable){if(this.filterable&&!this.visible){this.menuVisibleOnFocus=true;}this.visible=true;}this.$emit('focus',event);}else{this.softFocus=false;}},blur:function blur(){this.visible=false;this.$refs.reference.blur();},handleBlur:function handleBlur(event){var _this9=this;setTimeout(function(){if(_this9.isSilentBlur){_this9.isSilentBlur=false;}else{_this9.$emit('blur',event);}},50);this.softFocus=false;},handleClearClick:function handleClearClick(event){this.deleteSelected(event);},doDestroy:function doDestroy(){this.$refs.popper&&this.$refs.popper.doDestroy();},handleClose:function handleClose(){this.visible=false;},toggleLastOptionHitState:function toggleLastOptionHitState(hit){if(!Array.isArray(this.selected))return;var option=this.selected[this.selected.length-1];if(!option)return;if(hit===true||hit===false){option.hitState=hit;return hit;}option.hitState=!option.hitState;return option.hitState;},deletePrevTag:function deletePrevTag(e){if(e.target.value.length<=0&&!this.toggleLastOptionHitState()){var value=this.value.slice();value.pop();this.$emit('input',value);this.emitChange(value);}},managePlaceholder:function managePlaceholder(){if(this.currentPlaceholder!==''){this.currentPlaceholder=this.$refs.input.value?'':this.cachedPlaceHolder;}},resetInputState:function resetInputState(e){if(e.keyCode!==8)this.toggleLastOptionHitState(false);this.inputLength=this.$refs.input.value.length*15+20;this.resetInputHeight();},resetInputHeight:function resetInputHeight(){var _this10=this;if(this.collapseTags&&!this.filterable)return;this.$nextTick(function(){if(!_this10.$refs.reference)return;var inputChildNodes=_this10.$refs.reference.$el.childNodes;var input=[].filter.call(inputChildNodes,function(item){return item.tagName==='INPUT';})[0];var tags=_this10.$refs.tags;var tagsHeight=tags?Math.round(tags.getBoundingClientRect().height):0;var sizeInMap=_this10.initialInputHeight||40;input.style.height=_this10.selected.length===0?sizeInMap+'px':Math.max(tags?tagsHeight+(tagsHeight>sizeInMap?6:0):0,sizeInMap)+'px';if(_this10.visible&&_this10.emptyText!==false){_this10.broadcast('ElSelectDropdown','updatePopper');}});},resetHoverIndex:function resetHoverIndex(){var _this11=this;setTimeout(function(){if(!_this11.multiple){_this11.hoverIndex=_this11.options.indexOf(_this11.selected);}else{if(_this11.selected.length>0){_this11.hoverIndex=Math.min.apply(null,_this11.selected.map(function(item){return _this11.options.indexOf(item);}));}else{_this11.hoverIndex=-1;}}},300);},handleOptionSelect:function handleOptionSelect(option,byClick){var _this12=this;if(this.multiple){var value=(this.value||[]).slice();var optionIndex=this.getValueIndex(value,option.value);if(optionIndex>-1){value.splice(optionIndex,1);}else if(this.multipleLimit<=0||value.length<this.multipleLimit){value.push(option.value);}this.$emit('input',value);this.emitChange(value);if(option.created){this.query='';this.handleQueryChange('');this.inputLength=20;}if(this.filterable)this.$refs.input.focus();}else{this.$emit('input',option.value);this.emitChange(option.value);this.visible=false;}this.isSilentBlur=byClick;this.setSoftFocus();if(this.visible)return;this.$nextTick(function(){_this12.scrollToOption(option);});},setSoftFocus:function setSoftFocus(){this.softFocus=true;var input=this.$refs.input||this.$refs.reference;if(input){input.focus();}},getValueIndex:function getValueIndex(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var value=arguments[1];var isObject=Object.prototype.toString.call(value).toLowerCase()==='[object object]';if(!isObject){return arr.indexOf(value);}else{var valueKey=this.valueKey;var index=-1;arr.some(function(item,i){if(Object(util_["getValueByPath"])(item,valueKey)===Object(util_["getValueByPath"])(value,valueKey)){index=i;return true;}return false;});return index;}},toggleMenu:function toggleMenu(){if(!this.selectDisabled){if(this.menuVisibleOnFocus){this.menuVisibleOnFocus=false;}else{this.visible=!this.visible;}if(this.visible){(this.$refs.input||this.$refs.reference).focus();}}},selectOption:function selectOption(){if(!this.visible){this.toggleMenu();}else{if(this.options[this.hoverIndex]){this.handleOptionSelect(this.options[this.hoverIndex]);}}},deleteSelected:function deleteSelected(event){event.stopPropagation();var value=this.multiple?[]:'';this.$emit('input',value);this.emitChange(value);this.visible=false;this.$emit('clear');},deleteTag:function deleteTag(event,tag){var index=this.selected.indexOf(tag);if(index>-1&&!this.selectDisabled){var value=this.value.slice();value.splice(index,1);this.$emit('input',value);this.emitChange(value);this.$emit('remove-tag',tag.value);}event.stopPropagation();},onInputChange:function onInputChange(){if(this.filterable&&this.query!==this.selectedLabel){this.query=this.selectedLabel;this.handleQueryChange(this.query);}},onOptionDestroy:function onOptionDestroy(index){if(index>-1){this.optionsCount--;this.filteredOptionsCount--;this.options.splice(index,1);}},resetInputWidth:function resetInputWidth(){this.inputWidth=this.$refs.reference.$el.getBoundingClientRect().width;},handleResize:function handleResize(){this.resetInputWidth();if(this.multiple)this.resetInputHeight();},checkDefaultFirstOption:function checkDefaultFirstOption(){this.hoverIndex=-1;// highlight the created option
var hasCreated=false;for(var i=this.options.length-1;i>=0;i--){if(this.options[i].created){hasCreated=true;this.hoverIndex=i;break;}}if(hasCreated)return;for(var _i=0;_i!==this.options.length;++_i){var option=this.options[_i];if(this.query){// highlight first options that passes the filter
if(!option.disabled&&!option.groupDisabled&&option.visible){this.hoverIndex=_i;break;}}else{// highlight currently selected option
if(option.itemSelected){this.hoverIndex=_i;break;}}}},getValueKey:function getValueKey(item){if(Object.prototype.toString.call(item.value).toLowerCase()!=='[object object]'){return item.value;}else{return Object(util_["getValueByPath"])(item.value,this.valueKey);}}},created:function created(){var _this13=this;this.cachedPlaceHolder=this.currentPlaceholder=this.propPlaceholder;if(this.multiple&&!Array.isArray(this.value)){this.$emit('input',[]);}if(!this.multiple&&Array.isArray(this.value)){this.$emit('input','');}this.debouncedOnInputChange=debounce_default()(this.debounce,function(){_this13.onInputChange();});this.debouncedQueryChange=debounce_default()(this.debounce,function(e){_this13.handleQueryChange(e.target.value);});this.$on('handleOptionClick',this.handleOptionSelect);this.$on('setSelected',this.setSelected);},mounted:function mounted(){var _this14=this;if(this.multiple&&Array.isArray(this.value)&&this.value.length>0){this.currentPlaceholder='';}Object(resize_event_["addResizeListener"])(this.$el,this.handleResize);var reference=this.$refs.reference;if(reference&&reference.$el){var sizeMap={medium:36,small:32,mini:28};var input=reference.$el.querySelector('input');this.initialInputHeight=input.getBoundingClientRect().height||sizeMap[this.selectSize];}if(this.remote&&this.multiple){this.resetInputHeight();}this.$nextTick(function(){if(reference&&reference.$el){_this14.inputWidth=reference.$el.getBoundingClientRect().width;}});this.setSelected();},beforeDestroy:function beforeDestroy(){if(this.$el&&this.handleResize)Object(resize_event_["removeResizeListener"])(this.$el,this.handleResize);}};// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
/* harmony default export */var src_selectvue_type_script_lang_js_=selectvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/select.vue
/* normalize component */var select_component=normalizeComponent(src_selectvue_type_script_lang_js_,selectvue_type_template_id_0e4aade6_render,selectvue_type_template_id_0e4aade6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var select_api;}select_component.options.__file="packages/select/src/select.vue";/* harmony default export */var src_select=select_component.exports;// CONCATENATED MODULE: ./packages/select/index.js
/* istanbul ignore next */src_select.install=function(Vue){Vue.component(src_select.name,src_select);};/* harmony default export */var packages_select=src_select;// CONCATENATED MODULE: ./packages/option/index.js
/* istanbul ignore next */src_option.install=function(Vue){Vue.component(src_option.name,src_option);};/* harmony default export */var packages_option=src_option;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
var option_groupvue_type_template_id_6685e5de_render=function option_groupvue_type_template_id_6685e5de_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("ul",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-select-group__wrap"},[_c("li",{staticClass:"el-select-group__title"},[_vm._v(_vm._s(_vm.label))]),_c("li",[_c("ul",{staticClass:"el-select-group"},[_vm._t("default")],2)])]);};var option_groupvue_type_template_id_6685e5de_staticRenderFns=[];option_groupvue_type_template_id_6685e5de_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var option_groupvue_type_script_lang_js_={mixins:[emitter_default.a],name:'ElOptionGroup',componentName:'ElOptionGroup',props:{label:String,disabled:{type:Boolean,default:false}},data:function data(){return{visible:true};},watch:{disabled:function disabled(val){this.broadcast('ElOption','handleGroupDisabled',val);}},methods:{queryChange:function queryChange(){this.visible=this.$children&&Array.isArray(this.$children)&&this.$children.some(function(option){return option.visible===true;});}},created:function created(){this.$on('queryChange',this.queryChange);},mounted:function mounted(){if(this.disabled){this.broadcast('ElOption','handleGroupDisabled',this.disabled);}}};// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_option_groupvue_type_script_lang_js_=option_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/option-group.vue
/* normalize component */var option_group_component=normalizeComponent(src_option_groupvue_type_script_lang_js_,option_groupvue_type_template_id_6685e5de_render,option_groupvue_type_template_id_6685e5de_staticRenderFns,false,null,null,null);/* hot reload */if(false){var option_group_api;}option_group_component.options.__file="packages/select/src/option-group.vue";/* harmony default export */var option_group=option_group_component.exports;// CONCATENATED MODULE: ./packages/option-group/index.js
/* istanbul ignore next */option_group.install=function(Vue){Vue.component(option_group.name,option_group);};/* harmony default export */var packages_option_group=option_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var buttonvue_type_template_id_ca859fb4_render=function buttonvue_type_template_id_ca859fb4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("button",{staticClass:"el-button",class:[_vm.type?"el-button--"+_vm.type:"",_vm.buttonSize?"el-button--"+_vm.buttonSize:"",{"is-disabled":_vm.buttonDisabled,"is-loading":_vm.loading,"is-plain":_vm.plain,"is-round":_vm.round,"is-circle":_vm.circle}],attrs:{disabled:_vm.buttonDisabled||_vm.loading,autofocus:_vm.autofocus,type:_vm.nativeType},on:{click:_vm.handleClick}},[_vm.loading?_c("i",{staticClass:"el-icon-loading"}):_vm._e(),_vm.icon&&!_vm.loading?_c("i",{class:_vm.icon}):_vm._e(),_vm.$slots.default?_c("span",[_vm._t("default")],2):_vm._e()]);};var buttonvue_type_template_id_ca859fb4_staticRenderFns=[];buttonvue_type_template_id_ca859fb4_render._withStripped=true;// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var buttonvue_type_script_lang_js_={name:'ElButton',inject:{elForm:{default:''},elFormItem:{default:''}},props:{type:{type:String,default:'default'},size:String,icon:{type:String,default:''},nativeType:{type:String,default:'button'},loading:Boolean,disabled:Boolean,plain:Boolean,autofocus:Boolean,round:Boolean,circle:Boolean},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},buttonSize:function buttonSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},buttonDisabled:function buttonDisabled(){return this.$options.propsData.hasOwnProperty('disabled')?this.disabled:(this.elForm||{}).disabled;}},methods:{handleClick:function handleClick(evt){this.$emit('click',evt);}}};// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
/* harmony default export */var src_buttonvue_type_script_lang_js_=buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/button/src/button.vue
/* normalize component */var button_component=normalizeComponent(src_buttonvue_type_script_lang_js_,buttonvue_type_template_id_ca859fb4_render,buttonvue_type_template_id_ca859fb4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var button_api;}button_component.options.__file="packages/button/src/button.vue";/* harmony default export */var src_button=button_component.exports;// CONCATENATED MODULE: ./packages/button/index.js
/* istanbul ignore next */src_button.install=function(Vue){Vue.component(src_button.name,src_button);};/* harmony default export */var packages_button=src_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
var button_groupvue_type_template_id_3d8661d0_render=function button_groupvue_type_template_id_3d8661d0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-button-group"},[_vm._t("default")],2);};var button_groupvue_type_template_id_3d8661d0_staticRenderFns=[];button_groupvue_type_template_id_3d8661d0_render._withStripped=true;// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var button_groupvue_type_script_lang_js_={name:'ElButtonGroup'};// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_button_groupvue_type_script_lang_js_=button_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/button/src/button-group.vue
/* normalize component */var button_group_component=normalizeComponent(src_button_groupvue_type_script_lang_js_,button_groupvue_type_template_id_3d8661d0_render,button_groupvue_type_template_id_3d8661d0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var button_group_api;}button_group_component.options.__file="packages/button/src/button-group.vue";/* harmony default export */var button_group=button_group_component.exports;// CONCATENATED MODULE: ./packages/button-group/index.js
/* istanbul ignore next */button_group.install=function(Vue){Vue.component(button_group.name,button_group);};/* harmony default export */var packages_button_group=button_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
var tablevue_type_template_id_493fe34e_render=function tablevue_type_template_id_493fe34e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-table",class:[{"el-table--fit":_vm.fit,"el-table--striped":_vm.stripe,"el-table--border":_vm.border||_vm.isGroup,"el-table--hidden":_vm.isHidden,"el-table--group":_vm.isGroup,"el-table--fluid-height":_vm.maxHeight,"el-table--scrollable-x":_vm.layout.scrollX,"el-table--scrollable-y":_vm.layout.scrollY,"el-table--enable-row-hover":!_vm.store.states.isComplex,"el-table--enable-row-transition":(_vm.store.states.data||[]).length!==0&&(_vm.store.states.data||[]).length<100},_vm.tableSize?"el-table--"+_vm.tableSize:""],on:{mouseleave:function mouseleave($event){_vm.handleMouseLeave($event);}}},[_c("div",{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),_vm.showHeader?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleHeaderFooterMousewheel,expression:"handleHeaderFooterMousewheel"}],ref:"headerWrapper",staticClass:"el-table__header-wrapper"},[_c("table-header",{ref:"tableHeader",style:{width:_vm.layout.bodyWidth?_vm.layout.bodyWidth+"px":""},attrs:{store:_vm.store,border:_vm.border,"default-sort":_vm.defaultSort}})],1):_vm._e(),_c("div",{ref:"bodyWrapper",staticClass:"el-table__body-wrapper",class:[_vm.layout.scrollX?"is-scrolling-"+_vm.scrollPosition:"is-scrolling-none"],style:[_vm.bodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{context:_vm.context,store:_vm.store,stripe:_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,highlight:_vm.highlightCurrentRow}}),!_vm.data||_vm.data.length===0?_c("div",{ref:"emptyBlock",staticClass:"el-table__empty-block",style:_vm.emptyBlockStyle},[_c("span",{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(_vm._s(_vm.emptyText||_vm.t("el.table.emptyText")))])],2)]):_vm._e(),_vm.$slots.append?_c("div",{ref:"appendWrapper",staticClass:"el-table__append-wrapper"},[_vm._t("append")],2):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"},{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleHeaderFooterMousewheel,expression:"handleHeaderFooterMousewheel"}],ref:"footerWrapper",staticClass:"el-table__footer-wrapper"},[_c("table-footer",{style:{width:_vm.layout.bodyWidth?_vm.layout.bodyWidth+"px":""},attrs:{store:_vm.store,border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,"default-sort":_vm.defaultSort}})],1):_vm._e(),_vm.fixedColumns.length>0?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleFixedMousewheel,expression:"handleFixedMousewheel"}],ref:"fixedWrapper",staticClass:"el-table__fixed",style:[{width:_vm.layout.fixedWidth?_vm.layout.fixedWidth+"px":""},_vm.fixedHeight]},[_vm.showHeader?_c("div",{ref:"fixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c("table-header",{ref:"fixedTableHeader",style:{width:_vm.bodyWidth},attrs:{fixed:"left",border:_vm.border,store:_vm.store}})],1):_vm._e(),_c("div",{ref:"fixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:[{top:_vm.layout.headerHeight+"px"},_vm.fixedBodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{fixed:"left",store:_vm.store,stripe:_vm.stripe,highlight:_vm.highlightCurrentRow,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle}}),_vm.$slots.append?_c("div",{staticClass:"el-table__append-gutter",style:{height:_vm.layout.appendHeight+"px"}}):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"}],ref:"fixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c("table-footer",{style:{width:_vm.bodyWidth},attrs:{fixed:"left",border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,store:_vm.store}})],1):_vm._e()]):_vm._e(),_vm.rightFixedColumns.length>0?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleFixedMousewheel,expression:"handleFixedMousewheel"}],ref:"rightFixedWrapper",staticClass:"el-table__fixed-right",style:[{width:_vm.layout.rightFixedWidth?_vm.layout.rightFixedWidth+"px":"",right:_vm.layout.scrollY?(_vm.border?_vm.layout.gutterWidth:_vm.layout.gutterWidth||0)+"px":""},_vm.fixedHeight]},[_vm.showHeader?_c("div",{ref:"rightFixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c("table-header",{ref:"rightFixedTableHeader",style:{width:_vm.bodyWidth},attrs:{fixed:"right",border:_vm.border,store:_vm.store}})],1):_vm._e(),_c("div",{ref:"rightFixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:[{top:_vm.layout.headerHeight+"px"},_vm.fixedBodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{fixed:"right",store:_vm.store,stripe:_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,highlight:_vm.highlightCurrentRow}}),_vm.$slots.append?_c("div",{staticClass:"el-table__append-gutter",style:{height:_vm.layout.appendHeight+"px"}}):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"}],ref:"rightFixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c("table-footer",{style:{width:_vm.bodyWidth},attrs:{fixed:"right",border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,store:_vm.store}})],1):_vm._e()]):_vm._e(),_vm.rightFixedColumns.length>0?_c("div",{ref:"rightFixedPatch",staticClass:"el-table__fixed-right-patch",style:{width:_vm.layout.scrollY?_vm.layout.gutterWidth+"px":"0",height:_vm.layout.headerHeight+"px"}}):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.resizeProxyVisible,expression:"resizeProxyVisible"}],ref:"resizeProxy",staticClass:"el-table__column-resize-proxy"})]);};var tablevue_type_template_id_493fe34e_staticRenderFns=[];tablevue_type_template_id_493fe34e_render._withStripped=true;// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
// EXTERNAL MODULE: external "element-ui/lib/checkbox"
var checkbox_=__webpack_require__(14);var checkbox_default=/*#__PURE__*/__webpack_require__.n(checkbox_);// EXTERNAL MODULE: external "throttle-debounce"
var external_throttle_debounce_=__webpack_require__(36);// EXTERNAL MODULE: external "normalize-wheel"
var external_normalize_wheel_=__webpack_require__(39);var external_normalize_wheel_default=/*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);// CONCATENATED MODULE: ./src/directives/mousewheel.js
var isFirefox=typeof navigator!=='undefined'&&navigator.userAgent.toLowerCase().indexOf('firefox')>-1;var mousewheel_mousewheel=function mousewheel(element,callback){if(element&&element.addEventListener){element.addEventListener(isFirefox?'DOMMouseScroll':'mousewheel',function(event){var normalized=external_normalize_wheel_default()(event);callback&&callback.apply(this,[event,normalized]);});}};/* harmony default export */var directives_mousewheel={bind:function bind(el,binding){mousewheel_mousewheel(el,binding.value);}};// EXTERNAL MODULE: external "vue"
var external_vue_=__webpack_require__(6);var external_vue_default=/*#__PURE__*/__webpack_require__.n(external_vue_);// CONCATENATED MODULE: ./packages/table/src/util.js
var util_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var getCell=function getCell(event){var cell=event.target;while(cell&&cell.tagName.toUpperCase()!=='HTML'){if(cell.tagName.toUpperCase()==='TD'){return cell;}cell=cell.parentNode;}return null;};var util_isObject=function isObject(obj){return obj!==null&&(typeof obj==='undefined'?'undefined':util_typeof(obj))==='object';};var util_orderBy=function orderBy(array,sortKey,reverse,sortMethod,sortBy){if(!sortKey&&!sortMethod&&(!sortBy||Array.isArray(sortBy)&&!sortBy.length)){return array;}if(typeof reverse==='string'){reverse=reverse==='descending'?-1:1;}else{reverse=reverse&&reverse<0?-1:1;}var getKey=sortMethod?null:function(value,index){if(sortBy){if(!Array.isArray(sortBy)){sortBy=[sortBy];}return sortBy.map(function(by){if(typeof by==='string'){return Object(util_["getValueByPath"])(value,by);}else{return by(value,index,array);}});}if(sortKey!=='$key'){if(util_isObject(value)&&'$value'in value)value=value.$value;}return[util_isObject(value)?Object(util_["getValueByPath"])(value,sortKey):value];};var compare=function compare(a,b){if(sortMethod){return sortMethod(a.value,b.value);}for(var i=0,len=a.key.length;i<len;i++){if(a.key[i]<b.key[i]){return-1;}if(a.key[i]>b.key[i]){return 1;}}return 0;};return array.map(function(value,index){return{value:value,index:index,key:getKey?getKey(value,index):null};}).sort(function(a,b){var order=compare(a,b);if(!order){// make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
order=a.index-b.index;}return order*reverse;}).map(function(item){return item.value;});};var getColumnById=function getColumnById(table,columnId){var column=null;table.columns.forEach(function(item){if(item.id===columnId){column=item;}});return column;};var getColumnByKey=function getColumnByKey(table,columnKey){var column=null;for(var i=0;i<table.columns.length;i++){var item=table.columns[i];if(item.columnKey===columnKey){column=item;break;}}return column;};var getColumnByCell=function getColumnByCell(table,cell){var matches=(cell.className||'').match(/el-table_[^\s]+/gm);if(matches){return getColumnById(table,matches[0]);}return null;};var getRowIdentity=function getRowIdentity(row,rowKey){if(!row)throw new Error('row is required when get row identity');if(typeof rowKey==='string'){if(rowKey.indexOf('.')<0){return row[rowKey];}var key=rowKey.split('.');var current=row;for(var i=0;i<key.length;i++){current=current[key[i]];}return current;}else if(typeof rowKey==='function'){return rowKey.call(null,row);}};var getKeysMap=function getKeysMap(array,rowKey){var arrayMap={};(array||[]).forEach(function(row,index){arrayMap[getRowIdentity(row,rowKey)]={row:row,index:index};});return arrayMap;};function hasOwn(obj,key){return Object.prototype.hasOwnProperty.call(obj,key);}function mergeOptions(defaults,config){var options={};var key=void 0;for(key in defaults){options[key]=defaults[key];}for(key in config){if(hasOwn(config,key)){var value=config[key];if(typeof value!=='undefined'){options[key]=value;}}}return options;}function parseWidth(width){if(width!==undefined){width=parseInt(width,10);if(isNaN(width)){width=null;}}return width;}function parseMinWidth(minWidth){if(typeof minWidth!=='undefined'){minWidth=parseWidth(minWidth);if(isNaN(minWidth)){minWidth=80;}}return minWidth;};function parseHeight(height){if(typeof height==='number'){return height;}if(typeof height==='string'){if(/^\d+(?:px)?$/.test(height)){return parseInt(height,10);}else{return height;}}return null;}// https://github.com/reduxjs/redux/blob/master/src/compose.js
function compose(){for(var _len=arguments.length,funcs=Array(_len),_key=0;_key<_len;_key++){funcs[_key]=arguments[_key];}if(funcs.length===0){return function(arg){return arg;};}if(funcs.length===1){return funcs[0];}return funcs.reduce(function(a,b){return function(){return a(b.apply(undefined,arguments));};});}function toggleRowStatus(statusArr,row,newVal){var changed=false;var index=statusArr.indexOf(row);var included=index!==-1;var addRow=function addRow(){statusArr.push(row);changed=true;};var removeRow=function removeRow(){statusArr.splice(index,1);changed=true;};if(typeof newVal==='boolean'){if(newVal&&!included){addRow();}else if(!newVal&&included){removeRow();}}else{if(included){removeRow();}else{addRow();}}return changed;}function walkTreeNode(root,cb){var childrenKey=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'children';var lazyKey=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'hasChildren';var isNil=function isNil(array){return!(Array.isArray(array)&&array.length);};function _walker(parent,children,level){cb(parent,children,level);children.forEach(function(item){if(item[lazyKey]){cb(item,null,level+1);return;}var children=item[childrenKey];if(!isNil(children)){_walker(item,children,level+1);}});}root.forEach(function(item){if(item[lazyKey]){cb(item,null,0);return;}var children=item[childrenKey];if(!isNil(children)){_walker(item,children,0);}});}var objectEquals=function objectEquals(objectA,objectB){// 取对象a和b的属性名
var aProps=Object.getOwnPropertyNames(objectA);var bProps=Object.getOwnPropertyNames(objectB);// 判断属性名的length是否一致
if(aProps.length!==bProps.length){return false;}// 循环取出属性名，再判断属性值是否一致
for(var i=0;i<aProps.length;i++){var propName=aProps[i];if(objectA[propName]!==objectB[propName]){return false;}}return true;};// CONCATENATED MODULE: ./packages/table/src/store/expand.js
/* harmony default export */var expand={data:function data(){return{states:{defaultExpandAll:false,expandRows:[]}};},methods:{updateExpandRows:function updateExpandRows(){var _states=this.states,_states$data=_states.data,data=_states$data===undefined?[]:_states$data,rowKey=_states.rowKey,defaultExpandAll=_states.defaultExpandAll,expandRows=_states.expandRows;if(defaultExpandAll){this.states.expandRows=data.slice();}else if(rowKey){// TODO：这里的代码可以优化
var expandRowsMap=getKeysMap(expandRows,rowKey);this.states.expandRows=data.reduce(function(prev,row){var rowId=getRowIdentity(row,rowKey);var rowInfo=expandRowsMap[rowId];if(rowInfo){prev.push(row);}return prev;},[]);}else{this.states.expandRows=[];}},toggleRowExpansion:function toggleRowExpansion(row,expanded){var changed=toggleRowStatus(this.states.expandRows,row,expanded);if(changed){this.table.$emit('expand-change',row,this.states.expandRows.slice());this.scheduleLayout();}},setExpandRowKeys:function setExpandRowKeys(rowKeys){this.assertRowKey();// TODO：这里的代码可以优化
var _states2=this.states,data=_states2.data,rowKey=_states2.rowKey;var keysMap=getKeysMap(data,rowKey);this.states.expandRows=rowKeys.reduce(function(prev,cur){var info=keysMap[cur];if(info){prev.push(info.row);}return prev;},[]);},isRowExpanded:function isRowExpanded(row){var _states3=this.states,_states3$expandRows=_states3.expandRows,expandRows=_states3$expandRows===undefined?[]:_states3$expandRows,rowKey=_states3.rowKey;if(rowKey){var expandMap=getKeysMap(expandRows,rowKey);return!!expandMap[getRowIdentity(row,rowKey)];}return expandRows.indexOf(row)!==-1;}}};// CONCATENATED MODULE: ./packages/table/src/store/current.js
/* harmony default export */var store_current={data:function data(){return{states:{// 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
// 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
_currentRowKey:null,currentRow:null}};},methods:{setCurrentRowKey:function setCurrentRowKey(key){this.assertRowKey();this.states._currentRowKey=key;this.setCurrentRowByKey(key);},restoreCurrentRowKey:function restoreCurrentRowKey(){this.states._currentRowKey=null;},setCurrentRowByKey:function setCurrentRowByKey(key){var states=this.states;var _states$data=states.data,data=_states$data===undefined?[]:_states$data,rowKey=states.rowKey;var currentRow=null;if(rowKey){currentRow=Object(util_["arrayFind"])(data,function(item){return getRowIdentity(item,rowKey)===key;});}states.currentRow=currentRow;},updateCurrentRow:function updateCurrentRow(currentRow){var states=this.states,table=this.table;var oldCurrentRow=states.currentRow;if(currentRow&&currentRow!==oldCurrentRow){states.currentRow=currentRow;table.$emit('current-change',currentRow,oldCurrentRow);return;}if(!currentRow&&oldCurrentRow){states.currentRow=null;table.$emit('current-change',null,oldCurrentRow);}},updateCurrentRowData:function updateCurrentRowData(){var states=this.states,table=this.table;var rowKey=states.rowKey,_currentRowKey=states._currentRowKey;// data 为 null 时，解构时的默认值会被忽略
var data=states.data||[];var oldCurrentRow=states.currentRow;// 当 currentRow 不在 data 中时尝试更新数据
if(data.indexOf(oldCurrentRow)===-1&&oldCurrentRow){if(rowKey){var currentRowKey=getRowIdentity(oldCurrentRow,rowKey);this.setCurrentRowByKey(currentRowKey);}else{states.currentRow=null;}if(states.currentRow===null){table.$emit('current-change',null,oldCurrentRow);}}else if(_currentRowKey){// 把初始时下设置的 rowKey 转化成 rowData
this.setCurrentRowByKey(_currentRowKey);this.restoreCurrentRowKey();}}}};// CONCATENATED MODULE: ./packages/table/src/store/tree.js
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var tree={data:function data(){return{states:{// defaultExpandAll 存在于 expand.js 中，这里不重复添加
// 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
// TODO: 拆分为独立的 TreeTable，统一用法
expandRowKeys:[],treeData:{},indent:16,lazy:false,lazyTreeNodeMap:{},lazyColumnIdentifier:'hasChildren',childrenColumnName:'children'}};},computed:{// 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
// TODO: 使用 computed 解决该问题，是否会造成性能问题？
// @return { id: { level, children } }
normalizedData:function normalizedData(){if(!this.states.rowKey)return{};var data=this.states.data||[];return this.normalize(data);},// @return { id: { children } }
// 针对懒加载的情形，不处理嵌套数据
normalizedLazyNode:function normalizedLazyNode(){var _states=this.states,rowKey=_states.rowKey,lazyTreeNodeMap=_states.lazyTreeNodeMap,lazyColumnIdentifier=_states.lazyColumnIdentifier;var keys=Object.keys(lazyTreeNodeMap);var res={};if(!keys.length)return res;keys.forEach(function(key){if(lazyTreeNodeMap[key].length){var item={children:[]};lazyTreeNodeMap[key].forEach(function(row){var currentRowKey=getRowIdentity(row,rowKey);item.children.push(currentRowKey);if(row[lazyColumnIdentifier]&&!res[currentRowKey]){res[currentRowKey]={children:[]};}});res[key]=item;}});return res;}},watch:{normalizedData:'updateTreeData',normalizedLazyNode:'updateTreeData'},methods:{normalize:function normalize(data){var _states2=this.states,childrenColumnName=_states2.childrenColumnName,lazyColumnIdentifier=_states2.lazyColumnIdentifier,rowKey=_states2.rowKey,lazy=_states2.lazy;var res={};walkTreeNode(data,function(parent,children,level){var parentId=getRowIdentity(parent,rowKey);if(Array.isArray(children)){res[parentId]={children:children.map(function(row){return getRowIdentity(row,rowKey);}),level:level};}else if(lazy){// 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
res[parentId]={children:[],lazy:true,level:level};}},childrenColumnName,lazyColumnIdentifier);return res;},updateTreeData:function updateTreeData(){var nested=this.normalizedData;var normalizedLazyNode=this.normalizedLazyNode;var keys=Object.keys(nested);var newTreeData={};if(keys.length){var _states3=this.states,oldTreeData=_states3.treeData,defaultExpandAll=_states3.defaultExpandAll,expandRowKeys=_states3.expandRowKeys,lazy=_states3.lazy;var rootLazyRowKeys=[];var getExpanded=function getExpanded(oldValue,key){var included=defaultExpandAll||expandRowKeys&&expandRowKeys.indexOf(key)!==-1;return!!(oldValue&&oldValue.expanded||included);};// 合并 expanded 与 display，确保数据刷新后，状态不变
keys.forEach(function(key){var oldValue=oldTreeData[key];var newValue=_extends({},nested[key]);newValue.expanded=getExpanded(oldValue,key);if(newValue.lazy){var _ref=oldValue||{},_ref$loaded=_ref.loaded,loaded=_ref$loaded===undefined?false:_ref$loaded,_ref$loading=_ref.loading,loading=_ref$loading===undefined?false:_ref$loading;newValue.loaded=!!loaded;newValue.loading=!!loading;rootLazyRowKeys.push(key);}newTreeData[key]=newValue;});// 根据懒加载数据更新 treeData
var lazyKeys=Object.keys(normalizedLazyNode);if(lazy&&lazyKeys.length&&rootLazyRowKeys.length){lazyKeys.forEach(function(key){var oldValue=oldTreeData[key];var lazyNodeChildren=normalizedLazyNode[key].children;if(rootLazyRowKeys.indexOf(key)!==-1){// 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
if(newTreeData[key].children.length!==0){throw new Error('[ElTable]children must be an empty array.');}newTreeData[key].children=lazyNodeChildren;}else{var _ref2=oldValue||{},_ref2$loaded=_ref2.loaded,loaded=_ref2$loaded===undefined?false:_ref2$loaded,_ref2$loading=_ref2.loading,loading=_ref2$loading===undefined?false:_ref2$loading;newTreeData[key]={lazy:true,loaded:!!loaded,loading:!!loading,expanded:getExpanded(oldValue,key),children:lazyNodeChildren,level:''};}});}}this.states.treeData=newTreeData;this.updateTableScrollY();},updateTreeExpandKeys:function updateTreeExpandKeys(value){this.states.expandRowKeys=value;this.updateTreeData();},toggleTreeExpansion:function toggleTreeExpansion(row,expanded){this.assertRowKey();var _states4=this.states,rowKey=_states4.rowKey,treeData=_states4.treeData;var id=getRowIdentity(row,rowKey);var data=id&&treeData[id];if(id&&data&&'expanded'in data){var oldExpanded=data.expanded;expanded=typeof expanded==='undefined'?!data.expanded:expanded;treeData[id].expanded=expanded;if(oldExpanded!==expanded){this.table.$emit('expand-change',row,expanded);}this.updateTableScrollY();}},loadOrToggle:function loadOrToggle(row){this.assertRowKey();var _states5=this.states,lazy=_states5.lazy,treeData=_states5.treeData,rowKey=_states5.rowKey;var id=getRowIdentity(row,rowKey);var data=treeData[id];if(lazy&&data&&'loaded'in data&&!data.loaded){this.loadData(row,id,data);}else{this.toggleTreeExpansion(row);}},loadData:function loadData(row,key,treeNode){var _this=this;var load=this.table.load;var rawTreeData=this.states.treeData;if(load&&!rawTreeData[key].loaded){rawTreeData[key].loading=true;load(row,treeNode,function(data){if(!Array.isArray(data)){throw new Error('[ElTable] data must be an array');}var _states6=_this.states,lazyTreeNodeMap=_states6.lazyTreeNodeMap,treeData=_states6.treeData;treeData[key].loading=false;treeData[key].loaded=true;treeData[key].expanded=true;if(data.length){_this.$set(lazyTreeNodeMap,key,data);}_this.table.$emit('expand-change',row,true);});}}}};// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
var watcher_sortData=function sortData(data,states){var sortingColumn=states.sortingColumn;if(!sortingColumn||typeof sortingColumn.sortable==='string'){return data;}return util_orderBy(data,states.sortProp,states.sortOrder,sortingColumn.sortMethod,sortingColumn.sortBy);};var doFlattenColumns=function doFlattenColumns(columns){var result=[];columns.forEach(function(column){if(column.children){result.push.apply(result,doFlattenColumns(column.children));}else{result.push(column);}});return result;};/* harmony default export */var watcher=external_vue_default.a.extend({data:function data(){return{states:{// 3.0 版本后要求必须设置该属性
rowKey:null,// 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
data:[],// 是否包含固定列
isComplex:false,// 列
_columns:[],// 不可响应的
originColumns:[],columns:[],fixedColumns:[],rightFixedColumns:[],leafColumns:[],fixedLeafColumns:[],rightFixedLeafColumns:[],leafColumnsLength:0,fixedLeafColumnsLength:0,rightFixedLeafColumnsLength:0,// 选择
isAllSelected:false,selection:[],reserveSelection:false,selectOnIndeterminate:false,selectable:null,// 过滤
filters:{},// 不可响应的
filteredData:null,// 排序
sortingColumn:null,sortProp:null,sortOrder:null,hoverRow:null}};},mixins:[expand,store_current,tree],methods:{// 检查 rowKey 是否存在
assertRowKey:function assertRowKey(){var rowKey=this.states.rowKey;if(!rowKey)throw new Error('[ElTable] prop row-key is required');},// 更新列
updateColumns:function updateColumns(){var states=this.states;var _columns=states._columns||[];states.fixedColumns=_columns.filter(function(column){return column.fixed===true||column.fixed==='left';});states.rightFixedColumns=_columns.filter(function(column){return column.fixed==='right';});if(states.fixedColumns.length>0&&_columns[0]&&_columns[0].type==='selection'&&!_columns[0].fixed){_columns[0].fixed=true;states.fixedColumns.unshift(_columns[0]);}var notFixedColumns=_columns.filter(function(column){return!column.fixed;});states.originColumns=[].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);var leafColumns=doFlattenColumns(notFixedColumns);var fixedLeafColumns=doFlattenColumns(states.fixedColumns);var rightFixedLeafColumns=doFlattenColumns(states.rightFixedColumns);states.leafColumnsLength=leafColumns.length;states.fixedLeafColumnsLength=fixedLeafColumns.length;states.rightFixedLeafColumnsLength=rightFixedLeafColumns.length;states.columns=[].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);states.isComplex=states.fixedColumns.length>0||states.rightFixedColumns.length>0;},// 更新 DOM
scheduleLayout:function scheduleLayout(needUpdateColumns){if(needUpdateColumns){this.updateColumns();}this.table.debouncedUpdateLayout();},// 选择
isSelected:function isSelected(row){var _states$selection=this.states.selection,selection=_states$selection===undefined?[]:_states$selection;return selection.indexOf(row)>-1;},clearSelection:function clearSelection(){var states=this.states;states.isAllSelected=false;var oldSelection=states.selection;if(oldSelection.length){states.selection=[];this.table.$emit('selection-change',[]);}},cleanSelection:function cleanSelection(){var states=this.states;var data=states.data,rowKey=states.rowKey,selection=states.selection;var deleted=void 0;if(rowKey){deleted=[];var selectedMap=getKeysMap(selection,rowKey);var dataMap=getKeysMap(data,rowKey);for(var key in selectedMap){if(selectedMap.hasOwnProperty(key)&&!dataMap[key]){deleted.push(selectedMap[key].row);}}}else{deleted=selection.filter(function(item){return data.indexOf(item)===-1;});}if(deleted.length){var newSelection=selection.filter(function(item){return deleted.indexOf(item)===-1;});states.selection=newSelection;this.table.$emit('selection-change',newSelection.slice());}},toggleRowSelection:function toggleRowSelection(row,selected){var emitChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var changed=toggleRowStatus(this.states.selection,row,selected);if(changed){var newSelection=(this.states.selection||[]).slice();// 调用 API 修改选中值，不触发 select 事件
if(emitChange){this.table.$emit('select',newSelection,row);}this.table.$emit('selection-change',newSelection);}},_toggleAllSelection:function _toggleAllSelection(){var states=this.states;var _states$data=states.data,data=_states$data===undefined?[]:_states$data,selection=states.selection;// when only some rows are selected (but not all), select or deselect all of them
// depending on the value of selectOnIndeterminate
var value=states.selectOnIndeterminate?!states.isAllSelected:!(states.isAllSelected||selection.length);states.isAllSelected=value;var selectionChanged=false;data.forEach(function(row,index){if(states.selectable){if(states.selectable.call(null,row,index)&&toggleRowStatus(selection,row,value)){selectionChanged=true;}}else{if(toggleRowStatus(selection,row,value)){selectionChanged=true;}}});if(selectionChanged){this.table.$emit('selection-change',selection?selection.slice():[]);}this.table.$emit('select-all',selection);},updateSelectionByRowKey:function updateSelectionByRowKey(){var states=this.states;var selection=states.selection,rowKey=states.rowKey,data=states.data;var selectedMap=getKeysMap(selection,rowKey);data.forEach(function(row){var rowId=getRowIdentity(row,rowKey);var rowInfo=selectedMap[rowId];if(rowInfo){selection[rowInfo.index]=row;}});},updateAllSelected:function updateAllSelected(){var states=this.states;var selection=states.selection,rowKey=states.rowKey,selectable=states.selectable;// data 为 null 时，解构时的默认值会被忽略
var data=states.data||[];if(data.length===0){states.isAllSelected=false;return;}var selectedMap=void 0;if(rowKey){selectedMap=getKeysMap(selection,rowKey);}var isSelected=function isSelected(row){if(selectedMap){return!!selectedMap[getRowIdentity(row,rowKey)];}else{return selection.indexOf(row)!==-1;}};var isAllSelected=true;var selectedCount=0;for(var i=0,j=data.length;i<j;i++){var item=data[i];var isRowSelectable=selectable&&selectable.call(null,item,i);if(!isSelected(item)){if(!selectable||isRowSelectable){isAllSelected=false;break;}}else{selectedCount++;}}if(selectedCount===0)isAllSelected=false;states.isAllSelected=isAllSelected;},// 过滤与排序
updateFilters:function updateFilters(columns,values){if(!Array.isArray(columns)){columns=[columns];}var states=this.states;var filters={};columns.forEach(function(col){states.filters[col.id]=values;filters[col.columnKey||col.id]=values;});return filters;},updateSort:function updateSort(column,prop,order){if(this.states.sortingColumn&&this.states.sortingColumn!==column){this.states.sortingColumn.order=null;}this.states.sortingColumn=column;this.states.sortProp=prop;this.states.sortOrder=order;},execFilter:function execFilter(){var _this=this;var states=this.states;var _data=states._data,filters=states.filters;var data=_data;Object.keys(filters).forEach(function(columnId){var values=states.filters[columnId];if(!values||values.length===0)return;var column=getColumnById(_this.states,columnId);if(column&&column.filterMethod){data=data.filter(function(row){return values.some(function(value){return column.filterMethod.call(null,value,row,column);});});}});states.filteredData=data;},execSort:function execSort(){var states=this.states;states.data=watcher_sortData(states.filteredData,states);},// 根据 filters 与 sort 去过滤 data
execQuery:function execQuery(ignore){if(!(ignore&&ignore.filter)){this.execFilter();}this.execSort();},clearFilter:function clearFilter(columnKeys){var states=this.states;var _table$$refs=this.table.$refs,tableHeader=_table$$refs.tableHeader,fixedTableHeader=_table$$refs.fixedTableHeader,rightFixedTableHeader=_table$$refs.rightFixedTableHeader;var panels={};if(tableHeader)panels=merge_default()(panels,tableHeader.filterPanels);if(fixedTableHeader)panels=merge_default()(panels,fixedTableHeader.filterPanels);if(rightFixedTableHeader)panels=merge_default()(panels,rightFixedTableHeader.filterPanels);var keys=Object.keys(panels);if(!keys.length)return;if(typeof columnKeys==='string'){columnKeys=[columnKeys];}if(Array.isArray(columnKeys)){var columns=columnKeys.map(function(key){return getColumnByKey(states,key);});keys.forEach(function(key){var column=columns.find(function(col){return col.id===key;});if(column){// TODO: 优化这里的代码
panels[key].filteredValue=[];}});this.commit('filterChange',{column:columns,values:[],silent:true,multi:true});}else{keys.forEach(function(key){// TODO: 优化这里的代码
panels[key].filteredValue=[];});states.filters={};this.commit('filterChange',{column:{},values:[],silent:true});}},clearSort:function clearSort(){var states=this.states;if(!states.sortingColumn)return;this.updateSort(null,null,null);this.commit('changeSortCondition',{silent:true});},// 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
setExpandRowKeysAdapter:function setExpandRowKeysAdapter(val){// 这里会触发额外的计算，但为了兼容性，暂时这么做
this.setExpandRowKeys(val);this.updateTreeExpandKeys(val);},// 展开行与 TreeTable 都要使用
toggleRowExpansionAdapter:function toggleRowExpansionAdapter(row,expanded){var hasExpandColumn=this.states.columns.some(function(_ref){var type=_ref.type;return type==='expand';});if(hasExpandColumn){this.toggleRowExpansion(row,expanded);}else{this.toggleTreeExpansion(row,expanded);}}}});// CONCATENATED MODULE: ./packages/table/src/store/index.js
watcher.prototype.mutations={setData:function setData(states,data){var dataInstanceChanged=states._data!==data;states._data=data;this.execQuery();// 数据变化，更新部分数据。
// 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
this.updateCurrentRowData();this.updateExpandRows();if(states.reserveSelection){this.assertRowKey();this.updateSelectionByRowKey();}else{if(dataInstanceChanged){this.clearSelection();}else{this.cleanSelection();}}this.updateAllSelected();this.updateTableScrollY();},insertColumn:function insertColumn(states,column,index,parent){var array=states._columns;if(parent){array=parent.children;if(!array)array=parent.children=[];}if(typeof index!=='undefined'){array.splice(index,0,column);}else{array.push(column);}if(column.type==='selection'){states.selectable=column.selectable;states.reserveSelection=column.reserveSelection;}if(this.table.$ready){this.updateColumns();// hack for dynamics insert column
this.scheduleLayout();}},removeColumn:function removeColumn(states,column,parent){var array=states._columns;if(parent){array=parent.children;if(!array)array=parent.children=[];}if(array){array.splice(array.indexOf(column),1);}if(this.table.$ready){this.updateColumns();// hack for dynamics remove column
this.scheduleLayout();}},sort:function sort(states,options){var prop=options.prop,order=options.order,init=options.init;if(prop){var column=Object(util_["arrayFind"])(states.columns,function(column){return column.property===prop;});if(column){column.order=order;this.updateSort(column,prop,order);this.commit('changeSortCondition',{init:init});}}},changeSortCondition:function changeSortCondition(states,options){// 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
var column=states.sortingColumn,prop=states.sortProp,order=states.sortOrder;if(order===null){states.sortingColumn=null;states.sortProp=null;}var ingore={filter:true};this.execQuery(ingore);if(!options||!(options.silent||options.init)){this.table.$emit('sort-change',{column:column,prop:prop,order:order});}this.updateTableScrollY();},filterChange:function filterChange(states,options){var column=options.column,values=options.values,silent=options.silent;var newFilters=this.updateFilters(column,values);this.execQuery();if(!silent){this.table.$emit('filter-change',newFilters);}this.updateTableScrollY();},toggleAllSelection:function toggleAllSelection(){this.toggleAllSelection();},rowSelectedChanged:function rowSelectedChanged(states,row){this.toggleRowSelection(row);this.updateAllSelected();},setHoverRow:function setHoverRow(states,row){states.hoverRow=row;},setCurrentRow:function setCurrentRow(states,row){this.updateCurrentRow(row);}};watcher.prototype.commit=function(name){var mutations=this.mutations;if(mutations[name]){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}mutations[name].apply(this,[this.states].concat(args));}else{throw new Error('Action not found: '+name);}};watcher.prototype.updateTableScrollY=function(){external_vue_default.a.nextTick(this.table.updateScrollY);};/* harmony default export */var src_store=watcher;// CONCATENATED MODULE: ./packages/table/src/store/helper.js
function createStore(table){var initialState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!table){throw new Error('Table is required.');}var store=new src_store();store.table=table;// fix https://github.com/ElemeFE/element/issues/14075
// related pr https://github.com/ElemeFE/element/pull/14146
store.toggleAllSelection=debounce_default()(10,store._toggleAllSelection);Object.keys(initialState).forEach(function(key){store.states[key]=initialState[key];});return store;}function mapStates(mapper){var res={};Object.keys(mapper).forEach(function(key){var value=mapper[key];var fn=void 0;if(typeof value==='string'){fn=function fn(){return this.store.states[value];};}else if(typeof value==='function'){fn=function fn(){return value.call(this,this.store.states);};}else{console.error('invalid value type');}if(fn){res[key]=fn;}});return res;};// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
var scrollbar_width_=__webpack_require__(31);var scrollbar_width_default=/*#__PURE__*/__webpack_require__.n(scrollbar_width_);// CONCATENATED MODULE: ./packages/table/src/table-layout.js
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var table_layout_TableLayout=function(){function TableLayout(options){_classCallCheck(this,TableLayout);this.observers=[];this.table=null;this.store=null;this.columns=null;this.fit=true;this.showHeader=true;this.height=null;this.scrollX=false;this.scrollY=false;this.bodyWidth=null;this.fixedWidth=null;this.rightFixedWidth=null;this.tableHeight=null;this.headerHeight=44;// Table Header Height
this.appendHeight=0;// Append Slot Height
this.footerHeight=44;// Table Footer Height
this.viewportHeight=null;// Table Height - Scroll Bar Height
this.bodyHeight=null;// Table Height - Table Header Height
this.fixedBodyHeight=null;// Table Height - Table Header Height - Scroll Bar Height
this.gutterWidth=scrollbar_width_default()();for(var name in options){if(options.hasOwnProperty(name)){this[name]=options[name];}}if(!this.table){throw new Error('table is required for Table Layout');}if(!this.store){throw new Error('store is required for Table Layout');}}TableLayout.prototype.updateScrollY=function updateScrollY(){var height=this.height;if(height===null)return false;var bodyWrapper=this.table.bodyWrapper;if(this.table.$el&&bodyWrapper){var body=bodyWrapper.querySelector('.el-table__body');var prevScrollY=this.scrollY;var scrollY=body.offsetHeight>this.bodyHeight;this.scrollY=scrollY;return prevScrollY!==scrollY;}return false;};TableLayout.prototype.setHeight=function setHeight(value){var _this=this;var prop=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'height';if(external_vue_default.a.prototype.$isServer)return;var el=this.table.$el;value=parseHeight(value);this.height=value;if(!el&&(value||value===0))return external_vue_default.a.nextTick(function(){return _this.setHeight(value,prop);});if(typeof value==='number'){el.style[prop]=value+'px';this.updateElsHeight();}else if(typeof value==='string'){el.style[prop]=value;this.updateElsHeight();}};TableLayout.prototype.setMaxHeight=function setMaxHeight(value){this.setHeight(value,'max-height');};TableLayout.prototype.getFlattenColumns=function getFlattenColumns(){var flattenColumns=[];var columns=this.table.columns;columns.forEach(function(column){if(column.isColumnGroup){flattenColumns.push.apply(flattenColumns,column.columns);}else{flattenColumns.push(column);}});return flattenColumns;};TableLayout.prototype.updateElsHeight=function updateElsHeight(){var _this2=this;if(!this.table.$ready)return external_vue_default.a.nextTick(function(){return _this2.updateElsHeight();});var _table$$refs=this.table.$refs,headerWrapper=_table$$refs.headerWrapper,appendWrapper=_table$$refs.appendWrapper,footerWrapper=_table$$refs.footerWrapper;this.appendHeight=appendWrapper?appendWrapper.offsetHeight:0;if(this.showHeader&&!headerWrapper)return;// fix issue (https://github.com/ElemeFE/element/pull/16956)
var headerTrElm=headerWrapper?headerWrapper.querySelector('.el-table__header tr'):null;var noneHeader=this.headerDisplayNone(headerTrElm);var headerHeight=this.headerHeight=!this.showHeader?0:headerWrapper.offsetHeight;if(this.showHeader&&!noneHeader&&headerWrapper.offsetWidth>0&&(this.table.columns||[]).length>0&&headerHeight<2){return external_vue_default.a.nextTick(function(){return _this2.updateElsHeight();});}var tableHeight=this.tableHeight=this.table.$el.clientHeight;var footerHeight=this.footerHeight=footerWrapper?footerWrapper.offsetHeight:0;if(this.height!==null){this.bodyHeight=tableHeight-headerHeight-footerHeight+(footerWrapper?1:0);}this.fixedBodyHeight=this.scrollX?this.bodyHeight-this.gutterWidth:this.bodyHeight;var noData=!(this.store.states.data&&this.store.states.data.length);this.viewportHeight=this.scrollX?tableHeight-(noData?0:this.gutterWidth):tableHeight;this.updateScrollY();this.notifyObservers('scrollable');};TableLayout.prototype.headerDisplayNone=function headerDisplayNone(elm){if(!elm)return true;var headerChild=elm;while(headerChild.tagName!=='DIV'){if(getComputedStyle(headerChild).display==='none'){return true;}headerChild=headerChild.parentElement;}return false;};TableLayout.prototype.updateColumnsWidth=function updateColumnsWidth(){if(external_vue_default.a.prototype.$isServer)return;var fit=this.fit;var bodyWidth=this.table.$el.clientWidth;var bodyMinWidth=0;var flattenColumns=this.getFlattenColumns();var flexColumns=flattenColumns.filter(function(column){return typeof column.width!=='number';});flattenColumns.forEach(function(column){// Clean those columns whose width changed from flex to unflex
if(typeof column.width==='number'&&column.realWidth)column.realWidth=null;});if(flexColumns.length>0&&fit){flattenColumns.forEach(function(column){bodyMinWidth+=column.width||column.minWidth||80;});var scrollYWidth=this.scrollY?this.gutterWidth:0;if(bodyMinWidth<=bodyWidth-scrollYWidth){// DON'T HAVE SCROLL BAR
this.scrollX=false;var totalFlexWidth=bodyWidth-scrollYWidth-bodyMinWidth;if(flexColumns.length===1){flexColumns[0].realWidth=(flexColumns[0].minWidth||80)+totalFlexWidth;}else{var allColumnsWidth=flexColumns.reduce(function(prev,column){return prev+(column.minWidth||80);},0);var flexWidthPerPixel=totalFlexWidth/allColumnsWidth;var noneFirstWidth=0;flexColumns.forEach(function(column,index){if(index===0)return;var flexWidth=Math.floor((column.minWidth||80)*flexWidthPerPixel);noneFirstWidth+=flexWidth;column.realWidth=(column.minWidth||80)+flexWidth;});flexColumns[0].realWidth=(flexColumns[0].minWidth||80)+totalFlexWidth-noneFirstWidth;}}else{// HAVE HORIZONTAL SCROLL BAR
this.scrollX=true;flexColumns.forEach(function(column){column.realWidth=column.minWidth;});}this.bodyWidth=Math.max(bodyMinWidth,bodyWidth);this.table.resizeState.width=this.bodyWidth;}else{flattenColumns.forEach(function(column){if(!column.width&&!column.minWidth){column.realWidth=80;}else{column.realWidth=column.width||column.minWidth;}bodyMinWidth+=column.realWidth;});this.scrollX=bodyMinWidth>bodyWidth;this.bodyWidth=bodyMinWidth;}var fixedColumns=this.store.states.fixedColumns;if(fixedColumns.length>0){var fixedWidth=0;fixedColumns.forEach(function(column){fixedWidth+=column.realWidth||column.width;});this.fixedWidth=fixedWidth;}var rightFixedColumns=this.store.states.rightFixedColumns;if(rightFixedColumns.length>0){var rightFixedWidth=0;rightFixedColumns.forEach(function(column){rightFixedWidth+=column.realWidth||column.width;});this.rightFixedWidth=rightFixedWidth;}this.notifyObservers('columns');};TableLayout.prototype.addObserver=function addObserver(observer){this.observers.push(observer);};TableLayout.prototype.removeObserver=function removeObserver(observer){var index=this.observers.indexOf(observer);if(index!==-1){this.observers.splice(index,1);}};TableLayout.prototype.notifyObservers=function notifyObservers(event){var _this3=this;var observers=this.observers;observers.forEach(function(observer){switch(event){case'columns':observer.onColumnsChange(_this3);break;case'scrollable':observer.onScrollableChange(_this3);break;default:throw new Error('Table Layout don\'t have event '+event+'.');}});};return TableLayout;}();/* harmony default export */var table_layout=table_layout_TableLayout;// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
/* harmony default export */var layout_observer={created:function created(){this.tableLayout.addObserver(this);},destroyed:function destroyed(){this.tableLayout.removeObserver(this);},computed:{tableLayout:function tableLayout(){var layout=this.layout;if(!layout&&this.table){layout=this.table.layout;}if(!layout){throw new Error('Can not find table layout.');}return layout;}},mounted:function mounted(){this.onColumnsChange(this.tableLayout);this.onScrollableChange(this.tableLayout);},updated:function updated(){if(this.__updated__)return;this.onColumnsChange(this.tableLayout);this.onScrollableChange(this.tableLayout);this.__updated__=true;},methods:{onColumnsChange:function onColumnsChange(layout){var cols=this.$el.querySelectorAll('colgroup > col');if(!cols.length)return;var flattenColumns=layout.getFlattenColumns();var columnsMap={};flattenColumns.forEach(function(column){columnsMap[column.id]=column;});for(var i=0,j=cols.length;i<j;i++){var col=cols[i];var name=col.getAttribute('name');var column=columnsMap[name];if(column){col.setAttribute('width',column.realWidth||column.width);}}},onScrollableChange:function onScrollableChange(layout){var cols=this.$el.querySelectorAll('colgroup > col[name=gutter]');for(var i=0,j=cols.length;i<j;i++){var col=cols[i];col.setAttribute('width',layout.scrollY?layout.gutterWidth:'0');}var ths=this.$el.querySelectorAll('th.gutter');for(var _i=0,_j=ths.length;_i<_j;_i++){var th=ths[_i];th.style.width=layout.scrollY?layout.gutterWidth+'px':'0';th.style.display=layout.scrollY?'':'none';}}}};// CONCATENATED MODULE: ./packages/table/src/table-row.js
var table_row_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_row={name:'ElTableRow',props:['columns','row','index','isSelected','isExpanded','store','context','firstDefaultColumnIndex','treeRowData','treeIndent','columnsHidden','getSpan','getColspanRealWidth','getCellStyle','getCellClass','handleCellMouseLeave','handleCellMouseEnter','fixed'],components:{ElCheckbox:checkbox_default.a},render:function render(){var _this=this;var h=arguments[0];var columns=this.columns,row=this.row,$index=this.index,store=this.store,context=this.context,firstDefaultColumnIndex=this.firstDefaultColumnIndex,treeRowData=this.treeRowData,treeIndent=this.treeIndent,_columnsHidden=this.columnsHidden,columnsHidden=_columnsHidden===undefined?[]:_columnsHidden,isSelected=this.isSelected,isExpanded=this.isExpanded;return h('tr',[columns.map(function(column,cellIndex){var _getSpan=_this.getSpan(row,column,$index,cellIndex),rowspan=_getSpan.rowspan,colspan=_getSpan.colspan;if(!rowspan||!colspan){return null;}var columnData=table_row_extends({},column);columnData.realWidth=_this.getColspanRealWidth(columns,colspan,cellIndex);var data={store:store,isSelected:isSelected,isExpanded:isExpanded,_self:context,column:columnData,row:row,$index:$index};if(cellIndex===firstDefaultColumnIndex&&treeRowData){data.treeNode={indent:treeRowData.level*treeIndent,level:treeRowData.level};if(typeof treeRowData.expanded==='boolean'){data.treeNode.expanded=treeRowData.expanded;// 表明是懒加载
if('loading'in treeRowData){data.treeNode.loading=treeRowData.loading;}if('noLazyChildren'in treeRowData){data.treeNode.noLazyChildren=treeRowData.noLazyChildren;}}}return h('td',{style:_this.getCellStyle($index,cellIndex,row,column),'class':_this.getCellClass($index,cellIndex,row,column),attrs:{rowspan:rowspan,colspan:colspan},on:{'mouseenter':function mouseenter($event){return _this.handleCellMouseEnter($event,row);},'mouseleave':_this.handleCellMouseLeave}},[column.renderCell.call(_this._renderProxy,_this.$createElement,data,columnsHidden[cellIndex])]);})]);}};// CONCATENATED MODULE: ./packages/table/src/table-body.js
var table_body_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var table_body_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_body={name:'ElTableBody',mixins:[layout_observer],components:{ElCheckbox:checkbox_default.a,ElTooltip:tooltip_default.a,TableRow:table_row},props:{store:{required:true},stripe:Boolean,context:{},rowClassName:[String,Function],rowStyle:[Object,Function],fixed:String,highlight:Boolean},render:function render(h){var _this=this;var data=this.data||[];return h('table',{'class':'el-table__body',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});})]),h('tbody',[data.reduce(function(acc,row){return acc.concat(_this.wrappedRowRender(row,acc.length));},[]),h('el-tooltip',{attrs:{effect:this.table.tooltipEffect,placement:'top',content:this.tooltipContent},ref:'tooltip'})])]);},computed:table_body_extends({table:function table(){return this.$parent;}},mapStates({data:'data',columns:'columns',treeIndent:'indent',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;},hasExpandColumn:function hasExpandColumn(states){return states.columns.some(function(_ref){var type=_ref.type;return type==='expand';});}}),{columnsHidden:function columnsHidden(){var _this2=this;return this.columns.map(function(column,index){return _this2.isColumnHidden(index);});},firstDefaultColumnIndex:function firstDefaultColumnIndex(){return Object(util_["arrayFindIndex"])(this.columns,function(_ref2){var type=_ref2.type;return type==='default';});}}),watch:{// don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
// update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
'store.states.hoverRow':function storeStatesHoverRow(newVal,oldVal){var _this3=this;if(!this.store.states.isComplex||this.$isServer)return;var raf=window.requestAnimationFrame;if(!raf){raf=function raf(fn){return setTimeout(fn,16);};}raf(function(){var rows=_this3.$el.querySelectorAll('.el-table__row');var oldRow=rows[oldVal];var newRow=rows[newVal];if(oldRow){Object(dom_["removeClass"])(oldRow,'hover-row');}if(newRow){Object(dom_["addClass"])(newRow,'hover-row');}});}},data:function data(){return{tooltipContent:''};},created:function created(){this.activateTooltip=debounce_default()(50,function(tooltip){return tooltip.handleShowPopper();});},methods:{getKeyOfRow:function getKeyOfRow(row,index){var rowKey=this.table.rowKey;if(rowKey){return getRowIdentity(row,rowKey);}return index;},isColumnHidden:function isColumnHidden(index){if(this.fixed===true||this.fixed==='left'){return index>=this.leftFixedLeafCount;}else if(this.fixed==='right'){return index<this.columnsCount-this.rightFixedLeafCount;}else{return index<this.leftFixedLeafCount||index>=this.columnsCount-this.rightFixedLeafCount;}},getSpan:function getSpan(row,column,rowIndex,columnIndex){var rowspan=1;var colspan=1;var fn=this.table.spanMethod;if(typeof fn==='function'){var result=fn({row:row,column:column,rowIndex:rowIndex,columnIndex:columnIndex});if(Array.isArray(result)){rowspan=result[0];colspan=result[1];}else if((typeof result==='undefined'?'undefined':table_body_typeof(result))==='object'){rowspan=result.rowspan;colspan=result.colspan;}}return{rowspan:rowspan,colspan:colspan};},getRowStyle:function getRowStyle(row,rowIndex){var rowStyle=this.table.rowStyle;if(typeof rowStyle==='function'){return rowStyle.call(null,{row:row,rowIndex:rowIndex});}return rowStyle||null;},getRowClass:function getRowClass(row,rowIndex){var selection=this.store.states.selection;var classes=['el-table__row'];if(this.table.highlightCurrentRow&&row===this.store.states.currentRow){classes.push('current-row');}if(this.table.highlightSelectionRow){for(var i=0;i<selection.length;i++){if(objectEquals(row,selection[i])){classes.push('selection-row');}};}if(this.stripe&&rowIndex%2===1){classes.push('el-table__row--striped');}var rowClassName=this.table.rowClassName;if(typeof rowClassName==='string'){classes.push(rowClassName);}else if(typeof rowClassName==='function'){classes.push(rowClassName.call(null,{row:row,rowIndex:rowIndex}));}if(this.store.states.expandRows.indexOf(row)>-1){classes.push('expanded');}return classes;},getCellStyle:function getCellStyle(rowIndex,columnIndex,row,column){var cellStyle=this.table.cellStyle;if(typeof cellStyle==='function'){return cellStyle.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column});}return cellStyle;},getCellClass:function getCellClass(rowIndex,columnIndex,row,column){var classes=[column.id,column.align,column.className];if(this.isColumnHidden(columnIndex)){classes.push('is-hidden');}var cellClassName=this.table.cellClassName;if(typeof cellClassName==='string'){classes.push(cellClassName);}else if(typeof cellClassName==='function'){classes.push(cellClassName.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column}));}classes.push('el-table__cell');return classes.join(' ');},getColspanRealWidth:function getColspanRealWidth(columns,colspan,index){if(colspan<1){return columns[index].realWidth;}var widthArr=columns.map(function(_ref3){var realWidth=_ref3.realWidth;return realWidth;}).slice(index,index+colspan);return widthArr.reduce(function(acc,width){return acc+width;},-1);},handleCellMouseEnter:function handleCellMouseEnter(event,row){var table=this.table;var cell=getCell(event);if(cell){var column=getColumnByCell(table,cell);var hoverState=table.hoverState={cell:cell,column:column,row:row};table.$emit('cell-mouse-enter',hoverState.row,hoverState.column,hoverState.cell,event);}// 判断是否text-overflow, 如果是就显示tooltip
var cellChild=event.target.querySelector('.cell');if(!(Object(dom_["hasClass"])(cellChild,'el-tooltip')&&cellChild.childNodes.length)){return;}// use range width instead of scrollWidth to determine whether the text is overflowing
// to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
var range=document.createRange();range.setStart(cellChild,0);range.setEnd(cellChild,cellChild.childNodes.length);var rangeWidth=range.getBoundingClientRect().width;var padding=(parseInt(Object(dom_["getStyle"])(cellChild,'paddingLeft'),10)||0)+(parseInt(Object(dom_["getStyle"])(cellChild,'paddingRight'),10)||0);if((rangeWidth+padding>cellChild.offsetWidth||cellChild.scrollWidth>cellChild.offsetWidth)&&this.$refs.tooltip){var tooltip=this.$refs.tooltip;// TODO 会引起整个 Table 的重新渲染，需要优化
this.tooltipContent=cell.innerText||cell.textContent;tooltip.referenceElm=cell;tooltip.$refs.popper&&(tooltip.$refs.popper.style.display='none');tooltip.doDestroy();tooltip.setExpectedState(true);this.activateTooltip(tooltip);}},handleCellMouseLeave:function handleCellMouseLeave(event){var tooltip=this.$refs.tooltip;if(tooltip){tooltip.setExpectedState(false);tooltip.handleClosePopper();}var cell=getCell(event);if(!cell)return;var oldHoverState=this.table.hoverState||{};this.table.$emit('cell-mouse-leave',oldHoverState.row,oldHoverState.column,oldHoverState.cell,event);},handleMouseEnter:debounce_default()(30,function(index){this.store.commit('setHoverRow',index);}),handleMouseLeave:debounce_default()(30,function(){this.store.commit('setHoverRow',null);}),handleContextMenu:function handleContextMenu(event,row){this.handleEvent(event,row,'contextmenu');},handleDoubleClick:function handleDoubleClick(event,row){this.handleEvent(event,row,'dblclick');},handleClick:function handleClick(event,row){this.store.commit('setCurrentRow',row);this.handleEvent(event,row,'click');},handleEvent:function handleEvent(event,row,name){var table=this.table;var cell=getCell(event);var column=void 0;if(cell){column=getColumnByCell(table,cell);if(column){table.$emit('cell-'+name,row,column,cell,event);}}table.$emit('row-'+name,row,column,event);},rowRender:function rowRender(row,$index,treeRowData){var _this4=this;var h=this.$createElement;var treeIndent=this.treeIndent,columns=this.columns,firstDefaultColumnIndex=this.firstDefaultColumnIndex;var rowClasses=this.getRowClass(row,$index);var display=true;if(treeRowData){rowClasses.push('el-table__row--level-'+treeRowData.level);display=treeRowData.display;}// 指令 v-show 会覆盖 row-style 中 display
// 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
var displayStyle=display?null:{display:'none'};return h(table_row,{style:[displayStyle,this.getRowStyle(row,$index)],'class':rowClasses,key:this.getKeyOfRow(row,$index),nativeOn:{'dblclick':function dblclick($event){return _this4.handleDoubleClick($event,row);},'click':function click($event){return _this4.handleClick($event,row);},'contextmenu':function contextmenu($event){return _this4.handleContextMenu($event,row);},'mouseenter':function mouseenter(_){return _this4.handleMouseEnter($index);},'mouseleave':this.handleMouseLeave},attrs:{columns:columns,row:row,index:$index,store:this.store,context:this.context||this.table.$vnode.context,firstDefaultColumnIndex:firstDefaultColumnIndex,treeRowData:treeRowData,treeIndent:treeIndent,columnsHidden:this.columnsHidden,getSpan:this.getSpan,getColspanRealWidth:this.getColspanRealWidth,getCellStyle:this.getCellStyle,getCellClass:this.getCellClass,handleCellMouseEnter:this.handleCellMouseEnter,handleCellMouseLeave:this.handleCellMouseLeave,isSelected:this.store.isSelected(row),isExpanded:this.store.states.expandRows.indexOf(row)>-1,fixed:this.fixed}});},wrappedRowRender:function wrappedRowRender(row,$index){var _this5=this;var h=this.$createElement;var store=this.store;var isRowExpanded=store.isRowExpanded,assertRowKey=store.assertRowKey;var _store$states=store.states,treeData=_store$states.treeData,lazyTreeNodeMap=_store$states.lazyTreeNodeMap,childrenColumnName=_store$states.childrenColumnName,rowKey=_store$states.rowKey;if(this.hasExpandColumn&&isRowExpanded(row)){var renderExpanded=this.table.renderExpanded;var tr=this.rowRender(row,$index);if(!renderExpanded){console.error('[Element Error]renderExpanded is required.');return tr;}// 使用二维数组，避免修改 $index
return[[tr,h('tr',{key:'expanded-row__'+tr.key},[h('td',{attrs:{colspan:this.columnsCount},'class':'el-table__cell el-table__expanded-cell'},[renderExpanded(this.$createElement,{row:row,$index:$index,store:this.store})])])]];}else if(Object.keys(treeData).length){assertRowKey();// TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
// 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
var key=getRowIdentity(row,rowKey);var cur=treeData[key];var treeRowData=null;if(cur){treeRowData={expanded:cur.expanded,level:cur.level,display:true};if(typeof cur.lazy==='boolean'){if(typeof cur.loaded==='boolean'&&cur.loaded){treeRowData.noLazyChildren=!(cur.children&&cur.children.length);}treeRowData.loading=cur.loading;}}var tmp=[this.rowRender(row,$index,treeRowData)];// 渲染嵌套数据
if(cur){// currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
var i=0;var traverse=function traverse(children,parent){if(!(children&&children.length&&parent))return;children.forEach(function(node){// 父节点的 display 状态影响子节点的显示状态
var innerTreeRowData={display:parent.display&&parent.expanded,level:parent.level+1};var childKey=getRowIdentity(node,rowKey);if(childKey===undefined||childKey===null){throw new Error('for nested data item, row-key is required.');}cur=table_body_extends({},treeData[childKey]);// 对于当前节点，分成有无子节点两种情况。
// 如果包含子节点的，设置 expanded 属性。
// 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
if(cur){innerTreeRowData.expanded=cur.expanded;// 懒加载的某些节点，level 未知
cur.level=cur.level||innerTreeRowData.level;cur.display=!!(cur.expanded&&innerTreeRowData.display);if(typeof cur.lazy==='boolean'){if(typeof cur.loaded==='boolean'&&cur.loaded){innerTreeRowData.noLazyChildren=!(cur.children&&cur.children.length);}innerTreeRowData.loading=cur.loading;}}i++;tmp.push(_this5.rowRender(node,$index+i,innerTreeRowData));if(cur){var _nodes=lazyTreeNodeMap[childKey]||node[childrenColumnName];traverse(_nodes,cur);}});};// 对于 root 节点，display 一定为 true
cur.display=true;var nodes=lazyTreeNodeMap[key]||row[childrenColumnName];traverse(nodes,cur);}return tmp;}else{return this.rowRender(row,$index);}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
var filter_panelvue_type_template_id_7f2c919f_render=function filter_panelvue_type_template_id_7f2c919f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"}},[_vm.multiple?_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleOutsideClick,expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-table-filter"},[_c("div",{staticClass:"el-table-filter__content"},[_c("el-scrollbar",{attrs:{"wrap-class":"el-table-filter__wrap"}},[_c("el-checkbox-group",{staticClass:"el-table-filter__checkbox-group",model:{value:_vm.filteredValue,callback:function callback($$v){_vm.filteredValue=$$v;},expression:"filteredValue"}},_vm._l(_vm.filters,function(filter){return _c("el-checkbox",{key:filter.value,attrs:{label:filter.value}},[_vm._v(_vm._s(filter.text))]);}),1)],1)],1),_c("div",{staticClass:"el-table-filter__bottom"},[_c("button",{class:{"is-disabled":_vm.filteredValue.length===0},attrs:{disabled:_vm.filteredValue.length===0},on:{click:_vm.handleConfirm}},[_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]),_c("button",{on:{click:_vm.handleReset}},[_vm._v(_vm._s(_vm.t("el.table.resetFilter")))])])]):_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleOutsideClick,expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-table-filter"},[_c("ul",{staticClass:"el-table-filter__list"},[_c("li",{staticClass:"el-table-filter__list-item",class:{"is-active":_vm.filterValue===undefined||_vm.filterValue===null},on:{click:function click($event){_vm.handleSelect(null);}}},[_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]),_vm._l(_vm.filters,function(filter){return _c("li",{key:filter.value,staticClass:"el-table-filter__list-item",class:{"is-active":_vm.isActive(filter)},attrs:{label:filter.value},on:{click:function click($event){_vm.handleSelect(filter.value);}}},[_vm._v(_vm._s(filter.text))]);})],2)])]);};var filter_panelvue_type_template_id_7f2c919f_staticRenderFns=[];filter_panelvue_type_template_id_7f2c919f_render._withStripped=true;// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
// CONCATENATED MODULE: ./packages/table/src/dropdown.js
var dropdowns=[];!external_vue_default.a.prototype.$isServer&&document.addEventListener('click',function(event){dropdowns.forEach(function(dropdown){var target=event.target;if(!dropdown||!dropdown.$el)return;if(target===dropdown.$el||dropdown.$el.contains(target)){return;}dropdown.handleOutsideClick&&dropdown.handleOutsideClick(event);});});/* harmony default export */var src_dropdown={open:function open(instance){if(instance){dropdowns.push(instance);}},close:function close(instance){var index=dropdowns.indexOf(instance);if(index!==-1){dropdowns.splice(instance,1);}}};// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
var checkbox_group_=__webpack_require__(32);var checkbox_group_default=/*#__PURE__*/__webpack_require__.n(checkbox_group_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var filter_panelvue_type_script_lang_js_={name:'ElTableFilterPanel',mixins:[vue_popper_default.a,locale_default.a],directives:{Clickoutside:clickoutside_default.a},components:{ElCheckbox:checkbox_default.a,ElCheckboxGroup:checkbox_group_default.a,ElScrollbar:scrollbar_default.a},props:{placement:{type:String,default:'bottom-end'}},methods:{isActive:function isActive(filter){return filter.value===this.filterValue;},handleOutsideClick:function handleOutsideClick(){var _this=this;setTimeout(function(){_this.showPopper=false;},16);},handleConfirm:function handleConfirm(){this.confirmFilter(this.filteredValue);this.handleOutsideClick();},handleReset:function handleReset(){this.filteredValue=[];this.confirmFilter(this.filteredValue);this.handleOutsideClick();},handleSelect:function handleSelect(filterValue){this.filterValue=filterValue;if(typeof filterValue!=='undefined'&&filterValue!==null){this.confirmFilter(this.filteredValue);}else{this.confirmFilter([]);}this.handleOutsideClick();},confirmFilter:function confirmFilter(filteredValue){this.table.store.commit('filterChange',{column:this.column,values:filteredValue});this.table.store.updateAllSelected();}},data:function data(){return{table:null,cell:null,column:null};},computed:{filters:function filters(){return this.column&&this.column.filters;},filterValue:{get:function get(){return(this.column.filteredValue||[])[0];},set:function set(value){if(this.filteredValue){if(typeof value!=='undefined'&&value!==null){this.filteredValue.splice(0,1,value);}else{this.filteredValue.splice(0,1);}}}},filteredValue:{get:function get(){if(this.column){return this.column.filteredValue||[];}return[];},set:function set(value){if(this.column){this.column.filteredValue=value;}}},multiple:function multiple(){if(this.column){return this.column.filterMultiple;}return true;}},mounted:function mounted(){var _this2=this;this.popperElm=this.$el;this.referenceElm=this.cell;this.table.bodyWrapper.addEventListener('scroll',function(){_this2.updatePopper();});this.$watch('showPopper',function(value){if(_this2.column)_this2.column.filterOpened=value;if(value){src_dropdown.open(_this2);}else{src_dropdown.close(_this2);}});},watch:{showPopper:function showPopper(val){if(val===true&&parseInt(this.popperJS._popper.style.zIndex,10)<popup_["PopupManager"].zIndex){this.popperJS._popper.style.zIndex=popup_["PopupManager"].nextZIndex();}}}};// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_filter_panelvue_type_script_lang_js_=filter_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
/* normalize component */var filter_panel_component=normalizeComponent(src_filter_panelvue_type_script_lang_js_,filter_panelvue_type_template_id_7f2c919f_render,filter_panelvue_type_template_id_7f2c919f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var filter_panel_api;}filter_panel_component.options.__file="packages/table/src/filter-panel.vue";/* harmony default export */var filter_panel=filter_panel_component.exports;// CONCATENATED MODULE: ./packages/table/src/table-header.js
var table_header_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var getAllColumns=function getAllColumns(columns){var result=[];columns.forEach(function(column){if(column.children){result.push(column);result.push.apply(result,getAllColumns(column.children));}else{result.push(column);}});return result;};var convertToRows=function convertToRows(originColumns){var maxLevel=1;var traverse=function traverse(column,parent){if(parent){column.level=parent.level+1;if(maxLevel<column.level){maxLevel=column.level;}}if(column.children){var colSpan=0;column.children.forEach(function(subColumn){traverse(subColumn,column);colSpan+=subColumn.colSpan;});column.colSpan=colSpan;}else{column.colSpan=1;}};originColumns.forEach(function(column){column.level=1;traverse(column);});var rows=[];for(var i=0;i<maxLevel;i++){rows.push([]);}var allColumns=getAllColumns(originColumns);allColumns.forEach(function(column){if(!column.children){column.rowSpan=maxLevel-column.level+1;}else{column.rowSpan=1;}rows[column.level-1].push(column);});return rows;};/* harmony default export */var table_header={name:'ElTableHeader',mixins:[layout_observer],render:function render(h){var _this=this;var originColumns=this.store.states.originColumns;var columnRows=convertToRows(originColumns,this.columns);// 是否拥有多级表头
var isGroup=columnRows.length>1;if(isGroup)this.$parent.isGroup=true;return h('table',{'class':'el-table__header',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});}),this.hasGutter?h('col',{attrs:{name:'gutter'}}):'']),h('thead',{'class':[{'is-group':isGroup,'has-gutter':this.hasGutter}]},[this._l(columnRows,function(columns,rowIndex){return h('tr',{style:_this.getHeaderRowStyle(rowIndex),'class':_this.getHeaderRowClass(rowIndex)},[columns.map(function(column,cellIndex){return h('th',{attrs:{colspan:column.colSpan,rowspan:column.rowSpan},on:{'mousemove':function mousemove($event){return _this.handleMouseMove($event,column);},'mouseout':_this.handleMouseOut,'mousedown':function mousedown($event){return _this.handleMouseDown($event,column);},'click':function click($event){return _this.handleHeaderClick($event,column);},'contextmenu':function contextmenu($event){return _this.handleHeaderContextMenu($event,column);}},style:_this.getHeaderCellStyle(rowIndex,cellIndex,columns,column),'class':_this.getHeaderCellClass(rowIndex,cellIndex,columns,column),key:column.id},[h('div',{'class':['cell',column.filteredValue&&column.filteredValue.length>0?'highlight':'',column.labelClassName]},[column.renderHeader?column.renderHeader.call(_this._renderProxy,h,{column:column,$index:cellIndex,store:_this.store,_self:_this.$parent.$vnode.context}):column.label,column.sortable?h('span',{'class':'caret-wrapper',on:{'click':function click($event){return _this.handleSortClick($event,column);}}},[h('i',{'class':'sort-caret ascending',on:{'click':function click($event){return _this.handleSortClick($event,column,'ascending');}}}),h('i',{'class':'sort-caret descending',on:{'click':function click($event){return _this.handleSortClick($event,column,'descending');}}})]):'',column.filterable?h('span',{'class':'el-table__column-filter-trigger',on:{'click':function click($event){return _this.handleFilterClick($event,column);}}},[h('i',{'class':['el-icon-arrow-down',column.filterOpened?'el-icon-arrow-up':'']})]):''])]);}),_this.hasGutter?h('th',{'class':'el-table__cell gutter'}):'']);})])]);},props:{fixed:String,store:{required:true},border:Boolean,defaultSort:{type:Object,default:function _default(){return{prop:'',order:''};}}},components:{ElCheckbox:checkbox_default.a},computed:table_header_extends({table:function table(){return this.$parent;},hasGutter:function hasGutter(){return!this.fixed&&this.tableLayout.gutterWidth;}},mapStates({columns:'columns',isAllSelected:'isAllSelected',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;}})),created:function created(){this.filterPanels={};},mounted:function mounted(){var _this2=this;// nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
this.$nextTick(function(){var _defaultSort=_this2.defaultSort,prop=_defaultSort.prop,order=_defaultSort.order;var init=true;_this2.store.commit('sort',{prop:prop,order:order,init:init});});},beforeDestroy:function beforeDestroy(){var panels=this.filterPanels;for(var prop in panels){if(panels.hasOwnProperty(prop)&&panels[prop]){panels[prop].$destroy(true);}}},methods:{isCellHidden:function isCellHidden(index,columns){var start=0;for(var i=0;i<index;i++){start+=columns[i].colSpan;}var after=start+columns[index].colSpan-1;if(this.fixed===true||this.fixed==='left'){return after>=this.leftFixedLeafCount;}else if(this.fixed==='right'){return start<this.columnsCount-this.rightFixedLeafCount;}else{return after<this.leftFixedLeafCount||start>=this.columnsCount-this.rightFixedLeafCount;}},getHeaderRowStyle:function getHeaderRowStyle(rowIndex){var headerRowStyle=this.table.headerRowStyle;if(typeof headerRowStyle==='function'){return headerRowStyle.call(null,{rowIndex:rowIndex});}return headerRowStyle;},getHeaderRowClass:function getHeaderRowClass(rowIndex){var classes=[];var headerRowClassName=this.table.headerRowClassName;if(typeof headerRowClassName==='string'){classes.push(headerRowClassName);}else if(typeof headerRowClassName==='function'){classes.push(headerRowClassName.call(null,{rowIndex:rowIndex}));}return classes.join(' ');},getHeaderCellStyle:function getHeaderCellStyle(rowIndex,columnIndex,row,column){var headerCellStyle=this.table.headerCellStyle;if(typeof headerCellStyle==='function'){return headerCellStyle.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column});}return headerCellStyle;},getHeaderCellClass:function getHeaderCellClass(rowIndex,columnIndex,row,column){var classes=[column.id,column.order,column.headerAlign,column.className,column.labelClassName];if(rowIndex===0&&this.isCellHidden(columnIndex,row)){classes.push('is-hidden');}if(!column.children){classes.push('is-leaf');}if(column.sortable){classes.push('is-sortable');}var headerCellClassName=this.table.headerCellClassName;if(typeof headerCellClassName==='string'){classes.push(headerCellClassName);}else if(typeof headerCellClassName==='function'){classes.push(headerCellClassName.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column}));}classes.push('el-table__cell');return classes.join(' ');},toggleAllSelection:function toggleAllSelection(){this.store.commit('toggleAllSelection');},handleFilterClick:function handleFilterClick(event,column){event.stopPropagation();var target=event.target;var cell=target.tagName==='TH'?target:target.parentNode;if(Object(dom_["hasClass"])(cell,'noclick'))return;cell=cell.querySelector('.el-table__column-filter-trigger')||cell;var table=this.$parent;var filterPanel=this.filterPanels[column.id];if(filterPanel&&column.filterOpened){filterPanel.showPopper=false;return;}if(!filterPanel){filterPanel=new external_vue_default.a(filter_panel);this.filterPanels[column.id]=filterPanel;if(column.filterPlacement){filterPanel.placement=column.filterPlacement;}filterPanel.table=table;filterPanel.cell=cell;filterPanel.column=column;!this.$isServer&&filterPanel.$mount(document.createElement('div'));}setTimeout(function(){filterPanel.showPopper=true;},16);},handleHeaderClick:function handleHeaderClick(event,column){if(!column.filters&&column.sortable){this.handleSortClick(event,column);}else if(column.filterable&&!column.sortable){this.handleFilterClick(event,column);}this.$parent.$emit('header-click',column,event);},handleHeaderContextMenu:function handleHeaderContextMenu(event,column){this.$parent.$emit('header-contextmenu',column,event);},handleMouseDown:function handleMouseDown(event,column){var _this3=this;if(this.$isServer)return;if(column.children&&column.children.length>0)return;/* istanbul ignore if */if(this.draggingColumn&&this.border){this.dragging=true;this.$parent.resizeProxyVisible=true;var table=this.$parent;var tableEl=table.$el;var tableLeft=tableEl.getBoundingClientRect().left;var columnEl=this.$el.querySelector('th.'+column.id);var columnRect=columnEl.getBoundingClientRect();var minLeft=columnRect.left-tableLeft+30;Object(dom_["addClass"])(columnEl,'noclick');this.dragState={startMouseLeft:event.clientX,startLeft:columnRect.right-tableLeft,startColumnLeft:columnRect.left-tableLeft,tableLeft:tableLeft};var resizeProxy=table.$refs.resizeProxy;resizeProxy.style.left=this.dragState.startLeft+'px';document.onselectstart=function(){return false;};document.ondragstart=function(){return false;};var handleMouseMove=function handleMouseMove(event){var deltaLeft=event.clientX-_this3.dragState.startMouseLeft;var proxyLeft=_this3.dragState.startLeft+deltaLeft;resizeProxy.style.left=Math.max(minLeft,proxyLeft)+'px';};var handleMouseUp=function handleMouseUp(){if(_this3.dragging){var _dragState=_this3.dragState,startColumnLeft=_dragState.startColumnLeft,startLeft=_dragState.startLeft;var finalLeft=parseInt(resizeProxy.style.left,10);var columnWidth=finalLeft-startColumnLeft;column.width=column.realWidth=columnWidth;table.$emit('header-dragend',column.width,startLeft-startColumnLeft,column,event);_this3.store.scheduleLayout();document.body.style.cursor='';_this3.dragging=false;_this3.draggingColumn=null;_this3.dragState={};table.resizeProxyVisible=false;}document.removeEventListener('mousemove',handleMouseMove);document.removeEventListener('mouseup',handleMouseUp);document.onselectstart=null;document.ondragstart=null;setTimeout(function(){Object(dom_["removeClass"])(columnEl,'noclick');},0);};document.addEventListener('mousemove',handleMouseMove);document.addEventListener('mouseup',handleMouseUp);}},handleMouseMove:function handleMouseMove(event,column){if(column.children&&column.children.length>0)return;var target=event.target;while(target&&target.tagName!=='TH'){target=target.parentNode;}if(!column||!column.resizable)return;if(!this.dragging&&this.border){var rect=target.getBoundingClientRect();var bodyStyle=document.body.style;if(rect.width>12&&rect.right-event.pageX<8){bodyStyle.cursor='col-resize';if(Object(dom_["hasClass"])(target,'is-sortable')){target.style.cursor='col-resize';}this.draggingColumn=column;}else if(!this.dragging){bodyStyle.cursor='';if(Object(dom_["hasClass"])(target,'is-sortable')){target.style.cursor='pointer';}this.draggingColumn=null;}}},handleMouseOut:function handleMouseOut(){if(this.$isServer)return;document.body.style.cursor='';},toggleOrder:function toggleOrder(_ref){var order=_ref.order,sortOrders=_ref.sortOrders;if(order==='')return sortOrders[0];var index=sortOrders.indexOf(order||null);return sortOrders[index>sortOrders.length-2?0:index+1];},handleSortClick:function handleSortClick(event,column,givenOrder){event.stopPropagation();var order=column.order===givenOrder?null:givenOrder||this.toggleOrder(column);var target=event.target;while(target&&target.tagName!=='TH'){target=target.parentNode;}if(target&&target.tagName==='TH'){if(Object(dom_["hasClass"])(target,'noclick')){Object(dom_["removeClass"])(target,'noclick');return;}}if(!column.sortable)return;var states=this.store.states;var sortProp=states.sortProp;var sortOrder=void 0;var sortingColumn=states.sortingColumn;if(sortingColumn!==column||sortingColumn===column&&sortingColumn.order===null){if(sortingColumn){sortingColumn.order=null;}states.sortingColumn=column;sortProp=column.property;}if(!order){sortOrder=column.order=null;}else{sortOrder=column.order=order;}states.sortProp=sortProp;states.sortOrder=sortOrder;this.store.commit('changeSortCondition');}},data:function data(){return{draggingColumn:null,dragging:false,dragState:{}};}};// CONCATENATED MODULE: ./packages/table/src/table-footer.js
var table_footer_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_footer={name:'ElTableFooter',mixins:[layout_observer],render:function render(h){var _this=this;var sums=[];if(this.summaryMethod){sums=this.summaryMethod({columns:this.columns,data:this.store.states.data});}else{this.columns.forEach(function(column,index){if(index===0){sums[index]=_this.sumText;return;}var values=_this.store.states.data.map(function(item){return Number(item[column.property]);});var precisions=[];var notNumber=true;values.forEach(function(value){if(!isNaN(value)){notNumber=false;var decimal=(''+value).split('.')[1];precisions.push(decimal?decimal.length:0);}});var precision=Math.max.apply(null,precisions);if(!notNumber){sums[index]=values.reduce(function(prev,curr){var value=Number(curr);if(!isNaN(value)){return parseFloat((prev+curr).toFixed(Math.min(precision,20)));}else{return prev;}},0);}else{sums[index]='';}});}return h('table',{'class':'el-table__footer',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});}),this.hasGutter?h('col',{attrs:{name:'gutter'}}):'']),h('tbody',{'class':[{'has-gutter':this.hasGutter}]},[h('tr',[this.columns.map(function(column,cellIndex){return h('td',{key:cellIndex,attrs:{colspan:column.colSpan,rowspan:column.rowSpan},'class':[].concat(_this.getRowClasses(column,cellIndex),['el-table__cell'])},[h('div',{'class':['cell',column.labelClassName]},[sums[cellIndex]])]);}),this.hasGutter?h('th',{'class':'el-table__cell gutter'}):''])])]);},props:{fixed:String,store:{required:true},summaryMethod:Function,sumText:String,border:Boolean,defaultSort:{type:Object,default:function _default(){return{prop:'',order:''};}}},computed:table_footer_extends({table:function table(){return this.$parent;},hasGutter:function hasGutter(){return!this.fixed&&this.tableLayout.gutterWidth;}},mapStates({columns:'columns',isAllSelected:'isAllSelected',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;}})),methods:{isCellHidden:function isCellHidden(index,columns,column){if(this.fixed===true||this.fixed==='left'){return index>=this.leftFixedLeafCount;}else if(this.fixed==='right'){var before=0;for(var i=0;i<index;i++){before+=columns[i].colSpan;}return before<this.columnsCount-this.rightFixedLeafCount;}else if(!this.fixed&&column.fixed){// hide cell when footer instance is not fixed and column is fixed
return true;}else{return index<this.leftFixedCount||index>=this.columnsCount-this.rightFixedCount;}},getRowClasses:function getRowClasses(column,cellIndex){var classes=[column.id,column.align,column.labelClassName];if(column.className){classes.push(column.className);}if(this.isCellHidden(cellIndex,this.columns,column)){classes.push('is-hidden');}if(!column.children){classes.push('is-leaf');}return classes;}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
var tablevue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tableIdSeed=1;/* harmony default export */var tablevue_type_script_lang_js_={name:'ElTable',mixins:[locale_default.a,migrating_default.a],directives:{Mousewheel:directives_mousewheel},props:{data:{type:Array,default:function _default(){return[];}},size:String,width:[String,Number],height:[String,Number],maxHeight:[String,Number],fit:{type:Boolean,default:true},stripe:Boolean,border:Boolean,rowKey:[String,Function],context:{},showHeader:{type:Boolean,default:true},showSummary:Boolean,sumText:String,summaryMethod:Function,rowClassName:[String,Function],rowStyle:[Object,Function],cellClassName:[String,Function],cellStyle:[Object,Function],headerRowClassName:[String,Function],headerRowStyle:[Object,Function],headerCellClassName:[String,Function],headerCellStyle:[Object,Function],highlightCurrentRow:Boolean,highlightSelectionRow:{type:Boolean,default:false},currentRowKey:[String,Number],emptyText:String,expandRowKeys:Array,defaultExpandAll:Boolean,defaultSort:Object,tooltipEffect:String,spanMethod:Function,selectOnIndeterminate:{type:Boolean,default:true},indent:{type:Number,default:16},treeProps:{type:Object,default:function _default(){return{hasChildren:'hasChildren',children:'children'};}},lazy:Boolean,load:Function},components:{TableHeader:table_header,TableFooter:table_footer,TableBody:table_body,ElCheckbox:checkbox_default.a},methods:{getMigratingConfig:function getMigratingConfig(){return{events:{expand:'expand is renamed to expand-change'}};},setCurrentRow:function setCurrentRow(row){this.store.commit('setCurrentRow',row);},toggleRowSelection:function toggleRowSelection(row,selected){this.store.toggleRowSelection(row,selected,false);this.store.updateAllSelected();},toggleRowExpansion:function toggleRowExpansion(row,expanded){this.store.toggleRowExpansionAdapter(row,expanded);},clearSelection:function clearSelection(){this.store.clearSelection();},clearFilter:function clearFilter(columnKeys){this.store.clearFilter(columnKeys);},clearSort:function clearSort(){this.store.clearSort();},handleMouseLeave:function handleMouseLeave(){this.store.commit('setHoverRow',null);if(this.hoverState)this.hoverState=null;},updateScrollY:function updateScrollY(){var changed=this.layout.updateScrollY();if(changed){this.layout.notifyObservers('scrollable');this.layout.updateColumnsWidth();}},handleFixedMousewheel:function handleFixedMousewheel(event,data){var bodyWrapper=this.bodyWrapper;if(Math.abs(data.spinY)>0){var currentScrollTop=bodyWrapper.scrollTop;if(data.pixelY<0&&currentScrollTop!==0){event.preventDefault();}if(data.pixelY>0&&bodyWrapper.scrollHeight-bodyWrapper.clientHeight>currentScrollTop){event.preventDefault();}bodyWrapper.scrollTop+=Math.ceil(data.pixelY/5);}else{bodyWrapper.scrollLeft+=Math.ceil(data.pixelX/5);}},handleHeaderFooterMousewheel:function handleHeaderFooterMousewheel(event,data){var pixelX=data.pixelX,pixelY=data.pixelY;if(Math.abs(pixelX)>=Math.abs(pixelY)){this.bodyWrapper.scrollLeft+=data.pixelX/5;}},// TODO 使用 CSS transform
syncPostion:function syncPostion(){var _bodyWrapper=this.bodyWrapper,scrollLeft=_bodyWrapper.scrollLeft,scrollTop=_bodyWrapper.scrollTop,offsetWidth=_bodyWrapper.offsetWidth,scrollWidth=_bodyWrapper.scrollWidth;var _$refs=this.$refs,headerWrapper=_$refs.headerWrapper,footerWrapper=_$refs.footerWrapper,fixedBodyWrapper=_$refs.fixedBodyWrapper,rightFixedBodyWrapper=_$refs.rightFixedBodyWrapper;if(headerWrapper)headerWrapper.scrollLeft=scrollLeft;if(footerWrapper)footerWrapper.scrollLeft=scrollLeft;if(fixedBodyWrapper)fixedBodyWrapper.scrollTop=scrollTop;if(rightFixedBodyWrapper)rightFixedBodyWrapper.scrollTop=scrollTop;var maxScrollLeftPosition=scrollWidth-offsetWidth-1;if(scrollLeft>=maxScrollLeftPosition){this.scrollPosition='right';}else if(scrollLeft===0){this.scrollPosition='left';}else{this.scrollPosition='middle';}},throttleSyncPostion:Object(external_throttle_debounce_["throttle"])(16,function(){this.syncPostion();}),onScroll:function onScroll(evt){var raf=window.requestAnimationFrame;if(!raf){this.throttleSyncPostion();}else{raf(this.syncPostion);}},bindEvents:function bindEvents(){this.bodyWrapper.addEventListener('scroll',this.onScroll,{passive:true});if(this.fit){Object(resize_event_["addResizeListener"])(this.$el,this.resizeListener);}},unbindEvents:function unbindEvents(){this.bodyWrapper.removeEventListener('scroll',this.onScroll,{passive:true});if(this.fit){Object(resize_event_["removeResizeListener"])(this.$el,this.resizeListener);}},resizeListener:function resizeListener(){if(!this.$ready)return;var shouldUpdateLayout=false;var el=this.$el;var _resizeState=this.resizeState,oldWidth=_resizeState.width,oldHeight=_resizeState.height;var width=el.offsetWidth;if(oldWidth!==width){shouldUpdateLayout=true;}var height=el.offsetHeight;if((this.height||this.shouldUpdateHeight)&&oldHeight!==height){shouldUpdateLayout=true;}if(shouldUpdateLayout){this.resizeState.width=width;this.resizeState.height=height;this.doLayout();}},doLayout:function doLayout(){if(this.shouldUpdateHeight){this.layout.updateElsHeight();}this.layout.updateColumnsWidth();},sort:function sort(prop,order){this.store.commit('sort',{prop:prop,order:order});},toggleAllSelection:function toggleAllSelection(){this.store.commit('toggleAllSelection');}},computed:tablevue_type_script_lang_js_extends({tableSize:function tableSize(){return this.size||(this.$ELEMENT||{}).size;},bodyWrapper:function bodyWrapper(){return this.$refs.bodyWrapper;},shouldUpdateHeight:function shouldUpdateHeight(){return this.height||this.maxHeight||this.fixedColumns.length>0||this.rightFixedColumns.length>0;},bodyWidth:function bodyWidth(){var _layout=this.layout,bodyWidth=_layout.bodyWidth,scrollY=_layout.scrollY,gutterWidth=_layout.gutterWidth;return bodyWidth?bodyWidth-(scrollY?gutterWidth:0)+'px':'';},bodyHeight:function bodyHeight(){var _layout2=this.layout,_layout2$headerHeight=_layout2.headerHeight,headerHeight=_layout2$headerHeight===undefined?0:_layout2$headerHeight,bodyHeight=_layout2.bodyHeight,_layout2$footerHeight=_layout2.footerHeight,footerHeight=_layout2$footerHeight===undefined?0:_layout2$footerHeight;if(this.height){return{height:bodyHeight?bodyHeight+'px':''};}else if(this.maxHeight){var maxHeight=parseHeight(this.maxHeight);if(typeof maxHeight==='number'){return{'max-height':maxHeight-footerHeight-(this.showHeader?headerHeight:0)+'px'};}}return{};},fixedBodyHeight:function fixedBodyHeight(){if(this.height){return{height:this.layout.fixedBodyHeight?this.layout.fixedBodyHeight+'px':''};}else if(this.maxHeight){var maxHeight=parseHeight(this.maxHeight);if(typeof maxHeight==='number'){maxHeight=this.layout.scrollX?maxHeight-this.layout.gutterWidth:maxHeight;if(this.showHeader){maxHeight-=this.layout.headerHeight;}maxHeight-=this.layout.footerHeight;return{'max-height':maxHeight+'px'};}}return{};},fixedHeight:function fixedHeight(){if(this.maxHeight){if(this.showSummary){return{bottom:0};}return{bottom:this.layout.scrollX&&this.data.length?this.layout.gutterWidth+'px':''};}else{if(this.showSummary){return{height:this.layout.tableHeight?this.layout.tableHeight+'px':''};}return{height:this.layout.viewportHeight?this.layout.viewportHeight+'px':''};}},emptyBlockStyle:function emptyBlockStyle(){if(this.data&&this.data.length)return null;var height='100%';if(this.layout.appendHeight){height='calc(100% - '+this.layout.appendHeight+'px)';}return{width:this.bodyWidth,height:height};}},mapStates({selection:'selection',columns:'columns',tableData:'data',fixedColumns:'fixedColumns',rightFixedColumns:'rightFixedColumns'})),watch:{height:{immediate:true,handler:function handler(value){this.layout.setHeight(value);}},maxHeight:{immediate:true,handler:function handler(value){this.layout.setMaxHeight(value);}},currentRowKey:{immediate:true,handler:function handler(value){if(!this.rowKey)return;this.store.setCurrentRowKey(value);}},data:{immediate:true,handler:function handler(value){this.store.commit('setData',value);}},expandRowKeys:{immediate:true,handler:function handler(newVal){if(newVal){this.store.setExpandRowKeysAdapter(newVal);}}}},created:function created(){var _this=this;this.tableId='el-table_'+tableIdSeed++;this.debouncedUpdateLayout=Object(external_throttle_debounce_["debounce"])(50,function(){return _this.doLayout();});},mounted:function mounted(){var _this2=this;this.bindEvents();this.store.updateColumns();this.doLayout();this.resizeState={width:this.$el.offsetWidth,height:this.$el.offsetHeight};// init filters
this.store.states.columns.forEach(function(column){if(column.filteredValue&&column.filteredValue.length){_this2.store.commit('filterChange',{column:column,values:column.filteredValue,silent:true});}});this.$ready=true;},destroyed:function destroyed(){this.unbindEvents();},data:function data(){var _treeProps=this.treeProps,_treeProps$hasChildre=_treeProps.hasChildren,hasChildren=_treeProps$hasChildre===undefined?'hasChildren':_treeProps$hasChildre,_treeProps$children=_treeProps.children,children=_treeProps$children===undefined?'children':_treeProps$children;this.store=createStore(this,{rowKey:this.rowKey,defaultExpandAll:this.defaultExpandAll,selectOnIndeterminate:this.selectOnIndeterminate,// TreeTable 的相关配置
indent:this.indent,lazy:this.lazy,lazyColumnIdentifier:hasChildren,childrenColumnName:children});var layout=new table_layout({store:this.store,table:this,fit:this.fit,showHeader:this.showHeader});return{layout:layout,isHidden:false,renderExpanded:null,resizeProxyVisible:false,resizeState:{width:null,height:null},// 是否拥有多级表头
isGroup:false,scrollPosition:'left'};}};// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
/* harmony default export */var src_tablevue_type_script_lang_js_=tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/table/src/table.vue
/* normalize component */var table_component=normalizeComponent(src_tablevue_type_script_lang_js_,tablevue_type_template_id_493fe34e_render,tablevue_type_template_id_493fe34e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var table_api;}table_component.options.__file="packages/table/src/table.vue";/* harmony default export */var src_table=table_component.exports;// CONCATENATED MODULE: ./packages/table/index.js
/* istanbul ignore next */src_table.install=function(Vue){Vue.component(src_table.name,src_table);};/* harmony default export */var packages_table=src_table;// CONCATENATED MODULE: ./packages/table/src/config.js
var cellStarts={default:{order:''},selection:{width:48,minWidth:48,realWidth:48,order:'',className:'el-table-column--selection'},expand:{width:48,minWidth:48,realWidth:48,order:''},index:{width:48,minWidth:48,realWidth:48,order:''}};// 这些选项不应该被覆盖
var cellForced={selection:{renderHeader:function renderHeader(h,_ref){var store=_ref.store;return h('el-checkbox',{attrs:{disabled:store.states.data&&store.states.data.length===0,indeterminate:store.states.selection.length>0&&!this.isAllSelected,value:this.isAllSelected},on:{'input':this.toggleAllSelection}});},renderCell:function renderCell(h,_ref2){var row=_ref2.row,column=_ref2.column,isSelected=_ref2.isSelected,store=_ref2.store,$index=_ref2.$index;return h('el-checkbox',{nativeOn:{'click':function click(event){return event.stopPropagation();}},attrs:{value:isSelected,disabled:column.selectable?!column.selectable.call(null,row,$index):false},on:{'input':function input(){store.commit('rowSelectedChanged',row);}}});},sortable:false,resizable:false},index:{renderHeader:function renderHeader(h,_ref3){var column=_ref3.column;return column.label||'#';},renderCell:function renderCell(h,_ref4){var $index=_ref4.$index,column=_ref4.column;var i=$index+1;var index=column.index;if(typeof index==='number'){i=$index+index;}else if(typeof index==='function'){i=index($index);}return h('div',[i]);},sortable:false},expand:{renderHeader:function renderHeader(h,_ref5){var column=_ref5.column;return column.label||'';},renderCell:function renderCell(h,_ref6){var row=_ref6.row,store=_ref6.store,isExpanded=_ref6.isExpanded;var classes=['el-table__expand-icon'];if(isExpanded){classes.push('el-table__expand-icon--expanded');}var callback=function callback(e){e.stopPropagation();store.toggleRowExpansion(row);};return h('div',{'class':classes,on:{'click':callback}},[h('i',{'class':'el-icon el-icon-arrow-right'})]);},sortable:false,resizable:false,className:'el-table__expand-column'}};function defaultRenderCell(h,_ref7){var row=_ref7.row,column=_ref7.column,$index=_ref7.$index;var property=column.property;var value=property&&Object(util_["getPropByPath"])(row,property).v;if(column&&column.formatter){return column.formatter(row,column,value,$index);}return value;}function treeCellPrefix(h,_ref8){var row=_ref8.row,treeNode=_ref8.treeNode,store=_ref8.store;if(!treeNode)return null;var ele=[];var callback=function callback(e){e.stopPropagation();store.loadOrToggle(row);};if(treeNode.indent){ele.push(h('span',{'class':'el-table__indent',style:{'padding-left':treeNode.indent+'px'}}));}if(typeof treeNode.expanded==='boolean'&&!treeNode.noLazyChildren){var expandClasses=['el-table__expand-icon',treeNode.expanded?'el-table__expand-icon--expanded':''];var iconClasses=['el-icon-arrow-right'];if(treeNode.loading){iconClasses=['el-icon-loading'];}ele.push(h('div',{'class':expandClasses,on:{'click':callback}},[h('i',{'class':iconClasses})]));}else{ele.push(h('span',{'class':'el-table__placeholder'}));}return ele;}// CONCATENATED MODULE: ./packages/table/src/table-column.js
var table_column_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var columnIdSeed=1;/* harmony default export */var table_column={name:'ElTableColumn',props:{type:{type:String,default:'default'},label:String,className:String,labelClassName:String,property:String,prop:String,width:{},minWidth:{},renderHeader:Function,sortable:{type:[Boolean,String],default:false},sortMethod:Function,sortBy:[String,Function,Array],resizable:{type:Boolean,default:true},columnKey:String,align:String,headerAlign:String,showTooltipWhenOverflow:Boolean,showOverflowTooltip:Boolean,fixed:[Boolean,String],formatter:Function,selectable:Function,reserveSelection:Boolean,filterMethod:Function,filteredValue:Array,filters:Array,filterPlacement:String,filterMultiple:{type:Boolean,default:true},index:[Number,Function],sortOrders:{type:Array,default:function _default(){return['ascending','descending',null];},validator:function validator(val){return val.every(function(order){return['ascending','descending',null].indexOf(order)>-1;});}}},data:function data(){return{isSubColumn:false,columns:[]};},computed:{owner:function owner(){var parent=this.$parent;while(parent&&!parent.tableId){parent=parent.$parent;}return parent;},columnOrTableParent:function columnOrTableParent(){var parent=this.$parent;while(parent&&!parent.tableId&&!parent.columnId){parent=parent.$parent;}return parent;},realWidth:function realWidth(){return parseWidth(this.width);},realMinWidth:function realMinWidth(){return parseMinWidth(this.minWidth);},realAlign:function realAlign(){return this.align?'is-'+this.align:null;},realHeaderAlign:function realHeaderAlign(){return this.headerAlign?'is-'+this.headerAlign:this.realAlign;}},methods:{getPropsData:function getPropsData(){var _this=this;for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}return props.reduce(function(prev,cur){if(Array.isArray(cur)){cur.forEach(function(key){prev[key]=_this[key];});}return prev;},{});},getColumnElIndex:function getColumnElIndex(children,child){return[].indexOf.call(children,child);},setColumnWidth:function setColumnWidth(column){if(this.realWidth){column.width=this.realWidth;}if(this.realMinWidth){column.minWidth=this.realMinWidth;}if(!column.minWidth){column.minWidth=80;}column.realWidth=column.width===undefined?column.minWidth:column.width;return column;},setColumnForcedProps:function setColumnForcedProps(column){// 对于特定类型的 column，某些属性不允许设置
var type=column.type;var source=cellForced[type]||{};Object.keys(source).forEach(function(prop){var value=source[prop];if(value!==undefined){column[prop]=prop==='className'?column[prop]+' '+value:value;}});return column;},setColumnRenders:function setColumnRenders(column){var _this2=this;var h=this.$createElement;// renderHeader 属性不推荐使用。
if(this.renderHeader){console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');}else if(column.type!=='selection'){column.renderHeader=function(h,scope){var renderHeader=_this2.$scopedSlots.header;return renderHeader?renderHeader(scope):column.label;};}var originRenderCell=column.renderCell;// TODO: 这里的实现调整
if(column.type==='expand'){// 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
column.renderCell=function(h,data){return h('div',{'class':'cell'},[originRenderCell(h,data)]);};this.owner.renderExpanded=function(h,data){return _this2.$scopedSlots.default?_this2.$scopedSlots.default(data):_this2.$slots.default;};}else{originRenderCell=originRenderCell||defaultRenderCell;// 对 renderCell 进行包装
column.renderCell=function(h,data){var children=null;if(_this2.$scopedSlots.default){children=_this2.$scopedSlots.default(data);}else{children=originRenderCell(h,data);}var prefix=treeCellPrefix(h,data);var props={class:'cell',style:{}};if(column.showOverflowTooltip){props.class+=' el-tooltip';props.style={width:(data.column.realWidth||data.column.width)-1+'px'};}return h('div',props,[prefix,children]);};}return column;},registerNormalWatchers:function registerNormalWatchers(){var _this3=this;var props=['label','property','filters','filterMultiple','sortable','index','formatter','className','labelClassName','showOverflowTooltip'];// 一些属性具有别名
var aliases={prop:'property',realAlign:'align',realHeaderAlign:'headerAlign',realWidth:'width'};var allAliases=props.reduce(function(prev,cur){prev[cur]=cur;return prev;},aliases);Object.keys(allAliases).forEach(function(key){var columnKey=aliases[key];_this3.$watch(key,function(newVal){_this3.columnConfig[columnKey]=newVal;});});},registerComplexWatchers:function registerComplexWatchers(){var _this4=this;var props=['fixed'];var aliases={realWidth:'width',realMinWidth:'minWidth'};var allAliases=props.reduce(function(prev,cur){prev[cur]=cur;return prev;},aliases);Object.keys(allAliases).forEach(function(key){var columnKey=aliases[key];_this4.$watch(key,function(newVal){_this4.columnConfig[columnKey]=newVal;var updateColumns=columnKey==='fixed';_this4.owner.store.scheduleLayout(updateColumns);});});}},components:{ElCheckbox:checkbox_default.a},beforeCreate:function beforeCreate(){this.row={};this.column={};this.$index=0;this.columnId='';},created:function created(){var parent=this.columnOrTableParent;this.isSubColumn=this.owner!==parent;this.columnId=(parent.tableId||parent.columnId)+'_column_'+columnIdSeed++;var type=this.type||'default';var sortable=this.sortable===''?true:this.sortable;var defaults=table_column_extends({},cellStarts[type],{id:this.columnId,type:type,property:this.prop||this.property,align:this.realAlign,headerAlign:this.realHeaderAlign,showOverflowTooltip:this.showOverflowTooltip||this.showTooltipWhenOverflow,// filter 相关属性
filterable:this.filters||this.filterMethod,filteredValue:[],filterPlacement:'',isColumnGroup:false,filterOpened:false,// sort 相关属性
sortable:sortable,// index 列
index:this.index});var basicProps=['columnKey','label','className','labelClassName','type','renderHeader','formatter','fixed','resizable'];var sortProps=['sortMethod','sortBy','sortOrders'];var selectProps=['selectable','reserveSelection'];var filterProps=['filterMethod','filters','filterMultiple','filterOpened','filteredValue','filterPlacement'];var column=this.getPropsData(basicProps,sortProps,selectProps,filterProps);column=mergeOptions(defaults,column);// 注意 compose 中函数执行的顺序是从右到左
var chains=compose(this.setColumnRenders,this.setColumnWidth,this.setColumnForcedProps);column=chains(column);this.columnConfig=column;// 注册 watcher
this.registerNormalWatchers();this.registerComplexWatchers();},mounted:function mounted(){var owner=this.owner;var parent=this.columnOrTableParent;var children=this.isSubColumn?parent.$el.children:parent.$refs.hiddenColumns.children;var columnIndex=this.getColumnElIndex(children,this.$el);owner.store.commit('insertColumn',this.columnConfig,columnIndex,this.isSubColumn?parent.columnConfig:null);},destroyed:function destroyed(){if(!this.$parent)return;var parent=this.$parent;this.owner.store.commit('removeColumn',this.columnConfig,this.isSubColumn?parent.columnConfig:null);},render:function render(h){// slots 也要渲染，需要计算合并表头
return h('div',this.$slots.default);}};// CONCATENATED MODULE: ./packages/table-column/index.js
/* istanbul ignore next */table_column.install=function(Vue){Vue.component(table_column.name,table_column);};/* harmony default export */var packages_table_column=table_column;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
var pickervue_type_template_id_79ae069f_render=function pickervue_type_template_id_79ae069f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return!_vm.ranged?_c("el-input",_vm._b({directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor",class:"el-date-editor--"+_vm.type,attrs:{readonly:!_vm.editable||_vm.readonly||_vm.type==="dates"||_vm.type==="week"||_vm.type==="years"||_vm.type==="months",disabled:_vm.pickerDisabled,size:_vm.pickerSize,name:_vm.name,placeholder:_vm.placeholder,value:_vm.displayValue,validateEvent:false},on:{focus:_vm.handleFocus,input:function input(value){return _vm.userInput=value;},change:_vm.handleChange},nativeOn:{keydown:function keydown($event){return _vm.handleKeydown($event);},mouseenter:function mouseenter($event){return _vm.handleMouseEnter($event);},mouseleave:function mouseleave($event){_vm.showClose=false;}}},"el-input",_vm.firstInputId,false),[_c("i",{staticClass:"el-input__icon",class:_vm.triggerClass,attrs:{slot:"prefix"},on:{click:_vm.handleFocus},slot:"prefix"}),_vm.haveTrigger?_c("i",{staticClass:"el-input__icon",class:[_vm.showClose?""+_vm.clearIcon:""],attrs:{slot:"suffix"},on:{click:_vm.handleClickIcon},slot:"suffix"}):_vm._e()]):_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor el-range-editor el-input__inner",class:["el-date-editor--"+_vm.type,_vm.pickerSize?"el-range-editor--"+_vm.pickerSize:"",_vm.pickerDisabled?"is-disabled":"",_vm.pickerVisible?"is-active":""],on:{click:_vm.handleRangeClick,mouseenter:_vm.handleMouseEnter,mouseleave:function mouseleave($event){_vm.showClose=false;},keydown:_vm.handleKeydown}},[_c("i",{class:["el-input__icon","el-range__icon",_vm.triggerClass]}),_c("input",_vm._b({staticClass:"el-range-input",attrs:{autocomplete:"off",placeholder:_vm.startPlaceholder,disabled:_vm.pickerDisabled,readonly:!_vm.editable||_vm.readonly,name:_vm.name&&_vm.name[0]},domProps:{value:_vm.displayValue&&_vm.displayValue[0]},on:{input:_vm.handleStartInput,change:_vm.handleStartChange,focus:_vm.handleFocus}},"input",_vm.firstInputId,false)),_vm._t("range-separator",[_c("span",{staticClass:"el-range-separator"},[_vm._v(_vm._s(_vm.rangeSeparator))])]),_c("input",_vm._b({staticClass:"el-range-input",attrs:{autocomplete:"off",placeholder:_vm.endPlaceholder,disabled:_vm.pickerDisabled,readonly:!_vm.editable||_vm.readonly,name:_vm.name&&_vm.name[1]},domProps:{value:_vm.displayValue&&_vm.displayValue[1]},on:{input:_vm.handleEndInput,change:_vm.handleEndChange,focus:_vm.handleFocus}},"input",_vm.secondInputId,false)),_vm.haveTrigger?_c("i",{staticClass:"el-input__icon el-range__close-icon",class:[_vm.showClose?""+_vm.clearIcon:""],on:{click:_vm.handleClickIcon}}):_vm._e()],2);};var pickervue_type_template_id_79ae069f_staticRenderFns=[];pickervue_type_template_id_79ae069f_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
var date_util_=__webpack_require__(0);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var NewPopper={props:{appendToBody:vue_popper_default.a.props.appendToBody,offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,arrowOffset:vue_popper_default.a.props.arrowOffset,transformOrigin:vue_popper_default.a.props.transformOrigin},methods:vue_popper_default.a.methods,data:function data(){return merge_default()({visibleArrow:true},vue_popper_default.a.data);},beforeDestroy:vue_popper_default.a.beforeDestroy};var DEFAULT_FORMATS={date:'yyyy-MM-dd',month:'yyyy-MM',months:'yyyy-MM',datetime:'yyyy-MM-dd HH:mm:ss',time:'HH:mm:ss',week:'yyyywWW',timerange:'HH:mm:ss',daterange:'yyyy-MM-dd',monthrange:'yyyy-MM',datetimerange:'yyyy-MM-dd HH:mm:ss',year:'yyyy',years:'yyyy'};var HAVE_TRIGGER_TYPES=['date','datetime','time','time-select','week','month','year','daterange','monthrange','timerange','datetimerange','dates','months','years'];var pickervue_type_script_lang_js_DATE_FORMATTER=function DATE_FORMATTER(value,format){if(format==='timestamp')return value.getTime();return Object(date_util_["formatDate"])(value,format);};var pickervue_type_script_lang_js_DATE_PARSER=function DATE_PARSER(text,format){if(format==='timestamp')return new Date(Number(text));return Object(date_util_["parseDate"])(text,format);};var RANGE_FORMATTER=function RANGE_FORMATTER(value,format){if(Array.isArray(value)&&value.length===2){var start=value[0];var end=value[1];if(start&&end){return[pickervue_type_script_lang_js_DATE_FORMATTER(start,format),pickervue_type_script_lang_js_DATE_FORMATTER(end,format)];}}return'';};var RANGE_PARSER=function RANGE_PARSER(array,format,separator){if(!Array.isArray(array)){array=array.split(separator);}if(array.length===2){var range1=array[0];var range2=array[1];return[pickervue_type_script_lang_js_DATE_PARSER(range1,format),pickervue_type_script_lang_js_DATE_PARSER(range2,format)];}return[];};var TYPE_VALUE_RESOLVER_MAP={default:{formatter:function formatter(value){if(!value)return'';return''+value;},parser:function parser(text){if(text===undefined||text==='')return null;return text;}},week:{formatter:function formatter(value,format){var week=Object(date_util_["getWeekNumber"])(value);var month=value.getMonth();var trueDate=new Date(value);if(week===1&&month===11){trueDate.setHours(0,0,0,0);trueDate.setDate(trueDate.getDate()+3-(trueDate.getDay()+6)%7);}var date=Object(date_util_["formatDate"])(trueDate,format);date=/WW/.test(date)?date.replace(/WW/,week<10?'0'+week:week):date.replace(/W/,week);return date;},parser:function parser(text,format){// parse as if a normal date
return TYPE_VALUE_RESOLVER_MAP.date.parser(text,format);}},date:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},datetime:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},daterange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},monthrange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},datetimerange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},timerange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},time:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},month:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},year:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},number:{formatter:function formatter(value){if(!value)return'';return''+value;},parser:function parser(text){var result=Number(text);if(!isNaN(text)){return result;}else{return null;}}},dates:{formatter:function formatter(value,format){return value.map(function(date){return pickervue_type_script_lang_js_DATE_FORMATTER(date,format);});},parser:function parser(value,format){return(typeof value==='string'?value.split(', '):value).map(function(date){return date instanceof Date?date:pickervue_type_script_lang_js_DATE_PARSER(date,format);});}},months:{formatter:function formatter(value,format){return value.map(function(date){return pickervue_type_script_lang_js_DATE_FORMATTER(date,format);});},parser:function parser(value,format){return(typeof value==='string'?value.split(', '):value).map(function(date){return date instanceof Date?date:pickervue_type_script_lang_js_DATE_PARSER(date,format);});}},years:{formatter:function formatter(value,format){return value.map(function(date){return pickervue_type_script_lang_js_DATE_FORMATTER(date,format);});},parser:function parser(value,format){return(typeof value==='string'?value.split(', '):value).map(function(date){return date instanceof Date?date:pickervue_type_script_lang_js_DATE_PARSER(date,format);});}}};var PLACEMENT_MAP={left:'bottom-start',center:'bottom',right:'bottom-end'};var parseAsFormatAndType=function parseAsFormatAndType(value,customFormat,type){var rangeSeparator=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'-';if(!value)return null;var parser=(TYPE_VALUE_RESOLVER_MAP[type]||TYPE_VALUE_RESOLVER_MAP['default']).parser;var format=customFormat||DEFAULT_FORMATS[type];return parser(value,format,rangeSeparator);};var formatAsFormatAndType=function formatAsFormatAndType(value,customFormat,type){if(!value)return null;var formatter=(TYPE_VALUE_RESOLVER_MAP[type]||TYPE_VALUE_RESOLVER_MAP['default']).formatter;var format=customFormat||DEFAULT_FORMATS[type];return formatter(value,format);};/*
 * Considers:
 *   1. Date object
 *   2. date string
 *   3. array of 1 or 2
 */var valueEquals=function valueEquals(a,b){// considers Date object and string
var dateEquals=function dateEquals(a,b){var aIsDate=a instanceof Date;var bIsDate=b instanceof Date;if(aIsDate&&bIsDate){return a.getTime()===b.getTime();}if(!aIsDate&&!bIsDate){return a===b;}return false;};var aIsArray=a instanceof Array;var bIsArray=b instanceof Array;if(aIsArray&&bIsArray){if(a.length!==b.length){return false;}return a.every(function(item,index){return dateEquals(item,b[index]);});}if(!aIsArray&&!bIsArray){return dateEquals(a,b);}return false;};var isString=function isString(val){return typeof val==='string'||val instanceof String;};var pickervue_type_script_lang_js_validator=function validator(val){// either: String, Array of String, null / undefined
return val===null||val===undefined||isString(val)||Array.isArray(val)&&val.length===2&&val.every(isString);};/* harmony default export */var pickervue_type_script_lang_js_={mixins:[emitter_default.a,NewPopper],inject:{elForm:{default:''},elFormItem:{default:''}},props:{size:String,format:String,valueFormat:String,readonly:Boolean,placeholder:String,startPlaceholder:String,endPlaceholder:String,prefixIcon:String,clearIcon:{type:String,default:'el-icon-circle-close'},name:{default:'',validator:pickervue_type_script_lang_js_validator},disabled:Boolean,clearable:{type:Boolean,default:true},id:{default:'',validator:pickervue_type_script_lang_js_validator},popperClass:String,editable:{type:Boolean,default:true},align:{type:String,default:'left'},value:{},defaultValue:{},defaultTime:{},rangeSeparator:{default:'-'},pickerOptions:{},unlinkPanels:Boolean,validateEvent:{type:Boolean,default:true}},components:{ElInput:input_default.a},directives:{Clickoutside:clickoutside_default.a},data:function data(){return{pickerVisible:false,showClose:false,userInput:null,valueOnOpen:null,// value when picker opens, used to determine whether to emit change
unwatchPickerOptions:null};},watch:{pickerVisible:function pickerVisible(val){if(this.readonly||this.pickerDisabled)return;if(val){this.showPicker();this.valueOnOpen=Array.isArray(this.value)?[].concat(this.value):this.value;}else{this.hidePicker();this.emitChange(this.value);this.userInput=null;if(this.validateEvent){this.dispatch('ElFormItem','el.form.blur');}this.$emit('blur',this);this.blur();}},parsedValue:{immediate:true,handler:function handler(val){if(this.picker){this.picker.value=val;}}},defaultValue:function defaultValue(val){// NOTE: should eventually move to jsx style picker + panel ?
if(this.picker){this.picker.defaultValue=val;}},value:function value(val,oldVal){if(!valueEquals(val,oldVal)&&!this.pickerVisible&&this.validateEvent){this.dispatch('ElFormItem','el.form.change',val);}}},computed:{ranged:function ranged(){return this.type.indexOf('range')>-1;},reference:function reference(){var reference=this.$refs.reference;return reference.$el||reference;},refInput:function refInput(){if(this.reference){return[].slice.call(this.reference.querySelectorAll('input'));}return[];},valueIsEmpty:function valueIsEmpty(){var val=this.value;if(Array.isArray(val)){for(var i=0,len=val.length;i<len;i++){if(val[i]){return false;}}}else{if(val){return false;}}return true;},triggerClass:function triggerClass(){return this.prefixIcon||(this.type.indexOf('time')!==-1?'el-icon-time':'el-icon-date');},selectionMode:function selectionMode(){if(this.type==='week'){return'week';}else if(this.type==='month'){return'month';}else if(this.type==='year'){return'year';}else if(this.type==='dates'){return'dates';}else if(this.type==='months'){return'months';}else if(this.type==='years'){return'years';}return'day';},haveTrigger:function haveTrigger(){if(typeof this.showTrigger!=='undefined'){return this.showTrigger;}return HAVE_TRIGGER_TYPES.indexOf(this.type)!==-1;},displayValue:function displayValue(){var formattedValue=formatAsFormatAndType(this.parsedValue,this.format,this.type,this.rangeSeparator);if(Array.isArray(this.userInput)){return[this.userInput[0]||formattedValue&&formattedValue[0]||'',this.userInput[1]||formattedValue&&formattedValue[1]||''];}else if(this.userInput!==null){return this.userInput;}else if(formattedValue){return this.type==='dates'||this.type==='years'||this.type==='months'?formattedValue.join(', '):formattedValue;}else{return'';}},parsedValue:function parsedValue(){if(!this.value)return this.value;// component value is not set
if(this.type==='time-select')return this.value;// time-select does not require parsing, this might change in next major version
var valueIsDateObject=Object(date_util_["isDateObject"])(this.value)||Array.isArray(this.value)&&this.value.every(date_util_["isDateObject"]);if(valueIsDateObject){return this.value;}if(this.valueFormat){return parseAsFormatAndType(this.value,this.valueFormat,this.type,this.rangeSeparator)||this.value;}// NOTE: deal with common but incorrect usage, should remove in next major version
// user might provide string / timestamp without value-format, coerce them into date (or array of date)
return Array.isArray(this.value)?this.value.map(function(val){return new Date(val);}):new Date(this.value);},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},pickerSize:function pickerSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},pickerDisabled:function pickerDisabled(){return this.disabled||(this.elForm||{}).disabled;},firstInputId:function firstInputId(){var obj={};var id=void 0;if(this.ranged){id=this.id&&this.id[0];}else{id=this.id;}if(id)obj.id=id;return obj;},secondInputId:function secondInputId(){var obj={};var id=void 0;if(this.ranged){id=this.id&&this.id[1];}if(id)obj.id=id;return obj;}},created:function created(){// vue-popper
this.popperOptions={boundariesPadding:0,gpuAcceleration:false};this.placement=PLACEMENT_MAP[this.align]||PLACEMENT_MAP.left;this.$on('fieldReset',this.handleFieldReset);},methods:{focus:function focus(){if(!this.ranged){this.$refs.reference.focus();}else{this.handleFocus();}},blur:function blur(){this.refInput.forEach(function(input){return input.blur();});},// {parse, formatTo} Value deals maps component value with internal Date
parseValue:function parseValue(value){var isParsed=Object(date_util_["isDateObject"])(value)||Array.isArray(value)&&value.every(date_util_["isDateObject"]);if(this.valueFormat&&!isParsed){return parseAsFormatAndType(value,this.valueFormat,this.type,this.rangeSeparator)||value;}else{return value;}},formatToValue:function formatToValue(date){var isFormattable=Object(date_util_["isDateObject"])(date)||Array.isArray(date)&&date.every(date_util_["isDateObject"]);if(this.valueFormat&&isFormattable){return formatAsFormatAndType(date,this.valueFormat,this.type,this.rangeSeparator);}else{return date;}},// {parse, formatTo} String deals with user input
parseString:function parseString(value){var type=Array.isArray(value)?this.type:this.type.replace('range','');return parseAsFormatAndType(value,this.format,type);},formatToString:function formatToString(value){var type=Array.isArray(value)?this.type:this.type.replace('range','');return formatAsFormatAndType(value,this.format,type);},handleMouseEnter:function handleMouseEnter(){if(this.readonly||this.pickerDisabled)return;if(!this.valueIsEmpty&&this.clearable){this.showClose=true;}},handleChange:function handleChange(){if(this.userInput){var value=this.parseString(this.displayValue);if(value){this.picker.value=value;if(this.isValidValue(value)){this.emitInput(value);this.userInput=null;}}}if(this.userInput===''){this.emitInput(null);this.emitChange(null);this.userInput=null;}},handleStartInput:function handleStartInput(event){if(this.userInput){this.userInput=[event.target.value,this.userInput[1]];}else{this.userInput=[event.target.value,null];}},handleEndInput:function handleEndInput(event){if(this.userInput){this.userInput=[this.userInput[0],event.target.value];}else{this.userInput=[null,event.target.value];}},handleStartChange:function handleStartChange(event){var value=this.parseString(this.userInput&&this.userInput[0]);if(value){this.userInput=[this.formatToString(value),this.displayValue[1]];var newValue=[value,this.picker.value&&this.picker.value[1]];this.picker.value=newValue;if(this.isValidValue(newValue)){this.emitInput(newValue);this.userInput=null;}}},handleEndChange:function handleEndChange(event){var value=this.parseString(this.userInput&&this.userInput[1]);if(value){this.userInput=[this.displayValue[0],this.formatToString(value)];var newValue=[this.picker.value&&this.picker.value[0],value];this.picker.value=newValue;if(this.isValidValue(newValue)){this.emitInput(newValue);this.userInput=null;}}},handleClickIcon:function handleClickIcon(event){if(this.readonly||this.pickerDisabled)return;if(this.showClose){this.valueOnOpen=this.value;event.stopPropagation();this.emitInput(null);this.emitChange(null);this.showClose=false;if(this.picker&&typeof this.picker.handleClear==='function'){this.picker.handleClear();}}else{this.pickerVisible=!this.pickerVisible;}},handleClose:function handleClose(){if(!this.pickerVisible)return;this.pickerVisible=false;if(this.type==='dates'||this.type==='years'||this.type==='months'){// restore to former value
var oldValue=parseAsFormatAndType(this.valueOnOpen,this.valueFormat,this.type,this.rangeSeparator)||this.valueOnOpen;this.emitInput(oldValue);}},handleFieldReset:function handleFieldReset(initialValue){this.userInput=initialValue===''?null:initialValue;},handleFocus:function handleFocus(){var type=this.type;if(HAVE_TRIGGER_TYPES.indexOf(type)!==-1&&!this.pickerVisible){this.pickerVisible=true;}this.$emit('focus',this);},handleKeydown:function handleKeydown(event){var _this=this;var keyCode=event.keyCode;// ESC
if(keyCode===27){this.pickerVisible=false;event.stopPropagation();return;}// Tab
if(keyCode===9){if(!this.ranged){this.handleChange();this.pickerVisible=this.picker.visible=false;this.blur();event.stopPropagation();}else{// user may change focus between two input
setTimeout(function(){if(_this.refInput.indexOf(document.activeElement)===-1){_this.pickerVisible=false;_this.blur();event.stopPropagation();}},0);}return;}// Enter
if(keyCode===13){if(this.userInput===''||this.isValidValue(this.parseString(this.displayValue))){this.handleChange();this.pickerVisible=this.picker.visible=false;this.blur();}event.stopPropagation();return;}// if user is typing, do not let picker handle key input
if(this.userInput){event.stopPropagation();return;}// delegate other keys to panel
if(this.picker&&this.picker.handleKeydown){this.picker.handleKeydown(event);}},handleRangeClick:function handleRangeClick(){var type=this.type;if(HAVE_TRIGGER_TYPES.indexOf(type)!==-1&&!this.pickerVisible){this.pickerVisible=true;}this.$emit('focus',this);},hidePicker:function hidePicker(){if(this.picker){this.picker.resetView&&this.picker.resetView();this.pickerVisible=this.picker.visible=false;this.destroyPopper();}},showPicker:function showPicker(){var _this2=this;if(this.$isServer)return;if(!this.picker){this.mountPicker();}this.pickerVisible=this.picker.visible=true;this.updatePopper();this.picker.value=this.parsedValue;this.picker.resetView&&this.picker.resetView();this.$nextTick(function(){_this2.picker.adjustSpinners&&_this2.picker.adjustSpinners();});},mountPicker:function mountPicker(){var _this3=this;this.picker=new external_vue_default.a(this.panel).$mount();this.picker.defaultValue=this.defaultValue;this.picker.defaultTime=this.defaultTime;this.picker.popperClass=this.popperClass;this.popperElm=this.picker.$el;this.picker.width=this.reference.getBoundingClientRect().width;this.picker.showTime=this.type==='datetime'||this.type==='datetimerange';this.picker.selectionMode=this.selectionMode;this.picker.unlinkPanels=this.unlinkPanels;this.picker.arrowControl=this.arrowControl||this.timeArrowControl||false;this.$watch('format',function(format){_this3.picker.format=format;});var updateOptions=function updateOptions(){var options=_this3.pickerOptions;if(options&&options.selectableRange){var ranges=options.selectableRange;var parser=TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;var format=DEFAULT_FORMATS.timerange;ranges=Array.isArray(ranges)?ranges:[ranges];_this3.picker.selectableRange=ranges.map(function(range){return parser(range,format,_this3.rangeSeparator);});}for(var option in options){if(options.hasOwnProperty(option)&&// 忽略 time-picker 的该配置项
option!=='selectableRange'){_this3.picker[option]=options[option];}}// main format must prevail over undocumented pickerOptions.format
if(_this3.format){_this3.picker.format=_this3.format;}};updateOptions();this.unwatchPickerOptions=this.$watch('pickerOptions',function(){return updateOptions();},{deep:true});this.$el.appendChild(this.picker.$el);this.picker.resetView&&this.picker.resetView();this.picker.$on('dodestroy',this.doDestroy);this.picker.$on('pick',function(){var date=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var visible=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;_this3.userInput=null;_this3.pickerVisible=_this3.picker.visible=visible;_this3.emitInput(date);_this3.picker.resetView&&_this3.picker.resetView();});this.picker.$on('select-range',function(start,end,pos){if(_this3.refInput.length===0)return;if(!pos||pos==='min'){_this3.refInput[0].setSelectionRange(start,end);_this3.refInput[0].focus();}else if(pos==='max'){_this3.refInput[1].setSelectionRange(start,end);_this3.refInput[1].focus();}});},unmountPicker:function unmountPicker(){if(this.picker){this.picker.$destroy();this.picker.$off();if(typeof this.unwatchPickerOptions==='function'){this.unwatchPickerOptions();}this.picker.$el.parentNode.removeChild(this.picker.$el);}},emitChange:function emitChange(val){// determine user real change only
if(!valueEquals(val,this.valueOnOpen)){this.$emit('change',val);this.valueOnOpen=val;if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',val);}}},emitInput:function emitInput(val){var formatted=this.formatToValue(val);if(!valueEquals(this.value,formatted)){this.$emit('input',formatted);}},isValidValue:function isValidValue(value){if(!this.picker){this.mountPicker();}if(this.picker.isValidValue){return value&&this.picker.isValidValue(value);}else{return true;}}}};// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
/* harmony default export */var src_pickervue_type_script_lang_js_=pickervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
/* normalize component */var picker_component=normalizeComponent(src_pickervue_type_script_lang_js_,pickervue_type_template_id_79ae069f_render,pickervue_type_template_id_79ae069f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var picker_api;}picker_component.options.__file="packages/date-picker/src/picker.vue";/* harmony default export */var picker=picker_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
var datevue_type_template_id_2440d4ea_render=function datevue_type_template_id_2440d4ea_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-enter":_vm.handleEnter,"after-leave":_vm.handleLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts,"has-time":_vm.showTime},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_vm.showTime?_c("div",{staticClass:"el-date-picker__time-header"},[_c("span",{staticClass:"el-date-picker__editor-wrap"},[_c("el-input",{attrs:{placeholder:_vm.t("el.datepicker.selectDate"),value:_vm.visibleDate,size:"small"},on:{input:function input(val){return _vm.userInputDate=val;},change:_vm.handleVisibleDateChange}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleTimePickClose,expression:"handleTimePickClose"}],staticClass:"el-date-picker__editor-wrap"},[_c("el-input",{ref:"input",attrs:{placeholder:_vm.t("el.datepicker.selectTime"),value:_vm.visibleTime,size:"small"},on:{focus:function focus($event){_vm.timePickerVisible=true;},input:function input(val){return _vm.userInputTime=val;},change:_vm.handleVisibleTimeChange}}),_c("time-picker",{ref:"timepicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.timePickerVisible},on:{pick:_vm.handleTimePick,mounted:_vm.proxyTimePickerDataProperties}})],1)]):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView!=="time",expression:"currentView !== 'time'"}],staticClass:"el-date-picker__header",class:{"el-date-picker__header--bordered":_vm.currentView==="year"||_vm.currentView==="month"}},[_c("button",{staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",attrs:{type:"button","aria-label":_vm.t("el.datepicker.prevYear")},on:{click:_vm.prevYear}}),_c("button",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",attrs:{type:"button","aria-label":_vm.t("el.datepicker.prevMonth")},on:{click:_vm.prevMonth}}),_c("span",{staticClass:"el-date-picker__header-label",attrs:{role:"button"},on:{click:_vm.showYearPicker}},[_vm._v(_vm._s(_vm.yearLabel))]),_c("span",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-date-picker__header-label",class:{active:_vm.currentView==="month"},attrs:{role:"button"},on:{click:_vm.showMonthPicker}},[_vm._v(_vm._s(_vm.t("el.datepicker.month"+(_vm.month+1))))]),_c("button",{staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",attrs:{type:"button","aria-label":_vm.t("el.datepicker.nextYear")},on:{click:_vm.nextYear}}),_c("button",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",attrs:{type:"button","aria-label":_vm.t("el.datepicker.nextMonth")},on:{click:_vm.nextMonth}})]),_c("div",{staticClass:"el-picker-panel__content"},[_c("date-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],attrs:{"selection-mode":_vm.selectionMode,"first-day-of-week":_vm.firstDayOfWeek,value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"cell-class-name":_vm.cellClassName,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleDatePick}}),_c("year-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="year",expression:"currentView === 'year'"}],attrs:{"selection-mode":_vm.selectionMode,value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleYearPick}}),_c("month-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="month",expression:"currentView === 'month'"}],attrs:{"selection-mode":_vm.selectionMode,value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleMonthPick}})],1)])],2),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.footerVisible&&(_vm.currentView==="date"||_vm.currentView==="month"||_vm.currentView==="year"),expression:"footerVisible && (currentView === 'date' || currentView === 'month' || currentView === 'year')"}],staticClass:"el-picker-panel__footer"},[_c("el-button",{directives:[{name:"show",rawName:"v-show",value:_vm.selectionMode!=="dates"&&_vm.selectionMode!=="months"&&_vm.selectionMode!=="years",expression:"selectionMode !== 'dates' && selectionMode !== 'months' && selectionMode !== 'years'"}],staticClass:"el-picker-panel__link-btn",attrs:{size:"mini",type:"text"},on:{click:_vm.changeToNow}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.now"))+"\n      ")]),_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{plain:"",size:"mini"},on:{click:_vm.confirm}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.confirm"))+"\n      ")])],1)])]);};var datevue_type_template_id_2440d4ea_staticRenderFns=[];datevue_type_template_id_2440d4ea_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
var timevue_type_template_id_3d939089_render=function timevue_type_template_id_3d939089_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-time-panel el-popper",class:_vm.popperClass},[_c("div",{staticClass:"el-time-panel__content",class:{"has-seconds":_vm.showSeconds}},[_c("time-spinner",{ref:"spinner",attrs:{"arrow-control":_vm.useArrow,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,date:_vm.date},on:{change:_vm.handleChange,"select-range":_vm.setSelectionRange}})],1),_c("div",{staticClass:"el-time-panel__footer"},[_c("button",{staticClass:"el-time-panel__btn cancel",attrs:{type:"button"},on:{click:_vm.handleCancel}},[_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]),_c("button",{staticClass:"el-time-panel__btn",class:{confirm:!_vm.disabled},attrs:{type:"button"},on:{click:function click($event){_vm.handleConfirm();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))])])])]);};var timevue_type_template_id_3d939089_staticRenderFns=[];timevue_type_template_id_3d939089_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
var time_spinnervue_type_template_id_1facadeb_render=function time_spinnervue_type_template_id_1facadeb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-time-spinner",class:{"has-seconds":_vm.showSeconds}},[!_vm.arrowControl?[_c("el-scrollbar",{ref:"hours",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("hours");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("hours");}}},_vm._l(_vm.hoursList,function(disabled,hour){return _c("li",{key:hour,staticClass:"el-time-spinner__item",class:{active:hour===_vm.hours,disabled:disabled},on:{click:function click($event){_vm.handleClick("hours",{value:hour,disabled:disabled});}}},[_vm._v(_vm._s(("0"+(_vm.amPmMode?hour%12||12:hour)).slice(-2))+_vm._s(_vm.amPm(hour)))]);}),0),_c("el-scrollbar",{ref:"minutes",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("minutes");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("minutes");}}},_vm._l(_vm.minutesList,function(enabled,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:key===_vm.minutes,disabled:!enabled},on:{click:function click($event){_vm.handleClick("minutes",{value:key,disabled:false});}}},[_vm._v(_vm._s(("0"+key).slice(-2)))]);}),0),_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.showSeconds,expression:"showSeconds"}],ref:"seconds",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("seconds");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("seconds");}}},_vm._l(60,function(second,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:key===_vm.seconds},on:{click:function click($event){_vm.handleClick("seconds",{value:key,disabled:false});}}},[_vm._v(_vm._s(("0"+key).slice(-2)))]);}),0)]:_vm._e(),_vm.arrowControl?[_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("hours");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"hours",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowHourList,function(hour,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:hour===_vm.hours,disabled:_vm.hoursList[hour]}},[_vm._v(_vm._s(hour===undefined?"":("0"+(_vm.amPmMode?hour%12||12:hour)).slice(-2)+_vm.amPm(hour)))]);}),0)]),_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("minutes");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"minutes",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowMinuteList,function(minute,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:minute===_vm.minutes}},[_vm._v("\n          "+_vm._s(minute===undefined?"":("0"+minute).slice(-2))+"\n        ")]);}),0)]),_vm.showSeconds?_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("seconds");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"seconds",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowSecondList,function(second,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:second===_vm.seconds}},[_vm._v("\n          "+_vm._s(second===undefined?"":("0"+second).slice(-2))+"\n        ")]);}),0)]):_vm._e()]:_vm._e()],2);};var time_spinnervue_type_template_id_1facadeb_staticRenderFns=[];time_spinnervue_type_template_id_1facadeb_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var time_spinnervue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},directives:{repeatClick:repeat_click},props:{date:{},defaultValue:{},// reserved for future use
showSeconds:{type:Boolean,default:true},arrowControl:Boolean,amPmMode:{type:String,default:''// 'a': am/pm; 'A': AM/PM
}},computed:{hours:function hours(){return this.date.getHours();},minutes:function minutes(){return this.date.getMinutes();},seconds:function seconds(){return this.date.getSeconds();},hoursList:function hoursList(){return Object(date_util_["getRangeHours"])(this.selectableRange);},minutesList:function minutesList(){return Object(date_util_["getRangeMinutes"])(this.selectableRange,this.hours);},arrowHourList:function arrowHourList(){var hours=this.hours;return[hours>0?hours-1:undefined,hours,hours<23?hours+1:undefined];},arrowMinuteList:function arrowMinuteList(){var minutes=this.minutes;return[minutes>0?minutes-1:undefined,minutes,minutes<59?minutes+1:undefined];},arrowSecondList:function arrowSecondList(){var seconds=this.seconds;return[seconds>0?seconds-1:undefined,seconds,seconds<59?seconds+1:undefined];}},data:function data(){return{selectableRange:[],currentScrollbar:null};},mounted:function mounted(){var _this=this;this.$nextTick(function(){!_this.arrowControl&&_this.bindScrollEvent();});},methods:{increase:function increase(){this.scrollDown(1);},decrease:function decrease(){this.scrollDown(-1);},modifyDateField:function modifyDateField(type,value){switch(type){case'hours':this.$emit('change',Object(date_util_["modifyTime"])(this.date,value,this.minutes,this.seconds));break;case'minutes':this.$emit('change',Object(date_util_["modifyTime"])(this.date,this.hours,value,this.seconds));break;case'seconds':this.$emit('change',Object(date_util_["modifyTime"])(this.date,this.hours,this.minutes,value));break;}},handleClick:function handleClick(type,_ref){var value=_ref.value,disabled=_ref.disabled;if(!disabled){this.modifyDateField(type,value);this.emitSelectRange(type);this.adjustSpinner(type,value);}},emitSelectRange:function emitSelectRange(type){if(type==='hours'){this.$emit('select-range',0,2);}else if(type==='minutes'){this.$emit('select-range',3,5);}else if(type==='seconds'){this.$emit('select-range',6,8);}this.currentScrollbar=type;},bindScrollEvent:function bindScrollEvent(){var _this2=this;var bindFunction=function bindFunction(type){_this2.$refs[type].wrap.onscroll=function(e){// TODO: scroll is emitted when set scrollTop programatically
// should find better solutions in the future!
_this2.handleScroll(type,e);};};bindFunction('hours');bindFunction('minutes');bindFunction('seconds');},handleScroll:function handleScroll(type){var value=Math.min(Math.round((this.$refs[type].wrap.scrollTop-(this.scrollBarHeight(type)*0.5-10)/this.typeItemHeight(type)+3)/this.typeItemHeight(type)),type==='hours'?23:59);this.modifyDateField(type,value);},// NOTE: used by datetime / date-range panel
//       renamed from adjustScrollTop
//       should try to refactory it
adjustSpinners:function adjustSpinners(){this.adjustSpinner('hours',this.hours);this.adjustSpinner('minutes',this.minutes);this.adjustSpinner('seconds',this.seconds);},adjustCurrentSpinner:function adjustCurrentSpinner(type){this.adjustSpinner(type,this[type]);},adjustSpinner:function adjustSpinner(type,value){if(this.arrowControl)return;var el=this.$refs[type].wrap;if(el){el.scrollTop=Math.max(0,value*this.typeItemHeight(type));}},scrollDown:function scrollDown(step){var _this3=this;if(!this.currentScrollbar){this.emitSelectRange('hours');}var label=this.currentScrollbar;var hoursList=this.hoursList;var now=this[label];if(this.currentScrollbar==='hours'){var total=Math.abs(step);step=step>0?1:-1;var length=hoursList.length;while(length--&&total){now=(now+step+hoursList.length)%hoursList.length;if(hoursList[now]){continue;}total--;}if(hoursList[now])return;}else{now=(now+step+60)%60;}this.modifyDateField(label,now);this.adjustSpinner(label,now);this.$nextTick(function(){return _this3.emitSelectRange(_this3.currentScrollbar);});},amPm:function amPm(hour){var shouldShowAmPm=this.amPmMode.toLowerCase()==='a';if(!shouldShowAmPm)return'';var isCapital=this.amPmMode==='A';var content=hour<12?' am':' pm';if(isCapital)content=content.toUpperCase();return content;},typeItemHeight:function typeItemHeight(type){return this.$refs[type].$el.querySelector('li').offsetHeight;},scrollBarHeight:function scrollBarHeight(type){return this.$refs[type].$el.offsetHeight;}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
/* harmony default export */var basic_time_spinnervue_type_script_lang_js_=time_spinnervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
/* normalize component */var time_spinner_component=normalizeComponent(basic_time_spinnervue_type_script_lang_js_,time_spinnervue_type_template_id_1facadeb_render,time_spinnervue_type_template_id_1facadeb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_spinner_api;}time_spinner_component.options.__file="packages/date-picker/src/basic/time-spinner.vue";/* harmony default export */var time_spinner=time_spinner_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var timevue_type_script_lang_js_={mixins:[locale_default.a],components:{TimeSpinner:time_spinner},props:{visible:Boolean,timeArrowControl:Boolean},watch:{visible:function visible(val){var _this=this;if(val){this.oldValue=this.value;this.$nextTick(function(){return _this.$refs.spinner.emitSelectRange('hours');});}else{this.needInitAdjust=true;}},value:function value(newVal){var _this2=this;var date=void 0;if(newVal instanceof Date){date=Object(date_util_["limitTimeRange"])(newVal,this.selectableRange,this.format);}else if(!newVal){date=this.defaultValue?new Date(this.defaultValue):new Date();}this.date=date;if(this.visible&&this.needInitAdjust){this.$nextTick(function(_){return _this2.adjustSpinners();});this.needInitAdjust=false;}},selectableRange:function selectableRange(val){this.$refs.spinner.selectableRange=val;},defaultValue:function defaultValue(val){if(!Object(date_util_["isDate"])(this.value)){this.date=val?new Date(val):new Date();}}},data:function data(){return{popperClass:'',format:'HH:mm:ss',value:'',defaultValue:null,date:new Date(),oldValue:new Date(),selectableRange:[],selectionRange:[0,2],disabled:false,arrowControl:false,needInitAdjust:true};},computed:{showSeconds:function showSeconds(){return(this.format||'').indexOf('ss')!==-1;},useArrow:function useArrow(){return this.arrowControl||this.timeArrowControl||false;},amPmMode:function amPmMode(){if((this.format||'').indexOf('A')!==-1)return'A';if((this.format||'').indexOf('a')!==-1)return'a';return'';}},methods:{handleCancel:function handleCancel(){this.$emit('pick',this.oldValue,false);},handleChange:function handleChange(date){// this.visible avoids edge cases, when use scrolls during panel closing animation
if(this.visible){this.date=Object(date_util_["clearMilliseconds"])(date);// if date is out of range, do not emit
if(this.isValidValue(this.date)){this.$emit('pick',this.date,true);}}},setSelectionRange:function setSelectionRange(start,end){this.$emit('select-range',start,end);this.selectionRange=[start,end];},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var first=arguments[1];if(first)return;var date=Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date,this.selectableRange,this.format));this.$emit('pick',date,visible,first);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var mapping={38:-1,40:1,37:-1,39:1};// Left or Right
if(keyCode===37||keyCode===39){var step=mapping[keyCode];this.changeSelectionRange(step);event.preventDefault();return;}// Up or Down
if(keyCode===38||keyCode===40){var _step=mapping[keyCode];this.$refs.spinner.scrollDown(_step);event.preventDefault();return;}},isValidValue:function isValidValue(date){return Object(date_util_["timeWithinRange"])(date,this.selectableRange,this.format);},adjustSpinners:function adjustSpinners(){return this.$refs.spinner.adjustSpinners();},changeSelectionRange:function changeSelectionRange(step){var list=[0,3].concat(this.showSeconds?[6]:[]);var mapping=['hours','minutes'].concat(this.showSeconds?['seconds']:[]);var index=list.indexOf(this.selectionRange[0]);var next=(index+step+list.length)%list.length;this.$refs.spinner.emitSelectRange(mapping[next]);}},mounted:function mounted(){var _this3=this;this.$nextTick(function(){return _this3.handleConfirm(true,true);});this.$emit('mounted');}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
/* harmony default export */var panel_timevue_type_script_lang_js_=timevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
/* normalize component */var time_component=normalizeComponent(panel_timevue_type_script_lang_js_,timevue_type_template_id_3d939089_render,timevue_type_template_id_3d939089_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_api;}time_component.options.__file="packages/date-picker/src/panel/time.vue";/* harmony default export */var panel_time=time_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
var year_tablevue_type_template_id_c86ab5e0_render=function year_tablevue_type_template_id_c86ab5e0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-year-table",on:{click:_vm.handleYearTableClick}},[_c("tbody",[_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+0)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+1)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+1))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+2)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+2))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+3)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+3))])])]),_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+4)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+4))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+5)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+5))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+6)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+6))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+7)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+7))])])]),_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+8)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+8))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+9)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+9))])]),_c("td"),_c("td")])])]);};var year_tablevue_type_template_id_c86ab5e0_staticRenderFns=[];year_tablevue_type_template_id_c86ab5e0_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var year_tablevue_type_script_lang_js_datesInYear=function datesInYear(year){var numOfDays=Object(date_util_["getDayCountOfYear"])(year);var firstDay=new Date(year,0,1);return Object(date_util_["range"])(numOfDays).map(function(n){return Object(date_util_["nextDate"])(firstDay,n);});};/* harmony default export */var year_tablevue_type_script_lang_js_={props:{disabledDate:{},value:{},defaultValue:{validator:function validator(val){// null or valid Date Object
return val===null||val instanceof Date&&Object(date_util_["isDate"])(val);}},date:{},selectionMode:{}},computed:{startYear:function startYear(){return Math.floor(this.date.getFullYear()/10)*10;}},methods:{getCellStyle:function getCellStyle(year){var style={};var today=new Date();style.disabled=typeof this.disabledDate==='function'?year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate):false;style.current=Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value),function(date){return date.getFullYear()===year;})>=0;style.today=today.getFullYear()===year;style.default=this.defaultValue&&this.defaultValue.getFullYear()===year;return style;},handleYearTableClick:function handleYearTableClick(event){var target=event.target;if(target.tagName==='A'){if(Object(dom_["hasClass"])(target.parentNode,'disabled'))return;var year=target.textContent||target.innerText;if(this.selectionMode==='years'){var value=this.value||[];var idx=Object(util_["arrayFindIndex"])(value,function(date){return date.getFullYear()===Number(year);});var newValue=idx>-1?[].concat(value.slice(0,idx),value.slice(idx+1)):[].concat(value,[new Date(year)]);this.$emit('pick',newValue);}else{this.$emit('pick',Number(year));}}}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_year_tablevue_type_script_lang_js_=year_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
/* normalize component */var year_table_component=normalizeComponent(basic_year_tablevue_type_script_lang_js_,year_tablevue_type_template_id_c86ab5e0_render,year_tablevue_type_template_id_c86ab5e0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var year_table_api;}year_table_component.options.__file="packages/date-picker/src/basic/year-table.vue";/* harmony default export */var year_table=year_table_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
var month_tablevue_type_template_id_654d4f42_render=function month_tablevue_type_template_id_654d4f42_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-month-table",on:{click:_vm.handleMonthTableClick,mousemove:_vm.handleMouseMove}},[_c("tbody",_vm._l(_vm.rows,function(row,key){return _c("tr",{key:key},_vm._l(row,function(cell,key){return _c("td",{key:key,class:_vm.getCellStyle(cell)},[_c("div",[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.t("el.datepicker.months."+_vm.months[cell.text])))])])]);}),0);}),0)]);};var month_tablevue_type_template_id_654d4f42_staticRenderFns=[];month_tablevue_type_template_id_654d4f42_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var month_tablevue_type_script_lang_js_datesInMonth=function datesInMonth(year,month){var numOfDays=Object(date_util_["getDayCountOfMonth"])(year,month);var firstDay=new Date(year,month,1);return Object(date_util_["range"])(numOfDays).map(function(n){return Object(date_util_["nextDate"])(firstDay,n);});};var clearDate=function clearDate(date){return new Date(date.getFullYear(),date.getMonth());};var getMonthTimestamp=function getMonthTimestamp(time){if(typeof time==='number'||typeof time==='string'){return clearDate(new Date(time)).getTime();}else if(time instanceof Date){return clearDate(time).getTime();}else{return NaN;}};// remove the first element that satisfies `pred` from arr
// return a new array if modification occurs
// return the original array otherwise
var month_tablevue_type_script_lang_js_removeFromArray=function removeFromArray(arr,pred){var idx=typeof pred==='function'?Object(util_["arrayFindIndex"])(arr,pred):arr.indexOf(pred);return idx>=0?[].concat(arr.slice(0,idx),arr.slice(idx+1)):arr;};/* harmony default export */var month_tablevue_type_script_lang_js_={props:{disabledDate:{},value:{},selectionMode:{default:'month'},minDate:{},maxDate:{},defaultValue:{validator:function validator(val){// null or valid Date Object
return val===null||Object(date_util_["isDate"])(val)||Array.isArray(val)&&val.every(date_util_["isDate"]);}},date:{},rangeState:{default:function _default(){return{endDate:null,selecting:false};}}},mixins:[locale_default.a],watch:{'rangeState.endDate':function rangeStateEndDate(newVal){this.markRange(this.minDate,newVal);},minDate:function minDate(newVal,oldVal){if(getMonthTimestamp(newVal)!==getMonthTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}},maxDate:function maxDate(newVal,oldVal){if(getMonthTimestamp(newVal)!==getMonthTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}}},data:function data(){return{months:['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'],tableRows:[[],[],[]],lastRow:null,lastColumn:null};},methods:{cellMatchesDate:function cellMatchesDate(cell,date){var value=new Date(date);return this.date.getFullYear()===value.getFullYear()&&Number(cell.text)===value.getMonth();},getCellStyle:function getCellStyle(cell){var _this=this;var style={};var year=this.date.getFullYear();var today=new Date();var month=cell.text;var defaultValue=this.defaultValue?Array.isArray(this.defaultValue)?this.defaultValue:[this.defaultValue]:[];style.disabled=typeof this.disabledDate==='function'?month_tablevue_type_script_lang_js_datesInMonth(year,month).every(this.disabledDate):false;style.current=Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value),function(date){return date.getFullYear()===year&&date.getMonth()===month;})>=0;style.today=today.getFullYear()===year&&today.getMonth()===month;style.default=defaultValue.some(function(date){return _this.cellMatchesDate(cell,date);});if(cell.inRange){style['in-range']=true;if(cell.start){style['start-date']=true;}if(cell.end){style['end-date']=true;}}return style;},getMonthOfCell:function getMonthOfCell(month){var year=this.date.getFullYear();return new Date(year,month,1);},markRange:function markRange(minDate,maxDate){minDate=getMonthTimestamp(minDate);maxDate=getMonthTimestamp(maxDate)||minDate;var _ref=[Math.min(minDate,maxDate),Math.max(minDate,maxDate)];minDate=_ref[0];maxDate=_ref[1];var rows=this.rows;for(var i=0,k=rows.length;i<k;i++){var row=rows[i];for(var j=0,l=row.length;j<l;j++){var cell=row[j];var index=i*4+j;var time=new Date(this.date.getFullYear(),index).getTime();cell.inRange=minDate&&time>=minDate&&time<=maxDate;cell.start=minDate&&time===minDate;cell.end=maxDate&&time===maxDate;}}},handleMouseMove:function handleMouseMove(event){if(!this.rangeState.selecting)return;var target=event.target;if(target.tagName==='A'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex;var column=target.cellIndex;// can not select disabled date
if(this.rows[row][column].disabled)return;// only update rangeState when mouse moves to a new cell
// this avoids frequent Date object creation and improves performance
if(row!==this.lastRow||column!==this.lastColumn){this.lastRow=row;this.lastColumn=column;this.$emit('changerange',{minDate:this.minDate,maxDate:this.maxDate,rangeState:{selecting:true,endDate:this.getMonthOfCell(row*4+column)}});}},handleMonthTableClick:function handleMonthTableClick(event){var target=event.target;if(target.tagName==='A'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;if(Object(dom_["hasClass"])(target,'disabled'))return;var column=target.cellIndex;var row=target.parentNode.rowIndex;var month=row*4+column;var newDate=this.getMonthOfCell(month);if(this.selectionMode==='range'){if(!this.rangeState.selecting){this.$emit('pick',{minDate:newDate,maxDate:null});this.rangeState.selecting=true;}else{if(newDate>=this.minDate){this.$emit('pick',{minDate:this.minDate,maxDate:newDate});}else{this.$emit('pick',{minDate:newDate,maxDate:this.minDate});}this.rangeState.selecting=false;}}else if(this.selectionMode==='months'){var value=this.value||[];var year=this.date.getFullYear();var newValue=Object(util_["arrayFindIndex"])(value,function(date){return date.getFullYear()===year&&date.getMonth()===month;})>=0?month_tablevue_type_script_lang_js_removeFromArray(value,function(date){return date.getTime()===newDate.getTime();}):[].concat(value,[newDate]);this.$emit('pick',newValue);}else{this.$emit('pick',month);}}},computed:{rows:function rows(){var _this2=this;// TODO: refactory rows / getCellClasses
var rows=this.tableRows;var disabledDate=this.disabledDate;var selectedDate=[];var now=getMonthTimestamp(new Date());for(var i=0;i<3;i++){var row=rows[i];var _loop=function _loop(j){var cell=row[j];if(!cell){cell={row:i,column:j,type:'normal',inRange:false,start:false,end:false};}cell.type='normal';var index=i*4+j;var time=new Date(_this2.date.getFullYear(),index).getTime();cell.inRange=time>=getMonthTimestamp(_this2.minDate)&&time<=getMonthTimestamp(_this2.maxDate);cell.start=_this2.minDate&&time===getMonthTimestamp(_this2.minDate);cell.end=_this2.maxDate&&time===getMonthTimestamp(_this2.maxDate);var isToday=time===now;if(isToday){cell.type='today';}cell.text=index;var cellDate=new Date(time);cell.disabled=typeof disabledDate==='function'&&disabledDate(cellDate);cell.selected=Object(util_["arrayFind"])(selectedDate,function(date){return date.getTime()===cellDate.getTime();});_this2.$set(row,j,cell);};for(var j=0;j<4;j++){_loop(j);}}return rows;}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_month_tablevue_type_script_lang_js_=month_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
/* normalize component */var month_table_component=normalizeComponent(basic_month_tablevue_type_script_lang_js_,month_tablevue_type_template_id_654d4f42_render,month_tablevue_type_template_id_654d4f42_staticRenderFns,false,null,null,null);/* hot reload */if(false){var month_table_api;}month_table_component.options.__file="packages/date-picker/src/basic/month-table.vue";/* harmony default export */var month_table=month_table_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
var date_tablevue_type_template_id_5d1f3341_render=function date_tablevue_type_template_id_5d1f3341_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-date-table",class:{"is-week-mode":_vm.selectionMode==="week"},attrs:{cellspacing:"0",cellpadding:"0"},on:{click:_vm.handleClick,mousemove:_vm.handleMouseMove}},[_c("tbody",[_c("tr",[_vm.showWeekNumber?_c("th",[_vm._v(_vm._s(_vm.t("el.datepicker.week")))]):_vm._e(),_vm._l(_vm.WEEKS,function(week,key){return _c("th",{key:key},[_vm._v(_vm._s(_vm.t("el.datepicker.weeks."+week)))]);})],2),_vm._l(_vm.rows,function(row,key){return _c("tr",{key:key,staticClass:"el-date-table__row",class:{current:_vm.isWeekActive(row[1])}},_vm._l(row,function(cell,key){return _c("td",{key:key,class:_vm.getCellClasses(cell)},[_c("div",[_c("span",[_vm._v("\n          "+_vm._s(cell.text)+"\n        ")])])]);}),0);})],2)]);};var date_tablevue_type_template_id_5d1f3341_staticRenderFns=[];date_tablevue_type_template_id_5d1f3341_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _WEEKS=['sun','mon','tue','wed','thu','fri','sat'];var date_tablevue_type_script_lang_js_getDateTimestamp=function getDateTimestamp(time){if(typeof time==='number'||typeof time==='string'){return Object(date_util_["clearTime"])(new Date(time)).getTime();}else if(time instanceof Date){return Object(date_util_["clearTime"])(time).getTime();}else{return NaN;}};// remove the first element that satisfies `pred` from arr
// return a new array if modification occurs
// return the original array otherwise
var date_tablevue_type_script_lang_js_removeFromArray=function removeFromArray(arr,pred){var idx=typeof pred==='function'?Object(util_["arrayFindIndex"])(arr,pred):arr.indexOf(pred);return idx>=0?[].concat(arr.slice(0,idx),arr.slice(idx+1)):arr;};/* harmony default export */var date_tablevue_type_script_lang_js_={mixins:[locale_default.a],props:{firstDayOfWeek:{default:7,type:Number,validator:function validator(val){return val>=1&&val<=7;}},value:{},defaultValue:{validator:function validator(val){// either: null, valid Date object, Array of valid Date objects
return val===null||Object(date_util_["isDate"])(val)||Array.isArray(val)&&val.every(date_util_["isDate"]);}},date:{},selectionMode:{default:'day'},showWeekNumber:{type:Boolean,default:false},disabledDate:{},cellClassName:{},minDate:{},maxDate:{},rangeState:{default:function _default(){return{endDate:null,selecting:false};}}},computed:{offsetDay:function offsetDay(){var week=this.firstDayOfWeek;// 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
return week>3?7-week:-week;},WEEKS:function WEEKS(){var week=this.firstDayOfWeek;return _WEEKS.concat(_WEEKS).slice(week,week+7);},year:function year(){return this.date.getFullYear();},month:function month(){return this.date.getMonth();},startDate:function startDate(){return Object(date_util_["getStartDateOfMonth"])(this.year,this.month);},rows:function rows(){var _this=this;// TODO: refactory rows / getCellClasses
var date=new Date(this.year,this.month,1);var day=Object(date_util_["getFirstDayOfMonth"])(date);// day of first day
var dateCountOfMonth=Object(date_util_["getDayCountOfMonth"])(date.getFullYear(),date.getMonth());var dateCountOfLastMonth=Object(date_util_["getDayCountOfMonth"])(date.getFullYear(),date.getMonth()===0?11:date.getMonth()-1);day=day===0?7:day;var offset=this.offsetDay;var rows=this.tableRows;var count=1;var startDate=this.startDate;var disabledDate=this.disabledDate;var cellClassName=this.cellClassName;var selectedDate=this.selectionMode==='dates'?Object(util_["coerceTruthyValueToArray"])(this.value):[];var now=date_tablevue_type_script_lang_js_getDateTimestamp(new Date());for(var i=0;i<6;i++){var row=rows[i];if(this.showWeekNumber){if(!row[0]){row[0]={type:'week',text:Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate,i*7+1))};}}var _loop=function _loop(j){var cell=row[_this.showWeekNumber?j+1:j];if(!cell){cell={row:i,column:j,type:'normal',inRange:false,start:false,end:false};}cell.type='normal';var index=i*7+j;var time=Object(date_util_["nextDate"])(startDate,index-offset).getTime();cell.inRange=time>=date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate)&&time<=date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);cell.start=_this.minDate&&time===date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);cell.end=_this.maxDate&&time===date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);var isToday=time===now;if(isToday){cell.type='today';}if(i>=0&&i<=1){var numberOfDaysFromPreviousMonth=day+offset<0?7+day+offset:day+offset;if(j+i*7>=numberOfDaysFromPreviousMonth){cell.text=count++;}else{cell.text=dateCountOfLastMonth-(numberOfDaysFromPreviousMonth-j%7)+1+i*7;cell.type='prev-month';}}else{if(count<=dateCountOfMonth){cell.text=count++;}else{cell.text=count++-dateCountOfMonth;cell.type='next-month';}}var cellDate=new Date(time);cell.disabled=typeof disabledDate==='function'&&disabledDate(cellDate);cell.selected=Object(util_["arrayFind"])(selectedDate,function(date){return date.getTime()===cellDate.getTime();});cell.customClass=typeof cellClassName==='function'&&cellClassName(cellDate);_this.$set(row,_this.showWeekNumber?j+1:j,cell);};for(var j=0;j<7;j++){_loop(j);}if(this.selectionMode==='week'){var start=this.showWeekNumber?1:0;var end=this.showWeekNumber?7:6;var isWeekActive=this.isWeekActive(row[start+1]);row[start].inRange=isWeekActive;row[start].start=isWeekActive;row[end].inRange=isWeekActive;row[end].end=isWeekActive;}}return rows;}},watch:{'rangeState.endDate':function rangeStateEndDate(newVal){this.markRange(this.minDate,newVal);},minDate:function minDate(newVal,oldVal){if(date_tablevue_type_script_lang_js_getDateTimestamp(newVal)!==date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}},maxDate:function maxDate(newVal,oldVal){if(date_tablevue_type_script_lang_js_getDateTimestamp(newVal)!==date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}}},data:function data(){return{tableRows:[[],[],[],[],[],[]],lastRow:null,lastColumn:null};},methods:{cellMatchesDate:function cellMatchesDate(cell,date){var value=new Date(date);return this.year===value.getFullYear()&&this.month===value.getMonth()&&Number(cell.text)===value.getDate();},getCellClasses:function getCellClasses(cell){var _this2=this;var selectionMode=this.selectionMode;var defaultValue=this.defaultValue?Array.isArray(this.defaultValue)?this.defaultValue:[this.defaultValue]:[];var classes=[];if((cell.type==='normal'||cell.type==='today')&&!cell.disabled){classes.push('available');if(cell.type==='today'){classes.push('today');}}else{classes.push(cell.type);}if(cell.type==='normal'&&defaultValue.some(function(date){return _this2.cellMatchesDate(cell,date);})){classes.push('default');}if(selectionMode==='day'&&(cell.type==='normal'||cell.type==='today')&&this.cellMatchesDate(cell,this.value)){classes.push('current');}if(cell.inRange&&(cell.type==='normal'||cell.type==='today'||this.selectionMode==='week')){classes.push('in-range');if(cell.start){classes.push('start-date');}if(cell.end){classes.push('end-date');}}if(cell.disabled){classes.push('disabled');}if(cell.selected){classes.push('selected');}if(cell.customClass){classes.push(cell.customClass);}return classes.join(' ');},getDateOfCell:function getDateOfCell(row,column){var offsetFromStart=row*7+(column-(this.showWeekNumber?1:0))-this.offsetDay;return Object(date_util_["nextDate"])(this.startDate,offsetFromStart);},isWeekActive:function isWeekActive(cell){if(this.selectionMode!=='week')return false;var newDate=new Date(this.year,this.month,1);var year=newDate.getFullYear();var month=newDate.getMonth();if(cell.type==='prev-month'){newDate.setMonth(month===0?11:month-1);newDate.setFullYear(month===0?year-1:year);}if(cell.type==='next-month'){newDate.setMonth(month===11?0:month+1);newDate.setFullYear(month===11?year+1:year);}newDate.setDate(parseInt(cell.text,10));if(Object(date_util_["isDate"])(this.value)){var dayOffset=(this.value.getDay()-this.firstDayOfWeek+7)%7-1;var weekDate=Object(date_util_["prevDate"])(this.value,dayOffset);return weekDate.getTime()===newDate.getTime();}return false;},markRange:function markRange(minDate,maxDate){minDate=date_tablevue_type_script_lang_js_getDateTimestamp(minDate);maxDate=date_tablevue_type_script_lang_js_getDateTimestamp(maxDate)||minDate;var _ref=[Math.min(minDate,maxDate),Math.max(minDate,maxDate)];minDate=_ref[0];maxDate=_ref[1];var startDate=this.startDate;var rows=this.rows;for(var i=0,k=rows.length;i<k;i++){var row=rows[i];for(var j=0,l=row.length;j<l;j++){if(this.showWeekNumber&&j===0)continue;var _cell=row[j];var index=i*7+j+(this.showWeekNumber?-1:0);var time=Object(date_util_["nextDate"])(startDate,index-this.offsetDay).getTime();_cell.inRange=minDate&&time>=minDate&&time<=maxDate;_cell.start=minDate&&time===minDate;_cell.end=maxDate&&time===maxDate;}}},handleMouseMove:function handleMouseMove(event){if(!this.rangeState.selecting)return;var target=event.target;if(target.tagName==='SPAN'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex-1;var column=target.cellIndex;// can not select disabled date
if(this.rows[row][column].disabled)return;// only update rangeState when mouse moves to a new cell
// this avoids frequent Date object creation and improves performance
if(row!==this.lastRow||column!==this.lastColumn){this.lastRow=row;this.lastColumn=column;this.$emit('changerange',{minDate:this.minDate,maxDate:this.maxDate,rangeState:{selecting:true,endDate:this.getDateOfCell(row,column)}});}},handleClick:function handleClick(event){var target=event.target;if(target.tagName==='SPAN'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex-1;var column=this.selectionMode==='week'?1:target.cellIndex;var cell=this.rows[row][column];if(cell.disabled||cell.type==='week')return;var newDate=this.getDateOfCell(row,column);if(this.selectionMode==='range'){if(!this.rangeState.selecting){this.$emit('pick',{minDate:newDate,maxDate:null});this.rangeState.selecting=true;}else{if(newDate>=this.minDate){this.$emit('pick',{minDate:this.minDate,maxDate:newDate});}else{this.$emit('pick',{minDate:newDate,maxDate:this.minDate});}this.rangeState.selecting=false;}}else if(this.selectionMode==='day'){this.$emit('pick',newDate);}else if(this.selectionMode==='week'){var weekNumber=Object(date_util_["getWeekNumber"])(newDate);var value=newDate.getFullYear()+'w'+weekNumber;this.$emit('pick',{year:newDate.getFullYear(),week:weekNumber,value:value,date:newDate});}else if(this.selectionMode==='dates'){var _value=this.value||[];var newValue=cell.selected?date_tablevue_type_script_lang_js_removeFromArray(_value,function(date){return date.getTime()===newDate.getTime();}):[].concat(_value,[newDate]);this.$emit('pick',newValue);}}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_date_tablevue_type_script_lang_js_=date_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
/* normalize component */var date_table_component=normalizeComponent(basic_date_tablevue_type_script_lang_js_,date_tablevue_type_template_id_5d1f3341_render,date_tablevue_type_template_id_5d1f3341_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_table_api;}date_table_component.options.__file="packages/date-picker/src/basic/date-table.vue";/* harmony default export */var date_table=date_table_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var datevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},watch:{showTime:function showTime(val){var _this=this;/* istanbul ignore if */if(!val)return;this.$nextTick(function(_){var inputElm=_this.$refs.input.$el;if(inputElm){_this.pickerWidth=inputElm.getBoundingClientRect().width+10;}});},value:function value(val){if(this.selectionMode==='dates'&&this.value)return;if(this.selectionMode==='months'&&this.value)return;if(this.selectionMode==='years'&&this.value)return;if(Object(date_util_["isDate"])(val)){this.date=new Date(val);}else{this.date=this.getDefaultValue();}},defaultValue:function defaultValue(val){if(!Object(date_util_["isDate"])(this.value)){this.date=val?new Date(val):new Date();}},timePickerVisible:function timePickerVisible(val){var _this2=this;if(val)this.$nextTick(function(){return _this2.$refs.timepicker.adjustSpinners();});},selectionMode:function selectionMode(newVal){if(newVal==='month'){/* istanbul ignore next */if(this.currentView!=='year'||this.currentView!=='month'){this.currentView='month';}}else if(newVal==='dates'){this.currentView='date';}else if(newVal==='years'){this.currentView='year';}else if(newVal==='months'){this.currentView='month';}}},methods:{proxyTimePickerDataProperties:function proxyTimePickerDataProperties(){var _this3=this;var format=function format(timeFormat){_this3.$refs.timepicker.format=timeFormat;};var value=function value(_value){_this3.$refs.timepicker.value=_value;};var date=function date(_date){_this3.$refs.timepicker.date=_date;};var selectableRange=function selectableRange(_selectableRange){_this3.$refs.timepicker.selectableRange=_selectableRange;};this.$watch('value',value);this.$watch('date',date);this.$watch('selectableRange',selectableRange);format(this.timeFormat);value(this.value);date(this.date);selectableRange(this.selectableRange);},handleClear:function handleClear(){this.date=this.getDefaultValue();this.$emit('pick',null);},emit:function emit(value){var _this4=this;for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}if(!value){this.$emit.apply(this,['pick',value].concat(args));}else if(Array.isArray(value)){var dates=value.map(function(date){return _this4.showTime?Object(date_util_["clearMilliseconds"])(date):Object(date_util_["clearTime"])(date);});this.$emit.apply(this,['pick',dates].concat(args));}else{this.$emit.apply(this,['pick',this.showTime?Object(date_util_["clearMilliseconds"])(value):Object(date_util_["clearTime"])(value)].concat(args));}this.userInputDate=null;this.userInputTime=null;},// resetDate() {
//   this.date = new Date(this.date);
// },
showMonthPicker:function showMonthPicker(){this.currentView='month';},showYearPicker:function showYearPicker(){this.currentView='year';},// XXX: 没用到
// handleLabelClick() {
//   if (this.currentView === 'date') {
//     this.showMonthPicker();
//   } else if (this.currentView === 'month') {
//     this.showYearPicker();
//   }
// },
prevMonth:function prevMonth(){this.date=Object(date_util_["prevMonth"])(this.date);},nextMonth:function nextMonth(){this.date=Object(date_util_["nextMonth"])(this.date);},prevYear:function prevYear(){if(this.currentView==='year'){this.date=Object(date_util_["prevYear"])(this.date,10);}else{this.date=Object(date_util_["prevYear"])(this.date);}},nextYear:function nextYear(){if(this.currentView==='year'){this.date=Object(date_util_["nextYear"])(this.date,10);}else{this.date=Object(date_util_["nextYear"])(this.date);}},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},handleTimePick:function handleTimePick(value,visible,first){if(Object(date_util_["isDate"])(value)){var newDate=this.value?Object(date_util_["modifyTime"])(this.value,value.getHours(),value.getMinutes(),value.getSeconds()):Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(),this.defaultTime);this.date=newDate;this.emit(this.date,true);}else{this.emit(value,true);}if(!first){this.timePickerVisible=visible;}},handleTimePickClose:function handleTimePickClose(){this.timePickerVisible=false;},handleMonthPick:function handleMonthPick(month){if(this.selectionMode==='month'){this.date=Object(date_util_["modifyDate"])(this.date,this.year,month,1);this.emit(this.date);}else if(this.selectionMode==='months'){this.emit(month,true);}else{this.date=Object(date_util_["changeYearMonthAndClampDate"])(this.date,this.year,month);// TODO: should emit intermediate value ??
// this.emit(this.date);
this.currentView='date';}},handleDatePick:function handleDatePick(value){if(this.selectionMode==='day'){var newDate=this.value?Object(date_util_["modifyDate"])(this.value,value.getFullYear(),value.getMonth(),value.getDate()):Object(date_util_["modifyWithTimeString"])(value,this.defaultTime);// change default time while out of selectableRange
if(!this.checkDateWithinRange(newDate)){newDate=Object(date_util_["modifyDate"])(this.selectableRange[0][0],value.getFullYear(),value.getMonth(),value.getDate());}this.date=newDate;this.emit(this.date,this.showTime);}else if(this.selectionMode==='week'){this.emit(value.date);}else if(this.selectionMode==='dates'){this.emit(value,true);// set false to keep panel open
}},handleYearPick:function handleYearPick(year){if(this.selectionMode==='year'){this.date=Object(date_util_["modifyDate"])(this.date,year,0,1);this.emit(this.date);}else if(this.selectionMode==='years'){this.emit(year,true);}else{this.date=Object(date_util_["changeYearMonthAndClampDate"])(this.date,year,this.month);// TODO: should emit intermediate value ??
// this.emit(this.date, true);
this.currentView='month';}},changeToNow:function changeToNow(){// NOTE: not a permanent solution
//       consider disable "now" button in the future
if((!this.disabledDate||!this.disabledDate(new Date()))&&this.checkDateWithinRange(new Date())){this.date=new Date();this.emit(this.date);}},confirm:function confirm(){if(this.selectionMode==='dates'||this.selectionMode==='months'||this.selectionMode==='years'){this.emit(this.value);}else{// value were emitted in handle{Date,Time}Pick, nothing to update here
// deal with the scenario where: user opens the picker, then confirm without doing anything
var value=this.value?this.value:Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(),this.defaultTime);this.date=new Date(value);// refresh date
this.emit(value);}},resetView:function resetView(){if(this.selectionMode==='month'||this.selectionMode==='months'){this.currentView='month';}else if(this.selectionMode==='year'||this.selectionMode==='years'){this.currentView='year';}else{this.currentView='date';}},handleEnter:function handleEnter(){document.body.addEventListener('keydown',this.handleKeydown);},handleLeave:function handleLeave(){this.$emit('dodestroy');document.body.removeEventListener('keydown',this.handleKeydown);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var list=[38,40,37,39];if(this.visible&&!this.timePickerVisible){if(list.indexOf(keyCode)!==-1){this.handleKeyControl(keyCode);event.stopPropagation();event.preventDefault();}if(keyCode===13&&this.userInputDate===null&&this.userInputTime===null){// Enter
this.emit(this.date,false);}}},handleKeyControl:function handleKeyControl(keyCode){var mapping={'year':{38:-4,40:4,37:-1,39:1,offset:function offset(date,step){return date.setFullYear(date.getFullYear()+step);}},'month':{38:-4,40:4,37:-1,39:1,offset:function offset(date,step){return date.setMonth(date.getMonth()+step);}},'week':{38:-1,40:1,37:-1,39:1,offset:function offset(date,step){return date.setDate(date.getDate()+step*7);}},'day':{38:-7,40:7,37:-1,39:1,offset:function offset(date,step){return date.setDate(date.getDate()+step);}}};var mode=this.selectionMode;var year=3.1536e10;var now=this.date.getTime();var newDate=new Date(this.date.getTime());while(Math.abs(now-newDate.getTime())<=year){var map=mapping[mode];map.offset(newDate,map[keyCode]);if(typeof this.disabledDate==='function'&&this.disabledDate(newDate)){continue;}this.date=newDate;this.$emit('pick',newDate,true);break;}},handleVisibleTimeChange:function handleVisibleTimeChange(value){var time=Object(date_util_["parseDate"])(value,this.timeFormat);if(time&&this.checkDateWithinRange(time)){this.date=Object(date_util_["modifyDate"])(time,this.year,this.month,this.monthDate);this.userInputTime=null;this.$refs.timepicker.value=this.date;this.timePickerVisible=false;this.emit(this.date,true);}},handleVisibleDateChange:function handleVisibleDateChange(value){var date=Object(date_util_["parseDate"])(value,this.dateFormat);if(date){if(typeof this.disabledDate==='function'&&this.disabledDate(date)){return;}this.date=Object(date_util_["modifyTime"])(date,this.date.getHours(),this.date.getMinutes(),this.date.getSeconds());this.userInputDate=null;this.resetView();this.emit(this.date,true);}},isValidValue:function isValidValue(value){return value&&!isNaN(value)&&(typeof this.disabledDate==='function'?!this.disabledDate(value):true)&&this.checkDateWithinRange(value);},getDefaultValue:function getDefaultValue(){// if default-value is set, return it
// otherwise, return now (the moment this method gets called)
return this.defaultValue?new Date(this.defaultValue):new Date();},checkDateWithinRange:function checkDateWithinRange(date){return this.selectableRange.length>0?Object(date_util_["timeWithinRange"])(date,this.selectableRange,this.format||'HH:mm:ss'):true;}},components:{TimePicker:panel_time,YearTable:year_table,MonthTable:month_table,DateTable:date_table,ElInput:input_default.a,ElButton:button_default.a},data:function data(){return{popperClass:'',date:new Date(),value:'',defaultValue:null,// use getDefaultValue() for time computation
defaultTime:null,showTime:false,selectionMode:'day',shortcuts:'',visible:false,currentView:'date',disabledDate:'',cellClassName:'',selectableRange:[],firstDayOfWeek:7,showWeekNumber:false,timePickerVisible:false,format:'',arrowControl:false,userInputDate:null,userInputTime:null};},computed:{year:function year(){return this.date.getFullYear();},month:function month(){return this.date.getMonth();},week:function week(){return Object(date_util_["getWeekNumber"])(this.date);},monthDate:function monthDate(){return this.date.getDate();},footerVisible:function footerVisible(){return this.showTime||this.selectionMode==='dates'||this.selectionMode==='months'||this.selectionMode==='years';},visibleTime:function visibleTime(){if(this.userInputTime!==null){return this.userInputTime;}else{return Object(date_util_["formatDate"])(this.value||this.defaultValue,this.timeFormat);}},visibleDate:function visibleDate(){if(this.userInputDate!==null){return this.userInputDate;}else{return Object(date_util_["formatDate"])(this.value||this.defaultValue,this.dateFormat);}},yearLabel:function yearLabel(){var yearTranslation=this.t('el.datepicker.year');if(this.currentView==='year'){var startYear=Math.floor(this.year/10)*10;if(yearTranslation){return startYear+' '+yearTranslation+' - '+(startYear+9)+' '+yearTranslation;}return startYear+' - '+(startYear+9);}return this.year+' '+yearTranslation;},timeFormat:function timeFormat(){if(this.format){return Object(date_util_["extractTimeFormat"])(this.format);}else{return'HH:mm:ss';}},dateFormat:function dateFormat(){if(this.format){return Object(date_util_["extractDateFormat"])(this.format);}else{return'yyyy-MM-dd';}}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
/* harmony default export */var panel_datevue_type_script_lang_js_=datevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
/* normalize component */var date_component=normalizeComponent(panel_datevue_type_script_lang_js_,datevue_type_template_id_2440d4ea_render,datevue_type_template_id_2440d4ea_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_api;}date_component.options.__file="packages/date-picker/src/panel/date.vue";/* harmony default export */var panel_date=date_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
var date_rangevue_type_template_id_2652849a_render=function date_rangevue_type_template_id_2652849a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts,"has-time":_vm.showTime},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_vm.showTime?_c("div",{staticClass:"el-date-range-picker__time-header"},[_c("span",{staticClass:"el-date-range-picker__editors-wrap"},[_c("span",{staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{ref:"minInput",staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.startDate"),value:_vm.minVisibleDate},on:{input:function input(val){return _vm.handleDateInput(val,"min");},change:function change(val){return _vm.handleDateChange(val,"min");}}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleMinTimeClose,expression:"handleMinTimeClose"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.startTime"),value:_vm.minVisibleTime},on:{focus:function focus($event){_vm.minTimePickerVisible=true;},input:function input(val){return _vm.handleTimeInput(val,"min");},change:function change(val){return _vm.handleTimeChange(val,"min");}}}),_c("time-picker",{ref:"minTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.minTimePickerVisible},on:{pick:_vm.handleMinTimePick,mounted:function mounted($event){_vm.$refs.minTimePicker.format=_vm.timeFormat;}}})],1)]),_c("span",{staticClass:"el-icon-arrow-right"}),_c("span",{staticClass:"el-date-range-picker__editors-wrap is-right"},[_c("span",{staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.endDate"),value:_vm.maxVisibleDate,readonly:!_vm.minDate},on:{input:function input(val){return _vm.handleDateInput(val,"max");},change:function change(val){return _vm.handleDateChange(val,"max");}}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleMaxTimeClose,expression:"handleMaxTimeClose"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.endTime"),value:_vm.maxVisibleTime,readonly:!_vm.minDate},on:{focus:function focus($event){_vm.minDate&&(_vm.maxTimePickerVisible=true);},input:function input(val){return _vm.handleTimeInput(val,"max");},change:function change(val){return _vm.handleTimeChange(val,"max");}}}),_c("time-picker",{ref:"maxTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.maxTimePickerVisible},on:{pick:_vm.handleMaxTimePick,mounted:function mounted($event){_vm.$refs.maxTimePicker.format=_vm.timeFormat;}}})],1)])]):_vm._e(),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c("div",{staticClass:"el-date-range-picker__header"},[_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevYear}}),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevMonth}}),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.leftNextYear}}):_vm._e(),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",class:{"is-disabled":!_vm.enableMonthArrow},attrs:{type:"button",disabled:!_vm.enableMonthArrow},on:{click:_vm.leftNextMonth}}):_vm._e(),_c("div",[_vm._v(_vm._s(_vm.leftLabel))])]),_c("date-table",{attrs:{"selection-mode":"range",date:_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"cell-class-name":_vm.cellClassName,"first-day-of-week":_vm.firstDayOfWeek},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c("div",{staticClass:"el-date-range-picker__header"},[_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.rightPrevYear}}):_vm._e(),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",class:{"is-disabled":!_vm.enableMonthArrow},attrs:{type:"button",disabled:!_vm.enableMonthArrow},on:{click:_vm.rightPrevMonth}}):_vm._e(),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextYear}}),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextMonth}}),_c("div",[_vm._v(_vm._s(_vm.rightLabel))])]),_c("date-table",{attrs:{"selection-mode":"range",date:_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"cell-class-name":_vm.cellClassName,"first-day-of-week":_vm.firstDayOfWeek},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1)])],2),_vm.showTime?_c("div",{staticClass:"el-picker-panel__footer"},[_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{size:"mini",type:"text"},on:{click:_vm.handleClear}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.clear"))+"\n      ")]),_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{plain:"",size:"mini",disabled:_vm.btnDisabled},on:{click:function click($event){_vm.handleConfirm(false);}}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.confirm"))+"\n      ")])],1):_vm._e()])]);};var date_rangevue_type_template_id_2652849a_staticRenderFns=[];date_rangevue_type_template_id_2652849a_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var date_rangevue_type_script_lang_js_calcDefaultValue=function calcDefaultValue(defaultValue){if(Array.isArray(defaultValue)){return[new Date(defaultValue[0]),new Date(defaultValue[1])];}else if(defaultValue){return[new Date(defaultValue),Object(date_util_["nextDate"])(new Date(defaultValue),1)];}else{return[new Date(),Object(date_util_["nextDate"])(new Date(),1)];}};/* harmony default export */var date_rangevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},computed:{btnDisabled:function btnDisabled(){return!(this.minDate&&this.maxDate&&!this.selecting&&this.isValidValue([this.minDate,this.maxDate]));},leftLabel:function leftLabel(){return this.leftDate.getFullYear()+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+(this.leftDate.getMonth()+1));},rightLabel:function rightLabel(){return this.rightDate.getFullYear()+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+(this.rightDate.getMonth()+1));},leftYear:function leftYear(){return this.leftDate.getFullYear();},leftMonth:function leftMonth(){return this.leftDate.getMonth();},leftMonthDate:function leftMonthDate(){return this.leftDate.getDate();},rightYear:function rightYear(){return this.rightDate.getFullYear();},rightMonth:function rightMonth(){return this.rightDate.getMonth();},rightMonthDate:function rightMonthDate(){return this.rightDate.getDate();},minVisibleDate:function minVisibleDate(){if(this.dateUserInput.min!==null)return this.dateUserInput.min;if(this.minDate)return Object(date_util_["formatDate"])(this.minDate,this.dateFormat);return'';},maxVisibleDate:function maxVisibleDate(){if(this.dateUserInput.max!==null)return this.dateUserInput.max;if(this.maxDate||this.minDate)return Object(date_util_["formatDate"])(this.maxDate||this.minDate,this.dateFormat);return'';},minVisibleTime:function minVisibleTime(){if(this.timeUserInput.min!==null)return this.timeUserInput.min;if(this.minDate)return Object(date_util_["formatDate"])(this.minDate,this.timeFormat);return'';},maxVisibleTime:function maxVisibleTime(){if(this.timeUserInput.max!==null)return this.timeUserInput.max;if(this.maxDate||this.minDate)return Object(date_util_["formatDate"])(this.maxDate||this.minDate,this.timeFormat);return'';},timeFormat:function timeFormat(){if(this.format){return Object(date_util_["extractTimeFormat"])(this.format);}else{return'HH:mm:ss';}},dateFormat:function dateFormat(){if(this.format){return Object(date_util_["extractDateFormat"])(this.format);}else{return'yyyy-MM-dd';}},enableMonthArrow:function enableMonthArrow(){var nextMonth=(this.leftMonth+1)%12;var yearOffset=this.leftMonth+1>=12?1:0;return this.unlinkPanels&&new Date(this.leftYear+yearOffset,nextMonth)<new Date(this.rightYear,this.rightMonth);},enableYearArrow:function enableYearArrow(){return this.unlinkPanels&&this.rightYear*12+this.rightMonth-(this.leftYear*12+this.leftMonth+1)>=12;}},data:function data(){return{popperClass:'',value:[],defaultValue:null,defaultTime:null,minDate:'',maxDate:'',leftDate:new Date(),rightDate:Object(date_util_["nextMonth"])(new Date()),rangeState:{endDate:null,selecting:false,row:null,column:null},showTime:false,shortcuts:'',visible:'',disabledDate:'',cellClassName:'',firstDayOfWeek:7,minTimePickerVisible:false,maxTimePickerVisible:false,format:'',arrowControl:false,unlinkPanels:false,dateUserInput:{min:null,max:null},timeUserInput:{min:null,max:null}};},watch:{minDate:function minDate(val){var _this=this;this.dateUserInput.min=null;this.timeUserInput.min=null;this.$nextTick(function(){if(_this.$refs.maxTimePicker&&_this.maxDate&&_this.maxDate<_this.minDate){var format='HH:mm:ss';_this.$refs.maxTimePicker.selectableRange=[[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate,format),format),Object(date_util_["parseDate"])('23:59:59',format)]];}});if(val&&this.$refs.minTimePicker){this.$refs.minTimePicker.date=val;this.$refs.minTimePicker.value=val;}},maxDate:function maxDate(val){this.dateUserInput.max=null;this.timeUserInput.max=null;if(val&&this.$refs.maxTimePicker){this.$refs.maxTimePicker.date=val;this.$refs.maxTimePicker.value=val;}},minTimePickerVisible:function minTimePickerVisible(val){var _this2=this;if(val){this.$nextTick(function(){_this2.$refs.minTimePicker.date=_this2.minDate;_this2.$refs.minTimePicker.value=_this2.minDate;_this2.$refs.minTimePicker.adjustSpinners();});}},maxTimePickerVisible:function maxTimePickerVisible(val){var _this3=this;if(val){this.$nextTick(function(){_this3.$refs.maxTimePicker.date=_this3.maxDate;_this3.$refs.maxTimePicker.value=_this3.maxDate;_this3.$refs.maxTimePicker.adjustSpinners();});}},value:function value(newVal){if(!newVal){this.minDate=null;this.maxDate=null;}else if(Array.isArray(newVal)){this.minDate=Object(date_util_["isDate"])(newVal[0])?new Date(newVal[0]):null;this.maxDate=Object(date_util_["isDate"])(newVal[1])?new Date(newVal[1]):null;if(this.minDate){this.leftDate=this.minDate;if(this.unlinkPanels&&this.maxDate){var minDateYear=this.minDate.getFullYear();var minDateMonth=this.minDate.getMonth();var maxDateYear=this.maxDate.getFullYear();var maxDateMonth=this.maxDate.getMonth();this.rightDate=minDateYear===maxDateYear&&minDateMonth===maxDateMonth?Object(date_util_["nextMonth"])(this.maxDate):this.maxDate;}else{this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}else{this.leftDate=date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}},defaultValue:function defaultValue(val){if(!Array.isArray(this.value)){var _calcDefaultValue=date_rangevue_type_script_lang_js_calcDefaultValue(val),left=_calcDefaultValue[0],right=_calcDefaultValue[1];this.leftDate=left;this.rightDate=val&&val[1]&&this.unlinkPanels?right:Object(date_util_["nextMonth"])(this.leftDate);}}},methods:{handleClear:function handleClear(){this.minDate=null;this.maxDate=null;this.leftDate=date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);this.$emit('pick',null);},handleChangeRange:function handleChangeRange(val){this.minDate=val.minDate;this.maxDate=val.maxDate;this.rangeState=val.rangeState;},handleDateInput:function handleDateInput(value,type){this.dateUserInput[type]=value;if(value.length!==this.dateFormat.length)return;var parsedValue=Object(date_util_["parseDate"])(value,this.dateFormat);if(parsedValue){if(typeof this.disabledDate==='function'&&this.disabledDate(new Date(parsedValue))){return;}if(type==='min'){this.minDate=Object(date_util_["modifyDate"])(this.minDate||new Date(),parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());this.leftDate=new Date(parsedValue);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}else{this.maxDate=Object(date_util_["modifyDate"])(this.maxDate||new Date(),parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());this.rightDate=new Date(parsedValue);if(!this.unlinkPanels){this.leftDate=Object(date_util_["prevMonth"])(parsedValue);}}}},handleDateChange:function handleDateChange(value,type){var parsedValue=Object(date_util_["parseDate"])(value,this.dateFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyDate"])(this.minDate,parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());if(this.minDate>this.maxDate){this.maxDate=this.minDate;}}else{this.maxDate=Object(date_util_["modifyDate"])(this.maxDate,parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());if(this.maxDate<this.minDate){this.minDate=this.maxDate;}}}},handleTimeInput:function handleTimeInput(value,type){var _this4=this;this.timeUserInput[type]=value;if(value.length!==this.timeFormat.length)return;var parsedValue=Object(date_util_["parseDate"])(value,this.timeFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyTime"])(this.minDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());this.$nextTick(function(_){return _this4.$refs.minTimePicker.adjustSpinners();});}else{this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());this.$nextTick(function(_){return _this4.$refs.maxTimePicker.adjustSpinners();});}}},handleTimeChange:function handleTimeChange(value,type){var parsedValue=Object(date_util_["parseDate"])(value,this.timeFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyTime"])(this.minDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());if(this.minDate>this.maxDate){this.maxDate=this.minDate;}this.$refs.minTimePicker.value=this.minDate;this.minTimePickerVisible=false;}else{this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());if(this.maxDate<this.minDate){this.minDate=this.maxDate;}this.$refs.maxTimePicker.value=this.minDate;this.maxTimePickerVisible=false;}}},handleRangePick:function handleRangePick(val){var _this5=this;var close=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var defaultTime=this.defaultTime||[];var minDate=Object(date_util_["modifyWithTimeString"])(val.minDate,defaultTime[0]);var maxDate=Object(date_util_["modifyWithTimeString"])(val.maxDate,defaultTime[1]);if(this.maxDate===maxDate&&this.minDate===minDate){return;}this.onPick&&this.onPick(val);this.maxDate=maxDate;this.minDate=minDate;// workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
setTimeout(function(){_this5.maxDate=maxDate;_this5.minDate=minDate;},10);if(!close||this.showTime)return;this.handleConfirm();},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},handleMinTimePick:function handleMinTimePick(value,visible,first){this.minDate=this.minDate||new Date();if(value){this.minDate=Object(date_util_["modifyTime"])(this.minDate,value.getHours(),value.getMinutes(),value.getSeconds());}if(!first){this.minTimePickerVisible=visible;}if(!this.maxDate||this.maxDate&&this.maxDate.getTime()<this.minDate.getTime()){this.maxDate=new Date(this.minDate);}},handleMinTimeClose:function handleMinTimeClose(){this.minTimePickerVisible=false;},handleMaxTimePick:function handleMaxTimePick(value,visible,first){if(this.maxDate&&value){this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,value.getHours(),value.getMinutes(),value.getSeconds());}if(!first){this.maxTimePickerVisible=visible;}if(this.maxDate&&this.minDate&&this.minDate.getTime()>this.maxDate.getTime()){this.minDate=new Date(this.maxDate);}},handleMaxTimeClose:function handleMaxTimeClose(){this.maxTimePickerVisible=false;},// leftPrev*, rightNext* need to take care of `unlinkPanels`
leftPrevYear:function leftPrevYear(){this.leftDate=Object(date_util_["prevYear"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}},leftPrevMonth:function leftPrevMonth(){this.leftDate=Object(date_util_["prevMonth"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}},rightNextYear:function rightNextYear(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}else{this.rightDate=Object(date_util_["nextYear"])(this.rightDate);}},rightNextMonth:function rightNextMonth(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextMonth"])(this.leftDate);this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}else{this.rightDate=Object(date_util_["nextMonth"])(this.rightDate);}},// leftNext*, rightPrev* are called when `unlinkPanels` is true
leftNextYear:function leftNextYear(){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);},leftNextMonth:function leftNextMonth(){this.leftDate=Object(date_util_["nextMonth"])(this.leftDate);},rightPrevYear:function rightPrevYear(){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);},rightPrevMonth:function rightPrevMonth(){this.rightDate=Object(date_util_["prevMonth"])(this.rightDate);},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.isValidValue([this.minDate,this.maxDate])){this.$emit('pick',[this.minDate,this.maxDate],visible);}},isValidValue:function isValidValue(value){return Array.isArray(value)&&value&&value[0]&&value[1]&&Object(date_util_["isDate"])(value[0])&&Object(date_util_["isDate"])(value[1])&&value[0].getTime()<=value[1].getTime()&&(typeof this.disabledDate==='function'?!this.disabledDate(value[0])&&!this.disabledDate(value[1]):true);},resetView:function resetView(){// NOTE: this is a hack to reset {min, max}Date on picker open.
// TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
//       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
if(this.minDate&&this.maxDate==null)this.rangeState.selecting=false;this.minDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[0]):null;this.maxDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[1]):null;}},components:{TimePicker:panel_time,DateTable:date_table,ElInput:input_default.a,ElButton:button_default.a}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_date_rangevue_type_script_lang_js_=date_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
/* normalize component */var date_range_component=normalizeComponent(panel_date_rangevue_type_script_lang_js_,date_rangevue_type_template_id_2652849a_render,date_rangevue_type_template_id_2652849a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_range_api;}date_range_component.options.__file="packages/date-picker/src/panel/date-range.vue";/* harmony default export */var date_range=date_range_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
var month_rangevue_type_template_id_f2645fb8_render=function month_rangevue_type_template_id_f2645fb8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c("div",{staticClass:"el-date-range-picker__header"},[_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevYear}}),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.leftNextYear}}):_vm._e(),_c("div",[_vm._v(_vm._s(_vm.leftLabel))])]),_c("month-table",{attrs:{"selection-mode":"range",date:_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c("div",{staticClass:"el-date-range-picker__header"},[_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.rightPrevYear}}):_vm._e(),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextYear}}),_c("div",[_vm._v(_vm._s(_vm.rightLabel))])]),_c("month-table",{attrs:{"selection-mode":"range",date:_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1)])],2)])]);};var month_rangevue_type_template_id_f2645fb8_staticRenderFns=[];month_rangevue_type_template_id_f2645fb8_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var month_rangevue_type_script_lang_js_calcDefaultValue=function calcDefaultValue(defaultValue){if(Array.isArray(defaultValue)){return[new Date(defaultValue[0]),new Date(defaultValue[1])];}else if(defaultValue){return[new Date(defaultValue),Object(date_util_["nextMonth"])(new Date(defaultValue))];}else{return[new Date(),Object(date_util_["nextMonth"])(new Date())];}};/* harmony default export */var month_rangevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},computed:{btnDisabled:function btnDisabled(){return!(this.minDate&&this.maxDate&&!this.selecting&&this.isValidValue([this.minDate,this.maxDate]));},leftLabel:function leftLabel(){return this.leftDate.getFullYear()+' '+this.t('el.datepicker.year');},rightLabel:function rightLabel(){return this.rightDate.getFullYear()+' '+this.t('el.datepicker.year');},leftYear:function leftYear(){return this.leftDate.getFullYear();},rightYear:function rightYear(){return this.rightDate.getFullYear()===this.leftDate.getFullYear()?this.leftDate.getFullYear()+1:this.rightDate.getFullYear();},enableYearArrow:function enableYearArrow(){return this.unlinkPanels&&this.rightYear>this.leftYear+1;}},data:function data(){return{popperClass:'',value:[],defaultValue:null,defaultTime:null,minDate:'',maxDate:'',leftDate:new Date(),rightDate:Object(date_util_["nextYear"])(new Date()),rangeState:{endDate:null,selecting:false,row:null,column:null},shortcuts:'',visible:'',disabledDate:'',format:'',arrowControl:false,unlinkPanels:false};},watch:{value:function value(newVal){if(!newVal){this.minDate=null;this.maxDate=null;}else if(Array.isArray(newVal)){this.minDate=Object(date_util_["isDate"])(newVal[0])?new Date(newVal[0]):null;this.maxDate=Object(date_util_["isDate"])(newVal[1])?new Date(newVal[1]):null;if(this.minDate){this.leftDate=this.minDate;if(this.unlinkPanels&&this.maxDate){var minDateYear=this.minDate.getFullYear();var maxDateYear=this.maxDate.getFullYear();this.rightDate=minDateYear===maxDateYear?Object(date_util_["nextYear"])(this.maxDate):this.maxDate;}else{this.rightDate=Object(date_util_["nextYear"])(this.leftDate);}}else{this.leftDate=month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextYear"])(this.leftDate);}}},defaultValue:function defaultValue(val){if(!Array.isArray(this.value)){var _calcDefaultValue=month_rangevue_type_script_lang_js_calcDefaultValue(val),left=_calcDefaultValue[0],right=_calcDefaultValue[1];this.leftDate=left;this.rightDate=val&&val[1]&&left.getFullYear()!==right.getFullYear()&&this.unlinkPanels?right:Object(date_util_["nextYear"])(this.leftDate);}}},methods:{handleClear:function handleClear(){this.minDate=null;this.maxDate=null;this.leftDate=month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextYear"])(this.leftDate);this.$emit('pick',null);},handleChangeRange:function handleChangeRange(val){this.minDate=val.minDate;this.maxDate=val.maxDate;this.rangeState=val.rangeState;},handleRangePick:function handleRangePick(val){var _this=this;var close=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var defaultTime=this.defaultTime||[];var minDate=Object(date_util_["modifyWithTimeString"])(val.minDate,defaultTime[0]);var maxDate=Object(date_util_["modifyWithTimeString"])(val.maxDate,defaultTime[1]);if(this.maxDate===maxDate&&this.minDate===minDate){return;}this.onPick&&this.onPick(val);this.maxDate=maxDate;this.minDate=minDate;// workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
setTimeout(function(){_this.maxDate=maxDate;_this.minDate=minDate;},10);if(!close)return;this.handleConfirm();},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},// leftPrev*, rightNext* need to take care of `unlinkPanels`
leftPrevYear:function leftPrevYear(){this.leftDate=Object(date_util_["prevYear"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);}},rightNextYear:function rightNextYear(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);}this.rightDate=Object(date_util_["nextYear"])(this.rightDate);},// leftNext*, rightPrev* are called when `unlinkPanels` is true
leftNextYear:function leftNextYear(){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);},rightPrevYear:function rightPrevYear(){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.isValidValue([this.minDate,this.maxDate])){this.$emit('pick',[this.minDate,this.maxDate],visible);}},isValidValue:function isValidValue(value){return Array.isArray(value)&&value&&value[0]&&value[1]&&Object(date_util_["isDate"])(value[0])&&Object(date_util_["isDate"])(value[1])&&value[0].getTime()<=value[1].getTime()&&(typeof this.disabledDate==='function'?!this.disabledDate(value[0])&&!this.disabledDate(value[1]):true);},resetView:function resetView(){// NOTE: this is a hack to reset {min, max}Date on picker open.
// TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
//       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
this.minDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[0]):null;this.maxDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[1]):null;}},components:{MonthTable:month_table,ElInput:input_default.a,ElButton:button_default.a}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_month_rangevue_type_script_lang_js_=month_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
/* normalize component */var month_range_component=normalizeComponent(panel_month_rangevue_type_script_lang_js_,month_rangevue_type_template_id_f2645fb8_render,month_rangevue_type_template_id_f2645fb8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var month_range_api;}month_range_component.options.__file="packages/date-picker/src/panel/month-range.vue";/* harmony default export */var month_range=month_range_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
var date_picker_getPanel=function getPanel(type){if(type==='daterange'||type==='datetimerange'){return date_range;}else if(type==='monthrange'){return month_range;}return panel_date;};/* harmony default export */var date_picker={mixins:[picker],name:'ElDatePicker',props:{type:{type:String,default:'date'},timeArrowControl:Boolean},watch:{type:function type(_type){if(this.picker){this.unmountPicker();this.panel=date_picker_getPanel(_type);this.mountPicker();}else{this.panel=date_picker_getPanel(_type);}}},created:function created(){this.panel=date_picker_getPanel(this.type);}};// CONCATENATED MODULE: ./packages/date-picker/index.js
/* istanbul ignore next */date_picker.install=function install(Vue){Vue.component(date_picker.name,date_picker);};/* harmony default export */var packages_date_picker=date_picker;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
var time_selectvue_type_template_id_51ab9320_render=function time_selectvue_type_template_id_51ab9320_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],ref:"popper",staticClass:"el-picker-panel time-select el-popper",class:_vm.popperClass,style:{width:_vm.width+"px"}},[_c("el-scrollbar",{attrs:{noresize:"","wrap-class":"el-picker-panel__content"}},_vm._l(_vm.items,function(item){return _c("div",{key:item.value,staticClass:"time-select-item",class:{selected:_vm.value===item.value,disabled:item.disabled,default:item.value===_vm.defaultValue},attrs:{disabled:item.disabled},on:{click:function click($event){_vm.handleClick(item);}}},[_vm._v(_vm._s(item.value))]);}),0)],1)]);};var time_selectvue_type_template_id_51ab9320_staticRenderFns=[];time_selectvue_type_template_id_51ab9320_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var parseTime=function parseTime(time){var values=(time||'').split(':');if(values.length>=2){var hours=parseInt(values[0],10);var minutes=parseInt(values[1],10);return{hours:hours,minutes:minutes};}/* istanbul ignore next */return null;};var compareTime=function compareTime(time1,time2){var value1=parseTime(time1);var value2=parseTime(time2);var minutes1=value1.minutes+value1.hours*60;var minutes2=value2.minutes+value2.hours*60;if(minutes1===minutes2){return 0;}return minutes1>minutes2?1:-1;};var formatTime=function formatTime(time){return(time.hours<10?'0'+time.hours:time.hours)+':'+(time.minutes<10?'0'+time.minutes:time.minutes);};var nextTime=function nextTime(time,step){var timeValue=parseTime(time);var stepValue=parseTime(step);var next={hours:timeValue.hours,minutes:timeValue.minutes};next.minutes+=stepValue.minutes;next.hours+=stepValue.hours;next.hours+=Math.floor(next.minutes/60);next.minutes=next.minutes%60;return formatTime(next);};/* harmony default export */var time_selectvue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},watch:{value:function value(val){var _this=this;if(!val)return;this.$nextTick(function(){return _this.scrollToOption();});}},methods:{handleClick:function handleClick(item){if(!item.disabled){this.$emit('pick',item.value);}},handleClear:function handleClear(){this.$emit('pick',null);},scrollToOption:function scrollToOption(){var selector=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'.selected';var menu=this.$refs.popper.querySelector('.el-picker-panel__content');scroll_into_view_default()(menu,menu.querySelector(selector));},handleMenuEnter:function handleMenuEnter(){var _this2=this;var selected=this.items.map(function(item){return item.value;}).indexOf(this.value)!==-1;var hasDefault=this.items.map(function(item){return item.value;}).indexOf(this.defaultValue)!==-1;var option=selected&&'.selected'||hasDefault&&'.default'||'.time-select-item:not(.disabled)';this.$nextTick(function(){return _this2.scrollToOption(option);});},scrollDown:function scrollDown(step){var items=this.items;var length=items.length;var total=items.length;var index=items.map(function(item){return item.value;}).indexOf(this.value);while(total--){index=(index+step+length)%length;if(!items[index].disabled){this.$emit('pick',items[index].value,true);return;}}},isValidValue:function isValidValue(date){return this.items.filter(function(item){return!item.disabled;}).map(function(item){return item.value;}).indexOf(date)!==-1;},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;if(keyCode===38||keyCode===40){var mapping={40:1,38:-1};var offset=mapping[keyCode.toString()];this.scrollDown(offset);event.stopPropagation();return;}}},data:function data(){return{popperClass:'',start:'09:00',end:'18:00',step:'00:30',value:'',defaultValue:'',visible:false,minTime:'',maxTime:'',width:0};},computed:{items:function items(){var start=this.start;var end=this.end;var step=this.step;var result=[];if(start&&end&&step){var current=start;while(compareTime(current,end)<=0){result.push({value:current,disabled:compareTime(current,this.minTime||'-1:-1')<=0||compareTime(current,this.maxTime||'100:100')>=0});current=nextTime(current,step);}}return result;}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
/* harmony default export */var panel_time_selectvue_type_script_lang_js_=time_selectvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
/* normalize component */var time_select_component=normalizeComponent(panel_time_selectvue_type_script_lang_js_,time_selectvue_type_template_id_51ab9320_render,time_selectvue_type_template_id_51ab9320_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_select_api;}time_select_component.options.__file="packages/date-picker/src/panel/time-select.vue";/* harmony default export */var time_select=time_select_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
/* harmony default export */var picker_time_select={mixins:[picker],name:'ElTimeSelect',componentName:'ElTimeSelect',props:{type:{type:String,default:'time-select'}},beforeCreate:function beforeCreate(){this.panel=time_select;}};// CONCATENATED MODULE: ./packages/time-select/index.js
/* istanbul ignore next */picker_time_select.install=function(Vue){Vue.component(picker_time_select.name,picker_time_select);};/* harmony default export */var packages_time_select=picker_time_select;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
var time_rangevue_type_template_id_fb28660e_render=function time_rangevue_type_template_id_fb28660e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-time-range-picker el-picker-panel el-popper",class:_vm.popperClass},[_c("div",{staticClass:"el-time-range-picker__content"},[_c("div",{staticClass:"el-time-range-picker__cell"},[_c("div",{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t("el.datepicker.startTime")))]),_c("div",{staticClass:"el-time-range-picker__body el-time-panel__content",class:{"has-seconds":_vm.showSeconds,"is-arrow":_vm.arrowControl}},[_c("time-spinner",{ref:"minSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,date:_vm.minDate},on:{change:_vm.handleMinChange,"select-range":_vm.setMinSelectionRange}})],1)]),_c("div",{staticClass:"el-time-range-picker__cell"},[_c("div",{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t("el.datepicker.endTime")))]),_c("div",{staticClass:"el-time-range-picker__body el-time-panel__content",class:{"has-seconds":_vm.showSeconds,"is-arrow":_vm.arrowControl}},[_c("time-spinner",{ref:"maxSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,date:_vm.maxDate},on:{change:_vm.handleMaxChange,"select-range":_vm.setMaxSelectionRange}})],1)])]),_c("div",{staticClass:"el-time-panel__footer"},[_c("button",{staticClass:"el-time-panel__btn cancel",attrs:{type:"button"},on:{click:function click($event){_vm.handleCancel();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]),_c("button",{staticClass:"el-time-panel__btn confirm",attrs:{type:"button",disabled:_vm.btnDisabled},on:{click:function click($event){_vm.handleConfirm();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))])])])]);};var time_rangevue_type_template_id_fb28660e_staticRenderFns=[];time_rangevue_type_template_id_fb28660e_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MIN_TIME=Object(date_util_["parseDate"])('00:00:00','HH:mm:ss');var MAX_TIME=Object(date_util_["parseDate"])('23:59:59','HH:mm:ss');var time_rangevue_type_script_lang_js_minTimeOfDay=function minTimeOfDay(date){return Object(date_util_["modifyDate"])(MIN_TIME,date.getFullYear(),date.getMonth(),date.getDate());};var time_rangevue_type_script_lang_js_maxTimeOfDay=function maxTimeOfDay(date){return Object(date_util_["modifyDate"])(MAX_TIME,date.getFullYear(),date.getMonth(),date.getDate());};// increase time by amount of milliseconds, but within the range of day
var advanceTime=function advanceTime(date,amount){return new Date(Math.min(date.getTime()+amount,time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));};/* harmony default export */var time_rangevue_type_script_lang_js_={mixins:[locale_default.a],components:{TimeSpinner:time_spinner},computed:{showSeconds:function showSeconds(){return(this.format||'').indexOf('ss')!==-1;},offset:function offset(){return this.showSeconds?11:8;},spinner:function spinner(){return this.selectionRange[0]<this.offset?this.$refs.minSpinner:this.$refs.maxSpinner;},btnDisabled:function btnDisabled(){return this.minDate.getTime()>this.maxDate.getTime();},amPmMode:function amPmMode(){if((this.format||'').indexOf('A')!==-1)return'A';if((this.format||'').indexOf('a')!==-1)return'a';return'';}},data:function data(){return{popperClass:'',minDate:new Date(),maxDate:new Date(),value:[],oldValue:[new Date(),new Date()],defaultValue:null,format:'HH:mm:ss',visible:false,selectionRange:[0,2],arrowControl:false};},watch:{value:function value(_value){if(Array.isArray(_value)){this.minDate=new Date(_value[0]);this.maxDate=new Date(_value[1]);}else{if(Array.isArray(this.defaultValue)){this.minDate=new Date(this.defaultValue[0]);this.maxDate=new Date(this.defaultValue[1]);}else if(this.defaultValue){this.minDate=new Date(this.defaultValue);this.maxDate=advanceTime(new Date(this.defaultValue),60*60*1000);}else{this.minDate=new Date();this.maxDate=advanceTime(new Date(),60*60*1000);}}},visible:function visible(val){var _this=this;if(val){this.oldValue=this.value;this.$nextTick(function(){return _this.$refs.minSpinner.emitSelectRange('hours');});}}},methods:{handleClear:function handleClear(){this.$emit('pick',null);},handleCancel:function handleCancel(){this.$emit('pick',this.oldValue);},handleMinChange:function handleMinChange(date){this.minDate=Object(date_util_["clearMilliseconds"])(date);this.handleChange();},handleMaxChange:function handleMaxChange(date){this.maxDate=Object(date_util_["clearMilliseconds"])(date);this.handleChange();},handleChange:function handleChange(){if(this.isValidValue([this.minDate,this.maxDate])){this.$refs.minSpinner.selectableRange=[[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate),this.maxDate]];this.$refs.maxSpinner.selectableRange=[[this.minDate,time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];this.$emit('pick',[this.minDate,this.maxDate],true);}},setMinSelectionRange:function setMinSelectionRange(start,end){this.$emit('select-range',start,end,'min');this.selectionRange=[start,end];},setMaxSelectionRange:function setMaxSelectionRange(start,end){this.$emit('select-range',start,end,'max');this.selectionRange=[start+this.offset,end+this.offset];},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var minSelectableRange=this.$refs.minSpinner.selectableRange;var maxSelectableRange=this.$refs.maxSpinner.selectableRange;this.minDate=Object(date_util_["limitTimeRange"])(this.minDate,minSelectableRange,this.format);this.maxDate=Object(date_util_["limitTimeRange"])(this.maxDate,maxSelectableRange,this.format);this.$emit('pick',[this.minDate,this.maxDate],visible);},adjustSpinners:function adjustSpinners(){this.$refs.minSpinner.adjustSpinners();this.$refs.maxSpinner.adjustSpinners();},changeSelectionRange:function changeSelectionRange(step){var list=this.showSeconds?[0,3,6,11,14,17]:[0,3,8,11];var mapping=['hours','minutes'].concat(this.showSeconds?['seconds']:[]);var index=list.indexOf(this.selectionRange[0]);var next=(index+step+list.length)%list.length;var half=list.length/2;if(next<half){this.$refs.minSpinner.emitSelectRange(mapping[next]);}else{this.$refs.maxSpinner.emitSelectRange(mapping[next-half]);}},isValidValue:function isValidValue(date){return Array.isArray(date)&&Object(date_util_["timeWithinRange"])(this.minDate,this.$refs.minSpinner.selectableRange)&&Object(date_util_["timeWithinRange"])(this.maxDate,this.$refs.maxSpinner.selectableRange);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var mapping={38:-1,40:1,37:-1,39:1};// Left or Right
if(keyCode===37||keyCode===39){var step=mapping[keyCode];this.changeSelectionRange(step);event.preventDefault();return;}// Up or Down
if(keyCode===38||keyCode===40){var _step=mapping[keyCode];this.spinner.scrollDown(_step);event.preventDefault();return;}}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_time_rangevue_type_script_lang_js_=time_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
/* normalize component */var time_range_component=normalizeComponent(panel_time_rangevue_type_script_lang_js_,time_rangevue_type_template_id_fb28660e_render,time_rangevue_type_template_id_fb28660e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_range_api;}time_range_component.options.__file="packages/date-picker/src/panel/time-range.vue";/* harmony default export */var time_range=time_range_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
/* harmony default export */var time_picker={mixins:[picker],name:'ElTimePicker',props:{isRange:Boolean,arrowControl:Boolean},data:function data(){return{type:''};},watch:{isRange:function isRange(_isRange){if(this.picker){this.unmountPicker();this.type=_isRange?'timerange':'time';this.panel=_isRange?time_range:panel_time;this.mountPicker();}else{this.type=_isRange?'timerange':'time';this.panel=_isRange?time_range:panel_time;}}},created:function created(){this.type=this.isRange?'timerange':'time';this.panel=this.isRange?time_range:panel_time;}};// CONCATENATED MODULE: ./packages/time-picker/index.js
/* istanbul ignore next */time_picker.install=function(Vue){Vue.component(time_picker.name,time_picker);};/* harmony default export */var packages_time_picker=time_picker;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
var mainvue_type_template_id_52060272_render=function mainvue_type_template_id_52060272_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",[_c("transition",{attrs:{name:_vm.transition},on:{"after-enter":_vm.handleAfterEnter,"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:!_vm.disabled&&_vm.showPopper,expression:"!disabled && showPopper"}],ref:"popper",staticClass:"el-popover el-popper",class:[_vm.popperClass,_vm.content&&"el-popover--plain"],style:{width:_vm.width+"px"},attrs:{role:"tooltip",id:_vm.tooltipId,"aria-hidden":_vm.disabled||!_vm.showPopper?"true":"false"}},[_vm.title?_c("div",{staticClass:"el-popover__title",domProps:{textContent:_vm._s(_vm.title)}}):_vm._e(),_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2)]),_c("span",{ref:"wrapper",staticClass:"el-popover__reference-wrapper"},[_vm._t("reference")],2)],1);};var mainvue_type_template_id_52060272_staticRenderFns=[];mainvue_type_template_id_52060272_render._withStripped=true;// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var mainvue_type_script_lang_js_={name:'ElPopover',mixins:[vue_popper_default.a],props:{trigger:{type:String,default:'click',validator:function validator(value){return['click','focus','hover','manual'].indexOf(value)>-1;}},openDelay:{type:Number,default:0},closeDelay:{type:Number,default:200},title:String,disabled:Boolean,content:String,reference:{},popperClass:String,width:{},visibleArrow:{default:true},arrowOffset:{type:Number,default:0},transition:{type:String,default:'fade-in-linear'},tabindex:{type:Number,default:0}},computed:{tooltipId:function tooltipId(){return'el-popover-'+Object(util_["generateId"])();}},watch:{showPopper:function showPopper(val){if(this.disabled){return;}val?this.$emit('show'):this.$emit('hide');}},mounted:function mounted(){var _this=this;var reference=this.referenceElm=this.reference||this.$refs.reference;var popper=this.popper||this.$refs.popper;if(!reference&&this.$refs.wrapper.children){reference=this.referenceElm=this.$refs.wrapper.children[0];}// 可访问性
if(reference){Object(dom_["addClass"])(reference,'el-popover__reference');reference.setAttribute('aria-describedby',this.tooltipId);reference.setAttribute('tabindex',this.tabindex);// tab序列
popper.setAttribute('tabindex',0);if(this.trigger!=='click'){Object(dom_["on"])(reference,'focusin',function(){_this.handleFocus();var instance=reference.__vue__;if(instance&&typeof instance.focus==='function'){instance.focus();}});Object(dom_["on"])(popper,'focusin',this.handleFocus);Object(dom_["on"])(reference,'focusout',this.handleBlur);Object(dom_["on"])(popper,'focusout',this.handleBlur);}Object(dom_["on"])(reference,'keydown',this.handleKeydown);Object(dom_["on"])(reference,'click',this.handleClick);}if(this.trigger==='click'){Object(dom_["on"])(reference,'click',this.doToggle);Object(dom_["on"])(document,'click',this.handleDocumentClick);}else if(this.trigger==='hover'){Object(dom_["on"])(reference,'mouseenter',this.handleMouseEnter);Object(dom_["on"])(popper,'mouseenter',this.handleMouseEnter);Object(dom_["on"])(reference,'mouseleave',this.handleMouseLeave);Object(dom_["on"])(popper,'mouseleave',this.handleMouseLeave);}else if(this.trigger==='focus'){if(this.tabindex<0){console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');}if(reference.querySelector('input, textarea')){Object(dom_["on"])(reference,'focusin',this.doShow);Object(dom_["on"])(reference,'focusout',this.doClose);}else{Object(dom_["on"])(reference,'mousedown',this.doShow);Object(dom_["on"])(reference,'mouseup',this.doClose);}}},beforeDestroy:function beforeDestroy(){this.cleanup();},deactivated:function deactivated(){this.cleanup();},methods:{doToggle:function doToggle(){this.showPopper=!this.showPopper;},doShow:function doShow(){this.showPopper=true;},doClose:function doClose(){this.showPopper=false;},handleFocus:function handleFocus(){Object(dom_["addClass"])(this.referenceElm,'focusing');if(this.trigger==='click'||this.trigger==='focus')this.showPopper=true;},handleClick:function handleClick(){Object(dom_["removeClass"])(this.referenceElm,'focusing');},handleBlur:function handleBlur(){Object(dom_["removeClass"])(this.referenceElm,'focusing');if(this.trigger==='click'||this.trigger==='focus')this.showPopper=false;},handleMouseEnter:function handleMouseEnter(){var _this2=this;clearTimeout(this._timer);if(this.openDelay){this._timer=setTimeout(function(){_this2.showPopper=true;},this.openDelay);}else{this.showPopper=true;}},handleKeydown:function handleKeydown(ev){if(ev.keyCode===27&&this.trigger!=='manual'){// esc
this.doClose();}},handleMouseLeave:function handleMouseLeave(){var _this3=this;clearTimeout(this._timer);if(this.closeDelay){this._timer=setTimeout(function(){_this3.showPopper=false;},this.closeDelay);}else{this.showPopper=false;}},handleDocumentClick:function handleDocumentClick(e){var reference=this.reference||this.$refs.reference;var popper=this.popper||this.$refs.popper;if(!reference&&this.$refs.wrapper.children){reference=this.referenceElm=this.$refs.wrapper.children[0];}if(!this.$el||!reference||this.$el.contains(e.target)||reference.contains(e.target)||!popper||popper.contains(e.target))return;this.showPopper=false;},handleAfterEnter:function handleAfterEnter(){this.$emit('after-enter');},handleAfterLeave:function handleAfterLeave(){this.$emit('after-leave');this.doDestroy();},cleanup:function cleanup(){if(this.openDelay||this.closeDelay){clearTimeout(this._timer);}}},destroyed:function destroyed(){var reference=this.reference;Object(dom_["off"])(reference,'click',this.doToggle);Object(dom_["off"])(reference,'mouseup',this.doClose);Object(dom_["off"])(reference,'mousedown',this.doShow);Object(dom_["off"])(reference,'focusin',this.doShow);Object(dom_["off"])(reference,'focusout',this.doClose);Object(dom_["off"])(reference,'mousedown',this.doShow);Object(dom_["off"])(reference,'mouseup',this.doClose);Object(dom_["off"])(reference,'mouseleave',this.handleMouseLeave);Object(dom_["off"])(reference,'mouseenter',this.handleMouseEnter);Object(dom_["off"])(document,'click',this.handleDocumentClick);}};// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var src_mainvue_type_script_lang_js_=mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/popover/src/main.vue
/* normalize component */var main_component=normalizeComponent(src_mainvue_type_script_lang_js_,mainvue_type_template_id_52060272_render,mainvue_type_template_id_52060272_staticRenderFns,false,null,null,null);/* hot reload */if(false){var main_api;}main_component.options.__file="packages/popover/src/main.vue";/* harmony default export */var main=main_component.exports;// CONCATENATED MODULE: ./packages/popover/src/directive.js
var getReference=function getReference(el,binding,vnode){var _ref=binding.expression?binding.value:binding.arg;var popper=vnode.context.$refs[_ref];if(popper){if(Array.isArray(popper)){popper[0].$refs.reference=el;}else{popper.$refs.reference=el;}}};/* harmony default export */var directive={bind:function bind(el,binding,vnode){getReference(el,binding,vnode);},inserted:function inserted(el,binding,vnode){getReference(el,binding,vnode);}};// CONCATENATED MODULE: ./packages/popover/index.js
external_vue_default.a.directive('popover',directive);/* istanbul ignore next */main.install=function(Vue){Vue.directive('popover',directive);Vue.component(main.name,main);};main.directive=directive;/* harmony default export */var popover=main;// CONCATENATED MODULE: ./packages/tooltip/src/main.js
/* harmony default export */var src_main={name:'ElTooltip',mixins:[vue_popper_default.a],props:{openDelay:{type:Number,default:0},disabled:Boolean,manual:Boolean,effect:{type:String,default:'dark'},arrowOffset:{type:Number,default:0},popperClass:String,content:String,visibleArrow:{default:true},transition:{type:String,default:'el-fade-in-linear'},popperOptions:{default:function _default(){return{boundariesPadding:10,gpuAcceleration:false};}},enterable:{type:Boolean,default:true},hideAfter:{type:Number,default:0},tabindex:{type:Number,default:0}},data:function data(){return{tooltipId:'el-tooltip-'+Object(util_["generateId"])(),timeoutPending:null,focusing:false};},beforeCreate:function beforeCreate(){var _this=this;if(this.$isServer)return;this.popperVM=new external_vue_default.a({data:{node:''},render:function render(h){return this.node;}}).$mount();this.debounceClose=debounce_default()(200,function(){return _this.handleClosePopper();});},render:function render(h){var _this2=this;if(this.popperVM){this.popperVM.node=h('transition',{attrs:{name:this.transition},on:{'afterLeave':this.doDestroy}},[h('div',{on:{'mouseleave':function mouseleave(){_this2.setExpectedState(false);_this2.debounceClose();},'mouseenter':function mouseenter(){_this2.setExpectedState(true);}},ref:'popper',attrs:{role:'tooltip',id:this.tooltipId,'aria-hidden':this.disabled||!this.showPopper?'true':'false'},directives:[{name:'show',value:!this.disabled&&this.showPopper}],'class':['el-tooltip__popper','is-'+this.effect,this.popperClass]},[this.$slots.content||this.content])]);}var firstElement=this.getFirstElement();if(!firstElement)return null;var data=firstElement.data=firstElement.data||{};data.staticClass=this.addTooltipClass(data.staticClass);return firstElement;},mounted:function mounted(){var _this3=this;this.referenceElm=this.$el;if(this.$el.nodeType===1){this.$el.setAttribute('aria-describedby',this.tooltipId);this.$el.setAttribute('tabindex',this.tabindex);Object(dom_["on"])(this.referenceElm,'mouseenter',this.show);Object(dom_["on"])(this.referenceElm,'mouseleave',this.hide);Object(dom_["on"])(this.referenceElm,'focus',function(){if(!_this3.$slots.default||!_this3.$slots.default.length){_this3.handleFocus();return;}var instance=_this3.$slots.default[0].componentInstance;if(instance&&instance.focus){instance.focus();}else{_this3.handleFocus();}});Object(dom_["on"])(this.referenceElm,'blur',this.handleBlur);Object(dom_["on"])(this.referenceElm,'click',this.removeFocusing);}// fix issue https://github.com/ElemeFE/element/issues/14424
if(this.value&&this.popperVM){this.popperVM.$nextTick(function(){if(_this3.value){_this3.updatePopper();}});}},watch:{focusing:function focusing(val){if(val){Object(dom_["addClass"])(this.referenceElm,'focusing');}else{Object(dom_["removeClass"])(this.referenceElm,'focusing');}}},methods:{show:function show(){this.setExpectedState(true);this.handleShowPopper();},hide:function hide(){this.setExpectedState(false);this.debounceClose();},handleFocus:function handleFocus(){this.focusing=true;this.show();},handleBlur:function handleBlur(){this.focusing=false;this.hide();},removeFocusing:function removeFocusing(){this.focusing=false;},addTooltipClass:function addTooltipClass(prev){if(!prev){return'el-tooltip';}else{return'el-tooltip '+prev.replace('el-tooltip','');}},handleShowPopper:function handleShowPopper(){var _this4=this;if(!this.expectedState||this.manual)return;clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this4.showPopper=true;},this.openDelay);if(this.hideAfter>0){this.timeoutPending=setTimeout(function(){_this4.showPopper=false;},this.hideAfter);}},handleClosePopper:function handleClosePopper(){if(this.enterable&&this.expectedState||this.manual)return;clearTimeout(this.timeout);if(this.timeoutPending){clearTimeout(this.timeoutPending);}this.showPopper=false;if(this.disabled){this.doDestroy();}},setExpectedState:function setExpectedState(expectedState){if(expectedState===false){clearTimeout(this.timeoutPending);}this.expectedState=expectedState;},getFirstElement:function getFirstElement(){var slots=this.$slots.default;if(!Array.isArray(slots))return null;var element=null;for(var index=0;index<slots.length;index++){if(slots[index]&&slots[index].tag){element=slots[index];break;};}return element;}},beforeDestroy:function beforeDestroy(){this.popperVM&&this.popperVM.$destroy();},destroyed:function destroyed(){var reference=this.referenceElm;if(reference.nodeType===1){Object(dom_["off"])(reference,'mouseenter',this.show);Object(dom_["off"])(reference,'mouseleave',this.hide);Object(dom_["off"])(reference,'focus',this.handleFocus);Object(dom_["off"])(reference,'blur',this.handleBlur);Object(dom_["off"])(reference,'click',this.removeFocusing);}}};// CONCATENATED MODULE: ./packages/tooltip/index.js
/* istanbul ignore next */src_main.install=function(Vue){Vue.component(src_main.name,src_main);};/* harmony default export */var packages_tooltip=src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
var mainvue_type_template_id_6b29b012_render=function mainvue_type_template_id_6b29b012_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"msgbox-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-message-box__wrapper",attrs:{tabindex:"-1",role:"dialog","aria-modal":"true","aria-label":_vm.title||"dialog"},on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{staticClass:"el-message-box",class:[_vm.customClass,_vm.center&&"el-message-box--center"]},[_vm.title!==null?_c("div",{staticClass:"el-message-box__header"},[_c("div",{staticClass:"el-message-box__title"},[_vm.icon&&_vm.center?_c("div",{class:["el-message-box__status",_vm.icon]}):_vm._e(),_c("span",[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-message-box__headerbtn",attrs:{type:"button","aria-label":"Close"},on:{click:function click($event){_vm.handleAction(_vm.distinguishCancelAndClose?"close":"cancel");},keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction(_vm.distinguishCancelAndClose?"close":"cancel");}}},[_c("i",{staticClass:"el-message-box__close el-icon-close"})]):_vm._e()]):_vm._e(),_c("div",{staticClass:"el-message-box__content"},[_c("div",{staticClass:"el-message-box__container"},[_vm.icon&&!_vm.center&&_vm.message!==""?_c("div",{class:["el-message-box__status",_vm.icon]}):_vm._e(),_vm.message!==""?_c("div",{staticClass:"el-message-box__message"},[_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",[_vm._v(_vm._s(_vm.message))]):_c("p",{domProps:{innerHTML:_vm._s(_vm.message)}})])],2):_vm._e()]),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showInput,expression:"showInput"}],staticClass:"el-message-box__input"},[_c("el-input",{ref:"input",attrs:{type:_vm.inputType,placeholder:_vm.inputPlaceholder},nativeOn:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleInputEnter($event);}},model:{value:_vm.inputValue,callback:function callback($$v){_vm.inputValue=$$v;},expression:"inputValue"}}),_c("div",{staticClass:"el-message-box__errormsg",style:{visibility:!!_vm.editorErrorMessage?"visible":"hidden"}},[_vm._v(_vm._s(_vm.editorErrorMessage))])],1)]),_c("div",{staticClass:"el-message-box__btns"},[_vm.showCancelButton?_c("el-button",{class:[_vm.cancelButtonClasses],attrs:{loading:_vm.cancelButtonLoading,round:_vm.roundButton,size:"small"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction("cancel");}},nativeOn:{click:function click($event){_vm.handleAction("cancel");}}},[_vm._v("\n          "+_vm._s(_vm.cancelButtonText||_vm.t("el.messagebox.cancel"))+"\n        ")]):_vm._e(),_c("el-button",{directives:[{name:"show",rawName:"v-show",value:_vm.showConfirmButton,expression:"showConfirmButton"}],ref:"confirm",class:[_vm.confirmButtonClasses],attrs:{loading:_vm.confirmButtonLoading,round:_vm.roundButton,size:"small"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction("confirm");}},nativeOn:{click:function click($event){_vm.handleAction("confirm");}}},[_vm._v("\n          "+_vm._s(_vm.confirmButtonText||_vm.t("el.messagebox.confirm"))+"\n        ")])],1)])])]);};var mainvue_type_template_id_6b29b012_staticRenderFns=[];mainvue_type_template_id_6b29b012_render._withStripped=true;// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
// EXTERNAL MODULE: external "element-ui/lib/locale"
var lib_locale_=__webpack_require__(12);var lib_locale_default=/*#__PURE__*/__webpack_require__.n(lib_locale_);// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
var aria_dialog_=__webpack_require__(40);var aria_dialog_default=/*#__PURE__*/__webpack_require__.n(aria_dialog_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var messageBox=void 0;var typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var message_box_src_mainvue_type_script_lang_js_={mixins:[popup_default.a,locale_default.a],props:{modal:{default:true},lockScroll:{default:true},showClose:{type:Boolean,default:true},closeOnClickModal:{default:true},closeOnPressEscape:{default:true},closeOnHashChange:{default:true},center:{default:false,type:Boolean},roundButton:{default:false,type:Boolean}},components:{ElInput:input_default.a,ElButton:button_default.a},computed:{icon:function icon(){var type=this.type,iconClass=this.iconClass;return iconClass||(type&&typeMap[type]?'el-icon-'+typeMap[type]:'');},confirmButtonClasses:function confirmButtonClasses(){return'el-button--primary '+this.confirmButtonClass;},cancelButtonClasses:function cancelButtonClasses(){return''+this.cancelButtonClass;}},methods:{getSafeClose:function getSafeClose(){var _this=this;var currentId=this.uid;return function(){_this.$nextTick(function(){if(currentId===_this.uid)_this.doClose();});};},doClose:function doClose(){var _this2=this;if(!this.visible)return;this.visible=false;this._closing=true;this.onClose&&this.onClose();messageBox.closeDialog();// 解绑
if(this.lockScroll){setTimeout(this.restoreBodyStyle,200);}this.opened=false;this.doAfterClose();setTimeout(function(){if(_this2.action)_this2.callback(_this2.action,_this2);});},handleWrapperClick:function handleWrapperClick(){if(this.closeOnClickModal){this.handleAction(this.distinguishCancelAndClose?'close':'cancel');}},handleInputEnter:function handleInputEnter(){if(this.inputType!=='textarea'){return this.handleAction('confirm');}},handleAction:function handleAction(action){if(this.$type==='prompt'&&action==='confirm'&&!this.validate()){return;}this.action=action;if(typeof this.beforeClose==='function'){this.close=this.getSafeClose();this.beforeClose(action,this,this.close);}else{this.doClose();}},validate:function validate(){if(this.$type==='prompt'){var inputPattern=this.inputPattern;if(inputPattern&&!inputPattern.test(this.inputValue||'')){this.editorErrorMessage=this.inputErrorMessage||Object(lib_locale_["t"])('el.messagebox.error');Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}var inputValidator=this.inputValidator;if(typeof inputValidator==='function'){var validateResult=inputValidator(this.inputValue);if(validateResult===false){this.editorErrorMessage=this.inputErrorMessage||Object(lib_locale_["t"])('el.messagebox.error');Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}if(typeof validateResult==='string'){this.editorErrorMessage=validateResult;Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}}}this.editorErrorMessage='';Object(dom_["removeClass"])(this.getInputElement(),'invalid');return true;},getFirstFocus:function getFirstFocus(){var btn=this.$el.querySelector('.el-message-box__btns .el-button');var title=this.$el.querySelector('.el-message-box__btns .el-message-box__title');return btn||title;},getInputElement:function getInputElement(){var inputRefs=this.$refs.input.$refs;return inputRefs.input||inputRefs.textarea;},handleClose:function handleClose(){this.handleAction('close');}},watch:{inputValue:{immediate:true,handler:function handler(val){var _this3=this;this.$nextTick(function(_){if(_this3.$type==='prompt'&&val!==null){_this3.validate();}});}},visible:function visible(val){var _this4=this;if(val){this.uid++;if(this.$type==='alert'||this.$type==='confirm'){this.$nextTick(function(){_this4.$refs.confirm.$el.focus();});}this.focusAfterClosed=document.activeElement;messageBox=new aria_dialog_default.a(this.$el,this.focusAfterClosed,this.getFirstFocus());}// prompt
if(this.$type!=='prompt')return;if(val){setTimeout(function(){if(_this4.$refs.input&&_this4.$refs.input.$el){_this4.getInputElement().focus();}},500);}else{this.editorErrorMessage='';Object(dom_["removeClass"])(this.getInputElement(),'invalid');}}},mounted:function mounted(){var _this5=this;this.$nextTick(function(){if(_this5.closeOnHashChange){window.addEventListener('hashchange',_this5.close);}});},beforeDestroy:function beforeDestroy(){if(this.closeOnHashChange){window.removeEventListener('hashchange',this.close);}setTimeout(function(){messageBox.closeDialog();});},data:function data(){return{uid:1,title:undefined,message:'',type:'',iconClass:'',customClass:'',showInput:false,inputValue:null,inputPlaceholder:'',inputType:'text',inputPattern:null,inputValidator:null,inputErrorMessage:'',showConfirmButton:true,showCancelButton:false,action:'',confirmButtonText:'',cancelButtonText:'',confirmButtonLoading:false,cancelButtonLoading:false,confirmButtonClass:'',confirmButtonDisabled:false,cancelButtonClass:'',editorErrorMessage:null,callback:null,dangerouslyUseHTMLString:false,focusAfterClosed:null,isOnComposition:false,distinguishCancelAndClose:false};}};// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_message_box_src_mainvue_type_script_lang_js_=message_box_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/message-box/src/main.vue
/* normalize component */var src_main_component=normalizeComponent(packages_message_box_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6b29b012_render,mainvue_type_template_id_6b29b012_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_main_api;}src_main_component.options.__file="packages/message-box/src/main.vue";/* harmony default export */var message_box_src_main=src_main_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_=__webpack_require__(22);// CONCATENATED MODULE: ./packages/message-box/src/main.js
var main_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var main_defaults={title:null,message:'',type:'',iconClass:'',showInput:false,showClose:true,modalFade:true,lockScroll:true,closeOnClickModal:true,closeOnPressEscape:true,closeOnHashChange:true,inputValue:null,inputPlaceholder:'',inputType:'text',inputPattern:null,inputValidator:null,inputErrorMessage:'',showConfirmButton:true,showCancelButton:false,confirmButtonPosition:'right',confirmButtonHighlight:false,cancelButtonHighlight:false,confirmButtonText:'',cancelButtonText:'',confirmButtonClass:'',cancelButtonClass:'',customClass:'',beforeClose:null,dangerouslyUseHTMLString:false,center:false,roundButton:false,distinguishCancelAndClose:false};var MessageBoxConstructor=external_vue_default.a.extend(message_box_src_main);var currentMsg=void 0,main_instance=void 0;var msgQueue=[];var defaultCallback=function defaultCallback(action){if(currentMsg){var callback=currentMsg.callback;if(typeof callback==='function'){if(main_instance.showInput){callback(main_instance.inputValue,action);}else{callback(action);}}if(currentMsg.resolve){if(action==='confirm'){if(main_instance.showInput){currentMsg.resolve({value:main_instance.inputValue,action:action});}else{currentMsg.resolve(action);}}else if(currentMsg.reject&&(action==='cancel'||action==='close')){currentMsg.reject(action);}}}};var initInstance=function initInstance(){main_instance=new MessageBoxConstructor({el:document.createElement('div')});main_instance.callback=defaultCallback;};var main_showNextMsg=function showNextMsg(){if(!main_instance){initInstance();}main_instance.action='';if(!main_instance.visible||main_instance.closeTimer){if(msgQueue.length>0){currentMsg=msgQueue.shift();var options=currentMsg.options;for(var prop in options){if(options.hasOwnProperty(prop)){main_instance[prop]=options[prop];}}if(options.callback===undefined){main_instance.callback=defaultCallback;}var oldCb=main_instance.callback;main_instance.callback=function(action,instance){oldCb(action,instance);showNextMsg();};if(Object(vdom_["isVNode"])(main_instance.message)){main_instance.$slots.default=[main_instance.message];main_instance.message=null;}else{delete main_instance.$slots.default;}['modal','showClose','closeOnClickModal','closeOnPressEscape','closeOnHashChange'].forEach(function(prop){if(main_instance[prop]===undefined){main_instance[prop]=true;}});document.body.appendChild(main_instance.$el);external_vue_default.a.nextTick(function(){main_instance.visible=true;});}}};var main_MessageBox=function MessageBox(options,callback){if(external_vue_default.a.prototype.$isServer)return;if(typeof options==='string'||Object(vdom_["isVNode"])(options)){options={message:options};if(typeof arguments[1]==='string'){options.title=arguments[1];}}else if(options.callback&&!callback){callback=options.callback;}if(typeof Promise!=='undefined'){return new Promise(function(resolve,reject){// eslint-disable-line
msgQueue.push({options:merge_default()({},main_defaults,MessageBox.defaults,options),callback:callback,resolve:resolve,reject:reject});main_showNextMsg();});}else{msgQueue.push({options:merge_default()({},main_defaults,MessageBox.defaults,options),callback:callback});main_showNextMsg();}};main_MessageBox.setDefaults=function(defaults){main_MessageBox.defaults=defaults;};main_MessageBox.alert=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,$type:'alert',closeOnPressEscape:false,closeOnClickModal:false},options));};main_MessageBox.confirm=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,$type:'confirm',showCancelButton:true},options));};main_MessageBox.prompt=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,showCancelButton:true,showInput:true,$type:'prompt'},options));};main_MessageBox.close=function(){main_instance.doClose();main_instance.visible=false;msgQueue=[];currentMsg=null;};/* harmony default export */var packages_message_box_src_main=main_MessageBox;// CONCATENATED MODULE: ./packages/message-box/index.js
/* harmony default export */var message_box=packages_message_box_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
var breadcrumbvue_type_template_id_4b464c06_render=function breadcrumbvue_type_template_id_4b464c06_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-breadcrumb",attrs:{"aria-label":"Breadcrumb",role:"navigation"}},[_vm._t("default")],2);};var breadcrumbvue_type_template_id_4b464c06_staticRenderFns=[];breadcrumbvue_type_template_id_4b464c06_render._withStripped=true;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var breadcrumbvue_type_script_lang_js_={name:'ElBreadcrumb',props:{separator:{type:String,default:'/'},separatorClass:{type:String,default:''}},provide:function provide(){return{elBreadcrumb:this};},mounted:function mounted(){var items=this.$el.querySelectorAll('.el-breadcrumb__item');if(items.length){items[items.length-1].setAttribute('aria-current','page');}}};// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
/* harmony default export */var src_breadcrumbvue_type_script_lang_js_=breadcrumbvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
/* normalize component */var breadcrumb_component=normalizeComponent(src_breadcrumbvue_type_script_lang_js_,breadcrumbvue_type_template_id_4b464c06_render,breadcrumbvue_type_template_id_4b464c06_staticRenderFns,false,null,null,null);/* hot reload */if(false){var breadcrumb_api;}breadcrumb_component.options.__file="packages/breadcrumb/src/breadcrumb.vue";/* harmony default export */var breadcrumb=breadcrumb_component.exports;// CONCATENATED MODULE: ./packages/breadcrumb/index.js
/* istanbul ignore next */breadcrumb.install=function(Vue){Vue.component(breadcrumb.name,breadcrumb);};/* harmony default export */var packages_breadcrumb=breadcrumb;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
var breadcrumb_itemvue_type_template_id_fcf9eaac_render=function breadcrumb_itemvue_type_template_id_fcf9eaac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",{staticClass:"el-breadcrumb__item"},[_c("span",{ref:"link",class:["el-breadcrumb__inner",_vm.to?"is-link":""],attrs:{role:"link"}},[_vm._t("default")],2),_vm.separatorClass?_c("i",{staticClass:"el-breadcrumb__separator",class:_vm.separatorClass}):_c("span",{staticClass:"el-breadcrumb__separator",attrs:{role:"presentation"}},[_vm._v(_vm._s(_vm.separator))])]);};var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns=[];breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped=true;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var breadcrumb_itemvue_type_script_lang_js_={name:'ElBreadcrumbItem',props:{to:{},replace:Boolean},data:function data(){return{separator:'',separatorClass:''};},inject:['elBreadcrumb'],mounted:function mounted(){var _this=this;this.separator=this.elBreadcrumb.separator;this.separatorClass=this.elBreadcrumb.separatorClass;var link=this.$refs.link;link.setAttribute('role','link');link.addEventListener('click',function(_){var to=_this.to,$router=_this.$router;if(!to||!$router)return;_this.replace?$router.replace(to):$router.push(to);});}};// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_breadcrumb_itemvue_type_script_lang_js_=breadcrumb_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
/* normalize component */var breadcrumb_item_component=normalizeComponent(src_breadcrumb_itemvue_type_script_lang_js_,breadcrumb_itemvue_type_template_id_fcf9eaac_render,breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var breadcrumb_item_api;}breadcrumb_item_component.options.__file="packages/breadcrumb/src/breadcrumb-item.vue";/* harmony default export */var breadcrumb_item=breadcrumb_item_component.exports;// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
/* istanbul ignore next */breadcrumb_item.install=function(Vue){Vue.component(breadcrumb_item.name,breadcrumb_item);};/* harmony default export */var packages_breadcrumb_item=breadcrumb_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
var formvue_type_template_id_a1b5ff34_render=function formvue_type_template_id_a1b5ff34_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("form",{staticClass:"el-form",class:[_vm.labelPosition?"el-form--label-"+_vm.labelPosition:"",{"el-form--inline":_vm.inline}]},[_vm._t("default")],2);};var formvue_type_template_id_a1b5ff34_staticRenderFns=[];formvue_type_template_id_a1b5ff34_render._withStripped=true;// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var formvue_type_script_lang_js_={name:'ElForm',componentName:'ElForm',provide:function provide(){return{elForm:this};},props:{model:Object,rules:Object,labelPosition:String,labelWidth:String,labelSuffix:{type:String,default:''},inline:Boolean,inlineMessage:Boolean,statusIcon:Boolean,showMessage:{type:Boolean,default:true},size:String,disabled:Boolean,validateOnRuleChange:{type:Boolean,default:true},hideRequiredAsterisk:{type:Boolean,default:false}},watch:{rules:function rules(){// remove then add event listeners on form-item after form rules change
this.fields.forEach(function(field){field.removeValidateEvents();field.addValidateEvents();});if(this.validateOnRuleChange){this.validate(function(){});}}},computed:{autoLabelWidth:function autoLabelWidth(){if(!this.potentialLabelWidthArr.length)return 0;var max=Math.max.apply(Math,this.potentialLabelWidthArr);return max?max+'px':'';}},data:function data(){return{fields:[],potentialLabelWidthArr:[]// use this array to calculate auto width
};},created:function created(){var _this=this;this.$on('el.form.addField',function(field){if(field){_this.fields.push(field);}});/* istanbul ignore next */this.$on('el.form.removeField',function(field){if(field.prop){_this.fields.splice(_this.fields.indexOf(field),1);}});},methods:{resetFields:function resetFields(){if(!this.model){console.warn('[Element Warn][Form]model is required for resetFields to work.');return;}this.fields.forEach(function(field){field.resetField();});},clearValidate:function clearValidate(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var fields=props.length?typeof props==='string'?this.fields.filter(function(field){return props===field.prop;}):this.fields.filter(function(field){return props.indexOf(field.prop)>-1;}):this.fields;fields.forEach(function(field){field.clearValidate();});},validate:function validate(callback){var _this2=this;if(!this.model){console.warn('[Element Warn][Form]model is required for validate to work!');return;}var promise=void 0;// if no callback, return promise
if(typeof callback!=='function'&&window.Promise){promise=new window.Promise(function(resolve,reject){callback=function callback(valid,invalidFields){valid?resolve(valid):reject(invalidFields);};});}var valid=true;var count=0;// 如果需要验证的fields为空，调用验证时立刻返回callback
if(this.fields.length===0&&callback){callback(true);}var invalidFields={};this.fields.forEach(function(field){field.validate('',function(message,field){if(message){valid=false;}invalidFields=merge_default()({},invalidFields,field);if(typeof callback==='function'&&++count===_this2.fields.length){callback(valid,invalidFields);}});});if(promise){return promise;}},validateField:function validateField(props,cb){props=[].concat(props);var fields=this.fields.filter(function(field){return props.indexOf(field.prop)!==-1;});if(!fields.length){console.warn('[Element Warn]please pass correct props!');return;}fields.forEach(function(field){field.validate('',cb);});},getLabelWidthIndex:function getLabelWidthIndex(width){var index=this.potentialLabelWidthArr.indexOf(width);// it's impossible
if(index===-1){throw new Error('[ElementForm]unpected width ',width);}return index;},registerLabelWidth:function registerLabelWidth(val,oldVal){if(val&&oldVal){var index=this.getLabelWidthIndex(oldVal);this.potentialLabelWidthArr.splice(index,1,val);}else if(val){this.potentialLabelWidthArr.push(val);}},deregisterLabelWidth:function deregisterLabelWidth(val){var index=this.getLabelWidthIndex(val);this.potentialLabelWidthArr.splice(index,1);}}};// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
/* harmony default export */var src_formvue_type_script_lang_js_=formvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/form.vue
/* normalize component */var form_component=normalizeComponent(src_formvue_type_script_lang_js_,formvue_type_template_id_a1b5ff34_render,formvue_type_template_id_a1b5ff34_staticRenderFns,false,null,null,null);/* hot reload */if(false){var form_api;}form_component.options.__file="packages/form/src/form.vue";/* harmony default export */var src_form=form_component.exports;// CONCATENATED MODULE: ./packages/form/index.js
/* istanbul ignore next */src_form.install=function(Vue){Vue.component(src_form.name,src_form);};/* harmony default export */var packages_form=src_form;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
var form_itemvue_type_template_id_b6f3db6c_render=function form_itemvue_type_template_id_b6f3db6c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-form-item",class:[{"el-form-item--feedback":_vm.elForm&&_vm.elForm.statusIcon,"is-error":_vm.validateState==="error","is-validating":_vm.validateState==="validating","is-success":_vm.validateState==="success","is-required":_vm.isRequired||_vm.required,"is-no-asterisk":_vm.elForm&&_vm.elForm.hideRequiredAsterisk},_vm.sizeClass?"el-form-item--"+_vm.sizeClass:""]},[_c("label-wrap",{attrs:{"is-auto-width":_vm.labelStyle&&_vm.labelStyle.width==="auto","update-all":_vm.form.labelWidth==="auto"}},[_vm.label||_vm.$slots.label?_c("label",{staticClass:"el-form-item__label",style:_vm.labelStyle,attrs:{for:_vm.labelFor}},[_vm._t("label",[_vm._v(_vm._s(_vm.label+_vm.form.labelSuffix))])],2):_vm._e()]),_c("div",{staticClass:"el-form-item__content",style:_vm.contentStyle},[_vm._t("default"),_c("transition",{attrs:{name:"el-zoom-in-top"}},[_vm.validateState==="error"&&_vm.showMessage&&_vm.form.showMessage?_vm._t("error",[_c("div",{staticClass:"el-form-item__error",class:{"el-form-item__error--inline":typeof _vm.inlineMessage==="boolean"?_vm.inlineMessage:_vm.elForm&&_vm.elForm.inlineMessage||false}},[_vm._v("\n          "+_vm._s(_vm.validateMessage)+"\n        ")])],{error:_vm.validateMessage}):_vm._e()],2)],2)],1);};var form_itemvue_type_template_id_b6f3db6c_staticRenderFns=[];form_itemvue_type_template_id_b6f3db6c_render._withStripped=true;// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
// EXTERNAL MODULE: external "async-validator"
var external_async_validator_=__webpack_require__(41);var external_async_validator_default=/*#__PURE__*/__webpack_require__.n(external_async_validator_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
/* harmony default export */var label_wrapvue_type_script_lang_js_={props:{isAutoWidth:Boolean,updateAll:Boolean},inject:['elForm','elFormItem'],render:function render(){var h=arguments[0];var slots=this.$slots.default;if(!slots)return null;if(this.isAutoWidth){var autoLabelWidth=this.elForm.autoLabelWidth;var style={};if(autoLabelWidth&&autoLabelWidth!=='auto'){var marginLeft=parseInt(autoLabelWidth,10)-this.computedWidth;if(marginLeft){style.marginLeft=marginLeft+'px';}}return h('div',{'class':'el-form-item__label-wrap',style:style},[slots]);}else{return slots[0];}},methods:{getLabelWidth:function getLabelWidth(){if(this.$el&&this.$el.firstElementChild){var computedWidth=window.getComputedStyle(this.$el.firstElementChild).width;return Math.ceil(parseFloat(computedWidth));}else{return 0;}},updateLabelWidth:function updateLabelWidth(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'update';if(this.$slots.default&&this.isAutoWidth&&this.$el.firstElementChild){if(action==='update'){this.computedWidth=this.getLabelWidth();}else if(action==='remove'){this.elForm.deregisterLabelWidth(this.computedWidth);}}}},watch:{computedWidth:function computedWidth(val,oldVal){if(this.updateAll){this.elForm.registerLabelWidth(val,oldVal);this.elFormItem.updateComputedLabelWidth(val);}}},data:function data(){return{computedWidth:0};},mounted:function mounted(){this.updateLabelWidth('update');},updated:function updated(){this.updateLabelWidth('update');},beforeDestroy:function beforeDestroy(){this.updateLabelWidth('remove');}};// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
/* harmony default export */var src_label_wrapvue_type_script_lang_js_=label_wrapvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
var label_wrap_render,label_wrap_staticRenderFns;/* normalize component */var label_wrap_component=normalizeComponent(src_label_wrapvue_type_script_lang_js_,label_wrap_render,label_wrap_staticRenderFns,false,null,null,null);/* hot reload */if(false){var label_wrap_api;}label_wrap_component.options.__file="packages/form/src/label-wrap.vue";/* harmony default export */var label_wrap=label_wrap_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var form_itemvue_type_script_lang_js_={name:'ElFormItem',componentName:'ElFormItem',mixins:[emitter_default.a],provide:function provide(){return{elFormItem:this};},inject:['elForm'],props:{label:String,labelWidth:String,prop:String,required:{type:Boolean,default:undefined},rules:[Object,Array],error:String,validateStatus:String,for:String,inlineMessage:{type:[String,Boolean],default:''},showMessage:{type:Boolean,default:true},size:String},components:{// use this component to calculate auto width
LabelWrap:label_wrap},watch:{error:{immediate:true,handler:function handler(value){this.validateMessage=value;this.validateState=value?'error':'';}},validateStatus:function validateStatus(value){this.validateState=value;},rules:function rules(value){if((!value||value.length===0)&&this.required===undefined){this.clearValidate();}}},computed:{labelFor:function labelFor(){return this.for||this.prop;},labelStyle:function labelStyle(){var ret={};if(this.form.labelPosition==='top')return ret;var labelWidth=this.labelWidth||this.form.labelWidth;if(labelWidth){ret.width=labelWidth;}return ret;},contentStyle:function contentStyle(){var ret={};var label=this.label;if(this.form.labelPosition==='top'||this.form.inline)return ret;if(!label&&!this.labelWidth&&this.isNested)return ret;var labelWidth=this.labelWidth||this.form.labelWidth;if(labelWidth==='auto'){if(this.labelWidth==='auto'){ret.marginLeft=this.computedLabelWidth;}else if(this.form.labelWidth==='auto'){ret.marginLeft=this.elForm.autoLabelWidth;}}else{ret.marginLeft=labelWidth;}return ret;},form:function form(){var parent=this.$parent;var parentName=parent.$options.componentName;while(parentName!=='ElForm'){if(parentName==='ElFormItem'){this.isNested=true;}parent=parent.$parent;parentName=parent.$options.componentName;}return parent;},fieldValue:function fieldValue(){var model=this.form.model;if(!model||!this.prop){return;}var path=this.prop;if(path.indexOf(':')!==-1){path=path.replace(/:/,'.');}return Object(util_["getPropByPath"])(model,path,true).v;},isRequired:function isRequired(){var rules=this.getRules();var isRequired=false;if(rules&&rules.length){rules.every(function(rule){if(rule.required){isRequired=true;return false;}return true;});}return isRequired;},_formSize:function _formSize(){return this.elForm.size;},elFormItemSize:function elFormItemSize(){return this.size||this._formSize;},sizeClass:function sizeClass(){return this.elFormItemSize||(this.$ELEMENT||{}).size;}},data:function data(){return{validateState:'',validateMessage:'',validateDisabled:false,validator:{},isNested:false,computedLabelWidth:''};},methods:{validate:function validate(trigger){var _this=this;var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:util_["noop"];this.validateDisabled=false;var rules=this.getFilteredRule(trigger);if((!rules||rules.length===0)&&this.required===undefined){callback();return true;}this.validateState='validating';var descriptor={};if(rules&&rules.length>0){rules.forEach(function(rule){delete rule.trigger;});}descriptor[this.prop]=rules;var validator=new external_async_validator_default.a(descriptor);var model={};model[this.prop]=this.fieldValue;validator.validate(model,{firstFields:true},function(errors,invalidFields){_this.validateState=!errors?'success':'error';_this.validateMessage=errors?errors[0].message:'';callback(_this.validateMessage,invalidFields);_this.elForm&&_this.elForm.$emit('validate',_this.prop,!errors,_this.validateMessage||null);});},clearValidate:function clearValidate(){this.validateState='';this.validateMessage='';this.validateDisabled=false;},resetField:function resetField(){var _this2=this;this.validateState='';this.validateMessage='';var model=this.form.model;var value=this.fieldValue;var path=this.prop;if(path.indexOf(':')!==-1){path=path.replace(/:/,'.');}var prop=Object(util_["getPropByPath"])(model,path,true);this.validateDisabled=true;if(Array.isArray(value)){prop.o[prop.k]=[].concat(this.initialValue);}else{prop.o[prop.k]=this.initialValue;}// reset validateDisabled after onFieldChange triggered
this.$nextTick(function(){_this2.validateDisabled=false;});this.broadcast('ElTimeSelect','fieldReset',this.initialValue);},getRules:function getRules(){var formRules=this.form.rules;var selfRules=this.rules;var requiredRule=this.required!==undefined?{required:!!this.required}:[];var prop=Object(util_["getPropByPath"])(formRules,this.prop||'');formRules=formRules?prop.o[this.prop||'']||prop.v:[];return[].concat(selfRules||formRules||[]).concat(requiredRule);},getFilteredRule:function getFilteredRule(trigger){var rules=this.getRules();return rules.filter(function(rule){if(!rule.trigger||trigger==='')return true;if(Array.isArray(rule.trigger)){return rule.trigger.indexOf(trigger)>-1;}else{return rule.trigger===trigger;}}).map(function(rule){return merge_default()({},rule);});},onFieldBlur:function onFieldBlur(){this.validate('blur');},onFieldChange:function onFieldChange(){if(this.validateDisabled){this.validateDisabled=false;return;}this.validate('change');},updateComputedLabelWidth:function updateComputedLabelWidth(width){this.computedLabelWidth=width?width+'px':'';},addValidateEvents:function addValidateEvents(){var rules=this.getRules();if(rules.length||this.required!==undefined){this.$on('el.form.blur',this.onFieldBlur);this.$on('el.form.change',this.onFieldChange);}},removeValidateEvents:function removeValidateEvents(){this.$off();}},mounted:function mounted(){if(this.prop){this.dispatch('ElForm','el.form.addField',[this]);var initialValue=this.fieldValue;if(Array.isArray(initialValue)){initialValue=[].concat(initialValue);}Object.defineProperty(this,'initialValue',{value:initialValue});this.addValidateEvents();}},beforeDestroy:function beforeDestroy(){this.dispatch('ElForm','el.form.removeField',[this]);}};// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_form_itemvue_type_script_lang_js_=form_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/form-item.vue
/* normalize component */var form_item_component=normalizeComponent(src_form_itemvue_type_script_lang_js_,form_itemvue_type_template_id_b6f3db6c_render,form_itemvue_type_template_id_b6f3db6c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var form_item_api;}form_item_component.options.__file="packages/form/src/form-item.vue";/* harmony default export */var form_item=form_item_component.exports;// CONCATENATED MODULE: ./packages/form-item/index.js
/* istanbul ignore next */form_item.install=function(Vue){Vue.component(form_item.name,form_item);};/* harmony default export */var packages_form_item=form_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
var tab_barvue_type_template_id_2031f33a_render=function tab_barvue_type_template_id_2031f33a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-tabs__active-bar",class:"is-"+_vm.rootTabs.tabPosition,style:_vm.barStyle});};var tab_barvue_type_template_id_2031f33a_staticRenderFns=[];tab_barvue_type_template_id_2031f33a_render._withStripped=true;// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
//
//
//
/* harmony default export */var tab_barvue_type_script_lang_js_={name:'TabBar',props:{tabs:Array},inject:['rootTabs'],computed:{barStyle:{get:function get(){var _this=this;var style={};var offset=0;var tabSize=0;var sizeName=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'width':'height';var sizeDir=sizeName==='width'?'x':'y';var firstUpperCase=function firstUpperCase(str){return str.toLowerCase().replace(/( |^)[a-z]/g,function(L){return L.toUpperCase();});};this.tabs.every(function(tab,index){var $el=Object(util_["arrayFind"])(_this.$parent.$refs.tabs||[],function(t){return t.id.replace('tab-','')===tab.paneName;});if(!$el){return false;}if(!tab.active){offset+=$el['client'+firstUpperCase(sizeName)];return true;}else{tabSize=$el['client'+firstUpperCase(sizeName)];var tabStyles=window.getComputedStyle($el);if(sizeName==='width'&&_this.tabs.length>1){tabSize-=parseFloat(tabStyles.paddingLeft)+parseFloat(tabStyles.paddingRight);}if(sizeName==='width'){offset+=parseFloat(tabStyles.paddingLeft);}return false;}});var transform='translate'+firstUpperCase(sizeDir)+'('+offset+'px)';style[sizeName]=tabSize+'px';style.transform=transform;style.msTransform=transform;style.webkitTransform=transform;return style;}}}};// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_barvue_type_script_lang_js_=tab_barvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
/* normalize component */var tab_bar_component=normalizeComponent(src_tab_barvue_type_script_lang_js_,tab_barvue_type_template_id_2031f33a_render,tab_barvue_type_template_id_2031f33a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_bar_api;}tab_bar_component.options.__file="packages/tabs/src/tab-bar.vue";/* harmony default export */var tab_bar=tab_bar_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
function noop(){}var tab_navvue_type_script_lang_js_firstUpperCase=function firstUpperCase(str){return str.toLowerCase().replace(/( |^)[a-z]/g,function(L){return L.toUpperCase();});};/* harmony default export */var tab_navvue_type_script_lang_js_={name:'TabNav',components:{TabBar:tab_bar},inject:['rootTabs'],props:{panes:Array,currentName:String,editable:Boolean,onTabClick:{type:Function,default:noop},onTabRemove:{type:Function,default:noop},type:String,stretch:Boolean},data:function data(){return{scrollable:false,navOffset:0,isFocus:false,focusable:true};},computed:{navStyle:function navStyle(){var dir=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'X':'Y';return{transform:'translate'+dir+'(-'+this.navOffset+'px)'};},sizeName:function sizeName(){return['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'width':'height';}},methods:{scrollPrev:function scrollPrev(){var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var currentOffset=this.navOffset;if(!currentOffset)return;var newOffset=currentOffset>containerSize?currentOffset-containerSize:0;this.navOffset=newOffset;},scrollNext:function scrollNext(){var navSize=this.$refs.nav['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var currentOffset=this.navOffset;if(navSize-currentOffset<=containerSize)return;var newOffset=navSize-currentOffset>containerSize*2?currentOffset+containerSize:navSize-containerSize;this.navOffset=newOffset;},scrollToActiveTab:function scrollToActiveTab(){if(!this.scrollable)return;var nav=this.$refs.nav;var activeTab=this.$el.querySelector('.is-active');if(!activeTab)return;var navScroll=this.$refs.navScroll;var isHorizontal=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1;var activeTabBounding=activeTab.getBoundingClientRect();var navScrollBounding=navScroll.getBoundingClientRect();var maxOffset=isHorizontal?nav.offsetWidth-navScrollBounding.width:nav.offsetHeight-navScrollBounding.height;var currentOffset=this.navOffset;var newOffset=currentOffset;if(isHorizontal){if(activeTabBounding.left<navScrollBounding.left){newOffset=currentOffset-(navScrollBounding.left-activeTabBounding.left);}if(activeTabBounding.right>navScrollBounding.right){newOffset=currentOffset+activeTabBounding.right-navScrollBounding.right;}}else{if(activeTabBounding.top<navScrollBounding.top){newOffset=currentOffset-(navScrollBounding.top-activeTabBounding.top);}if(activeTabBounding.bottom>navScrollBounding.bottom){newOffset=currentOffset+(activeTabBounding.bottom-navScrollBounding.bottom);}}newOffset=Math.max(newOffset,0);this.navOffset=Math.min(newOffset,maxOffset);},update:function update(){if(!this.$refs.nav)return;var sizeName=this.sizeName;var navSize=this.$refs.nav['offset'+tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];var currentOffset=this.navOffset;if(containerSize<navSize){var _currentOffset=this.navOffset;this.scrollable=this.scrollable||{};this.scrollable.prev=_currentOffset;this.scrollable.next=_currentOffset+containerSize<navSize;if(navSize-_currentOffset<containerSize){this.navOffset=navSize-containerSize;}}else{this.scrollable=false;if(currentOffset>0){this.navOffset=0;}}},changeTab:function changeTab(e){var keyCode=e.keyCode;var nextIndex=void 0;var currentIndex=void 0,tabList=void 0;if([37,38,39,40].indexOf(keyCode)!==-1){// 左右上下键更换tab
tabList=e.currentTarget.querySelectorAll('[role=tab]');currentIndex=Array.prototype.indexOf.call(tabList,e.target);}else{return;}if(keyCode===37||keyCode===38){// left
if(currentIndex===0){// first
nextIndex=tabList.length-1;}else{nextIndex=currentIndex-1;}}else{// right
if(currentIndex<tabList.length-1){// not last
nextIndex=currentIndex+1;}else{nextIndex=0;}}tabList[nextIndex].focus();// 改变焦点元素
tabList[nextIndex].click();// 选中下一个tab
this.setFocus();},setFocus:function setFocus(){if(this.focusable){this.isFocus=true;}},removeFocus:function removeFocus(){this.isFocus=false;},visibilityChangeHandler:function visibilityChangeHandler(){var _this=this;var visibility=document.visibilityState;if(visibility==='hidden'){this.focusable=false;}else if(visibility==='visible'){setTimeout(function(){_this.focusable=true;},50);}},windowBlurHandler:function windowBlurHandler(){this.focusable=false;},windowFocusHandler:function windowFocusHandler(){var _this2=this;setTimeout(function(){_this2.focusable=true;},50);}},updated:function updated(){this.update();},render:function render(h){var _this3=this;var type=this.type,panes=this.panes,editable=this.editable,stretch=this.stretch,onTabClick=this.onTabClick,onTabRemove=this.onTabRemove,navStyle=this.navStyle,scrollable=this.scrollable,scrollNext=this.scrollNext,scrollPrev=this.scrollPrev,changeTab=this.changeTab,setFocus=this.setFocus,removeFocus=this.removeFocus;var scrollBtn=scrollable?[h('span',{'class':['el-tabs__nav-prev',scrollable.prev?'':'is-disabled'],on:{'click':scrollPrev}},[h('i',{'class':'el-icon-arrow-left'})]),h('span',{'class':['el-tabs__nav-next',scrollable.next?'':'is-disabled'],on:{'click':scrollNext}},[h('i',{'class':'el-icon-arrow-right'})])]:null;var tabs=this._l(panes,function(pane,index){var _ref;var tabName=pane.name||pane.index||index;var closable=pane.isClosable||editable;pane.index=''+index;var btnClose=closable?h('span',{'class':'el-icon-close',on:{'click':function click(ev){onTabRemove(pane,ev);}}}):null;var tabLabelContent=pane.$slots.label||pane.label;var tabindex=pane.active?0:-1;return h('div',{'class':(_ref={'el-tabs__item':true},_ref['is-'+_this3.rootTabs.tabPosition]=true,_ref['is-active']=pane.active,_ref['is-disabled']=pane.disabled,_ref['is-closable']=closable,_ref['is-focus']=_this3.isFocus,_ref),attrs:{id:'tab-'+tabName,'aria-controls':'pane-'+tabName,role:'tab','aria-selected':pane.active,tabindex:tabindex},key:'tab-'+tabName,ref:'tabs',refInFor:true,on:{'focus':function focus(){setFocus();},'blur':function blur(){removeFocus();},'click':function click(ev){removeFocus();onTabClick(pane,tabName,ev);},'keydown':function keydown(ev){if(closable&&(ev.keyCode===46||ev.keyCode===8)){onTabRemove(pane,ev);}}}},[tabLabelContent,btnClose]);});return h('div',{'class':['el-tabs__nav-wrap',scrollable?'is-scrollable':'','is-'+this.rootTabs.tabPosition]},[scrollBtn,h('div',{'class':['el-tabs__nav-scroll'],ref:'navScroll'},[h('div',{'class':['el-tabs__nav','is-'+this.rootTabs.tabPosition,stretch&&['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'is-stretch':''],ref:'nav',style:navStyle,attrs:{role:'tablist'},on:{'keydown':changeTab}},[!type?h('tab-bar',{attrs:{tabs:panes}}):null,tabs])])]);},mounted:function mounted(){var _this4=this;Object(resize_event_["addResizeListener"])(this.$el,this.update);document.addEventListener('visibilitychange',this.visibilityChangeHandler);window.addEventListener('blur',this.windowBlurHandler);window.addEventListener('focus',this.windowFocusHandler);setTimeout(function(){_this4.scrollToActiveTab();},0);},beforeDestroy:function beforeDestroy(){if(this.$el&&this.update)Object(resize_event_["removeResizeListener"])(this.$el,this.update);document.removeEventListener('visibilitychange',this.visibilityChangeHandler);window.removeEventListener('blur',this.windowBlurHandler);window.removeEventListener('focus',this.windowFocusHandler);}};// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_navvue_type_script_lang_js_=tab_navvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
var tab_nav_render,tab_nav_staticRenderFns;/* normalize component */var tab_nav_component=normalizeComponent(src_tab_navvue_type_script_lang_js_,tab_nav_render,tab_nav_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_nav_api;}tab_nav_component.options.__file="packages/tabs/src/tab-nav.vue";/* harmony default export */var tab_nav=tab_nav_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
/* harmony default export */var tabsvue_type_script_lang_js_={name:'ElTabs',components:{TabNav:tab_nav},props:{type:String,activeName:String,closable:Boolean,addable:Boolean,value:{},editable:Boolean,tabPosition:{type:String,default:'top'},beforeLeave:Function,stretch:Boolean},provide:function provide(){return{rootTabs:this};},data:function data(){return{currentName:this.value||this.activeName,panes:[]};},watch:{activeName:function activeName(value){this.setCurrentName(value);},value:function value(_value){this.setCurrentName(_value);},currentName:function currentName(value){var _this=this;if(this.$refs.nav){this.$nextTick(function(){_this.$refs.nav.$nextTick(function(_){_this.$refs.nav.scrollToActiveTab();});});}}},methods:{calcPaneInstances:function calcPaneInstances(){var _this2=this;var isForceUpdate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.$slots.default){var paneSlots=this.$slots.default.filter(function(vnode){return vnode.tag&&vnode.componentOptions&&vnode.componentOptions.Ctor.options.name==='ElTabPane';});// update indeed
var panes=paneSlots.map(function(_ref){var componentInstance=_ref.componentInstance;return componentInstance;});var panesChanged=!(panes.length===this.panes.length&&panes.every(function(pane,index){return pane===_this2.panes[index];}));if(isForceUpdate||panesChanged){this.panes=panes;}}else if(this.panes.length!==0){this.panes=[];}},handleTabClick:function handleTabClick(tab,tabName,event){if(tab.disabled)return;this.setCurrentName(tabName);this.$emit('tab-click',tab,event);},handleTabRemove:function handleTabRemove(pane,ev){if(pane.disabled)return;ev.stopPropagation();this.$emit('edit',pane.name,'remove');this.$emit('tab-remove',pane.name);},handleTabAdd:function handleTabAdd(){this.$emit('edit',null,'add');this.$emit('tab-add');},setCurrentName:function setCurrentName(value){var _this3=this;var changeCurrentName=function changeCurrentName(){_this3.currentName=value;_this3.$emit('input',value);};if(this.currentName!==value&&this.beforeLeave){var before=this.beforeLeave(value,this.currentName);if(before&&before.then){before.then(function(){changeCurrentName();_this3.$refs.nav&&_this3.$refs.nav.removeFocus();},function(){// https://github.com/ElemeFE/element/pull/14816
// ignore promise rejection in `before-leave` hook
});}else if(before!==false){changeCurrentName();}}else{changeCurrentName();}}},render:function render(h){var _ref2;var type=this.type,handleTabClick=this.handleTabClick,handleTabRemove=this.handleTabRemove,handleTabAdd=this.handleTabAdd,currentName=this.currentName,panes=this.panes,editable=this.editable,addable=this.addable,tabPosition=this.tabPosition,stretch=this.stretch;var newButton=editable||addable?h('span',{'class':'el-tabs__new-tab',on:{'click':handleTabAdd,'keydown':function keydown(ev){if(ev.keyCode===13){handleTabAdd();}}},attrs:{tabindex:'0'}},[h('i',{'class':'el-icon-plus'})]):null;var navData={props:{currentName:currentName,onTabClick:handleTabClick,onTabRemove:handleTabRemove,editable:editable,type:type,panes:panes,stretch:stretch},ref:'nav'};var header=h('div',{'class':['el-tabs__header','is-'+tabPosition]},[newButton,h('tab-nav',navData)]);var panels=h('div',{'class':'el-tabs__content'},[this.$slots.default]);return h('div',{'class':(_ref2={'el-tabs':true,'el-tabs--card':type==='card'},_ref2['el-tabs--'+tabPosition]=true,_ref2['el-tabs--border-card']=type==='border-card',_ref2)},[tabPosition!=='bottom'?[header,panels]:[panels,header]]);},created:function created(){if(!this.currentName){this.setCurrentName('0');}this.$on('tab-nav-update',this.calcPaneInstances.bind(null,true));},mounted:function mounted(){this.calcPaneInstances();},updated:function updated(){this.calcPaneInstances();}};// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
/* harmony default export */var src_tabsvue_type_script_lang_js_=tabsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
var tabs_render,tabs_staticRenderFns;/* normalize component */var tabs_component=normalizeComponent(src_tabsvue_type_script_lang_js_,tabs_render,tabs_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tabs_api;}tabs_component.options.__file="packages/tabs/src/tabs.vue";/* harmony default export */var tabs=tabs_component.exports;// CONCATENATED MODULE: ./packages/tabs/index.js
/* istanbul ignore next */tabs.install=function(Vue){Vue.component(tabs.name,tabs);};/* harmony default export */var packages_tabs=tabs;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
var tab_panevue_type_template_id_9145a070_render=function tab_panevue_type_template_id_9145a070_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return!_vm.lazy||_vm.loaded||_vm.active?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.active,expression:"active"}],staticClass:"el-tab-pane",attrs:{role:"tabpanel","aria-hidden":!_vm.active,id:"pane-"+_vm.paneName,"aria-labelledby":"tab-"+_vm.paneName}},[_vm._t("default")],2):_vm._e();};var tab_panevue_type_template_id_9145a070_staticRenderFns=[];tab_panevue_type_template_id_9145a070_render._withStripped=true;// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var tab_panevue_type_script_lang_js_={name:'ElTabPane',componentName:'ElTabPane',props:{label:String,labelContent:Function,name:String,closable:Boolean,disabled:Boolean,lazy:Boolean},data:function data(){return{index:null,loaded:false};},computed:{isClosable:function isClosable(){return this.closable||this.$parent.closable;},active:function active(){var active=this.$parent.currentName===(this.name||this.index);if(active){this.loaded=true;}return active;},paneName:function paneName(){return this.name||this.index;}},updated:function updated(){this.$parent.$emit('tab-nav-update');}};// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_panevue_type_script_lang_js_=tab_panevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
/* normalize component */var tab_pane_component=normalizeComponent(src_tab_panevue_type_script_lang_js_,tab_panevue_type_template_id_9145a070_render,tab_panevue_type_template_id_9145a070_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_pane_api;}tab_pane_component.options.__file="packages/tabs/src/tab-pane.vue";/* harmony default export */var tab_pane=tab_pane_component.exports;// CONCATENATED MODULE: ./packages/tab-pane/index.js
/* istanbul ignore next */tab_pane.install=function(Vue){Vue.component(tab_pane.name,tab_pane);};/* harmony default export */var packages_tab_pane=tab_pane;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
/* harmony default export */var tagvue_type_script_lang_js_={name:'ElTag',props:{text:String,closable:Boolean,type:String,hit:Boolean,disableTransitions:Boolean,color:String,size:String,effect:{type:String,default:'light',validator:function validator(val){return['dark','light','plain'].indexOf(val)!==-1;}}},methods:{handleClose:function handleClose(event){event.stopPropagation();this.$emit('close',event);},handleClick:function handleClick(event){this.$emit('click',event);}},computed:{tagSize:function tagSize(){return this.size||(this.$ELEMENT||{}).size;}},render:function render(h){var type=this.type,tagSize=this.tagSize,hit=this.hit,effect=this.effect;var classes=['el-tag',type?'el-tag--'+type:'',tagSize?'el-tag--'+tagSize:'',effect?'el-tag--'+effect:'',hit&&'is-hit'];var tagEl=h('span',{'class':classes,style:{backgroundColor:this.color},on:{'click':this.handleClick}},[this.$slots.default,this.closable&&h('i',{'class':'el-tag__close el-icon-close',on:{'click':this.handleClose}})]);return this.disableTransitions?tagEl:h('transition',{attrs:{name:'el-zoom-in-center'}},[tagEl]);}};// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
/* harmony default export */var src_tagvue_type_script_lang_js_=tagvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tag/src/tag.vue
var tag_render,tag_staticRenderFns;/* normalize component */var tag_component=normalizeComponent(src_tagvue_type_script_lang_js_,tag_render,tag_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tag_api;}tag_component.options.__file="packages/tag/src/tag.vue";/* harmony default export */var src_tag=tag_component.exports;// CONCATENATED MODULE: ./packages/tag/index.js
/* istanbul ignore next */src_tag.install=function(Vue){Vue.component(src_tag.name,src_tag);};/* harmony default export */var packages_tag=src_tag;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
var treevue_type_template_id_547575a6_render=function treevue_type_template_id_547575a6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-tree",class:{"el-tree--highlight-current":_vm.highlightCurrent,"is-dragging":!!_vm.dragState.draggingNode,"is-drop-not-allow":!_vm.dragState.allowDrop,"is-drop-inner":_vm.dragState.dropType==="inner"},attrs:{role:"tree"}},[_vm._l(_vm.root.childNodes,function(child){return _c("el-tree-node",{key:_vm.getNodeKey(child),attrs:{node:child,props:_vm.props,"render-after-expand":_vm.renderAfterExpand,"show-checkbox":_vm.showCheckbox,"render-content":_vm.renderContent},on:{"node-expand":_vm.handleNodeExpand}});}),_vm.isEmpty?_c("div",{staticClass:"el-tree__empty-block"},[_c("span",{staticClass:"el-tree__empty-text"},[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.dragState.showDropIndicator,expression:"dragState.showDropIndicator"}],ref:"dropIndicator",staticClass:"el-tree__drop-indicator"})],2);};var treevue_type_template_id_547575a6_staticRenderFns=[];treevue_type_template_id_547575a6_render._withStripped=true;// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
// CONCATENATED MODULE: ./packages/tree/src/model/util.js
var NODE_KEY='$treeNodeId';var markNodeData=function markNodeData(node,data){if(!data||data[NODE_KEY])return;Object.defineProperty(data,NODE_KEY,{value:node.id,enumerable:false,configurable:false,writable:false});};var util_getNodeKey=function getNodeKey(key,data){if(!key)return data[NODE_KEY];return data[key];};var findNearestComponent=function findNearestComponent(element,componentName){var target=element;while(target&&target.tagName!=='BODY'){if(target.__vue__&&target.__vue__.$options.name===componentName){return target.__vue__;}target=target.parentNode;}return null;};// CONCATENATED MODULE: ./packages/tree/src/model/node.js
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function node_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var getChildState=function getChildState(node){var all=true;var none=true;var allWithoutDisable=true;for(var i=0,j=node.length;i<j;i++){var n=node[i];if(n.checked!==true||n.indeterminate){all=false;if(!n.disabled){allWithoutDisable=false;}}if(n.checked!==false||n.indeterminate){none=false;}}return{all:all,none:none,allWithoutDisable:allWithoutDisable,half:!all&&!none};};var reInitChecked=function reInitChecked(node){if(node.childNodes.length===0||node.loading)return;var _getChildState=getChildState(node.childNodes),all=_getChildState.all,none=_getChildState.none,half=_getChildState.half;if(all){node.checked=true;node.indeterminate=false;}else if(half){node.checked=false;node.indeterminate=true;}else if(none){node.checked=false;node.indeterminate=false;}var parent=node.parent;if(!parent||parent.level===0)return;if(!node.store.checkStrictly){reInitChecked(parent);}};var getPropertyFromData=function getPropertyFromData(node,prop){var props=node.store.props;var data=node.data||{};var config=props[prop];if(typeof config==='function'){return config(data,node);}else if(typeof config==='string'){return data[config];}else if(typeof config==='undefined'){var dataProp=data[prop];return dataProp===undefined?'':dataProp;}};var nodeIdSeed=0;var node_Node=function(){function Node(options){node_classCallCheck(this,Node);this.id=nodeIdSeed++;this.text=null;this.checked=false;this.indeterminate=false;this.data=null;this.expanded=false;this.parent=null;this.visible=true;this.isCurrent=false;for(var name in options){if(options.hasOwnProperty(name)){this[name]=options[name];}}// internal
this.level=0;this.loaded=false;this.childNodes=[];this.loading=false;if(this.parent){this.level=this.parent.level+1;}var store=this.store;if(!store){throw new Error('[Node]store is required!');}store.registerNode(this);var props=store.props;if(props&&typeof props.isLeaf!=='undefined'){var isLeaf=getPropertyFromData(this,'isLeaf');if(typeof isLeaf==='boolean'){this.isLeafByUser=isLeaf;}}if(store.lazy!==true&&this.data){this.setData(this.data);if(store.defaultExpandAll){this.expanded=true;}}else if(this.level>0&&store.lazy&&store.defaultExpandAll){this.expand();}if(!Array.isArray(this.data)){markNodeData(this,this.data);}if(!this.data)return;var defaultExpandedKeys=store.defaultExpandedKeys;var key=store.key;if(key&&defaultExpandedKeys&&defaultExpandedKeys.indexOf(this.key)!==-1){this.expand(null,store.autoExpandParent);}if(key&&store.currentNodeKey!==undefined&&this.key===store.currentNodeKey){store.currentNode=this;store.currentNode.isCurrent=true;}if(store.lazy){store._initDefaultCheckedNode(this);}this.updateLeafState();}Node.prototype.setData=function setData(data){if(!Array.isArray(data)){markNodeData(this,data);}this.data=data;this.childNodes=[];var children=void 0;if(this.level===0&&this.data instanceof Array){children=this.data;}else{children=getPropertyFromData(this,'children')||[];}for(var i=0,j=children.length;i<j;i++){this.insertChild({data:children[i]});}};Node.prototype.contains=function contains(target){var deep=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var walk=function walk(parent){var children=parent.childNodes||[];var result=false;for(var i=0,j=children.length;i<j;i++){var child=children[i];if(child===target||deep&&walk(child)){result=true;break;}}return result;};return walk(this);};Node.prototype.remove=function remove(){var parent=this.parent;if(parent){parent.removeChild(this);}};Node.prototype.insertChild=function insertChild(child,index,batch){if(!child)throw new Error('insertChild error: child is required.');if(!(child instanceof Node)){if(!batch){var children=this.getChildren(true)||[];if(children.indexOf(child.data)===-1){if(typeof index==='undefined'||index<0){children.push(child.data);}else{children.splice(index,0,child.data);}}}merge_default()(child,{parent:this,store:this.store});child=new Node(child);}child.level=this.level+1;if(typeof index==='undefined'||index<0){this.childNodes.push(child);}else{this.childNodes.splice(index,0,child);}this.updateLeafState();};Node.prototype.insertBefore=function insertBefore(child,ref){var index=void 0;if(ref){index=this.childNodes.indexOf(ref);}this.insertChild(child,index);};Node.prototype.insertAfter=function insertAfter(child,ref){var index=void 0;if(ref){index=this.childNodes.indexOf(ref);if(index!==-1)index+=1;}this.insertChild(child,index);};Node.prototype.removeChild=function removeChild(child){var children=this.getChildren()||[];var dataIndex=children.indexOf(child.data);if(dataIndex>-1){children.splice(dataIndex,1);}var index=this.childNodes.indexOf(child);if(index>-1){this.store&&this.store.deregisterNode(child);child.parent=null;this.childNodes.splice(index,1);}this.updateLeafState();};Node.prototype.removeChildByData=function removeChildByData(data){var targetNode=null;for(var i=0;i<this.childNodes.length;i++){if(this.childNodes[i].data===data){targetNode=this.childNodes[i];break;}}if(targetNode){this.removeChild(targetNode);}};Node.prototype.expand=function expand(callback,expandParent){var _this=this;var done=function done(){if(expandParent){var parent=_this.parent;while(parent.level>0){parent.expanded=true;parent=parent.parent;}}_this.expanded=true;if(callback)callback();};if(this.shouldLoadData()){this.loadData(function(data){if(data instanceof Array){if(_this.checked){_this.setChecked(true,true);}else if(!_this.store.checkStrictly){reInitChecked(_this);}done();}});}else{done();}};Node.prototype.doCreateChildren=function doCreateChildren(array){var _this2=this;var defaultProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};array.forEach(function(item){_this2.insertChild(merge_default()({data:item},defaultProps),undefined,true);});};Node.prototype.collapse=function collapse(){this.expanded=false;};Node.prototype.shouldLoadData=function shouldLoadData(){return this.store.lazy===true&&this.store.load&&!this.loaded;};Node.prototype.updateLeafState=function updateLeafState(){if(this.store.lazy===true&&this.loaded!==true&&typeof this.isLeafByUser!=='undefined'){this.isLeaf=this.isLeafByUser;return;}var childNodes=this.childNodes;if(!this.store.lazy||this.store.lazy===true&&this.loaded===true){this.isLeaf=!childNodes||childNodes.length===0;return;}this.isLeaf=false;};Node.prototype.setChecked=function setChecked(value,deep,recursion,passValue){var _this3=this;this.indeterminate=value==='half';this.checked=value===true;if(this.store.checkStrictly)return;if(!(this.shouldLoadData()&&!this.store.checkDescendants)){var _getChildState2=getChildState(this.childNodes),all=_getChildState2.all,allWithoutDisable=_getChildState2.allWithoutDisable;if(!this.isLeaf&&!all&&allWithoutDisable){this.checked=false;value=false;}var handleDescendants=function handleDescendants(){if(deep){var childNodes=_this3.childNodes;for(var i=0,j=childNodes.length;i<j;i++){var child=childNodes[i];passValue=passValue||value!==false;var isCheck=child.disabled?child.checked:passValue;child.setChecked(isCheck,deep,true,passValue);}var _getChildState3=getChildState(childNodes),half=_getChildState3.half,_all=_getChildState3.all;if(!_all){_this3.checked=_all;_this3.indeterminate=half;}}};if(this.shouldLoadData()){// Only work on lazy load data.
this.loadData(function(){handleDescendants();reInitChecked(_this3);},{checked:value!==false});return;}else{handleDescendants();}}var parent=this.parent;if(!parent||parent.level===0)return;if(!recursion){reInitChecked(parent);}};Node.prototype.getChildren=function getChildren(){var forceInit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// this is data
if(this.level===0)return this.data;var data=this.data;if(!data)return null;var props=this.store.props;var children='children';if(props){children=props.children||'children';}if(data[children]===undefined){data[children]=null;}if(forceInit&&!data[children]){data[children]=[];}return data[children];};Node.prototype.updateChildren=function updateChildren(){var _this4=this;var newData=this.getChildren()||[];var oldData=this.childNodes.map(function(node){return node.data;});var newDataMap={};var newNodes=[];newData.forEach(function(item,index){var key=item[NODE_KEY];var isNodeExists=!!key&&Object(util_["arrayFindIndex"])(oldData,function(data){return data[NODE_KEY]===key;})>=0;if(isNodeExists){newDataMap[key]={index:index,data:item};}else{newNodes.push({index:index,data:item});}});if(!this.store.lazy){oldData.forEach(function(item){if(!newDataMap[item[NODE_KEY]])_this4.removeChildByData(item);});}newNodes.forEach(function(_ref){var index=_ref.index,data=_ref.data;_this4.insertChild({data:data},index);});this.updateLeafState();};Node.prototype.loadData=function loadData(callback){var _this5=this;var defaultProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(this.store.lazy===true&&this.store.load&&!this.loaded&&(!this.loading||Object.keys(defaultProps).length)){this.loading=true;var resolve=function resolve(children){_this5.childNodes=[];_this5.doCreateChildren(children,defaultProps);_this5.loaded=true;_this5.loading=false;_this5.updateLeafState();if(callback){callback.call(_this5,children);}};this.store.load(this,resolve);}else{if(callback){callback.call(this);}}};_createClass(Node,[{key:'label',get:function get(){return getPropertyFromData(this,'label');}},{key:'key',get:function get(){var nodeKey=this.store.key;if(this.data)return this.data[nodeKey];return null;}},{key:'disabled',get:function get(){return getPropertyFromData(this,'disabled');}},{key:'nextSibling',get:function get(){var parent=this.parent;if(parent){var index=parent.childNodes.indexOf(this);if(index>-1){return parent.childNodes[index+1];}}return null;}},{key:'previousSibling',get:function get(){var parent=this.parent;if(parent){var index=parent.childNodes.indexOf(this);if(index>-1){return index>0?parent.childNodes[index-1]:null;}}return null;}}]);return Node;}();/* harmony default export */var model_node=node_Node;// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
var tree_store_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};function tree_store_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var tree_store_TreeStore=function(){function TreeStore(options){var _this=this;tree_store_classCallCheck(this,TreeStore);this.currentNode=null;this.currentNodeKey=null;for(var option in options){if(options.hasOwnProperty(option)){this[option]=options[option];}}this.nodesMap={};this.root=new model_node({data:this.data,store:this});if(this.lazy&&this.load){var loadFn=this.load;loadFn(this.root,function(data){_this.root.doCreateChildren(data);_this._initDefaultCheckedNodes();});}else{this._initDefaultCheckedNodes();}}TreeStore.prototype.filter=function filter(value){var filterNodeMethod=this.filterNodeMethod;var lazy=this.lazy;var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){child.visible=filterNodeMethod.call(child,value,child.data,child);traverse(child);});if(!node.visible&&childNodes.length){var allHidden=true;allHidden=!childNodes.some(function(child){return child.visible;});if(node.root){node.root.visible=allHidden===false;}else{node.visible=allHidden===false;}}if(!value)return;if(node.visible&&!node.isLeaf&&!lazy)node.expand();};traverse(this);};TreeStore.prototype.setData=function setData(newVal){var instanceChanged=newVal!==this.root.data;if(instanceChanged){this.root.setData(newVal);this._initDefaultCheckedNodes();}else{this.root.updateChildren();}};TreeStore.prototype.getNode=function getNode(data){if(data instanceof model_node)return data;var key=(typeof data==='undefined'?'undefined':tree_store_typeof(data))!=='object'?data:util_getNodeKey(this.key,data);return this.nodesMap[key]||null;};TreeStore.prototype.insertBefore=function insertBefore(data,refData){var refNode=this.getNode(refData);refNode.parent.insertBefore({data:data},refNode);};TreeStore.prototype.insertAfter=function insertAfter(data,refData){var refNode=this.getNode(refData);refNode.parent.insertAfter({data:data},refNode);};TreeStore.prototype.remove=function remove(data){var node=this.getNode(data);if(node&&node.parent){if(node===this.currentNode){this.currentNode=null;}node.parent.removeChild(node);}};TreeStore.prototype.append=function append(data,parentData){var parentNode=parentData?this.getNode(parentData):this.root;if(parentNode){parentNode.insertChild({data:data});}};TreeStore.prototype._initDefaultCheckedNodes=function _initDefaultCheckedNodes(){var _this2=this;var defaultCheckedKeys=this.defaultCheckedKeys||[];var nodesMap=this.nodesMap;defaultCheckedKeys.forEach(function(checkedKey){var node=nodesMap[checkedKey];if(node){node.setChecked(true,!_this2.checkStrictly);}});};TreeStore.prototype._initDefaultCheckedNode=function _initDefaultCheckedNode(node){var defaultCheckedKeys=this.defaultCheckedKeys||[];if(defaultCheckedKeys.indexOf(node.key)!==-1){node.setChecked(true,!this.checkStrictly);}};TreeStore.prototype.setDefaultCheckedKey=function setDefaultCheckedKey(newVal){if(newVal!==this.defaultCheckedKeys){this.defaultCheckedKeys=newVal;this._initDefaultCheckedNodes();}};TreeStore.prototype.registerNode=function registerNode(node){var key=this.key;if(!key||!node||!node.data)return;var nodeKey=node.key;if(nodeKey!==undefined)this.nodesMap[node.key]=node;};TreeStore.prototype.deregisterNode=function deregisterNode(node){var _this3=this;var key=this.key;if(!key||!node||!node.data)return;node.childNodes.forEach(function(child){_this3.deregisterNode(child);});delete this.nodesMap[node.key];};TreeStore.prototype.getCheckedNodes=function getCheckedNodes(){var leafOnly=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var includeHalfChecked=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var checkedNodes=[];var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){if((child.checked||includeHalfChecked&&child.indeterminate)&&(!leafOnly||leafOnly&&child.isLeaf)){checkedNodes.push(child.data);}traverse(child);});};traverse(this);return checkedNodes;};TreeStore.prototype.getCheckedKeys=function getCheckedKeys(){var _this4=this;var leafOnly=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return this.getCheckedNodes(leafOnly).map(function(data){return(data||{})[_this4.key];});};TreeStore.prototype.getHalfCheckedNodes=function getHalfCheckedNodes(){var nodes=[];var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){if(child.indeterminate){nodes.push(child.data);}traverse(child);});};traverse(this);return nodes;};TreeStore.prototype.getHalfCheckedKeys=function getHalfCheckedKeys(){var _this5=this;return this.getHalfCheckedNodes().map(function(data){return(data||{})[_this5.key];});};TreeStore.prototype._getAllNodes=function _getAllNodes(){var allNodes=[];var nodesMap=this.nodesMap;for(var nodeKey in nodesMap){if(nodesMap.hasOwnProperty(nodeKey)){allNodes.push(nodesMap[nodeKey]);}}return allNodes;};TreeStore.prototype.updateChildren=function updateChildren(key,data){var node=this.nodesMap[key];if(!node)return;var childNodes=node.childNodes;for(var i=childNodes.length-1;i>=0;i--){var child=childNodes[i];this.remove(child.data);}for(var _i=0,j=data.length;_i<j;_i++){var _child=data[_i];this.append(_child,node.data);}};TreeStore.prototype._setCheckedKeys=function _setCheckedKeys(key){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var checkedKeys=arguments[2];var allNodes=this._getAllNodes().sort(function(a,b){return b.level-a.level;});var cache=Object.create(null);var keys=Object.keys(checkedKeys);allNodes.forEach(function(node){return node.setChecked(false,false);});for(var i=0,j=allNodes.length;i<j;i++){var node=allNodes[i];var nodeKey=node.data[key].toString();var checked=keys.indexOf(nodeKey)>-1;if(!checked){if(node.checked&&!cache[nodeKey]){node.setChecked(false,false);}continue;}var parent=node.parent;while(parent&&parent.level>0){cache[parent.data[key]]=true;parent=parent.parent;}if(node.isLeaf||this.checkStrictly){node.setChecked(true,false);continue;}node.setChecked(true,true);if(leafOnly){(function(){node.setChecked(false,false);var traverse=function traverse(node){var childNodes=node.childNodes;childNodes.forEach(function(child){if(!child.isLeaf){child.setChecked(false,false);}traverse(child);});};traverse(node);})();}}};TreeStore.prototype.setCheckedNodes=function setCheckedNodes(array){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var key=this.key;var checkedKeys={};array.forEach(function(item){checkedKeys[(item||{})[key]]=true;});this._setCheckedKeys(key,leafOnly,checkedKeys);};TreeStore.prototype.setCheckedKeys=function setCheckedKeys(keys){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;this.defaultCheckedKeys=keys;var key=this.key;var checkedKeys={};keys.forEach(function(key){checkedKeys[key]=true;});this._setCheckedKeys(key,leafOnly,checkedKeys);};TreeStore.prototype.setDefaultExpandedKeys=function setDefaultExpandedKeys(keys){var _this6=this;keys=keys||[];this.defaultExpandedKeys=keys;keys.forEach(function(key){var node=_this6.getNode(key);if(node)node.expand(null,_this6.autoExpandParent);});};TreeStore.prototype.setChecked=function setChecked(data,checked,deep){var node=this.getNode(data);if(node){node.setChecked(!!checked,deep);}};TreeStore.prototype.getCurrentNode=function getCurrentNode(){return this.currentNode;};TreeStore.prototype.setCurrentNode=function setCurrentNode(currentNode){var prevCurrentNode=this.currentNode;if(prevCurrentNode){prevCurrentNode.isCurrent=false;}this.currentNode=currentNode;this.currentNode.isCurrent=true;};TreeStore.prototype.setUserCurrentNode=function setUserCurrentNode(node){var key=node[this.key];var currNode=this.nodesMap[key];this.setCurrentNode(currNode);};TreeStore.prototype.setCurrentNodeKey=function setCurrentNodeKey(key){if(key===null||key===undefined){this.currentNode&&(this.currentNode.isCurrent=false);this.currentNode=null;return;}var node=this.getNode(key);if(node){this.setCurrentNode(node);}};return TreeStore;}();/* harmony default export */var tree_store=tree_store_TreeStore;;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
var tree_nodevue_type_template_id_3ba3ef0e_render=function tree_nodevue_type_template_id_3ba3ef0e_render(){var this$1=this;var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.node.visible,expression:"node.visible"}],ref:"node",staticClass:"el-tree-node",class:{"is-expanded":_vm.expanded,"is-current":_vm.node.isCurrent,"is-hidden":!_vm.node.visible,"is-focusable":!_vm.node.disabled,"is-checked":!_vm.node.disabled&&_vm.node.checked},attrs:{role:"treeitem",tabindex:"-1","aria-expanded":_vm.expanded,"aria-disabled":_vm.node.disabled,"aria-checked":_vm.node.checked,draggable:_vm.tree.draggable},on:{click:function click($event){$event.stopPropagation();return _vm.handleClick($event);},contextmenu:function contextmenu($event){return this$1.handleContextMenu($event);},dragstart:function dragstart($event){$event.stopPropagation();return _vm.handleDragStart($event);},dragover:function dragover($event){$event.stopPropagation();return _vm.handleDragOver($event);},dragend:function dragend($event){$event.stopPropagation();return _vm.handleDragEnd($event);},drop:function drop($event){$event.stopPropagation();return _vm.handleDrop($event);}}},[_c("div",{staticClass:"el-tree-node__content",style:{"padding-left":(_vm.node.level-1)*_vm.tree.indent+"px"}},[_c("span",{class:[{"is-leaf":_vm.node.isLeaf,expanded:!_vm.node.isLeaf&&_vm.expanded},"el-tree-node__expand-icon",_vm.tree.iconClass?_vm.tree.iconClass:"el-icon-caret-right"],on:{click:function click($event){$event.stopPropagation();return _vm.handleExpandIconClick($event);}}}),_vm.showCheckbox?_c("el-checkbox",{attrs:{indeterminate:_vm.node.indeterminate,disabled:!!_vm.node.disabled},on:{change:_vm.handleCheckChange},nativeOn:{click:function click($event){$event.stopPropagation();}},model:{value:_vm.node.checked,callback:function callback($$v){_vm.$set(_vm.node,"checked",$$v);},expression:"node.checked"}}):_vm._e(),_vm.node.loading?_c("span",{staticClass:"el-tree-node__loading-icon el-icon-loading"}):_vm._e(),_c("node-content",{attrs:{node:_vm.node}})],1),_c("el-collapse-transition",[!_vm.renderAfterExpand||_vm.childNodeRendered?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.expanded,expression:"expanded"}],staticClass:"el-tree-node__children",attrs:{role:"group","aria-expanded":_vm.expanded}},_vm._l(_vm.node.childNodes,function(child){return _c("el-tree-node",{key:_vm.getNodeKey(child),attrs:{"render-content":_vm.renderContent,"render-after-expand":_vm.renderAfterExpand,"show-checkbox":_vm.showCheckbox,node:child},on:{"node-expand":_vm.handleChildNodeExpand}});}),1):_vm._e()])],1);};var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns=[];tree_nodevue_type_template_id_3ba3ef0e_render._withStripped=true;// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var tree_nodevue_type_script_lang_js_={name:'ElTreeNode',componentName:'ElTreeNode',mixins:[emitter_default.a],props:{node:{default:function _default(){return{};}},props:{},renderContent:Function,renderAfterExpand:{type:Boolean,default:true},showCheckbox:{type:Boolean,default:false}},components:{ElCollapseTransition:collapse_transition_default.a,ElCheckbox:checkbox_default.a,NodeContent:{props:{node:{required:true}},render:function render(h){var parent=this.$parent;var tree=parent.tree;var node=this.node;var data=node.data,store=node.store;return parent.renderContent?parent.renderContent.call(parent._renderProxy,h,{_self:tree.$vnode.context,node:node,data:data,store:store}):tree.$scopedSlots.default?tree.$scopedSlots.default({node:node,data:data}):h('span',{'class':'el-tree-node__label'},[node.label]);}}},data:function data(){return{tree:null,expanded:false,childNodeRendered:false,oldChecked:null,oldIndeterminate:null};},watch:{'node.indeterminate':function nodeIndeterminate(val){this.handleSelectChange(this.node.checked,val);},'node.checked':function nodeChecked(val){this.handleSelectChange(val,this.node.indeterminate);},'node.expanded':function nodeExpanded(val){var _this=this;this.$nextTick(function(){return _this.expanded=val;});if(val){this.childNodeRendered=true;}}},methods:{getNodeKey:function getNodeKey(node){return util_getNodeKey(this.tree.nodeKey,node.data);},handleSelectChange:function handleSelectChange(checked,indeterminate){if(this.oldChecked!==checked&&this.oldIndeterminate!==indeterminate){this.tree.$emit('check-change',this.node.data,checked,indeterminate);}this.oldChecked=checked;this.indeterminate=indeterminate;},handleClick:function handleClick(){var store=this.tree.store;store.setCurrentNode(this.node);this.tree.$emit('current-change',store.currentNode?store.currentNode.data:null,store.currentNode);this.tree.currentNode=this;if(this.tree.expandOnClickNode){this.handleExpandIconClick();}if(this.tree.checkOnClickNode&&!this.node.disabled){this.handleCheckChange(null,{target:{checked:!this.node.checked}});}this.tree.$emit('node-click',this.node.data,this.node,this);},handleContextMenu:function handleContextMenu(event){if(this.tree._events['node-contextmenu']&&this.tree._events['node-contextmenu'].length>0){event.stopPropagation();event.preventDefault();}this.tree.$emit('node-contextmenu',event,this.node.data,this.node,this);},handleExpandIconClick:function handleExpandIconClick(){if(this.node.isLeaf)return;if(this.expanded){this.tree.$emit('node-collapse',this.node.data,this.node,this);this.node.collapse();}else{this.node.expand();this.$emit('node-expand',this.node.data,this.node,this);}},handleCheckChange:function handleCheckChange(value,ev){var _this2=this;this.node.setChecked(ev.target.checked,!this.tree.checkStrictly);this.$nextTick(function(){var store=_this2.tree.store;_this2.tree.$emit('check',_this2.node.data,{checkedNodes:store.getCheckedNodes(),checkedKeys:store.getCheckedKeys(),halfCheckedNodes:store.getHalfCheckedNodes(),halfCheckedKeys:store.getHalfCheckedKeys()});});},handleChildNodeExpand:function handleChildNodeExpand(nodeData,node,instance){this.broadcast('ElTreeNode','tree-node-expand',node);this.tree.$emit('node-expand',nodeData,node,instance);},handleDragStart:function handleDragStart(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-start',event,this);},handleDragOver:function handleDragOver(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-over',event,this);event.preventDefault();},handleDrop:function handleDrop(event){event.preventDefault();},handleDragEnd:function handleDragEnd(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-end',event,this);}},created:function created(){var _this3=this;var parent=this.$parent;if(parent.isTree){this.tree=parent;}else{this.tree=parent.tree;}var tree=this.tree;if(!tree){console.warn('Can not find node\'s tree.');}var props=tree.props||{};var childrenKey=props['children']||'children';this.$watch('node.data.'+childrenKey,function(){_this3.node.updateChildren();});if(this.node.expanded){this.expanded=true;this.childNodeRendered=true;}if(this.tree.accordion){this.$on('tree-node-expand',function(node){if(_this3.node!==node){_this3.node.collapse();}});}}};// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
/* harmony default export */var src_tree_nodevue_type_script_lang_js_=tree_nodevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
/* normalize component */var tree_node_component=normalizeComponent(src_tree_nodevue_type_script_lang_js_,tree_nodevue_type_template_id_3ba3ef0e_render,tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tree_node_api;}tree_node_component.options.__file="packages/tree/src/tree-node.vue";/* harmony default export */var tree_node=tree_node_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var treevue_type_script_lang_js_={name:'ElTree',mixins:[emitter_default.a],components:{ElTreeNode:tree_node},data:function data(){return{store:null,root:null,currentNode:null,treeItems:null,checkboxItems:[],dragState:{showDropIndicator:false,draggingNode:null,dropNode:null,allowDrop:true}};},props:{data:{type:Array},emptyText:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.tree.emptyText');}},renderAfterExpand:{type:Boolean,default:true},nodeKey:String,checkStrictly:Boolean,defaultExpandAll:Boolean,expandOnClickNode:{type:Boolean,default:true},checkOnClickNode:Boolean,checkDescendants:{type:Boolean,default:false},autoExpandParent:{type:Boolean,default:true},defaultCheckedKeys:Array,defaultExpandedKeys:Array,currentNodeKey:[String,Number],renderContent:Function,showCheckbox:{type:Boolean,default:false},draggable:{type:Boolean,default:false},allowDrag:Function,allowDrop:Function,props:{default:function _default(){return{children:'children',label:'label',disabled:'disabled'};}},lazy:{type:Boolean,default:false},highlightCurrent:Boolean,load:Function,filterNodeMethod:Function,accordion:Boolean,indent:{type:Number,default:18},iconClass:String},computed:{children:{set:function set(value){this.data=value;},get:function get(){return this.data;}},treeItemArray:function treeItemArray(){return Array.prototype.slice.call(this.treeItems);},isEmpty:function isEmpty(){var childNodes=this.root.childNodes;return!childNodes||childNodes.length===0||childNodes.every(function(_ref){var visible=_ref.visible;return!visible;});}},watch:{defaultCheckedKeys:function defaultCheckedKeys(newVal){this.store.setDefaultCheckedKey(newVal);},defaultExpandedKeys:function defaultExpandedKeys(newVal){this.store.defaultExpandedKeys=newVal;this.store.setDefaultExpandedKeys(newVal);},data:function data(newVal){this.store.setData(newVal);},checkboxItems:function checkboxItems(val){Array.prototype.forEach.call(val,function(checkbox){checkbox.setAttribute('tabindex',-1);});},checkStrictly:function checkStrictly(newVal){this.store.checkStrictly=newVal;}},methods:{filter:function filter(value){if(!this.filterNodeMethod)throw new Error('[Tree] filterNodeMethod is required when filter');this.store.filter(value);},getNodeKey:function getNodeKey(node){return util_getNodeKey(this.nodeKey,node.data);},getNodePath:function getNodePath(data){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in getNodePath');var node=this.store.getNode(data);if(!node)return[];var path=[node.data];var parent=node.parent;while(parent&&parent!==this.root){path.push(parent.data);parent=parent.parent;}return path.reverse();},getCheckedNodes:function getCheckedNodes(leafOnly,includeHalfChecked){return this.store.getCheckedNodes(leafOnly,includeHalfChecked);},getCheckedKeys:function getCheckedKeys(leafOnly){return this.store.getCheckedKeys(leafOnly);},getCurrentNode:function getCurrentNode(){var currentNode=this.store.getCurrentNode();return currentNode?currentNode.data:null;},getCurrentKey:function getCurrentKey(){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in getCurrentKey');var currentNode=this.getCurrentNode();return currentNode?currentNode[this.nodeKey]:null;},setCheckedNodes:function setCheckedNodes(nodes,leafOnly){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCheckedNodes');this.store.setCheckedNodes(nodes,leafOnly);},setCheckedKeys:function setCheckedKeys(keys,leafOnly){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCheckedKeys');this.store.setCheckedKeys(keys,leafOnly);},setChecked:function setChecked(data,checked,deep){this.store.setChecked(data,checked,deep);},getHalfCheckedNodes:function getHalfCheckedNodes(){return this.store.getHalfCheckedNodes();},getHalfCheckedKeys:function getHalfCheckedKeys(){return this.store.getHalfCheckedKeys();},setCurrentNode:function setCurrentNode(node){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCurrentNode');this.store.setUserCurrentNode(node);},setCurrentKey:function setCurrentKey(key){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCurrentKey');this.store.setCurrentNodeKey(key);},getNode:function getNode(data){return this.store.getNode(data);},remove:function remove(data){this.store.remove(data);},append:function append(data,parentNode){this.store.append(data,parentNode);},insertBefore:function insertBefore(data,refNode){this.store.insertBefore(data,refNode);},insertAfter:function insertAfter(data,refNode){this.store.insertAfter(data,refNode);},handleNodeExpand:function handleNodeExpand(nodeData,node,instance){this.broadcast('ElTreeNode','tree-node-expand',node);this.$emit('node-expand',nodeData,node,instance);},updateKeyChildren:function updateKeyChildren(key,data){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in updateKeyChild');this.store.updateChildren(key,data);},initTabIndex:function initTabIndex(){this.treeItems=this.$el.querySelectorAll('.is-focusable[role=treeitem]');this.checkboxItems=this.$el.querySelectorAll('input[type=checkbox]');var checkedItem=this.$el.querySelectorAll('.is-checked[role=treeitem]');if(checkedItem.length){checkedItem[0].setAttribute('tabindex',0);return;}this.treeItems[0]&&this.treeItems[0].setAttribute('tabindex',0);},handleKeydown:function handleKeydown(ev){var currentItem=ev.target;if(currentItem.className.indexOf('el-tree-node')===-1)return;var keyCode=ev.keyCode;this.treeItems=this.$el.querySelectorAll('.is-focusable[role=treeitem]');var currentIndex=this.treeItemArray.indexOf(currentItem);var nextIndex=void 0;if([38,40].indexOf(keyCode)>-1){// up、down
ev.preventDefault();if(keyCode===38){// up
nextIndex=currentIndex!==0?currentIndex-1:0;}else{nextIndex=currentIndex<this.treeItemArray.length-1?currentIndex+1:0;}this.treeItemArray[nextIndex].focus();// 选中
}if([37,39].indexOf(keyCode)>-1){// left、right 展开
ev.preventDefault();currentItem.click();// 选中
}var hasInput=currentItem.querySelector('[type="checkbox"]');if([13,32].indexOf(keyCode)>-1&&hasInput){// space enter选中checkbox
ev.preventDefault();hasInput.click();}}},created:function created(){var _this=this;this.isTree=true;this.store=new tree_store({key:this.nodeKey,data:this.data,lazy:this.lazy,props:this.props,load:this.load,currentNodeKey:this.currentNodeKey,checkStrictly:this.checkStrictly,checkDescendants:this.checkDescendants,defaultCheckedKeys:this.defaultCheckedKeys,defaultExpandedKeys:this.defaultExpandedKeys,autoExpandParent:this.autoExpandParent,defaultExpandAll:this.defaultExpandAll,filterNodeMethod:this.filterNodeMethod});this.root=this.store.root;var dragState=this.dragState;this.$on('tree-node-drag-start',function(event,treeNode){if(typeof _this.allowDrag==='function'&&!_this.allowDrag(treeNode.node)){event.preventDefault();return false;}event.dataTransfer.effectAllowed='move';// wrap in try catch to address IE's error when first param is 'text/plain'
try{// setData is required for draggable to work in FireFox
// the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
event.dataTransfer.setData('text/plain','');}catch(e){}dragState.draggingNode=treeNode;_this.$emit('node-drag-start',treeNode.node,event);});this.$on('tree-node-drag-over',function(event,treeNode){var dropNode=findNearestComponent(event.target,'ElTreeNode');var oldDropNode=dragState.dropNode;if(oldDropNode&&oldDropNode!==dropNode){Object(dom_["removeClass"])(oldDropNode.$el,'is-drop-inner');}var draggingNode=dragState.draggingNode;if(!draggingNode||!dropNode)return;var dropPrev=true;var dropInner=true;var dropNext=true;var userAllowDropInner=true;if(typeof _this.allowDrop==='function'){dropPrev=_this.allowDrop(draggingNode.node,dropNode.node,'prev');userAllowDropInner=dropInner=_this.allowDrop(draggingNode.node,dropNode.node,'inner');dropNext=_this.allowDrop(draggingNode.node,dropNode.node,'next');}event.dataTransfer.dropEffect=dropInner?'move':'none';if((dropPrev||dropInner||dropNext)&&oldDropNode!==dropNode){if(oldDropNode){_this.$emit('node-drag-leave',draggingNode.node,oldDropNode.node,event);}_this.$emit('node-drag-enter',draggingNode.node,dropNode.node,event);}if(dropPrev||dropInner||dropNext){dragState.dropNode=dropNode;}if(dropNode.node.nextSibling===draggingNode.node){dropNext=false;}if(dropNode.node.previousSibling===draggingNode.node){dropPrev=false;}if(dropNode.node.contains(draggingNode.node,false)){dropInner=false;}if(draggingNode.node===dropNode.node||draggingNode.node.contains(dropNode.node)){dropPrev=false;dropInner=false;dropNext=false;}var targetPosition=dropNode.$el.getBoundingClientRect();var treePosition=_this.$el.getBoundingClientRect();var dropType=void 0;var prevPercent=dropPrev?dropInner?0.25:dropNext?0.45:1:-1;var nextPercent=dropNext?dropInner?0.75:dropPrev?0.55:0:1;var indicatorTop=-9999;var distance=event.clientY-targetPosition.top;if(distance<targetPosition.height*prevPercent){dropType='before';}else if(distance>targetPosition.height*nextPercent){dropType='after';}else if(dropInner){dropType='inner';}else{dropType='none';}var iconPosition=dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();var dropIndicator=_this.$refs.dropIndicator;if(dropType==='before'){indicatorTop=iconPosition.top-treePosition.top;}else if(dropType==='after'){indicatorTop=iconPosition.bottom-treePosition.top;}dropIndicator.style.top=indicatorTop+'px';dropIndicator.style.left=iconPosition.right-treePosition.left+'px';if(dropType==='inner'){Object(dom_["addClass"])(dropNode.$el,'is-drop-inner');}else{Object(dom_["removeClass"])(dropNode.$el,'is-drop-inner');}dragState.showDropIndicator=dropType==='before'||dropType==='after';dragState.allowDrop=dragState.showDropIndicator||userAllowDropInner;dragState.dropType=dropType;_this.$emit('node-drag-over',draggingNode.node,dropNode.node,event);});this.$on('tree-node-drag-end',function(event){var draggingNode=dragState.draggingNode,dropType=dragState.dropType,dropNode=dragState.dropNode;event.preventDefault();event.dataTransfer.dropEffect='move';if(draggingNode&&dropNode){var draggingNodeCopy={data:draggingNode.node.data};if(dropType!=='none'){draggingNode.node.remove();}if(dropType==='before'){dropNode.node.parent.insertBefore(draggingNodeCopy,dropNode.node);}else if(dropType==='after'){dropNode.node.parent.insertAfter(draggingNodeCopy,dropNode.node);}else if(dropType==='inner'){dropNode.node.insertChild(draggingNodeCopy);}if(dropType!=='none'){_this.store.registerNode(draggingNodeCopy);}Object(dom_["removeClass"])(dropNode.$el,'is-drop-inner');_this.$emit('node-drag-end',draggingNode.node,dropNode.node,dropType,event);if(dropType!=='none'){_this.$emit('node-drop',draggingNode.node,dropNode.node,dropType,event);}}if(draggingNode&&!dropNode){_this.$emit('node-drag-end',draggingNode.node,null,dropType,event);}dragState.showDropIndicator=false;dragState.draggingNode=null;dragState.dropNode=null;dragState.allowDrop=true;});},mounted:function mounted(){this.initTabIndex();this.$el.addEventListener('keydown',this.handleKeydown);},updated:function updated(){this.treeItems=this.$el.querySelectorAll('[role=treeitem]');this.checkboxItems=this.$el.querySelectorAll('input[type=checkbox]');}};// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
/* harmony default export */var src_treevue_type_script_lang_js_=treevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tree/src/tree.vue
/* normalize component */var tree_component=normalizeComponent(src_treevue_type_script_lang_js_,treevue_type_template_id_547575a6_render,treevue_type_template_id_547575a6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tree_api;}tree_component.options.__file="packages/tree/src/tree.vue";/* harmony default export */var src_tree=tree_component.exports;// CONCATENATED MODULE: ./packages/tree/index.js
/* istanbul ignore next */src_tree.install=function(Vue){Vue.component(src_tree.name,src_tree);};/* harmony default export */var packages_tree=src_tree;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
var mainvue_type_template_id_6e53341b_render=function mainvue_type_template_id_6e53341b_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-alert-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-alert",class:[_vm.typeClass,_vm.center?"is-center":"","is-"+_vm.effect],attrs:{role:"alert"}},[_vm.showIcon?_c("i",{staticClass:"el-alert__icon",class:[_vm.iconClass,_vm.isBigIcon]}):_vm._e(),_c("div",{staticClass:"el-alert__content"},[_vm.title||_vm.$slots.title?_c("span",{staticClass:"el-alert__title",class:[_vm.isBoldTitle]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm.$slots.default&&!_vm.description?_c("p",{staticClass:"el-alert__description"},[_vm._t("default")],2):_vm._e(),_vm.description&&!_vm.$slots.default?_c("p",{staticClass:"el-alert__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c("i",{directives:[{name:"show",rawName:"v-show",value:_vm.closable,expression:"closable"}],staticClass:"el-alert__closebtn",class:{"is-customed":_vm.closeText!=="","el-icon-close":_vm.closeText===""},on:{click:function click($event){_vm.close();}}},[_vm._v(_vm._s(_vm.closeText))])])])]);};var mainvue_type_template_id_6e53341b_staticRenderFns=[];mainvue_type_template_id_6e53341b_render._withStripped=true;// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var TYPE_CLASSES_MAP={'success':'el-icon-success','warning':'el-icon-warning','error':'el-icon-error'};/* harmony default export */var alert_src_mainvue_type_script_lang_js_={name:'ElAlert',props:{title:{type:String,default:''},description:{type:String,default:''},type:{type:String,default:'info'},closable:{type:Boolean,default:true},closeText:{type:String,default:''},showIcon:Boolean,center:Boolean,effect:{type:String,default:'light',validator:function validator(value){return['light','dark'].indexOf(value)!==-1;}}},data:function data(){return{visible:true};},methods:{close:function close(){this.visible=false;this.$emit('close');}},computed:{typeClass:function typeClass(){return'el-alert--'+this.type;},iconClass:function iconClass(){return TYPE_CLASSES_MAP[this.type]||'el-icon-info';},isBigIcon:function isBigIcon(){return this.description||this.$slots.default?'is-big':'';},isBoldTitle:function isBoldTitle(){return this.description||this.$slots.default?'is-bold':'';}}};// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_alert_src_mainvue_type_script_lang_js_=alert_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/alert/src/main.vue
/* normalize component */var alert_src_main_component=normalizeComponent(packages_alert_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6e53341b_render,mainvue_type_template_id_6e53341b_staticRenderFns,false,null,null,null);/* hot reload */if(false){var alert_src_main_api;}alert_src_main_component.options.__file="packages/alert/src/main.vue";/* harmony default export */var alert_src_main=alert_src_main_component.exports;// CONCATENATED MODULE: ./packages/alert/index.js
/* istanbul ignore next */alert_src_main.install=function(Vue){Vue.component(alert_src_main.name,alert_src_main);};/* harmony default export */var packages_alert=alert_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
var mainvue_type_template_id_43dbc3d8_render=function mainvue_type_template_id_43dbc3d8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-notification-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],class:["el-notification",_vm.customClass,_vm.horizontalClass],style:_vm.positionStyle,attrs:{role:"alert"},on:{mouseenter:function mouseenter($event){_vm.clearTimer();},mouseleave:function mouseleave($event){_vm.startTimer();},click:_vm.click}},[_vm.type||_vm.iconClass?_c("i",{staticClass:"el-notification__icon",class:[_vm.typeClass,_vm.iconClass]}):_vm._e(),_c("div",{staticClass:"el-notification__group",class:{"is-with-icon":_vm.typeClass||_vm.iconClass}},[_c("h2",{staticClass:"el-notification__title",domProps:{textContent:_vm._s(_vm.title)}}),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.message,expression:"message"}],staticClass:"el-notification__content"},[_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",[_vm._v(_vm._s(_vm.message))]):_c("p",{domProps:{innerHTML:_vm._s(_vm.message)}})])],2),_vm.showClose?_c("div",{staticClass:"el-notification__closeBtn el-icon-close",on:{click:function click($event){$event.stopPropagation();return _vm.close($event);}}}):_vm._e()])])]);};var mainvue_type_template_id_43dbc3d8_staticRenderFns=[];mainvue_type_template_id_43dbc3d8_render._withStripped=true;// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var mainvue_type_script_lang_js_typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var notification_src_mainvue_type_script_lang_js_={data:function data(){return{visible:false,title:'',message:'',duration:4500,type:'',showClose:true,customClass:'',iconClass:'',onClose:null,onClick:null,closed:false,verticalOffset:0,timer:null,dangerouslyUseHTMLString:false,position:'top-right'};},computed:{typeClass:function typeClass(){return this.type&&mainvue_type_script_lang_js_typeMap[this.type]?'el-icon-'+mainvue_type_script_lang_js_typeMap[this.type]:'';},horizontalClass:function horizontalClass(){return this.position.indexOf('right')>-1?'right':'left';},verticalProperty:function verticalProperty(){return /^top-/.test(this.position)?'top':'bottom';},positionStyle:function positionStyle(){var _ref;return _ref={},_ref[this.verticalProperty]=this.verticalOffset+'px',_ref;}},watch:{closed:function closed(newVal){if(newVal){this.visible=false;this.$el.addEventListener('transitionend',this.destroyElement);}}},methods:{destroyElement:function destroyElement(){this.$el.removeEventListener('transitionend',this.destroyElement);this.$destroy(true);this.$el.parentNode.removeChild(this.$el);},click:function click(){if(typeof this.onClick==='function'){this.onClick();}},close:function close(){this.closed=true;if(typeof this.onClose==='function'){this.onClose();}},clearTimer:function clearTimer(){clearTimeout(this.timer);},startTimer:function startTimer(){var _this=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this.closed){_this.close();}},this.duration);}},keydown:function keydown(e){if(e.keyCode===46||e.keyCode===8){this.clearTimer();// detele 取消倒计时
}else if(e.keyCode===27){// esc关闭消息
if(!this.closed){this.close();}}else{this.startTimer();// 恢复倒计时
}}},mounted:function mounted(){var _this2=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this2.closed){_this2.close();}},this.duration);}document.addEventListener('keydown',this.keydown);},beforeDestroy:function beforeDestroy(){document.removeEventListener('keydown',this.keydown);}};// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_notification_src_mainvue_type_script_lang_js_=notification_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/notification/src/main.vue
/* normalize component */var notification_src_main_component=normalizeComponent(packages_notification_src_mainvue_type_script_lang_js_,mainvue_type_template_id_43dbc3d8_render,mainvue_type_template_id_43dbc3d8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var notification_src_main_api;}notification_src_main_component.options.__file="packages/notification/src/main.vue";/* harmony default export */var notification_src_main=notification_src_main_component.exports;// CONCATENATED MODULE: ./packages/notification/src/main.js
var NotificationConstructor=external_vue_default.a.extend(notification_src_main);var src_main_instance=void 0;var instances=[];var seed=1;var main_Notification=function Notification(options){if(external_vue_default.a.prototype.$isServer)return;options=merge_default()({},options);var userOnClose=options.onClose;var id='notification_'+seed++;var position=options.position||'top-right';options.onClose=function(){Notification.close(id,userOnClose);};src_main_instance=new NotificationConstructor({data:options});if(Object(vdom_["isVNode"])(options.message)){src_main_instance.$slots.default=[options.message];options.message='REPLACED_BY_VNODE';}src_main_instance.id=id;src_main_instance.$mount();document.body.appendChild(src_main_instance.$el);src_main_instance.visible=true;src_main_instance.dom=src_main_instance.$el;src_main_instance.dom.style.zIndex=popup_["PopupManager"].nextZIndex();var verticalOffset=options.offset||0;instances.filter(function(item){return item.position===position;}).forEach(function(item){verticalOffset+=item.$el.offsetHeight+16;});verticalOffset+=16;src_main_instance.verticalOffset=verticalOffset;instances.push(src_main_instance);return src_main_instance;};['success','warning','info','error'].forEach(function(type){main_Notification[type]=function(options){if(typeof options==='string'||Object(vdom_["isVNode"])(options)){options={message:options};}options.type=type;return main_Notification(options);};});main_Notification.close=function(id,userOnClose){var index=-1;var len=instances.length;var instance=instances.filter(function(instance,i){if(instance.id===id){index=i;return true;}return false;})[0];if(!instance)return;if(typeof userOnClose==='function'){userOnClose(instance);}instances.splice(index,1);if(len<=1)return;var position=instance.position;var removedHeight=instance.dom.offsetHeight;for(var i=index;i<len-1;i++){if(instances[i].position===position){instances[i].dom.style[instance.verticalProperty]=parseInt(instances[i].dom.style[instance.verticalProperty],10)-removedHeight-16+'px';}}};main_Notification.closeAll=function(){for(var i=instances.length-1;i>=0;i--){instances[i].close();}};/* harmony default export */var packages_notification_src_main=main_Notification;// CONCATENATED MODULE: ./packages/notification/index.js
/* harmony default export */var notification=packages_notification_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
var mainvue_type_template_id_32708644_render=function mainvue_type_template_id_32708644_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-slider",class:{"is-vertical":_vm.vertical,"el-slider--with-input":_vm.showInput},attrs:{role:"slider","aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-orientation":_vm.vertical?"vertical":"horizontal","aria-disabled":_vm.sliderDisabled}},[_vm.showInput&&!_vm.range?_c("el-input-number",{ref:"input",staticClass:"el-slider__input",attrs:{step:_vm.step,disabled:_vm.sliderDisabled,controls:_vm.showInputControls,min:_vm.min,max:_vm.max,debounce:_vm.debounce,size:_vm.inputSize},on:{change:_vm.emitChange},model:{value:_vm.firstValue,callback:function callback($$v){_vm.firstValue=$$v;},expression:"firstValue"}}):_vm._e(),_c("div",{ref:"slider",staticClass:"el-slider__runway",class:{"show-input":_vm.showInput,disabled:_vm.sliderDisabled},style:_vm.runwayStyle,on:{click:_vm.onSliderClick}},[_c("div",{staticClass:"el-slider__bar",style:_vm.barStyle}),_c("slider-button",{ref:"button1",attrs:{vertical:_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:_vm.firstValue,callback:function callback($$v){_vm.firstValue=$$v;},expression:"firstValue"}}),_vm.range?_c("slider-button",{ref:"button2",attrs:{vertical:_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:_vm.secondValue,callback:function callback($$v){_vm.secondValue=$$v;},expression:"secondValue"}}):_vm._e(),_vm._l(_vm.stops,function(item,key){return _vm.showStops?_c("div",{key:key,staticClass:"el-slider__stop",style:_vm.getStopStyle(item)}):_vm._e();}),_vm.markList.length>0?[_c("div",_vm._l(_vm.markList,function(item,key){return _c("div",{key:key,staticClass:"el-slider__stop el-slider__marks-stop",style:_vm.getStopStyle(item.position)});}),0),_c("div",{staticClass:"el-slider__marks"},_vm._l(_vm.markList,function(item,key){return _c("slider-marker",{key:key,style:_vm.getStopStyle(item.position),attrs:{mark:item.mark}});}),1)]:_vm._e()],2)],1);};var mainvue_type_template_id_32708644_staticRenderFns=[];mainvue_type_template_id_32708644_render._withStripped=true;// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
// EXTERNAL MODULE: external "element-ui/lib/input-number"
var input_number_=__webpack_require__(42);var input_number_default=/*#__PURE__*/__webpack_require__.n(input_number_);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
var buttonvue_type_template_id_e72d2ad2_render=function buttonvue_type_template_id_e72d2ad2_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{ref:"button",staticClass:"el-slider__button-wrapper",class:{hover:_vm.hovering,dragging:_vm.dragging},style:_vm.wrapperStyle,attrs:{tabindex:"0"},on:{mouseenter:_vm.handleMouseEnter,mouseleave:_vm.handleMouseLeave,mousedown:_vm.onButtonDown,touchstart:_vm.onButtonDown,focus:_vm.handleMouseEnter,blur:_vm.handleMouseLeave,keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){return null;}if("button"in $event&&$event.button!==0){return null;}return _vm.onLeftKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){return null;}if("button"in $event&&$event.button!==2){return null;}return _vm.onRightKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();return _vm.onLeftKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();return _vm.onRightKeyDown($event);}]}},[_c("el-tooltip",{ref:"tooltip",attrs:{placement:"top","popper-class":_vm.tooltipClass,disabled:!_vm.showTooltip}},[_c("span",{attrs:{slot:"content"},slot:"content"},[_vm._v(_vm._s(_vm.formatValue))]),_c("div",{staticClass:"el-slider__button",class:{hover:_vm.hovering,dragging:_vm.dragging}})])],1);};var buttonvue_type_template_id_e72d2ad2_staticRenderFns=[];buttonvue_type_template_id_e72d2ad2_render._withStripped=true;// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var slider_src_buttonvue_type_script_lang_js_={name:'ElSliderButton',components:{ElTooltip:tooltip_default.a},props:{value:{type:Number,default:0},vertical:{type:Boolean,default:false},tooltipClass:String},data:function data(){return{hovering:false,dragging:false,isClick:false,startX:0,currentX:0,startY:0,currentY:0,startPosition:0,newPosition:null,oldValue:this.value};},computed:{disabled:function disabled(){return this.$parent.sliderDisabled;},max:function max(){return this.$parent.max;},min:function min(){return this.$parent.min;},step:function step(){return this.$parent.step;},showTooltip:function showTooltip(){return this.$parent.showTooltip;},precision:function precision(){return this.$parent.precision;},currentPosition:function currentPosition(){return(this.value-this.min)/(this.max-this.min)*100+'%';},enableFormat:function enableFormat(){return this.$parent.formatTooltip instanceof Function;},formatValue:function formatValue(){return this.enableFormat&&this.$parent.formatTooltip(this.value)||this.value;},wrapperStyle:function wrapperStyle(){return this.vertical?{bottom:this.currentPosition}:{left:this.currentPosition};}},watch:{dragging:function dragging(val){this.$parent.dragging=val;}},methods:{displayTooltip:function displayTooltip(){this.$refs.tooltip&&(this.$refs.tooltip.showPopper=true);},hideTooltip:function hideTooltip(){this.$refs.tooltip&&(this.$refs.tooltip.showPopper=false);},handleMouseEnter:function handleMouseEnter(){this.hovering=true;this.displayTooltip();},handleMouseLeave:function handleMouseLeave(){this.hovering=false;this.hideTooltip();},onButtonDown:function onButtonDown(event){if(this.disabled)return;event.preventDefault();this.onDragStart(event);window.addEventListener('mousemove',this.onDragging);window.addEventListener('touchmove',this.onDragging);window.addEventListener('mouseup',this.onDragEnd);window.addEventListener('touchend',this.onDragEnd);window.addEventListener('contextmenu',this.onDragEnd);},onLeftKeyDown:function onLeftKeyDown(){if(this.disabled)return;this.newPosition=parseFloat(this.currentPosition)-this.step/(this.max-this.min)*100;this.setPosition(this.newPosition);this.$parent.emitChange();},onRightKeyDown:function onRightKeyDown(){if(this.disabled)return;this.newPosition=parseFloat(this.currentPosition)+this.step/(this.max-this.min)*100;this.setPosition(this.newPosition);this.$parent.emitChange();},onDragStart:function onDragStart(event){this.dragging=true;this.isClick=true;if(event.type==='touchstart'){event.clientY=event.touches[0].clientY;event.clientX=event.touches[0].clientX;}if(this.vertical){this.startY=event.clientY;}else{this.startX=event.clientX;}this.startPosition=parseFloat(this.currentPosition);this.newPosition=this.startPosition;},onDragging:function onDragging(event){if(this.dragging){this.isClick=false;this.displayTooltip();this.$parent.resetSize();var diff=0;if(event.type==='touchmove'){event.clientY=event.touches[0].clientY;event.clientX=event.touches[0].clientX;}if(this.vertical){this.currentY=event.clientY;diff=(this.startY-this.currentY)/this.$parent.sliderSize*100;}else{this.currentX=event.clientX;diff=(this.currentX-this.startX)/this.$parent.sliderSize*100;}this.newPosition=this.startPosition+diff;this.setPosition(this.newPosition);}},onDragEnd:function onDragEnd(){var _this=this;if(this.dragging){/*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */setTimeout(function(){_this.dragging=false;_this.hideTooltip();if(!_this.isClick){_this.setPosition(_this.newPosition);_this.$parent.emitChange();}},0);window.removeEventListener('mousemove',this.onDragging);window.removeEventListener('touchmove',this.onDragging);window.removeEventListener('mouseup',this.onDragEnd);window.removeEventListener('touchend',this.onDragEnd);window.removeEventListener('contextmenu',this.onDragEnd);}},setPosition:function setPosition(newPosition){var _this2=this;if(newPosition===null||isNaN(newPosition))return;if(newPosition<0){newPosition=0;}else if(newPosition>100){newPosition=100;}var lengthPerStep=100/((this.max-this.min)/this.step);var steps=Math.round(newPosition/lengthPerStep);var value=steps*lengthPerStep*(this.max-this.min)*0.01+this.min;value=parseFloat(value.toFixed(this.precision));this.$emit('input',value);this.$nextTick(function(){_this2.displayTooltip();_this2.$refs.tooltip&&_this2.$refs.tooltip.updatePopper();});if(!this.dragging&&this.value!==this.oldValue){this.oldValue=this.value;}}}};// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
/* harmony default export */var packages_slider_src_buttonvue_type_script_lang_js_=slider_src_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/slider/src/button.vue
/* normalize component */var src_button_component=normalizeComponent(packages_slider_src_buttonvue_type_script_lang_js_,buttonvue_type_template_id_e72d2ad2_render,buttonvue_type_template_id_e72d2ad2_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_button_api;}src_button_component.options.__file="packages/slider/src/button.vue";/* harmony default export */var slider_src_button=src_button_component.exports;// CONCATENATED MODULE: ./packages/slider/src/marker.js
/* harmony default export */var marker={name:'ElMarker',props:{mark:{type:[String,Object]}},render:function render(){var h=arguments[0];var label=typeof this.mark==='string'?this.mark:this.mark.label;return h('div',{'class':'el-slider__marks-text',style:this.mark.style||{}},[label]);}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var slider_src_mainvue_type_script_lang_js_={name:'ElSlider',mixins:[emitter_default.a],inject:{elForm:{default:''}},props:{min:{type:Number,default:0},max:{type:Number,default:100},step:{type:Number,default:1},value:{type:[Number,Array],default:0},showInput:{type:Boolean,default:false},showInputControls:{type:Boolean,default:true},inputSize:{type:String,default:'small'},showStops:{type:Boolean,default:false},showTooltip:{type:Boolean,default:true},formatTooltip:Function,disabled:{type:Boolean,default:false},range:{type:Boolean,default:false},vertical:{type:Boolean,default:false},height:{type:String},debounce:{type:Number,default:300},label:{type:String},tooltipClass:String,marks:Object},components:{ElInputNumber:input_number_default.a,SliderButton:slider_src_button,SliderMarker:marker},data:function data(){return{firstValue:null,secondValue:null,oldValue:null,dragging:false,sliderSize:1};},watch:{value:function value(val,oldVal){if(this.dragging||Array.isArray(val)&&Array.isArray(oldVal)&&val.every(function(item,index){return item===oldVal[index];})){return;}this.setValues();},dragging:function dragging(val){if(!val){this.setValues();}},firstValue:function firstValue(val){if(this.range){this.$emit('input',[this.minValue,this.maxValue]);}else{this.$emit('input',val);}},secondValue:function secondValue(){if(this.range){this.$emit('input',[this.minValue,this.maxValue]);}},min:function min(){this.setValues();},max:function max(){this.setValues();}},methods:{valueChanged:function valueChanged(){var _this=this;if(this.range){return![this.minValue,this.maxValue].every(function(item,index){return item===_this.oldValue[index];});}else{return this.value!==this.oldValue;}},setValues:function setValues(){if(this.min>this.max){console.error('[Element Error][Slider]min should not be greater than max.');return;}var val=this.value;if(this.range&&Array.isArray(val)){if(val[1]<this.min){this.$emit('input',[this.min,this.min]);}else if(val[0]>this.max){this.$emit('input',[this.max,this.max]);}else if(val[0]<this.min){this.$emit('input',[this.min,val[1]]);}else if(val[1]>this.max){this.$emit('input',[val[0],this.max]);}else{this.firstValue=val[0];this.secondValue=val[1];if(this.valueChanged()){this.dispatch('ElFormItem','el.form.change',[this.minValue,this.maxValue]);this.oldValue=val.slice();}}}else if(!this.range&&typeof val==='number'&&!isNaN(val)){if(val<this.min){this.$emit('input',this.min);}else if(val>this.max){this.$emit('input',this.max);}else{this.firstValue=val;if(this.valueChanged()){this.dispatch('ElFormItem','el.form.change',val);this.oldValue=val;}}}},setPosition:function setPosition(percent){var targetValue=this.min+percent*(this.max-this.min)/100;if(!this.range){this.$refs.button1.setPosition(percent);return;}var button=void 0;if(Math.abs(this.minValue-targetValue)<Math.abs(this.maxValue-targetValue)){button=this.firstValue<this.secondValue?'button1':'button2';}else{button=this.firstValue>this.secondValue?'button1':'button2';}this.$refs[button].setPosition(percent);},onSliderClick:function onSliderClick(event){if(this.sliderDisabled||this.dragging)return;this.resetSize();if(this.vertical){var sliderOffsetBottom=this.$refs.slider.getBoundingClientRect().bottom;this.setPosition((sliderOffsetBottom-event.clientY)/this.sliderSize*100);}else{var sliderOffsetLeft=this.$refs.slider.getBoundingClientRect().left;this.setPosition((event.clientX-sliderOffsetLeft)/this.sliderSize*100);}this.emitChange();},resetSize:function resetSize(){if(this.$refs.slider){this.sliderSize=this.$refs.slider['client'+(this.vertical?'Height':'Width')];}},emitChange:function emitChange(){var _this2=this;this.$nextTick(function(){_this2.$emit('change',_this2.range?[_this2.minValue,_this2.maxValue]:_this2.value);});},getStopStyle:function getStopStyle(position){return this.vertical?{'bottom':position+'%'}:{'left':position+'%'};}},computed:{stops:function stops(){var _this3=this;if(!this.showStops||this.min>this.max)return[];if(this.step===0){false&&false;return[];}var stopCount=(this.max-this.min)/this.step;var stepWidth=100*this.step/(this.max-this.min);var result=[];for(var i=1;i<stopCount;i++){result.push(i*stepWidth);}if(this.range){return result.filter(function(step){return step<100*(_this3.minValue-_this3.min)/(_this3.max-_this3.min)||step>100*(_this3.maxValue-_this3.min)/(_this3.max-_this3.min);});}else{return result.filter(function(step){return step>100*(_this3.firstValue-_this3.min)/(_this3.max-_this3.min);});}},markList:function markList(){var _this4=this;if(!this.marks){return[];}var marksKeys=Object.keys(this.marks);return marksKeys.map(parseFloat).sort(function(a,b){return a-b;}).filter(function(point){return point<=_this4.max&&point>=_this4.min;}).map(function(point){return{point:point,position:(point-_this4.min)*100/(_this4.max-_this4.min),mark:_this4.marks[point]};});},minValue:function minValue(){return Math.min(this.firstValue,this.secondValue);},maxValue:function maxValue(){return Math.max(this.firstValue,this.secondValue);},barSize:function barSize(){return this.range?100*(this.maxValue-this.minValue)/(this.max-this.min)+'%':100*(this.firstValue-this.min)/(this.max-this.min)+'%';},barStart:function barStart(){return this.range?100*(this.minValue-this.min)/(this.max-this.min)+'%':'0%';},precision:function precision(){var precisions=[this.min,this.max,this.step].map(function(item){var decimal=(''+item).split('.')[1];return decimal?decimal.length:0;});return Math.max.apply(null,precisions);},runwayStyle:function runwayStyle(){return this.vertical?{height:this.height}:{};},barStyle:function barStyle(){return this.vertical?{height:this.barSize,bottom:this.barStart}:{width:this.barSize,left:this.barStart};},sliderDisabled:function sliderDisabled(){return this.disabled||(this.elForm||{}).disabled;}},mounted:function mounted(){var valuetext=void 0;if(this.range){if(Array.isArray(this.value)){this.firstValue=Math.max(this.min,this.value[0]);this.secondValue=Math.min(this.max,this.value[1]);}else{this.firstValue=this.min;this.secondValue=this.max;}this.oldValue=[this.firstValue,this.secondValue];valuetext=this.firstValue+'-'+this.secondValue;}else{if(typeof this.value!=='number'||isNaN(this.value)){this.firstValue=this.min;}else{this.firstValue=Math.min(this.max,Math.max(this.min,this.value));}this.oldValue=this.firstValue;valuetext=this.firstValue;}this.$el.setAttribute('aria-valuetext',valuetext);// label screen reader
this.$el.setAttribute('aria-label',this.label?this.label:'slider between '+this.min+' and '+this.max);this.resetSize();window.addEventListener('resize',this.resetSize);},beforeDestroy:function beforeDestroy(){window.removeEventListener('resize',this.resetSize);}};// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_slider_src_mainvue_type_script_lang_js_=slider_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/slider/src/main.vue
/* normalize component */var slider_src_main_component=normalizeComponent(packages_slider_src_mainvue_type_script_lang_js_,mainvue_type_template_id_32708644_render,mainvue_type_template_id_32708644_staticRenderFns,false,null,null,null);/* hot reload */if(false){var slider_src_main_api;}slider_src_main_component.options.__file="packages/slider/src/main.vue";/* harmony default export */var slider_src_main=slider_src_main_component.exports;// CONCATENATED MODULE: ./packages/slider/index.js
/* istanbul ignore next */slider_src_main.install=function(Vue){Vue.component(slider_src_main.name,slider_src_main);};/* harmony default export */var slider=slider_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
var loadingvue_type_template_id_eee0a7ac_render=function loadingvue_type_template_id_eee0a7ac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-loading-mask",class:[_vm.customClass,{"is-fullscreen":_vm.fullscreen}],style:{backgroundColor:_vm.background||""}},[_c("div",{staticClass:"el-loading-spinner"},[!_vm.spinner?_c("svg",{staticClass:"circular",attrs:{viewBox:"25 25 50 50"}},[_c("circle",{staticClass:"path",attrs:{cx:"50",cy:"50",r:"20",fill:"none"}})]):_c("i",{class:_vm.spinner}),_vm.text?_c("p",{staticClass:"el-loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])]);};var loadingvue_type_template_id_eee0a7ac_staticRenderFns=[];loadingvue_type_template_id_eee0a7ac_render._withStripped=true;// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var loadingvue_type_script_lang_js_={data:function data(){return{text:null,spinner:null,background:null,fullscreen:true,visible:false,customClass:''};},methods:{handleAfterLeave:function handleAfterLeave(){this.$emit('after-leave');},setText:function setText(text){this.text=text;}}};// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
/* harmony default export */var src_loadingvue_type_script_lang_js_=loadingvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/loading/src/loading.vue
/* normalize component */var loading_component=normalizeComponent(src_loadingvue_type_script_lang_js_,loadingvue_type_template_id_eee0a7ac_render,loadingvue_type_template_id_eee0a7ac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var loading_api;}loading_component.options.__file="packages/loading/src/loading.vue";/* harmony default export */var loading=loading_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
var after_leave_=__webpack_require__(33);var after_leave_default=/*#__PURE__*/__webpack_require__.n(after_leave_);// CONCATENATED MODULE: ./packages/loading/src/directive.js
var Mask=external_vue_default.a.extend(loading);var loadingDirective={};loadingDirective.install=function(Vue){if(Vue.prototype.$isServer)return;var toggleLoading=function toggleLoading(el,binding){if(binding.value){Vue.nextTick(function(){if(binding.modifiers.fullscreen){el.originalPosition=Object(dom_["getStyle"])(document.body,'position');el.originalOverflow=Object(dom_["getStyle"])(document.body,'overflow');el.maskStyle.zIndex=popup_["PopupManager"].nextZIndex();Object(dom_["addClass"])(el.mask,'is-fullscreen');insertDom(document.body,el,binding);}else{Object(dom_["removeClass"])(el.mask,'is-fullscreen');if(binding.modifiers.body){el.originalPosition=Object(dom_["getStyle"])(document.body,'position');['top','left'].forEach(function(property){var scroll=property==='top'?'scrollTop':'scrollLeft';el.maskStyle[property]=el.getBoundingClientRect()[property]+document.body[scroll]+document.documentElement[scroll]-parseInt(Object(dom_["getStyle"])(document.body,'margin-'+property),10)+'px';});['height','width'].forEach(function(property){el.maskStyle[property]=el.getBoundingClientRect()[property]+'px';});insertDom(document.body,el,binding);}else{el.originalPosition=Object(dom_["getStyle"])(el,'position');insertDom(el,el,binding);}}});}else{after_leave_default()(el.instance,function(_){if(!el.instance.hiding)return;el.domVisible=false;var target=binding.modifiers.fullscreen||binding.modifiers.body?document.body:el;Object(dom_["removeClass"])(target,'el-loading-parent--relative');Object(dom_["removeClass"])(target,'el-loading-parent--hidden');el.instance.hiding=false;},300,true);el.instance.visible=false;el.instance.hiding=true;}};var insertDom=function insertDom(parent,el,binding){if(!el.domVisible&&Object(dom_["getStyle"])(el,'display')!=='none'&&Object(dom_["getStyle"])(el,'visibility')!=='hidden'){Object.keys(el.maskStyle).forEach(function(property){el.mask.style[property]=el.maskStyle[property];});if(el.originalPosition!=='absolute'&&el.originalPosition!=='fixed'&&el.originalPosition!=='sticky'){Object(dom_["addClass"])(parent,'el-loading-parent--relative');}if(binding.modifiers.fullscreen&&binding.modifiers.lock){Object(dom_["addClass"])(parent,'el-loading-parent--hidden');}el.domVisible=true;parent.appendChild(el.mask);Vue.nextTick(function(){if(el.instance.hiding){el.instance.$emit('after-leave');}else{el.instance.visible=true;}});el.domInserted=true;}else if(el.domVisible&&el.instance.hiding===true){el.instance.visible=true;el.instance.hiding=false;}};Vue.directive('loading',{bind:function bind(el,binding,vnode){var textExr=el.getAttribute('element-loading-text');var spinnerExr=el.getAttribute('element-loading-spinner');var backgroundExr=el.getAttribute('element-loading-background');var customClassExr=el.getAttribute('element-loading-custom-class');var vm=vnode.context;var mask=new Mask({el:document.createElement('div'),data:{text:vm&&vm[textExr]||textExr,spinner:vm&&vm[spinnerExr]||spinnerExr,background:vm&&vm[backgroundExr]||backgroundExr,customClass:vm&&vm[customClassExr]||customClassExr,fullscreen:!!binding.modifiers.fullscreen}});el.instance=mask;el.mask=mask.$el;el.maskStyle={};binding.value&&toggleLoading(el,binding);},update:function update(el,binding){el.instance.setText(el.getAttribute('element-loading-text'));if(binding.oldValue!==binding.value){toggleLoading(el,binding);}},unbind:function unbind(el,binding){if(el.domInserted){el.mask&&el.mask.parentNode&&el.mask.parentNode.removeChild(el.mask);toggleLoading(el,{value:false,modifiers:binding.modifiers});}el.instance&&el.instance.$destroy();}});};/* harmony default export */var src_directive=loadingDirective;// CONCATENATED MODULE: ./packages/loading/src/index.js
var LoadingConstructor=external_vue_default.a.extend(loading);var src_defaults={text:null,fullscreen:true,body:false,lock:false,customClass:''};var fullscreenLoading=void 0;LoadingConstructor.prototype.originalPosition='';LoadingConstructor.prototype.originalOverflow='';LoadingConstructor.prototype.close=function(){var _this=this;if(this.fullscreen){fullscreenLoading=undefined;}after_leave_default()(this,function(_){var target=_this.fullscreen||_this.body?document.body:_this.target;Object(dom_["removeClass"])(target,'el-loading-parent--relative');Object(dom_["removeClass"])(target,'el-loading-parent--hidden');if(_this.$el&&_this.$el.parentNode){_this.$el.parentNode.removeChild(_this.$el);}_this.$destroy();},300);this.visible=false;};var src_addStyle=function addStyle(options,parent,instance){var maskStyle={};if(options.fullscreen){instance.originalPosition=Object(dom_["getStyle"])(document.body,'position');instance.originalOverflow=Object(dom_["getStyle"])(document.body,'overflow');maskStyle.zIndex=popup_["PopupManager"].nextZIndex();}else if(options.body){instance.originalPosition=Object(dom_["getStyle"])(document.body,'position');['top','left'].forEach(function(property){var scroll=property==='top'?'scrollTop':'scrollLeft';maskStyle[property]=options.target.getBoundingClientRect()[property]+document.body[scroll]+document.documentElement[scroll]+'px';});['height','width'].forEach(function(property){maskStyle[property]=options.target.getBoundingClientRect()[property]+'px';});}else{instance.originalPosition=Object(dom_["getStyle"])(parent,'position');}Object.keys(maskStyle).forEach(function(property){instance.$el.style[property]=maskStyle[property];});};var src_Loading=function Loading(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(external_vue_default.a.prototype.$isServer)return;options=merge_default()({},src_defaults,options);if(typeof options.target==='string'){options.target=document.querySelector(options.target);}options.target=options.target||document.body;if(options.target!==document.body){options.fullscreen=false;}else{options.body=true;}if(options.fullscreen&&fullscreenLoading){return fullscreenLoading;}var parent=options.body?document.body:options.target;var instance=new LoadingConstructor({el:document.createElement('div'),data:options});src_addStyle(options,parent,instance);if(instance.originalPosition!=='absolute'&&instance.originalPosition!=='fixed'&&instance.originalPosition!=='sticky'){Object(dom_["addClass"])(parent,'el-loading-parent--relative');}if(options.fullscreen&&options.lock){Object(dom_["addClass"])(parent,'el-loading-parent--hidden');}parent.appendChild(instance.$el);external_vue_default.a.nextTick(function(){instance.visible=true;});if(options.fullscreen){fullscreenLoading=instance;}return instance;};/* harmony default export */var src=src_Loading;// CONCATENATED MODULE: ./packages/loading/index.js
/* harmony default export */var packages_loading={install:function install(Vue){Vue.use(src_directive);Vue.prototype.$loading=src;},directive:src_directive,service:src};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
var iconvue_type_template_id_cb3fe7f4_render=function iconvue_type_template_id_cb3fe7f4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("i",{class:"el-icon-"+_vm.name});};var iconvue_type_template_id_cb3fe7f4_staticRenderFns=[];iconvue_type_template_id_cb3fe7f4_render._withStripped=true;// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */var iconvue_type_script_lang_js_={name:'ElIcon',props:{name:String}};// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
/* harmony default export */var src_iconvue_type_script_lang_js_=iconvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/icon/src/icon.vue
/* normalize component */var icon_component=normalizeComponent(src_iconvue_type_script_lang_js_,iconvue_type_template_id_cb3fe7f4_render,iconvue_type_template_id_cb3fe7f4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_api;}icon_component.options.__file="packages/icon/src/icon.vue";/* harmony default export */var icon=icon_component.exports;// CONCATENATED MODULE: ./packages/icon/index.js
/* istanbul ignore next */icon.install=function(Vue){Vue.component(icon.name,icon);};/* harmony default export */var packages_icon=icon;// CONCATENATED MODULE: ./packages/row/src/row.js
/* harmony default export */var src_row={name:'ElRow',componentName:'ElRow',props:{tag:{type:String,default:'div'},gutter:Number,type:String,justify:{type:String,default:'start'},align:String},computed:{style:function style(){var ret={};if(this.gutter){ret.marginLeft='-'+this.gutter/2+'px';ret.marginRight=ret.marginLeft;}return ret;}},render:function render(h){return h(this.tag,{class:['el-row',this.justify!=='start'?'is-justify-'+this.justify:'',this.align?'is-align-'+this.align:'',{'el-row--flex':this.type==='flex'}],style:this.style},this.$slots.default);}};// CONCATENATED MODULE: ./packages/row/index.js
/* istanbul ignore next */src_row.install=function(Vue){Vue.component(src_row.name,src_row);};/* harmony default export */var packages_row=src_row;// CONCATENATED MODULE: ./packages/col/src/col.js
var col_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};/* harmony default export */var col={name:'ElCol',props:{span:{type:Number,default:24},tag:{type:String,default:'div'},offset:Number,pull:Number,push:Number,xs:[Number,Object],sm:[Number,Object],md:[Number,Object],lg:[Number,Object],xl:[Number,Object]},computed:{gutter:function gutter(){var parent=this.$parent;while(parent&&parent.$options.componentName!=='ElRow'){parent=parent.$parent;}return parent?parent.gutter:0;}},render:function render(h){var _this=this;var classList=[];var style={};if(this.gutter){style.paddingLeft=this.gutter/2+'px';style.paddingRight=style.paddingLeft;}['span','offset','pull','push'].forEach(function(prop){if(_this[prop]||_this[prop]===0){classList.push(prop!=='span'?'el-col-'+prop+'-'+_this[prop]:'el-col-'+_this[prop]);}});['xs','sm','md','lg','xl'].forEach(function(size){if(typeof _this[size]==='number'){classList.push('el-col-'+size+'-'+_this[size]);}else if(col_typeof(_this[size])==='object'){var props=_this[size];Object.keys(props).forEach(function(prop){classList.push(prop!=='span'?'el-col-'+size+'-'+prop+'-'+props[prop]:'el-col-'+size+'-'+props[prop]);});}});return h(this.tag,{class:['el-col',classList],style:style},this.$slots.default);}};// CONCATENATED MODULE: ./packages/col/index.js
/* istanbul ignore next */col.install=function(Vue){Vue.component(col.name,col);};/* harmony default export */var packages_col=col;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
var upload_listvue_type_template_id_173fedf5_render=function upload_listvue_type_template_id_173fedf5_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition-group",{class:["el-upload-list","el-upload-list--"+_vm.listType,{"is-disabled":_vm.disabled}],attrs:{tag:"ul",name:"el-list"}},_vm._l(_vm.files,function(file){return _c("li",{key:file.uid,class:["el-upload-list__item","is-"+file.status,_vm.focusing?"focusing":""],attrs:{tabindex:"0"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}!_vm.disabled&&_vm.$emit("remove",file);},focus:function focus($event){_vm.focusing=true;},blur:function blur($event){_vm.focusing=false;},click:function click($event){_vm.focusing=false;}}},[_vm._t("default",[file.status!=="uploading"&&["picture-card","picture"].indexOf(_vm.listType)>-1?_c("img",{staticClass:"el-upload-list__item-thumbnail",attrs:{src:file.url,alt:""}}):_vm._e(),_c("a",{staticClass:"el-upload-list__item-name",on:{click:function click($event){_vm.handleClick(file);}}},[_c("i",{staticClass:"el-icon-document"}),_vm._v(_vm._s(file.name)+"\n      ")]),_c("label",{staticClass:"el-upload-list__item-status-label"},[_c("i",{class:{"el-icon-upload-success":true,"el-icon-circle-check":_vm.listType==="text","el-icon-check":["picture-card","picture"].indexOf(_vm.listType)>-1}})]),!_vm.disabled?_c("i",{staticClass:"el-icon-close",on:{click:function click($event){_vm.$emit("remove",file);}}}):_vm._e(),!_vm.disabled?_c("i",{staticClass:"el-icon-close-tip"},[_vm._v(_vm._s(_vm.t("el.upload.deleteTip")))]):_vm._e(),file.status==="uploading"?_c("el-progress",{attrs:{type:_vm.listType==="picture-card"?"circle":"line","stroke-width":_vm.listType==="picture-card"?6:2,percentage:_vm.parsePercentage(file.percentage)}}):_vm._e(),_vm.listType==="picture-card"?_c("span",{staticClass:"el-upload-list__item-actions"},[_vm.handlePreview&&_vm.listType==="picture-card"?_c("span",{staticClass:"el-upload-list__item-preview",on:{click:function click($event){_vm.handlePreview(file);}}},[_c("i",{staticClass:"el-icon-zoom-in"})]):_vm._e(),!_vm.disabled?_c("span",{staticClass:"el-upload-list__item-delete",on:{click:function click($event){_vm.$emit("remove",file);}}},[_c("i",{staticClass:"el-icon-delete"})]):_vm._e()]):_vm._e()],{file:file})],2);}),0);};var upload_listvue_type_template_id_173fedf5_staticRenderFns=[];upload_listvue_type_template_id_173fedf5_render._withStripped=true;// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
// EXTERNAL MODULE: external "element-ui/lib/progress"
var progress_=__webpack_require__(34);var progress_default=/*#__PURE__*/__webpack_require__.n(progress_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var upload_listvue_type_script_lang_js_={name:'ElUploadList',mixins:[locale_default.a],data:function data(){return{focusing:false};},components:{ElProgress:progress_default.a},props:{files:{type:Array,default:function _default(){return[];}},disabled:{type:Boolean,default:false},handlePreview:Function,listType:String},methods:{parsePercentage:function parsePercentage(val){return parseInt(val,10);},handleClick:function handleClick(file){this.handlePreview&&this.handlePreview(file);}}};// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
/* harmony default export */var src_upload_listvue_type_script_lang_js_=upload_listvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
/* normalize component */var upload_list_component=normalizeComponent(src_upload_listvue_type_script_lang_js_,upload_listvue_type_template_id_173fedf5_render,upload_listvue_type_template_id_173fedf5_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_list_api;}upload_list_component.options.__file="packages/upload/src/upload-list.vue";/* harmony default export */var upload_list=upload_list_component.exports;// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_=__webpack_require__(24);var external_babel_helper_vue_jsx_merge_props_default=/*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);// CONCATENATED MODULE: ./packages/upload/src/ajax.js
function getError(action,option,xhr){var msg=void 0;if(xhr.response){msg=''+(xhr.response.error||xhr.response);}else if(xhr.responseText){msg=''+xhr.responseText;}else{msg='fail to post '+action+' '+xhr.status;}var err=new Error(msg);err.status=xhr.status;err.method='post';err.url=action;return err;}function getBody(xhr){var text=xhr.responseText||xhr.response;if(!text){return text;}try{return JSON.parse(text);}catch(e){return text;}}function upload(option){if(typeof XMLHttpRequest==='undefined'){return;}var xhr=new XMLHttpRequest();var action=option.action;if(xhr.upload){xhr.upload.onprogress=function progress(e){if(e.total>0){e.percent=e.loaded/e.total*100;}option.onProgress(e);};}var formData=new FormData();if(option.data){Object.keys(option.data).forEach(function(key){formData.append(key,option.data[key]);});}formData.append(option.filename,option.file,option.file.name);xhr.onerror=function error(e){option.onError(e);};xhr.onload=function onload(){if(xhr.status<200||xhr.status>=300){return option.onError(getError(action,option,xhr));}option.onSuccess(getBody(xhr));};xhr.open('post',action,true);if(option.withCredentials&&'withCredentials'in xhr){xhr.withCredentials=true;}var headers=option.headers||{};for(var item in headers){if(headers.hasOwnProperty(item)&&headers[item]!==null){xhr.setRequestHeader(item,headers[item]);}}xhr.send(formData);return xhr;}// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
var upload_draggervue_type_template_id_7ebbf219_render=function upload_draggervue_type_template_id_7ebbf219_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-upload-dragger",class:{"is-dragover":_vm.dragover},on:{drop:function drop($event){$event.preventDefault();return _vm.onDrop($event);},dragover:function dragover($event){$event.preventDefault();return _vm.onDragover($event);},dragleave:function dragleave($event){$event.preventDefault();_vm.dragover=false;}}},[_vm._t("default")],2);};var upload_draggervue_type_template_id_7ebbf219_staticRenderFns=[];upload_draggervue_type_template_id_7ebbf219_render._withStripped=true;// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var upload_draggervue_type_script_lang_js_={name:'ElUploadDrag',props:{disabled:Boolean},inject:{uploader:{default:''}},data:function data(){return{dragover:false};},methods:{onDragover:function onDragover(){if(!this.disabled){this.dragover=true;}},onDrop:function onDrop(e){if(this.disabled||!this.uploader)return;var accept=this.uploader.accept;this.dragover=false;if(!accept){this.$emit('file',e.dataTransfer.files);return;}this.$emit('file',[].slice.call(e.dataTransfer.files).filter(function(file){var type=file.type,name=file.name;var extension=name.indexOf('.')>-1?'.'+name.split('.').pop():'';var baseType=type.replace(/\/.*$/,'');return accept.split(',').map(function(type){return type.trim();}).filter(function(type){return type;}).some(function(acceptedType){if(/\..+$/.test(acceptedType)){return extension===acceptedType;}if(/\/\*$/.test(acceptedType)){return baseType===acceptedType.replace(/\/\*$/,'');}if(/^[^\/]+\/[^\/]+$/.test(acceptedType)){return type===acceptedType;}return false;});}));}}};// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
/* harmony default export */var src_upload_draggervue_type_script_lang_js_=upload_draggervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
/* normalize component */var upload_dragger_component=normalizeComponent(src_upload_draggervue_type_script_lang_js_,upload_draggervue_type_template_id_7ebbf219_render,upload_draggervue_type_template_id_7ebbf219_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_dragger_api;}upload_dragger_component.options.__file="packages/upload/src/upload-dragger.vue";/* harmony default export */var upload_dragger=upload_dragger_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
/* harmony default export */var uploadvue_type_script_lang_js_={inject:['uploader'],components:{UploadDragger:upload_dragger},props:{type:String,action:{type:String,required:true},name:{type:String,default:'file'},data:Object,headers:Object,withCredentials:Boolean,multiple:Boolean,accept:String,onStart:Function,onProgress:Function,onSuccess:Function,onError:Function,beforeUpload:Function,drag:Boolean,onPreview:{type:Function,default:function _default(){}},onRemove:{type:Function,default:function _default(){}},fileList:Array,autoUpload:Boolean,listType:String,httpRequest:{type:Function,default:upload},disabled:Boolean,limit:Number,onExceed:Function},data:function data(){return{mouseover:false,reqs:{}};},methods:{isImage:function isImage(str){return str.indexOf('image')!==-1;},handleChange:function handleChange(ev){var files=ev.target.files;if(!files)return;this.uploadFiles(files);},uploadFiles:function uploadFiles(files){var _this=this;if(this.limit&&this.fileList.length+files.length>this.limit){this.onExceed&&this.onExceed(files,this.fileList);return;}var postFiles=Array.prototype.slice.call(files);if(!this.multiple){postFiles=postFiles.slice(0,1);}if(postFiles.length===0){return;}postFiles.forEach(function(rawFile){_this.onStart(rawFile);if(_this.autoUpload)_this.upload(rawFile);});},upload:function upload(rawFile){var _this2=this;this.$refs.input.value=null;if(!this.beforeUpload){return this.post(rawFile);}var before=this.beforeUpload(rawFile);if(before&&before.then){before.then(function(processedFile){var fileType=Object.prototype.toString.call(processedFile);if(fileType==='[object File]'||fileType==='[object Blob]'){if(fileType==='[object Blob]'){processedFile=new File([processedFile],rawFile.name,{type:rawFile.type});}for(var p in rawFile){if(rawFile.hasOwnProperty(p)){processedFile[p]=rawFile[p];}}_this2.post(processedFile);}else{_this2.post(rawFile);}},function(){_this2.onRemove(null,rawFile);});}else if(before!==false){this.post(rawFile);}else{this.onRemove(null,rawFile);}},abort:function abort(file){var reqs=this.reqs;if(file){var uid=file;if(file.uid)uid=file.uid;if(reqs[uid]){reqs[uid].abort();}}else{Object.keys(reqs).forEach(function(uid){if(reqs[uid])reqs[uid].abort();delete reqs[uid];});}},post:function post(rawFile){var _this3=this;var uid=rawFile.uid;var options={headers:this.headers,withCredentials:this.withCredentials,file:rawFile,data:this.data,filename:this.name,action:this.action,onProgress:function onProgress(e){_this3.onProgress(e,rawFile);},onSuccess:function onSuccess(res){_this3.onSuccess(res,rawFile);delete _this3.reqs[uid];},onError:function onError(err){_this3.onError(err,rawFile);delete _this3.reqs[uid];}};var req=this.httpRequest(options);this.reqs[uid]=req;if(req&&req.then){req.then(options.onSuccess,options.onError);}},handleClick:function handleClick(){if(!this.disabled){this.$refs.input.value=null;this.$refs.input.click();}},handleKeydown:function handleKeydown(e){if(e.target!==e.currentTarget)return;if(e.keyCode===13||e.keyCode===32){this.handleClick();}}},render:function render(h){var handleClick=this.handleClick,drag=this.drag,name=this.name,handleChange=this.handleChange,multiple=this.multiple,accept=this.accept,listType=this.listType,uploadFiles=this.uploadFiles,disabled=this.disabled,handleKeydown=this.handleKeydown;var data={class:{'el-upload':true},on:{click:handleClick,keydown:handleKeydown}};data.class['el-upload--'+listType]=true;return h('div',external_babel_helper_vue_jsx_merge_props_default()([data,{attrs:{tabindex:'0'}}]),[drag?h('upload-dragger',{attrs:{disabled:disabled},on:{'file':uploadFiles}},[this.$slots.default]):this.$slots.default,h('input',{'class':'el-upload__input',attrs:{type:'file',name:name,multiple:multiple,accept:accept},ref:'input',on:{'change':handleChange}})]);}};// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
/* harmony default export */var src_uploadvue_type_script_lang_js_=uploadvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload.vue
var upload_render,upload_staticRenderFns;/* normalize component */var upload_component=normalizeComponent(src_uploadvue_type_script_lang_js_,upload_render,upload_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_api;}upload_component.options.__file="packages/upload/src/upload.vue";/* harmony default export */var src_upload=upload_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
function srcvue_type_script_lang_js_noop(){}/* harmony default export */var srcvue_type_script_lang_js_={name:'ElUpload',mixins:[migrating_default.a],components:{ElProgress:progress_default.a,UploadList:upload_list,Upload:src_upload},provide:function provide(){return{uploader:this};},inject:{elForm:{default:''}},props:{action:{type:String,required:true},headers:{type:Object,default:function _default(){return{};}},data:Object,multiple:Boolean,name:{type:String,default:'file'},drag:Boolean,dragger:Boolean,withCredentials:Boolean,showFileList:{type:Boolean,default:true},accept:String,type:{type:String,default:'select'},beforeUpload:Function,beforeRemove:Function,onRemove:{type:Function,default:srcvue_type_script_lang_js_noop},onChange:{type:Function,default:srcvue_type_script_lang_js_noop},onPreview:{type:Function},onSuccess:{type:Function,default:srcvue_type_script_lang_js_noop},onProgress:{type:Function,default:srcvue_type_script_lang_js_noop},onError:{type:Function,default:srcvue_type_script_lang_js_noop},fileList:{type:Array,default:function _default(){return[];}},autoUpload:{type:Boolean,default:true},listType:{type:String,default:'text'// text,picture,picture-card
},httpRequest:Function,disabled:Boolean,limit:Number,onExceed:{type:Function,default:srcvue_type_script_lang_js_noop}},data:function data(){return{uploadFiles:[],dragOver:false,draging:false,tempIndex:1};},computed:{uploadDisabled:function uploadDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{listType:function listType(type){if(type==='picture-card'||type==='picture'){this.uploadFiles=this.uploadFiles.map(function(file){if(!file.url&&file.raw){try{file.url=URL.createObjectURL(file.raw);}catch(err){console.error('[Element Error][Upload]',err);}}return file;});}},fileList:{immediate:true,handler:function handler(fileList){var _this=this;this.uploadFiles=fileList.map(function(item){item.uid=item.uid||Date.now()+_this.tempIndex++;item.status=item.status||'success';return item;});}}},methods:{handleStart:function handleStart(rawFile){rawFile.uid=Date.now()+this.tempIndex++;var file={status:'ready',name:rawFile.name,size:rawFile.size,percentage:0,uid:rawFile.uid,raw:rawFile};if(this.listType==='picture-card'||this.listType==='picture'){try{file.url=URL.createObjectURL(rawFile);}catch(err){console.error('[Element Error][Upload]',err);return;}}this.uploadFiles.push(file);this.onChange(file,this.uploadFiles);},handleProgress:function handleProgress(ev,rawFile){var file=this.getFile(rawFile);this.onProgress(ev,file,this.uploadFiles);file.status='uploading';file.percentage=ev.percent||0;},handleSuccess:function handleSuccess(res,rawFile){var file=this.getFile(rawFile);if(file){file.status='success';file.response=res;this.onSuccess(res,file,this.uploadFiles);this.onChange(file,this.uploadFiles);}},handleError:function handleError(err,rawFile){var file=this.getFile(rawFile);var fileList=this.uploadFiles;file.status='fail';fileList.splice(fileList.indexOf(file),1);this.onError(err,file,this.uploadFiles);this.onChange(file,this.uploadFiles);},handleRemove:function handleRemove(file,raw){var _this2=this;if(raw){file=this.getFile(raw);}var doRemove=function doRemove(){_this2.abort(file);var fileList=_this2.uploadFiles;fileList.splice(fileList.indexOf(file),1);_this2.onRemove(file,fileList);};if(!this.beforeRemove){doRemove();}else if(typeof this.beforeRemove==='function'){var before=this.beforeRemove(file,this.uploadFiles);if(before&&before.then){before.then(function(){doRemove();},srcvue_type_script_lang_js_noop);}else if(before!==false){doRemove();}}},getFile:function getFile(rawFile){var fileList=this.uploadFiles;var target=void 0;fileList.every(function(item){target=rawFile.uid===item.uid?item:null;return!target;});return target;},abort:function abort(file){this.$refs['upload-inner'].abort(file);},clearFiles:function clearFiles(){this.uploadFiles=[];},submit:function submit(){var _this3=this;this.uploadFiles.filter(function(file){return file.status==='ready';}).forEach(function(file){_this3.$refs['upload-inner'].upload(file.raw);});},getMigratingConfig:function getMigratingConfig(){return{props:{'default-file-list':'default-file-list is renamed to file-list.','show-upload-list':'show-upload-list is renamed to show-file-list.','thumbnail-mode':'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'}};}},beforeDestroy:function beforeDestroy(){this.uploadFiles.forEach(function(file){if(file.url&&file.url.indexOf('blob:')===0){URL.revokeObjectURL(file.url);}});},render:function render(h){var _this4=this;var uploadList=void 0;if(this.showFileList){uploadList=h(upload_list,{attrs:{disabled:this.uploadDisabled,listType:this.listType,files:this.uploadFiles,handlePreview:this.onPreview},on:{'remove':this.handleRemove}},[function(props){if(_this4.$scopedSlots.file){return _this4.$scopedSlots.file({file:props.file});}}]);}var uploadData={props:{type:this.type,drag:this.drag,action:this.action,multiple:this.multiple,'before-upload':this.beforeUpload,'with-credentials':this.withCredentials,headers:this.headers,name:this.name,data:this.data,accept:this.accept,fileList:this.uploadFiles,autoUpload:this.autoUpload,listType:this.listType,disabled:this.uploadDisabled,limit:this.limit,'on-exceed':this.onExceed,'on-start':this.handleStart,'on-progress':this.handleProgress,'on-success':this.handleSuccess,'on-error':this.handleError,'on-preview':this.onPreview,'on-remove':this.handleRemove,'http-request':this.httpRequest},ref:'upload-inner'};var trigger=this.$slots.trigger||this.$slots.default;var uploadComponent=h('upload',uploadData,[trigger]);return h('div',[this.listType==='picture-card'?uploadList:'',this.$slots.trigger?[uploadComponent,this.$slots.default]:uploadComponent,this.$slots.tip,this.listType!=='picture-card'?uploadList:'']);}};// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var upload_srcvue_type_script_lang_js_=srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/index.vue
var src_render,src_staticRenderFns;/* normalize component */var upload_src_component=normalizeComponent(upload_srcvue_type_script_lang_js_,src_render,src_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_api;}upload_src_component.options.__file="packages/upload/src/index.vue";/* harmony default export */var upload_src=upload_src_component.exports;// CONCATENATED MODULE: ./packages/upload/index.js
/* istanbul ignore next */upload_src.install=function(Vue){Vue.component(upload_src.name,upload_src);};/* harmony default export */var packages_upload=upload_src;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
var progressvue_type_template_id_229ee406_render=function progressvue_type_template_id_229ee406_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-progress",class:["el-progress--"+_vm.type,_vm.status?"is-"+_vm.status:"",{"el-progress--without-text":!_vm.showText,"el-progress--text-inside":_vm.textInside}],attrs:{role:"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm.type==="line"?_c("div",{staticClass:"el-progress-bar"},[_c("div",{staticClass:"el-progress-bar__outer",style:{height:_vm.strokeWidth+"px",backgroundColor:_vm.defineBackColor}},[_c("div",{staticClass:"el-progress-bar__inner",style:_vm.barStyle},[_vm.showText&&_vm.textInside?_c("div",{staticClass:"el-progress-bar__innerText",style:{color:_vm.textColor}},[_vm._v(_vm._s(_vm.content))]):_vm._e()])])]):_c("div",{staticClass:"el-progress-circle",style:{height:_vm.width+"px",width:_vm.width+"px"}},[_c("svg",{attrs:{viewBox:"0 0 100 100"}},[_c("path",{staticClass:"el-progress-circle__track",style:_vm.trailPathStyle,attrs:{d:_vm.trackPath,stroke:_vm.defineBackColor,"stroke-width":_vm.relativeStrokeWidth,fill:"none"}}),_c("path",{staticClass:"el-progress-circle__path",style:_vm.circlePathStyle,attrs:{d:_vm.trackPath,stroke:_vm.stroke,fill:"none","stroke-linecap":_vm.strokeLinecap,"stroke-width":_vm.percentage?_vm.relativeStrokeWidth:0}})])]),_vm.showText&&!_vm.textInside?_c("div",{staticClass:"el-progress__text",style:{fontSize:_vm.progressTextSize+"px",color:_vm.textColor}},[!_vm.status?[_vm._v(_vm._s(_vm.content))]:_c("i",{class:_vm.iconClass})],2):_vm._e()]);};var progressvue_type_template_id_229ee406_staticRenderFns=[];progressvue_type_template_id_229ee406_render._withStripped=true;// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var progressvue_type_script_lang_js_={name:'ElProgress',props:{type:{type:String,default:'line',validator:function validator(val){return['line','circle','dashboard'].indexOf(val)>-1;}},percentage:{type:Number,default:0,required:true,validator:function validator(val){return val>=0&&val<=100;}},status:{type:String,validator:function validator(val){return['success','exception','warning'].indexOf(val)>-1;}},strokeWidth:{type:Number,default:6},strokeLinecap:{type:String,default:'round'},textInside:{type:Boolean,default:false},width:{type:Number,default:126},showText:{type:Boolean,default:true},color:{type:[String,Array,Function],default:''},defineBackColor:{type:[String,Array,Function],default:'#ebeef5'},textColor:{type:[String,Array,Function],default:'#606266'},format:Function},computed:{barStyle:function barStyle(){var style={};style.width=this.percentage+'%';style.backgroundColor=this.getCurrentColor(this.percentage);return style;},relativeStrokeWidth:function relativeStrokeWidth(){return(this.strokeWidth/this.width*100).toFixed(1);},radius:function radius(){if(this.type==='circle'||this.type==='dashboard'){return parseInt(50-parseFloat(this.relativeStrokeWidth)/2,10);}else{return 0;}},trackPath:function trackPath(){var radius=this.radius;var isDashboard=this.type==='dashboard';return'\n        M 50 50\n        m 0 '+(isDashboard?'':'-')+radius+'\n        a '+radius+' '+radius+' 0 1 1 0 '+(isDashboard?'-':'')+radius*2+'\n        a '+radius+' '+radius+' 0 1 1 0 '+(isDashboard?'':'-')+radius*2+'\n        ';},perimeter:function perimeter(){return 2*Math.PI*this.radius;},rate:function rate(){return this.type==='dashboard'?0.75:1;},strokeDashoffset:function strokeDashoffset(){var offset=-1*this.perimeter*(1-this.rate)/2;return offset+'px';},trailPathStyle:function trailPathStyle(){return{strokeDasharray:this.perimeter*this.rate+'px, '+this.perimeter+'px',strokeDashoffset:this.strokeDashoffset};},circlePathStyle:function circlePathStyle(){return{strokeDasharray:this.perimeter*this.rate*(this.percentage/100)+'px, '+this.perimeter+'px',strokeDashoffset:this.strokeDashoffset,transition:'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'};},stroke:function stroke(){var ret=void 0;if(this.color){ret=this.getCurrentColor(this.percentage);}else{switch(this.status){case'success':ret='#13ce66';break;case'exception':ret='#ff4949';break;case'warning':ret='#e6a23c';break;default:ret='#20a0ff';}}return ret;},iconClass:function iconClass(){if(this.status==='warning'){return'el-icon-warning';}if(this.type==='line'){return this.status==='success'?'el-icon-circle-check':'el-icon-circle-close';}else{return this.status==='success'?'el-icon-check':'el-icon-close';}},progressTextSize:function progressTextSize(){return this.type==='line'?12+this.strokeWidth*0.4:this.width*0.111111+2;},content:function content(){if(typeof this.format==='function'){return this.format(this.percentage)||'';}else{return this.percentage+'%';}}},methods:{getCurrentColor:function getCurrentColor(percentage){if(typeof this.color==='function'){return this.color(percentage);}else if(typeof this.color==='string'){return this.color;}else{return this.getLevelColor(percentage);}},getLevelColor:function getLevelColor(percentage){var colorArray=this.getColorArray().sort(function(a,b){return a.percentage-b.percentage;});for(var i=0;i<colorArray.length;i++){if(colorArray[i].percentage>percentage){return colorArray[i].color;}}return colorArray[colorArray.length-1].color;},getColorArray:function getColorArray(){var color=this.color;var span=100/color.length;return color.map(function(seriesColor,index){if(typeof seriesColor==='string'){return{color:seriesColor,percentage:(index+1)*span};}return seriesColor;});}}};// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
/* harmony default export */var src_progressvue_type_script_lang_js_=progressvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/progress/src/progress.vue
/* normalize component */var progress_component=normalizeComponent(src_progressvue_type_script_lang_js_,progressvue_type_template_id_229ee406_render,progressvue_type_template_id_229ee406_staticRenderFns,false,null,null,null);/* hot reload */if(false){var progress_api;}progress_component.options.__file="packages/progress/src/progress.vue";/* harmony default export */var progress=progress_component.exports;// CONCATENATED MODULE: ./packages/progress/index.js
/* istanbul ignore next */progress.install=function(Vue){Vue.component(progress.name,progress);};/* harmony default export */var packages_progress=progress;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
var spinnervue_type_template_id_697b8538_render=function spinnervue_type_template_id_697b8538_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",{staticClass:"el-spinner"},[_c("svg",{staticClass:"el-spinner-inner",style:{width:_vm.radius/2+"px",height:_vm.radius/2+"px"},attrs:{viewBox:"0 0 50 50"}},[_c("circle",{staticClass:"path",attrs:{cx:"25",cy:"25",r:"20",fill:"none",stroke:_vm.strokeColor,"stroke-width":_vm.strokeWidth}})])]);};var spinnervue_type_template_id_697b8538_staticRenderFns=[];spinnervue_type_template_id_697b8538_render._withStripped=true;// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */var spinnervue_type_script_lang_js_={name:'ElSpinner',props:{type:String,radius:{type:Number,default:100},strokeWidth:{type:Number,default:5},strokeColor:{type:String,default:'#efefef'}}};// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
/* harmony default export */var src_spinnervue_type_script_lang_js_=spinnervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
/* normalize component */var spinner_component=normalizeComponent(src_spinnervue_type_script_lang_js_,spinnervue_type_template_id_697b8538_render,spinnervue_type_template_id_697b8538_staticRenderFns,false,null,null,null);/* hot reload */if(false){var spinner_api;}spinner_component.options.__file="packages/spinner/src/spinner.vue";/* harmony default export */var spinner=spinner_component.exports;// CONCATENATED MODULE: ./packages/spinner/index.js
/* istanbul ignore next */spinner.install=function(Vue){Vue.component(spinner.name,spinner);};/* harmony default export */var packages_spinner=spinner;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
var mainvue_type_template_id_455b9f60_render=function mainvue_type_template_id_455b9f60_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-message-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],class:["el-message",_vm.type&&!_vm.iconClass?"el-message--"+_vm.type:"",_vm.center?"is-center":"",_vm.showClose?"is-closable":"",_vm.customClass],style:_vm.positionStyle,attrs:{role:"alert"},on:{mouseenter:_vm.clearTimer,mouseleave:_vm.startTimer}},[_vm.iconClass?_c("i",{class:_vm.iconClass}):_c("i",{class:_vm.typeClass}),_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",{staticClass:"el-message__content"},[_vm._v(_vm._s(_vm.message))]):_c("p",{staticClass:"el-message__content",domProps:{innerHTML:_vm._s(_vm.message)}})]),_vm.showClose?_c("i",{staticClass:"el-message__closeBtn el-icon-close",on:{click:_vm.close}}):_vm._e()],2)]);};var mainvue_type_template_id_455b9f60_staticRenderFns=[];mainvue_type_template_id_455b9f60_render._withStripped=true;// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var src_mainvue_type_script_lang_js_typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var message_src_mainvue_type_script_lang_js_={data:function data(){return{visible:false,message:'',duration:3000,type:'info',iconClass:'',customClass:'',onClose:null,showClose:false,closed:false,verticalOffset:20,timer:null,dangerouslyUseHTMLString:false,center:false};},computed:{typeClass:function typeClass(){return this.type&&!this.iconClass?'el-message__icon el-icon-'+src_mainvue_type_script_lang_js_typeMap[this.type]:'';},positionStyle:function positionStyle(){return{'top':this.verticalOffset+'px'};}},watch:{closed:function closed(newVal){if(newVal){this.visible=false;}}},methods:{handleAfterLeave:function handleAfterLeave(){this.$destroy(true);this.$el.parentNode.removeChild(this.$el);},close:function close(){this.closed=true;if(typeof this.onClose==='function'){this.onClose(this);}},clearTimer:function clearTimer(){clearTimeout(this.timer);},startTimer:function startTimer(){var _this=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this.closed){_this.close();}},this.duration);}},keydown:function keydown(e){if(e.keyCode===27){// esc关闭消息
if(!this.closed){this.close();}}}},mounted:function mounted(){this.startTimer();document.addEventListener('keydown',this.keydown);},beforeDestroy:function beforeDestroy(){document.removeEventListener('keydown',this.keydown);}};// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_message_src_mainvue_type_script_lang_js_=message_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/message/src/main.vue
/* normalize component */var message_src_main_component=normalizeComponent(packages_message_src_mainvue_type_script_lang_js_,mainvue_type_template_id_455b9f60_render,mainvue_type_template_id_455b9f60_staticRenderFns,false,null,null,null);/* hot reload */if(false){var message_src_main_api;}message_src_main_component.options.__file="packages/message/src/main.vue";/* harmony default export */var message_src_main=message_src_main_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/types"
var types_=__webpack_require__(16);// CONCATENATED MODULE: ./packages/message/src/main.js
var main_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var MessageConstructor=external_vue_default.a.extend(message_src_main);var message_src_main_instance=void 0;var main_instances=[];var main_seed=1;var main_Message=function Message(options){if(external_vue_default.a.prototype.$isServer)return;options=options||{};if(typeof options==='string'){options={message:options};}var userOnClose=options.onClose;var id='message_'+main_seed++;options.onClose=function(){Message.close(id,userOnClose);};message_src_main_instance=new MessageConstructor({data:options});message_src_main_instance.id=id;if(Object(vdom_["isVNode"])(message_src_main_instance.message)){message_src_main_instance.$slots.default=[message_src_main_instance.message];message_src_main_instance.message=null;}message_src_main_instance.$mount();document.body.appendChild(message_src_main_instance.$el);var verticalOffset=options.offset||20;main_instances.forEach(function(item){verticalOffset+=item.$el.offsetHeight+16;});message_src_main_instance.verticalOffset=verticalOffset;message_src_main_instance.visible=true;message_src_main_instance.$el.style.zIndex=popup_["PopupManager"].nextZIndex();main_instances.push(message_src_main_instance);return message_src_main_instance;};['success','warning','info','error'].forEach(function(type){main_Message[type]=function(options){if(Object(types_["isObject"])(options)&&!Object(vdom_["isVNode"])(options)){return main_Message(main_extends({},options,{type:type}));}return main_Message({type:type,message:options});};});main_Message.close=function(id,userOnClose){var len=main_instances.length;var index=-1;var removedHeight=void 0;for(var i=0;i<len;i++){if(id===main_instances[i].id){removedHeight=main_instances[i].$el.offsetHeight;index=i;if(typeof userOnClose==='function'){userOnClose(main_instances[i]);}main_instances.splice(i,1);break;}}if(len<=1||index===-1||index>main_instances.length-1)return;for(var _i=index;_i<len-1;_i++){var dom=main_instances[_i].$el;dom.style['top']=parseInt(dom.style['top'],10)-removedHeight-16+'px';}};main_Message.closeAll=function(){for(var i=main_instances.length-1;i>=0;i--){main_instances[i].close();}};/* harmony default export */var packages_message_src_main=main_Message;// CONCATENATED MODULE: ./packages/message/index.js
/* harmony default export */var packages_message=packages_message_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
var mainvue_type_template_id_7ccb6598_render=function mainvue_type_template_id_7ccb6598_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-badge"},[_vm._t("default"),_c("transition",{attrs:{name:"el-zoom-in-center"}},[_c("sup",{directives:[{name:"show",rawName:"v-show",value:!_vm.hidden&&(_vm.content||_vm.content===0||_vm.isDot),expression:"!hidden && (content || content === 0 || isDot)"}],staticClass:"el-badge__content",class:[_vm.type?"el-badge__content--"+_vm.type:null,{"is-fixed":_vm.$slots.default,"is-dot":_vm.isDot}],domProps:{textContent:_vm._s(_vm.content)}})])],2);};var mainvue_type_template_id_7ccb6598_staticRenderFns=[];mainvue_type_template_id_7ccb6598_render._withStripped=true;// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var badge_src_mainvue_type_script_lang_js_={name:'ElBadge',props:{value:[String,Number],max:Number,isDot:Boolean,hidden:Boolean,type:{type:String,validator:function validator(val){return['primary','success','warning','info','danger'].indexOf(val)>-1;}}},computed:{content:function content(){if(this.isDot)return;var value=this.value;var max=this.max;if(typeof value==='number'&&typeof max==='number'){return max<value?max+'+':value;}return value;}}};// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_badge_src_mainvue_type_script_lang_js_=badge_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/badge/src/main.vue
/* normalize component */var badge_src_main_component=normalizeComponent(packages_badge_src_mainvue_type_script_lang_js_,mainvue_type_template_id_7ccb6598_render,mainvue_type_template_id_7ccb6598_staticRenderFns,false,null,null,null);/* hot reload */if(false){var badge_src_main_api;}badge_src_main_component.options.__file="packages/badge/src/main.vue";/* harmony default export */var badge_src_main=badge_src_main_component.exports;// CONCATENATED MODULE: ./packages/badge/index.js
/* istanbul ignore next */badge_src_main.install=function(Vue){Vue.component(badge_src_main.name,badge_src_main);};/* harmony default export */var badge=badge_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
var mainvue_type_template_id_59a4a40f_render=function mainvue_type_template_id_59a4a40f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-card",class:_vm.shadow?"is-"+_vm.shadow+"-shadow":"is-always-shadow"},[_vm.$slots.header||_vm.header?_c("div",{staticClass:"el-card__header"},[_vm._t("header",[_vm._v(_vm._s(_vm.header))])],2):_vm._e(),_c("div",{staticClass:"el-card__body",style:_vm.bodyStyle},[_vm._t("default")],2)]);};var mainvue_type_template_id_59a4a40f_staticRenderFns=[];mainvue_type_template_id_59a4a40f_render._withStripped=true;// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var card_src_mainvue_type_script_lang_js_={name:'ElCard',props:{header:{},bodyStyle:{},shadow:{type:String}}};// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_card_src_mainvue_type_script_lang_js_=card_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/card/src/main.vue
/* normalize component */var card_src_main_component=normalizeComponent(packages_card_src_mainvue_type_script_lang_js_,mainvue_type_template_id_59a4a40f_render,mainvue_type_template_id_59a4a40f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var card_src_main_api;}card_src_main_component.options.__file="packages/card/src/main.vue";/* harmony default export */var card_src_main=card_src_main_component.exports;// CONCATENATED MODULE: ./packages/card/index.js
/* istanbul ignore next */card_src_main.install=function(Vue){Vue.component(card_src_main.name,card_src_main);};/* harmony default export */var card=card_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
var mainvue_type_template_id_ada57782_render=function mainvue_type_template_id_ada57782_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-rate",attrs:{role:"slider","aria-valuenow":_vm.currentValue,"aria-valuetext":_vm.text,"aria-valuemin":"0","aria-valuemax":_vm.max,tabindex:"0"},on:{keydown:_vm.handleKey}},[_vm._l(_vm.max,function(item,key){return _c("span",{key:key,staticClass:"el-rate__item",style:{cursor:_vm.rateDisabled?"auto":"pointer"},on:{mousemove:function mousemove($event){_vm.setCurrentValue(item,$event);},mouseleave:_vm.resetCurrentValue,click:function click($event){_vm.selectValue(item);}}},[_c("i",{staticClass:"el-rate__icon",class:[_vm.classes[item-1],{hover:_vm.hoverIndex===item}],style:_vm.getIconStyle(item)},[_vm.showDecimalIcon(item)?_c("i",{staticClass:"el-rate__decimal",class:_vm.decimalIconClass,style:_vm.decimalStyle}):_vm._e()])]);}),_vm.showText||_vm.showScore?_c("span",{staticClass:"el-rate__text",style:{color:_vm.textColor}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2);};var mainvue_type_template_id_ada57782_staticRenderFns=[];mainvue_type_template_id_ada57782_render._withStripped=true;// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var rate_src_mainvue_type_script_lang_js_={name:'ElRate',mixins:[migrating_default.a],inject:{elForm:{default:''}},data:function data(){return{pointerAtLeftHalf:true,currentValue:this.value,hoverIndex:-1};},props:{value:{type:Number,default:0},lowThreshold:{type:Number,default:2},highThreshold:{type:Number,default:4},max:{type:Number,default:5},colors:{type:[Array,Object],default:function _default(){return['#F7BA2A','#F7BA2A','#F7BA2A'];}},voidColor:{type:String,default:'#C6D1DE'},disabledVoidColor:{type:String,default:'#EFF2F7'},iconClasses:{type:[Array,Object],default:function _default(){return['el-icon-star-on','el-icon-star-on','el-icon-star-on'];}},voidIconClass:{type:String,default:'el-icon-star-off'},disabledVoidIconClass:{type:String,default:'el-icon-star-on'},disabled:{type:Boolean,default:false},allowHalf:{type:Boolean,default:false},showText:{type:Boolean,default:false},showScore:{type:Boolean,default:false},textColor:{type:String,default:'#1f2d3d'},texts:{type:Array,default:function _default(){return['极差','失望','一般','满意','惊喜'];}},scoreTemplate:{type:String,default:'{value}'}},computed:{text:function text(){var result='';if(this.showScore){result=this.scoreTemplate.replace(/\{\s*value\s*\}/,this.rateDisabled?this.value:this.currentValue);}else if(this.showText){result=this.texts[Math.ceil(this.currentValue)-1];}return result;},decimalStyle:function decimalStyle(){var width='';if(this.rateDisabled){width=this.valueDecimal+'%';}else if(this.allowHalf){width='50%';}return{color:this.activeColor,width:width};},valueDecimal:function valueDecimal(){return this.value*100-Math.floor(this.value)*100;},classMap:function classMap(){var _ref;return Array.isArray(this.iconClasses)?(_ref={},_ref[this.lowThreshold]=this.iconClasses[0],_ref[this.highThreshold]={value:this.iconClasses[1],excluded:true},_ref[this.max]=this.iconClasses[2],_ref):this.iconClasses;},decimalIconClass:function decimalIconClass(){return this.getValueFromMap(this.value,this.classMap);},voidClass:function voidClass(){return this.rateDisabled?this.disabledVoidIconClass:this.voidIconClass;},activeClass:function activeClass(){return this.getValueFromMap(this.currentValue,this.classMap);},colorMap:function colorMap(){var _ref2;return Array.isArray(this.colors)?(_ref2={},_ref2[this.lowThreshold]=this.colors[0],_ref2[this.highThreshold]={value:this.colors[1],excluded:true},_ref2[this.max]=this.colors[2],_ref2):this.colors;},activeColor:function activeColor(){return this.getValueFromMap(this.currentValue,this.colorMap);},classes:function classes(){var result=[];var i=0;var threshold=this.currentValue;if(this.allowHalf&&this.currentValue!==Math.floor(this.currentValue)){threshold--;}for(;i<threshold;i++){result.push(this.activeClass);}for(;i<this.max;i++){result.push(this.voidClass);}return result;},rateDisabled:function rateDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{value:function value(val){this.currentValue=val;this.pointerAtLeftHalf=this.value!==Math.floor(this.value);}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'text-template':'text-template is renamed to score-template.'}};},getValueFromMap:function getValueFromMap(value,map){var matchedKeys=Object.keys(map).filter(function(key){var val=map[key];var excluded=Object(types_["isObject"])(val)?val.excluded:false;return excluded?value<key:value<=key;}).sort(function(a,b){return a-b;});var matchedValue=map[matchedKeys[0]];return Object(types_["isObject"])(matchedValue)?matchedValue.value:matchedValue||'';},showDecimalIcon:function showDecimalIcon(item){var showWhenDisabled=this.rateDisabled&&this.valueDecimal>0&&item-1<this.value&&item>this.value;/* istanbul ignore next */var showWhenAllowHalf=this.allowHalf&&this.pointerAtLeftHalf&&item-0.5<=this.currentValue&&item>this.currentValue;return showWhenDisabled||showWhenAllowHalf;},getIconStyle:function getIconStyle(item){var voidColor=this.rateDisabled?this.disabledVoidColor:this.voidColor;return{color:item<=this.currentValue?this.activeColor:voidColor};},selectValue:function selectValue(value){if(this.rateDisabled){return;}if(this.allowHalf&&this.pointerAtLeftHalf){this.$emit('input',this.currentValue);this.$emit('change',this.currentValue);}else{this.$emit('input',value);this.$emit('change',value);}},handleKey:function handleKey(e){if(this.rateDisabled){return;}var currentValue=this.currentValue;var keyCode=e.keyCode;if(keyCode===38||keyCode===39){// left / down
if(this.allowHalf){currentValue+=0.5;}else{currentValue+=1;}e.stopPropagation();e.preventDefault();}else if(keyCode===37||keyCode===40){if(this.allowHalf){currentValue-=0.5;}else{currentValue-=1;}e.stopPropagation();e.preventDefault();}currentValue=currentValue<0?0:currentValue;currentValue=currentValue>this.max?this.max:currentValue;this.$emit('input',currentValue);this.$emit('change',currentValue);},setCurrentValue:function setCurrentValue(value,event){if(this.rateDisabled){return;}/* istanbul ignore if */if(this.allowHalf){var target=event.target;if(Object(dom_["hasClass"])(target,'el-rate__item')){target=target.querySelector('.el-rate__icon');}if(Object(dom_["hasClass"])(target,'el-rate__decimal')){target=target.parentNode;}this.pointerAtLeftHalf=event.offsetX*2<=target.clientWidth;this.currentValue=this.pointerAtLeftHalf?value-0.5:value;}else{this.currentValue=value;}this.hoverIndex=value;},resetCurrentValue:function resetCurrentValue(){if(this.rateDisabled){return;}if(this.allowHalf){this.pointerAtLeftHalf=this.value!==Math.floor(this.value);}this.currentValue=this.value;this.hoverIndex=-1;}},created:function created(){if(!this.value){this.$emit('input',0);}}};// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_rate_src_mainvue_type_script_lang_js_=rate_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/rate/src/main.vue
/* normalize component */var rate_src_main_component=normalizeComponent(packages_rate_src_mainvue_type_script_lang_js_,mainvue_type_template_id_ada57782_render,mainvue_type_template_id_ada57782_staticRenderFns,false,null,null,null);/* hot reload */if(false){var rate_src_main_api;}rate_src_main_component.options.__file="packages/rate/src/main.vue";/* harmony default export */var rate_src_main=rate_src_main_component.exports;// CONCATENATED MODULE: ./packages/rate/index.js
/* istanbul ignore next */rate_src_main.install=function(Vue){Vue.component(rate_src_main.name,rate_src_main);};/* harmony default export */var packages_rate=rate_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
var stepsvue_type_template_id_3c6b6dc0_render=function stepsvue_type_template_id_3c6b6dc0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-steps",class:[!_vm.simple&&"el-steps--"+_vm.direction,_vm.simple&&"el-steps--simple"]},[_vm._t("default")],2);};var stepsvue_type_template_id_3c6b6dc0_staticRenderFns=[];stepsvue_type_template_id_3c6b6dc0_render._withStripped=true;// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var stepsvue_type_script_lang_js_={name:'ElSteps',mixins:[migrating_default.a],props:{space:[Number,String],active:Number,direction:{type:String,default:'horizontal'},alignCenter:Boolean,simple:Boolean,finishStatus:{type:String,default:'finish'},processStatus:{type:String,default:'process'}},data:function data(){return{steps:[],stepOffset:0};},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'center':'center is removed.'}};}},watch:{active:function active(newVal,oldVal){this.$emit('change',newVal,oldVal);},steps:function steps(_steps){_steps.forEach(function(child,index){child.index=index;});}}};// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
/* harmony default export */var src_stepsvue_type_script_lang_js_=stepsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/steps/src/steps.vue
/* normalize component */var steps_component=normalizeComponent(src_stepsvue_type_script_lang_js_,stepsvue_type_template_id_3c6b6dc0_render,stepsvue_type_template_id_3c6b6dc0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var steps_api;}steps_component.options.__file="packages/steps/src/steps.vue";/* harmony default export */var steps=steps_component.exports;// CONCATENATED MODULE: ./packages/steps/index.js
/* istanbul ignore next */steps.install=function(Vue){Vue.component(steps.name,steps);};/* harmony default export */var packages_steps=steps;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
var stepvue_type_template_id_f414a87a_render=function stepvue_type_template_id_f414a87a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-step",class:[!_vm.isSimple&&"is-"+_vm.$parent.direction,_vm.isSimple&&"is-simple",_vm.isLast&&!_vm.space&&!_vm.isCenter&&"is-flex",_vm.isCenter&&!_vm.isVertical&&!_vm.isSimple&&"is-center"],style:_vm.style},[_c("div",{staticClass:"el-step__head",class:"is-"+_vm.currentStatus},[_c("div",{staticClass:"el-step__line",style:_vm.isLast?"":{marginRight:_vm.$parent.stepOffset+"px"}},[_c("i",{staticClass:"el-step__line-inner",style:_vm.lineStyle})]),_c("div",{staticClass:"el-step__icon",class:"is-"+(_vm.icon?"icon":"text")},[_vm.currentStatus!=="success"&&_vm.currentStatus!=="error"?_vm._t("icon",[_vm.icon?_c("i",{staticClass:"el-step__icon-inner",class:[_vm.icon]}):_vm._e(),!_vm.icon&&!_vm.isSimple?_c("div",{staticClass:"el-step__icon-inner"},[_vm._v(_vm._s(_vm.index+1))]):_vm._e()]):_c("i",{staticClass:"el-step__icon-inner is-status",class:["el-icon-"+(_vm.currentStatus==="success"?"check":"close")]})],2)]),_c("div",{staticClass:"el-step__main"},[_c("div",{ref:"title",staticClass:"el-step__title",class:["is-"+_vm.currentStatus]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm.isSimple?_c("div",{staticClass:"el-step__arrow"}):_c("div",{staticClass:"el-step__description",class:["is-"+_vm.currentStatus]},[_vm._t("description",[_vm._v(_vm._s(_vm.description))])],2)])]);};var stepvue_type_template_id_f414a87a_staticRenderFns=[];stepvue_type_template_id_f414a87a_render._withStripped=true;// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var stepvue_type_script_lang_js_={name:'ElStep',props:{title:String,icon:String,description:String,status:String},data:function data(){return{index:-1,lineStyle:{},internalStatus:''};},beforeCreate:function beforeCreate(){this.$parent.steps.push(this);},beforeDestroy:function beforeDestroy(){var steps=this.$parent.steps;var index=steps.indexOf(this);if(index>=0){steps.splice(index,1);}},computed:{currentStatus:function currentStatus(){return this.status||this.internalStatus;},prevStatus:function prevStatus(){var prevStep=this.$parent.steps[this.index-1];return prevStep?prevStep.currentStatus:'wait';},isCenter:function isCenter(){return this.$parent.alignCenter;},isVertical:function isVertical(){return this.$parent.direction==='vertical';},isSimple:function isSimple(){return this.$parent.simple;},isLast:function isLast(){var parent=this.$parent;return parent.steps[parent.steps.length-1]===this;},stepsCount:function stepsCount(){return this.$parent.steps.length;},space:function space(){var isSimple=this.isSimple,space=this.$parent.space;return isSimple?'':space;},style:function style(){var style={};var parent=this.$parent;var len=parent.steps.length;var space=typeof this.space==='number'?this.space+'px':this.space?this.space:100/(len-(this.isCenter?0:1))+'%';style.flexBasis=space;if(this.isVertical)return style;if(this.isLast){style.maxWidth=100/this.stepsCount+'%';}else{style.marginRight=-this.$parent.stepOffset+'px';}return style;}},methods:{updateStatus:function updateStatus(val){var prevChild=this.$parent.$children[this.index-1];if(val>this.index){this.internalStatus=this.$parent.finishStatus;}else if(val===this.index&&this.prevStatus!=='error'){this.internalStatus=this.$parent.processStatus;}else{this.internalStatus='wait';}if(prevChild)prevChild.calcProgress(this.internalStatus);},calcProgress:function calcProgress(status){var step=100;var style={};style.transitionDelay=150*this.index+'ms';if(status===this.$parent.processStatus){step=this.currentStatus!=='error'?0:0;}else if(status==='wait'){step=0;style.transitionDelay=-150*this.index+'ms';}style.borderWidth=step&&!this.isSimple?'1px':0;this.$parent.direction==='vertical'?style.height=step+'%':style.width=step+'%';this.lineStyle=style;}},mounted:function mounted(){var _this=this;var unwatch=this.$watch('index',function(val){_this.$watch('$parent.active',_this.updateStatus,{immediate:true});_this.$watch('$parent.processStatus',function(){var activeIndex=_this.$parent.active;_this.updateStatus(activeIndex);},{immediate:true});unwatch();});}};// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
/* harmony default export */var src_stepvue_type_script_lang_js_=stepvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/steps/src/step.vue
/* normalize component */var step_component=normalizeComponent(src_stepvue_type_script_lang_js_,stepvue_type_template_id_f414a87a_render,stepvue_type_template_id_f414a87a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var step_api;}step_component.options.__file="packages/steps/src/step.vue";/* harmony default export */var step=step_component.exports;// CONCATENATED MODULE: ./packages/step/index.js
/* istanbul ignore next */step.install=function(Vue){Vue.component(step.name,step);};/* harmony default export */var packages_step=step;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
var mainvue_type_template_id_5d5d1482_render=function mainvue_type_template_id_5d5d1482_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:_vm.carouselClasses,on:{mouseenter:function mouseenter($event){$event.stopPropagation();return _vm.handleMouseEnter($event);},mouseleave:function mouseleave($event){$event.stopPropagation();return _vm.handleMouseLeave($event);}}},[_c("div",{staticClass:"el-carousel__container",style:{height:_vm.height}},[_vm.arrowDisplay?_c("transition",{attrs:{name:"carousel-arrow-left"}},[_c("button",{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow==="always"||_vm.hover)&&(_vm.loop||_vm.activeIndex>0),expression:"(arrow === 'always' || hover) && (loop || activeIndex > 0)"}],staticClass:"el-carousel__arrow el-carousel__arrow--left",attrs:{type:"button"},on:{mouseenter:function mouseenter($event){_vm.handleButtonEnter("left");},mouseleave:_vm.handleButtonLeave,click:function click($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex-1);}}},[_c("i",{staticClass:"el-icon-arrow-left"})])]):_vm._e(),_vm.arrowDisplay?_c("transition",{attrs:{name:"carousel-arrow-right"}},[_c("button",{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow==="always"||_vm.hover)&&(_vm.loop||_vm.activeIndex<_vm.items.length-1),expression:"(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"}],staticClass:"el-carousel__arrow el-carousel__arrow--right",attrs:{type:"button"},on:{mouseenter:function mouseenter($event){_vm.handleButtonEnter("right");},mouseleave:_vm.handleButtonLeave,click:function click($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex+1);}}},[_c("i",{staticClass:"el-icon-arrow-right"})])]):_vm._e(),_vm._t("default")],2),_vm.indicatorPosition!=="none"?_c("ul",{class:_vm.indicatorsClasses},_vm._l(_vm.items,function(item,index){return _c("li",{key:index,class:["el-carousel__indicator","el-carousel__indicator--"+_vm.direction,{"is-active":index===_vm.activeIndex}],on:{mouseenter:function mouseenter($event){_vm.throttledIndicatorHover(index);},click:function click($event){$event.stopPropagation();_vm.handleIndicatorClick(index);}}},[_c("button",{staticClass:"el-carousel__button"},[_vm.hasLabel?_c("span",[_vm._v(_vm._s(item.label))]):_vm._e()])]);}),0):_vm._e()]);};var mainvue_type_template_id_5d5d1482_staticRenderFns=[];mainvue_type_template_id_5d5d1482_render._withStripped=true;// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
// EXTERNAL MODULE: external "throttle-debounce/throttle"
var throttle_=__webpack_require__(25);var throttle_default=/*#__PURE__*/__webpack_require__.n(throttle_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var carousel_src_mainvue_type_script_lang_js_={name:'ElCarousel',props:{initialIndex:{type:Number,default:0},height:String,trigger:{type:String,default:'hover'},autoplay:{type:Boolean,default:true},interval:{type:Number,default:3000},indicatorPosition:String,indicator:{type:Boolean,default:true},arrow:{type:String,default:'hover'},type:String,loop:{type:Boolean,default:true},direction:{type:String,default:'horizontal',validator:function validator(val){return['horizontal','vertical'].indexOf(val)!==-1;}}},data:function data(){return{items:[],activeIndex:-1,containerWidth:0,timer:null,hover:false};},computed:{arrowDisplay:function arrowDisplay(){return this.arrow!=='never'&&this.direction!=='vertical';},hasLabel:function hasLabel(){return this.items.some(function(item){return item.label.toString().length>0;});},carouselClasses:function carouselClasses(){var classes=['el-carousel','el-carousel--'+this.direction];if(this.type==='card'){classes.push('el-carousel--card');}return classes;},indicatorsClasses:function indicatorsClasses(){var classes=['el-carousel__indicators','el-carousel__indicators--'+this.direction];if(this.hasLabel){classes.push('el-carousel__indicators--labels');}if(this.indicatorPosition==='outside'||this.type==='card'){classes.push('el-carousel__indicators--outside');}return classes;}},watch:{items:function items(val){if(val.length>0)this.setActiveItem(this.initialIndex);},activeIndex:function activeIndex(val,oldVal){this.resetItemPosition(oldVal);if(oldVal>-1){this.$emit('change',val,oldVal);}},autoplay:function autoplay(val){val?this.startTimer():this.pauseTimer();},loop:function loop(){this.setActiveItem(this.activeIndex);},interval:function interval(){this.pauseTimer();this.startTimer();}},methods:{handleMouseEnter:function handleMouseEnter(){this.hover=true;this.pauseTimer();},handleMouseLeave:function handleMouseLeave(){this.hover=false;this.startTimer();},itemInStage:function itemInStage(item,index){var length=this.items.length;if(index===length-1&&item.inStage&&this.items[0].active||item.inStage&&this.items[index+1]&&this.items[index+1].active){return'left';}else if(index===0&&item.inStage&&this.items[length-1].active||item.inStage&&this.items[index-1]&&this.items[index-1].active){return'right';}return false;},handleButtonEnter:function handleButtonEnter(arrow){var _this=this;if(this.direction==='vertical')return;this.items.forEach(function(item,index){if(arrow===_this.itemInStage(item,index)){item.hover=true;}});},handleButtonLeave:function handleButtonLeave(){if(this.direction==='vertical')return;this.items.forEach(function(item){item.hover=false;});},updateItems:function updateItems(){this.items=this.$children.filter(function(child){return child.$options.name==='ElCarouselItem';});},resetItemPosition:function resetItemPosition(oldIndex){var _this2=this;this.items.forEach(function(item,index){item.translateItem(index,_this2.activeIndex,oldIndex);});},playSlides:function playSlides(){if(this.activeIndex<this.items.length-1){this.activeIndex++;}else if(this.loop){this.activeIndex=0;}},pauseTimer:function pauseTimer(){if(this.timer){clearInterval(this.timer);this.timer=null;}},startTimer:function startTimer(){if(this.interval<=0||!this.autoplay||this.timer)return;this.timer=setInterval(this.playSlides,this.interval);},resetTimer:function resetTimer(){this.pauseTimer();this.startTimer();},setActiveItem:function setActiveItem(index){if(typeof index==='string'){var filteredItems=this.items.filter(function(item){return item.name===index;});if(filteredItems.length>0){index=this.items.indexOf(filteredItems[0]);}}index=Number(index);if(isNaN(index)||index!==Math.floor(index)){console.warn('[Element Warn][Carousel]index must be an integer.');return;}var length=this.items.length;var oldIndex=this.activeIndex;if(index<0){this.activeIndex=this.loop?length-1:0;}else if(index>=length){this.activeIndex=this.loop?0:length-1;}else{this.activeIndex=index;}if(oldIndex===this.activeIndex){this.resetItemPosition(oldIndex);}this.resetTimer();},prev:function prev(){this.setActiveItem(this.activeIndex-1);},next:function next(){this.setActiveItem(this.activeIndex+1);},handleIndicatorClick:function handleIndicatorClick(index){this.activeIndex=index;},handleIndicatorHover:function handleIndicatorHover(index){if(this.trigger==='hover'&&index!==this.activeIndex){this.activeIndex=index;}}},created:function created(){var _this3=this;this.throttledArrowClick=throttle_default()(300,true,function(index){_this3.setActiveItem(index);});this.throttledIndicatorHover=throttle_default()(300,function(index){_this3.handleIndicatorHover(index);});},mounted:function mounted(){var _this4=this;this.updateItems();this.$nextTick(function(){Object(resize_event_["addResizeListener"])(_this4.$el,_this4.resetItemPosition);if(_this4.initialIndex<_this4.items.length&&_this4.initialIndex>=0){_this4.activeIndex=_this4.initialIndex;}_this4.startTimer();});},beforeDestroy:function beforeDestroy(){if(this.$el)Object(resize_event_["removeResizeListener"])(this.$el,this.resetItemPosition);this.pauseTimer();}};// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_carousel_src_mainvue_type_script_lang_js_=carousel_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/carousel/src/main.vue
/* normalize component */var carousel_src_main_component=normalizeComponent(packages_carousel_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5d5d1482_render,mainvue_type_template_id_5d5d1482_staticRenderFns,false,null,null,null);/* hot reload */if(false){var carousel_src_main_api;}carousel_src_main_component.options.__file="packages/carousel/src/main.vue";/* harmony default export */var carousel_src_main=carousel_src_main_component.exports;// CONCATENATED MODULE: ./packages/carousel/index.js
/* istanbul ignore next */carousel_src_main.install=function(Vue){Vue.component(carousel_src_main.name,carousel_src_main);};/* harmony default export */var carousel=carousel_src_main;// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
var BAR_MAP={vertical:{offset:'offsetHeight',scroll:'scrollTop',scrollSize:'scrollHeight',size:'height',key:'vertical',axis:'Y',client:'clientY',direction:'top'},horizontal:{offset:'offsetWidth',scroll:'scrollLeft',scrollSize:'scrollWidth',size:'width',key:'horizontal',axis:'X',client:'clientX',direction:'left'}};function renderThumbStyle(_ref){var move=_ref.move,size=_ref.size,bar=_ref.bar;var style={};var translate='translate'+bar.axis+'('+move+'%)';style[bar.size]=size;style.transform=translate;style.msTransform=translate;style.webkitTransform=translate;return style;};// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
/* istanbul ignore next *//* harmony default export */var src_bar={name:'Bar',props:{vertical:Boolean,size:String,move:Number},computed:{bar:function bar(){return BAR_MAP[this.vertical?'vertical':'horizontal'];},wrap:function wrap(){return this.$parent.wrap;}},render:function render(h){var size=this.size,move=this.move,bar=this.bar;return h('div',{'class':['el-scrollbar__bar','is-'+bar.key],on:{'mousedown':this.clickTrackHandler}},[h('div',{ref:'thumb','class':'el-scrollbar__thumb',on:{'mousedown':this.clickThumbHandler},style:renderThumbStyle({size:size,move:move,bar:bar})})]);},methods:{clickThumbHandler:function clickThumbHandler(e){// prevent click event of right button
if(e.ctrlKey||e.button===2){return;}this.startDrag(e);this[this.bar.axis]=e.currentTarget[this.bar.offset]-(e[this.bar.client]-e.currentTarget.getBoundingClientRect()[this.bar.direction]);},clickTrackHandler:function clickTrackHandler(e){var offset=Math.abs(e.target.getBoundingClientRect()[this.bar.direction]-e[this.bar.client]);var thumbHalf=this.$refs.thumb[this.bar.offset]/2;var thumbPositionPercentage=(offset-thumbHalf)*100/this.$el[this.bar.offset];this.wrap[this.bar.scroll]=thumbPositionPercentage*this.wrap[this.bar.scrollSize]/100;},startDrag:function startDrag(e){e.stopImmediatePropagation();this.cursorDown=true;Object(dom_["on"])(document,'mousemove',this.mouseMoveDocumentHandler);Object(dom_["on"])(document,'mouseup',this.mouseUpDocumentHandler);document.onselectstart=function(){return false;};},mouseMoveDocumentHandler:function mouseMoveDocumentHandler(e){if(this.cursorDown===false)return;var prevPage=this[this.bar.axis];if(!prevPage)return;var offset=(this.$el.getBoundingClientRect()[this.bar.direction]-e[this.bar.client])*-1;var thumbClickPosition=this.$refs.thumb[this.bar.offset]-prevPage;var thumbPositionPercentage=(offset-thumbClickPosition)*100/this.$el[this.bar.offset];this.wrap[this.bar.scroll]=thumbPositionPercentage*this.wrap[this.bar.scrollSize]/100;},mouseUpDocumentHandler:function mouseUpDocumentHandler(e){this.cursorDown=false;this[this.bar.axis]=0;Object(dom_["off"])(document,'mousemove',this.mouseMoveDocumentHandler);document.onselectstart=null;}},destroyed:function destroyed(){Object(dom_["off"])(document,'mouseup',this.mouseUpDocumentHandler);}};// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
/* istanbul ignore next *//* harmony default export */var scrollbar_src_main={name:'ElScrollbar',components:{Bar:src_bar},props:{native:Boolean,wrapStyle:{},wrapClass:{},viewClass:{},viewStyle:{},noresize:Boolean,// 如果 container 尺寸不会发生变化，最好设置它可以优化性能
tag:{type:String,default:'div'}},data:function data(){return{sizeWidth:'0',sizeHeight:'0',moveX:0,moveY:0};},computed:{wrap:function wrap(){return this.$refs.wrap;}},render:function render(h){var gutter=scrollbar_width_default()();var style=this.wrapStyle;if(gutter){var gutterWith='-'+gutter+'px';var gutterStyle='margin-bottom: '+gutterWith+'; margin-right: '+gutterWith+';';if(Array.isArray(this.wrapStyle)){style=Object(util_["toObject"])(this.wrapStyle);style.marginRight=style.marginBottom=gutterWith;}else if(typeof this.wrapStyle==='string'){style+=gutterStyle;}else{style=gutterStyle;}}var view=h(this.tag,{class:['el-scrollbar__view',this.viewClass],style:this.viewStyle,ref:'resize'},this.$slots.default);var wrap=h('div',{ref:'wrap',style:style,on:{'scroll':this.handleScroll},'class':[this.wrapClass,'el-scrollbar__wrap',gutter?'':'el-scrollbar__wrap--hidden-default']},[[view]]);var nodes=void 0;if(!this.native){nodes=[wrap,h(src_bar,{attrs:{move:this.moveX,size:this.sizeWidth}}),h(src_bar,{attrs:{vertical:true,move:this.moveY,size:this.sizeHeight}})];}else{nodes=[h('div',{ref:'wrap','class':[this.wrapClass,'el-scrollbar__wrap'],style:style},[[view]])];}return h('div',{class:'el-scrollbar'},nodes);},methods:{handleScroll:function handleScroll(){var wrap=this.wrap;this.moveY=wrap.scrollTop*100/wrap.clientHeight;this.moveX=wrap.scrollLeft*100/wrap.clientWidth;},update:function update(){var heightPercentage=void 0,widthPercentage=void 0;var wrap=this.wrap;if(!wrap)return;heightPercentage=wrap.clientHeight*100/wrap.scrollHeight;widthPercentage=wrap.clientWidth*100/wrap.scrollWidth;this.sizeHeight=heightPercentage<100?heightPercentage+'%':'';this.sizeWidth=widthPercentage<100?widthPercentage+'%':'';}},mounted:function mounted(){if(this.native)return;this.$nextTick(this.update);!this.noresize&&Object(resize_event_["addResizeListener"])(this.$refs.resize,this.update);},beforeDestroy:function beforeDestroy(){if(this.native)return;!this.noresize&&Object(resize_event_["removeResizeListener"])(this.$refs.resize,this.update);}};// CONCATENATED MODULE: ./packages/scrollbar/index.js
/* istanbul ignore next */scrollbar_src_main.install=function(Vue){Vue.component(scrollbar_src_main.name,scrollbar_src_main);};/* harmony default export */var scrollbar=scrollbar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
var itemvue_type_template_id_1801ae19_render=function itemvue_type_template_id_1801ae19_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.ready,expression:"ready"}],staticClass:"el-carousel__item",class:{"is-active":_vm.active,"el-carousel__item--card":_vm.$parent.type==="card","is-in-stage":_vm.inStage,"is-hover":_vm.hover,"is-animating":_vm.animating},style:_vm.itemStyle,on:{click:_vm.handleItemClick}},[_vm.$parent.type==="card"?_c("div",{directives:[{name:"show",rawName:"v-show",value:!_vm.active,expression:"!active"}],staticClass:"el-carousel__mask"}):_vm._e(),_vm._t("default")],2);};var itemvue_type_template_id_1801ae19_staticRenderFns=[];itemvue_type_template_id_1801ae19_render._withStripped=true;// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var CARD_SCALE=0.83;/* harmony default export */var itemvue_type_script_lang_js_={name:'ElCarouselItem',props:{name:String,label:{type:[String,Number],default:''}},data:function data(){return{hover:false,translate:0,scale:1,active:false,ready:false,inStage:false,animating:false};},methods:{processIndex:function processIndex(index,activeIndex,length){if(activeIndex===0&&index===length-1){return-1;}else if(activeIndex===length-1&&index===0){return length;}else if(index<activeIndex-1&&activeIndex-index>=length/2){return length+1;}else if(index>activeIndex+1&&index-activeIndex>=length/2){return-2;}return index;},calcCardTranslate:function calcCardTranslate(index,activeIndex){var parentWidth=this.$parent.$el.offsetWidth;if(this.inStage){return parentWidth*((2-CARD_SCALE)*(index-activeIndex)+1)/4;}else if(index<activeIndex){return-(1+CARD_SCALE)*parentWidth/4;}else{return(3+CARD_SCALE)*parentWidth/4;}},calcTranslate:function calcTranslate(index,activeIndex,isVertical){var distance=this.$parent.$el[isVertical?'offsetHeight':'offsetWidth'];return distance*(index-activeIndex);},translateItem:function translateItem(index,activeIndex,oldIndex){var parentType=this.$parent.type;var parentDirection=this.parentDirection;var length=this.$parent.items.length;if(parentType!=='card'&&oldIndex!==undefined){this.animating=index===activeIndex||index===oldIndex;}if(index!==activeIndex&&length>2&&this.$parent.loop){index=this.processIndex(index,activeIndex,length);}if(parentType==='card'){if(parentDirection==='vertical'){console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');}this.inStage=Math.round(Math.abs(index-activeIndex))<=1;this.active=index===activeIndex;this.translate=this.calcCardTranslate(index,activeIndex);this.scale=this.active?1:CARD_SCALE;}else{this.active=index===activeIndex;var isVertical=parentDirection==='vertical';this.translate=this.calcTranslate(index,activeIndex,isVertical);this.scale=1;}this.ready=true;},handleItemClick:function handleItemClick(){var parent=this.$parent;if(parent&&parent.type==='card'){var index=parent.items.indexOf(this);parent.setActiveItem(index);}}},computed:{parentDirection:function parentDirection(){return this.$parent.direction;},itemStyle:function itemStyle(){var translateType=this.parentDirection==='vertical'?'translateY':'translateX';var value=translateType+'('+this.translate+'px) scale('+this.scale+')';var style={transform:value};return Object(util_["autoprefixer"])(style);}},created:function created(){this.$parent&&this.$parent.updateItems();},destroyed:function destroyed(){this.$parent&&this.$parent.updateItems();}};// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var src_itemvue_type_script_lang_js_=itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/carousel/src/item.vue
/* normalize component */var item_component=normalizeComponent(src_itemvue_type_script_lang_js_,itemvue_type_template_id_1801ae19_render,itemvue_type_template_id_1801ae19_staticRenderFns,false,null,null,null);/* hot reload */if(false){var item_api;}item_component.options.__file="packages/carousel/src/item.vue";/* harmony default export */var src_item=item_component.exports;// CONCATENATED MODULE: ./packages/carousel-item/index.js
/* istanbul ignore next */src_item.install=function(Vue){Vue.component(src_item.name,src_item);};/* harmony default export */var carousel_item=src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
var collapsevue_type_template_id_461d57f4_render=function collapsevue_type_template_id_461d57f4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-collapse",attrs:{role:"tablist","aria-multiselectable":"true"}},[_vm._t("default")],2);};var collapsevue_type_template_id_461d57f4_staticRenderFns=[];collapsevue_type_template_id_461d57f4_render._withStripped=true;// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var collapsevue_type_script_lang_js_={name:'ElCollapse',componentName:'ElCollapse',props:{accordion:Boolean,value:{type:[Array,String,Number],default:function _default(){return[];}}},data:function data(){return{activeNames:[].concat(this.value)};},provide:function provide(){return{collapse:this};},watch:{value:function value(_value){this.activeNames=[].concat(_value);}},methods:{setActiveNames:function setActiveNames(activeNames){activeNames=[].concat(activeNames);var value=this.accordion?activeNames[0]:activeNames;this.activeNames=activeNames;this.$emit('input',value);this.$emit('change',value);},handleItemClick:function handleItemClick(item){if(this.accordion){this.setActiveNames((this.activeNames[0]||this.activeNames[0]===0)&&this.activeNames[0]===item.name?'':item.name);}else{var activeNames=this.activeNames.slice(0);var index=activeNames.indexOf(item.name);if(index>-1){activeNames.splice(index,1);}else{activeNames.push(item.name);}this.setActiveNames(activeNames);}}},created:function created(){this.$on('item-click',this.handleItemClick);}};// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
/* harmony default export */var src_collapsevue_type_script_lang_js_=collapsevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
/* normalize component */var collapse_component=normalizeComponent(src_collapsevue_type_script_lang_js_,collapsevue_type_template_id_461d57f4_render,collapsevue_type_template_id_461d57f4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var collapse_api;}collapse_component.options.__file="packages/collapse/src/collapse.vue";/* harmony default export */var collapse=collapse_component.exports;// CONCATENATED MODULE: ./packages/collapse/index.js
/* istanbul ignore next */collapse.install=function(Vue){Vue.component(collapse.name,collapse);};/* harmony default export */var packages_collapse=collapse;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
var collapse_itemvue_type_template_id_2d05faac_render=function collapse_itemvue_type_template_id_2d05faac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-collapse-item",class:{"is-active":_vm.isActive,"is-disabled":_vm.disabled}},[_c("div",{attrs:{role:"tab","aria-expanded":_vm.isActive,"aria-controls":"el-collapse-content-"+_vm.id,"aria-describedby":"el-collapse-content-"+_vm.id}},[_c("div",{staticClass:"el-collapse-item__header",class:{focusing:_vm.focusing,"is-active":_vm.isActive},attrs:{role:"button",id:"el-collapse-head-"+_vm.id,tabindex:_vm.disabled?undefined:0},on:{click:_vm.handleHeaderClick,keyup:function keyup($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.stopPropagation();return _vm.handleEnterClick($event);},focus:_vm.handleFocus,blur:function blur($event){_vm.focusing=false;}}},[_vm._t("title",[_vm._v(_vm._s(_vm.title))]),_c("i",{staticClass:"el-collapse-item__arrow el-icon-arrow-right",class:{"is-active":_vm.isActive}})],2)]),_c("el-collapse-transition",[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.isActive,expression:"isActive"}],staticClass:"el-collapse-item__wrap",attrs:{role:"tabpanel","aria-hidden":!_vm.isActive,"aria-labelledby":"el-collapse-head-"+_vm.id,id:"el-collapse-content-"+_vm.id}},[_c("div",{staticClass:"el-collapse-item__content"},[_vm._t("default")],2)])])],1);};var collapse_itemvue_type_template_id_2d05faac_staticRenderFns=[];collapse_itemvue_type_template_id_2d05faac_render._withStripped=true;// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var collapse_itemvue_type_script_lang_js_={name:'ElCollapseItem',componentName:'ElCollapseItem',mixins:[emitter_default.a],components:{ElCollapseTransition:collapse_transition_default.a},data:function data(){return{contentWrapStyle:{height:'auto',display:'block'},contentHeight:0,focusing:false,isClick:false,id:Object(util_["generateId"])()};},inject:['collapse'],props:{title:String,name:{type:[String,Number],default:function _default(){return this._uid;}},disabled:Boolean},computed:{isActive:function isActive(){return this.collapse.activeNames.indexOf(this.name)>-1;}},methods:{handleFocus:function handleFocus(){var _this=this;setTimeout(function(){if(!_this.isClick){_this.focusing=true;}else{_this.isClick=false;}},50);},handleHeaderClick:function handleHeaderClick(){if(this.disabled)return;this.dispatch('ElCollapse','item-click',this);this.focusing=false;this.isClick=true;},handleEnterClick:function handleEnterClick(){this.dispatch('ElCollapse','item-click',this);}}};// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_collapse_itemvue_type_script_lang_js_=collapse_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
/* normalize component */var collapse_item_component=normalizeComponent(src_collapse_itemvue_type_script_lang_js_,collapse_itemvue_type_template_id_2d05faac_render,collapse_itemvue_type_template_id_2d05faac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var collapse_item_api;}collapse_item_component.options.__file="packages/collapse/src/collapse-item.vue";/* harmony default export */var collapse_item=collapse_item_component.exports;// CONCATENATED MODULE: ./packages/collapse-item/index.js
/* istanbul ignore next */collapse_item.install=function(Vue){Vue.component(collapse_item.name,collapse_item);};/* harmony default export */var packages_collapse_item=collapse_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
var cascadervue_type_template_id_032537a6_render=function cascadervue_type_template_id_032537a6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:function value(){return _vm.toggleDropDownVisible(false);},expression:"() => toggleDropDownVisible(false)"}],ref:"reference",class:["el-cascader",_vm.realSize&&"el-cascader--"+_vm.realSize,{"is-disabled":_vm.isDisabled}],on:{mouseenter:function mouseenter($event){_vm.inputHover=true;},mouseleave:function mouseleave($event){_vm.inputHover=false;},click:function click(){return _vm.toggleDropDownVisible(_vm.readonly?undefined:true);},keydown:_vm.handleKeyDown}},[_c("el-input",{ref:"input",class:{"is-focus":_vm.dropDownVisible},attrs:{size:_vm.realSize,placeholder:_vm.placeholder,readonly:_vm.readonly,disabled:_vm.isDisabled,"validate-event":false},on:{focus:_vm.handleFocus,blur:_vm.handleBlur,input:_vm.handleInput},model:{value:_vm.multiple?_vm.presentText:_vm.inputValue,callback:function callback($$v){_vm.multiple?_vm.presentText:_vm.inputValue=$$v;},expression:"multiple ? presentText : inputValue"}},[_c("template",{slot:"suffix"},[_vm.clearBtnVisible?_c("i",{key:"clear",staticClass:"el-input__icon el-icon-circle-close",on:{click:function click($event){$event.stopPropagation();return _vm.handleClear($event);}}}):_c("i",{key:"arrow-down",class:["el-input__icon","el-icon-arrow-down",_vm.dropDownVisible&&"is-reverse"],on:{click:function click($event){$event.stopPropagation();_vm.toggleDropDownVisible();}}})])],2),_vm.multiple?_c("div",{staticClass:"el-cascader__tags"},[_vm._l(_vm.presentTags,function(tag){return _c("el-tag",{key:tag.key,attrs:{type:"info",size:_vm.tagSize,hit:tag.hitState,closable:tag.closable,"disable-transitions":""},on:{close:function close($event){_vm.deleteTag(tag);}}},[_c("span",[_vm._v(_vm._s(tag.text))])]);}),_vm.filterable&&!_vm.isDisabled?_c("input",{directives:[{name:"model",rawName:"v-model.trim",value:_vm.inputValue,expression:"inputValue",modifiers:{trim:true}}],staticClass:"el-cascader__search-input",attrs:{type:"text",placeholder:_vm.presentTags.length?"":_vm.placeholder},domProps:{value:_vm.inputValue},on:{input:[function($event){if($event.target.composing){return;}_vm.inputValue=$event.target.value.trim();},function(e){return _vm.handleInput(_vm.inputValue,e);}],click:function click($event){$event.stopPropagation();_vm.toggleDropDownVisible(true);},keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}return _vm.handleDelete($event);},blur:function blur($event){_vm.$forceUpdate();}}}):_vm._e()],2):_vm._e(),_c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.handleDropdownLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.dropDownVisible,expression:"dropDownVisible"}],ref:"popper",class:["el-popper","el-cascader__dropdown",_vm.popperClass]},[_c("el-cascader-panel",{directives:[{name:"show",rawName:"v-show",value:!_vm.filtering,expression:"!filtering"}],ref:"panel",attrs:{options:_vm.options,props:_vm.config,border:false,"render-label":_vm.$scopedSlots.default},on:{"expand-change":_vm.handleExpandChange,close:function close($event){_vm.toggleDropDownVisible(false);}},model:{value:_vm.checkedValue,callback:function callback($$v){_vm.checkedValue=$$v;},expression:"checkedValue"}}),_vm.filterable?_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.filtering,expression:"filtering"}],ref:"suggestionPanel",staticClass:"el-cascader__suggestion-panel",attrs:{tag:"ul","view-class":"el-cascader__suggestion-list"},nativeOn:{keydown:function keydown($event){return _vm.handleSuggestionKeyDown($event);}}},[_vm.suggestions.length?_vm._l(_vm.suggestions,function(item,index){return _c("li",{key:item.uid,class:["el-cascader__suggestion-item",item.checked&&"is-checked"],attrs:{tabindex:-1},on:{click:function click($event){_vm.handleSuggestionClick(index);}}},[_c("span",[_vm._v(_vm._s(item.text))]),item.checked?_c("i",{staticClass:"el-icon-check"}):_vm._e()]);}):_vm._t("empty",[_c("li",{staticClass:"el-cascader__empty-text"},[_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))])])],2):_vm._e()],1)])],1);};var cascadervue_type_template_id_032537a6_staticRenderFns=[];cascadervue_type_template_id_032537a6_render._withStripped=true;// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
var cascader_panel_=__webpack_require__(43);var cascader_panel_default=/*#__PURE__*/__webpack_require__.n(cascader_panel_);// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
var aria_utils_=__webpack_require__(35);var aria_utils_default=/*#__PURE__*/__webpack_require__.n(aria_utils_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var KeyCode=aria_utils_default.a.keys;var MigratingProps={expandTrigger:{newProp:'expandTrigger',type:String},changeOnSelect:{newProp:'checkStrictly',type:Boolean},hoverThreshold:{newProp:'hoverThreshold',type:Number}};var PopperMixin={props:{placement:{type:String,default:'bottom-start'},appendToBody:vue_popper_default.a.props.appendToBody,visibleArrow:{type:Boolean,default:true},arrowOffset:vue_popper_default.a.props.arrowOffset,offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,popperOptions:vue_popper_default.a.props.popperOptions,transformOrigin:vue_popper_default.a.props.transformOrigin},methods:vue_popper_default.a.methods,data:vue_popper_default.a.data,beforeDestroy:vue_popper_default.a.beforeDestroy};var InputSizeMap={medium:36,small:32,mini:28};/* harmony default export */var cascadervue_type_script_lang_js_={name:'ElCascader',directives:{Clickoutside:clickoutside_default.a},mixins:[PopperMixin,emitter_default.a,locale_default.a,migrating_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},components:{ElInput:input_default.a,ElTag:tag_default.a,ElScrollbar:scrollbar_default.a,ElCascaderPanel:cascader_panel_default.a},props:{value:{},options:Array,props:Object,size:String,placeholder:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.cascader.placeholder');}},disabled:Boolean,clearable:Boolean,filterable:Boolean,filterMethod:Function,separator:{type:String,default:' / '},showAllLevels:{type:Boolean,default:true},collapseTags:Boolean,debounce:{type:Number,default:300},beforeFilter:{type:Function,default:function _default(){return function(){};}},popperClass:String},data:function data(){return{dropDownVisible:false,checkedValue:this.value,inputHover:false,inputValue:null,presentText:null,presentTags:[],checkedNodes:[],filtering:false,suggestions:[],inputInitialHeight:0,pressDeleteCount:0};},computed:{realSize:function realSize(){var _elFormItemSize=(this.elFormItem||{}).elFormItemSize;return this.size||_elFormItemSize||(this.$ELEMENT||{}).size;},tagSize:function tagSize(){return['small','mini'].indexOf(this.realSize)>-1?'mini':'small';},isDisabled:function isDisabled(){return this.disabled||(this.elForm||{}).disabled;},config:function config(){var config=this.props||{};var $attrs=this.$attrs;Object.keys(MigratingProps).forEach(function(oldProp){var _MigratingProps$oldPr=MigratingProps[oldProp],newProp=_MigratingProps$oldPr.newProp,type=_MigratingProps$oldPr.type;var oldValue=$attrs[oldProp]||$attrs[Object(util_["kebabCase"])(oldProp)];if(Object(shared_["isDef"])(oldProp)&&!Object(shared_["isDef"])(config[newProp])){if(type===Boolean&&oldValue===''){oldValue=true;}config[newProp]=oldValue;}});return config;},multiple:function multiple(){return this.config.multiple;},leafOnly:function leafOnly(){return!this.config.checkStrictly;},readonly:function readonly(){return!this.filterable||this.multiple;},clearBtnVisible:function clearBtnVisible(){if(!this.clearable||this.isDisabled||this.filtering||!this.inputHover){return false;}return this.multiple?!!this.checkedNodes.filter(function(node){return!node.isDisabled;}).length:!!this.presentText;},panel:function panel(){return this.$refs.panel;}},watch:{disabled:function disabled(){this.computePresentContent();},value:function value(val){if(!Object(util_["isEqual"])(val,this.checkedValue)){this.checkedValue=val;this.computePresentContent();}},checkedValue:function checkedValue(val){var value=this.value,dropDownVisible=this.dropDownVisible;var _config=this.config,checkStrictly=_config.checkStrictly,multiple=_config.multiple;if(!Object(util_["isEqual"])(val,value)||Object(types_["isUndefined"])(value)){this.computePresentContent();// hide dropdown when single mode
if(!multiple&&!checkStrictly&&dropDownVisible){this.toggleDropDownVisible(false);}this.$emit('input',val);this.$emit('change',val);this.dispatch('ElFormItem','el.form.change',[val]);}},options:{handler:function handler(){this.$nextTick(this.computePresentContent);},deep:true},presentText:function presentText(val){this.inputValue=val;},presentTags:function presentTags(val,oldVal){if(this.multiple&&(val.length||oldVal.length)){this.$nextTick(this.updateStyle);}},filtering:function filtering(val){this.$nextTick(this.updatePopper);}},mounted:function mounted(){var _this=this;var input=this.$refs.input;if(input&&input.$el){this.inputInitialHeight=input.$el.offsetHeight||InputSizeMap[this.realSize]||40;}if(!this.isEmptyValue(this.value)){this.computePresentContent();}this.filterHandler=debounce_default()(this.debounce,function(){var inputValue=_this.inputValue;if(!inputValue){_this.filtering=false;return;}var before=_this.beforeFilter(inputValue);if(before&&before.then){before.then(_this.getSuggestions);}else if(before!==false){_this.getSuggestions();}else{_this.filtering=false;}});Object(resize_event_["addResizeListener"])(this.$el,this.updateStyle);},beforeDestroy:function beforeDestroy(){Object(resize_event_["removeResizeListener"])(this.$el,this.updateStyle);},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'expand-trigger':'expand-trigger is removed, use `props.expandTrigger` instead.','change-on-select':'change-on-select is removed, use `props.checkStrictly` instead.','hover-threshold':'hover-threshold is removed, use `props.hoverThreshold` instead'},events:{'active-item-change':'active-item-change is renamed to expand-change'}};},toggleDropDownVisible:function toggleDropDownVisible(visible){var _this2=this;if(this.isDisabled)return;var dropDownVisible=this.dropDownVisible;var input=this.$refs.input;visible=Object(shared_["isDef"])(visible)?visible:!dropDownVisible;if(visible!==dropDownVisible){this.dropDownVisible=visible;if(visible){this.$nextTick(function(){_this2.updatePopper();_this2.panel.scrollIntoView();});}input.$refs.input.setAttribute('aria-expanded',visible);this.$emit('visible-change',visible);}},handleDropdownLeave:function handleDropdownLeave(){this.filtering=false;this.inputValue=this.presentText;this.doDestroy();},handleKeyDown:function handleKeyDown(event){switch(event.keyCode){case KeyCode.enter:this.toggleDropDownVisible();break;case KeyCode.down:this.toggleDropDownVisible(true);this.focusFirstNode();event.preventDefault();break;case KeyCode.esc:case KeyCode.tab:this.toggleDropDownVisible(false);break;}},handleFocus:function handleFocus(e){this.$emit('focus',e);},handleBlur:function handleBlur(e){this.$emit('blur',e);},handleInput:function handleInput(val,event){!this.dropDownVisible&&this.toggleDropDownVisible(true);if(event&&event.isComposing)return;if(val){this.filterHandler();}else{this.filtering=false;}},handleClear:function handleClear(){this.presentText='';this.panel.clearCheckedNodes();},handleExpandChange:function handleExpandChange(value){this.$nextTick(this.updatePopper.bind(this));this.$emit('expand-change',value);this.$emit('active-item-change',value);// Deprecated
},focusFirstNode:function focusFirstNode(){var _this3=this;this.$nextTick(function(){var filtering=_this3.filtering;var _$refs=_this3.$refs,popper=_$refs.popper,suggestionPanel=_$refs.suggestionPanel;var firstNode=null;if(filtering&&suggestionPanel){firstNode=suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');}else{var firstMenu=popper.querySelector('.el-cascader-menu');firstNode=firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');}if(firstNode){firstNode.focus();!filtering&&firstNode.click();}});},computePresentContent:function computePresentContent(){var _this4=this;// nextTick is required, because checked nodes may not change right now
this.$nextTick(function(){if(_this4.config.multiple){_this4.computePresentTags();_this4.presentText=_this4.presentTags.length?' ':null;}else{_this4.computePresentText();}});},isEmptyValue:function isEmptyValue(val){var multiple=this.multiple;var emitPath=this.panel.config.emitPath;if(multiple||emitPath){return Object(util_["isEmpty"])(val);}return false;},computePresentText:function computePresentText(){var checkedValue=this.checkedValue,config=this.config;if(!this.isEmptyValue(checkedValue)){var node=this.panel.getNodeByValue(checkedValue);if(node&&(config.checkStrictly||node.isLeaf)){this.presentText=node.getText(this.showAllLevels,this.separator);return;}}this.presentText=null;},computePresentTags:function computePresentTags(){var isDisabled=this.isDisabled,leafOnly=this.leafOnly,showAllLevels=this.showAllLevels,separator=this.separator,collapseTags=this.collapseTags;var checkedNodes=this.getCheckedNodes(leafOnly);var tags=[];var genTag=function genTag(node){return{node:node,key:node.uid,text:node.getText(showAllLevels,separator),hitState:false,closable:!isDisabled&&!node.isDisabled};};if(checkedNodes.length){var first=checkedNodes[0],rest=checkedNodes.slice(1);var restCount=rest.length;tags.push(genTag(first));if(restCount){if(collapseTags){tags.push({key:-1,text:'+ '+restCount,closable:false});}else{rest.forEach(function(node){return tags.push(genTag(node));});}}}this.checkedNodes=checkedNodes;this.presentTags=tags;},getSuggestions:function getSuggestions(){var _this5=this;var filterMethod=this.filterMethod;if(!Object(types_["isFunction"])(filterMethod)){filterMethod=function filterMethod(node,keyword){return node.text.includes(keyword);};}var suggestions=this.panel.getFlattedNodes(this.leafOnly).filter(function(node){if(node.isDisabled)return false;node.text=node.getText(_this5.showAllLevels,_this5.separator)||'';return filterMethod(node,_this5.inputValue);});if(this.multiple){this.presentTags.forEach(function(tag){tag.hitState=false;});}else{suggestions.forEach(function(node){node.checked=Object(util_["isEqual"])(_this5.checkedValue,node.getValueByOption());});}this.filtering=true;this.suggestions=suggestions;this.$nextTick(this.updatePopper);},handleSuggestionKeyDown:function handleSuggestionKeyDown(event){var keyCode=event.keyCode,target=event.target;switch(keyCode){case KeyCode.enter:target.click();break;case KeyCode.up:var prev=target.previousElementSibling;prev&&prev.focus();break;case KeyCode.down:var next=target.nextElementSibling;next&&next.focus();break;case KeyCode.esc:case KeyCode.tab:this.toggleDropDownVisible(false);break;}},handleDelete:function handleDelete(){var inputValue=this.inputValue,pressDeleteCount=this.pressDeleteCount,presentTags=this.presentTags;var lastIndex=presentTags.length-1;var lastTag=presentTags[lastIndex];this.pressDeleteCount=inputValue?0:pressDeleteCount+1;if(!lastTag)return;if(this.pressDeleteCount){if(lastTag.hitState){this.deleteTag(lastTag);}else{lastTag.hitState=true;}}},handleSuggestionClick:function handleSuggestionClick(index){var multiple=this.multiple;var targetNode=this.suggestions[index];if(multiple){var checked=targetNode.checked;targetNode.doCheck(!checked);this.panel.calculateMultiCheckedValue();}else{this.checkedValue=targetNode.getValueByOption();this.toggleDropDownVisible(false);}},deleteTag:function deleteTag(tag){var checkedValue=this.checkedValue;var current=tag.node.getValueByOption();var val=checkedValue.find(function(n){return Object(util_["isEqual"])(n,current);});this.checkedValue=checkedValue.filter(function(n){return!Object(util_["isEqual"])(n,current);});this.$emit('remove-tag',val);},updateStyle:function updateStyle(){var $el=this.$el,inputInitialHeight=this.inputInitialHeight;if(this.$isServer||!$el)return;var suggestionPanel=this.$refs.suggestionPanel;var inputInner=$el.querySelector('.el-input__inner');if(!inputInner)return;var tags=$el.querySelector('.el-cascader__tags');var suggestionPanelEl=null;if(suggestionPanel&&(suggestionPanelEl=suggestionPanel.$el)){var suggestionList=suggestionPanelEl.querySelector('.el-cascader__suggestion-list');suggestionList.style.minWidth=inputInner.offsetWidth+'px';}if(tags){var offsetHeight=Math.round(tags.getBoundingClientRect().height);var height=Math.max(offsetHeight+6,inputInitialHeight)+'px';inputInner.style.height=height;if(this.dropDownVisible){this.updatePopper();}}},/**
     * public methods
    */getCheckedNodes:function getCheckedNodes(leafOnly){return this.panel.getCheckedNodes(leafOnly);}}};// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascadervue_type_script_lang_js_=cascadervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
/* normalize component */var cascader_component=normalizeComponent(src_cascadervue_type_script_lang_js_,cascadervue_type_template_id_032537a6_render,cascadervue_type_template_id_032537a6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_api;}cascader_component.options.__file="packages/cascader/src/cascader.vue";/* harmony default export */var cascader=cascader_component.exports;// CONCATENATED MODULE: ./packages/cascader/index.js
/* istanbul ignore next */cascader.install=function(Vue){Vue.component(cascader.name,cascader);};/* harmony default export */var packages_cascader=cascader;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
var mainvue_type_template_id_55c8ade7_render=function mainvue_type_template_id_55c8ade7_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.hide,expression:"hide"}],class:["el-color-picker",_vm.colorDisabled?"is-disabled":"",_vm.colorSize?"el-color-picker--"+_vm.colorSize:""]},[_vm.colorDisabled?_c("div",{staticClass:"el-color-picker__mask"}):_vm._e(),_c("div",{staticClass:"el-color-picker__trigger",on:{click:_vm.handleTrigger}},[_c("span",{staticClass:"el-color-picker__color",class:{"is-alpha":_vm.showAlpha}},[_c("span",{staticClass:"el-color-picker__color-inner",style:{backgroundColor:_vm.displayedColor}}),!_vm.value&&!_vm.showPanelColor?_c("span",{staticClass:"el-color-picker__empty el-icon-close"}):_vm._e()]),_c("span",{directives:[{name:"show",rawName:"v-show",value:_vm.value||_vm.showPanelColor,expression:"value || showPanelColor"}],staticClass:"el-color-picker__icon el-icon-arrow-down"})]),_c("picker-dropdown",{ref:"dropdown",class:["el-color-picker__panel",_vm.popperClass||""],attrs:{color:_vm.color,"show-alpha":_vm.showAlpha,predefine:_vm.predefine},on:{pick:_vm.confirmValue,clear:_vm.clearValue},model:{value:_vm.showPicker,callback:function callback($$v){_vm.showPicker=$$v;},expression:"showPicker"}})],1);};var mainvue_type_template_id_55c8ade7_staticRenderFns=[];mainvue_type_template_id_55c8ade7_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
// CONCATENATED MODULE: ./packages/color-picker/src/color.js
var color_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};function color_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var hsv2hsl=function hsv2hsl(hue,sat,val){return[hue,sat*val/((hue=(2-sat)*val)<1?hue:2-hue)||0,hue/2];};// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
var isOnePointZero=function isOnePointZero(n){return typeof n==='string'&&n.indexOf('.')!==-1&&parseFloat(n)===1;};var isPercentage=function isPercentage(n){return typeof n==='string'&&n.indexOf('%')!==-1;};// Take input from [0, n] and return it as [0, 1]
var bound01=function bound01(value,max){if(isOnePointZero(value))value='100%';var processPercent=isPercentage(value);value=Math.min(max,Math.max(0,parseFloat(value)));// Automatically convert percentage into number
if(processPercent){value=parseInt(value*max,10)/100;}// Handle floating point rounding errors
if(Math.abs(value-max)<0.000001){return 1;}// Convert into [0, 1] range if it isn't already
return value%max/parseFloat(max);};var INT_HEX_MAP={10:'A',11:'B',12:'C',13:'D',14:'E',15:'F'};var toHex=function toHex(_ref){var r=_ref.r,g=_ref.g,b=_ref.b;var hexOne=function hexOne(value){value=Math.min(Math.round(value),255);var high=Math.floor(value/16);var low=value%16;return''+(INT_HEX_MAP[high]||high)+(INT_HEX_MAP[low]||low);};if(isNaN(r)||isNaN(g)||isNaN(b))return'';return'#'+hexOne(r)+hexOne(g)+hexOne(b);};var HEX_INT_MAP={A:10,B:11,C:12,D:13,E:14,F:15};var parseHexChannel=function parseHexChannel(hex){if(hex.length===2){return(HEX_INT_MAP[hex[0].toUpperCase()]||+hex[0])*16+(HEX_INT_MAP[hex[1].toUpperCase()]||+hex[1]);}return HEX_INT_MAP[hex[1].toUpperCase()]||+hex[1];};var hsl2hsv=function hsl2hsv(hue,sat,light){sat=sat/100;light=light/100;var smin=sat;var lmin=Math.max(light,0.01);var sv=void 0;var v=void 0;light*=2;sat*=light<=1?light:2-light;smin*=lmin<=1?lmin:2-lmin;v=(light+sat)/2;sv=light===0?2*smin/(lmin+smin):2*sat/(light+sat);return{h:hue,s:sv*100,v:v*100};};// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
var rgb2hsv=function rgb2hsv(r,g,b){r=bound01(r,255);g=bound01(g,255);b=bound01(b,255);var max=Math.max(r,g,b);var min=Math.min(r,g,b);var h=void 0,s=void 0;var v=max;var d=max-min;s=max===0?0:d/max;if(max===min){h=0;// achromatic
}else{switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;}h/=6;}return{h:h*360,s:s*100,v:v*100};};// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
var hsv2rgb=function hsv2rgb(h,s,v){h=bound01(h,360)*6;s=bound01(s,100);v=bound01(v,100);var i=Math.floor(h);var f=h-i;var p=v*(1-s);var q=v*(1-f*s);var t=v*(1-(1-f)*s);var mod=i%6;var r=[v,q,p,p,t,v][mod];var g=[t,v,v,q,p,p][mod];var b=[p,p,t,v,v,q][mod];return{r:Math.round(r*255),g:Math.round(g*255),b:Math.round(b*255)};};var Color=function(){function Color(options){color_classCallCheck(this,Color);this._hue=0;this._saturation=100;this._value=100;this._alpha=100;this.enableAlpha=false;this.format='hex';this.value='';options=options||{};for(var option in options){if(options.hasOwnProperty(option)){this[option]=options[option];}}this.doOnChange();}Color.prototype.set=function set(prop,value){if(arguments.length===1&&(typeof prop==='undefined'?'undefined':color_typeof(prop))==='object'){for(var p in prop){if(prop.hasOwnProperty(p)){this.set(p,prop[p]);}}return;}this['_'+prop]=value;this.doOnChange();};Color.prototype.get=function get(prop){return this['_'+prop];};Color.prototype.toRgb=function toRgb(){return hsv2rgb(this._hue,this._saturation,this._value);};Color.prototype.fromString=function fromString(value){var _this=this;if(!value){this._hue=0;this._saturation=100;this._value=100;this.doOnChange();return;}var fromHSV=function fromHSV(h,s,v){_this._hue=Math.max(0,Math.min(360,h));_this._saturation=Math.max(0,Math.min(100,s));_this._value=Math.max(0,Math.min(100,v));_this.doOnChange();};if(value.indexOf('hsl')!==-1){var parts=value.replace(/hsla|hsl|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(parts.length===4){this._alpha=Math.floor(parseFloat(parts[3])*100);}else if(parts.length===3){this._alpha=100;}if(parts.length>=3){var _hsl2hsv=hsl2hsv(parts[0],parts[1],parts[2]),h=_hsl2hsv.h,s=_hsl2hsv.s,v=_hsl2hsv.v;fromHSV(h,s,v);}}else if(value.indexOf('hsv')!==-1){var _parts=value.replace(/hsva|hsv|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(_parts.length===4){this._alpha=Math.floor(parseFloat(_parts[3])*100);}else if(_parts.length===3){this._alpha=100;}if(_parts.length>=3){fromHSV(_parts[0],_parts[1],_parts[2]);}}else if(value.indexOf('rgb')!==-1){var _parts2=value.replace(/rgba|rgb|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(_parts2.length===4){this._alpha=Math.floor(parseFloat(_parts2[3])*100);}else if(_parts2.length===3){this._alpha=100;}if(_parts2.length>=3){var _rgb2hsv=rgb2hsv(_parts2[0],_parts2[1],_parts2[2]),_h=_rgb2hsv.h,_s=_rgb2hsv.s,_v=_rgb2hsv.v;fromHSV(_h,_s,_v);}}else if(value.indexOf('#')!==-1){var hex=value.replace('#','').trim();if(!/^(?:[0-9a-fA-F]{3}){1,2}|[0-9a-fA-F]{8}$/.test(hex))return;var r=void 0,g=void 0,b=void 0;if(hex.length===3){r=parseHexChannel(hex[0]+hex[0]);g=parseHexChannel(hex[1]+hex[1]);b=parseHexChannel(hex[2]+hex[2]);}else if(hex.length===6||hex.length===8){r=parseHexChannel(hex.substring(0,2));g=parseHexChannel(hex.substring(2,4));b=parseHexChannel(hex.substring(4,6));}if(hex.length===8){this._alpha=Math.floor(parseHexChannel(hex.substring(6))/255*100);}else if(hex.length===3||hex.length===6){this._alpha=100;}var _rgb2hsv2=rgb2hsv(r,g,b),_h2=_rgb2hsv2.h,_s2=_rgb2hsv2.s,_v2=_rgb2hsv2.v;fromHSV(_h2,_s2,_v2);}};Color.prototype.compare=function compare(color){return Math.abs(color._hue-this._hue)<2&&Math.abs(color._saturation-this._saturation)<1&&Math.abs(color._value-this._value)<1&&Math.abs(color._alpha-this._alpha)<1;};Color.prototype.doOnChange=function doOnChange(){var _hue=this._hue,_saturation=this._saturation,_value=this._value,_alpha=this._alpha,format=this.format;if(this.enableAlpha){switch(format){case'hsl':var hsl=hsv2hsl(_hue,_saturation/100,_value/100);this.value='hsla('+_hue+', '+Math.round(hsl[1]*100)+'%, '+Math.round(hsl[2]*100)+'%, '+_alpha/100+')';break;case'hsv':this.value='hsva('+_hue+', '+Math.round(_saturation)+'%, '+Math.round(_value)+'%, '+_alpha/100+')';break;default:var _hsv2rgb=hsv2rgb(_hue,_saturation,_value),r=_hsv2rgb.r,g=_hsv2rgb.g,b=_hsv2rgb.b;this.value='rgba('+r+', '+g+', '+b+', '+_alpha/100+')';}}else{switch(format){case'hsl':var _hsl=hsv2hsl(_hue,_saturation/100,_value/100);this.value='hsl('+_hue+', '+Math.round(_hsl[1]*100)+'%, '+Math.round(_hsl[2]*100)+'%)';break;case'hsv':this.value='hsv('+_hue+', '+Math.round(_saturation)+'%, '+Math.round(_value)+'%)';break;case'rgb':var _hsv2rgb2=hsv2rgb(_hue,_saturation,_value),_r=_hsv2rgb2.r,_g=_hsv2rgb2.g,_b=_hsv2rgb2.b;this.value='rgb('+_r+', '+_g+', '+_b+')';break;default:this.value=toHex(hsv2rgb(_hue,_saturation,_value));}}};return Color;}();/* harmony default export */var src_color=Color;;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
var picker_dropdownvue_type_template_id_06601625_render=function picker_dropdownvue_type_template_id_06601625_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-color-dropdown"},[_c("div",{staticClass:"el-color-dropdown__main-wrapper"},[_c("hue-slider",{ref:"hue",staticStyle:{float:"right"},attrs:{color:_vm.color,vertical:""}}),_c("sv-panel",{ref:"sl",attrs:{color:_vm.color}})],1),_vm.showAlpha?_c("alpha-slider",{ref:"alpha",attrs:{color:_vm.color}}):_vm._e(),_vm.predefine?_c("predefine",{attrs:{color:_vm.color,colors:_vm.predefine}}):_vm._e(),_c("div",{staticClass:"el-color-dropdown__btns"},[_c("span",{staticClass:"el-color-dropdown__value"},[_c("el-input",{attrs:{"validate-event":false,size:"mini"},on:{blur:_vm.handleConfirm},nativeOn:{keyup:function keyup($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleConfirm($event);}},model:{value:_vm.customInput,callback:function callback($$v){_vm.customInput=$$v;},expression:"customInput"}})],1),_c("el-button",{staticClass:"el-color-dropdown__link-btn",attrs:{size:"mini",type:"text"},on:{click:function click($event){_vm.$emit("clear");}}},[_vm._v("\n        "+_vm._s(_vm.t("el.colorpicker.clear"))+"\n      ")]),_c("el-button",{staticClass:"el-color-dropdown__btn",attrs:{plain:"",size:"mini"},on:{click:_vm.confirmValue}},[_vm._v("\n        "+_vm._s(_vm.t("el.colorpicker.confirm"))+"\n      ")])],1)],1)]);};var picker_dropdownvue_type_template_id_06601625_staticRenderFns=[];picker_dropdownvue_type_template_id_06601625_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
var sv_panelvue_type_template_id_d8583596_render=function sv_panelvue_type_template_id_d8583596_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-svpanel",style:{backgroundColor:_vm.background}},[_c("div",{staticClass:"el-color-svpanel__white"}),_c("div",{staticClass:"el-color-svpanel__black"}),_c("div",{staticClass:"el-color-svpanel__cursor",style:{top:_vm.cursorTop+"px",left:_vm.cursorLeft+"px"}},[_c("div")])]);};var sv_panelvue_type_template_id_d8583596_staticRenderFns=[];sv_panelvue_type_template_id_d8583596_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
var isDragging=false;/* harmony default export */var draggable=function draggable(element,options){if(external_vue_default.a.prototype.$isServer)return;var moveFn=function moveFn(event){if(options.drag){options.drag(event);}};var upFn=function upFn(event){document.removeEventListener('mousemove',moveFn);document.removeEventListener('mouseup',upFn);document.onselectstart=null;document.ondragstart=null;isDragging=false;if(options.end){options.end(event);}};element.addEventListener('mousedown',function(event){if(isDragging)return;document.onselectstart=function(){return false;};document.ondragstart=function(){return false;};document.addEventListener('mousemove',moveFn);document.addEventListener('mouseup',upFn);isDragging=true;if(options.start){options.start(event);}});};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var sv_panelvue_type_script_lang_js_={name:'el-sl-panel',props:{color:{required:true}},computed:{colorValue:function colorValue(){var hue=this.color.get('hue');var value=this.color.get('value');return{hue:hue,value:value};}},watch:{colorValue:function colorValue(){this.update();}},methods:{update:function update(){var saturation=this.color.get('saturation');var value=this.color.get('value');var el=this.$el;var width=el.clientWidth,height=el.clientHeight;this.cursorLeft=saturation*width/100;this.cursorTop=(100-value)*height/100;this.background='hsl('+this.color.get('hue')+', 100%, 50%)';},handleDrag:function handleDrag(event){var el=this.$el;var rect=el.getBoundingClientRect();var left=event.clientX-rect.left;var top=event.clientY-rect.top;left=Math.max(0,left);left=Math.min(left,rect.width);top=Math.max(0,top);top=Math.min(top,rect.height);this.cursorLeft=left;this.cursorTop=top;this.color.set({saturation:left/rect.width*100,value:100-top/rect.height*100});}},mounted:function mounted(){var _this=this;draggable(this.$el,{drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}});this.update();},data:function data(){return{cursorTop:0,cursorLeft:0,background:'hsl(0, 100%, 50%)'};}};// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
/* harmony default export */var components_sv_panelvue_type_script_lang_js_=sv_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
/* normalize component */var sv_panel_component=normalizeComponent(components_sv_panelvue_type_script_lang_js_,sv_panelvue_type_template_id_d8583596_render,sv_panelvue_type_template_id_d8583596_staticRenderFns,false,null,null,null);/* hot reload */if(false){var sv_panel_api;}sv_panel_component.options.__file="packages/color-picker/src/components/sv-panel.vue";/* harmony default export */var sv_panel=sv_panel_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
var hue_slidervue_type_template_id_5cdc43b1_render=function hue_slidervue_type_template_id_5cdc43b1_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-hue-slider",class:{"is-vertical":_vm.vertical}},[_c("div",{ref:"bar",staticClass:"el-color-hue-slider__bar",on:{click:_vm.handleClick}}),_c("div",{ref:"thumb",staticClass:"el-color-hue-slider__thumb",style:{left:_vm.thumbLeft+"px",top:_vm.thumbTop+"px"}})]);};var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns=[];hue_slidervue_type_template_id_5cdc43b1_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var hue_slidervue_type_script_lang_js_={name:'el-color-hue-slider',props:{color:{required:true},vertical:Boolean},data:function data(){return{thumbLeft:0,thumbTop:0};},computed:{hueValue:function hueValue(){var hue=this.color.get('hue');return hue;}},watch:{hueValue:function hueValue(){this.update();}},methods:{handleClick:function handleClick(event){var thumb=this.$refs.thumb;var target=event.target;if(target!==thumb){this.handleDrag(event);}},handleDrag:function handleDrag(event){var rect=this.$el.getBoundingClientRect();var thumb=this.$refs.thumb;var hue=void 0;if(!this.vertical){var left=event.clientX-rect.left;left=Math.min(left,rect.width-thumb.offsetWidth/2);left=Math.max(thumb.offsetWidth/2,left);hue=Math.round((left-thumb.offsetWidth/2)/(rect.width-thumb.offsetWidth)*360);}else{var top=event.clientY-rect.top;top=Math.min(top,rect.height-thumb.offsetHeight/2);top=Math.max(thumb.offsetHeight/2,top);hue=Math.round((top-thumb.offsetHeight/2)/(rect.height-thumb.offsetHeight)*360);}this.color.set('hue',hue);},getThumbLeft:function getThumbLeft(){if(this.vertical)return 0;var el=this.$el;var hue=this.color.get('hue');if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(hue*(el.offsetWidth-thumb.offsetWidth/2)/360);},getThumbTop:function getThumbTop(){if(!this.vertical)return 0;var el=this.$el;var hue=this.color.get('hue');if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(hue*(el.offsetHeight-thumb.offsetHeight/2)/360);},update:function update(){this.thumbLeft=this.getThumbLeft();this.thumbTop=this.getThumbTop();}},mounted:function mounted(){var _this=this;var _$refs=this.$refs,bar=_$refs.bar,thumb=_$refs.thumb;var dragConfig={drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}};draggable(bar,dragConfig);draggable(thumb,dragConfig);this.update();}};// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
/* harmony default export */var components_hue_slidervue_type_script_lang_js_=hue_slidervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
/* normalize component */var hue_slider_component=normalizeComponent(components_hue_slidervue_type_script_lang_js_,hue_slidervue_type_template_id_5cdc43b1_render,hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,false,null,null,null);/* hot reload */if(false){var hue_slider_api;}hue_slider_component.options.__file="packages/color-picker/src/components/hue-slider.vue";/* harmony default export */var hue_slider=hue_slider_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
var alpha_slidervue_type_template_id_068c66cb_render=function alpha_slidervue_type_template_id_068c66cb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-alpha-slider",class:{"is-vertical":_vm.vertical}},[_c("div",{ref:"bar",staticClass:"el-color-alpha-slider__bar",style:{background:_vm.background},on:{click:_vm.handleClick}}),_c("div",{ref:"thumb",staticClass:"el-color-alpha-slider__thumb",style:{left:_vm.thumbLeft+"px",top:_vm.thumbTop+"px"}})]);};var alpha_slidervue_type_template_id_068c66cb_staticRenderFns=[];alpha_slidervue_type_template_id_068c66cb_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var alpha_slidervue_type_script_lang_js_={name:'el-color-alpha-slider',props:{color:{required:true},vertical:Boolean},watch:{'color._alpha':function color_alpha(){this.update();},'color.value':function colorValue(){this.update();}},methods:{handleClick:function handleClick(event){var thumb=this.$refs.thumb;var target=event.target;if(target!==thumb){this.handleDrag(event);}},handleDrag:function handleDrag(event){var rect=this.$el.getBoundingClientRect();var thumb=this.$refs.thumb;if(!this.vertical){var left=event.clientX-rect.left;left=Math.max(thumb.offsetWidth/2,left);left=Math.min(left,rect.width-thumb.offsetWidth/2);this.color.set('alpha',Math.round((left-thumb.offsetWidth/2)/(rect.width-thumb.offsetWidth)*100));}else{var top=event.clientY-rect.top;top=Math.max(thumb.offsetHeight/2,top);top=Math.min(top,rect.height-thumb.offsetHeight/2);this.color.set('alpha',Math.round((top-thumb.offsetHeight/2)/(rect.height-thumb.offsetHeight)*100));}},getThumbLeft:function getThumbLeft(){if(this.vertical)return 0;var el=this.$el;var alpha=this.color._alpha;if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(alpha*(el.offsetWidth-thumb.offsetWidth/2)/100);},getThumbTop:function getThumbTop(){if(!this.vertical)return 0;var el=this.$el;var alpha=this.color._alpha;if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(alpha*(el.offsetHeight-thumb.offsetHeight/2)/100);},getBackground:function getBackground(){if(this.color&&this.color.value){var _color$toRgb=this.color.toRgb(),r=_color$toRgb.r,g=_color$toRgb.g,b=_color$toRgb.b;return'linear-gradient(to right, rgba('+r+', '+g+', '+b+', 0) 0%, rgba('+r+', '+g+', '+b+', 1) 100%)';}return null;},update:function update(){this.thumbLeft=this.getThumbLeft();this.thumbTop=this.getThumbTop();this.background=this.getBackground();}},data:function data(){return{thumbLeft:0,thumbTop:0,background:null};},mounted:function mounted(){var _this=this;var _$refs=this.$refs,bar=_$refs.bar,thumb=_$refs.thumb;var dragConfig={drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}};draggable(bar,dragConfig);draggable(thumb,dragConfig);this.update();}};// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
/* harmony default export */var components_alpha_slidervue_type_script_lang_js_=alpha_slidervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
/* normalize component */var alpha_slider_component=normalizeComponent(components_alpha_slidervue_type_script_lang_js_,alpha_slidervue_type_template_id_068c66cb_render,alpha_slidervue_type_template_id_068c66cb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var alpha_slider_api;}alpha_slider_component.options.__file="packages/color-picker/src/components/alpha-slider.vue";/* harmony default export */var alpha_slider=alpha_slider_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
var predefinevue_type_template_id_06e03093_render=function predefinevue_type_template_id_06e03093_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-predefine"},[_c("div",{staticClass:"el-color-predefine__colors"},_vm._l(_vm.rgbaColors,function(item,index){return _c("div",{key:_vm.colors[index],staticClass:"el-color-predefine__color-selector",class:{selected:item.selected,"is-alpha":item._alpha<100},on:{click:function click($event){_vm.handleSelect(index);}}},[_c("div",{style:{"background-color":item.value}})]);}),0)]);};var predefinevue_type_template_id_06e03093_staticRenderFns=[];predefinevue_type_template_id_06e03093_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var predefinevue_type_script_lang_js_={props:{colors:{type:Array,required:true},color:{required:true}},data:function data(){return{rgbaColors:this.parseColors(this.colors,this.color)};},methods:{handleSelect:function handleSelect(index){this.color.fromString(this.colors[index]);},parseColors:function parseColors(colors,color){return colors.map(function(value){var c=new src_color();c.enableAlpha=true;c.format='rgba';c.fromString(value);c.selected=c.value===color.value;return c;});}},watch:{'$parent.currentColor':function $parentCurrentColor(val){var color=new src_color();color.fromString(val);this.rgbaColors.forEach(function(item){item.selected=color.compare(item);});},colors:function colors(newVal){this.rgbaColors=this.parseColors(newVal,this.color);},color:function color(newVal){this.rgbaColors=this.parseColors(this.colors,newVal);}}};// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
/* harmony default export */var components_predefinevue_type_script_lang_js_=predefinevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
/* normalize component */var predefine_component=normalizeComponent(components_predefinevue_type_script_lang_js_,predefinevue_type_template_id_06e03093_render,predefinevue_type_template_id_06e03093_staticRenderFns,false,null,null,null);/* hot reload */if(false){var predefine_api;}predefine_component.options.__file="packages/color-picker/src/components/predefine.vue";/* harmony default export */var predefine=predefine_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var picker_dropdownvue_type_script_lang_js_={name:'el-color-picker-dropdown',mixins:[vue_popper_default.a,locale_default.a],components:{SvPanel:sv_panel,HueSlider:hue_slider,AlphaSlider:alpha_slider,ElInput:input_default.a,ElButton:button_default.a,Predefine:predefine},props:{color:{required:true},showAlpha:Boolean,predefine:Array},data:function data(){return{customInput:''};},computed:{currentColor:function currentColor(){var parent=this.$parent;return!parent.value&&!parent.showPanelColor?'':parent.color.value;}},methods:{confirmValue:function confirmValue(){this.$emit('pick');},handleConfirm:function handleConfirm(){this.color.fromString(this.customInput);}},mounted:function mounted(){this.$parent.popperElm=this.popperElm=this.$el;this.referenceElm=this.$parent.$el;},watch:{showPopper:function showPopper(val){var _this=this;if(val===true){this.$nextTick(function(){var _$refs=_this.$refs,sl=_$refs.sl,hue=_$refs.hue,alpha=_$refs.alpha;sl&&sl.update();hue&&hue.update();alpha&&alpha.update();});}},currentColor:{immediate:true,handler:function handler(val){this.customInput=val;}}}};// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var components_picker_dropdownvue_type_script_lang_js_=picker_dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
/* normalize component */var picker_dropdown_component=normalizeComponent(components_picker_dropdownvue_type_script_lang_js_,picker_dropdownvue_type_template_id_06601625_render,picker_dropdownvue_type_template_id_06601625_staticRenderFns,false,null,null,null);/* hot reload */if(false){var picker_dropdown_api;}picker_dropdown_component.options.__file="packages/color-picker/src/components/picker-dropdown.vue";/* harmony default export */var picker_dropdown=picker_dropdown_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var color_picker_src_mainvue_type_script_lang_js_={name:'ElColorPicker',mixins:[emitter_default.a],props:{value:String,showAlpha:Boolean,colorFormat:String,disabled:Boolean,size:String,popperClass:String,predefine:Array},inject:{elForm:{default:''},elFormItem:{default:''}},directives:{Clickoutside:clickoutside_default.a},computed:{displayedColor:function displayedColor(){if(!this.value&&!this.showPanelColor){return'transparent';}return this.displayedRgb(this.color,this.showAlpha);},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},colorSize:function colorSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},colorDisabled:function colorDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{value:function value(val){if(!val){this.showPanelColor=false;}else if(val&&val!==this.color.value){this.color.fromString(val);}},color:{deep:true,handler:function handler(){this.showPanelColor=true;}},displayedColor:function displayedColor(val){if(!this.showPicker)return;var currentValueColor=new src_color({enableAlpha:this.showAlpha,format:this.colorFormat});currentValueColor.fromString(this.value);var currentValueColorRgb=this.displayedRgb(currentValueColor,this.showAlpha);if(val!==currentValueColorRgb){this.$emit('active-change',val);}}},methods:{handleTrigger:function handleTrigger(){if(this.colorDisabled)return;this.showPicker=!this.showPicker;},confirmValue:function confirmValue(){var value=this.color.value;this.$emit('input',value);this.$emit('change',value);this.dispatch('ElFormItem','el.form.change',value);this.showPicker=false;},clearValue:function clearValue(){this.$emit('input',null);this.$emit('change',null);if(this.value!==null){this.dispatch('ElFormItem','el.form.change',null);}this.showPanelColor=false;this.showPicker=false;this.resetColor();},hide:function hide(){this.showPicker=false;this.resetColor();},resetColor:function resetColor(){var _this=this;this.$nextTick(function(_){if(_this.value){_this.color.fromString(_this.value);}else{_this.showPanelColor=false;}});},displayedRgb:function displayedRgb(color,showAlpha){if(!(color instanceof src_color)){throw Error('color should be instance of Color Class');}var _color$toRgb=color.toRgb(),r=_color$toRgb.r,g=_color$toRgb.g,b=_color$toRgb.b;return showAlpha?'rgba('+r+', '+g+', '+b+', '+color.get('alpha')/100+')':'rgb('+r+', '+g+', '+b+')';}},mounted:function mounted(){var value=this.value;if(value){this.color.fromString(value);}this.popperElm=this.$refs.dropdown.$el;},data:function data(){var color=new src_color({enableAlpha:this.showAlpha,format:this.colorFormat});return{color:color,showPicker:false,showPanelColor:false};},components:{PickerDropdown:picker_dropdown}};// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_color_picker_src_mainvue_type_script_lang_js_=color_picker_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
/* normalize component */var color_picker_src_main_component=normalizeComponent(packages_color_picker_src_mainvue_type_script_lang_js_,mainvue_type_template_id_55c8ade7_render,mainvue_type_template_id_55c8ade7_staticRenderFns,false,null,null,null);/* hot reload */if(false){var color_picker_src_main_api;}color_picker_src_main_component.options.__file="packages/color-picker/src/main.vue";/* harmony default export */var color_picker_src_main=color_picker_src_main_component.exports;// CONCATENATED MODULE: ./packages/color-picker/index.js
/* istanbul ignore next */color_picker_src_main.install=function(Vue){Vue.component(color_picker_src_main.name,color_picker_src_main);};/* harmony default export */var color_picker=color_picker_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
var mainvue_type_template_id_5c654dd8_render=function mainvue_type_template_id_5c654dd8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-transfer"},[_c("transfer-panel",_vm._b({ref:"leftPanel",attrs:{data:_vm.sourceData,title:_vm.titles[0]||_vm.t("el.transfer.titles.0"),"default-checked":_vm.leftDefaultChecked,placeholder:_vm.filterPlaceholder||_vm.t("el.transfer.filterPlaceholder")},on:{"checked-change":_vm.onSourceCheckedChange}},"transfer-panel",_vm.$props,false),[_vm._t("left-footer")],2),_c("div",{staticClass:"el-transfer__buttons"},[_c("el-button",{class:["el-transfer__button",_vm.hasButtonTexts?"is-with-texts":""],attrs:{type:"primary",disabled:_vm.rightChecked.length===0},nativeOn:{click:function click($event){return _vm.addToLeft($event);}}},[_c("i",{staticClass:"el-icon-arrow-left"}),_vm.buttonTexts[0]!==undefined?_c("span",[_vm._v(_vm._s(_vm.buttonTexts[0]))]):_vm._e()]),_c("el-button",{class:["el-transfer__button",_vm.hasButtonTexts?"is-with-texts":""],attrs:{type:"primary",disabled:_vm.leftChecked.length===0},nativeOn:{click:function click($event){return _vm.addToRight($event);}}},[_vm.buttonTexts[1]!==undefined?_c("span",[_vm._v(_vm._s(_vm.buttonTexts[1]))]):_vm._e(),_c("i",{staticClass:"el-icon-arrow-right"})])],1),_c("transfer-panel",_vm._b({ref:"rightPanel",attrs:{data:_vm.targetData,title:_vm.titles[1]||_vm.t("el.transfer.titles.1"),"default-checked":_vm.rightDefaultChecked,placeholder:_vm.filterPlaceholder||_vm.t("el.transfer.filterPlaceholder")},on:{"checked-change":_vm.onTargetCheckedChange}},"transfer-panel",_vm.$props,false),[_vm._t("right-footer")],2)],1);};var mainvue_type_template_id_5c654dd8_staticRenderFns=[];mainvue_type_template_id_5c654dd8_render._withStripped=true;// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
var transfer_panelvue_type_template_id_2ddab8bd_render=function transfer_panelvue_type_template_id_2ddab8bd_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-transfer-panel"},[_c("p",{staticClass:"el-transfer-panel__header"},[_c("el-checkbox",{attrs:{indeterminate:_vm.isIndeterminate},on:{change:_vm.handleAllCheckedChange},model:{value:_vm.allChecked,callback:function callback($$v){_vm.allChecked=$$v;},expression:"allChecked"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c("span",[_vm._v(_vm._s(_vm.checkedSummary))])])],1),_c("div",{class:["el-transfer-panel__body",_vm.hasFooter?"is-with-footer":""]},[_vm.filterable?_c("el-input",{staticClass:"el-transfer-panel__filter",attrs:{size:"small",placeholder:_vm.placeholder},nativeOn:{mouseenter:function mouseenter($event){_vm.inputHover=true;},mouseleave:function mouseleave($event){_vm.inputHover=false;}},model:{value:_vm.query,callback:function callback($$v){_vm.query=$$v;},expression:"query"}},[_c("i",{class:["el-input__icon","el-icon-"+_vm.inputIcon],attrs:{slot:"prefix"},on:{click:_vm.clearQuery},slot:"prefix"})]):_vm._e(),_c("el-checkbox-group",{directives:[{name:"show",rawName:"v-show",value:!_vm.hasNoMatch&&_vm.data.length>0,expression:"!hasNoMatch && data.length > 0"}],staticClass:"el-transfer-panel__list",class:{"is-filterable":_vm.filterable},model:{value:_vm.checked,callback:function callback($$v){_vm.checked=$$v;},expression:"checked"}},_vm._l(_vm.filteredData,function(item){return _c("el-checkbox",{key:item[_vm.keyProp],staticClass:"el-transfer-panel__item",attrs:{label:item[_vm.keyProp],disabled:item[_vm.disabledProp]}},[_c("option-content",{attrs:{option:item}})],1);}),1),_c("p",{directives:[{name:"show",rawName:"v-show",value:_vm.hasNoMatch,expression:"hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]),_c("p",{directives:[{name:"show",rawName:"v-show",value:_vm.data.length===0&&!_vm.hasNoMatch,expression:"data.length === 0 && !hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t("el.transfer.noData")))])],1),_vm.hasFooter?_c("p",{staticClass:"el-transfer-panel__footer"},[_vm._t("default")],2):_vm._e()]);};var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns=[];transfer_panelvue_type_template_id_2ddab8bd_render._withStripped=true;// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var transfer_panelvue_type_script_lang_js_={mixins:[locale_default.a],name:'ElTransferPanel',componentName:'ElTransferPanel',components:{ElCheckboxGroup:checkbox_group_default.a,ElCheckbox:checkbox_default.a,ElInput:input_default.a,OptionContent:{props:{option:Object},render:function render(h){var getParent=function getParent(vm){if(vm.$options.componentName==='ElTransferPanel'){return vm;}else if(vm.$parent){return getParent(vm.$parent);}else{return vm;}};var panel=getParent(this);var transfer=panel.$parent||panel;return panel.renderContent?panel.renderContent(h,this.option):transfer.$scopedSlots.default?transfer.$scopedSlots.default({option:this.option}):h('span',[this.option[panel.labelProp]||this.option[panel.keyProp]]);}}},props:{data:{type:Array,default:function _default(){return[];}},renderContent:Function,placeholder:String,title:String,filterable:Boolean,format:Object,filterMethod:Function,defaultChecked:Array,props:Object},data:function data(){return{checked:[],allChecked:false,query:'',inputHover:false,checkChangeByUser:true};},watch:{checked:function checked(val,oldVal){this.updateAllChecked();if(this.checkChangeByUser){var movedKeys=val.concat(oldVal).filter(function(v){return val.indexOf(v)===-1||oldVal.indexOf(v)===-1;});this.$emit('checked-change',val,movedKeys);}else{this.$emit('checked-change',val);this.checkChangeByUser=true;}},data:function data(){var _this=this;var checked=[];var filteredDataKeys=this.filteredData.map(function(item){return item[_this.keyProp];});this.checked.forEach(function(item){if(filteredDataKeys.indexOf(item)>-1){checked.push(item);}});this.checkChangeByUser=false;this.checked=checked;},checkableData:function checkableData(){this.updateAllChecked();},defaultChecked:{immediate:true,handler:function handler(val,oldVal){var _this2=this;if(oldVal&&val.length===oldVal.length&&val.every(function(item){return oldVal.indexOf(item)>-1;}))return;var checked=[];var checkableDataKeys=this.checkableData.map(function(item){return item[_this2.keyProp];});val.forEach(function(item){if(checkableDataKeys.indexOf(item)>-1){checked.push(item);}});this.checkChangeByUser=false;this.checked=checked;}}},computed:{filteredData:function filteredData(){var _this3=this;return this.data.filter(function(item){if(typeof _this3.filterMethod==='function'){return _this3.filterMethod(_this3.query,item);}else{var label=item[_this3.labelProp]||item[_this3.keyProp].toString();return label.toLowerCase().indexOf(_this3.query.toLowerCase())>-1;}});},checkableData:function checkableData(){var _this4=this;return this.filteredData.filter(function(item){return!item[_this4.disabledProp];});},checkedSummary:function checkedSummary(){var checkedLength=this.checked.length;var dataLength=this.data.length;var _format=this.format,noChecked=_format.noChecked,hasChecked=_format.hasChecked;if(noChecked&&hasChecked){return checkedLength>0?hasChecked.replace(/\${checked}/g,checkedLength).replace(/\${total}/g,dataLength):noChecked.replace(/\${total}/g,dataLength);}else{return checkedLength+'/'+dataLength;}},isIndeterminate:function isIndeterminate(){var checkedLength=this.checked.length;return checkedLength>0&&checkedLength<this.checkableData.length;},hasNoMatch:function hasNoMatch(){return this.query.length>0&&this.filteredData.length===0;},inputIcon:function inputIcon(){return this.query.length>0&&this.inputHover?'circle-close':'search';},labelProp:function labelProp(){return this.props.label||'label';},keyProp:function keyProp(){return this.props.key||'key';},disabledProp:function disabledProp(){return this.props.disabled||'disabled';},hasFooter:function hasFooter(){return!!this.$slots.default;}},methods:{updateAllChecked:function updateAllChecked(){var _this5=this;var checkableDataKeys=this.checkableData.map(function(item){return item[_this5.keyProp];});this.allChecked=checkableDataKeys.length>0&&checkableDataKeys.every(function(item){return _this5.checked.indexOf(item)>-1;});},handleAllCheckedChange:function handleAllCheckedChange(value){var _this6=this;this.checked=value?this.checkableData.map(function(item){return item[_this6.keyProp];}):[];},clearQuery:function clearQuery(){if(this.inputIcon==='circle-close'){this.query='';}}}};// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_transfer_panelvue_type_script_lang_js_=transfer_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
/* normalize component */var transfer_panel_component=normalizeComponent(src_transfer_panelvue_type_script_lang_js_,transfer_panelvue_type_template_id_2ddab8bd_render,transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,false,null,null,null);/* hot reload */if(false){var transfer_panel_api;}transfer_panel_component.options.__file="packages/transfer/src/transfer-panel.vue";/* harmony default export */var transfer_panel=transfer_panel_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var transfer_src_mainvue_type_script_lang_js_={name:'ElTransfer',mixins:[emitter_default.a,locale_default.a,migrating_default.a],components:{TransferPanel:transfer_panel,ElButton:button_default.a},props:{data:{type:Array,default:function _default(){return[];}},titles:{type:Array,default:function _default(){return[];}},buttonTexts:{type:Array,default:function _default(){return[];}},filterPlaceholder:{type:String,default:''},filterMethod:Function,leftDefaultChecked:{type:Array,default:function _default(){return[];}},rightDefaultChecked:{type:Array,default:function _default(){return[];}},renderContent:Function,value:{type:Array,default:function _default(){return[];}},format:{type:Object,default:function _default(){return{};}},filterable:Boolean,props:{type:Object,default:function _default(){return{label:'label',key:'key',disabled:'disabled'};}},targetOrder:{type:String,default:'original'}},data:function data(){return{leftChecked:[],rightChecked:[]};},computed:{dataObj:function dataObj(){var key=this.props.key;return this.data.reduce(function(o,cur){return(o[cur[key]]=cur)&&o;},{});},sourceData:function sourceData(){var _this=this;return this.data.filter(function(item){return _this.value.indexOf(item[_this.props.key])===-1;});},targetData:function targetData(){var _this2=this;if(this.targetOrder==='original'){return this.data.filter(function(item){return _this2.value.indexOf(item[_this2.props.key])>-1;});}else{return this.value.reduce(function(arr,cur){var val=_this2.dataObj[cur];if(val){arr.push(val);}return arr;},[]);}},hasButtonTexts:function hasButtonTexts(){return this.buttonTexts.length===2;}},watch:{value:function value(val){this.dispatch('ElFormItem','el.form.change',val);}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'footer-format':'footer-format is renamed to format.'}};},onSourceCheckedChange:function onSourceCheckedChange(val,movedKeys){this.leftChecked=val;if(movedKeys===undefined)return;this.$emit('left-check-change',val,movedKeys);},onTargetCheckedChange:function onTargetCheckedChange(val,movedKeys){this.rightChecked=val;if(movedKeys===undefined)return;this.$emit('right-check-change',val,movedKeys);},addToLeft:function addToLeft(){var currentValue=this.value.slice();this.rightChecked.forEach(function(item){var index=currentValue.indexOf(item);if(index>-1){currentValue.splice(index,1);}});this.$emit('input',currentValue);this.$emit('change',currentValue,'left',this.rightChecked);},addToRight:function addToRight(){var _this3=this;var currentValue=this.value.slice();var itemsToBeMoved=[];var key=this.props.key;this.data.forEach(function(item){var itemKey=item[key];if(_this3.leftChecked.indexOf(itemKey)>-1&&_this3.value.indexOf(itemKey)===-1){itemsToBeMoved.push(itemKey);}});currentValue=this.targetOrder==='unshift'?itemsToBeMoved.concat(currentValue):currentValue.concat(itemsToBeMoved);this.$emit('input',currentValue);this.$emit('change',currentValue,'right',this.leftChecked);},clearQuery:function clearQuery(which){if(which==='left'){this.$refs.leftPanel.query='';}else if(which==='right'){this.$refs.rightPanel.query='';}}}};// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_transfer_src_mainvue_type_script_lang_js_=transfer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/transfer/src/main.vue
/* normalize component */var transfer_src_main_component=normalizeComponent(packages_transfer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5c654dd8_render,mainvue_type_template_id_5c654dd8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var transfer_src_main_api;}transfer_src_main_component.options.__file="packages/transfer/src/main.vue";/* harmony default export */var transfer_src_main=transfer_src_main_component.exports;// CONCATENATED MODULE: ./packages/transfer/index.js
/* istanbul ignore next */transfer_src_main.install=function(Vue){Vue.component(transfer_src_main.name,transfer_src_main);};/* harmony default export */var transfer=transfer_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
var mainvue_type_template_id_5bf181d4_render=function mainvue_type_template_id_5bf181d4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("section",{staticClass:"el-container",class:{"is-vertical":_vm.isVertical}},[_vm._t("default")],2);};var mainvue_type_template_id_5bf181d4_staticRenderFns=[];mainvue_type_template_id_5bf181d4_render._withStripped=true;// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var container_src_mainvue_type_script_lang_js_={name:'ElContainer',componentName:'ElContainer',props:{direction:String},computed:{isVertical:function isVertical(){if(this.direction==='vertical'){return true;}else if(this.direction==='horizontal'){return false;}return this.$slots&&this.$slots.default?this.$slots.default.some(function(vnode){var tag=vnode.componentOptions&&vnode.componentOptions.tag;return tag==='el-header'||tag==='el-footer';}):false;}}};// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_container_src_mainvue_type_script_lang_js_=container_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/container/src/main.vue
/* normalize component */var container_src_main_component=normalizeComponent(packages_container_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5bf181d4_render,mainvue_type_template_id_5bf181d4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var container_src_main_api;}container_src_main_component.options.__file="packages/container/src/main.vue";/* harmony default export */var container_src_main=container_src_main_component.exports;// CONCATENATED MODULE: ./packages/container/index.js
/* istanbul ignore next */container_src_main.install=function(Vue){Vue.component(container_src_main.name,container_src_main);};/* harmony default export */var packages_container=container_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
var mainvue_type_template_id_2b296ab2_render=function mainvue_type_template_id_2b296ab2_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("header",{staticClass:"el-header",style:{height:_vm.height}},[_vm._t("default")],2);};var mainvue_type_template_id_2b296ab2_staticRenderFns=[];mainvue_type_template_id_2b296ab2_render._withStripped=true;// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var header_src_mainvue_type_script_lang_js_={name:'ElHeader',componentName:'ElHeader',props:{height:{type:String,default:'60px'}}};// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_header_src_mainvue_type_script_lang_js_=header_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/header/src/main.vue
/* normalize component */var header_src_main_component=normalizeComponent(packages_header_src_mainvue_type_script_lang_js_,mainvue_type_template_id_2b296ab2_render,mainvue_type_template_id_2b296ab2_staticRenderFns,false,null,null,null);/* hot reload */if(false){var header_src_main_api;}header_src_main_component.options.__file="packages/header/src/main.vue";/* harmony default export */var header_src_main=header_src_main_component.exports;// CONCATENATED MODULE: ./packages/header/index.js
/* istanbul ignore next */header_src_main.install=function(Vue){Vue.component(header_src_main.name,header_src_main);};/* harmony default export */var header=header_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
var mainvue_type_template_id_03411dbf_render=function mainvue_type_template_id_03411dbf_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("aside",{staticClass:"el-aside",style:{width:_vm.width}},[_vm._t("default")],2);};var mainvue_type_template_id_03411dbf_staticRenderFns=[];mainvue_type_template_id_03411dbf_render._withStripped=true;// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var aside_src_mainvue_type_script_lang_js_={name:'ElAside',componentName:'ElAside',props:{width:{type:String,default:'300px'}}};// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_aside_src_mainvue_type_script_lang_js_=aside_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/aside/src/main.vue
/* normalize component */var aside_src_main_component=normalizeComponent(packages_aside_src_mainvue_type_script_lang_js_,mainvue_type_template_id_03411dbf_render,mainvue_type_template_id_03411dbf_staticRenderFns,false,null,null,null);/* hot reload */if(false){var aside_src_main_api;}aside_src_main_component.options.__file="packages/aside/src/main.vue";/* harmony default export */var aside_src_main=aside_src_main_component.exports;// CONCATENATED MODULE: ./packages/aside/index.js
/* istanbul ignore next */aside_src_main.install=function(Vue){Vue.component(aside_src_main.name,aside_src_main);};/* harmony default export */var aside=aside_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
var mainvue_type_template_id_2a3a7406_render=function mainvue_type_template_id_2a3a7406_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("main",{staticClass:"el-main"},[_vm._t("default")],2);};var mainvue_type_template_id_2a3a7406_staticRenderFns=[];mainvue_type_template_id_2a3a7406_render._withStripped=true;// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var main_src_mainvue_type_script_lang_js_={name:'ElMain',componentName:'ElMain'};// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_main_src_mainvue_type_script_lang_js_=main_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/main/src/main.vue
/* normalize component */var main_src_main_component=normalizeComponent(packages_main_src_mainvue_type_script_lang_js_,mainvue_type_template_id_2a3a7406_render,mainvue_type_template_id_2a3a7406_staticRenderFns,false,null,null,null);/* hot reload */if(false){var main_src_main_api;}main_src_main_component.options.__file="packages/main/src/main.vue";/* harmony default export */var main_src_main=main_src_main_component.exports;// CONCATENATED MODULE: ./packages/main/index.js
/* istanbul ignore next */main_src_main.install=function(Vue){Vue.component(main_src_main.name,main_src_main);};/* harmony default export */var packages_main=main_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
var mainvue_type_template_id_80210338_render=function mainvue_type_template_id_80210338_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("footer",{staticClass:"el-footer",style:{height:_vm.height}},[_vm._t("default")],2);};var mainvue_type_template_id_80210338_staticRenderFns=[];mainvue_type_template_id_80210338_render._withStripped=true;// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var footer_src_mainvue_type_script_lang_js_={name:'ElFooter',componentName:'ElFooter',props:{height:{type:String,default:'60px'}}};// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_footer_src_mainvue_type_script_lang_js_=footer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/footer/src/main.vue
/* normalize component */var footer_src_main_component=normalizeComponent(packages_footer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_80210338_render,mainvue_type_template_id_80210338_staticRenderFns,false,null,null,null);/* hot reload */if(false){var footer_src_main_api;}footer_src_main_component.options.__file="packages/footer/src/main.vue";/* harmony default export */var footer_src_main=footer_src_main_component.exports;// CONCATENATED MODULE: ./packages/footer/index.js
/* istanbul ignore next */footer_src_main.install=function(Vue){Vue.component(footer_src_main.name,footer_src_main);};/* harmony default export */var footer=footer_src_main;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var timeline_src_mainvue_type_script_lang_js_={name:'ElTimeline',props:{reverse:{type:Boolean,default:false}},provide:function provide(){return{timeline:this};},render:function render(){var h=arguments[0];var reverse=this.reverse;var classes={'el-timeline':true,'is-reverse':reverse};var slots=this.$slots.default||[];if(reverse){slots=slots.reverse();}return h('ul',{'class':classes},[slots]);}};// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_timeline_src_mainvue_type_script_lang_js_=timeline_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/timeline/src/main.vue
var main_render,main_staticRenderFns;/* normalize component */var timeline_src_main_component=normalizeComponent(packages_timeline_src_mainvue_type_script_lang_js_,main_render,main_staticRenderFns,false,null,null,null);/* hot reload */if(false){var timeline_src_main_api;}timeline_src_main_component.options.__file="packages/timeline/src/main.vue";/* harmony default export */var timeline_src_main=timeline_src_main_component.exports;// CONCATENATED MODULE: ./packages/timeline/index.js
/* istanbul ignore next */timeline_src_main.install=function(Vue){Vue.component(timeline_src_main.name,timeline_src_main);};/* harmony default export */var timeline=timeline_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
var itemvue_type_template_id_61a69e50_render=function itemvue_type_template_id_61a69e50_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-timeline-item"},[_c("div",{staticClass:"el-timeline-item__tail"}),!_vm.$slots.dot?_c("div",{staticClass:"el-timeline-item__node",class:["el-timeline-item__node--"+(_vm.size||""),"el-timeline-item__node--"+(_vm.type||"")],style:{backgroundColor:_vm.color}},[_vm.icon?_c("i",{staticClass:"el-timeline-item__icon",class:_vm.icon}):_vm._e()]):_vm._e(),_vm.$slots.dot?_c("div",{staticClass:"el-timeline-item__dot"},[_vm._t("dot")],2):_vm._e(),_c("div",{staticClass:"el-timeline-item__wrapper"},[!_vm.hideTimestamp&&_vm.placement==="top"?_c("div",{staticClass:"el-timeline-item__timestamp is-top"},[_vm._v("\n      "+_vm._s(_vm.timestamp)+"\n    ")]):_vm._e(),_c("div",{staticClass:"el-timeline-item__content"},[_vm._t("default")],2),!_vm.hideTimestamp&&_vm.placement==="bottom"?_c("div",{staticClass:"el-timeline-item__timestamp is-bottom"},[_vm._v("\n      "+_vm._s(_vm.timestamp)+"\n    ")]):_vm._e()])]);};var itemvue_type_template_id_61a69e50_staticRenderFns=[];itemvue_type_template_id_61a69e50_render._withStripped=true;// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var timeline_src_itemvue_type_script_lang_js_={name:'ElTimelineItem',inject:['timeline'],props:{timestamp:String,hideTimestamp:{type:Boolean,default:false},placement:{type:String,default:'bottom'},type:String,color:String,size:{type:String,default:'normal'},icon:String}};// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var packages_timeline_src_itemvue_type_script_lang_js_=timeline_src_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/timeline/src/item.vue
/* normalize component */var src_item_component=normalizeComponent(packages_timeline_src_itemvue_type_script_lang_js_,itemvue_type_template_id_61a69e50_render,itemvue_type_template_id_61a69e50_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_item_api;}src_item_component.options.__file="packages/timeline/src/item.vue";/* harmony default export */var timeline_src_item=src_item_component.exports;// CONCATENATED MODULE: ./packages/timeline-item/index.js
/* istanbul ignore next */timeline_src_item.install=function(Vue){Vue.component(timeline_src_item.name,timeline_src_item);};/* harmony default export */var timeline_item=timeline_src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
var mainvue_type_template_id_01cf3b65_render=function mainvue_type_template_id_01cf3b65_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("a",_vm._b({class:["el-link",_vm.type?"el-link--"+_vm.type:"",_vm.disabled&&"is-disabled",_vm.underline&&!_vm.disabled&&"is-underline"],attrs:{href:_vm.disabled?null:_vm.href},on:{click:_vm.handleClick}},"a",_vm.$attrs,false),[_vm.icon?_c("i",{class:_vm.icon}):_vm._e(),_vm.$slots.default?_c("span",{staticClass:"el-link--inner"},[_vm._t("default")],2):_vm._e(),_vm.$slots.icon?[_vm.$slots.icon?_vm._t("icon"):_vm._e()]:_vm._e()],2);};var mainvue_type_template_id_01cf3b65_staticRenderFns=[];mainvue_type_template_id_01cf3b65_render._withStripped=true;// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var link_src_mainvue_type_script_lang_js_={name:'ElLink',props:{type:{type:String,default:'default'},underline:{type:Boolean,default:true},disabled:Boolean,href:String,icon:String},methods:{handleClick:function handleClick(event){if(!this.disabled){if(!this.href){this.$emit('click',event);}}}}};// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_link_src_mainvue_type_script_lang_js_=link_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/link/src/main.vue
/* normalize component */var link_src_main_component=normalizeComponent(packages_link_src_mainvue_type_script_lang_js_,mainvue_type_template_id_01cf3b65_render,mainvue_type_template_id_01cf3b65_staticRenderFns,false,null,null,null);/* hot reload */if(false){var link_src_main_api;}link_src_main_component.options.__file="packages/link/src/main.vue";/* harmony default export */var link_src_main=link_src_main_component.exports;// CONCATENATED MODULE: ./packages/link/index.js
/* istanbul ignore next */link_src_main.install=function(Vue){Vue.component(link_src_main.name,link_src_main);};/* harmony default export */var packages_link=link_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
var mainvue_type_template_id_7fa02a7e_functional_true_render=function mainvue_type_template_id_7fa02a7e_functional_true_render(_h,_vm){var _c=_vm._c;return _c("div",_vm._g(_vm._b({class:[_vm.data.staticClass,"el-divider","el-divider--"+_vm.props.direction]},"div",_vm.data.attrs,false),_vm.listeners),[_vm.slots().default&&_vm.props.direction!=="vertical"?_c("div",{class:["el-divider__text","is-"+_vm.props.contentPosition]},[_vm._t("default")],2):_vm._e()]);};var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns=[];mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped=true;// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var divider_src_mainvue_type_script_lang_js_={name:'ElDivider',props:{direction:{type:String,default:'horizontal',validator:function validator(val){return['horizontal','vertical'].indexOf(val)!==-1;}},contentPosition:{type:String,default:'center',validator:function validator(val){return['left','center','right'].indexOf(val)!==-1;}}}};// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_divider_src_mainvue_type_script_lang_js_=divider_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/divider/src/main.vue
/* normalize component */var divider_src_main_component=normalizeComponent(packages_divider_src_mainvue_type_script_lang_js_,mainvue_type_template_id_7fa02a7e_functional_true_render,mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,true,null,null,null);/* hot reload */if(false){var divider_src_main_api;}divider_src_main_component.options.__file="packages/divider/src/main.vue";/* harmony default export */var divider_src_main=divider_src_main_component.exports;// CONCATENATED MODULE: ./packages/divider/index.js
/* istanbul ignore next */divider_src_main.install=function(Vue){Vue.component(divider_src_main.name,divider_src_main);};/* harmony default export */var divider=divider_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
var mainvue_type_template_id_44d84a7c_render=function mainvue_type_template_id_44d84a7c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-image"},[_vm.loading?_vm._t("placeholder",[_c("div",{staticClass:"el-image__placeholder"})]):_vm.error?_vm._t("error",[_c("div",{staticClass:"el-image__error"},[_vm._v(_vm._s(_vm.t("el.image.error")))])]):_c("img",_vm._g(_vm._b({staticClass:"el-image__inner",class:{"el-image__inner--center":_vm.alignCenter,"el-image__preview":_vm.preview},style:_vm.imageStyle,attrs:{src:_vm.src},on:{click:_vm.clickHandler}},"img",_vm.$attrs,false),_vm.$listeners)),_vm.preview?[_vm.showViewer?_c("image-viewer",{attrs:{"z-index":_vm.zIndex,"initial-index":_vm.imageIndex,"on-close":_vm.closeViewer,"url-list":_vm.previewSrcList}}):_vm._e()]:_vm._e()],2);};var mainvue_type_template_id_44d84a7c_staticRenderFns=[];mainvue_type_template_id_44d84a7c_render._withStripped=true;// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
var image_viewervue_type_template_id_5e73b307_render=function image_viewervue_type_template_id_5e73b307_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"viewer-fade"}},[_c("div",{ref:"el-image-viewer__wrapper",staticClass:"el-image-viewer__wrapper",style:{"z-index":_vm.viewerZIndex},attrs:{tabindex:"-1"}},[_c("div",{staticClass:"el-image-viewer__mask",on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleMaskClick($event);}}}),_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__close",on:{click:_vm.hide}},[_c("i",{staticClass:"el-icon-close"})]),!_vm.isSingle?[_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__prev",class:{"is-disabled":!_vm.infinite&&_vm.isFirst},on:{click:_vm.prev}},[_c("i",{staticClass:"el-icon-arrow-left"})]),_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__next",class:{"is-disabled":!_vm.infinite&&_vm.isLast},on:{click:_vm.next}},[_c("i",{staticClass:"el-icon-arrow-right"})])]:_vm._e(),_c("div",{staticClass:"el-image-viewer__btn el-image-viewer__actions"},[_c("div",{staticClass:"el-image-viewer__actions__inner"},[_c("i",{staticClass:"el-icon-zoom-out",on:{click:function click($event){_vm.handleActions("zoomOut");}}}),_c("i",{staticClass:"el-icon-zoom-in",on:{click:function click($event){_vm.handleActions("zoomIn");}}}),_c("i",{staticClass:"el-image-viewer__actions__divider"}),_c("i",{class:_vm.mode.icon,on:{click:_vm.toggleMode}}),_c("i",{staticClass:"el-image-viewer__actions__divider"}),_c("i",{staticClass:"el-icon-refresh-left",on:{click:function click($event){_vm.handleActions("anticlocelise");}}}),_c("i",{staticClass:"el-icon-refresh-right",on:{click:function click($event){_vm.handleActions("clocelise");}}})])]),_c("div",{staticClass:"el-image-viewer__canvas"},_vm._l(_vm.urlList,function(url,i){return i===_vm.index?_c("img",{key:url,ref:"img",refInFor:true,staticClass:"el-image-viewer__img",style:_vm.imgStyle,attrs:{src:_vm.currentImg},on:{load:_vm.handleImgLoad,error:_vm.handleImgError,mousedown:_vm.handleMouseDown}}):_vm._e();}),0)],2)]);};var image_viewervue_type_template_id_5e73b307_staticRenderFns=[];image_viewervue_type_template_id_5e73b307_render._withStripped=true;// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
var image_viewervue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Mode={CONTAIN:{name:'contain',icon:'el-icon-full-screen'},ORIGINAL:{name:'original',icon:'el-icon-c-scale-to-original'}};var mousewheelEventName=Object(util_["isFirefox"])()?'DOMMouseScroll':'mousewheel';/* harmony default export */var image_viewervue_type_script_lang_js_={name:'elImageViewer',props:{urlList:{type:Array,default:function _default(){return[];}},zIndex:{type:Number,default:2000},onSwitch:{type:Function,default:function _default(){}},onClose:{type:Function,default:function _default(){}},initialIndex:{type:Number,default:0},appendToBody:{type:Boolean,default:true},maskClosable:{type:Boolean,default:true}},data:function data(){return{index:this.initialIndex,isShow:false,infinite:true,loading:false,mode:Mode.CONTAIN,transform:{scale:1,deg:0,offsetX:0,offsetY:0,enableTransition:false}};},computed:{isSingle:function isSingle(){return this.urlList.length<=1;},isFirst:function isFirst(){return this.index===0;},isLast:function isLast(){return this.index===this.urlList.length-1;},currentImg:function currentImg(){return this.urlList[this.index];},imgStyle:function imgStyle(){var _transform=this.transform,scale=_transform.scale,deg=_transform.deg,offsetX=_transform.offsetX,offsetY=_transform.offsetY,enableTransition=_transform.enableTransition;var style={transform:'scale('+scale+') rotate('+deg+'deg)',transition:enableTransition?'transform .3s':'','margin-left':offsetX+'px','margin-top':offsetY+'px'};if(this.mode===Mode.CONTAIN){style.maxWidth=style.maxHeight='100%';}return style;},viewerZIndex:function viewerZIndex(){var nextZIndex=popup_["PopupManager"].nextZIndex();return this.zIndex>nextZIndex?this.zIndex:nextZIndex;}},watch:{index:{handler:function handler(val){this.reset();this.onSwitch(val);}},currentImg:function currentImg(val){var _this=this;this.$nextTick(function(_){var $img=_this.$refs.img[0];if(!$img.complete){_this.loading=true;}});}},methods:{hide:function hide(){this.deviceSupportUninstall();this.onClose();},deviceSupportInstall:function deviceSupportInstall(){var _this2=this;this._keyDownHandler=function(e){e.stopPropagation();var keyCode=e.keyCode;switch(keyCode){// ESC
case 27:_this2.hide();break;// SPACE
case 32:_this2.toggleMode();break;// LEFT_ARROW
case 37:_this2.prev();break;// UP_ARROW
case 38:_this2.handleActions('zoomIn');break;// RIGHT_ARROW
case 39:_this2.next();break;// DOWN_ARROW
case 40:_this2.handleActions('zoomOut');break;}};this._mouseWheelHandler=Object(util_["rafThrottle"])(function(e){var delta=e.wheelDelta?e.wheelDelta:-e.detail;if(delta>0){_this2.handleActions('zoomIn',{zoomRate:0.015,enableTransition:false});}else{_this2.handleActions('zoomOut',{zoomRate:0.015,enableTransition:false});}});Object(dom_["on"])(document,'keydown',this._keyDownHandler);Object(dom_["on"])(document,mousewheelEventName,this._mouseWheelHandler);},deviceSupportUninstall:function deviceSupportUninstall(){Object(dom_["off"])(document,'keydown',this._keyDownHandler);Object(dom_["off"])(document,mousewheelEventName,this._mouseWheelHandler);this._keyDownHandler=null;this._mouseWheelHandler=null;},handleImgLoad:function handleImgLoad(e){this.loading=false;},handleImgError:function handleImgError(e){this.loading=false;e.target.alt='加载失败';},handleMouseDown:function handleMouseDown(e){var _this3=this;if(this.loading||e.button!==0)return;var _transform2=this.transform,offsetX=_transform2.offsetX,offsetY=_transform2.offsetY;var startX=e.pageX;var startY=e.pageY;this._dragHandler=Object(util_["rafThrottle"])(function(ev){_this3.transform.offsetX=offsetX+ev.pageX-startX;_this3.transform.offsetY=offsetY+ev.pageY-startY;});Object(dom_["on"])(document,'mousemove',this._dragHandler);Object(dom_["on"])(document,'mouseup',function(ev){Object(dom_["off"])(document,'mousemove',_this3._dragHandler);});e.preventDefault();},handleMaskClick:function handleMaskClick(){if(this.maskClosable){this.hide();}},reset:function reset(){this.transform={scale:1,deg:0,offsetX:0,offsetY:0,enableTransition:false};},toggleMode:function toggleMode(){if(this.loading)return;var modeNames=Object.keys(Mode);var modeValues=Object.values(Mode);var index=modeValues.indexOf(this.mode);var nextIndex=(index+1)%modeNames.length;this.mode=Mode[modeNames[nextIndex]];this.reset();},prev:function prev(){if(this.isFirst&&!this.infinite)return;var len=this.urlList.length;this.index=(this.index-1+len)%len;},next:function next(){if(this.isLast&&!this.infinite)return;var len=this.urlList.length;this.index=(this.index+1)%len;},handleActions:function handleActions(action){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(this.loading)return;var _zoomRate$rotateDeg$e=image_viewervue_type_script_lang_js_extends({zoomRate:0.2,rotateDeg:90,enableTransition:true},options),zoomRate=_zoomRate$rotateDeg$e.zoomRate,rotateDeg=_zoomRate$rotateDeg$e.rotateDeg,enableTransition=_zoomRate$rotateDeg$e.enableTransition;var transform=this.transform;switch(action){case'zoomOut':if(transform.scale>0.2){transform.scale=parseFloat((transform.scale-zoomRate).toFixed(3));}break;case'zoomIn':transform.scale=parseFloat((transform.scale+zoomRate).toFixed(3));break;case'clocelise':transform.deg+=rotateDeg;break;case'anticlocelise':transform.deg-=rotateDeg;break;}transform.enableTransition=enableTransition;}},mounted:function mounted(){this.deviceSupportInstall();if(this.appendToBody){document.body.appendChild(this.$el);}// add tabindex then wrapper can be focusable via Javascript
// focus wrapper so arrow key can't cause inner scroll behavior underneath
this.$refs['el-image-viewer__wrapper'].focus();},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
/* harmony default export */var src_image_viewervue_type_script_lang_js_=image_viewervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
/* normalize component */var image_viewer_component=normalizeComponent(src_image_viewervue_type_script_lang_js_,image_viewervue_type_template_id_5e73b307_render,image_viewervue_type_template_id_5e73b307_staticRenderFns,false,null,null,null);/* hot reload */if(false){var image_viewer_api;}image_viewer_component.options.__file="packages/image/src/image-viewer.vue";/* harmony default export */var image_viewer=image_viewer_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var isSupportObjectFit=function isSupportObjectFit(){return document.documentElement.style.objectFit!==undefined;};var ObjectFit={NONE:'none',CONTAIN:'contain',COVER:'cover',FILL:'fill',SCALE_DOWN:'scale-down'};var prevOverflow='';/* harmony default export */var image_src_mainvue_type_script_lang_js_={name:'ElImage',mixins:[locale_default.a],inheritAttrs:false,components:{ImageViewer:image_viewer},props:{src:String,fit:String,lazy:Boolean,scrollContainer:{},previewSrcList:{type:Array,default:function _default(){return[];}},zIndex:{type:Number,default:2000},initialIndex:Number},data:function data(){return{loading:true,error:false,show:!this.lazy,imageWidth:0,imageHeight:0,showViewer:false};},computed:{imageStyle:function imageStyle(){var fit=this.fit;if(!this.$isServer&&fit){return isSupportObjectFit()?{'object-fit':fit}:this.getImageStyle(fit);}return{};},alignCenter:function alignCenter(){return!this.$isServer&&!isSupportObjectFit()&&this.fit!==ObjectFit.FILL;},preview:function preview(){var previewSrcList=this.previewSrcList;return Array.isArray(previewSrcList)&&previewSrcList.length>0;},imageIndex:function imageIndex(){var previewIndex=0;var initialIndex=this.initialIndex;if(initialIndex>=0){previewIndex=initialIndex;return previewIndex;}var srcIndex=this.previewSrcList.indexOf(this.src);if(srcIndex>=0){previewIndex=srcIndex;return previewIndex;}return previewIndex;}},watch:{src:function src(val){this.show&&this.loadImage();},show:function show(val){val&&this.loadImage();}},mounted:function mounted(){if(this.lazy){this.addLazyLoadListener();}else{this.loadImage();}},beforeDestroy:function beforeDestroy(){this.lazy&&this.removeLazyLoadListener();},methods:{loadImage:function loadImage(){var _this=this;if(this.$isServer)return;// reset status
this.loading=true;this.error=false;var img=new Image();img.onload=function(e){return _this.handleLoad(e,img);};img.onerror=this.handleError.bind(this);// bind html attrs
// so it can behave consistently
Object.keys(this.$attrs).forEach(function(key){var value=_this.$attrs[key];img.setAttribute(key,value);});img.src=this.src;},handleLoad:function handleLoad(e,img){this.imageWidth=img.width;this.imageHeight=img.height;this.loading=false;this.error=false;},handleError:function handleError(e){this.loading=false;this.error=true;this.$emit('error',e);},handleLazyLoad:function handleLazyLoad(){if(Object(dom_["isInContainer"])(this.$el,this._scrollContainer)){this.show=true;this.removeLazyLoadListener();}},addLazyLoadListener:function addLazyLoadListener(){if(this.$isServer)return;var scrollContainer=this.scrollContainer;var _scrollContainer=null;if(Object(types_["isHtmlElement"])(scrollContainer)){_scrollContainer=scrollContainer;}else if(Object(types_["isString"])(scrollContainer)){_scrollContainer=document.querySelector(scrollContainer);}else{_scrollContainer=Object(dom_["getScrollContainer"])(this.$el);}if(_scrollContainer){this._scrollContainer=_scrollContainer;this._lazyLoadHandler=throttle_default()(200,this.handleLazyLoad);Object(dom_["on"])(_scrollContainer,'scroll',this._lazyLoadHandler);this.handleLazyLoad();}},removeLazyLoadListener:function removeLazyLoadListener(){var _scrollContainer=this._scrollContainer,_lazyLoadHandler=this._lazyLoadHandler;if(this.$isServer||!_scrollContainer||!_lazyLoadHandler)return;Object(dom_["off"])(_scrollContainer,'scroll',_lazyLoadHandler);this._scrollContainer=null;this._lazyLoadHandler=null;},/**
     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
     */getImageStyle:function getImageStyle(fit){var imageWidth=this.imageWidth,imageHeight=this.imageHeight;var _$el=this.$el,containerWidth=_$el.clientWidth,containerHeight=_$el.clientHeight;if(!imageWidth||!imageHeight||!containerWidth||!containerHeight)return{};var imageAspectRatio=imageWidth/imageHeight;var containerAspectRatio=containerWidth/containerHeight;if(fit===ObjectFit.SCALE_DOWN){var isSmaller=imageWidth<containerWidth&&imageHeight<containerHeight;fit=isSmaller?ObjectFit.NONE:ObjectFit.CONTAIN;}switch(fit){case ObjectFit.NONE:return{width:'auto',height:'auto'};case ObjectFit.CONTAIN:return imageAspectRatio<containerAspectRatio?{width:'auto'}:{height:'auto'};case ObjectFit.COVER:return imageAspectRatio<containerAspectRatio?{height:'auto'}:{width:'auto'};default:return{};}},clickHandler:function clickHandler(){// don't show viewer when preview is false
if(!this.preview){return;}// prevent body scroll
prevOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.showViewer=true;},closeViewer:function closeViewer(){document.body.style.overflow=prevOverflow;this.showViewer=false;}}};// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_image_src_mainvue_type_script_lang_js_=image_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/image/src/main.vue
/* normalize component */var image_src_main_component=normalizeComponent(packages_image_src_mainvue_type_script_lang_js_,mainvue_type_template_id_44d84a7c_render,mainvue_type_template_id_44d84a7c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var image_src_main_api;}image_src_main_component.options.__file="packages/image/src/main.vue";/* harmony default export */var image_src_main=image_src_main_component.exports;// CONCATENATED MODULE: ./packages/image/index.js
/* istanbul ignore next */image_src_main.install=function(Vue){Vue.component(image_src_main.name,image_src_main);};/* harmony default export */var packages_image=image_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
var mainvue_type_template_id_6d9756be_render=function mainvue_type_template_id_6d9756be_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-calendar"},[_c("div",{staticClass:"el-calendar__header"},[_c("div",{staticClass:"el-calendar__title"},[_vm._v("\n      "+_vm._s(_vm.i18nDate)+"\n    ")]),_vm.validatedRange.length===0?_c("div",{staticClass:"el-calendar__button-group"},[_c("el-button-group",[_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("prev-month");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.prevMonth"))+"\n        ")]),_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("today");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.today"))+"\n        ")]),_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("next-month");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.nextMonth"))+"\n        ")])],1)],1):_vm._e()]),_vm.validatedRange.length===0?_c("div",{key:"no-range",staticClass:"el-calendar__body"},[_c("date-table",{attrs:{date:_vm.date,"selected-day":_vm.realSelectedDay,"first-day-of-week":_vm.realFirstDayOfWeek},on:{pick:_vm.pickDay}})],1):_c("div",{key:"has-range",staticClass:"el-calendar__body"},_vm._l(_vm.validatedRange,function(range,index){return _c("date-table",{key:index,attrs:{date:range[0],"selected-day":_vm.realSelectedDay,range:range,"hide-header":index!==0,"first-day-of-week":_vm.realFirstDayOfWeek},on:{pick:_vm.pickDay}});}),1)]);};var mainvue_type_template_id_6d9756be_staticRenderFns=[];mainvue_type_template_id_6d9756be_render._withStripped=true;// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
// EXTERNAL MODULE: external "element-ui/lib/utils/date"
var date_=__webpack_require__(20);var date_default=/*#__PURE__*/__webpack_require__.n(date_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var src_date_tablevue_type_script_lang_js_={props:{selectedDay:String,// formated date yyyy-MM-dd
range:{type:Array,validator:function validator(val){if(!(val&&val.length))return true;var start=val[0],end=val[1];return Object(date_util_["validateRangeInOneMonth"])(start,end);}},date:Date,hideHeader:Boolean,firstDayOfWeek:Number},inject:['elCalendar'],methods:{toNestedArr:function toNestedArr(days){return Object(date_util_["range"])(days.length/7).map(function(_,index){var start=index*7;return days.slice(start,start+7);});},getFormateDate:function getFormateDate(day,type){if(!day||['prev','current','next'].indexOf(type)===-1){throw new Error('invalid day or type');}var prefix=this.curMonthDatePrefix;if(type==='prev'){prefix=this.prevMonthDatePrefix;}else if(type==='next'){prefix=this.nextMonthDatePrefix;}day=('00'+day).slice(-2);return prefix+'-'+day;},getCellClass:function getCellClass(_ref){var text=_ref.text,type=_ref.type;var classes=[type];if(type==='current'){var date=this.getFormateDate(text,type);if(date===this.selectedDay){classes.push('is-selected');}if(date===this.formatedToday){classes.push('is-today');}}return classes;},pickDay:function pickDay(_ref2){var text=_ref2.text,type=_ref2.type;var date=this.getFormateDate(text,type);this.$emit('pick',date);},cellRenderProxy:function cellRenderProxy(_ref3){var text=_ref3.text,type=_ref3.type;var h=this.$createElement;var render=this.elCalendar.$scopedSlots.dateCell;if(!render)return h('span',[text]);var day=this.getFormateDate(text,type);var date=new Date(day);var data={isSelected:this.selectedDay===day,type:type+'-month',day:day};return render({date:date,data:data});}},computed:{WEEK_DAYS:function WEEK_DAYS(){return Object(date_util_["getI18nSettings"])().dayNames;},prevMonthDatePrefix:function prevMonthDatePrefix(){var temp=new Date(this.date.getTime());temp.setDate(0);return date_default.a.format(temp,'yyyy-MM');},curMonthDatePrefix:function curMonthDatePrefix(){return date_default.a.format(this.date,'yyyy-MM');},nextMonthDatePrefix:function nextMonthDatePrefix(){var temp=new Date(this.date.getFullYear(),this.date.getMonth()+1,1);return date_default.a.format(temp,'yyyy-MM');},formatedToday:function formatedToday(){return this.elCalendar.formatedToday;},isInRange:function isInRange(){return this.range&&this.range.length;},rows:function rows(){var days=[];// if range exists, should render days in range.
if(this.isInRange){var _range=this.range,start=_range[0],end=_range[1];var currentMonthRange=Object(date_util_["range"])(end.getDate()-start.getDate()+1).map(function(_,index){return{text:start.getDate()+index,type:'current'};});var remaining=currentMonthRange.length%7;remaining=remaining===0?0:7-remaining;var nextMonthRange=Object(date_util_["range"])(remaining).map(function(_,index){return{text:index+1,type:'next'};});days=currentMonthRange.concat(nextMonthRange);}else{var date=this.date;var firstDay=Object(date_util_["getFirstDayOfMonth"])(date);firstDay=firstDay===0?7:firstDay;var firstDayOfWeek=typeof this.firstDayOfWeek==='number'?this.firstDayOfWeek:1;var offset=(7+firstDay-firstDayOfWeek)%7;var prevMonthDays=Object(date_util_["getPrevMonthLastDays"])(date,offset).map(function(day){return{text:day,type:'prev'};});var currentMonthDays=Object(date_util_["getMonthDays"])(date).map(function(day){return{text:day,type:'current'};});days=[].concat(prevMonthDays,currentMonthDays);var nextMonthDays=Object(date_util_["range"])(42-days.length).map(function(_,index){return{text:index+1,type:'next'};});days=days.concat(nextMonthDays);}return this.toNestedArr(days);},weekDays:function weekDays(){var start=this.firstDayOfWeek;var WEEK_DAYS=this.WEEK_DAYS;if(typeof start!=='number'||start===0){return WEEK_DAYS.slice();}else{return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0,start));}}},render:function render(){var _this=this;var h=arguments[0];var thead=this.hideHeader?null:h('thead',[this.weekDays.map(function(day){return h('th',{key:day},[day]);})]);return h('table',{'class':{'el-calendar-table':true,'is-range':this.isInRange},attrs:{cellspacing:'0',cellpadding:'0'}},[thead,h('tbody',[this.rows.map(function(row,index){return h('tr',{'class':{'el-calendar-table__row':true,'el-calendar-table__row--hide-border':index===0&&_this.hideHeader},key:index},[row.map(function(cell,key){return h('td',{key:key,'class':_this.getCellClass(cell),on:{'click':_this.pickDay.bind(_this,cell)}},[h('div',{'class':'el-calendar-day'},[_this.cellRenderProxy(cell)])]);})]);})])]);}};// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var calendar_src_date_tablevue_type_script_lang_js_=src_date_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
var date_table_render,date_table_staticRenderFns;/* normalize component */var src_date_table_component=normalizeComponent(calendar_src_date_tablevue_type_script_lang_js_,date_table_render,date_table_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_date_table_api;}src_date_table_component.options.__file="packages/calendar/src/date-table.vue";/* harmony default export */var src_date_table=src_date_table_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var validTypes=['prev-month','today','next-month'];var weekDays=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];var oneDay=86400000;/* harmony default export */var calendar_src_mainvue_type_script_lang_js_={name:'ElCalendar',mixins:[locale_default.a],components:{DateTable:src_date_table,ElButton:button_default.a,ElButtonGroup:button_group_default.a},props:{value:[Date,String,Number],range:{type:Array,validator:function validator(range){if(Array.isArray(range)){return range.length===2&&range.every(function(item){return typeof item==='string'||typeof item==='number'||item instanceof Date;});}else{return true;}}},firstDayOfWeek:{type:Number,default:1}},provide:function provide(){return{elCalendar:this};},methods:{pickDay:function pickDay(day){this.realSelectedDay=day;},selectDate:function selectDate(type){if(validTypes.indexOf(type)===-1){throw new Error('invalid type '+type);}var day='';if(type==='prev-month'){day=this.prevMonthDatePrefix+'-01';}else if(type==='next-month'){day=this.nextMonthDatePrefix+'-01';}else{day=this.formatedToday;}if(day===this.formatedDate)return;this.pickDay(day);},toDate:function toDate(val){if(!val){throw new Error('invalid val');}return val instanceof Date?val:new Date(val);},rangeValidator:function rangeValidator(date,isStart){var firstDayOfWeek=this.realFirstDayOfWeek;var expected=isStart?firstDayOfWeek:firstDayOfWeek===0?6:firstDayOfWeek-1;var message=(isStart?'start':'end')+' of range should be '+weekDays[expected]+'.';if(date.getDay()!==expected){console.warn('[ElementCalendar]',message,'Invalid range will be ignored.');return false;}return true;}},computed:{prevMonthDatePrefix:function prevMonthDatePrefix(){var temp=new Date(this.date.getTime());temp.setDate(0);return date_default.a.format(temp,'yyyy-MM');},curMonthDatePrefix:function curMonthDatePrefix(){return date_default.a.format(this.date,'yyyy-MM');},nextMonthDatePrefix:function nextMonthDatePrefix(){var temp=new Date(this.date.getFullYear(),this.date.getMonth()+1,1);return date_default.a.format(temp,'yyyy-MM');},formatedDate:function formatedDate(){return date_default.a.format(this.date,'yyyy-MM-dd');},i18nDate:function i18nDate(){var year=this.date.getFullYear();var month=this.date.getMonth()+1;return year+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+month);},formatedToday:function formatedToday(){return date_default.a.format(this.now,'yyyy-MM-dd');},realSelectedDay:{get:function get(){if(!this.value)return this.selectedDay;return this.formatedDate;},set:function set(val){this.selectedDay=val;var date=new Date(val);this.$emit('input',date);}},date:function date(){if(!this.value){if(this.realSelectedDay){var d=this.selectedDay.split('-');return new Date(d[0],d[1]-1,d[2]);}else if(this.validatedRange.length){return this.validatedRange[0][0];}return this.now;}else{return this.toDate(this.value);}},// if range is valid, we get a two-digit array
validatedRange:function validatedRange(){var _this=this;var range=this.range;if(!range)return[];range=range.reduce(function(prev,val,index){var date=_this.toDate(val);if(_this.rangeValidator(date,index===0)){prev=prev.concat(date);}return prev;},[]);if(range.length===2){var _range=range,start=_range[0],end=_range[1];if(start>end){console.warn('[ElementCalendar]end time should be greater than start time');return[];}// start time and end time in one month
if(Object(date_util_["validateRangeInOneMonth"])(start,end)){return[[start,end]];}var data=[];var startDay=new Date(start.getFullYear(),start.getMonth()+1,1);var lastDay=this.toDate(startDay.getTime()-oneDay);if(!Object(date_util_["validateRangeInOneMonth"])(startDay,end)){console.warn('[ElementCalendar]start time and end time interval must not exceed two months');return[];}// 第一个月的时间范围
data.push([start,lastDay]);// 下一月的时间范围，需要计算一下该月的第一个周起始日
var firstDayOfWeek=this.realFirstDayOfWeek;var nextMontFirstDay=startDay.getDay();var interval=0;if(nextMontFirstDay!==firstDayOfWeek){if(firstDayOfWeek===0){interval=7-nextMontFirstDay;}else{interval=firstDayOfWeek-nextMontFirstDay;interval=interval>0?interval:7+interval;}}startDay=this.toDate(startDay.getTime()+interval*oneDay);if(startDay.getDate()<end.getDate()){data.push([startDay,end]);}return data;}return[];},realFirstDayOfWeek:function realFirstDayOfWeek(){if(this.firstDayOfWeek<1||this.firstDayOfWeek>6){return 0;}return Math.floor(this.firstDayOfWeek);}},data:function data(){return{selectedDay:'',now:new Date()};}};// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_calendar_src_mainvue_type_script_lang_js_=calendar_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/calendar/src/main.vue
/* normalize component */var calendar_src_main_component=normalizeComponent(packages_calendar_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6d9756be_render,mainvue_type_template_id_6d9756be_staticRenderFns,false,null,null,null);/* hot reload */if(false){var calendar_src_main_api;}calendar_src_main_component.options.__file="packages/calendar/src/main.vue";/* harmony default export */var calendar_src_main=calendar_src_main_component.exports;// CONCATENATED MODULE: ./packages/calendar/index.js
/* istanbul ignore next */calendar_src_main.install=function(Vue){Vue.component(calendar_src_main.name,calendar_src_main);};/* harmony default export */var calendar=calendar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
var mainvue_type_template_id_257dd4a9_render=function mainvue_type_template_id_257dd4a9_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-fade-in"}},[_vm.visible?_c("div",{staticClass:"el-backtop",style:{right:_vm.styleRight,bottom:_vm.styleBottom},on:{click:function click($event){$event.stopPropagation();return _vm.handleClick($event);}}},[_vm._t("default",[_c("el-icon",{attrs:{name:"caret-top"}})])],2):_vm._e()]);};var mainvue_type_template_id_257dd4a9_staticRenderFns=[];mainvue_type_template_id_257dd4a9_render._withStripped=true;// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var cubic=function cubic(value){return Math.pow(value,3);};var easeInOutCubic=function easeInOutCubic(value){return value<0.5?cubic(value*2)/2:1-cubic((1-value)*2)/2;};/* harmony default export */var backtop_src_mainvue_type_script_lang_js_={name:'ElBacktop',props:{visibilityHeight:{type:Number,default:200},target:[String],right:{type:Number,default:40},bottom:{type:Number,default:40}},data:function data(){return{el:null,container:null,visible:false};},computed:{styleBottom:function styleBottom(){return this.bottom+'px';},styleRight:function styleRight(){return this.right+'px';}},mounted:function mounted(){this.init();this.throttledScrollHandler=throttle_default()(300,this.onScroll);this.container.addEventListener('scroll',this.throttledScrollHandler);},methods:{init:function init(){this.container=document;this.el=document.documentElement;if(this.target){this.el=document.querySelector(this.target);if(!this.el){throw new Error('target is not existed: '+this.target);}this.container=this.el;}},onScroll:function onScroll(){var scrollTop=this.el.scrollTop;this.visible=scrollTop>=this.visibilityHeight;},handleClick:function handleClick(e){this.scrollToTop();this.$emit('click',e);},scrollToTop:function scrollToTop(){var el=this.el;var beginTime=Date.now();var beginValue=el.scrollTop;var rAF=window.requestAnimationFrame||function(func){return setTimeout(func,16);};var frameFunc=function frameFunc(){var progress=(Date.now()-beginTime)/500;if(progress<1){el.scrollTop=beginValue*(1-easeInOutCubic(progress));rAF(frameFunc);}else{el.scrollTop=0;}};rAF(frameFunc);}},beforeDestroy:function beforeDestroy(){this.container.removeEventListener('scroll',this.throttledScrollHandler);}};// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_backtop_src_mainvue_type_script_lang_js_=backtop_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/backtop/src/main.vue
/* normalize component */var backtop_src_main_component=normalizeComponent(packages_backtop_src_mainvue_type_script_lang_js_,mainvue_type_template_id_257dd4a9_render,mainvue_type_template_id_257dd4a9_staticRenderFns,false,null,null,null);/* hot reload */if(false){var backtop_src_main_api;}backtop_src_main_component.options.__file="packages/backtop/src/main.vue";/* harmony default export */var backtop_src_main=backtop_src_main_component.exports;// CONCATENATED MODULE: ./packages/backtop/index.js
/* istanbul ignore next */backtop_src_main.install=function(Vue){Vue.component(backtop_src_main.name,backtop_src_main);};/* harmony default export */var backtop=backtop_src_main;// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
var getStyleComputedProperty=function getStyleComputedProperty(element,property){if(element===window){element=document.documentElement;}if(element.nodeType!==1){return[];}// NOTE: 1 DOM access here
var css=window.getComputedStyle(element,null);return property?css[property]:css;};var entries=function entries(obj){return Object.keys(obj||{}).map(function(key){return[key,obj[key]];});};var getPositionSize=function getPositionSize(el,prop){return el===window||el===document?document.documentElement[prop]:el[prop];};var getOffsetHeight=function getOffsetHeight(el){return getPositionSize(el,'offsetHeight');};var getClientHeight=function getClientHeight(el){return getPositionSize(el,'clientHeight');};var scope='ElInfiniteScroll';var attributes={delay:{type:Number,default:200},distance:{type:Number,default:0},disabled:{type:Boolean,default:false},immediate:{type:Boolean,default:true}};var main_getScrollOptions=function getScrollOptions(el,vm){if(!Object(types_["isHtmlElement"])(el))return{};return entries(attributes).reduce(function(map,_ref){var key=_ref[0],option=_ref[1];var type=option.type,defaultValue=option.default;var value=el.getAttribute('infinite-scroll-'+key);value=Object(types_["isUndefined"])(vm[value])?value:vm[value];switch(type){case Number:value=Number(value);value=Number.isNaN(value)?defaultValue:value;break;case Boolean:value=Object(types_["isDefined"])(value)?value==='false'?false:Boolean(value):defaultValue;break;default:value=type(value);}map[key]=value;return map;},{});};var getElementTop=function getElementTop(el){return el.getBoundingClientRect().top;};var main_handleScroll=function handleScroll(cb){var _scope=this[scope],el=_scope.el,vm=_scope.vm,container=_scope.container,observer=_scope.observer;var _getScrollOptions=main_getScrollOptions(el,vm),distance=_getScrollOptions.distance,disabled=_getScrollOptions.disabled;if(disabled)return;var containerInfo=container.getBoundingClientRect();if(!containerInfo.width&&!containerInfo.height)return;var shouldTrigger=false;if(container===el){// be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
var scrollBottom=container.scrollTop+getClientHeight(container);shouldTrigger=container.scrollHeight-scrollBottom<=distance;}else{var heightBelowTop=getOffsetHeight(el)+getElementTop(el)-getElementTop(container);var offsetHeight=getOffsetHeight(container);var borderBottom=Number.parseFloat(getStyleComputedProperty(container,'borderBottomWidth'));shouldTrigger=heightBelowTop-offsetHeight+borderBottom<=distance;}if(shouldTrigger&&Object(types_["isFunction"])(cb)){cb.call(vm);}else if(observer){observer.disconnect();this[scope].observer=null;}};/* harmony default export */var infinite_scroll_src_main={name:'InfiniteScroll',inserted:function inserted(el,binding,vnode){var cb=binding.value;var vm=vnode.context;// only include vertical scroll
var container=Object(dom_["getScrollContainer"])(el,true);var _getScrollOptions2=main_getScrollOptions(el,vm),delay=_getScrollOptions2.delay,immediate=_getScrollOptions2.immediate;var onScroll=debounce_default()(delay,main_handleScroll.bind(el,cb));el[scope]={el:el,vm:vm,container:container,onScroll:onScroll};if(container){container.addEventListener('scroll',onScroll);if(immediate){var observer=el[scope].observer=new MutationObserver(onScroll);observer.observe(container,{childList:true,subtree:true});onScroll();}}},unbind:function unbind(el){var _el$scope=el[scope],container=_el$scope.container,onScroll=_el$scope.onScroll;if(container){container.removeEventListener('scroll',onScroll);}}};// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
/* istanbul ignore next */infinite_scroll_src_main.install=function(Vue){Vue.directive(infinite_scroll_src_main.name,infinite_scroll_src_main);};/* harmony default export */var infinite_scroll=infinite_scroll_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
var mainvue_type_template_id_5070954c_render=function mainvue_type_template_id_5070954c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-page-header"},[_c("div",{staticClass:"el-page-header__left",on:{click:function click($event){_vm.$emit("back");}}},[_c("i",{staticClass:"el-icon-back"}),_c("div",{staticClass:"el-page-header__title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)]),_c("div",{staticClass:"el-page-header__content"},[_vm._t("content",[_vm._v(_vm._s(_vm.content))])],2)]);};var mainvue_type_template_id_5070954c_staticRenderFns=[];mainvue_type_template_id_5070954c_render._withStripped=true;// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var page_header_src_mainvue_type_script_lang_js_={name:'ElPageHeader',props:{title:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.pageHeader.title');}},content:String}};// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_page_header_src_mainvue_type_script_lang_js_=page_header_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/page-header/src/main.vue
/* normalize component */var page_header_src_main_component=normalizeComponent(packages_page_header_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5070954c_render,mainvue_type_template_id_5070954c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var page_header_src_main_api;}page_header_src_main_component.options.__file="packages/page-header/src/main.vue";/* harmony default export */var page_header_src_main=page_header_src_main_component.exports;// CONCATENATED MODULE: ./packages/page-header/index.js
/* istanbul ignore next */page_header_src_main.install=function(Vue){Vue.component(page_header_src_main.name,page_header_src_main);};/* harmony default export */var page_header=page_header_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
var cascader_panelvue_type_template_id_34932346_render=function cascader_panelvue_type_template_id_34932346_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-cascader-panel",_vm.border&&"is-bordered"],on:{keydown:_vm.handleKeyDown}},_vm._l(_vm.menus,function(menu,index){return _c("cascader-menu",{key:index,ref:"menu",refInFor:true,attrs:{index:index,nodes:menu}});}),1);};var cascader_panelvue_type_template_id_34932346_staticRenderFns=[];cascader_panelvue_type_template_id_34932346_render._withStripped=true;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
// EXTERNAL MODULE: external "element-ui/lib/radio"
var radio_=__webpack_require__(44);var radio_default=/*#__PURE__*/__webpack_require__.n(radio_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
var stopPropagation=function stopPropagation(e){return e.stopPropagation();};/* harmony default export */var cascader_nodevue_type_script_lang_js_={inject:['panel'],components:{ElCheckbox:checkbox_default.a,ElRadio:radio_default.a},props:{node:{required:true},nodeId:String},computed:{config:function config(){return this.panel.config;},isLeaf:function isLeaf(){return this.node.isLeaf;},isDisabled:function isDisabled(){return this.node.isDisabled;},checkedValue:function checkedValue(){return this.panel.checkedValue;},isChecked:function isChecked(){return this.node.isSameNode(this.checkedValue);},inActivePath:function inActivePath(){return this.isInPath(this.panel.activePath);},inCheckedPath:function inCheckedPath(){var _this=this;if(!this.config.checkStrictly)return false;return this.panel.checkedNodePaths.some(function(checkedPath){return _this.isInPath(checkedPath);});},value:function value(){return this.node.getValueByOption();}},methods:{handleExpand:function handleExpand(){var _this2=this;var panel=this.panel,node=this.node,isDisabled=this.isDisabled,config=this.config;var multiple=config.multiple,checkStrictly=config.checkStrictly;if(!checkStrictly&&isDisabled||node.loading)return;if(config.lazy&&!node.loaded){panel.lazyLoad(node,function(){// do not use cached leaf value here, invoke this.isLeaf to get new value.
var isLeaf=_this2.isLeaf;if(!isLeaf)_this2.handleExpand();if(multiple){// if leaf sync checked state, else clear checked state
var checked=isLeaf?node.checked:false;_this2.handleMultiCheckChange(checked);}});}else{panel.handleExpand(node);}},handleCheckChange:function handleCheckChange(){var panel=this.panel,value=this.value,node=this.node;panel.handleCheckChange(value);panel.handleExpand(node);},handleMultiCheckChange:function handleMultiCheckChange(checked){this.node.doCheck(checked);this.panel.calculateMultiCheckedValue();},isInPath:function isInPath(pathNodes){var node=this.node;var selectedPathNode=pathNodes[node.level-1]||{};return selectedPathNode.uid===node.uid;},renderPrefix:function renderPrefix(h){var isLeaf=this.isLeaf,isChecked=this.isChecked,config=this.config;var checkStrictly=config.checkStrictly,multiple=config.multiple;if(multiple){return this.renderCheckbox(h);}else if(checkStrictly){return this.renderRadio(h);}else if(isLeaf&&isChecked){return this.renderCheckIcon(h);}return null;},renderPostfix:function renderPostfix(h){var node=this.node,isLeaf=this.isLeaf;if(node.loading){return this.renderLoadingIcon(h);}else if(!isLeaf){return this.renderExpandIcon(h);}return null;},renderCheckbox:function renderCheckbox(h){var node=this.node,config=this.config,isDisabled=this.isDisabled;var events={on:{change:this.handleMultiCheckChange},nativeOn:{}};if(config.checkStrictly){// when every node is selectable, click event should not trigger expand event.
events.nativeOn.click=stopPropagation;}return h('el-checkbox',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{value:node.checked,indeterminate:node.indeterminate,disabled:isDisabled}},events]));},renderRadio:function renderRadio(h){var checkedValue=this.checkedValue,value=this.value,isDisabled=this.isDisabled;// to keep same reference if value cause radio's checked state is calculated by reference comparision;
if(Object(util_["isEqual"])(value,checkedValue)){value=checkedValue;}return h('el-radio',{attrs:{value:checkedValue,label:value,disabled:isDisabled},on:{'change':this.handleCheckChange},nativeOn:{'click':stopPropagation}},[h('span')]);},renderCheckIcon:function renderCheckIcon(h){return h('i',{'class':'el-icon-check el-cascader-node__prefix'});},renderLoadingIcon:function renderLoadingIcon(h){return h('i',{'class':'el-icon-loading el-cascader-node__postfix'});},renderExpandIcon:function renderExpandIcon(h){return h('i',{'class':'el-icon-arrow-right el-cascader-node__postfix'});},renderContent:function renderContent(h){var panel=this.panel,node=this.node;var render=panel.renderLabelFn;var vnode=render?render({node:node,data:node.data}):null;return h('span',{'class':'el-cascader-node__label'},[vnode||node.label]);}},render:function render(h){var _this3=this;var inActivePath=this.inActivePath,inCheckedPath=this.inCheckedPath,isChecked=this.isChecked,isLeaf=this.isLeaf,isDisabled=this.isDisabled,config=this.config,nodeId=this.nodeId;var expandTrigger=config.expandTrigger,checkStrictly=config.checkStrictly,multiple=config.multiple;var disabled=!checkStrictly&&isDisabled;var events={on:{}};if(expandTrigger==='click'){events.on.click=this.handleExpand;}else{events.on.mouseenter=function(e){_this3.handleExpand();_this3.$emit('expand',e);};events.on.focus=function(e){_this3.handleExpand();_this3.$emit('expand',e);};}if(isLeaf&&!isDisabled&&!checkStrictly&&!multiple){events.on.click=this.handleCheckChange;}return h('li',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{role:'menuitem',id:nodeId,'aria-expanded':inActivePath,tabindex:disabled?null:-1},'class':{'el-cascader-node':true,'is-selectable':checkStrictly,'in-active-path':inActivePath,'in-checked-path':inCheckedPath,'is-active':isChecked,'is-disabled':disabled}},events]),[this.renderPrefix(h),this.renderContent(h),this.renderPostfix(h)]);}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_nodevue_type_script_lang_js_=cascader_nodevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
var cascader_node_render,cascader_node_staticRenderFns;/* normalize component */var cascader_node_component=normalizeComponent(src_cascader_nodevue_type_script_lang_js_,cascader_node_render,cascader_node_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_node_api;}cascader_node_component.options.__file="packages/cascader-panel/src/cascader-node.vue";/* harmony default export */var cascader_node=cascader_node_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
/* harmony default export */var cascader_menuvue_type_script_lang_js_={name:'ElCascaderMenu',mixins:[locale_default.a],inject:['panel'],components:{ElScrollbar:scrollbar_default.a,CascaderNode:cascader_node},props:{nodes:{type:Array,required:true},index:Number},data:function data(){return{activeNode:null,hoverTimer:null,id:Object(util_["generateId"])()};},computed:{isEmpty:function isEmpty(){return!this.nodes.length;},menuId:function menuId(){return'cascader-menu-'+this.id+'-'+this.index;}},methods:{handleExpand:function handleExpand(e){this.activeNode=e.target;},handleMouseMove:function handleMouseMove(e){var activeNode=this.activeNode,hoverTimer=this.hoverTimer;var hoverZone=this.$refs.hoverZone;if(!activeNode||!hoverZone)return;if(activeNode.contains(e.target)){clearTimeout(hoverTimer);var _$el$getBoundingClien=this.$el.getBoundingClientRect(),left=_$el$getBoundingClien.left;var startX=e.clientX-left;var _$el=this.$el,offsetWidth=_$el.offsetWidth,offsetHeight=_$el.offsetHeight;var top=activeNode.offsetTop;var bottom=top+activeNode.offsetHeight;hoverZone.innerHTML='\n          <path style="pointer-events: auto;" fill="transparent" d="M'+startX+' '+top+' L'+offsetWidth+' 0 V'+top+' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M'+startX+' '+bottom+' L'+offsetWidth+' '+offsetHeight+' V'+bottom+' Z" />\n        ';}else if(!hoverTimer){this.hoverTimer=setTimeout(this.clearHoverZone,this.panel.config.hoverThreshold);}},clearHoverZone:function clearHoverZone(){var hoverZone=this.$refs.hoverZone;if(!hoverZone)return;hoverZone.innerHTML='';},renderEmptyText:function renderEmptyText(h){return h('div',{'class':'el-cascader-menu__empty-text'},[this.t('el.cascader.noData')]);},renderNodeList:function renderNodeList(h){var menuId=this.menuId;var isHoverMenu=this.panel.isHoverMenu;var events={on:{}};if(isHoverMenu){events.on.expand=this.handleExpand;}var nodes=this.nodes.map(function(node,index){var hasChildren=node.hasChildren;return h('cascader-node',external_babel_helper_vue_jsx_merge_props_default()([{key:node.uid,attrs:{node:node,'node-id':menuId+'-'+index,'aria-haspopup':hasChildren,'aria-owns':hasChildren?menuId:null}},events]));});return[].concat(nodes,[isHoverMenu?h('svg',{ref:'hoverZone','class':'el-cascader-menu__hover-zone'}):null]);}},render:function render(h){var isEmpty=this.isEmpty,menuId=this.menuId;var events={nativeOn:{}};// optimize hover to expand experience (#8010)
if(this.panel.isHoverMenu){events.nativeOn.mousemove=this.handleMouseMove;// events.nativeOn.mouseleave = this.clearHoverZone;
}return h('el-scrollbar',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{tag:'ul',role:'menu',id:menuId,'wrap-class':'el-cascader-menu__wrap','view-class':{'el-cascader-menu__list':true,'is-empty':isEmpty}},'class':'el-cascader-menu'},events]),[isEmpty?this.renderEmptyText(h):this.renderNodeList(h)]);}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_menuvue_type_script_lang_js_=cascader_menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
var cascader_menu_render,cascader_menu_staticRenderFns;/* normalize component */var cascader_menu_component=normalizeComponent(src_cascader_menuvue_type_script_lang_js_,cascader_menu_render,cascader_menu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_menu_api;}cascader_menu_component.options.__file="packages/cascader-panel/src/cascader-menu.vue";/* harmony default export */var cascader_menu=cascader_menu_component.exports;// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
var node_createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function src_node_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var uid=0;var src_node_Node=function(){function Node(data,config,parentNode){src_node_classCallCheck(this,Node);this.data=data;this.config=config;this.parent=parentNode||null;this.level=!this.parent?1:this.parent.level+1;this.uid=uid++;this.initState();this.initChildren();}Node.prototype.initState=function initState(){var _config=this.config,valueKey=_config.value,labelKey=_config.label;this.value=this.data[valueKey];this.label=this.data[labelKey];this.pathNodes=this.calculatePathNodes();this.path=this.pathNodes.map(function(node){return node.value;});this.pathLabels=this.pathNodes.map(function(node){return node.label;});// lazy load
this.loading=false;this.loaded=false;};Node.prototype.initChildren=function initChildren(){var _this=this;var config=this.config;var childrenKey=config.children;var childrenData=this.data[childrenKey];this.hasChildren=Array.isArray(childrenData);this.children=(childrenData||[]).map(function(child){return new Node(child,config,_this);});};Node.prototype.calculatePathNodes=function calculatePathNodes(){var nodes=[this];var parent=this.parent;while(parent){nodes.unshift(parent);parent=parent.parent;}return nodes;};Node.prototype.getPath=function getPath(){return this.path;};Node.prototype.getValue=function getValue(){return this.value;};Node.prototype.getValueByOption=function getValueByOption(){return this.config.emitPath?this.getPath():this.getValue();};Node.prototype.getText=function getText(allLevels,separator){return allLevels?this.pathLabels.join(separator):this.label;};Node.prototype.isSameNode=function isSameNode(checkedValue){var value=this.getValueByOption();return this.config.multiple&&Array.isArray(checkedValue)?checkedValue.some(function(val){return Object(util_["isEqual"])(val,value);}):Object(util_["isEqual"])(checkedValue,value);};Node.prototype.broadcast=function broadcast(event){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var handlerName='onParent'+Object(util_["capitalize"])(event);this.children.forEach(function(child){if(child){// bottom up
child.broadcast.apply(child,[event].concat(args));child[handlerName]&&child[handlerName].apply(child,args);}});};Node.prototype.emit=function emit(event){var parent=this.parent;var handlerName='onChild'+Object(util_["capitalize"])(event);if(parent){for(var _len2=arguments.length,args=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}parent[handlerName]&&parent[handlerName].apply(parent,args);parent.emit.apply(parent,[event].concat(args));}};Node.prototype.onParentCheck=function onParentCheck(checked){if(!this.isDisabled){this.setCheckState(checked);}};Node.prototype.onChildCheck=function onChildCheck(){var children=this.children;var validChildren=children.filter(function(child){return!child.isDisabled;});var checked=validChildren.length?validChildren.every(function(child){return child.checked;}):false;this.setCheckState(checked);};Node.prototype.setCheckState=function setCheckState(checked){var totalNum=this.children.length;var checkedNum=this.children.reduce(function(c,p){var num=p.checked?1:p.indeterminate?0.5:0;return c+num;},0);this.checked=checked;this.indeterminate=checkedNum!==totalNum&&checkedNum>0;};Node.prototype.syncCheckState=function syncCheckState(checkedValue){var value=this.getValueByOption();var checked=this.isSameNode(checkedValue,value);this.doCheck(checked);};Node.prototype.doCheck=function doCheck(checked){if(this.checked!==checked){if(this.config.checkStrictly){this.checked=checked;}else{// bottom up to unify the calculation of the indeterminate state
this.broadcast('check',checked);this.setCheckState(checked);this.emit('check');}}};node_createClass(Node,[{key:'isDisabled',get:function get(){var data=this.data,parent=this.parent,config=this.config;var disabledKey=config.disabled;var checkStrictly=config.checkStrictly;return data[disabledKey]||!checkStrictly&&parent&&parent.isDisabled;}},{key:'isLeaf',get:function get(){var data=this.data,loaded=this.loaded,hasChildren=this.hasChildren,children=this.children;var _config2=this.config,lazy=_config2.lazy,leafKey=_config2.leaf;if(lazy){var isLeaf=Object(shared_["isDef"])(data[leafKey])?data[leafKey]:loaded?!children.length:false;this.hasChildren=!isLeaf;return isLeaf;}return!hasChildren;}}]);return Node;}();/* harmony default export */var src_node=src_node_Node;// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
function store_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var flatNodes=function flatNodes(data,leafOnly){return data.reduce(function(res,node){if(node.isLeaf){res.push(node);}else{!leafOnly&&res.push(node);res=res.concat(flatNodes(node.children,leafOnly));}return res;},[]);};var store_Store=function(){function Store(data,config){store_classCallCheck(this,Store);this.config=config;this.initNodes(data);}Store.prototype.initNodes=function initNodes(data){var _this=this;data=Object(util_["coerceTruthyValueToArray"])(data);this.nodes=data.map(function(nodeData){return new src_node(nodeData,_this.config);});this.flattedNodes=this.getFlattedNodes(false,false);this.leafNodes=this.getFlattedNodes(true,false);};Store.prototype.appendNode=function appendNode(nodeData,parentNode){var node=new src_node(nodeData,this.config,parentNode);var children=parentNode?parentNode.children:this.nodes;children.push(node);};Store.prototype.appendNodes=function appendNodes(nodeDataList,parentNode){var _this2=this;nodeDataList=Object(util_["coerceTruthyValueToArray"])(nodeDataList);nodeDataList.forEach(function(nodeData){return _this2.appendNode(nodeData,parentNode);});};Store.prototype.getNodes=function getNodes(){return this.nodes;};Store.prototype.getFlattedNodes=function getFlattedNodes(leafOnly){var cached=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var cachedNodes=leafOnly?this.leafNodes:this.flattedNodes;return cached?cachedNodes:flatNodes(this.nodes,leafOnly);};Store.prototype.getNodeByValue=function getNodeByValue(value){var nodes=this.getFlattedNodes(false,!this.config.lazy).filter(function(node){return Object(util_["valueEquals"])(node.path,value)||node.value===value;});return nodes&&nodes.length?nodes[0]:null;};return Store;}();/* harmony default export */var cascader_panel_src_store=store_Store;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
var cascader_panelvue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var cascader_panelvue_type_script_lang_js_KeyCode=aria_utils_default.a.keys;var DefaultProps={expandTrigger:'click',// or hover
multiple:false,checkStrictly:false,// whether all nodes can be selected
emitPath:true,// wether to emit an array of all levels value in which node is located
lazy:false,lazyLoad:util_["noop"],value:'value',label:'label',children:'children',leaf:'leaf',disabled:'disabled',hoverThreshold:500};var cascader_panelvue_type_script_lang_js_isLeaf=function isLeaf(el){return!el.getAttribute('aria-owns');};var getSibling=function getSibling(el,distance){var parentNode=el.parentNode;if(parentNode){var siblings=parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');var index=Array.prototype.indexOf.call(siblings,el);return siblings[index+distance]||null;}return null;};var getMenuIndex=function getMenuIndex(el,distance){if(!el)return;var pieces=el.id.split('-');return Number(pieces[pieces.length-2]);};var focusNode=function focusNode(el){if(!el)return;el.focus();!cascader_panelvue_type_script_lang_js_isLeaf(el)&&el.click();};var checkNode=function checkNode(el){if(!el)return;var input=el.querySelector('input');if(input){input.click();}else if(cascader_panelvue_type_script_lang_js_isLeaf(el)){el.click();}};/* harmony default export */var cascader_panelvue_type_script_lang_js_={name:'ElCascaderPanel',components:{CascaderMenu:cascader_menu},props:{value:{},options:Array,props:Object,border:{type:Boolean,default:true},renderLabel:Function},provide:function provide(){return{panel:this};},data:function data(){return{checkedValue:null,checkedNodePaths:[],store:[],menus:[],activePath:[],loadCount:0};},computed:{config:function config(){return merge_default()(cascader_panelvue_type_script_lang_js_extends({},DefaultProps),this.props||{});},multiple:function multiple(){return this.config.multiple;},checkStrictly:function checkStrictly(){return this.config.checkStrictly;},leafOnly:function leafOnly(){return!this.checkStrictly;},isHoverMenu:function isHoverMenu(){return this.config.expandTrigger==='hover';},renderLabelFn:function renderLabelFn(){return this.renderLabel||this.$scopedSlots.default;}},watch:{value:function value(){this.syncCheckedValue();this.checkStrictly&&this.calculateCheckedNodePaths();},options:{handler:function handler(){this.initStore();},immediate:true,deep:true},checkedValue:function checkedValue(val){if(!Object(util_["isEqual"])(val,this.value)){this.checkStrictly&&this.calculateCheckedNodePaths();this.$emit('input',val);this.$emit('change',val);}}},mounted:function mounted(){if(!this.isEmptyValue(this.value)){this.syncCheckedValue();}},methods:{initStore:function initStore(){var config=this.config,options=this.options;if(config.lazy&&Object(util_["isEmpty"])(options)){this.lazyLoad();}else{this.store=new cascader_panel_src_store(options,config);this.menus=[this.store.getNodes()];this.syncMenuState();}},syncCheckedValue:function syncCheckedValue(){var value=this.value,checkedValue=this.checkedValue;if(!Object(util_["isEqual"])(value,checkedValue)){this.activePath=[];this.checkedValue=value;this.syncMenuState();}},syncMenuState:function syncMenuState(){var multiple=this.multiple,checkStrictly=this.checkStrictly;this.syncActivePath();multiple&&this.syncMultiCheckState();checkStrictly&&this.calculateCheckedNodePaths();this.$nextTick(this.scrollIntoView);},syncMultiCheckState:function syncMultiCheckState(){var _this=this;var nodes=this.getFlattedNodes(this.leafOnly);nodes.forEach(function(node){node.syncCheckState(_this.checkedValue);});},isEmptyValue:function isEmptyValue(val){var multiple=this.multiple,config=this.config;var emitPath=config.emitPath;if(multiple||emitPath){return Object(util_["isEmpty"])(val);}return false;},syncActivePath:function syncActivePath(){var _this2=this;var store=this.store,multiple=this.multiple,activePath=this.activePath,checkedValue=this.checkedValue;if(!Object(util_["isEmpty"])(activePath)){var nodes=activePath.map(function(node){return _this2.getNodeByValue(node.getValue());});this.expandNodes(nodes);}else if(!this.isEmptyValue(checkedValue)){var value=multiple?checkedValue[0]:checkedValue;var checkedNode=this.getNodeByValue(value)||{};var _nodes=(checkedNode.pathNodes||[]).slice(0,-1);this.expandNodes(_nodes);}else{this.activePath=[];this.menus=[store.getNodes()];}},expandNodes:function expandNodes(nodes){var _this3=this;nodes.forEach(function(node){return _this3.handleExpand(node,true/* silent */);});},calculateCheckedNodePaths:function calculateCheckedNodePaths(){var _this4=this;var checkedValue=this.checkedValue,multiple=this.multiple;var checkedValues=multiple?Object(util_["coerceTruthyValueToArray"])(checkedValue):[checkedValue];this.checkedNodePaths=checkedValues.map(function(v){var checkedNode=_this4.getNodeByValue(v);return checkedNode?checkedNode.pathNodes:[];});},handleKeyDown:function handleKeyDown(e){var target=e.target,keyCode=e.keyCode;switch(keyCode){case cascader_panelvue_type_script_lang_js_KeyCode.up:var prev=getSibling(target,-1);focusNode(prev);break;case cascader_panelvue_type_script_lang_js_KeyCode.down:var next=getSibling(target,1);focusNode(next);break;case cascader_panelvue_type_script_lang_js_KeyCode.left:var preMenu=this.$refs.menu[getMenuIndex(target)-1];if(preMenu){var expandedNode=preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');focusNode(expandedNode);}break;case cascader_panelvue_type_script_lang_js_KeyCode.right:var nextMenu=this.$refs.menu[getMenuIndex(target)+1];if(nextMenu){var firstNode=nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');focusNode(firstNode);}break;case cascader_panelvue_type_script_lang_js_KeyCode.enter:checkNode(target);break;case cascader_panelvue_type_script_lang_js_KeyCode.esc:case cascader_panelvue_type_script_lang_js_KeyCode.tab:this.$emit('close');break;default:return;}},handleExpand:function handleExpand(node,silent){var activePath=this.activePath;var level=node.level;var path=activePath.slice(0,level-1);var menus=this.menus.slice(0,level);if(!node.isLeaf){path.push(node);menus.push(node.children);}this.activePath=path;this.menus=menus;if(!silent){var pathValues=path.map(function(node){return node.getValue();});var activePathValues=activePath.map(function(node){return node.getValue();});if(!Object(util_["valueEquals"])(pathValues,activePathValues)){this.$emit('active-item-change',pathValues);// Deprecated
this.$emit('expand-change',pathValues);}}},handleCheckChange:function handleCheckChange(value){this.checkedValue=value;},lazyLoad:function lazyLoad(node,onFullfiled){var _this5=this;var config=this.config;if(!node){node=node||{root:true,level:0};this.store=new cascader_panel_src_store([],config);this.menus=[this.store.getNodes()];}node.loading=true;var resolve=function resolve(dataList){var parent=node.root?null:node;dataList&&dataList.length&&_this5.store.appendNodes(dataList,parent);node.loading=false;node.loaded=true;// dispose default value on lazy load mode
if(Array.isArray(_this5.checkedValue)){var nodeValue=_this5.checkedValue[_this5.loadCount++];var valueKey=_this5.config.value;var leafKey=_this5.config.leaf;if(Array.isArray(dataList)&&dataList.filter(function(item){return item[valueKey]===nodeValue;}).length>0){var checkedNode=_this5.store.getNodeByValue(nodeValue);if(!checkedNode.data[leafKey]){_this5.lazyLoad(checkedNode,function(){_this5.handleExpand(checkedNode);});}if(_this5.loadCount===_this5.checkedValue.length){_this5.$parent.computePresentText();}}}onFullfiled&&onFullfiled(dataList);};config.lazyLoad(node,resolve);},/**
     * public methods
    */calculateMultiCheckedValue:function calculateMultiCheckedValue(){this.checkedValue=this.getCheckedNodes(this.leafOnly).map(function(node){return node.getValueByOption();});},scrollIntoView:function scrollIntoView(){if(this.$isServer)return;var menus=this.$refs.menu||[];menus.forEach(function(menu){var menuElement=menu.$el;if(menuElement){var container=menuElement.querySelector('.el-scrollbar__wrap');var activeNode=menuElement.querySelector('.el-cascader-node.is-active')||menuElement.querySelector('.el-cascader-node.in-active-path');scroll_into_view_default()(container,activeNode);}});},getNodeByValue:function getNodeByValue(val){return this.store.getNodeByValue(val);},getFlattedNodes:function getFlattedNodes(leafOnly){var cached=!this.config.lazy;return this.store.getFlattedNodes(leafOnly,cached);},getCheckedNodes:function getCheckedNodes(leafOnly){var checkedValue=this.checkedValue,multiple=this.multiple;if(multiple){var nodes=this.getFlattedNodes(leafOnly);return nodes.filter(function(node){return node.checked;});}else{return this.isEmptyValue(checkedValue)?[]:[this.getNodeByValue(checkedValue)];}},clearCheckedNodes:function clearCheckedNodes(){var config=this.config,leafOnly=this.leafOnly;var multiple=config.multiple,emitPath=config.emitPath;if(multiple){this.getCheckedNodes(leafOnly).filter(function(node){return!node.isDisabled;}).forEach(function(node){return node.doCheck(false);});this.calculateMultiCheckedValue();}else{this.checkedValue=emitPath?[]:null;}}}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_panelvue_type_script_lang_js_=cascader_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
/* normalize component */var cascader_panel_component=normalizeComponent(src_cascader_panelvue_type_script_lang_js_,cascader_panelvue_type_template_id_34932346_render,cascader_panelvue_type_template_id_34932346_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_panel_api;}cascader_panel_component.options.__file="packages/cascader-panel/src/cascader-panel.vue";/* harmony default export */var cascader_panel=cascader_panel_component.exports;// CONCATENATED MODULE: ./packages/cascader-panel/index.js
/* istanbul ignore next */cascader_panel.install=function(Vue){Vue.component(cascader_panel.name,cascader_panel);};/* harmony default export */var packages_cascader_panel=cascader_panel;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var avatar_src_mainvue_type_script_lang_js_={name:'ElAvatar',props:{size:{type:[Number,String],validator:function validator(val){if(typeof val==='string'){return['large','medium','small'].includes(val);}return typeof val==='number';}},shape:{type:String,default:'circle',validator:function validator(val){return['circle','square'].includes(val);}},icon:String,src:String,alt:String,srcSet:String,error:Function,fit:{type:String,default:'cover'}},data:function data(){return{isImageExist:true};},computed:{avatarClass:function avatarClass(){var size=this.size,icon=this.icon,shape=this.shape;var classList=['el-avatar'];if(size&&typeof size==='string'){classList.push('el-avatar--'+size);}if(icon){classList.push('el-avatar--icon');}if(shape){classList.push('el-avatar--'+shape);}return classList.join(' ');}},methods:{handleError:function handleError(){var error=this.error;var errorFlag=error?error():undefined;if(errorFlag!==false){this.isImageExist=false;}},renderAvatar:function renderAvatar(){var h=this.$createElement;var icon=this.icon,src=this.src,alt=this.alt,isImageExist=this.isImageExist,srcSet=this.srcSet,fit=this.fit;if(isImageExist&&src){return h('img',{attrs:{src:src,alt:alt,srcSet:srcSet},on:{'error':this.handleError},style:{'object-fit':fit}});}if(icon){return h('i',{'class':icon});}return this.$slots.default;}},render:function render(){var h=arguments[0];var avatarClass=this.avatarClass,size=this.size;var sizeStyle=typeof size==='number'?{height:size+'px',width:size+'px',lineHeight:size+'px'}:{};return h('span',{'class':avatarClass,style:sizeStyle},[this.renderAvatar()]);}};// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_avatar_src_mainvue_type_script_lang_js_=avatar_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/avatar/src/main.vue
var src_main_render,src_main_staticRenderFns;/* normalize component */var avatar_src_main_component=normalizeComponent(packages_avatar_src_mainvue_type_script_lang_js_,src_main_render,src_main_staticRenderFns,false,null,null,null);/* hot reload */if(false){var avatar_src_main_api;}avatar_src_main_component.options.__file="packages/avatar/src/main.vue";/* harmony default export */var avatar_src_main=avatar_src_main_component.exports;// CONCATENATED MODULE: ./packages/avatar/index.js
/* istanbul ignore next */avatar_src_main.install=function(Vue){Vue.component(avatar_src_main.name,avatar_src_main);};/* harmony default export */var avatar=avatar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
var mainvue_type_template_id_a4885264_render=function mainvue_type_template_id_a4885264_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-drawer-fade"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-drawer__wrapper",attrs:{tabindex:"-1"}},[_c("div",{staticClass:"el-drawer__container",class:_vm.visible&&"el-drawer__open",attrs:{role:"document",tabindex:"-1"},on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{ref:"drawer",staticClass:"el-drawer",class:[_vm.direction,_vm.customClass],style:_vm.isHorizontal?"width: "+_vm.drawerSize:"height: "+_vm.drawerSize,attrs:{"aria-modal":"true","aria-labelledby":"el-drawer__title","aria-label":_vm.title,role:"dialog",tabindex:"-1"}},[_vm.withHeader?_c("header",{staticClass:"el-drawer__header",attrs:{id:"el-drawer__title"}},[_vm._t("title",[_c("span",{attrs:{role:"heading",title:_vm.title}},[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-drawer__close-btn",attrs:{"aria-label":"close "+(_vm.title||"drawer"),type:"button"},on:{click:_vm.closeDrawer}},[_c("i",{staticClass:"el-dialog__close el-icon el-icon-close"})]):_vm._e()],2):_vm._e(),_vm.rendered?_c("section",{staticClass:"el-drawer__body"},[_vm._t("default")],2):_vm._e()])])])]);};var mainvue_type_template_id_a4885264_staticRenderFns=[];mainvue_type_template_id_a4885264_render._withStripped=true;// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var drawer_src_mainvue_type_script_lang_js_={name:'ElDrawer',mixins:[popup_default.a,emitter_default.a],props:{appendToBody:{type:Boolean,default:false},beforeClose:{type:Function},customClass:{type:String,default:''},closeOnPressEscape:{type:Boolean,default:true},destroyOnClose:{type:Boolean,default:false},modal:{type:Boolean,default:true},direction:{type:String,default:'rtl',validator:function validator(val){return['ltr','rtl','ttb','btt'].indexOf(val)!==-1;}},modalAppendToBody:{type:Boolean,default:true},showClose:{type:Boolean,default:true},size:{type:[Number,String],default:'30%'},title:{type:String,default:''},visible:{type:Boolean},wrapperClosable:{type:Boolean,default:true},withHeader:{type:Boolean,default:true}},computed:{isHorizontal:function isHorizontal(){return this.direction==='rtl'||this.direction==='ltr';},drawerSize:function drawerSize(){return typeof this.size==='number'?this.size+'px':this.size;}},data:function data(){return{closed:false,prevActiveElement:null};},watch:{visible:function visible(val){var _this=this;if(val){this.closed=false;this.$emit('open');if(this.appendToBody){document.body.appendChild(this.$el);}this.prevActiveElement=document.activeElement;}else{if(!this.closed){this.$emit('close');if(this.destroyOnClose===true){this.rendered=false;}}this.$nextTick(function(){if(_this.prevActiveElement){_this.prevActiveElement.focus();}});}}},methods:{afterEnter:function afterEnter(){this.$emit('opened');},afterLeave:function afterLeave(){this.$emit('closed');},hide:function hide(cancel){if(cancel!==false){this.$emit('update:visible',false);this.$emit('close');if(this.destroyOnClose===true){this.rendered=false;}this.closed=true;}},handleWrapperClick:function handleWrapperClick(){if(this.wrapperClosable){this.closeDrawer();}},closeDrawer:function closeDrawer(){if(typeof this.beforeClose==='function'){this.beforeClose(this.hide);}else{this.hide();}},handleClose:function handleClose(){// This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
// pressing `ESC` will call this method, and also close the drawer.
// This method also calls `beforeClose` if there was one.
this.closeDrawer();}},mounted:function mounted(){if(this.visible){this.rendered=true;this.open();if(this.appendToBody){document.body.appendChild(this.$el);}}},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_drawer_src_mainvue_type_script_lang_js_=drawer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/drawer/src/main.vue
/* normalize component */var drawer_src_main_component=normalizeComponent(packages_drawer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_a4885264_render,mainvue_type_template_id_a4885264_staticRenderFns,false,null,null,null);/* hot reload */if(false){var drawer_src_main_api;}drawer_src_main_component.options.__file="packages/drawer/src/main.vue";/* harmony default export */var drawer_src_main=drawer_src_main_component.exports;// CONCATENATED MODULE: ./packages/drawer/index.js
/* istanbul ignore next */drawer_src_main.install=function(Vue){Vue.component(drawer_src_main.name,drawer_src_main);};/* harmony default export */var drawer=drawer_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/statistic/src/main.vue?vue&type=template&id=76339aa7&
var mainvue_type_template_id_76339aa7_render=function mainvue_type_template_id_76339aa7_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-statistic"},[_vm.title||_vm.$slots.title?_c("div",{staticClass:"head"},[_vm._t("title",[_c("span",{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])],2):_vm._e(),_c("div",{staticClass:"con"},[_vm.prefix||_vm.$slots.prefix?_c("span",{staticClass:"prefix"},[_vm._t("prefix",[_vm._v("\n        "+_vm._s(_vm.prefix)+"\n      ")])],2):_vm._e(),_c("span",{staticClass:"number",style:_vm.valueStyle},[_vm._t("formatter",[_vm._v(" "+_vm._s(_vm.disposeValue))])],2),_vm.suffix||_vm.$slots.suffix?_c("span",{staticClass:"suffix"},[_vm._t("suffix",[_vm._v("\n        "+_vm._s(_vm.suffix)+"\n      ")])],2):_vm._e()])]);};var mainvue_type_template_id_76339aa7_staticRenderFns=[];mainvue_type_template_id_76339aa7_render._withStripped=true;// CONCATENATED MODULE: ./packages/statistic/src/main.vue?vue&type=template&id=76339aa7&
// EXTERNAL MODULE: external "element-ui/lib/utils/lodash"
var lodash_=__webpack_require__(28);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/statistic/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var statistic_src_mainvue_type_script_lang_js_={name:'ElStatistic',data:function data(){return{disposeValue:'',timeTask:null,REFRESH_INTERVAL:1000/30};},props:{decimalSeparator:{type:String,default:'.'},groupSeparator:{type:String,default:''},precision:{type:Number,default:null},value:{type:[String,Number,Date],default:''},prefix:{type:String,default:''},suffix:{type:String,default:''},title:{type:[String,Number],default:''},timeIndices:{type:Boolean,default:false},valueStyle:{type:Object,default:function _default(){return{};}},format:{type:String,default:'HH:mm:ss:SSS'},rate:{type:Number,default:1000}},created:function created(){this.branch();},watch:{value:function value(){this.branch();},groupSeparator:function groupSeparator(){this.dispose();},mulriple:function mulriple(){this.dispose();}},methods:{branch:function branch(){var timeIndices=this.timeIndices,countDown=this.countDown,dispose=this.dispose;if(timeIndices){countDown(this.value.valueOf()||this.value);}else{dispose();}},magnification:function magnification(num){var mulriple=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1000;var groupSeparator=arguments.length>2&&arguments[2]!==undefined?arguments[2]:',';// magnification factor
var level=String(mulriple).length;return num.replace(new RegExp('(\\d)(?=(\\d{'+(level-1)+'})+$)','g'),'$1'+groupSeparator);},dispose:function dispose(){var value=this.value,rate=this.rate,groupSeparator=this.groupSeparator;if(!Object(lodash_["isNumber"])(value))return false;if(this.precision){value=value.toFixed(this.precision);}var _String$split=String(value).split('.'),integer=_String$split[0],decimal=_String$split[1];// 1000 multiplying power
if(groupSeparator){integer=this.magnification(integer,rate,groupSeparator);}var result=''+integer+(decimal?this.decimalSeparator+decimal:'');this.disposeValue=result;return result;},diffDate:function diffDate(minuend,subtrahend){return Math.max(minuend-subtrahend,0);},suspend:function suspend(isStop){if(isStop){if(this.timeTask){clearInterval(this.timeTask);this.timeTask=null;}}else{this.branch();}return this.disposeValue;},formatTimeStr:function formatTimeStr(time){var format=this.format;var escapeRegex=/\[[^\]]*]/g;var keepList=(format.match(escapeRegex)||[]).map(function(str){return str.slice(1,-1);});var timeUnits=[['Y',1000*60*60*24*365],// years
['M',1000*60*60*24*30],// months
['D',1000*60*60*24],// days
['H',1000*60*60],// hours
['m',1000*60],// minutes
['s',1000],// seconds
['S',1]// million seconds
];var formatText=Object(lodash_["reduce"])(timeUnits,function(con,item){var name=item[0];return con.replace(new RegExp(name+'+','g'),function(match){var sum=Object(lodash_["chain"])(time).divide(item[1]).floor(0).value();time-=Object(lodash_["multiply"])(sum,item[1]);return Object(lodash_["padStart"])(String(sum),String(match).length,0);});},format);var index=0;return formatText.replace(escapeRegex,function(){var match=keepList[index];index+=1;return match;});},stopTime:function stopTime(time){var result=true;// stop
if(time){this.$emit('change',time);result=false;}else{result=true;this.suspend(true);this.$emit('finish',true);}return result;},countDown:function countDown(timeVlaue){var REFRESH_INTERVAL=this.REFRESH_INTERVAL,timeTask=this.timeTask,diffDate=this.diffDate,formatTimeStr=this.formatTimeStr,stopTime=this.stopTime,suspend=this.suspend;if(timeTask)return;var than=this;this.timeTask=setInterval(function(){var diffTiem=diffDate(timeVlaue,Date.now());than.disposeValue=formatTimeStr(diffTiem);stopTime(diffTiem);},REFRESH_INTERVAL);this.$once('hook:beforeDestroy',function(){suspend(true);});}}};// CONCATENATED MODULE: ./packages/statistic/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_statistic_src_mainvue_type_script_lang_js_=statistic_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/statistic/src/main.vue
/* normalize component */var statistic_src_main_component=normalizeComponent(packages_statistic_src_mainvue_type_script_lang_js_,mainvue_type_template_id_76339aa7_render,mainvue_type_template_id_76339aa7_staticRenderFns,false,null,null,null);/* hot reload */if(false){var statistic_src_main_api;}statistic_src_main_component.options.__file="packages/statistic/src/main.vue";/* harmony default export */var statistic_src_main=statistic_src_main_component.exports;// CONCATENATED MODULE: ./packages/statistic/index.js
/* istanbul ignore next */statistic_src_main.install=function(Vue){Vue.component(statistic_src_main.name,statistic_src_main);};/* harmony default export */var statistic=statistic_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
var mainvue_type_template_id_048de730_render=function mainvue_type_template_id_048de730_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("el-popover",_vm._b({attrs:{trigger:"click"},model:{value:_vm.visible,callback:function callback($$v){_vm.visible=$$v;},expression:"visible"}},"el-popover",_vm.$attrs,false),[_c("div",{staticClass:"el-popconfirm"},[_c("p",{staticClass:"el-popconfirm__main"},[!_vm.hideIcon?_c("i",{staticClass:"el-popconfirm__icon",class:_vm.icon,style:{color:_vm.iconColor}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_c("div",{staticClass:"el-popconfirm__action"},[_c("el-button",{attrs:{size:"mini",type:_vm.cancelButtonType},on:{click:_vm.cancel}},[_vm._v("\n        "+_vm._s(_vm.displayCancelButtonText)+"\n      ")]),_c("el-button",{attrs:{size:"mini",type:_vm.confirmButtonType},on:{click:_vm.confirm}},[_vm._v("\n        "+_vm._s(_vm.displayConfirmButtonText)+"\n      ")])],1)]),_vm._t("reference",null,{slot:"reference"})],2);};var mainvue_type_template_id_048de730_staticRenderFns=[];mainvue_type_template_id_048de730_render._withStripped=true;// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
// EXTERNAL MODULE: external "element-ui/lib/popover"
var popover_=__webpack_require__(45);var popover_default=/*#__PURE__*/__webpack_require__.n(popover_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var popconfirm_src_mainvue_type_script_lang_js_={name:'ElPopconfirm',props:{title:{type:String},confirmButtonText:{type:String},cancelButtonText:{type:String},confirmButtonType:{type:String,default:'primary'},cancelButtonType:{type:String,default:'text'},icon:{type:String,default:'el-icon-question'},iconColor:{type:String,default:'#f90'},hideIcon:{type:Boolean,default:false}},components:{ElPopover:popover_default.a,ElButton:button_default.a},data:function data(){return{visible:false};},computed:{displayConfirmButtonText:function displayConfirmButtonText(){return this.confirmButtonText||Object(lib_locale_["t"])('el.popconfirm.confirmButtonText');},displayCancelButtonText:function displayCancelButtonText(){return this.cancelButtonText||Object(lib_locale_["t"])('el.popconfirm.cancelButtonText');}},methods:{confirm:function confirm(){this.visible=false;this.$emit('confirm');},cancel:function cancel(){this.visible=false;this.$emit('cancel');}}};// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_popconfirm_src_mainvue_type_script_lang_js_=popconfirm_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
/* normalize component */var popconfirm_src_main_component=normalizeComponent(packages_popconfirm_src_mainvue_type_script_lang_js_,mainvue_type_template_id_048de730_render,mainvue_type_template_id_048de730_staticRenderFns,false,null,null,null);/* hot reload */if(false){var popconfirm_src_main_api;}popconfirm_src_main_component.options.__file="packages/popconfirm/src/main.vue";/* harmony default export */var popconfirm_src_main=popconfirm_src_main_component.exports;// CONCATENATED MODULE: ./packages/popconfirm/index.js
/* istanbul ignore next */popconfirm_src_main.install=function(Vue){Vue.component(popconfirm_src_main.name,popconfirm_src_main);};/* harmony default export */var popconfirm=popconfirm_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/index.vue?vue&type=template&id=7f659269&
var srcvue_type_template_id_7f659269_render=function srcvue_type_template_id_7f659269_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",[_vm.uiLoading?[_c("div",_vm._b({class:["el-skeleton",_vm.animated?"is-animated":""]},"div",_vm.$attrs,false),[_vm._l(_vm.count,function(i){return[_vm.loading?_vm._t("template",_vm._l(_vm.rows,function(item){return _c("el-skeleton-item",{key:i+"-"+item,class:{"el-skeleton__paragraph":item!==1,"is-first":item===1,"is-last":item===_vm.rows&&_vm.rows>1},attrs:{variant:"p"}});})):_vm._e()];})],2)]:[_vm._t("default",null,null,_vm.$attrs)]],2);};var srcvue_type_template_id_7f659269_staticRenderFns=[];srcvue_type_template_id_7f659269_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/index.vue?vue&type=template&id=7f659269&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var skeleton_srcvue_type_script_lang_js_={name:'ElSkeleton',props:{animated:{type:Boolean,default:false},count:{type:Number,default:1},rows:{type:Number,default:4},loading:{type:Boolean,default:true},throttle:{type:Number,default:0}},watch:{loading:{handler:function handler(loading){var _this=this;if(this.throttle<=0){this.uiLoading=loading;return;}if(loading){clearTimeout(this.timeoutHandle);this.timeoutHandle=setTimeout(function(){_this.uiLoading=_this.loading;},this.throttle);}else{this.uiLoading=loading;}},immediate:true}},data:function data(){return{uiLoading:this.throttle<=0?this.loading:false};}};// CONCATENATED MODULE: ./packages/skeleton/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_skeleton_srcvue_type_script_lang_js_=skeleton_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/index.vue
/* normalize component */var skeleton_src_component=normalizeComponent(packages_skeleton_srcvue_type_script_lang_js_,srcvue_type_template_id_7f659269_render,srcvue_type_template_id_7f659269_staticRenderFns,false,null,null,null);/* hot reload */if(false){var skeleton_src_api;}skeleton_src_component.options.__file="packages/skeleton/src/index.vue";/* harmony default export */var skeleton_src=skeleton_src_component.exports;// CONCATENATED MODULE: ./packages/skeleton/index.js
/* istanbul ignore next */skeleton_src.install=function(Vue){Vue.component(skeleton_src.name,skeleton_src);};/* harmony default export */var skeleton=skeleton_src;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/item.vue?vue&type=template&id=4bc8804c&
var itemvue_type_template_id_4bc8804c_render=function itemvue_type_template_id_4bc8804c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-skeleton__item","el-skeleton__"+_vm.variant]},[_vm.variant==="image"?_c("img-placeholder"):_vm._e()],1);};var itemvue_type_template_id_4bc8804c_staticRenderFns=[];itemvue_type_template_id_4bc8804c_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/item.vue?vue&type=template&id=4bc8804c&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/img-placeholder.vue?vue&type=template&id=1b2cb5c0&
var img_placeholdervue_type_template_id_1b2cb5c0_render=function img_placeholdervue_type_template_id_1b2cb5c0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 1024 1024",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M64 896V128h896v768H64z m64-128l192-192 116.352 116.352L640 448l256 307.2V192H128v576z m224-480a96 96 0 1 1-0.064 192.064A96 96 0 0 1 352 288z"}})]);};var img_placeholdervue_type_template_id_1b2cb5c0_staticRenderFns=[];img_placeholdervue_type_template_id_1b2cb5c0_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue?vue&type=template&id=1b2cb5c0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/img-placeholder.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var img_placeholdervue_type_script_lang_js_={name:'ImgPlaceholder'};// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue?vue&type=script&lang=js&
/* harmony default export */var src_img_placeholdervue_type_script_lang_js_=img_placeholdervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue
/* normalize component */var img_placeholder_component=normalizeComponent(src_img_placeholdervue_type_script_lang_js_,img_placeholdervue_type_template_id_1b2cb5c0_render,img_placeholdervue_type_template_id_1b2cb5c0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var img_placeholder_api;}img_placeholder_component.options.__file="packages/skeleton/src/img-placeholder.vue";/* harmony default export */var img_placeholder=img_placeholder_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/item.vue?vue&type=script&lang=js&
var _components;//
//
//
//
//
//
/* harmony default export */var skeleton_src_itemvue_type_script_lang_js_={name:'ElSkeletonItem',props:{variant:{type:String,default:'text'}},components:(_components={},_components[img_placeholder.name]=img_placeholder,_components)};// CONCATENATED MODULE: ./packages/skeleton/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var packages_skeleton_src_itemvue_type_script_lang_js_=skeleton_src_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/item.vue
/* normalize component */var skeleton_src_item_component=normalizeComponent(packages_skeleton_src_itemvue_type_script_lang_js_,itemvue_type_template_id_4bc8804c_render,itemvue_type_template_id_4bc8804c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var skeleton_src_item_api;}skeleton_src_item_component.options.__file="packages/skeleton/src/item.vue";/* harmony default export */var skeleton_src_item=skeleton_src_item_component.exports;// CONCATENATED MODULE: ./packages/skeleton-item/index.js
/* istanbul ignore next */skeleton_src_item.install=function(Vue){Vue.component(skeleton_src_item.name,skeleton_src_item);};/* harmony default export */var skeleton_item=skeleton_src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/index.vue?vue&type=template&id=347ced91&
var srcvue_type_template_id_347ced91_render=function srcvue_type_template_id_347ced91_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-empty"},[_c("div",{staticClass:"el-empty__image",style:_vm.imageStyle},[_vm.image?_c("img",{attrs:{src:_vm.image,ondragstart:"return false"}}):_vm._t("image",[_c("img-empty")])],2),_c("div",{staticClass:"el-empty__description"},[_vm.$slots.description?_vm._t("description"):_c("p",[_vm._v(_vm._s(_vm.emptyDescription))])],2),_vm.$slots.default?_c("div",{staticClass:"el-empty__bottom"},[_vm._t("default")],2):_vm._e()]);};var srcvue_type_template_id_347ced91_staticRenderFns=[];srcvue_type_template_id_347ced91_render._withStripped=true;// CONCATENATED MODULE: ./packages/empty/src/index.vue?vue&type=template&id=347ced91&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/img-empty.vue?vue&type=template&id=42918b82&
var img_emptyvue_type_template_id_42918b82_render=function img_emptyvue_type_template_id_42918b82_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 79 86",version:"1.1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c("defs",[_c("linearGradient",{attrs:{id:"linearGradient-1-"+_vm.id,x1:"38.8503086%",y1:"0%",x2:"61.1496914%",y2:"100%"}},[_c("stop",{attrs:{"stop-color":"#FCFCFD",offset:"0%"}}),_c("stop",{attrs:{"stop-color":"#EEEFF3",offset:"100%"}})],1),_c("linearGradient",{attrs:{id:"linearGradient-2-"+_vm.id,x1:"0%",y1:"9.5%",x2:"100%",y2:"90.5%"}},[_c("stop",{attrs:{"stop-color":"#FCFCFD",offset:"0%"}}),_c("stop",{attrs:{"stop-color":"#E9EBEF",offset:"100%"}})],1),_c("rect",{attrs:{id:"path-3-"+_vm.id,x:"0",y:"0",width:"17",height:"36"}})],1),_c("g",{attrs:{id:"Illustrations",stroke:"none","stroke-width":"1",fill:"none","fill-rule":"evenodd"}},[_c("g",{attrs:{id:"B-type",transform:"translate(-1268.000000, -535.000000)"}},[_c("g",{attrs:{id:"Group-2",transform:"translate(1268.000000, 535.000000)"}},[_c("path",{attrs:{id:"Oval-Copy-2",d:"M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z",fill:"#F7F8FC"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-14",fill:"#E5E7E9",transform:"translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) ",points:"13 58 53 58 42 45 2 45"}}),_c("g",{attrs:{id:"Group-Copy",transform:"translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"}},[_c("polygon",{attrs:{id:"Rectangle-Copy-10",fill:"#E5E7E9",transform:"translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) ",points:"2.84078316e-14 3 18 3 23 7 5 7"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-11",fill:"#EDEEF2",points:"-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"}}),_c("rect",{attrs:{id:"Rectangle-Copy-12",fill:"url(#linearGradient-1-"+_vm.id+")",transform:"translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) ",x:"38",y:"7",width:"17",height:"36"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-13",fill:"#F8F9FB",transform:"translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) ",points:"24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"}})]),_c("rect",{attrs:{id:"Rectangle-Copy-15",fill:"url(#linearGradient-2-"+_vm.id+")",x:"13",y:"45",width:"40",height:"36"}}),_c("g",{attrs:{id:"Rectangle-Copy-17",transform:"translate(53.000000, 45.000000)"}},[_c("mask",{attrs:{id:"mask-4-"+_vm.id,fill:"white"}},[_c("use",{attrs:{"xlink:href":"#path-3-"+_vm.id}})]),_c("use",{attrs:{id:"Mask",fill:"#E0E3E9",transform:"translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) ","xlink:href":"#path-3-"+_vm.id}}),_c("polygon",{attrs:{id:"Rectangle-Copy",fill:"#D5D7DE",mask:"url(#mask-4-"+_vm.id+")",transform:"translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) ",points:"7 0 24 0 20 18 -1.70530257e-13 16"}})]),_c("polygon",{attrs:{id:"Rectangle-Copy-18",fill:"#F8F9FB",transform:"translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) ",points:"62 45 79 45 70 58 53 58"}})])])])]);};var img_emptyvue_type_template_id_42918b82_staticRenderFns=[];img_emptyvue_type_template_id_42918b82_render._withStripped=true;// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue?vue&type=template&id=42918b82&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/img-empty.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var img_emptyvue_type_script_lang_js_id=0;/* harmony default export */var img_emptyvue_type_script_lang_js_={name:'ImgEmpty',data:function data(){return{id:++img_emptyvue_type_script_lang_js_id};}};// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue?vue&type=script&lang=js&
/* harmony default export */var src_img_emptyvue_type_script_lang_js_=img_emptyvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue
/* normalize component */var img_empty_component=normalizeComponent(src_img_emptyvue_type_script_lang_js_,img_emptyvue_type_template_id_42918b82_render,img_emptyvue_type_template_id_42918b82_staticRenderFns,false,null,null,null);/* hot reload */if(false){var img_empty_api;}img_empty_component.options.__file="packages/empty/src/img-empty.vue";/* harmony default export */var img_empty=img_empty_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/index.vue?vue&type=script&lang=js&
var srcvue_type_script_lang_js_components;//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var empty_srcvue_type_script_lang_js_={name:'ElEmpty',components:(srcvue_type_script_lang_js_components={},srcvue_type_script_lang_js_components[img_empty.name]=img_empty,srcvue_type_script_lang_js_components),props:{image:{type:String,default:''},imageSize:Number,description:{type:String,default:''}},computed:{emptyDescription:function emptyDescription(){return this.description||Object(lib_locale_["t"])('el.empty.description');},imageStyle:function imageStyle(){return{width:this.imageSize?this.imageSize+'px':''};}}};// CONCATENATED MODULE: ./packages/empty/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_empty_srcvue_type_script_lang_js_=empty_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/empty/src/index.vue
/* normalize component */var empty_src_component=normalizeComponent(packages_empty_srcvue_type_script_lang_js_,srcvue_type_template_id_347ced91_render,srcvue_type_template_id_347ced91_staticRenderFns,false,null,null,null);/* hot reload */if(false){var empty_src_api;}empty_src_component.options.__file="packages/empty/src/index.vue";/* harmony default export */var empty_src=empty_src_component.exports;// CONCATENATED MODULE: ./packages/empty/index.js
empty_src.install=function(Vue){Vue.component(empty_src.name,empty_src);};/* harmony default export */var empty=empty_src;// CONCATENATED MODULE: ./packages/descriptions/src/descriptions-row.js
var descriptions_row_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var descriptions_row={name:'ElDescriptionsRow',props:{row:{type:Array}},inject:['elDescriptions'],render:function render(h){var elDescriptions=this.elDescriptions;var row=(this.row||[]).map(function(item){return descriptions_row_extends({},item,{label:item.slots.label||item.props.label},['labelClassName','contentClassName','labelStyle','contentStyle'].reduce(function(res,key){res[key]=item.props[key]||elDescriptions[key];return res;},{}));});if(elDescriptions.direction==='vertical'){return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref;return h('th',{'class':(_ref={'el-descriptions-item__cell':true,'el-descriptions-item__label':true,'has-colon':elDescriptions.border?false:elDescriptions.colon,'is-bordered-label':elDescriptions.border},_ref[item.labelClassName]=true,_ref),style:item.labelStyle,attrs:{colSpan:item.props.span}},[item.label]);})]),h('tr',{'class':'el-descriptions-row'},[row.map(function(item){return h('td',{'class':['el-descriptions-item__cell','el-descriptions-item__content',item.contentClassName],style:item.contentStyle,attrs:{colSpan:item.props.span}},[item.slots.default]);})])]);}if(elDescriptions.border){return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref2;return[h('th',{'class':(_ref2={'el-descriptions-item__cell':true,'el-descriptions-item__label':true,'is-bordered-label':elDescriptions.border},_ref2[item.labelClassName]=true,_ref2),style:item.labelStyle,attrs:{colSpan:'1'}},[item.label]),h('td',{'class':['el-descriptions-item__cell','el-descriptions-item__content',item.contentClassName],style:item.contentStyle,attrs:{colSpan:item.props.span*2-1}},[item.slots.default])];})])]);}return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref3;return h('td',{'class':'el-descriptions-item el-descriptions-item__cell',attrs:{colSpan:item.props.span}},[h('div',{'class':'el-descriptions-item__container'},[h('span',{'class':(_ref3={'el-descriptions-item__label':true,'has-colon':elDescriptions.colon},_ref3[item.labelClassName]=true,_ref3),style:item.labelStyle},[item.label]),h('span',{'class':['el-descriptions-item__content',item.contentClassName],style:item.contentStyle},[item.slots.default])])]);})])]);}};// CONCATENATED MODULE: ./packages/descriptions/src/index.js
var src_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var src_components;/* harmony default export */var descriptions_src={name:'ElDescriptions',components:(src_components={},src_components[descriptions_row.name]=descriptions_row,src_components),props:{border:{type:Boolean,default:false},column:{type:Number,default:3},direction:{type:String,default:'horizontal'},size:{type:String// validator: isValidComponentSize,
},title:{type:String,default:''},extra:{type:String,default:''},labelStyle:{type:Object},contentStyle:{type:Object},labelClassName:{type:String,default:''},contentClassName:{type:String,default:''},colon:{type:Boolean,default:true}},computed:{descriptionsSize:function descriptionsSize(){return this.size||(this.$ELEMENT||{}).size;}},provide:function provide(){return{elDescriptions:this};},methods:{getOptionProps:function getOptionProps(vnode){if(vnode.componentOptions){var componentOptions=vnode.componentOptions;var _componentOptions$pro=componentOptions.propsData,propsData=_componentOptions$pro===undefined?{}:_componentOptions$pro,_componentOptions$Cto=componentOptions.Ctor,Ctor=_componentOptions$Cto===undefined?{}:_componentOptions$Cto;var props=(Ctor.options||{}).props||{};var res={};for(var k in props){var v=props[k];var defaultValue=v.default;if(defaultValue!==undefined){res[k]=Object(types_["isFunction"])(defaultValue)?defaultValue.call(vnode):defaultValue;}}return src_extends({},res,propsData);}return{};},getSlots:function getSlots(vnode){var _this=this;var componentOptions=vnode.componentOptions||{};var children=vnode.children||componentOptions.children||[];var slots={};children.forEach(function(child){if(!_this.isEmptyElement(child)){var name=child.data&&child.data.slot||'default';slots[name]=slots[name]||[];if(child.tag==='template'){slots[name].push(child.children);}else{slots[name].push(child);}}});return src_extends({},slots);},isEmptyElement:function isEmptyElement(c){return!(c.tag||c.text&&c.text.trim()!=='');},filledNode:function filledNode(node,span,count){var isLast=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!node.props){node.props={};}if(span>count){node.props.span=count;}if(isLast){// set the max span, cause of the last td
node.props.span=count;}return node;},getRows:function getRows(){var _this2=this;var children=(this.$slots.default||[]).filter(function(vnode){return vnode.tag&&vnode.componentOptions&&vnode.componentOptions.Ctor.options.name==='ElDescriptionsItem';});var nodes=children.map(function(vnode){return{props:_this2.getOptionProps(vnode),slots:_this2.getSlots(vnode),vnode:vnode};});var rows=[];var temp=[];var count=this.column;nodes.forEach(function(node,index){var span=node.props.span||1;if(index===children.length-1){temp.push(_this2.filledNode(node,span,count,true));rows.push(temp);return;}if(span<count){count-=span;temp.push(node);}else{temp.push(_this2.filledNode(node,span,count));rows.push(temp);count=_this2.column;temp=[];}});return rows;}},render:function render(){var h=arguments[0];var title=this.title,extra=this.extra,border=this.border,descriptionsSize=this.descriptionsSize,$slots=this.$slots;var rows=this.getRows();return h('div',{'class':'el-descriptions'},[title||extra||$slots.title||$slots.extra?h('div',{'class':'el-descriptions__header'},[h('div',{'class':'el-descriptions__title'},[$slots.title?$slots.title:title]),h('div',{'class':'el-descriptions__extra'},[$slots.extra?$slots.extra:extra])]):null,h('div',{'class':'el-descriptions__body'},[h('table',{'class':['el-descriptions__table',{'is-bordered':border},descriptionsSize?'el-descriptions--'+descriptionsSize:'']},[rows.map(function(row){return h(descriptions_row,{attrs:{row:row}});})])])]);}};// CONCATENATED MODULE: ./packages/descriptions/index.js
/* istanbul ignore next */descriptions_src.install=function install(Vue){Vue.component(descriptions_src.name,descriptions_src);};/* harmony default export */var descriptions=descriptions_src;// CONCATENATED MODULE: ./packages/descriptions/src/descriptions-item.js
/* harmony default export */var descriptions_item={name:'ElDescriptionsItem',props:{label:{type:String,default:''},span:{type:Number,default:1},contentClassName:{type:String,default:''},contentStyle:{type:Object},labelClassName:{type:String,default:''},labelStyle:{type:Object}},render:function render(){return null;}};// CONCATENATED MODULE: ./packages/descriptions-item/index.js
/* istanbul ignore next */descriptions_item.install=function install(Vue){Vue.component(descriptions_item.name,descriptions_item);};/* harmony default export */var packages_descriptions_item=descriptions_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/index.vue?vue&type=template&id=3408b139&
var srcvue_type_template_id_3408b139_render=function srcvue_type_template_id_3408b139_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-result"},[_c("div",{staticClass:"el-result__icon"},[_vm._t("icon",[_c(_vm.iconElement,{tag:"component",class:_vm.iconElement})])],2),_vm.title||_vm.$slots.title?_c("div",{staticClass:"el-result__title"},[_vm._t("title",[_c("p",[_vm._v(_vm._s(_vm.title))])])],2):_vm._e(),_vm.subTitle||_vm.$slots.subTitle?_c("div",{staticClass:"el-result__subtitle"},[_vm._t("subTitle",[_c("p",[_vm._v(_vm._s(_vm.subTitle))])])],2):_vm._e(),_vm.$slots.extra?_c("div",{staticClass:"el-result__extra"},[_vm._t("extra")],2):_vm._e()]);};var srcvue_type_template_id_3408b139_staticRenderFns=[];srcvue_type_template_id_3408b139_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/index.vue?vue&type=template&id=3408b139&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-success.vue?vue&type=template&id=18119418&
var icon_successvue_type_template_id_18119418_render=function icon_successvue_type_template_id_18119418_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M34.5548098,16.4485711 C33.9612228,15.8504763 32.9988282,15.8504763 32.4052412,16.4485711 L32.4052412,16.4485711 L21.413757,27.5805811 L21.413757,27.5805811 L21.4034642,27.590855 C21.0097542,27.9781674 20.3766105,27.9729811 19.9892981,27.5792711 L19.9892981,27.5792711 L15.5947588,23.1121428 C15.0011718,22.514048 14.0387772,22.514048 13.4451902,23.1121428 C12.8516033,23.7102376 12.8516033,24.6799409 13.4451902,25.2780357 L13.4451902,25.2780357 L19.6260786,31.5514289 C20.2196656,32.1495237 21.1820602,32.1495237 21.7756472,31.5514289 L21.7756472,31.5514289 L34.5548098,18.614464 C35.1483967,18.0163692 35.1483967,17.0466659 34.5548098,16.4485711 Z"}})]);};var icon_successvue_type_template_id_18119418_staticRenderFns=[];icon_successvue_type_template_id_18119418_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-success.vue?vue&type=template&id=18119418&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-success.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var icon_successvue_type_script_lang_js_={name:'IconSuccess'};// CONCATENATED MODULE: ./packages/result/src/icon-success.vue?vue&type=script&lang=js&
/* harmony default export */var src_icon_successvue_type_script_lang_js_=icon_successvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/icon-success.vue
/* normalize component */var icon_success_component=normalizeComponent(src_icon_successvue_type_script_lang_js_,icon_successvue_type_template_id_18119418_render,icon_successvue_type_template_id_18119418_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_success_api;}icon_success_component.options.__file="packages/result/src/icon-success.vue";/* harmony default export */var icon_success=icon_success_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-error.vue?vue&type=template&id=21199246&
var icon_errorvue_type_template_id_21199246_render=function icon_errorvue_type_template_id_21199246_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.57818,15.42182 C32.0157534,14.8593933 31.1038797,14.8593933 30.541453,15.42182 L30.541453,15.42182 L24.0006789,21.9625941 L17.458547,15.42182 C16.8961203,14.8593933 15.9842466,14.8593933 15.42182,15.42182 C14.8593933,15.9842466 14.8593933,16.8961203 15.42182,17.458547 L15.42182,17.458547 L21.9639519,23.9993211 L15.42182,30.541453 C14.8593933,31.1038797 14.8593933,32.0157534 15.42182,32.57818 C15.9842466,33.1406067 16.8961203,33.1406067 17.458547,32.57818 L17.458547,32.57818 L24.0006789,26.0360481 L30.541453,32.57818 C31.1038797,33.1406067 32.0157534,33.1406067 32.57818,32.57818 C33.1406067,32.0157534 33.1406067,31.1038797 32.57818,30.541453 L32.57818,30.541453 L26.0374059,23.9993211 L32.57818,17.458547 C33.1406067,16.8961203 33.1406067,15.9842466 32.57818,15.42182 Z"}})]);};var icon_errorvue_type_template_id_21199246_staticRenderFns=[];icon_errorvue_type_template_id_21199246_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-error.vue?vue&type=template&id=21199246&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-error.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var icon_errorvue_type_script_lang_js_={name:'IconError'};// CONCATENATED MODULE: ./packages/result/src/icon-error.vue?vue&type=script&lang=js&
/* harmony default export */var src_icon_errorvue_type_script_lang_js_=icon_errorvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/icon-error.vue
/* normalize component */var icon_error_component=normalizeComponent(src_icon_errorvue_type_script_lang_js_,icon_errorvue_type_template_id_21199246_render,icon_errorvue_type_template_id_21199246_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_error_api;}icon_error_component.options.__file="packages/result/src/icon-error.vue";/* harmony default export */var icon_error=icon_error_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-warning.vue?vue&type=template&id=46fe8f31&
var icon_warningvue_type_template_id_46fe8f31_render=function icon_warningvue_type_template_id_46fe8f31_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,31 C22.8954305,31 22,31.8954305 22,33 C22,34.1045695 22.8954305,35 24,35 C25.1045695,35 26,34.1045695 26,33 C26,31.8954305 25.1045695,31 24,31 Z M24,14 C23.1715729,14 22.5,14.6715729 22.5,15.5 L22.5,15.5 L22.5,27.5 C22.5,28.3284271 23.1715729,29 24,29 C24.8284271,29 25.5,28.3284271 25.5,27.5 L25.5,27.5 L25.5,15.5 C25.5,14.6715729 24.8284271,14 24,14 Z"}})]);};var icon_warningvue_type_template_id_46fe8f31_staticRenderFns=[];icon_warningvue_type_template_id_46fe8f31_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue?vue&type=template&id=46fe8f31&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-warning.vue?vue&type=script&lang=ts&
/* harmony default export */var icon_warningvue_type_script_lang_ts_={name:'IconWarning'};// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue?vue&type=script&lang=ts&
/* harmony default export */var src_icon_warningvue_type_script_lang_ts_=icon_warningvue_type_script_lang_ts_;// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue
/* normalize component */var icon_warning_component=normalizeComponent(src_icon_warningvue_type_script_lang_ts_,icon_warningvue_type_template_id_46fe8f31_render,icon_warningvue_type_template_id_46fe8f31_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_warning_api;}icon_warning_component.options.__file="packages/result/src/icon-warning.vue";/* harmony default export */var icon_warning=icon_warning_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-info.vue?vue&type=template&id=19e3de69&
var icon_infovue_type_template_id_19e3de69_render=function icon_infovue_type_template_id_19e3de69_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,19 L21,19 C20.1715729,19 19.5,19.6715729 19.5,20.5 C19.5,21.3284271 20.1715729,22 21,22 L21,22 L22.5,22 L22.5,31 L21,31 C20.1715729,31 19.5,31.6715729 19.5,32.5 C19.5,33.3284271 20.1715729,34 21,34 L21,34 L27,34 C27.8284271,34 28.5,33.3284271 28.5,32.5 C28.5,31.6715729 27.8284271,31 27,31 L27,31 L25.5,31 L25.5,20.5 C25.5,19.6715729 24.8284271,19 24,19 L24,19 Z M24,13 C22.8954305,13 22,13.8954305 22,15 C22,16.1045695 22.8954305,17 24,17 C25.1045695,17 26,16.1045695 26,15 C26,13.8954305 25.1045695,13 24,13 Z"}})]);};var icon_infovue_type_template_id_19e3de69_staticRenderFns=[];icon_infovue_type_template_id_19e3de69_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-info.vue?vue&type=template&id=19e3de69&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-info.vue?vue&type=script&lang=ts&
/* harmony default export */var icon_infovue_type_script_lang_ts_={name:'IconInfo'};// CONCATENATED MODULE: ./packages/result/src/icon-info.vue?vue&type=script&lang=ts&
/* harmony default export */var src_icon_infovue_type_script_lang_ts_=icon_infovue_type_script_lang_ts_;// CONCATENATED MODULE: ./packages/result/src/icon-info.vue
/* normalize component */var icon_info_component=normalizeComponent(src_icon_infovue_type_script_lang_ts_,icon_infovue_type_template_id_19e3de69_render,icon_infovue_type_template_id_19e3de69_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_info_api;}icon_info_component.options.__file="packages/result/src/icon-info.vue";/* harmony default export */var icon_info=icon_info_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/index.vue?vue&type=script&lang=js&
var result_srcvue_type_script_lang_js_components;//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var IconMap={success:'icon-success',warning:'icon-warning',error:'icon-error',info:'icon-info'};/* harmony default export */var result_srcvue_type_script_lang_js_={name:'ElResult',components:(result_srcvue_type_script_lang_js_components={},result_srcvue_type_script_lang_js_components[icon_success.name]=icon_success,result_srcvue_type_script_lang_js_components[icon_error.name]=icon_error,result_srcvue_type_script_lang_js_components[icon_warning.name]=icon_warning,result_srcvue_type_script_lang_js_components[icon_info.name]=icon_info,result_srcvue_type_script_lang_js_components),props:{title:{type:String,default:''},subTitle:{type:String,default:''},icon:{type:String,default:'info'}},computed:{iconElement:function iconElement(){var icon=this.icon;return icon&&IconMap[icon]?IconMap[icon]:'icon-info';}}};// CONCATENATED MODULE: ./packages/result/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_result_srcvue_type_script_lang_js_=result_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/index.vue
/* normalize component */var result_src_component=normalizeComponent(packages_result_srcvue_type_script_lang_js_,srcvue_type_template_id_3408b139_render,srcvue_type_template_id_3408b139_staticRenderFns,false,null,null,null);/* hot reload */if(false){var result_src_api;}result_src_component.options.__file="packages/result/src/index.vue";/* harmony default export */var result_src=result_src_component.exports;// CONCATENATED MODULE: ./packages/result/index.js
/* istanbul ignore next */result_src.install=function(Vue){Vue.component(result_src.name,result_src);};/* harmony default export */var packages_result=result_src;// CONCATENATED MODULE: ./src/index.js
/* Automatically generated by './build/bin/build-entry.js' */var components=[packages_pagination,dialog,packages_autocomplete,packages_dropdown,packages_dropdown_menu,packages_dropdown_item,packages_menu,packages_submenu,packages_menu_item,packages_menu_item_group,packages_input,packages_input_number,packages_radio,packages_radio_group,packages_radio_button,packages_checkbox,packages_checkbox_button,packages_checkbox_group,packages_switch,packages_select,packages_option,packages_option_group,packages_button,packages_button_group,packages_table,packages_table_column,packages_date_picker,packages_time_select,packages_time_picker,popover,packages_tooltip,packages_breadcrumb,packages_breadcrumb_item,packages_form,packages_form_item,packages_tabs,packages_tab_pane,packages_tag,packages_tree,packages_alert,slider,packages_icon,packages_row,packages_col,packages_upload,packages_progress,packages_spinner,badge,card,packages_rate,packages_steps,packages_step,carousel,scrollbar,carousel_item,packages_collapse,packages_collapse_item,packages_cascader,color_picker,transfer,packages_container,header,aside,packages_main,footer,timeline,timeline_item,packages_link,divider,packages_image,calendar,backtop,page_header,packages_cascader_panel,avatar,drawer,statistic,popconfirm,skeleton,skeleton_item,empty,descriptions,packages_descriptions_item,packages_result,collapse_transition_default.a];var src_install=function install(Vue){var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};lib_locale_default.a.use(opts.locale);lib_locale_default.a.i18n(opts.i18n);components.forEach(function(component){Vue.component(component.name,component);});Vue.use(infinite_scroll);Vue.use(packages_loading.directive);Vue.prototype.$ELEMENT={size:opts.size||'',zIndex:opts.zIndex||2000};Vue.prototype.$loading=packages_loading.service;Vue.prototype.$msgbox=message_box;Vue.prototype.$alert=message_box.alert;Vue.prototype.$confirm=message_box.confirm;Vue.prototype.$prompt=message_box.prompt;Vue.prototype.$notify=notification;Vue.prototype.$message=packages_message;};/* istanbul ignore if */if(typeof window!=='undefined'&&window.Vue){src_install(window.Vue);}/* harmony default export */var src_0=__webpack_exports__["default"]={version:'2.15.14',locale:lib_locale_default.a.use,i18n:lib_locale_default.a.i18n,install:src_install,CollapseTransition:collapse_transition_default.a,Loading:packages_loading,Pagination:packages_pagination,Dialog:dialog,Autocomplete:packages_autocomplete,Dropdown:packages_dropdown,DropdownMenu:packages_dropdown_menu,DropdownItem:packages_dropdown_item,Menu:packages_menu,Submenu:packages_submenu,MenuItem:packages_menu_item,MenuItemGroup:packages_menu_item_group,Input:packages_input,InputNumber:packages_input_number,Radio:packages_radio,RadioGroup:packages_radio_group,RadioButton:packages_radio_button,Checkbox:packages_checkbox,CheckboxButton:packages_checkbox_button,CheckboxGroup:packages_checkbox_group,Switch:packages_switch,Select:packages_select,Option:packages_option,OptionGroup:packages_option_group,Button:packages_button,ButtonGroup:packages_button_group,Table:packages_table,TableColumn:packages_table_column,DatePicker:packages_date_picker,TimeSelect:packages_time_select,TimePicker:packages_time_picker,Popover:popover,Tooltip:packages_tooltip,MessageBox:message_box,Breadcrumb:packages_breadcrumb,BreadcrumbItem:packages_breadcrumb_item,Form:packages_form,FormItem:packages_form_item,Tabs:packages_tabs,TabPane:packages_tab_pane,Tag:packages_tag,Tree:packages_tree,Alert:packages_alert,Notification:notification,Slider:slider,Icon:packages_icon,Row:packages_row,Col:packages_col,Upload:packages_upload,Progress:packages_progress,Spinner:packages_spinner,Message:packages_message,Badge:badge,Card:card,Rate:packages_rate,Steps:packages_steps,Step:packages_step,Carousel:carousel,Scrollbar:scrollbar,CarouselItem:carousel_item,Collapse:packages_collapse,CollapseItem:packages_collapse_item,Cascader:packages_cascader,ColorPicker:color_picker,Transfer:transfer,Container:packages_container,Header:header,Aside:aside,Main:packages_main,Footer:footer,Timeline:timeline,TimelineItem:timeline_item,Link:packages_link,Divider:divider,Image:packages_image,Calendar:calendar,Backtop:backtop,InfiniteScroll:infinite_scroll,PageHeader:page_header,CascaderPanel:packages_cascader_panel,Avatar:avatar,Drawer:drawer,Statistic:statistic,Popconfirm:popconfirm,Skeleton:skeleton,SkeletonItem:skeleton_item,Empty:empty,Descriptions:descriptions,DescriptionsItem:packages_descriptions_item,Result:packages_result};/***/}]/******/)["default"];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;

var _date = __webpack_require__(665);

var _date2 = _interopRequireDefault(_date);

var _locale = __webpack_require__(569);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

var newArray = function newArray(start, end) {
  var result = [];
  for (var i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
};

var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
  return {
    dayNamesShort: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    dayNames: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    monthNamesShort: months.map(function (month) {
      return (0, _locale.t)('el.datepicker.months.' + month);
    }),
    monthNames: months.map(function (month, index) {
      return (0, _locale.t)('el.datepicker.month' + (index + 1));
    }),
    amPm: ['am', 'pm']
  };
};

var toDate = exports.toDate = function toDate(date) {
  return isDate(date) ? new Date(date) : null;
};

var isDate = exports.isDate = function isDate(date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
  return true;
};

var isDateObject = exports.isDateObject = function isDateObject(val) {
  return val instanceof Date;
};

var formatDate = exports.formatDate = function formatDate(date, format) {
  date = toDate(date);
  if (!date) return '';
  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
};

var parseDate = exports.parseDate = function parseDate(string, format) {
  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
};

var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (isNaN(+month)) return 31;

  return new Date(year, +month + 1, 0).getDate();
};

var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
  return isLeapYear ? 366 : 365;
};

var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
};

// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
// {prev, next} Date should work for Daylight Saving Time
// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
var prevDate = exports.prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

var nextDate = exports.nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();

  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};

var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
  if (!isDate(src)) return null;
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
  var hours = [];
  var disabledHours = [];

  (ranges || []).forEach(function (range) {
    var value = range.map(function (date) {
      return date.getHours();
    });

    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
  });

  if (disabledHours.length) {
    for (var i = 0; i < 24; i++) {
      hours[i] = disabledHours.indexOf(i) === -1;
    }
  } else {
    for (var _i = 0; _i < 24; _i++) {
      hours[_i] = false;
    }
  }

  return hours;
};

var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
  if (amount <= 0) return [];
  var temp = new Date(date.getTime());
  temp.setDate(0);
  var lastDay = temp.getDate();
  return range(amount).map(function (_, index) {
    return lastDay - (amount - index - 1);
  });
};

var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  var days = temp.getDate();
  return range(days).map(function (_, index) {
    return index + 1;
  });
};

function setRangeData(arr, start, end, value) {
  for (var i = start; i < end; i++) {
    arr[i] = value;
  }
}

var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
  var minutes = new Array(60);

  if (ranges.length > 0) {
    ranges.forEach(function (range) {
      var start = range[0];
      var end = range[1];
      var startHour = start.getHours();
      var startMinute = start.getMinutes();
      var endHour = end.getHours();
      var endMinute = end.getMinutes();
      if (startHour === hour && endHour !== hour) {
        setRangeData(minutes, startMinute, 60, true);
      } else if (startHour === hour && endHour === hour) {
        setRangeData(minutes, startMinute, endMinute + 1, true);
      } else if (startHour !== hour && endHour === hour) {
        setRangeData(minutes, 0, endMinute + 1, true);
      } else if (startHour < hour && endHour > hour) {
        setRangeData(minutes, 0, 60, true);
      }
    });
  } else {
    setRangeData(minutes, 0, 60, true);
  }
  return minutes;
};

var range = exports.range = function range(n) {
  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
  return Array.apply(null, { length: n }).map(function (_, n) {
    return n;
  });
};

var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
};

var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
  if (date == null || !time) {
    return date;
  }
  time = parseDate(time, 'HH:mm:ss');
  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
};

var clearTime = exports.clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
};

var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';

  // TODO: refactory a more elegant solution
  if (ranges.length === 0) return date;
  var normalizeDate = function normalizeDate(date) {
    return _date2.default.parse(_date2.default.format(date, format), format);
  };
  var ndate = normalizeDate(date);
  var nranges = ranges.map(function (range) {
    return range.map(normalizeDate);
  });
  if (nranges.some(function (nrange) {
    return ndate >= nrange[0] && ndate <= nrange[1];
  })) return date;

  var minDate = nranges[0][0];
  var maxDate = nranges[0][0];

  nranges.forEach(function (nrange) {
    minDate = new Date(Math.min(nrange[0], minDate));
    maxDate = new Date(Math.max(nrange[1], minDate));
  });

  var ret = ndate < minDate ? minDate : maxDate;
  // preserve Year/Month/Date
  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
};

var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
  var limitedDate = limitTimeRange(date, selectableRange, format);
  return limitedDate.getTime() === date.getTime();
};

var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

var prevMonth = exports.prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};

var nextMonth = exports.nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};

var prevYear = exports.prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};

var nextYear = exports.nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};

var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
};

var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
};

var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Törlés'
    },
    datepicker: {
      now: 'Most',
      today: 'Ma',
      cancel: 'Mégse',
      clear: 'Törlés',
      confirm: 'OK',
      selectDate: 'Dátum',
      selectTime: 'Időpont',
      startDate: 'Dátum-tól',
      startTime: 'Időpont-tól',
      endDate: 'Dátum-ig',
      endTime: 'Időpont-ig',
      prevYear: 'Előző év',
      nextYear: 'Következő év',
      prevMonth: 'Előző hónap',
      nextMonth: 'Következő hónap',
      year: '',
      month1: 'Január',
      month2: 'Február',
      month3: 'Március',
      month4: 'Április',
      month5: 'Május',
      month6: 'Június',
      month7: 'Július',
      month8: 'Augusztus',
      month9: 'Szeptember',
      month10: 'Október',
      month11: 'November',
      month12: 'December',
      weeks: {
        sun: 'Vas',
        mon: 'Hét',
        tue: 'Ked',
        wed: 'Sze',
        thu: 'Csü',
        fri: 'Pén',
        sat: 'Szo'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Már',
        apr: 'Ápr',
        may: 'Máj',
        jun: 'Jún',
        jul: 'Júl',
        aug: 'Aug',
        sep: 'Szep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Betöltés',
      noMatch: 'Nincs találat',
      noData: 'Nincs adat',
      placeholder: 'Válassz'
    },
    cascader: {
      noMatch: 'Nincs találat',
      loading: 'Betöltés',
      placeholder: 'Válassz',
      noData: 'Nincs adat'
    },
    pagination: {
      goto: 'Ugrás',
      pagesize: '/oldal',
      total: 'Össz {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Üzenet',
      confirm: 'OK',
      cancel: 'Mégse',
      error: 'Hibás adat'
    },
    upload: {
      deleteTip: 'kattints a törléshez',
      delete: 'Törlés',
      preview: 'Előnézet',
      continue: 'Tovább'
    },
    table: {
      emptyText: 'Nincs adat',
      confirmFilter: 'Megerősít',
      resetFilter: 'Alaphelyet',
      clearFilter: 'Mind',
      sumText: 'Összeg'
    },
    tree: {
      emptyText: 'Nincs adat'
    },
    transfer: {
      noMatch: 'Nincs találat',
      noData: 'Nincs adat',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Kulcsszó',
      noCheckedFormat: '{total} elem',
      hasCheckedFormat: '{checked}/{total} kiválasztva'
    },
    image: {
      error: 'FAILED' // to be translated
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No' // to be translated
    },
    empty: {
      description: 'Nincs adat'
    }
  }
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
    return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);

    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return clone && isMergeableObject(value) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination;
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination;
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument);
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument);
    } else {
        return mergeObject(target, source, optionsArgument);
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
    });
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};

var _util = __webpack_require__(73);

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(32);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(98);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasModal = false;
var hasInitZIndex = false;
var zIndex = void 0;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set: function set(value) {
    zIndex = value;
  }
});

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.Popper = factory();
    }
})(undefined, function () {

    'use strict';

    var root = window;

    // default options
    var DEFAULTS = {
        // placement of the popper
        placement: 'bottom',

        gpuAcceleration: true,

        // shift popper from its origin by the given amount of pixels (can be negative)
        offset: 0,

        // the element which will act as boundary of the popper
        boundariesElement: 'viewport',

        // amount of pixel used to define a minimum distance between the boundaries and the popper
        boundariesPadding: 5,

        // popper will try to prevent overflow following this order,
        // by default, then, it could overflow on the left and on top of the boundariesElement
        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],

        // the behavior used by flip to change the placement of the popper
        flipBehavior: 'flip',

        arrowElement: '[x-arrow]',

        arrowOffset: 0,

        // list of functions used to modify the offsets before they are applied to the popper
        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],

        modifiersIgnored: [],

        forceAbsolute: false
    };

    /**
     * Create a new Popper.js instance
     * @constructor Popper
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement|Object} popper
     *      The HTML element used as popper, or a configuration used to generate the popper.
     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
     * @param {Object} options
     * @param {String} [options.placement=bottom]
     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
     *      left(-start, -end)`
     *
     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
     *      reference element.
     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
     *
     * @param {Boolean} [options.gpuAcceleration=true]
     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
     *      browser to use the GPU to accelerate the rendering.
     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
     *
     * @param {Number} [options.offset=0]
     *      Amount of pixels the popper will be shifted (can be negative).
     *
     * @param {String|Element} [options.boundariesElement='viewport']
     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
     *      of the defined boundaries (except if `keepTogether` is enabled)
     *
     * @param {Number} [options.boundariesPadding=5]
     *      Additional padding for the boundaries
     *
     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
     *      this means that the last ones will never overflow
     *
     * @param {String|Array} [options.flipBehavior='flip']
     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
     *      its axis (`right - left`, `top - bottom`).
     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
     *
     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
     *      to this array to edit the offsets and placement.
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Array} [options.modifiersIgnored=[]]
     *      Put here any built-in modifier name you want to exclude from the modifiers list
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Boolean} [options.removeOnDestroy=false]
     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
     */
    function Popper(reference, popper, options) {
        this._reference = reference.jquery ? reference[0] : reference;
        this.state = {};

        // if the popper variable is a configuration object, parse it to generate an HTMLElement
        // generate a default popper if is not defined
        var isNotDefined = typeof popper === 'undefined' || popper === null;
        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
        if (isNotDefined || isConfig) {
            this._popper = this.parse(isConfig ? popper : {});
        }
        // otherwise, use the given HTMLElement as popper
        else {
                this._popper = popper.jquery ? popper[0] : popper;
            }

        // with {} we create a new object with the options inside it
        this._options = Object.assign({}, DEFAULTS, options);

        // refactoring modifiers' list
        this._options.modifiers = this._options.modifiers.map(function (modifier) {
            // remove ignored modifiers
            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;

            // set the x-placement attribute before everything else because it could be used to add margins to the popper
            // margins needs to be calculated to get the correct popper offsets
            if (modifier === 'applyStyle') {
                this._popper.setAttribute('x-placement', this._options.placement);
            }

            // return predefined modifier identified by string or keep the custom one
            return this.modifiers[modifier] || modifier;
        }.bind(this));

        // make sure to apply the popper position before any computation
        this.state.position = this._getPosition(this._popper, this._reference);
        setStyle(this._popper, { position: this.state.position, top: 0 });

        // fire the first update to position the popper in the right place
        this.update();

        // setup event listeners, they will take care of update the position in specific situations
        this._setupEventListeners();
        return this;
    }

    //
    // Methods
    //
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */
    Popper.prototype.destroy = function () {
        this._popper.removeAttribute('x-placement');
        this._popper.style.left = '';
        this._popper.style.position = '';
        this._popper.style.top = '';
        this._popper.style[getSupportedPropertyName('transform')] = '';
        this._removeEventListeners();

        // remove the popper if user explicity asked for the deletion on destroy
        if (this._options.removeOnDestroy) {
            this._popper.remove();
        }
        return this;
    };

    /**
     * Updates the position of the popper, computing the new offsets and applying the new style
     * @method
     * @memberof Popper
     */
    Popper.prototype.update = function () {
        var data = { instance: this, styles: {} };

        // store placement inside the data object, modifiers will be able to edit `placement` if needed
        // and refer to _originalPlacement to know the original value
        data.placement = this._options.placement;
        data._originalPlacement = this._options.placement;

        // compute the popper and reference offsets and put them inside data.offsets
        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);

        // get boundaries
        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);

        data = this.runModifiers(data, this._options.modifiers);

        if (typeof this.state.updateCallback === 'function') {
            this.state.updateCallback(data);
        }
    };

    /**
     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onCreate = function (callback) {
        // the createCallbacks return as first argument the popper instance
        callback(this);
        return this;
    };

    /**
     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
     * used to style popper and its arrow.
     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onUpdate = function (callback) {
        this.state.updateCallback = callback;
        return this;
    };

    /**
     * Helper used to generate poppers from a configuration file
     * @method
     * @memberof Popper
     * @param config {Object} configuration
     * @returns {HTMLElement} popper
     */
    Popper.prototype.parse = function (config) {
        var defaultConfig = {
            tagName: 'div',
            classNames: ['popper'],
            attributes: [],
            parent: root.document.body,
            content: '',
            contentType: 'text',
            arrowTagName: 'div',
            arrowClassNames: ['popper__arrow'],
            arrowAttributes: ['x-arrow']
        };
        config = Object.assign({}, defaultConfig, config);

        var d = root.document;

        var popper = d.createElement(config.tagName);
        addClassNames(popper, config.classNames);
        addAttributes(popper, config.attributes);
        if (config.contentType === 'node') {
            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
        } else if (config.contentType === 'html') {
            popper.innerHTML = config.content;
        } else {
            popper.textContent = config.content;
        }

        if (config.arrowTagName) {
            var arrow = d.createElement(config.arrowTagName);
            addClassNames(arrow, config.arrowClassNames);
            addAttributes(arrow, config.arrowAttributes);
            popper.appendChild(arrow);
        }

        var parent = config.parent.jquery ? config.parent[0] : config.parent;

        // if the given parent is a string, use it to match an element
        // if more than one element is matched, the first one will be used as parent
        // if no elements are matched, the script will throw an error
        if (typeof parent === 'string') {
            parent = d.querySelectorAll(config.parent);
            if (parent.length > 1) {
                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
            }
            if (parent.length === 0) {
                throw 'ERROR: the given `parent` doesn\'t exists!';
            }
            parent = parent[0];
        }
        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
        // the first one will be used as parent
        if (parent.length > 1 && parent instanceof Element === false) {
            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
            parent = parent[0];
        }

        // append the generated popper to its parent
        parent.appendChild(popper);

        return popper;

        /**
         * Adds class names to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} classes
         */
        function addClassNames(element, classNames) {
            classNames.forEach(function (className) {
                element.classList.add(className);
            });
        }

        /**
         * Adds attributes to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} attributes
         * @example
         * addAttributes(element, [ 'data-info:foobar' ]);
         */
        function addAttributes(element, attributes) {
            attributes.forEach(function (attribute) {
                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
            });
        }
    };

    /**
     * Helper used to get the position which will be applied to the popper
     * @method
     * @memberof Popper
     * @param config {HTMLElement} popper element
     * @param reference {HTMLElement} reference element
     * @returns {String} position
     */
    Popper.prototype._getPosition = function (popper, reference) {
        var container = getOffsetParent(reference);

        if (this._options.forceAbsolute) {
            return 'absolute';
        }

        // Decide if the popper will be fixed
        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
        var isParentFixed = isFixed(reference, container);
        return isParentFixed ? 'fixed' : 'absolute';
    };

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper
     * @access private
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    Popper.prototype._getOffsets = function (popper, reference, placement) {
        placement = placement.split('-')[0];
        var popperOffsets = {};

        popperOffsets.position = this.state.position;
        var isParentFixed = popperOffsets.position === 'fixed';

        //
        // Get reference element position
        //
        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);

        //
        // Get popper sizes
        //
        var popperRect = getOuterSizes(popper);

        //
        // Compute offsets of popper
        //

        // depending by the popper placement we have to compute its offsets slightly differently
        if (['right', 'left'].indexOf(placement) !== -1) {
            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
            if (placement === 'left') {
                popperOffsets.left = referenceOffsets.left - popperRect.width;
            } else {
                popperOffsets.left = referenceOffsets.right;
            }
        } else {
            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
            if (placement === 'top') {
                popperOffsets.top = referenceOffsets.top - popperRect.height;
            } else {
                popperOffsets.top = referenceOffsets.bottom;
            }
        }

        // Add width and height to our offsets object
        popperOffsets.width = popperRect.width;
        popperOffsets.height = popperRect.height;

        return {
            popper: popperOffsets,
            reference: referenceOffsets
        };
    };

    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._setupEventListeners = function () {
        // NOTE: 1 DOM access here
        this.state.updateBound = this.update.bind(this);
        root.addEventListener('resize', this.state.updateBound);
        // if the boundariesElement is window we don't need to listen for the scroll event
        if (this._options.boundariesElement !== 'window') {
            var target = getScrollParent(this._reference);
            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
            if (target === root.document.body || target === root.document.documentElement) {
                target = root;
            }
            target.addEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = target;
        }
    };

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._removeEventListeners = function () {
        // NOTE: 1 DOM access here
        root.removeEventListener('resize', this.state.updateBound);
        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = null;
        }
        this.state.updateBound = null;
    };

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper
     * @access private
     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
     * @param {Number} padding - Boundaries padding
     * @param {Element} boundariesElement - Element used to define the boundaries
     * @returns {Object} Coordinates of the boundaries
     */
    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
        // NOTE: 1 DOM access here
        var boundaries = {};
        var width, height;
        if (boundariesElement === 'window') {
            var body = root.document.body,
                html = root.document.documentElement;

            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);

            boundaries = {
                top: 0,
                right: width,
                bottom: height,
                left: 0
            };
        } else if (boundariesElement === 'viewport') {
            var offsetParent = getOffsetParent(this._popper);
            var scrollParent = getScrollParent(this._popper);
            var offsetParentRect = getOffsetRect(offsetParent);

            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
            var getScrollTopValue = function getScrollTopValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
            };
            var getScrollLeftValue = function getScrollLeftValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
            };

            // if the popper is fixed we don't have to substract scrolling from the boundaries
            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);

            boundaries = {
                top: 0 - (offsetParentRect.top - scrollTop),
                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
                left: 0 - (offsetParentRect.left - scrollLeft)
            };
        } else {
            if (getOffsetParent(this._popper) === boundariesElement) {
                boundaries = {
                    top: 0,
                    left: 0,
                    right: boundariesElement.clientWidth,
                    bottom: boundariesElement.clientHeight
                };
            } else {
                boundaries = getOffsetRect(boundariesElement);
            }
        }
        boundaries.left += padding;
        boundaries.right -= padding;
        boundaries.top = boundaries.top + padding;
        boundaries.bottom = boundaries.bottom - padding;
        return boundaries;
    };

    /**
     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
     * @method
     * @memberof Popper
     * @access public
     * @param {Object} data
     * @param {Array} modifiers
     * @param {Function} ends
     */
    Popper.prototype.runModifiers = function (data, modifiers, ends) {
        var modifiersToRun = modifiers.slice();
        if (ends !== undefined) {
            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
        }

        modifiersToRun.forEach(function (modifier) {
            if (isFunction(modifier)) {
                data = modifier.call(this, data);
            }
        }.bind(this));

        return data;
    };

    /**
     * Helper used to know if the given modifier depends from another one.
     * @method
     * @memberof Popper
     * @param {String} requesting - name of requesting modifier
     * @param {String} requested - name of requested modifier
     * @returns {Boolean}
     */
    Popper.prototype.isModifierRequired = function (requesting, requested) {
        var index = getArrayKeyIndex(this._options.modifiers, requesting);
        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
            return modifier === requested;
        }).length;
    };

    //
    // Modifiers
    //

    /**
     * Modifiers list
     * @namespace Popper.modifiers
     * @memberof Popper
     * @type {Object}
     */
    Popper.prototype.modifiers = {};

    /**
     * Apply the computed styles to the popper element
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The same data object
     */
    Popper.prototype.modifiers.applyStyle = function (data) {
        // apply the final offsets to the popper
        // NOTE: 1 DOM access here
        var styles = {
            position: data.offsets.popper.position
        };

        // round top and left to avoid blurry text
        var left = Math.round(data.offsets.popper.left);
        var top = Math.round(data.offsets.popper.top);

        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
        // we automatically use the supported prefixed version if needed
        var prefixedProperty;
        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles.top = 0;
            styles.left = 0;
        }
        // othwerise, we use the standard `left` and `top` properties
        else {
                styles.left = left;
                styles.top = top;
            }

        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        Object.assign(styles, data.styles);

        setStyle(this._popper, styles);

        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
        // NOTE: 1 DOM access here
        this._popper.setAttribute('x-placement', data.placement);

        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
            setStyle(data.arrowElement, data.offsets.arrow);
        }

        return data;
    };

    /**
     * Modifier used to shift the popper on the start or end of its reference element side
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.shift = function (data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftVariation = placement.split('-')[1];

        // if shift shiftVariation is specified, run the modifier
        if (shiftVariation) {
            var reference = data.offsets.reference;
            var popper = getPopperClientRect(data.offsets.popper);

            var shiftOffsets = {
                y: {
                    start: { top: reference.top },
                    end: { top: reference.top + reference.height - popper.height }
                },
                x: {
                    start: { left: reference.left },
                    end: { left: reference.left + reference.width - popper.width }
                }
            };

            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';

            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
        }

        return data;
    };

    /**
     * Modifier used to make sure the popper does not overflows from it's boundaries
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.preventOverflow = function (data) {
        var order = this._options.preventOverflowOrder;
        var popper = getPopperClientRect(data.offsets.popper);

        var check = {
            left: function left() {
                var left = popper.left;
                if (popper.left < data.boundaries.left) {
                    left = Math.max(popper.left, data.boundaries.left);
                }
                return { left: left };
            },
            right: function right() {
                var left = popper.left;
                if (popper.right > data.boundaries.right) {
                    left = Math.min(popper.left, data.boundaries.right - popper.width);
                }
                return { left: left };
            },
            top: function top() {
                var top = popper.top;
                if (popper.top < data.boundaries.top) {
                    top = Math.max(popper.top, data.boundaries.top);
                }
                return { top: top };
            },
            bottom: function bottom() {
                var top = popper.top;
                if (popper.bottom > data.boundaries.bottom) {
                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
                }
                return { top: top };
            }
        };

        order.forEach(function (direction) {
            data.offsets.popper = Object.assign(popper, check[direction]());
        });

        return data;
    };

    /**
     * Modifier used to make sure the popper is always near its reference
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.keepTogether = function (data) {
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var f = Math.floor;

        if (popper.right < f(reference.left)) {
            data.offsets.popper.left = f(reference.left) - popper.width;
        }
        if (popper.left > f(reference.right)) {
            data.offsets.popper.left = f(reference.right);
        }
        if (popper.bottom < f(reference.top)) {
            data.offsets.popper.top = f(reference.top) - popper.height;
        }
        if (popper.top > f(reference.bottom)) {
            data.offsets.popper.top = f(reference.bottom);
        }

        return data;
    };

    /**
     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
     * Requires the `preventOverflow` modifier before it in order to work.
     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.flip = function (data) {
        // check if preventOverflow is in the list of modifiers before the flip modifier.
        // otherwise flip would not work as expected.
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
            return data;
        }

        if (data.flipped && data.placement === data._originalPlacement) {
            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
            return data;
        }

        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';

        var flipOrder = [];
        if (this._options.flipBehavior === 'flip') {
            flipOrder = [placement, placementOpposite];
        } else {
            flipOrder = this._options.flipBehavior;
        }

        flipOrder.forEach(function (step, index) {
            if (placement !== step || flipOrder.length === index + 1) {
                return;
            }

            placement = data.placement.split('-')[0];
            placementOpposite = getOppositePlacement(placement);

            var popperOffsets = getPopperClientRect(data.offsets.popper);

            // this boolean is used to distinguish right and bottom from top and left
            // they need different computations to get flipped
            var a = ['right', 'bottom'].indexOf(placement) !== -1;

            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
                // we'll use this boolean to detect any flip loop
                data.flipped = true;
                data.placement = flipOrder[index + 1];
                if (variation) {
                    data.placement += '-' + variation;
                }
                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;

                data = this.runModifiers(data, this._options.modifiers, this._flip);
            }
        }.bind(this));
        return data;
    };

    /**
     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
     * The offsets will shift the popper on the side of its reference element.
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.offset = function (data) {
        var offset = this._options.offset;
        var popper = data.offsets.popper;

        if (data.placement.indexOf('left') !== -1) {
            popper.top -= offset;
        } else if (data.placement.indexOf('right') !== -1) {
            popper.top += offset;
        } else if (data.placement.indexOf('top') !== -1) {
            popper.left -= offset;
        } else if (data.placement.indexOf('bottom') !== -1) {
            popper.left += offset;
        }
        return data;
    };

    /**
     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.arrow = function (data) {
        var arrow = this._options.arrowElement;
        var arrowOffset = this._options.arrowOffset;

        // if the arrowElement is a string, suppose it's a CSS selector
        if (typeof arrow === 'string') {
            arrow = this._popper.querySelector(arrow);
        }

        // if arrow element is not found, don't run the modifier
        if (!arrow) {
            return data;
        }

        // the arrow element must be child of its popper
        if (!this._popper.contains(arrow)) {
            console.warn('WARNING: `arrowElement` must be child of its popper element!');
            return data;
        }

        // arrow depends on keepTogether in order to work
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
            return data;
        }

        var arrowStyle = {};
        var placement = data.placement.split('-')[0];
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var isVertical = ['left', 'right'].indexOf(placement) !== -1;

        var len = isVertical ? 'height' : 'width';
        var side = isVertical ? 'top' : 'left';
        var translate = isVertical ? 'translateY' : 'translateX';
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowSize = getOuterSizes(arrow)[len];

        //
        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
        //

        // top/left side
        if (reference[opSide] - arrowSize < popper[side]) {
            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
        }
        // bottom/right side
        if (reference[side] + arrowSize > popper[opSide]) {
            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
        }

        // compute center of the popper
        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);

        var sideValue = center - popper[side];

        // prevent arrow from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
        arrowStyle[side] = sideValue;
        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

        data.offsets.arrow = arrowStyle;
        data.arrowElement = arrow;

        return data;
    };

    //
    // Helpers
    //

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
        // NOTE: 1 DOM access here
        var _display = element.style.display,
            _visibility = element.style.visibility;
        element.style.display = 'block';element.style.visibility = 'hidden';
        var calcWidthToForceRepaint = element.offsetWidth;

        // original method
        var styles = root.getComputedStyle(element);
        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };

        // reset element styles
        element.style.display = _display;element.style.visibility = _visibility;
        return result;
    }

    /**
     * Get the opposite placement of the given one/
     * @function
     * @ignore
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
        return placement.replace(/left|right|bottom|top/g, function (matched) {
            return hash[matched];
        });
    }

    /**
     * Given the popper offsets, generate an output similar to getBoundingClientRect
     * @function
     * @ignore
     * @argument {Object} popperOffsets
     * @returns {Object} ClientRect like output
     */
    function getPopperClientRect(popperOffsets) {
        var offsets = Object.assign({}, popperOffsets);
        offsets.right = offsets.left + offsets.width;
        offsets.bottom = offsets.top + offsets.height;
        return offsets;
    }

    /**
     * Given an array and the key to find, returns its index
     * @function
     * @ignore
     * @argument {Array} arr
     * @argument keyToFind
     * @returns index or null
     */
    function getArrayKeyIndex(arr, keyToFind) {
        var i = 0,
            key;
        for (key in arr) {
            if (arr[key] === keyToFind) {
                return i;
            }
            i++;
        }
        return null;
    }

    /**
     * Get CSS computed property of the given element
     * @function
     * @ignore
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
        // NOTE: 1 DOM access here
        var css = root.getComputedStyle(element, null);
        return css[property];
    }

    /**
     * Returns the offset parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent;
        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
    }

    /**
     * Returns the scrolling parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {
            return element;
        }

        if (parent === root.document) {
            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
            // greater than 0 and return the proper element
            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
                return root.document.body;
            } else {
                return root.document.documentElement;
            }
        }

        // Firefox want us to check `-x` and `-y` variations as well
        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
            // If the detected scrollParent is body, we perform an additional check on its parentNode
            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
            // fixes issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @function
     * @ignore
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
        if (element === root.document.body) {
            return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
            return true;
        }
        return element.parentNode ? isFixed(element.parentNode) : element;
    }

    /**
     * Set the style to the given popper
     * @function
     * @ignore
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
     */
    function setStyle(element, styles) {
        function is_numeric(n) {
            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
        }
        Object.keys(styles).forEach(function (prop) {
            var unit = '';
            // add unit if the value is numeric and is one of the following
            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
                unit = 'px';
            }
            element.style[prop] = styles[prop] + unit;
        });
    }

    /**
     * Check if the given variable is a function
     * @function
     * @ignore
     * @argument {*} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get the position of the given element, relative to its offset parent
     * @function
     * @ignore
     * @param {Element} element
     * @return {Object} position - Coordinates of the element and its `scrollTop`
     */
    function getOffsetRect(element) {
        var elementRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
            left: element.offsetLeft,
            top: element.offsetTop
        };

        elementRect.right = elementRect.left + elementRect.width;
        elementRect.bottom = elementRect.top + elementRect.height;

        // position
        return elementRect;
    }

    /**
     * Get bounding client rect of given element
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
        var rect = element.getBoundingClientRect();

        // whether the IE version is lower than 11
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;

        // fix ie document bounding top always 0 bug
        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;

        return {
            left: rect.left,
            top: rectTop,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.right - rect.left,
            height: rect.bottom - rectTop
        };
    }

    /**
     * Given an element and one of its parents, return the offset
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @return {Object} rect
     */
    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
        var elementRect = getBoundingClientRect(element);
        var parentRect = getBoundingClientRect(parent);

        if (fixed) {
            var scrollParent = getScrollParent(parent);
            parentRect.top += scrollParent.scrollTop;
            parentRect.bottom += scrollParent.scrollTop;
            parentRect.left += scrollParent.scrollLeft;
            parentRect.right += scrollParent.scrollLeft;
        }

        var rect = {
            top: elementRect.top - parentRect.top,
            left: elementRect.left - parentRect.left,
            bottom: elementRect.top - parentRect.top + elementRect.height,
            right: elementRect.left - parentRect.left + elementRect.width,
            width: elementRect.width,
            height: elementRect.height
        };
        return rect;
    }

    /**
     * Get the prefixed supported property name
     * @function
     * @ignore
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase)
     */
    function getSupportedPropertyName(property) {
        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
            if (typeof root.document.body.style[toCheck] !== 'undefined') {
                return toCheck;
            }
        }
        return null;
    }

    /**
     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
     * objects to a target object. It will return the target object.
     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
     * @function
     * @ignore
     */
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function value(target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }

    return Popper;
});

/***/ }),
/* 915 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 96);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/96:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("button", {
        staticClass: "el-button",
        class: [_vm.type ? "el-button--" + _vm.type : "", _vm.buttonSize ? "el-button--" + _vm.buttonSize : "", {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }],
        attrs: {
          disabled: _vm.buttonDisabled || _vm.loading,
          autofocus: _vm.autofocus,
          type: _vm.nativeType
        },
        on: { click: _vm.handleClick }
      }, [_vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(), _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(), _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */var buttonvue_type_script_lang_js_ = {
      name: 'ElButton',

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      props: {
        type: {
          type: String,
          default: 'default'
        },
        size: String,
        icon: {
          type: String,
          default: ''
        },
        nativeType: {
          type: String,
          default: 'button'
        },
        loading: Boolean,
        disabled: Boolean,
        plain: Boolean,
        autofocus: Boolean,
        round: Boolean,
        circle: Boolean
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        buttonSize: function buttonSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        buttonDisabled: function buttonDisabled() {
          return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled;
        }
      },

      methods: {
        handleClick: function handleClick(evt) {
          this.$emit('click', evt);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
    /* harmony default export */var src_buttonvue_type_script_lang_js_ = buttonvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/button/src/button.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_buttonvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/button/src/button.vue";
    /* harmony default export */var src_button = component.exports;
    // CONCATENATED MODULE: ./packages/button/index.js


    /* istanbul ignore next */
    src_button.install = function (Vue) {
      Vue.component(src_button.name, src_button);
    };

    /* harmony default export */var packages_button = __webpack_exports__["default"] = src_button;

    /***/
  }

  /******/ });

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(98);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Transition = function () {
  function Transition() {
    _classCallCheck(this, Transition);
  }

  Transition.prototype.beforeEnter = function beforeEnter(el) {
    (0, _dom.addClass)(el, 'collapse-transition');
    if (!el.dataset) el.dataset = {};

    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;

    el.style.height = '0';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  };

  Transition.prototype.enter = function enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = '';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }

    el.style.overflow = 'hidden';
  };

  Transition.prototype.afterEnter = function afterEnter(el) {
    // for safari: remove class then reset height is necessary
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
  };

  Transition.prototype.beforeLeave = function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  };

  Transition.prototype.leave = function leave(el) {
    if (el.scrollHeight !== 0) {
      // for safari: add class after set height, or it will jump to zero height suddenly, weired
      (0, _dom.addClass)(el, 'collapse-transition');
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  };

  Transition.prototype.afterLeave = function afterLeave(el) {
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  };

  return Transition;
}();

exports.default = {
  name: 'ElCollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;

    var data = {
      on: new Transition()
    };

    return h('transition', data, children);
  }
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.isVNode = isVNode;

var _util = __webpack_require__(73);

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 138);
  /******/
}(
/************************************************************************/
/******/{

  /***/138:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // EXTERNAL MODULE: external "throttle-debounce/debounce"
    var debounce_ = __webpack_require__(19);
    var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // EXTERNAL MODULE: external "vue"
    var external_vue_ = __webpack_require__(7);
    var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

    // CONCATENATED MODULE: ./packages/tooltip/src/main.js


    /* harmony default export */var main = {
      name: 'ElTooltip',

      mixins: [vue_popper_default.a],

      props: {
        openDelay: {
          type: Number,
          default: 0
        },
        disabled: Boolean,
        manual: Boolean,
        effect: {
          type: String,
          default: 'dark'
        },
        arrowOffset: {
          type: Number,
          default: 0
        },
        popperClass: String,
        content: String,
        visibleArrow: {
          default: true
        },
        transition: {
          type: String,
          default: 'el-fade-in-linear'
        },
        popperOptions: {
          default: function _default() {
            return {
              boundariesPadding: 10,
              gpuAcceleration: false
            };
          }
        },
        enterable: {
          type: Boolean,
          default: true
        },
        hideAfter: {
          type: Number,
          default: 0
        },
        tabindex: {
          type: Number,
          default: 0
        }
      },

      data: function data() {
        return {
          tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
          timeoutPending: null,
          focusing: false
        };
      },
      beforeCreate: function beforeCreate() {
        var _this = this;

        if (this.$isServer) return;

        this.popperVM = new external_vue_default.a({
          data: { node: '' },
          render: function render(h) {
            return this.node;
          }
        }).$mount();

        this.debounceClose = debounce_default()(200, function () {
          return _this.handleClosePopper();
        });
      },
      render: function render(h) {
        var _this2 = this;

        if (this.popperVM) {
          this.popperVM.node = h('transition', {
            attrs: {
              name: this.transition
            },
            on: {
              'afterLeave': this.doDestroy
            }
          }, [h('div', {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] }, [this.$slots.content || this.content])]);
        }

        var firstElement = this.getFirstElement();
        if (!firstElement) return null;

        var data = firstElement.data = firstElement.data || {};
        data.staticClass = this.addTooltipClass(data.staticClass);

        return firstElement;
      },
      mounted: function mounted() {
        var _this3 = this;

        this.referenceElm = this.$el;
        if (this.$el.nodeType === 1) {
          this.$el.setAttribute('aria-describedby', this.tooltipId);
          this.$el.setAttribute('tabindex', this.tabindex);
          Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
          Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
          Object(dom_["on"])(this.referenceElm, 'focus', function () {
            if (!_this3.$slots.default || !_this3.$slots.default.length) {
              _this3.handleFocus();
              return;
            }
            var instance = _this3.$slots.default[0].componentInstance;
            if (instance && instance.focus) {
              instance.focus();
            } else {
              _this3.handleFocus();
            }
          });
          Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
          Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
        }
        // fix issue https://github.com/ElemeFE/element/issues/14424
        if (this.value && this.popperVM) {
          this.popperVM.$nextTick(function () {
            if (_this3.value) {
              _this3.updatePopper();
            }
          });
        }
      },

      watch: {
        focusing: function focusing(val) {
          if (val) {
            Object(dom_["addClass"])(this.referenceElm, 'focusing');
          } else {
            Object(dom_["removeClass"])(this.referenceElm, 'focusing');
          }
        }
      },
      methods: {
        show: function show() {
          this.setExpectedState(true);
          this.handleShowPopper();
        },
        hide: function hide() {
          this.setExpectedState(false);
          this.debounceClose();
        },
        handleFocus: function handleFocus() {
          this.focusing = true;
          this.show();
        },
        handleBlur: function handleBlur() {
          this.focusing = false;
          this.hide();
        },
        removeFocusing: function removeFocusing() {
          this.focusing = false;
        },
        addTooltipClass: function addTooltipClass(prev) {
          if (!prev) {
            return 'el-tooltip';
          } else {
            return 'el-tooltip ' + prev.replace('el-tooltip', '');
          }
        },
        handleShowPopper: function handleShowPopper() {
          var _this4 = this;

          if (!this.expectedState || this.manual) return;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            _this4.showPopper = true;
          }, this.openDelay);

          if (this.hideAfter > 0) {
            this.timeoutPending = setTimeout(function () {
              _this4.showPopper = false;
            }, this.hideAfter);
          }
        },
        handleClosePopper: function handleClosePopper() {
          if (this.enterable && this.expectedState || this.manual) return;
          clearTimeout(this.timeout);

          if (this.timeoutPending) {
            clearTimeout(this.timeoutPending);
          }
          this.showPopper = false;

          if (this.disabled) {
            this.doDestroy();
          }
        },
        setExpectedState: function setExpectedState(expectedState) {
          if (expectedState === false) {
            clearTimeout(this.timeoutPending);
          }
          this.expectedState = expectedState;
        },
        getFirstElement: function getFirstElement() {
          var slots = this.$slots.default;
          if (!Array.isArray(slots)) return null;
          var element = null;
          for (var index = 0; index < slots.length; index++) {
            if (slots[index] && slots[index].tag) {
              element = slots[index];
              break;
            };
          }
          return element;
        }
      },

      beforeDestroy: function beforeDestroy() {
        this.popperVM && this.popperVM.$destroy();
      },
      destroyed: function destroyed() {
        var reference = this.referenceElm;
        if (reference.nodeType === 1) {
          Object(dom_["off"])(reference, 'mouseenter', this.show);
          Object(dom_["off"])(reference, 'mouseleave', this.hide);
          Object(dom_["off"])(reference, 'focus', this.handleFocus);
          Object(dom_["off"])(reference, 'blur', this.handleBlur);
          Object(dom_["off"])(reference, 'click', this.removeFocusing);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/tooltip/index.js


    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.component(main.name, main);
    };

    /* harmony default export */var tooltip = __webpack_exports__["default"] = main;

    /***/
  },

  /***/19:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(264);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(98);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(261);

    /***/
  },

  /***/7:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(32);

    /***/
  }

  /******/ });

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==="undefined"?"undefined":_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==="undefined"?"undefined":_typeof2(obj);};/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 *//*eslint-disable*/(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.10';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
     * Used to match
     * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
     */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange="\\ud800-\\udfff",rsComboMarksRange="\\u0300-\\u036f",reComboHalfMarksRange="\\ufe20-\\ufe2f",rsComboSymbolsRange="\\u20d0-\\u20ff",rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange="\\u2700-\\u27bf",rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange="\\u2000-\\u206f",rsSpaceRange=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange="\\ufe0e\\ufe0f",rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz="\\ud83c[\\udffb-\\udfff]",rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional="(?:\\ud83c[\\udde6-\\uddff]){2}",rsSurrPair="[\\ud800-\\udbff][\\udc00-\\udfff]",rsUpper='['+rsUpperRange+']',rsZWJ="\\u200d";/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
À:'A',Á:'A',Â:'A',Ã:'A',Ä:'A',Å:'A',à:'a',á:'a',â:'a',ã:'a',ä:'a',å:'a',Ç:'C',ç:'c',Ð:'D',ð:'d',È:'E',É:'E',Ê:'E',Ë:'E',è:'e',é:'e',ê:'e',ë:'e',Ì:'I',Í:'I',Î:'I',Ï:'I',ì:'i',í:'i',î:'i',ï:'i',Ñ:'N',ñ:'n',Ò:'O',Ó:'O',Ô:'O',Õ:'O',Ö:'O',Ø:'O',ò:'o',ó:'o',ô:'o',õ:'o',ö:'o',ø:'o',Ù:'U',Ú:'U',Û:'U',Ü:'U',ù:'u',ú:'u',û:'u',ü:'u',Ý:'Y',ý:'y',ÿ:'y',Æ:'Ae',æ:'ae',Þ:'Th',þ:'th',ß:'ss',// Latin Extended-A block.
Ā:'A',Ă:'A',Ą:'A',ā:'a',ă:'a',ą:'a',Ć:'C',Ĉ:'C',Ċ:'C',Č:'C',ć:'c',ĉ:'c',ċ:'c',č:'c',Ď:'D',Đ:'D',ď:'d',đ:'d',Ē:'E',Ĕ:'E',Ė:'E',Ę:'E',Ě:'E',ē:'e',ĕ:'e',ė:'e',ę:'e',ě:'e',Ĝ:'G',Ğ:'G',Ġ:'G',Ģ:'G',ĝ:'g',ğ:'g',ġ:'g',ģ:'g',Ĥ:'H',Ħ:'H',ĥ:'h',ħ:'h',Ĩ:'I',Ī:'I',Ĭ:'I',Į:'I',İ:'I',ĩ:'i',ī:'i',ĭ:'i',į:'i',ı:'i',Ĵ:'J',ĵ:'j',Ķ:'K',ķ:'k',ĸ:'k',Ĺ:'L',Ļ:'L',Ľ:'L',Ŀ:'L',Ł:'L',ĺ:'l',ļ:'l',ľ:'l',ŀ:'l',ł:'l',Ń:'N',Ņ:'N',Ň:'N',Ŋ:'N',ń:'n',ņ:'n',ň:'n',ŋ:'n',Ō:'O',Ŏ:'O',Ő:'O',ō:'o',ŏ:'o',ő:'o',Ŕ:'R',Ŗ:'R',Ř:'R',ŕ:'r',ŗ:'r',ř:'r',Ś:'S',Ŝ:'S',Ş:'S',Š:'S',ś:'s',ŝ:'s',ş:'s',š:'s',Ţ:'T',Ť:'T',Ŧ:'T',ţ:'t',ť:'t',ŧ:'t',Ũ:'U',Ū:'U',Ŭ:'U',Ů:'U',Ű:'U',Ų:'U',ũ:'u',ū:'u',ŭ:'u',ů:'u',ű:'u',ų:'u',Ŵ:'W',ŵ:'w',Ŷ:'Y',ŷ:'y',Ÿ:'Y',Ź:'Z',Ż:'Z',Ž:'Z',ź:'z',ż:'z',ž:'z',Ĳ:'IJ',ĳ:'ij',Œ:'Oe',œ:'oe',ŉ:"'n",ſ:'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r',"\u2028":'u2028',"\u2029":'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))==='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))==='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))==='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))==='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/* --------------------------------------------------------------------------*//**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
     * A specialized version of `baseAggregator` for arrays.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
     * A specialized version of `_.forEachRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
     * A specialized version of `_.every` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
     * A specialized version of `_.reduceRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the last element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
     * Gets the size of an ASCII `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */var asciiSize=baseProperty('length');/**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */function asciiToArray(string){return string.split('');}/**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
     * The base implementation of methods like `_.findKey` and `_.findLastKey`,
     * without support for iteratee shorthands, which iterates over `collection`
     * using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
     * This function is like `baseIndexOf` except that it accepts a comparator.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */function baseIsNaN(value){return value!==value;}/**
     * The base implementation of `_.mean` and `_.meanBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the mean.
     */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
     * The base implementation of `_.reduce` and `_.reduceRight`, without support
     * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initAccum Specify using the first or last element of
     *  `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
     * The base implementation of `_.sortBy` which uses `comparer` to define the
     * sort order of `array` and replaces criteria objects with their corresponding
     * values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
     * The base implementation of `_.sum` and `_.sumBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
     * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
     * of key-value pairs for `object` corresponding to the property names of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the key-value pairs.
     */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */function baseUnary(func){return function(value){return func(value);};}/**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function cacheHas(cache,key){return cache.has(key);}/**
     * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the first unmatched string symbol.
     */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the last unmatched string symbol.
     */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */var deburrLetter=basePropertyOf(deburredLetters);/**
     * Used by `_.escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
     * Used by `_.template` to escape characters for inclusion in compiled string literals.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function getValue(object,key){return object==null?undefined:object[key];}/**
     * Checks if `string` contains Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a symbol is found, else `false`.
     */function hasUnicode(string){return reHasUnicode.test(string);}/**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
     * Converts `iterator` to an array.
     *
     * @private
     * @param {Object} iterator The iterator to convert.
     * @returns {Array} Returns the converted array.
     */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){return key=='__proto__'?undefined:object[key];}/**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
     * Converts `set` to its value-value pairs.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the value-value pairs.
     */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
     * A specialized version of `_.lastIndexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
     * Gets the number of symbols in `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the string size.
     */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
     * Converts `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
     * Used by `_.unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} chr The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
     * Gets the size of a Unicode `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
     * Converts a Unicode `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/* --------------------------------------------------------------------------*//**
     * Create a new pristine `lodash` function using the `context` object.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Util
     * @param {Object} [context=root] The context object.
     * @returns {Function} Returns a new `lodash` function.
     * @example
     *
     * _.mixin({ 'foo': _.constant('foo') });
     *
     * var lodash = _.runInContext();
     * lodash.mixin({ 'bar': lodash.constant('bar') });
     *
     * _.isFunction(_.foo);
     * // => true
     * _.isFunction(_.bar);
     * // => false
     *
     * lodash.isFunction(lodash.foo);
     * // => false
     * lodash.isFunction(lodash.bar);
     * // => true
     *
     * // Create a suped-up `defer` in Node.js.
     * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
     */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/* ------------------------------------------------------------------------*//**
       * Creates a `lodash` object which wraps `value` to enable implicit method
       * chain sequences. Methods that operate on and return arrays, collections,
       * and functions can be chained together. Methods that retrieve a single value
       * or may return a primitive value will automatically end the chain sequence
       * and return the unwrapped value. Otherwise, the value must be unwrapped
       * with `_#value`.
       *
       * Explicit chain sequences, which must be unwrapped with `_#value`, may be
       * enabled using `_.chain`.
       *
       * The execution of chained methods is lazy, that is, it's deferred until
       * `_#value` is implicitly or explicitly called.
       *
       * Lazy evaluation allows several methods to support shortcut fusion.
       * Shortcut fusion is an optimization to merge iteratee calls; this avoids
       * the creation of intermediate arrays and can greatly reduce the number of
       * iteratee executions. Sections of a chain sequence qualify for shortcut
       * fusion if the section is applied to an array and iteratees accept only
       * one argument. The heuristic for whether a section qualifies for shortcut
       * fusion is subject to change.
       *
       * Chaining is supported in custom builds as long as the `_#value` method is
       * directly or indirectly included in the build.
       *
       * In addition to lodash methods, wrappers have `Array` and `String` methods.
       *
       * The wrapper `Array` methods are:
       * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
       *
       * The wrapper `String` methods are:
       * `replace` and `split`
       *
       * The wrapper methods that support shortcut fusion are:
       * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
       * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
       * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
       *
       * The chainable wrapper methods are:
       * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
       * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
       * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
       * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
       * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
       * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
       * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
       * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
       * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
       * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
       * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
       * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
       * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
       * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
       * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
       * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
       * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
       * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
       * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
       * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
       * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
       * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
       * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
       * `zipObject`, `zipObjectDeep`, and `zipWith`
       *
       * The wrapper methods that are **not** chainable by default are:
       * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
       * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
       * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
       * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
       * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
       * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
       * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
       * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
       * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
       * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
       * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
       * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
       * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
       * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
       * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
       * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
       * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
       * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
       * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
       * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
       * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
       * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
       * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
       * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
       * `upperFirst`, `value`, and `words`
       *
       * @name _
       * @constructor
       * @category Seq
       * @param {*} value The value to wrap in a `lodash` instance.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2, 3]);
       *
       * // Returns an unwrapped value.
       * wrapped.reduce(_.add);
       * // => 6
       *
       * // Returns a wrapped value.
       * var squares = wrapped.map(square);
       *
       * _.isArray(squares);
       * // => false
       *
       * _.isArray(squares.value());
       * // => true
       */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
         * The base implementation of `_.create` without support for assigning
         * properties to the created object.
         *
         * @private
         * @param {Object} proto The object to inherit from.
         * @returns {Object} Returns the new object.
         */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
       * The function whose prototype chain sequence wrappers inherit from.
       *
       * @private
       */function baseLodash(){}// No operation performed.
/**
         * The base constructor for creating `lodash` wrapper objects.
         *
         * @private
         * @param {*} value The value to wrap.
         * @param {boolean} [chainAll] Enable explicit method chain sequences.
         */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
         * By default, the template delimiters used by lodash are like those in
         * embedded Ruby (ERB) as well as ES2015 template strings. Change the
         * following template settings to use alternative delimiters.
         *
         * @static
         * @memberOf _
         * @type {Object}
         */lodash.templateSettings={/**
             * Used to detect `data` property values to be HTML-escaped.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */escape:reEscape,/**
             * Used to detect code to be evaluated.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */evaluate:reEvaluate,/**
             * Used to detect `data` property values to inject.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */interpolate:reInterpolate,/**
             * Used to reference the data object in the template text.
             *
             * @memberOf _.templateSettings
             * @type {string}
             */variable:'',/**
             * Used to import variables into the compiled template.
             *
             * @memberOf _.templateSettings
             * @type {Object}
             */imports:{/**
                 * A reference to the `lodash` function.
                 *
                 * @memberOf _.templateSettings.imports
                 * @type {Function}
                 */_:lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/* ------------------------------------------------------------------------*//**
         * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
         *
         * @private
         * @constructor
         * @param {*} value The value to wrap.
         */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
         * Creates a clone of the lazy wrapper object.
         *
         * @private
         * @name clone
         * @memberOf LazyWrapper
         * @returns {Object} Returns the cloned `LazyWrapper` object.
         */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
         * Reverses the direction of lazy iteration.
         *
         * @private
         * @name reverse
         * @memberOf LazyWrapper
         * @returns {Object} Returns the new reversed `LazyWrapper` object.
         */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
         * Extracts the unwrapped value from its lazy wrapper.
         *
         * @private
         * @name value
         * @memberOf LazyWrapper
         * @returns {*} Returns the unwrapped value.
         */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/* ------------------------------------------------------------------------*//**
         * Creates a hash object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
         * Removes all key-value entries from the hash.
         *
         * @private
         * @name clear
         * @memberOf Hash
         */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
         * Removes `key` and its value from the hash.
         *
         * @private
         * @name delete
         * @memberOf Hash
         * @param {Object} hash The hash to modify.
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
         * Gets the hash value for `key`.
         *
         * @private
         * @name get
         * @memberOf Hash
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
         * Checks if a hash value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Hash
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
         * Sets the hash `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Hash
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the hash instance.
         */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/* ------------------------------------------------------------------------*//**
         * Creates an list cache object.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
         * Removes all key-value entries from the list cache.
         *
         * @private
         * @name clear
         * @memberOf ListCache
         */function listCacheClear(){this.__data__=[];this.size=0;}/**
         * Removes `key` and its value from the list cache.
         *
         * @private
         * @name delete
         * @memberOf ListCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
         * Gets the list cache value for `key`.
         *
         * @private
         * @name get
         * @memberOf ListCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
         * Checks if a list cache value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf ListCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
         * Sets the list cache `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf ListCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the list cache instance.
         */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/* ------------------------------------------------------------------------*//**
         * Creates a map cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
         * Removes all key-value entries from the map.
         *
         * @private
         * @name clear
         * @memberOf MapCache
         */function mapCacheClear(){this.size=0;this.__data__={hash:new Hash(),map:new(Map||ListCache)(),string:new Hash()};}/**
         * Removes `key` and its value from the map.
         *
         * @private
         * @name delete
         * @memberOf MapCache
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
         * Gets the map value for `key`.
         *
         * @private
         * @name get
         * @memberOf MapCache
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
         * Checks if a map value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf MapCache
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
         * Sets the map `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf MapCache
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the map cache instance.
         */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/* ------------------------------------------------------------------------*//**
         *
         * Creates an array cache object to store unique values.
         *
         * @private
         * @constructor
         * @param {Array} [values] The values to cache.
         */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
         * Adds `value` to the array cache.
         *
         * @private
         * @name add
         * @memberOf SetCache
         * @alias push
         * @param {*} value The value to cache.
         * @returns {Object} Returns the cache instance.
         */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
         * Checks if `value` is in the array cache.
         *
         * @private
         * @name has
         * @memberOf SetCache
         * @param {*} value The value to search for.
         * @returns {number} Returns `true` if `value` is found, else `false`.
         */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/* ------------------------------------------------------------------------*//**
         * Creates a stack cache object to store key-value pairs.
         *
         * @private
         * @constructor
         * @param {Array} [entries] The key-value pairs to cache.
         */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
         * Removes all key-value entries from the stack.
         *
         * @private
         * @name clear
         * @memberOf Stack
         */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
         * Removes `key` and its value from the stack.
         *
         * @private
         * @name delete
         * @memberOf Stack
         * @param {string} key The key of the value to remove.
         * @returns {boolean} Returns `true` if the entry was removed, else `false`.
         */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
         * Gets the stack value for `key`.
         *
         * @private
         * @name get
         * @memberOf Stack
         * @param {string} key The key of the value to get.
         * @returns {*} Returns the entry value.
         */function stackGet(key){return this.__data__.get(key);}/**
         * Checks if a stack value for `key` exists.
         *
         * @private
         * @name has
         * @memberOf Stack
         * @param {string} key The key of the entry to check.
         * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
         */function stackHas(key){return this.__data__.has(key);}/**
         * Sets the stack `key` to `value`.
         *
         * @private
         * @name set
         * @memberOf Stack
         * @param {string} key The key of the value to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns the stack cache instance.
         */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/* ------------------------------------------------------------------------*//**
         * Creates an array of the enumerable property names of the array-like `value`.
         *
         * @private
         * @param {*} value The value to query.
         * @param {boolean} inherited Specify returning inherited property names.
         * @returns {Array} Returns the array of property names.
         */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
         * A specialized version of `_.sample` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @returns {*} Returns the random element.
         */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
         * A specialized version of `_.sampleSize` for arrays.
         *
         * @private
         * @param {Array} array The array to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
         * A specialized version of `_.shuffle` for arrays.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @returns {Array} Returns the new shuffled array.
         */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
         * This function is like `assignValue` except that it doesn't assign
         * `undefined` values.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
         * Assigns `value` to `key` of `object` if the existing value is not equivalent
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
         * Gets the index at which the `key` is found in `array` of key-value pairs.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {*} key The key to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
         * Aggregates elements of `collection` on `accumulator` with keys transformed
         * by `iteratee` and values set by `setter`.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform keys.
         * @param {Object} accumulator The initial aggregated object.
         * @returns {Function} Returns `accumulator`.
         */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
         * The base implementation of `_.assign` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
         * The base implementation of `_.assignIn` without support for multiple sources
         * or `customizer` functions.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @returns {Object} Returns `object`.
         */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
         * The base implementation of `assignValue` and `assignMergeValue` without
         * value checks.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {string} key The key of the property to assign.
         * @param {*} value The value to assign.
         */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{configurable:true,enumerable:true,value:value,writable:true});}else{object[key]=value;}}/**
         * The base implementation of `_.at` without support for individual paths.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {string[]} paths The property paths to pick.
         * @returns {Array} Returns the picked elements.
         */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
         * The base implementation of `_.clamp` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
         * The base implementation of `_.clone` and `_.cloneDeep` which tracks
         * traversed objects.
         *
         * @private
         * @param {*} value The value to clone.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Deep clone
         *  2 - Flatten inherited properties
         *  4 - Clone symbols
         * @param {Function} [customizer] The function to customize cloning.
         * @param {string} [key] The key of `value`.
         * @param {Object} [object] The parent object of `value`.
         * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
         * @returns {*} Returns the cloned value.
         */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});return result;}if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
         * The base implementation of `_.conforms` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
         * The base implementation of `_.conformsTo` which accepts `props` to check.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
         * The base implementation of `_.delay` and `_.defer` which accepts `args`
         * to provide to `func`.
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @param {Array} args The arguments to provide to `func`.
         * @returns {number|Object} Returns the timer id or timeout object.
         */function baseDelay(func,wait,args){if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
         * The base implementation of methods like `_.difference` without support
         * for excluding multiple arrays or iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Array} values The values to exclude.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of filtered values.
         */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
         * The base implementation of `_.forEach` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */var baseEach=createBaseEach(baseForOwn);/**
         * The base implementation of `_.forEachRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
         * The base implementation of `_.every` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if all elements pass the predicate check,
         *  else `false`
         */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
         * The base implementation of methods like `_.max` and `_.min` which accepts a
         * `comparator` to determine the extremum value.
         *
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} iteratee The iteratee invoked per iteration.
         * @param {Function} comparator The comparator used to compare values.
         * @returns {*} Returns the extremum value.
         */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
         * The base implementation of `_.fill` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
         * The base implementation of `_.filter` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
         * The base implementation of `_.flatten` with support for restricting flattening.
         *
         * @private
         * @param {Array} array The array to flatten.
         * @param {number} depth The maximum recursion depth.
         * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
         * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
         * @param {Array} [result=[]] The initial result value.
         * @returns {Array} Returns the new flattened array.
         */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
         * The base implementation of `baseForOwn` which iterates over `object`
         * properties returned by `keysFunc` and invokes `iteratee` for each property.
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */var baseFor=createBaseFor();/**
         * This function is like `baseFor` except that it iterates over properties
         * in the opposite order.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @returns {Object} Returns `object`.
         */var baseForRight=createBaseFor(true);/**
         * The base implementation of `_.forOwn` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
         * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Object} Returns `object`.
         */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
         * The base implementation of `_.functions` which creates an array of
         * `object` function property names filtered from `props`.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Array} props The property names to filter.
         * @returns {Array} Returns the function names.
         */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
         * The base implementation of `_.get` without support for default values.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @returns {*} Returns the resolved value.
         */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
         * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
         * `keysFunc` and `symbolsFunc` to get the enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Function} keysFunc The function to get the keys of `object`.
         * @param {Function} symbolsFunc The function to get the symbols of `object`.
         * @returns {Array} Returns the array of property names and symbols.
         */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
         * The base implementation of `_.gt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         */function baseGt(value,other){return value>other;}/**
         * The base implementation of `_.has` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
         * The base implementation of `_.hasIn` without support for deep paths.
         *
         * @private
         * @param {Object} [object] The object to query.
         * @param {Array|string} key The key to check.
         * @returns {boolean} Returns `true` if `key` exists, else `false`.
         */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
         * The base implementation of `_.inRange` which doesn't coerce arguments.
         *
         * @private
         * @param {number} number The number to check.
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
         * The base implementation of methods like `_.intersection`, without support
         * for iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of shared values.
         */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
         * The base implementation of `_.invert` and `_.invertBy` which inverts
         * `object` with values transformed by `iteratee` and set by `setter`.
         *
         * @private
         * @param {Object} object The object to iterate over.
         * @param {Function} setter The function to set `accumulator` values.
         * @param {Function} iteratee The iteratee to transform values.
         * @param {Object} accumulator The initial inverted object.
         * @returns {Function} Returns `accumulator`.
         */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
         * The base implementation of `_.invoke` without support for individual
         * method arguments.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the method to invoke.
         * @param {Array} args The arguments to invoke the method with.
         * @returns {*} Returns the result of the invoked method.
         */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
         * The base implementation of `_.isArguments`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an `arguments` object,
         */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
         * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
         * The base implementation of `_.isDate` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
         * The base implementation of `_.isEqual` which supports partial comparisons
         * and tracks traversed objects.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {boolean} bitmask The bitmask flags.
         *  1 - Unordered comparison
         *  2 - Partial comparison
         * @param {Function} [customizer] The function to customize comparisons.
         * @param {Object} [stack] Tracks traversed `value` and `other` objects.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
         * A specialized version of `baseIsEqual` for arrays and objects which performs
         * deep comparisons and tracks traversed objects enabling objects with circular
         * references to be compared.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} [stack] Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
         * The base implementation of `_.isMap` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
         * The base implementation of `_.isMatch` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Array} matchData The property names, values, and compare flags to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
         * The base implementation of `_.isNative` without bad shim checks.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
         * The base implementation of `_.isRegExp` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
         * The base implementation of `_.isSet` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
         * The base implementation of `_.isTypedArray` without Node.js optimizations.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
         * The base implementation of `_.iteratee`.
         *
         * @private
         * @param {*} [value=_.identity] The value to convert to an iteratee.
         * @returns {Function} Returns the iteratee.
         */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value==='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))==='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
         * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
         * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
         * The base implementation of `_.lt` which doesn't coerce arguments.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         */function baseLt(value,other){return value<other;}/**
         * The base implementation of `_.map` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} iteratee The function invoked per iteration.
         * @returns {Array} Returns the new mapped array.
         */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
         * The base implementation of `_.matches` which doesn't clone `source`.
         *
         * @private
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
         * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
         *
         * @private
         * @param {string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
         * The base implementation of `_.merge` without support for multiple sources.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} [customizer] The function to customize merged values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
         * A specialized version of `baseMerge` for arrays and objects which performs
         * deep merges and tracks traversed objects enabling objects with circular
         * references to be merged.
         *
         * @private
         * @param {Object} object The destination object.
         * @param {Object} source The source object.
         * @param {string} key The key of the value to merge.
         * @param {number} srcIndex The index of `source`.
         * @param {Function} mergeFunc The function to merge values.
         * @param {Function} [customizer] The function to customize assigned values.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
         * The base implementation of `_.nth` which doesn't coerce arguments.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {number} n The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
         * The base implementation of `_.orderBy` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
         * @param {string[]} orders The sort orders of `iteratees`.
         * @returns {Array} Returns the new sorted array.
         */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{criteria:criteria,index:++index,value:value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
         * The base implementation of `_.pick` without support for individual
         * property identifiers.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @returns {Object} Returns the new object.
         */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
         * The base implementation of  `_.pickBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Object} object The source object.
         * @param {string[]} paths The property paths to pick.
         * @param {Function} predicate The function invoked per property.
         * @returns {Object} Returns the new object.
         */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
         * A specialized version of `baseProperty` which supports deep paths.
         *
         * @private
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
         * The base implementation of `_.pullAllBy` without support for iteratee
         * shorthands.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
         * The base implementation of `_.pullAt` without support for individual
         * indexes or capturing the removed elements.
         *
         * @private
         * @param {Array} array The array to modify.
         * @param {number[]} indexes The indexes of elements to remove.
         * @returns {Array} Returns `array`.
         */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
         * The base implementation of `_.random` without support for returning
         * floating-point numbers.
         *
         * @private
         * @param {number} lower The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the random number.
         */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
         * The base implementation of `_.range` and `_.rangeRight` which doesn't
         * coerce arguments.
         *
         * @private
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @param {number} step The value to increment or decrement by.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the range of numbers.
         */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
         * The base implementation of `_.repeat` which doesn't coerce arguments.
         *
         * @private
         * @param {string} string The string to repeat.
         * @param {number} n The number of times to repeat the string.
         * @returns {string} Returns the repeated string.
         */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
         * The base implementation of `_.rest` which doesn't validate or coerce arguments.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @returns {Function} Returns the new function.
         */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
         * The base implementation of `_.sample`.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         */function baseSample(collection){return arraySample(values(collection));}/**
         * The base implementation of `_.sampleSize` without param guards.
         *
         * @private
         * @param {Array|Object} collection The collection to sample.
         * @param {number} n The number of elements to sample.
         * @returns {Array} Returns the random elements.
         */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
         * The base implementation of `_.set`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
         * The base implementation of `setData` without support for hot loop shorting.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{configurable:true,enumerable:false,value:constant(string),writable:true});};/**
       * The base implementation of `_.shuffle`.
       *
       * @private
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
         * The base implementation of `_.some` without support for iteratee shorthands.
         *
         * @private
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} predicate The function invoked per iteration.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
         * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
         * performs a binary search of `array` to determine the index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value==='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
         * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
         * which invokes `iteratee` for `value` and each element of `array` to compute
         * their sort ranking. The iteratee is invoked with one argument; (value).
         *
         * @private
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} iteratee The iteratee invoked per element.
         * @param {boolean} [retHighest] Specify returning the highest qualified index.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array==null?0:array.length,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
         * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
         * support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
         * The base implementation of `_.toNumber` which doesn't ensure correct
         * conversions of binary, hexadecimal, or octal string values.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         */function baseToNumber(value){if(typeof value==='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
         * The base implementation of `_.toString` which doesn't convert nullish
         * values to empty strings.
         *
         * @private
         * @param {*} value The value to process.
         * @returns {string} Returns the string.
         */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value==='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
         * The base implementation of `_.uniqBy` without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
         * The base implementation of `_.unset`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The property path to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
         * The base implementation of `_.update`.
         *
         * @private
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to update.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize path creation.
         * @returns {Object} Returns `object`.
         */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
         * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
         * without support for iteratee shorthands.
         *
         * @private
         * @param {Array} array The array to query.
         * @param {Function} predicate The function invoked per iteration.
         * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the slice of `array`.
         */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
         * The base implementation of `wrapperValue` which returns the result of
         * performing a sequence of actions on the unwrapped `value`, where each
         * successive action is supplied the return value of the previous.
         *
         * @private
         * @param {*} value The unwrapped value.
         * @param {Array} actions Actions to perform to resolve the unwrapped value.
         * @returns {*} Returns the resolved value.
         */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
         * The base implementation of methods like `_.xor`, without support for
         * iteratee shorthands, that accepts an array of arrays to inspect.
         *
         * @private
         * @param {Array} arrays The arrays to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new array of values.
         */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
         * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
         *
         * @private
         * @param {Array} props The property identifiers.
         * @param {Array} values The property values.
         * @param {Function} assignFunc The function to assign values.
         * @returns {Object} Returns the new object.
         */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
         * Casts `value` to an empty array if it's not an array like object.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Array|Object} Returns the cast array-like object.
         */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
         * Casts `value` to `identity` if it's not a function.
         *
         * @private
         * @param {*} value The value to inspect.
         * @returns {Function} Returns cast function.
         */function castFunction(value){return typeof value==='function'?value:identity;}/**
         * Casts `value` to a path array if it's not one.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {Object} [object] The object to query keys on.
         * @returns {Array} Returns the cast property path array.
         */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
         * A `baseRest` alias which can be replaced with `identity` by module
         * replacement plugins.
         *
         * @private
         * @type {Function}
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */var castRest=baseRest;/**
         * Casts `array` to a slice if it's needed.
         *
         * @private
         * @param {Array} array The array to inspect.
         * @param {number} start The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the cast slice.
         */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
         * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
         *
         * @private
         * @param {number|Object} id The timer id or timeout object of the timer to clear.
         */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
         * Creates a clone of `arrayBuffer`.
         *
         * @private
         * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
         * @returns {ArrayBuffer} Returns the cloned array buffer.
         */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
         * Creates a clone of `dataView`.
         *
         * @private
         * @param {Object} dataView The data view to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned data view.
         */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
         * Creates a clone of `regexp`.
         *
         * @private
         * @param {Object} regexp The regexp to clone.
         * @returns {Object} Returns the cloned regexp.
         */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
         * Creates a clone of the `symbol` object.
         *
         * @private
         * @param {Object} symbol The symbol object to clone.
         * @returns {Object} Returns the cloned symbol object.
         */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
         * Creates a clone of `typedArray`.
         *
         * @private
         * @param {Object} typedArray The typed array to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the cloned typed array.
         */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
         * Compares values to sort them in ascending order.
         *
         * @private
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {number} Returns the sort order indicator for `value`.
         */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
         * Used by `_.orderBy` to compare multiple properties of a value to another
         * and stable sort them.
         *
         * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
         * specify an order of "desc" for descending or "asc" for ascending sort order
         * of corresponding values.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {boolean[]|string[]} orders The order to sort by for each property.
         * @returns {number} Returns the sort order indicator for `object`.
         */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
         * Creates an array that is the composition of partially applied arguments,
         * placeholders, and provided arguments into a single array of arguments.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to prepend to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
         * This function is like `composeArgs` except that the arguments composition
         * is tailored for `_.partialRight`.
         *
         * @private
         * @param {Array} args The provided arguments.
         * @param {Array} partials The arguments to append to those provided.
         * @param {Array} holders The `partials` placeholder indexes.
         * @params {boolean} [isCurried] Specify composing for a curried function.
         * @returns {Array} Returns the new array of composed arguments.
         */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
         * Copies the values of `source` to `array`.
         *
         * @private
         * @param {Array} source The array to copy values from.
         * @param {Array} [array=[]] The array to copy values to.
         * @returns {Array} Returns `array`.
         */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
         * Copies properties of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy properties from.
         * @param {Array} props The property identifiers to copy.
         * @param {Object} [object={}] The object to copy properties to.
         * @param {Function} [customizer] The function to customize copied values.
         * @returns {Object} Returns `object`.
         */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
         * Copies own symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
         * Copies own and inherited symbols of `source` to `object`.
         *
         * @private
         * @param {Object} source The object to copy symbols from.
         * @param {Object} [object={}] The object to copy symbols to.
         * @returns {Object} Returns `object`.
         */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
         * Creates a function like `_.groupBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} [initializer] The accumulator object initializer.
         * @returns {Function} Returns the new aggregator function.
         */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
         * Creates a function like `_.assign`.
         *
         * @private
         * @param {Function} assigner The function to assign values.
         * @returns {Function} Returns the new assigner function.
         */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer==='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
         * Creates a `baseEach` or `baseEachRight` function.
         *
         * @private
         * @param {Function} eachFunc The function to iterate over a collection.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
         * Creates a base function for methods like `_.forIn` and `_.forOwn`.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new base function.
         */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
         * Creates a function that wraps `func` to invoke it with the optional `this`
         * binding of `thisArg`.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @returns {Function} Returns the new wrapped function.
         */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
         * Creates a function like `_.lowerFirst`.
         *
         * @private
         * @param {string} methodName The name of the `String` case method to use.
         * @returns {Function} Returns the new case function.
         */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
         * Creates a function like `_.camelCase`.
         *
         * @private
         * @param {Function} callback The function to combine each word.
         * @returns {Function} Returns the new compounder function.
         */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
         * Creates a function that produces an instance of `Ctor` regardless of
         * whether it was invoked as part of a `new` expression or by `call` or `apply`.
         *
         * @private
         * @param {Function} Ctor The constructor to wrap.
         * @returns {Function} Returns the new wrapped function.
         */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
         * Creates a function that wraps `func` to enable currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {number} arity The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
         * Creates a `_.find` or `_.findLast` function.
         *
         * @private
         * @param {Function} findIndexFunc The function to find the collection index.
         * @returns {Function} Returns the new find function.
         */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
         * Creates a `_.flow` or `_.flowRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new flow function.
         */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
         * Creates a function that wraps `func` to invoke it with optional `this`
         * binding of `thisArg`, partial application, and currying.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [partialsRight] The arguments to append to those provided
         *  to the new function.
         * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
         * Creates a function like `_.invertBy`.
         *
         * @private
         * @param {Function} setter The function to set accumulator values.
         * @param {Function} toIteratee The function to resolve iteratees.
         * @returns {Function} Returns the new inverter function.
         */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
         * Creates a function that performs a mathematical operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @param {number} [defaultValue] The value used for `undefined` arguments.
         * @returns {Function} Returns the new mathematical operation function.
         */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value==='string'||typeof other==='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
         * Creates a function like `_.over`.
         *
         * @private
         * @param {Function} arrayFunc The function to iterate over iteratees.
         * @returns {Function} Returns the new over function.
         */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
         * Creates the padding for `string` based on `length`. The `chars` string
         * is truncated if the number of characters exceeds `length`.
         *
         * @private
         * @param {number} length The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padding for `string`.
         */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
         * Creates a function that wraps `func` to invoke it with the `this` binding
         * of `thisArg` and `partials` prepended to the arguments it receives.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {Array} partials The arguments to prepend to those provided to
         *  the new function.
         * @returns {Function} Returns the new wrapped function.
         */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
         * Creates a `_.range` or `_.rangeRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new range function.
         */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!=='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
         * Creates a function that performs a relational operation on two values.
         *
         * @private
         * @param {Function} operator The function to perform the operation.
         * @returns {Function} Returns the new relational operation function.
         */function createRelationalOperation(operator){return function(value,other){if(!(typeof value==='string'&&typeof other==='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
         * Creates a function that wraps `func` to continue currying.
         *
         * @private
         * @param {Function} func The function to wrap.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @param {Function} wrapFunc The function to create the `func` wrapper.
         * @param {*} placeholder The placeholder value.
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to prepend to those provided to
         *  the new function.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
         * Creates a function like `_.round`.
         *
         * @private
         * @param {string} methodName The name of the `Math` method to use when rounding.
         * @returns {Function} Returns the new round function.
         */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
         * Creates a set object of `values`.
         *
         * @private
         * @param {Array} values The values to add to the set.
         * @returns {Object} Returns the new set.
         */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
       * Creates a `_.toPairs` or `_.toPairsIn` function.
       *
       * @private
       * @param {Function} keysFunc The function to get the keys of a given object.
       * @returns {Function} Returns the new pairs function.
       */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
         * Creates a function that either curries or invokes `func` with optional
         * `this` binding and partially applied arguments.
         *
         * @private
         * @param {Function|string} func The function or method name to wrap.
         * @param {number} bitmask The bitmask flags.
         *    1 - `_.bind`
         *    2 - `_.bindKey`
         *    4 - `_.curry` or `_.curryRight` of a bound function
         *    8 - `_.curry`
         *   16 - `_.curryRight`
         *   32 - `_.partial`
         *   64 - `_.partialRight`
         *  128 - `_.rearg`
         *  256 - `_.ary`
         *  512 - `_.flip`
         * @param {*} [thisArg] The `this` binding of `func`.
         * @param {Array} [partials] The arguments to be partially applied.
         * @param {Array} [holders] The `partials` placeholder indexes.
         * @param {Array} [argPos] The argument positions of the new function.
         * @param {number} [ary] The arity cap of `func`.
         * @param {number} [arity] The arity of `func`.
         * @returns {Function} Returns the new wrapped function.
         */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
         * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
         * of source objects to the destination object for all destination properties
         * that resolve to `undefined`.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to assign.
         * @param {Object} object The parent object of `objValue`.
         * @returns {*} Returns the value to assign.
         */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
         * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
         * objects into destination objects that are passed thru.
         *
         * @private
         * @param {*} objValue The destination value.
         * @param {*} srcValue The source value.
         * @param {string} key The key of the property to merge.
         * @param {Object} object The parent object of `objValue`.
         * @param {Object} source The parent object of `srcValue`.
         * @param {Object} [stack] Tracks traversed source values and their merged
         *  counterparts.
         * @returns {*} Returns the value to assign.
         */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
         * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
         * objects.
         *
         * @private
         * @param {*} value The value to inspect.
         * @param {string} key The key of the property to inspect.
         * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
         */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
         * A specialized version of `baseIsEqualDeep` for arrays with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Array} array The array to compare.
         * @param {Array} other The other array to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `array` and `other` objects.
         * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
         */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
         * A specialized version of `baseIsEqualDeep` for comparing objects of
         * the same `toStringTag`.
         *
         * **Note:** This function only supports comparing values with tags of
         * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {string} tag The `toStringTag` of the objects to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
         * A specialized version of `baseIsEqualDeep` for objects with support for
         * partial deep comparisons.
         *
         * @private
         * @param {Object} object The object to compare.
         * @param {Object} other The other object to compare.
         * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
         * @param {Function} customizer The function to customize comparisons.
         * @param {Function} equalFunc The function to determine equivalents of values.
         * @param {Object} stack Tracks traversed `object` and `other` objects.
         * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
         */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor==='function'&&objCtor instanceof objCtor&&typeof othCtor==='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
         * A specialized version of `baseRest` which flattens the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @returns {Function} Returns the new function.
         */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
         * Creates an array of own enumerable property names and symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
         * Creates an array of own and inherited enumerable property names and
         * symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names and symbols.
         */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
         * Gets metadata for `func`.
         *
         * @private
         * @param {Function} func The function to query.
         * @returns {*} Returns the metadata for `func`.
         */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
       * Gets the name of `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {string} Returns the function name.
       */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
         * Gets the argument placeholder value for `func`.
         *
         * @private
         * @param {Function} func The function to inspect.
         * @returns {*} Returns the placeholder value.
         */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
         * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
         * this function returns the custom method, otherwise it returns `baseIteratee`.
         * If arguments are provided, the chosen function is invoked with them and
         * its result is returned.
         *
         * @private
         * @param {*} [value] The value to convert to an iteratee.
         * @param {number} [arity] The arity of the created iteratee.
         * @returns {Function} Returns the chosen function or its result.
         */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
         * Gets the data for `map`.
         *
         * @private
         * @param {Object} map The map to query.
         * @param {string} key The reference key.
         * @returns {*} Returns the map data.
         */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key==='string'?'string':'hash']:data.map;}/**
         * Gets the property names, values, and compare flags of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the match data of `object`.
         */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
         * Gets the native function at `key` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {string} key The key of the method to get.
         * @returns {*} Returns the function if it's native, else `undefined`.
         */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
         * Creates an array of the own enumerable symbols of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of symbols.
         */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
         * Gets the view, applying any `transforms` to the `start` and `end` positions.
         *
         * @private
         * @param {number} start The start of the view.
         * @param {number} end The end of the view.
         * @param {Array} transforms The transformations to apply to the view.
         * @returns {Object} Returns an object containing the `start` and `end`
         *  positions of the view.
         */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{start:start,end:end};}/**
         * Extracts wrapper details from the `source` body comment.
         *
         * @private
         * @param {string} source The source to inspect.
         * @returns {Array} Returns the wrapper details.
         */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
         * Checks if `path` exists on `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @param {Function} hasFunc The function to check properties.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
         * Initializes an array clone.
         *
         * @private
         * @param {Array} array The array to clone.
         * @returns {Array} Returns the initialized clone.
         */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]==='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
         * Initializes an object clone.
         *
         * @private
         * @param {Object} object The object to clone.
         * @returns {Object} Returns the initialized clone.
         */function initCloneObject(object){return typeof object.constructor==='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
         * Initializes an object clone based on its `toStringTag`.
         *
         * **Note:** This function only supports cloning values with tags of
         * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
         *
         * @private
         * @param {Object} object The object to clone.
         * @param {string} tag The `toStringTag` of the object to clone.
         * @param {boolean} [isDeep] Specify a deep clone.
         * @returns {Object} Returns the initialized clone.
         */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
         * Inserts wrapper `details` in a comment at the top of the `source` body.
         *
         * @private
         * @param {string} source The source to modify.
         * @returns {Array} details The details to insert.
         * @returns {string} Returns the modified source.
         */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
         * Checks if `value` is a flattenable `arguments` object or array.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
         */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */function isIndex(value,length){var type=typeof value==='undefined'?'undefined':_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
         * Checks if `value` is a property name and not a property path.
         *
         * @private
         * @param {*} value The value to check.
         * @param {Object} [object] The object to query keys on.
         * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
         */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
         * Checks if `value` is suitable for use as unique object key.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
         */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
         * Checks if `func` has a lazy counterpart.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
         *  else `false`.
         */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!=='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
         * Checks if `func` has its source masked.
         *
         * @private
         * @param {Function} func The function to check.
         * @returns {boolean} Returns `true` if `func` is masked, else `false`.
         */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
         * Checks if `func` is capable of being masked.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
         */var isMaskable=coreJsData?isFunction:stubFalse;/**
         * Checks if `value` is likely a prototype object.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
         */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor==='function'&&Ctor.prototype||objectProto;return value===proto;}/**
         * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` if suitable for strict
         *  equality comparisons, else `false`.
         */function isStrictComparable(value){return value===value&&!isObject(value);}/**
         * A specialized version of `matchesProperty` for source values suitable
         * for strict equality comparisons, i.e. `===`.
         *
         * @private
         * @param {string} key The key of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
         * A specialized version of `_.memoize` which clears the memoized function's
         * cache when it exceeds `MAX_MEMOIZE_SIZE`.
         *
         * @private
         * @param {Function} func The function to have its output memoized.
         * @returns {Function} Returns the new memoized function.
         */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
         * Merges the function metadata of `source` into `data`.
         *
         * Merging metadata reduces the number of wrappers used to invoke a function.
         * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
         * may be applied regardless of execution order. Methods like `_.ary` and
         * `_.rearg` modify function arguments, making the order in which they are
         * executed important, preventing the merging of metadata. However, we make
         * an exception for a safe combined case where curried functions have `_.ary`
         * and or `_.rearg` applied.
         *
         * @private
         * @param {Array} data The destination metadata.
         * @param {Array} source The source metadata.
         * @returns {Array} Returns `data`.
         */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
         * This function is like
         * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * except that it includes inherited enumerable properties.
         *
         * @private
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */function objectToString(value){return nativeObjectToString.call(value);}/**
         * A specialized version of `baseRest` which transforms the rest array.
         *
         * @private
         * @param {Function} func The function to apply a rest parameter to.
         * @param {number} [start=func.length-1] The start position of the rest parameter.
         * @param {Function} transform The rest array transform.
         * @returns {Function} Returns the new function.
         */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
         * Gets the parent value at `path` of `object`.
         *
         * @private
         * @param {Object} object The object to query.
         * @param {Array} path The path to get the parent value of.
         * @returns {*} Returns the parent value.
         */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
         * Reorder `array` according to the specified indexes where the element at
         * the first index is assigned as the first element, the element at
         * the second index is assigned as the second element, and so on.
         *
         * @private
         * @param {Array} array The array to reorder.
         * @param {Array} indexes The arranged array indexes.
         * @returns {Array} Returns `array`.
         */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
         * Sets metadata for `func`.
         *
         * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
         * period of time, it will trip its breaker and transition to an identity
         * function to avoid garbage collection pauses in V8. See
         * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
         * for more details.
         *
         * @private
         * @param {Function} func The function to associate metadata with.
         * @param {*} data The metadata.
         * @returns {Function} Returns `func`.
         */var setData=shortOut(baseSetData);/**
         * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
         *
         * @private
         * @param {Function} func The function to delay.
         * @param {number} wait The number of milliseconds to delay invocation.
         * @returns {number|Object} Returns the timer id or timeout object.
         */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */var setToString=shortOut(baseSetToString);/**
         * Sets the `toString` method of `wrapper` to mimic the source of `reference`
         * with wrapper details in a comment at the top of the source body.
         *
         * @private
         * @param {Function} wrapper The function to modify.
         * @param {Function} reference The reference function.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Function} Returns `wrapper`.
         */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
         * Creates a function that'll short out and invoke `identity` instead
         * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
         * milliseconds.
         *
         * @private
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new shortable function.
         */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
         * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
         *
         * @private
         * @param {Array} array The array to shuffle.
         * @param {number} [size=array.length] The size of `array`.
         * @returns {Array} Returns `array`.
         */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
         * Converts `string` to a property path array.
         *
         * @private
         * @param {string} string The string to convert.
         * @returns {Array} Returns the property path array.
         */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */function toKey(value){if(typeof value==='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
         * Converts `func` to its source code.
         *
         * @private
         * @param {Function} func The function to convert.
         * @returns {string} Returns the source code.
         */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
         * Updates wrapper `details` based on `bitmask` flags.
         *
         * @private
         * @returns {Array} details The details to modify.
         * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
         * @returns {Array} Returns `details`.
         */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
         * Creates a clone of `wrapper`.
         *
         * @private
         * @param {Object} wrapper The wrapper to clone.
         * @returns {Object} Returns the cloned wrapper.
         */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/* ------------------------------------------------------------------------*//**
         * Creates an array of elements split into groups the length of `size`.
         * If `array` can't be split evenly, the final chunk will be the remaining
         * elements.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to process.
         * @param {number} [size=1] The length of each chunk
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the new array of chunks.
         * @example
         *
         * _.chunk(['a', 'b', 'c', 'd'], 2);
         * // => [['a', 'b'], ['c', 'd']]
         *
         * _.chunk(['a', 'b', 'c', 'd'], 3);
         * // => [['a', 'b', 'c'], ['d']]
         */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
         * Creates an array with all falsey values removed. The values `false`, `null`,
         * `0`, `""`, `undefined`, and `NaN` are falsey.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to compact.
         * @returns {Array} Returns the new array of filtered values.
         * @example
         *
         * _.compact([0, 1, false, 2, '', 3]);
         * // => [1, 2, 3]
         */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
         * Creates a new array concatenating `array` with any additional arrays
         * and/or values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to concatenate.
         * @param {...*} [values] The values to concatenate.
         * @returns {Array} Returns the new concatenated array.
         * @example
         *
         * var array = [1];
         * var other = _.concat(array, 2, [3], [[4]]);
         *
         * console.log(other);
         * // => [1, 2, 3, [4]]
         *
         * console.log(array);
         * // => [1]
         */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
         * Creates an array of `array` values not included in the other given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * **Note:** Unlike `_.pullAll`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...Array} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.without, _.xor
         * @example
         *
         * _.difference([2, 1], [2, 3]);
         * // => [1]
         */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
       * This method is like `_.difference` except that it accepts `iteratee` which
       * is invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
       * This method is like `_.difference` except that it accepts `comparator`
       * which is invoked to compare elements of `array` to `values`. The order and
       * references of result values are determined by the first array. The comparator
       * is invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       *
       * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }]
       */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
       * Creates a slice of `array` with `n` elements dropped from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.drop([1, 2, 3]);
       * // => [2, 3]
       *
       * _.drop([1, 2, 3], 2);
       * // => [3]
       *
       * _.drop([1, 2, 3], 5);
       * // => []
       *
       * _.drop([1, 2, 3], 0);
       * // => [1, 2, 3]
       */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
         * Creates a slice of `array` with `n` elements dropped from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to drop.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.dropRight([1, 2, 3]);
         * // => [1, 2]
         *
         * _.dropRight([1, 2, 3], 2);
         * // => [1]
         *
         * _.dropRight([1, 2, 3], 5);
         * // => []
         *
         * _.dropRight([1, 2, 3], 0);
         * // => [1, 2, 3]
         */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
         * Creates a slice of `array` excluding elements dropped from the end.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.dropRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropRightWhile(users, ['active', false]);
         * // => objects for ['barney']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropRightWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
         * Creates a slice of `array` excluding elements dropped from the beginning.
         * Elements are dropped until `predicate` returns falsey. The predicate is
         * invoked with three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.dropWhile(users, function(o) { return !o.active; });
         * // => objects for ['pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.dropWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.dropWhile(users, ['active', false]);
         * // => objects for ['pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.dropWhile(users, 'active');
         * // => objects for ['barney', 'fred', 'pebbles']
         */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
         * Fills elements of `array` with `value` from `start` up to, but not
         * including, `end`.
         *
         * **Note:** This method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Array
         * @param {Array} array The array to fill.
         * @param {*} value The value to fill `array` with.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.fill(array, 'a');
         * console.log(array);
         * // => ['a', 'a', 'a']
         *
         * _.fill(Array(3), 2);
         * // => [2, 2, 2]
         *
         * _.fill([4, 6, 8, 10], '*', 1, 3);
         * // => [4, '*', '*', 10]
         */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!=='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
         * This method is like `_.find` except that it returns the index of the first
         * element `predicate` returns truthy for instead of the element itself.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.findIndex(users, function(o) { return o.user == 'barney'; });
         * // => 0
         *
         * // The `_.matches` iteratee shorthand.
         * _.findIndex(users, { 'user': 'fred', 'active': false });
         * // => 1
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findIndex(users, ['active', false]);
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.findIndex(users, 'active');
         * // => 2
         */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
         * This method is like `_.findIndex` except that it iterates over elements
         * of `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the found element, else `-1`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
         * // => 2
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastIndex(users, { 'user': 'barney', 'active': true });
         * // => 0
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastIndex(users, ['active', false]);
         * // => 2
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastIndex(users, 'active');
         * // => 0
         */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
         * Flattens `array` a single level deep.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flatten([1, [2, [3, [4]], 5]]);
         * // => [1, 2, [3, [4]], 5]
         */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
         * Recursively flattens `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * _.flattenDeep([1, [2, [3, [4]], 5]]);
         * // => [1, 2, 3, 4, 5]
         */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
         * Recursively flatten `array` up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Array
         * @param {Array} array The array to flatten.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * var array = [1, [2, [3, [4]], 5]];
         *
         * _.flattenDepth(array, 1);
         * // => [1, 2, [3, [4]], 5]
         *
         * _.flattenDepth(array, 2);
         * // => [1, 2, 3, [4], 5]
         */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
         * The inverse of `_.toPairs`; this method returns an object composed
         * from key-value `pairs`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} pairs The key-value pairs.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.fromPairs([['a', 1], ['b', 2]]);
         * // => { 'a': 1, 'b': 2 }
         */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
         * Gets the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias first
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the first element of `array`.
         * @example
         *
         * _.head([1, 2, 3]);
         * // => 1
         *
         * _.head([]);
         * // => undefined
         */function head(array){return array&&array.length?array[0]:undefined;}/**
         * Gets the index at which the first occurrence of `value` is found in `array`
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. If `fromIndex` is negative, it's used as the
         * offset from the end of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.indexOf([1, 2, 1, 2], 2);
         * // => 1
         *
         * // Search from the `fromIndex`.
         * _.indexOf([1, 2, 1, 2], 2, 2);
         * // => 3
         */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
         * Gets all but the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.initial([1, 2, 3]);
         * // => [1, 2]
         */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
         * Creates an array of unique values that are included in all given arrays
         * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons. The order and references of result values are
         * determined by the first array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of intersecting values.
         * @example
         *
         * _.intersection([2, 1], [2, 3]);
         * // => [2]
         */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
       * This method is like `_.intersection` except that it accepts `iteratee`
       * which is invoked for each element of each `arrays` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [2.1]
       *
       * // The `_.property` iteratee shorthand.
       * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }]
       */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
       * This method is like `_.intersection` except that it accepts `comparator`
       * which is invoked to compare elements of `arrays`. The order and references
       * of result values are determined by the first array. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.intersectionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }]
       */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator==='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
       * Converts all elements in `array` into a string separated by `separator`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to convert.
       * @param {string} [separator=','] The element separator.
       * @returns {string} Returns the joined string.
       * @example
       *
       * _.join(['a', 'b', 'c'], '~');
       * // => 'a~b~c'
       */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
         * Gets the last element of `array`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {*} Returns the last element of `array`.
         * @example
         *
         * _.last([1, 2, 3]);
         * // => 3
         */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
         * This method is like `_.indexOf` except that it iterates over elements of
         * `array` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @param {number} [fromIndex=array.length-1] The index to search from.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.lastIndexOf([1, 2, 1, 2], 2);
         * // => 3
         *
         * // Search from the `fromIndex`.
         * _.lastIndexOf([1, 2, 1, 2], 2, 2);
         * // => 1
         */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
         * Gets the element at index `n` of `array`. If `n` is negative, the nth
         * element from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.11.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=0] The index of the element to return.
         * @returns {*} Returns the nth element of `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         *
         * _.nth(array, 1);
         * // => 'b'
         *
         * _.nth(array, -2);
         * // => 'c';
         */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
         * Removes all given values from `array` using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
         * to remove elements from an array by predicate.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...*} [values] The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pull(array, 'a', 'c');
         * console.log(array);
         * // => ['b', 'b']
         */var pull=baseRest(pullAll);/**
         * This method is like `_.pull` except that it accepts an array of values to remove.
         *
         * **Note:** Unlike `_.difference`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
         *
         * _.pullAll(array, ['a', 'c']);
         * console.log(array);
         * // => ['b', 'b']
         */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
         * This method is like `_.pullAll` except that it accepts `iteratee` which is
         * invoked for each element of `array` and `values` to generate the criterion
         * by which they're compared. The iteratee is invoked with one argument: (value).
         *
         * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
         *
         * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
         * console.log(array);
         * // => [{ 'x': 2 }]
         */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
         * This method is like `_.pullAll` except that it accepts `comparator` which
         * is invoked to compare elements of `array` to `values`. The comparator is
         * invoked with two arguments: (arrVal, othVal).
         *
         * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {Array} values The values to remove.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
         *
         * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
         * console.log(array);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
         */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
         * Removes elements from `array` corresponding to `indexes` and returns an
         * array of removed elements.
         *
         * **Note:** Unlike `_.at`, this method mutates `array`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @param {...(number|number[])} [indexes] The indexes of elements to remove.
         * @returns {Array} Returns the new array of removed elements.
         * @example
         *
         * var array = ['a', 'b', 'c', 'd'];
         * var pulled = _.pullAt(array, [1, 3]);
         *
         * console.log(array);
         * // => ['a', 'c']
         *
         * console.log(pulled);
         * // => ['b', 'd']
         */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
       * Removes all elements from `array` that `predicate` returns truthy for
       * and returns an array of the removed elements. The predicate is invoked
       * with three arguments: (value, index, array).
       *
       * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
       * to pull elements from an array by value.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = [1, 2, 3, 4];
       * var evens = _.remove(array, function(n) {
       *   return n % 2 == 0;
       * });
       *
       * console.log(array);
       * // => [1, 3]
       *
       * console.log(evens);
       * // => [2, 4]
       */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
         * Reverses `array` so that the first element becomes the last, the second
         * element becomes the second to last, and so on.
         *
         * **Note:** This method mutates `array` and is based on
         * [`Array#reverse`](https://mdn.io/Array/reverse).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to modify.
         * @returns {Array} Returns `array`.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _.reverse(array);
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
         * Creates a slice of `array` from `start` up to, but not including, `end`.
         *
         * **Note:** This method is used instead of
         * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
         * returned.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!=='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
         * Uses a binary search to determine the lowest index at which `value`
         * should be inserted into `array` in order to maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedIndex([30, 50], 40);
         * // => 1
         */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
         * This method is like `_.sortedIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 0
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
         * // => 0
         */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
         * This method is like `_.indexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
         * // => 1
         */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
         * This method is like `_.sortedIndex` except that it returns the highest
         * index at which `value` should be inserted into `array` in order to
         * maintain its sort order.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
         * // => 4
         */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
         * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
         * which is invoked for `value` and each element of `array` to compute their
         * sort ranking. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The sorted array to inspect.
         * @param {*} value The value to evaluate.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the index at which `value` should be inserted
         *  into `array`.
         * @example
         *
         * var objects = [{ 'x': 4 }, { 'x': 5 }];
         *
         * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
         * // => 1
         *
         * // The `_.property` iteratee shorthand.
         * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
         * // => 1
         */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
         * This method is like `_.lastIndexOf` except that it performs a binary
         * search on a sorted `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {*} value The value to search for.
         * @returns {number} Returns the index of the matched value, else `-1`.
         * @example
         *
         * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
         * // => 3
         */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
         * This method is like `_.uniq` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniq([1, 1, 2]);
         * // => [1, 2]
         */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
         * This method is like `_.uniqBy` except that it's designed and optimized
         * for sorted arrays.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
         * // => [1.1, 2.3]
         */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
         * Gets all but the first element of `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.tail([1, 2, 3]);
         * // => [2, 3]
         */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
         * Creates a slice of `array` with `n` elements taken from the beginning.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.take([1, 2, 3]);
         * // => [1]
         *
         * _.take([1, 2, 3], 2);
         * // => [1, 2]
         *
         * _.take([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.take([1, 2, 3], 0);
         * // => []
         */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
         * Creates a slice of `array` with `n` elements taken from the end.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {number} [n=1] The number of elements to take.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * _.takeRight([1, 2, 3]);
         * // => [3]
         *
         * _.takeRight([1, 2, 3], 2);
         * // => [2, 3]
         *
         * _.takeRight([1, 2, 3], 5);
         * // => [1, 2, 3]
         *
         * _.takeRight([1, 2, 3], 0);
         * // => []
         */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
         * Creates a slice of `array` with elements taken from the end. Elements are
         * taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': true },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': false }
         * ];
         *
         * _.takeRightWhile(users, function(o) { return !o.active; });
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
         * // => objects for ['pebbles']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeRightWhile(users, ['active', false]);
         * // => objects for ['fred', 'pebbles']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeRightWhile(users, 'active');
         * // => []
         */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
         * Creates a slice of `array` with elements taken from the beginning. Elements
         * are taken until `predicate` returns falsey. The predicate is invoked with
         * three arguments: (value, index, array).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to query.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the slice of `array`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'active': false },
         *   { 'user': 'fred',    'active': false },
         *   { 'user': 'pebbles', 'active': true }
         * ];
         *
         * _.takeWhile(users, function(o) { return !o.active; });
         * // => objects for ['barney', 'fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.takeWhile(users, { 'user': 'barney', 'active': false });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.takeWhile(users, ['active', false]);
         * // => objects for ['barney', 'fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.takeWhile(users, 'active');
         * // => []
         */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
         * Creates an array of unique values, in order, from all given arrays using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {...Array} [arrays] The arrays to inspect.
         * @returns {Array} Returns the new array of combined values.
         * @example
         *
         * _.union([2], [1, 2]);
         * // => [2, 1]
         */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
       * This method is like `_.union` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which uniqueness is computed. Result values are chosen from the first
       * array in which the value occurs. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.unionBy([2.1], [1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
       * This method is like `_.union` except that it accepts `comparator` which
       * is invoked to compare elements of `arrays`. Result values are chosen from
       * the first array in which the value occurs. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.unionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator==='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
       * Creates a duplicate-free version of an array, using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons, in which only the first occurrence of each element
       * is kept. The order of result values is determined by the order they occur
       * in the array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniq([2, 1, 2]);
       * // => [2, 1]
       */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
         * This method is like `_.uniq` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * uniqueness is computed. The order of result values is determined by the
         * order they occur in the array. The iteratee is invoked with one argument:
         * (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
         * // => [2.1, 1.2]
         *
         * // The `_.property` iteratee shorthand.
         * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
         * // => [{ 'x': 1 }, { 'x': 2 }]
         */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
         * This method is like `_.uniq` except that it accepts `comparator` which
         * is invoked to compare elements of `array`. The order of result values is
         * determined by the order they occur in the array.The comparator is invoked
         * with two arguments: (arrVal, othVal).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {Function} [comparator] The comparator invoked per element.
         * @returns {Array} Returns the new duplicate free array.
         * @example
         *
         * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
         *
         * _.uniqWith(objects, _.isEqual);
         * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
         */function uniqWith(array,comparator){comparator=typeof comparator==='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
         * This method is like `_.zip` except that it accepts an array of grouped
         * elements and creates an array regrouping the elements to their pre-zip
         * configuration.
         *
         * @static
         * @memberOf _
         * @since 1.2.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
         * // => [['a', 1, true], ['b', 2, false]]
         *
         * _.unzip(zipped);
         * // => [['a', 'b'], [1, 2], [true, false]]
         */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
         * This method is like `_.unzip` except that it accepts `iteratee` to specify
         * how regrouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {Array} array The array of grouped elements to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  regrouped values.
         * @returns {Array} Returns the new array of regrouped elements.
         * @example
         *
         * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
         * // => [[1, 10, 100], [2, 20, 200]]
         *
         * _.unzipWith(zipped, _.add);
         * // => [3, 30, 300]
         */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
         * Creates an array excluding all given values using
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * for equality comparisons.
         *
         * **Note:** Unlike `_.pull`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Array
         * @param {Array} array The array to inspect.
         * @param {...*} [values] The values to exclude.
         * @returns {Array} Returns the new array of filtered values.
         * @see _.difference, _.xor
         * @example
         *
         * _.without([2, 1, 2, 3], 1, 2);
         * // => [3]
         */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
       * Creates an array of unique values that is the
       * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
       * of the given arrays. The order of result values is determined by the order
       * they occur in the arrays.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.without
       * @example
       *
       * _.xor([2, 1], [2, 3]);
       * // => [1, 3]
       */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
       * This method is like `_.xor` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which by which they're compared. The order of result values is determined
       * by the order they occur in the arrays. The iteratee is invoked with one
       * argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2, 3.4]
       *
       * // The `_.property` iteratee shorthand.
       * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
       * This method is like `_.xor` except that it accepts `comparator` which is
       * invoked to compare elements of `arrays`. The order of result values is
       * determined by the order they occur in the arrays. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.xorWith(objects, others, _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator==='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
       * Creates an array of grouped elements, the first of which contains the
       * first elements of the given arrays, the second of which contains the
       * second elements of the given arrays, and so on.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       */var zip=baseRest(unzip);/**
         * This method is like `_.fromPairs` except that it accepts two arrays,
         * one of property identifiers and one of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 0.4.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObject(['a', 'b'], [1, 2]);
         * // => { 'a': 1, 'b': 2 }
         */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
         * This method is like `_.zipObject` except that it supports property paths.
         *
         * @static
         * @memberOf _
         * @since 4.1.0
         * @category Array
         * @param {Array} [props=[]] The property identifiers.
         * @param {Array} [values=[]] The property values.
         * @returns {Object} Returns the new object.
         * @example
         *
         * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
         * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
         */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
         * This method is like `_.zip` except that it accepts `iteratee` to specify
         * how grouped values should be combined. The iteratee is invoked with the
         * elements of each group: (...group).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Array
         * @param {...Array} [arrays] The arrays to process.
         * @param {Function} [iteratee=_.identity] The function to combine
         *  grouped values.
         * @returns {Array} Returns the new array of grouped elements.
         * @example
         *
         * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
         *   return a + b + c;
         * });
         * // => [111, 222]
         */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee==='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/* ------------------------------------------------------------------------*//**
       * Creates a `lodash` wrapper instance that wraps `value` with explicit method
       * chain sequences enabled. The result of such sequences must be unwrapped
       * with `_#value`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Seq
       * @param {*} value The value to wrap.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36 },
       *   { 'user': 'fred',    'age': 40 },
       *   { 'user': 'pebbles', 'age': 1 }
       * ];
       *
       * var youngest = _
       *   .chain(users)
       *   .sortBy('age')
       *   .map(function(o) {
       *     return o.user + ' is ' + o.age;
       *   })
       *   .head()
       *   .value();
       * // => 'pebbles is 1'
       */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
         * This method invokes `interceptor` and returns `value`. The interceptor
         * is invoked with one argument; (value). The purpose of this method is to
         * "tap into" a method chain sequence in order to modify intermediate results.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns `value`.
         * @example
         *
         * _([1, 2, 3])
         *  .tap(function(array) {
         *    // Mutate input array.
         *    array.pop();
         *  })
         *  .reverse()
         *  .value();
         * // => [2, 1]
         */function tap(value,interceptor){interceptor(value);return value;}/**
         * This method is like `_.tap` except that it returns the result of `interceptor`.
         * The purpose of this method is to "pass thru" values replacing intermediate
         * results in a method chain sequence.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Seq
         * @param {*} value The value to provide to `interceptor`.
         * @param {Function} interceptor The function to invoke.
         * @returns {*} Returns the result of `interceptor`.
         * @example
         *
         * _('  abc  ')
         *  .chain()
         *  .trim()
         *  .thru(function(value) {
         *    return [value];
         *  })
         *  .value();
         * // => ['abc']
         */function thru(value,interceptor){return interceptor(value);}/**
         * This method is the wrapper version of `_.at`.
         *
         * @name at
         * @memberOf _
         * @since 1.0.0
         * @category Seq
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
         *
         * _(object).at(['a[0].b.c', 'a[1]']).value();
         * // => [3, 4]
         */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({func:thru,args:[interceptor],thisArg:undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
       * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
       *
       * @name chain
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 40 }
       * ];
       *
       * // A sequence without explicit chaining.
       * _(users).head();
       * // => { 'user': 'barney', 'age': 36 }
       *
       * // A sequence with explicit chaining.
       * _(users)
       *   .chain()
       *   .head()
       *   .pick('user')
       *   .value();
       * // => { 'user': 'barney' }
       */function wrapperChain(){return chain(this);}/**
         * Executes the chain sequence and returns the wrapped result.
         *
         * @name commit
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2];
         * var wrapped = _(array).push(3);
         *
         * console.log(array);
         * // => [1, 2]
         *
         * wrapped = wrapped.commit();
         * console.log(array);
         * // => [1, 2, 3]
         *
         * wrapped.last();
         * // => 3
         *
         * console.log(array);
         * // => [1, 2, 3]
         */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
         * Gets the next value on a wrapped object following the
         * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
         *
         * @name next
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the next iterator value.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 1 }
         *
         * wrapped.next();
         * // => { 'done': false, 'value': 2 }
         *
         * wrapped.next();
         * // => { 'done': true, 'value': undefined }
         */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{done:done,value:value};}/**
         * Enables the wrapper to be iterable.
         *
         * @name Symbol.iterator
         * @memberOf _
         * @since 4.0.0
         * @category Seq
         * @returns {Object} Returns the wrapper object.
         * @example
         *
         * var wrapped = _([1, 2]);
         *
         * wrapped[Symbol.iterator]() === wrapped;
         * // => true
         *
         * Array.from(wrapped);
         * // => [1, 2]
         */function wrapperToIterator(){return this;}/**
         * Creates a clone of the chain sequence planting `value` as the wrapped value.
         *
         * @name plant
         * @memberOf _
         * @since 3.2.0
         * @category Seq
         * @param {*} value The value to plant.
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var wrapped = _([1, 2]).map(square);
         * var other = wrapped.plant([3, 4]);
         *
         * other.value();
         * // => [9, 16]
         *
         * wrapped.value();
         * // => [1, 4]
         */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
         * This method is the wrapper version of `_.reverse`.
         *
         * **Note:** This method mutates the wrapped array.
         *
         * @name reverse
         * @memberOf _
         * @since 0.1.0
         * @category Seq
         * @returns {Object} Returns the new `lodash` wrapper instance.
         * @example
         *
         * var array = [1, 2, 3];
         *
         * _(array).reverse().value()
         * // => [3, 2, 1]
         *
         * console.log(array);
         * // => [3, 2, 1]
         */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({func:thru,args:[reverse],thisArg:undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
         * Executes the chain sequence to resolve the unwrapped value.
         *
         * @name value
         * @memberOf _
         * @since 0.1.0
         * @alias toJSON, valueOf
         * @category Seq
         * @returns {*} Returns the resolved unwrapped value.
         * @example
         *
         * _([1, 2, 3]).value();
         * // => [1, 2, 3]
         */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/* ------------------------------------------------------------------------*//**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The corresponding value of
         * each key is the number of times the key was returned by `iteratee`. The
         * iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.countBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': 1, '6': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.countBy(['one', 'two', 'three'], 'length');
         * // => { '3': 2, '5': 1 }
         */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
       * Checks if `predicate` returns truthy for **all** elements of `collection`.
       * Iteration is stopped once `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * **Note:** This method returns `true` for
       * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
       * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
       * elements of empty collections.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       * @example
       *
       * _.every([true, 1, null, 'yes'], Boolean);
       * // => false
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.every(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.every(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.every(users, 'active');
       * // => false
       */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
         * Iterates over elements of `collection`, returning an array of all elements
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * **Note:** Unlike `_.remove`, this method returns a new array.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.reject
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * _.filter(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, { 'age': 36, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.filter(users, 'active');
         * // => objects for ['barney']
         */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
         * Iterates over elements of `collection`, returning the first element
         * `predicate` returns truthy for. The predicate is invoked with three
         * arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=0] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': true },
         *   { 'user': 'fred',    'age': 40, 'active': false },
         *   { 'user': 'pebbles', 'age': 1,  'active': true }
         * ];
         *
         * _.find(users, function(o) { return o.age < 40; });
         * // => object for 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.find(users, { 'age': 1, 'active': true });
         * // => object for 'pebbles'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.find(users, ['active', false]);
         * // => object for 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.find(users, 'active');
         * // => object for 'barney'
         */var find=createFind(findIndex);/**
         * This method is like `_.find` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param {number} [fromIndex=collection.length-1] The index to search from.
         * @returns {*} Returns the matched element, else `undefined`.
         * @example
         *
         * _.findLast([1, 2, 3, 4], function(n) {
         *   return n % 2 == 1;
         * });
         * // => 3
         */var findLast=createFind(findLastIndex);/**
         * Creates a flattened array of values by running each element in `collection`
         * thru `iteratee` and flattening the mapped results. The iteratee is invoked
         * with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [n, n];
         * }
         *
         * _.flatMap([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDeep([1, 2], duplicate);
         * // => [1, 1, 2, 2]
         */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
         * This method is like `_.flatMap` except that it recursively flattens the
         * mapped results up to `depth` times.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {number} [depth=1] The maximum recursion depth.
         * @returns {Array} Returns the new flattened array.
         * @example
         *
         * function duplicate(n) {
         *   return [[[n, n]]];
         * }
         *
         * _.flatMapDepth([1, 2], duplicate, 2);
         * // => [[1, 1], [2, 2]]
         */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
         * Iterates over elements of `collection` and invokes `iteratee` for each element.
         * The iteratee is invoked with three arguments: (value, index|key, collection).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * **Note:** As with other "Collections" methods, objects with a "length"
         * property are iterated like arrays. To avoid this behavior use `_.forIn`
         * or `_.forOwn` for object iteration.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @alias each
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEachRight
         * @example
         *
         * _.forEach([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `1` then `2`.
         *
         * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
         * This method is like `_.forEach` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @alias eachRight
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array|Object} Returns `collection`.
         * @see _.forEach
         * @example
         *
         * _.forEachRight([1, 2], function(value) {
         *   console.log(value);
         * });
         * // => Logs `2` then `1`.
         */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
         * Creates an object composed of keys generated from the results of running
         * each element of `collection` thru `iteratee`. The order of grouped values
         * is determined by the order they occur in `collection`. The corresponding
         * value of each key is an array of elements responsible for generating the
         * key. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
         * @returns {Object} Returns the composed aggregate object.
         * @example
         *
         * _.groupBy([6.1, 4.2, 6.3], Math.floor);
         * // => { '4': [4.2], '6': [6.1, 6.3] }
         *
         * // The `_.property` iteratee shorthand.
         * _.groupBy(['one', 'two', 'three'], 'length');
         * // => { '3': ['one', 'two'], '5': ['three'] }
         */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
         * Invokes the method at `path` of each element in `collection`, returning
         * an array of the results of each invoked method. Any additional arguments
         * are provided to each invoked method. If `path` is a function, it's invoked
         * for, and `this` bound to, each element in `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array|Function|string} path The path of the method to invoke or
         *  the function invoked per iteration.
         * @param {...*} [args] The arguments to invoke each method with.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
         * // => [[1, 5, 7], [1, 2, 3]]
         *
         * _.invokeMap([123, 456], String.prototype.split, '');
         * // => [['1', '2', '3'], ['4', '5', '6']]
         */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path==='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the last element responsible for generating the key. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * var array = [
       *   { 'dir': 'left', 'code': 97 },
       *   { 'dir': 'right', 'code': 100 }
       * ];
       *
       * _.keyBy(array, function(o) {
       *   return String.fromCharCode(o.code);
       * });
       * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
       *
       * _.keyBy(array, 'dir');
       * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
       */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
       * Creates an array of values by running each element in `collection` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
       *
       * The guarded methods are:
       * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
       * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
       * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
       * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * _.map([4, 8], square);
       * // => [16, 64]
       *
       * _.map({ 'a': 4, 'b': 8 }, square);
       * // => [16, 64] (iteration order is not guaranteed)
       *
       * var users = [
       *   { 'user': 'barney' },
       *   { 'user': 'fred' }
       * ];
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, 'user');
       * // => ['barney', 'fred']
       */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
         * This method is like `_.sortBy` except that it allows specifying the sort
         * orders of the iteratees to sort by. If `orders` is unspecified, all values
         * are sorted in ascending order. Otherwise, specify an order of "desc" for
         * descending or "asc" for ascending sort order of corresponding values.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @param {string[]} [orders] The sort orders of `iteratees`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 34 },
         *   { 'user': 'fred',   'age': 40 },
         *   { 'user': 'barney', 'age': 36 }
         * ];
         *
         * // Sort by `user` in ascending order and by `age` in descending order.
         * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
         */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
         * Creates an array of elements split into two groups, the first of which
         * contains elements `predicate` returns truthy for, the second of which
         * contains elements `predicate` returns falsey for. The predicate is
         * invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of grouped elements.
         * @example
         *
         * var users = [
         *   { 'user': 'barney',  'age': 36, 'active': false },
         *   { 'user': 'fred',    'age': 40, 'active': true },
         *   { 'user': 'pebbles', 'age': 1,  'active': false }
         * ];
         *
         * _.partition(users, function(o) { return o.active; });
         * // => objects for [['fred'], ['barney', 'pebbles']]
         *
         * // The `_.matches` iteratee shorthand.
         * _.partition(users, { 'age': 1, 'active': false });
         * // => objects for [['pebbles'], ['barney', 'fred']]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.partition(users, ['active', false]);
         * // => objects for [['barney', 'pebbles'], ['fred']]
         *
         * // The `_.property` iteratee shorthand.
         * _.partition(users, 'active');
         * // => objects for [['fred'], ['barney', 'pebbles']]
         */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
       * Reduces `collection` to a value which is the accumulated result of running
       * each element in `collection` thru `iteratee`, where each successive
       * invocation is supplied the return value of the previous. If `accumulator`
       * is not given, the first element of `collection` is used as the initial
       * value. The iteratee is invoked with four arguments:
       * (accumulator, value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.reduce`, `_.reduceRight`, and `_.transform`.
       *
       * The guarded methods are:
       * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
       * and `sortBy`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduceRight
       * @example
       *
       * _.reduce([1, 2], function(sum, n) {
       *   return sum + n;
       * }, 0);
       * // => 3
       *
       * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       *   return result;
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
       */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
         * This method is like `_.reduce` except that it iterates over elements of
         * `collection` from right to left.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The initial value.
         * @returns {*} Returns the accumulated value.
         * @see _.reduce
         * @example
         *
         * var array = [[0, 1], [2, 3], [4, 5]];
         *
         * _.reduceRight(array, function(flattened, other) {
         *   return flattened.concat(other);
         * }, []);
         * // => [4, 5, 2, 3, 0, 1]
         */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
         * The opposite of `_.filter`; this method returns the elements of `collection`
         * that `predicate` does **not** return truthy for.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the new filtered array.
         * @see _.filter
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': false },
         *   { 'user': 'fred',   'age': 40, 'active': true }
         * ];
         *
         * _.reject(users, function(o) { return !o.active; });
         * // => objects for ['fred']
         *
         * // The `_.matches` iteratee shorthand.
         * _.reject(users, { 'age': 40, 'active': true });
         * // => objects for ['barney']
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.reject(users, ['active', false]);
         * // => objects for ['fred']
         *
         * // The `_.property` iteratee shorthand.
         * _.reject(users, 'active');
         * // => objects for ['barney']
         */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
         * Gets a random element from `collection`.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @returns {*} Returns the random element.
         * @example
         *
         * _.sample([1, 2, 3, 4]);
         * // => 2
         */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
         * Gets `n` random elements at unique keys from `collection` up to the
         * size of `collection`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Collection
         * @param {Array|Object} collection The collection to sample.
         * @param {number} [n=1] The number of elements to sample.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the random elements.
         * @example
         *
         * _.sampleSize([1, 2, 3], 2);
         * // => [3, 1]
         *
         * _.sampleSize([1, 2, 3], 4);
         * // => [2, 3, 1]
         */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
         * Creates an array of shuffled values, using a version of the
         * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to shuffle.
         * @returns {Array} Returns the new shuffled array.
         * @example
         *
         * _.shuffle([1, 2, 3, 4]);
         * // => [4, 1, 3, 2]
         */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
         * Gets the size of `collection` by returning its length for array-like
         * values or the number of own enumerable string keyed properties for objects.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object|string} collection The collection to inspect.
         * @returns {number} Returns the collection size.
         * @example
         *
         * _.size([1, 2, 3]);
         * // => 3
         *
         * _.size({ 'a': 1, 'b': 2 });
         * // => 2
         *
         * _.size('pebbles');
         * // => 7
         */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
         * Checks if `predicate` returns truthy for **any** element of `collection`.
         * Iteration is stopped once `predicate` returns truthy. The predicate is
         * invoked with three arguments: (value, index|key, collection).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {boolean} Returns `true` if any element passes the predicate check,
         *  else `false`.
         * @example
         *
         * _.some([null, 0, 'yes', false], Boolean);
         * // => true
         *
         * var users = [
         *   { 'user': 'barney', 'active': true },
         *   { 'user': 'fred',   'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.some(users, { 'user': 'barney', 'active': false });
         * // => false
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.some(users, ['active', false]);
         * // => true
         *
         * // The `_.property` iteratee shorthand.
         * _.some(users, 'active');
         * // => true
         */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
         * Creates an array of elements, sorted in ascending order by the results of
         * running each element in a collection thru each iteratee. This method
         * performs a stable sort, that is, it preserves the original sort order of
         * equal elements. The iteratees are invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Collection
         * @param {Array|Object} collection The collection to iterate over.
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to sort by.
         * @returns {Array} Returns the new sorted array.
         * @example
         *
         * var users = [
         *   { 'user': 'fred',   'age': 48 },
         *   { 'user': 'barney', 'age': 36 },
         *   { 'user': 'fred',   'age': 40 },
         *   { 'user': 'barney', 'age': 34 }
         * ];
         *
         * _.sortBy(users, [function(o) { return o.user; }]);
         * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
         *
         * _.sortBy(users, ['user', 'age']);
         * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
         */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/* ------------------------------------------------------------------------*//**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */var now=ctxNow||function(){return root.Date.now();};/* ------------------------------------------------------------------------*//**
       * The opposite of `_.before`; this method creates a function that invokes
       * `func` once it's called `n` or more times.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {number} n The number of calls before `func` is invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var saves = ['profile', 'settings'];
       *
       * var done = _.after(saves.length, function() {
       *   console.log('done saving!');
       * });
       *
       * _.forEach(saves, function(type) {
       *   asyncSave({ 'type': type, 'complete': done });
       * });
       * // => Logs 'done saving!' after the two async saves have completed.
       */function after(n,func){if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
         * Creates a function that invokes `func`, with up to `n` arguments,
         * ignoring any additional arguments.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @param {number} [n=func.length] The arity cap.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.ary(parseInt, 1));
         * // => [6, 8, 10]
         */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
         * Creates a function that invokes `func`, with the `this` binding and arguments
         * of the created function, while it's called less than `n` times. Subsequent
         * calls to the created function return the result of the last `func` invocation.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {number} n The number of calls at which `func` is no longer invoked.
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * jQuery(element).on('click', _.before(5, addContactToList));
         * // => Allows adding up to 4 contacts to the list.
         */function before(n,func){var result;if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
         * Creates a function that invokes `func` with the `this` binding of `thisArg`
         * and `partials` prepended to the arguments it receives.
         *
         * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
         * may be used as a placeholder for partially applied arguments.
         *
         * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
         * property of bound functions.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to bind.
         * @param {*} thisArg The `this` binding of `func`.
         * @param {...*} [partials] The arguments to be partially applied.
         * @returns {Function} Returns the new bound function.
         * @example
         *
         * function greet(greeting, punctuation) {
         *   return greeting + ' ' + this.user + punctuation;
         * }
         *
         * var object = { 'user': 'fred' };
         *
         * var bound = _.bind(greet, object, 'hi');
         * bound('!');
         * // => 'hi fred!'
         *
         * // Bound with placeholders.
         * var bound = _.bind(greet, object, _, '!');
         * bound('hi');
         * // => 'hi fred!'
         */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
       * Creates a function that invokes the method at `object[key]` with `partials`
       * prepended to the arguments it receives.
       *
       * This method differs from `_.bind` by allowing bound functions to reference
       * methods that may be redefined or don't yet exist. See
       * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
       * for more details.
       *
       * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Function
       * @param {Object} object The object to invoke the method on.
       * @param {string} key The key of the method.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * var object = {
       *   'user': 'fred',
       *   'greet': function(greeting, punctuation) {
       *     return greeting + ' ' + this.user + punctuation;
       *   }
       * };
       *
       * var bound = _.bindKey(object, 'greet', 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * object.greet = function(greeting, punctuation) {
       *   return greeting + 'ya ' + this.user + punctuation;
       * };
       *
       * bound('!');
       * // => 'hiya fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bindKey(object, 'greet', _, '!');
       * bound('hi');
       * // => 'hiya fred!'
       */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
       * Creates a function that accepts arguments of `func` and either invokes
       * `func` returning its result, if at least `arity` number of arguments have
       * been provided, or returns a function that accepts the remaining `func`
       * arguments, and so on. The arity of `func` may be specified if `func.length`
       * is not sufficient.
       *
       * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curry(abc);
       *
       * curried(1)(2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(1)(_, 3)(2);
       * // => [1, 2, 3]
       */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
         * This method is like `_.curry` except that arguments are applied to `func`
         * in the manner of `_.partialRight` instead of `_.partial`.
         *
         * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
         * builds, may be used as a placeholder for provided arguments.
         *
         * **Note:** This method doesn't set the "length" property of curried functions.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} func The function to curry.
         * @param {number} [arity=func.length] The arity of `func`.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the new curried function.
         * @example
         *
         * var abc = function(a, b, c) {
         *   return [a, b, c];
         * };
         *
         * var curried = _.curryRight(abc);
         *
         * curried(3)(2)(1);
         * // => [1, 2, 3]
         *
         * curried(2, 3)(1);
         * // => [1, 2, 3]
         *
         * curried(1, 2, 3);
         * // => [1, 2, 3]
         *
         * // Curried with placeholders.
         * curried(3)(1, _)(2);
         * // => [1, 2, 3]
         */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
         * Defers invoking the `func` until the current call stack has cleared. Any
         * additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to defer.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {number} Returns the timer id.
         * @example
         *
         * _.defer(function(text) {
         *   console.log(text);
         * }, 'deferred');
         * // => Logs 'deferred' after one millisecond.
         */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.delay(function(text) {
       *   console.log(text);
       * }, 1000, 'later');
       * // => Logs 'later' after one second.
       */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
       * Creates a function that invokes `func` with arguments reversed.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to flip arguments for.
       * @returns {Function} Returns the new flipped function.
       * @example
       *
       * var flipped = _.flip(function() {
       *   return _.toArray(arguments);
       * });
       *
       * flipped('a', 'b', 'c', 'd');
       * // => ['d', 'c', 'b', 'a']
       */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
         * Creates a function that memoizes the result of `func`. If `resolver` is
         * provided, it determines the cache key for storing the result based on the
         * arguments provided to the memoized function. By default, the first argument
         * provided to the memoized function is used as the map cache key. The `func`
         * is invoked with the `this` binding of the memoized function.
         *
         * **Note:** The cache is exposed as the `cache` property on the memoized
         * function. Its creation may be customized by replacing the `_.memoize.Cache`
         * constructor with one whose instances implement the
         * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
         * method interface of `clear`, `delete`, `get`, `has`, and `set`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to have its output memoized.
         * @param {Function} [resolver] The function to resolve the cache key.
         * @returns {Function} Returns the new memoized function.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         * var other = { 'c': 3, 'd': 4 };
         *
         * var values = _.memoize(_.values);
         * values(object);
         * // => [1, 2]
         *
         * values(other);
         * // => [3, 4]
         *
         * object.a = 2;
         * values(object);
         * // => [1, 2]
         *
         * // Modify the result cache.
         * values.cache.set(object, ['a', 'b']);
         * values(object);
         * // => ['a', 'b']
         *
         * // Replace `_.memoize.Cache`.
         * _.memoize.Cache = WeakMap;
         */function memoize(func,resolver){if(typeof func!=='function'||resolver!=null&&typeof resolver!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
         * Creates a function that negates the result of the predicate `func`. The
         * `func` predicate is invoked with the `this` binding and arguments of the
         * created function.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Function
         * @param {Function} predicate The predicate to negate.
         * @returns {Function} Returns the new negated function.
         * @example
         *
         * function isEven(n) {
         *   return n % 2 == 0;
         * }
         *
         * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
         * // => [1, 3, 5]
         */function negate(predicate){if(typeof predicate!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
         * Creates a function that is restricted to invoking `func` once. Repeat calls
         * to the function return the value of the first invocation. The `func` is
         * invoked with the `this` binding and arguments of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to restrict.
         * @returns {Function} Returns the new restricted function.
         * @example
         *
         * var initialize = _.once(createApplication);
         * initialize();
         * initialize();
         * // => `createApplication` is invoked once
         */function once(func){return before(2,func);}/**
         * Creates a function that invokes `func` with its arguments transformed.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Function
         * @param {Function} func The function to wrap.
         * @param {...(Function|Function[])} [transforms=[_.identity]]
         *  The argument transforms.
         * @returns {Function} Returns the new function.
         * @example
         *
         * function doubled(n) {
         *   return n * 2;
         * }
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var func = _.overArgs(function(x, y) {
         *   return [x, y];
         * }, [square, doubled]);
         *
         * func(9, 3);
         * // => [81, 6]
         *
         * func(10, 5);
         * // => [100, 10]
         */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
       * Creates a function that invokes `func` with `partials` prepended to the
       * arguments it receives. This method is like `_.bind` except it does **not**
       * alter the `this` binding.
       *
       * The `_.partial.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 0.2.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var sayHelloTo = _.partial(greet, 'hello');
       * sayHelloTo('fred');
       * // => 'hello fred'
       *
       * // Partially applied with placeholders.
       * var greetFred = _.partial(greet, _, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
       * This method is like `_.partial` except that partially applied arguments
       * are appended to the arguments it receives.
       *
       * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var greetFred = _.partialRight(greet, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       *
       * // Partially applied with placeholders.
       * var sayHelloTo = _.partialRight(greet, 'hello', _);
       * sayHelloTo('fred');
       * // => 'hello fred'
       */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
       * Creates a function that invokes `func` with arguments arranged according
       * to the specified `indexes` where the argument value at the first index is
       * provided as the first argument, the argument value at the second index is
       * provided as the second argument, and so on.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to rearrange arguments for.
       * @param {...(number|number[])} indexes The arranged argument indexes.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var rearged = _.rearg(function(a, b, c) {
       *   return [a, b, c];
       * }, [2, 0, 1]);
       *
       * rearged('b', 'c', 'a')
       * // => ['a', 'b', 'c']
       */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
       * Creates a function that invokes `func` with the `this` binding of the
       * created function and arguments from `start` and beyond provided as
       * an array.
       *
       * **Note:** This method is based on the
       * [rest parameter](https://mdn.io/rest_parameters).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.rest(function(what, names) {
       *   return what + ' ' + _.initial(names).join(', ') +
       *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
       * });
       *
       * say('hello', 'fred', 'barney', 'pebbles');
       * // => 'hello fred, barney, & pebbles'
       */function rest(func,start){if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
         * Creates a function that invokes `func` with the `this` binding of the
         * create function and an array of arguments much like
         * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
         *
         * **Note:** This method is based on the
         * [spread operator](https://mdn.io/spread_operator).
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Function
         * @param {Function} func The function to spread arguments over.
         * @param {number} [start=0] The start position of the spread.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var say = _.spread(function(who, what) {
         *   return who + ' says ' + what;
         * });
         *
         * say(['fred', 'hello']);
         * // => 'fred says hello'
         *
         * var numbers = Promise.all([
         *   Promise.resolve(40),
         *   Promise.resolve(36)
         * ]);
         *
         * numbers.then(_.spread(function(x, y) {
         *   return x + y;
         * }));
         * // => a Promise of 76
         */function spread(func,start){if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
         * Creates a throttled function that only invokes `func` at most once per
         * every `wait` milliseconds. The throttled function comes with a `cancel`
         * method to cancel delayed `func` invocations and a `flush` method to
         * immediately invoke them. Provide `options` to indicate whether `func`
         * should be invoked on the leading and/or trailing edge of the `wait`
         * timeout. The `func` is invoked with the last arguments provided to the
         * throttled function. Subsequent calls to the throttled function return the
         * result of the last `func` invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the throttled function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.throttle` and `_.debounce`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to throttle.
         * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=true]
         *  Specify invoking on the leading edge of the timeout.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new throttled function.
         * @example
         *
         * // Avoid excessively updating the position while scrolling.
         * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
         *
         * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
         * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
         * jQuery(element).on('click', throttled);
         *
         * // Cancel the trailing throttled invocation.
         * jQuery(window).on('popstate', throttled.cancel);
         */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{leading:leading,maxWait:wait,trailing:trailing});}/**
         * Creates a function that accepts up to one argument, ignoring any
         * additional arguments.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Function
         * @param {Function} func The function to cap arguments for.
         * @returns {Function} Returns the new capped function.
         * @example
         *
         * _.map(['6', '8', '10'], _.unary(parseInt));
         * // => [6, 8, 10]
         */function unary(func){return ary(func,1);}/**
         * Creates a function that provides `value` to `wrapper` as its first
         * argument. Any additional arguments provided to the function are appended
         * to those provided to the `wrapper`. The wrapper is invoked with the `this`
         * binding of the created function.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {*} value The value to wrap.
         * @param {Function} [wrapper=identity] The wrapper function.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var p = _.wrap(_.escape, function(func, text) {
         *   return '<p>' + func(text) + '</p>';
         * });
         *
         * p('fred, barney, & pebbles');
         * // => '<p>fred, barney, &amp; pebbles</p>'
         */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/* ------------------------------------------------------------------------*//**
         * Casts `value` as an array if it's not one.
         *
         * @static
         * @memberOf _
         * @since 4.4.0
         * @category Lang
         * @param {*} value The value to inspect.
         * @returns {Array} Returns the cast array.
         * @example
         *
         * _.castArray(1);
         * // => [1]
         *
         * _.castArray({ 'a': 1 });
         * // => [{ 'a': 1 }]
         *
         * _.castArray('abc');
         * // => ['abc']
         *
         * _.castArray(null);
         * // => [null]
         *
         * _.castArray(undefined);
         * // => [undefined]
         *
         * _.castArray();
         * // => []
         *
         * var array = [1, 2, 3];
         * console.log(_.castArray(array) === array);
         * // => true
         */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
         * Creates a shallow clone of `value`.
         *
         * **Note:** This method is loosely based on the
         * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
         * and supports cloning arrays, array buffers, booleans, date objects, maps,
         * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
         * arrays. The own enumerable properties of `arguments` objects are cloned
         * as plain objects. An empty object is returned for uncloneable values such
         * as error objects, functions, DOM nodes, and WeakMaps.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to clone.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeep
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var shallow = _.clone(objects);
         * console.log(shallow[0] === objects[0]);
         * // => true
         */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
         * This method is like `_.clone` except that it accepts `customizer` which
         * is invoked to produce the cloned value. If `customizer` returns `undefined`,
         * cloning is handled by the method instead. The `customizer` is invoked with
         * up to four arguments; (value [, index|key, object, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the cloned value.
         * @see _.cloneDeepWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(false);
         *   }
         * }
         *
         * var el = _.cloneWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 0
         */function cloneWith(value,customizer){customizer=typeof customizer==='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
         * This method is like `_.clone` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 1.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @returns {*} Returns the deep cloned value.
         * @see _.clone
         * @example
         *
         * var objects = [{ 'a': 1 }, { 'b': 2 }];
         *
         * var deep = _.cloneDeep(objects);
         * console.log(deep[0] === objects[0]);
         * // => false
         */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
         * This method is like `_.cloneWith` except that it recursively clones `value`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to recursively clone.
         * @param {Function} [customizer] The function to customize cloning.
         * @returns {*} Returns the deep cloned value.
         * @see _.cloneWith
         * @example
         *
         * function customizer(value) {
         *   if (_.isElement(value)) {
         *     return value.cloneNode(true);
         *   }
         * }
         *
         * var el = _.cloneDeepWith(document.body, customizer);
         *
         * console.log(el === document.body);
         * // => false
         * console.log(el.nodeName);
         * // => 'BODY'
         * console.log(el.childNodes.length);
         * // => 20
         */function cloneDeepWith(value,customizer){customizer=typeof customizer==='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
         * Checks if `object` conforms to `source` by invoking the predicate
         * properties of `source` with the corresponding property values of `object`.
         *
         * **Note:** This method is equivalent to `_.conforms` when `source` is
         * partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property predicates to conform to.
         * @returns {boolean} Returns `true` if `object` conforms, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
         * // => true
         *
         * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
         * // => false
         */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */function eq(value,other){return value===other||value!==value&&other!==other;}/**
         * Checks if `value` is greater than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than `other`,
         *  else `false`.
         * @see _.lt
         * @example
         *
         * _.gt(3, 1);
         * // => true
         *
         * _.gt(3, 3);
         * // => false
         *
         * _.gt(1, 3);
         * // => false
         */var gt=createRelationalOperation(baseGt);/**
         * Checks if `value` is greater than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is greater than or equal to
         *  `other`, else `false`.
         * @see _.lte
         * @example
         *
         * _.gte(3, 1);
         * // => true
         *
         * _.gte(3, 3);
         * // => true
         *
         * _.gte(1, 3);
         * // => false
         */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */var isArray=Array.isArray;/**
         * Checks if `value` is classified as an `ArrayBuffer` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
         * @example
         *
         * _.isArrayBuffer(new ArrayBuffer(2));
         * // => true
         *
         * _.isArrayBuffer(new Array(2));
         * // => false
         */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
         * This method is like `_.isArrayLike` except that it also checks if `value`
         * is an object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an array-like object,
         *  else `false`.
         * @example
         *
         * _.isArrayLikeObject([1, 2, 3]);
         * // => true
         *
         * _.isArrayLikeObject(document.body.children);
         * // => true
         *
         * _.isArrayLikeObject('abc');
         * // => false
         *
         * _.isArrayLikeObject(_.noop);
         * // => false
         */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
         * Checks if `value` is classified as a boolean primitive or object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
         * @example
         *
         * _.isBoolean(false);
         * // => true
         *
         * _.isBoolean(null);
         * // => false
         */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
         * Checks if `value` is a buffer.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
         * @example
         *
         * _.isBuffer(new Buffer(2));
         * // => true
         *
         * _.isBuffer(new Uint8Array(2));
         * // => false
         */var isBuffer=nativeIsBuffer||stubFalse;/**
         * Checks if `value` is classified as a `Date` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
         * @example
         *
         * _.isDate(new Date);
         * // => true
         *
         * _.isDate('Mon April 23 2012');
         * // => false
         */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
         * Checks if `value` is likely a DOM element.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
         * @example
         *
         * _.isElement(document.body);
         * // => true
         *
         * _.isElement('<body>');
         * // => false
         */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
         * Checks if `value` is an empty object, collection, map, or set.
         *
         * Objects are considered empty if they have no own enumerable string keyed
         * properties.
         *
         * Array-like values such as `arguments` objects, arrays, buffers, strings, or
         * jQuery-like collections are considered empty if they have a `length` of `0`.
         * Similarly, maps and sets are considered empty if they have a `size` of `0`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is empty, else `false`.
         * @example
         *
         * _.isEmpty(null);
         * // => true
         *
         * _.isEmpty(true);
         * // => true
         *
         * _.isEmpty(1);
         * // => true
         *
         * _.isEmpty([1, 2, 3]);
         * // => false
         *
         * _.isEmpty({ 'a': 1 });
         * // => false
         */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value==='string'||typeof value.splice==='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
         * Performs a deep comparison between two values to determine if they are
         * equivalent.
         *
         * **Note:** This method supports comparing arrays, array buffers, booleans,
         * date objects, error objects, maps, numbers, `Object` objects, regexes,
         * sets, strings, symbols, and typed arrays. `Object` objects are compared
         * by their own, not inherited, enumerable properties. Functions and DOM
         * nodes are compared by strict equality, i.e. `===`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.isEqual(object, other);
         * // => true
         *
         * object === other;
         * // => false
         */function isEqual(value,other){return baseIsEqual(value,other);}/**
         * This method is like `_.isEqual` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with up to
         * six arguments: (objValue, othValue [, index|key, object, other, stack]).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, othValue) {
         *   if (isGreeting(objValue) && isGreeting(othValue)) {
         *     return true;
         *   }
         * }
         *
         * var array = ['hello', 'goodbye'];
         * var other = ['hi', 'goodbye'];
         *
         * _.isEqualWith(array, other, customizer);
         * // => true
         */function isEqualWith(value,other,customizer){customizer=typeof customizer==='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
         * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
         * `SyntaxError`, `TypeError`, or `URIError` object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
         * @example
         *
         * _.isError(new Error);
         * // => true
         *
         * _.isError(Error);
         * // => false
         */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message==='string'&&typeof value.name==='string'&&!isPlainObject(value);}/**
         * Checks if `value` is a finite primitive number.
         *
         * **Note:** This method is based on
         * [`Number.isFinite`](https://mdn.io/Number/isFinite).
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
         * @example
         *
         * _.isFinite(3);
         * // => true
         *
         * _.isFinite(Number.MIN_VALUE);
         * // => true
         *
         * _.isFinite(Infinity);
         * // => false
         *
         * _.isFinite('3');
         * // => false
         */function isFinite(value){return typeof value==='number'&&nativeIsFinite(value);}/**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
         * Checks if `value` is an integer.
         *
         * **Note:** This method is based on
         * [`Number.isInteger`](https://mdn.io/Number/isInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
         * @example
         *
         * _.isInteger(3);
         * // => true
         *
         * _.isInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isInteger(Infinity);
         * // => false
         *
         * _.isInteger('3');
         * // => false
         */function isInteger(value){return typeof value==='number'&&value==toInteger(value);}/**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */function isLength(value){return typeof value==='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))==='object';}/**
         * Checks if `value` is classified as a `Map` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a map, else `false`.
         * @example
         *
         * _.isMap(new Map);
         * // => true
         *
         * _.isMap(new WeakMap);
         * // => false
         */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
         * Performs a partial deep comparison between `object` and `source` to
         * determine if `object` contains equivalent property values.
         *
         * **Note:** This method is equivalent to `_.matches` when `source` is
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * var object = { 'a': 1, 'b': 2 };
         *
         * _.isMatch(object, { 'b': 2 });
         * // => true
         *
         * _.isMatch(object, { 'b': 1 });
         * // => false
         */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
         * This method is like `_.isMatch` except that it accepts `customizer` which
         * is invoked to compare values. If `customizer` returns `undefined`, comparisons
         * are handled by the method instead. The `customizer` is invoked with five
         * arguments: (objValue, srcValue, index|key, object, source).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {Object} object The object to inspect.
         * @param {Object} source The object of property values to match.
         * @param {Function} [customizer] The function to customize comparisons.
         * @returns {boolean} Returns `true` if `object` is a match, else `false`.
         * @example
         *
         * function isGreeting(value) {
         *   return /^h(?:i|ello)$/.test(value);
         * }
         *
         * function customizer(objValue, srcValue) {
         *   if (isGreeting(objValue) && isGreeting(srcValue)) {
         *     return true;
         *   }
         * }
         *
         * var object = { 'greeting': 'hello' };
         * var source = { 'greeting': 'hi' };
         *
         * _.isMatchWith(object, source, customizer);
         * // => true
         */function isMatchWith(object,source,customizer){customizer=typeof customizer==='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
         * Checks if `value` is `NaN`.
         *
         * **Note:** This method is based on
         * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
         * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
         * `undefined` and other non-number values.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
         * @example
         *
         * _.isNaN(NaN);
         * // => true
         *
         * _.isNaN(new Number(NaN));
         * // => true
         *
         * isNaN(undefined);
         * // => true
         *
         * _.isNaN(undefined);
         * // => false
         */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
         * Checks if `value` is a pristine native function.
         *
         * **Note:** This method can't reliably detect native functions in the presence
         * of the core-js package because core-js circumvents this kind of detection.
         * Despite multiple requests, the core-js maintainer has made it clear: any
         * attempt to fix the detection will be obstructed. As a result, we're left
         * with little choice but to throw an error. Unfortunately, this also affects
         * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
         * which rely on core-js.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a native function,
         *  else `false`.
         * @example
         *
         * _.isNative(Array.prototype.push);
         * // => true
         *
         * _.isNative(_);
         * // => false
         */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
         * Checks if `value` is `null`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
         * @example
         *
         * _.isNull(null);
         * // => true
         *
         * _.isNull(void 0);
         * // => false
         */function isNull(value){return value===null;}/**
         * Checks if `value` is `null` or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
         * @example
         *
         * _.isNil(null);
         * // => true
         *
         * _.isNil(void 0);
         * // => true
         *
         * _.isNil(NaN);
         * // => false
         */function isNil(value){return value==null;}/**
         * Checks if `value` is classified as a `Number` primitive or object.
         *
         * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
         * classified as numbers, use the `_.isFinite` method.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a number, else `false`.
         * @example
         *
         * _.isNumber(3);
         * // => true
         *
         * _.isNumber(Number.MIN_VALUE);
         * // => true
         *
         * _.isNumber(Infinity);
         * // => true
         *
         * _.isNumber('3');
         * // => false
         */function isNumber(value){return typeof value==='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
         * Checks if `value` is a plain object, that is, an object created by the
         * `Object` constructor or one with a `[[Prototype]]` of `null`.
         *
         * @static
         * @memberOf _
         * @since 0.8.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * _.isPlainObject(new Foo);
         * // => false
         *
         * _.isPlainObject([1, 2, 3]);
         * // => false
         *
         * _.isPlainObject({ 'x': 0, 'y': 0 });
         * // => true
         *
         * _.isPlainObject(Object.create(null));
         * // => true
         */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor==='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
         * Checks if `value` is classified as a `RegExp` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
         * @example
         *
         * _.isRegExp(/abc/);
         * // => true
         *
         * _.isRegExp('/abc/');
         * // => false
         */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
         * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
         * double precision number which isn't the result of a rounded unsafe integer.
         *
         * **Note:** This method is based on
         * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
         * @example
         *
         * _.isSafeInteger(3);
         * // => true
         *
         * _.isSafeInteger(Number.MIN_VALUE);
         * // => false
         *
         * _.isSafeInteger(Infinity);
         * // => false
         *
         * _.isSafeInteger('3');
         * // => false
         */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
         * Checks if `value` is classified as a `Set` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a set, else `false`.
         * @example
         *
         * _.isSet(new Set);
         * // => true
         *
         * _.isSet(new WeakSet);
         * // => false
         */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
         * Checks if `value` is classified as a `String` primitive or object.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a string, else `false`.
         * @example
         *
         * _.isString('abc');
         * // => true
         *
         * _.isString(1);
         * // => false
         */function isString(value){return typeof value==='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))==='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
         * Checks if `value` is classified as a typed array.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
         * @example
         *
         * _.isTypedArray(new Uint8Array);
         * // => true
         *
         * _.isTypedArray([]);
         * // => false
         */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
       * Checks if `value` is `undefined`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
       * @example
       *
       * _.isUndefined(void 0);
       * // => true
       *
       * _.isUndefined(null);
       * // => false
       */function isUndefined(value){return value===undefined;}/**
         * Checks if `value` is classified as a `WeakMap` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
         * @example
         *
         * _.isWeakMap(new WeakMap);
         * // => true
         *
         * _.isWeakMap(new Map);
         * // => false
         */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
         * Checks if `value` is classified as a `WeakSet` object.
         *
         * @static
         * @memberOf _
         * @since 4.3.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
         * @example
         *
         * _.isWeakSet(new WeakSet);
         * // => true
         *
         * _.isWeakSet(new Set);
         * // => false
         */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
         * Checks if `value` is less than `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than `other`,
         *  else `false`.
         * @see _.gt
         * @example
         *
         * _.lt(1, 3);
         * // => true
         *
         * _.lt(3, 3);
         * // => false
         *
         * _.lt(3, 1);
         * // => false
         */var lt=createRelationalOperation(baseLt);/**
         * Checks if `value` is less than or equal to `other`.
         *
         * @static
         * @memberOf _
         * @since 3.9.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if `value` is less than or equal to
         *  `other`, else `false`.
         * @see _.gte
         * @example
         *
         * _.lte(1, 3);
         * // => true
         *
         * _.lte(3, 3);
         * // => true
         *
         * _.lte(3, 1);
         * // => false
         */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
       * Converts `value` to an array.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Array} Returns the converted array.
       * @example
       *
       * _.toArray({ 'a': 1, 'b': 2 });
       * // => [1, 2]
       *
       * _.toArray('abc');
       * // => ['a', 'b', 'c']
       *
       * _.toArray(1);
       * // => []
       *
       * _.toArray(null);
       * // => []
       */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
         * Converts `value` to an integer suitable for use as the length of an
         * array-like object.
         *
         * **Note:** This method is based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toLength(3.2);
         * // => 3
         *
         * _.toLength(Number.MIN_VALUE);
         * // => 0
         *
         * _.toLength(Infinity);
         * // => 4294967295
         *
         * _.toLength('3.2');
         * // => 3
         */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */function toNumber(value){if(typeof value==='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf==='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!=='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
         * Converts `value` to a plain object flattening inherited enumerable string
         * keyed properties of `value` to own properties of the plain object.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {Object} Returns the converted plain object.
         * @example
         *
         * function Foo() {
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.assign({ 'a': 1 }, new Foo);
         * // => { 'a': 1, 'b': 2 }
         *
         * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
         * // => { 'a': 1, 'b': 2, 'c': 3 }
         */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
         * Converts `value` to a safe integer. A safe integer can be compared and
         * represented correctly.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toSafeInteger(3.2);
         * // => 3
         *
         * _.toSafeInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toSafeInteger(Infinity);
         * // => 9007199254740991
         *
         * _.toSafeInteger('3.2');
         * // => 3
         */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
         * Converts `value` to a string. An empty string is returned for `null`
         * and `undefined` values. The sign of `-0` is preserved.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         * @example
         *
         * _.toString(null);
         * // => ''
         *
         * _.toString(-0);
         * // => '-0'
         *
         * _.toString([1, 2, 3]);
         * // => '1,2,3'
         */function toString(value){return value==null?'':baseToString(value);}/* ------------------------------------------------------------------------*//**
         * Assigns own enumerable string keyed properties of source objects to the
         * destination object. Source objects are applied from left to right.
         * Subsequent sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object` and is loosely based on
         * [`Object.assign`](https://mdn.io/Object/assign).
         *
         * @static
         * @memberOf _
         * @since 0.10.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.assignIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         * }
         *
         * function Bar() {
         *   this.c = 3;
         * }
         *
         * Foo.prototype.b = 2;
         * Bar.prototype.d = 4;
         *
         * _.assign({ 'a': 0 }, new Foo, new Bar);
         * // => { 'a': 1, 'c': 3 }
         */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
       * This method is like `_.assign` except that it iterates over own and
       * inherited source properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extend
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assign
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assignIn({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
       */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
       * This method is like `_.assignIn` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extendWith
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignInWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
       * This method is like `_.assign` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignInWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
       * Creates an array of values corresponding to `paths` of `object`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Array} Returns the picked values.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _.at(object, ['a[0].b.c', 'a[1]']);
       * // => [3, 4]
       */var at=flatRest(baseAt);/**
         * Creates an object that inherits from the `prototype` object. If a
         * `properties` object is given, its own enumerable string keyed properties
         * are assigned to the created object.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Object
         * @param {Object} prototype The object to inherit from.
         * @param {Object} [properties] The properties to assign to the object.
         * @returns {Object} Returns the new object.
         * @example
         *
         * function Shape() {
         *   this.x = 0;
         *   this.y = 0;
         * }
         *
         * function Circle() {
         *   Shape.call(this);
         * }
         *
         * Circle.prototype = _.create(Shape.prototype, {
         *   'constructor': Circle
         * });
         *
         * var circle = new Circle;
         * circle instanceof Circle;
         * // => true
         *
         * circle instanceof Shape;
         * // => true
         */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
         * Assigns own and inherited enumerable string keyed properties of source
         * objects to the destination object for all destination properties that
         * resolve to `undefined`. Source objects are applied from left to right.
         * Once a property is set, additional values of the same property are ignored.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @see _.defaultsDeep
         * @example
         *
         * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
         * // => { 'a': 1, 'b': 2 }
         */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
       * This method is like `_.defaults` except that it recursively assigns
       * default properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaults
       * @example
       *
       * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
       * // => { 'a': { 'b': 2, 'c': 3 } }
       */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
       * This method is like `_.find` except that it returns the key of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findKey(users, function(o) { return o.age < 40; });
       * // => 'barney' (iteration order is not guaranteed)
       *
       * // The `_.matches` iteratee shorthand.
       * _.findKey(users, { 'age': 1, 'active': true });
       * // => 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findKey(users, 'active');
       * // => 'barney'
       */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
         * This method is like `_.findKey` except that it iterates over elements of
         * a collection in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @param {Function} [predicate=_.identity] The function invoked per iteration.
         * @returns {string|undefined} Returns the key of the matched element,
         *  else `undefined`.
         * @example
         *
         * var users = {
         *   'barney':  { 'age': 36, 'active': true },
         *   'fred':    { 'age': 40, 'active': false },
         *   'pebbles': { 'age': 1,  'active': true }
         * };
         *
         * _.findLastKey(users, function(o) { return o.age < 40; });
         * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
         *
         * // The `_.matches` iteratee shorthand.
         * _.findLastKey(users, { 'age': 36, 'active': true });
         * // => 'barney'
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.findLastKey(users, ['active', false]);
         * // => 'fred'
         *
         * // The `_.property` iteratee shorthand.
         * _.findLastKey(users, 'active');
         * // => 'pebbles'
         */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
         * Iterates over own and inherited enumerable string keyed properties of an
         * object and invokes `iteratee` for each property. The iteratee is invoked
         * with three arguments: (value, key, object). Iteratee functions may exit
         * iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forInRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forIn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
         */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
         * This method is like `_.forIn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forIn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forInRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
         */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
         * Iterates over own enumerable string keyed properties of an object and
         * invokes `iteratee` for each property. The iteratee is invoked with three
         * arguments: (value, key, object). Iteratee functions may exit iteration
         * early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 0.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwnRight
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwn(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'a' then 'b' (iteration order is not guaranteed).
         */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
         * This method is like `_.forOwn` except that it iterates over properties of
         * `object` in the opposite order.
         *
         * @static
         * @memberOf _
         * @since 2.0.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns `object`.
         * @see _.forOwn
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.forOwnRight(new Foo, function(value, key) {
         *   console.log(key);
         * });
         * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
         */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
         * Creates an array of function property names from own enumerable properties
         * of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functionsIn
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functions(new Foo);
         * // => ['a', 'b']
         */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
         * Creates an array of function property names from own and inherited
         * enumerable properties of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to inspect.
         * @returns {Array} Returns the function names.
         * @see _.functions
         * @example
         *
         * function Foo() {
         *   this.a = _.constant('a');
         *   this.b = _.constant('b');
         * }
         *
         * Foo.prototype.c = _.constant('c');
         *
         * _.functionsIn(new Foo);
         * // => ['a', 'b', 'c']
         */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
         * Gets the value at `path` of `object`. If the resolved value is
         * `undefined`, the `defaultValue` is returned in its place.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.get(object, 'a[0].b.c');
         * // => 3
         *
         * _.get(object, ['a', '0', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
         * Checks if `path` is a direct property of `object`.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = { 'a': { 'b': 2 } };
         * var other = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.has(object, 'a');
         * // => true
         *
         * _.has(object, 'a.b');
         * // => true
         *
         * _.has(object, ['a', 'b']);
         * // => true
         *
         * _.has(other, 'a');
         * // => false
         */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
         * Checks if `path` is a direct or inherited property of `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path to check.
         * @returns {boolean} Returns `true` if `path` exists, else `false`.
         * @example
         *
         * var object = _.create({ 'a': _.create({ 'b': 2 }) });
         *
         * _.hasIn(object, 'a');
         * // => true
         *
         * _.hasIn(object, 'a.b');
         * // => true
         *
         * _.hasIn(object, ['a', 'b']);
         * // => true
         *
         * _.hasIn(object, 'b');
         * // => false
         */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
         * Creates an object composed of the inverted keys and values of `object`.
         * If `object` contains duplicate values, subsequent values overwrite
         * property assignments of previous values.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Object
         * @param {Object} object The object to invert.
         * @returns {Object} Returns the new inverted object.
         * @example
         *
         * var object = { 'a': 1, 'b': 2, 'c': 1 };
         *
         * _.invert(object);
         * // => { '1': 'c', '2': 'b' }
         */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!=='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
       * This method is like `_.invert` except that the inverted object is generated
       * from the results of running each element of `object` thru `iteratee`. The
       * corresponding inverted value of each inverted key is an array of keys
       * responsible for generating the inverted value. The iteratee is invoked
       * with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Object
       * @param {Object} object The object to invert.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invertBy(object);
       * // => { '1': ['a', 'c'], '2': ['b'] }
       *
       * _.invertBy(object, function(value) {
       *   return 'group' + value;
       * });
       * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
       */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!=='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
       * Invokes the method at `path` of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
       *
       * _.invoke(object, 'a[0].b.c.slice', 1, 3);
       * // => [2, 3]
       */var invoke=baseRest(baseInvoke);/**
         * Creates an array of the own enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects. See the
         * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
         * for more details.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keys(new Foo);
         * // => ['a', 'b'] (iteration order is not guaranteed)
         *
         * _.keys('hi');
         * // => ['0', '1']
         */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
         * Creates an array of the own and inherited enumerable property names of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property names.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.keysIn(new Foo);
         * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
         */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
         * The opposite of `_.mapValues`; this method creates an object with the
         * same values as `object` and keys generated by running each own enumerable
         * string keyed property of `object` thru `iteratee`. The iteratee is invoked
         * with three arguments: (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 3.8.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapValues
         * @example
         *
         * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
         *   return key + value;
         * });
         * // => { 'a1': 1, 'b2': 2 }
         */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
         * Creates an object with the same keys as `object` and values generated
         * by running each own enumerable string keyed property of `object` thru
         * `iteratee`. The iteratee is invoked with three arguments:
         * (value, key, object).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Object} Returns the new mapped object.
         * @see _.mapKeys
         * @example
         *
         * var users = {
         *   'fred':    { 'user': 'fred',    'age': 40 },
         *   'pebbles': { 'user': 'pebbles', 'age': 1 }
         * };
         *
         * _.mapValues(users, function(o) { return o.age; });
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         *
         * // The `_.property` iteratee shorthand.
         * _.mapValues(users, 'age');
         * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
         */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
         * This method is like `_.assign` except that it recursively merges own and
         * inherited enumerable string keyed properties of source objects into the
         * destination object. Source properties that resolve to `undefined` are
         * skipped if a destination value exists. Array and plain object properties
         * are merged recursively. Other objects and value types are overridden by
         * assignment. Source objects are applied from left to right. Subsequent
         * sources overwrite property assignments of previous sources.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 0.5.0
         * @category Object
         * @param {Object} object The destination object.
         * @param {...Object} [sources] The source objects.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {
         *   'a': [{ 'b': 2 }, { 'd': 4 }]
         * };
         *
         * var other = {
         *   'a': [{ 'c': 3 }, { 'e': 5 }]
         * };
         *
         * _.merge(object, other);
         * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
         */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
       * This method is like `_.merge` except that it accepts `customizer` which
       * is invoked to produce the merged values of the destination and source
       * properties. If `customizer` returns `undefined`, merging is handled by the
       * method instead. The `customizer` is invoked with six arguments:
       * (objValue, srcValue, key, object, source, stack).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} customizer The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   if (_.isArray(objValue)) {
       *     return objValue.concat(srcValue);
       *   }
       * }
       *
       * var object = { 'a': [1], 'b': [2] };
       * var other = { 'a': [3], 'b': [4] };
       *
       * _.mergeWith(object, other, customizer);
       * // => { 'a': [1, 3], 'b': [2, 4] }
       */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
       * The opposite of `_.pickBy`; this method creates an object composed of
       * the own and inherited enumerable string keyed properties of `object` that
       * `predicate` doesn't return truthy for. The predicate is invoked with two
       * arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omitBy(object, _.isNumber);
       * // => { 'b': '2' }
       */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
         * Creates an object composed of the picked `object` properties.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The source object.
         * @param {...(string|string[])} [paths] The property paths to pick.
         * @returns {Object} Returns the new object.
         * @example
         *
         * var object = { 'a': 1, 'b': '2', 'c': 3 };
         *
         * _.pick(object, ['a', 'c']);
         * // => { 'a': 1, 'c': 3 }
         */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
       * Creates an object composed of the `object` properties `predicate` returns
       * truthy for. The predicate is invoked with two arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pickBy(object, _.isNumber);
       * // => { 'a': 1, 'c': 3 }
       */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
         * This method is like `_.get` except that if the resolved value is a
         * function it's invoked with the `this` binding of its parent object and
         * its result is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to resolve.
         * @param {*} [defaultValue] The value returned for `undefined` resolved values.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
         *
         * _.result(object, 'a[0].b.c1');
         * // => 3
         *
         * _.result(object, 'a[0].b.c2');
         * // => 4
         *
         * _.result(object, 'a[0].b.c3', 'default');
         * // => 'default'
         *
         * _.result(object, 'a[0].b.c3', _.constant('default'));
         * // => 'default'
         */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
         * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
         * it's created. Arrays are created for missing index properties while objects
         * are created for all other missing properties. Use `_.setWith` to customize
         * `path` creation.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.set(object, 'a[0].b.c', 4);
         * console.log(object.a[0].b.c);
         * // => 4
         *
         * _.set(object, ['x', '0', 'y', 'z'], 5);
         * console.log(object.x[0].y.z);
         * // => 5
         */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
         * This method is like `_.set` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {*} value The value to set.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.setWith(object, '[0][1]', 'a', Object);
         * // => { '0': { '1': 'a' } }
         */function setWith(object,path,value,customizer){customizer=typeof customizer==='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
         * Creates an array of own enumerable string keyed-value pairs for `object`
         * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
         * entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entries
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairs(new Foo);
         * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
         */var toPairs=createToPairs(keys);/**
         * Creates an array of own and inherited enumerable string keyed-value pairs
         * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
         * or set, its entries are returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @alias entriesIn
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the key-value pairs.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.toPairsIn(new Foo);
         * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
         */var toPairsIn=createToPairs(keysIn);/**
         * An alternative to `_.reduce`; this method transforms `object` to a new
         * `accumulator` object which is the result of running each of its own
         * enumerable string keyed properties thru `iteratee`, with each invocation
         * potentially mutating the `accumulator` object. If `accumulator` is not
         * provided, a new object with the same `[[Prototype]]` will be used. The
         * iteratee is invoked with four arguments: (accumulator, value, key, object).
         * Iteratee functions may exit iteration early by explicitly returning `false`.
         *
         * @static
         * @memberOf _
         * @since 1.3.0
         * @category Object
         * @param {Object} object The object to iterate over.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @param {*} [accumulator] The custom accumulator value.
         * @returns {*} Returns the accumulated value.
         * @example
         *
         * _.transform([2, 3, 4], function(result, n) {
         *   result.push(n *= n);
         *   return n % 2 == 0;
         * }, []);
         * // => [4, 9]
         *
         * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
         *   (result[value] || (result[value] = [])).push(key);
         * }, {});
         * // => { '1': ['a', 'c'], '2': ['b'] }
         */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
         * Removes the property at `path` of `object`.
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to unset.
         * @returns {boolean} Returns `true` if the property is deleted, else `false`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 7 } }] };
         * _.unset(object, 'a[0].b.c');
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         *
         * _.unset(object, ['a', '0', 'b', 'c']);
         * // => true
         *
         * console.log(object);
         * // => { 'a': [{ 'b': {} }] };
         */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
         * This method is like `_.set` except that accepts `updater` to produce the
         * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
         * is invoked with one argument: (value).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = { 'a': [{ 'b': { 'c': 3 } }] };
         *
         * _.update(object, 'a[0].b.c', function(n) { return n * n; });
         * console.log(object.a[0].b.c);
         * // => 9
         *
         * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
         * console.log(object.x[0].y.z);
         * // => 0
         */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
         * This method is like `_.update` except that it accepts `customizer` which is
         * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
         * path creation is handled by the method instead. The `customizer` is invoked
         * with three arguments: (nsValue, key, nsObject).
         *
         * **Note:** This method mutates `object`.
         *
         * @static
         * @memberOf _
         * @since 4.6.0
         * @category Object
         * @param {Object} object The object to modify.
         * @param {Array|string} path The path of the property to set.
         * @param {Function} updater The function to produce the updated value.
         * @param {Function} [customizer] The function to customize assigned values.
         * @returns {Object} Returns `object`.
         * @example
         *
         * var object = {};
         *
         * _.updateWith(object, '[0][1]', _.constant('a'), Object);
         * // => { '0': { '1': 'a' } }
         */function updateWith(object,path,updater,customizer){customizer=typeof customizer==='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
         * Creates an array of the own enumerable string keyed property values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.values(new Foo);
         * // => [1, 2] (iteration order is not guaranteed)
         *
         * _.values('hi');
         * // => ['h', 'i']
         */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
         * Creates an array of the own and inherited enumerable string keyed property
         * values of `object`.
         *
         * **Note:** Non-object values are coerced to objects.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Object
         * @param {Object} object The object to query.
         * @returns {Array} Returns the array of property values.
         * @example
         *
         * function Foo() {
         *   this.a = 1;
         *   this.b = 2;
         * }
         *
         * Foo.prototype.c = 3;
         *
         * _.valuesIn(new Foo);
         * // => [1, 2, 3] (iteration order is not guaranteed)
         */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/* ------------------------------------------------------------------------*//**
         * Clamps `number` within the inclusive `lower` and `upper` bounds.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Number
         * @param {number} number The number to clamp.
         * @param {number} [lower] The lower bound.
         * @param {number} upper The upper bound.
         * @returns {number} Returns the clamped number.
         * @example
         *
         * _.clamp(-10, -5, 5);
         * // => -5
         *
         * _.clamp(10, -5, 5);
         * // => 5
         */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
         * Checks if `n` is between `start` and up to, but not including, `end`. If
         * `end` is not specified, it's set to `start` with `start` then set to `0`.
         * If `start` is greater than `end` the params are swapped to support
         * negative ranges.
         *
         * @static
         * @memberOf _
         * @since 3.3.0
         * @category Number
         * @param {number} number The number to check.
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
         * @see _.range, _.rangeRight
         * @example
         *
         * _.inRange(3, 2, 4);
         * // => true
         *
         * _.inRange(4, 8);
         * // => true
         *
         * _.inRange(4, 2);
         * // => false
         *
         * _.inRange(2, 2);
         * // => false
         *
         * _.inRange(1.2, 2);
         * // => true
         *
         * _.inRange(5.2, 4);
         * // => false
         *
         * _.inRange(-3, -2, -6);
         * // => true
         */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
         * Produces a random number between the inclusive `lower` and `upper` bounds.
         * If only one argument is provided a number between `0` and the given number
         * is returned. If `floating` is `true`, or either `lower` or `upper` are
         * floats, a floating-point number is returned instead of an integer.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @memberOf _
         * @since 0.7.0
         * @category Number
         * @param {number} [lower=0] The lower bound.
         * @param {number} [upper=1] The upper bound.
         * @param {boolean} [floating] Specify returning a floating-point number.
         * @returns {number} Returns the random number.
         * @example
         *
         * _.random(0, 5);
         * // => an integer between 0 and 5
         *
         * _.random(5);
         * // => also an integer between 0 and 5
         *
         * _.random(5, true);
         * // => a floating-point number between 0 and 5
         *
         * _.random(1.2, 5.2);
         * // => a floating-point number between 1.2 and 5.2
         */function random(lower,upper,floating){if(floating&&typeof floating!=='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper==='boolean'){floating=upper;upper=undefined;}else if(typeof lower==='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/* ------------------------------------------------------------------------*//**
         * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the camel cased string.
         * @example
         *
         * _.camelCase('Foo Bar');
         * // => 'fooBar'
         *
         * _.camelCase('--foo-bar--');
         * // => 'fooBar'
         *
         * _.camelCase('__FOO_BAR__');
         * // => 'fooBar'
         */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
       * Converts the first character of `string` to upper case and the remaining
       * to lower case.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to capitalize.
       * @returns {string} Returns the capitalized string.
       * @example
       *
       * _.capitalize('FRED');
       * // => 'Fred'
       */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
         * Deburrs `string` by converting
         * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
         * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
         * letters to basic Latin letters and removing
         * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to deburr.
         * @returns {string} Returns the deburred string.
         * @example
         *
         * _.deburr('déjà vu');
         * // => 'deja vu'
         */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
         * Checks if `string` ends with the given target string.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {string} [target] The string to search for.
         * @param {number} [position=string.length] The position to search up to.
         * @returns {boolean} Returns `true` if `string` ends with `target`,
         *  else `false`.
         * @example
         *
         * _.endsWith('abc', 'c');
         * // => true
         *
         * _.endsWith('abc', 'b');
         * // => false
         *
         * _.endsWith('abc', 'b', 2);
         * // => true
         */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
         * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
         * corresponding HTML entities.
         *
         * **Note:** No other characters are escaped. To escape additional
         * characters use a third-party library like [_he_](https://mths.be/he).
         *
         * Though the ">" character is escaped for symmetry, characters like
         * ">" and "/" don't need escaping in HTML and have no special meaning
         * unless they're part of a tag or unquoted attribute value. See
         * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
         * (under "semi-related fun fact") for more details.
         *
         * When working with HTML you should always
         * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
         * XSS vectors.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escape('fred, barney, & pebbles');
         * // => 'fred, barney, &amp; pebbles'
         */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
         * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
         * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to escape.
         * @returns {string} Returns the escaped string.
         * @example
         *
         * _.escapeRegExp('[lodash](https://lodash.com/)');
         * // => '\[lodash\]\(https://lodash\.com/\)'
         */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
         * Converts `string` to
         * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the kebab cased string.
         * @example
         *
         * _.kebabCase('Foo Bar');
         * // => 'foo-bar'
         *
         * _.kebabCase('fooBar');
         * // => 'foo-bar'
         *
         * _.kebabCase('__FOO_BAR__');
         * // => 'foo-bar'
         */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
       * Converts `string`, as space separated words, to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.lowerCase('--Foo-Bar--');
       * // => 'foo bar'
       *
       * _.lowerCase('fooBar');
       * // => 'foo bar'
       *
       * _.lowerCase('__FOO_BAR__');
       * // => 'foo bar'
       */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
       * Converts the first character of `string` to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.lowerFirst('Fred');
       * // => 'fred'
       *
       * _.lowerFirst('FRED');
       * // => 'fRED'
       */var lowerFirst=createCaseFirst('toLowerCase');/**
         * Pads `string` on the left and right sides if it's shorter than `length`.
         * Padding characters are truncated if they can't be evenly divided by `length`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.pad('abc', 8);
         * // => '  abc   '
         *
         * _.pad('abc', 8, '_-');
         * // => '_-abc_-_'
         *
         * _.pad('abc', 3);
         * // => 'abc'
         */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
         * Pads `string` on the right side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padEnd('abc', 6);
         * // => 'abc   '
         *
         * _.padEnd('abc', 6, '_-');
         * // => 'abc_-_'
         *
         * _.padEnd('abc', 3);
         * // => 'abc'
         */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
         * Pads `string` on the left side if it's shorter than `length`. Padding
         * characters are truncated if they exceed `length`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to pad.
         * @param {number} [length=0] The padding length.
         * @param {string} [chars=' '] The string used as padding.
         * @returns {string} Returns the padded string.
         * @example
         *
         * _.padStart('abc', 6);
         * // => '   abc'
         *
         * _.padStart('abc', 6, '_-');
         * // => '_-_abc'
         *
         * _.padStart('abc', 3);
         * // => 'abc'
         */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
         * Converts `string` to an integer of the specified radix. If `radix` is
         * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
         * hexadecimal, in which case a `radix` of `16` is used.
         *
         * **Note:** This method aligns with the
         * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
         *
         * @static
         * @memberOf _
         * @since 1.1.0
         * @category String
         * @param {string} string The string to convert.
         * @param {number} [radix=10] The radix to interpret `value` by.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.parseInt('08');
         * // => 8
         *
         * _.map(['6', '08', '10'], _.parseInt);
         * // => [6, 8, 10]
         */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
         * Repeats the given string `n` times.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to repeat.
         * @param {number} [n=1] The number of times to repeat the string.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the repeated string.
         * @example
         *
         * _.repeat('*', 3);
         * // => '***'
         *
         * _.repeat('abc', 2);
         * // => 'abcabc'
         *
         * _.repeat('abc', 0);
         * // => ''
         */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
         * Replaces matches for `pattern` in `string` with `replacement`.
         *
         * **Note:** This method is based on
         * [`String#replace`](https://mdn.io/String/replace).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to modify.
         * @param {RegExp|string} pattern The pattern to replace.
         * @param {Function|string} replacement The match replacement.
         * @returns {string} Returns the modified string.
         * @example
         *
         * _.replace('Hi Fred', 'Fred', 'Barney');
         * // => 'Hi Barney'
         */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
         * Converts `string` to
         * [snake case](https://en.wikipedia.org/wiki/Snake_case).
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the snake cased string.
         * @example
         *
         * _.snakeCase('Foo Bar');
         * // => 'foo_bar'
         *
         * _.snakeCase('fooBar');
         * // => 'foo_bar'
         *
         * _.snakeCase('--FOO-BAR--');
         * // => 'foo_bar'
         */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
       * Splits `string` by `separator`.
       *
       * **Note:** This method is based on
       * [`String#split`](https://mdn.io/String/split).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to split.
       * @param {RegExp|string} separator The separator pattern to split by.
       * @param {number} [limit] The length to truncate results to.
       * @returns {Array} Returns the string segments.
       * @example
       *
       * _.split('a-b-c', '-', 2);
       * // => ['a', 'b']
       */function split(string,separator,limit){if(limit&&typeof limit!=='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator==='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
         * Converts `string` to
         * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
         *
         * @static
         * @memberOf _
         * @since 3.1.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the start cased string.
         * @example
         *
         * _.startCase('--foo-bar--');
         * // => 'Foo Bar'
         *
         * _.startCase('fooBar');
         * // => 'Foo Bar'
         *
         * _.startCase('__FOO_BAR__');
         * // => 'FOO BAR'
         */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
       * Checks if `string` starts with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=0] The position to search from.
       * @returns {boolean} Returns `true` if `string` starts with `target`,
       *  else `false`.
       * @example
       *
       * _.startsWith('abc', 'a');
       * // => true
       *
       * _.startsWith('abc', 'b');
       * // => false
       *
       * _.startsWith('abc', 'b', 1);
       * // => true
       */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
         * Creates a compiled template function that can interpolate data properties
         * in "interpolate" delimiters, HTML-escape interpolated data properties in
         * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
         * properties may be accessed as free variables in the template. If a setting
         * object is given, it takes precedence over `_.templateSettings` values.
         *
         * **Note:** In the development build `_.template` utilizes
         * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
         * for easier debugging.
         *
         * For more information on precompiling templates see
         * [lodash's custom builds documentation](https://lodash.com/custom-builds).
         *
         * For more information on Chrome extension sandboxes see
         * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category String
         * @param {string} [string=''] The template string.
         * @param {Object} [options={}] The options object.
         * @param {RegExp} [options.escape=_.templateSettings.escape]
         *  The HTML "escape" delimiter.
         * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
         *  The "evaluate" delimiter.
         * @param {Object} [options.imports=_.templateSettings.imports]
         *  An object to import into the template as free variables.
         * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
         *  The "interpolate" delimiter.
         * @param {string} [options.sourceURL='lodash.templateSources[n]']
         *  The sourceURL of the compiled template.
         * @param {string} [options.variable='obj']
         *  The data object variable name.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Function} Returns the compiled template function.
         * @example
         *
         * // Use the "interpolate" delimiter to create a compiled template.
         * var compiled = _.template('hello <%= user %>!');
         * compiled({ 'user': 'fred' });
         * // => 'hello fred!'
         *
         * // Use the HTML "escape" delimiter to escape data property values.
         * var compiled = _.template('<b><%- value %></b>');
         * compiled({ 'value': '<script>' });
         * // => '<b>&lt;script&gt;</b>'
         *
         * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
         * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the internal `print` function in "evaluate" delimiters.
         * var compiled = _.template('<% print("hello " + user); %>!');
         * compiled({ 'user': 'barney' });
         * // => 'hello barney!'
         *
         * // Use the ES template literal delimiter as an "interpolate" delimiter.
         * // Disable support by replacing the "interpolate" delimiter.
         * var compiled = _.template('hello ${ user }!');
         * compiled({ 'user': 'pebbles' });
         * // => 'hello pebbles!'
         *
         * // Use backslashes to treat delimiters as plain text.
         * var compiled = _.template('<%= "\\<%- value %\\>" %>');
         * compiled({ 'value': 'ignored' });
         * // => '<%- value %>'
         *
         * // Use the `imports` option to import `jQuery` as `jq`.
         * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
         * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
         * compiled({ 'users': ['fred', 'barney'] });
         * // => '<li>fred</li><li>barney</li>'
         *
         * // Use the `sourceURL` option to specify a custom sourceURL for the template.
         * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
         * compiled(data);
         * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
         *
         * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
         * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
         * compiled.source;
         * // => function(data) {
         * //   var __t, __p = '';
         * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
         * //   return __p;
         * // }
         *
         * // Use custom template delimiters.
         * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
         * var compiled = _.template('hello {{ user }}!');
         * compiled({ 'user': 'mustache' });
         * // => 'hello mustache!'
         *
         * // Use the `source` property to inline compiled templates for meaningful
         * // line numbers in error messages and stack traces.
         * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
         *   var JST = {\
         *     "main": ' + _.template(mainText).source + '\
         *   };\
         * ');
         */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
         * Converts `string`, as a whole, to lower case just like
         * [String#toLowerCase](https://mdn.io/toLowerCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the lower cased string.
         * @example
         *
         * _.toLower('--Foo-Bar--');
         * // => '--foo-bar--'
         *
         * _.toLower('fooBar');
         * // => 'foobar'
         *
         * _.toLower('__FOO_BAR__');
         * // => '__foo_bar__'
         */function toLower(value){return toString(value).toLowerCase();}/**
         * Converts `string`, as a whole, to upper case just like
         * [String#toUpperCase](https://mdn.io/toUpperCase).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.toUpper('--foo-bar--');
         * // => '--FOO-BAR--'
         *
         * _.toUpper('fooBar');
         * // => 'FOOBAR'
         *
         * _.toUpper('__foo_bar__');
         * // => '__FOO_BAR__'
         */function toUpper(value){return toString(value).toUpperCase();}/**
         * Removes leading and trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trim('  abc  ');
         * // => 'abc'
         *
         * _.trim('-_-abc-_-', '_-');
         * // => 'abc'
         *
         * _.map(['  foo  ', '  bar  '], _.trim);
         * // => ['foo', 'bar']
         */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
         * Removes trailing whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimEnd('  abc  ');
         * // => '  abc'
         *
         * _.trimEnd('-_-abc-_-', '_-');
         * // => '-_-abc'
         */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
         * Removes leading whitespace or specified characters from `string`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to trim.
         * @param {string} [chars=whitespace] The characters to trim.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {string} Returns the trimmed string.
         * @example
         *
         * _.trimStart('  abc  ');
         * // => 'abc  '
         *
         * _.trimStart('-_-abc-_-', '_-');
         * // => 'abc-_-'
         */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
         * Truncates `string` if it's longer than the given maximum string length.
         * The last characters of the truncated string are replaced with the omission
         * string which defaults to "...".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to truncate.
         * @param {Object} [options={}] The options object.
         * @param {number} [options.length=30] The maximum string length.
         * @param {string} [options.omission='...'] The string to indicate text is omitted.
         * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
         * @returns {string} Returns the truncated string.
         * @example
         *
         * _.truncate('hi-diddly-ho there, neighborino');
         * // => 'hi-diddly-ho there, neighbo...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': ' '
         * });
         * // => 'hi-diddly-ho there,...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'length': 24,
         *   'separator': /,? +/
         * });
         * // => 'hi-diddly-ho there...'
         *
         * _.truncate('hi-diddly-ho there, neighborino', {
         *   'omission': ' [...]'
         * });
         * // => 'hi-diddly-ho there, neig [...]'
         */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
         * The inverse of `_.escape`; this method converts the HTML entities
         * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
         * their corresponding characters.
         *
         * **Note:** No other HTML entities are unescaped. To unescape additional
         * HTML entities use a third-party library like [_he_](https://mths.be/he).
         *
         * @static
         * @memberOf _
         * @since 0.6.0
         * @category String
         * @param {string} [string=''] The string to unescape.
         * @returns {string} Returns the unescaped string.
         * @example
         *
         * _.unescape('fred, barney, &amp; pebbles');
         * // => 'fred, barney, & pebbles'
         */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
         * Converts `string`, as space separated words, to upper case.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category String
         * @param {string} [string=''] The string to convert.
         * @returns {string} Returns the upper cased string.
         * @example
         *
         * _.upperCase('--foo-bar');
         * // => 'FOO BAR'
         *
         * _.upperCase('fooBar');
         * // => 'FOO BAR'
         *
         * _.upperCase('__foo_bar__');
         * // => 'FOO BAR'
         */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
       * Converts the first character of `string` to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.upperFirst('fred');
       * // => 'Fred'
       *
       * _.upperFirst('FRED');
       * // => 'FRED'
       */var upperFirst=createCaseFirst('toUpperCase');/**
         * Splits `string` into an array of its words.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category String
         * @param {string} [string=''] The string to inspect.
         * @param {RegExp|string} [pattern] The pattern to match words.
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the words of `string`.
         * @example
         *
         * _.words('fred, barney, & pebbles');
         * // => ['fred', 'barney', 'pebbles']
         *
         * _.words('fred, barney, & pebbles', /[^, ]+/g);
         * // => ['fred', 'barney', '&', 'pebbles']
         */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/* ------------------------------------------------------------------------*//**
         * Attempts to invoke `func`, returning either the result or the caught error
         * object. Any additional arguments are provided to `func` when it's invoked.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Function} func The function to attempt.
         * @param {...*} [args] The arguments to invoke `func` with.
         * @returns {*} Returns the `func` result or error object.
         * @example
         *
         * // Avoid throwing errors for invalid selectors.
         * var elements = _.attempt(function(selector) {
         *   return document.querySelectorAll(selector);
         * }, '>_>');
         *
         * if (_.isError(elements)) {
         *   elements = [];
         * }
         */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
       * Binds methods of an object to the object itself, overwriting the existing
       * method.
       *
       * **Note:** This method doesn't set the "length" property of bound functions.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Object} object The object to bind and assign the bound methods to.
       * @param {...(string|string[])} methodNames The object method names to bind.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var view = {
       *   'label': 'docs',
       *   'click': function() {
       *     console.log('clicked ' + this.label);
       *   }
       * };
       *
       * _.bindAll(view, ['click']);
       * jQuery(element).on('click', view.click);
       * // => Logs 'clicked docs' when clicked.
       */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
       * Creates a function that iterates over `pairs` and invokes the corresponding
       * function of the first predicate to return truthy. The predicate-function
       * pairs are invoked with the `this` binding and arguments of the created
       * function.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Array} pairs The predicate-function pairs.
       * @returns {Function} Returns the new composite function.
       * @example
       *
       * var func = _.cond([
       *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
       *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
       *   [_.stubTrue,                      _.constant('no match')]
       * ]);
       *
       * func({ 'a': 1, 'b': 2 });
       * // => 'matches A'
       *
       * func({ 'a': 0, 'b': 1 });
       * // => 'matches B'
       *
       * func({ 'a': '1', 'b': '2' });
       * // => 'no match'
       */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!=='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
         * Creates a function that invokes the predicate properties of `source` with
         * the corresponding property values of a given object, returning `true` if
         * all predicates return truthy, else `false`.
         *
         * **Note:** The created function is equivalent to `_.conformsTo` with
         * `source` partially applied.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {Object} source The object of property predicates to conform to.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 2, 'b': 1 },
         *   { 'a': 1, 'b': 2 }
         * ];
         *
         * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
         * // => [{ 'a': 1, 'b': 2 }]
         */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
         * Creates a function that returns `value`.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {*} value The value to return from the new function.
         * @returns {Function} Returns the new constant function.
         * @example
         *
         * var objects = _.times(2, _.constant({ 'a': 1 }));
         *
         * console.log(objects);
         * // => [{ 'a': 1 }, { 'a': 1 }]
         *
         * console.log(objects[0] === objects[1]);
         * // => true
         */function constant(value){return function(){return value;};}/**
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         *
         * @static
         * @memberOf _
         * @since 4.14.0
         * @category Util
         * @param {*} value The value to check.
         * @param {*} defaultValue The default value.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * _.defaultTo(1, 10);
         * // => 1
         *
         * _.defaultTo(undefined, 10);
         * // => 10
         */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
         * Creates a function that returns the result of invoking the given functions
         * with the `this` binding of the created function, where each successive
         * invocation is supplied the return value of the previous.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flowRight
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flow([_.add, square]);
         * addSquare(1, 2);
         * // => 9
         */var flow=createFlow();/**
         * This method is like `_.flow` except that it creates a function that
         * invokes the given functions from right to left.
         *
         * @static
         * @since 3.0.0
         * @memberOf _
         * @category Util
         * @param {...(Function|Function[])} [funcs] The functions to invoke.
         * @returns {Function} Returns the new composite function.
         * @see _.flow
         * @example
         *
         * function square(n) {
         *   return n * n;
         * }
         *
         * var addSquare = _.flowRight([square, _.add]);
         * addSquare(1, 2);
         * // => 9
         */var flowRight=createFlow(true);/**
         * This method returns the first argument it receives.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {*} value Any value.
         * @returns {*} Returns `value`.
         * @example
         *
         * var object = { 'a': 1 };
         *
         * console.log(_.identity(object) === object);
         * // => true
         */function identity(value){return value;}/**
         * Creates a function that invokes `func` with the arguments of the created
         * function. If `func` is a property name, the created function returns the
         * property value for a given element. If `func` is an array or object, the
         * created function returns `true` for elements that contain the equivalent
         * source properties, otherwise it returns `false`.
         *
         * @static
         * @since 4.0.0
         * @memberOf _
         * @category Util
         * @param {*} [func=_.identity] The value to convert to a callback.
         * @returns {Function} Returns the callback.
         * @example
         *
         * var users = [
         *   { 'user': 'barney', 'age': 36, 'active': true },
         *   { 'user': 'fred',   'age': 40, 'active': false }
         * ];
         *
         * // The `_.matches` iteratee shorthand.
         * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
         * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
         *
         * // The `_.matchesProperty` iteratee shorthand.
         * _.filter(users, _.iteratee(['user', 'fred']));
         * // => [{ 'user': 'fred', 'age': 40 }]
         *
         * // The `_.property` iteratee shorthand.
         * _.map(users, _.iteratee('user'));
         * // => ['barney', 'fred']
         *
         * // Create custom iteratee shorthands.
         * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
         *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
         *     return func.test(string);
         *   };
         * });
         *
         * _.filter(['abc', 'def'], /ef/);
         * // => ['def']
         */function iteratee(func){return baseIteratee(typeof func==='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
         * Creates a function that performs a partial deep comparison between a given
         * object and `source`, returning `true` if the given object has equivalent
         * property values, else `false`.
         *
         * **Note:** The created function is equivalent to `_.isMatch` with `source`
         * partially applied.
         *
         * Partial comparisons will match empty array and empty object `source`
         * values against any array or object value, respectively. See `_.isEqual`
         * for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} source The object of property values to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
         * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
         */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
         * Creates a function that performs a partial deep comparison between the
         * value at `path` of a given object to `srcValue`, returning `true` if the
         * object value is equivalent, else `false`.
         *
         * **Note:** Partial comparisons will match empty array and empty object
         * `srcValue` values against any array or object value, respectively. See
         * `_.isEqual` for a list of supported value comparisons.
         *
         * @static
         * @memberOf _
         * @since 3.2.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @param {*} srcValue The value to match.
         * @returns {Function} Returns the new spec function.
         * @example
         *
         * var objects = [
         *   { 'a': 1, 'b': 2, 'c': 3 },
         *   { 'a': 4, 'b': 5, 'c': 6 }
         * ];
         *
         * _.find(objects, _.matchesProperty('a', 4));
         * // => { 'a': 4, 'b': 5, 'c': 6 }
         */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
         * Creates a function that invokes the method at `path` of a given object.
         * Any additional arguments are provided to the invoked method.
         *
         * @static
         * @memberOf _
         * @since 3.7.0
         * @category Util
         * @param {Array|string} path The path of the method to invoke.
         * @param {...*} [args] The arguments to invoke the method with.
         * @returns {Function} Returns the new invoker function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': _.constant(2) } },
         *   { 'a': { 'b': _.constant(1) } }
         * ];
         *
         * _.map(objects, _.method('a.b'));
         * // => [2, 1]
         *
         * _.map(objects, _.method(['a', 'b']));
         * // => [2, 1]
         */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
       * The opposite of `_.method`; this method creates a function that invokes
       * the method at a given path of `object`. Any additional arguments are
       * provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Object} object The object to query.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var array = _.times(3, _.constant),
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.methodOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
       * // => [2, 0]
       */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
       * Adds all own enumerable string keyed function properties of a source
       * object to the destination object. If `object` is a function, then methods
       * are added to its prototype as well.
       *
       * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
       * avoid conflicts caused by modifying the original.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Function|Object} [object=lodash] The destination object.
       * @param {Object} source The object of functions to add.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
       * @returns {Function|Object} Returns `object`.
       * @example
       *
       * function vowels(string) {
       *   return _.filter(string, function(v) {
       *     return /[aeiou]/i.test(v);
       *   });
       * }
       *
       * _.mixin({ 'vowels': vowels });
       * _.vowels('fred');
       * // => ['e']
       *
       * _('fred').vowels().value();
       * // => ['e']
       *
       * _.mixin({ 'vowels': vowels }, { 'chain': false });
       * _('fred').vowels();
       * // => ['e']
       */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({func:func,args:arguments,thisArg:object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
         * Reverts the `_` variable to its previous value and returns a reference to
         * the `lodash` function.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @returns {Function} Returns the `lodash` function.
         * @example
         *
         * var lodash = _.noConflict();
         */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
         * This method returns `undefined`.
         *
         * @static
         * @memberOf _
         * @since 2.3.0
         * @category Util
         * @example
         *
         * _.times(2, _.noop);
         * // => [undefined, undefined]
         */function noop(){}// No operation performed.
/**
         * Creates a function that gets the argument at index `n`. If `n` is negative,
         * the nth argument from the end is returned.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [n=0] The index of the argument to return.
         * @returns {Function} Returns the new pass-thru function.
         * @example
         *
         * var func = _.nthArg(1);
         * func('a', 'b', 'c', 'd');
         * // => 'b'
         *
         * var func = _.nthArg(-2);
         * func('a', 'b', 'c', 'd');
         * // => 'c'
         */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
         * Creates a function that invokes `iteratees` with the arguments it receives
         * and returns their results.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [iteratees=[_.identity]]
         *  The iteratees to invoke.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.over([Math.max, Math.min]);
         *
         * func(1, 2, 3, 4);
         * // => [4, 1]
         */var over=createOver(arrayMap);/**
         * Creates a function that checks if **all** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overEvery([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => false
         *
         * func(NaN);
         * // => false
         */var overEvery=createOver(arrayEvery);/**
         * Creates a function that checks if **any** of the `predicates` return
         * truthy when invoked with the arguments it receives.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {...(Function|Function[])} [predicates=[_.identity]]
         *  The predicates to check.
         * @returns {Function} Returns the new function.
         * @example
         *
         * var func = _.overSome([Boolean, isFinite]);
         *
         * func('1');
         * // => true
         *
         * func(null);
         * // => true
         *
         * func(NaN);
         * // => false
         */var overSome=createOver(arraySome);/**
         * Creates a function that returns the value at `path` of a given object.
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Util
         * @param {Array|string} path The path of the property to get.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var objects = [
         *   { 'a': { 'b': 2 } },
         *   { 'a': { 'b': 1 } }
         * ];
         *
         * _.map(objects, _.property('a.b'));
         * // => [2, 1]
         *
         * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
         * // => [1, 2]
         */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
         * The opposite of `_.property`; this method creates a function that returns
         * the value at a given path of `object`.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Util
         * @param {Object} object The object to query.
         * @returns {Function} Returns the new accessor function.
         * @example
         *
         * var array = [0, 1, 2],
         *     object = { 'a': array, 'b': array, 'c': array };
         *
         * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
         * // => [2, 0]
         *
         * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
         * // => [2, 0]
         */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
         * Creates an array of numbers (positive and/or negative) progressing from
         * `start` up to, but not including, `end`. A step of `-1` is used if a negative
         * `start` is specified without an `end` or `step`. If `end` is not specified,
         * it's set to `start` with `start` then set to `0`.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.rangeRight
         * @example
         *
         * _.range(4);
         * // => [0, 1, 2, 3]
         *
         * _.range(-4);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 5);
         * // => [1, 2, 3, 4]
         *
         * _.range(0, 20, 5);
         * // => [0, 5, 10, 15]
         *
         * _.range(0, -4, -1);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.range(0);
         * // => []
         */var range=createRange();/**
         * This method is like `_.range` except that it populates values in
         * descending order.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.range
         * @example
         *
         * _.rangeRight(4);
         * // => [3, 2, 1, 0]
         *
         * _.rangeRight(-4);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 5);
         * // => [4, 3, 2, 1]
         *
         * _.rangeRight(0, 20, 5);
         * // => [15, 10, 5, 0]
         *
         * _.rangeRight(0, -4, -1);
         * // => [-3, -2, -1, 0]
         *
         * _.rangeRight(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.rangeRight(0);
         * // => []
         */var rangeRight=createRange(true);/**
         * This method returns a new empty array.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Array} Returns the new empty array.
         * @example
         *
         * var arrays = _.times(2, _.stubArray);
         *
         * console.log(arrays);
         * // => [[], []]
         *
         * console.log(arrays[0] === arrays[1]);
         * // => false
         */function stubArray(){return[];}/**
         * This method returns `false`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `false`.
         * @example
         *
         * _.times(2, _.stubFalse);
         * // => [false, false]
         */function stubFalse(){return false;}/**
         * This method returns a new empty object.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {Object} Returns the new empty object.
         * @example
         *
         * var objects = _.times(2, _.stubObject);
         *
         * console.log(objects);
         * // => [{}, {}]
         *
         * console.log(objects[0] === objects[1]);
         * // => false
         */function stubObject(){return{};}/**
         * This method returns an empty string.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {string} Returns the empty string.
         * @example
         *
         * _.times(2, _.stubString);
         * // => ['', '']
         */function stubString(){return'';}/**
         * This method returns `true`.
         *
         * @static
         * @memberOf _
         * @since 4.13.0
         * @category Util
         * @returns {boolean} Returns `true`.
         * @example
         *
         * _.times(2, _.stubTrue);
         * // => [true, true]
         */function stubTrue(){return true;}/**
         * Invokes the iteratee `n` times, returning an array of the results of
         * each invocation. The iteratee is invoked with one argument; (index).
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} n The number of times to invoke `iteratee`.
         * @param {Function} [iteratee=_.identity] The function invoked per iteration.
         * @returns {Array} Returns the array of results.
         * @example
         *
         * _.times(3, String);
         * // => ['0', '1', '2']
         *
         *  _.times(4, _.constant(0));
         * // => [0, 0, 0, 0]
         */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
         * Converts `value` to a property path array.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Util
         * @param {*} value The value to convert.
         * @returns {Array} Returns the new property path array.
         * @example
         *
         * _.toPath('a.b.c');
         * // => ['a', 'b', 'c']
         *
         * _.toPath('a[0].b.c');
         * // => ['a', '0', 'b', 'c']
         */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
         * Generates a unique ID. If `prefix` is given, the ID is appended to it.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {string} [prefix=''] The value to prefix the ID with.
         * @returns {string} Returns the unique ID.
         * @example
         *
         * _.uniqueId('contact_');
         * // => 'contact_104'
         *
         * _.uniqueId();
         * // => '105'
         */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/* ------------------------------------------------------------------------*//**
         * Adds two numbers.
         *
         * @static
         * @memberOf _
         * @since 3.4.0
         * @category Math
         * @param {number} augend The first number in an addition.
         * @param {number} addend The second number in an addition.
         * @returns {number} Returns the total.
         * @example
         *
         * _.add(6, 4);
         * // => 10
         */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
       * Computes `number` rounded up to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round up.
       * @param {number} [precision=0] The precision to round up to.
       * @returns {number} Returns the rounded up number.
       * @example
       *
       * _.ceil(4.006);
       * // => 5
       *
       * _.ceil(6.004, 2);
       * // => 6.01
       *
       * _.ceil(6040, -2);
       * // => 6100
       */var ceil=createRound('ceil');/**
         * Divide two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} dividend The first number in a division.
         * @param {number} divisor The second number in a division.
         * @returns {number} Returns the quotient.
         * @example
         *
         * _.divide(6, 4);
         * // => 1.5
         */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
       * Computes `number` rounded down to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round down.
       * @param {number} [precision=0] The precision to round down to.
       * @returns {number} Returns the rounded down number.
       * @example
       *
       * _.floor(4.006);
       * // => 4
       *
       * _.floor(0.046, 2);
       * // => 0.04
       *
       * _.floor(4060, -2);
       * // => 4000
       */var floor=createRound('floor');/**
         * Computes the maximum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * _.max([4, 2, 8, 6]);
         * // => 8
         *
         * _.max([]);
         * // => undefined
         */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
         * This method is like `_.max` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the maximum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.maxBy(objects, function(o) { return o.n; });
         * // => { 'n': 2 }
         *
         * // The `_.property` iteratee shorthand.
         * _.maxBy(objects, 'n');
         * // => { 'n': 2 }
         */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
         * Computes the mean of the values in `array`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {number} Returns the mean.
         * @example
         *
         * _.mean([4, 2, 8, 6]);
         * // => 5
         */function mean(array){return baseMean(array,identity);}/**
         * This method is like `_.mean` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be averaged.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the mean.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.meanBy(objects, function(o) { return o.n; });
         * // => 5
         *
         * // The `_.property` iteratee shorthand.
         * _.meanBy(objects, 'n');
         * // => 5
         */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
         * Computes the minimum value of `array`. If `array` is empty or falsey,
         * `undefined` is returned.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Math
         * @param {Array} array The array to iterate over.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * _.min([4, 2, 8, 6]);
         * // => 2
         *
         * _.min([]);
         * // => undefined
         */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
         * This method is like `_.min` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the criterion by which
         * the value is ranked. The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {*} Returns the minimum value.
         * @example
         *
         * var objects = [{ 'n': 1 }, { 'n': 2 }];
         *
         * _.minBy(objects, function(o) { return o.n; });
         * // => { 'n': 1 }
         *
         * // The `_.property` iteratee shorthand.
         * _.minBy(objects, 'n');
         * // => { 'n': 1 }
         */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
         * Multiply two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.7.0
         * @category Math
         * @param {number} multiplier The first number in a multiplication.
         * @param {number} multiplicand The second number in a multiplication.
         * @returns {number} Returns the product.
         * @example
         *
         * _.multiply(6, 4);
         * // => 24
         */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
       * Computes `number` rounded to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round.
       * @param {number} [precision=0] The precision to round to.
       * @returns {number} Returns the rounded number.
       * @example
       *
       * _.round(4.006);
       * // => 4
       *
       * _.round(4.006, 2);
       * // => 4.01
       *
       * _.round(4060, -2);
       * // => 4100
       */var round=createRound('round');/**
         * Subtract two numbers.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {number} minuend The first number in a subtraction.
         * @param {number} subtrahend The second number in a subtraction.
         * @returns {number} Returns the difference.
         * @example
         *
         * _.subtract(6, 4);
         * // => 2
         */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
       * Computes the sum of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the sum.
       * @example
       *
       * _.sum([4, 2, 8, 6]);
       * // => 20
       */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
         * This method is like `_.sum` except that it accepts `iteratee` which is
         * invoked for each element in `array` to generate the value to be summed.
         * The iteratee is invoked with one argument: (value).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Math
         * @param {Array} array The array to iterate over.
         * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
         * @returns {number} Returns the sum.
         * @example
         *
         * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
         *
         * _.sumBy(objects, function(o) { return o.n; });
         * // => 20
         *
         * // The `_.property` iteratee shorthand.
         * _.sumBy(objects, 'n');
         * // => 20
         */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/* ------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/* ------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{chain:false});/* ------------------------------------------------------------------------*//**
         * The semantic version number.
         *
         * @static
         * @memberOf _
         * @type {string}
         */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({size:nativeMin(n,MAX_ARRAY_LENGTH),type:methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({iteratee:getIteratee(iteratee,3),type:type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path==='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee==='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({func:thru,args:[interceptor],thisArg:undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({name:methodName,func:lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{name:'wrapper',func:undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/* --------------------------------------------------------------------------*/// Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if("function"==='function'&&_typeof(__webpack_require__(673))==='object'&&__webpack_require__(673)){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return _;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else if(freeModule){// Export for Node.js.
(freeModule.exports=_)._=_;// Export for CommonJS support.
freeExports._=_;}else{// Export to the global object.
root._=_;}}).call(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(62)(module)))

/***/ }),
/* 921 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 97);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/97:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //

    /* harmony default export */var button_groupvue_type_script_lang_js_ = {
      name: 'ElButtonGroup'
    };
    // CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
    /* harmony default export */var src_button_groupvue_type_script_lang_js_ = button_groupvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/button/src/button-group.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_button_groupvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/button/src/button-group.vue";
    /* harmony default export */var button_group = component.exports;
    // CONCATENATED MODULE: ./packages/button-group/index.js


    /* istanbul ignore next */
    button_group.install = function (Vue) {
      Vue.component(button_group.name, button_group);
    };

    /* harmony default export */var packages_button_group = __webpack_exports__["default"] = button_group;

    /***/
  }

  /******/ });

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 93);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/93:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-checkbox-group",
        attrs: { role: "group", "aria-label": "checkbox-group" }
      }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&


    /* harmony default export */var checkbox_groupvue_type_script_lang_js_ = {
      name: 'ElCheckboxGroup',

      componentName: 'ElCheckboxGroup',

      mixins: [emitter_default.a],

      inject: {
        elFormItem: {
          default: ''
        }
      },

      props: {
        value: {},
        disabled: Boolean,
        min: Number,
        max: Number,
        size: String,
        fill: String,
        textColor: String
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        checkboxGroupSize: function checkboxGroupSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        }
      },

      watch: {
        value: function value(_value) {
          this.dispatch('ElFormItem', 'el.form.change', [_value]);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
    /* harmony default export */var src_checkbox_groupvue_type_script_lang_js_ = checkbox_groupvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_checkbox_groupvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/checkbox/src/checkbox-group.vue";
    /* harmony default export */var checkbox_group = component.exports;
    // CONCATENATED MODULE: ./packages/checkbox-group/index.js


    /* istanbul ignore next */
    checkbox_group.install = function (Vue) {
      Vue.component(checkbox_group.name, checkbox_group);
    };

    /* harmony default export */var packages_checkbox_group = __webpack_exports__["default"] = checkbox_group;

    /***/
  }

  /******/ });

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;
    if (callback) {
      callback.apply(null, arguments);
    }
  };
  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }
  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
};

; /**
   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
   *
   * @param {Vue} instance Vue instance.
   * @param {Function} callback callback of after-leave event
   * @param {Number} speed the speed of transition, default value is 300ms
   * @param {Boolean} once weather bind after-leave once. default value is false.
   */

/***/ }),
/* 924 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 104);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/104:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-progress",
        class: ["el-progress--" + _vm.type, _vm.status ? "is-" + _vm.status : "", {
          "el-progress--without-text": !_vm.showText,
          "el-progress--text-inside": _vm.textInside
        }],
        attrs: {
          role: "progressbar",
          "aria-valuenow": _vm.percentage,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      }, [_vm.type === "line" ? _c("div", { staticClass: "el-progress-bar" }, [_c("div", {
        staticClass: "el-progress-bar__outer",
        style: {
          height: _vm.strokeWidth + "px",
          backgroundColor: _vm.defineBackColor
        }
      }, [_c("div", {
        staticClass: "el-progress-bar__inner",
        style: _vm.barStyle
      }, [_vm.showText && _vm.textInside ? _c("div", {
        staticClass: "el-progress-bar__innerText",
        style: { color: _vm.textColor }
      }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()])])]) : _c("div", {
        staticClass: "el-progress-circle",
        style: { height: _vm.width + "px", width: _vm.width + "px" }
      }, [_c("svg", { attrs: { viewBox: "0 0 100 100" } }, [_c("path", {
        staticClass: "el-progress-circle__track",
        style: _vm.trailPathStyle,
        attrs: {
          d: _vm.trackPath,
          stroke: _vm.defineBackColor,
          "stroke-width": _vm.relativeStrokeWidth,
          fill: "none"
        }
      }), _c("path", {
        staticClass: "el-progress-circle__path",
        style: _vm.circlePathStyle,
        attrs: {
          d: _vm.trackPath,
          stroke: _vm.stroke,
          fill: "none",
          "stroke-linecap": _vm.strokeLinecap,
          "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
        }
      })])]), _vm.showText && !_vm.textInside ? _c("div", {
        staticClass: "el-progress__text",
        style: {
          fontSize: _vm.progressTextSize + "px",
          color: _vm.textColor
        }
      }, [!_vm.status ? [_vm._v(_vm._s(_vm.content))] : _c("i", { class: _vm.iconClass })], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */var progressvue_type_script_lang_js_ = {
      name: 'ElProgress',
      props: {
        type: {
          type: String,
          default: 'line',
          validator: function validator(val) {
            return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
          }
        },
        percentage: {
          type: Number,
          default: 0,
          required: true,
          validator: function validator(val) {
            return val >= 0 && val <= 100;
          }
        },
        status: {
          type: String,
          validator: function validator(val) {
            return ['success', 'exception', 'warning'].indexOf(val) > -1;
          }
        },
        strokeWidth: {
          type: Number,
          default: 6
        },
        strokeLinecap: {
          type: String,
          default: 'round'
        },
        textInside: {
          type: Boolean,
          default: false
        },
        width: {
          type: Number,
          default: 126
        },
        showText: {
          type: Boolean,
          default: true
        },
        color: {
          type: [String, Array, Function],
          default: ''
        },
        defineBackColor: {
          type: [String, Array, Function],
          default: '#ebeef5'
        },
        textColor: {
          type: [String, Array, Function],
          default: '#606266'
        },
        format: Function
      },
      computed: {
        barStyle: function barStyle() {
          var style = {};
          style.width = this.percentage + '%';
          style.backgroundColor = this.getCurrentColor(this.percentage);
          return style;
        },
        relativeStrokeWidth: function relativeStrokeWidth() {
          return (this.strokeWidth / this.width * 100).toFixed(1);
        },
        radius: function radius() {
          if (this.type === 'circle' || this.type === 'dashboard') {
            return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
          } else {
            return 0;
          }
        },
        trackPath: function trackPath() {
          var radius = this.radius;
          var isDashboard = this.type === 'dashboard';
          return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
        },
        perimeter: function perimeter() {
          return 2 * Math.PI * this.radius;
        },
        rate: function rate() {
          return this.type === 'dashboard' ? 0.75 : 1;
        },
        strokeDashoffset: function strokeDashoffset() {
          var offset = -1 * this.perimeter * (1 - this.rate) / 2;
          return offset + 'px';
        },
        trailPathStyle: function trailPathStyle() {
          return {
            strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
            strokeDashoffset: this.strokeDashoffset
          };
        },
        circlePathStyle: function circlePathStyle() {
          return {
            strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
            strokeDashoffset: this.strokeDashoffset,
            transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
          };
        },
        stroke: function stroke() {
          var ret = void 0;
          if (this.color) {
            ret = this.getCurrentColor(this.percentage);
          } else {
            switch (this.status) {
              case 'success':
                ret = '#13ce66';
                break;
              case 'exception':
                ret = '#ff4949';
                break;
              case 'warning':
                ret = '#e6a23c';
                break;
              default:
                ret = '#20a0ff';
            }
          }
          return ret;
        },
        iconClass: function iconClass() {
          if (this.status === 'warning') {
            return 'el-icon-warning';
          }
          if (this.type === 'line') {
            return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
          } else {
            return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
          }
        },
        progressTextSize: function progressTextSize() {
          return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
        },
        content: function content() {
          if (typeof this.format === 'function') {
            return this.format(this.percentage) || '';
          } else {
            return this.percentage + '%';
          }
        }
      },
      methods: {
        getCurrentColor: function getCurrentColor(percentage) {
          if (typeof this.color === 'function') {
            return this.color(percentage);
          } else if (typeof this.color === 'string') {
            return this.color;
          } else {
            return this.getLevelColor(percentage);
          }
        },
        getLevelColor: function getLevelColor(percentage) {
          var colorArray = this.getColorArray().sort(function (a, b) {
            return a.percentage - b.percentage;
          });

          for (var i = 0; i < colorArray.length; i++) {
            if (colorArray[i].percentage > percentage) {
              return colorArray[i].color;
            }
          }
          return colorArray[colorArray.length - 1].color;
        },
        getColorArray: function getColorArray() {
          var color = this.color;
          var span = 100 / color.length;
          return color.map(function (seriesColor, index) {
            if (typeof seriesColor === 'string') {
              return {
                color: seriesColor,
                percentage: (index + 1) * span
              };
            }
            return seriesColor;
          });
        }
      }
    };
    // CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
    /* harmony default export */var src_progressvue_type_script_lang_js_ = progressvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/progress/src/progress.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_progressvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/progress/src/progress.vue";
    /* harmony default export */var progress = component.exports;
    // CONCATENATED MODULE: ./packages/progress/index.js


    /* istanbul ignore next */
    progress.install = function (Vue) {
      Vue.component(progress.name, progress);
    };

    /* harmony default export */var packages_progress = __webpack_exports__["default"] = progress;

    /***/
  }

  /******/ });

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 62);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/10:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(572);

    /***/
  },

  /***/12:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(669);

    /***/
  },

  /***/15:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(575);

    /***/
  },

  /***/16:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(573);

    /***/
  },

  /***/19:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(264);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(263);

    /***/
  },

  /***/22:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(576);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/31:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(577);

    /***/
  },

  /***/33:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }],
        staticClass: "el-select-dropdown__item",
        class: {
          selected: _vm.itemSelected,
          "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
          hover: _vm.hover
        },
        on: {
          mouseenter: _vm.hoverItem,
          click: function click($event) {
            $event.stopPropagation();
            return _vm.selectOptionClick($event);
          }
        }
      }, [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var optionvue_type_script_lang_js_ = {
      mixins: [emitter_default.a],

      name: 'ElOption',

      componentName: 'ElOption',

      inject: ['select'],

      props: {
        value: {
          required: true
        },
        label: [String, Number],
        created: Boolean,
        disabled: {
          type: Boolean,
          default: false
        }
      },

      data: function data() {
        return {
          index: -1,
          groupDisabled: false,
          visible: true,
          hitState: false,
          hover: false
        };
      },

      computed: {
        isObject: function isObject() {
          return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
        },
        currentLabel: function currentLabel() {
          return this.label || (this.isObject ? '' : this.value);
        },
        currentValue: function currentValue() {
          return this.value || this.label || '';
        },
        itemSelected: function itemSelected() {
          if (!this.select.multiple) {
            return this.isEqual(this.value, this.select.value);
          } else {
            return this.contains(this.select.value, this.value);
          }
        },
        limitReached: function limitReached() {
          if (this.select.multiple) {
            return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
          } else {
            return false;
          }
        }
      },

      watch: {
        currentLabel: function currentLabel() {
          if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
        },
        value: function value(val, oldVal) {
          var _select = this.select,
              remote = _select.remote,
              valueKey = _select.valueKey;

          if (!this.created && !remote) {
            if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
              return;
            }
            this.dispatch('ElSelect', 'setSelected');
          }
        }
      },

      methods: {
        isEqual: function isEqual(a, b) {
          if (!this.isObject) {
            return a === b;
          } else {
            var valueKey = this.select.valueKey;
            return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
          }
        },
        contains: function contains() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var target = arguments[1];

          if (!this.isObject) {
            return arr && arr.indexOf(target) > -1;
          } else {
            var valueKey = this.select.valueKey;
            return arr && arr.some(function (item) {
              return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
            });
          }
        },
        handleGroupDisabled: function handleGroupDisabled(val) {
          this.groupDisabled = val;
        },
        hoverItem: function hoverItem() {
          if (!this.disabled && !this.groupDisabled) {
            this.select.hoverIndex = this.select.options.indexOf(this);
          }
        },
        selectOptionClick: function selectOptionClick() {
          if (this.disabled !== true && this.groupDisabled !== true) {
            this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
          }
        },
        queryChange: function queryChange(query) {
          this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
          if (!this.visible) {
            this.select.filteredOptionsCount--;
          }
        }
      },

      created: function created() {
        this.select.options.push(this);
        this.select.cachedOptions.push(this);
        this.select.optionsCount++;
        this.select.filteredOptionsCount++;

        this.$on('queryChange', this.queryChange);
        this.$on('handleGroupDisabled', this.handleGroupDisabled);
      },
      beforeDestroy: function beforeDestroy() {
        var _select2 = this.select,
            selected = _select2.selected,
            multiple = _select2.multiple;

        var selectedOptions = multiple ? selected : [selected];
        var index = this.select.cachedOptions.indexOf(this);
        var selectedIndex = selectedOptions.indexOf(this);

        // if option is not selected, remove it from cache
        if (index > -1 && selectedIndex < 0) {
          this.select.cachedOptions.splice(index, 1);
        }
        this.select.onOptionDestroy(this.select.options.indexOf(this));
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
    /* harmony default export */var src_optionvue_type_script_lang_js_ = optionvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/option.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_optionvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/option.vue";
    /* harmony default export */var src_option = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/38:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(674);

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(261);

    /***/
  },

  /***/6:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(570);

    /***/
  },

  /***/62:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        directives: [{
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.handleClose,
          expression: "handleClose"
        }],
        staticClass: "el-select",
        class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toggleMenu($event);
          }
        }
      }, [_vm.multiple ? _c("div", {
        ref: "tags",
        staticClass: "el-select__tags",
        style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
      }, [_vm.collapseTags && _vm.selected.length ? _c("span", [_c("el-tag", {
        attrs: {
          closable: !_vm.selectDisabled,
          size: _vm.collapseTagSize,
          hit: _vm.selected[0].hitState,
          type: "info",
          "disable-transitions": ""
        },
        on: {
          close: function close($event) {
            _vm.deleteTag($event, _vm.selected[0]);
          }
        }
      }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v(_vm._s(_vm.selected[0].currentLabel))])]), _vm.selected.length > 1 ? _c("el-tag", {
        attrs: {
          closable: false,
          size: _vm.collapseTagSize,
          type: "info",
          "disable-transitions": ""
        }
      }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v("+ " + _vm._s(_vm.selected.length - 1))])]) : _vm._e()], 1) : _vm._e(), !_vm.collapseTags ? _c("transition-group", { on: { "after-leave": _vm.resetInputHeight } }, _vm._l(_vm.selected, function (item) {
        return _c("el-tag", {
          key: _vm.getValueKey(item),
          attrs: {
            closable: !_vm.selectDisabled,
            size: _vm.collapseTagSize,
            hit: item.hitState,
            type: "info",
            "disable-transitions": ""
          },
          on: {
            close: function close($event) {
              _vm.deleteTag($event, item);
            }
          }
        }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v(_vm._s(item.currentLabel))])]);
      }), 1) : _vm._e(), _vm.filterable ? _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.query,
          expression: "query"
        }],
        ref: "input",
        staticClass: "el-select__input",
        class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
        style: {
          "flex-grow": "1",
          width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
          "max-width": _vm.inputWidth - 42 + "px"
        },
        attrs: {
          type: "text",
          disabled: _vm.selectDisabled,
          autocomplete: _vm.autoComplete || _vm.autocomplete
        },
        domProps: { value: _vm.query },
        on: {
          focus: _vm.handleFocus,
          blur: function blur($event) {
            _vm.softFocus = false;
          },
          keyup: _vm.managePlaceholder,
          keydown: [_vm.resetInputState, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.preventDefault();
            _vm.handleNavigate("next");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.preventDefault();
            _vm.handleNavigate("prev");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            $event.preventDefault();
            return _vm.selectOption($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.visible = false;
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
              return null;
            }
            return _vm.deletePrevTag($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
              return null;
            }
            _vm.visible = false;
          }],
          compositionstart: _vm.handleComposition,
          compositionupdate: _vm.handleComposition,
          compositionend: _vm.handleComposition,
          input: [function ($event) {
            if ($event.target.composing) {
              return;
            }
            _vm.query = $event.target.value;
          }, _vm.debouncedQueryChange]
        }
      }) : _vm._e()], 1) : _vm._e(), _c("el-input", {
        ref: "reference",
        class: { "is-focus": _vm.visible },
        attrs: {
          type: "text",
          placeholder: _vm.currentPlaceholder,
          name: _vm.name,
          id: _vm.id,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          size: _vm.selectSize,
          disabled: _vm.selectDisabled,
          readonly: _vm.readonly,
          "validate-event": false,
          tabindex: _vm.multiple && _vm.filterable ? "-1" : null
        },
        on: {
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          input: _vm.debouncedOnInputChange,
          compositionstart: _vm.handleComposition,
          compositionupdate: _vm.handleComposition,
          compositionend: _vm.handleComposition
        },
        nativeOn: {
          keydown: [function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.handleNavigate("next");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.handleNavigate("prev");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            $event.preventDefault();
            return _vm.selectOption($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.visible = false;
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
              return null;
            }
            _vm.visible = false;
          }],
          mouseenter: function mouseenter($event) {
            _vm.inputHovering = true;
          },
          mouseleave: function mouseleave($event) {
            _vm.inputHovering = false;
          }
        },
        model: {
          value: _vm.selectedLabel,
          callback: function callback($$v) {
            _vm.selectedLabel = $$v;
          },
          expression: "selectedLabel"
        }
      }, [_vm.$slots.prefix ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2) : _vm._e(), _c("template", { slot: "suffix" }, [_c("i", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.showClose,
          expression: "!showClose"
        }],
        class: ["el-select__caret", "el-input__icon", "el-icon-" + _vm.iconClass]
      }), _vm.showClose ? _c("i", {
        staticClass: "el-select__caret el-input__icon el-icon-circle-close",
        on: { click: _vm.handleClearClick }
      }) : _vm._e()])], 2), _c("transition", {
        attrs: { name: "el-zoom-in-top" },
        on: {
          "before-enter": _vm.handleMenuEnter,
          "after-leave": _vm.doDestroy
        }
      }, [_c("el-select-menu", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible && _vm.emptyText !== false,
          expression: "visible && emptyText !== false"
        }],
        ref: "popper",
        attrs: { "append-to-body": _vm.popperAppendToBody }
      }, [_c("el-scrollbar", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.options.length > 0 && !_vm.loading,
          expression: "options.length > 0 && !loading"
        }],
        ref: "scrollbar",
        class: {
          "is-empty": !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0
        },
        attrs: {
          tag: "ul",
          "wrap-class": "el-select-dropdown__wrap",
          "view-class": "el-select-dropdown__list"
        }
      }, [_vm.showNewOption ? _c("el-option", {
        attrs: { value: _vm.query, created: "" }
      }) : _vm._e(), _vm._t("default")], 2), _vm.emptyText && (!_vm.allowCreate || _vm.loading || _vm.allowCreate && _vm.options.length === 0) ? [_vm.$slots.empty ? _vm._t("empty") : _c("p", { staticClass: "el-select-dropdown__empty" }, [_vm._v("\n          " + _vm._s(_vm.emptyText) + "\n        ")])] : _vm._e()], 2)], 1)], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
    var focus_ = __webpack_require__(22);
    var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
    var locale_ = __webpack_require__(6);
    var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

    // EXTERNAL MODULE: external "element-ui/lib/input"
    var input_ = __webpack_require__(10);
    var input_default = /*#__PURE__*/__webpack_require__.n(input_);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
    var select_dropdownvue_type_template_id_06828748_render = function select_dropdownvue_type_template_id_06828748_render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-select-dropdown el-popper",
        class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
        style: { minWidth: _vm.minWidth }
      }, [_vm._t("default")], 2);
    };
    var select_dropdownvue_type_template_id_06828748_staticRenderFns = [];
    select_dropdownvue_type_template_id_06828748_render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var select_dropdownvue_type_script_lang_js_ = {
      name: 'ElSelectDropdown',

      componentName: 'ElSelectDropdown',

      mixins: [vue_popper_default.a],

      props: {
        placement: {
          default: 'bottom-start'
        },

        boundariesPadding: {
          default: 0
        },

        popperOptions: {
          default: function _default() {
            return {
              gpuAcceleration: false
            };
          }
        },

        visibleArrow: {
          default: true
        },

        appendToBody: {
          type: Boolean,
          default: true
        }
      },

      data: function data() {
        return {
          minWidth: ''
        };
      },

      computed: {
        popperClass: function popperClass() {
          return this.$parent.popperClass;
        }
      },

      watch: {
        '$parent.inputWidth': function $parentInputWidth() {
          this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
        }
      },

      mounted: function mounted() {
        var _this = this;

        this.referenceElm = this.$parent.$refs.reference.$el;
        this.$parent.popperElm = this.popperElm = this.$el;
        this.$on('updatePopper', function () {
          if (_this.$parent.visible) _this.updatePopper();
        });
        this.$on('destroyPopper', this.destroyPopper);
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
    /* harmony default export */var src_select_dropdownvue_type_script_lang_js_ = select_dropdownvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_select_dropdownvue_type_script_lang_js_, select_dropdownvue_type_template_id_06828748_render, select_dropdownvue_type_template_id_06828748_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/select-dropdown.vue";
    /* harmony default export */var select_dropdown = component.exports;
    // EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
    var src_option = __webpack_require__(33);

    // EXTERNAL MODULE: external "element-ui/lib/tag"
    var tag_ = __webpack_require__(38);
    var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);

    // EXTERNAL MODULE: external "element-ui/lib/scrollbar"
    var scrollbar_ = __webpack_require__(15);
    var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

    // EXTERNAL MODULE: external "throttle-debounce/debounce"
    var debounce_ = __webpack_require__(19);
    var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
    var clickoutside_ = __webpack_require__(12);
    var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
    var resize_event_ = __webpack_require__(16);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
    var scroll_into_view_ = __webpack_require__(31);
    var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
    /* harmony default export */var navigation_mixin = {
      data: function data() {
        return {
          hoverOption: -1
        };
      },

      computed: {
        optionsAllDisabled: function optionsAllDisabled() {
          return this.options.filter(function (option) {
            return option.visible;
          }).every(function (option) {
            return option.disabled;
          });
        }
      },

      watch: {
        hoverIndex: function hoverIndex(val) {
          var _this = this;

          if (typeof val === 'number' && val > -1) {
            this.hoverOption = this.options[val] || {};
          }
          this.options.forEach(function (option) {
            option.hover = _this.hoverOption === option;
          });
        }
      },

      methods: {
        navigateOptions: function navigateOptions(direction) {
          var _this2 = this;

          if (!this.visible) {
            this.visible = true;
            return;
          }
          if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
          if (!this.optionsAllDisabled) {
            if (direction === 'next') {
              this.hoverIndex++;
              if (this.hoverIndex === this.options.length) {
                this.hoverIndex = 0;
              }
            } else if (direction === 'prev') {
              this.hoverIndex--;
              if (this.hoverIndex < 0) {
                this.hoverIndex = this.options.length - 1;
              }
            }
            var option = this.options[this.hoverIndex];
            if (option.disabled === true || option.groupDisabled === true || !option.visible) {
              this.navigateOptions(direction);
            }
            this.$nextTick(function () {
              return _this2.scrollToOption(_this2.hoverOption);
            });
          }
        }
      }
    };
    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var selectvue_type_script_lang_js_ = {
      mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],

      name: 'ElSelect',

      componentName: 'ElSelect',

      inject: {
        elForm: {
          default: ''
        },

        elFormItem: {
          default: ''
        }
      },

      provide: function provide() {
        return {
          'select': this
        };
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        readonly: function readonly() {
          return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
        },
        showClose: function showClose() {
          var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
          var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
          return criteria;
        },
        iconClass: function iconClass() {
          return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
        },
        debounce: function debounce() {
          return this.remote ? 300 : 0;
        },
        emptyText: function emptyText() {
          if (this.loading) {
            return this.loadingText || this.t('el.select.loading');
          } else {
            if (this.remote && this.query === '' && this.options.length === 0) return false;
            if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
              return this.noMatchText || this.t('el.select.noMatch');
            }
            if (this.options.length === 0) {
              return this.noDataText || this.t('el.select.noData');
            }
          }
          return null;
        },
        showNewOption: function showNewOption() {
          var _this = this;

          var hasExistingOption = this.options.filter(function (option) {
            return !option.created;
          }).some(function (option) {
            return option.currentLabel === _this.query;
          });
          return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
        },
        selectSize: function selectSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        selectDisabled: function selectDisabled() {
          return this.disabled || (this.elForm || {}).disabled;
        },
        collapseTagSize: function collapseTagSize() {
          return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
        },
        propPlaceholder: function propPlaceholder() {
          return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
        }
      },

      components: {
        ElInput: input_default.a,
        ElSelectMenu: select_dropdown,
        ElOption: src_option["a" /* default */],
        ElTag: tag_default.a,
        ElScrollbar: scrollbar_default.a
      },

      directives: { Clickoutside: clickoutside_default.a },

      props: {
        name: String,
        id: String,
        value: {
          required: true
        },
        autocomplete: {
          type: String,
          default: 'off'
        },
        /** @Deprecated in next major version */
        autoComplete: {
          type: String,
          validator: function validator(val) {
            false && false;
            return true;
          }
        },
        automaticDropdown: Boolean,
        size: String,
        disabled: Boolean,
        clearable: Boolean,
        filterable: Boolean,
        allowCreate: Boolean,
        loading: Boolean,
        popperClass: String,
        remote: Boolean,
        loadingText: String,
        noMatchText: String,
        noDataText: String,
        remoteMethod: Function,
        filterMethod: Function,
        multiple: Boolean,
        multipleLimit: {
          type: Number,
          default: 0
        },
        placeholder: {
          type: String,
          required: false
        },
        defaultFirstOption: Boolean,
        reserveKeyword: Boolean,
        valueKey: {
          type: String,
          default: 'value'
        },
        collapseTags: Boolean,
        popperAppendToBody: {
          type: Boolean,
          default: true
        }
      },

      data: function data() {
        return {
          options: [],
          cachedOptions: [],
          createdLabel: null,
          createdSelected: false,
          selected: this.multiple ? [] : {},
          inputLength: 20,
          inputWidth: 0,
          initialInputHeight: 0,
          cachedPlaceHolder: '',
          optionsCount: 0,
          filteredOptionsCount: 0,
          visible: false,
          softFocus: false,
          selectedLabel: '',
          hoverIndex: -1,
          query: '',
          previousQuery: null,
          inputHovering: false,
          currentPlaceholder: '',
          menuVisibleOnFocus: false,
          isOnComposition: false,
          isSilentBlur: false
        };
      },

      watch: {
        selectDisabled: function selectDisabled() {
          var _this2 = this;

          this.$nextTick(function () {
            _this2.resetInputHeight();
          });
        },
        propPlaceholder: function propPlaceholder(val) {
          this.cachedPlaceHolder = this.currentPlaceholder = val;
        },
        value: function value(val, oldVal) {
          if (this.multiple) {
            this.resetInputHeight();
            if (val && val.length > 0 || this.$refs.input && this.query !== '') {
              this.currentPlaceholder = '';
            } else {
              this.currentPlaceholder = this.cachedPlaceHolder;
            }
            if (this.filterable && !this.reserveKeyword) {
              this.query = '';
              this.handleQueryChange(this.query);
            }
          }
          this.setSelected();
          if (this.filterable && !this.multiple) {
            this.inputLength = 20;
          }
          if (!Object(util_["valueEquals"])(val, oldVal)) {
            this.dispatch('ElFormItem', 'el.form.change', val);
          }
        },
        visible: function visible(val) {
          var _this3 = this;

          if (!val) {
            this.broadcast('ElSelectDropdown', 'destroyPopper');
            if (this.$refs.input) {
              this.$refs.input.blur();
            }
            this.query = '';
            this.previousQuery = null;
            this.selectedLabel = '';
            this.inputLength = 20;
            this.menuVisibleOnFocus = false;
            this.resetHoverIndex();
            this.$nextTick(function () {
              if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
                _this3.currentPlaceholder = _this3.cachedPlaceHolder;
              }
            });
            if (!this.multiple) {
              if (this.selected) {
                if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
                  this.selectedLabel = this.createdLabel;
                } else {
                  this.selectedLabel = this.selected.currentLabel;
                }
                if (this.filterable) this.query = this.selectedLabel;
              }

              if (this.filterable) {
                this.currentPlaceholder = this.cachedPlaceHolder;
              }
            }
          } else {
            this.broadcast('ElSelectDropdown', 'updatePopper');
            if (this.filterable) {
              this.query = this.remote ? '' : this.selectedLabel;
              this.handleQueryChange(this.query);
              if (this.multiple) {
                this.$refs.input.focus();
              } else {
                if (!this.remote) {
                  this.broadcast('ElOption', 'queryChange', '');
                  this.broadcast('ElOptionGroup', 'queryChange');
                }

                if (this.selectedLabel) {
                  this.currentPlaceholder = this.selectedLabel;
                  this.selectedLabel = '';
                }
              }
            }
          }
          this.$emit('visible-change', val);
        },
        options: function options() {
          var _this4 = this;

          if (this.$isServer) return;
          this.$nextTick(function () {
            _this4.broadcast('ElSelectDropdown', 'updatePopper');
          });
          if (this.multiple) {
            this.resetInputHeight();
          }
          var inputs = this.$el.querySelectorAll('input');
          if ([].indexOf.call(inputs, document.activeElement) === -1) {
            this.setSelected();
          }
          if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
            this.checkDefaultFirstOption();
          }
        }
      },

      methods: {
        handleNavigate: function handleNavigate(direction) {
          if (this.isOnComposition) return;

          this.navigateOptions(direction);
        },
        handleComposition: function handleComposition(event) {
          var _this5 = this;

          var text = event.target.value;
          if (event.type === 'compositionend') {
            this.isOnComposition = false;
            this.$nextTick(function (_) {
              return _this5.handleQueryChange(text);
            });
          } else {
            var lastCharacter = text[text.length - 1] || '';
            this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
          }
        },
        handleQueryChange: function handleQueryChange(val) {
          var _this6 = this;

          if (this.previousQuery === val || this.isOnComposition) return;
          if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
            this.previousQuery = val;
            return;
          }
          this.previousQuery = val;
          this.$nextTick(function () {
            if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
          });
          this.hoverIndex = -1;
          if (this.multiple && this.filterable) {
            this.$nextTick(function () {
              var length = _this6.$refs.input.value.length * 15 + 20;
              _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
              _this6.managePlaceholder();
              _this6.resetInputHeight();
            });
          }
          if (this.remote && typeof this.remoteMethod === 'function') {
            this.hoverIndex = -1;
            this.remoteMethod(val);
          } else if (typeof this.filterMethod === 'function') {
            this.filterMethod(val);
            this.broadcast('ElOptionGroup', 'queryChange');
          } else {
            this.filteredOptionsCount = this.optionsCount;
            this.broadcast('ElOption', 'queryChange', val);
            this.broadcast('ElOptionGroup', 'queryChange');
          }
          if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
            this.checkDefaultFirstOption();
          }
        },
        scrollToOption: function scrollToOption(option) {
          var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
          if (this.$refs.popper && target) {
            var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
            scroll_into_view_default()(menu, target);
          }
          this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
        },
        handleMenuEnter: function handleMenuEnter() {
          var _this7 = this;

          this.$nextTick(function () {
            return _this7.scrollToOption(_this7.selected);
          });
        },
        emitChange: function emitChange(val) {
          if (!Object(util_["valueEquals"])(this.value, val)) {
            this.$emit('change', val);
          }
        },
        getOption: function getOption(value) {
          var option = void 0;
          var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
          var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
          var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

          for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
            var cachedOption = this.cachedOptions[i];
            var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
            if (isEqual) {
              option = cachedOption;
              break;
            }
          }
          if (option) return option;
          var label = !isObject && !isNull && !isUndefined ? String(value) : '';
          var newOption = {
            value: value,
            currentLabel: label
          };
          if (this.multiple) {
            newOption.hitState = false;
          }
          return newOption;
        },
        setSelected: function setSelected() {
          var _this8 = this;

          if (!this.multiple) {
            var option = this.getOption(this.value);
            if (option.created) {
              this.createdLabel = option.currentLabel;
              this.createdSelected = true;
            } else {
              this.createdSelected = false;
            }
            this.selectedLabel = option.currentLabel;
            this.selected = option;
            if (this.filterable) this.query = this.selectedLabel;
            return;
          }
          var result = [];
          if (Array.isArray(this.value)) {
            this.value.forEach(function (value) {
              result.push(_this8.getOption(value));
            });
          }
          this.selected = result;
          this.$nextTick(function () {
            _this8.resetInputHeight();
          });
        },
        handleFocus: function handleFocus(event) {
          if (!this.softFocus) {
            if (this.automaticDropdown || this.filterable) {
              if (this.filterable && !this.visible) {
                this.menuVisibleOnFocus = true;
              }
              this.visible = true;
            }
            this.$emit('focus', event);
          } else {
            this.softFocus = false;
          }
        },
        blur: function blur() {
          this.visible = false;
          this.$refs.reference.blur();
        },
        handleBlur: function handleBlur(event) {
          var _this9 = this;

          setTimeout(function () {
            if (_this9.isSilentBlur) {
              _this9.isSilentBlur = false;
            } else {
              _this9.$emit('blur', event);
            }
          }, 50);
          this.softFocus = false;
        },
        handleClearClick: function handleClearClick(event) {
          this.deleteSelected(event);
        },
        doDestroy: function doDestroy() {
          this.$refs.popper && this.$refs.popper.doDestroy();
        },
        handleClose: function handleClose() {
          this.visible = false;
        },
        toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
          if (!Array.isArray(this.selected)) return;
          var option = this.selected[this.selected.length - 1];
          if (!option) return;

          if (hit === true || hit === false) {
            option.hitState = hit;
            return hit;
          }

          option.hitState = !option.hitState;
          return option.hitState;
        },
        deletePrevTag: function deletePrevTag(e) {
          if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
            var value = this.value.slice();
            value.pop();
            this.$emit('input', value);
            this.emitChange(value);
          }
        },
        managePlaceholder: function managePlaceholder() {
          if (this.currentPlaceholder !== '') {
            this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
          }
        },
        resetInputState: function resetInputState(e) {
          if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
          this.inputLength = this.$refs.input.value.length * 15 + 20;
          this.resetInputHeight();
        },
        resetInputHeight: function resetInputHeight() {
          var _this10 = this;

          if (this.collapseTags && !this.filterable) return;
          this.$nextTick(function () {
            if (!_this10.$refs.reference) return;
            var inputChildNodes = _this10.$refs.reference.$el.childNodes;
            var input = [].filter.call(inputChildNodes, function (item) {
              return item.tagName === 'INPUT';
            })[0];
            var tags = _this10.$refs.tags;
            var tagsHeight = tags ? Math.round(tags.getBoundingClientRect().height) : 0;
            var sizeInMap = _this10.initialInputHeight || 40;
            input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tagsHeight + (tagsHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
            if (_this10.visible && _this10.emptyText !== false) {
              _this10.broadcast('ElSelectDropdown', 'updatePopper');
            }
          });
        },
        resetHoverIndex: function resetHoverIndex() {
          var _this11 = this;

          setTimeout(function () {
            if (!_this11.multiple) {
              _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
            } else {
              if (_this11.selected.length > 0) {
                _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
                  return _this11.options.indexOf(item);
                }));
              } else {
                _this11.hoverIndex = -1;
              }
            }
          }, 300);
        },
        handleOptionSelect: function handleOptionSelect(option, byClick) {
          var _this12 = this;

          if (this.multiple) {
            var value = (this.value || []).slice();
            var optionIndex = this.getValueIndex(value, option.value);
            if (optionIndex > -1) {
              value.splice(optionIndex, 1);
            } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
              value.push(option.value);
            }
            this.$emit('input', value);
            this.emitChange(value);
            if (option.created) {
              this.query = '';
              this.handleQueryChange('');
              this.inputLength = 20;
            }
            if (this.filterable) this.$refs.input.focus();
          } else {
            this.$emit('input', option.value);
            this.emitChange(option.value);
            this.visible = false;
          }
          this.isSilentBlur = byClick;
          this.setSoftFocus();
          if (this.visible) return;
          this.$nextTick(function () {
            _this12.scrollToOption(option);
          });
        },
        setSoftFocus: function setSoftFocus() {
          this.softFocus = true;
          var input = this.$refs.input || this.$refs.reference;
          if (input) {
            input.focus();
          }
        },
        getValueIndex: function getValueIndex() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var value = arguments[1];

          var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
          if (!isObject) {
            return arr.indexOf(value);
          } else {
            var valueKey = this.valueKey;
            var index = -1;
            arr.some(function (item, i) {
              if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
                index = i;
                return true;
              }
              return false;
            });
            return index;
          }
        },
        toggleMenu: function toggleMenu() {
          if (!this.selectDisabled) {
            if (this.menuVisibleOnFocus) {
              this.menuVisibleOnFocus = false;
            } else {
              this.visible = !this.visible;
            }
            if (this.visible) {
              (this.$refs.input || this.$refs.reference).focus();
            }
          }
        },
        selectOption: function selectOption() {
          if (!this.visible) {
            this.toggleMenu();
          } else {
            if (this.options[this.hoverIndex]) {
              this.handleOptionSelect(this.options[this.hoverIndex]);
            }
          }
        },
        deleteSelected: function deleteSelected(event) {
          event.stopPropagation();
          var value = this.multiple ? [] : '';
          this.$emit('input', value);
          this.emitChange(value);
          this.visible = false;
          this.$emit('clear');
        },
        deleteTag: function deleteTag(event, tag) {
          var index = this.selected.indexOf(tag);
          if (index > -1 && !this.selectDisabled) {
            var value = this.value.slice();
            value.splice(index, 1);
            this.$emit('input', value);
            this.emitChange(value);
            this.$emit('remove-tag', tag.value);
          }
          event.stopPropagation();
        },
        onInputChange: function onInputChange() {
          if (this.filterable && this.query !== this.selectedLabel) {
            this.query = this.selectedLabel;
            this.handleQueryChange(this.query);
          }
        },
        onOptionDestroy: function onOptionDestroy(index) {
          if (index > -1) {
            this.optionsCount--;
            this.filteredOptionsCount--;
            this.options.splice(index, 1);
          }
        },
        resetInputWidth: function resetInputWidth() {
          this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
        },
        handleResize: function handleResize() {
          this.resetInputWidth();
          if (this.multiple) this.resetInputHeight();
        },
        checkDefaultFirstOption: function checkDefaultFirstOption() {
          this.hoverIndex = -1;
          // highlight the created option
          var hasCreated = false;
          for (var i = this.options.length - 1; i >= 0; i--) {
            if (this.options[i].created) {
              hasCreated = true;
              this.hoverIndex = i;
              break;
            }
          }
          if (hasCreated) return;
          for (var _i = 0; _i !== this.options.length; ++_i) {
            var option = this.options[_i];
            if (this.query) {
              // highlight first options that passes the filter
              if (!option.disabled && !option.groupDisabled && option.visible) {
                this.hoverIndex = _i;
                break;
              }
            } else {
              // highlight currently selected option
              if (option.itemSelected) {
                this.hoverIndex = _i;
                break;
              }
            }
          }
        },
        getValueKey: function getValueKey(item) {
          if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
            return item.value;
          } else {
            return Object(util_["getValueByPath"])(item.value, this.valueKey);
          }
        }
      },

      created: function created() {
        var _this13 = this;

        this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
        if (this.multiple && !Array.isArray(this.value)) {
          this.$emit('input', []);
        }
        if (!this.multiple && Array.isArray(this.value)) {
          this.$emit('input', '');
        }

        this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
          _this13.onInputChange();
        });

        this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
          _this13.handleQueryChange(e.target.value);
        });

        this.$on('handleOptionClick', this.handleOptionSelect);
        this.$on('setSelected', this.setSelected);
      },
      mounted: function mounted() {
        var _this14 = this;

        if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
          this.currentPlaceholder = '';
        }
        Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);

        var reference = this.$refs.reference;
        if (reference && reference.$el) {
          var sizeMap = {
            medium: 36,
            small: 32,
            mini: 28
          };
          var input = reference.$el.querySelector('input');
          this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
        }
        if (this.remote && this.multiple) {
          this.resetInputHeight();
        }
        this.$nextTick(function () {
          if (reference && reference.$el) {
            _this14.inputWidth = reference.$el.getBoundingClientRect().width;
          }
        });
        this.setSelected();
      },
      beforeDestroy: function beforeDestroy() {
        if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
    /* harmony default export */var src_selectvue_type_script_lang_js_ = selectvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/select/src/select.vue


    /* normalize component */

    var select_component = Object(componentNormalizer["a" /* default */])(src_selectvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var select_api;
    }
    select_component.options.__file = "packages/select/src/select.vue";
    /* harmony default export */var src_select = select_component.exports;
    // CONCATENATED MODULE: ./packages/select/index.js


    /* istanbul ignore next */
    src_select.install = function (Vue) {
      Vue.component(src_select.name, src_select);
    };

    /* harmony default export */var packages_select = __webpack_exports__["default"] = src_select;

    /***/
  }

  /******/ });

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 54);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/33:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }],
        staticClass: "el-select-dropdown__item",
        class: {
          selected: _vm.itemSelected,
          "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
          hover: _vm.hover
        },
        on: {
          mouseenter: _vm.hoverItem,
          click: function click($event) {
            $event.stopPropagation();
            return _vm.selectOptionClick($event);
          }
        }
      }, [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var optionvue_type_script_lang_js_ = {
      mixins: [emitter_default.a],

      name: 'ElOption',

      componentName: 'ElOption',

      inject: ['select'],

      props: {
        value: {
          required: true
        },
        label: [String, Number],
        created: Boolean,
        disabled: {
          type: Boolean,
          default: false
        }
      },

      data: function data() {
        return {
          index: -1,
          groupDisabled: false,
          visible: true,
          hitState: false,
          hover: false
        };
      },

      computed: {
        isObject: function isObject() {
          return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
        },
        currentLabel: function currentLabel() {
          return this.label || (this.isObject ? '' : this.value);
        },
        currentValue: function currentValue() {
          return this.value || this.label || '';
        },
        itemSelected: function itemSelected() {
          if (!this.select.multiple) {
            return this.isEqual(this.value, this.select.value);
          } else {
            return this.contains(this.select.value, this.value);
          }
        },
        limitReached: function limitReached() {
          if (this.select.multiple) {
            return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
          } else {
            return false;
          }
        }
      },

      watch: {
        currentLabel: function currentLabel() {
          if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
        },
        value: function value(val, oldVal) {
          var _select = this.select,
              remote = _select.remote,
              valueKey = _select.valueKey;

          if (!this.created && !remote) {
            if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
              return;
            }
            this.dispatch('ElSelect', 'setSelected');
          }
        }
      },

      methods: {
        isEqual: function isEqual(a, b) {
          if (!this.isObject) {
            return a === b;
          } else {
            var valueKey = this.select.valueKey;
            return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
          }
        },
        contains: function contains() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var target = arguments[1];

          if (!this.isObject) {
            return arr && arr.indexOf(target) > -1;
          } else {
            var valueKey = this.select.valueKey;
            return arr && arr.some(function (item) {
              return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
            });
          }
        },
        handleGroupDisabled: function handleGroupDisabled(val) {
          this.groupDisabled = val;
        },
        hoverItem: function hoverItem() {
          if (!this.disabled && !this.groupDisabled) {
            this.select.hoverIndex = this.select.options.indexOf(this);
          }
        },
        selectOptionClick: function selectOptionClick() {
          if (this.disabled !== true && this.groupDisabled !== true) {
            this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
          }
        },
        queryChange: function queryChange(query) {
          this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
          if (!this.visible) {
            this.select.filteredOptionsCount--;
          }
        }
      },

      created: function created() {
        this.select.options.push(this);
        this.select.cachedOptions.push(this);
        this.select.optionsCount++;
        this.select.filteredOptionsCount++;

        this.$on('queryChange', this.queryChange);
        this.$on('handleGroupDisabled', this.handleGroupDisabled);
      },
      beforeDestroy: function beforeDestroy() {
        var _select2 = this.select,
            selected = _select2.selected,
            multiple = _select2.multiple;

        var selectedOptions = multiple ? selected : [selected];
        var index = this.select.cachedOptions.indexOf(this);
        var selectedIndex = selectedOptions.indexOf(this);

        // if option is not selected, remove it from cache
        if (index > -1 && selectedIndex < 0) {
          this.select.cachedOptions.splice(index, 1);
        }
        this.select.onOptionDestroy(this.select.options.indexOf(this));
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
    /* harmony default export */var src_optionvue_type_script_lang_js_ = optionvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/option.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_optionvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/option.vue";
    /* harmony default export */var src_option = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(133);

    /***/
  },

  /***/54:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);

    /* istanbul ignore next */
    _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"].install = function (Vue) {
      Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"]);
    };

    /* harmony default export */__webpack_exports__["default"] = _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"];

    /***/
  }

  /******/ });

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(928);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */



var UserAgent_DEPRECATED = __webpack_require__(929);

var isEventSupported = __webpack_require__(930);

// Reasonable defaults
var PIXEL_STEP = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel( /*object*/event) /*object*/{
  var sX = 0,
      sY = 0,
      // spinX, spinY
  pX = 0,
      pY = 0; // pixelX, pixelY

  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return { spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY };
}

/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel.getEventType = function () /*string*/{
  return UserAgent_DEPRECATED.firefox() ? 'DOMMouseScroll' : isEventSupported('wheel') ? 'wheel' : 'mousewheel';
};

module.exports = normalizeWheel;

/***/ }),
/* 929 */
/***/ (function(module, exports) {

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!/Win64/.exec(uas);

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function ie() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function ieCompatibilityMode() {
    return _populate() || _ie_real_version > _ie;
  },

  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function ie64() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function firefox() {
    return _populate() || _firefox;
  },

  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function opera() {
    return _populate() || _opera;
  },

  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function webkit() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function safari() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome: function chrome() {
    return _populate() || _chrome;
  },

  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function windows() {
    return _populate() || _windows;
  },

  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function osx() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function linux() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function iphone() {
    return _populate() || _iphone;
  },

  mobile: function mobile() {
    return _populate() || _iphone || _ipad || _android || _mobile;
  },

  nativeApp: function nativeApp() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function android() {
    return _populate() || _android;
  },

  ipad: function ipad() {
    return _populate() || _ipad;
  }
};

module.exports = UserAgent_DEPRECATED;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(931);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

/*jslint evil: true */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _ariaUtils = __webpack_require__(578);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * @constructor
 * @desc Dialog object providing modal focus management.
 *
 * Assumptions: The element serving as the dialog container is present in the
 * DOM and hidden. The dialog container has role='dialog'.
 *
 * @param dialogId
 *          The ID of the element serving as the dialog container.
 * @param focusAfterClosed
 *          Either the DOM node or the ID of the DOM node to focus when the
 *          dialog closes.
 * @param focusFirst
 *          Optional parameter containing either the DOM node or the ID of the
 *          DOM node to focus when the dialog opens. If not specified, the
 *          first focusable element in the dialog will receive focus.
 */
var aria = aria || {};
var tabEvent;

aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
  var _this = this;

  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
  }

  if (typeof focusAfterClosed === 'string') {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }

  if (typeof focusFirst === 'string') {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }

  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }

  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};

aria.Dialog.prototype.addListeners = function () {
  document.addEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.removeListeners = function () {
  document.removeEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.closeDialog = function () {
  var _this2 = this;

  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function () {
      _this2.focusAfterClosed.focus();
    });
  }
};

aria.Dialog.prototype.trapFocus = function (event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};

exports.default = aria.Dialog;

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(978);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(935);
module.exports = __webpack_require__(74).Object.assign;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(134);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(936) });

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__(99);
var getKeys = __webpack_require__(268);
var gOPS = __webpack_require__(586);
var pIE = __webpack_require__(270);
var toObject = __webpack_require__(587);
var IObject = __webpack_require__(679);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(234)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(155);
var toLength = __webpack_require__(680);
var toAbsoluteIndex = __webpack_require__(938);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(582);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(940), __esModule: true };

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(681);
__webpack_require__(686);
module.exports = __webpack_require__(588).f('iterator');

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(582);
var defined = __webpack_require__(581);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(684);
var descriptor = __webpack_require__(267);
var setToStringTag = __webpack_require__(272);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(135)(IteratorPrototype, __webpack_require__(54)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(103);
var anObject = __webpack_require__(104);
var getKeys = __webpack_require__(268);

module.exports = __webpack_require__(99) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(137);
var toObject = __webpack_require__(587);
var IE_PROTO = __webpack_require__(583)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(946);
var step = __webpack_require__(947);
var Iterators = __webpack_require__(237);
var toIObject = __webpack_require__(155);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(682)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(949), __esModule: true };

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(950);
__webpack_require__(688);
__webpack_require__(956);
__webpack_require__(957);
module.exports = __webpack_require__(74).Symbol;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(45);
var has = __webpack_require__(137);
var DESCRIPTORS = __webpack_require__(99);
var $export = __webpack_require__(134);
var redefine = __webpack_require__(683);
var META = __webpack_require__(951).KEY;
var $fails = __webpack_require__(234);
var shared = __webpack_require__(584);
var setToStringTag = __webpack_require__(272);
var uid = __webpack_require__(269);
var wks = __webpack_require__(54);
var wksExt = __webpack_require__(588);
var wksDefine = __webpack_require__(589);
var enumKeys = __webpack_require__(952);
var isArray = __webpack_require__(953);
var anObject = __webpack_require__(104);
var isObject = __webpack_require__(136);
var toObject = __webpack_require__(587);
var toIObject = __webpack_require__(155);
var toPrimitive = __webpack_require__(580);
var createDesc = __webpack_require__(267);
var _create = __webpack_require__(684);
var gOPNExt = __webpack_require__(954);
var $GOPD = __webpack_require__(955);
var $GOPS = __webpack_require__(586);
var $DP = __webpack_require__(103);
var $keys = __webpack_require__(268);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(687).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(270).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(236)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(135)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(269)('meta');
var isObject = __webpack_require__(136);
var has = __webpack_require__(137);
var setDesc = __webpack_require__(103).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(234)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(268);
var gOPS = __webpack_require__(586);
var pIE = __webpack_require__(270);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(235);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(155);
var gOPN = __webpack_require__(687).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(270);
var createDesc = __webpack_require__(267);
var toIObject = __webpack_require__(155);
var toPrimitive = __webpack_require__(580);
var has = __webpack_require__(137);
var IE8_DOM_DEFINE = __webpack_require__(677);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(99) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(589)('asyncIterator');

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(589)('observable');

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(977);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(689);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(46);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(46);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(28);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 87);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/10:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(572);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(98);

    /***/
  },

  /***/22:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(576);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/30:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
    /* harmony import */var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var element_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
    /* harmony import */var element_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_1__);

    /* harmony default export */__webpack_exports__["a"] = {
      bind: function bind(el, binding, vnode) {
        var interval = null;
        var startTime = void 0;
        var maxIntervals = Object(element_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_1__["isMac"])() ? 100 : 200;
        var handler = function handler() {
          return vnode.context[binding.expression].apply();
        };
        var clear = function clear() {
          if (Date.now() - startTime < maxIntervals) {
            handler();
          }
          clearInterval(interval);
          interval = null;
        };

        Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
          if (e.button !== 0) return;
          startTime = Date.now();
          Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
          clearInterval(interval);
          interval = setInterval(handler, maxIntervals);
        });
      }
    };

    /***/
  },

  /***/87:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: ["el-input-number", _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "", { "is-disabled": _vm.inputNumberDisabled }, { "is-without-controls": !_vm.controls }, { "is-controls-right": _vm.controlsAtRight }],
        on: {
          dragstart: function dragstart($event) {
            $event.preventDefault();
          }
        }
      }, [_vm.controls ? _c("span", {
        directives: [{
          name: "repeat-click",
          rawName: "v-repeat-click",
          value: _vm.decrease,
          expression: "decrease"
        }],
        staticClass: "el-input-number__decrease",
        class: { "is-disabled": _vm.minDisabled },
        attrs: { role: "button" },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            return _vm.decrease($event);
          }
        }
      }, [_c("i", {
        class: "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
      })]) : _vm._e(), _vm.controls ? _c("span", {
        directives: [{
          name: "repeat-click",
          rawName: "v-repeat-click",
          value: _vm.increase,
          expression: "increase"
        }],
        staticClass: "el-input-number__increase",
        class: { "is-disabled": _vm.maxDisabled },
        attrs: { role: "button" },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            return _vm.increase($event);
          }
        }
      }, [_c("i", {
        class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
      })]) : _vm._e(), _c("el-input", {
        ref: "input",
        attrs: {
          value: _vm.displayValue,
          placeholder: _vm.placeholder,
          disabled: _vm.inputNumberDisabled,
          size: _vm.inputNumberSize,
          max: _vm.max,
          min: _vm.min,
          name: _vm.name,
          label: _vm.label
        },
        on: {
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          input: _vm.handleInput,
          change: _vm.handleInputChange
        },
        nativeOn: {
          keydown: [function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.preventDefault();
            return _vm.increase($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.preventDefault();
            return _vm.decrease($event);
          }]
        }
      })], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&

    // EXTERNAL MODULE: external "element-ui/lib/input"
    var input_ = __webpack_require__(10);
    var input_default = /*#__PURE__*/__webpack_require__.n(input_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
    var focus_ = __webpack_require__(22);
    var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

    // EXTERNAL MODULE: ./src/directives/repeat-click.js
    var repeat_click = __webpack_require__(30);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var input_numbervue_type_script_lang_js_ = {
      name: 'ElInputNumber',
      mixins: [focus_default()('input')],
      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },
      directives: {
        repeatClick: repeat_click["a" /* default */]
      },
      components: {
        ElInput: input_default.a
      },
      props: {
        step: {
          type: Number,
          default: 1
        },
        stepStrictly: {
          type: Boolean,
          default: false
        },
        max: {
          type: Number,
          default: Infinity
        },
        min: {
          type: Number,
          default: -Infinity
        },
        value: {},
        disabled: Boolean,
        size: String,
        controls: {
          type: Boolean,
          default: true
        },
        controlsPosition: {
          type: String,
          default: ''
        },
        name: String,
        label: String,
        placeholder: String,
        precision: {
          type: Number,
          validator: function validator(val) {
            return val >= 0 && val === parseInt(val, 10);
          }
        }
      },
      data: function data() {
        return {
          currentValue: 0,
          userInput: null
        };
      },

      watch: {
        value: {
          immediate: true,
          handler: function handler(value) {
            var newVal = value === undefined ? value : Number(value);
            if (newVal !== undefined) {
              if (isNaN(newVal)) {
                return;
              }

              if (this.stepStrictly) {
                var stepPrecision = this.getPrecision(this.step);
                var precisionFactor = Math.pow(10, stepPrecision);
                newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
              }

              if (this.precision !== undefined) {
                newVal = this.toPrecision(newVal, this.precision);
              }
            }
            if (newVal >= this.max) newVal = this.max;
            if (newVal <= this.min) newVal = this.min;
            this.currentValue = newVal;
            this.userInput = null;
            this.$emit('input', newVal);
          }
        }
      },
      computed: {
        minDisabled: function minDisabled() {
          return this._decrease(this.value, this.step) < this.min;
        },
        maxDisabled: function maxDisabled() {
          return this._increase(this.value, this.step) > this.max;
        },
        numPrecision: function numPrecision() {
          var value = this.value,
              step = this.step,
              getPrecision = this.getPrecision,
              precision = this.precision;

          var stepPrecision = getPrecision(step);
          if (precision !== undefined) {
            if (stepPrecision > precision) {
              console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
            }
            return precision;
          } else {
            return Math.max(getPrecision(value), stepPrecision);
          }
        },
        controlsAtRight: function controlsAtRight() {
          return this.controls && this.controlsPosition === 'right';
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        inputNumberSize: function inputNumberSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        inputNumberDisabled: function inputNumberDisabled() {
          return this.disabled || !!(this.elForm || {}).disabled;
        },
        displayValue: function displayValue() {
          if (this.userInput !== null) {
            return this.userInput;
          }

          var currentValue = this.currentValue;

          if (typeof currentValue === 'number') {
            if (this.stepStrictly) {
              var stepPrecision = this.getPrecision(this.step);
              var precisionFactor = Math.pow(10, stepPrecision);
              currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
            }

            if (this.precision !== undefined) {
              currentValue = currentValue.toFixed(this.precision);
            }
          }

          return currentValue;
        }
      },
      methods: {
        toPrecision: function toPrecision(num, precision) {
          if (precision === undefined) precision = this.numPrecision;
          return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
        },
        getPrecision: function getPrecision(value) {
          if (value === undefined) return 0;
          var valueString = value.toString();
          var dotPosition = valueString.indexOf('.');
          var precision = 0;
          if (dotPosition !== -1) {
            precision = valueString.length - dotPosition - 1;
          }
          return precision;
        },
        _increase: function _increase(val, step) {
          if (typeof val !== 'number' && val !== undefined) return this.currentValue;

          var precisionFactor = Math.pow(10, this.numPrecision);
          // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
          return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
        },
        _decrease: function _decrease(val, step) {
          if (typeof val !== 'number' && val !== undefined) return this.currentValue;

          var precisionFactor = Math.pow(10, this.numPrecision);

          return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
        },
        increase: function increase() {
          if (this.inputNumberDisabled || this.maxDisabled) return;
          var value = this.value || 0;
          var newVal = this._increase(value, this.step);
          this.setCurrentValue(newVal);
        },
        decrease: function decrease() {
          if (this.inputNumberDisabled || this.minDisabled) return;
          var value = this.value || 0;
          var newVal = this._decrease(value, this.step);
          this.setCurrentValue(newVal);
        },
        handleBlur: function handleBlur(event) {
          this.$emit('blur', event);
        },
        handleFocus: function handleFocus(event) {
          this.$emit('focus', event);
        },
        setCurrentValue: function setCurrentValue(newVal) {
          var oldVal = this.currentValue;
          if (typeof newVal === 'number' && this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
          if (newVal >= this.max) newVal = this.max;
          if (newVal <= this.min) newVal = this.min;
          if (oldVal === newVal) return;
          this.userInput = null;
          this.$emit('input', newVal);
          this.$emit('change', newVal, oldVal);
          this.currentValue = newVal;
        },
        handleInput: function handleInput(value) {
          this.userInput = value;
        },
        handleInputChange: function handleInputChange(value) {
          var newVal = value === '' ? undefined : Number(value);
          if (!isNaN(newVal) || value === '') {
            this.setCurrentValue(newVal);
          }
          this.userInput = null;
        },
        select: function select() {
          this.$refs.input.select();
        }
      },
      mounted: function mounted() {
        var innerInput = this.$refs.input.$refs.input;
        innerInput.setAttribute('role', 'spinbutton');
        innerInput.setAttribute('aria-valuemax', this.max);
        innerInput.setAttribute('aria-valuemin', this.min);
        innerInput.setAttribute('aria-valuenow', this.currentValue);
        innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
      },
      updated: function updated() {
        if (!this.$refs || !this.$refs.input) return;
        var innerInput = this.$refs.input.$refs.input;
        innerInput.setAttribute('aria-valuenow', this.currentValue);
      }
    };
    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
    /* harmony default export */var src_input_numbervue_type_script_lang_js_ = input_numbervue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_input_numbervue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/input-number/src/input-number.vue";
    /* harmony default export */var input_number = component.exports;
    // CONCATENATED MODULE: ./packages/input-number/index.js


    /* istanbul ignore next */
    input_number.install = function (Vue) {
      Vue.component(input_number.name, input_number);
    };

    /* harmony default export */var packages_input_number = __webpack_exports__["default"] = input_number;

    /***/
  }

  /******/ });

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 61);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/15:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(575);

    /***/
  },

  /***/18:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(670);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(263);

    /***/
  },

  /***/26:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(672);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/31:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(577);

    /***/
  },

  /***/41:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(578);

    /***/
  },

  /***/52:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(690);

    /***/
  },

  /***/6:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(570);

    /***/
  },

  /***/61:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
    var cascader_panelvue_type_template_id_34932346_render = function cascader_panelvue_type_template_id_34932346_render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: ["el-cascader-panel", _vm.border && "is-bordered"],
        on: { keydown: _vm.handleKeyDown }
      }, _vm._l(_vm.menus, function (menu, index) {
        return _c("cascader-menu", {
          key: index,
          ref: "menu",
          refInFor: true,
          attrs: { index: index, nodes: menu }
        });
      }), 1);
    };
    var staticRenderFns = [];
    cascader_panelvue_type_template_id_34932346_render._withStripped = true;

    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&

    // EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
    var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
    var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

    // EXTERNAL MODULE: external "element-ui/lib/scrollbar"
    var scrollbar_ = __webpack_require__(15);
    var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

    // EXTERNAL MODULE: external "element-ui/lib/checkbox"
    var checkbox_ = __webpack_require__(18);
    var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

    // EXTERNAL MODULE: external "element-ui/lib/radio"
    var radio_ = __webpack_require__(52);
    var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&


    var stopPropagation = function stopPropagation(e) {
      return e.stopPropagation();
    };

    /* harmony default export */var cascader_nodevue_type_script_lang_js_ = {
      inject: ['panel'],

      components: {
        ElCheckbox: checkbox_default.a,
        ElRadio: radio_default.a
      },

      props: {
        node: {
          required: true
        },
        nodeId: String
      },

      computed: {
        config: function config() {
          return this.panel.config;
        },
        isLeaf: function isLeaf() {
          return this.node.isLeaf;
        },
        isDisabled: function isDisabled() {
          return this.node.isDisabled;
        },
        checkedValue: function checkedValue() {
          return this.panel.checkedValue;
        },
        isChecked: function isChecked() {
          return this.node.isSameNode(this.checkedValue);
        },
        inActivePath: function inActivePath() {
          return this.isInPath(this.panel.activePath);
        },
        inCheckedPath: function inCheckedPath() {
          var _this = this;

          if (!this.config.checkStrictly) return false;

          return this.panel.checkedNodePaths.some(function (checkedPath) {
            return _this.isInPath(checkedPath);
          });
        },
        value: function value() {
          return this.node.getValueByOption();
        }
      },

      methods: {
        handleExpand: function handleExpand() {
          var _this2 = this;

          var panel = this.panel,
              node = this.node,
              isDisabled = this.isDisabled,
              config = this.config;
          var multiple = config.multiple,
              checkStrictly = config.checkStrictly;

          if (!checkStrictly && isDisabled || node.loading) return;

          if (config.lazy && !node.loaded) {
            panel.lazyLoad(node, function () {
              // do not use cached leaf value here, invoke this.isLeaf to get new value.
              var isLeaf = _this2.isLeaf;

              if (!isLeaf) _this2.handleExpand();
              if (multiple) {
                // if leaf sync checked state, else clear checked state
                var checked = isLeaf ? node.checked : false;
                _this2.handleMultiCheckChange(checked);
              }
            });
          } else {
            panel.handleExpand(node);
          }
        },
        handleCheckChange: function handleCheckChange() {
          var panel = this.panel,
              value = this.value,
              node = this.node;

          panel.handleCheckChange(value);
          panel.handleExpand(node);
        },
        handleMultiCheckChange: function handleMultiCheckChange(checked) {
          this.node.doCheck(checked);
          this.panel.calculateMultiCheckedValue();
        },
        isInPath: function isInPath(pathNodes) {
          var node = this.node;

          var selectedPathNode = pathNodes[node.level - 1] || {};
          return selectedPathNode.uid === node.uid;
        },
        renderPrefix: function renderPrefix(h) {
          var isLeaf = this.isLeaf,
              isChecked = this.isChecked,
              config = this.config;
          var checkStrictly = config.checkStrictly,
              multiple = config.multiple;

          if (multiple) {
            return this.renderCheckbox(h);
          } else if (checkStrictly) {
            return this.renderRadio(h);
          } else if (isLeaf && isChecked) {
            return this.renderCheckIcon(h);
          }

          return null;
        },
        renderPostfix: function renderPostfix(h) {
          var node = this.node,
              isLeaf = this.isLeaf;

          if (node.loading) {
            return this.renderLoadingIcon(h);
          } else if (!isLeaf) {
            return this.renderExpandIcon(h);
          }

          return null;
        },
        renderCheckbox: function renderCheckbox(h) {
          var node = this.node,
              config = this.config,
              isDisabled = this.isDisabled;

          var events = {
            on: { change: this.handleMultiCheckChange },
            nativeOn: {}
          };

          if (config.checkStrictly) {
            // when every node is selectable, click event should not trigger expand event.
            events.nativeOn.click = stopPropagation;
          }

          return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              value: node.checked,
              indeterminate: node.indeterminate,
              disabled: isDisabled
            }
          }, events]));
        },
        renderRadio: function renderRadio(h) {
          var checkedValue = this.checkedValue,
              value = this.value,
              isDisabled = this.isDisabled;

          // to keep same reference if value cause radio's checked state is calculated by reference comparision;

          if (Object(util_["isEqual"])(value, checkedValue)) {
            value = checkedValue;
          }

          return h('el-radio', {
            attrs: {
              value: checkedValue,
              label: value,
              disabled: isDisabled
            },
            on: {
              'change': this.handleCheckChange
            },
            nativeOn: {
              'click': stopPropagation
            }
          }, [h('span')]);
        },
        renderCheckIcon: function renderCheckIcon(h) {
          return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
        },
        renderLoadingIcon: function renderLoadingIcon(h) {
          return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
        },
        renderExpandIcon: function renderExpandIcon(h) {
          return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
        },
        renderContent: function renderContent(h) {
          var panel = this.panel,
              node = this.node;

          var render = panel.renderLabelFn;
          var vnode = render ? render({ node: node, data: node.data }) : null;

          return h('span', { 'class': 'el-cascader-node__label' }, [vnode || node.label]);
        }
      },

      render: function render(h) {
        var _this3 = this;

        var inActivePath = this.inActivePath,
            inCheckedPath = this.inCheckedPath,
            isChecked = this.isChecked,
            isLeaf = this.isLeaf,
            isDisabled = this.isDisabled,
            config = this.config,
            nodeId = this.nodeId;
        var expandTrigger = config.expandTrigger,
            checkStrictly = config.checkStrictly,
            multiple = config.multiple;

        var disabled = !checkStrictly && isDisabled;
        var events = { on: {} };

        if (expandTrigger === 'click') {
          events.on.click = this.handleExpand;
        } else {
          events.on.mouseenter = function (e) {
            _this3.handleExpand();
            _this3.$emit('expand', e);
          };
          events.on.focus = function (e) {
            _this3.handleExpand();
            _this3.$emit('expand', e);
          };
        }
        if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
          events.on.click = this.handleCheckChange;
        }

        return h('li', external_babel_helper_vue_jsx_merge_props_default()([{
          attrs: {
            role: 'menuitem',
            id: nodeId,
            'aria-expanded': inActivePath,
            tabindex: disabled ? null : -1
          },
          'class': {
            'el-cascader-node': true,
            'is-selectable': checkStrictly,
            'in-active-path': inActivePath,
            'in-checked-path': inCheckedPath,
            'is-active': isChecked,
            'is-disabled': disabled
          }
        }, events]), [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]);
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_nodevue_type_script_lang_js_ = cascader_nodevue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
    var cascader_node_render, cascader_node_staticRenderFns;

    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_cascader_nodevue_type_script_lang_js_, cascader_node_render, cascader_node_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/cascader-panel/src/cascader-node.vue";
    /* harmony default export */var cascader_node = component.exports;
    // EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
    var locale_ = __webpack_require__(6);
    var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&


    /* harmony default export */var cascader_menuvue_type_script_lang_js_ = {
      name: 'ElCascaderMenu',

      mixins: [locale_default.a],

      inject: ['panel'],

      components: {
        ElScrollbar: scrollbar_default.a,
        CascaderNode: cascader_node
      },

      props: {
        nodes: {
          type: Array,
          required: true
        },
        index: Number
      },

      data: function data() {
        return {
          activeNode: null,
          hoverTimer: null,
          id: Object(util_["generateId"])()
        };
      },

      computed: {
        isEmpty: function isEmpty() {
          return !this.nodes.length;
        },
        menuId: function menuId() {
          return 'cascader-menu-' + this.id + '-' + this.index;
        }
      },

      methods: {
        handleExpand: function handleExpand(e) {
          this.activeNode = e.target;
        },
        handleMouseMove: function handleMouseMove(e) {
          var activeNode = this.activeNode,
              hoverTimer = this.hoverTimer;
          var hoverZone = this.$refs.hoverZone;

          if (!activeNode || !hoverZone) return;

          if (activeNode.contains(e.target)) {
            clearTimeout(hoverTimer);

            var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
                left = _$el$getBoundingClien.left;

            var startX = e.clientX - left;
            var _$el = this.$el,
                offsetWidth = _$el.offsetWidth,
                offsetHeight = _$el.offsetHeight;

            var top = activeNode.offsetTop;
            var bottom = top + activeNode.offsetHeight;

            hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
          } else if (!hoverTimer) {
            this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
          }
        },
        clearHoverZone: function clearHoverZone() {
          var hoverZone = this.$refs.hoverZone;

          if (!hoverZone) return;
          hoverZone.innerHTML = '';
        },
        renderEmptyText: function renderEmptyText(h) {
          return h('div', { 'class': 'el-cascader-menu__empty-text' }, [this.t('el.cascader.noData')]);
        },
        renderNodeList: function renderNodeList(h) {
          var menuId = this.menuId;
          var isHoverMenu = this.panel.isHoverMenu;

          var events = { on: {} };

          if (isHoverMenu) {
            events.on.expand = this.handleExpand;
          }

          var nodes = this.nodes.map(function (node, index) {
            var hasChildren = node.hasChildren;

            return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
              key: node.uid,
              attrs: { node: node,
                'node-id': menuId + '-' + index,
                'aria-haspopup': hasChildren,
                'aria-owns': hasChildren ? menuId : null
              }
            }, events]));
          });

          return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
        }
      },

      render: function render(h) {
        var isEmpty = this.isEmpty,
            menuId = this.menuId;

        var events = { nativeOn: {} };

        // optimize hover to expand experience (#8010)
        if (this.panel.isHoverMenu) {
          events.nativeOn.mousemove = this.handleMouseMove;
          // events.nativeOn.mouseleave = this.clearHoverZone;
        }

        return h('el-scrollbar', external_babel_helper_vue_jsx_merge_props_default()([{
          attrs: {
            tag: 'ul',
            role: 'menu',
            id: menuId,

            'wrap-class': 'el-cascader-menu__wrap',
            'view-class': {
              'el-cascader-menu__list': true,
              'is-empty': isEmpty
            }
          },
          'class': 'el-cascader-menu' }, events]), [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]);
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_menuvue_type_script_lang_js_ = cascader_menuvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
    var cascader_menu_render, cascader_menu_staticRenderFns;

    /* normalize component */

    var cascader_menu_component = Object(componentNormalizer["a" /* default */])(src_cascader_menuvue_type_script_lang_js_, cascader_menu_render, cascader_menu_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var cascader_menu_api;
    }
    cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue";
    /* harmony default export */var cascader_menu = cascader_menu_component.exports;
    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
      }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
      };
    }();

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var uid = 0;

    var node_Node = function () {
      function Node(data, config, parentNode) {
        _classCallCheck(this, Node);

        this.data = data;
        this.config = config;
        this.parent = parentNode || null;
        this.level = !this.parent ? 1 : this.parent.level + 1;
        this.uid = uid++;

        this.initState();
        this.initChildren();
      }

      Node.prototype.initState = function initState() {
        var _config = this.config,
            valueKey = _config.value,
            labelKey = _config.label;

        this.value = this.data[valueKey];
        this.label = this.data[labelKey];
        this.pathNodes = this.calculatePathNodes();
        this.path = this.pathNodes.map(function (node) {
          return node.value;
        });
        this.pathLabels = this.pathNodes.map(function (node) {
          return node.label;
        });

        // lazy load
        this.loading = false;
        this.loaded = false;
      };

      Node.prototype.initChildren = function initChildren() {
        var _this = this;

        var config = this.config;

        var childrenKey = config.children;
        var childrenData = this.data[childrenKey];
        this.hasChildren = Array.isArray(childrenData);
        this.children = (childrenData || []).map(function (child) {
          return new Node(child, config, _this);
        });
      };

      Node.prototype.calculatePathNodes = function calculatePathNodes() {
        var nodes = [this];
        var parent = this.parent;

        while (parent) {
          nodes.unshift(parent);
          parent = parent.parent;
        }

        return nodes;
      };

      Node.prototype.getPath = function getPath() {
        return this.path;
      };

      Node.prototype.getValue = function getValue() {
        return this.value;
      };

      Node.prototype.getValueByOption = function getValueByOption() {
        return this.config.emitPath ? this.getPath() : this.getValue();
      };

      Node.prototype.getText = function getText(allLevels, separator) {
        return allLevels ? this.pathLabels.join(separator) : this.label;
      };

      Node.prototype.isSameNode = function isSameNode(checkedValue) {
        var value = this.getValueByOption();
        return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
          return Object(util_["isEqual"])(val, value);
        }) : Object(util_["isEqual"])(checkedValue, value);
      };

      Node.prototype.broadcast = function broadcast(event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var handlerName = 'onParent' + Object(util_["capitalize"])(event);

        this.children.forEach(function (child) {
          if (child) {
            // bottom up
            child.broadcast.apply(child, [event].concat(args));
            child[handlerName] && child[handlerName].apply(child, args);
          }
        });
      };

      Node.prototype.emit = function emit(event) {
        var parent = this.parent;

        var handlerName = 'onChild' + Object(util_["capitalize"])(event);
        if (parent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          parent[handlerName] && parent[handlerName].apply(parent, args);
          parent.emit.apply(parent, [event].concat(args));
        }
      };

      Node.prototype.onParentCheck = function onParentCheck(checked) {
        if (!this.isDisabled) {
          this.setCheckState(checked);
        }
      };

      Node.prototype.onChildCheck = function onChildCheck() {
        var children = this.children;

        var validChildren = children.filter(function (child) {
          return !child.isDisabled;
        });
        var checked = validChildren.length ? validChildren.every(function (child) {
          return child.checked;
        }) : false;

        this.setCheckState(checked);
      };

      Node.prototype.setCheckState = function setCheckState(checked) {
        var totalNum = this.children.length;
        var checkedNum = this.children.reduce(function (c, p) {
          var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
          return c + num;
        }, 0);

        this.checked = checked;
        this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
      };

      Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
        var value = this.getValueByOption();
        var checked = this.isSameNode(checkedValue, value);

        this.doCheck(checked);
      };

      Node.prototype.doCheck = function doCheck(checked) {
        if (this.checked !== checked) {
          if (this.config.checkStrictly) {
            this.checked = checked;
          } else {
            // bottom up to unify the calculation of the indeterminate state
            this.broadcast('check', checked);
            this.setCheckState(checked);
            this.emit('check');
          }
        }
      };

      _createClass(Node, [{
        key: 'isDisabled',
        get: function get() {
          var data = this.data,
              parent = this.parent,
              config = this.config;

          var disabledKey = config.disabled;
          var checkStrictly = config.checkStrictly;

          return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
        }
      }, {
        key: 'isLeaf',
        get: function get() {
          var data = this.data,
              loaded = this.loaded,
              hasChildren = this.hasChildren,
              children = this.children;
          var _config2 = this.config,
              lazy = _config2.lazy,
              leafKey = _config2.leaf;

          if (lazy) {
            var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
            this.hasChildren = !isLeaf;
            return isLeaf;
          }
          return !hasChildren;
        }
      }]);

      return Node;
    }();

    /* harmony default export */var src_node = node_Node;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
    function store_classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var flatNodes = function flatNodes(data, leafOnly) {
      return data.reduce(function (res, node) {
        if (node.isLeaf) {
          res.push(node);
        } else {
          !leafOnly && res.push(node);
          res = res.concat(flatNodes(node.children, leafOnly));
        }
        return res;
      }, []);
    };

    var store_Store = function () {
      function Store(data, config) {
        store_classCallCheck(this, Store);

        this.config = config;
        this.initNodes(data);
      }

      Store.prototype.initNodes = function initNodes(data) {
        var _this = this;

        data = Object(util_["coerceTruthyValueToArray"])(data);
        this.nodes = data.map(function (nodeData) {
          return new src_node(nodeData, _this.config);
        });
        this.flattedNodes = this.getFlattedNodes(false, false);
        this.leafNodes = this.getFlattedNodes(true, false);
      };

      Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
        var node = new src_node(nodeData, this.config, parentNode);
        var children = parentNode ? parentNode.children : this.nodes;

        children.push(node);
      };

      Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
        var _this2 = this;

        nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
        nodeDataList.forEach(function (nodeData) {
          return _this2.appendNode(nodeData, parentNode);
        });
      };

      Store.prototype.getNodes = function getNodes() {
        return this.nodes;
      };

      Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
        var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
        return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
      };

      Store.prototype.getNodeByValue = function getNodeByValue(value) {
        var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
          return Object(util_["valueEquals"])(node.path, value) || node.value === value;
        });
        return nodes && nodes.length ? nodes[0] : null;
      };

      return Store;
    }();

    /* harmony default export */var src_store = store_Store;
    // EXTERNAL MODULE: external "element-ui/lib/utils/merge"
    var merge_ = __webpack_require__(9);
    var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
    var aria_utils_ = __webpack_require__(41);
    var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
    var scroll_into_view_ = __webpack_require__(31);
    var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }return target;
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    var KeyCode = aria_utils_default.a.keys;

    var DefaultProps = {
      expandTrigger: 'click', // or hover
      multiple: false,
      checkStrictly: false, // whether all nodes can be selected
      emitPath: true, // wether to emit an array of all levels value in which node is located
      lazy: false,
      lazyLoad: util_["noop"],
      value: 'value',
      label: 'label',
      children: 'children',
      leaf: 'leaf',
      disabled: 'disabled',
      hoverThreshold: 500
    };

    var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
      return !el.getAttribute('aria-owns');
    };

    var getSibling = function getSibling(el, distance) {
      var parentNode = el.parentNode;

      if (parentNode) {
        var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
        var index = Array.prototype.indexOf.call(siblings, el);
        return siblings[index + distance] || null;
      }
      return null;
    };

    var getMenuIndex = function getMenuIndex(el, distance) {
      if (!el) return;
      var pieces = el.id.split('-');
      return Number(pieces[pieces.length - 2]);
    };

    var focusNode = function focusNode(el) {
      if (!el) return;
      el.focus();
      !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
    };

    var checkNode = function checkNode(el) {
      if (!el) return;

      var input = el.querySelector('input');
      if (input) {
        input.click();
      } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
        el.click();
      }
    };

    /* harmony default export */var cascader_panelvue_type_script_lang_js_ = {
      name: 'ElCascaderPanel',

      components: {
        CascaderMenu: cascader_menu
      },

      props: {
        value: {},
        options: Array,
        props: Object,
        border: {
          type: Boolean,
          default: true
        },
        renderLabel: Function
      },

      provide: function provide() {
        return {
          panel: this
        };
      },
      data: function data() {
        return {
          checkedValue: null,
          checkedNodePaths: [],
          store: [],
          menus: [],
          activePath: [],
          loadCount: 0
        };
      },

      computed: {
        config: function config() {
          return merge_default()(_extends({}, DefaultProps), this.props || {});
        },
        multiple: function multiple() {
          return this.config.multiple;
        },
        checkStrictly: function checkStrictly() {
          return this.config.checkStrictly;
        },
        leafOnly: function leafOnly() {
          return !this.checkStrictly;
        },
        isHoverMenu: function isHoverMenu() {
          return this.config.expandTrigger === 'hover';
        },
        renderLabelFn: function renderLabelFn() {
          return this.renderLabel || this.$scopedSlots.default;
        }
      },

      watch: {
        value: function value() {
          this.syncCheckedValue();
          this.checkStrictly && this.calculateCheckedNodePaths();
        },

        options: {
          handler: function handler() {
            this.initStore();
          },
          immediate: true,
          deep: true
        },
        checkedValue: function checkedValue(val) {
          if (!Object(util_["isEqual"])(val, this.value)) {
            this.checkStrictly && this.calculateCheckedNodePaths();
            this.$emit('input', val);
            this.$emit('change', val);
          }
        }
      },

      mounted: function mounted() {
        if (!this.isEmptyValue(this.value)) {
          this.syncCheckedValue();
        }
      },

      methods: {
        initStore: function initStore() {
          var config = this.config,
              options = this.options;

          if (config.lazy && Object(util_["isEmpty"])(options)) {
            this.lazyLoad();
          } else {
            this.store = new src_store(options, config);
            this.menus = [this.store.getNodes()];
            this.syncMenuState();
          }
        },
        syncCheckedValue: function syncCheckedValue() {
          var value = this.value,
              checkedValue = this.checkedValue;

          if (!Object(util_["isEqual"])(value, checkedValue)) {
            this.activePath = [];
            this.checkedValue = value;
            this.syncMenuState();
          }
        },
        syncMenuState: function syncMenuState() {
          var multiple = this.multiple,
              checkStrictly = this.checkStrictly;

          this.syncActivePath();
          multiple && this.syncMultiCheckState();
          checkStrictly && this.calculateCheckedNodePaths();
          this.$nextTick(this.scrollIntoView);
        },
        syncMultiCheckState: function syncMultiCheckState() {
          var _this = this;

          var nodes = this.getFlattedNodes(this.leafOnly);

          nodes.forEach(function (node) {
            node.syncCheckState(_this.checkedValue);
          });
        },
        isEmptyValue: function isEmptyValue(val) {
          var multiple = this.multiple,
              config = this.config;
          var emitPath = config.emitPath;

          if (multiple || emitPath) {
            return Object(util_["isEmpty"])(val);
          }
          return false;
        },
        syncActivePath: function syncActivePath() {
          var _this2 = this;

          var store = this.store,
              multiple = this.multiple,
              activePath = this.activePath,
              checkedValue = this.checkedValue;

          if (!Object(util_["isEmpty"])(activePath)) {
            var nodes = activePath.map(function (node) {
              return _this2.getNodeByValue(node.getValue());
            });
            this.expandNodes(nodes);
          } else if (!this.isEmptyValue(checkedValue)) {
            var value = multiple ? checkedValue[0] : checkedValue;
            var checkedNode = this.getNodeByValue(value) || {};
            var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
            this.expandNodes(_nodes);
          } else {
            this.activePath = [];
            this.menus = [store.getNodes()];
          }
        },
        expandNodes: function expandNodes(nodes) {
          var _this3 = this;

          nodes.forEach(function (node) {
            return _this3.handleExpand(node, true /* silent */);
          });
        },
        calculateCheckedNodePaths: function calculateCheckedNodePaths() {
          var _this4 = this;

          var checkedValue = this.checkedValue,
              multiple = this.multiple;

          var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
          this.checkedNodePaths = checkedValues.map(function (v) {
            var checkedNode = _this4.getNodeByValue(v);
            return checkedNode ? checkedNode.pathNodes : [];
          });
        },
        handleKeyDown: function handleKeyDown(e) {
          var target = e.target,
              keyCode = e.keyCode;

          switch (keyCode) {
            case KeyCode.up:
              var prev = getSibling(target, -1);
              focusNode(prev);
              break;
            case KeyCode.down:
              var next = getSibling(target, 1);
              focusNode(next);
              break;
            case KeyCode.left:
              var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
              if (preMenu) {
                var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
                focusNode(expandedNode);
              }
              break;
            case KeyCode.right:
              var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
              if (nextMenu) {
                var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
                focusNode(firstNode);
              }
              break;
            case KeyCode.enter:
              checkNode(target);
              break;
            case KeyCode.esc:
            case KeyCode.tab:
              this.$emit('close');
              break;
            default:
              return;
          }
        },
        handleExpand: function handleExpand(node, silent) {
          var activePath = this.activePath;
          var level = node.level;

          var path = activePath.slice(0, level - 1);
          var menus = this.menus.slice(0, level);

          if (!node.isLeaf) {
            path.push(node);
            menus.push(node.children);
          }

          this.activePath = path;
          this.menus = menus;

          if (!silent) {
            var pathValues = path.map(function (node) {
              return node.getValue();
            });
            var activePathValues = activePath.map(function (node) {
              return node.getValue();
            });
            if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
              this.$emit('active-item-change', pathValues); // Deprecated
              this.$emit('expand-change', pathValues);
            }
          }
        },
        handleCheckChange: function handleCheckChange(value) {
          this.checkedValue = value;
        },
        lazyLoad: function lazyLoad(node, onFullfiled) {
          var _this5 = this;

          var config = this.config;

          if (!node) {
            node = node || { root: true, level: 0 };
            this.store = new src_store([], config);
            this.menus = [this.store.getNodes()];
          }
          node.loading = true;
          var resolve = function resolve(dataList) {
            var parent = node.root ? null : node;
            dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
            node.loading = false;
            node.loaded = true;

            // dispose default value on lazy load mode
            if (Array.isArray(_this5.checkedValue)) {
              var nodeValue = _this5.checkedValue[_this5.loadCount++];
              var valueKey = _this5.config.value;
              var leafKey = _this5.config.leaf;

              if (Array.isArray(dataList) && dataList.filter(function (item) {
                return item[valueKey] === nodeValue;
              }).length > 0) {
                var checkedNode = _this5.store.getNodeByValue(nodeValue);

                if (!checkedNode.data[leafKey]) {
                  _this5.lazyLoad(checkedNode, function () {
                    _this5.handleExpand(checkedNode);
                  });
                }

                if (_this5.loadCount === _this5.checkedValue.length) {
                  _this5.$parent.computePresentText();
                }
              }
            }

            onFullfiled && onFullfiled(dataList);
          };
          config.lazyLoad(node, resolve);
        },

        /**
         * public methods
        */
        calculateMultiCheckedValue: function calculateMultiCheckedValue() {
          this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
            return node.getValueByOption();
          });
        },
        scrollIntoView: function scrollIntoView() {
          if (this.$isServer) return;

          var menus = this.$refs.menu || [];
          menus.forEach(function (menu) {
            var menuElement = menu.$el;
            if (menuElement) {
              var container = menuElement.querySelector('.el-scrollbar__wrap');
              var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
              scroll_into_view_default()(container, activeNode);
            }
          });
        },
        getNodeByValue: function getNodeByValue(val) {
          return this.store.getNodeByValue(val);
        },
        getFlattedNodes: function getFlattedNodes(leafOnly) {
          var cached = !this.config.lazy;
          return this.store.getFlattedNodes(leafOnly, cached);
        },
        getCheckedNodes: function getCheckedNodes(leafOnly) {
          var checkedValue = this.checkedValue,
              multiple = this.multiple;

          if (multiple) {
            var nodes = this.getFlattedNodes(leafOnly);
            return nodes.filter(function (node) {
              return node.checked;
            });
          } else {
            return this.isEmptyValue(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
          }
        },
        clearCheckedNodes: function clearCheckedNodes() {
          var config = this.config,
              leafOnly = this.leafOnly;
          var multiple = config.multiple,
              emitPath = config.emitPath;

          if (multiple) {
            this.getCheckedNodes(leafOnly).filter(function (node) {
              return !node.isDisabled;
            }).forEach(function (node) {
              return node.doCheck(false);
            });
            this.calculateMultiCheckedValue();
          } else {
            this.checkedValue = emitPath ? [] : null;
          }
        }
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_panelvue_type_script_lang_js_ = cascader_panelvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue


    /* normalize component */

    var cascader_panel_component = Object(componentNormalizer["a" /* default */])(src_cascader_panelvue_type_script_lang_js_, cascader_panelvue_type_template_id_34932346_render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var cascader_panel_api;
    }
    cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue";
    /* harmony default export */var cascader_panel = cascader_panel_component.exports;
    // CONCATENATED MODULE: ./packages/cascader-panel/index.js


    /* istanbul ignore next */
    cascader_panel.install = function (Vue) {
      Vue.component(cascader_panel.name, cascader_panel);
    };

    /* harmony default export */var packages_cascader_panel = __webpack_exports__["default"] = cascader_panel;

    /***/
  },

  /***/9:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(262);

    /***/
  }

  /******/ });

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 78);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(98);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(73);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(261);

    /***/
  },

  /***/7:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(32);

    /***/
  },

  /***/78:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("span", [_c("transition", {
        attrs: { name: _vm.transition },
        on: {
          "after-enter": _vm.handleAfterEnter,
          "after-leave": _vm.handleAfterLeave
        }
      }, [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.disabled && _vm.showPopper,
          expression: "!disabled && showPopper"
        }],
        ref: "popper",
        staticClass: "el-popover el-popper",
        class: [_vm.popperClass, _vm.content && "el-popover--plain"],
        style: { width: _vm.width + "px" },
        attrs: {
          role: "tooltip",
          id: _vm.tooltipId,
          "aria-hidden": _vm.disabled || !_vm.showPopper ? "true" : "false"
        }
      }, [_vm.title ? _c("div", {
        staticClass: "el-popover__title",
        domProps: { textContent: _vm._s(_vm.title) }
      }) : _vm._e(), _vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2)]), _c("span", { ref: "wrapper", staticClass: "el-popover__reference-wrapper" }, [_vm._t("reference")], 2)], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var mainvue_type_script_lang_js_ = {
      name: 'ElPopover',

      mixins: [vue_popper_default.a],

      props: {
        trigger: {
          type: String,
          default: 'click',
          validator: function validator(value) {
            return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
          }
        },
        openDelay: {
          type: Number,
          default: 0
        },
        closeDelay: {
          type: Number,
          default: 200
        },
        title: String,
        disabled: Boolean,
        content: String,
        reference: {},
        popperClass: String,
        width: {},
        visibleArrow: {
          default: true
        },
        arrowOffset: {
          type: Number,
          default: 0
        },
        transition: {
          type: String,
          default: 'fade-in-linear'
        },
        tabindex: {
          type: Number,
          default: 0
        }
      },

      computed: {
        tooltipId: function tooltipId() {
          return 'el-popover-' + Object(util_["generateId"])();
        }
      },
      watch: {
        showPopper: function showPopper(val) {
          if (this.disabled) {
            return;
          }
          val ? this.$emit('show') : this.$emit('hide');
        }
      },

      mounted: function mounted() {
        var _this = this;

        var reference = this.referenceElm = this.reference || this.$refs.reference;
        var popper = this.popper || this.$refs.popper;

        if (!reference && this.$refs.wrapper.children) {
          reference = this.referenceElm = this.$refs.wrapper.children[0];
        }
        // 可访问性
        if (reference) {
          Object(dom_["addClass"])(reference, 'el-popover__reference');
          reference.setAttribute('aria-describedby', this.tooltipId);
          reference.setAttribute('tabindex', this.tabindex); // tab序列
          popper.setAttribute('tabindex', 0);

          if (this.trigger !== 'click') {
            Object(dom_["on"])(reference, 'focusin', function () {
              _this.handleFocus();
              var instance = reference.__vue__;
              if (instance && typeof instance.focus === 'function') {
                instance.focus();
              }
            });
            Object(dom_["on"])(popper, 'focusin', this.handleFocus);
            Object(dom_["on"])(reference, 'focusout', this.handleBlur);
            Object(dom_["on"])(popper, 'focusout', this.handleBlur);
          }
          Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
          Object(dom_["on"])(reference, 'click', this.handleClick);
        }
        if (this.trigger === 'click') {
          Object(dom_["on"])(reference, 'click', this.doToggle);
          Object(dom_["on"])(document, 'click', this.handleDocumentClick);
        } else if (this.trigger === 'hover') {
          Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
          Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
          Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
          Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
        } else if (this.trigger === 'focus') {
          if (this.tabindex < 0) {
            console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
          }
          if (reference.querySelector('input, textarea')) {
            Object(dom_["on"])(reference, 'focusin', this.doShow);
            Object(dom_["on"])(reference, 'focusout', this.doClose);
          } else {
            Object(dom_["on"])(reference, 'mousedown', this.doShow);
            Object(dom_["on"])(reference, 'mouseup', this.doClose);
          }
        }
      },
      beforeDestroy: function beforeDestroy() {
        this.cleanup();
      },
      deactivated: function deactivated() {
        this.cleanup();
      },

      methods: {
        doToggle: function doToggle() {
          this.showPopper = !this.showPopper;
        },
        doShow: function doShow() {
          this.showPopper = true;
        },
        doClose: function doClose() {
          this.showPopper = false;
        },
        handleFocus: function handleFocus() {
          Object(dom_["addClass"])(this.referenceElm, 'focusing');
          if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
        },
        handleClick: function handleClick() {
          Object(dom_["removeClass"])(this.referenceElm, 'focusing');
        },
        handleBlur: function handleBlur() {
          Object(dom_["removeClass"])(this.referenceElm, 'focusing');
          if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
        },
        handleMouseEnter: function handleMouseEnter() {
          var _this2 = this;

          clearTimeout(this._timer);
          if (this.openDelay) {
            this._timer = setTimeout(function () {
              _this2.showPopper = true;
            }, this.openDelay);
          } else {
            this.showPopper = true;
          }
        },
        handleKeydown: function handleKeydown(ev) {
          if (ev.keyCode === 27 && this.trigger !== 'manual') {
            // esc
            this.doClose();
          }
        },
        handleMouseLeave: function handleMouseLeave() {
          var _this3 = this;

          clearTimeout(this._timer);
          if (this.closeDelay) {
            this._timer = setTimeout(function () {
              _this3.showPopper = false;
            }, this.closeDelay);
          } else {
            this.showPopper = false;
          }
        },
        handleDocumentClick: function handleDocumentClick(e) {
          var reference = this.reference || this.$refs.reference;
          var popper = this.popper || this.$refs.popper;

          if (!reference && this.$refs.wrapper.children) {
            reference = this.referenceElm = this.$refs.wrapper.children[0];
          }
          if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
          this.showPopper = false;
        },
        handleAfterEnter: function handleAfterEnter() {
          this.$emit('after-enter');
        },
        handleAfterLeave: function handleAfterLeave() {
          this.$emit('after-leave');
          this.doDestroy();
        },
        cleanup: function cleanup() {
          if (this.openDelay || this.closeDelay) {
            clearTimeout(this._timer);
          }
        }
      },

      destroyed: function destroyed() {
        var reference = this.reference;

        Object(dom_["off"])(reference, 'click', this.doToggle);
        Object(dom_["off"])(reference, 'mouseup', this.doClose);
        Object(dom_["off"])(reference, 'mousedown', this.doShow);
        Object(dom_["off"])(reference, 'focusin', this.doShow);
        Object(dom_["off"])(reference, 'focusout', this.doClose);
        Object(dom_["off"])(reference, 'mousedown', this.doShow);
        Object(dom_["off"])(reference, 'mouseup', this.doClose);
        Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
        Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
        Object(dom_["off"])(document, 'click', this.handleDocumentClick);
      }
    };
    // CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
    /* harmony default export */var src_mainvue_type_script_lang_js_ = mainvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/popover/src/main.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_mainvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/popover/src/main.vue";
    /* harmony default export */var main = component.exports;
    // CONCATENATED MODULE: ./packages/popover/src/directive.js
    var getReference = function getReference(el, binding, vnode) {
      var _ref = binding.expression ? binding.value : binding.arg;
      var popper = vnode.context.$refs[_ref];
      if (popper) {
        if (Array.isArray(popper)) {
          popper[0].$refs.reference = el;
        } else {
          popper.$refs.reference = el;
        }
      }
    };

    /* harmony default export */var directive = {
      bind: function bind(el, binding, vnode) {
        getReference(el, binding, vnode);
      },
      inserted: function inserted(el, binding, vnode) {
        getReference(el, binding, vnode);
      }
    };
    // EXTERNAL MODULE: external "vue"
    var external_vue_ = __webpack_require__(7);
    var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

    // CONCATENATED MODULE: ./packages/popover/index.js


    external_vue_default.a.directive('popover', directive);

    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.directive('popover', directive);
      Vue.component(main.name, main);
    };
    main.directive = directive;

    /* harmony default export */var popover = __webpack_exports__["default"] = main;

    /***/
  }

  /******/ });

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GAL01_gallery_viewer_GAL01_gallery_viewer_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GAL01_gallery_fullscreen_GAL01_gallery_fullscreen_vue__ = __webpack_require__(989);



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'gal01-gallery-viewer': __WEBPACK_IMPORTED_MODULE_0__GAL01_gallery_viewer_GAL01_gallery_viewer_vue__["a" /* default */],
		'gal01-gallery-fullscreen': __WEBPACK_IMPORTED_MODULE_1__GAL01_gallery_fullscreen_GAL01_gallery_fullscreen_vue__["a" /* default */]
	},
	props: {
		galleryName: {
			required: true,
			type: String
		}
	},
	data: function data() {
		return {
			gallery: {
				title: '',
				data: '',
				images: []
			},
			isGalleryViewerOpen: false,
			isGalleryFullscreenOpen: false,
			activeSlideIndex: 0
		};
	},
	mounted: function mounted() {
		this.getGalleryImages();
	},

	methods: {
		getGalleryImages: function getGalleryImages() {
			if (window[this.galleryName]) {
				this.gallery = window[this.galleryName];
			}
		},
		setActiveSlideIndex: function setActiveSlideIndex(index) {
			this.activeSlideIndex = index;
		},
		toggleGalleryViewer: function toggleGalleryViewer() {
			if (!this.isGalleryViewerOpen) {
				this.setActiveSlideIndex(0);
				document.body.style.overflowY = 'hidden';
				this.isGalleryViewerOpen = true;
			} else {
				document.body.style.overflowY = '';
				this.isGalleryViewerOpen = false;
			}
		},
		toggleGalleryFullscreen: function toggleGalleryFullscreen() {
			if (!this.isGalleryFullscreenOpen) {
				this.isGalleryViewerOpen = false;
				this.isGalleryFullscreenOpen = true;

				if (document.documentElement.requestFullscreen) {
					document.documentElement.requestFullscreen();
				}
			} else {
				this.isGalleryViewerOpen = true;
				this.isGalleryFullscreenOpen = false;

				if (document.exitFullscreen) {
					document.exitFullscreen();
				}
			}
		}
	}
});

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_GAL01_gallery_viewer_js__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db2ecb2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_GAL01_gallery_viewer_pug__ = __webpack_require__(988);
var normalizeComponent = __webpack_require__(102)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_GAL01_gallery_viewer_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6db2ecb2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_GAL01_gallery_viewer_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


var GALLERY_SLIDER_OPTIONS = {
	autoplay: false,
	loop: false,
	slidesPerView: 1,
	mousewheelControl: true,
	mousewheel: false
};

var GALLERY_THUMBNAILS_OPTIONS = {
	autoplay: false,
	loop: false,
	slidesPerView: 'auto',
	spaceBetween: 12,
	normalizeSlideIndex: false,
	mousewheelControl: true,
	mousewheel: false,
	breakpoints: {
		479: {
			centeredSlides: true
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	props: {
		gallery: {
			required: true,
			type: Object
		},
		activeSlideIndex: {
			required: false,
			type: Number
		}
	},
	data: function data() {
		return {
			currentIndex: 0,
			gallerySlider: null,
			galleryThumbnails: null,
			gallerySliderOptions: GALLERY_SLIDER_OPTIONS,
			galleryThumbnailsOptions: GALLERY_THUMBNAILS_OPTIONS,
			sliderPrevButton: null,
			sliderNextButton: null
		};
	},
	mounted: function mounted() {
		this.initSwipers();
		this.handleSwiperEvents();
		this.setInitialIndex();
	},

	methods: {
		initSwipers: function initSwipers() {
			this.gallerySlider = this.$refs['gallery-slider'].swiper;
			this.galleryThumbnails = this.$refs['gallery-thumbnails'].swiper;
		},
		setInitialIndex: function setInitialIndex() {
			if (this.activeSlideIndex) {
				this.slideToIndex(this.activeSlideIndex, 0);
			}
		},
		toggleGalleryViewer: function toggleGalleryViewer() {
			this.$emit('toggle-gallery-viewer');
		},
		toggleGalleryFullscreen: function toggleGalleryFullscreen() {
			this.$emit('toggle-gallery-fullscreen');
		},
		handleSwiperEvents: function handleSwiperEvents() {
			var _this = this;

			this.gallerySlider.on('slidePrevTransitionStart', function () {
				_this.galleryThumbnails.slideTo(_this.gallerySlider.activeIndex, 300, true);
				_this.$emit('set-active-slide-index', _this.gallerySlider.activeIndex);
			});

			this.gallerySlider.on('slideNextTransitionStart', function () {
				_this.galleryThumbnails.slideTo(_this.gallerySlider.activeIndex, 300, true);
				_this.$emit('set-active-slide-index', _this.gallerySlider.activeIndex);
			});

			this.gallerySlider.on('slideChange', function () {
				_this.$nextTick(function () {
					_this.currentIndex = _this.gallerySlider.activeIndex;
				});
			});
		},
		slidePrev: function slidePrev() {
			this.gallerySlider.slidePrev();
		},
		slideNext: function slideNext() {
			this.gallerySlider.slideNext();
		},
		slideToIndex: function slideToIndex(index) {
			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

			this.gallerySlider.slideTo(index, transition, true);
		}
	}
});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.Swiper = factory());
})(this, function () {
  'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */

  var doc = typeof document === 'undefined' ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    location: { hash: '' }
  } : document; // eslint-disable-line

  var win = typeof window === 'undefined' ? {
    document: doc,
    navigator: {
      userAgent: ''
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {}
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
      // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) {
            toCreate = 'ul';
          }
          if (html.indexOf('<tr') === 0) {
            toCreate = 'tbody';
          }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) {
            toCreate = 'tr';
          }
          if (html.indexOf('<tbody') === 0) {
            toCreate = 'table';
          }
          if (html.indexOf('<option') === 0) {
            toCreate = 'select';
          }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) {
              arr.push(els[i]);
            }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) {
        uniqueArray.push(arr[i]);
      }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
          this[j].classList.add(classes[i]);
        }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
          this[j].classList.remove(classes[i]);
        }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) {
      return false;
    }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
          this[j].classList.toggle(classes[i]);
        }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) {
        return this[0].getAttribute(attrs);
      }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute("data-" + key);
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) {
        el.dom7ElementDataStorage = {};
      }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
      targetSelector = undefined;
    }
    if (!capture) {
      capture = false;
    }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) {
        return;
      }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) {
        listener.apply(target, eventData);
      } else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) {
            listener.apply(parents[k], eventData);
          }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) {
            el.dom7Listeners = {};
          }
          if (!el.dom7Listeners[event]) {
            el.dom7Listeners[event] = [];
          }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) {
            el.dom7LiveListeners = {};
          }
          if (!el.dom7LiveListeners[event$1]) {
            el.dom7LiveListeners[event$1] = [];
          }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
      targetSelector = undefined;
    }
    if (!capture) {
      capture = false;
    }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = void 0;
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = void 0;
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) {
        return;
      }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) {
      return win.getComputedStyle(this[0], null);
    }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) {
          return win.getComputedStyle(this[0], null).getPropertyValue(props);
        }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) {
      return this;
    }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') {
      return false;
    }
    if (typeof selector === 'string') {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) {
          return true;
        }
      }
      return false;
    } else if (selector === doc) {
      return el === doc;
    } else if (selector === win) {
      return el === win;
    }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) {
          return true;
        }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) {
          i += 1;
        }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') {
      return this;
    }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) {
        return new Dom7([]);
      }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) {
      return new Dom7([]);
    }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) {
          nextEls.push(next);
        }
      } else {
        nextEls.push(next);
      }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) {
      return new Dom7([]);
    }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) {
          prevEls.push(prev);
        }
      } else {
        prevEls.push(prev);
      }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) {
            parents.push(this[i].parentNode);
          }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) {
            parents.push(parent);
          }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) {
            children.push(childNodes[j]);
          }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) {
        this[i].parentNode.removeChild(this[i]);
      }
    }
    return this;
  }
  function add() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if (delay === void 0) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if (axis === void 0) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) {
            return a.replace(',', '.');
          }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) {
          curTransform = transformMatrix.m41;
        }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) {
            curTransform = parseFloat(matrix[12]);
          }
          // Normal Browsers
          else {
              curTransform = parseFloat(matrix[4]);
            }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) {
          curTransform = transformMatrix.m42;
        }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) {
            curTransform = parseFloat(matrix[13]);
          }
          // Normal Browsers
          else {
              curTransform = parseFloat(matrix[5]);
            }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) {
          return paramsPart !== '';
        });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [],
          len$1 = arguments.length;
      while (len$1--) {
        args[len$1] = arguments[len$1];
      }var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    }
  };

  var Support = function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: win.Modernizr && win.Modernizr.touch === true || function checkTouch() {
        return !!(win.navigator.maxTouchPoints > 0 || 'ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch);
      }(),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || 'maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: function checkTransition() {
        var style = testDiv.style;
        return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
      }(),
      transforms3d: win.Modernizr && win.Modernizr.csstransforms3d === true || function checkTransforms3d() {
        var style = testDiv.style;
        return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
      }(),

      flexbox: function checkFlexbox() {
        var style = testDiv.style;
        var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) {
            return true;
          }
        }
        return false;
      }(),

      observer: function checkObserver() {
        return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
      }(),

      passiveListener: function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            }
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }(),

      gestures: function checkGestures() {
        return 'ongesturestart' in win;
      }()
    };
  }();

  var Browser = function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
    };
  }();

  var SwiperClass = function SwiperClass(params) {
    if (params === void 0) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') {
      return self;
    }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) {
        self.eventsListeners[event] = [];
      }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') {
      return self;
    }
    function onceHandler() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) {
      return self;
    }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var self = this;
    if (!self.eventsListeners) {
      return self;
    }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams(instanceParams) {
    var instance = this;
    if (!instance.modules) {
      return;
    }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules(modulesParams) {
    if (modulesParams === void 0) modulesParams = {};

    var instance = this;
    if (!instance.modules) {
      return;
    }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) {
      return;
    }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule(module) {
    var params = [],
        len = arguments.length - 1;
    while (len-- > 0) {
      params[len] = arguments[len + 1];
    }var Class = this;
    if (!Class.prototype.modules) {
      Class.prototype.modules = {};
    }
    var name = module.name || Object.keys(Class.prototype.modules).length + "_" + Utils.now();
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use(module) {
    var params = [],
        len = arguments.length - 1;
    while (len-- > 0) {
      params[len] = arguments[len + 1];
    }var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Class.installModule(m);
      });
      return Class;
    }
    return Class.installModule.apply(Class, [module].concat(params));
  };

  Object.defineProperties(SwiperClass, staticAccessors);

  function updateSize() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height
    });
  }

  function updateSlides() {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) {
      slides.css({ marginLeft: '', marginTop: '' });
    } else {
      slides.css({ marginRight: '', marginBottom: '' });
    }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = void 0;
        var column = void 0;
        var row = void 0;
        if (params.slidesPerColumnFill === 'column' || params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - column * slidesPerColumn;
            if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
          slide.css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex
          });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - row * slidesPerRow;
        }
        slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px").attr('data-swiper-column', column).attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') {
        continue;
      } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) {
          slideSize = Math.floor(slideSize);
        }
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) {
          slideSize = Math.floor(slideSize);
        }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);

      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) {
          slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        }
        if (i === 0) {
          slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        }
        if (Math.abs(slidePosition) < 1 / 1000) {
          slidePosition = 0;
        }
        if (params.roundLengths) {
          slidePosition = Math.floor(slidePosition);
        }
        if (index % params.slidesPerGroup === 0) {
          snapGrid.push(slidePosition);
        }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) {
          slidePosition = Math.floor(slidePosition);
        }
        if (index % params.slidesPerGroup === 0) {
          snapGrid.push(slidePosition);
        }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + "px" });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) {
        $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + "px" });
      } else {
        $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + "px" });
      }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) {
        $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + "px" });
      } else {
        $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + "px" });
      }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) {
            slidesGridItem = Math.floor(slidesGridItem);
          }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) {
            newSlidesGrid.push(slidesGridItem);
          }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) {
          slidesGridItem$1 = Math.floor(slidesGridItem$1);
        }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) {
      snapGrid = [0];
    }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) {
          slides.css({ marginLeft: spaceBetween + "px" });
        } else {
          slides.css({ marginRight: spaceBetween + "px" });
        }
      } else {
        slides.css({ marginBottom: spaceBetween + "px" });
      }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) {
          break;
        }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) {
      swiper.$wrapperEl.css('height', newHeight + "px");
    }
  }

  function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) {
      return;
    }
    if (typeof slides[0].swiperSlideOffset === 'undefined') {
      swiper.updateSlidesOffset();
    }

    var offsetCenter = -translate;
    if (rtl) {
      offsetCenter = translate;
    }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / translatesDiff;
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesProgress(translate);
    }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses() {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') {
          activeIndex = 0;
        }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) {
      snapIndex = snapGrid.length - 1;
    }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) {
          slideFound = true;
        }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
  };

  function getTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) {
      currentTranslate = -currentTranslate;
    }

    return currentTranslate || 0;
  }

  function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) {
        $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
      } else {
        $wrapperEl.transform("translate(" + x + "px, " + y + "px)");
      }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate() {
    return -this.snapGrid[0];
  }

  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate
  };

  function setTransition(duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) {
        dir = 'next';
      } else if (activeIndex < previousIndex) {
        dir = 'prev';
      } else {
        dir = 'reset';
      }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) {
        dir = 'next';
      } else if (activeIndex < previousIndex) {
        dir = 'prev';
      } else {
        dir = 'reset';
      }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1
  };

  function slideTo(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) {
      slideIndex = 0;
    }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) {
      snapIndex = snapGrid.length - 1;
    }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) {
          return false;
        }
      }
    }

    var direction;
    if (slideIndex > activeIndex) {
      direction = 'next';
    } else if (slideIndex < activeIndex) {
      direction = 'prev';
    } else {
      direction = 'reset';
    }

    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) {
              return;
            }
            if (e.target !== this) {
              return;
            }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) {
        return false;
      }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) {
        return false;
      }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) {
        return -Math.floor(Math.abs(val));
      }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) {
      return normalize(val);
    });
    var normalizedSlidesGrid = slidesGrid.map(function (val) {
      return normalize(val);
    });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) {
        prevIndex = swiper.activeIndex - 1;
      }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if (translate - currentSnap > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide() {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) {
        return;
      }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
  };

  function loopCreate() {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();

    var slides = $wrapperEl.children("." + params.slideClass);

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children("." + params.slideClass);
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) {
      params.loopedSlides = slides.length;
    }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) {
        appendSlides.push(el);
      }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
        prependSlides.push(el);
      }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix() {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();

    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = slides.length - loopedSlides * 3 + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
  };

  function setGrabCursor(moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) {
      return;
    }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor() {
    var swiper = this;
    if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) {
      return;
    }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
  };

  function appendSlide(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) {
          $wrapperEl.append(slides[i]);
        }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) {
          $wrapperEl.prepend(slides[i]);
        }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) {
          $wrapperEl.append(slides[i$1]);
        }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if ((typeof slidesIndexes === 'undefined' ? 'undefined' : _typeof(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) {
          swiper.slides.eq(indexToRemove).remove();
        }
        if (indexToRemove < newActiveIndex) {
          newActiveIndex -= 1;
        }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) {
        swiper.slides.eq(indexToRemove).remove();
      }
      if (indexToRemove < newActiveIndex) {
        newActiveIndex -= 1;
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides() {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides
  };

  var Device = function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }();

  function onTouchStart(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) {
      e = e.originalEvent;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) {
      return;
    }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) {
      return;
    }
    if (data.isTouched && data.isMoved) {
      return;
    }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) {
        return;
      }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) {
      data.allowThresholdMove = false;
    }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) {
        preventDefault = false;
      }
      if (doc.activeElement && $(doc.activeElement).is(data.formElements) && doc.activeElement !== e.target) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) {
      e = e.originalEvent;
    }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') {
      return;
    }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) {
      return;
    }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) {
      return;
    }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) {
      diff = -diff;
    }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
      }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
      }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }

    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) {
      return;
    }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now()
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) {
      e = e.originalEvent;
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && touchEndTime - data.lastClickTime > 300) {
        if (data.clickTimeout) {
          clearTimeout(data.clickTimeout);
        }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) {
            return;
          }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        if (data.clickTimeout) {
          clearTimeout(data.clickTimeout);
        }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) {
        swiper.allowClick = true;
      }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) {
          newPosition = -newPosition;
        }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) {
            needsLoopFix = true;
          }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) {
            needsLoopFix = true;
          }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) {
              return;
            }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) {
                return;
              }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) {
                return;
              }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > 1 - params.longSwipesRatio) {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize() {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) {
      return;
    }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick(e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) {
        e.preventDefault();
      }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
  };

  function setBreakpoint() {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides;if (loopedSlides === void 0) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) {
      return;
    }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') {
            return;
          }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint(breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) {
      return undefined;
    }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) {
      return parseInt(a, 10) - parseInt(b, 10);
    });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses() {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push("wp8-" + params.direction);
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses() {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) {
        callback();
      }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) {
        return;
      }
      if (swiper.imagesLoaded !== undefined) {
        swiper.imagesLoaded += 1;
      }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) {
          swiper.update();
        }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) {
      swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
    }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      }var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        assign = args, el = assign[0], params = assign[1];
      }
      if (!params) {
        params = {};
      }

      params = Utils.extend({}, params);
      if (el && !params.el) {
        params.el = el;
      }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) {
            return;
          }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            return;
          }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) {
            params[moduleParamName] = { enabled: false };
          }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children("." + swiper.params.wrapperClass);

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2]
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2]
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }(),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if (SwiperClass) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create(SwiperClass && SwiperClass.prototype);
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true }, defaults: { configurable: true }, Class: { configurable: true }, $: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) {
              breakLoop = true;
            }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) {
              breakLoop = true;
            }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) {
        return;
      }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection + " wp8-" + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(swiper.params.containerModifierClass + "wp8-" + newDirection);
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) {
        swiper.update();
      }

      return swiper;
    };

    Swiper.prototype.init = function init() {
      var swiper = this;
      if (swiper.initialized) {
        return;
      }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) deleteInstance = true;
      if (cleanStyles === void 0) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults(newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties(Swiper, staticAccessors);

    return Swiper;
  }(SwiperClass);

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device
    },
    static: {
      device: Device
    }
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support
    },
    static: {
      support: Support
    }
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser
    },
    static: {
      browser: Browser
    }
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) {
              return;
            }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) {
              return;
            }
            swiper.emit('orientationchange');
          }
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      }
    }
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if (options === void 0) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) {
        return;
      }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    }
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: []
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      }
    }
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) {
        offsetProp = 'right';
      } else {
        offsetProp = swiper.isHorizontal() ? 'left' : 'top';
      }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, offset + "px");
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) {
              appendIndexes.push(i$1);
            }
            if (i$1 < previousFrom) {
              prependIndexes.push(i$1);
            }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) {
        return b - a;
      }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
      if (!$slideEl.attr('data-swiper-slide-index')) {
        $slideEl.attr('data-swiper-slide-index', index);
      }
      if (params.cache) {
        swiper.virtual.cache[index] = $slideEl;
      }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            swiper.virtual.slides.push(slides[i]);
          }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            swiper.virtual.slides.unshift(slides[i]);
          }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) {
        return;
      }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) {
            activeIndex -= 1;
          }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) {
          activeIndex -= 1;
        }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    }
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {}
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) {
          return;
        }
        swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
        var overwriteParams = {
          watchSlidesProgress: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) {
          return;
        }
        swiper.virtual.update();
      }
    }
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) {
        e = e.originalEvent;
      } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) {
          swiperOffset.left -= swiper.$el[0].scrollLeft;
        }
        var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
            inView = true;
          }
        }
        if (!inView) {
          return undefined;
        }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
        }
        if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) {
          swiper.slideNext();
        }
        if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) {
          swiper.slidePrev();
        }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) {
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
        }
        if (kc === 34 || kc === 40) {
          swiper.slideNext();
        }
        if (kc === 33 || kc === 38) {
          swiper.slidePrev();
        }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) {
        return;
      }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) {
        return;
      }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    }
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      }
    }
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported && doc.implementation && doc.implementation.hasFeature
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    && doc.implementation.hasFeature('', '') !== true) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) {
        return 'DOMMouseScroll';
      }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }(),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) {
          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {
          // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = pX < 1 ? -1 : 1;
      }
      if (pY && !sY) {
        sY = pY < 1 ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) {
        return true;
      }

      if (e.originalEvent) {
        e = e.originalEvent;
      } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) {
            delta = data.pixelX * rtlFactor;
          } else {
            return true;
          }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) {
          delta = data.pixelY;
        } else {
          return true;
        }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) {
        return true;
      }

      if (params.invert) {
        delta = -delta;
      }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) {
              return true;
            }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) {
            return true;
          }
        }
        swiper.mousewheel.lastScrollTime = new win.Date().getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + delta * params.sensitivity;
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) {
          position = swiper.minTranslate();
        }
        if (position <= swiper.maxTranslate()) {
          position = swiper.maxTranslate();
        }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) {
          swiper.autoplay.stop();
        }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) {
          return true;
        }
      }

      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) {
        return false;
      }
      if (swiper.mousewheel.enabled) {
        return false;
      }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) {
        return false;
      }
      if (!swiper.mousewheel.enabled) {
        return false;
      }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    }
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now()
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) {
          swiper.mousewheel.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) {
          swiper.mousewheel.disable();
        }
      }
    }
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) {
        return;
      }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) {
        return;
      }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) {
        return;
      }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) {
        return;
      }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    }
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      }
    }
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
        return;
      }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
          current -= slidesLength - swiper.loopedSlides * 2;
        }
        if (current > total - 1) {
          current -= total;
        }
        if (current < 0 && swiper.params.paginationType !== 'bullets') {
          current = total + current;
        }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
            if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(params.bulletActiveClass + "-main");
              }
              if (bulletIndex === firstIndex) {
                $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              }
              if (bulletIndex === lastIndex) {
                $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(params.bulletActiveClass + "-main");
            }
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
        }
      }
      if (params.type === 'fraction') {
        $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
        $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
        return;
      }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find("." + params.bulletClass);
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + "<span class=\"" + params.totalClass + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) {
        return;
      }

      var $el = $(params.el);
      if ($el.length === 0) {
        return;
      }

      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass("" + params.modifierClass + params.type + "-dynamic");
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', "." + params.bulletClass, function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) {
            index += swiper.loopedSlides;
          }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0]
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
        return;
      }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) {
        swiper.pagination.bullets.removeClass(params.bulletActiveClass);
      }
      if (params.clickable) {
        $el.off('click', "." + params.bulletClass);
      }
    }
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(number) {
          return number;
        },
        formatFractionTotal: function formatFractionTotal(number) {
          return number;
        },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      }
    }
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
        return;
      }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
        } else {
          $dragEl.transform("translateX(" + newPos + "px)");
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
        } else {
          $dragEl.transform("translateY(" + newPos + "px)");
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
        return;
      }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
        return;
      }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
      }
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) {
        return;
      }
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) {
        return;
      }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) {
        return;
      }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) {
        return;
      }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) {
        return;
      }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
      if ($dragEl.length === 0) {
        $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0]
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    }
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      }
    }
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if (x.indexOf('%') >= 0) {
        x = parseInt(x, 10) * progress * rtlFactor + "%";
      } else {
        x = x * progress * rtlFactor + "px";
      }
      if (y.indexOf('%') >= 0) {
        y = parseInt(y, 10) * progress + "%";
      } else {
        y = y * progress + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform("translate3d(" + x + ", " + y + ", 0px)");
      } else {
        var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
        $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
        swiper.parallax.setTransform(el, progress);
      });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
          swiper.parallax.setTransform(el, slideProgress);
        });
      });
    },
    setTransition: function setTransition(duration) {
      if (duration === void 0) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
        var $parallaxEl = $(parallaxEl);
        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0) {
          parallaxDuration = 0;
        }
        $parallaxEl.transition(parallaxDuration);
      });
    }
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) {
          return;
        }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) {
          return;
        }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) {
          return;
        }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) {
          return;
        }
        swiper.parallax.setTransition(duration);
      }
    }
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) {
        return 1;
      }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) {
          gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
        }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
      }
      gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) {
        gesture.$slideEl = undefined;
      }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }
      if (image.isTouched) {
        return;
      }
      if (Device.android) {
        e.preventDefault();
      }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) {
        return;
      }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
        return;
      }

      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
          image.isTouched = false;
          return;
        }if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
      image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
      }
      if (image.currentX > image.maxX) {
        image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
      }

      if (image.currentY < image.minY) {
        image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
      }
      if (image.currentY > image.maxY) {
        image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
      }

      // Velocity
      if (!velocity.prevPositionX) {
        velocity.prevPositionX = image.touchesCurrent.x;
      }
      if (!velocity.prevPositionY) {
        velocity.prevPositionY = image.touchesCurrent.y;
      }
      if (!velocity.prevTime) {
        velocity.prevTime = Date.now();
      }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) {
        velocity.x = 0;
      }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) {
        velocity.y = 0;
      }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) {
        momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
      }
      if (velocity.y !== 0) {
        momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
      }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
      image.maxX = -image.minX;
      image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }

      gesture.$slideEl.addClass("" + params.zoomedSlideClass);

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = offsetX + slideWidth / 2 - touchX;
        diffY = offsetY + slideHeight / 2 - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
      gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
        return;
      }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) {
        return;
      }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) {
        return;
      }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
    }
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed'
      }
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {}
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined
        }
      };

      'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) {
          return;
        }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) {
          return;
        }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      }
    }
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if (loadInDuplicate === void 0) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') {
        return;
      }
      if (swiper.slides.length === 0) {
        return;
      }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);

      var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) {
        return;
      }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) {
            return;
          }
          if (background) {
            $imageEl.css('background-image', "url(\"" + background + "\")");
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find("." + params.preloaderClass).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
            return true;
          }
        } else if (slides[index]) {
          return true;
        }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) {
        swiper.lazy.initialImageLoaded = true;
      }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) {
            swiper.lazy.loadInSlide(i);
          }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) {
              swiper.lazy.loadInSlide(i$1);
            }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) {
              swiper.lazy.loadInSlide(i$2);
            }
          }
        } else {
          var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
          if (nextSlide.length > 0) {
            swiper.lazy.loadInSlide(slideIndex(nextSlide));
          }

          var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
          if (prevSlide.length > 0) {
            swiper.lazy.loadInSlide(slideIndex(prevSlide));
          }
        }
      }
    }
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      }
    }
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }();
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) {
          return 0;
        }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) {
              return;
            }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    }
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide' // or 'container'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper)
        }
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) {
          return;
        }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) {
          return;
        }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) {
          return;
        }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) {
          return;
        }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) {
          return;
        }
        swiper.controller.setTransition(duration, byController);
      }
    }
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) {
        return;
      }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass)) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) {
        return;
      }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) {
        return;
      }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) {
        swiper.a11y.liveRegion.remove();
      }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
      }
    }
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
        }
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) {
          return;
        }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) {
          return;
        }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) {
          return;
        }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) {
          return;
        }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) {
          return;
        }
        swiper.a11y.destroy();
      }
    }
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) {
        return;
      }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) {
        return;
      }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) {
        return part !== '';
      });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) {
        return;
      }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    }
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      }
    }
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
        if (typeof newIndex === 'undefined') {
          return;
        }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) {
        return;
      }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) {
        return;
      }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    }
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper)
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      }
    }
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') {
        return false;
      }
      if (swiper.autoplay.running) {
        return false;
      }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) {
        return false;
      }
      if (typeof swiper.autoplay.timeout === 'undefined') {
        return false;
      }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) {
        return;
      }
      if (swiper.autoplay.paused) {
        return;
      }
      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
      }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    }
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) {
              return;
            }
            if (e.target !== this) {
              return;
            }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          }
        }
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      }
    }
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) {
          tx -= swiper.translate;
        }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl.css({
          opacity: slideOpacity
        }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) {
            return;
          }
          if (!swiper || swiper.destroyed) {
            return;
          }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') {
          return;
        }
        swiper.classNames.push(swiper.params.containerModifierClass + "fade");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') {
          return;
        }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') {
          return;
        }
        swiper.fadeEffect.setTransition(duration);
      }
    }
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: swiperWidth + "px" });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + round * 4 * swiperSize;
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = 3 * swiperSize + swiperSize * 4 * round;
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = slideIndex * 90 + progress * 90;
          if (rtl) {
            wrapperRotate = -slideIndex * 90 - progress * 90;
          }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) {
            shadowBefore[0].style.opacity = Math.max(-progress, 0);
          }
          if (shadowAfter.length) {
            shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
        'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
          var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
        }
      }
      var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
      $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    }
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') {
          return;
        }
        swiper.classNames.push(swiper.params.containerModifierClass + "cube");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') {
          return;
        }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') {
          return;
        }
        swiper.cubeEffect.setTransition(duration);
      }
    }
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) {
            shadowBefore[0].style.opacity = Math.max(-progress, 0);
          }
          if (shadowAfter.length) {
            shadowAfter[0].style.opacity = Math.max(progress, 0);
          }
        }
        $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) {
            return;
          }
          if (!swiper || swiper.destroyed) {
            return;
          }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    }
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') {
          return;
        }
        swiper.classNames.push(swiper.params.containerModifierClass + "flip");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') {
          return;
        }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') {
          return;
        }
        swiper.flipEffect.setTransition(duration);
      }
    }
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
        var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) {
          translateX = 0;
        }
        if (Math.abs(translateY) < 0.001) {
          translateY = 0;
        }
        if (Math.abs(translateZ) < 0.001) {
          translateZ = 0;
        }
        if (Math.abs(rotateY) < 0.001) {
          rotateY = 0;
        }
        if (Math.abs(rotateX) < 0.001) {
          rotateX = 0;
        }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) {
            $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
          }
          if ($shadowAfterEl.length) {
            $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
          }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    }
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') {
          return;
        }

        swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
        swiper.classNames.push(swiper.params.containerModifierClass + "3d");

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') {
          return;
        }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') {
          return;
        }
        swiper.coverflowEffect.setTransition(duration);
      }
    }
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) {
        return;
      }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) {
        return;
      }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) {
        return;
      }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
        if (typeof prevIndex === 'undefined') {
          slideToIndex = nextIndex;
        } else if (typeof nextIndex === 'undefined') {
          slideToIndex = prevIndex;
        } else if (nextIndex - currentIndex < currentIndex - prevIndex) {
          slideToIndex = nextIndex;
        } else {
          slideToIndex = prevIndex;
        }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) {
        return;
      }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') {
            newThumbsIndex = nextThumbsIndex;
          } else if (typeof nextThumbsIndex === 'undefined') {
            newThumbsIndex = prevThumbsIndex;
          } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
            newThumbsIndex = currentThumbsIndex;
          } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
            newThumbsIndex = nextThumbsIndex;
          } else {
            newThumbsIndex = prevThumbsIndex;
          }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    }
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs'
      }
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) {
          return;
        }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) {
          return;
        }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) {
          return;
        }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) {
          return;
        }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) {
          return;
        }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) {
          return;
        }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) {
          return;
        }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      }
    }
  };

  // Swiper Class

  var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;
});

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ssr_window__ = __webpack_require__(691);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */




var Methods = {
  addClass: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["c" /* addClass */],
  removeClass: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["E" /* removeClass */],
  hasClass: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["m" /* hasClass */],
  toggleClass: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["H" /* toggleClass */],
  attr: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["e" /* attr */],
  removeAttr: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["D" /* removeAttr */],
  data: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["i" /* data */],
  transform: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["I" /* transform */],
  transition: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["J" /* transition */],
  on: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["u" /* on */],
  off: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["s" /* off */],
  trigger: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["L" /* trigger */],
  transitionEnd: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["K" /* transitionEnd */],
  outerWidth: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["w" /* outerWidth */],
  outerHeight: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["v" /* outerHeight */],
  offset: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["t" /* offset */],
  css: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["h" /* css */],
  each: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["j" /* each */],
  html: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["n" /* html */],
  text: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["G" /* text */],
  is: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["p" /* is */],
  index: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["o" /* index */],
  eq: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["k" /* eq */],
  append: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["d" /* append */],
  prepend: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["z" /* prepend */],
  next: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["q" /* next */],
  nextAll: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["r" /* nextAll */],
  prev: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["A" /* prev */],
  prevAll: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["B" /* prevAll */],
  parent: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["x" /* parent */],
  parents: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["y" /* parents */],
  closest: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["g" /* closest */],
  find: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["l" /* find */],
  children: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["f" /* children */],
  remove: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["C" /* remove */],
  add: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["b" /* add */],
  styles: __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["F" /* styles */]
};

Object.keys(Methods).forEach(function (methodName) {
  __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */].fn[methodName] = __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */].fn[methodName] || Methods[methodName];
});

var Utils = {
  deleteProps: function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {
        // no getter for object
      }
      try {
        delete object[key];
      } catch (e) {
        // something got wrong
      }
    });
  },
  nextTick: function nextTick(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return setTimeout(callback, delay);
  },
  now: function now() {
    return Date.now();
  },
  getTranslate: function getTranslate(el) {
    var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';

    var matrix = void 0;
    var curTransform = void 0;
    var transformMatrix = void 0;

    var curStyle = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].getComputedStyle(el, null);

    if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      }
      // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case
      transformMatrix = new __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].WebKitCSSMatrix) curTransform = transformMatrix.m41;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].WebKitCSSMatrix) curTransform = transformMatrix.m42;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  },
  parseUrlQuery: function parseUrlQuery(url) {
    var query = {};
    var urlToParse = url || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].location.href;
    var i = void 0;
    var params = void 0;
    var param = void 0;
    var length = void 0;
    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter(function (paramsPart) {
        return paramsPart !== '';
      });
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }
    return query;
  },
  isObject: function isObject(o) {
    return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend: function extend() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = arguments.length <= i ? undefined : arguments[i];
      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
};

var Support = function Support() {
  var testDiv = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].createElement('div');
  return {
    touch: __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Modernizr && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Modernizr.touch === true || function checkTouch() {
      return !!(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.maxTouchPoints > 0 || 'ontouchstart' in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */] || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].DocumentTouch && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */] instanceof __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].DocumentTouch);
    }(),

    pointerEvents: !!(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.pointerEnabled || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].PointerEvent || 'maxTouchPoints' in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.maxTouchPoints > 0),
    prefixedPointerEvents: !!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.msPointerEnabled,

    transition: function checkTransition() {
      var style = testDiv.style;
      return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
    }(),
    transforms3d: __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Modernizr && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Modernizr.csstransforms3d === true || function checkTransforms3d() {
      var style = testDiv.style;
      return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
    }(),

    flexbox: function checkFlexbox() {
      var style = testDiv.style;
      var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
      for (var i = 0; i < styles.length; i += 1) {
        if (styles[i] in style) return true;
      }
      return false;
    }(),

    observer: function checkObserver() {
      return 'MutationObserver' in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */] || 'WebkitMutationObserver' in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */];
    }(),

    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].addEventListener('testPassiveListener', null, opts);
      } catch (e) {
        // No support
      }
      return supportsPassive;
    }(),

    gestures: function checkGestures() {
      return 'ongesturestart' in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */];
    }()
  };
}();

var Browser = function Browser() {
  function isSafari() {
    var ua = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  return {
    isIE: !!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent.match(/Trident/g) || !!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent.match(/MSIE/g),
    isEdge: !!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent)
  };
}();

var SwiperClass = function () {
  function SwiperClass() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SwiperClass);

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  _createClass(SwiperClass, [{
    key: 'on',
    value: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    }
  }, {
    key: 'once',
    value: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      function onceHandler() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(self, args);
        self.off(events, onceHandler);
        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }
      }
      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    }
  }, {
    key: 'off',
    value: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    }
  }, {
    key: 'emit',
    value: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events = void 0;
      var data = void 0;
      var context = void 0;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  }, {
    key: 'useModulesParams',
    value: function useModulesParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        // Extend params
        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    }
  }, {
    key: 'useModules',
    value: function useModules() {
      var modulesParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {};
        // Extend instance methods and props
        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];
            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        }
        // Add event listeners
        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        }

        // Module create callback
        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  }], [{
    key: 'installModule',
    value: function installModule(module) {
      var Class = this;
      if (!Class.prototype.modules) Class.prototype.modules = {};
      var name = module.name || Object.keys(Class.prototype.modules).length + '_' + Utils.now();
      Class.prototype.modules[name] = module;
      // Prototype
      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      }
      // Class
      if (module.static) {
        Object.keys(module.static).forEach(function (key) {
          Class[key] = module.static[key];
        });
      }
      // Callback
      if (module.install) {
        for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          params[_key3 - 1] = arguments[_key3];
        }

        module.install.apply(Class, params);
      }
      return Class;
    }
  }, {
    key: 'use',
    value: function use(module) {
      var Class = this;
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }

      for (var _len4 = arguments.length, params = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        params[_key4 - 1] = arguments[_key4];
      }

      return Class.installModule.apply(Class, [module].concat(params));
    }
  }, {
    key: 'components',
    set: function set(components) {
      var Class = this;
      if (!Class.use) return;
      Class.use(components);
    }
  }]);

  return SwiperClass;
}();

function updateSize() {
  var swiper = this;
  var width = void 0;
  var height = void 0;
  var $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  Utils.extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  var params = swiper.params;

  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children('.' + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];

  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.snapGrid.length;

  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween;

  // reset margins
  if (rtl) slides.css({ marginLeft: '', marginTop: '' });else slides.css({ marginRight: '', marginBottom: '' });

  var slidesNumberEvenToRows = void 0;
  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }
    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  }

  // Calc slides
  var slideSize = void 0;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = slides.eq(i);
    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;
      if (params.slidesPerColumnFill === 'column' || params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - column * slidesPerColumn;
          if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          var groupIndex = Math.floor(i / params.slidesPerGroup);
          row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
          column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
        }
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        _slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }
      _slide.css('margin-' + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + 'px').attr('data-swiper-column', column).attr('data-swiper-row', row);
    }
    if (_slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].getComputedStyle(_slide[0], null);
      var currentTransform = _slide[0].style.transform;
      var currentWebKitTransform = _slide[0].style.webkitTransform;
      if (currentTransform) {
        _slide[0].style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? _slide.outerWidth(true) : _slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        if (swiper.isHorizontal()) {
          var width = parseFloat(slideStyles.getPropertyValue('width'));
          var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
          var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
          var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
          var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
          var boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
            slideSize = width + marginLeft + marginRight;
          } else {
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
          }
        } else {
          var height = parseFloat(slideStyles.getPropertyValue('height'));
          var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
          var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
          var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
          var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
          var _boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (_boxSizing && _boxSizing === 'border-box' && !Browser.isIE) {
            slideSize = height + marginTop + marginBottom;
          } else {
            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
          }
        }
      }
      if (currentTransform) {
        _slide[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = slideSize + 'px';
        } else {
          slides[i].style.height = slideSize + 'px';
        }
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;

    prevSlideSize = slideSize;

    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid = void 0;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });
  }
  if (!Support.flexbox || params.setWrapperSize) {
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
    if (params.centeredSlides) {
      newSlidesGrid = [];
      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }
      snapGrid = newSlidesGrid;
    }
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    newSlidesGrid = [];
    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) slides.css({ marginLeft: spaceBetween + 'px' });else slides.css({ marginRight: spaceBetween + 'px' });
    } else slides.css({ marginBottom: spaceBetween + 'px' });
  }

  if (params.centerInsufficientSlides) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Utils.extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var newHeight = 0;
  var i = void 0;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
      var _index = swiper.activeIndex + i;
      if (_index > swiper.slides.length) break;
      activeSlides.push(swiper.slides.eq(_index)[0]);
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight) swiper.$wrapperEl.css('height', newHeight + 'px');
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;


  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();

  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.removeClass(params.slideVisibleClass);

  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var _slide2 = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - _slide2.swiperSlideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);
    if (params.watchSlidesVisibility) {
      var slideBefore = -(offsetCenter - _slide2.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(_slide2);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }
    _slide2.progress = rtl ? -slideProgress : slideProgress;
  }
  swiper.visibleSlides = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.visibleSlides);
}

function updateProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;

  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Utils.extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });

  if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;

  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;

  var isVirtual = swiper.virtual && params.virtual.enabled;

  slides.removeClass(params.slideActiveClass + ' ' + params.slideNextClass + ' ' + params.slidePrevClass + ' ' + params.slideDuplicateActiveClass + ' ' + params.slideDuplicateNextClass + ' ' + params.slideDuplicatePrevClass);

  var activeSlide = void 0;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find('.' + params.slideClass + '[data-swiper-slide-index="' + activeIndex + '"]');
  } else {
    activeSlide = slides.eq(activeIndex);
  }

  // Active classes
  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    }
  }
  // Next Slide
  var nextSlide = activeSlide.nextAll('.' + params.slideClass).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  // Prev Slide
  var prevSlide = activeSlide.prevAll('.' + params.slideClass).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;

  var activeIndex = newActiveIndex;
  var snapIndex = void 0;
  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }

  // Get real index
  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  Utils.extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  if (swiper.initialized || swiper.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).closest('.' + params.slideClass)[0];
  var slideFound = false;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) slideFound = true;
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getTranslate() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';

  var swiper = this;

  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;


  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;

  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      progress = swiper.progress;

  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (!params.virtualTranslate) {
    if (Support.transforms3d) $wrapperEl.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');else $wrapperEl.transform('translate(' + x + 'px, ' + y + 'px)');
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;

  // Check if we need to update progress
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

var translate = {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate
};

function setTransition(duration, byController) {
  var swiper = this;

  swiper.$wrapperEl.transition(duration);

  swiper.emit('setTransition', duration, byController);
}

function transitionStart() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }
    swiper.emit('slideChangeTransitionStart');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;

  swiper.animating = false;
  swiper.setTransition(0);

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }
    swiper.emit('slideChangeTransitionEnd');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;

  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex];

  // Update progress
  swiper.updateProgress(translate);

  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction = void 0;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }

  if (speed === 0 || !Support.transition) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var newIndex = index;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate;


  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var normalizedSlidesGrid = slidesGrid.map(function (val) {
    return normalize(val);
  });

  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  var prevIndex = void 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var index = swiper.activeIndex;
  var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

  if (snapIndex < swiper.snapGrid.length - 1) {
    var _translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (_translate - currentSnap > (nextSnap - currentSnap) / 2) {
      index = swiper.params.slidesPerGroup;
    }
  }

  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;


  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex = void 0;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

      Utils.nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  // Remove duplicated slides

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass).remove();

  var slides = $wrapperEl.children('.' + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].createElement('div')).addClass(params.slideClass + ' ' + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }
      slides = $wrapperEl.children('.' + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;

  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (index, el) {
    var slide = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(el);
    if (index < swiper.loopedSlides) appendSlides.push(el);
    if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
    slide.attr('data-swiper-slide-index', index);
  });
  for (var _i3 = 0; _i3 < appendSlides.length; _i3 += 1) {
    $wrapperEl.append(Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(appendSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (var _i4 = prependSlides.length - 1; _i4 >= 0; _i4 -= 1) {
    $wrapperEl.prepend(Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(prependSlides[_i4].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  var params = swiper.params,
      activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;

  var newIndex = void 0;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;

  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate();

  // Fix For Negative Oversliding
  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + ',.' + params.slideClass + '.' + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;
  if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) return;
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  if (params.loop) {
    swiper.loopDestroy();
  }
  var newActiveIndex = activeIndex + 1;
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;

  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

  var slidesBuffer = [];
  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var _i5 = 0; _i5 < slides.length; _i5 += 1) {
      if (slides[_i5]) $wrapperEl.append(slides[_i5]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i6 = 0; _i6 < slidesBuffer.length; _i6 += 1) {
    $wrapperEl.append(slidesBuffer[_i6]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var newActiveIndex = activeIndexBuffer;
  var indexToRemove = void 0;

  if ((typeof slidesIndexes === 'undefined' ? 'undefined' : _typeof(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;

  var slidesIndexes = [];
  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

var Device = function Device() {
  var ua = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent;

  var device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    windows: false,
    iphone: false,
    ipod: false,
    ipad: false,
    cordova: __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].cordova || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].phonegap,
    phonegap: __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].cordova || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].phonegap
  };

  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

  // Windows
  if (windows) {
    device.os = 'windows';
    device.osVersion = windows[2];
    device.windows = true;
  }
  // Android
  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.iphone = true;
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  }

  // Desktop
  device.desktop = !(device.os || device.android || device.webView);

  // Webview
  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

  // Minimal UI
  if (device.os && device.os === 'ios') {
    var osVersionArr = device.osVersion.split('.');
    var metaViewport = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].querySelector('meta[name="viewport"]');
    device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
  }

  // Pixel Ratio
  device.pixelRatio = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].devicePixelRatio || 1;

  // Export object
  return device;
}();

function onTouchStart(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  if (params.noSwiping && Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass)[0]) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e).closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].screen.width - edgeSwipeThreshold)) {
    return;
  }

  Utils.extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });

  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).is(data.formElements)) preventDefault = false;
    if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement).is(data.formElements) && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement !== e.target) {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if (params.touchStartForcePreventDefault || shouldPreventDefault) {
      e.preventDefault();
    }
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data.isTouchEvent && e.type === 'mousemove') return;
  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;
    if (data.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = Utils.now();
    }
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data.isTouchEvent && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement) {
    if (e.target === __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).is(data.formElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;

  touches.currentX = pageX;
  touches.currentY = pageY;

  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle = void 0;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  e.preventDefault();
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;

  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;

  diff *= params.touchRatio;
  if (rtl) diff = -diff;

  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;

  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger) return;

  // Update active index in free mode
  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now()
    });
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;

  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = Utils.now();
  var timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime > 300) {
      if (data.clickTimeout) clearTimeout(data.clickTimeout);
      data.clickTimeout = Utils.nextTick(function () {
        if (!swiper || swiper.destroyed) return;
        swiper.emit('click', e);
      }, 300);
    }
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      if (data.clickTimeout) clearTimeout(data.clickTimeout);
      swiper.emit('doubleTap', e);
    }
  }

  data.lastClickTime = Utils.now();
  Utils.nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;

  var currentPos = void 0;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();

        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeModeMomentumVelocityRatio;

      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;

      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;

      var doBounce = false;
      var afterBouncePosition = void 0;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix = void 0;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide = void 0;
        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');

          swiper.setTransition(params.speed);
          swiper.setTranslate(afterBouncePosition);
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    return;
  }

  // Find current slide
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
        stopIndex = i;
        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      swiper.slideTo(stopIndex + params.slidesPerGroup);
    }
    if (swiper.swipeDirection === 'prev') {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;

  var params = swiper.params,
      el = swiper.el;


  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid;

  // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;

  swiper.updateSize();
  swiper.updateSlides();

  if (params.freeMode) {
    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
    swiper.setTranslate(newTranslate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
  } else {
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function attachEvents() {
  var swiper = this;
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  {
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.addEventListener('mousedown', swiper.onTouchStart, false);
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener('mousemove', swiper.onTouchMove, capture);
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.addEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
}

function detachEvents() {
  var swiper = this;

  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.removeEventListener('mousedown', swiper.onTouchStart, false);
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener('mousemove', swiper.onTouchMove, capture);
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.removeEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === undefined ? 0 : _swiper$loopedSlides,
      params = swiper.params;

  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Set breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints);

  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) {
      ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;
        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
          breakpointOnlyParams[param] = 'auto';
        } else if (param === 'slidesPerView') {
          breakpointOnlyParams[param] = parseFloat(paramValue);
        } else {
          breakpointOnlyParams[param] = parseInt(paramValue, 10);
        }
      });
    }

    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

    if (directionChanged && initialized) {
      swiper.changeDirection();
    }

    Utils.extend(swiper.params, breakpointParams);

    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });

    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }

    swiper.emit('breakpoint', breakpointParams);
  }
}

function getBreakpoint(breakpoints) {
  var swiper = this;
  // Get breakpoint for window width
  if (!breakpoints) return undefined;
  var breakpoint = false;
  var points = [];
  Object.keys(breakpoints).forEach(function (point) {
    points.push(point);
  });
  points.sort(function (a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var point = points[i];
    if (swiper.params.breakpointsInverse) {
      if (point <= __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].innerWidth) {
        breakpoint = point;
      }
    } else if (point >= __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].innerWidth && !breakpoint) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el;

  var suffixes = [];

  suffixes.push('initialized');
  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }
  if (!Support.flexbox) {
    suffixes.push('no-flexbox');
  }
  if (params.autoHeight) {
    suffixes.push('autoheight');
  }
  if (rtl) {
    suffixes.push('rtl');
  }
  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');
  }
  if (Device.android) {
    suffixes.push('android');
  }
  if (Device.ios) {
    suffixes.push('ios');
  }
  // WP8 Touch Events Fix
  if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
    suffixes.push('wp8-' + params.direction);
  }

  suffixes.forEach(function (suffix) {
    classNames.push(params.containerModifierClass + suffix);
  });

  $el.addClass(classNames.join(' '));
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;


  $el.removeClass(classNames.join(' '));
}

var classes = { addClasses: addClasses, removeClasses: removeClasses };

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var image = void 0;
  function onReady() {
    if (callback) callback();
  }
  if (!imageEl.complete || !checkForComplete) {
    if (src) {
      image = new __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }
  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked;

  swiper.isLocked = swiper.snapGrid.length === 1;
  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked;

  // events
  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    swiper.navigation.update();
  }
}

var checkOverflow$1 = { checkOverflow: checkOverflow };

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  //
  preventInteractionOnTransition: false,

  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,

  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,

  // Autoheight
  autoHeight: false,

  // Set wrapper width
  setWrapperSize: false,

  // Virtual Translate
  virtualTranslate: false,

  // Effects
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsInverse: false,

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  centeredSlides: false,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,

  // Round length
  roundLengths: false,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: true,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,

  // Cursor
  grabCursor: false,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  // NS
  containerModifierClass: 'swiper-container-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true
};

/* eslint no-param-reassign: "off" */

var prototypes = {
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};

var extendedDefaults = {};

var Swiper = function (_SwiperClass) {
  _inherits(Swiper, _SwiperClass);

  function Swiper() {
    var _ret3;

    _classCallCheck(this, Swiper);

    var el = void 0;
    var params = void 0;

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};

    params = Utils.extend({}, params);
    if (el && !params.el) params.el = el;

    var _this = _possibleConstructorReturn(this, (Swiper.__proto__ || Object.getPrototypeOf(Swiper)).call(this, params));

    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        if (!Swiper.prototype[protoMethod]) {
          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    });

    // Swiper Instance
    var swiper = _this;
    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }
    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];
      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) return;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
        if (params[moduleParamName] === true) {
          params[moduleParamName] = { enabled: true };
        }
        if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
      }
    });

    // Extend defaults with modules params
    var swiperParams = Utils.extend({}, defaults);
    swiper.useModulesParams(swiperParams);

    // Extend defaults with passed params
    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params);

    // Save Dom lib
    swiper.$ = __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */];

    // Find el
    var $el = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.params.el);
    el = $el[0];

    if (!el) {
      var _ret;

      return _ret = undefined, _possibleConstructorReturn(_this, _ret);
    }

    if ($el.length > 1) {
      var _ret2;

      var swipers = [];
      $el.each(function (index, containerEl) {
        var newParams = Utils.extend({}, params, { el: containerEl });
        swipers.push(new Swiper(newParams));
      });
      return _ret2 = swipers, _possibleConstructorReturn(_this, _ret2);
    }

    el.swiper = swiper;
    $el.data('swiper', swiper);

    // Find Wrapper
    var $wrapperEl = $el.children('.' + swiper.params.wrapperClass);

    // Extend Swiper
    Utils.extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],

      // Classes
      classNames: [],

      // Slides
      slides: Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

      // Indexes
      activeIndex: 0,
      realIndex: 0,

      //
      isBeginning: true,
      isEnd: false,

      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,

      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];
        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        } else if (Support.prefixedPointerEvents) {
          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
        }
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },

      // Clicks
      allowClick: true,

      // Touches
      allowTouchMove: swiper.params.allowTouchMove,

      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },

      // Images
      imagesToLoad: [],
      imagesLoaded: 0

    });

    // Install Modules
    swiper.useModules();

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    return _ret3 = swiper, _possibleConstructorReturn(_this, _ret3);
  }

  _createClass(Swiper, [{
    key: 'slidesPerViewDynamic',
    value: function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;

      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop = void 0;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
          if (slides[_i7] && !breakLoop) {
            slideSize += slides[_i7].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
          if (slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    }
  }, {
    key: 'update',
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params;
      // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated = void 0;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: 'changeDirection',
    value: function changeDirection(newDirection) {
      var needUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass('' + swiper.params.containerModifierClass + currentDirection + ' wp8-' + currentDirection).addClass('' + swiper.params.containerModifierClass + newDirection);

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(swiper.params.containerModifierClass + 'wp8-' + newDirection);
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();

      return swiper;
    }
  }, {
    key: 'init',
    value: function init() {
      var swiper = this;
      if (swiper.initialized) return;

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;


      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    }
  }], [{
    key: 'extendDefaults',
    value: function extendDefaults(newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    }
  }, {
    key: 'extendedDefaults',
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: 'defaults',
    get: function get() {
      return defaults;
    }
  }, {
    key: 'Class',
    get: function get() {
      return SwiperClass;
    }
  }, {
    key: '$',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */];
    }
  }]);

  return Swiper;
}(SwiperClass);

var Device$1 = {
  name: 'device',
  proto: {
    device: Device
  },
  static: {
    device: Device
  }
};

var Support$1 = {
  name: 'support',
  proto: {
    support: Support
  },
  static: {
    support: Support
  }
};

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser
  },
  static: {
    browser: Browser
  }
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      // Emit resize
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].addEventListener('resize', swiper.resize.resizeHandler);

      // Emit orientationchange
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy() {
      var swiper = this;
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].removeEventListener('resize', swiper.resize.resizeHandler);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

var Observer = {
  func: __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].MutationObserver || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].WebkitMutationObserver,
  attach: function attach(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var swiper = this;

    var ObserverFunc = Observer.func;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }
      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].requestAnimationFrame) {
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].requestAnimationFrame(observerUpdate);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].setTimeout(observerUpdate, 0);
      }
    });

    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });

    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!Support.observer || !swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();
      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    }
    // Observe container
    swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

    // Observe wrapper
    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};

var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: []
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.observer.init();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.destroy();
    }
  }
};

var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;

    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;

    var offsetProp = void 0;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';

    var slidesAfter = void 0;
    var slidesBefore = void 0;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
      slidesBefore = slidesPerGroup + addSlidesAfter;
    }
    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

    Utils.extend(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, offset + 'px');
      }
      swiper.updateProgress();
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];
          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      onRendered();
      return;
    }
    var prependIndexes = [];
    var appendIndexes = [];
    if (force) {
      swiper.$wrapperEl.find('.' + swiper.params.slideClass).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + i + '"]').remove();
        }
      }
    }
    for (var _i9 = 0; _i9 < slides.length; _i9 += 1) {
      if (_i9 >= from && _i9 <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i9);
        } else {
          if (_i9 > previousTo) appendIndexes.push(_i9);
          if (_i9 < previousFrom) prependIndexes.push(_i9);
        }
      }
    }
    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + 'px');
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    var $slideEl = params.renderSlide ? Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(params.renderSlide.call(swiper, slide, index)) : Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="' + swiper.params.slideClass + '" data-swiper-slide-index="' + index + '">' + slide + '</div>');
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slides) {
    var swiper = this;
    if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slides) {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
      });
      swiper.virtual.cache = newCache;
    }
    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide: function removeSlide(slidesIndexes) {
    var swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides: function removeAllSlides() {
    var swiper = this;
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  }
};

var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        removeSlide: Virtual.removeSlide.bind(swiper),
        removeAllSlides: Virtual.removeAllSlides.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {}
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'virtual');
      var overwriteParams = {
        watchSlidesProgress: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
};

var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;

    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var kc = e.keyCode || e.charCode;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement.nodeName && (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement.nodeName.toLowerCase() === 'input' || __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
      var inView = false;
      // Check that swiper should be inside of visible area of window
      if (swiper.$el.parents('.' + swiper.params.slideClass).length > 0 && swiper.$el.parents('.' + swiper.params.slideActiveClass).length === 0) {
        return undefined;
      }
      var windowWidth = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].innerWidth;
      var windowHeight = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) swiper.slideNext();
      if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) swiper.slidePrev();
    } else {
      if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (kc === 34 || kc === 40) swiper.slideNext();
      if (kc === 33 || kc === 38) swiper.slidePrev();
    }
    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    if (swiper.keyboard.enabled) return;
    Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */]).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    if (!swiper.keyboard.enabled) return;
    Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */]).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  }
};

var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    }
  }
};

function isEventSupported() {
  var eventName = 'onwheel';
  var isSupported = eventName in __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */];

  if (!isSupported) {
    var element = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].implementation && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].implementation.hasFeature
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].implementation.hasFeature('', '') !== true) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}
var Mousewheel = {
  lastScrollTime: Utils.now(),
  event: function getEvent() {
    if (__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  }(),
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;

    var sX = 0;
    var sY = 0; // spinX, spinY
    var pX = 0;
    var pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (!swiper.mouseEntered && !params.releaseOnEdges) return true;

    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;

    var data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;

    if (params.invert) delta = -delta;

    if (!swiper.params.freeMode) {
      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
        if (delta < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) return true;
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          swiper.emit('scroll', e);
        } else if (params.releaseOnEdges) return true;
      }
      swiper.mousewheel.lastScrollTime = new __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].Date().getTime();
    } else {
      // Freemode or scrollContainer:
      if (swiper.params.loop) {
        swiper.loopFix();
      }
      var position = swiper.getTranslate() + delta * params.sensitivity;
      var wasBeginning = swiper.isBeginning;
      var wasEnd = swiper.isEnd;

      if (position >= swiper.minTranslate()) position = swiper.minTranslate();
      if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();

      swiper.setTransition(0);
      swiper.setTranslate(position);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
        swiper.updateSlidesClasses();
      }

      if (swiper.params.freeModeSticky) {
        clearTimeout(swiper.mousewheel.timeout);
        swiper.mousewheel.timeout = Utils.nextTick(function () {
          swiper.slideToClosest();
        }, 300);
      }
      // Emit event
      swiper.emit('scroll', e);

      // Stop autoplay
      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
      // Return page scroll on edge positions
      if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  },
  enable: function enable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.params.mousewheel.eventsTarged);
    }
    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (!swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.params.mousewheel.eventsTarged);
    }
    target.off(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  }
};

var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        lastScrollTime: Utils.now()
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    }
  }
};

var Navigation = {
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;

    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }
      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }
      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (params.nextEl) {
      $nextEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(params.nextEl);
      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }
    if (params.prevEl) {
      $prevEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(params.prevEl);
      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    Utils.extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};

var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper),
        onNextClick: Navigation.onNextClick.bind(swiper),
        onPrevClick: Navigation.onPrevClick.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.navigation.destroy();
    },
    click: function click(e) {
      var swiper = this;
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if (swiper.params.navigation.hideOnClick && !Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).is($prevEl) && !Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).is($nextEl)) {
        var isHidden = void 0;
        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          swiper.emit('navigationShow', swiper);
        } else {
          swiper.emit('navigationHide', swiper);
        }
        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    // Current/Total
    var current = void 0;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex = void 0;
      var lastIndex = void 0;
      var midIndex = void 0;
      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + 'px');
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }
        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(params.bulletActiveClass + ' ' + params.bulletActiveClass + '-next ' + params.bulletActiveClass + '-next-next ' + params.bulletActiveClass + '-prev ' + params.bulletActiveClass + '-prev-prev ' + params.bulletActiveClass + '-main');
      if ($el.length > 1) {
        bullets.each(function (index, bullet) {
          var $bullet = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(bullet);
          var bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + '-main');
            }
            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
            }
            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);
          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + '-main');
          }
          $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
          $lastDisplayedBullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
        }
      }
      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + 'px');
      }
    }
    if (params.type === 'fraction') {
      $el.find('.' + params.currentClass).text(params.formatFractionCurrent(current + 1));
      $el.find('.' + params.totalClass).text(params.formatFractionTotal(total));
    }
    if (params.type === 'progressbar') {
      var progressbarDirection = void 0;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find('.' + params.progressbarFillClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }
    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

    var $el = swiper.pagination.$el;
    var paginationHTML = '';
    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += '<' + params.bulletElement + ' class="' + params.bulletClass + '"></' + params.bulletElement + '>';
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find('.' + params.bulletClass);
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = '<span class="' + params.currentClass + '"></span>' + ' / ' + ('<span class="' + params.totalClass + '"></span>');
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = '<span class="' + params.progressbarFillClass + '"></span>';
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el) return;

    var $el = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass('' + params.modifierClass + params.type + '-dynamic');
      swiper.pagination.dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', '.' + params.bulletClass, function onClick(e) {
        e.preventDefault();
        var index = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Utils.extend(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;

    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off('click', '.' + params.bulletClass);
    }
  }
};

var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-', // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable', // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.pagination.destroy();
    },
    click: function click(e) {
      var swiper = this;
      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).hasClass(swiper.params.pagination.bulletClass)) {
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
        if (isHidden === true) {
          swiper.emit('paginationShow', swiper);
        } else {
          swiper.emit('paginationHide', swiper);
        }
        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;

    var params = swiper.params.scrollbar;

    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(' + newPos + 'px, 0, 0)');
      } else {
        $dragEl.transform('translateX(' + newPos + 'px)');
      }
      $dragEl[0].style.width = newSize + 'px';
    } else {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(0px, ' + newPos + 'px, 0)');
      } else {
        $dragEl.transform('translateY(' + newPos + 'px)');
      }
      $dragEl[0].style.height = newSize + 'px';
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;


    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize = void 0;
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + 'px';
    } else {
      $dragEl[0].style.height = dragSize + 'px';
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }
    Utils.extend(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
    }
    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;


    var positionRatio = void 0;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;

    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;

    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();

    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);

    clearTimeout(swiper.scrollbar.dragTimeout);

    $el.transition(0);
    if (params.hide) {
      $el.css('opacity', 1);
    }
    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;


    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;

    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $el = scrollbar.$el;


    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;
    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }
    swiper.emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;

    var params = swiper.params.scrollbar;

    var $el = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find('.' + swiper.params.scrollbar.dragClass);
    if ($dragEl.length === 0) {
      $dragEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="' + swiper.params.scrollbar.dragClass + '"></div>');
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};

var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize: function resize() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.destroy();
    }
  }
};

var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;


    var $el = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(el);
    var rtlFactor = rtl ? -1 : 1;

    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = parseInt(x, 10) * progress * rtlFactor + '%';
    } else {
      x = x * progress * rtlFactor + 'px';
    }
    if (y.indexOf('%') >= 0) {
      y = parseInt(y, 10) * progress + '%';
    } else {
      y = y * progress + 'px';
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }
    if (typeof scale === 'undefined' || scale === null) {
      $el.transform('translate3d(' + x + ', ' + y + ', 0px)');
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform('translate3d(' + x + ', ' + y + ', 0px) scale(' + currentScale + ')');
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;

    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
      swiper.parallax.setTransform(el, progress);
    });
    slides.each(function (slideIndex, slideEl) {
      var slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
        swiper.parallax.setTransform(el, slideProgress);
      });
    });
  },
  setTransition: function setTransition() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;

    var swiper = this;
    var $el = swiper.$el;

    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
      var $parallaxEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  }
};

var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTransition(duration);
    }
  }
};

var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  },

  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;
    if (!Support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target).closest('.swiper-slide');
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }
    gesture.$imageEl.transition(0);
    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (Support.gestures) {
      zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
    }
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }
    gesture.$imageEl.transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }
      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
        return;
      }
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (Device.android) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    }
    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;

    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;

    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;

    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }
    e.preventDefault();
    e.stopPropagation();

    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();

    gesture.$imageWrapEl.transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

    image.currentX = newPositionX;
    image.currentY = newPositionY;

    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

    gesture.$imageWrapEl.transition(momentumDuration).transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      gesture.$imageWrapEl.transform('translate3d(0,0,0)');

      zoom.scale = 1;
      zoom.currentScale = 1;

      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  },

  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in: function _in(e) {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    gesture.$slideEl.addClass('' + params.zoomedSlideClass);

    var touchX = void 0;
    var touchY = void 0;
    var offsetX = void 0;
    var offsetY = void 0;
    var diffX = void 0;
    var diffY = void 0;
    var translateX = void 0;
    var translateY = void 0;
    var imageWidth = void 0;
    var imageHeight = void 0;
    var scaledWidth = void 0;
    var scaledHeight = void 0;
    var translateMinX = void 0;
    var translateMinY = void 0;
    var translateMaxX = void 0;
    var translateMaxY = void 0;
    var slideWidth = void 0;
    var slideHeight = void 0;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;

      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;

      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;

      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    gesture.$imageWrapEl.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  out: function out() {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass('' + params.zoomedSlideClass);
    gesture.$slideEl = undefined;
  },

  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.on(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;

    swiper.zoom.enabled = false;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.off(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  }
};

var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  },
  create: function create() {
    var swiper = this;
    var zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
      }
    };

    'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom: zoom
    });

    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
      get: function get() {
        return scale;
      },
      set: function set(value) {
        if (scale !== value) {
          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
          swiper.emit('zoomChange', value, imageEl, slideEl);
        }
        scale = value;
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.zoom.disable();
    },
    touchStart: function touchStart(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(e) {
      var swiper = this;
      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    }
  }
};

var Lazy = {
  loadInSlide: function loadInSlide(index) {
    var loadInDuplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

    var $slideEl = isVirtual ? swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + index + '"]') : swiper.slides.eq(index);

    var $images = $slideEl.find('.' + params.elementClass + ':not(.' + params.loadedClass + '):not(.' + params.loadingClass + ')');
    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }
    if ($images.length === 0) return;

    $images.each(function (imageIndex, imageEl) {
      var $imageEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(imageEl);
      $imageEl.addClass(params.loadingClass);

      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');

      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
        if (background) {
          $imageEl.css('background-image', 'url("' + background + '")');
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }
          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }
          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find('.' + params.preloaderClass).remove();
        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + swiper.params.slideDuplicateClass + ')');
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children('.' + swiper.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }
        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
      });

      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;

    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;

    var slidesPerView = swiperParams.slidesPerView;
    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children('.' + swiperParams.slideClass + '[data-swiper-slide-index="' + index + '"]').length) {
          return true;
        }
      } else if (slides[index]) return true;
      return false;
    }
    function slideIndex(slideEl) {
      if (isVirtual) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slideEl).attr('data-swiper-slide-index');
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children('.' + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
        var index = isVirtual ? Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slideEl).attr('data-swiper-slide-index') : Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }
    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        // Next Slides
        for (var _i10 = activeIndex + slidesPerView; _i10 < maxIndex; _i10 += 1) {
          if (slideExist(_i10)) swiper.lazy.loadInSlide(_i10);
        }
        // Prev Slides
        for (var _i11 = minIndex; _i11 < activeIndex; _i11 += 1) {
          if (slideExist(_i11)) swiper.lazy.loadInSlide(_i11);
        }
      } else {
        var nextSlide = $wrapperEl.children('.' + swiperParams.slideNextClass);
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));

        var prevSlide = $wrapperEl.children('.' + swiperParams.slidePrevClass);
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  }
};

var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,

      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll: function scroll() {
      var swiper = this;
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize: function resize() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove: function scrollbarDragMove() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    }
  }
};

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex = void 0;
      var minIndex = void 0;
      var guess = void 0;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    var i1 = void 0;
    var i3 = void 0;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier = void 0;
    var controlledTranslate = void 0;
    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var i = void 0;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          Utils.nextTick(function () {
            c.updateAutoHeight();
          });
        }
        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;
          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper)
      }
    });
  },

  on: {
    update: function update() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(translate, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
};

var a11y = {
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey: function onEnterKey(e) {
    var swiper = this;
    var params = swiper.params.a11y;
    if (e.keyCode !== 13) return;
    var $targetEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(e.target);
    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && $targetEl.is('.' + swiper.params.pagination.bulletClass)) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;

    if (swiper.params.loop) return;
    var _swiper$navigation4 = swiper.navigation,
        $nextEl = _swiper$navigation4.$nextEl,
        $prevEl = _swiper$navigation4.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
      }
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
        var $bulletEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
      });
    }
  },
  init: function init() {
    var swiper = this;

    swiper.$el.append(swiper.a11y.liveRegion);

    // Navigation
    var params = swiper.params.a11y;
    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  }
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<span class="' + swiper.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
      }
    });
    Object.keys(a11y).forEach(function (methodName) {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
};

var History = {
  init: function init() {
    var swiper = this;
    if (!swiper.params.history) return;
    if (!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history || !__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (!swiper.params.history.replaceState) {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues() {
    var pathArray = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].location.pathname.slice(1).split('/').filter(function (part) {
      return part !== '';
    });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return { key: key, value: value };
  },
  setHistory: function setHistory(key, index) {
    var swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    var slide = swiper.slides.eq(index);
    var value = History.slugify(slide.attr('data-history'));
    if (!__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].location.pathname.includes(key)) {
      value = key + '/' + value;
    }
    var currentState = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.replaceState({ value: value }, null, value);
    } else {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.pushState({ value: value }, null, value);
    }
  },
  slugify: function slugify(text) {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;
    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide3 = swiper.slides.eq(i);
        var slideHistory = History.slugify(_slide3.attr('data-history'));
        if (slideHistory === value && !_slide3.hasClass(swiper.params.slideDuplicateClass)) {
          var _index2 = _slide3.index();
          swiper.slideTo(_index2, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  }
};

var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    }
  }
};

var HashNavigation = {
  onHashCange: function onHashCange() {
    var swiper = this;
    var newHash = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
    if (newHash !== activeSlideHash) {
      var newIndex = swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-hash="' + newHash + '"]').index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  },
  setHash: function setHash() {
    var swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
    if (swiper.params.hashNavigation.replaceState && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history && __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.replaceState) {
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */].history.replaceState(null, null, '#' + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
    } else {
      var _slide4 = swiper.slides.eq(swiper.activeIndex);
      var hash = _slide4.attr('data-hash') || _slide4.attr('data-history');
      __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].location.hash = hash || '';
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    swiper.hashNavigation.initialized = true;
    var hash = __WEBPACK_IMPORTED_MODULE_1_ssr_window__["a" /* document */].location.hash.replace('#', '');
    if (hash) {
      var speed = 0;
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide5 = swiper.slides.eq(i);
        var slideHash = _slide5.attr('data-hash') || _slide5.attr('data-history');
        if (slideHash === hash && !_slide5.hasClass(swiper.params.slideDuplicateClass)) {
          var _index3 = _slide5.index();
          swiper.slideTo(_index3, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }
    if (swiper.params.hashNavigation.watchState) {
      Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */]).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.params.hashNavigation.watchState) {
      Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(__WEBPACK_IMPORTED_MODULE_1_ssr_window__["b" /* window */]).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  }
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    }
  }
};

/* eslint no-underscore-dangle: "off" */

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }
    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = Utils.nextTick(function () {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }
    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
    }
  }
};

var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
        onTransitionEnd: function onTransitionEnd(e) {
          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
          swiper.autoplay.paused = false;
          if (!swiper.autoplay.running) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.run();
          }
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove() {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  }
};

var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var _offset = $slideEl[0].swiperSlideOffset;
      var tx = -_offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'fade');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};

var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size;

    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl = void 0;
    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }
        $cubeShadowEl.css({ height: swiperWidth + 'px' });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }
      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var _transform = 'rotateX(' + (isHorizontal ? 0 : -slideAngle) + 'deg) rotateY(' + (isHorizontal ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      $slideEl.transform(_transform);
      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }
    $wrapperEl.css({
      '-webkit-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-moz-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-ms-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      'transform-origin': '50% 50% -' + swiperSize / 2 + 'px'
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform('translate3d(0px, ' + (swiperWidth / 2 + params.shadowOffset) + 'px, ' + -swiperWidth / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + params.shadowScale + ')');
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var _offset2 = params.shadowOffset;
        $cubeShadowEl.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (swiperHeight / 2 + _offset2) + 'px, ' + -swiperHeight / 2 / scale2 + 'px) rotateX(-90deg)');
      }
    }
    var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (swiper.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (swiper.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  }
};

var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'cube');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    }
  }
};

var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }
      var _offset3 = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = -_offset3;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
      $slideEl.transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      // eslint-disable-next-line
      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'flip');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    }
  }
};

var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl,
        slidesSizesGrid = swiper.slidesSizesGrid;

    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth;
    // Each slide offset from center
    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;

      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      var translateZ = -translate * Math.abs(offsetMultiplier);

      var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
      var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;

      var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';

      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append($shadowBeforeEl);
        }
        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append($shadowAfterEl);
        }
        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }

    // Set correct perspective for IE10
    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      var ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = center + 'px 50%';
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  }
};

var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;

      swiper.classNames.push(swiper.params.containerModifierClass + 'coverflow');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');

      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    }
  }
};

var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;

    var SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Utils.extend(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Utils.extend(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (Utils.isObject(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }
    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex = void 0;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(Object(__WEBPACK_IMPORTED_MODULE_0_dom7_dist_dom7_modular__["a" /* $ */])(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;
      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }
      var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }
    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;

    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

    if (swiper.realIndex !== thumbsSwiper.realIndex) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex = void 0;
      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix();
          // eslint-disable-next-line
          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        }
        // Find actual thumbs index to slide to
        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
      } else {
        newThumbsIndex = swiper.realIndex;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex) {
          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }

    // Activate thumbs
    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    thumbsSwiper.slides.removeClass(thumbActiveClass);
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="' + (swiper.realIndex + i) + '"]').addClass(thumbActiveClass);
      }
    } else {
      for (var _i12 = 0; _i12 < thumbsToActivate; _i12 += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i12).addClass(thumbActiveClass);
      }
    }
  }
};
var Thumbs$1 = {
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      thumbs: {
        swiper: null,
        init: Thumbs.init.bind(swiper),
        update: Thumbs.update.bind(swiper),
        onThumbClick: Thumbs.onThumbClick.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      var thumbs = swiper.params.thumbs;

      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
};

// Swiper Class

var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

if (typeof Swiper.use === 'undefined') {
  Swiper.use = Swiper.Class.use;
  Swiper.installModule = Swiper.Class.installModule;
}

Swiper.use(components);

/* harmony default export */ __webpack_exports__["default"] = (Swiper);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return toggleClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeAttr; });
/* unused harmony export prop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return data; });
/* unused harmony export removeData */
/* unused harmony export dataset */
/* unused harmony export val */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return transform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return off; });
/* unused harmony export once */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return trigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return transitionEnd; });
/* unused harmony export animationEnd */
/* unused harmony export width */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return outerWidth; });
/* unused harmony export height */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return outerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return offset; });
/* unused harmony export hide */
/* unused harmony export show */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return styles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return css; });
/* unused harmony export toArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return each; });
/* unused harmony export forEach */
/* unused harmony export filter */
/* unused harmony export map */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return html; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return is; });
/* unused harmony export indexOf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return eq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return append; });
/* unused harmony export appendTo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return prepend; });
/* unused harmony export prependTo */
/* unused harmony export insertBefore */
/* unused harmony export insertAfter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return nextAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return prevAll; });
/* unused harmony export siblings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return parent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return parents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return remove; });
/* unused harmony export detach */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return add; });
/* unused harmony export empty */
/* unused harmony export scrollTo */
/* unused harmony export scrollTop */
/* unused harmony export scrollLeft */
/* unused harmony export animate */
/* unused harmony export stop */
/* unused harmony export click */
/* unused harmony export blur */
/* unused harmony export focus */
/* unused harmony export focusin */
/* unused harmony export focusout */
/* unused harmony export keyup */
/* unused harmony export keydown */
/* unused harmony export keypress */
/* unused harmony export submit */
/* unused harmony export change */
/* unused harmony export mousedown */
/* unused harmony export mousemove */
/* unused harmony export mouseup */
/* unused harmony export mouseenter */
/* unused harmony export mouseleave */
/* unused harmony export mouseout */
/* unused harmony export mouseover */
/* unused harmony export touchstart */
/* unused harmony export touchend */
/* unused harmony export touchmove */
/* unused harmony export resize */
/* unused harmony export scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ssr_window__ = __webpack_require__(691);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Dom7 2.1.5
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: May 15, 2020
 */


var Dom7 = function Dom7(arr) {
  _classCallCheck(this, Dom7);

  var self = this;
  // Create array-like object
  for (var i = 0; i < arr.length; i += 1) {
    self[i] = arr[i];
  }
  self.length = arr.length;
  // Return collection with methods
  return this;
};

function $(selector, context) {
  var arr = [];
  var i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
    // String
    if (typeof selector === 'string') {
      var els = void 0;
      var tempParent = void 0;
      var _html = selector.trim();
      if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (_html.indexOf('<li') === 0) toCreate = 'ul';
        if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
        if (_html.indexOf('<tbody') === 0) toCreate = 'table';
        if (_html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].createElement(toCreate);
        tempParent.innerHTML = _html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [__WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */]).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */] || selector === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */]) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });
}

function requestAnimationFrame(callback) {
  if (__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].requestAnimationFrame) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].requestAnimationFrame(callback);else if (__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].webkitRequestAnimationFrame) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].webkitRequestAnimationFrame(callback);
  return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
  if (__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].cancelAnimationFrame) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].cancelAnimationFrame(id);else if (__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].webkitCancelAnimationFrame) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].webkitCancelAnimationFrame(id);
  return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].clearTimeout(id);
}

// Classes and attributes
function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }
  return this;
}
function removeClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }
  return this;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  }

  // Set attrs
  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
// eslint-disable-next-line
function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        // eslint-disable-next-line
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }
    return this;
  }
}
function data(key, value) {
  var el = void 0;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
        return el.dom7ElementDataStorage[key];
      }

      var dataKey = el.getAttribute('data-' + key);
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}
function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line
  if (el.dataset) {
    // eslint-disable-next-line
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      // eslint-disable-next-line
      var _attr = el.attributes[i];
      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }
  // eslint-disable-next-line
  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }
  return dataset;
}
function val(value) {
  var dom = this;
  if (typeof value === 'undefined') {
    if (dom[0]) {
      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
        var values = [];
        for (var i = 0; i < dom[0].selectedOptions.length; i += 1) {
          values.push(dom[0].selectedOptions[i].value);
        }
        return values;
      }
      return dom[0].value;
    }
    return undefined;
  }

  for (var _i = 0; _i < dom.length; _i += 1) {
    var el = dom[_i];
    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }
  return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  if (typeof duration !== 'string') {
    duration = duration + 'ms'; // eslint-disable-line
  }
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line
      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  var events = eventType.split(' ');
  var j = void 0;
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  var events = eventType.split(' ');
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function once() {
  var dom = this;

  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  function onceHandler() {
    for (var _len4 = arguments.length, eventArgs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      eventArgs[_key4] = arguments[_key4];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);
    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }
  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var events = args[0].split(' ');
  var eventData = args[1];
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var evt = void 0;
      try {
        evt = new __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
      } catch (e) {
        evt = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      el.dom7EventData = args.filter(function (data, dataIndex) {
        return dataIndex > 0;
      });
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  var events = ['webkitTransitionEnd', 'transitionend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function animationEnd(callback) {
  var events = ['webkitAnimationEnd', 'animationend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
// Sizing/Styles
function width() {
  if (this[0] === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */]) {
    return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles = this.styles();
      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function height() {
  if (this[0] === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */]) {
    return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var _scrollTop = el === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */] ? __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].scrollY : el.scrollTop;
    var _scrollLeft = el === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */] ? __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].scrollX : el.scrollLeft;
    return {
      top: box.top + _scrollTop - clientTop,
      left: box.left + _scrollLeft - clientLeft
    };
  }

  return null;
}
function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }
  return this;
}
function show() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.style.display === 'none') {
      el.style.display = '';
    }
    if (__WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }
  return this;
}
function styles() {
  if (this[0]) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  var i = void 0;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}

// Dom manipulation
function toArray() {
  var arr = [];
  for (var i = 0; i < this.length; i += 1) {
    arr.push(this[i]);
  }
  return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function forEach(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], this[i], i) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function filter(callback) {
  var matchedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }
  return new Dom7(matchedItems);
}
function map(callback) {
  var modifiedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    modifiedItems.push(callback.call(dom[i], i, dom[i]));
  }
  return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  var el = this[0];
  var compareWith = void 0;
  var i = void 0;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  } else if (selector === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */]) return el === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */];else if (selector === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */]) return el === __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */];

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function indexOf(el) {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i] === el) return i;
  }
  return -1;
}
function index() {
  var child = this[0];
  var i = void 0;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;
  var returnIndex = void 0;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append() {
  var newChild = void 0;

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = arguments.length <= k ? undefined : arguments[k];
    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}
// eslint-disable-next-line
function appendTo(parent) {
  $(parent).append(this);
  return this;
}
function prepend(newChild) {
  var i = void 0;
  var j = void 0;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["a" /* document */].createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
// eslint-disable-next-line
function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}
function insertBefore(selector) {
  var before = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}
function insertAfter(selector) {
  var after = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);
    el = _next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    var el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);
    el = _prev;
  }
  return new Dom7(prevEls);
}
function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line
    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }
      _parent = _parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  var closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  var foundElements = [];
  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);
    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  var children = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].childNodes;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
function detach() {
  return this.remove();
}
function add() {
  var dom = this;
  var i = void 0;
  var j = void 0;

  for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  for (i = 0; i < args.length; i += 1) {
    var toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}
function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }
      el.textContent = '';
    }
  }
  return this;
}

function scrollTo() {
  for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }
  if (typeof easing === 'undefined') easing = 'swing';

  return this.each(function animate() {
    var el = this;
    var currentTop = void 0;
    var currentLeft = void 0;
    var maxTop = void 0;
    var maxLeft = void 0;
    var newTop = void 0;
    var newLeft = void 0;
    var scrollTop = void 0; // eslint-disable-line
    var scrollLeft = void 0; // eslint-disable-line
    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;
    if (typeof easing === 'undefined') {
      easing = 'swing';
    }
    if (animateTop) {
      currentTop = el.scrollTop;
      if (!duration) {
        el.scrollTop = top;
      }
    }
    if (animateLeft) {
      currentLeft = el.scrollLeft;
      if (!duration) {
        el.scrollLeft = left;
      }
    }
    if (!duration) return;
    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }
    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }
    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;
    function render() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();

      if (startTime === null) {
        startTime = time;
      }
      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done = void 0;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }
      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }
      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop() {
  for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }
  return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
  for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }
  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'
      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
    }, initialParams),

    elements: els,
    animating: false,
    que: [],

    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }
      if (typeof easing === 'function') {
        return easing(progress);
      }
      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        cancelAnimationFrame(a.frameId);
      }
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);
      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }
      var elements = [];

      // Define & Cache Initials & Units
      a.elements.each(function (index, el) {
        var initialFullValue = void 0;
        var initialValue = void 0;
        var unit = void 0;
        var finalValue = void 0;
        var finalFullValue = void 0;

        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = __WEBPACK_IMPORTED_MODULE_0_ssr_window__["b" /* window */].getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });

      var startTime = null;
      var time = void 0;
      var elementsDone = 0;
      var propsDone = 0;
      var done = void 0;
      var began = false;

      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress = void 0;
        var easeProgress = void 0;
        // let el;
        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }
        if (startTime === null) {
          startTime = time;
        }
        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;

            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;
              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }
              if (elementsDone === elements.length) {
                done = true;
              }
            }
            if (done) {
              a.done(params.complete);
              return;
            }
            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return;
        // Then call
        a.frameId = requestAnimationFrame(render);
      }
      a.frameId = requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance = void 0;
  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }
  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;
  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');
function eventShortcut(name) {
  for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  if (typeof args[0] === 'undefined') {
    for (var i = 0; i < this.length; i += 1) {
      if (noTrigger.indexOf(name) < 0) {
        if (name in this[i]) this[i][name]();else {
          $(this[i]).trigger(name);
        }
      }
    }
    return this;
  }
  return this.on.apply(this, [name].concat(args));
}

function click() {
  for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }

  return eventShortcut.bind(this).apply(undefined, ['click'].concat(args));
}
function blur() {
  for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return eventShortcut.bind(this).apply(undefined, ['blur'].concat(args));
}
function focus() {
  for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }

  return eventShortcut.bind(this).apply(undefined, ['focus'].concat(args));
}
function focusin() {
  for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusin'].concat(args));
}
function focusout() {
  for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusout'].concat(args));
}
function keyup() {
  for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    args[_key16] = arguments[_key16];
  }

  return eventShortcut.bind(this).apply(undefined, ['keyup'].concat(args));
}
function keydown() {
  for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    args[_key17] = arguments[_key17];
  }

  return eventShortcut.bind(this).apply(undefined, ['keydown'].concat(args));
}
function keypress() {
  for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }

  return eventShortcut.bind(this).apply(undefined, ['keypress'].concat(args));
}
function submit() {
  for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    args[_key19] = arguments[_key19];
  }

  return eventShortcut.bind(this).apply(undefined, ['submit'].concat(args));
}
function change() {
  for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    args[_key20] = arguments[_key20];
  }

  return eventShortcut.bind(this).apply(undefined, ['change'].concat(args));
}
function mousedown() {
  for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
    args[_key21] = arguments[_key21];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousedown'].concat(args));
}
function mousemove() {
  for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    args[_key22] = arguments[_key22];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousemove'].concat(args));
}
function mouseup() {
  for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    args[_key23] = arguments[_key23];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseup'].concat(args));
}
function mouseenter() {
  for (var _len24 = arguments.length, args = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    args[_key24] = arguments[_key24];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseenter'].concat(args));
}
function mouseleave() {
  for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
    args[_key25] = arguments[_key25];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseleave'].concat(args));
}
function mouseout() {
  for (var _len26 = arguments.length, args = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
    args[_key26] = arguments[_key26];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseout'].concat(args));
}
function mouseover() {
  for (var _len27 = arguments.length, args = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
    args[_key27] = arguments[_key27];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseover'].concat(args));
}
function touchstart() {
  for (var _len28 = arguments.length, args = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
    args[_key28] = arguments[_key28];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchstart'].concat(args));
}
function touchend() {
  for (var _len29 = arguments.length, args = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
    args[_key29] = arguments[_key29];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchend'].concat(args));
}
function touchmove() {
  for (var _len30 = arguments.length, args = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
    args[_key30] = arguments[_key30];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchmove'].concat(args));
}
function resize() {
  for (var _len31 = arguments.length, args = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
    args[_key31] = arguments[_key31];
  }

  return eventShortcut.bind(this).apply(undefined, ['resize'].concat(args));
}
function scroll() {
  for (var _len32 = arguments.length, args = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
    args[_key32] = arguments[_key32];
  }

  return eventShortcut.bind(this).apply(undefined, ['scroll'].concat(args));
}



/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gal01-gallery-viewer"},[_c('div',{staticClass:"gal01-gallery-viewer__close-button",on:{"click":_vm.toggleGalleryViewer}}),_c('div',{staticClass:"gal01-gallery-slider__container"},[_c('swiper',{ref:"gallery-slider",staticClass:"gal01-gallery-slider__swiper",attrs:{"options":_vm.gallerySliderOptions}},_vm._l((_vm.gallery.images),function(image){return _c('swiper-slide',{staticClass:"gal01-gallery-slider__slide"},[_c('img',{staticClass:"gal01-gallery-slider__image",attrs:{"src":image.src,"alt":image.details,"title":image.title},on:{"click":_vm.toggleGalleryFullscreen}}),_c('div',{staticClass:"gal01-gallery-slider-text"},[_c('p',{staticClass:"gal01-gallery-slider-text__title"},[_vm._v(_vm._s(image.title))]),_c('p',{staticClass:"gal01-gallery-slider-text__description"},[_vm._v(_vm._s(image.details))])])])}),1),_c('div',{staticClass:"gal01-gallery-slider__prev",on:{"click":function($event){return _vm.slidePrev(_vm.currentIndex - 1)}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])]),_c('div',{staticClass:"gal01-gallery-slider__next",on:{"click":function($event){return _vm.slideNext(_vm.currentIndex + 1)}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])])],1),_c('p',{staticClass:"gal01-gallery-viewer__counter"},[_vm._v(_vm._s(_vm.currentIndex + 1)+" / "+_vm._s(_vm.gallery.images.length))]),_c('div',{staticClass:"gal01-gallery-thumbnails__container"},[_c('swiper',{ref:"gallery-thumbnails",staticClass:"gal01-gallery-thumbnails__swiper",attrs:{"options":_vm.galleryThumbnailsOptions}},_vm._l((_vm.gallery.images),function(image,index){return _c('swiper-slide',{staticClass:"gal01-gallery-thumbnails__slide"},[_c('img',{staticClass:"gal01-gallery-thumbnails__image",class:{'gal01-gallery-thumbnails--active': index === _vm.currentIndex},attrs:{"src":image.src,"alt":image.title},on:{"click":function($event){return _vm.slideToIndex(index)}}})])}),1),_c('div',{staticClass:"gal01-gallery-thumbnails__prev",on:{"click":_vm.slidePrev}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])]),_c('div',{staticClass:"gal01-gallery-thumbnails__next",on:{"click":_vm.slideNext}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_GAL01_gallery_fullscreen_js__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb3c5fdc_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_GAL01_gallery_fullscreen_pug__ = __webpack_require__(991);
var normalizeComponent = __webpack_require__(102)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_GAL01_gallery_fullscreen_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb3c5fdc_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_GAL01_gallery_fullscreen_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


var GALLERY_FULLSCREEN_OPTIONS = {
	autoplay: false,
	loop: false,
	slidesPerView: 1,
	mousewheelControl: true,
	mousewheel: false,
	pagination: {
		el: '.gal01-gallery-fullscreen__pagination',
		clickable: true
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	props: {
		gallery: {
			required: true,
			type: Object
		},
		activeSlideIndex: {
			required: false,
			type: Number
		}
	},
	data: function data() {
		return {
			currentIndex: 0,
			galleryFullscreen: null,
			galleryFullscreenOptions: GALLERY_FULLSCREEN_OPTIONS,
			sliderPrevButton: null,
			sliderNextButton: null
		};
	},
	mounted: function mounted() {
		this.initSwipers();
		this.handleSwiperEvents();
		this.setInitialIndex();
	},

	methods: {
		initSwipers: function initSwipers() {
			this.galleryFullscreen = this.$refs['gallery-fullscreen'].swiper;
		},
		setInitialIndex: function setInitialIndex() {
			if (this.activeSlideIndex) {
				this.slideToIndex(this.activeSlideIndex, 0);
			}
		},
		toggleGalleryFullscreen: function toggleGalleryFullscreen() {
			this.$emit('toggle-gallery-fullscreen');
		},
		handleSwiperEvents: function handleSwiperEvents() {
			var _this = this;

			this.galleryFullscreen.on('slidePrevTransitionStart', function () {
				_this.$emit('set-active-slide-index', _this.galleryFullscreen.activeIndex);
			});

			this.galleryFullscreen.on('slideNextTransitionStart', function () {
				_this.$emit('set-active-slide-index', _this.galleryFullscreen.activeIndex);
			});
		},
		slidePrev: function slidePrev() {
			this.galleryFullscreen.slidePrev();
		},
		slideNext: function slideNext() {
			this.galleryFullscreen.slideNext();
		},
		slideToIndex: function slideToIndex(index) {
			var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

			this.galleryFullscreen.slideTo(index, transition, true);
		}
	}
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gal01-gallery-fullscreen"},[_c('div',{staticClass:"gal01-gallery-fullscreen__close-button",on:{"click":_vm.toggleGalleryFullscreen}}),_c('div',{staticClass:"gal01-gallery-fullscreen__container"},[_c('swiper',{ref:"gallery-fullscreen",staticClass:"gal01-gallery-fullscreen__swiper",attrs:{"options":_vm.galleryFullscreenOptions}},_vm._l((_vm.gallery.images),function(image){return _c('swiper-slide',{staticClass:"gal01-gallery-fullscreen__slide"},[_c('div',{staticClass:"gal01-gallery-fullscreen__image-container"},[_c('img',{staticClass:"gal01-gallery-fullscreen__image",attrs:{"src":image.src,"alt":image.details,"title":image.title}}),_c('div',{staticClass:"gal01-gallery-fullscreen-text"},[_c('p',{staticClass:"gal01-gallery-fullscreen-text__description"},[_vm._v(_vm._s(image.details))])]),_c('div',{staticClass:"swiper-pagination gal01-gallery-fullscreen__pagination"})])])}),1),_c('div',{staticClass:"gal01-gallery-fullscreen__prev",on:{"click":function($event){return _vm.slidePrev(_vm.currentIndex - 1)}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])]),_c('div',{staticClass:"gal01-gallery-fullscreen__next",on:{"click":function($event){return _vm.slideNext(_vm.currentIndex + 1)}}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_search_box_search_box__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_api__ = __webpack_require__(591);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var PAGE_SIZE = 10;
var MIN_QUERY_LENGTH = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			currentLangCode: null,
			showHeaderSearch: false,
			suggestions: [], // searchbox miatt
			queryParamName: 'query',
			query: '',
			megamenuLeaveTimeout: 0,
			portfolioStock: null
		};
	},

	components: {
		'search-box': __WEBPACK_IMPORTED_MODULE_1__common_search_box_search_box__["a" /* default */],
		'multiselect': __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/apps/portfolio-stock').then(function (response) {
			_this.portfolioStock = response.data;

			var change = parseInt(_this.portfolioStock.change);
			if (change == 0) {
				_this.portfolioStock.changeDir = 'unchanged';
			} else if (change < 0) {
				_this.portfolioStock.changeDir = 'desc';
			} else if (change > 0) {
				_this.portfolioStock.changeDir = 'asc';
			}
		}).catch(function (e) {
			return console.error('Nem sikerült lekérdezni a részvényárfolyamot.', e);
		});
	},

	computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])('headerSearchStore', ['hideHeaderSearchMenu'])),
	methods: {
		toggleDesktopMenu: function toggleDesktopMenu(event) {
			var desktopMenuElement = event.currentTarget.querySelector('.header-desktop__megamenu');
			this.showHeaderSearch = false;

			if (desktopMenuElement && !desktopMenuElement.contains(event.target)) {
				if (!desktopMenuElement.classList.contains('header-desktop__megamenu--open')) {
					this.closeAllMenu('header-desktop__megamenu--open');
					desktopMenuElement.classList.add('header-desktop__megamenu--open');
				} else {
					desktopMenuElement.classList.remove('header-desktop__megamenu--open');
				}
			}
		},
		toggleMobileMenu: function toggleMobileMenu(event) {
			var mobileMenuElement = event.currentTarget.closest('.header-mobile__menu-item');

			if (!mobileMenuElement.classList.contains('header-mobile__menu-item--open')) {
				mobileMenuElement.classList.add('header-mobile__menu-item--open');
			} else {
				mobileMenuElement.classList.remove('header-mobile__menu-item--open');
			}
		},
		toggleHamburgerMenu: function toggleHamburgerMenu() {
			var hamburgerMenuElement = document.querySelector('.header-mobile__menubar');
			this.showHeaderSearch = false;

			if (!hamburgerMenuElement.classList.contains('header-mobile__menubar--open')) {
				hamburgerMenuElement.classList.add('header-mobile__menubar--open');
			} else {
				hamburgerMenuElement.classList.remove('header-mobile__menubar--open');
			}
		},
		closeAllMenu: function closeAllMenu(selector) {
			var allOpenMenuElement = document.querySelectorAll('.' + selector);

			allOpenMenuElement.forEach(function (menu) {
				menu.classList.remove(selector);
			});
		},
		handleClickOutside: function handleClickOutside(event) {
			if (!event.target.closest('.header-desktop__menu-item')) {
				this.closeAllMenu('header-desktop__megamenu--open');
			}
		},
		toggleHeaderSearch: function toggleHeaderSearch() {
			var previousHeaderSearch = this.showHeaderSearch;
			this.closeAllMenu('header-desktop__megamenu--open');
			this.closeAllMenu('header-mobile__menubar--open');
			this.closeAllMenu('header-mobile__menu-item--open');
			this.showHeaderSearch = !previousHeaderSearch;
		},
		goToUrl: function goToUrl(option) {
			window.location.href = option.url;
		},
		search: function search(query) {
			var _this2 = this;

			var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			this.query = query;
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(__WEBPACK_IMPORTED_MODULE_4__common_utils_api__["c" /* SEARCH_URL */], {
					params: {
						query: query,
						from: page * PAGE_SIZE,
						size: PAGE_SIZE,
						lang: window.lang
					}
				}).then(function (response) {
					_this2.searchResults = response.data.hits;
					_this2.currentPage = Math.ceil(response.data.from / PAGE_SIZE);
					_this2.numberOfPages = Math.ceil(response.data.total / response.data.size);
					_this2.numberOfSearchResults = response.data.total;
					_this2.isLoading = false;
					_this2.searchedAtLeastOnce = true;
					_this2.hitsOnPage = response.data.size;
				}).catch(function (error) {
					_this2.isLoading = false;
				});
			}
		},
		isActive: function isActive(path) {
			if (path[0] !== '/') path = '/' + path;
			path = location.protocol + '//' + location.host + path;
			return path.replace(/\?.*/g, '') === location.href.replace(/\?.*/g, '');
		},
		autoSuggest: function autoSuggest(query) {
			var _this3 = this;

			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(__WEBPACK_IMPORTED_MODULE_4__common_utils_api__["d" /* SUGGEST_URL */], {
					params: {
						query: query,
						lang: window.lang
					}
				}).then(function (response) {
					_this3.suggestions = response.data.suggestions;
					_this3.isLoading = false;
				}).catch(function (error) {
					_this3.isLoading = false;
				});
			} else {
				this.suggestions = [];
			}
		} // search-box miatt

	}
});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(994);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(1010);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(676);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(32);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  data: function data() {
    return {
      items: [],
      query: '',
      current: -1,
      loading: false,
      selectFirst: false,
      queryParamName: 'q'
    };
  },

  computed: {
    hasItems: function hasItems() {
      return this.items.length > 0;
    },
    isEmpty: function isEmpty() {
      return !this.query;
    },
    isDirty: function isDirty() {
      return !!this.query;
    }
  },

  methods: {
    update: function update() {
      var _this = this;

      this.cancel();

      if (!this.query) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return;
      }

      this.loading = true;

      this.fetch().then(function (response) {
        if (response && _this.query) {
          var data = response.data;
          data = _this.prepareResponseData ? _this.prepareResponseData(data) : data;
          _this.items = _this.limit ? data.slice(0, _this.limit) : data;
          _this.current = -1;
          _this.loading = false;

          if (_this.selectFirst) {
            _this.down();
          }
        }
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      if (!this.$http) {
        return _vue.util.warn('You need to provide a HTTP client', this);
      }

      if (!this.src) {
        return _vue.util.warn('You need to set the `src` property', this);
      }

      var src = this.queryParamName ? this.src : this.src + this.query;

      var params = this.queryParamName ? (0, _assign2.default)((0, _defineProperty3.default)({}, this.queryParamName, this.query), this.data) : this.data;

      var cancel = new _promise2.default(function (resolve) {
        return _this2.cancel = resolve;
      });
      var request = this.$http.get(src, { params: params });

      return _promise2.default.race([cancel, request]);
    },
    cancel: function cancel() {},
    reset: function reset() {
      this.items = [];
      this.query = '';
      this.loading = false;
    },
    setActive: function setActive(index) {
      this.current = index;
    },
    activeClass: function activeClass(index) {
      return {
        active: this.current === index
      };
    },
    hit: function hit() {
      if (this.current !== -1) {
        this.onHit(this.items[this.current]);
      }
    },
    up: function up() {
      if (this.current > 0) {
        this.current--;
      } else if (this.current === -1) {
        this.current = this.items.length - 1;
      } else {
        this.current = -1;
      }
    },
    down: function down() {
      if (this.current < this.items.length - 1) {
        this.current++;
      } else {
        this.current = -1;
      }
    },
    onHit: function onHit() {
      _vue.util.warn('You need to implement the `onHit` method', this);
    }
  }
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(995), __esModule: true };

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(688);
__webpack_require__(681);
__webpack_require__(686);
__webpack_require__(996);
__webpack_require__(1008);
__webpack_require__(1009);
module.exports = __webpack_require__(74).Promise;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(236);
var global = __webpack_require__(45);
var ctx = __webpack_require__(265);
var classof = __webpack_require__(693);
var $export = __webpack_require__(134);
var isObject = __webpack_require__(136);
var aFunction = __webpack_require__(266);
var anInstance = __webpack_require__(997);
var forOf = __webpack_require__(998);
var speciesConstructor = __webpack_require__(694);
var task = __webpack_require__(695).set;
var microtask = __webpack_require__(1003)();
var newPromiseCapabilityModule = __webpack_require__(590);
var perform = __webpack_require__(696);
var userAgent = __webpack_require__(1004);
var promiseResolve = __webpack_require__(697);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(54)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {/* empty */}
}();

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(1005)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(272)($Promise, PROMISE);
__webpack_require__(1006)(PROMISE);
Wrapper = __webpack_require__(74)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(1007)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(265);
var call = __webpack_require__(999);
var isArrayIter = __webpack_require__(1000);
var anObject = __webpack_require__(104);
var toLength = __webpack_require__(680);
var getIterFn = __webpack_require__(1001);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(104);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(237);
var ITERATOR = __webpack_require__(54)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(693);
var ITERATOR = __webpack_require__(54)('iterator');
var Iterators = __webpack_require__(237);
module.exports = __webpack_require__(74).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var macrotask = __webpack_require__(695).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(235)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(45);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(135);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
  }return target;
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(45);
var core = __webpack_require__(74);
var dP = __webpack_require__(103);
var DESCRIPTORS = __webpack_require__(99);
var SPECIES = __webpack_require__(54)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(54)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally


var $export = __webpack_require__(134);
var core = __webpack_require__(74);
var global = __webpack_require__(45);
var speciesConstructor = __webpack_require__(694);
var promiseResolve = __webpack_require__(697);

$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  } });

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try

var $export = __webpack_require__(134);
var newPromiseCapability = __webpack_require__(590);
var perform = __webpack_require__(696);

$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1011);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1012), __esModule: true };

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1013);
var $Object = __webpack_require__(74).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(134);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(99), 'Object', { defineProperty: __webpack_require__(103).f });

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'her01-hero',
	data: function data() {
		return {
			category: ''
		};
	},
	created: function created() {
		var searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has('category')) this.setCategory(searchParams.get('category'));
	},

	methods: {
		setCategory: function setCategory(category) {
			this.category = this.category == category ? '' : category;
		}
	}
});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils_event_bus__ = __webpack_require__(698);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lst03-list',
	data: function data() {
		return {
			category: ''
		};
	},

	methods: {
		setCategory: function setCategory(category) {
			__WEBPACK_IMPORTED_MODULE_0__common_utils_event_bus__["a" /* default */].$emit('set-news-category', category);
		}
	}
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_NL01_news_list_js__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_560dd1d2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_NL01_news_list_pug__ = __webpack_require__(1025);
var normalizeComponent = __webpack_require__(102)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_NL01_news_list_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_560dd1d2_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_NL01_news_list_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NL01_news_list_item_vue__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_pagination_pagination_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_year_filter_year_filter_vue__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_event_bus__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_api__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_constants__ = __webpack_require__(273);








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'nl01-news-list',
	components: {
		'cd02-card': __WEBPACK_IMPORTED_MODULE_1__NL01_news_list_item_vue__["a" /* default */],
		'year-filter': __WEBPACK_IMPORTED_MODULE_3__common_year_filter_year_filter_vue__["a" /* default */],
		'pagination': __WEBPACK_IMPORTED_MODULE_2__common_pagination_pagination_vue__["a" /* default */]
	},
	props: {
		size: {
			type: String,
			required: false,
			default: '10'
		},
		layout: {
			type: String,
			required: true
		},
		categoryInEditor: {
			type: String,
			required: false
		},
		type: {
			type: String,
			required: false,
			default: ''
		},
		parentLeloLink: {
			type: String,
			required: false,
			default: ''
		},
		yearpicker: {
			type: Boolean,
			default: false
		},
		currentPageId: {
			type: String,
			required: true
		}
	},
	data: function data() {
		return {
			list: [],
			total: 0,
			from: 0,
			currentPage: 0,
			isError: false,
			isLoading: true,
			selectedYear: null,
			category: ''
		};
	},
	created: function created() {
		__WEBPACK_IMPORTED_MODULE_4__common_utils_event_bus__["a" /* default */].$on('set-news-category', this.setCategory);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_4__common_utils_event_bus__["a" /* default */].$off('set-news-category', this.setCategory);
	},
	mounted: function mounted() {
		this.from = 0;

		if (!this.categoryInEditor) {
			var searchParams = new URLSearchParams(window.location.search);
			if (searchParams.has('category')) {
				this.setCategory(searchParams.get('category'));
			} else {
				this.getNews();
			}
		} else {
			this.category = this.categoryInEditor;
			this.getNews();
		}
	},

	computed: {
		lang: function lang() {
			return window.lang || __WEBPACK_IMPORTED_MODULE_6__common_utils_constants__["b" /* LANGUAGES */].HU;
		},
		isLangHungarian: function isLangHungarian() {
			return this.lang === __WEBPACK_IMPORTED_MODULE_6__common_utils_constants__["b" /* LANGUAGES */].HU;
		}
	},
	methods: {
		yearChange: function yearChange(year) {
			if (this.selectedYear !== year) {
				this.selectedYear = year;
				this.from = 0;
				this.getNews();
			}
		},
		setCategory: function setCategory(category) {
			if (this.category !== category) {
				this.category = category;
			}
			this.getNews();
		},
		nextPage: function nextPage(_nextPage) {
			this.from = _nextPage ? (_nextPage - 1) * this.size : this.from;
			this.getNews();
		},
		formatHits: function formatHits(hits) {
			var _this = this;

			return hits.map(function (item) {
				item.news.date = _this.$options.filters.dateFormat(item.news.date);

				if (_this.lang === __WEBPACK_IMPORTED_MODULE_6__common_utils_constants__["b" /* LANGUAGES */].EN) {
					var _window = window,
					    categories = _window.categories;


					item.news.tags = item.news.tags.map(function (tag) {
						return Object.keys(categories).find(function (key) {
							return categories[key] === tag;
						});
					});
				}

				return item;
			});
		},
		formatUrl: function formatUrl(url) {
			if (url.startsWith('/')) {
				url = url.substring(1, url.length);
			}
			return '/' + __WEBPACK_IMPORTED_MODULE_5__common_utils_api__["b" /* PREFIX */] + url;
		},
		getNews: function getNews() {
			var _this2 = this;

			var params = this.getParams();
			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__common_utils_api__["a" /* NEWS_LIST_URL */], { params: params }).then(function (_ref) {
				var data = _ref.data;

				_this2.list = _this2.formatHits(data.hits);
				_this2.total = data.total;
				_this2.from = data.from;
				_this2.currentPage = Math.ceil(data.from / Number(_this2.size));
			}).catch(function (_err) {
				console.error('Nem sikerült betölteni a hírek listát.', _err);
				_this2.isError = true;
			}).finally(function () {
				_this2.isLoading = false;
			});
		},
		getParams: function getParams() {
			var category = this.lang === __WEBPACK_IMPORTED_MODULE_6__common_utils_constants__["b" /* LANGUAGES */].HU ? this.category : window.categories[this.category];

			return {
				layout: this.layout || undefined,
				from: this.from,
				size: this.size,
				startYear: this.selectedYear || undefined,
				endYear: this.selectedYear ? this.selectedYear + 1 : undefined,
				category: category || undefined,
				lang: this.lang,
				type: this.type || undefined,
				currentPageId: this.currentPageId || ""
			};
		}
	}
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eafa108_hasScoped_false_buble_transforms_stripWithFunctional_true_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_NL01_news_list_item_vue__ = __webpack_require__(1019);
var normalizeComponent = __webpack_require__(102)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eafa108_hasScoped_false_buble_transforms_stripWithFunctional_true_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_developer_tools_node_modules_vue_loader_lib_selector_type_template_index_0_NL01_news_list_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"cd02-card__item"},[_c('div',{staticClass:"cd02-card__header"},[_c('p',{staticClass:"cd02-card__date"},[_vm._v(_vm._s(_vm.data.attrs.date))]),(_vm.data.attrs.tags.length)?_c('div',{staticClass:"cd02-card-item__taglist"},_vm._l((_vm.data.attrs.tags),function(tag){return _c('a',{key:tag,staticClass:"cd02-card-item__tag",attrs:{"href":_vm.data.attrs.tagUrlPrefix + '?category=' + tag}},[_vm._v(_vm._s(tag))])}),0):_vm._e()]),_c('div',{staticClass:"cd02-card__body"},[_c('h4',{staticClass:"cd02-card-item__title"},[_vm._v(_vm._s(_vm.data.attrs.title))]),_c('p',{staticClass:"cd02-card__text"},[_vm._v(_vm._s(_vm.data.attrs.text))]),(_vm.data.attrs.linkType === 'download' || (_vm.data.attrs.linkType !== 'more' && _vm.data.attrs.layout === 'LBHIR' && _vm.data.attrs.files && _vm.data.attrs.files.length == 1))?_c('a',{staticClass:"btn btn--transparent btn--arrow-right",attrs:{"href":_vm.data.attrs.files[0]}},[_vm._v(_vm._s(_vm.data.attrs.lang=='hu' ? 'Letöltés' : 'Download')),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","width":"20","height":"20"}},[_c('path',{attrs:{"fill":"currentColor","d":"M14.69 5.3a1 1 0 0 0-1.35 0L10 8.66 6.62 5.27a1 1 0 0 0-1.35 1.36l4.05 4.08a1 1 0 0 0 1.35 0l4-4a1 1 0 0 0 .02-1.41zM13 14H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"}})])]):_c('a',{staticClass:"btn btn--transparent btn--arrow-right",attrs:{"href":_vm.data.attrs.url}},[_vm._v(_vm._s(_vm.data.attrs.lang=='hu' ? 'Bővebben' : 'More')),_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.16666 10H15M10.8333 5L15.2441 9.41074C15.5695 9.73618 15.5695 10.2638 15.2441 10.5893L10.8333 15","stroke":"currentColor","stroke-width":"1.67","stroke-linecap":"round"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Pagination",
	components: {
		VueMultiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
	},
	props: {
		total: {
			type: Number,
			required: false,
			default: 10
		},
		from: {
			type: Number,
			required: false,
			default: 0
		},
		pageLength: {
			type: Number,
			required: false,
			default: 10
		}
	},
	data: function data() {
		return {
			isDropdownClosed: false,
			pointString: '...'
		};
	},

	computed: {
		isPreviousPageDisabled: function isPreviousPageDisabled() {
			return this.currentPage == 1;
		},
		isNextPageDisabled: function isNextPageDisabled() {
			return this.totalPage[this.totalPage.length - 1] < this.currentPage + 1;
		},
		currentPage: function currentPage() {
			return this.from;
		},
		totalPage: function totalPage() {
			var length = Math.ceil(this.total / this.pageLength) || 1;
			return this.getListOfPages(length);
		},
		options: function options() {
			var options = [];
			for (var i = 1; i <= this.totalPage[this.totalPage.length - 1]; i++) {
				options.push(i);
			}
			return options;
		},
		lang: function lang() {
			return window.lang || 'hu';
		}
	},
	methods: {
		goToPreviousPage: function goToPreviousPage() {
			if (this.currentPage > 0) this.goToPage(this.currentPage - 1);
		},
		goToNextPage: function goToNextPage() {
			if (this.totalPage[this.totalPage.length - 1] >= this.currentPage + 1) this.goToPage(this.currentPage + 1);
		},
		goToPage: function goToPage(page) {
			if (!this.isPoints(page)) this.$emit('on-page-change', page);
		},
		toggleDropdown: function toggleDropdown() {
			this.isDropdownClosed = !this.isDropdownClosed;
		},
		getListOfPages: function getListOfPages(pageLength) {
			var start = this.calculateStartPage(pageLength);
			var end = this.calculateEndPage(pageLength);
			var paginator = [];
			for (var i = start; i <= end; i++) {
				paginator.push(i);
			}
			paginator = this.reducePageLength(paginator, pageLength);
			this.setFirstTwoPages(paginator, pageLength);
			this.setLastTwoPages(paginator, pageLength);
			return paginator;
		},
		calculateStartPage: function calculateStartPage(pageLength) {
			var start = this.currentPage - 4 > 1 ? this.currentPage - 4 : 1;
			start -= this.currentPage == pageLength ? 2 : this.currentPage == pageLength - 1 ? 1 : 0;
			start = start < 1 ? 1 : start;
			return start;
		},
		calculateEndPage: function calculateEndPage(pageLength) {
			var end = this.currentPage + 4 < pageLength ? this.currentPage + 4 : pageLength;
			end += this.currentPage == 1 ? 2 : this.currentPage == 2 ? 1 : 0;
			return end;
		},
		reducePageLength: function reducePageLength(paginator, pageLength) {
			return paginator.slice(0, pageLength);
		},
		setFirstTwoPages: function setFirstTwoPages(paginator, pageLength) {
			paginator[0] = 1;
			if (pageLength > 1) paginator[1] = paginator[1] != 2 ? this.pointString : 2;
		},
		setLastTwoPages: function setLastTwoPages(paginator, pageLength) {
			paginator[paginator.length - 1] = pageLength;
			paginator[paginator.length - 2] = pageLength - 1 != paginator[paginator.length - 2] ? this.pointString : pageLength - 1;
		},
		isPoints: function isPoints(page) {
			return page === this.pointString;
		}
	}
});

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('button',{staticClass:"pagination__button pagination__button--prev",attrs:{"type":"button","title":_vm.lang=='hu' ? 'Vissza' : 'Back',"disabled":_vm.isPreviousPageDisabled},on:{"click":_vm.goToPreviousPage}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])]),_c('div',{staticClass:"pagination-list-dropdown"},[_c('vue-multiselect',{attrs:{"options":_vm.options,"searchable":false,"allow-empty":false,"show-pointer":false,"show-labels":false,"value":_vm.currentPage},on:{"select":_vm.goToPage},scopedSlots:_vm._u([{key:"option",fn:function(page){return [_c('span',[_vm._v(_vm._s(page.option))])]}}])},[_c('template',{slot:"singleLabel"},[_c('span',[_vm._v(_vm._s(_vm.currentPage)+"/"+_vm._s(_vm.totalPage.length))])])],2)],1),_c('div',{staticClass:"pagination-list"},_vm._l((_vm.totalPage),function(page){return _c('button',{staticClass:"pagination-list__item",class:{'is-selected': page == _vm.currentPage, 'is-point': _vm.isPoints(page)},attrs:{"type":"button"},on:{"click":function($event){return _vm.goToPage(page)}}},[_vm._v(_vm._s(page))])}),0),_c('button',{staticClass:"pagination__button pagination__button--next",attrs:{"type":"button","title":_vm.lang=='hu' ? 'Tovább' : 'Next',"disabled":_vm.isNextPageDisabled},on:{"click":_vm.goToNextPage}},[_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_year_filter_js__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcee55c_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_year_filter_pug__ = __webpack_require__(1024);
var normalizeComponent = __webpack_require__(102)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_extends_usr_local_app_frontend_developer_tools_babelrc_year_filter_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__developer_tools_node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcee55c_hasScoped_false_buble_transforms_developer_tools_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_year_filter_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "year-filter",
	components: {
		VueMultiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
	},
	props: {
		defaultYear: {
			type: Number,
			required: false
		}
	},
	data: function data() {
		return {
			selectedYear: undefined,
			isOpened: false
		};
	},

	computed: {
		yearList: function yearList() {
			var yearList = [];
			var thisYear = new Date().getFullYear();
			for (var i = thisYear; i >= 2004; i--) {
				yearList.push(i);
			}
			return yearList;
		},
		lang: function lang() {
			return window.lang || 'hu';
		}
	},
	methods: {
		changeYear: function changeYear(year) {
			this.selectedYear = year;
			this.isOpened = false;
			this.$emit('on-year-change', year);
		},
		getActiveYear: function getActiveYear(year) {
			return this.selectedYear == year;
		},
		allYear: function allYear() {
			this.selectedYear = undefined;
			this.isOpened = false;
			this.$emit('on-year-change', this.selectedYear);
		}
	},
	created: function created() {
		if (this.defaultYear) {
			this.selectedYear = this.defaultYear;
		}
	}
});

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"year-filter-container"},[_c('div',{staticClass:"year-filter",class:{'year-filter--show-dropdown': _vm.isOpened}},[_c('button',{staticClass:"btn year-filter-button",class:{'year-filter-button--show-dropdown': _vm.isOpened},attrs:{"type":"button"},on:{"click":function($event){_vm.isOpened = !_vm.isOpened}}},[_c('div',{staticClass:"year-filter-button__text"},[_vm._v(_vm._s(_vm.lang=='hu' ? 'ÉVSZÁM' : 'YEAR')),_c('div',{staticClass:"year-filter-button__selected-year"},[_vm._v(_vm._s(_vm.selectedYear ? _vm.selectedYear : _vm.lang=='hu' ? 'ÖSSZES ÉV' : 'ALL YEARS'))])]),_c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.5 9.99984L7.25004 6.74984C7.09726 6.59706 7.02087 6.40262 7.02087 6.1665C7.02087 5.93039 7.09726 5.73595 7.25004 5.58317C7.40282 5.43039 7.59726 5.354 7.83337 5.354C8.06949 5.354 8.26393 5.43039 8.41671 5.58317L12.25 9.4165C12.3334 9.49984 12.3924 9.59012 12.4271 9.68734C12.4618 9.78456 12.4792 9.88873 12.4792 9.99984C12.4792 10.1109 12.4618 10.2151 12.4271 10.3123C12.3924 10.4096 12.3334 10.4998 12.25 10.5832L8.41671 14.4165C8.26393 14.5693 8.06949 14.6457 7.83337 14.6457C7.59726 14.6457 7.40282 14.5693 7.25004 14.4165C7.09726 14.2637 7.02087 14.0693 7.02087 13.8332C7.02087 13.5971 7.09726 13.4026 7.25004 13.2498L10.5 9.99984Z","fill":"currentColor"}})])]),_c('div',{staticClass:"year-filter-dropdown",class:{'year-filter-dropdown--show': _vm.isOpened}},[_c('p',{staticClass:"year-filter-dropdown__all-years",class:{ 'year-filter-dropdown__all-years--active': !_vm.selectedYear},on:{"click":function($event){return _vm.allYear()}}},[_vm._v(_vm._s(_vm.lang=='hu' ? 'ÖSSZES ÉV' : 'ALL YEARS'))]),_c('ul',{staticClass:"year-list"},_vm._l((_vm.yearList),function(year){return _c('li',{staticClass:"year-list__item",class:{ 'year-list__item--active': _vm.getActiveYear(year) },on:{"click":function($event){return _vm.changeYear(year)}}},[_vm._v(_vm._s(year))])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nl01-news-list"},[_vm._t("head"),(_vm.yearpicker)?_c('year-filter',{on:{"on-year-change":_vm.yearChange}}):_vm._e(),(_vm.isError)?[_vm._t("error",[_c('p',[_vm._v(_vm._s(_vm.isLangHungarian ? 'Nem sikerült betölteni a listát.' : 'Sorry, the list could not be loaded.'))])])]:(_vm.isLoading)?[_vm._t("loader",[_c('p',[_vm._v(_vm._s(_vm.isLangHungarian ? 'Betöltés...' : 'Loading.'))])])]:(_vm.list.length)?[_c('div',{staticClass:"cd02-card"},_vm._l((_vm.list),function(item){return _c('cd02-card',{key:item.id,attrs:{"layout":item.layout,"date":item.news.date,"tags":item.news.tags,"title":item.news.title,"text":item.news.text,"url":_vm.formatUrl(item.news.url),"files":item.news.files,"tagUrlPrefix":_vm.parentLeloLink,"lang":_vm.lang,"linkType":item.news.linkType}})}),1)]:[_vm._t("empty-list",[_c('p',[_vm._v(_vm._s(_vm.isLangHungarian ? 'Nincs a keresési feltételnek megfelelő elem.' : 'There are no items matching the search criteria.'))])])],(_vm.total > Number(_vm.size))?_c('pagination',{attrs:{"total":+_vm.total,"from":_vm.currentPage + 1,"page-length":+_vm.size},on:{"on-page-change":_vm.nextPage}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		var _sld03SliderOption;

		return {
			notNextTick: true,
			sld03SliderOption: (_sld03SliderOption = {
				autoplay: false,
				loop: false,
				autoHeight: true,
				mousewheelControl: true,
				slidesPerView: 'auto',
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null
				},
				pagination: {
					el: this.pagination || null,
					clickable: true
				},
				spaceBetween: 32
			}, _defineProperty(_sld03SliderOption, 'slidesPerView', 4), _defineProperty(_sld03SliderOption, 'breakpoints', {
				479: {
					slidesPerView: 1
				},
				767: {
					spaceBetween: 12,
					slidesPerView: 2
				},
				1439: {
					spaceBetween: 12,
					slidesPerView: 3
				}
			}), _defineProperty(_sld03SliderOption, 'mousewheel', false), _sld03SliderOption)
		};
	},

	props: ['nextButton', 'prevButton', 'pagination']
});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		return {
			notNextTick: true,
			sld04SliderOption: {
				autoplay: {
					delay: this.duration,
					stopOnLastSlide: false,
					disableOnInteraction: true
				},
				loop: false,
				mousewheelControl: true,
				slidesPerView: 'auto',
				simulateTouch: false,
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null
				},
				spaceBetween: 49,
				breakpoints: {
					479: {
						spaceBetween: 0,
						slidesPerView: 2
					},
					1439: {
						slidesPerView: 3
					}
				},
				mousewheel: false
			},
			isMoreElementsThanFit: false
		};
	},

	props: {
		moduleId: {
			type: String,
			required: true
		},
		nextButton: {
			type: String,
			required: true
		},
		prevButton: {
			type: String,
			required: true
		},
		duration: {
			type: Number,
			required: true
		}
	},
	mounted: function mounted() {
		var container = document.querySelector('.sld04-logo-slider.' + this.moduleId + ' .swiper-container');
		var slides = Array.from(document.querySelectorAll('.sld04-logo-slider.' + this.moduleId + ' .swiper-slide'));
		var containerWidth = container.offsetWidth;
		var slidesWidth = slides.reduce(function (sum, slide) {
			return sum + slide.offsetWidth;
		}, 0);

		this.isMoreElementsThanFit = containerWidth < slidesWidth;
		this.sld04SliderOption.loop = this.isMoreElementsThanFit;
		this.sld04SliderOption.simulateTouch = this.isMoreElementsThanFit;
	}
});

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_search_box_search_box__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_pagination_pagination_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_api__ = __webpack_require__(591);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Created by laszlo.czondor on 2017. 11. 13.
 */







var QUERY_HASH = '#query=';
var PAGE_SIZE = 10;
var MIN_QUERY_LENGTH = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'multiselect': __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
		'search-box': __WEBPACK_IMPORTED_MODULE_2__common_search_box_search_box__["a" /* default */],
		'pagination': __WEBPACK_IMPORTED_MODULE_3__common_pagination_pagination_vue__["a" /* default */]
	},
	data: function data() {
		return {
			suggestions: [],
			suggestion: '',
			searchResults: [],
			pages: [],
			currentPage: 0,
			numberOfPages: 1,
			numberOfSearchResults: 0,
			query: '',
			isLoading: true,
			searchedAtLeastOnce: false,
			hitsOnPage: 10, //default érték, de egyébként a keresés response-ból jön, hogy mennyi találtat van egy oldalon
			searchInAttachments: false,
			labels: window.searchHitsLabels || {}
		};
	},

	methods: _extends({
		createFullUrl: function createFullUrl(searchResultUrl) {
			if (searchResultUrl.startsWith('/')) {
				searchResultUrl = searchResultUrl.substring(1, searchResultUrl.length);
			}
			var isDefaultPort = location.port == '' || location.port == '80' || location.port == '443';
			var port = isDefaultPort ? '' : ':' + location.port;
			var retValue = location.protocol + '//' + location.host + port;
			retValue += '/' + __WEBPACK_IMPORTED_MODULE_5__common_utils_api__["b" /* PREFIX */] + searchResultUrl;
			return retValue;
		},
		getLabel: function getLabel(result) {
			var category = result.category;


			if (category) {
				return category;
			} else {
				var layout = result.layout;

				return this.labels[layout] || '';
			}
		},
		setSearchInAttachments: function setSearchInAttachments(searchInAttachments) {
			this.searchInAttachments = searchInAttachments;
		},
		search: function search(query) {
			var _this = this;

			var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			this.query = query;
			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(__WEBPACK_IMPORTED_MODULE_5__common_utils_api__["c" /* SEARCH_URL */], {
					params: {
						query: query.trim().toLowerCase() + ' | ' + query.trim().toLowerCase() + '*',
						from: page * PAGE_SIZE,
						size: PAGE_SIZE,
						searchInAttachments: this.searchInAttachments,
						lang: window.lang
					}
				}).then(function (response) {
					_this.searchResults = response.data.hits;
					_this.currentPage = Math.ceil(response.data.from / PAGE_SIZE);
					_this.numberOfPages = Math.ceil(response.data.total / response.data.size);
					_this.numberOfSearchResults = response.data.total;
					_this.isLoading = false;
					_this.searchedAtLeastOnce = true;
					_this.hitsOnPage = response.data.size;
				}).catch(function (error) {
					_this.isLoading = false;
				});
			}
		},
		autoSuggest: function autoSuggest(query) {
			var _this2 = this;

			if (query && query.length >= MIN_QUERY_LENGTH) {
				Axios.get(__WEBPACK_IMPORTED_MODULE_5__common_utils_api__["d" /* SUGGEST_URL */], {
					params: {
						query: query,
						searchInAttachments: this.searchInAttachments,
						lang: window.lang
					}
				}).then(function (response) {
					_this2.suggestions = response.data.suggestions;
					_this2.isLoading = false;
				}).catch(function (error) {
					_this2.isLoading = false;
				});
			} else {
				this.suggestions = [];
			}
		},
		clearSuggestion: function clearSuggestion() {
			this.suggestion = '';
		},
		pageSelectLabel: function pageSelectLabel(page) {
			return page + 1 + ' / ' + this.numberOfPages;
		},
		changeToPage: function changeToPage(page) {
			if (page >= 0 && page < this.numberOfPages + 1) {
				this.currentPage = page - 1;
				this.search(this.query, this.currentPage);
				__WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo(this.selectorToScrollToOnPageChange, this.scrollDurationInMs, { offset: this.scrollOffsetInPx });
			}
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])('headerSearchStore', ['toggleHeaderSearchMenu'])),
	watch: {
		numberOfPages: function numberOfPages(_numberOfPages) {
			var pages = [];

			if (_numberOfPages) {
				for (var i = 0; i < _numberOfPages; i++) {
					pages.push(i);
				}
			}

			this.pages = pages;
		}
	},
	props: ['selectorToScrollToOnPageChange', 'scrollDurationInMs', 'scrollOffsetInPx'],
	mounted: function mounted() {
		if (window.location.hash && new RegExp(QUERY_HASH).test(window.location.hash)) {
			this.query = decodeURI(window.location.hash.split('=')[1]);
		} else {
			this.isLoading = false;
		}
		this.toggleHeaderSearchMenu();
	}
});

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	mounted: function mounted() {
		var _this = this;

		var logoContainer = document.querySelector('.szechenyi');

		setTimeout(function () {
			if (!logoContainer.classList.contains('hidden')) {
				_this.toggleLogo();
			}
		}, 5000);
	},

	methods: {
		toggleLogo: function toggleLogo() {
			var logoContainer = document.querySelector('.szechenyi');
			logoContainer.classList.toggle('hidden');
		}
	}
});

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});
exports.default = exports.validationMixin = void 0;

var _vval = __webpack_require__(1031);

var _params = __webpack_require__(664);

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    var _this4 = this;

    if (this.$error) return true;
    return this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$anyError;
    });
  },
  $pending: function $pending() {
    var _this5 = this;

    return this.ruleKeys.some(function (key) {
      return _this5.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this5.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this6 = this;

    var vals = this.validations;
    return _objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), {}, buildFromKeys(this.ruleKeys, function (key) {
      return _this6.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this7 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this7.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this8 = this;

        return this.keys.filter(function (k) {
          return !_this8.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this9 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this9.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this9[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this9[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread({}, keyDefs, {}, iterDefs, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this9.lazyParentModel();

              if (parent != null) {
                return parent[_this9.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this9.lazyParentModel();

              if (parent != null) {
                parent[_this9.prop] = value;

                _this9.$touch();
              }
            }
          }
        }, getterDefs, {}, methodDefs));
      },
      children: function children() {
        var _this10 = this;

        return [].concat(_toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this10, key);
        })), _toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this10, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this11 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this11.rootModel, _this11.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this12 = this;

        return function () {
          return _this12.getModel();
        };
      },
      children: function children() {
        var _this13 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this13.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this13.getModelLazy,
            model: model[key],
            rootModel: _this13.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by laszlo.czondor on 2017. 10. 26.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  strict: "production" !== 'production'
});

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_HEADER_SEARCH_BUTTON = 'SET_HEADER_SEARCH_BUTTON';

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		hideHeaderSearchMenu: false,
		params: {}
	},
	actions: {
		toggleHeaderSearchMenu: function toggleHeaderSearchMenu(_ref) {
			var state = _ref.state,
			    commit = _ref.commit;

			commit(SET_HEADER_SEARCH_BUTTON, !state.hideHeaderSearchMenu);
		}
	},
	mutations: _defineProperty({}, SET_HEADER_SEARCH_BUTTON, function (state, payload) {
		state.hideHeaderSearchMenu = payload;
	})
});

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__);


var INDICATOR_CLASS = '.pro01-promo__slide-status-indicator';
var INDICATOR_ANIMATION_CLASS = 'pro01-promo__slide-status-indicator--animate';

function startAnimation() {
	this.indicators = document.querySelectorAll(INDICATOR_CLASS); // when looping, this needs to be reselected
	for (var i = 0; i < this.indicators.length; i++) {
		this.indicators[i].classList.add(INDICATOR_ANIMATION_CLASS);
		this.indicators[i].style.animationDuration = this.duration / 1000 + 's';
	}
}

function stopAnimation() {
	this.indicators = document.querySelectorAll(INDICATOR_CLASS);
	for (var i = 0; i < this.indicators.length; i++) {
		this.indicators[i].classList.remove(INDICATOR_ANIMATION_CLASS);
	}
}

var pro01Promo = {
	components: {
		swiper: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_swiper__["swiperSlide"]
	},
	data: function data() {
		return {
			doAutoSlide: true,
			indicators: [],
			notNextTick: true,
			pro01PromoOption: null,
			isOnlyOneItem: false
		};
	},

	computed: {
		getWindowWidth: function getWindowWidth() {
			return window.width;
		}
	},
	methods: {
		calculateAutoSlide: function calculateAutoSlide() {
			this.doAutoSlide = this.slideCount > 1;
		},
		calculatePromoOption: function calculatePromoOption() {
			this.pro01PromoOption = {
				autoplay: this.doAutoSlide ? { delay: this.duration } || false : false,
				autoplayDisableOnInteraction: false,
				loop: this.doAutoSlide,
				simulateTouch: this.doAutoSlide,
				allowSwipeToNext: this.doAutoSlide,
				allowSwipeToPrev: this.doAutoSlide,
				slidesPerView: 'auto',
				width: 1300,
				on: {
					init: startAnimation.bind(this),
					slideChangeTransitionEnd: startAnimation.bind(this),
					slideChangeTransitionStart: stopAnimation.bind(this),
					touchEnd: startAnimation.bind(this),
					touchStart: stopAnimation.bind(this)
				},
				breakpoints: {
					1170: {
						width: this.getWindowWidth
					},
					767: {
						width: this.getWindowWidth,
						autoHeight: true
					}
				},
				navigation: {
					nextEl: this.nextButton || null,
					prevEl: this.prevButton || null
				},
				pagination: {
					el: this.pagination || null,
					clickable: true
				},
				mousewheel: false
			};
		}
	},
	props: ['moduleId', 'duration', 'nextButton', 'prevButton', 'pagination', 'slideCount'],
	beforeMount: function beforeMount() {
		var slides = document.querySelectorAll('.pro01-promo.' + this.moduleId + ' .swiper-container .swiper-slide');
		// ezt azért created-ben kell megtenni, mert később már újabb elemek kerülnek a dom-ba
		this.isOnlyOneItem = slides && slides.length === 1;
	},
	mounted: function mounted() {
		this.calculateAutoSlide();
		this.calculatePromoOption();
	}
};

/* harmony default export */ __webpack_exports__["a"] = (pro01Promo);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// layout.js